
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49fb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49fb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jLKiy", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e64651fad3c66e54$export$ffb0004e005737fa; }, function (v) { return $e64651fad3c66e54$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e64651fad3c66e54$export$34b9dba7ce09269b; }, function (v) { return $e64651fad3c66e54$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e64651fad3c66e54$export$25062201e9e25d76; }, function (v) { return $e64651fad3c66e54$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e64651fad3c66e54$export$ffb0004e005737fa;
var $e64651fad3c66e54$export$34b9dba7ce09269b;
var $e64651fad3c66e54$export$25062201e9e25d76;
'use strict';

var $itHdT = parcelRequire("itHdT");
var $e64651fad3c66e54$var$k = Symbol.for("react.element"), $e64651fad3c66e54$var$l = Symbol.for("react.fragment"), $e64651fad3c66e54$var$m = Object.prototype.hasOwnProperty, $e64651fad3c66e54$var$n = $itHdT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e64651fad3c66e54$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e64651fad3c66e54$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e64651fad3c66e54$var$m.call(a, b) && !$e64651fad3c66e54$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e64651fad3c66e54$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e64651fad3c66e54$var$n.current
    };
}
$e64651fad3c66e54$export$ffb0004e005737fa = $e64651fad3c66e54$var$l;
$e64651fad3c66e54$export$34b9dba7ce09269b = $e64651fad3c66e54$var$q;
$e64651fad3c66e54$export$25062201e9e25d76 = $e64651fad3c66e54$var$q;

});
parcelRegister("itHdT", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iQmnf"));

});
parcelRegister("iQmnf", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $db7e705031b55ab1$export$dca3b0875bd9a954; }, function (v) { return $db7e705031b55ab1$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $db7e705031b55ab1$export$16fa2f45be04daa8; }, function (v) { return $db7e705031b55ab1$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $db7e705031b55ab1$export$ffb0004e005737fa; }, function (v) { return $db7e705031b55ab1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $db7e705031b55ab1$export$e2c29f18771995cb; }, function (v) { return $db7e705031b55ab1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $db7e705031b55ab1$export$221d75b3f55bb0bd; }, function (v) { return $db7e705031b55ab1$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $db7e705031b55ab1$export$5f8d39834fd61797; }, function (v) { return $db7e705031b55ab1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $db7e705031b55ab1$export$74bf444e3cd11ea5; }, function (v) { return $db7e705031b55ab1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $db7e705031b55ab1$export$ae55be85d98224ed; }, function (v) { return $db7e705031b55ab1$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $db7e705031b55ab1$export$3ba232387fd5d6dd; }, function (v) { return $db7e705031b55ab1$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $db7e705031b55ab1$export$e530037191fcd5d7; }, function (v) { return $db7e705031b55ab1$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $db7e705031b55ab1$export$fd42f52fd3ae1109; }, function (v) { return $db7e705031b55ab1$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $db7e705031b55ab1$export$c8a8987d4410bf2d; }, function (v) { return $db7e705031b55ab1$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $db7e705031b55ab1$export$d38cd72104c1f0e9; }, function (v) { return $db7e705031b55ab1$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $db7e705031b55ab1$export$7d1e3a5e95ceca43; }, function (v) { return $db7e705031b55ab1$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $db7e705031b55ab1$export$257a8862b851cb5b; }, function (v) { return $db7e705031b55ab1$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $db7e705031b55ab1$export$a8257692ac88316c; }, function (v) { return $db7e705031b55ab1$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $db7e705031b55ab1$export$488013bae63b21da; }, function (v) { return $db7e705031b55ab1$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $db7e705031b55ab1$export$7c73462e0d25e514; }, function (v) { return $db7e705031b55ab1$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $db7e705031b55ab1$export$7568632d0d33d16d; }, function (v) { return $db7e705031b55ab1$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $db7e705031b55ab1$export$88948ce120ea2619; }, function (v) { return $db7e705031b55ab1$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $db7e705031b55ab1$export$35808ee640e87ca7; }, function (v) { return $db7e705031b55ab1$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $db7e705031b55ab1$export$fae74005e78b1a27; }, function (v) { return $db7e705031b55ab1$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $db7e705031b55ab1$export$dc8fbce3eb94dc1e; }, function (v) { return $db7e705031b55ab1$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $db7e705031b55ab1$export$6a7bc4e911dc01cf; }, function (v) { return $db7e705031b55ab1$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $db7e705031b55ab1$export$6d9c69b0de29b591; }, function (v) { return $db7e705031b55ab1$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $db7e705031b55ab1$export$f680877a34711e37; }, function (v) { return $db7e705031b55ab1$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $db7e705031b55ab1$export$d5a552a76deda3c2; }, function (v) { return $db7e705031b55ab1$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $db7e705031b55ab1$export$aaabe4eda9ed9969; }, function (v) { return $db7e705031b55ab1$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $db7e705031b55ab1$export$e5c5a5f917a5871c; }, function (v) { return $db7e705031b55ab1$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $db7e705031b55ab1$export$1538c33de8887b59; }, function (v) { return $db7e705031b55ab1$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $db7e705031b55ab1$export$13e3392192263954; }, function (v) { return $db7e705031b55ab1$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $db7e705031b55ab1$export$b8f5890fc79d6aca; }, function (v) { return $db7e705031b55ab1$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $db7e705031b55ab1$export$60241385465d0a34; }, function (v) { return $db7e705031b55ab1$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $db7e705031b55ab1$export$306c0aa65ff9ec16; }, function (v) { return $db7e705031b55ab1$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $db7e705031b55ab1$export$7b286972b8d8ccbf; }, function (v) { return $db7e705031b55ab1$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $db7e705031b55ab1$export$83d89fbfd8236492; }, function (v) { return $db7e705031b55ab1$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $db7e705031b55ab1$export$dca3b0875bd9a954;
var $db7e705031b55ab1$export$16fa2f45be04daa8;
var $db7e705031b55ab1$export$ffb0004e005737fa;
var $db7e705031b55ab1$export$e2c29f18771995cb;
var $db7e705031b55ab1$export$221d75b3f55bb0bd;
var $db7e705031b55ab1$export$5f8d39834fd61797;
var $db7e705031b55ab1$export$74bf444e3cd11ea5;
var $db7e705031b55ab1$export$ae55be85d98224ed;
var $db7e705031b55ab1$export$3ba232387fd5d6dd;
var $db7e705031b55ab1$export$e530037191fcd5d7;
var $db7e705031b55ab1$export$fd42f52fd3ae1109;
var $db7e705031b55ab1$export$c8a8987d4410bf2d;
var $db7e705031b55ab1$export$d38cd72104c1f0e9;
var $db7e705031b55ab1$export$7d1e3a5e95ceca43;
var $db7e705031b55ab1$export$257a8862b851cb5b;
var $db7e705031b55ab1$export$a8257692ac88316c;
var $db7e705031b55ab1$export$488013bae63b21da;
var $db7e705031b55ab1$export$7c73462e0d25e514;
var $db7e705031b55ab1$export$7568632d0d33d16d;
var $db7e705031b55ab1$export$88948ce120ea2619;
var $db7e705031b55ab1$export$35808ee640e87ca7;
var $db7e705031b55ab1$export$fae74005e78b1a27;
var $db7e705031b55ab1$export$dc8fbce3eb94dc1e;
var $db7e705031b55ab1$export$6a7bc4e911dc01cf;
var $db7e705031b55ab1$export$6d9c69b0de29b591;
var $db7e705031b55ab1$export$f680877a34711e37;
var $db7e705031b55ab1$export$d5a552a76deda3c2;
var $db7e705031b55ab1$export$aaabe4eda9ed9969;
var $db7e705031b55ab1$export$e5c5a5f917a5871c;
var $db7e705031b55ab1$export$1538c33de8887b59;
var $db7e705031b55ab1$export$13e3392192263954;
var $db7e705031b55ab1$export$b8f5890fc79d6aca;
var $db7e705031b55ab1$export$60241385465d0a34;
var $db7e705031b55ab1$export$306c0aa65ff9ec16;
var $db7e705031b55ab1$export$7b286972b8d8ccbf;
var $db7e705031b55ab1$export$83d89fbfd8236492;
'use strict';
var $db7e705031b55ab1$var$l = Symbol.for("react.element"), $db7e705031b55ab1$var$n = Symbol.for("react.portal"), $db7e705031b55ab1$var$p = Symbol.for("react.fragment"), $db7e705031b55ab1$var$q = Symbol.for("react.strict_mode"), $db7e705031b55ab1$var$r = Symbol.for("react.profiler"), $db7e705031b55ab1$var$t = Symbol.for("react.provider"), $db7e705031b55ab1$var$u = Symbol.for("react.context"), $db7e705031b55ab1$var$v = Symbol.for("react.forward_ref"), $db7e705031b55ab1$var$w = Symbol.for("react.suspense"), $db7e705031b55ab1$var$x = Symbol.for("react.memo"), $db7e705031b55ab1$var$y = Symbol.for("react.lazy"), $db7e705031b55ab1$var$z = Symbol.iterator;
function $db7e705031b55ab1$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $db7e705031b55ab1$var$z && a[$db7e705031b55ab1$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $db7e705031b55ab1$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $db7e705031b55ab1$var$C = Object.assign, $db7e705031b55ab1$var$D = {};
function $db7e705031b55ab1$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $db7e705031b55ab1$var$D;
    this.updater = e || $db7e705031b55ab1$var$B;
}
$db7e705031b55ab1$var$E.prototype.isReactComponent = {};
$db7e705031b55ab1$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$db7e705031b55ab1$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $db7e705031b55ab1$var$F() {}
$db7e705031b55ab1$var$F.prototype = $db7e705031b55ab1$var$E.prototype;
function $db7e705031b55ab1$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $db7e705031b55ab1$var$D;
    this.updater = e || $db7e705031b55ab1$var$B;
}
var $db7e705031b55ab1$var$H = $db7e705031b55ab1$var$G.prototype = new $db7e705031b55ab1$var$F;
$db7e705031b55ab1$var$H.constructor = $db7e705031b55ab1$var$G;
$db7e705031b55ab1$var$C($db7e705031b55ab1$var$H, $db7e705031b55ab1$var$E.prototype);
$db7e705031b55ab1$var$H.isPureReactComponent = !0;
var $db7e705031b55ab1$var$I = Array.isArray, $db7e705031b55ab1$var$J = Object.prototype.hasOwnProperty, $db7e705031b55ab1$var$K = {
    current: null
}, $db7e705031b55ab1$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $db7e705031b55ab1$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$db7e705031b55ab1$var$J.call(b, d) && !$db7e705031b55ab1$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $db7e705031b55ab1$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $db7e705031b55ab1$var$K.current
    };
}
function $db7e705031b55ab1$var$N(a, b) {
    return {
        $$typeof: $db7e705031b55ab1$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $db7e705031b55ab1$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $db7e705031b55ab1$var$l;
}
function $db7e705031b55ab1$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $db7e705031b55ab1$var$P = /\/+/g;
function $db7e705031b55ab1$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $db7e705031b55ab1$var$escape("" + a.key) : b.toString(36);
}
function $db7e705031b55ab1$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $db7e705031b55ab1$var$l:
                case $db7e705031b55ab1$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $db7e705031b55ab1$var$Q(h, 0) : d, $db7e705031b55ab1$var$I(c) ? (e = "", null != a && (e = a.replace($db7e705031b55ab1$var$P, "$&/") + "/"), $db7e705031b55ab1$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($db7e705031b55ab1$var$O(c) && (c = $db7e705031b55ab1$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($db7e705031b55ab1$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($db7e705031b55ab1$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $db7e705031b55ab1$var$Q(k, g);
        h += $db7e705031b55ab1$var$R(k, b, e, f, c);
    }
    else if (f = $db7e705031b55ab1$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $db7e705031b55ab1$var$Q(k, g++), h += $db7e705031b55ab1$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $db7e705031b55ab1$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $db7e705031b55ab1$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $db7e705031b55ab1$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $db7e705031b55ab1$var$U = {
    current: null
}, $db7e705031b55ab1$var$V = {
    transition: null
}, $db7e705031b55ab1$var$W = {
    ReactCurrentDispatcher: $db7e705031b55ab1$var$U,
    ReactCurrentBatchConfig: $db7e705031b55ab1$var$V,
    ReactCurrentOwner: $db7e705031b55ab1$var$K
};
function $db7e705031b55ab1$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$db7e705031b55ab1$export$dca3b0875bd9a954 = {
    map: $db7e705031b55ab1$var$S,
    forEach: function(a, b, e) {
        $db7e705031b55ab1$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $db7e705031b55ab1$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $db7e705031b55ab1$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$db7e705031b55ab1$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$db7e705031b55ab1$export$16fa2f45be04daa8 = $db7e705031b55ab1$var$E;
$db7e705031b55ab1$export$ffb0004e005737fa = $db7e705031b55ab1$var$p;
$db7e705031b55ab1$export$e2c29f18771995cb = $db7e705031b55ab1$var$r;
$db7e705031b55ab1$export$221d75b3f55bb0bd = $db7e705031b55ab1$var$G;
$db7e705031b55ab1$export$5f8d39834fd61797 = $db7e705031b55ab1$var$q;
$db7e705031b55ab1$export$74bf444e3cd11ea5 = $db7e705031b55ab1$var$w;
$db7e705031b55ab1$export$ae55be85d98224ed = $db7e705031b55ab1$var$W;
$db7e705031b55ab1$export$3ba232387fd5d6dd = $db7e705031b55ab1$var$X;
$db7e705031b55ab1$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $db7e705031b55ab1$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $db7e705031b55ab1$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$db7e705031b55ab1$var$J.call(b, f) && !$db7e705031b55ab1$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $db7e705031b55ab1$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$db7e705031b55ab1$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $db7e705031b55ab1$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $db7e705031b55ab1$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$db7e705031b55ab1$export$c8a8987d4410bf2d = $db7e705031b55ab1$var$M;
$db7e705031b55ab1$export$d38cd72104c1f0e9 = function(a) {
    var b = $db7e705031b55ab1$var$M.bind(null, a);
    b.type = a;
    return b;
};
$db7e705031b55ab1$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$db7e705031b55ab1$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $db7e705031b55ab1$var$v,
        render: a
    };
};
$db7e705031b55ab1$export$a8257692ac88316c = $db7e705031b55ab1$var$O;
$db7e705031b55ab1$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $db7e705031b55ab1$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $db7e705031b55ab1$var$T
    };
};
$db7e705031b55ab1$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $db7e705031b55ab1$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$db7e705031b55ab1$export$7568632d0d33d16d = function(a) {
    var b = $db7e705031b55ab1$var$V.transition;
    $db7e705031b55ab1$var$V.transition = {};
    try {
        a();
    } finally{
        $db7e705031b55ab1$var$V.transition = b;
    }
};
$db7e705031b55ab1$export$88948ce120ea2619 = $db7e705031b55ab1$var$X;
$db7e705031b55ab1$export$35808ee640e87ca7 = function(a, b) {
    return $db7e705031b55ab1$var$U.current.useCallback(a, b);
};
$db7e705031b55ab1$export$fae74005e78b1a27 = function(a) {
    return $db7e705031b55ab1$var$U.current.useContext(a);
};
$db7e705031b55ab1$export$dc8fbce3eb94dc1e = function() {};
$db7e705031b55ab1$export$6a7bc4e911dc01cf = function(a) {
    return $db7e705031b55ab1$var$U.current.useDeferredValue(a);
};
$db7e705031b55ab1$export$6d9c69b0de29b591 = function(a, b) {
    return $db7e705031b55ab1$var$U.current.useEffect(a, b);
};
$db7e705031b55ab1$export$f680877a34711e37 = function() {
    return $db7e705031b55ab1$var$U.current.useId();
};
$db7e705031b55ab1$export$d5a552a76deda3c2 = function(a, b, e) {
    return $db7e705031b55ab1$var$U.current.useImperativeHandle(a, b, e);
};
$db7e705031b55ab1$export$aaabe4eda9ed9969 = function(a, b) {
    return $db7e705031b55ab1$var$U.current.useInsertionEffect(a, b);
};
$db7e705031b55ab1$export$e5c5a5f917a5871c = function(a, b) {
    return $db7e705031b55ab1$var$U.current.useLayoutEffect(a, b);
};
$db7e705031b55ab1$export$1538c33de8887b59 = function(a, b) {
    return $db7e705031b55ab1$var$U.current.useMemo(a, b);
};
$db7e705031b55ab1$export$13e3392192263954 = function(a, b, e) {
    return $db7e705031b55ab1$var$U.current.useReducer(a, b, e);
};
$db7e705031b55ab1$export$b8f5890fc79d6aca = function(a) {
    return $db7e705031b55ab1$var$U.current.useRef(a);
};
$db7e705031b55ab1$export$60241385465d0a34 = function(a) {
    return $db7e705031b55ab1$var$U.current.useState(a);
};
$db7e705031b55ab1$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $db7e705031b55ab1$var$U.current.useSyncExternalStore(a, b, e);
};
$db7e705031b55ab1$export$7b286972b8d8ccbf = function() {
    return $db7e705031b55ab1$var$U.current.useTransition();
};
$db7e705031b55ab1$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("8UE37", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $12kse = parcelRequire("12kse");

var $eb8RV = parcelRequire("eb8RV");

var $fciTx = parcelRequire("fciTx");

var $zKmFx = parcelRequire("zKmFx");

var $jmqLW = parcelRequire("jmqLW");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");

var $kOJcT = parcelRequire("kOJcT");

var $kYUUl = parcelRequire("kYUUl");

var $H0bGg = parcelRequire("H0bGg");

var $7KBXl = parcelRequire("7KBXl");

var $lHgv5 = parcelRequire("lHgv5");

var $23CGM = parcelRequire("23CGM");

var $aHJDA = parcelRequire("aHJDA");

var $duCSA = parcelRequire("duCSA");

var $9OgG9 = parcelRequire("9OgG9");

var $fdwY1 = parcelRequire("fdwY1");

var $arkyo = parcelRequire("arkyo");

var $2x74l = parcelRequire("2x74l");

var $aBajH = parcelRequire("aBajH");

var $De3kE = parcelRequire("De3kE");

var $jw7Bz = parcelRequire("jw7Bz");

var $d1DWf = parcelRequire("d1DWf");

var $32zx8 = parcelRequire("32zx8");

var $avNV4 = parcelRequire("avNV4");

var $29kP8 = parcelRequire("29kP8");

var $3dqfv = parcelRequire("3dqfv");

var $gXjBI = parcelRequire("gXjBI");

var $bNCFC = parcelRequire("bNCFC");

var $6GHZ4 = parcelRequire("6GHZ4");

var $cFOe7 = parcelRequire("cFOe7");

var $eWJ1t = parcelRequire("eWJ1t");

var $8vCgJ = parcelRequire("8vCgJ");

var $f74bw = parcelRequire("f74bw");

var $i1HdV = parcelRequire("i1HdV");

var $Uh5B7 = parcelRequire("Uh5B7");

var $jQbkN = parcelRequire("jQbkN");

var $2dDpf = parcelRequire("2dDpf");

var $fvKkS = parcelRequire("fvKkS");

var $j7Wkw = parcelRequire("j7Wkw");

var $dl6Mu = parcelRequire("dl6Mu");

var $jVjPX = parcelRequire("jVjPX");

var $2nX7a = parcelRequire("2nX7a");

var $6JHAx = parcelRequire("6JHAx");

var $3QV8T = parcelRequire("3QV8T");

var $2oeY5 = parcelRequire("2oeY5");

var $3JV3y = parcelRequire("3JV3y");

var $18Thx = parcelRequire("18Thx");

var $a3VLZ = parcelRequire("a3VLZ");

var $3Lbwh = parcelRequire("3Lbwh");

var $6y5oV = parcelRequire("6y5oV");

var $c67nG = parcelRequire("c67nG");

var $cVsnx = parcelRequire("cVsnx");

var $cMia1 = parcelRequire("cMia1");

var $9H5ke = parcelRequire("9H5ke");

var $770IZ = parcelRequire("770IZ");

var $7nyuW = parcelRequire("7nyuW");

var $69xgb = parcelRequire("69xgb");

var $5Yd87 = parcelRequire("5Yd87");

var $hS89i = parcelRequire("hS89i");

var $2WFPY = parcelRequire("2WFPY");

var $Plrf4 = parcelRequire("Plrf4");

var $ct3gP = parcelRequire("ct3gP");

var $dsNIc = parcelRequire("dsNIc");

var $kQmZ5 = parcelRequire("kQmZ5");

var $dQR84 = parcelRequire("dQR84");

var $fDiFQ = parcelRequire("fDiFQ");

var $fXL5b = parcelRequire("fXL5b");

var $dfiTg = parcelRequire("dfiTg");

var $l2Qyh = parcelRequire("l2Qyh");

var $gdMHb = parcelRequire("gdMHb");

var $5wZDP = parcelRequire("5wZDP");

var $iAQfc = parcelRequire("iAQfc");

var $jb8ql = parcelRequire("jb8ql");

var $deIMO = parcelRequire("deIMO");

var $eOAMk = parcelRequire("eOAMk");

var $lDiMO = parcelRequire("lDiMO");

var $iYjf7 = parcelRequire("iYjf7");

var $59i3n = parcelRequire("59i3n");

var $bJhjl = parcelRequire("bJhjl");

var $03LKB = parcelRequire("03LKB");

var $cUrBz = parcelRequire("cUrBz");

var $i4dps = parcelRequire("i4dps");

var $7CERs = parcelRequire("7CERs");

var $8g96C = parcelRequire("8g96C");

var $42B6Y = parcelRequire("42B6Y");

var $hc8y4 = parcelRequire("hc8y4");

var $9eqfu = parcelRequire("9eqfu");

var $j7BPI = parcelRequire("j7BPI");

var $k2AQU = parcelRequire("k2AQU");

var $aGyAs = parcelRequire("aGyAs");

var $3c3xM = parcelRequire("3c3xM");

var $d9ZPE = parcelRequire("d9ZPE");

var $hbdBm = parcelRequire("hbdBm");

var $bIN9s = parcelRequire("bIN9s");

var $9GC77 = parcelRequire("9GC77");

var $eRY7r = parcelRequire("eRY7r");

var $7Qa0H = parcelRequire("7Qa0H");

var $hQW07 = parcelRequire("hQW07");

var $c6vRz = parcelRequire("c6vRz");

var $kbOoO = parcelRequire("kbOoO");

var $jTuXY = parcelRequire("jTuXY");

var $cieLS = parcelRequire("cieLS");

var $hYIB8 = parcelRequire("hYIB8");

var $6hRPo = parcelRequire("6hRPo");

var $6jVna = parcelRequire("6jVna");

var $4zslB = parcelRequire("4zslB");

var $98L9O = parcelRequire("98L9O");

var $jeg5Z = parcelRequire("jeg5Z");

var $awwU9 = parcelRequire("awwU9");

var $6tZdC = parcelRequire("6tZdC");

var $lMMO3 = parcelRequire("lMMO3");

var $3DKL9 = parcelRequire("3DKL9");

var $23WDq = parcelRequire("23WDq");

var $cAnBa = parcelRequire("cAnBa");

var $2uBiD = parcelRequire("2uBiD");

var $eXIZW = parcelRequire("eXIZW");

var $6UTvW = parcelRequire("6UTvW");

var $eWlAJ = parcelRequire("eWlAJ");

var $ekucH = parcelRequire("ekucH");

var $gKbW9 = parcelRequire("gKbW9");

var $3Arox = parcelRequire("3Arox");

var $694gv = parcelRequire("694gv");

var $jWoUg = parcelRequire("jWoUg");

var $cmMjb = parcelRequire("cmMjb");

var $5w1OV = parcelRequire("5w1OV");

var $dbV67 = parcelRequire("dbV67");

var $9tYE4 = parcelRequire("9tYE4");

var $hnvKl = parcelRequire("hnvKl");

var $1Kjg0 = parcelRequire("1Kjg0");

var $1B9gR = parcelRequire("1B9gR");

var $ejsmR = parcelRequire("ejsmR");

var $cgx6M = parcelRequire("cgx6M");

var $kGhFN = parcelRequire("kGhFN");

var $lacoC = parcelRequire("lacoC");

var $lMrpL = parcelRequire("lMrpL");

var $8gllD = parcelRequire("8gllD");

var $65IUO = parcelRequire("65IUO");

var $iRcsS = parcelRequire("iRcsS");

var $iWURH = parcelRequire("iWURH");

var $gtpOW = parcelRequire("gtpOW");

var $7KadD = parcelRequire("7KadD");

var $hFOjs = parcelRequire("hFOjs");
module.exports.registerSpanErrorInstrumentation = $12kse.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $eb8RV.getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $eb8RV.setCapturedScopesOnSpan;
module.exports.TRACING_DEFAULTS = $fciTx.TRACING_DEFAULTS;
module.exports.startIdleSpan = $fciTx.startIdleSpan;
module.exports.SentrySpan = $zKmFx.SentrySpan;
module.exports.SentryNonRecordingSpan = $jmqLW.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $8OylQ.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $8OylQ.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $8OylQ.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $8OylQ.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $8OylQ.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $bn0md.SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $bn0md.continueTrace;
module.exports.startInactiveSpan = $bn0md.startInactiveSpan;
module.exports.startNewTrace = $bn0md.startNewTrace;
module.exports.startSpan = $bn0md.startSpan;
module.exports.startSpanManual = $bn0md.startSpanManual;
module.exports.suppressTracing = $bn0md.suppressTracing;
module.exports.withActiveSpan = $bn0md.withActiveSpan;
module.exports.getDynamicSamplingContextFromClient = $kOJcT.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $kOJcT.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $kOJcT.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $kOJcT.spanToBaggageHeader;
module.exports.setMeasurement = $kYUUl.setMeasurement;
module.exports.timedEventsToMeasurements = $kYUUl.timedEventsToMeasurements;
module.exports.sampleSpan = $H0bGg.sampleSpan;
module.exports.logSpanEnd = $7KBXl.logSpanEnd;
module.exports.logSpanStart = $7KBXl.logSpanStart;
module.exports.captureSpan = $lHgv5.captureSpan;
module.exports.safeSetSpanJSONAttributes = $lHgv5.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $23CGM.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $23CGM.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $23CGM.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $23CGM.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $23CGM.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $23CGM.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $23CGM.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $23CGM.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $23CGM.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $23CGM.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $23CGM.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $23CGM.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $23CGM.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $aHJDA.createEventEnvelope;
module.exports.createSessionEnvelope = $aHJDA.createSessionEnvelope;
module.exports.createSpanEnvelope = $aHJDA.createSpanEnvelope;
module.exports.addEventProcessor = $duCSA.addEventProcessor;
module.exports.captureCheckIn = $duCSA.captureCheckIn;
module.exports.captureEvent = $duCSA.captureEvent;
module.exports.captureException = $duCSA.captureException;
module.exports.captureMessage = $duCSA.captureMessage;
module.exports.captureSession = $duCSA.captureSession;
module.exports.close = $duCSA.close;
module.exports.endSession = $duCSA.endSession;
module.exports.flush = $duCSA.flush;
module.exports.isEnabled = $duCSA.isEnabled;
module.exports.isInitialized = $duCSA.isInitialized;
module.exports.lastEventId = $duCSA.lastEventId;
module.exports.setContext = $duCSA.setContext;
module.exports.setConversationId = $duCSA.setConversationId;
module.exports.setExtra = $duCSA.setExtra;
module.exports.setExtras = $duCSA.setExtras;
module.exports.setTag = $duCSA.setTag;
module.exports.setTags = $duCSA.setTags;
module.exports.setUser = $duCSA.setUser;
module.exports.startSession = $duCSA.startSession;
module.exports.withMonitor = $duCSA.withMonitor;
module.exports.getClient = $9OgG9.getClient;
module.exports.getCurrentScope = $9OgG9.getCurrentScope;
module.exports.getExternalPropagationContext = $9OgG9.getExternalPropagationContext;
module.exports.getGlobalScope = $9OgG9.getGlobalScope;
module.exports.getIsolationScope = $9OgG9.getIsolationScope;
module.exports.getTraceContextFromScope = $9OgG9.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $9OgG9.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $9OgG9.registerExternalPropagationContext;
module.exports.withIsolationScope = $9OgG9.withIsolationScope;
module.exports.withScope = $9OgG9.withScope;
module.exports.getDefaultCurrentScope = $fdwY1.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $fdwY1.getDefaultIsolationScope;
module.exports.setAsyncContextStrategy = $arkyo.setAsyncContextStrategy;
module.exports.getGlobalSingleton = $2x74l.getGlobalSingleton;
module.exports.getMainCarrier = $2x74l.getMainCarrier;
module.exports.closeSession = $aBajH.closeSession;
module.exports.makeSession = $aBajH.makeSession;
module.exports.updateSession = $aBajH.updateSession;
module.exports.Scope = $De3kE.Scope;
module.exports.notifyEventProcessors = $jw7Bz.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $d1DWf.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $d1DWf.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $d1DWf.getReportDialogEndpoint;
module.exports.Client = $32zx8.Client;
module.exports.initAndBind = $avNV4.initAndBind;
module.exports.setCurrentClient = $avNV4.setCurrentClient;
module.exports.createTransport = $29kP8.createTransport;
module.exports.makeOfflineTransport = $3dqfv.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $gXjBI.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $gXjBI.makeMultiplexedTransport;
module.exports.addIntegration = $bNCFC.addIntegration;
module.exports.defineIntegration = $bNCFC.defineIntegration;
module.exports.getIntegrationsToSetup = $bNCFC.getIntegrationsToSetup;
module.exports.installedIntegrations = $bNCFC.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $6GHZ4._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $6GHZ4._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $6GHZ4._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $cFOe7.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $eWJ1t.filterCookies;
module.exports._INTERNAL_filterQueryParams = $8vCgJ.filterQueryParams;
module.exports.envToBool = $f74bw.envToBool;
module.exports.applyScopeDataToEvent = $i1HdV.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $i1HdV.getCombinedScopeData;
module.exports.mergeScopeData = $i1HdV.mergeScopeData;
module.exports.prepareEvent = $Uh5B7.prepareEvent;
module.exports.createCheckInEnvelope = $jQbkN.createCheckInEnvelope;
module.exports.hasSpansEnabled = $2dDpf.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $fvKkS.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $fvKkS.withStreamedSpan;
module.exports.isSentryRequestUrl = $j7Wkw.isSentryRequestUrl;
module.exports.handleCallbackErrors = $dl6Mu.handleCallbackErrors;
module.exports.fmt = $jVjPX.fmt;
module.exports.parameterize = $jVjPX.parameterize;
module.exports.handleTunnelRequest = $2nX7a.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $6JHAx.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $6JHAx.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $3QV8T.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $3QV8T.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $3QV8T.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $3QV8T.getActiveSpan;
module.exports.getRootSpan = $3QV8T.getRootSpan;
module.exports.getSpanDescendants = $3QV8T.getSpanDescendants;
module.exports.getStatusMessage = $3QV8T.getStatusMessage;
module.exports.spanIsSampled = $3QV8T.spanIsSampled;
module.exports.spanTimeInputToSeconds = $3QV8T.spanTimeInputToSeconds;
module.exports.spanToJSON = $3QV8T.spanToJSON;
module.exports.spanToStreamedSpanJSON = $3QV8T.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $3QV8T.spanToTraceContext;
module.exports.spanToTraceHeader = $3QV8T.spanToTraceHeader;
module.exports.updateSpanName = $3QV8T.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $2oeY5._setSpanForScope;
module.exports.parseSampleRate = $3JV3y.parseSampleRate;
module.exports.applySdkMetadata = $18Thx.applySdkMetadata;
module.exports.getTraceData = $a3VLZ.getTraceData;
module.exports.shouldPropagateTraceForUrl = $3Lbwh.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $6y5oV.getTraceMetaTags;
module.exports.debounce = $c67nG.debounce;
module.exports.derefWeakRef = $cVsnx.derefWeakRef;
module.exports.makeWeakRef = $cVsnx.makeWeakRef;
module.exports.shouldIgnoreSpan = $cMia1.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $9H5ke.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $9H5ke.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $9H5ke.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $9H5ke.getMaxBodyByteLength;
module.exports.headersToDict = $9H5ke.headersToDict;
module.exports.httpHeadersToSpanAttributes = $9H5ke.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $9H5ke.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $9H5ke.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $9H5ke.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $770IZ.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $770IZ.DEV_ENVIRONMENT;
module.exports.addBreadcrumb = $7nyuW.addBreadcrumb;
module.exports.functionToStringIntegration = $69xgb.functionToStringIntegration;
module.exports.eventFiltersIntegration = $5Yd87.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $5Yd87.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $hS89i.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $2WFPY.moduleMetadataIntegration;
module.exports.requestDataIntegration = $Plrf4.requestDataIntegration;
module.exports.captureConsoleIntegration = $ct3gP.captureConsoleIntegration;
module.exports.dedupeIntegration = $dsNIc.dedupeIntegration;
module.exports.extraErrorDataIntegration = $kQmZ5.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $dQR84.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $fDiFQ.instrumentSupabaseClient;
module.exports.supabaseIntegration = $fDiFQ.supabaseIntegration;
module.exports.zodErrorsIntegration = $fXL5b.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $dfiTg.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $l2Qyh.consoleIntegration;
module.exports.featureFlagsIntegration = $gdMHb.featureFlagsIntegration;
module.exports.growthbookIntegration = $5wZDP.growthbookIntegration;
module.exports.conversationIdIntegration = $iAQfc.conversationIdIntegration;
module.exports.profiler = $jb8ql.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $deIMO._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $deIMO.instrumentFetchRequest;
module.exports.captureFeedback = $eOAMk.captureFeedback;
module.exports._INTERNAL_captureLog = $lDiMO._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $lDiMO._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $lDiMO._INTERNAL_flushLogsBuffer;
module.exports.logger = $iYjf7;
module.exports.consoleLoggingIntegration = $59i3n.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $bJhjl._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $bJhjl._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $bJhjl._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $03LKB;
module.exports.createConsolaReporter = $cUrBz.createConsolaReporter;
module.exports.addVercelAiProcessors = $i4dps.addVercelAiProcessors;
module.exports._INTERNAL_cleanupToolCallSpanContext = $7CERs._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $7CERs._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $8g96C.toolCallSpanContextMap;
module.exports.instrumentOpenAiClient = $42B6Y.instrumentOpenAiClient;
module.exports.OPENAI_INTEGRATION_NAME = $hc8y4.OPENAI_INTEGRATION_NAME;
module.exports.instrumentAnthropicAiClient = $9eqfu.instrumentAnthropicAiClient;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $j7BPI.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.instrumentGoogleGenAIClient = $k2AQU.instrumentGoogleGenAIClient;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $aGyAs.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $3c3xM.createLangChainCallbackHandler;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $d9ZPE._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $hbdBm.LANGCHAIN_INTEGRATION_NAME;
module.exports.instrumentCreateReactAgent = $bIN9s.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $bIN9s.instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $bIN9s.instrumentStateGraphCompile;
module.exports.LANGGRAPH_INTEGRATION_NAME = $9GC77.LANGGRAPH_INTEGRATION_NAME;
module.exports.SpanBuffer = $eRY7r.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $7Qa0H.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $hQW07.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $c6vRz._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $c6vRz._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $c6vRz._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $c6vRz._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $c6vRz._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $kbOoO.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $jTuXY.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $cieLS.dsnFromString;
module.exports.dsnToString = $cieLS.dsnToString;
module.exports.makeDsn = $cieLS.makeDsn;
module.exports.SentryError = $hYIB8.SentryError;
module.exports.GLOBAL_OBJ = $6hRPo.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $6jVna.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $6jVna.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $4zslB.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $4zslB.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $98L9O.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $jeg5Z.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $awwU9.addHandler;
module.exports.maybeInstrument = $awwU9.maybeInstrument;
module.exports.resetInstrumentationHandlers = $awwU9.resetInstrumentationHandlers;
module.exports.triggerHandlers = $awwU9.triggerHandlers;
module.exports.isDOMError = $6tZdC.isDOMError;
module.exports.isDOMException = $6tZdC.isDOMException;
module.exports.isElement = $6tZdC.isElement;
module.exports.isError = $6tZdC.isError;
module.exports.isErrorEvent = $6tZdC.isErrorEvent;
module.exports.isEvent = $6tZdC.isEvent;
module.exports.isInstanceOf = $6tZdC.isInstanceOf;
module.exports.isParameterizedString = $6tZdC.isParameterizedString;
module.exports.isPlainObject = $6tZdC.isPlainObject;
module.exports.isPrimitive = $6tZdC.isPrimitive;
module.exports.isRegExp = $6tZdC.isRegExp;
module.exports.isString = $6tZdC.isString;
module.exports.isSyntheticEvent = $6tZdC.isSyntheticEvent;
module.exports.isThenable = $6tZdC.isThenable;
module.exports.isVueViewModel = $6tZdC.isVueViewModel;
module.exports.isBrowser = $lMMO3.isBrowser;
module.exports.CONSOLE_LEVELS = $3DKL9.CONSOLE_LEVELS;
module.exports.consoleSandbox = $3DKL9.consoleSandbox;
module.exports.debug = $3DKL9.debug;
module.exports.originalConsoleMethods = $3DKL9.originalConsoleMethods;
module.exports.addContextToFrame = $23WDq.addContextToFrame;
module.exports.addExceptionMechanism = $23WDq.addExceptionMechanism;
module.exports.addExceptionTypeValue = $23WDq.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $23WDq.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $23WDq.getEventDescription;
module.exports.isAlreadyCaptured = $23WDq.isAlreadyCaptured;
module.exports.parseSemver = $23WDq.parseSemver;
module.exports.uuid4 = $23WDq.uuid4;
module.exports.normalize = $cAnBa.normalize;
module.exports.normalizeToSize = $cAnBa.normalizeToSize;
module.exports.normalizeUrlToBase = $cAnBa.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $cAnBa.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $2uBiD.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $2uBiD.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $eXIZW.addNonEnumerableProperty;
module.exports.convertToPlainObject = $eXIZW.convertToPlainObject;
module.exports.dropUndefinedKeys = $eXIZW.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $eXIZW.extractExceptionKeysForMessage;
module.exports.fill = $eXIZW.fill;
module.exports.getOriginalFunction = $eXIZW.getOriginalFunction;
module.exports.markFunctionWrapped = $eXIZW.markFunctionWrapped;
module.exports.objectify = $eXIZW.objectify;
module.exports.basename = $6UTvW.basename;
module.exports.dirname = $6UTvW.dirname;
module.exports.isAbsolute = $6UTvW.isAbsolute;
module.exports.join = $6UTvW.join;
module.exports.normalizePath = $6UTvW.normalizePath;
module.exports.relative = $6UTvW.relative;
module.exports.resolve = $6UTvW.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $eWlAJ.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $eWlAJ.makePromiseBuffer;
module.exports.severityLevelFromString = $ekucH.severityLevelFromString;
module.exports.replaceExports = $gKbW9.replaceExports;
module.exports.UNKNOWN_FUNCTION = $3Arox.UNKNOWN_FUNCTION;
module.exports.createStackParser = $3Arox.createStackParser;
module.exports.getFramesFromEvent = $3Arox.getFramesFromEvent;
module.exports.getFunctionName = $3Arox.getFunctionName;
module.exports.stackParserFromStackParserOptions = $3Arox.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $3Arox.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $694gv.isMatchingPattern;
module.exports.safeJoin = $694gv.safeJoin;
module.exports.snipLine = $694gv.snipLine;
module.exports.stringMatchesSomePattern = $694gv.stringMatchesSomePattern;
module.exports.truncate = $694gv.truncate;
module.exports.isNativeFunction = $jWoUg.isNativeFunction;
module.exports.supportsDOMError = $jWoUg.supportsDOMError;
module.exports.supportsDOMException = $jWoUg.supportsDOMException;
module.exports.supportsErrorEvent = $jWoUg.supportsErrorEvent;
module.exports.supportsFetch = $jWoUg.supportsFetch;
module.exports.supportsHistory = $jWoUg.supportsHistory;
module.exports.supportsNativeFetch = $jWoUg.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $jWoUg.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $jWoUg.supportsReportingObserver;
module.exports.SyncPromise = $cmMjb.SyncPromise;
module.exports.rejectedSyncPromise = $cmMjb.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $cmMjb.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $5w1OV.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $5w1OV.dateTimestampInSeconds;
module.exports.timestampInSeconds = $5w1OV.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $dbV67.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $dbV67.extractTraceparentData;
module.exports.generateSentryTraceHeader = $dbV67.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $dbV67.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $dbV67.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $dbV67.shouldContinueTrace;
module.exports.getSDKSource = $9tYE4.getSDKSource;
module.exports.isBrowserBundle = $9tYE4.isBrowserBundle;
module.exports.addItemToEnvelope = $hnvKl.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $hnvKl.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $hnvKl.createEnvelope;
module.exports.createEventEnvelopeHeaders = $hnvKl.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $hnvKl.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $hnvKl.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $hnvKl.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $hnvKl.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $hnvKl.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $hnvKl.parseEnvelope;
module.exports.serializeEnvelope = $hnvKl.serializeEnvelope;
module.exports.createClientReportEnvelope = $1Kjg0.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $1B9gR.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $1B9gR.disabledUntil;
module.exports.isRateLimited = $1B9gR.isRateLimited;
module.exports.parseRetryAfterHeader = $1B9gR.parseRetryAfterHeader;
module.exports.updateRateLimits = $1B9gR.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $ejsmR.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $ejsmR.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $ejsmR.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $ejsmR.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $ejsmR.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $ejsmR.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $ejsmR.objectToBaggageHeader;
module.exports.parseBaggageHeader = $ejsmR.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $cgx6M.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $cgx6M.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $cgx6M.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $cgx6M.isURLObjectRelative;
module.exports.parseStringToURLObject = $cgx6M.parseStringToURLObject;
module.exports.parseUrl = $cgx6M.parseUrl;
module.exports.stripDataUrlContent = $cgx6M.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $cgx6M.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $kGhFN._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $kGhFN.eventFromMessage;
module.exports.eventFromUnknownInput = $kGhFN.eventFromUnknownInput;
module.exports.exceptionFromError = $kGhFN.exceptionFromError;
module.exports.parseStackFrames = $kGhFN.parseStackFrames;
module.exports.LRUMap = $lacoC.LRUMap;
module.exports.generateSpanId = $lMrpL.generateSpanId;
module.exports.generateTraceId = $lMrpL.generateTraceId;
module.exports.SDK_VERSION = $8gllD.SDK_VERSION;
module.exports.getDebugImagesForResources = $65IUO.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $65IUO.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $iRcsS.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $iWURH.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $gtpOW.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $gtpOW.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $gtpOW.withRandomSafeContext;
module.exports.getComponentName = $7KadD.getComponentName;
module.exports.getLocationHref = $7KadD.getLocationHref;
module.exports.htmlTreeAsString = $7KadD.htmlTreeAsString;
module.exports.instrumentLangChainEmbeddings = $hFOjs.instrumentLangChainEmbeddings;

});
parcelRegister("12kse", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $98L9O = parcelRequire("98L9O");

var $jeg5Z = parcelRequire("jeg5Z");

var $3DKL9 = parcelRequire("3DKL9");

var $3QV8T = parcelRequire("3QV8T");

var $8OylQ = parcelRequire("8OylQ");
let $0c15d82441abdad0$var$errorsInstrumented = false;
function $0c15d82441abdad0$var$registerSpanErrorInstrumentation() {
    if ($0c15d82441abdad0$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $3QV8T.getActiveSpan();
        const rootSpan = activeSpan && $3QV8T.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $8OylQ.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $0c15d82441abdad0$var$errorsInstrumented = true;
    $98L9O.addGlobalErrorInstrumentationHandler(errorCallback);
    $jeg5Z.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $0c15d82441abdad0$var$registerSpanErrorInstrumentation;

});
parcelRegister("glA0g", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $be6a8900c9727da7$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $be6a8900c9727da7$var$DEBUG_BUILD;

});

parcelRegister("98L9O", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6hRPo = parcelRequire("6hRPo");

var $awwU9 = parcelRequire("awwU9");
let $6a7970e32f9cc231$var$_oldOnErrorHandler = null;
function $6a7970e32f9cc231$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $awwU9.addHandler(type, handler);
    $awwU9.maybeInstrument(type, $6a7970e32f9cc231$var$instrumentError);
}
function $6a7970e32f9cc231$var$instrumentError() {
    $6a7970e32f9cc231$var$_oldOnErrorHandler = $6hRPo.GLOBAL_OBJ.onerror;
    $6hRPo.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $awwU9.triggerHandlers("error", handlerData);
        if ($6a7970e32f9cc231$var$_oldOnErrorHandler) return $6a7970e32f9cc231$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $6hRPo.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $6a7970e32f9cc231$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("6hRPo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $493e15bb7c387b1b$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $493e15bb7c387b1b$var$GLOBAL_OBJ;

});

parcelRegister("awwU9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $3Arox = parcelRequire("3Arox");
const $7a966abd61976d44$var$handlers = {};
const $7a966abd61976d44$var$instrumented = {};
function $7a966abd61976d44$var$addHandler(type, handler) {
    $7a966abd61976d44$var$handlers[type] = $7a966abd61976d44$var$handlers[type] || [];
    $7a966abd61976d44$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $7a966abd61976d44$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $7a966abd61976d44$var$resetInstrumentationHandlers() {
    Object.keys($7a966abd61976d44$var$handlers).forEach((key)=>{
        $7a966abd61976d44$var$handlers[key] = void 0;
    });
}
function $7a966abd61976d44$var$maybeInstrument(type, instrumentFn) {
    if (!$7a966abd61976d44$var$instrumented[type]) {
        $7a966abd61976d44$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $7a966abd61976d44$var$triggerHandlers(type, data) {
    const typeHandlers = type && $7a966abd61976d44$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$3Arox.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $7a966abd61976d44$var$addHandler;
module.exports.maybeInstrument = $7a966abd61976d44$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $7a966abd61976d44$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $7a966abd61976d44$var$triggerHandlers;

});
parcelRegister("3DKL9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2x74l = parcelRequire("2x74l");

var $glA0g = parcelRequire("glA0g");

var $6hRPo = parcelRequire("6hRPo");
const $2a6949159a2c709d$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $2a6949159a2c709d$var$PREFIX = "Sentry Logger ";
const $2a6949159a2c709d$var$originalConsoleMethods = {};
function $2a6949159a2c709d$var$consoleSandbox(callback) {
    if (!("console" in $6hRPo.GLOBAL_OBJ)) return callback();
    const console = $6hRPo.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($2a6949159a2c709d$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $2a6949159a2c709d$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $2a6949159a2c709d$var$enable() {
    $2a6949159a2c709d$var$_getLoggerSettings().enabled = true;
}
function $2a6949159a2c709d$var$disable() {
    $2a6949159a2c709d$var$_getLoggerSettings().enabled = false;
}
function $2a6949159a2c709d$var$isEnabled() {
    return $2a6949159a2c709d$var$_getLoggerSettings().enabled;
}
function $2a6949159a2c709d$var$log(...args) {
    $2a6949159a2c709d$var$_maybeLog("log", ...args);
}
function $2a6949159a2c709d$var$warn(...args) {
    $2a6949159a2c709d$var$_maybeLog("warn", ...args);
}
function $2a6949159a2c709d$var$error(...args) {
    $2a6949159a2c709d$var$_maybeLog("error", ...args);
}
function $2a6949159a2c709d$var$_maybeLog(level, ...args) {
    if (!$glA0g.DEBUG_BUILD) return;
    if ($2a6949159a2c709d$var$isEnabled()) $2a6949159a2c709d$var$consoleSandbox(()=>{
        $6hRPo.GLOBAL_OBJ.console[level](`${$2a6949159a2c709d$var$PREFIX}[${level}]:`, ...args);
    });
}
function $2a6949159a2c709d$var$_getLoggerSettings() {
    if (!$glA0g.DEBUG_BUILD) return {
        enabled: false
    };
    return $2x74l.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $2a6949159a2c709d$var$debug = {
    enable: /** Enable logging. */ $2a6949159a2c709d$var$enable,
    disable: /** Disable logging. */ $2a6949159a2c709d$var$disable,
    isEnabled: /** Check if logging is enabled. */ $2a6949159a2c709d$var$isEnabled,
    log: /** Log a message. */ $2a6949159a2c709d$var$log,
    warn: /** Log a warning. */ $2a6949159a2c709d$var$warn,
    error: /** Log an error. */ $2a6949159a2c709d$var$error
};
module.exports.CONSOLE_LEVELS = $2a6949159a2c709d$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $2a6949159a2c709d$var$consoleSandbox;
module.exports.debug = $2a6949159a2c709d$var$debug;
module.exports.originalConsoleMethods = $2a6949159a2c709d$var$originalConsoleMethods;

});
parcelRegister("2x74l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8gllD = parcelRequire("8gllD");

var $6hRPo = parcelRequire("6hRPo");
function $1d84259c49ad0692$var$getMainCarrier() {
    $1d84259c49ad0692$var$getSentryCarrier($6hRPo.GLOBAL_OBJ);
    return $6hRPo.GLOBAL_OBJ;
}
function $1d84259c49ad0692$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $8gllD.SDK_VERSION;
    return __SENTRY__[$8gllD.SDK_VERSION] = __SENTRY__[$8gllD.SDK_VERSION] || {};
}
function $1d84259c49ad0692$var$getGlobalSingleton(name, creator, obj = $6hRPo.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$8gllD.SDK_VERSION] = __SENTRY__[$8gllD.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $1d84259c49ad0692$var$getGlobalSingleton;
module.exports.getMainCarrier = $1d84259c49ad0692$var$getMainCarrier;
module.exports.getSentryCarrier = $1d84259c49ad0692$var$getSentryCarrier;

});
parcelRegister("8gllD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $60406098b8ddfa9f$var$SDK_VERSION = "10.58.0";
module.exports.SDK_VERSION = $60406098b8ddfa9f$var$SDK_VERSION;

});



parcelRegister("3Arox", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $29c9fbee2e22e0c6$var$STACKTRACE_FRAME_LIMIT = 50;
const $29c9fbee2e22e0c6$var$UNKNOWN_FUNCTION = "?";
const $29c9fbee2e22e0c6$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $29c9fbee2e22e0c6$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $29c9fbee2e22e0c6$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $29c9fbee2e22e0c6$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($29c9fbee2e22e0c6$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $29c9fbee2e22e0c6$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $29c9fbee2e22e0c6$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $29c9fbee2e22e0c6$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $29c9fbee2e22e0c6$var$createStackParser(...stackParser);
    return stackParser;
}
function $29c9fbee2e22e0c6$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($29c9fbee2e22e0c6$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($29c9fbee2e22e0c6$var$STRIP_FRAME_REGEXP.test($29c9fbee2e22e0c6$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($29c9fbee2e22e0c6$var$STRIP_FRAME_REGEXP.test($29c9fbee2e22e0c6$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $29c9fbee2e22e0c6$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $29c9fbee2e22e0c6$var$getLastStackFrame(localStack).filename,
            function: frame.function || $29c9fbee2e22e0c6$var$UNKNOWN_FUNCTION
        }));
}
function $29c9fbee2e22e0c6$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $29c9fbee2e22e0c6$var$defaultFunctionName = "<anonymous>";
function $29c9fbee2e22e0c6$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $29c9fbee2e22e0c6$var$defaultFunctionName;
        return fn.name || $29c9fbee2e22e0c6$var$defaultFunctionName;
    } catch  {
        return $29c9fbee2e22e0c6$var$defaultFunctionName;
    }
}
function $29c9fbee2e22e0c6$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $29c9fbee2e22e0c6$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $29c9fbee2e22e0c6$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $29c9fbee2e22e0c6$var$createStackParser;
module.exports.getFramesFromEvent = $29c9fbee2e22e0c6$var$getFramesFromEvent;
module.exports.getFunctionName = $29c9fbee2e22e0c6$var$getFunctionName;
module.exports.normalizeStackTracePath = $29c9fbee2e22e0c6$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $29c9fbee2e22e0c6$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $29c9fbee2e22e0c6$var$stripSentryFramesAndReverse;

});



parcelRegister("jeg5Z", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6hRPo = parcelRequire("6hRPo");

var $awwU9 = parcelRequire("awwU9");
let $dffbcf64d4f9f89f$var$_oldOnUnhandledRejectionHandler = null;
function $dffbcf64d4f9f89f$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $awwU9.addHandler(type, handler);
    $awwU9.maybeInstrument(type, $dffbcf64d4f9f89f$var$instrumentUnhandledRejection);
}
function $dffbcf64d4f9f89f$var$instrumentUnhandledRejection() {
    $dffbcf64d4f9f89f$var$_oldOnUnhandledRejectionHandler = $6hRPo.GLOBAL_OBJ.onunhandledrejection;
    $6hRPo.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $awwU9.triggerHandlers("unhandledrejection", handlerData);
        if ($dffbcf64d4f9f89f$var$_oldOnUnhandledRejectionHandler) return $dffbcf64d4f9f89f$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $6hRPo.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $dffbcf64d4f9f89f$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("3QV8T", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $arkyo = parcelRequire("arkyo");

var $aTrwl = parcelRequire("aTrwl");

var $2x74l = parcelRequire("2x74l");

var $9OgG9 = parcelRequire("9OgG9");

var $23CGM = parcelRequire("23CGM");

var $8OylQ = parcelRequire("8OylQ");

var $eb8RV = parcelRequire("eb8RV");

var $eXIZW = parcelRequire("eXIZW");

var $lMrpL = parcelRequire("lMrpL");

var $5w1OV = parcelRequire("5w1OV");

var $dbV67 = parcelRequire("dbV67");

var $3DKL9 = parcelRequire("3DKL9");

var $2oeY5 = parcelRequire("2oeY5");
const $2ce28db46c04d63b$var$TRACE_FLAG_NONE = 0;
const $2ce28db46c04d63b$var$TRACE_FLAG_SAMPLED = 1;
let $2ce28db46c04d63b$var$hasShownSpanDropWarning = false;
function $2ce28db46c04d63b$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $2ce28db46c04d63b$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $2ce28db46c04d63b$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $2ce28db46c04d63b$var$spanToJSON(span).parent_span_id;
    const scope = $eb8RV.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $lMrpL.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $2ce28db46c04d63b$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $2ce28db46c04d63b$var$spanIsSampled(span);
    return $dbV67.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $2ce28db46c04d63b$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $2ce28db46c04d63b$var$spanIsSampled(span);
    return $dbV67.generateTraceparentHeader(traceId, spanId, sampled);
}
function $2ce28db46c04d63b$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $2ce28db46c04d63b$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $2ce28db46c04d63b$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $2ce28db46c04d63b$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $2ce28db46c04d63b$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $2ce28db46c04d63b$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $2ce28db46c04d63b$var$ensureTimestampInSeconds(input.getTime());
    return $5w1OV.timestampInSeconds();
}
function $2ce28db46c04d63b$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $2ce28db46c04d63b$var$spanToJSON(span) {
    if ($2ce28db46c04d63b$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($2ce28db46c04d63b$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $2ce28db46c04d63b$var$getOtelParentSpanId(span),
            start_timestamp: $2ce28db46c04d63b$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $2ce28db46c04d63b$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $2ce28db46c04d63b$var$getStatusMessage(status),
            op: attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $2ce28db46c04d63b$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $2ce28db46c04d63b$var$spanToStreamedSpanJSON(span) {
    if ($2ce28db46c04d63b$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($2ce28db46c04d63b$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $2ce28db46c04d63b$var$getOtelParentSpanId(span),
            start_timestamp: $2ce28db46c04d63b$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $2ce28db46c04d63b$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $2ce28db46c04d63b$var$INTERNAL_getSegmentSpan(span),
            status: $2ce28db46c04d63b$var$getSimpleStatusMessage(status),
            attributes: attributes,
            links: $2ce28db46c04d63b$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $2ce28db46c04d63b$var$INTERNAL_getSegmentSpan(span)
    };
}
function $2ce28db46c04d63b$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $2ce28db46c04d63b$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $aTrwl.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $aTrwl.serializeAttributes(link.attributes)
            }))
    };
}
function $2ce28db46c04d63b$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $2ce28db46c04d63b$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $2ce28db46c04d63b$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $2ce28db46c04d63b$var$TRACE_FLAG_SAMPLED;
}
function $2ce28db46c04d63b$var$getStatusMessage(status) {
    if (!status || status.code === $8OylQ.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $8OylQ.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $2ce28db46c04d63b$var$getSimpleStatusMessage(status) {
    return !status || status.code === $8OylQ.SPAN_STATUS_OK || status.code === $8OylQ.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
const $2ce28db46c04d63b$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $2ce28db46c04d63b$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $2ce28db46c04d63b$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$2ce28db46c04d63b$var$ROOT_SPAN_FIELD] || span;
    $eXIZW.addNonEnumerableProperty(childSpan, $2ce28db46c04d63b$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$2ce28db46c04d63b$var$CHILD_SPANS_FIELD]) span[$2ce28db46c04d63b$var$CHILD_SPANS_FIELD].add(childSpan);
    else $eXIZW.addNonEnumerableProperty(span, $2ce28db46c04d63b$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $2ce28db46c04d63b$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$2ce28db46c04d63b$var$CHILD_SPANS_FIELD]) span[$2ce28db46c04d63b$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $2ce28db46c04d63b$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($2ce28db46c04d63b$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$2ce28db46c04d63b$var$CHILD_SPANS_FIELD] ? Array.from(span2[$2ce28db46c04d63b$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $2ce28db46c04d63b$var$getRootSpan = $2ce28db46c04d63b$var$INTERNAL_getSegmentSpan;
function $2ce28db46c04d63b$var$INTERNAL_getSegmentSpan(span) {
    return span[$2ce28db46c04d63b$var$ROOT_SPAN_FIELD] || span;
}
function $2ce28db46c04d63b$var$getActiveSpan() {
    const carrier$1 = $2x74l.getMainCarrier();
    const acs = $arkyo.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $2oeY5._getSpanForScope($9OgG9.getCurrentScope());
}
function $2ce28db46c04d63b$var$showSpanDropWarning() {
    if (!$2ce28db46c04d63b$var$hasShownSpanDropWarning) {
        $3DKL9.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $2ce28db46c04d63b$var$hasShownSpanDropWarning = true;
    }
}
function $2ce28db46c04d63b$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $2ce28db46c04d63b$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $2ce28db46c04d63b$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $2ce28db46c04d63b$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $2ce28db46c04d63b$var$addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $2ce28db46c04d63b$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $2ce28db46c04d63b$var$getActiveSpan;
module.exports.getRootSpan = $2ce28db46c04d63b$var$getRootSpan;
module.exports.getSimpleStatusMessage = $2ce28db46c04d63b$var$getSimpleStatusMessage;
module.exports.getSpanDescendants = $2ce28db46c04d63b$var$getSpanDescendants;
module.exports.getStatusMessage = $2ce28db46c04d63b$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $2ce28db46c04d63b$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $2ce28db46c04d63b$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $2ce28db46c04d63b$var$showSpanDropWarning;
module.exports.spanIsSampled = $2ce28db46c04d63b$var$spanIsSampled;
module.exports.spanTimeInputToSeconds = $2ce28db46c04d63b$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $2ce28db46c04d63b$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $2ce28db46c04d63b$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $2ce28db46c04d63b$var$spanToTraceContext;
module.exports.spanToTraceHeader = $2ce28db46c04d63b$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $2ce28db46c04d63b$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $2ce28db46c04d63b$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $2ce28db46c04d63b$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $2ce28db46c04d63b$var$updateSpanName;

});
parcelRegister("arkyo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2x74l = parcelRequire("2x74l");

var $irmLV = parcelRequire("irmLV");
function $799c5e8b479b6095$var$setAsyncContextStrategy(strategy) {
    const registry = $2x74l.getMainCarrier();
    const sentry = $2x74l.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $799c5e8b479b6095$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $2x74l.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $irmLV.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $799c5e8b479b6095$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $799c5e8b479b6095$var$setAsyncContextStrategy;

});
parcelRegister("irmLV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fdwY1 = parcelRequire("fdwY1");

var $De3kE = parcelRequire("De3kE");

var $1cVQS = parcelRequire("1cVQS");

var $6tZdC = parcelRequire("6tZdC");

var $2x74l = parcelRequire("2x74l");
class $d6cc69a267ce4c67$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $De3kE.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $De3kE.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($6tZdC.isThenable(maybePromiseResult)) return $1cVQS.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $d6cc69a267ce4c67$var$getAsyncContextStack() {
    const registry = $2x74l.getMainCarrier();
    const sentry = $2x74l.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $d6cc69a267ce4c67$var$AsyncContextStack($fdwY1.getDefaultCurrentScope(), $fdwY1.getDefaultIsolationScope());
}
function $d6cc69a267ce4c67$var$withScope(callback) {
    return $d6cc69a267ce4c67$var$getAsyncContextStack().withScope(callback);
}
function $d6cc69a267ce4c67$var$withSetScope(scope, callback) {
    const stack = $d6cc69a267ce4c67$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $d6cc69a267ce4c67$var$withIsolationScope(callback) {
    return $d6cc69a267ce4c67$var$getAsyncContextStack().withScope(()=>{
        return callback($d6cc69a267ce4c67$var$getAsyncContextStack().getIsolationScope());
    });
}
function $d6cc69a267ce4c67$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $d6cc69a267ce4c67$var$withIsolationScope,
        withScope: $d6cc69a267ce4c67$var$withScope,
        withSetScope: $d6cc69a267ce4c67$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $d6cc69a267ce4c67$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$d6cc69a267ce4c67$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$d6cc69a267ce4c67$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $d6cc69a267ce4c67$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $d6cc69a267ce4c67$var$getStackAsyncContextStrategy;

});
parcelRegister("fdwY1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2x74l = parcelRequire("2x74l");

var $De3kE = parcelRequire("De3kE");
function $b141a477c1b4349d$var$getDefaultCurrentScope() {
    return $2x74l.getGlobalSingleton("defaultCurrentScope", ()=>new $De3kE.Scope());
}
function $b141a477c1b4349d$var$getDefaultIsolationScope() {
    return $2x74l.getGlobalSingleton("defaultIsolationScope", ()=>new $De3kE.Scope());
}
module.exports.getDefaultCurrentScope = $b141a477c1b4349d$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $b141a477c1b4349d$var$getDefaultIsolationScope;

});
parcelRegister("De3kE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $aBajH = parcelRequire("aBajH");

var $3DKL9 = parcelRequire("3DKL9");

var $6tZdC = parcelRequire("6tZdC");

var $hI1Sn = parcelRequire("hI1Sn");

var $23WDq = parcelRequire("23WDq");

var $lMrpL = parcelRequire("lMrpL");

var $gtpOW = parcelRequire("gtpOW");

var $2oeY5 = parcelRequire("2oeY5");

var $694gv = parcelRequire("694gv");

var $5w1OV = parcelRequire("5w1OV");
const $075e8b3713cb5330$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $075e8b3713cb5330$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $lMrpL.generateTraceId(),
            sampleRand: $gtpOW.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $075e8b3713cb5330$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $2oeY5._setSpanForScope(newScope, $2oeY5._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $aBajH.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $075e8b3713cb5330$var$Scope ? scopeToMerge.getScopeData() : $6tZdC.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $2oeY5._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $lMrpL.generateTraceId(),
            sampleRand: $gtpOW.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $075e8b3713cb5330$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $5w1OV.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $694gv.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $2oeY5._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $hI1Sn.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $23WDq.uuid4();
        if (!this._client) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $23WDq.uuid4();
        if (!this._client) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $23WDq.uuid4();
        if (!this._client) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $075e8b3713cb5330$var$Scope;

});
parcelRegister("aBajH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $23WDq = parcelRequire("23WDq");

var $5w1OV = parcelRequire("5w1OV");
function $7b755cc6cc3ae98e$var$makeSession(context) {
    const startingTime = $5w1OV.timestampInSeconds();
    const session = {
        sid: $23WDq.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$7b755cc6cc3ae98e$var$sessionToJSON(session)
    };
    if (context) $7b755cc6cc3ae98e$var$updateSession(session, context);
    return session;
}
function $7b755cc6cc3ae98e$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $5w1OV.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $23WDq.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $7b755cc6cc3ae98e$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $7b755cc6cc3ae98e$var$updateSession(session, context);
}
function $7b755cc6cc3ae98e$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $7b755cc6cc3ae98e$var$closeSession;
module.exports.makeSession = $7b755cc6cc3ae98e$var$makeSession;
module.exports.updateSession = $7b755cc6cc3ae98e$var$updateSession;

});
parcelRegister("23WDq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eXIZW = parcelRequire("eXIZW");

var $gtpOW = parcelRequire("gtpOW");

var $694gv = parcelRequire("694gv");

var $6hRPo = parcelRequire("6hRPo");
function $18095844de993f34$var$getCrypto() {
    const gbl = $6hRPo.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $18095844de993f34$var$emptyUuid;
function $18095844de993f34$var$getRandomByte() {
    return $gtpOW.safeMathRandom() * 16;
}
function $18095844de993f34$var$uuid4(crypto = $18095844de993f34$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $gtpOW.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$18095844de993f34$var$emptyUuid) $18095844de993f34$var$emptyUuid = "10000000100040008000100000000000";
    return $18095844de993f34$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($18095844de993f34$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $18095844de993f34$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $18095844de993f34$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $18095844de993f34$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $18095844de993f34$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $18095844de993f34$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $18095844de993f34$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $18095844de993f34$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $18095844de993f34$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $18095844de993f34$var$parseSemver(input) {
    const match = input.match($18095844de993f34$var$SEMVER_REGEXP) || [];
    const major = $18095844de993f34$var$_parseInt(match[1]);
    const minor = $18095844de993f34$var$_parseInt(match[2]);
    const patch = $18095844de993f34$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $18095844de993f34$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$694gv.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $694gv.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$694gv.snipLine(line, 0));
}
function $18095844de993f34$var$checkOrSetAlreadyCaught(exception) {
    if ($18095844de993f34$var$isAlreadyCaptured(exception)) return true;
    try {
        $eXIZW.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $18095844de993f34$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $18095844de993f34$var$addContextToFrame;
module.exports.addExceptionMechanism = $18095844de993f34$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $18095844de993f34$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $18095844de993f34$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $18095844de993f34$var$getEventDescription;
module.exports.isAlreadyCaptured = $18095844de993f34$var$isAlreadyCaptured;
module.exports.parseSemver = $18095844de993f34$var$parseSemver;
module.exports.uuid4 = $18095844de993f34$var$uuid4;

});
parcelRegister("eXIZW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $6tZdC = parcelRequire("6tZdC");
function $ae497b098725f37a$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $ae497b098725f37a$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $ae497b098725f37a$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $ae497b098725f37a$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $ae497b098725f37a$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $ae497b098725f37a$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($ae497b098725f37a$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $ae497b098725f37a$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $ae497b098725f37a$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $ae497b098725f37a$var$convertToPlainObject(value) {
    if ($6tZdC.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$ae497b098725f37a$var$getOwnProperties(value)
    };
    if ($6tZdC.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$ae497b098725f37a$var$getOwnProperties(value)
        };
    }
    return value;
}
function $ae497b098725f37a$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $ae497b098725f37a$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($ae497b098725f37a$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $ae497b098725f37a$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $ae497b098725f37a$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $ae497b098725f37a$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($ae497b098725f37a$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($ae497b098725f37a$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $ae497b098725f37a$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $ae497b098725f37a$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $ae497b098725f37a$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $6tZdC.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $ae497b098725f37a$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $ae497b098725f37a$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $ae497b098725f37a$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $ae497b098725f37a$var$extractExceptionKeysForMessage;
module.exports.fill = $ae497b098725f37a$var$fill;
module.exports.getOriginalFunction = $ae497b098725f37a$var$getOriginalFunction;
module.exports.markFunctionWrapped = $ae497b098725f37a$var$markFunctionWrapped;
module.exports.objectify = $ae497b098725f37a$var$objectify;
module.exports.wrapMethod = $ae497b098725f37a$var$wrapMethod;

});
parcelRegister("6tZdC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4b84f048e6f52a35$var$objectToString = Object.prototype.toString;
function $4b84f048e6f52a35$var$isError(wat) {
    switch($4b84f048e6f52a35$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $4b84f048e6f52a35$var$isInstanceOf(wat, Error);
    }
}
function $4b84f048e6f52a35$var$isBuiltin(wat, className) {
    return $4b84f048e6f52a35$var$objectToString.call(wat) === `[object ${className}]`;
}
function $4b84f048e6f52a35$var$isErrorEvent(wat) {
    return $4b84f048e6f52a35$var$isBuiltin(wat, "ErrorEvent");
}
function $4b84f048e6f52a35$var$isDOMError(wat) {
    return $4b84f048e6f52a35$var$isBuiltin(wat, "DOMError");
}
function $4b84f048e6f52a35$var$isDOMException(wat) {
    return $4b84f048e6f52a35$var$isBuiltin(wat, "DOMException");
}
function $4b84f048e6f52a35$var$isString(wat) {
    return $4b84f048e6f52a35$var$isBuiltin(wat, "String");
}
function $4b84f048e6f52a35$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $4b84f048e6f52a35$var$isPrimitive(wat) {
    return wat === null || $4b84f048e6f52a35$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $4b84f048e6f52a35$var$isPlainObject(wat) {
    return $4b84f048e6f52a35$var$isBuiltin(wat, "Object");
}
function $4b84f048e6f52a35$var$isEvent(wat) {
    return typeof Event !== "undefined" && $4b84f048e6f52a35$var$isInstanceOf(wat, Event);
}
function $4b84f048e6f52a35$var$isElement(wat) {
    return typeof Element !== "undefined" && $4b84f048e6f52a35$var$isInstanceOf(wat, Element);
}
function $4b84f048e6f52a35$var$isRegExp(wat) {
    return $4b84f048e6f52a35$var$isBuiltin(wat, "RegExp");
}
function $4b84f048e6f52a35$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $4b84f048e6f52a35$var$isSyntheticEvent(wat) {
    return $4b84f048e6f52a35$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $4b84f048e6f52a35$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $4b84f048e6f52a35$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $4b84f048e6f52a35$var$isRequest(request) {
    return typeof Request !== "undefined" && $4b84f048e6f52a35$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $4b84f048e6f52a35$var$isDOMError;
module.exports.isDOMException = $4b84f048e6f52a35$var$isDOMException;
module.exports.isElement = $4b84f048e6f52a35$var$isElement;
module.exports.isError = $4b84f048e6f52a35$var$isError;
module.exports.isErrorEvent = $4b84f048e6f52a35$var$isErrorEvent;
module.exports.isEvent = $4b84f048e6f52a35$var$isEvent;
module.exports.isInstanceOf = $4b84f048e6f52a35$var$isInstanceOf;
module.exports.isParameterizedString = $4b84f048e6f52a35$var$isParameterizedString;
module.exports.isPlainObject = $4b84f048e6f52a35$var$isPlainObject;
module.exports.isPrimitive = $4b84f048e6f52a35$var$isPrimitive;
module.exports.isRegExp = $4b84f048e6f52a35$var$isRegExp;
module.exports.isRequest = $4b84f048e6f52a35$var$isRequest;
module.exports.isString = $4b84f048e6f52a35$var$isString;
module.exports.isSyntheticEvent = $4b84f048e6f52a35$var$isSyntheticEvent;
module.exports.isThenable = $4b84f048e6f52a35$var$isThenable;
module.exports.isVueViewModel = $4b84f048e6f52a35$var$isVueViewModel;

});


parcelRegister("gtpOW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6hRPo = parcelRequire("6hRPo");
let $bfe3623abbae8ce2$var$RESOLVED_RUNNER;
function $bfe3623abbae8ce2$var$withRandomSafeContext(cb) {
    if ($bfe3623abbae8ce2$var$RESOLVED_RUNNER !== void 0) return $bfe3623abbae8ce2$var$RESOLVED_RUNNER ? $bfe3623abbae8ce2$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $6hRPo.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $bfe3623abbae8ce2$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $bfe3623abbae8ce2$var$RESOLVED_RUNNER(cb);
    }
    $bfe3623abbae8ce2$var$RESOLVED_RUNNER = null;
    return cb();
}
function $bfe3623abbae8ce2$var$safeMathRandom() {
    return $bfe3623abbae8ce2$var$withRandomSafeContext(()=>Math.random());
}
function $bfe3623abbae8ce2$var$safeDateNow() {
    return $bfe3623abbae8ce2$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $bfe3623abbae8ce2$var$safeDateNow;
module.exports.safeMathRandom = $bfe3623abbae8ce2$var$safeMathRandom;
module.exports.withRandomSafeContext = $bfe3623abbae8ce2$var$withRandomSafeContext;

});

parcelRegister("694gv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6tZdC = parcelRequire("6tZdC");

var $cAnBa = parcelRequire("cAnBa");
function $4796e45740328cde$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $4796e45740328cde$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $4796e45740328cde$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($6tZdC.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($cAnBa.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $4796e45740328cde$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$6tZdC.isString(value)) return false;
    if ($6tZdC.isRegExp(pattern)) return pattern.test(value);
    if ($6tZdC.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $4796e45740328cde$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($4796e45740328cde$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $4796e45740328cde$var$isMatchingPattern;
module.exports.safeJoin = $4796e45740328cde$var$safeJoin;
module.exports.snipLine = $4796e45740328cde$var$snipLine;
module.exports.stringMatchesSomePattern = $4796e45740328cde$var$stringMatchesSomePattern;
module.exports.truncate = $4796e45740328cde$var$truncate;

});
parcelRegister("cAnBa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2uBiD = parcelRequire("2uBiD");

var $eXIZW = parcelRequire("eXIZW");

var $3Arox = parcelRequire("3Arox");
let $929b26f93d6e1b64$var$stringifier;
function $929b26f93d6e1b64$var$setNormalizeStringifier(newStringifier) {
    $929b26f93d6e1b64$var$stringifier = newStringifier;
}
function $929b26f93d6e1b64$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $929b26f93d6e1b64$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $929b26f93d6e1b64$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $929b26f93d6e1b64$var$normalize(object, depth);
    if ($929b26f93d6e1b64$var$jsonSize(normalized) > maxSize) return $929b26f93d6e1b64$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $929b26f93d6e1b64$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $929b26f93d6e1b64$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $929b26f93d6e1b64$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($2uBiD.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $2uBiD.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $929b26f93d6e1b64$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $eXIZW.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $929b26f93d6e1b64$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $929b26f93d6e1b64$var$stringifyValue(key, value) {
    try {
        if ($929b26f93d6e1b64$var$stringifier) {
            const stringified = $929b26f93d6e1b64$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$3Arox.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $929b26f93d6e1b64$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $929b26f93d6e1b64$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $929b26f93d6e1b64$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $929b26f93d6e1b64$var$jsonSize(value) {
    return $929b26f93d6e1b64$var$utf8Length(JSON.stringify(value));
}
function $929b26f93d6e1b64$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $929b26f93d6e1b64$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $929b26f93d6e1b64$var$normalize;
module.exports.normalizeToSize = $929b26f93d6e1b64$var$normalizeToSize;
module.exports.normalizeUrlToBase = $929b26f93d6e1b64$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $929b26f93d6e1b64$var$setNormalizeStringifier;
module.exports.stringifyValue = $929b26f93d6e1b64$var$stringifyValue;

});
parcelRegister("2uBiD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eXIZW = parcelRequire("eXIZW");
const $1d0b51016d5c87ea$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $1d0b51016d5c87ea$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $1d0b51016d5c87ea$var$setSkipNormalizationHint(obj) {
    $eXIZW.addNonEnumerableProperty(obj, $1d0b51016d5c87ea$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $1d0b51016d5c87ea$var$setNormalizationDepthOverrideHint(obj, depth) {
    $eXIZW.addNonEnumerableProperty(obj, $1d0b51016d5c87ea$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $1d0b51016d5c87ea$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$1d0b51016d5c87ea$var$SENTRY_SKIP_NORMALIZATION]);
}
function $1d0b51016d5c87ea$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$1d0b51016d5c87ea$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $1d0b51016d5c87ea$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $1d0b51016d5c87ea$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $1d0b51016d5c87ea$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $1d0b51016d5c87ea$var$setSkipNormalizationHint;

});




parcelRegister("5w1OV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gtpOW = parcelRequire("gtpOW");

var $6hRPo = parcelRequire("6hRPo");
const $40415a690be0fdba$var$ONE_SECOND_IN_MS = 1e3;
function $40415a690be0fdba$var$dateTimestampInSeconds() {
    return $gtpOW.safeDateNow() / $40415a690be0fdba$var$ONE_SECOND_IN_MS;
}
function $40415a690be0fdba$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $6hRPo.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $40415a690be0fdba$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $gtpOW.withRandomSafeContext(()=>performance.now())) / $40415a690be0fdba$var$ONE_SECOND_IN_MS;
    };
}
let $40415a690be0fdba$var$_cachedTimestampInSeconds;
function $40415a690be0fdba$var$timestampInSeconds() {
    const func = $40415a690be0fdba$var$_cachedTimestampInSeconds ?? ($40415a690be0fdba$var$_cachedTimestampInSeconds = $40415a690be0fdba$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $40415a690be0fdba$var$cachedTimeOrigin = null;
function $40415a690be0fdba$var$getBrowserTimeOrigin() {
    const { performance: performance } = $6hRPo.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $gtpOW.withRandomSafeContext(()=>performance.now());
    const dateNow = $gtpOW.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $40415a690be0fdba$var$browserPerformanceTimeOrigin() {
    if ($40415a690be0fdba$var$cachedTimeOrigin === null) $40415a690be0fdba$var$cachedTimeOrigin = $40415a690be0fdba$var$getBrowserTimeOrigin();
    return $40415a690be0fdba$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $40415a690be0fdba$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $40415a690be0fdba$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $40415a690be0fdba$var$timestampInSeconds;

});


parcelRegister("hI1Sn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ce48004661236f91$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $ce48004661236f91$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $ce48004661236f91$var$merge;

});

parcelRegister("lMrpL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $23WDq = parcelRequire("23WDq");
function $fdb358a43ff9fa3b$var$generateTraceId() {
    return $23WDq.uuid4();
}
function $fdb358a43ff9fa3b$var$generateSpanId() {
    return $23WDq.uuid4().substring(16);
}
module.exports.generateSpanId = $fdb358a43ff9fa3b$var$generateSpanId;
module.exports.generateTraceId = $fdb358a43ff9fa3b$var$generateTraceId;

});

parcelRegister("2oeY5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eXIZW = parcelRequire("eXIZW");

var $cVsnx = parcelRequire("cVsnx");
const $1bd96f046ebd8e51$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $1bd96f046ebd8e51$var$_setSpanForScope(scope, span) {
    if (span) $eXIZW.addNonEnumerableProperty(scope, $1bd96f046ebd8e51$var$SCOPE_SPAN_FIELD, $cVsnx.makeWeakRef(span));
    else delete scope[$1bd96f046ebd8e51$var$SCOPE_SPAN_FIELD];
}
function $1bd96f046ebd8e51$var$_getSpanForScope(scope) {
    return $cVsnx.derefWeakRef(scope[$1bd96f046ebd8e51$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $1bd96f046ebd8e51$var$_getSpanForScope;
module.exports._setSpanForScope = $1bd96f046ebd8e51$var$_setSpanForScope;

});
parcelRegister("cVsnx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6hRPo = parcelRequire("6hRPo");
function $9690d24bf820df37$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $6hRPo.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $9690d24bf820df37$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $9690d24bf820df37$var$derefWeakRef;
module.exports.makeWeakRef = $9690d24bf820df37$var$makeWeakRef;

});




parcelRegister("1cVQS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0e13c9992a5876b9$var$isActualPromise = (p)=>p instanceof Promise && !p[$0e13c9992a5876b9$var$kChainedCopy];
const $0e13c9992a5876b9$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $0e13c9992a5876b9$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $0e13c9992a5876b9$var$isActualPromise(chained) && $0e13c9992a5876b9$var$isActualPromise(original) ? chained : $0e13c9992a5876b9$var$copyProps(original, chained);
};
const $0e13c9992a5876b9$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$0e13c9992a5876b9$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $0e13c9992a5876b9$var$chainAndCopyPromiseLike;

});



parcelRegister("aTrwl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6tZdC = parcelRequire("6tZdC");
function $7ee4637f4b96aa35$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $7ee4637f4b96aa35$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $7ee4637f4b96aa35$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $7ee4637f4b96aa35$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $7ee4637f4b96aa35$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $7ee4637f4b96aa35$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $7ee4637f4b96aa35$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $7ee4637f4b96aa35$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($6tZdC.isPrimitive(val)) weight += $7ee4637f4b96aa35$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $7ee4637f4b96aa35$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $7ee4637f4b96aa35$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $7ee4637f4b96aa35$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $7ee4637f4b96aa35$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $7ee4637f4b96aa35$var$isAttributeObject;
module.exports.serializeAttributes = $7ee4637f4b96aa35$var$serializeAttributes;

});

parcelRegister("9OgG9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $arkyo = parcelRequire("arkyo");

var $2x74l = parcelRequire("2x74l");

var $De3kE = parcelRequire("De3kE");

var $lMrpL = parcelRequire("lMrpL");
let $7245b8a7c3e6b1fc$var$_externalPropagationContextProvider;
function $7245b8a7c3e6b1fc$var$registerExternalPropagationContext(fn) {
    $7245b8a7c3e6b1fc$var$_externalPropagationContextProvider = fn;
}
function $7245b8a7c3e6b1fc$var$getExternalPropagationContext() {
    return $7245b8a7c3e6b1fc$var$_externalPropagationContextProvider?.();
}
function $7245b8a7c3e6b1fc$var$hasExternalPropagationContext() {
    return $7245b8a7c3e6b1fc$var$_externalPropagationContextProvider !== void 0;
}
function $7245b8a7c3e6b1fc$var$getCurrentScope() {
    const carrier$1 = $2x74l.getMainCarrier();
    const acs = $arkyo.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $7245b8a7c3e6b1fc$var$getIsolationScope() {
    const carrier$1 = $2x74l.getMainCarrier();
    const acs = $arkyo.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $7245b8a7c3e6b1fc$var$getGlobalScope() {
    return $2x74l.getGlobalSingleton("globalScope", ()=>new $De3kE.Scope());
}
function $7245b8a7c3e6b1fc$var$withScope(...rest) {
    const carrier$1 = $2x74l.getMainCarrier();
    const acs = $arkyo.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $7245b8a7c3e6b1fc$var$withIsolationScope(...rest) {
    const carrier$1 = $2x74l.getMainCarrier();
    const acs = $arkyo.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $7245b8a7c3e6b1fc$var$getClient() {
    return $7245b8a7c3e6b1fc$var$getCurrentScope().getClient();
}
function $7245b8a7c3e6b1fc$var$getTraceContextFromScope(scope) {
    const externalContext = $7245b8a7c3e6b1fc$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $lMrpL.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $7245b8a7c3e6b1fc$var$getClient;
module.exports.getCurrentScope = $7245b8a7c3e6b1fc$var$getCurrentScope;
module.exports.getExternalPropagationContext = $7245b8a7c3e6b1fc$var$getExternalPropagationContext;
module.exports.getGlobalScope = $7245b8a7c3e6b1fc$var$getGlobalScope;
module.exports.getIsolationScope = $7245b8a7c3e6b1fc$var$getIsolationScope;
module.exports.getTraceContextFromScope = $7245b8a7c3e6b1fc$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $7245b8a7c3e6b1fc$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $7245b8a7c3e6b1fc$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $7245b8a7c3e6b1fc$var$withIsolationScope;
module.exports.withScope = $7245b8a7c3e6b1fc$var$withScope;

});

parcelRegister("23CGM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $17f9df64ab99a088$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $17f9df64ab99a088$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $17f9df64ab99a088$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $17f9df64ab99a088$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $17f9df64ab99a088$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("8OylQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $66ada3b6a9a207fc$var$SPAN_STATUS_UNSET = 0;
const $66ada3b6a9a207fc$var$SPAN_STATUS_OK = 1;
const $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR = 2;
function $66ada3b6a9a207fc$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $66ada3b6a9a207fc$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $66ada3b6a9a207fc$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $66ada3b6a9a207fc$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $66ada3b6a9a207fc$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $66ada3b6a9a207fc$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $66ada3b6a9a207fc$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $66ada3b6a9a207fc$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $66ada3b6a9a207fc$var$setHttpStatus;

});

parcelRegister("eb8RV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eXIZW = parcelRequire("eXIZW");

var $cVsnx = parcelRequire("cVsnx");
const $a528f8f04bb83d04$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $a528f8f04bb83d04$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $a528f8f04bb83d04$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $eXIZW.addNonEnumerableProperty(span, $a528f8f04bb83d04$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $cVsnx.makeWeakRef(isolationScope));
        $eXIZW.addNonEnumerableProperty(span, $a528f8f04bb83d04$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $a528f8f04bb83d04$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$a528f8f04bb83d04$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $cVsnx.derefWeakRef(spanWithScopes[$a528f8f04bb83d04$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
module.exports.getCapturedScopesOnSpan = $a528f8f04bb83d04$var$getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $a528f8f04bb83d04$var$setCapturedScopesOnSpan;

});

parcelRegister("dbV67", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3DKL9 = parcelRequire("3DKL9");

var $ejsmR = parcelRequire("ejsmR");

var $cieLS = parcelRequire("cieLS");

var $3JV3y = parcelRequire("3JV3y");

var $lMrpL = parcelRequire("lMrpL");

var $gtpOW = parcelRequire("gtpOW");
const $99a897dac5d8d714$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $99a897dac5d8d714$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($99a897dac5d8d714$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $99a897dac5d8d714$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $99a897dac5d8d714$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $ejsmR.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $lMrpL.generateTraceId(),
        sampleRand: $gtpOW.safeMathRandom()
    };
    const sampleRand = $99a897dac5d8d714$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $99a897dac5d8d714$var$generateSentryTraceHeader(traceId = $lMrpL.generateTraceId(), spanId = $lMrpL.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $99a897dac5d8d714$var$generateTraceparentHeader(traceId = $lMrpL.generateTraceId(), spanId = $lMrpL.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $99a897dac5d8d714$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $3JV3y.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $3JV3y.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $gtpOW.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $gtpOW.safeMathRandom() * (1 - parsedSampleRate);
    else return $gtpOW.safeMathRandom();
}
function $99a897dac5d8d714$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $cieLS.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $3DKL9.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $3DKL9.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $99a897dac5d8d714$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $99a897dac5d8d714$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $99a897dac5d8d714$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $99a897dac5d8d714$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $99a897dac5d8d714$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $99a897dac5d8d714$var$shouldContinueTrace;

});
parcelRegister("ejsmR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $6tZdC = parcelRequire("6tZdC");
const $a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $a6b8d8446f822cb6$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $a6b8d8446f822cb6$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $a6b8d8446f822cb6$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $a6b8d8446f822cb6$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $a6b8d8446f822cb6$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $a6b8d8446f822cb6$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$6tZdC.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $a6b8d8446f822cb6$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $a6b8d8446f822cb6$var$baggageHeaderToObject(baggageHeader);
}
function $a6b8d8446f822cb6$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $a6b8d8446f822cb6$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $a6b8d8446f822cb6$var$MAX_BAGGAGE_STRING_LENGTH) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $a6b8d8446f822cb6$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $a6b8d8446f822cb6$var$parseBaggageHeader(existing);
    const incomingEntries = $a6b8d8446f822cb6$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $a6b8d8446f822cb6$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $a6b8d8446f822cb6$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $a6b8d8446f822cb6$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $a6b8d8446f822cb6$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $a6b8d8446f822cb6$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $a6b8d8446f822cb6$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $a6b8d8446f822cb6$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $a6b8d8446f822cb6$var$parseBaggageHeader;

});

parcelRegister("cieLS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");
const $8f329fb82569835e$var$ORG_ID_REGEX = /^o(\d+)\./;
const $8f329fb82569835e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $8f329fb82569835e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $8f329fb82569835e$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $8f329fb82569835e$var$dsnFromString(str) {
    const match = $8f329fb82569835e$var$DSN_REGEX.exec(str);
    if (!match) {
        $3DKL9.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $8f329fb82569835e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $8f329fb82569835e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $8f329fb82569835e$var$validateDsn(dsn) {
    if (!$glA0g.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $3DKL9.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $3DKL9.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$8f329fb82569835e$var$isValidProtocol(protocol)) {
        $3DKL9.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $3DKL9.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $8f329fb82569835e$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($8f329fb82569835e$var$ORG_ID_REGEX);
    return match?.[1];
}
function $8f329fb82569835e$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $8f329fb82569835e$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $8f329fb82569835e$var$makeDsn(from) {
    const components = typeof from === "string" ? $8f329fb82569835e$var$dsnFromString(from) : $8f329fb82569835e$var$dsnFromComponents(from);
    if (!components || !$8f329fb82569835e$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $8f329fb82569835e$var$dsnFromString;
module.exports.dsnToString = $8f329fb82569835e$var$dsnToString;
module.exports.extractOrgIdFromClient = $8f329fb82569835e$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $8f329fb82569835e$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $8f329fb82569835e$var$makeDsn;

});

parcelRegister("3JV3y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $2b91d5457e42c9a0$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $2b91d5457e42c9a0$var$parseSampleRate;

});




parcelRegister("fciTx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $23CGM = parcelRequire("23CGM");

var $3DKL9 = parcelRequire("3DKL9");

var $2dDpf = parcelRequire("2dDpf");

var $cMia1 = parcelRequire("cMia1");

var $2oeY5 = parcelRequire("2oeY5");

var $3QV8T = parcelRequire("3QV8T");

var $5w1OV = parcelRequire("5w1OV");

var $kOJcT = parcelRequire("kOJcT");

var $jmqLW = parcelRequire("jmqLW");

var $zKmFx = parcelRequire("zKmFx");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");
const $b106a2179253290b$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $b106a2179253290b$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $b106a2179253290b$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $b106a2179253290b$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $b106a2179253290b$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $b106a2179253290b$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _finishReason = $b106a2179253290b$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $b106a2179253290b$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $b106a2179253290b$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $b106a2179253290b$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $9OgG9.getClient();
    if (!client || !$2dDpf.hasSpansEnabled()) {
        const span2 = new $jmqLW.SentryNonRecordingSpan();
        const dsc = {
            sample_rate: "0",
            sampled: "false",
            ...$kOJcT.getDynamicSamplingContextFromSpan(span2)
        };
        $kOJcT.freezeDscOnSpan(span2, dsc);
        return span2;
    }
    const scope = $9OgG9.getCurrentScope();
    const previousActiveSpan = $3QV8T.getActiveSpan();
    const span = $b106a2179253290b$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if (thisArg instanceof $jmqLW.SentryNonRecordingSpan) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $5w1OV.timestampInSeconds();
            const spanEndTimestamp = $3QV8T.spanTimeInputToSeconds(timestamp);
            const spans = $3QV8T.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $3QV8T.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $3QV8T.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $cMia1.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $b106a2179253290b$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $b106a2179253290b$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $5w1OV.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $5w1OV.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $2oeY5._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $3QV8T.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($23CGM.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $8OylQ.SPAN_STATUS_OK
        });
        $3DKL9.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $3QV8T.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $8OylQ.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $glA0g.DEBUG_BUILD && $3DKL9.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $3QV8T.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($glA0g.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $3DKL9.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $3DKL9.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $3QV8T.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$3QV8T.spanToJSON(startedSpan).timestamp || startedSpan instanceof $zKmFx.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $3QV8T.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $8OylQ.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $b106a2179253290b$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $b106a2179253290b$var$_startIdleSpan(options) {
    const span = $bn0md.startInactiveSpan(options);
    $2oeY5._setSpanForScope($9OgG9.getCurrentScope(), span);
    $glA0g.DEBUG_BUILD && $3DKL9.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $b106a2179253290b$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $b106a2179253290b$var$startIdleSpan;

});
parcelRegister("2dDpf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");
function $19db5cea6ab83501$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $9OgG9.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $19db5cea6ab83501$var$hasSpansEnabled;

});

parcelRegister("cMia1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $694gv = parcelRequire("694gv");
function $94d80e0f771f113e$var$logIgnoredSpan(droppedSpan) {
    $3DKL9.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $94d80e0f771f113e$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($94d80e0f771f113e$var$isStringOrRegExp(pattern)) {
            if (span.description && $694gv.isMatchingPattern(span.description, pattern)) {
                $glA0g.DEBUG_BUILD && $94d80e0f771f113e$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $694gv.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $694gv.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$94d80e0f771f113e$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $glA0g.DEBUG_BUILD && $94d80e0f771f113e$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $94d80e0f771f113e$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $694gv.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $94d80e0f771f113e$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $94d80e0f771f113e$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $94d80e0f771f113e$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $94d80e0f771f113e$var$shouldIgnoreSpan;

});

parcelRegister("kOJcT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $770IZ = parcelRequire("770IZ");

var $9OgG9 = parcelRequire("9OgG9");

var $23CGM = parcelRequire("23CGM");

var $ejsmR = parcelRequire("ejsmR");

var $cieLS = parcelRequire("cieLS");

var $2dDpf = parcelRequire("2dDpf");

var $eXIZW = parcelRequire("eXIZW");

var $3QV8T = parcelRequire("3QV8T");

var $eb8RV = parcelRequire("eb8RV");
const $f27b8b52e29f999f$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $f27b8b52e29f999f$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $eXIZW.addNonEnumerableProperty(spanWithMaybeDsc, $f27b8b52e29f999f$var$FROZEN_DSC_FIELD, dsc);
}
function $f27b8b52e29f999f$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $770IZ.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $cieLS.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $f27b8b52e29f999f$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $f27b8b52e29f999f$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $f27b8b52e29f999f$var$getDynamicSamplingContextFromSpan(span) {
    const client = $9OgG9.getClient();
    if (!client) return {};
    const rootSpan = $3QV8T.getRootSpan(span);
    const rootSpanJson = $3QV8T.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$f27b8b52e29f999f$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $ejsmR.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $f27b8b52e29f999f$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($2dDpf.hasSpansEnabled()) {
        dsc.sampled = String($3QV8T.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $eb8RV.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $f27b8b52e29f999f$var$spanToBaggageHeader(span) {
    const dsc = $f27b8b52e29f999f$var$getDynamicSamplingContextFromSpan(span);
    return $ejsmR.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $f27b8b52e29f999f$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $f27b8b52e29f999f$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $f27b8b52e29f999f$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $f27b8b52e29f999f$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $f27b8b52e29f999f$var$spanToBaggageHeader;

});
parcelRegister("770IZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $52d9bfc4a0534635$var$DEFAULT_ENVIRONMENT = "production";
const $52d9bfc4a0534635$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $52d9bfc4a0534635$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $52d9bfc4a0534635$var$DEV_ENVIRONMENT;

});


parcelRegister("jmqLW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lMrpL = parcelRequire("lMrpL");

var $3QV8T = parcelRequire("3QV8T");
class $e184d6ce8a693add$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $lMrpL.generateTraceId();
        this._spanId = spanContext.spanId || $lMrpL.generateSpanId();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $3QV8T.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
module.exports.SentryNonRecordingSpan = $e184d6ce8a693add$var$SentryNonRecordingSpan;

});

parcelRegister("zKmFx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $aHJDA = parcelRequire("aHJDA");

var $23CGM = parcelRequire("23CGM");

var $3DKL9 = parcelRequire("3DKL9");

var $lMrpL = parcelRequire("lMrpL");

var $3QV8T = parcelRequire("3QV8T");

var $5w1OV = parcelRequire("5w1OV");

var $kOJcT = parcelRequire("kOJcT");

var $7KBXl = parcelRequire("7KBXl");

var $kYUUl = parcelRequire("kYUUl");

var $7Qa0H = parcelRequire("7Qa0H");

var $eb8RV = parcelRequire("eb8RV");
const $06b73c0c6f260a3c$var$MAX_SPAN_COUNT = 1e3;
class $06b73c0c6f260a3c$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $lMrpL.generateTraceId();
        this._spanId = spanContext.spanId || $lMrpL.generateSpanId();
        this._startTime = spanContext.startTimestamp || $5w1OV.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $3QV8T.TRACE_FLAG_SAMPLED : $3QV8T.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = $3QV8T.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute($23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = $3QV8T.spanTimeInputToSeconds(endTimestamp);
        $7KBXl.logSpanEnd(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $3QV8T.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$23CGM.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$23CGM.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $kYUUl.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $3QV8T.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $3QV8T.getRootSpan(this).spanContext().spanId : void 0,
            links: $3QV8T.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $3QV8T.getRootSpan(this),
            status: $3QV8T.getSimpleStatusMessage(this._status),
            attributes: this._attributes,
            links: $3QV8T.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $06b73c0c6f260a3c$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $5w1OV.timestampInSeconds();
        const attributes = $06b73c0c6f260a3c$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $3QV8T.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $9OgG9.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === $3QV8T.getRootSpan(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $06b73c0c6f260a3c$var$sendSpanEnvelope($aHJDA.createSpanEnvelope([
                this
            ], client));
            else {
                $glA0g.DEBUG_BUILD && $3DKL9.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && $7Qa0H.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = $eb8RV.getCapturedScopesOnSpan(this).scope || $9OgG9.getCurrentScope();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        if (!$06b73c0c6f260a3c$var$isFullFinishedSpan($3QV8T.spanToJSON(this))) return void 0;
        if (!this._name) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $eb8RV.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = $3QV8T.getSpanDescendants(this).filter((span)=>span !== this && !$06b73c0c6f260a3c$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>$3QV8T.spanToJSON(span)).filter($06b73c0c6f260a3c$var$isFullFinishedSpan);
        const source = this._attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $3QV8T.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $06b73c0c6f260a3c$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $06b73c0c6f260a3c$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $kOJcT.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $kYUUl.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $06b73c0c6f260a3c$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $06b73c0c6f260a3c$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $06b73c0c6f260a3c$var$isStandaloneSpan(span) {
    return span instanceof $06b73c0c6f260a3c$var$SentrySpan && span.isStandaloneSpan();
}
function $06b73c0c6f260a3c$var$sendSpanEnvelope(envelope) {
    const client = $9OgG9.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $06b73c0c6f260a3c$var$SentrySpan;

});
parcelRegister("aHJDA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kOJcT = parcelRequire("kOJcT");

var $fvKkS = parcelRequire("fvKkS");

var $cieLS = parcelRequire("cieLS");

var $hnvKl = parcelRequire("hnvKl");

var $gtpOW = parcelRequire("gtpOW");

var $cMia1 = parcelRequire("cMia1");

var $3QV8T = parcelRequire("3QV8T");
function $7cb15233893f0bd0$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $7cb15233893f0bd0$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $hnvKl.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date($gtpOW.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $cieLS.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $hnvKl.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $7cb15233893f0bd0$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $hnvKl.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $7cb15233893f0bd0$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $hnvKl.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $hnvKl.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $7cb15233893f0bd0$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $kOJcT.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date($gtpOW.safeDateNow()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $cieLS.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $3QV8T.spanToJSON(span);
        return !$cMia1.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $3QV8T.spanToJSON(span);
        const processedSpan = !$fvKkS.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $3QV8T.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $3QV8T.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($hnvKl.createSpanEnvelopeItem(spanJson));
    }
    return $hnvKl.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $7cb15233893f0bd0$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $7cb15233893f0bd0$var$createEventEnvelope;
module.exports.createSessionEnvelope = $7cb15233893f0bd0$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $7cb15233893f0bd0$var$createSpanEnvelope;

});
parcelRegister("fvKkS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eXIZW = parcelRequire("eXIZW");
function $b4adb1991a660185$var$withStreamedSpan(callback) {
    $eXIZW.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $b4adb1991a660185$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $b4adb1991a660185$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $b4adb1991a660185$var$withStreamedSpan;

});

parcelRegister("hnvKl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2x74l = parcelRequire("2x74l");

var $cieLS = parcelRequire("cieLS");

var $cAnBa = parcelRequire("cAnBa");

var $gtpOW = parcelRequire("gtpOW");

var $6hRPo = parcelRequire("6hRPo");
function $ca6d35d2a981138c$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $ca6d35d2a981138c$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $ca6d35d2a981138c$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $ca6d35d2a981138c$var$envelopeContainsItemType(envelope, types) {
    return $ca6d35d2a981138c$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $ca6d35d2a981138c$var$encodeUTF8(input) {
    const carrier$1 = $2x74l.getSentryCarrier($6hRPo.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $ca6d35d2a981138c$var$decodeUTF8(input) {
    const carrier$1 = $2x74l.getSentryCarrier($6hRPo.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $ca6d35d2a981138c$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $ca6d35d2a981138c$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $ca6d35d2a981138c$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($cAnBa.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $ca6d35d2a981138c$var$concatBuffers(parts);
}
function $ca6d35d2a981138c$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $ca6d35d2a981138c$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $ca6d35d2a981138c$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($ca6d35d2a981138c$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $ca6d35d2a981138c$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $ca6d35d2a981138c$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $ca6d35d2a981138c$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $ca6d35d2a981138c$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $ca6d35d2a981138c$var$_isOverriddenType(type) {
    return type in $ca6d35d2a981138c$var$DATA_CATEGORY_OVERRIDES;
}
function $ca6d35d2a981138c$var$envelopeItemTypeToDataCategory(type) {
    return $ca6d35d2a981138c$var$_isOverriddenType(type) ? $ca6d35d2a981138c$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $ca6d35d2a981138c$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $ca6d35d2a981138c$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date($gtpOW.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $cieLS.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $ca6d35d2a981138c$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $ca6d35d2a981138c$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $ca6d35d2a981138c$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $ca6d35d2a981138c$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $ca6d35d2a981138c$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $ca6d35d2a981138c$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $ca6d35d2a981138c$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $ca6d35d2a981138c$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $ca6d35d2a981138c$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $ca6d35d2a981138c$var$parseEnvelope;
module.exports.serializeEnvelope = $ca6d35d2a981138c$var$serializeEnvelope;

});


parcelRegister("7KBXl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $3QV8T = parcelRequire("3QV8T");
function $5a4a4598cb578769$var$logSpanStart(span) {
    if (!$glA0g.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $3QV8T.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $3QV8T.spanIsSampled(span);
    const rootSpan = $3QV8T.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $3QV8T.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $3DKL9.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $5a4a4598cb578769$var$logSpanEnd(span) {
    if (!$glA0g.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $3QV8T.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $3QV8T.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $3DKL9.debug.log(msg);
}
module.exports.logSpanEnd = $5a4a4598cb578769$var$logSpanEnd;
module.exports.logSpanStart = $5a4a4598cb578769$var$logSpanStart;

});

parcelRegister("kYUUl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $23CGM = parcelRequire("23CGM");

var $3DKL9 = parcelRequire("3DKL9");

var $3QV8T = parcelRequire("3QV8T");
function $f4658df194015406$var$setMeasurement(name, value, unit, activeSpan = $3QV8T.getActiveSpan()) {
    const rootSpan = activeSpan && $3QV8T.getRootSpan(activeSpan);
    if (rootSpan) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $f4658df194015406$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $f4658df194015406$var$setMeasurement;
module.exports.timedEventsToMeasurements = $f4658df194015406$var$timedEventsToMeasurements;

});

parcelRegister("7Qa0H", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $5b55278ca6331432$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $5b55278ca6331432$var$hasSpanStreamingEnabled;

});


parcelRegister("bn0md", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $arkyo = parcelRequire("arkyo");

var $2x74l = parcelRequire("2x74l");

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $23CGM = parcelRequire("23CGM");

var $ejsmR = parcelRequire("ejsmR");

var $3DKL9 = parcelRequire("3DKL9");

var $dl6Mu = parcelRequire("dl6Mu");

var $2dDpf = parcelRequire("2dDpf");

var $cMia1 = parcelRequire("cMia1");

var $7Qa0H = parcelRequire("7Qa0H");

var $3JV3y = parcelRequire("3JV3y");

var $lMrpL = parcelRequire("lMrpL");

var $gtpOW = parcelRequire("gtpOW");

var $2oeY5 = parcelRequire("2oeY5");

var $3QV8T = parcelRequire("3QV8T");

var $dbV67 = parcelRequire("dbV67");

var $kOJcT = parcelRequire("kOJcT");

var $7KBXl = parcelRequire("7KBXl");

var $H0bGg = parcelRequire("H0bGg");

var $jmqLW = parcelRequire("jmqLW");

var $zKmFx = parcelRequire("zKmFx");

var $8OylQ = parcelRequire("8OylQ");

var $eb8RV = parcelRequire("eb8RV");
const $84721ea13854c2cc$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $84721ea13854c2cc$var$startSpan(options, callback) {
    const acs = $84721ea13854c2cc$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $84721ea13854c2cc$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $9OgG9.withScope(customForkedScope, ()=>{
        const wrapper = $84721ea13854c2cc$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $9OgG9.getCurrentScope();
            const parentSpan = $84721ea13854c2cc$var$getParentSpan(scope, customParentSpan);
            const client = $9OgG9.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $jmqLW.SentryNonRecordingSpan() : $84721ea13854c2cc$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent("no_parent_span", "span");
            if (!$84721ea13854c2cc$var$_isIgnoredSpan(activeSpan) || !parentSpan) $2oeY5._setSpanForScope(scope, activeSpan);
            return $dl6Mu.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $3QV8T.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $8OylQ.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $84721ea13854c2cc$var$startSpanManual(options, callback) {
    const acs = $84721ea13854c2cc$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $84721ea13854c2cc$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $9OgG9.withScope(customForkedScope, ()=>{
        const wrapper = $84721ea13854c2cc$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $9OgG9.getCurrentScope();
            const parentSpan = $84721ea13854c2cc$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $jmqLW.SentryNonRecordingSpan() : $84721ea13854c2cc$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) $9OgG9.getClient()?.recordDroppedEvent("no_parent_span", "span");
            if (!$84721ea13854c2cc$var$_isIgnoredSpan(activeSpan) || !parentSpan) $2oeY5._setSpanForScope(scope, activeSpan);
            return $dl6Mu.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $3QV8T.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $8OylQ.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $84721ea13854c2cc$var$startInactiveSpan(options) {
    const acs = $84721ea13854c2cc$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $84721ea13854c2cc$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$9OgG9.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$84721ea13854c2cc$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $9OgG9.getCurrentScope();
        const parentSpan = $84721ea13854c2cc$var$getParentSpan(scope, customParentSpan);
        const client = $9OgG9.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent("no_parent_span", "span");
            return new $jmqLW.SentryNonRecordingSpan();
        }
        return $84721ea13854c2cc$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $84721ea13854c2cc$var$continueTrace = (options, callback)=>{
    const carrier$1 = $2x74l.getMainCarrier();
    const acs = $arkyo.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $9OgG9.getClient();
    const incomingDsc = $ejsmR.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$dbV67.shouldContinueTrace(client, incomingDsc?.org_id)) return $84721ea13854c2cc$var$startNewTrace(callback);
    return $9OgG9.withScope((scope)=>{
        const propagationContext = $dbV67.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $2oeY5._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $84721ea13854c2cc$var$withActiveSpan(span, callback) {
    const acs = $84721ea13854c2cc$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $9OgG9.withScope((scope)=>{
        $2oeY5._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $84721ea13854c2cc$var$suppressTracing(callback) {
    const acs = $84721ea13854c2cc$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $9OgG9.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$84721ea13854c2cc$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$84721ea13854c2cc$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $84721ea13854c2cc$var$startNewTrace(callback) {
    const acs = $84721ea13854c2cc$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $9OgG9.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $lMrpL.generateTraceId(),
            sampleRand: $gtpOW.safeMathRandom()
        });
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $84721ea13854c2cc$var$withActiveSpan(null, callback);
    });
}
function $84721ea13854c2cc$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!$2dDpf.hasSpansEnabled()) {
        const span2 = new $jmqLW.SentryNonRecordingSpan();
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...$kOJcT.getDynamicSamplingContextFromSpan(span2)
            };
            $kOJcT.freezeDscOnSpan(span2, dsc);
        }
        return span2;
    }
    const client = $9OgG9.getClient();
    if ($84721ea13854c2cc$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$84721ea13854c2cc$var$_isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        return new $jmqLW.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = $9OgG9.getIsolationScope();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $84721ea13854c2cc$var$_startChildSpan(parentSpan, scope, spanArguments);
        $3QV8T.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $kOJcT.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $3QV8T.spanIsSampled(parentSpan);
        span = $84721ea13854c2cc$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        $kOJcT.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $84721ea13854c2cc$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) $kOJcT.freezeDscOnSpan(span, dsc);
    }
    $7KBXl.logSpanStart(span);
    $eb8RV.setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
function $84721ea13854c2cc$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $3QV8T.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $84721ea13854c2cc$var$getAcs() {
    const carrier$1 = $2x74l.getMainCarrier();
    return $arkyo.getAsyncContextStrategy(carrier$1);
}
function $84721ea13854c2cc$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = $9OgG9.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $84721ea13854c2cc$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : $H0bGg.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: $3JV3y.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $zKmFx.SentrySpan({
        ...spanArguments,
        attributes: {
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $7Qa0H.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $84721ea13854c2cc$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $84721ea13854c2cc$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : $3QV8T.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $zKmFx.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $jmqLW.SentryNonRecordingSpan({
        traceId: traceId
    });
    $3QV8T.addChildSpanToSpan(parentSpan, childSpan);
    const client = $9OgG9.getClient();
    if (!client) return childSpan;
    if ($7Qa0H.hasSpanStreamingEnabled(client) && childSpan instanceof $jmqLW.SentryNonRecordingSpan) {
        if (parentSpan instanceof $jmqLW.SentryNonRecordingSpan && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $84721ea13854c2cc$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $2oeY5._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $9OgG9.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $3QV8T.getRootSpan(span);
    return span;
}
function $84721ea13854c2cc$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $84721ea13854c2cc$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $84721ea13854c2cc$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$7Qa0H.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $cMia1.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $84721ea13854c2cc$var$_isIgnoredSpan(span) {
    return span instanceof $jmqLW.SentryNonRecordingSpan && span.dropReason === "ignored";
}
function $84721ea13854c2cc$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$84721ea13854c2cc$var$SUPPRESS_TRACING_KEY] === true;
}
module.exports.SUPPRESS_TRACING_KEY = $84721ea13854c2cc$var$SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $84721ea13854c2cc$var$continueTrace;
module.exports.startInactiveSpan = $84721ea13854c2cc$var$startInactiveSpan;
module.exports.startNewTrace = $84721ea13854c2cc$var$startNewTrace;
module.exports.startSpan = $84721ea13854c2cc$var$startSpan;
module.exports.startSpanManual = $84721ea13854c2cc$var$startSpanManual;
module.exports.suppressTracing = $84721ea13854c2cc$var$suppressTracing;
module.exports.withActiveSpan = $84721ea13854c2cc$var$withActiveSpan;

});
parcelRegister("dl6Mu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1cVQS = parcelRequire("1cVQS");

var $6tZdC = parcelRequire("6tZdC");
function $9b627f227811fc62$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $9b627f227811fc62$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $9b627f227811fc62$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($6tZdC.isThenable(value)) return $1cVQS.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $9b627f227811fc62$var$handleCallbackErrors;

});

parcelRegister("H0bGg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $2dDpf = parcelRequire("2dDpf");

var $3JV3y = parcelRequire("3JV3y");
function $0814297af6023e59$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$2dDpf.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $3JV3y.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $0814297af6023e59$var$sampleSpan;

});



parcelRegister("lHgv5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $23CGM = parcelRequire("23CGM");

var $i1HdV = parcelRequire("i1HdV");

var $cgx6M = parcelRequire("cgx6M");

var $3QV8T = parcelRequire("3QV8T");

var $eb8RV = parcelRequire("eb8RV");

var $fvKkS = parcelRequire("fvKkS");

var $dWgQI = parcelRequire("dWgQI");
function $fcba69c42f04d5dc$var$captureSpan(span, client) {
    const spanJSON = $3QV8T.spanToStreamedSpanJSON(span);
    const segmentSpan = $3QV8T.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $3QV8T.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $eb8RV.getCapturedScopesOnSpan(span);
    const finalScopeData = $i1HdV.getCombinedScopeData(spanIsolationScope, spanScope);
    $fcba69c42f04d5dc$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    $fcba69c42f04d5dc$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind);
    if (spanJSON.is_segment) {
        $fcba69c42f04d5dc$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $fcba69c42f04d5dc$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $fvKkS.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $fcba69c42f04d5dc$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanNameSource) $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        "sentry.span.source": spanNameSource
    });
    return {
        ...$3QV8T.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $fcba69c42f04d5dc$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $dWgQI.scopeContextsToSpanAttributes(scopeData.contexts);
    $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $fcba69c42f04d5dc$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $fcba69c42f04d5dc$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$23CGM.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$23CGM.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$23CGM.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$23CGM.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $fcba69c42f04d5dc$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $3QV8T.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
const $fcba69c42f04d5dc$var$SPAN_KIND_SERVER = 1;
const $fcba69c42f04d5dc$var$SPAN_KIND_CLIENT = 2;
function $fcba69c42f04d5dc$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind) {
    const attributes = spanJSON.attributes;
    if (!attributes) return;
    const httpMethod = attributes["http.request.method"] || attributes["http.method"];
    if (httpMethod) {
        $fcba69c42f04d5dc$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod);
        return;
    }
    const dbSystem = attributes["db.system.name"] || attributes["db.system"];
    const opIsCache = typeof attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "string" && `${attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]}`.startsWith("cache.");
    if (dbSystem && !opIsCache) {
        $fcba69c42f04d5dc$var$inferDbSpanData(spanJSON, attributes);
        return;
    }
    if (attributes["rpc.service"]) {
        $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "rpc"
        });
        return;
    }
    if (attributes["messaging.system"]) {
        $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "message"
        });
        return;
    }
    const faasTrigger = attributes["faas.trigger"];
    if (faasTrigger) $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: `${faasTrigger}`
    });
}
function $fcba69c42f04d5dc$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod) {
    const opParts = [
        "http"
    ];
    if (spanKind === $fcba69c42f04d5dc$var$SPAN_KIND_CLIENT) opParts.push("client");
    else if (spanKind === $fcba69c42f04d5dc$var$SPAN_KIND_SERVER) opParts.push("server");
    if (attributes["sentry.http.prefetch"]) opParts.push("prefetch");
    $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: opParts.join(".")
    });
    const customName = attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === "custom") return;
    const httpRoute = attributes["http.route"];
    if (typeof httpRoute === "string") {
        spanJSON.name = `${httpMethod} ${httpRoute}`;
        $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "route"
        });
    } else {
        if (spanKind === $fcba69c42f04d5dc$var$SPAN_KIND_CLIENT || spanKind === $fcba69c42f04d5dc$var$SPAN_KIND_SERVER) {
            const urlPath = $fcba69c42f04d5dc$var$getUrlPath(attributes, spanKind);
            if (urlPath) spanJSON.name = `${httpMethod} ${urlPath}`;
        }
        $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
        });
    }
}
function $fcba69c42f04d5dc$var$getUrlPath(attributes, spanKind) {
    const httpUrl = attributes["http.url"] || attributes["url.full"];
    const httpTarget = attributes["http.target"];
    const parsedUrl = typeof httpUrl === "string" ? $cgx6M.parseUrl(httpUrl) : void 0;
    const sanitizedUrl = parsedUrl ? $cgx6M.getSanitizedUrlString(parsedUrl) : void 0;
    if (spanKind === $fcba69c42f04d5dc$var$SPAN_KIND_SERVER && typeof httpTarget === "string") return $cgx6M.stripUrlQueryAndFragment(httpTarget);
    if (sanitizedUrl) return sanitizedUrl;
    if (typeof httpTarget === "string") return $cgx6M.stripUrlQueryAndFragment(httpTarget);
    return void 0;
}
function $fcba69c42f04d5dc$var$inferDbSpanData(spanJSON, attributes) {
    $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
    });
    const customName = attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === "custom") return;
    const statement = attributes["db.statement"];
    if (statement) {
        spanJSON.name = `${statement}`;
        $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes(spanJSON, {
            [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "task"
        });
    }
}
module.exports.applyBeforeSendSpanCallback = $fcba69c42f04d5dc$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $fcba69c42f04d5dc$var$captureSpan;
module.exports.inferSpanDataFromOtelAttributes = $fcba69c42f04d5dc$var$inferSpanDataFromOtelAttributes;
module.exports.safeSetSpanJSONAttributes = $fcba69c42f04d5dc$var$safeSetSpanJSONAttributes;

});
parcelRegister("i1HdV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $kOJcT = parcelRequire("kOJcT");

var $hI1Sn = parcelRequire("hI1Sn");

var $3QV8T = parcelRequire("3QV8T");
function $d1f9d94a414d99be$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $d1f9d94a414d99be$var$applyDataToEvent(event, data);
    if (span) $d1f9d94a414d99be$var$applySpanToEvent(event, span);
    $d1f9d94a414d99be$var$applyFingerprintToEvent(event, fingerprint);
    $d1f9d94a414d99be$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $d1f9d94a414d99be$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $d1f9d94a414d99be$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $d1f9d94a414d99be$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $d1f9d94a414d99be$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $d1f9d94a414d99be$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $d1f9d94a414d99be$var$mergeAndOverwriteScopeData(data, "user", user);
    $d1f9d94a414d99be$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $hI1Sn.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $d1f9d94a414d99be$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $hI1Sn.merge(data[prop], mergeVal, 1);
}
function $d1f9d94a414d99be$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $9OgG9.getGlobalScope().getScopeData();
    isolationScope && $d1f9d94a414d99be$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $d1f9d94a414d99be$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $d1f9d94a414d99be$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $d1f9d94a414d99be$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $d1f9d94a414d99be$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $d1f9d94a414d99be$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $3QV8T.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $kOJcT.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $3QV8T.getRootSpan(span);
    const transactionName = $3QV8T.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $d1f9d94a414d99be$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $d1f9d94a414d99be$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $d1f9d94a414d99be$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $d1f9d94a414d99be$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $d1f9d94a414d99be$var$mergeScopeData;

});

parcelRegister("cgx6M", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $23CGM = parcelRequire("23CGM");
const $8ee0a946eb3049ec$var$DEFAULT_BASE_URL = "thismessage:/";
function $8ee0a946eb3049ec$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $8ee0a946eb3049ec$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $8ee0a946eb3049ec$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $8ee0a946eb3049ec$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($8ee0a946eb3049ec$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $8ee0a946eb3049ec$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $8ee0a946eb3049ec$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $8ee0a946eb3049ec$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes[$23CGM.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$8ee0a946eb3049ec$var$isURLObjectRelative(urlObject)) {
            attributes[$23CGM.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $8ee0a946eb3049ec$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $8ee0a946eb3049ec$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $8ee0a946eb3049ec$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $8ee0a946eb3049ec$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $8ee0a946eb3049ec$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $8ee0a946eb3049ec$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $8ee0a946eb3049ec$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $8ee0a946eb3049ec$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $8ee0a946eb3049ec$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $8ee0a946eb3049ec$var$parseStringToURLObject;
module.exports.parseUrl = $8ee0a946eb3049ec$var$parseUrl;
module.exports.stripDataUrlContent = $8ee0a946eb3049ec$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $8ee0a946eb3049ec$var$stripUrlQueryAndFragment;

});

parcelRegister("dWgQI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a25dc30b38e3e251$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $a25dc30b38e3e251$var$scopeContextsToSpanAttributes;

});


parcelRegister("duCSA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $aBajH = parcelRequire("aBajH");

var $bn0md = parcelRequire("bn0md");

var $3DKL9 = parcelRequire("3DKL9");

var $6tZdC = parcelRequire("6tZdC");

var $23WDq = parcelRequire("23WDq");

var $Uh5B7 = parcelRequire("Uh5B7");

var $i1HdV = parcelRequire("i1HdV");

var $5w1OV = parcelRequire("5w1OV");

var $6hRPo = parcelRequire("6hRPo");
function $9d2c3c5bcaaae174$var$captureException(exception, hint) {
    return $9OgG9.getCurrentScope().captureException(exception, $Uh5B7.parseEventHintOrCaptureContext(hint));
}
function $9d2c3c5bcaaae174$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $9OgG9.getCurrentScope().captureMessage(message, level, hint);
}
function $9d2c3c5bcaaae174$var$captureEvent(event, hint) {
    return $9OgG9.getCurrentScope().captureEvent(event, hint);
}
function $9d2c3c5bcaaae174$var$setContext(name, context) {
    $9OgG9.getIsolationScope().setContext(name, context);
}
function $9d2c3c5bcaaae174$var$setExtras(extras) {
    $9OgG9.getIsolationScope().setExtras(extras);
}
function $9d2c3c5bcaaae174$var$setExtra(key, extra) {
    $9OgG9.getIsolationScope().setExtra(key, extra);
}
function $9d2c3c5bcaaae174$var$setTags(tags) {
    $9OgG9.getIsolationScope().setTags(tags);
}
function $9d2c3c5bcaaae174$var$setTag(key, value) {
    $9OgG9.getIsolationScope().setTag(key, value);
}
function $9d2c3c5bcaaae174$var$setUser(user) {
    $9OgG9.getIsolationScope().setUser(user);
}
function $9d2c3c5bcaaae174$var$setConversationId(conversationId) {
    $9OgG9.getIsolationScope().setConversationId(conversationId);
}
function $9d2c3c5bcaaae174$var$lastEventId() {
    return $9OgG9.getIsolationScope().lastEventId();
}
function $9d2c3c5bcaaae174$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $9OgG9.getCurrentScope();
    const client = $9OgG9.getClient();
    if (!client) $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $23WDq.uuid4();
}
function $9d2c3c5bcaaae174$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $9d2c3c5bcaaae174$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $5w1OV.timestampInSeconds();
        function finishCheckIn(status) {
            $9d2c3c5bcaaae174$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $5w1OV.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($6tZdC.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return $9OgG9.withIsolationScope(()=>upsertMonitorConfig?.isolateTrace ? $bn0md.startNewTrace(runCallback) : runCallback());
}
async function $9d2c3c5bcaaae174$var$flush(timeout) {
    const client = $9OgG9.getClient();
    if (client) return client.flush(timeout);
    $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $9d2c3c5bcaaae174$var$close(timeout) {
    const client = $9OgG9.getClient();
    if (client) return client.close(timeout);
    $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $9d2c3c5bcaaae174$var$isInitialized() {
    return !!$9OgG9.getClient();
}
function $9d2c3c5bcaaae174$var$isEnabled() {
    const client = $9OgG9.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $9d2c3c5bcaaae174$var$addEventProcessor(callback) {
    $9OgG9.getIsolationScope().addEventProcessor(callback);
}
function $9d2c3c5bcaaae174$var$startSession(context) {
    const isolationScope = $9OgG9.getIsolationScope();
    const { user: user } = $i1HdV.getCombinedScopeData(isolationScope, $9OgG9.getCurrentScope());
    const { userAgent: userAgent } = $6hRPo.GLOBAL_OBJ.navigator || {};
    const session$1 = $aBajH.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $aBajH.updateSession(currentSession, {
        status: "exited"
    });
    $9d2c3c5bcaaae174$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $9d2c3c5bcaaae174$var$endSession() {
    const isolationScope = $9OgG9.getIsolationScope();
    const currentScope = $9OgG9.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $aBajH.closeSession(session$1);
    $9d2c3c5bcaaae174$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $9d2c3c5bcaaae174$var$_sendSessionUpdate() {
    const isolationScope = $9OgG9.getIsolationScope();
    const client = $9OgG9.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $9d2c3c5bcaaae174$var$captureSession(end = false) {
    if (end) {
        $9d2c3c5bcaaae174$var$endSession();
        return;
    }
    $9d2c3c5bcaaae174$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $9d2c3c5bcaaae174$var$addEventProcessor;
module.exports.captureCheckIn = $9d2c3c5bcaaae174$var$captureCheckIn;
module.exports.captureEvent = $9d2c3c5bcaaae174$var$captureEvent;
module.exports.captureException = $9d2c3c5bcaaae174$var$captureException;
module.exports.captureMessage = $9d2c3c5bcaaae174$var$captureMessage;
module.exports.captureSession = $9d2c3c5bcaaae174$var$captureSession;
module.exports.close = $9d2c3c5bcaaae174$var$close;
module.exports.endSession = $9d2c3c5bcaaae174$var$endSession;
module.exports.flush = $9d2c3c5bcaaae174$var$flush;
module.exports.isEnabled = $9d2c3c5bcaaae174$var$isEnabled;
module.exports.isInitialized = $9d2c3c5bcaaae174$var$isInitialized;
module.exports.lastEventId = $9d2c3c5bcaaae174$var$lastEventId;
module.exports.setContext = $9d2c3c5bcaaae174$var$setContext;
module.exports.setConversationId = $9d2c3c5bcaaae174$var$setConversationId;
module.exports.setExtra = $9d2c3c5bcaaae174$var$setExtra;
module.exports.setExtras = $9d2c3c5bcaaae174$var$setExtras;
module.exports.setTag = $9d2c3c5bcaaae174$var$setTag;
module.exports.setTags = $9d2c3c5bcaaae174$var$setTags;
module.exports.setUser = $9d2c3c5bcaaae174$var$setUser;
module.exports.startSession = $9d2c3c5bcaaae174$var$startSession;
module.exports.withMonitor = $9d2c3c5bcaaae174$var$withMonitor;

});
parcelRegister("Uh5B7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $770IZ = parcelRequire("770IZ");

var $jw7Bz = parcelRequire("jw7Bz");

var $De3kE = parcelRequire("De3kE");

var $65IUO = parcelRequire("65IUO");

var $23WDq = parcelRequire("23WDq");

var $cAnBa = parcelRequire("cAnBa");

var $i1HdV = parcelRequire("i1HdV");

var $694gv = parcelRequire("694gv");

var $cmMjb = parcelRequire("cmMjb");

var $5w1OV = parcelRequire("5w1OV");
function $0a927ca73fe22007$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $23WDq.uuid4(),
        timestamp: event.timestamp || $5w1OV.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $0a927ca73fe22007$var$applyClientOptions(prepared, options);
    $0a927ca73fe22007$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $0a927ca73fe22007$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $0a927ca73fe22007$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $23WDq.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $i1HdV.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $i1HdV.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $cmMjb.resolvedSyncPromise(prepared) : $jw7Bz.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $0a927ca73fe22007$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $0a927ca73fe22007$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $0a927ca73fe22007$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $770IZ.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $694gv.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $694gv.truncate(exception.value, maxValueLength);
    });
}
function $0a927ca73fe22007$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $65IUO.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $0a927ca73fe22007$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $0a927ca73fe22007$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $0a927ca73fe22007$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $cAnBa.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $cAnBa.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $cAnBa.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $cAnBa.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $cAnBa.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $cAnBa.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $cAnBa.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $0a927ca73fe22007$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $De3kE.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $0a927ca73fe22007$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($0a927ca73fe22007$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($0a927ca73fe22007$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $0a927ca73fe22007$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $De3kE.Scope || typeof hint === "function";
}
const $0a927ca73fe22007$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $0a927ca73fe22007$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$0a927ca73fe22007$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $0a927ca73fe22007$var$applyClientOptions;
module.exports.applyDebugIds = $0a927ca73fe22007$var$applyDebugIds;
module.exports.applyDebugMeta = $0a927ca73fe22007$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $0a927ca73fe22007$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $0a927ca73fe22007$var$prepareEvent;

});
parcelRegister("jw7Bz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $6tZdC = parcelRequire("6tZdC");

var $cmMjb = parcelRequire("cmMjb");
function $e356e7aa78b7abfc$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $e356e7aa78b7abfc$var$_notifyEventProcessors(event, hint, processors, index);
        return $6tZdC.isThenable(result) ? result : $cmMjb.resolvedSyncPromise(result);
    } catch (error) {
        return $cmMjb.rejectedSyncPromise(error);
    }
}
function $e356e7aa78b7abfc$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $glA0g.DEBUG_BUILD && result === null && $3DKL9.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($6tZdC.isThenable(result)) return result.then((final)=>$e356e7aa78b7abfc$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $e356e7aa78b7abfc$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $e356e7aa78b7abfc$var$notifyEventProcessors;

});
parcelRegister("cmMjb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6tZdC = parcelRequire("6tZdC");
const $900d0326dea7f95e$var$STATE_PENDING = 0;
const $900d0326dea7f95e$var$STATE_RESOLVED = 1;
const $900d0326dea7f95e$var$STATE_REJECTED = 2;
function $900d0326dea7f95e$var$resolvedSyncPromise(value) {
    return new $900d0326dea7f95e$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $900d0326dea7f95e$var$rejectedSyncPromise(reason) {
    return new $900d0326dea7f95e$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $900d0326dea7f95e$var$SyncPromise {
    constructor(executor){
        this._state = $900d0326dea7f95e$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $900d0326dea7f95e$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $900d0326dea7f95e$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $900d0326dea7f95e$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $900d0326dea7f95e$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $900d0326dea7f95e$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $900d0326dea7f95e$var$STATE_PENDING) return;
            if ($6tZdC.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($900d0326dea7f95e$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($900d0326dea7f95e$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $900d0326dea7f95e$var$SyncPromise;
module.exports.rejectedSyncPromise = $900d0326dea7f95e$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $900d0326dea7f95e$var$resolvedSyncPromise;

});


parcelRegister("65IUO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3Arox = parcelRequire("3Arox");

var $6hRPo = parcelRequire("6hRPo");
let $46f60cf6c245691d$var$parsedStackResults;
let $46f60cf6c245691d$var$lastSentryKeysCount;
let $46f60cf6c245691d$var$lastNativeKeysCount;
let $46f60cf6c245691d$var$cachedFilenameDebugIds;
function $46f60cf6c245691d$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $6hRPo.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $6hRPo.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($46f60cf6c245691d$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $46f60cf6c245691d$var$lastSentryKeysCount && nativeDebugIdKeys.length === $46f60cf6c245691d$var$lastNativeKeysCount) return $46f60cf6c245691d$var$cachedFilenameDebugIds;
    $46f60cf6c245691d$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $46f60cf6c245691d$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $46f60cf6c245691d$var$cachedFilenameDebugIds = {};
    if (!$46f60cf6c245691d$var$parsedStackResults) $46f60cf6c245691d$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $46f60cf6c245691d$var$parsedStackResults?.[key];
            if (result && $46f60cf6c245691d$var$cachedFilenameDebugIds && debugId) {
                $46f60cf6c245691d$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($46f60cf6c245691d$var$parsedStackResults) $46f60cf6c245691d$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $46f60cf6c245691d$var$cachedFilenameDebugIds && $46f60cf6c245691d$var$parsedStackResults) {
                        $46f60cf6c245691d$var$cachedFilenameDebugIds[filename] = debugId;
                        $46f60cf6c245691d$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $46f60cf6c245691d$var$cachedFilenameDebugIds;
}
function $46f60cf6c245691d$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $46f60cf6c245691d$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $3Arox.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $46f60cf6c245691d$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $46f60cf6c245691d$var$getFilenameToDebugIdMap;

});



parcelRegister("d1DWf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cieLS = parcelRequire("cieLS");
const $97ba5950e7c97b4b$var$SENTRY_API_VERSION = "7";
function $97ba5950e7c97b4b$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $97ba5950e7c97b4b$var$_getIngestEndpoint(dsn) {
    return `${$97ba5950e7c97b4b$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $97ba5950e7c97b4b$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $97ba5950e7c97b4b$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $97ba5950e7c97b4b$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$97ba5950e7c97b4b$var$_getIngestEndpoint(dsn)}?${$97ba5950e7c97b4b$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $97ba5950e7c97b4b$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $cieLS.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$97ba5950e7c97b4b$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$cieLS.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $97ba5950e7c97b4b$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $97ba5950e7c97b4b$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $97ba5950e7c97b4b$var$getReportDialogEndpoint;

});

parcelRegister("32zx8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d1DWf = parcelRequire("d1DWf");

var $770IZ = parcelRequire("770IZ");

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $aHJDA = parcelRequire("aHJDA");

var $bNCFC = parcelRequire("bNCFC");

var $lDiMO = parcelRequire("lDiMO");

var $bJhjl = parcelRequire("bJhjl");

var $aBajH = parcelRequire("aBajH");

var $kOJcT = parcelRequire("kOJcT");

var $fvKkS = parcelRequire("fvKkS");

var $5Q8fK = parcelRequire("5Q8fK");

var $29kP8 = parcelRequire("29kP8");

var $1Kjg0 = parcelRequire("1Kjg0");

var $3DKL9 = parcelRequire("3DKL9");

var $cieLS = parcelRequire("cieLS");

var $hnvKl = parcelRequire("hnvKl");

var $7zIyX = parcelRequire("7zIyX");

var $6tZdC = parcelRequire("6tZdC");

var $hI1Sn = parcelRequire("hI1Sn");

var $23WDq = parcelRequire("23WDq");

var $3JV3y = parcelRequire("3JV3y");

var $Uh5B7 = parcelRequire("Uh5B7");

var $eWlAJ = parcelRequire("eWlAJ");

var $gtpOW = parcelRequire("gtpOW");

var $cMia1 = parcelRequire("cMia1");

var $3QV8T = parcelRequire("3QV8T");

var $cmMjb = parcelRequire("cmMjb");

var $456Az = parcelRequire("456Az");

var $k3ytP = parcelRequire("k3ytP");

var $338d9 = parcelRequire("338d9");
const $236d1f2ff9004ea1$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $236d1f2ff9004ea1$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $236d1f2ff9004ea1$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $236d1f2ff9004ea1$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $236d1f2ff9004ea1$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $236d1f2ff9004ea1$var$_makeInternalError(message) {
    return {
        message: message,
        [$236d1f2ff9004ea1$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $236d1f2ff9004ea1$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$236d1f2ff9004ea1$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $236d1f2ff9004ea1$var$_isInternalError(error) {
    return !!error && typeof error === "object" && $236d1f2ff9004ea1$var$INTERNAL_ERROR_SYMBOL in error;
}
function $236d1f2ff9004ea1$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && $236d1f2ff9004ea1$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $236d1f2ff9004ea1$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $236d1f2ff9004ea1$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $456Az.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $236d1f2ff9004ea1$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $eWlAJ.makePromiseBuffer(options.transportOptions?.bufferSize ?? $29kP8.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $338d9.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $cieLS.makeDsn(options.dsn);
        else $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $d1DWf.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        if (this._options.enableLogs) $236d1f2ff9004ea1$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $236d1f2ff9004ea1$var$estimateLogSizeInBytes, $lDiMO._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $236d1f2ff9004ea1$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $236d1f2ff9004ea1$var$estimateMetricSizeInBytes, $bJhjl._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $23WDq.uuid4();
        if ($23WDq.checkOrSetAlreadyCaught(exception)) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log($236d1f2ff9004ea1$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $23WDq.uuid4(),
            ...hint
        };
        const eventMessage = $6tZdC.isParameterizedString(message) ? message : String(message);
        const isMessage = $6tZdC.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $23WDq.uuid4();
        if (hint?.originalException && $23WDq.checkOrSetAlreadyCaught(hint.originalException)) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log($236d1f2ff9004ea1$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $236d1f2ff9004ea1$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $aBajH.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        $lDiMO._INTERNAL_flushLogsBuffer(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $bNCFC.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $bNCFC.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $5Q8fK.extractGenAiSpansFromEvent(event, this);
        let env = $aHJDA.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $hnvKl.addItemToEnvelope(env, $hnvKl.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $hnvKl.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $770IZ.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $glA0g.DEBUG_BUILD && $3DKL9.debug.warn($236d1f2ff9004ea1$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $glA0g.DEBUG_BUILD && $3DKL9.debug.warn($236d1f2ff9004ea1$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $aHJDA.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $bNCFC.setupIntegrations(this, integrations);
        $bNCFC.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $aBajH.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $Uh5B7.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$9OgG9.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $kOJcT.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $9OgG9.getCurrentScope(), isolationScope = $9OgG9.getIsolationScope()) {
        if ($glA0g.DEBUG_BUILD && $236d1f2ff9004ea1$var$isErrorEvent(event)) $3DKL9.debug.log(`Captured error event \`${$7zIyX.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($glA0g.DEBUG_BUILD) {
                if ($236d1f2ff9004ea1$var$_isDoNotSendEventError(reason)) $3DKL9.debug.log(reason.message);
                else if ($236d1f2ff9004ea1$var$_isInternalError(reason)) $3DKL9.debug.warn(reason.message);
                else $3DKL9.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $236d1f2ff9004ea1$var$isTransactionEvent(event);
        const isError = $236d1f2ff9004ea1$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $3JV3y.parseSampleRate(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && $gtpOW.safeMathRandom() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return $cmMjb.rejectedSyncPromise($236d1f2ff9004ea1$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $236d1f2ff9004ea1$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $236d1f2ff9004ea1$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $236d1f2ff9004ea1$var$processBeforeSend(this, options, prepared, hint);
            return $236d1f2ff9004ea1$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $236d1f2ff9004ea1$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($236d1f2ff9004ea1$var$_isDoNotSendEventError(reason) || $236d1f2ff9004ea1$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $236d1f2ff9004ea1$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $eWlAJ.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log("Sending outcomes:", outcomes);
        const envelope = $1Kjg0.createClientReportEnvelope(outcomes, this._options.tunnel && $cieLS.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $236d1f2ff9004ea1$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $236d1f2ff9004ea1$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($6tZdC.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$6tZdC.isPlainObject(event) && event !== null) throw $236d1f2ff9004ea1$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $236d1f2ff9004ea1$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$6tZdC.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $236d1f2ff9004ea1$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $236d1f2ff9004ea1$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$fvKkS.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($236d1f2ff9004ea1$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($236d1f2ff9004ea1$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $k3ytP.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $cMia1.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $3QV8T.showSpanDropWarning();
                else processedEvent = $hI1Sn.merge(event, $k3ytP.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $cMia1.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $cMia1.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $3QV8T.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $236d1f2ff9004ea1$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $236d1f2ff9004ea1$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $236d1f2ff9004ea1$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $236d1f2ff9004ea1$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $236d1f2ff9004ea1$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $236d1f2ff9004ea1$var$estimateAttributesSizeInBytes(log.attributes);
}
function $236d1f2ff9004ea1$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $236d1f2ff9004ea1$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($6tZdC.isPrimitive(value)) weight += $236d1f2ff9004ea1$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $236d1f2ff9004ea1$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $236d1f2ff9004ea1$var$Client;

});
parcelRegister("bNCFC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");
const $8972446b5083ae1b$var$installedIntegrations = [];
function $8972446b5083ae1b$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $8972446b5083ae1b$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $8972446b5083ae1b$var$filterDuplicates(integrations);
}
function $8972446b5083ae1b$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $8972446b5083ae1b$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $8972446b5083ae1b$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $8972446b5083ae1b$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$8972446b5083ae1b$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $8972446b5083ae1b$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Integration installed: ${integration.name}`);
}
function $8972446b5083ae1b$var$addIntegration(integration) {
    const client = $9OgG9.getClient();
    if (!client) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $8972446b5083ae1b$var$defineIntegration(fn) {
    return fn;
}
module.exports.addIntegration = $8972446b5083ae1b$var$addIntegration;
module.exports.afterSetupIntegrations = $8972446b5083ae1b$var$afterSetupIntegrations;
module.exports.defineIntegration = $8972446b5083ae1b$var$defineIntegration;
module.exports.getIntegrationsToSetup = $8972446b5083ae1b$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $8972446b5083ae1b$var$installedIntegrations;
module.exports.setupIntegration = $8972446b5083ae1b$var$setupIntegration;
module.exports.setupIntegrations = $8972446b5083ae1b$var$setupIntegrations;

});

parcelRegister("lDiMO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aTrwl = parcelRequire("aTrwl");

var $2x74l = parcelRequire("2x74l");

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $6tZdC = parcelRequire("6tZdC");

var $i1HdV = parcelRequire("i1HdV");

var $2oeY5 = parcelRequire("2oeY5");

var $5w1OV = parcelRequire("5w1OV");

var $5pWkq = parcelRequire("5pWkq");

var $fmRzj = parcelRequire("fmRzj");

var $2U075 = parcelRequire("2U075");

var $lcNEO = parcelRequire("lcNEO");
const $fbfbd0152900a4f8$var$MAX_LOG_BUFFER_SIZE = 100;
function $fbfbd0152900a4f8$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $fbfbd0152900a4f8$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $fbfbd0152900a4f8$var$_getBufferMap();
    const logBuffer = $fbfbd0152900a4f8$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $fbfbd0152900a4f8$var$MAX_LOG_BUFFER_SIZE) {
        $fbfbd0152900a4f8$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $fbfbd0152900a4f8$var$_INTERNAL_captureLog(beforeLog, currentScope = $9OgG9.getCurrentScope(), captureSerializedLog = $fbfbd0152900a4f8$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $9OgG9.getClient();
    if (!client) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $fmRzj._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $i1HdV.getCombinedScopeData($9OgG9.getIsolationScope(), currentScope);
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($6tZdC.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $2oeY5._getSpanForScope(currentScope);
    $fbfbd0152900a4f8$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $3DKL9.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $5w1OV.timestampInSeconds();
    const sequenceAttr = $5pWkq.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $fbfbd0152900a4f8$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $2U075.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $fbfbd0152900a4f8$var$sanitizeLogAttributes({
            ...$aTrwl.serializeAttributes(scopeAttributes),
            ...$aTrwl.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $fbfbd0152900a4f8$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $fbfbd0152900a4f8$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $lcNEO.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $fbfbd0152900a4f8$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $fbfbd0152900a4f8$var$_INTERNAL_getLogBuffer(client) {
    return $fbfbd0152900a4f8$var$_getBufferMap().get(client);
}
function $fbfbd0152900a4f8$var$_getBufferMap() {
    return $2x74l.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $fbfbd0152900a4f8$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $fbfbd0152900a4f8$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $fbfbd0152900a4f8$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $fbfbd0152900a4f8$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $fbfbd0152900a4f8$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $fbfbd0152900a4f8$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $fbfbd0152900a4f8$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $fbfbd0152900a4f8$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $fbfbd0152900a4f8$var$_removeLoneSurrogates;

});
parcelRegister("5pWkq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $3f1c885f781e3067$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $3f1c885f781e3067$var$_sequenceNumber = 0;
let $3f1c885f781e3067$var$_previousTimestampMs;
function $3f1c885f781e3067$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($3f1c885f781e3067$var$_previousTimestampMs !== void 0 && nowMs !== $3f1c885f781e3067$var$_previousTimestampMs) $3f1c885f781e3067$var$_sequenceNumber = 0;
    const value = $3f1c885f781e3067$var$_sequenceNumber;
    $3f1c885f781e3067$var$_sequenceNumber++;
    $3f1c885f781e3067$var$_previousTimestampMs = nowMs;
    return {
        key: $3f1c885f781e3067$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $3f1c885f781e3067$var$getSequenceAttribute;

});

parcelRegister("fmRzj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $kOJcT = parcelRequire("kOJcT");

var $3QV8T = parcelRequire("3QV8T");
function $b30276a999a8233e$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $9OgG9.withScope(scope, ()=>{
        const span = $3QV8T.getActiveSpan();
        const traceContext = span ? $3QV8T.spanToTraceContext(span) : $9OgG9.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $kOJcT.getDynamicSamplingContextFromSpan(span) : $kOJcT.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $b30276a999a8233e$var$_getTraceInfoFromScope;

});

parcelRegister("2U075", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $21d0e63a7d022a8d$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $21d0e63a7d022a8d$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("lcNEO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cieLS = parcelRequire("cieLS");

var $hnvKl = parcelRequire("hnvKl");

var $lMMO3 = parcelRequire("lMMO3");
function $f7013ce245666dd3$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$lMMO3.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $f7013ce245666dd3$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $cieLS.dsnToString(dsn$1);
    return $hnvKl.createEnvelope(headers, [
        $f7013ce245666dd3$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $f7013ce245666dd3$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $f7013ce245666dd3$var$createLogEnvelope;

});
parcelRegister("lMMO3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $QHqb2 = parcelRequire("QHqb2");

var $6hRPo = parcelRequire("6hRPo");
function $fdc3f09b5addc0d9$var$isBrowser() {
    return typeof window !== "undefined" && (!$QHqb2.isNodeEnv() || $fdc3f09b5addc0d9$var$isElectronNodeRenderer());
}
function $fdc3f09b5addc0d9$var$isElectronNodeRenderer() {
    const process = $6hRPo.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $fdc3f09b5addc0d9$var$isBrowser;

});
parcelRegister("QHqb2", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9tYE4 = parcelRequire("9tYE4");
function isNodeEnv() {
    return !$9tYE4.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("9tYE4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6e75dd5c634d498d$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $6e75dd5c634d498d$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $6e75dd5c634d498d$var$getSDKSource;
module.exports.isBrowserBundle = $6e75dd5c634d498d$var$isBrowserBundle;

});





parcelRegister("bJhjl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aTrwl = parcelRequire("aTrwl");

var $2x74l = parcelRequire("2x74l");

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $i1HdV = parcelRequire("i1HdV");

var $2oeY5 = parcelRequire("2oeY5");

var $5w1OV = parcelRequire("5w1OV");

var $5pWkq = parcelRequire("5pWkq");

var $fmRzj = parcelRequire("fmRzj");

var $fV1az = parcelRequire("fV1az");
const $88a1534a91b73d3b$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $88a1534a91b73d3b$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $88a1534a91b73d3b$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $88a1534a91b73d3b$var$_getBufferMap();
    const metricBuffer = $88a1534a91b73d3b$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $88a1534a91b73d3b$var$MAX_METRIC_BUFFER_SIZE) {
        $88a1534a91b73d3b$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $88a1534a91b73d3b$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $88a1534a91b73d3b$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $88a1534a91b73d3b$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $fmRzj._getTraceInfoFromScope(client, currentScope);
    const span = $2oeY5._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $5w1OV.timestampInSeconds();
    const sequenceAttr = $5pWkq.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$aTrwl.serializeAttributes(scopeAttributes),
            ...$aTrwl.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $88a1534a91b73d3b$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $9OgG9.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $88a1534a91b73d3b$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $9OgG9.getClient();
    if (!client) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $i1HdV.getCombinedScopeData($9OgG9.getIsolationScope(), currentScope);
    const enrichedMetric = $88a1534a91b73d3b$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $88a1534a91b73d3b$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $glA0g.DEBUG_BUILD && $3DKL9.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $88a1534a91b73d3b$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $88a1534a91b73d3b$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $fV1az.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $88a1534a91b73d3b$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $88a1534a91b73d3b$var$_INTERNAL_getMetricBuffer(client) {
    return $88a1534a91b73d3b$var$_getBufferMap().get(client);
}
function $88a1534a91b73d3b$var$_getBufferMap() {
    return $2x74l.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $88a1534a91b73d3b$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $88a1534a91b73d3b$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $88a1534a91b73d3b$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $88a1534a91b73d3b$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("fV1az", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cieLS = parcelRequire("cieLS");

var $hnvKl = parcelRequire("hnvKl");

var $lMMO3 = parcelRequire("lMMO3");
function $b96d1625de8cdd40$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$lMMO3.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $b96d1625de8cdd40$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $cieLS.dsnToString(dsn$1);
    return $hnvKl.createEnvelope(headers, [
        $b96d1625de8cdd40$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $b96d1625de8cdd40$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $b96d1625de8cdd40$var$createMetricEnvelope;

});


parcelRegister("5Q8fK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lMMO3 = parcelRequire("lMMO3");

var $7Qa0H = parcelRequire("7Qa0H");

var $hBGbR = parcelRequire("hBGbR");
function $440835f1e75bffa1$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || !client.getOptions().streamGenAiSpans || $7Qa0H.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($hBGbR.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$lMMO3.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $440835f1e75bffa1$var$extractGenAiSpansFromEvent;

});
parcelRegister("hBGbR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3QV8T = parcelRequire("3QV8T");
function $cd169e80de6c5c3d$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $3QV8T.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $cd169e80de6c5c3d$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("29kP8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $hnvKl = parcelRequire("hnvKl");

var $eWlAJ = parcelRequire("eWlAJ");

var $1B9gR = parcelRequire("1B9gR");
const $190c93340b2fc463$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $190c93340b2fc463$var$createTransport(options, makeRequest, buffer = $eWlAJ.makePromiseBuffer(options.bufferSize || $190c93340b2fc463$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $hnvKl.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $hnvKl.envelopeItemTypeToDataCategory(type);
            if ($1B9gR.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $hnvKl.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($hnvKl.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $hnvKl.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $hnvKl.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $hnvKl.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($glA0g.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $3DKL9.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $1B9gR.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $eWlAJ.SENTRY_BUFFER_FULL_ERROR) {
                $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $190c93340b2fc463$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $190c93340b2fc463$var$createTransport;

});
parcelRegister("eWlAJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cmMjb = parcelRequire("cmMjb");

var $456Az = parcelRequire("456Az");
const $ae073b17ae1233db$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $ae073b17ae1233db$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $cmMjb.rejectedSyncPromise($ae073b17ae1233db$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $cmMjb.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$456Az.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $ae073b17ae1233db$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $ae073b17ae1233db$var$makePromiseBuffer;

});
parcelRegister("456Az", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $2f8cbd782368ca86$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $2f8cbd782368ca86$var$safeUnref;

});


parcelRegister("1B9gR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gtpOW = parcelRequire("gtpOW");
const $12a0702b2c975e46$var$DEFAULT_RETRY_AFTER = 60000;
function $12a0702b2c975e46$var$parseRetryAfterHeader(header, now = $gtpOW.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $12a0702b2c975e46$var$DEFAULT_RETRY_AFTER;
}
function $12a0702b2c975e46$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $12a0702b2c975e46$var$isRateLimited(limits, dataCategory, now = $gtpOW.safeDateNow()) {
    return $12a0702b2c975e46$var$disabledUntil(limits, dataCategory) > now;
}
function $12a0702b2c975e46$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $gtpOW.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $12a0702b2c975e46$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $12a0702b2c975e46$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $12a0702b2c975e46$var$disabledUntil;
module.exports.isRateLimited = $12a0702b2c975e46$var$isRateLimited;
module.exports.parseRetryAfterHeader = $12a0702b2c975e46$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $12a0702b2c975e46$var$updateRateLimits;

});


parcelRegister("1Kjg0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hnvKl = parcelRequire("hnvKl");

var $5w1OV = parcelRequire("5w1OV");
function $14590666bfeaadaf$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $5w1OV.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $hnvKl.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $14590666bfeaadaf$var$createClientReportEnvelope;

});

parcelRegister("7zIyX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $583e5e8dd17f042f$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $583e5e8dd17f042f$var$getPossibleEventMessages;

});

parcelRegister("k3ytP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $23CGM = parcelRequire("23CGM");
function $e99ed58270d9395d$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$23CGM.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$23CGM.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $e99ed58270d9395d$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$23CGM.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$23CGM.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $e99ed58270d9395d$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $e99ed58270d9395d$var$convertTransactionEventToSpanJson;

});

parcelRegister("338d9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dwTwE = parcelRequire("dwTwE");
const $238805779da795df$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    queryParams: true,
    genAI: {
        inputs: true,
        outputs: true
    },
    stackFrameVariables: true,
    frameContextLines: 5
};
function $238805779da795df$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $238805779da795df$var$DEFAULTS : $dwTwE.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: {
            request: dc.httpHeaders?.request ?? base.httpHeaders.request,
            response: dc.httpHeaders?.response ?? base.httpHeaders.response
        },
        httpBodies: dc.httpBodies ?? base.httpBodies,
        queryParams: dc.queryParams ?? base.queryParams,
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $238805779da795df$var$resolveDataCollectionOptions;

});
parcelRegister("dwTwE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $68XA5 = parcelRequire("68XA5");
function $9d9955c250f4ea76$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        queryParams: true,
        genAI: {
            inputs: true,
            outputs: true
        },
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: $68XA5.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $68XA5.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $68XA5.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        queryParams: {
            deny: $68XA5.PII_HEADER_SNIPPETS
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        stackFrameVariables: true,
        frameContextLines: 7
    };
}
module.exports.defaultPiiToCollectionOptions = $9d9955c250f4ea76$var$defaultPiiToCollectionOptions;

});
parcelRegister("68XA5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4791b500949876e6$var$FILTERED_VALUE = "[Filtered]";
const $4791b500949876e6$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $4791b500949876e6$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $4791b500949876e6$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $4791b500949876e6$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $4791b500949876e6$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $4791b500949876e6$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $4791b500949876e6$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("avNV4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");
function $7a73859ad73ee243$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($glA0g.DEBUG_BUILD) $3DKL9.debug.enable();
        else $3DKL9.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $9OgG9.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $7a73859ad73ee243$var$setCurrentClient(client);
    client.init();
    return client;
}
function $7a73859ad73ee243$var$setCurrentClient(client) {
    $9OgG9.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $7a73859ad73ee243$var$initAndBind;
module.exports.setCurrentClient = $7a73859ad73ee243$var$setCurrentClient;

});

parcelRegister("3dqfv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $hnvKl = parcelRequire("hnvKl");

var $gtpOW = parcelRequire("gtpOW");

var $1B9gR = parcelRequire("1B9gR");

var $456Az = parcelRequire("456Az");
const $2576f27fe796c8ca$var$MIN_DELAY = 100;
const $2576f27fe796c8ca$var$START_DELAY = 5e3;
const $2576f27fe796c8ca$var$MAX_DELAY = 36e5;
function $2576f27fe796c8ca$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $2576f27fe796c8ca$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($hnvKl.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $456Az.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = new Date($gtpOW.safeDateNow()).toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $2576f27fe796c8ca$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $hnvKl.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($2576f27fe796c8ca$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $2576f27fe796c8ca$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $1B9gR.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $2576f27fe796c8ca$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $2576f27fe796c8ca$var$START_DELAY;
                    flushIn($2576f27fe796c8ca$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $2576f27fe796c8ca$var$MIN_DELAY;
module.exports.START_DELAY = $2576f27fe796c8ca$var$START_DELAY;
module.exports.makeOfflineTransport = $2576f27fe796c8ca$var$makeOfflineTransport;

});

parcelRegister("gXjBI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d1DWf = parcelRequire("d1DWf");

var $cieLS = parcelRequire("cieLS");

var $hnvKl = parcelRequire("hnvKl");
const $c5815da39ea5eb70$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $c5815da39ea5eb70$var$eventFromEnvelope(env, types) {
    let event;
    $hnvKl.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $c5815da39ea5eb70$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $c5815da39ea5eb70$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $c5815da39ea5eb70$var$overrideDsn(envelope$1, dsn) {
    return $hnvKl.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $c5815da39ea5eb70$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$c5815da39ea5eb70$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$c5815da39ea5eb70$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$c5815da39ea5eb70$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $cieLS.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $d1DWf.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $c5815da39ea5eb70$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $c5815da39ea5eb70$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($c5815da39ea5eb70$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $c5815da39ea5eb70$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $c5815da39ea5eb70$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $c5815da39ea5eb70$var$makeMultiplexedTransport;

});

parcelRegister("6GHZ4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");
const $4de8c8a21daa7c5a$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $4de8c8a21daa7c5a$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $4de8c8a21daa7c5a$var$SKIPPED_AI_PROVIDERS.add(module);
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $4de8c8a21daa7c5a$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $4de8c8a21daa7c5a$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $4de8c8a21daa7c5a$var$_INTERNAL_clearAiProviderSkips() {
    $4de8c8a21daa7c5a$var$SKIPPED_AI_PROVIDERS.clear();
    $glA0g.DEBUG_BUILD && $3DKL9.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $4de8c8a21daa7c5a$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $4de8c8a21daa7c5a$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $4de8c8a21daa7c5a$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("cFOe7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $68XA5 = parcelRequire("68XA5");
function $93a0465d632fd8f9$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $93a0465d632fd8f9$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const denySnippets = additionalDenyTerms != null ? [
        ...$68XA5.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $68XA5.SENSITIVE_KEY_SNIPPETS;
    const result = {};
    if (behavior === true) {
        for (const key of Object.keys(data))result[key] = $93a0465d632fd8f9$var$isSensitiveKey(key.toLowerCase(), denySnippets) ? $68XA5.FILTERED_VALUE : data[key];
        return result;
    }
    if ("deny" in behavior) {
        const lowerTerms2 = behavior.deny.map((t)=>t.toLowerCase());
        for (const key of Object.keys(data)){
            const lower = key.toLowerCase();
            const isDenied = $93a0465d632fd8f9$var$isSensitiveKey(lower, denySnippets) || lowerTerms2.some((term)=>lower.includes(term));
            result[key] = isDenied ? $68XA5.FILTERED_VALUE : data[key];
        }
        return result;
    }
    const lowerTerms = behavior.allow.map((t)=>t.toLowerCase());
    for (const key of Object.keys(data)){
        const lower = key.toLowerCase();
        if ($93a0465d632fd8f9$var$isSensitiveKey(lower, denySnippets)) result[key] = $68XA5.FILTERED_VALUE;
        else {
            const isAllowed = lowerTerms.some((term)=>lower.includes(term));
            result[key] = isAllowed ? data[key] : $68XA5.FILTERED_VALUE;
        }
    }
    return result;
}
module.exports.filterKeyValueData = $93a0465d632fd8f9$var$filterKeyValueData;

});

parcelRegister("eWJ1t", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fdA3Y = parcelRequire("fdA3Y");

var $68XA5 = parcelRequire("68XA5");

var $cFOe7 = parcelRequire("cFOe7");
function $ae19680db188f919$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $fdA3Y.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $cFOe7.filterKeyValueData(parsed, behavior, $68XA5.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $68XA5.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $ae19680db188f919$var$filterCookies;

});
parcelRegister("fdA3Y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b1440b4fa544a08d$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $b1440b4fa544a08d$var$parseCookie;

});


parcelRegister("8vCgJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $68XA5 = parcelRequire("68XA5");

var $cFOe7 = parcelRequire("cFOe7");
function $631ee762231a1322$var$filterQueryParams(queryString, behavior) {
    if (behavior === false) return {};
    try {
        const params = new URLSearchParams(queryString);
        const parsed = {};
        params.forEach((value, key)=>{
            parsed[key] = value;
        });
        if (Object.keys(parsed).length === 0) return {};
        return $cFOe7.filterKeyValueData(parsed, behavior);
    } catch  {
        return $68XA5.FILTERED_VALUE;
    }
}
module.exports.filterQueryParams = $631ee762231a1322$var$filterQueryParams;

});

parcelRegister("f74bw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b00ac17bd8e313a9$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $b00ac17bd8e313a9$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $b00ac17bd8e313a9$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($b00ac17bd8e313a9$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($b00ac17bd8e313a9$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $b00ac17bd8e313a9$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $b00ac17bd8e313a9$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $b00ac17bd8e313a9$var$envToBool;

});

parcelRegister("jQbkN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cieLS = parcelRequire("cieLS");

var $hnvKl = parcelRequire("hnvKl");

var $gtpOW = parcelRequire("gtpOW");
function $e71baa68eefdd0e3$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date($gtpOW.safeDateNow()).toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $cieLS.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $e71baa68eefdd0e3$var$createCheckInEnvelopeItem(checkIn);
    return $hnvKl.createEnvelope(headers, [
        item
    ]);
}
function $e71baa68eefdd0e3$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $e71baa68eefdd0e3$var$createCheckInEnvelope;

});

parcelRegister("j7Wkw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cgx6M = parcelRequire("cgx6M");
function $0397ef249c819869$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $0397ef249c819869$var$checkDsn(url, dsn) || $0397ef249c819869$var$checkTunnel(url, tunnel);
}
function $0397ef249c819869$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $0397ef249c819869$var$removeTrailingSlash(url) === $0397ef249c819869$var$removeTrailingSlash(tunnel);
}
function $0397ef249c819869$var$checkDsn(url$1, dsn) {
    const urlParts = $cgx6M.parseStringToURLObject(url$1);
    if (!urlParts || $cgx6M.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $0397ef249c819869$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $0397ef249c819869$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $0397ef249c819869$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $0397ef249c819869$var$isSentryRequestUrl;

});

parcelRegister("jVjPX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e812ba661c4fb022$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $e812ba661c4fb022$var$fmt = $e812ba661c4fb022$var$parameterize;
module.exports.fmt = $e812ba661c4fb022$var$fmt;
module.exports.parameterize = $e812ba661c4fb022$var$parameterize;

});

parcelRegister("2nX7a", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d1DWf = parcelRequire("d1DWf");

var $3DKL9 = parcelRequire("3DKL9");

var $cieLS = parcelRequire("cieLS");

var $hnvKl = parcelRequire("hnvKl");
async function $1bcb95b14d9fea1d$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $hnvKl.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $3DKL9.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $cieLS.makeDsn(dsn$1);
    if (!dsnComponents) {
        $3DKL9.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $d1DWf.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $3DKL9.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $1bcb95b14d9fea1d$var$handleTunnelRequest;

});

parcelRegister("6JHAx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $4e78c1c8ac58e1c8$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $4e78c1c8ac58e1c8$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $4e78c1c8ac58e1c8$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $4e78c1c8ac58e1c8$var$addAutoIpAddressToUser;

});

parcelRegister("18Thx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8gllD = parcelRequire("8gllD");
function $0d516ba0dc3a201b$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $8gllD.SDK_VERSION
            }));
        sdk.version = $8gllD.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $0d516ba0dc3a201b$var$applySdkMetadata;

});

parcelRegister("a3VLZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $arkyo = parcelRequire("arkyo");

var $2x74l = parcelRequire("2x74l");

var $9OgG9 = parcelRequire("9OgG9");

var $duCSA = parcelRequire("duCSA");

var $3DKL9 = parcelRequire("3DKL9");

var $3QV8T = parcelRequire("3QV8T");

var $kOJcT = parcelRequire("kOJcT");

var $ejsmR = parcelRequire("ejsmR");

var $dbV67 = parcelRequire("dbV67");
function $7536ffb8085a30b3$var$getTraceData(options = {}) {
    const client = options.client || $9OgG9.getClient();
    if (!$duCSA.isEnabled() || !client) return {};
    const carrier$1 = $2x74l.getMainCarrier();
    const acs = $arkyo.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $9OgG9.getCurrentScope();
    const span = options.span || $3QV8T.getActiveSpan();
    if (!span && $9OgG9.hasExternalPropagationContext()) return {};
    const sentryTrace = span ? $3QV8T.spanToTraceHeader(span) : $7536ffb8085a30b3$var$scopeToTraceHeader(scope);
    const dsc = span ? $kOJcT.getDynamicSamplingContextFromSpan(span) : $kOJcT.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $ejsmR.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $dbV67.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $3DKL9.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span ? $3QV8T.spanToTraceparentHeader(span) : $7536ffb8085a30b3$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $7536ffb8085a30b3$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $dbV67.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $7536ffb8085a30b3$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $dbV67.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $7536ffb8085a30b3$var$getTraceData;

});

parcelRegister("3Lbwh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $694gv = parcelRequire("694gv");
const $2bceb273441d2e30$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $2bceb273441d2e30$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $glA0g.DEBUG_BUILD && !cachedDecision && $3DKL9.debug.log($2bceb273441d2e30$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $694gv.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $glA0g.DEBUG_BUILD && !decision && $3DKL9.debug.log($2bceb273441d2e30$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $2bceb273441d2e30$var$shouldPropagateTraceForUrl;

});

parcelRegister("6y5oV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $a3VLZ = parcelRequire("a3VLZ");
function $4c4a1b9545664aa4$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $a3VLZ.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("\n");
}
module.exports.getTraceMetaTags = $4c4a1b9545664aa4$var$getTraceMetaTags;

});

parcelRegister("c67nG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $8cebc5441754ea93$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $8cebc5441754ea93$var$debounce;

});

parcelRegister("9H5ke", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $dwTwE = parcelRequire("dwTwE");

var $68XA5 = parcelRequire("68XA5");

var $cFOe7 = parcelRequire("cFOe7");

var $456Az = parcelRequire("456Az");
const $01d24323dde58c39$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $01d24323dde58c39$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $01d24323dde58c39$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $01d24323dde58c39$var$MAX_BODY_BYTE_LENGTH;
}
function $01d24323dde58c39$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $01d24323dde58c39$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $01d24323dde58c39$var$winterCGRequestToRequestData(req) {
    const headers = $01d24323dde58c39$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $01d24323dde58c39$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $01d24323dde58c39$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $01d24323dde58c39$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $01d24323dde58c39$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$01d24323dde58c39$var$isTextualContentType(contentType)) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $01d24323dde58c39$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $01d24323dde58c39$var$MAX_BODY_BYTE_LENGTH) {
                $glA0g.DEBUG_BUILD && $3DKL9.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $456Az.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Error capturing request body:", error);
    }
}
function $01d24323dde58c39$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $01d24323dde58c39$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $01d24323dde58c39$var$extractQueryParamsFromUrl(url),
        headers: $01d24323dde58c39$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $01d24323dde58c39$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $01d24323dde58c39$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $dwTwE.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $01d24323dde58c39$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $cFOe7.filterKeyValueData(parsed, cookieBehavior, $68XA5.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$01d24323dde58c39$var$normalizeAttributeKey(lowerKey)}.${$01d24323dde58c39$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$01d24323dde58c39$var$normalizeAttributeKey(lowerKey)}`] = $68XA5.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $cFOe7.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$01d24323dde58c39$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $01d24323dde58c39$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $01d24323dde58c39$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $01d24323dde58c39$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $01d24323dde58c39$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $01d24323dde58c39$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $01d24323dde58c39$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $01d24323dde58c39$var$getMaxBodyByteLength;
module.exports.headersToDict = $01d24323dde58c39$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $01d24323dde58c39$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $01d24323dde58c39$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $01d24323dde58c39$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $01d24323dde58c39$var$winterCGRequestToRequestData;

});

parcelRegister("7nyuW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $3DKL9 = parcelRequire("3DKL9");

var $5w1OV = parcelRequire("5w1OV");
const $55f570ffd5115249$var$DEFAULT_BREADCRUMBS = 100;
function $55f570ffd5115249$var$addBreadcrumb(breadcrumb, hint) {
    const client = $9OgG9.getClient();
    const isolationScope = $9OgG9.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $55f570ffd5115249$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $5w1OV.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $3DKL9.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $55f570ffd5115249$var$addBreadcrumb;

});

parcelRegister("69xgb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $bNCFC = parcelRequire("bNCFC");

var $eXIZW = parcelRequire("eXIZW");
let $47ad621ab765805d$var$originalFunctionToString;
const $47ad621ab765805d$var$INTEGRATION_NAME = "FunctionToString";
const $47ad621ab765805d$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $47ad621ab765805d$var$_functionToStringIntegration = ()=>{
    return {
        name: $47ad621ab765805d$var$INTEGRATION_NAME,
        setupOnce () {
            $47ad621ab765805d$var$originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $eXIZW.getOriginalFunction(this);
                    const context = $47ad621ab765805d$var$SETUP_CLIENTS.has($9OgG9.getClient()) && originalFunction !== void 0 ? originalFunction : this;
                    return $47ad621ab765805d$var$originalFunctionToString.apply(context, args);
                };
            } catch  {}
        },
        setup (client) {
            $47ad621ab765805d$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $47ad621ab765805d$var$functionToStringIntegration = $bNCFC.defineIntegration($47ad621ab765805d$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $47ad621ab765805d$var$functionToStringIntegration;

});

parcelRegister("5Yd87", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $bNCFC = parcelRequire("bNCFC");

var $3DKL9 = parcelRequire("3DKL9");

var $7zIyX = parcelRequire("7zIyX");

var $23WDq = parcelRequire("23WDq");

var $694gv = parcelRequire("694gv");
const $458cbdb050fbff4d$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /^Java exception was raised during method invocation$/
];
const $458cbdb050fbff4d$var$INTEGRATION_NAME = "EventFilters";
const $458cbdb050fbff4d$var$eventFiltersIntegration = $bNCFC.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $458cbdb050fbff4d$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $458cbdb050fbff4d$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $458cbdb050fbff4d$var$_mergeOptions(options, clientOptions);
            }
            return $458cbdb050fbff4d$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $458cbdb050fbff4d$var$inboundFiltersIntegration = $bNCFC.defineIntegration((options = {})=>{
    return {
        ...$458cbdb050fbff4d$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $458cbdb050fbff4d$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $458cbdb050fbff4d$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $458cbdb050fbff4d$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($458cbdb050fbff4d$var$_isIgnoredError(event, options.ignoreErrors)) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$23WDq.getEventDescription(event)}`);
            return true;
        }
        if ($458cbdb050fbff4d$var$_isUselessError(event)) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$23WDq.getEventDescription(event)}`);
            return true;
        }
        if ($458cbdb050fbff4d$var$_isDeniedUrl(event, options.denyUrls)) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$23WDq.getEventDescription(event)}.
Url: ${$458cbdb050fbff4d$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$458cbdb050fbff4d$var$_isAllowedUrl(event, options.allowUrls)) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$23WDq.getEventDescription(event)}.
Url: ${$458cbdb050fbff4d$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($458cbdb050fbff4d$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$23WDq.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $458cbdb050fbff4d$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $7zIyX.getPossibleEventMessages(event).some((message)=>$694gv.stringMatchesSomePattern(message, ignoreErrors));
}
function $458cbdb050fbff4d$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $694gv.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $458cbdb050fbff4d$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $458cbdb050fbff4d$var$_getEventFilterUrl(event);
    return !url ? false : $694gv.stringMatchesSomePattern(url, denyUrls);
}
function $458cbdb050fbff4d$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $458cbdb050fbff4d$var$_getEventFilterUrl(event);
    return !url ? true : $694gv.stringMatchesSomePattern(url, allowUrls);
}
function $458cbdb050fbff4d$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $458cbdb050fbff4d$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $458cbdb050fbff4d$var$_getLastValidUrl(frames) : null;
    } catch  {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.error(`Cannot extract url for event ${$23WDq.getEventDescription(event)}`);
        return null;
    }
}
function $458cbdb050fbff4d$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $458cbdb050fbff4d$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $458cbdb050fbff4d$var$inboundFiltersIntegration;

});

parcelRegister("hS89i", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bNCFC = parcelRequire("bNCFC");

var $kbOoO = parcelRequire("kbOoO");

var $kGhFN = parcelRequire("kGhFN");
const $d02dcd0885a1d775$var$DEFAULT_KEY = "cause";
const $d02dcd0885a1d775$var$DEFAULT_LIMIT = 5;
const $d02dcd0885a1d775$var$INTEGRATION_NAME = "LinkedErrors";
const $d02dcd0885a1d775$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $d02dcd0885a1d775$var$DEFAULT_LIMIT;
    const key = options.key || $d02dcd0885a1d775$var$DEFAULT_KEY;
    return {
        name: $d02dcd0885a1d775$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $kbOoO.applyAggregateErrorsToEvent($kGhFN.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $d02dcd0885a1d775$var$linkedErrorsIntegration = $bNCFC.defineIntegration($d02dcd0885a1d775$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $d02dcd0885a1d775$var$linkedErrorsIntegration;

});
parcelRegister("kbOoO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6tZdC = parcelRequire("6tZdC");
function $eb2bedf8bd3dbbe5$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$6tZdC.isInstanceOf(hint.originalException, Error)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $eb2bedf8bd3dbbe5$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $eb2bedf8bd3dbbe5$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($6tZdC.isInstanceOf(error[key], Error)) {
        $eb2bedf8bd3dbbe5$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $eb2bedf8bd3dbbe5$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $eb2bedf8bd3dbbe5$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($eb2bedf8bd3dbbe5$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($6tZdC.isInstanceOf(childError, Error)) {
            $eb2bedf8bd3dbbe5$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $eb2bedf8bd3dbbe5$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $eb2bedf8bd3dbbe5$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $eb2bedf8bd3dbbe5$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $eb2bedf8bd3dbbe5$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$eb2bedf8bd3dbbe5$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $eb2bedf8bd3dbbe5$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $eb2bedf8bd3dbbe5$var$applyAggregateErrorsToEvent;

});

parcelRegister("kGhFN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6tZdC = parcelRequire("6tZdC");

var $23WDq = parcelRequire("23WDq");

var $cAnBa = parcelRequire("cAnBa");

var $eXIZW = parcelRequire("eXIZW");
function $f0e57065ae6d1f0e$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $f0e57065ae6d1f0e$var$hasSentryFetchUrlHost(error) {
    return $6tZdC.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $f0e57065ae6d1f0e$var$_enhanceErrorWithSentryInfo(error) {
    if ($f0e57065ae6d1f0e$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $f0e57065ae6d1f0e$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $f0e57065ae6d1f0e$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $f0e57065ae6d1f0e$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $f0e57065ae6d1f0e$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return void 0;
}
function $f0e57065ae6d1f0e$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $eXIZW.extractExceptionKeysForMessage(exception);
    if ($6tZdC.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $f0e57065ae6d1f0e$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $f0e57065ae6d1f0e$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $f0e57065ae6d1f0e$var$getException(client, mechanism, exception, hint) {
    if ($6tZdC.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($6tZdC.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $cAnBa.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $f0e57065ae6d1f0e$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $f0e57065ae6d1f0e$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $f0e57065ae6d1f0e$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $f0e57065ae6d1f0e$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $f0e57065ae6d1f0e$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $23WDq.addExceptionTypeValue(event, void 0, void 0);
    $23WDq.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $f0e57065ae6d1f0e$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $f0e57065ae6d1f0e$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $23WDq.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($6tZdC.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $f0e57065ae6d1f0e$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $f0e57065ae6d1f0e$var$eventFromMessage;
module.exports.eventFromUnknownInput = $f0e57065ae6d1f0e$var$eventFromUnknownInput;
module.exports.exceptionFromError = $f0e57065ae6d1f0e$var$exceptionFromError;
module.exports.parseStackFrames = $f0e57065ae6d1f0e$var$parseStackFrames;

});


parcelRegister("2WFPY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bNCFC = parcelRequire("bNCFC");

var $iRcsS = parcelRequire("iRcsS");

var $hnvKl = parcelRequire("hnvKl");
const $225173938fa9d2de$var$moduleMetadataIntegration = $bNCFC.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $hnvKl.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $iRcsS.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $iRcsS.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $225173938fa9d2de$var$moduleMetadataIntegration;

});
parcelRegister("iRcsS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6hRPo = parcelRequire("6hRPo");
const $dba6d87f130620a8$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $dba6d87f130620a8$var$parsedStacks = /* @__PURE__ */ new Set();
function $dba6d87f130620a8$var$getFilenameToMetadataMap(parser) {
    if (!$6hRPo.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($6hRPo.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $6hRPo.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $dba6d87f130620a8$var$ensureMetadataStacksAreParsed(parser) {
    if (!$6hRPo.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($6hRPo.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $6hRPo.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($dba6d87f130620a8$var$parsedStacks.has(stack)) continue;
        $dba6d87f130620a8$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $dba6d87f130620a8$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $dba6d87f130620a8$var$getMetadataForUrl(parser, filename) {
    $dba6d87f130620a8$var$ensureMetadataStacksAreParsed(parser);
    return $dba6d87f130620a8$var$filenameMetadataMap.get(filename);
}
function $dba6d87f130620a8$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $dba6d87f130620a8$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $dba6d87f130620a8$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $dba6d87f130620a8$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $dba6d87f130620a8$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $dba6d87f130620a8$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $dba6d87f130620a8$var$stripMetadataFromStackFrames;

});


parcelRegister("Plrf4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $bNCFC = parcelRequire("bNCFC");

var $23CGM = parcelRequire("23CGM");

var $fdA3Y = parcelRequire("fdA3Y");

var $9H5ke = parcelRequire("9H5ke");

var $7LAtH = parcelRequire("7LAtH");

var $lHgv5 = parcelRequire("lHgv5");
const $09a564c0a97db4cf$var$INTEGRATION_NAME = "RequestData";
const $09a564c0a97db4cf$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.queryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $09a564c0a97db4cf$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $09a564c0a97db4cf$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $9OgG9.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $09a564c0a97db4cf$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $09a564c0a97db4cf$var$requestDataIntegration = $bNCFC.defineIntegration($09a564c0a97db4cf$var$_requestDataIntegration);
function $09a564c0a97db4cf$var$addNormalizedRequestDataToEvent(event, req, additionalData, include) {
    event.request = {
        ...event.request,
        ...$09a564c0a97db4cf$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $7LAtH.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $09a564c0a97db4cf$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $09a564c0a97db4cf$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes = {};
    if (requestData.url) attributes["url.full"] = requestData.url;
    if (requestData.method) attributes["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes["url.query"] = $09a564c0a97db4cf$var$normalizeQueryString(requestData.query_string);
    $lHgv5.safeSetSpanJSONAttributes(span, attributes);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $9H5ke.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $lHgv5.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $9H5ke.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $lHgv5.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $lHgv5.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $7LAtH.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $lHgv5.safeSetSpanJSONAttributes(span, {
            [$23CGM.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $09a564c0a97db4cf$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($7LAtH.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $fdA3Y.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $09a564c0a97db4cf$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join("&");
    return result || void 0;
}
module.exports.requestDataIntegration = $09a564c0a97db4cf$var$requestDataIntegration;

});
parcelRegister("7LAtH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5a7937f2d60a85a8$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $5a7937f2d60a85a8$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $5a7937f2d60a85a8$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $5a7937f2d60a85a8$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $5a7937f2d60a85a8$var$isIP(ip));
    return ipAddress || null;
}
function $5a7937f2d60a85a8$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $5a7937f2d60a85a8$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $5a7937f2d60a85a8$var$getClientIPAddress;
module.exports.ipHeaderNames = $5a7937f2d60a85a8$var$ipHeaderNames;

});


parcelRegister("ct3gP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $duCSA = parcelRequire("duCSA");

var $6jVna = parcelRequire("6jVna");

var $bNCFC = parcelRequire("bNCFC");

var $3DKL9 = parcelRequire("3DKL9");

var $23WDq = parcelRequire("23WDq");

var $ekucH = parcelRequire("ekucH");

var $694gv = parcelRequire("694gv");

var $6hRPo = parcelRequire("6hRPo");
const $913abae421effa57$var$INTEGRATION_NAME = "CaptureConsole";
const $913abae421effa57$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $3DKL9.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $913abae421effa57$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $6hRPo.GLOBAL_OBJ)) return;
            $6jVna.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($9OgG9.getClient() !== client || !levels.includes(level)) return;
                $913abae421effa57$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $913abae421effa57$var$captureConsoleIntegration = $bNCFC.defineIntegration($913abae421effa57$var$_captureConsoleIntegration);
function $913abae421effa57$var$consoleHandler(args, level, handled) {
    const severityLevel = $ekucH.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $ekucH.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $9OgG9.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $23WDq.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$694gv.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $duCSA.captureException(error, captureContext);
            return;
        }
        const message = $694gv.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $913abae421effa57$var$captureConsoleIntegration;

});
parcelRegister("6jVna", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $eXIZW = parcelRequire("eXIZW");

var $694gv = parcelRequire("694gv");

var $6hRPo = parcelRequire("6hRPo");

var $awwU9 = parcelRequire("awwU9");
const $49a1057614067b9c$var$_filter = /* @__PURE__ */ new Set([]);
function $49a1057614067b9c$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $awwU9.addHandler(type, handler);
    $awwU9.maybeInstrument(type, $49a1057614067b9c$var$instrumentConsole);
    return removeHandler;
}
function $49a1057614067b9c$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$49a1057614067b9c$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$49a1057614067b9c$var$_filter.delete(f);
    };
}
function $49a1057614067b9c$var$instrumentConsole() {
    if (!("console" in $6hRPo.GLOBAL_OBJ)) return;
    $3DKL9.CONSOLE_LEVELS.forEach(function(level) {
        if (!(level in $6hRPo.GLOBAL_OBJ.console)) return;
        $eXIZW.fill($6hRPo.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $3DKL9.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $3DKL9.originalConsoleMethods[level];
                const isFiltered = $49a1057614067b9c$var$_filter.size && typeof firstArg === "string" && $694gv.stringMatchesSomePattern(firstArg, $49a1057614067b9c$var$_filter);
                if (!isFiltered) $awwU9.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $glA0g.DEBUG_BUILD && $3DKL9.debug.isEnabled()) log?.apply($6hRPo.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $49a1057614067b9c$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $49a1057614067b9c$var$addConsoleInstrumentationHandler;

});

parcelRegister("ekucH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a6ea5cc580c9ce51$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $a6ea5cc580c9ce51$var$severityLevelFromString;

});


parcelRegister("dsNIc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $bNCFC = parcelRequire("bNCFC");

var $3DKL9 = parcelRequire("3DKL9");

var $3Arox = parcelRequire("3Arox");
const $9cd473a394398148$var$INTEGRATION_NAME = "Dedupe";
const $9cd473a394398148$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $9cd473a394398148$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($9cd473a394398148$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $9cd473a394398148$var$dedupeIntegration = $bNCFC.defineIntegration($9cd473a394398148$var$_dedupeIntegration);
function $9cd473a394398148$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($9cd473a394398148$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($9cd473a394398148$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $9cd473a394398148$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$9cd473a394398148$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$9cd473a394398148$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $9cd473a394398148$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $9cd473a394398148$var$_getExceptionFromEvent(previousEvent);
    const currentException = $9cd473a394398148$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$9cd473a394398148$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$9cd473a394398148$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $9cd473a394398148$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $3Arox.getFramesFromEvent(currentEvent);
    let previousFrames = $3Arox.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $9cd473a394398148$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $9cd473a394398148$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $9cd473a394398148$var$_shouldDropEvent;
module.exports.dedupeIntegration = $9cd473a394398148$var$dedupeIntegration;

});

parcelRegister("kQmZ5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $bNCFC = parcelRequire("bNCFC");

var $3DKL9 = parcelRequire("3DKL9");

var $6tZdC = parcelRequire("6tZdC");

var $cAnBa = parcelRequire("cAnBa");

var $2uBiD = parcelRequire("2uBiD");

var $694gv = parcelRequire("694gv");
const $f2ca7e2e6bebaadb$var$INTEGRATION_NAME = "ExtraErrorData";
const $f2ca7e2e6bebaadb$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $f2ca7e2e6bebaadb$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $f2ca7e2e6bebaadb$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $f2ca7e2e6bebaadb$var$extraErrorDataIntegration = $bNCFC.defineIntegration($f2ca7e2e6bebaadb$var$_extraErrorDataIntegration);
function $f2ca7e2e6bebaadb$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$6tZdC.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $f2ca7e2e6bebaadb$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $cAnBa.normalize(errorData, depth);
        if ($6tZdC.isPlainObject(normalizedErrorData)) {
            $2uBiD.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $f2ca7e2e6bebaadb$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $6tZdC.isError(value) || typeof value === "string" ? maxValueLength ? $694gv.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($6tZdC.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $f2ca7e2e6bebaadb$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $6tZdC.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $f2ca7e2e6bebaadb$var$extraErrorDataIntegration;

});

parcelRegister("dQR84", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bNCFC = parcelRequire("bNCFC");

var $6UTvW = parcelRequire("6UTvW");

var $6hRPo = parcelRequire("6hRPo");
const $a1595808239ea3d0$var$INTEGRATION_NAME = "RewriteFrames";
const $a1595808239ea3d0$var$rewriteFramesIntegration = $bNCFC.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $6hRPo.GLOBAL_OBJ && !!$6hRPo.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $a1595808239ea3d0$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $a1595808239ea3d0$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $a1595808239ea3d0$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $6UTvW.relative(root, filename) : $6UTvW.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $a1595808239ea3d0$var$generateIteratee;
module.exports.rewriteFramesIntegration = $a1595808239ea3d0$var$rewriteFramesIntegration;

});
parcelRegister("6UTvW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $509308fc72fdb210$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $509308fc72fdb210$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $509308fc72fdb210$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $509308fc72fdb210$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $509308fc72fdb210$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $509308fc72fdb210$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $509308fc72fdb210$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $509308fc72fdb210$var$relative(from, to) {
    from = $509308fc72fdb210$var$resolve(from).slice(1);
    to = $509308fc72fdb210$var$resolve(to).slice(1);
    const fromParts = $509308fc72fdb210$var$trim(from.split("/"));
    const toParts = $509308fc72fdb210$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $509308fc72fdb210$var$normalizePath(path) {
    const isPathAbsolute = $509308fc72fdb210$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $509308fc72fdb210$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $509308fc72fdb210$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $509308fc72fdb210$var$join(...args) {
    return $509308fc72fdb210$var$normalizePath(args.join("/"));
}
function $509308fc72fdb210$var$dirname(path) {
    const result = $509308fc72fdb210$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $509308fc72fdb210$var$basename(path, ext) {
    let f = $509308fc72fdb210$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $509308fc72fdb210$var$basename;
module.exports.dirname = $509308fc72fdb210$var$dirname;
module.exports.isAbsolute = $509308fc72fdb210$var$isAbsolute;
module.exports.join = $509308fc72fdb210$var$join;
module.exports.normalizePath = $509308fc72fdb210$var$normalizePath;
module.exports.relative = $509308fc72fdb210$var$relative;
module.exports.resolve = $509308fc72fdb210$var$resolve;

});


parcelRegister("fDiFQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7nyuW = parcelRequire("7nyuW");

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $duCSA = parcelRequire("duCSA");

var $bNCFC = parcelRequire("bNCFC");

var $23CGM = parcelRequire("23CGM");

var $3DKL9 = parcelRequire("3DKL9");

var $23WDq = parcelRequire("23WDq");

var $6tZdC = parcelRequire("6tZdC");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");
const $b618fbc3d903d902$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $b618fbc3d903d902$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $b618fbc3d903d902$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $b618fbc3d903d902$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $b618fbc3d903d902$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $b618fbc3d903d902$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $b618fbc3d903d902$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $b618fbc3d903d902$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $b618fbc3d903d902$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $b618fbc3d903d902$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if (headers["Prefer"]?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $b618fbc3d903d902$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $b618fbc3d903d902$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $b618fbc3d903d902$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $bn0md.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === "object" && "error" in res && res.error) {
                        span.setStatus({
                            code: $8OylQ.SPAN_STATUS_ERROR
                        });
                        $duCSA.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $8OylQ.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $8OylQ.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $duCSA.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $b618fbc3d903d902$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $b618fbc3d903d902$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $b618fbc3d903d902$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $b618fbc3d903d902$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $b618fbc3d903d902$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $b618fbc3d903d902$var$instrumentAuthOperation(authOperation, true);
    }
    $b618fbc3d903d902$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $b618fbc3d903d902$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($b618fbc3d903d902$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $b618fbc3d903d902$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $b618fbc3d903d902$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $b618fbc3d903d902$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($b618fbc3d903d902$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $b618fbc3d903d902$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $b618fbc3d903d902$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($b618fbc3d903d902$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($6tZdC.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $9OgG9.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().userInfo === true;
            const bodyPayload = $b618fbc3d903d902$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$b618fbc3d903d902$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": typedThis.headers["X-Client-Info"],
                "db.system": "postgresql",
                "db.operation": operation,
                [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $bn0md.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $8OylQ.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $duCSA.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $23WDq.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $7nyuW.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $8OylQ.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $b618fbc3d903d902$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $b618fbc3d903d902$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $b618fbc3d903d902$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($b618fbc3d903d902$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $b618fbc3d903d902$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $b618fbc3d903d902$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $b618fbc3d903d902$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $b618fbc3d903d902$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $b618fbc3d903d902$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $b618fbc3d903d902$var$INTEGRATION_NAME = "Supabase";
const $b618fbc3d903d902$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $b618fbc3d903d902$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $b618fbc3d903d902$var$INTEGRATION_NAME
    };
};
const $b618fbc3d903d902$var$supabaseIntegration = $bNCFC.defineIntegration((options)=>{
    return $b618fbc3d903d902$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $b618fbc3d903d902$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $b618fbc3d903d902$var$FILTER_MAPPINGS;
module.exports.extractOperation = $b618fbc3d903d902$var$extractOperation;
module.exports.instrumentSupabaseClient = $b618fbc3d903d902$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $b618fbc3d903d902$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $b618fbc3d903d902$var$translateFiltersIntoMethods;

});

parcelRegister("fXL5b", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bNCFC = parcelRequire("bNCFC");

var $6tZdC = parcelRequire("6tZdC");

var $694gv = parcelRequire("694gv");
const $b9f0e351fd20bda8$var$DEFAULT_LIMIT = 10;
const $b9f0e351fd20bda8$var$INTEGRATION_NAME = "ZodErrors";
function $b9f0e351fd20bda8$var$originalExceptionIsZodError(originalException) {
    return $6tZdC.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $b9f0e351fd20bda8$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $b9f0e351fd20bda8$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $b9f0e351fd20bda8$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $b9f0e351fd20bda8$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$694gv.truncate(errorKeys.join(", "), 100)}`;
}
function $b9f0e351fd20bda8$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$b9f0e351fd20bda8$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($b9f0e351fd20bda8$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $b9f0e351fd20bda8$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $b9f0e351fd20bda8$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $b9f0e351fd20bda8$var$DEFAULT_LIMIT;
    return {
        name: $b9f0e351fd20bda8$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $b9f0e351fd20bda8$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $b9f0e351fd20bda8$var$zodErrorsIntegration = $bNCFC.defineIntegration($b9f0e351fd20bda8$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $b9f0e351fd20bda8$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $b9f0e351fd20bda8$var$flattenIssue;
module.exports.flattenIssuePath = $b9f0e351fd20bda8$var$flattenIssuePath;
module.exports.formatIssueMessage = $b9f0e351fd20bda8$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $b9f0e351fd20bda8$var$zodErrorsIntegration;

});

parcelRegister("dfiTg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bNCFC = parcelRequire("bNCFC");

var $iRcsS = parcelRequire("iRcsS");

var $hnvKl = parcelRequire("hnvKl");

var $3Arox = parcelRequire("3Arox");

var $6hRPo = parcelRequire("6hRPo");
const $9a4b5452e40198eb$var$thirdPartyErrorFilterIntegration = $bNCFC.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $hnvKl.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $iRcsS.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $iRcsS.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($6hRPo.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $9a4b5452e40198eb$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $9a4b5452e40198eb$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $9a4b5452e40198eb$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($9a4b5452e40198eb$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($9a4b5452e40198eb$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $9a4b5452e40198eb$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $3Arox.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$9a4b5452e40198eb$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($9a4b5452e40198eb$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($9a4b5452e40198eb$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $9a4b5452e40198eb$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $9a4b5452e40198eb$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $9a4b5452e40198eb$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $9a4b5452e40198eb$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $9a4b5452e40198eb$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("l2Qyh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7nyuW = parcelRequire("7nyuW");

var $9OgG9 = parcelRequire("9OgG9");

var $6jVna = parcelRequire("6jVna");

var $bNCFC = parcelRequire("bNCFC");

var $3DKL9 = parcelRequire("3DKL9");

var $ekucH = parcelRequire("ekucH");

var $694gv = parcelRequire("694gv");

var $6hRPo = parcelRequire("6hRPo");
const $f5228c9b23dc8f29$var$INTEGRATION_NAME = "Console";
const $f5228c9b23dc8f29$var$consoleIntegration = $bNCFC.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $3DKL9.CONSOLE_LEVELS);
    return {
        name: $f5228c9b23dc8f29$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $6jVna.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($9OgG9.getClient() !== client || !levels.has(level)) return;
                $f5228c9b23dc8f29$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $6jVna.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $f5228c9b23dc8f29$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $ekucH.severityLevelFromString(level),
        message: $f5228c9b23dc8f29$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$f5228c9b23dc8f29$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $7nyuW.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $f5228c9b23dc8f29$var$formatConsoleArgs(values) {
    return "util" in $6hRPo.GLOBAL_OBJ && typeof $6hRPo.GLOBAL_OBJ.util.format === "function" ? $6hRPo.GLOBAL_OBJ.util.format(...values) : $694gv.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $f5228c9b23dc8f29$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $f5228c9b23dc8f29$var$consoleIntegration;

});

parcelRegister("gdMHb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bNCFC = parcelRequire("bNCFC");

var $c6vRz = parcelRequire("c6vRz");
const $bcf3a22427a3d6b0$var$featureFlagsIntegration = $bNCFC.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $c6vRz._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $c6vRz._INTERNAL_insertFlagToScope(name, value);
            $c6vRz._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $bcf3a22427a3d6b0$var$featureFlagsIntegration;

});
parcelRegister("c6vRz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $3QV8T = parcelRequire("3QV8T");
const $8cfec2e52ac21c69$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $8cfec2e52ac21c69$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $8cfec2e52ac21c69$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $8cfec2e52ac21c69$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $9OgG9.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $8cfec2e52ac21c69$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $8cfec2e52ac21c69$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $9OgG9.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $8cfec2e52ac21c69$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $8cfec2e52ac21c69$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $8cfec2e52ac21c69$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $8cfec2e52ac21c69$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $3QV8T.getActiveSpan();
    if (!span) return;
    const attributes = $3QV8T.spanToJSON(span).data;
    if (`${$8cfec2e52ac21c69$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$8cfec2e52ac21c69$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($8cfec2e52ac21c69$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$8cfec2e52ac21c69$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $8cfec2e52ac21c69$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $8cfec2e52ac21c69$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $8cfec2e52ac21c69$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $8cfec2e52ac21c69$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $8cfec2e52ac21c69$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $8cfec2e52ac21c69$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("5wZDP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bNCFC = parcelRequire("bNCFC");

var $c6vRz = parcelRequire("c6vRz");

var $eXIZW = parcelRequire("eXIZW");
const $406fc19fdb6413ff$var$growthbookIntegration = $bNCFC.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $eXIZW.fill(proto, "isOn", $406fc19fdb6413ff$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $eXIZW.fill(proto, "getFeatureValue", $406fc19fdb6413ff$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $c6vRz._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $406fc19fdb6413ff$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $c6vRz._INTERNAL_insertFlagToScope(flagName, result);
            $c6vRz._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $406fc19fdb6413ff$var$growthbookIntegration;

});

parcelRegister("iAQfc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $bNCFC = parcelRequire("bNCFC");

var $23CGM = parcelRequire("23CGM");

var $3QV8T = parcelRequire("3QV8T");
const $d8941d66709a1ee0$var$INTEGRATION_NAME = "ConversationId";
const $d8941d66709a1ee0$var$_conversationIdIntegration = ()=>{
    return {
        name: $d8941d66709a1ee0$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $9OgG9.getCurrentScope().getScopeData();
                const isolationScopeData = $9OgG9.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $3QV8T.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($23CGM.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $d8941d66709a1ee0$var$conversationIdIntegration = $bNCFC.defineIntegration($d8941d66709a1ee0$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $d8941d66709a1ee0$var$conversationIdIntegration;

});

parcelRegister("jb8ql", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");
function $df6594338a157c18$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $df6594338a157c18$var$startProfiler() {
    const client = $9OgG9.getClient();
    if (!client) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$df6594338a157c18$var$isProfilingIntegrationWithProfiler(integration)) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $df6594338a157c18$var$stopProfiler() {
    const client = $9OgG9.getClient();
    if (!client) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$df6594338a157c18$var$isProfilingIntegrationWithProfiler(integration)) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $df6594338a157c18$var$profiler = {
    startProfiler: $df6594338a157c18$var$startProfiler,
    stopProfiler: $df6594338a157c18$var$stopProfiler
};
module.exports.profiler = $df6594338a157c18$var$profiler;

});

parcelRegister("deIMO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $23CGM = parcelRequire("23CGM");

var $3QV8T = parcelRequire("3QV8T");

var $8OylQ = parcelRequire("8OylQ");

var $6tZdC = parcelRequire("6tZdC");

var $2dDpf = parcelRequire("2dDpf");

var $ejsmR = parcelRequire("ejsmR");

var $jmqLW = parcelRequire("jmqLW");

var $7Qa0H = parcelRequire("7Qa0H");

var $bn0md = parcelRequire("bn0md");

var $cgx6M = parcelRequire("cgx6M");

var $a3VLZ = parcelRequire("a3VLZ");
function $9a2f52c765c0b123$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $2dDpf.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $9a2f52c765c0b123$var$endSpan(span2, handlerData);
                $9a2f52c765c0b123$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $9OgG9.getClient();
    const hasParent = !!$3QV8T.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $7Qa0H.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $bn0md.startInactiveSpan($9a2f52c765c0b123$var$getSpanStartOptions(url, method, spanOrigin)) : new $jmqLW.SentryNonRecordingSpan();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $9a2f52c765c0b123$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $2dDpf.hasSpansEnabled() && shouldEmitSpan ? span : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $9a2f52c765c0b123$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $9a2f52c765c0b123$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $a3VLZ.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($6tZdC.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($9a2f52c765c0b123$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$9a2f52c765c0b123$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($9a2f52c765c0b123$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $9a2f52c765c0b123$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$9a2f52c765c0b123$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $9a2f52c765c0b123$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : void 0
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $9a2f52c765c0b123$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $8OylQ.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $8OylQ.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $9a2f52c765c0b123$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($ejsmR.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $9a2f52c765c0b123$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $6tZdC.isInstanceOf(headers, Headers);
}
function $9a2f52c765c0b123$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $9a2f52c765c0b123$var$getSpanStartOptions(url$1, method, spanOrigin) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $cgx6M.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $9a2f52c765c0b123$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin)
        };
    }
    const parsedUrl = $cgx6M.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $cgx6M.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $9a2f52c765c0b123$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $9a2f52c765c0b123$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: $cgx6M.stripDataUrlContent(url$1),
        type: "fetch",
        "http.method": method,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$cgx6M.isURLObjectRelative(parsedUrl)) {
            attributes["http.url"] = $cgx6M.stripDataUrlContent(parsedUrl.href);
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $9a2f52c765c0b123$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $9a2f52c765c0b123$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $9a2f52c765c0b123$var$instrumentFetchRequest;

});

parcelRegister("eOAMk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");
function $ac9243a1f999d909$var$captureFeedback(params, hint = {}, scope = $9OgG9.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $9OgG9.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $ac9243a1f999d909$var$captureFeedback;

});

parcelRegister("iYjf7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lDiMO = parcelRequire("lDiMO");

var $jVjPX = parcelRequire("jVjPX");
function $dcfcc1cd3217351a$var$captureLog(level, message, attributes, scope, severityNumber) {
    $lDiMO._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $dcfcc1cd3217351a$var$trace(message, attributes, { scope: scope } = {}) {
    $dcfcc1cd3217351a$var$captureLog("trace", message, attributes, scope);
}
function $dcfcc1cd3217351a$var$debug(message, attributes, { scope: scope } = {}) {
    $dcfcc1cd3217351a$var$captureLog("debug", message, attributes, scope);
}
function $dcfcc1cd3217351a$var$info(message, attributes, { scope: scope } = {}) {
    $dcfcc1cd3217351a$var$captureLog("info", message, attributes, scope);
}
function $dcfcc1cd3217351a$var$warn(message, attributes, { scope: scope } = {}) {
    $dcfcc1cd3217351a$var$captureLog("warn", message, attributes, scope);
}
function $dcfcc1cd3217351a$var$error(message, attributes, { scope: scope } = {}) {
    $dcfcc1cd3217351a$var$captureLog("error", message, attributes, scope);
}
function $dcfcc1cd3217351a$var$fatal(message, attributes, { scope: scope } = {}) {
    $dcfcc1cd3217351a$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $jVjPX.fmt;
module.exports.debug = $dcfcc1cd3217351a$var$debug;
module.exports.error = $dcfcc1cd3217351a$var$error;
module.exports.fatal = $dcfcc1cd3217351a$var$fatal;
module.exports.info = $dcfcc1cd3217351a$var$info;
module.exports.trace = $dcfcc1cd3217351a$var$trace;
module.exports.warn = $dcfcc1cd3217351a$var$warn;

});

parcelRegister("59i3n", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $glA0g = parcelRequire("glA0g");

var $6jVna = parcelRequire("6jVna");

var $bNCFC = parcelRequire("bNCFC");

var $23CGM = parcelRequire("23CGM");

var $3DKL9 = parcelRequire("3DKL9");

var $6tZdC = parcelRequire("6tZdC");

var $cAnBa = parcelRequire("cAnBa");

var $lDiMO = parcelRequire("lDiMO");

var $bW3Nb = parcelRequire("bW3Nb");
const $3bfbcc07f8b3852d$var$INTEGRATION_NAME = "ConsoleLogs";
const $3bfbcc07f8b3852d$var$DEFAULT_ATTRIBUTES = {
    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $3bfbcc07f8b3852d$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $3DKL9.CONSOLE_LEVELS;
    return {
        name: $3bfbcc07f8b3852d$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $6jVna.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($9OgG9.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$bW3Nb.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $lDiMO._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $3bfbcc07f8b3852d$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = {
                    ...$3bfbcc07f8b3852d$var$DEFAULT_ATTRIBUTES
                };
                if ($6tZdC.isPlainObject(firstArg)) {
                    Object.assign(attributes, $cAnBa.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = $cAnBa.normalize(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !$bW3Nb.hasConsoleSubstitutions(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = $bW3Nb.createConsoleTemplateAttributes(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? $cAnBa.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                $lDiMO._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $bW3Nb.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $3bfbcc07f8b3852d$var$consoleLoggingIntegration = $bNCFC.defineIntegration($3bfbcc07f8b3852d$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $3bfbcc07f8b3852d$var$consoleLoggingIntegration;

});
parcelRegister("bW3Nb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6tZdC = parcelRequire("6tZdC");

var $cAnBa = parcelRequire("cAnBa");

var $6hRPo = parcelRequire("6hRPo");
function $8b080d8dff88cfd1$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $6hRPo.GLOBAL_OBJ && typeof $6hRPo.GLOBAL_OBJ.util.format === "function" ? $6hRPo.GLOBAL_OBJ.util.format(...values) : $8b080d8dff88cfd1$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $8b080d8dff88cfd1$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$6tZdC.isPrimitive(value) ? String(value) : JSON.stringify($cAnBa.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $8b080d8dff88cfd1$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $8b080d8dff88cfd1$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $8b080d8dff88cfd1$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $8b080d8dff88cfd1$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $8b080d8dff88cfd1$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $8b080d8dff88cfd1$var$safeJoinConsoleArgs;

});


parcelRegister("03LKB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bJhjl = parcelRequire("bJhjl");
function $00b5523abe124778$var$captureMetric(type, name, value, options) {
    $bJhjl._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $00b5523abe124778$var$count(name, value = 1, options) {
    $00b5523abe124778$var$captureMetric("counter", name, value, options);
}
function $00b5523abe124778$var$gauge(name, value, options) {
    $00b5523abe124778$var$captureMetric("gauge", name, value, options);
}
function $00b5523abe124778$var$distribution(name, value, options) {
    $00b5523abe124778$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $00b5523abe124778$var$count;
module.exports.distribution = $00b5523abe124778$var$distribution;
module.exports.gauge = $00b5523abe124778$var$gauge;

});

parcelRegister("cUrBz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $lDiMO = parcelRequire("lDiMO");

var $bW3Nb = parcelRequire("bW3Nb");

var $6tZdC = parcelRequire("6tZdC");

var $cAnBa = parcelRequire("cAnBa");
const $966020c5bef4a78e$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $966020c5bef4a78e$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $966020c5bef4a78e$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $9OgG9.getClient();
            if (!client) return;
            const logSeverityLevel = $966020c5bef4a78e$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $cAnBa.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $966020c5bef4a78e$var$processExtractedAttributes($966020c5bef4a78e$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $lDiMO._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $bW3Nb.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $966020c5bef4a78e$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $966020c5bef4a78e$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $966020c5bef4a78e$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $966020c5bef4a78e$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $966020c5bef4a78e$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $966020c5bef4a78e$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $bW3Nb.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($6tZdC.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$bW3Nb.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $966020c5bef4a78e$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $bW3Nb.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $cAnBa.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $cAnBa.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$cAnBa.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $966020c5bef4a78e$var$createConsolaReporter;

});

parcelRegister("i4dps", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $23CGM = parcelRequire("23CGM");

var $beSJN = parcelRequire("beSJN");

var $3QV8T = parcelRequire("3QV8T");

var $aUsXR = parcelRequire("aUsXR");

var $8g96C = parcelRequire("8g96C");

var $7Qa0H = parcelRequire("7Qa0H");

var $7CERs = parcelRequire("7CERs");

var $KfDeW = parcelRequire("KfDeW");
function $d27300949f811f3f$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $3QV8T.spanToJSON(span);
    if (!name) return;
    if (attributes[$KfDeW.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$KfDeW.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $d27300949f811f3f$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$KfDeW.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    const client = $9OgG9.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $beSJN.shouldEnableTruncation(integration?.options?.enableTruncation);
    $d27300949f811f3f$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $d27300949f811f3f$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $d27300949f811f3f$var$processEndedVercelAiSpan(span);
            $7CERs.accumulateTokensForParent(span, tokenAccumulator);
        }
        $7CERs.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $7CERs.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $d27300949f811f3f$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $d27300949f811f3f$var$buildOutputMessages(attributes) {
    const responseText = attributes[$KfDeW.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$KfDeW.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$KfDeW.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$KfDeW.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $d27300949f811f3f$var$normalizeFinishReason(finishReason)
        };
        attributes[$aUsXR.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$KfDeW.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $d27300949f811f3f$var$processVercelAiSpanAttributes(attributes) {
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_USAGE_TOKENS_ATTRIBUTE, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    const inputTokensAreCacheInclusive = Object.keys(attributes).some((key)=>key.startsWith($KfDeW.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX));
    if (!inputTokensAreCacheInclusive && typeof attributes[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$KfDeW.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$KfDeW.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$KfDeW.AI_PROMPT_TOOLS_ATTRIBUTE] = $7CERs.convertAvailableToolsToJsonString(attributes[$KfDeW.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$KfDeW.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$KfDeW.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$KfDeW.AI_OPERATION_ID_ATTRIBUTE] : attributes[$KfDeW.OPERATION_NAME_ATTRIBUTE];
        const operationName = $8g96C.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$KfDeW.OPERATION_NAME_ATTRIBUTE];
    }
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_PROMPT_MESSAGES_ATTRIBUTE, $aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $d27300949f811f3f$var$buildOutputMessages(attributes);
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_TOOL_CALL_ARGS_ATTRIBUTE, $aUsXR.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_TOOL_CALL_RESULT_ATTRIBUTE, $aUsXR.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_MODEL_ID_ATTRIBUTE, $aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$KfDeW.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$KfDeW.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$aUsXR.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $d27300949f811f3f$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $d27300949f811f3f$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $d27300949f811f3f$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $d27300949f811f3f$var$processVercelAiSpanAttributes(attributes);
}
function $d27300949f811f3f$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $d27300949f811f3f$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $8g96C.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$aUsXR.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$aUsXR.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $8g96C.toolDescriptionMap.delete(span.span_id);
}
function $d27300949f811f3f$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $d27300949f811f3f$var$processToolCallSpan(span, attributes) {
    span.setAttribute($23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_TOOL_CALL_NAME_ATTRIBUTE, $aUsXR.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $d27300949f811f3f$var$renameAttributeKey(attributes, $KfDeW.AI_TOOL_CALL_ID_ATTRIBUTE, $aUsXR.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$aUsXR.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $8g96C.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$aUsXR.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($aUsXR.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$aUsXR.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $d27300949f811f3f$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$KfDeW.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $7CERs.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$KfDeW.AI_MODEL_ID_ATTRIBUTE] && !attributes[$aUsXR.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($aUsXR.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$KfDeW.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $8g96C.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$KfDeW.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $9OgG9.getClient();
    if (client && $7Qa0H.hasSpanStreamingEnabled(client) && attributes[$KfDeW.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$KfDeW.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$KfDeW.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $3QV8T.spanToJSON(span).parent_span_id;
            if (parentSpanId) $8g96C.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
function $d27300949f811f3f$var$addVercelAiProcessors(client) {
    client.on("spanStart", $d27300949f811f3f$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($d27300949f811f3f$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $d27300949f811f3f$var$processVercelAiStreamedSpan(span);
    });
}
function $d27300949f811f3f$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$KfDeW.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (providerMetadata) try {
        const providerMetadataObject = JSON.parse(providerMetadata);
        const openaiMetadata = providerMetadataObject.openai ?? providerMetadataObject.azure;
        if (openaiMetadata) {
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
            if (!attributes["gen_ai.conversation.id"]) $d27300949f811f3f$var$setAttributeIfDefined(attributes, "gen_ai.conversation.id", openaiMetadata.responseId);
        }
        if (providerMetadataObject.anthropic) {
            const cachedInputTokens = providerMetadataObject.anthropic.usage?.cache_read_input_tokens ?? providerMetadataObject.anthropic.cacheReadInputTokens;
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
            const cacheWriteInputTokens = providerMetadataObject.anthropic.usage?.cache_creation_input_tokens ?? providerMetadataObject.anthropic.cacheCreationInputTokens;
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
        }
        if (providerMetadataObject.bedrock?.usage) {
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheReadInputTokens);
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheWriteInputTokens);
        }
        if (providerMetadataObject.deepseek) {
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.deepseek.promptCacheHitTokens);
            $d27300949f811f3f$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", providerMetadataObject.deepseek.promptCacheMissTokens);
        }
    } catch  {}
}
function $d27300949f811f3f$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $d27300949f811f3f$var$addVercelAiProcessors;
module.exports.processVercelAiSpanAttributes = $d27300949f811f3f$var$processVercelAiSpanAttributes;

});
parcelRegister("beSJN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $9OgG9 = parcelRequire("9OgG9");

var $7Qa0H = parcelRequire("7Qa0H");

var $6tZdC = parcelRequire("6tZdC");

var $aUsXR = parcelRequire("aUsXR");

var $h7z86 = parcelRequire("h7z86");
function $82eb76454e9eea75$var$resolveAIRecordingOptions(options) {
    const genAI = $9OgG9.getClient()?.getDataCollectionOptions().genAI;
    return {
        ...options,
        recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
        recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
    };
}
function $82eb76454e9eea75$var$shouldEnableTruncation(enableTruncation) {
    const client = $9OgG9.getClient();
    return enableTruncation ?? !(client && $7Qa0H.hasSpanStreamingEnabled(client));
}
function $82eb76454e9eea75$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $82eb76454e9eea75$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== void 0) span.setAttributes({
        [$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== void 0) span.setAttributes({
        [$aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== void 0 || completionTokens !== void 0 || cachedInputTokens !== void 0 || cachedOutputTokens !== void 0) {
        const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
function $82eb76454e9eea75$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$aUsXR.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$aUsXR.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$aUsXR.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== void 0) attrs[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== void 0) attrs[$aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    if (state.totalTokens !== void 0) attrs[$aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== void 0 || state.completionTokens !== void 0 || state.cacheCreationInputTokens !== void 0 || state.cacheReadInputTokens !== void 0) attrs[$aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$aUsXR.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$aUsXR.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $82eb76454e9eea75$var$getJsonString(value) {
    if (typeof value === "string") return value;
    return JSON.stringify(value);
}
function $82eb76454e9eea75$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $h7z86.truncateGenAiStringInput(value);
    if (Array.isArray(value)) {
        const truncatedMessages = $h7z86.truncateGenAiMessages(value);
        return JSON.stringify(truncatedMessages);
    }
    return JSON.stringify(value);
}
function $82eb76454e9eea75$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $82eb76454e9eea75$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        $duCSA.captureException(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $82eb76454e9eea75$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    if (!$6tZdC.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $82eb76454e9eea75$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $82eb76454e9eea75$var$buildMethodPath;
module.exports.endStreamSpan = $82eb76454e9eea75$var$endStreamSpan;
module.exports.extractSystemInstructions = $82eb76454e9eea75$var$extractSystemInstructions;
module.exports.getJsonString = $82eb76454e9eea75$var$getJsonString;
module.exports.getTruncatedJsonString = $82eb76454e9eea75$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $82eb76454e9eea75$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $82eb76454e9eea75$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $82eb76454e9eea75$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $82eb76454e9eea75$var$wrapPromiseWithMethods;

});
parcelRegister("aUsXR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $7f159a1b8d0d3544$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $7f159a1b8d0d3544$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $7f159a1b8d0d3544$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $7f159a1b8d0d3544$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $7f159a1b8d0d3544$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $7f159a1b8d0d3544$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $7f159a1b8d0d3544$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $7f159a1b8d0d3544$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $7f159a1b8d0d3544$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $7f159a1b8d0d3544$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $7f159a1b8d0d3544$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $7f159a1b8d0d3544$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $7f159a1b8d0d3544$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $7f159a1b8d0d3544$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $7f159a1b8d0d3544$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_creation_input_tokens";
const $7f159a1b8d0d3544$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.cache_read_input_tokens";
const $7f159a1b8d0d3544$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $7f159a1b8d0d3544$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $7f159a1b8d0d3544$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $7f159a1b8d0d3544$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $7f159a1b8d0d3544$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $7f159a1b8d0d3544$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $7f159a1b8d0d3544$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $7f159a1b8d0d3544$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $7f159a1b8d0d3544$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $7f159a1b8d0d3544$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $7f159a1b8d0d3544$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $7f159a1b8d0d3544$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $7f159a1b8d0d3544$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("h7z86", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aUFla = parcelRequire("aUFla");
const $c76e57274b482286$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $c76e57274b482286$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $c76e57274b482286$var$jsonBytes = (value)=>{
    return $c76e57274b482286$var$utf8Bytes(JSON.stringify(value));
};
function $c76e57274b482286$var$truncateTextByBytes(text, maxBytes) {
    if ($c76e57274b482286$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $c76e57274b482286$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $c76e57274b482286$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $c76e57274b482286$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $c76e57274b482286$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $c76e57274b482286$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $c76e57274b482286$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $c76e57274b482286$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $c76e57274b482286$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $c76e57274b482286$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $c76e57274b482286$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $c76e57274b482286$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $c76e57274b482286$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$c76e57274b482286$var$withItemText(item, ""));
    const overhead = $c76e57274b482286$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $c76e57274b482286$var$getItemText(item);
        const textSize = $c76e57274b482286$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $c76e57274b482286$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($c76e57274b482286$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $c76e57274b482286$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $c76e57274b482286$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($c76e57274b482286$var$isContentMessage(message)) return $c76e57274b482286$var$truncateContentMessage(message, maxBytes);
    if ($c76e57274b482286$var$isContentArrayMessage(message) || $c76e57274b482286$var$isPartsMessage(message)) return $c76e57274b482286$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $c76e57274b482286$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($c76e57274b482286$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $c76e57274b482286$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $aUFla.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $aUFla.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($c76e57274b482286$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $c76e57274b482286$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($aUFla.isContentMedia(newMessage)) newMessage = $aUFla.stripInlineMediaFromSingleMessage(newMessage);
            else if ($aUFla.isContentMedia(message)) newMessage = $aUFla.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $c76e57274b482286$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $c76e57274b482286$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $c76e57274b482286$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $c76e57274b482286$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $c76e57274b482286$var$truncateGenAiMessages(messages) {
    return $c76e57274b482286$var$truncateMessagesByBytes(messages, $c76e57274b482286$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $c76e57274b482286$var$truncateGenAiStringInput(input) {
    return $c76e57274b482286$var$truncateTextByBytes(input, $c76e57274b482286$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $c76e57274b482286$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $c76e57274b482286$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $c76e57274b482286$var$truncateGenAiStringInput;

});
parcelRegister("aUFla", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $7f1f33b167f520d1$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $7f1f33b167f520d1$var$isContentMediaSource(part) || $7f1f33b167f520d1$var$hasInlineData(part) || $7f1f33b167f520d1$var$hasImageUrl(part) || $7f1f33b167f520d1$var$hasInputAudio(part) || $7f1f33b167f520d1$var$hasFileData(part) || $7f1f33b167f520d1$var$hasMediaTypeData(part) || $7f1f33b167f520d1$var$hasVercelFileData(part) || $7f1f33b167f520d1$var$hasVercelImageData(part) || $7f1f33b167f520d1$var$hasBlobOrBase64Type(part) || $7f1f33b167f520d1$var$hasB64Json(part) || $7f1f33b167f520d1$var$hasImageGenerationResult(part) || $7f1f33b167f520d1$var$hasDataUri(part);
}
function $7f1f33b167f520d1$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $7f1f33b167f520d1$var$hasNestedImageUrl(part);
}
function $7f1f33b167f520d1$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $7f1f33b167f520d1$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $7f1f33b167f520d1$var$isContentMedia(part.source);
}
function $7f1f33b167f520d1$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $7f1f33b167f520d1$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $7f1f33b167f520d1$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $7f1f33b167f520d1$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $7f1f33b167f520d1$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $7f1f33b167f520d1$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $7f1f33b167f520d1$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $7f1f33b167f520d1$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $7f1f33b167f520d1$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $7f1f33b167f520d1$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $7f1f33b167f520d1$var$REMOVED_STRING = "[Blob substitute]";
const $7f1f33b167f520d1$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $7f1f33b167f520d1$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($7f1f33b167f520d1$var$isContentMedia(strip.source)) strip.source = $7f1f33b167f520d1$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($7f1f33b167f520d1$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $7f1f33b167f520d1$var$REMOVED_STRING
    };
    if ($7f1f33b167f520d1$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $7f1f33b167f520d1$var$REMOVED_STRING
    };
    if ($7f1f33b167f520d1$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $7f1f33b167f520d1$var$REMOVED_STRING
    };
    if ($7f1f33b167f520d1$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $7f1f33b167f520d1$var$REMOVED_STRING
    };
    for (const field of $7f1f33b167f520d1$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $7f1f33b167f520d1$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $7f1f33b167f520d1$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $7f1f33b167f520d1$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("8g96C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6036e19681042dff$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $6036e19681042dff$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $6036e19681042dff$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $6036e19681042dff$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $6036e19681042dff$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $6036e19681042dff$var$toolDescriptionMap;

});

parcelRegister("7CERs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aUsXR = parcelRequire("aUsXR");

var $beSJN = parcelRequire("beSJN");

var $8g96C = parcelRequire("8g96C");

var $KfDeW = parcelRequire("KfDeW");
function $58cbc737b728b623$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $58cbc737b728b623$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $58cbc737b728b623$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$aUsXR.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $58cbc737b728b623$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $58cbc737b728b623$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$aUsXR.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$aUsXR.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $58cbc737b728b623$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $58cbc737b728b623$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $8g96C.toolCallSpanContextMap.get(toolCallId);
}
function $58cbc737b728b623$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $8g96C.toolCallSpanContextMap.delete(toolCallId);
}
function $58cbc737b728b623$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $58cbc737b728b623$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $58cbc737b728b623$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$58cbc737b728b623$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$58cbc737b728b623$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $58cbc737b728b623$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$KfDeW.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$KfDeW.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$KfDeW.AI_PROMPT_ATTRIBUTE];
        const messages = $58cbc737b728b623$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $beSJN.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($aUsXR.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $beSJN.getTruncatedJsonString(filteredMessages) : $beSJN.getJsonString(filteredMessages);
            span.setAttributes({
                [$KfDeW.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$KfDeW.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
        const originalMessagesJson = attributes[$KfDeW.AI_PROMPT_MESSAGES_ATTRIBUTE];
        try {
            const messages = JSON.parse(originalMessagesJson);
            if (Array.isArray(messages)) {
                const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $beSJN.extractSystemInstructions(messages);
                if (systemInstructions) span.setAttribute($aUsXR.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? $beSJN.getTruncatedJsonString(filteredMessages) : $beSJN.getJsonString(filteredMessages);
                span.setAttributes({
                    [$KfDeW.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                });
            }
        } catch  {}
    }
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $58cbc737b728b623$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $58cbc737b728b623$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $58cbc737b728b623$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $58cbc737b728b623$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $58cbc737b728b623$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $58cbc737b728b623$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $58cbc737b728b623$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $58cbc737b728b623$var$requestMessagesFromPrompt;

});
parcelRegister("KfDeW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $08b06c29a0cdf762$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $08b06c29a0cdf762$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $08b06c29a0cdf762$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $08b06c29a0cdf762$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $08b06c29a0cdf762$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $08b06c29a0cdf762$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $08b06c29a0cdf762$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $08b06c29a0cdf762$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $08b06c29a0cdf762$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $08b06c29a0cdf762$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $08b06c29a0cdf762$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $08b06c29a0cdf762$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $08b06c29a0cdf762$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $08b06c29a0cdf762$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $08b06c29a0cdf762$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
const $08b06c29a0cdf762$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $08b06c29a0cdf762$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $08b06c29a0cdf762$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $08b06c29a0cdf762$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $08b06c29a0cdf762$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $08b06c29a0cdf762$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $08b06c29a0cdf762$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $08b06c29a0cdf762$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $08b06c29a0cdf762$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $08b06c29a0cdf762$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $08b06c29a0cdf762$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $08b06c29a0cdf762$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $08b06c29a0cdf762$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $08b06c29a0cdf762$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $08b06c29a0cdf762$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $08b06c29a0cdf762$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $08b06c29a0cdf762$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $08b06c29a0cdf762$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $08b06c29a0cdf762$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $08b06c29a0cdf762$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $08b06c29a0cdf762$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $08b06c29a0cdf762$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $08b06c29a0cdf762$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $08b06c29a0cdf762$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $08b06c29a0cdf762$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $08b06c29a0cdf762$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = $08b06c29a0cdf762$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $08b06c29a0cdf762$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $08b06c29a0cdf762$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $08b06c29a0cdf762$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $08b06c29a0cdf762$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("42B6Y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $duCSA = parcelRequire("duCSA");

var $23CGM = parcelRequire("23CGM");

var $3DKL9 = parcelRequire("3DKL9");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");

var $aUsXR = parcelRequire("aUsXR");

var $beSJN = parcelRequire("beSJN");

var $hc8y4 = parcelRequire("hc8y4");

var $bspIl = parcelRequire("bspIl");

var $lvdS5 = parcelRequire("lvdS5");
function $2f1422e6ff889b8b$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $2f1422e6ff889b8b$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$aUsXR.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $2f1422e6ff889b8b$var$extractAvailableTools(params);
        if (availableTools) attributes[$aUsXR.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $lvdS5.extractRequestParameters(params));
    } else attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $2f1422e6ff889b8b$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($aUsXR.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $beSJN.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($aUsXR.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $beSJN.getTruncatedJsonString(filteredMessages) : $beSJN.getJsonString(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $2f1422e6ff889b8b$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $2f1422e6ff889b8b$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $bn0md.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $2f1422e6ff889b8b$var$addRequestAttributes(span, params, operationName, $beSJN.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $bspIl.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $8OylQ.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $duCSA.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.openai.stream",
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $beSJN.wrapPromiseWithMethods(originalResult2, instrumentedPromise2, "auto.ai.openai");
        }
        let originalResult;
        const instrumentedPromise = $bn0md.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $2f1422e6ff889b8b$var$addRequestAttributes(span, params, operationName, $beSJN.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $lvdS5.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                $duCSA.captureException(error, {
                    mechanism: {
                        handled: false,
                        type: "auto.ai.openai",
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $beSJN.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.openai");
    };
}
function $2f1422e6ff889b8b$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $beSJN.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $hc8y4.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $2f1422e6ff889b8b$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $2f1422e6ff889b8b$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $2f1422e6ff889b8b$var$instrumentOpenAiClient(client, options) {
    return $2f1422e6ff889b8b$var$createDeepProxy(client, "", $beSJN.resolveAIRecordingOptions(options));
}
module.exports.instrumentOpenAiClient = $2f1422e6ff889b8b$var$instrumentOpenAiClient;

});
parcelRegister("hc8y4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c84a30327404f0ce$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $c84a30327404f0ce$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $c84a30327404f0ce$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $c84a30327404f0ce$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$c84a30327404f0ce$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $c84a30327404f0ce$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $c84a30327404f0ce$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $c84a30327404f0ce$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $c84a30327404f0ce$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("bspIl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $8OylQ = parcelRequire("8OylQ");

var $beSJN = parcelRequire("beSJN");

var $hc8y4 = parcelRequire("hc8y4");

var $lvdS5 = parcelRequire("lvdS5");
function $8576418898f4f195$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $8576418898f4f195$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $8576418898f4f195$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $8576418898f4f195$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $8OylQ.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $duCSA.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$hc8y4.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $8576418898f4f195$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($lvdS5.isChatCompletionChunk(event)) $8576418898f4f195$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($lvdS5.isResponsesApiStreamEvent(event)) $8576418898f4f195$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $beSJN.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $8576418898f4f195$var$instrumentStream;

});
parcelRegister("lvdS5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aUsXR = parcelRequire("aUsXR");
function $fa7740cd8af0bcd3$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $fa7740cd8af0bcd3$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $fa7740cd8af0bcd3$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$aUsXR.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$aUsXR.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$aUsXR.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$aUsXR.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$aUsXR.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$aUsXR.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$aUsXR.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$aUsXR.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$aUsXR.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $fa7740cd8af0bcd3$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $fa7740cd8af0bcd3$var$extractRequestParameters(params) {
    const attributes = {
        [$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$aUsXR.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$aUsXR.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$aUsXR.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$aUsXR.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$aUsXR.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$aUsXR.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$aUsXR.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $fa7740cd8af0bcd3$var$extractConversationId(params);
    if (conversationId) attributes[$aUsXR.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $fa7740cd8af0bcd3$var$addResponseAttributes;
module.exports.extractRequestParameters = $fa7740cd8af0bcd3$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $fa7740cd8af0bcd3$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $fa7740cd8af0bcd3$var$isResponsesApiStreamEvent;

});



parcelRegister("9eqfu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $23CGM = parcelRequire("23CGM");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");

var $aUsXR = parcelRequire("aUsXR");

var $beSJN = parcelRequire("beSJN");

var $j7BPI = parcelRequire("j7BPI");

var $aFQyr = parcelRequire("aFQyr");

var $7aElZ = parcelRequire("7aElZ");
function $6b89c84f46aad3a8$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$aUsXR.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$aUsXR.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$aUsXR.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$aUsXR.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$aUsXR.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$aUsXR.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$aUsXR.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$aUsXR.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $6b89c84f46aad3a8$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $7aElZ.messagesFromParams(params);
    $7aElZ.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$aUsXR.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $6b89c84f46aad3a8$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$aUsXR.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $6b89c84f46aad3a8$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$aUsXR.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$aUsXR.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) $beSJN.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
function $6b89c84f46aad3a8$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $7aElZ.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $6b89c84f46aad3a8$var$addContentAttributes(span, response);
    $6b89c84f46aad3a8$var$addMetadataAttributes(span, response);
}
function $6b89c84f46aad3a8$var$handleStreamingError(error, span, methodPath) {
    $duCSA.captureException(error, {
        mechanism: {
            handled: false,
            type: "auto.ai.anthropic",
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: $8OylQ.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $6b89c84f46aad3a8$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $bn0md.startSpanManual(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $6b89c84f46aad3a8$var$addPrivateRequestAttributes(span, params, $beSJN.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $aFQyr.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $6b89c84f46aad3a8$var$handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return $beSJN.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
    } else return $bn0md.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $6b89c84f46aad3a8$var$addPrivateRequestAttributes(span, params, $beSJN.shouldEnableTruncation(options.enableTruncation));
            const messageStream = target.apply(context, args);
            return $aFQyr.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return $6b89c84f46aad3a8$var$handleStreamingError(error, span, methodPath);
        }
    });
}
function $6b89c84f46aad3a8$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $6b89c84f46aad3a8$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return $6b89c84f46aad3a8$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $bn0md.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) $6b89c84f46aad3a8$var$addPrivateRequestAttributes(span, params, $beSJN.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $6b89c84f46aad3a8$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    $duCSA.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.anthropic",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return $beSJN.wrapPromiseWithMethods(originalResult, instrumentedPromise, "auto.ai.anthropic");
        }
    });
}
function $6b89c84f46aad3a8$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $beSJN.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $j7BPI.ANTHROPIC_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $6b89c84f46aad3a8$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $6b89c84f46aad3a8$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $6b89c84f46aad3a8$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $6b89c84f46aad3a8$var$createDeepProxy(anthropicAiClient, "", $beSJN.resolveAIRecordingOptions(options));
}
module.exports.instrumentAnthropicAiClient = $6b89c84f46aad3a8$var$instrumentAnthropicAiClient;

});
parcelRegister("j7BPI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $debc04a19d8b4eec$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $debc04a19d8b4eec$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $debc04a19d8b4eec$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $debc04a19d8b4eec$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("aFQyr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $8OylQ = parcelRequire("8OylQ");

var $beSJN = parcelRequire("beSJN");

var $7aElZ = parcelRequire("7aElZ");
function $7c567ff6d027f076$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $8OylQ.SPAN_STATUS_ERROR,
                message: $7aElZ.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            $duCSA.captureException(event.error, {
                mechanism: {
                    handled: false,
                    type: "auto.ai.anthropic.anthropic_error"
                }
            });
            return true;
        }
    }
    return false;
}
function $7c567ff6d027f076$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta" && event.usage) {
        if ("output_tokens" in event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $7c567ff6d027f076$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $7c567ff6d027f076$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $7c567ff6d027f076$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $7c567ff6d027f076$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $7c567ff6d027f076$var$isErrorEvent(event, span);
    if (isError) return;
    $7c567ff6d027f076$var$handleMessageMetadata(event, state);
    $7c567ff6d027f076$var$handleContentBlockStart(event, state);
    $7c567ff6d027f076$var$handleContentBlockDelta(event, state, recordOutputs);
    $7c567ff6d027f076$var$handleContentBlockStop(event, state);
}
async function* $7c567ff6d027f076$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $7c567ff6d027f076$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $beSJN.endStreamSpan(span, state, recordOutputs);
    }
}
function $7c567ff6d027f076$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $7c567ff6d027f076$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $beSJN.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $duCSA.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $8OylQ.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $7c567ff6d027f076$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $7c567ff6d027f076$var$instrumentMessageStream;

});
parcelRegister("7aElZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $8OylQ = parcelRequire("8OylQ");

var $aUsXR = parcelRequire("aUsXR");

var $beSJN = parcelRequire("beSJN");
function $5388c4ffdfaf0715$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $beSJN.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$aUsXR.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $beSJN.getTruncatedJsonString(filteredMessages) : $beSJN.getJsonString(filteredMessages),
        [$aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $5388c4ffdfaf0715$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $5388c4ffdfaf0715$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $5388c4ffdfaf0715$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $5388c4ffdfaf0715$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $8OylQ.SPAN_STATUS_ERROR,
            message: $5388c4ffdfaf0715$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $duCSA.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $5388c4ffdfaf0715$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $5388c4ffdfaf0715$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $5388c4ffdfaf0715$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $5388c4ffdfaf0715$var$messagesFromParams;
module.exports.setMessagesAttribute = $5388c4ffdfaf0715$var$setMessagesAttribute;

});



parcelRegister("k2AQU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $23CGM = parcelRequire("23CGM");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");

var $dl6Mu = parcelRequire("dl6Mu");

var $aUsXR = parcelRequire("aUsXR");

var $beSJN = parcelRequire("beSJN");

var $aGyAs = parcelRequire("aGyAs");

var $iJS88 = parcelRequire("iJS88");

var $zFcUE = parcelRequire("zFcUE");
function $e97094a4f3f742f0$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $e97094a4f3f742f0$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$aUsXR.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$aUsXR.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$aUsXR.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$aUsXR.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$aUsXR.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$aUsXR.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $e97094a4f3f742f0$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$aUsXR.GEN_AI_SYSTEM_ATTRIBUTE]: $aGyAs.GOOGLE_GENAI_SYSTEM_NAME,
        [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $e97094a4f3f742f0$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $e97094a4f3f742f0$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$aUsXR.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $e97094a4f3f742f0$var$extractModel({}, context);
    return attributes;
}
function $e97094a4f3f742f0$var$addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
    if (isEmbeddings) {
        const contents = params.contents;
        if (contents != null) span.setAttribute($aUsXR.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$zFcUE.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$zFcUE.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$zFcUE.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$zFcUE.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $beSJN.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($aUsXR.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $beSJN.getTruncatedJsonString(filteredMessages) : $beSJN.getJsonString(filteredMessages)
        });
    }
}
function $e97094a4f3f742f0$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($aUsXR.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === "number") span.setAttributes({
            [$aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === "number") span.setAttributes({
            [$aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === "number") span.setAttributes({
            [$aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$aUsXR.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $e97094a4f3f742f0$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $e97094a4f3f742f0$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $bn0md.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $e97094a4f3f742f0$var$addPrivateRequestAttributes(span, params, isEmbeddings, $beSJN.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $iJS88.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $8OylQ.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $duCSA.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            return $bn0md.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $e97094a4f3f742f0$var$addPrivateRequestAttributes(span, params, isEmbeddings, $beSJN.shouldEnableTruncation(options.enableTruncation));
                return $dl6Mu.handleCallbackErrors(()=>target.apply(context, args), (error)=>{
                    $duCSA.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.google_genai",
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    if (!isEmbeddings) $e97094a4f3f742f0$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $e97094a4f3f742f0$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $beSJN.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $aGyAs.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $e97094a4f3f742f0$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $e97094a4f3f742f0$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $e97094a4f3f742f0$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $e97094a4f3f742f0$var$instrumentGoogleGenAIClient(client, options) {
    return $e97094a4f3f742f0$var$createDeepProxy(client, "", $beSJN.resolveAIRecordingOptions(options));
}
module.exports.extractModel = $e97094a4f3f742f0$var$extractModel;
module.exports.instrumentGoogleGenAIClient = $e97094a4f3f742f0$var$instrumentGoogleGenAIClient;

});
parcelRegister("aGyAs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $7c78a7ddc3cae7c9$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $7c78a7ddc3cae7c9$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $7c78a7ddc3cae7c9$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $7c78a7ddc3cae7c9$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $7c78a7ddc3cae7c9$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $7c78a7ddc3cae7c9$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("iJS88", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $8OylQ = parcelRequire("8OylQ");

var $beSJN = parcelRequire("beSJN");
function $da466b193f7fbfc2$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $8OylQ.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $duCSA.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $da466b193f7fbfc2$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
    }
}
function $da466b193f7fbfc2$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $da466b193f7fbfc2$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $da466b193f7fbfc2$var$isErrorChunk(chunk, span)) return;
    $da466b193f7fbfc2$var$handleResponseMetadata(chunk, state);
    $da466b193f7fbfc2$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $da466b193f7fbfc2$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $da466b193f7fbfc2$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $beSJN.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $da466b193f7fbfc2$var$instrumentStream;

});

parcelRegister("zFcUE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $06b33be78114d34b$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$06b33be78114d34b$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $06b33be78114d34b$var$contentUnionToMessages;

});


parcelRegister("3c3xM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $23CGM = parcelRequire("23CGM");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");

var $aUsXR = parcelRequire("aUsXR");

var $beSJN = parcelRequire("beSJN");

var $hbdBm = parcelRequire("hbdBm");

var $d9ZPE = parcelRequire("d9ZPE");
function $25353dd01d8ce07c$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $beSJN.resolveAIRecordingOptions(options);
    const enableTruncation = $beSJN.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $d9ZPE.getInvocationParams(tags);
            const attributes = $d9ZPE.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $bn0md.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$d9ZPE.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $d9ZPE.getInvocationParams(tags);
            const attributes = $d9ZPE.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $d9ZPE.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$aUsXR.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $bn0md.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$d9ZPE.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $d9ZPE.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $8OylQ.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $duCSA.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$hbdBm.LANGCHAIN_ORIGIN}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $bn0md.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $8OylQ.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $duCSA.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$hbdBm.LANGCHAIN_ORIGIN}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$d9ZPE.getAgentNameFromMetadata(metadata),
                [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hbdBm.LANGCHAIN_ORIGIN,
                [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$aUsXR.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$aUsXR.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $bn0md.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$aUsXR.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $8OylQ.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
            $duCSA.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$hbdBm.LANGCHAIN_ORIGIN}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $25353dd01d8ce07c$var$createLangChainCallbackHandler;

});
parcelRegister("hbdBm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c81e03bf260e315e$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $c81e03bf260e315e$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $c81e03bf260e315e$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $c81e03bf260e315e$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $c81e03bf260e315e$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $c81e03bf260e315e$var$ROLE_MAP;

});

parcelRegister("d9ZPE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $23CGM = parcelRequire("23CGM");

var $aUsXR = parcelRequire("aUsXR");

var $aUFla = parcelRequire("aUFla");

var $beSJN = parcelRequire("beSJN");

var $hbdBm = parcelRequire("hbdBm");
const $994c1432dee282ed$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $994c1432dee282ed$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $994c1432dee282ed$var$asString(v) {
    if (typeof v === "string") return v;
    try {
        return JSON.stringify(v);
    } catch  {
        return String(v);
    }
}
function $994c1432dee282ed$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $aUFla.isContentMedia(part) ? $aUFla.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $994c1432dee282ed$var$asString(v);
}
function $994c1432dee282ed$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $hbdBm.ROLE_MAP[normalized] ?? normalized;
}
function $994c1432dee282ed$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $994c1432dee282ed$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $994c1432dee282ed$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $994c1432dee282ed$var$normalizeMessageRole(messageType),
                content: $994c1432dee282ed$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $994c1432dee282ed$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $994c1432dee282ed$var$normalizeMessageRole(role),
                content: $994c1432dee282ed$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $994c1432dee282ed$var$normalizeMessageRole(role),
                content: $994c1432dee282ed$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $994c1432dee282ed$var$normalizeMessageRole(String(message.role)),
            content: $994c1432dee282ed$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $994c1432dee282ed$var$normalizeMessageRole($994c1432dee282ed$var$normalizeRoleNameFromCtor(ctor)),
            content: $994c1432dee282ed$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $994c1432dee282ed$var$normalizeContent(message.content)
        };
    });
}
function $994c1432dee282ed$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $994c1432dee282ed$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$aUsXR.GEN_AI_SYSTEM_ATTRIBUTE]: $994c1432dee282ed$var$asString(system ?? "langchain"),
        [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $994c1432dee282ed$var$asString(modelName),
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hbdBm.LANGCHAIN_ORIGIN,
        ...$994c1432dee282ed$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $994c1432dee282ed$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $994c1432dee282ed$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $beSJN.getTruncatedJsonString(messages) : $beSJN.getJsonString(messages));
    }
    return attrs;
}
function $994c1432dee282ed$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $994c1432dee282ed$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $994c1432dee282ed$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $beSJN.extractSystemInstructions(normalized);
        if (systemInstructions) $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $beSJN.getTruncatedJsonString(filteredMessages) : $beSJN.getJsonString(filteredMessages));
    }
    return attrs;
}
function $994c1432dee282ed$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $994c1432dee282ed$var$asString(toolCalls));
}
function $994c1432dee282ed$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        if (anthropicUsage.cache_creation_input_tokens !== void 0) $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== void 0) $994c1432dee282ed$var$setNumberIfDefined(attrs, $aUsXR.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
function $994c1432dee282ed$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $994c1432dee282ed$var$asString(finishReasons));
        $994c1432dee282ed$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $994c1432dee282ed$var$asString(texts));
        }
    }
    $994c1432dee282ed$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $994c1432dee282ed$var$setIfDefined(attrs, $aUsXR.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $994c1432dee282ed$var$asString(stopReason));
    return attrs;
}
function $994c1432dee282ed$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$aUsXR.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $994c1432dee282ed$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $994c1432dee282ed$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $994c1432dee282ed$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $994c1432dee282ed$var$containsSentryHandler(handlers) {
    return handlers.some($994c1432dee282ed$var$isSentryHandler);
}
function $994c1432dee282ed$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($994c1432dee282ed$var$isCallbackManager(existing)) {
        if ($994c1432dee282ed$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($994c1432dee282ed$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $994c1432dee282ed$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $994c1432dee282ed$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $994c1432dee282ed$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $994c1432dee282ed$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $994c1432dee282ed$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $994c1432dee282ed$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $994c1432dee282ed$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $994c1432dee282ed$var$normalizeLangChainMessages;

});


parcelRegister("bIN9s", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $23CGM = parcelRequire("23CGM");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");

var $aUsXR = parcelRequire("aUsXR");

var $beSJN = parcelRequire("beSJN");

var $3c3xM = parcelRequire("3c3xM");

var $d9ZPE = parcelRequire("d9ZPE");

var $9GC77 = parcelRequire("9GC77");

var $4gSkO = parcelRequire("4gSkO");
let $8889ee44972bb0de$var$_insideCreateReactAgent = false;
const $8889ee44972bb0de$var$SENTRY_PATCHED = "__sentry_patched__";
function $8889ee44972bb0de$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $8889ee44972bb0de$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $3c3xM.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($8889ee44972bb0de$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $bn0md.startSpan({
                op: "gen_ai.create_agent",
                name: "create_agent",
                attributes: {
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $9GC77.LANGGRAPH_ORIGIN,
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
                    [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($aUsXR.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $8889ee44972bb0de$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $8OylQ.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $duCSA.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $8889ee44972bb0de$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $8889ee44972bb0de$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $bn0md.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $9GC77.LANGGRAPH_ORIGIN,
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $aUsXR.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($aUsXR.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($aUsXR.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($aUsXR.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $d9ZPE._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $4gSkO.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($aUsXR.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $d9ZPE.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $beSJN.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($aUsXR.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $beSJN.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$aUsXR.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $beSJN.getTruncatedJsonString(filteredMessages) : $beSJN.getJsonString(filteredMessages),
                            [$aUsXR.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $4gSkO.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $8OylQ.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    $duCSA.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langgraph.error"
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
function $8889ee44972bb0de$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $8889ee44972bb0de$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $beSJN.resolveAIRecordingOptions(options);
    const sentryHandler = $3c3xM.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $4gSkO.extractLLMFromParams(args);
            const agentName = $4gSkO.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $4gSkO.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $8889ee44972bb0de$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $8889ee44972bb0de$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $8889ee44972bb0de$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $8889ee44972bb0de$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $8889ee44972bb0de$var$instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = $8889ee44972bb0de$var$instrumentStateGraphCompile(stateGraph.compile, $beSJN.resolveAIRecordingOptions(options));
    return stateGraph;
}
module.exports.instrumentCreateReactAgent = $8889ee44972bb0de$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $8889ee44972bb0de$var$instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $8889ee44972bb0de$var$instrumentStateGraphCompile;

});
parcelRegister("9GC77", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $70d599ea99ccc25a$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $70d599ea99ccc25a$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $70d599ea99ccc25a$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $70d599ea99ccc25a$var$LANGGRAPH_ORIGIN;

});

parcelRegister("4gSkO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $23CGM = parcelRequire("23CGM");

var $8OylQ = parcelRequire("8OylQ");

var $bn0md = parcelRequire("bn0md");

var $aUsXR = parcelRequire("aUsXR");

var $d9ZPE = parcelRequire("d9ZPE");

var $9GC77 = parcelRequire("9GC77");
function $31c2cdcbe83acc96$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $31c2cdcbe83acc96$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $31c2cdcbe83acc96$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $9GC77.LANGGRAPH_ORIGIN,
                    [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $aUsXR.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$aUsXR.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$aUsXR.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$aUsXR.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$aUsXR.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$aUsXR.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$aUsXR.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $bn0md.startSpan({
                    op: $aUsXR.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($aUsXR.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $8OylQ.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        $duCSA.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: "auto.ai.langgraph.error"
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $31c2cdcbe83acc96$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $31c2cdcbe83acc96$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    if (msg.usage_metadata && typeof msg.usage_metadata === "object") {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === "number") inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === "number") outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === "number") totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === "object") {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === "number") inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === "number") outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === "number") totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
function $31c2cdcbe83acc96$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($aUsXR.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($aUsXR.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $31c2cdcbe83acc96$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $31c2cdcbe83acc96$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $31c2cdcbe83acc96$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($aUsXR.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $d9ZPE.normalizeLangChainMessages(newMessages);
    span.setAttribute($aUsXR.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    for (const message of newMessages){
        const tokens = $31c2cdcbe83acc96$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        $31c2cdcbe83acc96$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($aUsXR.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($aUsXR.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($aUsXR.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
module.exports.extractAgentNameFromParams = $31c2cdcbe83acc96$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $31c2cdcbe83acc96$var$extractLLMFromParams;
module.exports.extractModelMetadata = $31c2cdcbe83acc96$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $31c2cdcbe83acc96$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $31c2cdcbe83acc96$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $31c2cdcbe83acc96$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $31c2cdcbe83acc96$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $31c2cdcbe83acc96$var$wrapToolsWithSpans;

});


parcelRegister("eRY7r", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $456Az = parcelRequire("456Az");

var $kOJcT = parcelRequire("kOJcT");

var $fqtFY = parcelRequire("fqtFY");

var $faZWJ = parcelRequire("faZWJ");
const $ad34a651a3a9ac30$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $ad34a651a3a9ac30$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $ad34a651a3a9ac30$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $ad34a651a3a9ac30$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $ad34a651a3a9ac30$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $ad34a651a3a9ac30$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $456Az.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $faZWJ.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $kOJcT.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $fqtFY.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $glA0g.DEBUG_BUILD && $3DKL9.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $glA0g.DEBUG_BUILD && $3DKL9.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $ad34a651a3a9ac30$var$SpanBuffer;

});
parcelRegister("fqtFY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cieLS = parcelRequire("cieLS");

var $hnvKl = parcelRequire("hnvKl");

var $lMMO3 = parcelRequire("lMMO3");

var $gtpOW = parcelRequire("gtpOW");
function $b3b04dc67bc73076$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $hnvKl.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date($gtpOW.safeDateNow()).toISOString(),
        ...$b3b04dc67bc73076$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $cieLS.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$lMMO3.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $hnvKl.createEnvelope(headers, [
        spanContainer
    ]);
}
function $b3b04dc67bc73076$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $b3b04dc67bc73076$var$createStreamedSpanEnvelope;

});

parcelRegister("faZWJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aTrwl = parcelRequire("aTrwl");
function $b0c7d76eadca9878$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $aTrwl.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $aTrwl.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $b0c7d76eadca9878$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("hQW07", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $bNCFC = parcelRequire("bNCFC");

var $fvKkS = parcelRequire("fvKkS");

var $lHgv5 = parcelRequire("lHgv5");

var $7Qa0H = parcelRequire("7Qa0H");

var $eRY7r = parcelRequire("eRY7r");

var $3DKL9 = parcelRequire("3DKL9");

var $3QV8T = parcelRequire("3QV8T");
const $cff448c1187d06b1$var$spanStreamingIntegration = $bNCFC.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$7Qa0H.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$fvKkS.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $glA0g.DEBUG_BUILD && $3DKL9.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $eRY7r.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$3QV8T.spanIsSampled(span)) return;
                buffer.add($lHgv5.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $cff448c1187d06b1$var$spanStreamingIntegration;

});

parcelRegister("jTuXY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e7bb2caa39a37cda$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $e7bb2caa39a37cda$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("hYIB8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $d16aa27a32959488$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $d16aa27a32959488$var$SentryError;

});

parcelRegister("4zslB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9OgG9 = parcelRequire("9OgG9");

var $6tZdC = parcelRequire("6tZdC");

var $eXIZW = parcelRequire("eXIZW");

var $jWoUg = parcelRequire("jWoUg");

var $5w1OV = parcelRequire("5w1OV");

var $6hRPo = parcelRequire("6hRPo");

var $awwU9 = parcelRequire("awwU9");
function $35406b7e4312ea27$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $awwU9.addHandler(type, handler);
    $awwU9.maybeInstrument(type, ()=>$35406b7e4312ea27$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $35406b7e4312ea27$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $awwU9.addHandler(type, handler);
    $awwU9.maybeInstrument(type, ()=>$35406b7e4312ea27$var$instrumentFetch($35406b7e4312ea27$var$streamHandler));
    return removeHandler;
}
function $35406b7e4312ea27$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$jWoUg.supportsNativeFetch()) return;
    $eXIZW.fill($6hRPo.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $35406b7e4312ea27$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $5w1OV.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $35406b7e4312ea27$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $awwU9.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($6hRPo.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $awwU9.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $5w1OV.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $awwU9.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $5w1OV.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($6tZdC.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $eXIZW.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $9OgG9.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $eXIZW.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $35406b7e4312ea27$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $35406b7e4312ea27$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $35406b7e4312ea27$var$resolveResponse(clonedResponseForResolving, ()=>{
        $awwU9.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $5w1OV.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $35406b7e4312ea27$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $35406b7e4312ea27$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($35406b7e4312ea27$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $35406b7e4312ea27$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $35406b7e4312ea27$var$getUrlFromResource(resource),
            method: $35406b7e4312ea27$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $6tZdC.isRequest(resource) && $35406b7e4312ea27$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $35406b7e4312ea27$var$getUrlFromResource(arg),
        method: $35406b7e4312ea27$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $35406b7e4312ea27$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($6tZdC.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $35406b7e4312ea27$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $35406b7e4312ea27$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $35406b7e4312ea27$var$parseFetchArgs;

});
parcelRegister("jWoUg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $glA0g = parcelRequire("glA0g");

var $3DKL9 = parcelRequire("3DKL9");

var $6hRPo = parcelRequire("6hRPo");
const $e846c0ff1c65d1e1$var$WINDOW = $6hRPo.GLOBAL_OBJ;
function $e846c0ff1c65d1e1$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $e846c0ff1c65d1e1$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $e846c0ff1c65d1e1$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $e846c0ff1c65d1e1$var$supportsHistory() {
    return "history" in $e846c0ff1c65d1e1$var$WINDOW && !!$e846c0ff1c65d1e1$var$WINDOW.history;
}
const $e846c0ff1c65d1e1$var$supportsFetch = $e846c0ff1c65d1e1$var$_isFetchSupported;
function $e846c0ff1c65d1e1$var$_isFetchSupported() {
    if (!("fetch" in $e846c0ff1c65d1e1$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $e846c0ff1c65d1e1$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $e846c0ff1c65d1e1$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$e846c0ff1c65d1e1$var$_isFetchSupported()) return false;
    if ($e846c0ff1c65d1e1$var$isNativeFunction($e846c0ff1c65d1e1$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $e846c0ff1c65d1e1$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $e846c0ff1c65d1e1$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $glA0g.DEBUG_BUILD && $3DKL9.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $e846c0ff1c65d1e1$var$supportsReportingObserver() {
    return "ReportingObserver" in $e846c0ff1c65d1e1$var$WINDOW;
}
function $e846c0ff1c65d1e1$var$supportsReferrerPolicy() {
    if (!$e846c0ff1c65d1e1$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $e846c0ff1c65d1e1$var$isNativeFunction;
module.exports.supportsDOMError = $e846c0ff1c65d1e1$var$supportsDOMError;
module.exports.supportsDOMException = $e846c0ff1c65d1e1$var$supportsDOMException;
module.exports.supportsErrorEvent = $e846c0ff1c65d1e1$var$supportsErrorEvent;
module.exports.supportsFetch = $e846c0ff1c65d1e1$var$supportsFetch;
module.exports.supportsHistory = $e846c0ff1c65d1e1$var$supportsHistory;
module.exports.supportsNativeFetch = $e846c0ff1c65d1e1$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $e846c0ff1c65d1e1$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $e846c0ff1c65d1e1$var$supportsReportingObserver;

});


parcelRegister("gKbW9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c30a33a48d0d20b5$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $c30a33a48d0d20b5$var$replaceExports;

});

parcelRegister("lacoC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $f68425bb7f3a3398$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $f68425bb7f3a3398$var$LRUMap;

});

parcelRegister("iWURH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $dcb9c1057bc37814$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $dcb9c1057bc37814$var$escapeStringForRegex;

});

parcelRegister("7KadD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6tZdC = parcelRequire("6tZdC");

var $6hRPo = parcelRequire("6hRPo");
const $5a34c18a7d7e5c38$var$WINDOW = $6hRPo.GLOBAL_OBJ;
const $5a34c18a7d7e5c38$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $5a34c18a7d7e5c38$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $5a34c18a7d7e5c38$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $5a34c18a7d7e5c38$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $5a34c18a7d7e5c38$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($5a34c18a7d7e5c38$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $6tZdC.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $5a34c18a7d7e5c38$var$getLocationHref() {
    try {
        return $5a34c18a7d7e5c38$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $5a34c18a7d7e5c38$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$5a34c18a7d7e5c38$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $5a34c18a7d7e5c38$var$getComponentName;
module.exports.getLocationHref = $5a34c18a7d7e5c38$var$getLocationHref;
module.exports.htmlTreeAsString = $5a34c18a7d7e5c38$var$htmlTreeAsString;

});

parcelRegister("hFOjs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $duCSA = parcelRequire("duCSA");

var $23CGM = parcelRequire("23CGM");

var $bn0md = parcelRequire("bn0md");

var $aUsXR = parcelRequire("aUsXR");

var $beSJN = parcelRequire("beSJN");

var $hbdBm = parcelRequire("hbdBm");
function $cddd4b18adf01e5a$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $cddd4b18adf01e5a$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hbdBm.LANGCHAIN_ORIGIN,
        [$23CGM.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $aUsXR.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$aUsXR.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$aUsXR.GEN_AI_SYSTEM_ATTRIBUTE] = $cddd4b18adf01e5a$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$aUsXR.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$aUsXR.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $cddd4b18adf01e5a$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    const { recordInputs: recordInputs } = $beSJN.resolveAIRecordingOptions(options);
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const attributes = $cddd4b18adf01e5a$var$extractEmbeddingAttributes(thisArg);
            const modelName = attributes[$aUsXR.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
            if (recordInputs) {
                const input = args[0];
                if (input != null) attributes[$aUsXR.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
            }
            return $bn0md.startSpan({
                name: `embeddings ${modelName}`,
                op: $aUsXR.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
                attributes: attributes
            }, ()=>{
                return Reflect.apply(target, thisArg, args).then(void 0, (error)=>{
                    $duCSA.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: "auto.ai.langchain"
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
function $cddd4b18adf01e5a$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $cddd4b18adf01e5a$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $cddd4b18adf01e5a$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports.instrumentEmbeddingMethod = $cddd4b18adf01e5a$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $cddd4b18adf01e5a$var$instrumentLangChainEmbeddings;

});


parcelRegister("11Ba2", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $c2WdB = parcelRequire("c2WdB");
function isNodeEnv() {
    return !(0, $c2WdB.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("c2WdB", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $8c52d4e3db91b360$export$2928c40372e623c0; });
function $8c52d4e3db91b360$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $8c52d4e3db91b360$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("8nPCK", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $61a884290963e577$export$ae55be85d98224ed; }, function (v) { return $61a884290963e577$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $61a884290963e577$export$d39a5bbd09211389; }, function (v) { return $61a884290963e577$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $61a884290963e577$export$882461b6382ed46c; }, function (v) { return $61a884290963e577$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $61a884290963e577$export$466bfc07425424d5; }, function (v) { return $61a884290963e577$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $61a884290963e577$export$cd75ccfd720a3cd4; }, function (v) { return $61a884290963e577$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $61a884290963e577$export$fa8d919ba61d84db; }, function (v) { return $61a884290963e577$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $61a884290963e577$export$757ceba2d55c277e; }, function (v) { return $61a884290963e577$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $61a884290963e577$export$b3890eb0ae9dca99; }, function (v) { return $61a884290963e577$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $61a884290963e577$export$502457920280e6be; }, function (v) { return $61a884290963e577$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $61a884290963e577$export$c78a37762a8d58e1; }, function (v) { return $61a884290963e577$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $61a884290963e577$export$dc54d992c10e8a18; }, function (v) { return $61a884290963e577$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $61a884290963e577$export$83d89fbfd8236492; }, function (v) { return $61a884290963e577$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $61a884290963e577$export$ae55be85d98224ed;
var $61a884290963e577$export$d39a5bbd09211389;
var $61a884290963e577$export$882461b6382ed46c;
var $61a884290963e577$export$466bfc07425424d5;
var $61a884290963e577$export$cd75ccfd720a3cd4;
var $61a884290963e577$export$fa8d919ba61d84db;
var $61a884290963e577$export$757ceba2d55c277e;
var $61a884290963e577$export$b3890eb0ae9dca99;
var $61a884290963e577$export$502457920280e6be;
var $61a884290963e577$export$c78a37762a8d58e1;
var $61a884290963e577$export$dc54d992c10e8a18;
var $61a884290963e577$export$83d89fbfd8236492;
'use strict';

var $itHdT = parcelRequire("itHdT");

var $hCCIz = parcelRequire("hCCIz");
function $61a884290963e577$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $61a884290963e577$var$da = new Set, $61a884290963e577$var$ea = {};
function $61a884290963e577$var$fa(a, b) {
    $61a884290963e577$var$ha(a, b);
    $61a884290963e577$var$ha(a + "Capture", b);
}
function $61a884290963e577$var$ha(a, b) {
    $61a884290963e577$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$61a884290963e577$var$da.add(b[a]);
}
var $61a884290963e577$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $61a884290963e577$var$ja = Object.prototype.hasOwnProperty, $61a884290963e577$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $61a884290963e577$var$la = {}, $61a884290963e577$var$ma = {};
function $61a884290963e577$var$oa(a) {
    if ($61a884290963e577$var$ja.call($61a884290963e577$var$ma, a)) return !0;
    if ($61a884290963e577$var$ja.call($61a884290963e577$var$la, a)) return !1;
    if ($61a884290963e577$var$ka.test(a)) return $61a884290963e577$var$ma[a] = !0;
    $61a884290963e577$var$la[a] = !0;
    return !1;
}
function $61a884290963e577$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $61a884290963e577$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $61a884290963e577$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $61a884290963e577$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $61a884290963e577$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $61a884290963e577$var$z[b] = new $61a884290963e577$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $61a884290963e577$var$ra = /[\-:]([a-z])/g;
function $61a884290963e577$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($61a884290963e577$var$ra, $61a884290963e577$var$sa);
    $61a884290963e577$var$z[b] = new $61a884290963e577$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($61a884290963e577$var$ra, $61a884290963e577$var$sa);
    $61a884290963e577$var$z[b] = new $61a884290963e577$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($61a884290963e577$var$ra, $61a884290963e577$var$sa);
    $61a884290963e577$var$z[b] = new $61a884290963e577$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$61a884290963e577$var$z.xlinkHref = new $61a884290963e577$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $61a884290963e577$var$z[a] = new $61a884290963e577$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $61a884290963e577$var$ta(a, b, c, d) {
    var e = $61a884290963e577$var$z.hasOwnProperty(b) ? $61a884290963e577$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $61a884290963e577$var$qa(b, c, e, d) && (c = null), d || null === e ? $61a884290963e577$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $61a884290963e577$var$ua = $itHdT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $61a884290963e577$var$va = Symbol.for("react.element"), $61a884290963e577$var$wa = Symbol.for("react.portal"), $61a884290963e577$var$ya = Symbol.for("react.fragment"), $61a884290963e577$var$za = Symbol.for("react.strict_mode"), $61a884290963e577$var$Aa = Symbol.for("react.profiler"), $61a884290963e577$var$Ba = Symbol.for("react.provider"), $61a884290963e577$var$Ca = Symbol.for("react.context"), $61a884290963e577$var$Da = Symbol.for("react.forward_ref"), $61a884290963e577$var$Ea = Symbol.for("react.suspense"), $61a884290963e577$var$Fa = Symbol.for("react.suspense_list"), $61a884290963e577$var$Ga = Symbol.for("react.memo"), $61a884290963e577$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $61a884290963e577$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $61a884290963e577$var$Ja = Symbol.iterator;
function $61a884290963e577$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $61a884290963e577$var$Ja && a[$61a884290963e577$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $61a884290963e577$var$A = Object.assign, $61a884290963e577$var$La;
function $61a884290963e577$var$Ma(a) {
    if (void 0 === $61a884290963e577$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $61a884290963e577$var$La = b && b[1] || "";
    }
    return "\n" + $61a884290963e577$var$La + a;
}
var $61a884290963e577$var$Na = !1;
function $61a884290963e577$var$Oa(a, b) {
    if (!a || $61a884290963e577$var$Na) return "";
    $61a884290963e577$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $61a884290963e577$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $61a884290963e577$var$Ma(a) : "";
}
function $61a884290963e577$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $61a884290963e577$var$Ma(a.type);
        case 16:
            return $61a884290963e577$var$Ma("Lazy");
        case 13:
            return $61a884290963e577$var$Ma("Suspense");
        case 19:
            return $61a884290963e577$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $61a884290963e577$var$Oa(a.type, !1), a;
        case 11:
            return a = $61a884290963e577$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $61a884290963e577$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $61a884290963e577$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $61a884290963e577$var$ya:
            return "Fragment";
        case $61a884290963e577$var$wa:
            return "Portal";
        case $61a884290963e577$var$Aa:
            return "Profiler";
        case $61a884290963e577$var$za:
            return "StrictMode";
        case $61a884290963e577$var$Ea:
            return "Suspense";
        case $61a884290963e577$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $61a884290963e577$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $61a884290963e577$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $61a884290963e577$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $61a884290963e577$var$Ga:
            return b = a.displayName || null, null !== b ? b : $61a884290963e577$var$Qa(a.type) || "Memo";
        case $61a884290963e577$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $61a884290963e577$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $61a884290963e577$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $61a884290963e577$var$Qa(b);
        case 8:
            return b === $61a884290963e577$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $61a884290963e577$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $61a884290963e577$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $61a884290963e577$var$Ua(a) {
    var b = $61a884290963e577$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $61a884290963e577$var$Va(a) {
    a._valueTracker || (a._valueTracker = $61a884290963e577$var$Ua(a));
}
function $61a884290963e577$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $61a884290963e577$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $61a884290963e577$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $61a884290963e577$var$Ya(a, b) {
    var c = b.checked;
    return $61a884290963e577$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $61a884290963e577$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $61a884290963e577$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $61a884290963e577$var$ab(a, b) {
    b = b.checked;
    null != b && $61a884290963e577$var$ta(a, "checked", b, !1);
}
function $61a884290963e577$var$bb(a, b) {
    $61a884290963e577$var$ab(a, b);
    var c = $61a884290963e577$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $61a884290963e577$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $61a884290963e577$var$cb(a, b.type, $61a884290963e577$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $61a884290963e577$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $61a884290963e577$var$cb(a, b, c) {
    if ("number" !== b || $61a884290963e577$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $61a884290963e577$var$eb = Array.isArray;
function $61a884290963e577$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $61a884290963e577$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $61a884290963e577$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($61a884290963e577$var$p(91));
    return $61a884290963e577$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $61a884290963e577$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($61a884290963e577$var$p(92));
            if ($61a884290963e577$var$eb(c)) {
                if (1 < c.length) throw Error($61a884290963e577$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $61a884290963e577$var$Sa(c)
    };
}
function $61a884290963e577$var$ib(a, b) {
    var c = $61a884290963e577$var$Sa(b.value), d = $61a884290963e577$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $61a884290963e577$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $61a884290963e577$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $61a884290963e577$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $61a884290963e577$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $61a884290963e577$var$mb, $61a884290963e577$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $61a884290963e577$var$mb = $61a884290963e577$var$mb || document.createElement("div");
        $61a884290963e577$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $61a884290963e577$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $61a884290963e577$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $61a884290963e577$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $61a884290963e577$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($61a884290963e577$var$pb).forEach(function(a) {
    $61a884290963e577$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $61a884290963e577$var$pb[b] = $61a884290963e577$var$pb[a];
    });
});
function $61a884290963e577$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $61a884290963e577$var$pb.hasOwnProperty(a) && $61a884290963e577$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $61a884290963e577$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $61a884290963e577$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $61a884290963e577$var$tb = $61a884290963e577$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $61a884290963e577$var$ub(a, b) {
    if (b) {
        if ($61a884290963e577$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($61a884290963e577$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($61a884290963e577$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($61a884290963e577$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($61a884290963e577$var$p(62));
    }
}
function $61a884290963e577$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $61a884290963e577$var$wb = null;
function $61a884290963e577$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $61a884290963e577$var$yb = null, $61a884290963e577$var$zb = null, $61a884290963e577$var$Ab = null;
function $61a884290963e577$var$Bb(a) {
    if (a = $61a884290963e577$var$Cb(a)) {
        if ("function" !== typeof $61a884290963e577$var$yb) throw Error($61a884290963e577$var$p(280));
        var b = a.stateNode;
        b && (b = $61a884290963e577$var$Db(b), $61a884290963e577$var$yb(a.stateNode, a.type, b));
    }
}
function $61a884290963e577$var$Eb(a) {
    $61a884290963e577$var$zb ? $61a884290963e577$var$Ab ? $61a884290963e577$var$Ab.push(a) : $61a884290963e577$var$Ab = [
        a
    ] : $61a884290963e577$var$zb = a;
}
function $61a884290963e577$var$Fb() {
    if ($61a884290963e577$var$zb) {
        var a = $61a884290963e577$var$zb, b = $61a884290963e577$var$Ab;
        $61a884290963e577$var$Ab = $61a884290963e577$var$zb = null;
        $61a884290963e577$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$61a884290963e577$var$Bb(b[a]);
    }
}
function $61a884290963e577$var$Gb(a, b) {
    return a(b);
}
function $61a884290963e577$var$Hb() {}
var $61a884290963e577$var$Ib = !1;
function $61a884290963e577$var$Jb(a, b, c) {
    if ($61a884290963e577$var$Ib) return a(b, c);
    $61a884290963e577$var$Ib = !0;
    try {
        return $61a884290963e577$var$Gb(a, b, c);
    } finally{
        if ($61a884290963e577$var$Ib = !1, null !== $61a884290963e577$var$zb || null !== $61a884290963e577$var$Ab) $61a884290963e577$var$Hb(), $61a884290963e577$var$Fb();
    }
}
function $61a884290963e577$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $61a884290963e577$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($61a884290963e577$var$p(231, b, typeof c));
    return c;
}
var $61a884290963e577$var$Lb = !1;
if ($61a884290963e577$var$ia) try {
    var $61a884290963e577$var$Mb = {};
    Object.defineProperty($61a884290963e577$var$Mb, "passive", {
        get: function() {
            $61a884290963e577$var$Lb = !0;
        }
    });
    window.addEventListener("test", $61a884290963e577$var$Mb, $61a884290963e577$var$Mb);
    window.removeEventListener("test", $61a884290963e577$var$Mb, $61a884290963e577$var$Mb);
} catch (a) {
    $61a884290963e577$var$Lb = !1;
}
function $61a884290963e577$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $61a884290963e577$var$Ob = !1, $61a884290963e577$var$Pb = null, $61a884290963e577$var$Qb = !1, $61a884290963e577$var$Rb = null, $61a884290963e577$var$Sb = {
    onError: function(a) {
        $61a884290963e577$var$Ob = !0;
        $61a884290963e577$var$Pb = a;
    }
};
function $61a884290963e577$var$Tb(a, b, c, d, e, f, g, h, k) {
    $61a884290963e577$var$Ob = !1;
    $61a884290963e577$var$Pb = null;
    $61a884290963e577$var$Nb.apply($61a884290963e577$var$Sb, arguments);
}
function $61a884290963e577$var$Ub(a, b, c, d, e, f, g, h, k) {
    $61a884290963e577$var$Tb.apply(this, arguments);
    if ($61a884290963e577$var$Ob) {
        if ($61a884290963e577$var$Ob) {
            var l = $61a884290963e577$var$Pb;
            $61a884290963e577$var$Ob = !1;
            $61a884290963e577$var$Pb = null;
        } else throw Error($61a884290963e577$var$p(198));
        $61a884290963e577$var$Qb || ($61a884290963e577$var$Qb = !0, $61a884290963e577$var$Rb = l);
    }
}
function $61a884290963e577$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $61a884290963e577$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $61a884290963e577$var$Xb(a) {
    if ($61a884290963e577$var$Vb(a) !== a) throw Error($61a884290963e577$var$p(188));
}
function $61a884290963e577$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $61a884290963e577$var$Vb(a);
        if (null === b) throw Error($61a884290963e577$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $61a884290963e577$var$Xb(e), a;
                if (f === d) return $61a884290963e577$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($61a884290963e577$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($61a884290963e577$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($61a884290963e577$var$p(190));
    }
    if (3 !== c.tag) throw Error($61a884290963e577$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $61a884290963e577$var$Zb(a) {
    a = $61a884290963e577$var$Yb(a);
    return null !== a ? $61a884290963e577$var$$b(a) : null;
}
function $61a884290963e577$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $61a884290963e577$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $61a884290963e577$var$ac = $hCCIz.unstable_scheduleCallback, $61a884290963e577$var$bc = $hCCIz.unstable_cancelCallback, $61a884290963e577$var$cc = $hCCIz.unstable_shouldYield, $61a884290963e577$var$dc = $hCCIz.unstable_requestPaint, $61a884290963e577$var$B = $hCCIz.unstable_now, $61a884290963e577$var$ec = $hCCIz.unstable_getCurrentPriorityLevel, $61a884290963e577$var$fc = $hCCIz.unstable_ImmediatePriority, $61a884290963e577$var$gc = $hCCIz.unstable_UserBlockingPriority, $61a884290963e577$var$hc = $hCCIz.unstable_NormalPriority, $61a884290963e577$var$ic = $hCCIz.unstable_LowPriority, $61a884290963e577$var$jc = $hCCIz.unstable_IdlePriority, $61a884290963e577$var$kc = null, $61a884290963e577$var$lc = null;
function $61a884290963e577$var$mc(a) {
    if ($61a884290963e577$var$lc && "function" === typeof $61a884290963e577$var$lc.onCommitFiberRoot) try {
        $61a884290963e577$var$lc.onCommitFiberRoot($61a884290963e577$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $61a884290963e577$var$oc = Math.clz32 ? Math.clz32 : $61a884290963e577$var$nc, $61a884290963e577$var$pc = Math.log, $61a884290963e577$var$qc = Math.LN2;
function $61a884290963e577$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($61a884290963e577$var$pc(a) / $61a884290963e577$var$qc | 0) | 0;
}
var $61a884290963e577$var$rc = 64, $61a884290963e577$var$sc = 4194304;
function $61a884290963e577$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $61a884290963e577$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $61a884290963e577$var$tc(h) : (f &= g, 0 !== f && (d = $61a884290963e577$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $61a884290963e577$var$tc(g) : 0 !== f && (d = $61a884290963e577$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $61a884290963e577$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $61a884290963e577$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $61a884290963e577$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $61a884290963e577$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $61a884290963e577$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $61a884290963e577$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $61a884290963e577$var$yc() {
    var a = $61a884290963e577$var$rc;
    $61a884290963e577$var$rc <<= 1;
    0 === ($61a884290963e577$var$rc & 4194240) && ($61a884290963e577$var$rc = 64);
    return a;
}
function $61a884290963e577$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $61a884290963e577$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $61a884290963e577$var$oc(b);
    a[b] = c;
}
function $61a884290963e577$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $61a884290963e577$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $61a884290963e577$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $61a884290963e577$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $61a884290963e577$var$C = 0;
function $61a884290963e577$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $61a884290963e577$var$Ec, $61a884290963e577$var$Fc, $61a884290963e577$var$Gc, $61a884290963e577$var$Hc, $61a884290963e577$var$Ic, $61a884290963e577$var$Jc = !1, $61a884290963e577$var$Kc = [], $61a884290963e577$var$Lc = null, $61a884290963e577$var$Mc = null, $61a884290963e577$var$Nc = null, $61a884290963e577$var$Oc = new Map, $61a884290963e577$var$Pc = new Map, $61a884290963e577$var$Qc = [], $61a884290963e577$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $61a884290963e577$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $61a884290963e577$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $61a884290963e577$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $61a884290963e577$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $61a884290963e577$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $61a884290963e577$var$Pc.delete(b.pointerId);
    }
}
function $61a884290963e577$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $61a884290963e577$var$Cb(b), null !== b && $61a884290963e577$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $61a884290963e577$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $61a884290963e577$var$Lc = $61a884290963e577$var$Tc($61a884290963e577$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $61a884290963e577$var$Mc = $61a884290963e577$var$Tc($61a884290963e577$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $61a884290963e577$var$Nc = $61a884290963e577$var$Tc($61a884290963e577$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $61a884290963e577$var$Oc.set(f, $61a884290963e577$var$Tc($61a884290963e577$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $61a884290963e577$var$Pc.set(f, $61a884290963e577$var$Tc($61a884290963e577$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $61a884290963e577$var$Vc(a) {
    var b = $61a884290963e577$var$Wc(a.target);
    if (null !== b) {
        var c = $61a884290963e577$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $61a884290963e577$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $61a884290963e577$var$Ic(a.priority, function() {
                        $61a884290963e577$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $61a884290963e577$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $61a884290963e577$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $61a884290963e577$var$wb = d;
            c.target.dispatchEvent(d);
            $61a884290963e577$var$wb = null;
        } else return b = $61a884290963e577$var$Cb(c), null !== b && $61a884290963e577$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $61a884290963e577$var$Zc(a, b, c) {
    $61a884290963e577$var$Xc(a) && c.delete(b);
}
function $61a884290963e577$var$$c() {
    $61a884290963e577$var$Jc = !1;
    null !== $61a884290963e577$var$Lc && $61a884290963e577$var$Xc($61a884290963e577$var$Lc) && ($61a884290963e577$var$Lc = null);
    null !== $61a884290963e577$var$Mc && $61a884290963e577$var$Xc($61a884290963e577$var$Mc) && ($61a884290963e577$var$Mc = null);
    null !== $61a884290963e577$var$Nc && $61a884290963e577$var$Xc($61a884290963e577$var$Nc) && ($61a884290963e577$var$Nc = null);
    $61a884290963e577$var$Oc.forEach($61a884290963e577$var$Zc);
    $61a884290963e577$var$Pc.forEach($61a884290963e577$var$Zc);
}
function $61a884290963e577$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $61a884290963e577$var$Jc || ($61a884290963e577$var$Jc = !0, $hCCIz.unstable_scheduleCallback($hCCIz.unstable_NormalPriority, $61a884290963e577$var$$c)));
}
function $61a884290963e577$var$bd(a) {
    function b(b) {
        return $61a884290963e577$var$ad(b, a);
    }
    if (0 < $61a884290963e577$var$Kc.length) {
        $61a884290963e577$var$ad($61a884290963e577$var$Kc[0], a);
        for(var c = 1; c < $61a884290963e577$var$Kc.length; c++){
            var d = $61a884290963e577$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $61a884290963e577$var$Lc && $61a884290963e577$var$ad($61a884290963e577$var$Lc, a);
    null !== $61a884290963e577$var$Mc && $61a884290963e577$var$ad($61a884290963e577$var$Mc, a);
    null !== $61a884290963e577$var$Nc && $61a884290963e577$var$ad($61a884290963e577$var$Nc, a);
    $61a884290963e577$var$Oc.forEach(b);
    $61a884290963e577$var$Pc.forEach(b);
    for(c = 0; c < $61a884290963e577$var$Qc.length; c++)d = $61a884290963e577$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $61a884290963e577$var$Qc.length && (c = $61a884290963e577$var$Qc[0], null === c.blockedOn);)$61a884290963e577$var$Vc(c), null === c.blockedOn && $61a884290963e577$var$Qc.shift();
}
var $61a884290963e577$var$cd = $61a884290963e577$var$ua.ReactCurrentBatchConfig, $61a884290963e577$var$dd = !0;
function $61a884290963e577$var$ed(a, b, c, d) {
    var e = $61a884290963e577$var$C, f = $61a884290963e577$var$cd.transition;
    $61a884290963e577$var$cd.transition = null;
    try {
        $61a884290963e577$var$C = 1, $61a884290963e577$var$fd(a, b, c, d);
    } finally{
        $61a884290963e577$var$C = e, $61a884290963e577$var$cd.transition = f;
    }
}
function $61a884290963e577$var$gd(a, b, c, d) {
    var e = $61a884290963e577$var$C, f = $61a884290963e577$var$cd.transition;
    $61a884290963e577$var$cd.transition = null;
    try {
        $61a884290963e577$var$C = 4, $61a884290963e577$var$fd(a, b, c, d);
    } finally{
        $61a884290963e577$var$C = e, $61a884290963e577$var$cd.transition = f;
    }
}
function $61a884290963e577$var$fd(a, b, c, d) {
    if ($61a884290963e577$var$dd) {
        var e = $61a884290963e577$var$Yc(a, b, c, d);
        if (null === e) $61a884290963e577$var$hd(a, b, d, $61a884290963e577$var$id, c), $61a884290963e577$var$Sc(a, d);
        else if ($61a884290963e577$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($61a884290963e577$var$Sc(a, d), b & 4 && -1 < $61a884290963e577$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $61a884290963e577$var$Cb(e);
                null !== f && $61a884290963e577$var$Ec(f);
                f = $61a884290963e577$var$Yc(a, b, c, d);
                null === f && $61a884290963e577$var$hd(a, b, d, $61a884290963e577$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $61a884290963e577$var$hd(a, b, d, null, c);
    }
}
var $61a884290963e577$var$id = null;
function $61a884290963e577$var$Yc(a, b, c, d) {
    $61a884290963e577$var$id = null;
    a = $61a884290963e577$var$xb(d);
    a = $61a884290963e577$var$Wc(a);
    if (null !== a) {
        if (b = $61a884290963e577$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $61a884290963e577$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $61a884290963e577$var$id = a;
    return null;
}
function $61a884290963e577$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($61a884290963e577$var$ec()){
                case $61a884290963e577$var$fc:
                    return 1;
                case $61a884290963e577$var$gc:
                    return 4;
                case $61a884290963e577$var$hc:
                case $61a884290963e577$var$ic:
                    return 16;
                case $61a884290963e577$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $61a884290963e577$var$kd = null, $61a884290963e577$var$ld = null, $61a884290963e577$var$md = null;
function $61a884290963e577$var$nd() {
    if ($61a884290963e577$var$md) return $61a884290963e577$var$md;
    var a, b = $61a884290963e577$var$ld, c = b.length, d, e = "value" in $61a884290963e577$var$kd ? $61a884290963e577$var$kd.value : $61a884290963e577$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $61a884290963e577$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $61a884290963e577$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $61a884290963e577$var$pd() {
    return !0;
}
function $61a884290963e577$var$qd() {
    return !1;
}
function $61a884290963e577$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $61a884290963e577$var$pd : $61a884290963e577$var$qd;
        this.isPropagationStopped = $61a884290963e577$var$qd;
        return this;
    }
    $61a884290963e577$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $61a884290963e577$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $61a884290963e577$var$pd);
        },
        persist: function() {},
        isPersistent: $61a884290963e577$var$pd
    });
    return b;
}
var $61a884290963e577$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $61a884290963e577$var$td = $61a884290963e577$var$rd($61a884290963e577$var$sd), $61a884290963e577$var$ud = $61a884290963e577$var$A({}, $61a884290963e577$var$sd, {
    view: 0,
    detail: 0
}), $61a884290963e577$var$vd = $61a884290963e577$var$rd($61a884290963e577$var$ud), $61a884290963e577$var$wd, $61a884290963e577$var$xd, $61a884290963e577$var$yd, $61a884290963e577$var$Ad = $61a884290963e577$var$A({}, $61a884290963e577$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $61a884290963e577$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $61a884290963e577$var$yd && ($61a884290963e577$var$yd && "mousemove" === a.type ? ($61a884290963e577$var$wd = a.screenX - $61a884290963e577$var$yd.screenX, $61a884290963e577$var$xd = a.screenY - $61a884290963e577$var$yd.screenY) : $61a884290963e577$var$xd = $61a884290963e577$var$wd = 0, $61a884290963e577$var$yd = a);
        return $61a884290963e577$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $61a884290963e577$var$xd;
    }
}), $61a884290963e577$var$Bd = $61a884290963e577$var$rd($61a884290963e577$var$Ad), $61a884290963e577$var$Cd = $61a884290963e577$var$A({}, $61a884290963e577$var$Ad, {
    dataTransfer: 0
}), $61a884290963e577$var$Dd = $61a884290963e577$var$rd($61a884290963e577$var$Cd), $61a884290963e577$var$Ed = $61a884290963e577$var$A({}, $61a884290963e577$var$ud, {
    relatedTarget: 0
}), $61a884290963e577$var$Fd = $61a884290963e577$var$rd($61a884290963e577$var$Ed), $61a884290963e577$var$Gd = $61a884290963e577$var$A({}, $61a884290963e577$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $61a884290963e577$var$Hd = $61a884290963e577$var$rd($61a884290963e577$var$Gd), $61a884290963e577$var$Id = $61a884290963e577$var$A({}, $61a884290963e577$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $61a884290963e577$var$Jd = $61a884290963e577$var$rd($61a884290963e577$var$Id), $61a884290963e577$var$Kd = $61a884290963e577$var$A({}, $61a884290963e577$var$sd, {
    data: 0
}), $61a884290963e577$var$Ld = $61a884290963e577$var$rd($61a884290963e577$var$Kd), $61a884290963e577$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $61a884290963e577$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $61a884290963e577$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $61a884290963e577$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $61a884290963e577$var$Od[a]) ? !!b[a] : !1;
}
function $61a884290963e577$var$zd() {
    return $61a884290963e577$var$Pd;
}
var $61a884290963e577$var$Qd = $61a884290963e577$var$A({}, $61a884290963e577$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $61a884290963e577$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $61a884290963e577$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $61a884290963e577$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $61a884290963e577$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $61a884290963e577$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $61a884290963e577$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $61a884290963e577$var$Rd = $61a884290963e577$var$rd($61a884290963e577$var$Qd), $61a884290963e577$var$Sd = $61a884290963e577$var$A({}, $61a884290963e577$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $61a884290963e577$var$Td = $61a884290963e577$var$rd($61a884290963e577$var$Sd), $61a884290963e577$var$Ud = $61a884290963e577$var$A({}, $61a884290963e577$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $61a884290963e577$var$zd
}), $61a884290963e577$var$Vd = $61a884290963e577$var$rd($61a884290963e577$var$Ud), $61a884290963e577$var$Wd = $61a884290963e577$var$A({}, $61a884290963e577$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $61a884290963e577$var$Xd = $61a884290963e577$var$rd($61a884290963e577$var$Wd), $61a884290963e577$var$Yd = $61a884290963e577$var$A({}, $61a884290963e577$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $61a884290963e577$var$Zd = $61a884290963e577$var$rd($61a884290963e577$var$Yd), $61a884290963e577$var$$d = [
    9,
    13,
    27,
    32
], $61a884290963e577$var$ae = $61a884290963e577$var$ia && "CompositionEvent" in window, $61a884290963e577$var$be = null;
$61a884290963e577$var$ia && "documentMode" in document && ($61a884290963e577$var$be = document.documentMode);
var $61a884290963e577$var$ce = $61a884290963e577$var$ia && "TextEvent" in window && !$61a884290963e577$var$be, $61a884290963e577$var$de = $61a884290963e577$var$ia && (!$61a884290963e577$var$ae || $61a884290963e577$var$be && 8 < $61a884290963e577$var$be && 11 >= $61a884290963e577$var$be), $61a884290963e577$var$ee = String.fromCharCode(32), $61a884290963e577$var$fe = !1;
function $61a884290963e577$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $61a884290963e577$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $61a884290963e577$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $61a884290963e577$var$ie = !1;
function $61a884290963e577$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $61a884290963e577$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $61a884290963e577$var$fe = !0;
            return $61a884290963e577$var$ee;
        case "textInput":
            return a = b.data, a === $61a884290963e577$var$ee && $61a884290963e577$var$fe ? null : a;
        default:
            return null;
    }
}
function $61a884290963e577$var$ke(a, b) {
    if ($61a884290963e577$var$ie) return "compositionend" === a || !$61a884290963e577$var$ae && $61a884290963e577$var$ge(a, b) ? (a = $61a884290963e577$var$nd(), $61a884290963e577$var$md = $61a884290963e577$var$ld = $61a884290963e577$var$kd = null, $61a884290963e577$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $61a884290963e577$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $61a884290963e577$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $61a884290963e577$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$61a884290963e577$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $61a884290963e577$var$ne(a, b, c, d) {
    $61a884290963e577$var$Eb(d);
    b = $61a884290963e577$var$oe(b, "onChange");
    0 < b.length && (c = new $61a884290963e577$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $61a884290963e577$var$pe = null, $61a884290963e577$var$qe = null;
function $61a884290963e577$var$re(a) {
    $61a884290963e577$var$se(a, 0);
}
function $61a884290963e577$var$te(a) {
    var b = $61a884290963e577$var$ue(a);
    if ($61a884290963e577$var$Wa(b)) return a;
}
function $61a884290963e577$var$ve(a, b) {
    if ("change" === a) return b;
}
var $61a884290963e577$var$we = !1;
if ($61a884290963e577$var$ia) {
    var $61a884290963e577$var$xe;
    if ($61a884290963e577$var$ia) {
        var $61a884290963e577$var$ye = "oninput" in document;
        if (!$61a884290963e577$var$ye) {
            var $61a884290963e577$var$ze = document.createElement("div");
            $61a884290963e577$var$ze.setAttribute("oninput", "return;");
            $61a884290963e577$var$ye = "function" === typeof $61a884290963e577$var$ze.oninput;
        }
        $61a884290963e577$var$xe = $61a884290963e577$var$ye;
    } else $61a884290963e577$var$xe = !1;
    $61a884290963e577$var$we = $61a884290963e577$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $61a884290963e577$var$Ae() {
    $61a884290963e577$var$pe && ($61a884290963e577$var$pe.detachEvent("onpropertychange", $61a884290963e577$var$Be), $61a884290963e577$var$qe = $61a884290963e577$var$pe = null);
}
function $61a884290963e577$var$Be(a) {
    if ("value" === a.propertyName && $61a884290963e577$var$te($61a884290963e577$var$qe)) {
        var b = [];
        $61a884290963e577$var$ne(b, $61a884290963e577$var$qe, a, $61a884290963e577$var$xb(a));
        $61a884290963e577$var$Jb($61a884290963e577$var$re, b);
    }
}
function $61a884290963e577$var$Ce(a, b, c) {
    "focusin" === a ? ($61a884290963e577$var$Ae(), $61a884290963e577$var$pe = b, $61a884290963e577$var$qe = c, $61a884290963e577$var$pe.attachEvent("onpropertychange", $61a884290963e577$var$Be)) : "focusout" === a && $61a884290963e577$var$Ae();
}
function $61a884290963e577$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $61a884290963e577$var$te($61a884290963e577$var$qe);
}
function $61a884290963e577$var$Ee(a, b) {
    if ("click" === a) return $61a884290963e577$var$te(b);
}
function $61a884290963e577$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $61a884290963e577$var$te(b);
}
function $61a884290963e577$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $61a884290963e577$var$He = "function" === typeof Object.is ? Object.is : $61a884290963e577$var$Ge;
function $61a884290963e577$var$Ie(a, b) {
    if ($61a884290963e577$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$61a884290963e577$var$ja.call(b, e) || !$61a884290963e577$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $61a884290963e577$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $61a884290963e577$var$Ke(a, b) {
    var c = $61a884290963e577$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $61a884290963e577$var$Je(c);
    }
}
function $61a884290963e577$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $61a884290963e577$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $61a884290963e577$var$Me() {
    for(var a = window, b = $61a884290963e577$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $61a884290963e577$var$Xa(a.document);
    }
    return b;
}
function $61a884290963e577$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $61a884290963e577$var$Oe(a) {
    var b = $61a884290963e577$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $61a884290963e577$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $61a884290963e577$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $61a884290963e577$var$Ke(c, f);
                var g = $61a884290963e577$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $61a884290963e577$var$Pe = $61a884290963e577$var$ia && "documentMode" in document && 11 >= document.documentMode, $61a884290963e577$var$Qe = null, $61a884290963e577$var$Re = null, $61a884290963e577$var$Se = null, $61a884290963e577$var$Te = !1;
function $61a884290963e577$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $61a884290963e577$var$Te || null == $61a884290963e577$var$Qe || $61a884290963e577$var$Qe !== $61a884290963e577$var$Xa(d) || (d = $61a884290963e577$var$Qe, "selectionStart" in d && $61a884290963e577$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $61a884290963e577$var$Se && $61a884290963e577$var$Ie($61a884290963e577$var$Se, d) || ($61a884290963e577$var$Se = d, d = $61a884290963e577$var$oe($61a884290963e577$var$Re, "onSelect"), 0 < d.length && (b = new $61a884290963e577$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $61a884290963e577$var$Qe)));
}
function $61a884290963e577$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $61a884290963e577$var$We = {
    animationend: $61a884290963e577$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $61a884290963e577$var$Ve("Animation", "AnimationIteration"),
    animationstart: $61a884290963e577$var$Ve("Animation", "AnimationStart"),
    transitionend: $61a884290963e577$var$Ve("Transition", "TransitionEnd")
}, $61a884290963e577$var$Xe = {}, $61a884290963e577$var$Ye = {};
$61a884290963e577$var$ia && ($61a884290963e577$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $61a884290963e577$var$We.animationend.animation, delete $61a884290963e577$var$We.animationiteration.animation, delete $61a884290963e577$var$We.animationstart.animation), "TransitionEvent" in window || delete $61a884290963e577$var$We.transitionend.transition);
function $61a884290963e577$var$Ze(a) {
    if ($61a884290963e577$var$Xe[a]) return $61a884290963e577$var$Xe[a];
    if (!$61a884290963e577$var$We[a]) return a;
    var b = $61a884290963e577$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $61a884290963e577$var$Ye) return $61a884290963e577$var$Xe[a] = b[c];
    return a;
}
var $61a884290963e577$var$$e = $61a884290963e577$var$Ze("animationend"), $61a884290963e577$var$af = $61a884290963e577$var$Ze("animationiteration"), $61a884290963e577$var$bf = $61a884290963e577$var$Ze("animationstart"), $61a884290963e577$var$cf = $61a884290963e577$var$Ze("transitionend"), $61a884290963e577$var$df = new Map, $61a884290963e577$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $61a884290963e577$var$ff(a, b) {
    $61a884290963e577$var$df.set(a, b);
    $61a884290963e577$var$fa(b, [
        a
    ]);
}
for(var $61a884290963e577$var$gf = 0; $61a884290963e577$var$gf < $61a884290963e577$var$ef.length; $61a884290963e577$var$gf++){
    var $61a884290963e577$var$hf = $61a884290963e577$var$ef[$61a884290963e577$var$gf], $61a884290963e577$var$jf = $61a884290963e577$var$hf.toLowerCase(), $61a884290963e577$var$kf = $61a884290963e577$var$hf[0].toUpperCase() + $61a884290963e577$var$hf.slice(1);
    $61a884290963e577$var$ff($61a884290963e577$var$jf, "on" + $61a884290963e577$var$kf);
}
$61a884290963e577$var$ff($61a884290963e577$var$$e, "onAnimationEnd");
$61a884290963e577$var$ff($61a884290963e577$var$af, "onAnimationIteration");
$61a884290963e577$var$ff($61a884290963e577$var$bf, "onAnimationStart");
$61a884290963e577$var$ff("dblclick", "onDoubleClick");
$61a884290963e577$var$ff("focusin", "onFocus");
$61a884290963e577$var$ff("focusout", "onBlur");
$61a884290963e577$var$ff($61a884290963e577$var$cf, "onTransitionEnd");
$61a884290963e577$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$61a884290963e577$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$61a884290963e577$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$61a884290963e577$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$61a884290963e577$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$61a884290963e577$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$61a884290963e577$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$61a884290963e577$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$61a884290963e577$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$61a884290963e577$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $61a884290963e577$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $61a884290963e577$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($61a884290963e577$var$lf));
function $61a884290963e577$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $61a884290963e577$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $61a884290963e577$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $61a884290963e577$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $61a884290963e577$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($61a884290963e577$var$Qb) throw a = $61a884290963e577$var$Rb, $61a884290963e577$var$Qb = !1, $61a884290963e577$var$Rb = null, a;
}
function $61a884290963e577$var$D(a, b) {
    var c = b[$61a884290963e577$var$of];
    void 0 === c && (c = b[$61a884290963e577$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($61a884290963e577$var$pf(b, a, 2, !1), c.add(d));
}
function $61a884290963e577$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $61a884290963e577$var$pf(c, a, d, b);
}
var $61a884290963e577$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $61a884290963e577$var$sf(a) {
    if (!a[$61a884290963e577$var$rf]) {
        a[$61a884290963e577$var$rf] = !0;
        $61a884290963e577$var$da.forEach(function(b) {
            "selectionchange" !== b && ($61a884290963e577$var$mf.has(b) || $61a884290963e577$var$qf(b, !1, a), $61a884290963e577$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$61a884290963e577$var$rf] || (b[$61a884290963e577$var$rf] = !0, $61a884290963e577$var$qf("selectionchange", !1, b));
    }
}
function $61a884290963e577$var$pf(a, b, c, d) {
    switch($61a884290963e577$var$jd(b)){
        case 1:
            var e = $61a884290963e577$var$ed;
            break;
        case 4:
            e = $61a884290963e577$var$gd;
            break;
        default:
            e = $61a884290963e577$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$61a884290963e577$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $61a884290963e577$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $61a884290963e577$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $61a884290963e577$var$Jb(function() {
        var d = f, e = $61a884290963e577$var$xb(c), g = [];
        a: {
            var h = $61a884290963e577$var$df.get(a);
            if (void 0 !== h) {
                var k = $61a884290963e577$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $61a884290963e577$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $61a884290963e577$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $61a884290963e577$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $61a884290963e577$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $61a884290963e577$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $61a884290963e577$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $61a884290963e577$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $61a884290963e577$var$Vd;
                        break;
                    case $61a884290963e577$var$$e:
                    case $61a884290963e577$var$af:
                    case $61a884290963e577$var$bf:
                        k = $61a884290963e577$var$Hd;
                        break;
                    case $61a884290963e577$var$cf:
                        k = $61a884290963e577$var$Xd;
                        break;
                    case "scroll":
                        k = $61a884290963e577$var$vd;
                        break;
                    case "wheel":
                        k = $61a884290963e577$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $61a884290963e577$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $61a884290963e577$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $61a884290963e577$var$Kb(w, x), null != F && t.push($61a884290963e577$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $61a884290963e577$var$wb && (n = c.relatedTarget || c.fromElement) && ($61a884290963e577$var$Wc(n) || n[$61a884290963e577$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $61a884290963e577$var$Wc(n) : null, null !== n && (J = $61a884290963e577$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $61a884290963e577$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $61a884290963e577$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $61a884290963e577$var$ue(k);
                        u = null == n ? h : $61a884290963e577$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $61a884290963e577$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $61a884290963e577$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $61a884290963e577$var$vf(F))u++;
                            for(; 0 < w - u;)t = $61a884290963e577$var$vf(t), w--;
                            for(; 0 < u - w;)x = $61a884290963e577$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $61a884290963e577$var$vf(t);
                                x = $61a884290963e577$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $61a884290963e577$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $61a884290963e577$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $61a884290963e577$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $61a884290963e577$var$ve;
                else if ($61a884290963e577$var$me(h)) {
                    if ($61a884290963e577$var$we) na = $61a884290963e577$var$Fe;
                    else {
                        na = $61a884290963e577$var$De;
                        var xa = $61a884290963e577$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $61a884290963e577$var$Ee);
                if (na && (na = na(a, d))) {
                    $61a884290963e577$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $61a884290963e577$var$cb(h, "number", h.value);
            }
            xa = d ? $61a884290963e577$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($61a884290963e577$var$me(xa) || "true" === xa.contentEditable) $61a884290963e577$var$Qe = xa, $61a884290963e577$var$Re = d, $61a884290963e577$var$Se = null;
                    break;
                case "focusout":
                    $61a884290963e577$var$Se = $61a884290963e577$var$Re = $61a884290963e577$var$Qe = null;
                    break;
                case "mousedown":
                    $61a884290963e577$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $61a884290963e577$var$Te = !1;
                    $61a884290963e577$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($61a884290963e577$var$Pe) break;
                case "keydown":
                case "keyup":
                    $61a884290963e577$var$Ue(g, c, e);
            }
            var $a;
            if ($61a884290963e577$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $61a884290963e577$var$ie ? $61a884290963e577$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($61a884290963e577$var$de && "ko" !== c.locale && ($61a884290963e577$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $61a884290963e577$var$ie && ($a = $61a884290963e577$var$nd()) : ($61a884290963e577$var$kd = e, $61a884290963e577$var$ld = "value" in $61a884290963e577$var$kd ? $61a884290963e577$var$kd.value : $61a884290963e577$var$kd.textContent, $61a884290963e577$var$ie = !0)), xa = $61a884290963e577$var$oe(d, ba), 0 < xa.length && (ba = new $61a884290963e577$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $61a884290963e577$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $61a884290963e577$var$ce ? $61a884290963e577$var$je(a, c) : $61a884290963e577$var$ke(a, c)) d = $61a884290963e577$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $61a884290963e577$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $61a884290963e577$var$se(g, b);
    });
}
function $61a884290963e577$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $61a884290963e577$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $61a884290963e577$var$Kb(a, c), null != f && d.unshift($61a884290963e577$var$tf(a, f, e)), f = $61a884290963e577$var$Kb(a, b), null != f && d.push($61a884290963e577$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $61a884290963e577$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $61a884290963e577$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $61a884290963e577$var$Kb(c, f), null != k && g.unshift($61a884290963e577$var$tf(c, k, h))) : e || (k = $61a884290963e577$var$Kb(c, f), null != k && g.push($61a884290963e577$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $61a884290963e577$var$xf = /\r\n?/g, $61a884290963e577$var$yf = /\u0000|\uFFFD/g;
function $61a884290963e577$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($61a884290963e577$var$xf, "\n").replace($61a884290963e577$var$yf, "");
}
function $61a884290963e577$var$Af(a, b, c) {
    b = $61a884290963e577$var$zf(b);
    if ($61a884290963e577$var$zf(a) !== b && c) throw Error($61a884290963e577$var$p(425));
}
function $61a884290963e577$var$Bf() {}
var $61a884290963e577$var$Cf = null, $61a884290963e577$var$Df = null;
function $61a884290963e577$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $61a884290963e577$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $61a884290963e577$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $61a884290963e577$var$Hf = "function" === typeof Promise ? Promise : void 0, $61a884290963e577$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $61a884290963e577$var$Hf ? function(a) {
    return $61a884290963e577$var$Hf.resolve(null).then(a).catch($61a884290963e577$var$If);
} : $61a884290963e577$var$Ff;
function $61a884290963e577$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $61a884290963e577$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $61a884290963e577$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $61a884290963e577$var$bd(b);
}
function $61a884290963e577$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $61a884290963e577$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $61a884290963e577$var$Nf = Math.random().toString(36).slice(2), $61a884290963e577$var$Of = "__reactFiber$" + $61a884290963e577$var$Nf, $61a884290963e577$var$Pf = "__reactProps$" + $61a884290963e577$var$Nf, $61a884290963e577$var$uf = "__reactContainer$" + $61a884290963e577$var$Nf, $61a884290963e577$var$of = "__reactEvents$" + $61a884290963e577$var$Nf, $61a884290963e577$var$Qf = "__reactListeners$" + $61a884290963e577$var$Nf, $61a884290963e577$var$Rf = "__reactHandles$" + $61a884290963e577$var$Nf;
function $61a884290963e577$var$Wc(a) {
    var b = a[$61a884290963e577$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$61a884290963e577$var$uf] || c[$61a884290963e577$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $61a884290963e577$var$Mf(a); null !== a;){
                if (c = a[$61a884290963e577$var$Of]) return c;
                a = $61a884290963e577$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $61a884290963e577$var$Cb(a) {
    a = a[$61a884290963e577$var$Of] || a[$61a884290963e577$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $61a884290963e577$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($61a884290963e577$var$p(33));
}
function $61a884290963e577$var$Db(a) {
    return a[$61a884290963e577$var$Pf] || null;
}
var $61a884290963e577$var$Sf = [], $61a884290963e577$var$Tf = -1;
function $61a884290963e577$var$Uf(a) {
    return {
        current: a
    };
}
function $61a884290963e577$var$E(a) {
    0 > $61a884290963e577$var$Tf || (a.current = $61a884290963e577$var$Sf[$61a884290963e577$var$Tf], $61a884290963e577$var$Sf[$61a884290963e577$var$Tf] = null, $61a884290963e577$var$Tf--);
}
function $61a884290963e577$var$G(a, b) {
    $61a884290963e577$var$Tf++;
    $61a884290963e577$var$Sf[$61a884290963e577$var$Tf] = a.current;
    a.current = b;
}
var $61a884290963e577$var$Vf = {}, $61a884290963e577$var$H = $61a884290963e577$var$Uf($61a884290963e577$var$Vf), $61a884290963e577$var$Wf = $61a884290963e577$var$Uf(!1), $61a884290963e577$var$Xf = $61a884290963e577$var$Vf;
function $61a884290963e577$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $61a884290963e577$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $61a884290963e577$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $61a884290963e577$var$$f() {
    $61a884290963e577$var$E($61a884290963e577$var$Wf);
    $61a884290963e577$var$E($61a884290963e577$var$H);
}
function $61a884290963e577$var$ag(a, b, c) {
    if ($61a884290963e577$var$H.current !== $61a884290963e577$var$Vf) throw Error($61a884290963e577$var$p(168));
    $61a884290963e577$var$G($61a884290963e577$var$H, b);
    $61a884290963e577$var$G($61a884290963e577$var$Wf, c);
}
function $61a884290963e577$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($61a884290963e577$var$p(108, $61a884290963e577$var$Ra(a) || "Unknown", e));
    return $61a884290963e577$var$A({}, c, d);
}
function $61a884290963e577$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $61a884290963e577$var$Vf;
    $61a884290963e577$var$Xf = $61a884290963e577$var$H.current;
    $61a884290963e577$var$G($61a884290963e577$var$H, a);
    $61a884290963e577$var$G($61a884290963e577$var$Wf, $61a884290963e577$var$Wf.current);
    return !0;
}
function $61a884290963e577$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($61a884290963e577$var$p(169));
    c ? (a = $61a884290963e577$var$bg(a, b, $61a884290963e577$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $61a884290963e577$var$E($61a884290963e577$var$Wf), $61a884290963e577$var$E($61a884290963e577$var$H), $61a884290963e577$var$G($61a884290963e577$var$H, a)) : $61a884290963e577$var$E($61a884290963e577$var$Wf);
    $61a884290963e577$var$G($61a884290963e577$var$Wf, c);
}
var $61a884290963e577$var$eg = null, $61a884290963e577$var$fg = !1, $61a884290963e577$var$gg = !1;
function $61a884290963e577$var$hg(a) {
    null === $61a884290963e577$var$eg ? $61a884290963e577$var$eg = [
        a
    ] : $61a884290963e577$var$eg.push(a);
}
function $61a884290963e577$var$ig(a) {
    $61a884290963e577$var$fg = !0;
    $61a884290963e577$var$hg(a);
}
function $61a884290963e577$var$jg() {
    if (!$61a884290963e577$var$gg && null !== $61a884290963e577$var$eg) {
        $61a884290963e577$var$gg = !0;
        var a = 0, b = $61a884290963e577$var$C;
        try {
            var c = $61a884290963e577$var$eg;
            for($61a884290963e577$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $61a884290963e577$var$eg = null;
            $61a884290963e577$var$fg = !1;
        } catch (e) {
            throw null !== $61a884290963e577$var$eg && ($61a884290963e577$var$eg = $61a884290963e577$var$eg.slice(a + 1)), $61a884290963e577$var$ac($61a884290963e577$var$fc, $61a884290963e577$var$jg), e;
        } finally{
            $61a884290963e577$var$C = b, $61a884290963e577$var$gg = !1;
        }
    }
    return null;
}
var $61a884290963e577$var$kg = [], $61a884290963e577$var$lg = 0, $61a884290963e577$var$mg = null, $61a884290963e577$var$ng = 0, $61a884290963e577$var$og = [], $61a884290963e577$var$pg = 0, $61a884290963e577$var$qg = null, $61a884290963e577$var$rg = 1, $61a884290963e577$var$sg = "";
function $61a884290963e577$var$tg(a, b) {
    $61a884290963e577$var$kg[$61a884290963e577$var$lg++] = $61a884290963e577$var$ng;
    $61a884290963e577$var$kg[$61a884290963e577$var$lg++] = $61a884290963e577$var$mg;
    $61a884290963e577$var$mg = a;
    $61a884290963e577$var$ng = b;
}
function $61a884290963e577$var$ug(a, b, c) {
    $61a884290963e577$var$og[$61a884290963e577$var$pg++] = $61a884290963e577$var$rg;
    $61a884290963e577$var$og[$61a884290963e577$var$pg++] = $61a884290963e577$var$sg;
    $61a884290963e577$var$og[$61a884290963e577$var$pg++] = $61a884290963e577$var$qg;
    $61a884290963e577$var$qg = a;
    var d = $61a884290963e577$var$rg;
    a = $61a884290963e577$var$sg;
    var e = 32 - $61a884290963e577$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $61a884290963e577$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $61a884290963e577$var$rg = 1 << 32 - $61a884290963e577$var$oc(b) + e | c << e | d;
        $61a884290963e577$var$sg = f + a;
    } else $61a884290963e577$var$rg = 1 << f | c << e | d, $61a884290963e577$var$sg = a;
}
function $61a884290963e577$var$vg(a) {
    null !== a.return && ($61a884290963e577$var$tg(a, 1), $61a884290963e577$var$ug(a, 1, 0));
}
function $61a884290963e577$var$wg(a) {
    for(; a === $61a884290963e577$var$mg;)$61a884290963e577$var$mg = $61a884290963e577$var$kg[--$61a884290963e577$var$lg], $61a884290963e577$var$kg[$61a884290963e577$var$lg] = null, $61a884290963e577$var$ng = $61a884290963e577$var$kg[--$61a884290963e577$var$lg], $61a884290963e577$var$kg[$61a884290963e577$var$lg] = null;
    for(; a === $61a884290963e577$var$qg;)$61a884290963e577$var$qg = $61a884290963e577$var$og[--$61a884290963e577$var$pg], $61a884290963e577$var$og[$61a884290963e577$var$pg] = null, $61a884290963e577$var$sg = $61a884290963e577$var$og[--$61a884290963e577$var$pg], $61a884290963e577$var$og[$61a884290963e577$var$pg] = null, $61a884290963e577$var$rg = $61a884290963e577$var$og[--$61a884290963e577$var$pg], $61a884290963e577$var$og[$61a884290963e577$var$pg] = null;
}
var $61a884290963e577$var$xg = null, $61a884290963e577$var$yg = null, $61a884290963e577$var$I = !1, $61a884290963e577$var$zg = null;
function $61a884290963e577$var$Ag(a, b) {
    var c = $61a884290963e577$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $61a884290963e577$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $61a884290963e577$var$xg = a, $61a884290963e577$var$yg = $61a884290963e577$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $61a884290963e577$var$xg = a, $61a884290963e577$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $61a884290963e577$var$qg ? {
                id: $61a884290963e577$var$rg,
                overflow: $61a884290963e577$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $61a884290963e577$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $61a884290963e577$var$xg = a, $61a884290963e577$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $61a884290963e577$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $61a884290963e577$var$Eg(a) {
    if ($61a884290963e577$var$I) {
        var b = $61a884290963e577$var$yg;
        if (b) {
            var c = b;
            if (!$61a884290963e577$var$Cg(a, b)) {
                if ($61a884290963e577$var$Dg(a)) throw Error($61a884290963e577$var$p(418));
                b = $61a884290963e577$var$Lf(c.nextSibling);
                var d = $61a884290963e577$var$xg;
                b && $61a884290963e577$var$Cg(a, b) ? $61a884290963e577$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $61a884290963e577$var$I = !1, $61a884290963e577$var$xg = a);
            }
        } else {
            if ($61a884290963e577$var$Dg(a)) throw Error($61a884290963e577$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $61a884290963e577$var$I = !1;
            $61a884290963e577$var$xg = a;
        }
    }
}
function $61a884290963e577$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $61a884290963e577$var$xg = a;
}
function $61a884290963e577$var$Gg(a) {
    if (a !== $61a884290963e577$var$xg) return !1;
    if (!$61a884290963e577$var$I) return $61a884290963e577$var$Fg(a), $61a884290963e577$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$61a884290963e577$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $61a884290963e577$var$yg)) {
        if ($61a884290963e577$var$Dg(a)) throw $61a884290963e577$var$Hg(), Error($61a884290963e577$var$p(418));
        for(; b;)$61a884290963e577$var$Ag(a, b), b = $61a884290963e577$var$Lf(b.nextSibling);
    }
    $61a884290963e577$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($61a884290963e577$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $61a884290963e577$var$yg = $61a884290963e577$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $61a884290963e577$var$yg = null;
        }
    } else $61a884290963e577$var$yg = $61a884290963e577$var$xg ? $61a884290963e577$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $61a884290963e577$var$Hg() {
    for(var a = $61a884290963e577$var$yg; a;)a = $61a884290963e577$var$Lf(a.nextSibling);
}
function $61a884290963e577$var$Ig() {
    $61a884290963e577$var$yg = $61a884290963e577$var$xg = null;
    $61a884290963e577$var$I = !1;
}
function $61a884290963e577$var$Jg(a) {
    null === $61a884290963e577$var$zg ? $61a884290963e577$var$zg = [
        a
    ] : $61a884290963e577$var$zg.push(a);
}
var $61a884290963e577$var$Kg = $61a884290963e577$var$ua.ReactCurrentBatchConfig;
function $61a884290963e577$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($61a884290963e577$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($61a884290963e577$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($61a884290963e577$var$p(284));
        if (!c._owner) throw Error($61a884290963e577$var$p(290, a));
    }
    return a;
}
function $61a884290963e577$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($61a884290963e577$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $61a884290963e577$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $61a884290963e577$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $61a884290963e577$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $61a884290963e577$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $61a884290963e577$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $61a884290963e577$var$Ha && $61a884290963e577$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $61a884290963e577$var$Lg(a, b, c), d.return = a, d;
        d = $61a884290963e577$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $61a884290963e577$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $61a884290963e577$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $61a884290963e577$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $61a884290963e577$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $61a884290963e577$var$va:
                    return c = $61a884290963e577$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $61a884290963e577$var$Lg(a, null, b), c.return = a, c;
                case $61a884290963e577$var$wa:
                    return b = $61a884290963e577$var$Sg(b, a.mode, c), b.return = a, b;
                case $61a884290963e577$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($61a884290963e577$var$eb(b) || $61a884290963e577$var$Ka(b)) return b = $61a884290963e577$var$Tg(b, a.mode, c, null), b.return = a, b;
            $61a884290963e577$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $61a884290963e577$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $61a884290963e577$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $61a884290963e577$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($61a884290963e577$var$eb(c) || $61a884290963e577$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $61a884290963e577$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $61a884290963e577$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $61a884290963e577$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $61a884290963e577$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($61a884290963e577$var$eb(d) || $61a884290963e577$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $61a884290963e577$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $61a884290963e577$var$I && $61a884290963e577$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $61a884290963e577$var$I && $61a884290963e577$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $61a884290963e577$var$I && $61a884290963e577$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $61a884290963e577$var$Ka(h);
        if ("function" !== typeof l) throw Error($61a884290963e577$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($61a884290963e577$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $61a884290963e577$var$I && $61a884290963e577$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $61a884290963e577$var$I && $61a884290963e577$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $61a884290963e577$var$I && $61a884290963e577$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $61a884290963e577$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $61a884290963e577$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $61a884290963e577$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $61a884290963e577$var$Ha && $61a884290963e577$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $61a884290963e577$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $61a884290963e577$var$ya ? (d = $61a884290963e577$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $61a884290963e577$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $61a884290963e577$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $61a884290963e577$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $61a884290963e577$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $61a884290963e577$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($61a884290963e577$var$eb(f)) return n(a, d, f, h);
            if ($61a884290963e577$var$Ka(f)) return t(a, d, f, h);
            $61a884290963e577$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $61a884290963e577$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $61a884290963e577$var$Ug = $61a884290963e577$var$Og(!0), $61a884290963e577$var$Vg = $61a884290963e577$var$Og(!1), $61a884290963e577$var$Wg = $61a884290963e577$var$Uf(null), $61a884290963e577$var$Xg = null, $61a884290963e577$var$Yg = null, $61a884290963e577$var$Zg = null;
function $61a884290963e577$var$$g() {
    $61a884290963e577$var$Zg = $61a884290963e577$var$Yg = $61a884290963e577$var$Xg = null;
}
function $61a884290963e577$var$ah(a) {
    var b = $61a884290963e577$var$Wg.current;
    $61a884290963e577$var$E($61a884290963e577$var$Wg);
    a._currentValue = b;
}
function $61a884290963e577$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $61a884290963e577$var$ch(a, b) {
    $61a884290963e577$var$Xg = a;
    $61a884290963e577$var$Zg = $61a884290963e577$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($61a884290963e577$var$dh = !0), a.firstContext = null);
}
function $61a884290963e577$var$eh(a) {
    var b = a._currentValue;
    if ($61a884290963e577$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $61a884290963e577$var$Yg) {
            if (null === $61a884290963e577$var$Xg) throw Error($61a884290963e577$var$p(308));
            $61a884290963e577$var$Yg = a;
            $61a884290963e577$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $61a884290963e577$var$Yg = $61a884290963e577$var$Yg.next = a;
    }
    return b;
}
var $61a884290963e577$var$fh = null;
function $61a884290963e577$var$gh(a) {
    null === $61a884290963e577$var$fh ? $61a884290963e577$var$fh = [
        a
    ] : $61a884290963e577$var$fh.push(a);
}
function $61a884290963e577$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $61a884290963e577$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $61a884290963e577$var$ih(a, d);
}
function $61a884290963e577$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $61a884290963e577$var$jh = !1;
function $61a884290963e577$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $61a884290963e577$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $61a884290963e577$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $61a884290963e577$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($61a884290963e577$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $61a884290963e577$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $61a884290963e577$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $61a884290963e577$var$ih(a, c);
}
function $61a884290963e577$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $61a884290963e577$var$Cc(a, c);
    }
}
function $61a884290963e577$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $61a884290963e577$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $61a884290963e577$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $61a884290963e577$var$A({}, q, r);
                            break a;
                        case 2:
                            $61a884290963e577$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $61a884290963e577$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $61a884290963e577$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($61a884290963e577$var$p(191, e));
            e.call(d);
        }
    }
}
var $61a884290963e577$var$th = {}, $61a884290963e577$var$uh = $61a884290963e577$var$Uf($61a884290963e577$var$th), $61a884290963e577$var$vh = $61a884290963e577$var$Uf($61a884290963e577$var$th), $61a884290963e577$var$wh = $61a884290963e577$var$Uf($61a884290963e577$var$th);
function $61a884290963e577$var$xh(a) {
    if (a === $61a884290963e577$var$th) throw Error($61a884290963e577$var$p(174));
    return a;
}
function $61a884290963e577$var$yh(a, b) {
    $61a884290963e577$var$G($61a884290963e577$var$wh, b);
    $61a884290963e577$var$G($61a884290963e577$var$vh, a);
    $61a884290963e577$var$G($61a884290963e577$var$uh, $61a884290963e577$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $61a884290963e577$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $61a884290963e577$var$lb(b, a);
    }
    $61a884290963e577$var$E($61a884290963e577$var$uh);
    $61a884290963e577$var$G($61a884290963e577$var$uh, b);
}
function $61a884290963e577$var$zh() {
    $61a884290963e577$var$E($61a884290963e577$var$uh);
    $61a884290963e577$var$E($61a884290963e577$var$vh);
    $61a884290963e577$var$E($61a884290963e577$var$wh);
}
function $61a884290963e577$var$Ah(a) {
    $61a884290963e577$var$xh($61a884290963e577$var$wh.current);
    var b = $61a884290963e577$var$xh($61a884290963e577$var$uh.current);
    var c = $61a884290963e577$var$lb(b, a.type);
    b !== c && ($61a884290963e577$var$G($61a884290963e577$var$vh, a), $61a884290963e577$var$G($61a884290963e577$var$uh, c));
}
function $61a884290963e577$var$Bh(a) {
    $61a884290963e577$var$vh.current === a && ($61a884290963e577$var$E($61a884290963e577$var$uh), $61a884290963e577$var$E($61a884290963e577$var$vh));
}
var $61a884290963e577$var$L = $61a884290963e577$var$Uf(0);
function $61a884290963e577$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $61a884290963e577$var$Dh = [];
function $61a884290963e577$var$Eh() {
    for(var a = 0; a < $61a884290963e577$var$Dh.length; a++)$61a884290963e577$var$Dh[a]._workInProgressVersionPrimary = null;
    $61a884290963e577$var$Dh.length = 0;
}
var $61a884290963e577$var$Fh = $61a884290963e577$var$ua.ReactCurrentDispatcher, $61a884290963e577$var$Gh = $61a884290963e577$var$ua.ReactCurrentBatchConfig, $61a884290963e577$var$Hh = 0, $61a884290963e577$var$M = null, $61a884290963e577$var$N = null, $61a884290963e577$var$O = null, $61a884290963e577$var$Ih = !1, $61a884290963e577$var$Jh = !1, $61a884290963e577$var$Kh = 0, $61a884290963e577$var$Lh = 0;
function $61a884290963e577$var$P() {
    throw Error($61a884290963e577$var$p(321));
}
function $61a884290963e577$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$61a884290963e577$var$He(a[c], b[c])) return !1;
    return !0;
}
function $61a884290963e577$var$Nh(a, b, c, d, e, f) {
    $61a884290963e577$var$Hh = f;
    $61a884290963e577$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $61a884290963e577$var$Fh.current = null === a || null === a.memoizedState ? $61a884290963e577$var$Oh : $61a884290963e577$var$Ph;
    a = c(d, e);
    if ($61a884290963e577$var$Jh) {
        f = 0;
        do {
            $61a884290963e577$var$Jh = !1;
            $61a884290963e577$var$Kh = 0;
            if (25 <= f) throw Error($61a884290963e577$var$p(301));
            f += 1;
            $61a884290963e577$var$O = $61a884290963e577$var$N = null;
            b.updateQueue = null;
            $61a884290963e577$var$Fh.current = $61a884290963e577$var$Qh;
            a = c(d, e);
        }while ($61a884290963e577$var$Jh);
    }
    $61a884290963e577$var$Fh.current = $61a884290963e577$var$Rh;
    b = null !== $61a884290963e577$var$N && null !== $61a884290963e577$var$N.next;
    $61a884290963e577$var$Hh = 0;
    $61a884290963e577$var$O = $61a884290963e577$var$N = $61a884290963e577$var$M = null;
    $61a884290963e577$var$Ih = !1;
    if (b) throw Error($61a884290963e577$var$p(300));
    return a;
}
function $61a884290963e577$var$Sh() {
    var a = 0 !== $61a884290963e577$var$Kh;
    $61a884290963e577$var$Kh = 0;
    return a;
}
function $61a884290963e577$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $61a884290963e577$var$O ? $61a884290963e577$var$M.memoizedState = $61a884290963e577$var$O = a : $61a884290963e577$var$O = $61a884290963e577$var$O.next = a;
    return $61a884290963e577$var$O;
}
function $61a884290963e577$var$Uh() {
    if (null === $61a884290963e577$var$N) {
        var a = $61a884290963e577$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $61a884290963e577$var$N.next;
    var b = null === $61a884290963e577$var$O ? $61a884290963e577$var$M.memoizedState : $61a884290963e577$var$O.next;
    if (null !== b) $61a884290963e577$var$O = b, $61a884290963e577$var$N = a;
    else {
        if (null === a) throw Error($61a884290963e577$var$p(310));
        $61a884290963e577$var$N = a;
        a = {
            memoizedState: $61a884290963e577$var$N.memoizedState,
            baseState: $61a884290963e577$var$N.baseState,
            baseQueue: $61a884290963e577$var$N.baseQueue,
            queue: $61a884290963e577$var$N.queue,
            next: null
        };
        null === $61a884290963e577$var$O ? $61a884290963e577$var$M.memoizedState = $61a884290963e577$var$O = a : $61a884290963e577$var$O = $61a884290963e577$var$O.next = a;
    }
    return $61a884290963e577$var$O;
}
function $61a884290963e577$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $61a884290963e577$var$Wh(a) {
    var b = $61a884290963e577$var$Uh(), c = b.queue;
    if (null === c) throw Error($61a884290963e577$var$p(311));
    c.lastRenderedReducer = a;
    var d = $61a884290963e577$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($61a884290963e577$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $61a884290963e577$var$M.lanes |= m;
                $61a884290963e577$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $61a884290963e577$var$He(d, b.memoizedState) || ($61a884290963e577$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $61a884290963e577$var$M.lanes |= f, $61a884290963e577$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $61a884290963e577$var$Xh(a) {
    var b = $61a884290963e577$var$Uh(), c = b.queue;
    if (null === c) throw Error($61a884290963e577$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $61a884290963e577$var$He(f, b.memoizedState) || ($61a884290963e577$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $61a884290963e577$var$Yh() {}
function $61a884290963e577$var$Zh(a, b) {
    var c = $61a884290963e577$var$M, d = $61a884290963e577$var$Uh(), e = b(), f = !$61a884290963e577$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $61a884290963e577$var$dh = !0);
    d = d.queue;
    $61a884290963e577$var$$h($61a884290963e577$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $61a884290963e577$var$O && $61a884290963e577$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $61a884290963e577$var$bi(9, $61a884290963e577$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $61a884290963e577$var$Q) throw Error($61a884290963e577$var$p(349));
        0 !== ($61a884290963e577$var$Hh & 30) || $61a884290963e577$var$di(c, b, e);
    }
    return e;
}
function $61a884290963e577$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $61a884290963e577$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $61a884290963e577$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $61a884290963e577$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $61a884290963e577$var$ei(b) && $61a884290963e577$var$fi(a);
}
function $61a884290963e577$var$ai(a, b, c) {
    return c(function() {
        $61a884290963e577$var$ei(b) && $61a884290963e577$var$fi(a);
    });
}
function $61a884290963e577$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$61a884290963e577$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $61a884290963e577$var$fi(a) {
    var b = $61a884290963e577$var$ih(a, 1);
    null !== b && $61a884290963e577$var$gi(b, a, 1, -1);
}
function $61a884290963e577$var$hi(a) {
    var b = $61a884290963e577$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $61a884290963e577$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $61a884290963e577$var$ii.bind(null, $61a884290963e577$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $61a884290963e577$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $61a884290963e577$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $61a884290963e577$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $61a884290963e577$var$ji() {
    return $61a884290963e577$var$Uh().memoizedState;
}
function $61a884290963e577$var$ki(a, b, c, d) {
    var e = $61a884290963e577$var$Th();
    $61a884290963e577$var$M.flags |= a;
    e.memoizedState = $61a884290963e577$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $61a884290963e577$var$li(a, b, c, d) {
    var e = $61a884290963e577$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $61a884290963e577$var$N) {
        var g = $61a884290963e577$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $61a884290963e577$var$Mh(d, g.deps)) {
            e.memoizedState = $61a884290963e577$var$bi(b, c, f, d);
            return;
        }
    }
    $61a884290963e577$var$M.flags |= a;
    e.memoizedState = $61a884290963e577$var$bi(1 | b, c, f, d);
}
function $61a884290963e577$var$mi(a, b) {
    return $61a884290963e577$var$ki(8390656, 8, a, b);
}
function $61a884290963e577$var$$h(a, b) {
    return $61a884290963e577$var$li(2048, 8, a, b);
}
function $61a884290963e577$var$ni(a, b) {
    return $61a884290963e577$var$li(4, 2, a, b);
}
function $61a884290963e577$var$oi(a, b) {
    return $61a884290963e577$var$li(4, 4, a, b);
}
function $61a884290963e577$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $61a884290963e577$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $61a884290963e577$var$li(4, 4, $61a884290963e577$var$pi.bind(null, b, a), c);
}
function $61a884290963e577$var$ri() {}
function $61a884290963e577$var$si(a, b) {
    var c = $61a884290963e577$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $61a884290963e577$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $61a884290963e577$var$ti(a, b) {
    var c = $61a884290963e577$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $61a884290963e577$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $61a884290963e577$var$ui(a, b, c) {
    if (0 === ($61a884290963e577$var$Hh & 21)) return a.baseState && (a.baseState = !1, $61a884290963e577$var$dh = !0), a.memoizedState = c;
    $61a884290963e577$var$He(c, b) || (c = $61a884290963e577$var$yc(), $61a884290963e577$var$M.lanes |= c, $61a884290963e577$var$rh |= c, a.baseState = !0);
    return b;
}
function $61a884290963e577$var$vi(a, b) {
    var c = $61a884290963e577$var$C;
    $61a884290963e577$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $61a884290963e577$var$Gh.transition;
    $61a884290963e577$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $61a884290963e577$var$C = c, $61a884290963e577$var$Gh.transition = d;
    }
}
function $61a884290963e577$var$wi() {
    return $61a884290963e577$var$Uh().memoizedState;
}
function $61a884290963e577$var$xi(a, b, c) {
    var d = $61a884290963e577$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($61a884290963e577$var$zi(a)) $61a884290963e577$var$Ai(b, c);
    else if (c = $61a884290963e577$var$hh(a, b, c, d), null !== c) {
        var e = $61a884290963e577$var$R();
        $61a884290963e577$var$gi(c, a, d, e);
        $61a884290963e577$var$Bi(c, b, d);
    }
}
function $61a884290963e577$var$ii(a, b, c) {
    var d = $61a884290963e577$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($61a884290963e577$var$zi(a)) $61a884290963e577$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($61a884290963e577$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $61a884290963e577$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $61a884290963e577$var$hh(a, b, e, d);
        null !== c && (e = $61a884290963e577$var$R(), $61a884290963e577$var$gi(c, a, d, e), $61a884290963e577$var$Bi(c, b, d));
    }
}
function $61a884290963e577$var$zi(a) {
    var b = a.alternate;
    return a === $61a884290963e577$var$M || null !== b && b === $61a884290963e577$var$M;
}
function $61a884290963e577$var$Ai(a, b) {
    $61a884290963e577$var$Jh = $61a884290963e577$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $61a884290963e577$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $61a884290963e577$var$Cc(a, c);
    }
}
var $61a884290963e577$var$Rh = {
    readContext: $61a884290963e577$var$eh,
    useCallback: $61a884290963e577$var$P,
    useContext: $61a884290963e577$var$P,
    useEffect: $61a884290963e577$var$P,
    useImperativeHandle: $61a884290963e577$var$P,
    useInsertionEffect: $61a884290963e577$var$P,
    useLayoutEffect: $61a884290963e577$var$P,
    useMemo: $61a884290963e577$var$P,
    useReducer: $61a884290963e577$var$P,
    useRef: $61a884290963e577$var$P,
    useState: $61a884290963e577$var$P,
    useDebugValue: $61a884290963e577$var$P,
    useDeferredValue: $61a884290963e577$var$P,
    useTransition: $61a884290963e577$var$P,
    useMutableSource: $61a884290963e577$var$P,
    useSyncExternalStore: $61a884290963e577$var$P,
    useId: $61a884290963e577$var$P,
    unstable_isNewReconciler: !1
}, $61a884290963e577$var$Oh = {
    readContext: $61a884290963e577$var$eh,
    useCallback: function(a, b) {
        $61a884290963e577$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $61a884290963e577$var$eh,
    useEffect: $61a884290963e577$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $61a884290963e577$var$ki(4194308, 4, $61a884290963e577$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $61a884290963e577$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $61a884290963e577$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $61a884290963e577$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $61a884290963e577$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $61a884290963e577$var$xi.bind(null, $61a884290963e577$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $61a884290963e577$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $61a884290963e577$var$hi,
    useDebugValue: $61a884290963e577$var$ri,
    useDeferredValue: function(a) {
        return $61a884290963e577$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $61a884290963e577$var$hi(!1), b = a[0];
        a = $61a884290963e577$var$vi.bind(null, a[1]);
        $61a884290963e577$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $61a884290963e577$var$M, e = $61a884290963e577$var$Th();
        if ($61a884290963e577$var$I) {
            if (void 0 === c) throw Error($61a884290963e577$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $61a884290963e577$var$Q) throw Error($61a884290963e577$var$p(349));
            0 !== ($61a884290963e577$var$Hh & 30) || $61a884290963e577$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $61a884290963e577$var$mi($61a884290963e577$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $61a884290963e577$var$bi(9, $61a884290963e577$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $61a884290963e577$var$Th(), b = $61a884290963e577$var$Q.identifierPrefix;
        if ($61a884290963e577$var$I) {
            var c = $61a884290963e577$var$sg;
            var d = $61a884290963e577$var$rg;
            c = (d & ~(1 << 32 - $61a884290963e577$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $61a884290963e577$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $61a884290963e577$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $61a884290963e577$var$Ph = {
    readContext: $61a884290963e577$var$eh,
    useCallback: $61a884290963e577$var$si,
    useContext: $61a884290963e577$var$eh,
    useEffect: $61a884290963e577$var$$h,
    useImperativeHandle: $61a884290963e577$var$qi,
    useInsertionEffect: $61a884290963e577$var$ni,
    useLayoutEffect: $61a884290963e577$var$oi,
    useMemo: $61a884290963e577$var$ti,
    useReducer: $61a884290963e577$var$Wh,
    useRef: $61a884290963e577$var$ji,
    useState: function() {
        return $61a884290963e577$var$Wh($61a884290963e577$var$Vh);
    },
    useDebugValue: $61a884290963e577$var$ri,
    useDeferredValue: function(a) {
        var b = $61a884290963e577$var$Uh();
        return $61a884290963e577$var$ui(b, $61a884290963e577$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $61a884290963e577$var$Wh($61a884290963e577$var$Vh)[0], b = $61a884290963e577$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $61a884290963e577$var$Yh,
    useSyncExternalStore: $61a884290963e577$var$Zh,
    useId: $61a884290963e577$var$wi,
    unstable_isNewReconciler: !1
}, $61a884290963e577$var$Qh = {
    readContext: $61a884290963e577$var$eh,
    useCallback: $61a884290963e577$var$si,
    useContext: $61a884290963e577$var$eh,
    useEffect: $61a884290963e577$var$$h,
    useImperativeHandle: $61a884290963e577$var$qi,
    useInsertionEffect: $61a884290963e577$var$ni,
    useLayoutEffect: $61a884290963e577$var$oi,
    useMemo: $61a884290963e577$var$ti,
    useReducer: $61a884290963e577$var$Xh,
    useRef: $61a884290963e577$var$ji,
    useState: function() {
        return $61a884290963e577$var$Xh($61a884290963e577$var$Vh);
    },
    useDebugValue: $61a884290963e577$var$ri,
    useDeferredValue: function(a) {
        var b = $61a884290963e577$var$Uh();
        return null === $61a884290963e577$var$N ? b.memoizedState = a : $61a884290963e577$var$ui(b, $61a884290963e577$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $61a884290963e577$var$Xh($61a884290963e577$var$Vh)[0], b = $61a884290963e577$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $61a884290963e577$var$Yh,
    useSyncExternalStore: $61a884290963e577$var$Zh,
    useId: $61a884290963e577$var$wi,
    unstable_isNewReconciler: !1
};
function $61a884290963e577$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $61a884290963e577$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $61a884290963e577$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $61a884290963e577$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $61a884290963e577$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $61a884290963e577$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $61a884290963e577$var$R(), e = $61a884290963e577$var$yi(a), f = $61a884290963e577$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $61a884290963e577$var$nh(a, f, e);
        null !== b && ($61a884290963e577$var$gi(b, a, e, d), $61a884290963e577$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $61a884290963e577$var$R(), e = $61a884290963e577$var$yi(a), f = $61a884290963e577$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $61a884290963e577$var$nh(a, f, e);
        null !== b && ($61a884290963e577$var$gi(b, a, e, d), $61a884290963e577$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $61a884290963e577$var$R(), d = $61a884290963e577$var$yi(a), e = $61a884290963e577$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $61a884290963e577$var$nh(a, e, d);
        null !== b && ($61a884290963e577$var$gi(b, a, d, c), $61a884290963e577$var$oh(b, a, d));
    }
};
function $61a884290963e577$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$61a884290963e577$var$Ie(c, d) || !$61a884290963e577$var$Ie(e, f) : !0;
}
function $61a884290963e577$var$Gi(a, b, c) {
    var d = !1, e = $61a884290963e577$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $61a884290963e577$var$eh(f) : (e = $61a884290963e577$var$Zf(b) ? $61a884290963e577$var$Xf : $61a884290963e577$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $61a884290963e577$var$Yf(a, e) : $61a884290963e577$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $61a884290963e577$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $61a884290963e577$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $61a884290963e577$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $61a884290963e577$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $61a884290963e577$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $61a884290963e577$var$eh(f) : (f = $61a884290963e577$var$Zf(b) ? $61a884290963e577$var$Xf : $61a884290963e577$var$H.current, e.context = $61a884290963e577$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($61a884290963e577$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $61a884290963e577$var$Ei.enqueueReplaceState(e, e.state, null), $61a884290963e577$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $61a884290963e577$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $61a884290963e577$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $61a884290963e577$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $61a884290963e577$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $61a884290963e577$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $61a884290963e577$var$Ni(a, b, c) {
    c = $61a884290963e577$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $61a884290963e577$var$Oi || ($61a884290963e577$var$Oi = !0, $61a884290963e577$var$Pi = d);
        $61a884290963e577$var$Li(a, b);
    };
    return c;
}
function $61a884290963e577$var$Qi(a, b, c) {
    c = $61a884290963e577$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $61a884290963e577$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $61a884290963e577$var$Li(a, b);
        "function" !== typeof d && (null === $61a884290963e577$var$Ri ? $61a884290963e577$var$Ri = new Set([
            this
        ]) : $61a884290963e577$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $61a884290963e577$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $61a884290963e577$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $61a884290963e577$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $61a884290963e577$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $61a884290963e577$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $61a884290963e577$var$mh(-1, 1), b.tag = 2, $61a884290963e577$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $61a884290963e577$var$Wi = $61a884290963e577$var$ua.ReactCurrentOwner, $61a884290963e577$var$dh = !1;
function $61a884290963e577$var$Xi(a, b, c, d) {
    b.child = null === a ? $61a884290963e577$var$Vg(b, null, c, d) : $61a884290963e577$var$Ug(b, a.child, c, d);
}
function $61a884290963e577$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $61a884290963e577$var$ch(b, e);
    d = $61a884290963e577$var$Nh(a, b, c, d, f, e);
    c = $61a884290963e577$var$Sh();
    if (null !== a && !$61a884290963e577$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $61a884290963e577$var$Zi(a, b, e);
    $61a884290963e577$var$I && c && $61a884290963e577$var$vg(b);
    b.flags |= 1;
    $61a884290963e577$var$Xi(a, b, d, e);
    return b.child;
}
function $61a884290963e577$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$61a884290963e577$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $61a884290963e577$var$bj(a, b, f, d, e);
        a = $61a884290963e577$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $61a884290963e577$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $61a884290963e577$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $61a884290963e577$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $61a884290963e577$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($61a884290963e577$var$Ie(f, d) && a.ref === b.ref) {
            if ($61a884290963e577$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($61a884290963e577$var$dh = !0);
            else return b.lanes = a.lanes, $61a884290963e577$var$Zi(a, b, e);
        }
    }
    return $61a884290963e577$var$cj(a, b, c, d, e);
}
function $61a884290963e577$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $61a884290963e577$var$G($61a884290963e577$var$ej, $61a884290963e577$var$fj), $61a884290963e577$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $61a884290963e577$var$G($61a884290963e577$var$ej, $61a884290963e577$var$fj), $61a884290963e577$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $61a884290963e577$var$G($61a884290963e577$var$ej, $61a884290963e577$var$fj);
            $61a884290963e577$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $61a884290963e577$var$G($61a884290963e577$var$ej, $61a884290963e577$var$fj), $61a884290963e577$var$fj |= d;
    $61a884290963e577$var$Xi(a, b, e, c);
    return b.child;
}
function $61a884290963e577$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $61a884290963e577$var$cj(a, b, c, d, e) {
    var f = $61a884290963e577$var$Zf(c) ? $61a884290963e577$var$Xf : $61a884290963e577$var$H.current;
    f = $61a884290963e577$var$Yf(b, f);
    $61a884290963e577$var$ch(b, e);
    c = $61a884290963e577$var$Nh(a, b, c, d, f, e);
    d = $61a884290963e577$var$Sh();
    if (null !== a && !$61a884290963e577$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $61a884290963e577$var$Zi(a, b, e);
    $61a884290963e577$var$I && d && $61a884290963e577$var$vg(b);
    b.flags |= 1;
    $61a884290963e577$var$Xi(a, b, c, e);
    return b.child;
}
function $61a884290963e577$var$hj(a, b, c, d, e) {
    if ($61a884290963e577$var$Zf(c)) {
        var f = !0;
        $61a884290963e577$var$cg(b);
    } else f = !1;
    $61a884290963e577$var$ch(b, e);
    if (null === b.stateNode) $61a884290963e577$var$ij(a, b), $61a884290963e577$var$Gi(b, c, d), $61a884290963e577$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $61a884290963e577$var$eh(l) : (l = $61a884290963e577$var$Zf(c) ? $61a884290963e577$var$Xf : $61a884290963e577$var$H.current, l = $61a884290963e577$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $61a884290963e577$var$Hi(b, g, d, l);
        $61a884290963e577$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $61a884290963e577$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $61a884290963e577$var$Wf.current || $61a884290963e577$var$jh ? ("function" === typeof m && ($61a884290963e577$var$Di(b, c, m, d), k = b.memoizedState), (h = $61a884290963e577$var$jh || $61a884290963e577$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $61a884290963e577$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $61a884290963e577$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $61a884290963e577$var$eh(k) : (k = $61a884290963e577$var$Zf(c) ? $61a884290963e577$var$Xf : $61a884290963e577$var$H.current, k = $61a884290963e577$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $61a884290963e577$var$Hi(b, g, d, k);
        $61a884290963e577$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $61a884290963e577$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $61a884290963e577$var$Wf.current || $61a884290963e577$var$jh ? ("function" === typeof y && ($61a884290963e577$var$Di(b, c, y, d), n = b.memoizedState), (l = $61a884290963e577$var$jh || $61a884290963e577$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $61a884290963e577$var$jj(a, b, c, d, f, e);
}
function $61a884290963e577$var$jj(a, b, c, d, e, f) {
    $61a884290963e577$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $61a884290963e577$var$dg(b, c, !1), $61a884290963e577$var$Zi(a, b, f);
    d = b.stateNode;
    $61a884290963e577$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $61a884290963e577$var$Ug(b, a.child, null, f), b.child = $61a884290963e577$var$Ug(b, null, h, f)) : $61a884290963e577$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $61a884290963e577$var$dg(b, c, !0);
    return b.child;
}
function $61a884290963e577$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $61a884290963e577$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $61a884290963e577$var$ag(a, b.context, !1);
    $61a884290963e577$var$yh(a, b.containerInfo);
}
function $61a884290963e577$var$lj(a, b, c, d, e) {
    $61a884290963e577$var$Ig();
    $61a884290963e577$var$Jg(e);
    b.flags |= 256;
    $61a884290963e577$var$Xi(a, b, c, d);
    return b.child;
}
var $61a884290963e577$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $61a884290963e577$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $61a884290963e577$var$oj(a, b, c) {
    var d = b.pendingProps, e = $61a884290963e577$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $61a884290963e577$var$G($61a884290963e577$var$L, e & 1);
    if (null === a) {
        $61a884290963e577$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $61a884290963e577$var$pj(g, d, 0, null), a = $61a884290963e577$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $61a884290963e577$var$nj(c), b.memoizedState = $61a884290963e577$var$mj, a) : $61a884290963e577$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $61a884290963e577$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $61a884290963e577$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $61a884290963e577$var$Pg(h, f) : (f = $61a884290963e577$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $61a884290963e577$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $61a884290963e577$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $61a884290963e577$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $61a884290963e577$var$qj(a, b) {
    b = $61a884290963e577$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $61a884290963e577$var$sj(a, b, c, d) {
    null !== d && $61a884290963e577$var$Jg(d);
    $61a884290963e577$var$Ug(b, a.child, null, c);
    a = $61a884290963e577$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $61a884290963e577$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $61a884290963e577$var$Ki(Error($61a884290963e577$var$p(422))), $61a884290963e577$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $61a884290963e577$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $61a884290963e577$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $61a884290963e577$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $61a884290963e577$var$nj(g);
        b.memoizedState = $61a884290963e577$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $61a884290963e577$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($61a884290963e577$var$p(419));
        d = $61a884290963e577$var$Ki(f, d, void 0);
        return $61a884290963e577$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($61a884290963e577$var$dh || h) {
        d = $61a884290963e577$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $61a884290963e577$var$ih(a, e), $61a884290963e577$var$gi(d, a, e, -1));
        }
        $61a884290963e577$var$tj();
        d = $61a884290963e577$var$Ki(Error($61a884290963e577$var$p(421)));
        return $61a884290963e577$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $61a884290963e577$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $61a884290963e577$var$yg = $61a884290963e577$var$Lf(e.nextSibling);
    $61a884290963e577$var$xg = b;
    $61a884290963e577$var$I = !0;
    $61a884290963e577$var$zg = null;
    null !== a && ($61a884290963e577$var$og[$61a884290963e577$var$pg++] = $61a884290963e577$var$rg, $61a884290963e577$var$og[$61a884290963e577$var$pg++] = $61a884290963e577$var$sg, $61a884290963e577$var$og[$61a884290963e577$var$pg++] = $61a884290963e577$var$qg, $61a884290963e577$var$rg = a.id, $61a884290963e577$var$sg = a.overflow, $61a884290963e577$var$qg = b);
    b = $61a884290963e577$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $61a884290963e577$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $61a884290963e577$var$bh(a.return, b, c);
}
function $61a884290963e577$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $61a884290963e577$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $61a884290963e577$var$Xi(a, b, d.children, c);
    d = $61a884290963e577$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $61a884290963e577$var$vj(a, c, b);
            else if (19 === a.tag) $61a884290963e577$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $61a884290963e577$var$G($61a884290963e577$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $61a884290963e577$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $61a884290963e577$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $61a884290963e577$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $61a884290963e577$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $61a884290963e577$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $61a884290963e577$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $61a884290963e577$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $61a884290963e577$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($61a884290963e577$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $61a884290963e577$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $61a884290963e577$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $61a884290963e577$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $61a884290963e577$var$kj(b);
            $61a884290963e577$var$Ig();
            break;
        case 5:
            $61a884290963e577$var$Ah(b);
            break;
        case 1:
            $61a884290963e577$var$Zf(b.type) && $61a884290963e577$var$cg(b);
            break;
        case 4:
            $61a884290963e577$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $61a884290963e577$var$G($61a884290963e577$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $61a884290963e577$var$G($61a884290963e577$var$L, $61a884290963e577$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $61a884290963e577$var$oj(a, b, c);
                $61a884290963e577$var$G($61a884290963e577$var$L, $61a884290963e577$var$L.current & 1);
                a = $61a884290963e577$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $61a884290963e577$var$G($61a884290963e577$var$L, $61a884290963e577$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $61a884290963e577$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $61a884290963e577$var$G($61a884290963e577$var$L, $61a884290963e577$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $61a884290963e577$var$dj(a, b, c);
    }
    return $61a884290963e577$var$Zi(a, b, c);
}
var $61a884290963e577$var$zj, $61a884290963e577$var$Aj, $61a884290963e577$var$Bj, $61a884290963e577$var$Cj;
$61a884290963e577$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$61a884290963e577$var$Aj = function() {};
$61a884290963e577$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $61a884290963e577$var$xh($61a884290963e577$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $61a884290963e577$var$Ya(a, e);
                d = $61a884290963e577$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $61a884290963e577$var$A({}, e, {
                    value: void 0
                });
                d = $61a884290963e577$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $61a884290963e577$var$gb(a, e);
                d = $61a884290963e577$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $61a884290963e577$var$Bf);
        }
        $61a884290963e577$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($61a884290963e577$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($61a884290963e577$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $61a884290963e577$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$61a884290963e577$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $61a884290963e577$var$Dj(a, b) {
    if (!$61a884290963e577$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $61a884290963e577$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $61a884290963e577$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $61a884290963e577$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $61a884290963e577$var$S(b), null;
        case 1:
            return $61a884290963e577$var$Zf(b.type) && $61a884290963e577$var$$f(), $61a884290963e577$var$S(b), null;
        case 3:
            d = b.stateNode;
            $61a884290963e577$var$zh();
            $61a884290963e577$var$E($61a884290963e577$var$Wf);
            $61a884290963e577$var$E($61a884290963e577$var$H);
            $61a884290963e577$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $61a884290963e577$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $61a884290963e577$var$zg && ($61a884290963e577$var$Fj($61a884290963e577$var$zg), $61a884290963e577$var$zg = null));
            $61a884290963e577$var$Aj(a, b);
            $61a884290963e577$var$S(b);
            return null;
        case 5:
            $61a884290963e577$var$Bh(b);
            var e = $61a884290963e577$var$xh($61a884290963e577$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $61a884290963e577$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($61a884290963e577$var$p(166));
                    $61a884290963e577$var$S(b);
                    return null;
                }
                a = $61a884290963e577$var$xh($61a884290963e577$var$uh.current);
                if ($61a884290963e577$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$61a884290963e577$var$Of] = b;
                    d[$61a884290963e577$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $61a884290963e577$var$D("cancel", d);
                            $61a884290963e577$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $61a884290963e577$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $61a884290963e577$var$lf.length; e++)$61a884290963e577$var$D($61a884290963e577$var$lf[e], d);
                            break;
                        case "source":
                            $61a884290963e577$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $61a884290963e577$var$D("error", d);
                            $61a884290963e577$var$D("load", d);
                            break;
                        case "details":
                            $61a884290963e577$var$D("toggle", d);
                            break;
                        case "input":
                            $61a884290963e577$var$Za(d, f);
                            $61a884290963e577$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $61a884290963e577$var$D("invalid", d);
                            break;
                        case "textarea":
                            $61a884290963e577$var$hb(d, f), $61a884290963e577$var$D("invalid", d);
                    }
                    $61a884290963e577$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $61a884290963e577$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $61a884290963e577$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $61a884290963e577$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $61a884290963e577$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $61a884290963e577$var$Va(d);
                            $61a884290963e577$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $61a884290963e577$var$Va(d);
                            $61a884290963e577$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $61a884290963e577$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $61a884290963e577$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$61a884290963e577$var$Of] = b;
                    a[$61a884290963e577$var$Pf] = d;
                    $61a884290963e577$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $61a884290963e577$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $61a884290963e577$var$D("cancel", a);
                                $61a884290963e577$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $61a884290963e577$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $61a884290963e577$var$lf.length; e++)$61a884290963e577$var$D($61a884290963e577$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $61a884290963e577$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $61a884290963e577$var$D("error", a);
                                $61a884290963e577$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $61a884290963e577$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $61a884290963e577$var$Za(a, d);
                                e = $61a884290963e577$var$Ya(a, d);
                                $61a884290963e577$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $61a884290963e577$var$A({}, d, {
                                    value: void 0
                                });
                                $61a884290963e577$var$D("invalid", a);
                                break;
                            case "textarea":
                                $61a884290963e577$var$hb(a, d);
                                e = $61a884290963e577$var$gb(a, d);
                                $61a884290963e577$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $61a884290963e577$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $61a884290963e577$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $61a884290963e577$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $61a884290963e577$var$ob(a, k) : "number" === typeof k && $61a884290963e577$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($61a884290963e577$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $61a884290963e577$var$D("scroll", a) : null != k && $61a884290963e577$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $61a884290963e577$var$Va(a);
                                $61a884290963e577$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $61a884290963e577$var$Va(a);
                                $61a884290963e577$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $61a884290963e577$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $61a884290963e577$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $61a884290963e577$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $61a884290963e577$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $61a884290963e577$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $61a884290963e577$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($61a884290963e577$var$p(166));
                c = $61a884290963e577$var$xh($61a884290963e577$var$wh.current);
                $61a884290963e577$var$xh($61a884290963e577$var$uh.current);
                if ($61a884290963e577$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$61a884290963e577$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $61a884290963e577$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $61a884290963e577$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $61a884290963e577$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$61a884290963e577$var$Of] = b, b.stateNode = d;
            }
            $61a884290963e577$var$S(b);
            return null;
        case 13:
            $61a884290963e577$var$E($61a884290963e577$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($61a884290963e577$var$I && null !== $61a884290963e577$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $61a884290963e577$var$Hg(), $61a884290963e577$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $61a884290963e577$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($61a884290963e577$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($61a884290963e577$var$p(317));
                        f[$61a884290963e577$var$Of] = b;
                    } else $61a884290963e577$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $61a884290963e577$var$S(b);
                    f = !1;
                } else null !== $61a884290963e577$var$zg && ($61a884290963e577$var$Fj($61a884290963e577$var$zg), $61a884290963e577$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($61a884290963e577$var$L.current & 1) ? 0 === $61a884290963e577$var$T && ($61a884290963e577$var$T = 3) : $61a884290963e577$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $61a884290963e577$var$S(b);
            return null;
        case 4:
            return $61a884290963e577$var$zh(), $61a884290963e577$var$Aj(a, b), null === a && $61a884290963e577$var$sf(b.stateNode.containerInfo), $61a884290963e577$var$S(b), null;
        case 10:
            return $61a884290963e577$var$ah(b.type._context), $61a884290963e577$var$S(b), null;
        case 17:
            return $61a884290963e577$var$Zf(b.type) && $61a884290963e577$var$$f(), $61a884290963e577$var$S(b), null;
        case 19:
            $61a884290963e577$var$E($61a884290963e577$var$L);
            f = b.memoizedState;
            if (null === f) return $61a884290963e577$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $61a884290963e577$var$Dj(f, !1);
                else {
                    if (0 !== $61a884290963e577$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $61a884290963e577$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $61a884290963e577$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $61a884290963e577$var$G($61a884290963e577$var$L, $61a884290963e577$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $61a884290963e577$var$B() > $61a884290963e577$var$Gj && (b.flags |= 128, d = !0, $61a884290963e577$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $61a884290963e577$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $61a884290963e577$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$61a884290963e577$var$I) return $61a884290963e577$var$S(b), null;
                    } else 2 * $61a884290963e577$var$B() - f.renderingStartTime > $61a884290963e577$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $61a884290963e577$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $61a884290963e577$var$B(), b.sibling = null, c = $61a884290963e577$var$L.current, $61a884290963e577$var$G($61a884290963e577$var$L, d ? c & 1 | 2 : c & 1), b;
            $61a884290963e577$var$S(b);
            return null;
        case 22:
        case 23:
            return $61a884290963e577$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($61a884290963e577$var$fj & 1073741824) && ($61a884290963e577$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $61a884290963e577$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($61a884290963e577$var$p(156, b.tag));
}
function $61a884290963e577$var$Ij(a, b) {
    $61a884290963e577$var$wg(b);
    switch(b.tag){
        case 1:
            return $61a884290963e577$var$Zf(b.type) && $61a884290963e577$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $61a884290963e577$var$zh(), $61a884290963e577$var$E($61a884290963e577$var$Wf), $61a884290963e577$var$E($61a884290963e577$var$H), $61a884290963e577$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $61a884290963e577$var$Bh(b), null;
        case 13:
            $61a884290963e577$var$E($61a884290963e577$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($61a884290963e577$var$p(340));
                $61a884290963e577$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $61a884290963e577$var$E($61a884290963e577$var$L), null;
        case 4:
            return $61a884290963e577$var$zh(), null;
        case 10:
            return $61a884290963e577$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $61a884290963e577$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $61a884290963e577$var$Jj = !1, $61a884290963e577$var$U = !1, $61a884290963e577$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $61a884290963e577$var$V = null;
function $61a884290963e577$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $61a884290963e577$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $61a884290963e577$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $61a884290963e577$var$W(a, b, d);
    }
}
var $61a884290963e577$var$Nj = !1;
function $61a884290963e577$var$Oj(a, b) {
    $61a884290963e577$var$Cf = $61a884290963e577$var$dd;
    a = $61a884290963e577$var$Me();
    if ($61a884290963e577$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $61a884290963e577$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $61a884290963e577$var$dd = !1;
    for($61a884290963e577$var$V = b; null !== $61a884290963e577$var$V;)if (b = $61a884290963e577$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $61a884290963e577$var$V = a;
    else for(; null !== $61a884290963e577$var$V;){
        b = $61a884290963e577$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $61a884290963e577$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($61a884290963e577$var$p(163));
            }
        } catch (F) {
            $61a884290963e577$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $61a884290963e577$var$V = a;
            break;
        }
        $61a884290963e577$var$V = b.return;
    }
    n = $61a884290963e577$var$Nj;
    $61a884290963e577$var$Nj = !1;
    return n;
}
function $61a884290963e577$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $61a884290963e577$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $61a884290963e577$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $61a884290963e577$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $61a884290963e577$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $61a884290963e577$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$61a884290963e577$var$Of], delete b[$61a884290963e577$var$Pf], delete b[$61a884290963e577$var$of], delete b[$61a884290963e577$var$Qf], delete b[$61a884290963e577$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $61a884290963e577$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $61a884290963e577$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $61a884290963e577$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $61a884290963e577$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $61a884290963e577$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($61a884290963e577$var$Vj(a, b, c), a = a.sibling; null !== a;)$61a884290963e577$var$Vj(a, b, c), a = a.sibling;
}
function $61a884290963e577$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($61a884290963e577$var$Wj(a, b, c), a = a.sibling; null !== a;)$61a884290963e577$var$Wj(a, b, c), a = a.sibling;
}
var $61a884290963e577$var$X = null, $61a884290963e577$var$Xj = !1;
function $61a884290963e577$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$61a884290963e577$var$Zj(a, b, c), c = c.sibling;
}
function $61a884290963e577$var$Zj(a, b, c) {
    if ($61a884290963e577$var$lc && "function" === typeof $61a884290963e577$var$lc.onCommitFiberUnmount) try {
        $61a884290963e577$var$lc.onCommitFiberUnmount($61a884290963e577$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $61a884290963e577$var$U || $61a884290963e577$var$Lj(c, b);
        case 6:
            var d = $61a884290963e577$var$X, e = $61a884290963e577$var$Xj;
            $61a884290963e577$var$X = null;
            $61a884290963e577$var$Yj(a, b, c);
            $61a884290963e577$var$X = d;
            $61a884290963e577$var$Xj = e;
            null !== $61a884290963e577$var$X && ($61a884290963e577$var$Xj ? (a = $61a884290963e577$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $61a884290963e577$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $61a884290963e577$var$X && ($61a884290963e577$var$Xj ? (a = $61a884290963e577$var$X, c = c.stateNode, 8 === a.nodeType ? $61a884290963e577$var$Kf(a.parentNode, c) : 1 === a.nodeType && $61a884290963e577$var$Kf(a, c), $61a884290963e577$var$bd(a)) : $61a884290963e577$var$Kf($61a884290963e577$var$X, c.stateNode));
            break;
        case 4:
            d = $61a884290963e577$var$X;
            e = $61a884290963e577$var$Xj;
            $61a884290963e577$var$X = c.stateNode.containerInfo;
            $61a884290963e577$var$Xj = !0;
            $61a884290963e577$var$Yj(a, b, c);
            $61a884290963e577$var$X = d;
            $61a884290963e577$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$61a884290963e577$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $61a884290963e577$var$Mj(c, b, g) : 0 !== (f & 4) && $61a884290963e577$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $61a884290963e577$var$Yj(a, b, c);
            break;
        case 1:
            if (!$61a884290963e577$var$U && ($61a884290963e577$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $61a884290963e577$var$W(c, b, h);
            }
            $61a884290963e577$var$Yj(a, b, c);
            break;
        case 21:
            $61a884290963e577$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($61a884290963e577$var$U = (d = $61a884290963e577$var$U) || null !== c.memoizedState, $61a884290963e577$var$Yj(a, b, c), $61a884290963e577$var$U = d) : $61a884290963e577$var$Yj(a, b, c);
            break;
        default:
            $61a884290963e577$var$Yj(a, b, c);
    }
}
function $61a884290963e577$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $61a884290963e577$var$Kj);
        b.forEach(function(b) {
            var d = $61a884290963e577$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $61a884290963e577$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $61a884290963e577$var$X = h.stateNode;
                        $61a884290963e577$var$Xj = !1;
                        break a;
                    case 3:
                        $61a884290963e577$var$X = h.stateNode.containerInfo;
                        $61a884290963e577$var$Xj = !0;
                        break a;
                    case 4:
                        $61a884290963e577$var$X = h.stateNode.containerInfo;
                        $61a884290963e577$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $61a884290963e577$var$X) throw Error($61a884290963e577$var$p(160));
            $61a884290963e577$var$Zj(f, g, e);
            $61a884290963e577$var$X = null;
            $61a884290963e577$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $61a884290963e577$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$61a884290963e577$var$dk(b, a), b = b.sibling;
}
function $61a884290963e577$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            if (d & 4) {
                try {
                    $61a884290963e577$var$Pj(3, a, a.return), $61a884290963e577$var$Qj(3, a);
                } catch (t) {
                    $61a884290963e577$var$W(a, a.return, t);
                }
                try {
                    $61a884290963e577$var$Pj(5, a, a.return);
                } catch (t) {
                    $61a884290963e577$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            d & 512 && null !== c && $61a884290963e577$var$Lj(c, c.return);
            break;
        case 5:
            $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            d & 512 && null !== c && $61a884290963e577$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $61a884290963e577$var$ob(e, "");
                } catch (t) {
                    $61a884290963e577$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $61a884290963e577$var$ab(e, f);
                    $61a884290963e577$var$vb(h, g);
                    var l = $61a884290963e577$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $61a884290963e577$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $61a884290963e577$var$nb(e, q) : "children" === m ? $61a884290963e577$var$ob(e, q) : $61a884290963e577$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $61a884290963e577$var$bb(e, f);
                            break;
                        case "textarea":
                            $61a884290963e577$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $61a884290963e577$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $61a884290963e577$var$fb(e, !!f.multiple, f.defaultValue, !0) : $61a884290963e577$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$61a884290963e577$var$Pf] = f;
                } catch (t) {
                    $61a884290963e577$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($61a884290963e577$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $61a884290963e577$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $61a884290963e577$var$bd(b.containerInfo);
            } catch (t) {
                $61a884290963e577$var$W(a, a.return, t);
            }
            break;
        case 4:
            $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            break;
        case 13:
            $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($61a884290963e577$var$fk = $61a884290963e577$var$B()));
            d & 4 && $61a884290963e577$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($61a884290963e577$var$U = (l = $61a884290963e577$var$U) || m, $61a884290963e577$var$ck(b, a), $61a884290963e577$var$U = l) : $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($61a884290963e577$var$V = a, m = a.child; null !== m;){
                    for(q = $61a884290963e577$var$V = m; null !== $61a884290963e577$var$V;){
                        r = $61a884290963e577$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $61a884290963e577$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $61a884290963e577$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $61a884290963e577$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $61a884290963e577$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $61a884290963e577$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $61a884290963e577$var$V = y) : $61a884290963e577$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $61a884290963e577$var$rb("display", g));
                            } catch (t) {
                                $61a884290963e577$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $61a884290963e577$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $61a884290963e577$var$ck(b, a);
            $61a884290963e577$var$ek(a);
            d & 4 && $61a884290963e577$var$ak(a);
            break;
        case 21:
            break;
        default:
            $61a884290963e577$var$ck(b, a), $61a884290963e577$var$ek(a);
    }
}
function $61a884290963e577$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($61a884290963e577$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($61a884290963e577$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($61a884290963e577$var$ob(e, ""), d.flags &= -33);
                    var f = $61a884290963e577$var$Uj(a);
                    $61a884290963e577$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $61a884290963e577$var$Uj(a);
                    $61a884290963e577$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($61a884290963e577$var$p(161));
            }
        } catch (k) {
            $61a884290963e577$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $61a884290963e577$var$hk(a, b, c) {
    $61a884290963e577$var$V = a;
    $61a884290963e577$var$ik(a, b, c);
}
function $61a884290963e577$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $61a884290963e577$var$V;){
        var e = $61a884290963e577$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $61a884290963e577$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $61a884290963e577$var$U;
                h = $61a884290963e577$var$Jj;
                var l = $61a884290963e577$var$U;
                $61a884290963e577$var$Jj = g;
                if (($61a884290963e577$var$U = k) && !l) for($61a884290963e577$var$V = e; null !== $61a884290963e577$var$V;)g = $61a884290963e577$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $61a884290963e577$var$jk(e) : null !== k ? (k.return = g, $61a884290963e577$var$V = k) : $61a884290963e577$var$jk(e);
                for(; null !== f;)$61a884290963e577$var$V = f, $61a884290963e577$var$ik(f, b, c), f = f.sibling;
                $61a884290963e577$var$V = e;
                $61a884290963e577$var$Jj = h;
                $61a884290963e577$var$U = l;
            }
            $61a884290963e577$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $61a884290963e577$var$V = f) : $61a884290963e577$var$kk(a, b, c);
    }
}
function $61a884290963e577$var$kk(a) {
    for(; null !== $61a884290963e577$var$V;){
        var b = $61a884290963e577$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $61a884290963e577$var$U || $61a884290963e577$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$61a884290963e577$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $61a884290963e577$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $61a884290963e577$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $61a884290963e577$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $61a884290963e577$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($61a884290963e577$var$p(163));
                }
                $61a884290963e577$var$U || b.flags & 512 && $61a884290963e577$var$Rj(b);
            } catch (r) {
                $61a884290963e577$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $61a884290963e577$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $61a884290963e577$var$V = c;
            break;
        }
        $61a884290963e577$var$V = b.return;
    }
}
function $61a884290963e577$var$gk(a) {
    for(; null !== $61a884290963e577$var$V;){
        var b = $61a884290963e577$var$V;
        if (b === a) {
            $61a884290963e577$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $61a884290963e577$var$V = c;
            break;
        }
        $61a884290963e577$var$V = b.return;
    }
}
function $61a884290963e577$var$jk(a) {
    for(; null !== $61a884290963e577$var$V;){
        var b = $61a884290963e577$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $61a884290963e577$var$Qj(4, b);
                    } catch (k) {
                        $61a884290963e577$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $61a884290963e577$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $61a884290963e577$var$Rj(b);
                    } catch (k) {
                        $61a884290963e577$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $61a884290963e577$var$Rj(b);
                    } catch (k) {
                        $61a884290963e577$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $61a884290963e577$var$W(b, b.return, k);
        }
        if (b === a) {
            $61a884290963e577$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $61a884290963e577$var$V = h;
            break;
        }
        $61a884290963e577$var$V = b.return;
    }
}
var $61a884290963e577$var$lk = Math.ceil, $61a884290963e577$var$mk = $61a884290963e577$var$ua.ReactCurrentDispatcher, $61a884290963e577$var$nk = $61a884290963e577$var$ua.ReactCurrentOwner, $61a884290963e577$var$ok = $61a884290963e577$var$ua.ReactCurrentBatchConfig, $61a884290963e577$var$K = 0, $61a884290963e577$var$Q = null, $61a884290963e577$var$Y = null, $61a884290963e577$var$Z = 0, $61a884290963e577$var$fj = 0, $61a884290963e577$var$ej = $61a884290963e577$var$Uf(0), $61a884290963e577$var$T = 0, $61a884290963e577$var$pk = null, $61a884290963e577$var$rh = 0, $61a884290963e577$var$qk = 0, $61a884290963e577$var$rk = 0, $61a884290963e577$var$sk = null, $61a884290963e577$var$tk = null, $61a884290963e577$var$fk = 0, $61a884290963e577$var$Gj = Infinity, $61a884290963e577$var$uk = null, $61a884290963e577$var$Oi = !1, $61a884290963e577$var$Pi = null, $61a884290963e577$var$Ri = null, $61a884290963e577$var$vk = !1, $61a884290963e577$var$wk = null, $61a884290963e577$var$xk = 0, $61a884290963e577$var$yk = 0, $61a884290963e577$var$zk = null, $61a884290963e577$var$Ak = -1, $61a884290963e577$var$Bk = 0;
function $61a884290963e577$var$R() {
    return 0 !== ($61a884290963e577$var$K & 6) ? $61a884290963e577$var$B() : -1 !== $61a884290963e577$var$Ak ? $61a884290963e577$var$Ak : $61a884290963e577$var$Ak = $61a884290963e577$var$B();
}
function $61a884290963e577$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($61a884290963e577$var$K & 2) && 0 !== $61a884290963e577$var$Z) return $61a884290963e577$var$Z & -$61a884290963e577$var$Z;
    if (null !== $61a884290963e577$var$Kg.transition) return 0 === $61a884290963e577$var$Bk && ($61a884290963e577$var$Bk = $61a884290963e577$var$yc()), $61a884290963e577$var$Bk;
    a = $61a884290963e577$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $61a884290963e577$var$jd(a.type);
    return a;
}
function $61a884290963e577$var$gi(a, b, c, d) {
    if (50 < $61a884290963e577$var$yk) throw $61a884290963e577$var$yk = 0, $61a884290963e577$var$zk = null, Error($61a884290963e577$var$p(185));
    $61a884290963e577$var$Ac(a, c, d);
    if (0 === ($61a884290963e577$var$K & 2) || a !== $61a884290963e577$var$Q) a === $61a884290963e577$var$Q && (0 === ($61a884290963e577$var$K & 2) && ($61a884290963e577$var$qk |= c), 4 === $61a884290963e577$var$T && $61a884290963e577$var$Ck(a, $61a884290963e577$var$Z)), $61a884290963e577$var$Dk(a, d), 1 === c && 0 === $61a884290963e577$var$K && 0 === (b.mode & 1) && ($61a884290963e577$var$Gj = $61a884290963e577$var$B() + 500, $61a884290963e577$var$fg && $61a884290963e577$var$jg());
}
function $61a884290963e577$var$Dk(a, b) {
    var c = a.callbackNode;
    $61a884290963e577$var$wc(a, b);
    var d = $61a884290963e577$var$uc(a, a === $61a884290963e577$var$Q ? $61a884290963e577$var$Z : 0);
    if (0 === d) null !== c && $61a884290963e577$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $61a884290963e577$var$bc(c);
        if (1 === b) 0 === a.tag ? $61a884290963e577$var$ig($61a884290963e577$var$Ek.bind(null, a)) : $61a884290963e577$var$hg($61a884290963e577$var$Ek.bind(null, a)), $61a884290963e577$var$Jf(function() {
            0 === ($61a884290963e577$var$K & 6) && $61a884290963e577$var$jg();
        }), c = null;
        else {
            switch($61a884290963e577$var$Dc(d)){
                case 1:
                    c = $61a884290963e577$var$fc;
                    break;
                case 4:
                    c = $61a884290963e577$var$gc;
                    break;
                case 16:
                    c = $61a884290963e577$var$hc;
                    break;
                case 536870912:
                    c = $61a884290963e577$var$jc;
                    break;
                default:
                    c = $61a884290963e577$var$hc;
            }
            c = $61a884290963e577$var$Fk(c, $61a884290963e577$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $61a884290963e577$var$Gk(a, b) {
    $61a884290963e577$var$Ak = -1;
    $61a884290963e577$var$Bk = 0;
    if (0 !== ($61a884290963e577$var$K & 6)) throw Error($61a884290963e577$var$p(327));
    var c = a.callbackNode;
    if ($61a884290963e577$var$Hk() && a.callbackNode !== c) return null;
    var d = $61a884290963e577$var$uc(a, a === $61a884290963e577$var$Q ? $61a884290963e577$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $61a884290963e577$var$Ik(a, d);
    else {
        b = d;
        var e = $61a884290963e577$var$K;
        $61a884290963e577$var$K |= 2;
        var f = $61a884290963e577$var$Jk();
        if ($61a884290963e577$var$Q !== a || $61a884290963e577$var$Z !== b) $61a884290963e577$var$uk = null, $61a884290963e577$var$Gj = $61a884290963e577$var$B() + 500, $61a884290963e577$var$Kk(a, b);
        for(;;)try {
            $61a884290963e577$var$Lk();
            break;
        } catch (h) {
            $61a884290963e577$var$Mk(a, h);
        }
        $61a884290963e577$var$$g();
        $61a884290963e577$var$mk.current = f;
        $61a884290963e577$var$K = e;
        null !== $61a884290963e577$var$Y ? b = 0 : ($61a884290963e577$var$Q = null, $61a884290963e577$var$Z = 0, b = $61a884290963e577$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $61a884290963e577$var$xc(a), 0 !== e && (d = e, b = $61a884290963e577$var$Nk(a, e)));
        if (1 === b) throw c = $61a884290963e577$var$pk, $61a884290963e577$var$Kk(a, 0), $61a884290963e577$var$Ck(a, d), $61a884290963e577$var$Dk(a, $61a884290963e577$var$B()), c;
        if (6 === b) $61a884290963e577$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$61a884290963e577$var$Ok(e) && (b = $61a884290963e577$var$Ik(a, d), 2 === b && (f = $61a884290963e577$var$xc(a), 0 !== f && (d = f, b = $61a884290963e577$var$Nk(a, f))), 1 === b)) throw c = $61a884290963e577$var$pk, $61a884290963e577$var$Kk(a, 0), $61a884290963e577$var$Ck(a, d), $61a884290963e577$var$Dk(a, $61a884290963e577$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($61a884290963e577$var$p(345));
                case 2:
                    $61a884290963e577$var$Pk(a, $61a884290963e577$var$tk, $61a884290963e577$var$uk);
                    break;
                case 3:
                    $61a884290963e577$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $61a884290963e577$var$fk + 500 - $61a884290963e577$var$B(), 10 < b)) {
                        if (0 !== $61a884290963e577$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $61a884290963e577$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $61a884290963e577$var$Ff($61a884290963e577$var$Pk.bind(null, a, $61a884290963e577$var$tk, $61a884290963e577$var$uk), b);
                        break;
                    }
                    $61a884290963e577$var$Pk(a, $61a884290963e577$var$tk, $61a884290963e577$var$uk);
                    break;
                case 4:
                    $61a884290963e577$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $61a884290963e577$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $61a884290963e577$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $61a884290963e577$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $61a884290963e577$var$Ff($61a884290963e577$var$Pk.bind(null, a, $61a884290963e577$var$tk, $61a884290963e577$var$uk), d);
                        break;
                    }
                    $61a884290963e577$var$Pk(a, $61a884290963e577$var$tk, $61a884290963e577$var$uk);
                    break;
                case 5:
                    $61a884290963e577$var$Pk(a, $61a884290963e577$var$tk, $61a884290963e577$var$uk);
                    break;
                default:
                    throw Error($61a884290963e577$var$p(329));
            }
        }
    }
    $61a884290963e577$var$Dk(a, $61a884290963e577$var$B());
    return a.callbackNode === c ? $61a884290963e577$var$Gk.bind(null, a) : null;
}
function $61a884290963e577$var$Nk(a, b) {
    var c = $61a884290963e577$var$sk;
    a.current.memoizedState.isDehydrated && ($61a884290963e577$var$Kk(a, b).flags |= 256);
    a = $61a884290963e577$var$Ik(a, b);
    2 !== a && (b = $61a884290963e577$var$tk, $61a884290963e577$var$tk = c, null !== b && $61a884290963e577$var$Fj(b));
    return a;
}
function $61a884290963e577$var$Fj(a) {
    null === $61a884290963e577$var$tk ? $61a884290963e577$var$tk = a : $61a884290963e577$var$tk.push.apply($61a884290963e577$var$tk, a);
}
function $61a884290963e577$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$61a884290963e577$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $61a884290963e577$var$Ck(a, b) {
    b &= ~$61a884290963e577$var$rk;
    b &= ~$61a884290963e577$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $61a884290963e577$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $61a884290963e577$var$Ek(a) {
    if (0 !== ($61a884290963e577$var$K & 6)) throw Error($61a884290963e577$var$p(327));
    $61a884290963e577$var$Hk();
    var b = $61a884290963e577$var$uc(a, 0);
    if (0 === (b & 1)) return $61a884290963e577$var$Dk(a, $61a884290963e577$var$B()), null;
    var c = $61a884290963e577$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $61a884290963e577$var$xc(a);
        0 !== d && (b = d, c = $61a884290963e577$var$Nk(a, d));
    }
    if (1 === c) throw c = $61a884290963e577$var$pk, $61a884290963e577$var$Kk(a, 0), $61a884290963e577$var$Ck(a, b), $61a884290963e577$var$Dk(a, $61a884290963e577$var$B()), c;
    if (6 === c) throw Error($61a884290963e577$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $61a884290963e577$var$Pk(a, $61a884290963e577$var$tk, $61a884290963e577$var$uk);
    $61a884290963e577$var$Dk(a, $61a884290963e577$var$B());
    return null;
}
function $61a884290963e577$var$Qk(a, b) {
    var c = $61a884290963e577$var$K;
    $61a884290963e577$var$K |= 1;
    try {
        return a(b);
    } finally{
        $61a884290963e577$var$K = c, 0 === $61a884290963e577$var$K && ($61a884290963e577$var$Gj = $61a884290963e577$var$B() + 500, $61a884290963e577$var$fg && $61a884290963e577$var$jg());
    }
}
function $61a884290963e577$var$Rk(a) {
    null !== $61a884290963e577$var$wk && 0 === $61a884290963e577$var$wk.tag && 0 === ($61a884290963e577$var$K & 6) && $61a884290963e577$var$Hk();
    var b = $61a884290963e577$var$K;
    $61a884290963e577$var$K |= 1;
    var c = $61a884290963e577$var$ok.transition, d = $61a884290963e577$var$C;
    try {
        if ($61a884290963e577$var$ok.transition = null, $61a884290963e577$var$C = 1, a) return a();
    } finally{
        $61a884290963e577$var$C = d, $61a884290963e577$var$ok.transition = c, $61a884290963e577$var$K = b, 0 === ($61a884290963e577$var$K & 6) && $61a884290963e577$var$jg();
    }
}
function $61a884290963e577$var$Hj() {
    $61a884290963e577$var$fj = $61a884290963e577$var$ej.current;
    $61a884290963e577$var$E($61a884290963e577$var$ej);
}
function $61a884290963e577$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $61a884290963e577$var$Gf(c));
    if (null !== $61a884290963e577$var$Y) for(c = $61a884290963e577$var$Y.return; null !== c;){
        var d = c;
        $61a884290963e577$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $61a884290963e577$var$$f();
                break;
            case 3:
                $61a884290963e577$var$zh();
                $61a884290963e577$var$E($61a884290963e577$var$Wf);
                $61a884290963e577$var$E($61a884290963e577$var$H);
                $61a884290963e577$var$Eh();
                break;
            case 5:
                $61a884290963e577$var$Bh(d);
                break;
            case 4:
                $61a884290963e577$var$zh();
                break;
            case 13:
                $61a884290963e577$var$E($61a884290963e577$var$L);
                break;
            case 19:
                $61a884290963e577$var$E($61a884290963e577$var$L);
                break;
            case 10:
                $61a884290963e577$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $61a884290963e577$var$Hj();
        }
        c = c.return;
    }
    $61a884290963e577$var$Q = a;
    $61a884290963e577$var$Y = a = $61a884290963e577$var$Pg(a.current, null);
    $61a884290963e577$var$Z = $61a884290963e577$var$fj = b;
    $61a884290963e577$var$T = 0;
    $61a884290963e577$var$pk = null;
    $61a884290963e577$var$rk = $61a884290963e577$var$qk = $61a884290963e577$var$rh = 0;
    $61a884290963e577$var$tk = $61a884290963e577$var$sk = null;
    if (null !== $61a884290963e577$var$fh) {
        for(b = 0; b < $61a884290963e577$var$fh.length; b++)if (c = $61a884290963e577$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $61a884290963e577$var$fh = null;
    }
    return a;
}
function $61a884290963e577$var$Mk(a, b) {
    do {
        var c = $61a884290963e577$var$Y;
        try {
            $61a884290963e577$var$$g();
            $61a884290963e577$var$Fh.current = $61a884290963e577$var$Rh;
            if ($61a884290963e577$var$Ih) {
                for(var d = $61a884290963e577$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $61a884290963e577$var$Ih = !1;
            }
            $61a884290963e577$var$Hh = 0;
            $61a884290963e577$var$O = $61a884290963e577$var$N = $61a884290963e577$var$M = null;
            $61a884290963e577$var$Jh = !1;
            $61a884290963e577$var$Kh = 0;
            $61a884290963e577$var$nk.current = null;
            if (null === c || null === c.return) {
                $61a884290963e577$var$T = 1;
                $61a884290963e577$var$pk = b;
                $61a884290963e577$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $61a884290963e577$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $61a884290963e577$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $61a884290963e577$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $61a884290963e577$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $61a884290963e577$var$Si(f, l, b);
                            $61a884290963e577$var$tj();
                            break a;
                        }
                        k = Error($61a884290963e577$var$p(426));
                    }
                } else if ($61a884290963e577$var$I && h.mode & 1) {
                    var J = $61a884290963e577$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $61a884290963e577$var$Vi(J, g, h, f, b);
                        $61a884290963e577$var$Jg($61a884290963e577$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $61a884290963e577$var$Ji(k, h);
                4 !== $61a884290963e577$var$T && ($61a884290963e577$var$T = 2);
                null === $61a884290963e577$var$sk ? $61a884290963e577$var$sk = [
                    f
                ] : $61a884290963e577$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $61a884290963e577$var$Ni(f, k, b);
                            $61a884290963e577$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $61a884290963e577$var$Ri || !$61a884290963e577$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $61a884290963e577$var$Qi(f, h, b);
                                $61a884290963e577$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $61a884290963e577$var$Sk(c);
        } catch (na) {
            b = na;
            $61a884290963e577$var$Y === c && null !== c && ($61a884290963e577$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $61a884290963e577$var$Jk() {
    var a = $61a884290963e577$var$mk.current;
    $61a884290963e577$var$mk.current = $61a884290963e577$var$Rh;
    return null === a ? $61a884290963e577$var$Rh : a;
}
function $61a884290963e577$var$tj() {
    if (0 === $61a884290963e577$var$T || 3 === $61a884290963e577$var$T || 2 === $61a884290963e577$var$T) $61a884290963e577$var$T = 4;
    null === $61a884290963e577$var$Q || 0 === ($61a884290963e577$var$rh & 268435455) && 0 === ($61a884290963e577$var$qk & 268435455) || $61a884290963e577$var$Ck($61a884290963e577$var$Q, $61a884290963e577$var$Z);
}
function $61a884290963e577$var$Ik(a, b) {
    var c = $61a884290963e577$var$K;
    $61a884290963e577$var$K |= 2;
    var d = $61a884290963e577$var$Jk();
    if ($61a884290963e577$var$Q !== a || $61a884290963e577$var$Z !== b) $61a884290963e577$var$uk = null, $61a884290963e577$var$Kk(a, b);
    for(;;)try {
        $61a884290963e577$var$Tk();
        break;
    } catch (e) {
        $61a884290963e577$var$Mk(a, e);
    }
    $61a884290963e577$var$$g();
    $61a884290963e577$var$K = c;
    $61a884290963e577$var$mk.current = d;
    if (null !== $61a884290963e577$var$Y) throw Error($61a884290963e577$var$p(261));
    $61a884290963e577$var$Q = null;
    $61a884290963e577$var$Z = 0;
    return $61a884290963e577$var$T;
}
function $61a884290963e577$var$Tk() {
    for(; null !== $61a884290963e577$var$Y;)$61a884290963e577$var$Uk($61a884290963e577$var$Y);
}
function $61a884290963e577$var$Lk() {
    for(; null !== $61a884290963e577$var$Y && !$61a884290963e577$var$cc();)$61a884290963e577$var$Uk($61a884290963e577$var$Y);
}
function $61a884290963e577$var$Uk(a) {
    var b = $61a884290963e577$var$Vk(a.alternate, a, $61a884290963e577$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $61a884290963e577$var$Sk(a) : $61a884290963e577$var$Y = b;
    $61a884290963e577$var$nk.current = null;
}
function $61a884290963e577$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $61a884290963e577$var$Ej(c, b, $61a884290963e577$var$fj), null !== c) {
                $61a884290963e577$var$Y = c;
                return;
            }
        } else {
            c = $61a884290963e577$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $61a884290963e577$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $61a884290963e577$var$T = 6;
                $61a884290963e577$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $61a884290963e577$var$Y = b;
            return;
        }
        $61a884290963e577$var$Y = b = a;
    }while (null !== b);
    0 === $61a884290963e577$var$T && ($61a884290963e577$var$T = 5);
}
function $61a884290963e577$var$Pk(a, b, c) {
    var d = $61a884290963e577$var$C, e = $61a884290963e577$var$ok.transition;
    try {
        $61a884290963e577$var$ok.transition = null, $61a884290963e577$var$C = 1, $61a884290963e577$var$Wk(a, b, c, d);
    } finally{
        $61a884290963e577$var$ok.transition = e, $61a884290963e577$var$C = d;
    }
    return null;
}
function $61a884290963e577$var$Wk(a, b, c, d) {
    do $61a884290963e577$var$Hk();
    while (null !== $61a884290963e577$var$wk);
    if (0 !== ($61a884290963e577$var$K & 6)) throw Error($61a884290963e577$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($61a884290963e577$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $61a884290963e577$var$Bc(a, f);
    a === $61a884290963e577$var$Q && ($61a884290963e577$var$Y = $61a884290963e577$var$Q = null, $61a884290963e577$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $61a884290963e577$var$vk || ($61a884290963e577$var$vk = !0, $61a884290963e577$var$Fk($61a884290963e577$var$hc, function() {
        $61a884290963e577$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $61a884290963e577$var$ok.transition;
        $61a884290963e577$var$ok.transition = null;
        var g = $61a884290963e577$var$C;
        $61a884290963e577$var$C = 1;
        var h = $61a884290963e577$var$K;
        $61a884290963e577$var$K |= 4;
        $61a884290963e577$var$nk.current = null;
        $61a884290963e577$var$Oj(a, c);
        $61a884290963e577$var$dk(c, a);
        $61a884290963e577$var$Oe($61a884290963e577$var$Df);
        $61a884290963e577$var$dd = !!$61a884290963e577$var$Cf;
        $61a884290963e577$var$Df = $61a884290963e577$var$Cf = null;
        a.current = c;
        $61a884290963e577$var$hk(c, a, e);
        $61a884290963e577$var$dc();
        $61a884290963e577$var$K = h;
        $61a884290963e577$var$C = g;
        $61a884290963e577$var$ok.transition = f;
    } else a.current = c;
    $61a884290963e577$var$vk && ($61a884290963e577$var$vk = !1, $61a884290963e577$var$wk = a, $61a884290963e577$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($61a884290963e577$var$Ri = null);
    $61a884290963e577$var$mc(c.stateNode, d);
    $61a884290963e577$var$Dk(a, $61a884290963e577$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($61a884290963e577$var$Oi) throw $61a884290963e577$var$Oi = !1, a = $61a884290963e577$var$Pi, $61a884290963e577$var$Pi = null, a;
    0 !== ($61a884290963e577$var$xk & 1) && 0 !== a.tag && $61a884290963e577$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $61a884290963e577$var$zk ? $61a884290963e577$var$yk++ : ($61a884290963e577$var$yk = 0, $61a884290963e577$var$zk = a) : $61a884290963e577$var$yk = 0;
    $61a884290963e577$var$jg();
    return null;
}
function $61a884290963e577$var$Hk() {
    if (null !== $61a884290963e577$var$wk) {
        var a = $61a884290963e577$var$Dc($61a884290963e577$var$xk), b = $61a884290963e577$var$ok.transition, c = $61a884290963e577$var$C;
        try {
            $61a884290963e577$var$ok.transition = null;
            $61a884290963e577$var$C = 16 > a ? 16 : a;
            if (null === $61a884290963e577$var$wk) var d = !1;
            else {
                a = $61a884290963e577$var$wk;
                $61a884290963e577$var$wk = null;
                $61a884290963e577$var$xk = 0;
                if (0 !== ($61a884290963e577$var$K & 6)) throw Error($61a884290963e577$var$p(331));
                var e = $61a884290963e577$var$K;
                $61a884290963e577$var$K |= 4;
                for($61a884290963e577$var$V = a.current; null !== $61a884290963e577$var$V;){
                    var f = $61a884290963e577$var$V, g = f.child;
                    if (0 !== ($61a884290963e577$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($61a884290963e577$var$V = l; null !== $61a884290963e577$var$V;){
                                    var m = $61a884290963e577$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $61a884290963e577$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $61a884290963e577$var$V = q;
                                    else for(; null !== $61a884290963e577$var$V;){
                                        m = $61a884290963e577$var$V;
                                        var r = m.sibling, y = m.return;
                                        $61a884290963e577$var$Sj(m);
                                        if (m === l) {
                                            $61a884290963e577$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $61a884290963e577$var$V = r;
                                            break;
                                        }
                                        $61a884290963e577$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $61a884290963e577$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $61a884290963e577$var$V = g;
                    else b: for(; null !== $61a884290963e577$var$V;){
                        f = $61a884290963e577$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $61a884290963e577$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $61a884290963e577$var$V = x;
                            break b;
                        }
                        $61a884290963e577$var$V = f.return;
                    }
                }
                var w = a.current;
                for($61a884290963e577$var$V = w; null !== $61a884290963e577$var$V;){
                    g = $61a884290963e577$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $61a884290963e577$var$V = u;
                    else b: for(g = w; null !== $61a884290963e577$var$V;){
                        h = $61a884290963e577$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $61a884290963e577$var$Qj(9, h);
                            }
                        } catch (na) {
                            $61a884290963e577$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $61a884290963e577$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $61a884290963e577$var$V = F;
                            break b;
                        }
                        $61a884290963e577$var$V = h.return;
                    }
                }
                $61a884290963e577$var$K = e;
                $61a884290963e577$var$jg();
                if ($61a884290963e577$var$lc && "function" === typeof $61a884290963e577$var$lc.onPostCommitFiberRoot) try {
                    $61a884290963e577$var$lc.onPostCommitFiberRoot($61a884290963e577$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $61a884290963e577$var$C = c, $61a884290963e577$var$ok.transition = b;
        }
    }
    return !1;
}
function $61a884290963e577$var$Xk(a, b, c) {
    b = $61a884290963e577$var$Ji(c, b);
    b = $61a884290963e577$var$Ni(a, b, 1);
    a = $61a884290963e577$var$nh(a, b, 1);
    b = $61a884290963e577$var$R();
    null !== a && ($61a884290963e577$var$Ac(a, 1, b), $61a884290963e577$var$Dk(a, b));
}
function $61a884290963e577$var$W(a, b, c) {
    if (3 === a.tag) $61a884290963e577$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $61a884290963e577$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $61a884290963e577$var$Ri || !$61a884290963e577$var$Ri.has(d))) {
                a = $61a884290963e577$var$Ji(c, a);
                a = $61a884290963e577$var$Qi(b, a, 1);
                b = $61a884290963e577$var$nh(b, a, 1);
                a = $61a884290963e577$var$R();
                null !== b && ($61a884290963e577$var$Ac(b, 1, a), $61a884290963e577$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $61a884290963e577$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $61a884290963e577$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $61a884290963e577$var$Q === a && ($61a884290963e577$var$Z & c) === c && (4 === $61a884290963e577$var$T || 3 === $61a884290963e577$var$T && ($61a884290963e577$var$Z & 130023424) === $61a884290963e577$var$Z && 500 > $61a884290963e577$var$B() - $61a884290963e577$var$fk ? $61a884290963e577$var$Kk(a, 0) : $61a884290963e577$var$rk |= c);
    $61a884290963e577$var$Dk(a, b);
}
function $61a884290963e577$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $61a884290963e577$var$sc, $61a884290963e577$var$sc <<= 1, 0 === ($61a884290963e577$var$sc & 130023424) && ($61a884290963e577$var$sc = 4194304)));
    var c = $61a884290963e577$var$R();
    a = $61a884290963e577$var$ih(a, b);
    null !== a && ($61a884290963e577$var$Ac(a, b, c), $61a884290963e577$var$Dk(a, c));
}
function $61a884290963e577$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $61a884290963e577$var$Yk(a, c);
}
function $61a884290963e577$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($61a884290963e577$var$p(314));
    }
    null !== d && d.delete(b);
    $61a884290963e577$var$Yk(a, c);
}
var $61a884290963e577$var$Vk;
$61a884290963e577$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $61a884290963e577$var$Wf.current) $61a884290963e577$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $61a884290963e577$var$dh = !1, $61a884290963e577$var$yj(a, b, c);
            $61a884290963e577$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $61a884290963e577$var$dh = !1, $61a884290963e577$var$I && 0 !== (b.flags & 1048576) && $61a884290963e577$var$ug(b, $61a884290963e577$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $61a884290963e577$var$ij(a, b);
            a = b.pendingProps;
            var e = $61a884290963e577$var$Yf(b, $61a884290963e577$var$H.current);
            $61a884290963e577$var$ch(b, c);
            e = $61a884290963e577$var$Nh(null, b, d, a, e, c);
            var f = $61a884290963e577$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $61a884290963e577$var$Zf(d) ? (f = !0, $61a884290963e577$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $61a884290963e577$var$kh(b), e.updater = $61a884290963e577$var$Ei, b.stateNode = e, e._reactInternals = b, $61a884290963e577$var$Ii(b, d, a, c), b = $61a884290963e577$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $61a884290963e577$var$I && f && $61a884290963e577$var$vg(b), $61a884290963e577$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $61a884290963e577$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $61a884290963e577$var$Zk(d);
                a = $61a884290963e577$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $61a884290963e577$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $61a884290963e577$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $61a884290963e577$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $61a884290963e577$var$$i(null, b, d, $61a884290963e577$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($61a884290963e577$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $61a884290963e577$var$Ci(d, e), $61a884290963e577$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $61a884290963e577$var$Ci(d, e), $61a884290963e577$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $61a884290963e577$var$kj(b);
                if (null === a) throw Error($61a884290963e577$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $61a884290963e577$var$lh(a, b);
                $61a884290963e577$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $61a884290963e577$var$Ji(Error($61a884290963e577$var$p(423)), b);
                        b = $61a884290963e577$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $61a884290963e577$var$Ji(Error($61a884290963e577$var$p(424)), b);
                        b = $61a884290963e577$var$lj(a, b, d, c, e);
                        break a;
                    } else for($61a884290963e577$var$yg = $61a884290963e577$var$Lf(b.stateNode.containerInfo.firstChild), $61a884290963e577$var$xg = b, $61a884290963e577$var$I = !0, $61a884290963e577$var$zg = null, c = $61a884290963e577$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $61a884290963e577$var$Ig();
                    if (d === e) {
                        b = $61a884290963e577$var$Zi(a, b, c);
                        break a;
                    }
                    $61a884290963e577$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $61a884290963e577$var$Ah(b), null === a && $61a884290963e577$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $61a884290963e577$var$Ef(d, e) ? g = null : null !== f && $61a884290963e577$var$Ef(d, f) && (b.flags |= 32), $61a884290963e577$var$gj(a, b), $61a884290963e577$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $61a884290963e577$var$Eg(b), null;
        case 13:
            return $61a884290963e577$var$oj(a, b, c);
        case 4:
            return $61a884290963e577$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $61a884290963e577$var$Ug(b, null, d, c) : $61a884290963e577$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $61a884290963e577$var$Ci(d, e), $61a884290963e577$var$Yi(a, b, d, e, c);
        case 7:
            return $61a884290963e577$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $61a884290963e577$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $61a884290963e577$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $61a884290963e577$var$G($61a884290963e577$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($61a884290963e577$var$He(f.value, g)) {
                        if (f.children === e.children && !$61a884290963e577$var$Wf.current) {
                            b = $61a884290963e577$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $61a884290963e577$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $61a884290963e577$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($61a884290963e577$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $61a884290963e577$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $61a884290963e577$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $61a884290963e577$var$ch(b, c), e = $61a884290963e577$var$eh(e), d = d(e), b.flags |= 1, $61a884290963e577$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $61a884290963e577$var$Ci(d, b.pendingProps), e = $61a884290963e577$var$Ci(d.type, e), $61a884290963e577$var$$i(a, b, d, e, c);
        case 15:
            return $61a884290963e577$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $61a884290963e577$var$Ci(d, e), $61a884290963e577$var$ij(a, b), b.tag = 1, $61a884290963e577$var$Zf(d) ? (a = !0, $61a884290963e577$var$cg(b)) : a = !1, $61a884290963e577$var$ch(b, c), $61a884290963e577$var$Gi(b, d, e), $61a884290963e577$var$Ii(b, d, e, c), $61a884290963e577$var$jj(null, b, d, !0, a, c);
        case 19:
            return $61a884290963e577$var$xj(a, b, c);
        case 22:
            return $61a884290963e577$var$dj(a, b, c);
    }
    throw Error($61a884290963e577$var$p(156, b.tag));
};
function $61a884290963e577$var$Fk(a, b) {
    return $61a884290963e577$var$ac(a, b);
}
function $61a884290963e577$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $61a884290963e577$var$Bg(a, b, c, d) {
    return new $61a884290963e577$var$$k(a, b, c, d);
}
function $61a884290963e577$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $61a884290963e577$var$Zk(a) {
    if ("function" === typeof a) return $61a884290963e577$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $61a884290963e577$var$Da) return 11;
        if (a === $61a884290963e577$var$Ga) return 14;
    }
    return 2;
}
function $61a884290963e577$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $61a884290963e577$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $61a884290963e577$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $61a884290963e577$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $61a884290963e577$var$ya:
            return $61a884290963e577$var$Tg(c.children, e, f, b);
        case $61a884290963e577$var$za:
            g = 8;
            e |= 8;
            break;
        case $61a884290963e577$var$Aa:
            return a = $61a884290963e577$var$Bg(12, c, b, e | 2), a.elementType = $61a884290963e577$var$Aa, a.lanes = f, a;
        case $61a884290963e577$var$Ea:
            return a = $61a884290963e577$var$Bg(13, c, b, e), a.elementType = $61a884290963e577$var$Ea, a.lanes = f, a;
        case $61a884290963e577$var$Fa:
            return a = $61a884290963e577$var$Bg(19, c, b, e), a.elementType = $61a884290963e577$var$Fa, a.lanes = f, a;
        case $61a884290963e577$var$Ia:
            return $61a884290963e577$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $61a884290963e577$var$Ba:
                    g = 10;
                    break a;
                case $61a884290963e577$var$Ca:
                    g = 9;
                    break a;
                case $61a884290963e577$var$Da:
                    g = 11;
                    break a;
                case $61a884290963e577$var$Ga:
                    g = 14;
                    break a;
                case $61a884290963e577$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($61a884290963e577$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $61a884290963e577$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $61a884290963e577$var$Tg(a, b, c, d) {
    a = $61a884290963e577$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $61a884290963e577$var$pj(a, b, c, d) {
    a = $61a884290963e577$var$Bg(22, a, d, b);
    a.elementType = $61a884290963e577$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $61a884290963e577$var$Qg(a, b, c) {
    a = $61a884290963e577$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $61a884290963e577$var$Sg(a, b, c) {
    b = $61a884290963e577$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $61a884290963e577$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $61a884290963e577$var$zc(0);
    this.expirationTimes = $61a884290963e577$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $61a884290963e577$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $61a884290963e577$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $61a884290963e577$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $61a884290963e577$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $61a884290963e577$var$kh(f);
    return a;
}
function $61a884290963e577$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $61a884290963e577$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $61a884290963e577$var$dl(a) {
    if (!a) return $61a884290963e577$var$Vf;
    a = a._reactInternals;
    a: {
        if ($61a884290963e577$var$Vb(a) !== a || 1 !== a.tag) throw Error($61a884290963e577$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($61a884290963e577$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($61a884290963e577$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($61a884290963e577$var$Zf(c)) return $61a884290963e577$var$bg(a, c, b);
    }
    return b;
}
function $61a884290963e577$var$el(a, b, c, d, e, f, g, h, k) {
    a = $61a884290963e577$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $61a884290963e577$var$dl(null);
    c = a.current;
    d = $61a884290963e577$var$R();
    e = $61a884290963e577$var$yi(c);
    f = $61a884290963e577$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $61a884290963e577$var$nh(c, f, e);
    a.current.lanes = e;
    $61a884290963e577$var$Ac(a, e, d);
    $61a884290963e577$var$Dk(a, d);
    return a;
}
function $61a884290963e577$var$fl(a, b, c, d) {
    var e = b.current, f = $61a884290963e577$var$R(), g = $61a884290963e577$var$yi(e);
    c = $61a884290963e577$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $61a884290963e577$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $61a884290963e577$var$nh(e, b, g);
    null !== a && ($61a884290963e577$var$gi(a, e, g, f), $61a884290963e577$var$oh(a, e, g));
    return g;
}
function $61a884290963e577$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $61a884290963e577$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $61a884290963e577$var$il(a, b) {
    $61a884290963e577$var$hl(a, b);
    (a = a.alternate) && $61a884290963e577$var$hl(a, b);
}
function $61a884290963e577$var$jl() {
    return null;
}
var $61a884290963e577$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $61a884290963e577$var$ll(a) {
    this._internalRoot = a;
}
$61a884290963e577$var$ml.prototype.render = $61a884290963e577$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($61a884290963e577$var$p(409));
    $61a884290963e577$var$fl(a, b, null, null);
};
$61a884290963e577$var$ml.prototype.unmount = $61a884290963e577$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $61a884290963e577$var$Rk(function() {
            $61a884290963e577$var$fl(null, a, null, null);
        });
        b[$61a884290963e577$var$uf] = null;
    }
};
function $61a884290963e577$var$ml(a) {
    this._internalRoot = a;
}
$61a884290963e577$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $61a884290963e577$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $61a884290963e577$var$Qc.length && 0 !== b && b < $61a884290963e577$var$Qc[c].priority; c++);
        $61a884290963e577$var$Qc.splice(c, 0, a);
        0 === c && $61a884290963e577$var$Vc(a);
    }
};
function $61a884290963e577$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $61a884290963e577$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $61a884290963e577$var$pl() {}
function $61a884290963e577$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $61a884290963e577$var$gl(g);
                f.call(a);
            };
        }
        var g = $61a884290963e577$var$el(b, d, a, 0, null, !1, !1, "", $61a884290963e577$var$pl);
        a._reactRootContainer = g;
        a[$61a884290963e577$var$uf] = g.current;
        $61a884290963e577$var$sf(8 === a.nodeType ? a.parentNode : a);
        $61a884290963e577$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $61a884290963e577$var$gl(k);
            h.call(a);
        };
    }
    var k = $61a884290963e577$var$bl(a, 0, !1, null, null, !1, !1, "", $61a884290963e577$var$pl);
    a._reactRootContainer = k;
    a[$61a884290963e577$var$uf] = k.current;
    $61a884290963e577$var$sf(8 === a.nodeType ? a.parentNode : a);
    $61a884290963e577$var$Rk(function() {
        $61a884290963e577$var$fl(b, k, c, d);
    });
    return k;
}
function $61a884290963e577$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $61a884290963e577$var$gl(g);
                h.call(a);
            };
        }
        $61a884290963e577$var$fl(b, g, a, e);
    } else g = $61a884290963e577$var$ql(c, b, a, e, d);
    return $61a884290963e577$var$gl(g);
}
$61a884290963e577$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $61a884290963e577$var$tc(b.pendingLanes);
                0 !== c && ($61a884290963e577$var$Cc(b, c | 1), $61a884290963e577$var$Dk(b, $61a884290963e577$var$B()), 0 === ($61a884290963e577$var$K & 6) && ($61a884290963e577$var$Gj = $61a884290963e577$var$B() + 500, $61a884290963e577$var$jg()));
            }
            break;
        case 13:
            $61a884290963e577$var$Rk(function() {
                var b = $61a884290963e577$var$ih(a, 1);
                if (null !== b) {
                    var c = $61a884290963e577$var$R();
                    $61a884290963e577$var$gi(b, a, 1, c);
                }
            }), $61a884290963e577$var$il(a, 1);
    }
};
$61a884290963e577$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $61a884290963e577$var$ih(a, 134217728);
        if (null !== b) {
            var c = $61a884290963e577$var$R();
            $61a884290963e577$var$gi(b, a, 134217728, c);
        }
        $61a884290963e577$var$il(a, 134217728);
    }
};
$61a884290963e577$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $61a884290963e577$var$yi(a), c = $61a884290963e577$var$ih(a, b);
        if (null !== c) {
            var d = $61a884290963e577$var$R();
            $61a884290963e577$var$gi(c, a, b, d);
        }
        $61a884290963e577$var$il(a, b);
    }
};
$61a884290963e577$var$Hc = function() {
    return $61a884290963e577$var$C;
};
$61a884290963e577$var$Ic = function(a, b) {
    var c = $61a884290963e577$var$C;
    try {
        return $61a884290963e577$var$C = a, b();
    } finally{
        $61a884290963e577$var$C = c;
    }
};
$61a884290963e577$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $61a884290963e577$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $61a884290963e577$var$Db(d);
                        if (!e) throw Error($61a884290963e577$var$p(90));
                        $61a884290963e577$var$Wa(d);
                        $61a884290963e577$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $61a884290963e577$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $61a884290963e577$var$fb(a, !!c.multiple, b, !1);
    }
};
$61a884290963e577$var$Gb = $61a884290963e577$var$Qk;
$61a884290963e577$var$Hb = $61a884290963e577$var$Rk;
var $61a884290963e577$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $61a884290963e577$var$Cb,
        $61a884290963e577$var$ue,
        $61a884290963e577$var$Db,
        $61a884290963e577$var$Eb,
        $61a884290963e577$var$Fb,
        $61a884290963e577$var$Qk
    ]
}, $61a884290963e577$var$tl = {
    findFiberByHostInstance: $61a884290963e577$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $61a884290963e577$var$ul = {
    bundleType: $61a884290963e577$var$tl.bundleType,
    version: $61a884290963e577$var$tl.version,
    rendererPackageName: $61a884290963e577$var$tl.rendererPackageName,
    rendererConfig: $61a884290963e577$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $61a884290963e577$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $61a884290963e577$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $61a884290963e577$var$tl.findFiberByHostInstance || $61a884290963e577$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $61a884290963e577$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$61a884290963e577$var$vl.isDisabled && $61a884290963e577$var$vl.supportsFiber) try {
        $61a884290963e577$var$kc = $61a884290963e577$var$vl.inject($61a884290963e577$var$ul), $61a884290963e577$var$lc = $61a884290963e577$var$vl;
    } catch (a) {}
}
$61a884290963e577$export$ae55be85d98224ed = $61a884290963e577$var$sl;
$61a884290963e577$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$61a884290963e577$var$nl(b)) throw Error($61a884290963e577$var$p(200));
    return $61a884290963e577$var$cl(a, b, null, c);
};
$61a884290963e577$export$882461b6382ed46c = function(a, b) {
    if (!$61a884290963e577$var$nl(a)) throw Error($61a884290963e577$var$p(299));
    var c = !1, d = "", e = $61a884290963e577$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $61a884290963e577$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$61a884290963e577$var$uf] = b.current;
    $61a884290963e577$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $61a884290963e577$var$ll(b);
};
$61a884290963e577$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($61a884290963e577$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($61a884290963e577$var$p(268, a));
    }
    a = $61a884290963e577$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$61a884290963e577$export$cd75ccfd720a3cd4 = function(a) {
    return $61a884290963e577$var$Rk(a);
};
$61a884290963e577$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$61a884290963e577$var$ol(b)) throw Error($61a884290963e577$var$p(200));
    return $61a884290963e577$var$rl(null, a, b, !0, c);
};
$61a884290963e577$export$757ceba2d55c277e = function(a, b, c) {
    if (!$61a884290963e577$var$nl(a)) throw Error($61a884290963e577$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $61a884290963e577$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $61a884290963e577$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$61a884290963e577$var$uf] = b.current;
    $61a884290963e577$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $61a884290963e577$var$ml(b);
};
$61a884290963e577$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$61a884290963e577$var$ol(b)) throw Error($61a884290963e577$var$p(200));
    return $61a884290963e577$var$rl(null, a, b, !1, c);
};
$61a884290963e577$export$502457920280e6be = function(a) {
    if (!$61a884290963e577$var$ol(a)) throw Error($61a884290963e577$var$p(40));
    return a._reactRootContainer ? ($61a884290963e577$var$Rk(function() {
        $61a884290963e577$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$61a884290963e577$var$uf] = null;
        });
    }), !0) : !1;
};
$61a884290963e577$export$c78a37762a8d58e1 = $61a884290963e577$var$Qk;
$61a884290963e577$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$61a884290963e577$var$ol(c)) throw Error($61a884290963e577$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($61a884290963e577$var$p(38));
    return $61a884290963e577$var$rl(a, b, c, !1, d);
};
$61a884290963e577$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("hCCIz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jnwmm"));

});
parcelRegister("jnwmm", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e1b9443b5579d80d$export$c4744153514ff05d; }, function (v) { return $e1b9443b5579d80d$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e1b9443b5579d80d$export$3e506c1ccc9cc1a7; }, function (v) { return $e1b9443b5579d80d$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e1b9443b5579d80d$export$e26fe2ed2fa76875; }, function (v) { return $e1b9443b5579d80d$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e1b9443b5579d80d$export$502329bbf4b505b1; }, function (v) { return $e1b9443b5579d80d$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e1b9443b5579d80d$export$6e3807111c4874c4; }, function (v) { return $e1b9443b5579d80d$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e1b9443b5579d80d$export$c27134553091fb3a; }, function (v) { return $e1b9443b5579d80d$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e1b9443b5579d80d$export$33ee1acdc04fd2a2; }, function (v) { return $e1b9443b5579d80d$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e1b9443b5579d80d$export$b00a404bbd5edef2; }, function (v) { return $e1b9443b5579d80d$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e1b9443b5579d80d$export$8352ce38b91d0c62; }, function (v) { return $e1b9443b5579d80d$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e1b9443b5579d80d$export$d66a1c1c77bd778b; }, function (v) { return $e1b9443b5579d80d$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e1b9443b5579d80d$export$d3dfb8e4810cb555; }, function (v) { return $e1b9443b5579d80d$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e1b9443b5579d80d$export$839f9183b0465a69; }, function (v) { return $e1b9443b5579d80d$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e1b9443b5579d80d$export$72fdf0e06517287b; }, function (v) { return $e1b9443b5579d80d$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e1b9443b5579d80d$export$4b844e58a3e414b4; }, function (v) { return $e1b9443b5579d80d$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e1b9443b5579d80d$export$816d2913ae6b83b1; }, function (v) { return $e1b9443b5579d80d$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e1b9443b5579d80d$export$61bcfe829111a1d0; }, function (v) { return $e1b9443b5579d80d$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e1b9443b5579d80d$export$7ee8c9beb337bc3f; }, function (v) { return $e1b9443b5579d80d$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e1b9443b5579d80d$export$b5836b71941fa3ed; }, function (v) { return $e1b9443b5579d80d$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e1b9443b5579d80d$export$cf845f2c119da08a; }, function (v) { return $e1b9443b5579d80d$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e1b9443b5579d80d$export$c4744153514ff05d;
var $e1b9443b5579d80d$export$3e506c1ccc9cc1a7;
var $e1b9443b5579d80d$export$e26fe2ed2fa76875;
var $e1b9443b5579d80d$export$502329bbf4b505b1;
var $e1b9443b5579d80d$export$6e3807111c4874c4;
var $e1b9443b5579d80d$export$c27134553091fb3a;
var $e1b9443b5579d80d$export$33ee1acdc04fd2a2;
var $e1b9443b5579d80d$export$b00a404bbd5edef2;
var $e1b9443b5579d80d$export$8352ce38b91d0c62;
var $e1b9443b5579d80d$export$d66a1c1c77bd778b;
var $e1b9443b5579d80d$export$d3dfb8e4810cb555;
var $e1b9443b5579d80d$export$839f9183b0465a69;
var $e1b9443b5579d80d$export$72fdf0e06517287b;
var $e1b9443b5579d80d$export$4b844e58a3e414b4;
var $e1b9443b5579d80d$export$816d2913ae6b83b1;
var $e1b9443b5579d80d$export$61bcfe829111a1d0;
var $e1b9443b5579d80d$export$7ee8c9beb337bc3f;
var $e1b9443b5579d80d$export$b5836b71941fa3ed;
var $e1b9443b5579d80d$export$cf845f2c119da08a;
'use strict';
function $e1b9443b5579d80d$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e1b9443b5579d80d$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e1b9443b5579d80d$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e1b9443b5579d80d$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e1b9443b5579d80d$var$g(C, c)) n < e && 0 > $e1b9443b5579d80d$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e1b9443b5579d80d$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e1b9443b5579d80d$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e1b9443b5579d80d$var$l = performance;
    $e1b9443b5579d80d$export$c4744153514ff05d = function() {
        return $e1b9443b5579d80d$var$l.now();
    };
} else {
    var $e1b9443b5579d80d$var$p = Date, $e1b9443b5579d80d$var$q = $e1b9443b5579d80d$var$p.now();
    $e1b9443b5579d80d$export$c4744153514ff05d = function() {
        return $e1b9443b5579d80d$var$p.now() - $e1b9443b5579d80d$var$q;
    };
}
var $e1b9443b5579d80d$var$r = [], $e1b9443b5579d80d$var$t = [], $e1b9443b5579d80d$var$u = 1, $e1b9443b5579d80d$var$v = null, $e1b9443b5579d80d$var$y = 3, $e1b9443b5579d80d$var$z = !1, $e1b9443b5579d80d$var$A = !1, $e1b9443b5579d80d$var$B = !1, $e1b9443b5579d80d$var$D = "function" === typeof setTimeout ? setTimeout : null, $e1b9443b5579d80d$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e1b9443b5579d80d$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e1b9443b5579d80d$var$G(a) {
    for(var b = $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$t); null !== b;){
        if (null === b.callback) $e1b9443b5579d80d$var$k($e1b9443b5579d80d$var$t);
        else if (b.startTime <= a) $e1b9443b5579d80d$var$k($e1b9443b5579d80d$var$t), b.sortIndex = b.expirationTime, $e1b9443b5579d80d$var$f($e1b9443b5579d80d$var$r, b);
        else break;
        b = $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$t);
    }
}
function $e1b9443b5579d80d$var$H(a) {
    $e1b9443b5579d80d$var$B = !1;
    $e1b9443b5579d80d$var$G(a);
    if (!$e1b9443b5579d80d$var$A) {
        if (null !== $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$r)) $e1b9443b5579d80d$var$A = !0, $e1b9443b5579d80d$var$I($e1b9443b5579d80d$var$J);
        else {
            var b = $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$t);
            null !== b && $e1b9443b5579d80d$var$K($e1b9443b5579d80d$var$H, b.startTime - a);
        }
    }
}
function $e1b9443b5579d80d$var$J(a, b) {
    $e1b9443b5579d80d$var$A = !1;
    $e1b9443b5579d80d$var$B && ($e1b9443b5579d80d$var$B = !1, $e1b9443b5579d80d$var$E($e1b9443b5579d80d$var$L), $e1b9443b5579d80d$var$L = -1);
    $e1b9443b5579d80d$var$z = !0;
    var c = $e1b9443b5579d80d$var$y;
    try {
        $e1b9443b5579d80d$var$G(b);
        for($e1b9443b5579d80d$var$v = $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$r); null !== $e1b9443b5579d80d$var$v && (!($e1b9443b5579d80d$var$v.expirationTime > b) || a && !$e1b9443b5579d80d$var$M());){
            var d = $e1b9443b5579d80d$var$v.callback;
            if ("function" === typeof d) {
                $e1b9443b5579d80d$var$v.callback = null;
                $e1b9443b5579d80d$var$y = $e1b9443b5579d80d$var$v.priorityLevel;
                var e = d($e1b9443b5579d80d$var$v.expirationTime <= b);
                b = $e1b9443b5579d80d$export$c4744153514ff05d();
                "function" === typeof e ? $e1b9443b5579d80d$var$v.callback = e : $e1b9443b5579d80d$var$v === $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$r) && $e1b9443b5579d80d$var$k($e1b9443b5579d80d$var$r);
                $e1b9443b5579d80d$var$G(b);
            } else $e1b9443b5579d80d$var$k($e1b9443b5579d80d$var$r);
            $e1b9443b5579d80d$var$v = $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$r);
        }
        if (null !== $e1b9443b5579d80d$var$v) var w = !0;
        else {
            var m = $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$t);
            null !== m && $e1b9443b5579d80d$var$K($e1b9443b5579d80d$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e1b9443b5579d80d$var$v = null, $e1b9443b5579d80d$var$y = c, $e1b9443b5579d80d$var$z = !1;
    }
}
var $e1b9443b5579d80d$var$N = !1, $e1b9443b5579d80d$var$O = null, $e1b9443b5579d80d$var$L = -1, $e1b9443b5579d80d$var$P = 5, $e1b9443b5579d80d$var$Q = -1;
function $e1b9443b5579d80d$var$M() {
    return $e1b9443b5579d80d$export$c4744153514ff05d() - $e1b9443b5579d80d$var$Q < $e1b9443b5579d80d$var$P ? !1 : !0;
}
function $e1b9443b5579d80d$var$R() {
    if (null !== $e1b9443b5579d80d$var$O) {
        var a = $e1b9443b5579d80d$export$c4744153514ff05d();
        $e1b9443b5579d80d$var$Q = a;
        var b = !0;
        try {
            b = $e1b9443b5579d80d$var$O(!0, a);
        } finally{
            b ? $e1b9443b5579d80d$var$S() : ($e1b9443b5579d80d$var$N = !1, $e1b9443b5579d80d$var$O = null);
        }
    } else $e1b9443b5579d80d$var$N = !1;
}
var $e1b9443b5579d80d$var$S;
if ("function" === typeof $e1b9443b5579d80d$var$F) $e1b9443b5579d80d$var$S = function() {
    $e1b9443b5579d80d$var$F($e1b9443b5579d80d$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e1b9443b5579d80d$var$T = new MessageChannel, $e1b9443b5579d80d$var$U = $e1b9443b5579d80d$var$T.port2;
    $e1b9443b5579d80d$var$T.port1.onmessage = $e1b9443b5579d80d$var$R;
    $e1b9443b5579d80d$var$S = function() {
        $e1b9443b5579d80d$var$U.postMessage(null);
    };
} else $e1b9443b5579d80d$var$S = function() {
    $e1b9443b5579d80d$var$D($e1b9443b5579d80d$var$R, 0);
};
function $e1b9443b5579d80d$var$I(a) {
    $e1b9443b5579d80d$var$O = a;
    $e1b9443b5579d80d$var$N || ($e1b9443b5579d80d$var$N = !0, $e1b9443b5579d80d$var$S());
}
function $e1b9443b5579d80d$var$K(a, b) {
    $e1b9443b5579d80d$var$L = $e1b9443b5579d80d$var$D(function() {
        a($e1b9443b5579d80d$export$c4744153514ff05d());
    }, b);
}
$e1b9443b5579d80d$export$3e506c1ccc9cc1a7 = 5;
$e1b9443b5579d80d$export$e26fe2ed2fa76875 = 1;
$e1b9443b5579d80d$export$502329bbf4b505b1 = 4;
$e1b9443b5579d80d$export$6e3807111c4874c4 = 3;
$e1b9443b5579d80d$export$c27134553091fb3a = null;
$e1b9443b5579d80d$export$33ee1acdc04fd2a2 = 2;
$e1b9443b5579d80d$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e1b9443b5579d80d$export$8352ce38b91d0c62 = function() {
    $e1b9443b5579d80d$var$A || $e1b9443b5579d80d$var$z || ($e1b9443b5579d80d$var$A = !0, $e1b9443b5579d80d$var$I($e1b9443b5579d80d$var$J));
};
$e1b9443b5579d80d$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e1b9443b5579d80d$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e1b9443b5579d80d$export$d3dfb8e4810cb555 = function() {
    return $e1b9443b5579d80d$var$y;
};
$e1b9443b5579d80d$export$839f9183b0465a69 = function() {
    return $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$r);
};
$e1b9443b5579d80d$export$72fdf0e06517287b = function(a) {
    switch($e1b9443b5579d80d$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e1b9443b5579d80d$var$y;
    }
    var c = $e1b9443b5579d80d$var$y;
    $e1b9443b5579d80d$var$y = b;
    try {
        return a();
    } finally{
        $e1b9443b5579d80d$var$y = c;
    }
};
$e1b9443b5579d80d$export$4b844e58a3e414b4 = function() {};
$e1b9443b5579d80d$export$816d2913ae6b83b1 = function() {};
$e1b9443b5579d80d$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e1b9443b5579d80d$var$y;
    $e1b9443b5579d80d$var$y = a;
    try {
        return b();
    } finally{
        $e1b9443b5579d80d$var$y = c;
    }
};
$e1b9443b5579d80d$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e1b9443b5579d80d$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e1b9443b5579d80d$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e1b9443b5579d80d$var$f($e1b9443b5579d80d$var$t, a), null === $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$r) && a === $e1b9443b5579d80d$var$h($e1b9443b5579d80d$var$t) && ($e1b9443b5579d80d$var$B ? ($e1b9443b5579d80d$var$E($e1b9443b5579d80d$var$L), $e1b9443b5579d80d$var$L = -1) : $e1b9443b5579d80d$var$B = !0, $e1b9443b5579d80d$var$K($e1b9443b5579d80d$var$H, c - d))) : (a.sortIndex = e, $e1b9443b5579d80d$var$f($e1b9443b5579d80d$var$r, a), $e1b9443b5579d80d$var$A || $e1b9443b5579d80d$var$z || ($e1b9443b5579d80d$var$A = !0, $e1b9443b5579d80d$var$I($e1b9443b5579d80d$var$J)));
    return a;
};
$e1b9443b5579d80d$export$b5836b71941fa3ed = $e1b9443b5579d80d$var$M;
$e1b9443b5579d80d$export$cf845f2c119da08a = function(a) {
    var b = $e1b9443b5579d80d$var$y;
    return function() {
        var c = $e1b9443b5579d80d$var$y;
        $e1b9443b5579d80d$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e1b9443b5579d80d$var$y = c;
        }
    };
};

});



parcelRegister("i8WYF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $fBba2 = parcelRequire("fBba2");
function $d356b908d629bdff$var$emptyFunction() {}
function $d356b908d629bdff$var$emptyFunctionWithReset() {}
$d356b908d629bdff$var$emptyFunctionWithReset.resetWarningCache = $d356b908d629bdff$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fBba2) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d356b908d629bdff$var$emptyFunctionWithReset,
        resetWarningCache: $d356b908d629bdff$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("fBba2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $b5b2f80609804fec$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $b5b2f80609804fec$var$ReactPropTypesSecret;

});


parcelRegister("kuAZy", function(module, exports) {
"use strict";
var $eeb34dcba5485c31$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $eeb34dcba5485c31$var$PostgrestQueryBuilder_1 = $eeb34dcba5485c31$var$__importDefault((parcelRequire("3XBkd")));

const $eeb34dcba5485c31$var$PostgrestFilterBuilder_1 = $eeb34dcba5485c31$var$__importDefault((parcelRequire("kcIcf")));

var $33WU9 = parcelRequire("33WU9");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class $eeb34dcba5485c31$var$PostgrestClient {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $33WU9.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new $eeb34dcba5485c31$var$PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $eeb34dcba5485c31$var$PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new $eeb34dcba5485c31$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $eeb34dcba5485c31$var$PostgrestClient;

});
parcelRegister("3XBkd", function(module, exports) {
"use strict";
var $2e23d5c98b9a7221$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2e23d5c98b9a7221$var$PostgrestFilterBuilder_1 = $2e23d5c98b9a7221$var$__importDefault((parcelRequire("kcIcf")));
class $2e23d5c98b9a7221$var$PostgrestQueryBuilder {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new $2e23d5c98b9a7221$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $2e23d5c98b9a7221$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $2e23d5c98b9a7221$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $2e23d5c98b9a7221$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $2e23d5c98b9a7221$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $2e23d5c98b9a7221$var$PostgrestQueryBuilder;

});
parcelRegister("kcIcf", function(module, exports) {
"use strict";
var $eb57362373e875dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $eb57362373e875dd$var$PostgrestTransformBuilder_1 = $eb57362373e875dd$var$__importDefault((parcelRequire("k5Niq")));
class $eb57362373e875dd$var$PostgrestFilterBuilder extends $eb57362373e875dd$var$PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
module.exports.default = $eb57362373e875dd$var$PostgrestFilterBuilder;

});
parcelRegister("k5Niq", function(module, exports) {
"use strict";
var $ea0a8377629d54d3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ea0a8377629d54d3$var$PostgrestBuilder_1 = $ea0a8377629d54d3$var$__importDefault((parcelRequire("96pgx")));
class $ea0a8377629d54d3$var$PostgrestTransformBuilder extends $ea0a8377629d54d3$var$PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        return this;
    }
}
module.exports.default = $ea0a8377629d54d3$var$PostgrestTransformBuilder;

});
parcelRegister("96pgx", function(module, exports) {
"use strict";
var $6a0845de9c6b3726$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
const $6a0845de9c6b3726$var$node_fetch_1 = $6a0845de9c6b3726$var$__importDefault((parcelRequire("aLtt3")));

const $6a0845de9c6b3726$var$PostgrestError_1 = $6a0845de9c6b3726$var$__importDefault((parcelRequire("bXeOl")));
class $6a0845de9c6b3726$var$PostgrestBuilder {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $6a0845de9c6b3726$var$node_fetch_1.default;
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new $6a0845de9c6b3726$var$PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
     * Override the type of the returned `data` field in the response.
     *
     * @typeParam NewResult - The new type to cast the response data to
     * @typeParam Options - Optional type configuration (defaults to { merge: true })
     * @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
     * @example
     * ```typescript
     * // Merge with existing types (default behavior)
     * const query = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ custom_field: string }>()
     *
     * // Replace existing types completely
     * const replaceQuery = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ id: number; name: string }, { merge: false }>()
     * ```
     * @returns A PostgrestBuilder instance with the new type
     */ overrideTypes() {
        return this;
    }
}
module.exports.default = $6a0845de9c6b3726$var$PostgrestBuilder;

});
parcelRegister("aLtt3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", function () { return $7d6526cf9419d6aa$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "default", function () { return $7d6526cf9419d6aa$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Headers", function () { return $7d6526cf9419d6aa$export$79b704688b15c0f4; });
$parcel$export(module.exports, "Request", function () { return $7d6526cf9419d6aa$export$7fa6c5b6f8193917; });
$parcel$export(module.exports, "Response", function () { return $7d6526cf9419d6aa$export$9f633d56d7ec90d3; });
"use strict";
// ref: https://github.com/tc39/proposal-global
var $7d6526cf9419d6aa$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $7d6526cf9419d6aa$var$globalObject = $7d6526cf9419d6aa$var$getGlobal();
const $7d6526cf9419d6aa$export$e7aa7bc5c1b3cfb3 = $7d6526cf9419d6aa$var$globalObject.fetch;
var $7d6526cf9419d6aa$export$2e2bcd8739ae039 = $7d6526cf9419d6aa$var$globalObject.fetch.bind($7d6526cf9419d6aa$var$globalObject);
const $7d6526cf9419d6aa$export$79b704688b15c0f4 = $7d6526cf9419d6aa$var$globalObject.Headers;
const $7d6526cf9419d6aa$export$7fa6c5b6f8193917 = $7d6526cf9419d6aa$var$globalObject.Request;
const $7d6526cf9419d6aa$export$9f633d56d7ec90d3 = $7d6526cf9419d6aa$var$globalObject.Response;

});

parcelRegister("bXeOl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class $8b40b1888ab48e61$var$PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
module.exports.default = $8b40b1888ab48e61$var$PostgrestError;

});





parcelRegister("33WU9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $3EYIv = parcelRequire("3EYIv");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${$3EYIv.version}`
};

});
parcelRegister("3EYIv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("laUMG", function(module, exports) {

var $5wFbo = parcelRequire("5wFbo");

var $02yFo = parcelRequire("02yFo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $5wFbo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $02yFo;
module.exports = isBuffer;

});
parcelRegister("5wFbo", function(module, exports) {

var $du2vV = parcelRequire("du2vV");
/** Detect free variable `self`. */ var $405fe2eef54b0275$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $405fe2eef54b0275$var$root = $du2vV || $405fe2eef54b0275$var$freeSelf || Function('return this')();
module.exports = $405fe2eef54b0275$var$root;

});
parcelRegister("du2vV", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $9d1006ec662e7d1f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $9d1006ec662e7d1f$var$freeGlobal;

});


parcelRegister("02yFo", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $007b141d40ee41c0$var$stubFalse() {
    return false;
}
module.exports = $007b141d40ee41c0$var$stubFalse;

});


parcelRegister("7XhJT", function(module, exports) {

var $du2vV = parcelRequire("du2vV");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $du2vV.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("5C2YQ", function(module, exports) {

var $5wFbo = parcelRequire("5wFbo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $5wFbo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

var $05ada4fbf7867a8b$exports = {};
$parcel$extendImportMap({
    "cMf9G": "bootstrap-icons.b902a9f7.svg"
});

var $3d04577e83656c0d$exports = {};
'use strict';

$3d04577e83656c0d$exports = (parcelRequire("jLKiy"));


var $479c90d590bd4fd3$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$479c90d590bd4fd3$exports = (parcelRequire("8UE37"));


const $fc6c683469493657$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $dc5b15e7161e08de$export$31499a9cd224b78c = "10.58.0";


const $19eb101f55ba68c8$export$f1a6cdb1459e81d1 = globalThis;


function $ae40082355c0ca7d$export$19eade501500c6c1() {
    $ae40082355c0ca7d$export$c8bfa33e4e8ae492((0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1));
    return 0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1;
}
function $ae40082355c0ca7d$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $dc5b15e7161e08de$export$31499a9cd224b78c);
    return __SENTRY__[0, $dc5b15e7161e08de$export$31499a9cd224b78c] = __SENTRY__[0, $dc5b15e7161e08de$export$31499a9cd224b78c] || {};
}
function $ae40082355c0ca7d$export$7e223ec222791509(name, creator, obj = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $dc5b15e7161e08de$export$31499a9cd224b78c] = __SENTRY__[0, $dc5b15e7161e08de$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $35da606f4e6c3c2f$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $35da606f4e6c3c2f$var$PREFIX = "Sentry Logger ";
const $35da606f4e6c3c2f$export$77c4ce905194557b = {};
function $35da606f4e6c3c2f$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($35da606f4e6c3c2f$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $35da606f4e6c3c2f$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $35da606f4e6c3c2f$var$enable() {
    $35da606f4e6c3c2f$var$_getLoggerSettings().enabled = true;
}
function $35da606f4e6c3c2f$var$disable() {
    $35da606f4e6c3c2f$var$_getLoggerSettings().enabled = false;
}
function $35da606f4e6c3c2f$var$isEnabled() {
    return $35da606f4e6c3c2f$var$_getLoggerSettings().enabled;
}
function $35da606f4e6c3c2f$var$log(...args) {
    $35da606f4e6c3c2f$var$_maybeLog("log", ...args);
}
function $35da606f4e6c3c2f$var$warn(...args) {
    $35da606f4e6c3c2f$var$_maybeLog("warn", ...args);
}
function $35da606f4e6c3c2f$var$error(...args) {
    $35da606f4e6c3c2f$var$_maybeLog("error", ...args);
}
function $35da606f4e6c3c2f$var$_maybeLog(level, ...args) {
    if (!(0, $fc6c683469493657$export$16a28057038b10ef)) return;
    if ($35da606f4e6c3c2f$var$isEnabled()) $35da606f4e6c3c2f$export$cda52e2a8927a2ca(()=>{
        (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1).console[level](`${$35da606f4e6c3c2f$var$PREFIX}[${level}]:`, ...args);
    });
}
function $35da606f4e6c3c2f$var$_getLoggerSettings() {
    if (!(0, $fc6c683469493657$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $ae40082355c0ca7d$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $35da606f4e6c3c2f$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $35da606f4e6c3c2f$var$enable,
    disable: /** Disable logging. */ $35da606f4e6c3c2f$var$disable,
    isEnabled: /** Check if logging is enabled. */ $35da606f4e6c3c2f$var$isEnabled,
    log: /** Log a message. */ $35da606f4e6c3c2f$var$log,
    warn: /** Log a warning. */ $35da606f4e6c3c2f$var$warn,
    error: /** Log an error. */ $35da606f4e6c3c2f$var$error
};


const $40a6d78e295685ac$var$STACKTRACE_FRAME_LIMIT = 50;
const $40a6d78e295685ac$export$27c7e15d453fc0ac = "?";
const $40a6d78e295685ac$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $40a6d78e295685ac$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $40a6d78e295685ac$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $40a6d78e295685ac$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($40a6d78e295685ac$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $40a6d78e295685ac$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $40a6d78e295685ac$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $40a6d78e295685ac$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $40a6d78e295685ac$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $40a6d78e295685ac$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($40a6d78e295685ac$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($40a6d78e295685ac$var$STRIP_FRAME_REGEXP.test($40a6d78e295685ac$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($40a6d78e295685ac$var$STRIP_FRAME_REGEXP.test($40a6d78e295685ac$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $40a6d78e295685ac$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $40a6d78e295685ac$var$getLastStackFrame(localStack).filename,
            function: frame.function || $40a6d78e295685ac$export$27c7e15d453fc0ac
        }));
}
function $40a6d78e295685ac$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $40a6d78e295685ac$var$defaultFunctionName = "<anonymous>";
function $40a6d78e295685ac$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $40a6d78e295685ac$var$defaultFunctionName;
        return fn.name || $40a6d78e295685ac$var$defaultFunctionName;
    } catch  {
        return $40a6d78e295685ac$var$defaultFunctionName;
    }
}
function $40a6d78e295685ac$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $40a6d78e295685ac$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


const $eba7c8bf7b81317f$var$handlers = {};
const $eba7c8bf7b81317f$var$instrumented = {};
function $eba7c8bf7b81317f$export$a4e09611e30da72e(type, handler) {
    $eba7c8bf7b81317f$var$handlers[type] = $eba7c8bf7b81317f$var$handlers[type] || [];
    $eba7c8bf7b81317f$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $eba7c8bf7b81317f$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $eba7c8bf7b81317f$export$b17eab759a1cb5fe() {
    Object.keys($eba7c8bf7b81317f$var$handlers).forEach((key)=>{
        $eba7c8bf7b81317f$var$handlers[key] = void 0;
    });
}
function $eba7c8bf7b81317f$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$eba7c8bf7b81317f$var$instrumented[type]) {
        $eba7c8bf7b81317f$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $eba7c8bf7b81317f$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $eba7c8bf7b81317f$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $40a6d78e295685ac$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}

const $6967c74e7baedc72$var$objectToString = Object.prototype.toString;
function $6967c74e7baedc72$export$e6127cc7fe7395c3(wat) {
    switch($6967c74e7baedc72$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $6967c74e7baedc72$export$49034edbe6b62415(wat, Error);
    }
}
function $6967c74e7baedc72$var$isBuiltin(wat, className) {
    return $6967c74e7baedc72$var$objectToString.call(wat) === `[object ${className}]`;
}
function $6967c74e7baedc72$export$9f9636d330b71954(wat) {
    return $6967c74e7baedc72$var$isBuiltin(wat, "ErrorEvent");
}
function $6967c74e7baedc72$export$ef9e2056653f0c8e(wat) {
    return $6967c74e7baedc72$var$isBuiltin(wat, "DOMError");
}
function $6967c74e7baedc72$export$12e869b2a583f783(wat) {
    return $6967c74e7baedc72$var$isBuiltin(wat, "DOMException");
}
function $6967c74e7baedc72$export$844ec244b1367d54(wat) {
    return $6967c74e7baedc72$var$isBuiltin(wat, "String");
}
function $6967c74e7baedc72$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $6967c74e7baedc72$export$c3825b437cbdea5c(wat) {
    return wat === null || $6967c74e7baedc72$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $6967c74e7baedc72$export$53b83ca8eaab0383(wat) {
    return $6967c74e7baedc72$var$isBuiltin(wat, "Object");
}
function $6967c74e7baedc72$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $6967c74e7baedc72$export$49034edbe6b62415(wat, Event);
}
function $6967c74e7baedc72$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $6967c74e7baedc72$export$49034edbe6b62415(wat, Element);
}
function $6967c74e7baedc72$export$49841c62b9eff15(wat) {
    return $6967c74e7baedc72$var$isBuiltin(wat, "RegExp");
}
function $6967c74e7baedc72$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $6967c74e7baedc72$export$bc2894c7158efbac(wat) {
    return $6967c74e7baedc72$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $6967c74e7baedc72$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $6967c74e7baedc72$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $6967c74e7baedc72$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $6967c74e7baedc72$export$49034edbe6b62415(request, Request);
}


let $c95243b7bfad6ddc$var$RESOLVED_RUNNER;
function $c95243b7bfad6ddc$export$ff239213cb80e2da(cb) {
    if ($c95243b7bfad6ddc$var$RESOLVED_RUNNER !== void 0) return $c95243b7bfad6ddc$var$RESOLVED_RUNNER ? $c95243b7bfad6ddc$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $c95243b7bfad6ddc$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $c95243b7bfad6ddc$var$RESOLVED_RUNNER(cb);
    }
    $c95243b7bfad6ddc$var$RESOLVED_RUNNER = null;
    return cb();
}
function $c95243b7bfad6ddc$export$9869d72de32a3917() {
    return $c95243b7bfad6ddc$export$ff239213cb80e2da(()=>Math.random());
}
function $c95243b7bfad6ddc$export$65b1bada40c91b34() {
    return $c95243b7bfad6ddc$export$ff239213cb80e2da(()=>Date.now());
}



const $093eae9201b28ce4$var$ONE_SECOND_IN_MS = 1e3;
function $093eae9201b28ce4$export$7740643b9eeaf0c4() {
    return (0, $c95243b7bfad6ddc$export$65b1bada40c91b34)() / $093eae9201b28ce4$var$ONE_SECOND_IN_MS;
}
function $093eae9201b28ce4$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $093eae9201b28ce4$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $c95243b7bfad6ddc$export$ff239213cb80e2da)(()=>performance.now())) / $093eae9201b28ce4$var$ONE_SECOND_IN_MS;
    };
}
let $093eae9201b28ce4$var$_cachedTimestampInSeconds;
function $093eae9201b28ce4$export$ee52dced521e3e18() {
    const func = $093eae9201b28ce4$var$_cachedTimestampInSeconds ?? ($093eae9201b28ce4$var$_cachedTimestampInSeconds = $093eae9201b28ce4$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $093eae9201b28ce4$var$cachedTimeOrigin = null;
function $093eae9201b28ce4$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $c95243b7bfad6ddc$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $c95243b7bfad6ddc$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $093eae9201b28ce4$export$baf075a948ffc0bf() {
    if ($093eae9201b28ce4$var$cachedTimeOrigin === null) $093eae9201b28ce4$var$cachedTimeOrigin = $093eae9201b28ce4$var$getBrowserTimeOrigin();
    return $093eae9201b28ce4$var$cachedTimeOrigin;
}



const $7399e18e995d85aa$export$56d8a8a25bd48b81 = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1);


const $c5fb575b1e4cb8c4$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $c5fb575b1e4cb8c4$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $eba7c8bf7b81317f$export$a4e09611e30da72e)(type, handler);
    (0, $eba7c8bf7b81317f$export$e18d6c5462c01368)(type, $c5fb575b1e4cb8c4$export$c67d533bf77cbf54);
}
function $c5fb575b1e4cb8c4$export$c67d533bf77cbf54() {
    if (!(0, $7399e18e995d85aa$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            const virtualError = new Error();
            const startTimestamp = (0, $093eae9201b28ce4$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $6967c74e7baedc72$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $c5fb575b1e4cb8c4$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$c5fb575b1e4cb8c4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$c5fb575b1e4cb8c4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $093eae9201b28ce4$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $eba7c8bf7b81317f$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$c5fb575b1e4cb8c4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $6967c74e7baedc72$export$844ec244b1367d54)(header) && (0, $6967c74e7baedc72$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$c5fb575b1e4cb8c4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $093eae9201b28ce4$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $eba7c8bf7b81317f$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $c5fb575b1e4cb8c4$var$parseXhrUrlArg(url) {
    if ((0, $6967c74e7baedc72$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}


const $1576abfee53a7006$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $9e4edf64159831e9$var$INTEGRATION_NAME = "HttpClient";
const $9e4edf64159831e9$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $9e4edf64159831e9$var$INTEGRATION_NAME,
        setup (client) {
            $9e4edf64159831e9$var$_wrapFetch(client, _options);
            $9e4edf64159831e9$var$_wrapXHR(client, _options);
        }
    };
};
const $9e4edf64159831e9$export$8a3b7aeb379b3907 = (0, $479c90d590bd4fd3$exports.defineIntegration)($9e4edf64159831e9$var$_httpClientIntegration);
function $9e4edf64159831e9$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($9e4edf64159831e9$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $9e4edf64159831e9$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        const dc = $9e4edf64159831e9$var$_getDataCollectionSettings();
        if (dc.requestHeaders !== false) requestHeaders = (0, $479c90d590bd4fd3$exports._INTERNAL_filterKeyValueData)($9e4edf64159831e9$var$_extractFetchHeaders(request.headers), dc.requestHeaders);
        if (dc.responseHeaders !== false) responseHeaders = (0, $479c90d590bd4fd3$exports._INTERNAL_filterKeyValueData)($9e4edf64159831e9$var$_extractFetchHeaders(response.headers), dc.responseHeaders);
        if (dc.cookies !== false) {
            const reqCookieStr = request.headers.get("Cookie") || void 0;
            if (reqCookieStr) {
                const filtered = (0, $479c90d590bd4fd3$exports._INTERNAL_filterCookies)(reqCookieStr, dc.cookies);
                if (typeof filtered === "object") requestCookies = filtered;
            }
            const resCookieStr = response.headers.get("Set-Cookie") || void 0;
            if (resCookieStr) {
                const filtered = (0, $479c90d590bd4fd3$exports._INTERNAL_filterCookies)(resCookieStr, dc.cookies);
                if (typeof filtered === "object") responseCookies = filtered;
            }
        }
        const event = $9e4edf64159831e9$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error,
            type: "fetch"
        });
        (0, $479c90d590bd4fd3$exports.captureEvent)(event);
    }
}
function $9e4edf64159831e9$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($9e4edf64159831e9$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        const dc = $9e4edf64159831e9$var$_getDataCollectionSettings();
        if (dc.cookies !== false) try {
            const cookieString = xhr.getResponseHeader("Set-Cookie") || xhr.getResponseHeader("set-cookie") || void 0;
            if (cookieString) {
                const filtered = (0, $479c90d590bd4fd3$exports._INTERNAL_filterCookies)(cookieString, dc.cookies);
                if (typeof filtered === "object") responseCookies = filtered;
            }
        } catch  {}
        if (dc.responseHeaders !== false) try {
            responseHeaders = (0, $479c90d590bd4fd3$exports._INTERNAL_filterKeyValueData)($9e4edf64159831e9$var$_getXHRResponseHeaders(xhr), dc.responseHeaders);
        } catch  {}
        if (dc.requestHeaders !== false) requestHeaders = (0, $479c90d590bd4fd3$exports._INTERNAL_filterKeyValueData)(headers, dc.requestHeaders);
        const event = $9e4edf64159831e9$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error,
            type: "xhr"
        });
        (0, $479c90d590bd4fd3$exports.captureEvent)(event);
    }
}
function $9e4edf64159831e9$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers["Content-Length"] || headers["content-length"];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return void 0;
}
function $9e4edf64159831e9$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
function $9e4edf64159831e9$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $9e4edf64159831e9$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === "string") return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
function $9e4edf64159831e9$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === "number") return range === status;
        return status >= range[0] && status <= range[1];
    });
}
function $9e4edf64159831e9$var$_wrapFetch(client, options) {
    if (!(0, $479c90d590bd4fd3$exports.supportsNativeFetch)()) return;
    (0, $479c90d590bd4fd3$exports.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $9e4edf64159831e9$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
function $9e4edf64159831e9$var$_wrapXHR(client, options) {
    if (!("XMLHttpRequest" in (0, $479c90d590bd4fd3$exports.GLOBAL_OBJ))) return;
    (0, $c5fb575b1e4cb8c4$export$26ace48dd54c9aea)((handlerData)=>{
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $c5fb575b1e4cb8c4$export$55b6bb1e45c6cf59];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $9e4edf64159831e9$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn("Error while extracting response event form XHR response", e);
        }
    });
}
function $9e4edf64159831e9$var$_shouldCaptureResponse(options, status, url) {
    return $9e4edf64159831e9$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $9e4edf64159831e9$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $479c90d590bd4fd3$exports.isSentryRequestUrl)(url, (0, $479c90d590bd4fd3$exports.getClient)());
}
function $9e4edf64159831e9$var$_createEvent(data) {
    const client = (0, $479c90d590bd4fd3$exports.getClient)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : void 0;
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : void 0;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: "Error",
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : void 0
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $9e4edf64159831e9$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $479c90d590bd4fd3$exports.addExceptionMechanism)(event, {
        type: `auto.http.client.${data.type}`,
        handled: false
    });
    return event;
}
function $9e4edf64159831e9$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $9e4edf64159831e9$var$_getDataCollectionSettings() {
    const client = (0, $479c90d590bd4fd3$exports.getClient)();
    if (!client) return {
        cookies: false,
        requestHeaders: false,
        responseHeaders: false
    };
    const options = client.getOptions();
    if (options.dataCollection == null) {
        const enabled = Boolean(options.sendDefaultPii);
        return {
            cookies: enabled,
            requestHeaders: enabled,
            responseHeaders: enabled
        };
    }
    const { cookies: cookies, httpHeaders: httpHeaders } = client.getDataCollectionOptions();
    return {
        cookies: cookies,
        requestHeaders: httpHeaders.request,
        responseHeaders: httpHeaders.response
    };
}




function $04246ab1d43088ca$export$a6c2d27607295951(stackParser, ex) {
    const frames = $04246ab1d43088ca$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $04246ab1d43088ca$export$2e9ae379995d99e3(ex),
        value: $04246ab1d43088ca$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $04246ab1d43088ca$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $479c90d590bd4fd3$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $04246ab1d43088ca$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $479c90d590bd4fd3$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $04246ab1d43088ca$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $479c90d590bd4fd3$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $04246ab1d43088ca$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $04246ab1d43088ca$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $04246ab1d43088ca$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $04246ab1d43088ca$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $04246ab1d43088ca$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $04246ab1d43088ca$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $04246ab1d43088ca$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $04246ab1d43088ca$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $04246ab1d43088ca$var$getSkipFirstStackStringLines(ex) {
    if (ex && $04246ab1d43088ca$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $04246ab1d43088ca$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $04246ab1d43088ca$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $04246ab1d43088ca$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $04246ab1d43088ca$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $04246ab1d43088ca$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($04246ab1d43088ca$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $479c90d590bd4fd3$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $479c90d590bd4fd3$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $04246ab1d43088ca$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $04246ab1d43088ca$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $479c90d590bd4fd3$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $479c90d590bd4fd3$exports.resolvedSyncPromise)(event);
}
function $04246ab1d43088ca$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $04246ab1d43088ca$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $479c90d590bd4fd3$exports.resolvedSyncPromise)(event);
}
function $04246ab1d43088ca$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $479c90d590bd4fd3$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $04246ab1d43088ca$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $479c90d590bd4fd3$exports.isDOMError)(exception) || (0, $479c90d590bd4fd3$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $04246ab1d43088ca$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $04246ab1d43088ca$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $479c90d590bd4fd3$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $479c90d590bd4fd3$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $04246ab1d43088ca$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $479c90d590bd4fd3$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $479c90d590bd4fd3$exports.isError)(exception)) return $04246ab1d43088ca$var$eventFromError(stackParser, exception);
    if ((0, $479c90d590bd4fd3$exports.isPlainObject)(exception) || (0, $479c90d590bd4fd3$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $04246ab1d43088ca$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $479c90d590bd4fd3$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $04246ab1d43088ca$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $479c90d590bd4fd3$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $479c90d590bd4fd3$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $04246ab1d43088ca$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $04246ab1d43088ca$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $479c90d590bd4fd3$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $479c90d590bd4fd3$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $04246ab1d43088ca$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $479c90d590bd4fd3$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $479c90d590bd4fd3$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $479c90d590bd4fd3$exports.isEvent)(exception)) {
        const className = $04246ab1d43088ca$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $04246ab1d43088ca$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $04246ab1d43088ca$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



const $26e2765b4d6baedf$export$56d8a8a25bd48b81 = (0, $479c90d590bd4fd3$exports.GLOBAL_OBJ);
let $26e2765b4d6baedf$var$ignoreOnError = 0;
function $26e2765b4d6baedf$export$b79738ab10c590b2() {
    return $26e2765b4d6baedf$var$ignoreOnError > 0;
}
function $26e2765b4d6baedf$export$1265a142ff5ba165() {
    $26e2765b4d6baedf$var$ignoreOnError++;
    setTimeout(()=>{
        $26e2765b4d6baedf$var$ignoreOnError--;
    });
}
function $26e2765b4d6baedf$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $479c90d590bd4fd3$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $479c90d590bd4fd3$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $479c90d590bd4fd3$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$26e2765b4d6baedf$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $26e2765b4d6baedf$export$1265a142ff5ba165();
            (0, $479c90d590bd4fd3$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $479c90d590bd4fd3$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $479c90d590bd4fd3$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $479c90d590bd4fd3$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $479c90d590bd4fd3$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $479c90d590bd4fd3$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $479c90d590bd4fd3$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $479c90d590bd4fd3$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $26e2765b4d6baedf$export$a3c4a8453e8936f0() {
    const url = (0, $479c90d590bd4fd3$exports.getLocationHref)();
    const { referrer: referrer } = $26e2765b4d6baedf$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $26e2765b4d6baedf$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


class $02fb4cb80835a224$export$1df9218a526d318d extends (0, $479c90d590bd4fd3$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $02fb4cb80835a224$export$4e107b20a7f977(options);
        const sdkSource = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $479c90d590bd4fd3$exports.getSDKSource)();
        (0, $479c90d590bd4fd3$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        if ((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $479c90d590bd4fd3$exports._INTERNAL_flushLogsBuffer)(this);
                if (enableMetrics) (0, $479c90d590bd4fd3$exports._INTERNAL_flushMetricsBuffer)(this);
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $479c90d590bd4fd3$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $04246ab1d43088ca$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $04246ab1d43088ca$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $02fb4cb80835a224$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}






function $e632e89186c3a412$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $e632e89186c3a412$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $e632e89186c3a412$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $e632e89186c3a412$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $e632e89186c3a412$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $e632e89186c3a412$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($e632e89186c3a412$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $e632e89186c3a412$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $e632e89186c3a412$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $e632e89186c3a412$export$62ff257738bf57f5(value) {
    if ((0, $6967c74e7baedc72$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e632e89186c3a412$var$getOwnProperties(value)
    };
    if ((0, $6967c74e7baedc72$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$e632e89186c3a412$var$getOwnProperties(value)
        };
    }
    return value;
}
function $e632e89186c3a412$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $e632e89186c3a412$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($e632e89186c3a412$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $e632e89186c3a412$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $e632e89186c3a412$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e632e89186c3a412$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($e632e89186c3a412$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($e632e89186c3a412$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $e632e89186c3a412$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $e632e89186c3a412$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $e632e89186c3a412$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6967c74e7baedc72$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}





const $02a225c2f0ac9f77$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $02a225c2f0ac9f77$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $02a225c2f0ac9f77$export$280812de8e91ea53(obj) {
    (0, $e632e89186c3a412$export$e73679ffaf56810e)(obj, $02a225c2f0ac9f77$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $02a225c2f0ac9f77$export$610d1422c4bdc4c1(obj, depth) {
    (0, $e632e89186c3a412$export$e73679ffaf56810e)(obj, $02a225c2f0ac9f77$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $02a225c2f0ac9f77$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$02a225c2f0ac9f77$var$SENTRY_SKIP_NORMALIZATION]);
}
function $02a225c2f0ac9f77$export$fe95a19841c4b155(value) {
    const v = value[$02a225c2f0ac9f77$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




let $85448db1d36b6561$var$stringifier;
function $85448db1d36b6561$export$575c40989754ba4d(newStringifier) {
    $85448db1d36b6561$var$stringifier = newStringifier;
}
function $85448db1d36b6561$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $85448db1d36b6561$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $85448db1d36b6561$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $85448db1d36b6561$export$a3295358bff77e(object, depth);
    if ($85448db1d36b6561$var$jsonSize(normalized) > maxSize) return $85448db1d36b6561$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $85448db1d36b6561$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $85448db1d36b6561$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $85448db1d36b6561$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $02a225c2f0ac9f77$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $02a225c2f0ac9f77$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $85448db1d36b6561$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $e632e89186c3a412$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $85448db1d36b6561$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $85448db1d36b6561$export$a110e5bc79f44a84(key, value) {
    try {
        if ($85448db1d36b6561$var$stringifier) {
            const stringified = $85448db1d36b6561$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $40a6d78e295685ac$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $85448db1d36b6561$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $85448db1d36b6561$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $85448db1d36b6561$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $85448db1d36b6561$var$jsonSize(value) {
    return $85448db1d36b6561$var$utf8Length(JSON.stringify(value));
}
function $85448db1d36b6561$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $85448db1d36b6561$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $c29d6ad4887306ad$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $c29d6ad4887306ad$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $c29d6ad4887306ad$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $6967c74e7baedc72$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $85448db1d36b6561$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $c29d6ad4887306ad$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $6967c74e7baedc72$export$844ec244b1367d54)(value)) return false;
    if ((0, $6967c74e7baedc72$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $6967c74e7baedc72$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $c29d6ad4887306ad$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($c29d6ad4887306ad$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $990c0df00f1d901d$var$getCrypto() {
    const gbl = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $990c0df00f1d901d$var$emptyUuid;
function $990c0df00f1d901d$var$getRandomByte() {
    return (0, $c95243b7bfad6ddc$export$9869d72de32a3917)() * 16;
}
function $990c0df00f1d901d$export$19f53698e68b2496(crypto = $990c0df00f1d901d$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $c95243b7bfad6ddc$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$990c0df00f1d901d$var$emptyUuid) $990c0df00f1d901d$var$emptyUuid = "10000000100040008000100000000000";
    return $990c0df00f1d901d$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($990c0df00f1d901d$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $990c0df00f1d901d$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $990c0df00f1d901d$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $990c0df00f1d901d$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $990c0df00f1d901d$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $990c0df00f1d901d$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $990c0df00f1d901d$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $990c0df00f1d901d$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $990c0df00f1d901d$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $990c0df00f1d901d$export$d364f2020ab30578(input) {
    const match = input.match($990c0df00f1d901d$var$SEMVER_REGEXP) || [];
    const major = $990c0df00f1d901d$var$_parseInt(match[1]);
    const minor = $990c0df00f1d901d$var$_parseInt(match[2]);
    const patch = $990c0df00f1d901d$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $990c0df00f1d901d$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $c29d6ad4887306ad$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $c29d6ad4887306ad$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $c29d6ad4887306ad$export$4215662d762d6f9d)(line, 0));
}
function $990c0df00f1d901d$export$6de4ffac6a2f1098(exception) {
    if ($990c0df00f1d901d$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $e632e89186c3a412$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $990c0df00f1d901d$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}



const $d3a1d6d3c8dea540$var$DEBOUNCE_DURATION = 1e3;
let $d3a1d6d3c8dea540$var$debounceTimerID;
let $d3a1d6d3c8dea540$var$lastCapturedEventType;
let $d3a1d6d3c8dea540$var$lastCapturedEventTargetId;
function $d3a1d6d3c8dea540$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $eba7c8bf7b81317f$export$a4e09611e30da72e)(type, handler);
    (0, $eba7c8bf7b81317f$export$e18d6c5462c01368)(type, $d3a1d6d3c8dea540$export$3014bbf0af0e1d4a);
}
function $d3a1d6d3c8dea540$export$3014bbf0af0e1d4a() {
    if (!(0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $eba7c8bf7b81317f$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $d3a1d6d3c8dea540$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $7399e18e995d85aa$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $e632e89186c3a412$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $d3a1d6d3c8dea540$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $e632e89186c3a412$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $d3a1d6d3c8dea540$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $d3a1d6d3c8dea540$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $d3a1d6d3c8dea540$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $d3a1d6d3c8dea540$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $d3a1d6d3c8dea540$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $d3a1d6d3c8dea540$var$getEventTarget(event);
        if ($d3a1d6d3c8dea540$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $e632e89186c3a412$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $e632e89186c3a412$export$e73679ffaf56810e)(target, "_sentryId", (0, $990c0df00f1d901d$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$d3a1d6d3c8dea540$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $d3a1d6d3c8dea540$var$lastCapturedEventType = event.type;
            $d3a1d6d3c8dea540$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($d3a1d6d3c8dea540$var$debounceTimerID);
        $d3a1d6d3c8dea540$var$debounceTimerID = (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).setTimeout(()=>{
            $d3a1d6d3c8dea540$var$lastCapturedEventTargetId = void 0;
            $d3a1d6d3c8dea540$var$lastCapturedEventType = void 0;
        }, $d3a1d6d3c8dea540$var$DEBOUNCE_DURATION);
    };
}
function $d3a1d6d3c8dea540$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}




const $0d3379006a83d70a$var$WINDOW = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1);
function $0d3379006a83d70a$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $0d3379006a83d70a$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $0d3379006a83d70a$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $0d3379006a83d70a$export$67fc34576016d6ec() {
    return "history" in $0d3379006a83d70a$var$WINDOW && !!$0d3379006a83d70a$var$WINDOW.history;
}
const $0d3379006a83d70a$export$edf3cb81fd7d2a3e = $0d3379006a83d70a$var$_isFetchSupported;
function $0d3379006a83d70a$var$_isFetchSupported() {
    if (!("fetch" in $0d3379006a83d70a$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $0d3379006a83d70a$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $0d3379006a83d70a$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$0d3379006a83d70a$var$_isFetchSupported()) return false;
    if ($0d3379006a83d70a$export$d5f608b368e73f38($0d3379006a83d70a$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $0d3379006a83d70a$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $0d3379006a83d70a$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $0d3379006a83d70a$export$531055a6c684a70a() {
    return "ReportingObserver" in $0d3379006a83d70a$var$WINDOW;
}
function $0d3379006a83d70a$export$2d308b428295192f() {
    if (!$0d3379006a83d70a$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



let $0127b3f07f74acee$var$lastHref;
function $0127b3f07f74acee$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $eba7c8bf7b81317f$export$a4e09611e30da72e)(type, handler);
    (0, $eba7c8bf7b81317f$export$e18d6c5462c01368)(type, $0127b3f07f74acee$export$d9b613a6254a184e);
}
function $0127b3f07f74acee$export$d9b613a6254a184e() {
    (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).location.href;
        const from = $0127b3f07f74acee$var$lastHref;
        $0127b3f07f74acee$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $eba7c8bf7b81317f$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $0d3379006a83d70a$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $0127b3f07f74acee$var$lastHref;
                const to = $0127b3f07f74acee$var$getAbsoluteUrl(String(url));
                $0127b3f07f74acee$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $eba7c8bf7b81317f$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $e632e89186c3a412$export$9563e054e6f787fb)((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $e632e89186c3a412$export$9563e054e6f787fb)((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $0127b3f07f74acee$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}


const $65ba4186be3cc942$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $65ba4186be3cc942$var$accessors = {};
try {
    if (typeof Node !== "undefined") $65ba4186be3cc942$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $65ba4186be3cc942$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $65ba4186be3cc942$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $65ba4186be3cc942$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $65ba4186be3cc942$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $65ba4186be3cc942$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $65ba4186be3cc942$var$_safeRead(el, prop, arg) {
    const fn = $65ba4186be3cc942$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $65ba4186be3cc942$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $65ba4186be3cc942$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $65ba4186be3cc942$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $65ba4186be3cc942$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $65ba4186be3cc942$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $65ba4186be3cc942$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $65ba4186be3cc942$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$65ba4186be3cc942$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $65ba4186be3cc942$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $65ba4186be3cc942$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $65ba4186be3cc942$var$_safeRead(el, "className");
        if (className && (0, $6967c74e7baedc72$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $65ba4186be3cc942$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}




const $47011ff9d2853925$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $47011ff9d2853925$var$INTEGRATION_NAME = "Breadcrumbs";
const $47011ff9d2853925$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $47011ff9d2853925$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $479c90d590bd4fd3$exports.addConsoleInstrumentationHandler)($47011ff9d2853925$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $d3a1d6d3c8dea540$export$5aeffd3db2cf9df7)($47011ff9d2853925$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $c5fb575b1e4cb8c4$export$26ace48dd54c9aea)($47011ff9d2853925$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $479c90d590bd4fd3$exports.addFetchInstrumentationHandler)($47011ff9d2853925$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $0127b3f07f74acee$export$3f18c56c58114e75)($47011ff9d2853925$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $47011ff9d2853925$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $47011ff9d2853925$export$c079d904b326663a = (0, $479c90d590bd4fd3$exports.defineIntegration)($47011ff9d2853925$var$_breadcrumbsIntegration);
function $47011ff9d2853925$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
        (0, $479c90d590bd4fd3$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $479c90d590bd4fd3$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $47011ff9d2853925$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $47011ff9d2853925$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$47011ff9d2853925$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$47011ff9d2853925$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $47011ff9d2853925$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $47011ff9d2853925$var$_isEvent(event) ? event.target : event;
            target = (0, $65ba4186be3cc942$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $479c90d590bd4fd3$exports.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $479c90d590bd4fd3$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $47011ff9d2853925$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $479c90d590bd4fd3$exports.severityLevelFromString)(handlerData.level),
            message: (0, $479c90d590bd4fd3$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $479c90d590bd4fd3$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $479c90d590bd4fd3$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $47011ff9d2853925$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $c5fb575b1e4cb8c4$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $479c90d590bd4fd3$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $479c90d590bd4fd3$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $47011ff9d2853925$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $479c90d590bd4fd3$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $479c90d590bd4fd3$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $479c90d590bd4fd3$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $47011ff9d2853925$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $479c90d590bd4fd3$exports.parseUrl)((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $479c90d590bd4fd3$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $479c90d590bd4fd3$exports.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $479c90d590bd4fd3$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $47011ff9d2853925$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $bafeae5ba623f03a$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $bafeae5ba623f03a$var$INTEGRATION_NAME = "BrowserApiErrors";
const $bafeae5ba623f03a$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $bafeae5ba623f03a$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $479c90d590bd4fd3$exports.fill)((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81), "setTimeout", $bafeae5ba623f03a$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $479c90d590bd4fd3$exports.fill)((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81), "setInterval", $bafeae5ba623f03a$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $479c90d590bd4fd3$exports.fill)((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81), "requestAnimationFrame", $bafeae5ba623f03a$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81)) (0, $479c90d590bd4fd3$exports.fill)(XMLHttpRequest.prototype, "send", $bafeae5ba623f03a$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $bafeae5ba623f03a$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$bafeae5ba623f03a$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $bafeae5ba623f03a$export$59bfe9f1c76150e = (0, $479c90d590bd4fd3$exports.defineIntegration)($bafeae5ba623f03a$var$_browserApiErrorsIntegration);
function $bafeae5ba623f03a$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $26e2765b4d6baedf$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $479c90d590bd4fd3$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $bafeae5ba623f03a$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $26e2765b4d6baedf$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $479c90d590bd4fd3$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $bafeae5ba623f03a$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $479c90d590bd4fd3$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $479c90d590bd4fd3$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $479c90d590bd4fd3$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $479c90d590bd4fd3$exports.getFunctionName)(originalFunction);
                return (0, $26e2765b4d6baedf$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $bafeae5ba623f03a$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $479c90d590bd4fd3$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($bafeae5ba623f03a$var$isEventListenerObject(fn)) fn.handleEvent = (0, $26e2765b4d6baedf$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $479c90d590bd4fd3$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $bafeae5ba623f03a$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $26e2765b4d6baedf$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $479c90d590bd4fd3$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $479c90d590bd4fd3$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $bafeae5ba623f03a$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $bafeae5ba623f03a$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






const $66e3fb12e9cd78be$export$1baa7880e357371c = (0, $479c90d590bd4fd3$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $479c90d590bd4fd3$exports.startSession)({
                ignoreDuration: true
            });
            (0, $479c90d590bd4fd3$exports.captureSession)();
            const isolationScope = (0, $479c90d590bd4fd3$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    (0, $479c90d590bd4fd3$exports.captureSession)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === "route") (0, $0127b3f07f74acee$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $479c90d590bd4fd3$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $479c90d590bd4fd3$exports.captureSession)();
                }
            });
        }
    };
});




const $f0431a1184bb695c$var$INTEGRATION_NAME = "CultureContext";
const $f0431a1184bb695c$var$_cultureContextIntegration = ()=>{
    return {
        name: $f0431a1184bb695c$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $f0431a1184bb695c$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $f0431a1184bb695c$var$getCultureContext();
            if (culture) (0, $479c90d590bd4fd3$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $f0431a1184bb695c$export$ec5976aacdc85985 = (0, $479c90d590bd4fd3$exports.defineIntegration)($f0431a1184bb695c$var$_cultureContextIntegration);
function $f0431a1184bb695c$var$getCultureContext() {
    try {
        const intl = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $4e6fe6c25ec62793$var$INTEGRATION_NAME = "GlobalHandlers";
const $4e6fe6c25ec62793$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $4e6fe6c25ec62793$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $4e6fe6c25ec62793$var$_installGlobalOnErrorHandler(client);
                $4e6fe6c25ec62793$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $4e6fe6c25ec62793$var$_installGlobalOnUnhandledRejectionHandler(client);
                $4e6fe6c25ec62793$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $4e6fe6c25ec62793$export$66acc70e8cf2b71a = (0, $479c90d590bd4fd3$exports.defineIntegration)($4e6fe6c25ec62793$var$_globalHandlersIntegration);
function $4e6fe6c25ec62793$var$_installGlobalOnErrorHandler(client) {
    (0, $479c90d590bd4fd3$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $4e6fe6c25ec62793$var$getOptions();
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client || (0, $26e2765b4d6baedf$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $4e6fe6c25ec62793$var$_enhanceEventWithInitialFrame((0, $04246ab1d43088ca$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $479c90d590bd4fd3$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $4e6fe6c25ec62793$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $479c90d590bd4fd3$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $4e6fe6c25ec62793$var$getOptions();
        if ((0, $479c90d590bd4fd3$exports.getClient)() !== client || (0, $26e2765b4d6baedf$export$b79738ab10c590b2)()) return;
        const error = $4e6fe6c25ec62793$export$b2cc40fa8241780(e);
        const event = (0, $479c90d590bd4fd3$exports.isPrimitive)(error) ? $4e6fe6c25ec62793$export$1353b5b36844a9ed(error) : (0, $04246ab1d43088ca$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $479c90d590bd4fd3$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $4e6fe6c25ec62793$export$b2cc40fa8241780(error) {
    if ((0, $479c90d590bd4fd3$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $4e6fe6c25ec62793$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $4e6fe6c25ec62793$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $4e6fe6c25ec62793$var$getFilenameFromUrl(url) ?? (0, $479c90d590bd4fd3$exports.getLocationHref)(),
        function: (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $4e6fe6c25ec62793$var$globalHandlerLog(type) {
    (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).log(`Global Handler attached: ${type}`);
}
function $4e6fe6c25ec62793$var$getOptions() {
    const client = (0, $479c90d590bd4fd3$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $4e6fe6c25ec62793$var$getFilenameFromUrl(url) {
    if (!(0, $479c90d590bd4fd3$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $479c90d590bd4fd3$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}




const $c2b5dd12f9c7b1d1$export$1378794447170364 = (0, $479c90d590bd4fd3$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).navigator && !(0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location && !(0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $26e2765b4d6baedf$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            if (!(0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).navigator && !(0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location && !(0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $26e2765b4d6baedf$export$a3c4a8453e8936f0)();
            (0, $479c90d590bd4fd3$exports.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                "url.full": reqData.url || void 0,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});




const $e3110857a059768f$var$DEFAULT_KEY = "cause";
const $e3110857a059768f$var$DEFAULT_LIMIT = 5;
const $e3110857a059768f$var$INTEGRATION_NAME = "LinkedErrors";
const $e3110857a059768f$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e3110857a059768f$var$DEFAULT_LIMIT;
    const key = options.key || $e3110857a059768f$var$DEFAULT_KEY;
    return {
        name: $e3110857a059768f$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $479c90d590bd4fd3$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $04246ab1d43088ca$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $e3110857a059768f$export$ebabb00eb7f3a395 = (0, $479c90d590bd4fd3$exports.defineIntegration)($e3110857a059768f$var$_linkedErrorsIntegration);



const $faac1ddbb9638c5e$var$OPERA10_PRIORITY = 10;
const $faac1ddbb9638c5e$var$OPERA11_PRIORITY = 20;
const $faac1ddbb9638c5e$var$CHROME_PRIORITY = 30;
const $faac1ddbb9638c5e$var$WINJS_PRIORITY = 40;
const $faac1ddbb9638c5e$var$GECKO_PRIORITY = 50;
function $faac1ddbb9638c5e$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $faac1ddbb9638c5e$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $faac1ddbb9638c5e$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $faac1ddbb9638c5e$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $faac1ddbb9638c5e$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $faac1ddbb9638c5e$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($faac1ddbb9638c5e$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $faac1ddbb9638c5e$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $faac1ddbb9638c5e$var$createFrame(filename, (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $faac1ddbb9638c5e$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $faac1ddbb9638c5e$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $faac1ddbb9638c5e$var$extractSafariExtensionDetails(parts[1] || (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION), parts[2]);
        return $faac1ddbb9638c5e$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $faac1ddbb9638c5e$export$263a749fff749872 = [
    $faac1ddbb9638c5e$var$CHROME_PRIORITY,
    $faac1ddbb9638c5e$var$chromeStackParserFn
];
const $faac1ddbb9638c5e$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $faac1ddbb9638c5e$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $faac1ddbb9638c5e$var$gecko = (line)=>{
    const parts = $faac1ddbb9638c5e$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $faac1ddbb9638c5e$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION);
        [func, filename] = $faac1ddbb9638c5e$var$extractSafariExtensionDetails(func, filename);
        return $faac1ddbb9638c5e$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $faac1ddbb9638c5e$export$cdba47a5dd2804d = [
    $faac1ddbb9638c5e$var$GECKO_PRIORITY,
    $faac1ddbb9638c5e$var$gecko
];
const $faac1ddbb9638c5e$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $faac1ddbb9638c5e$var$winjs = (line)=>{
    const parts = $faac1ddbb9638c5e$var$winjsRegex.exec(line);
    return parts ? $faac1ddbb9638c5e$var$createFrame(parts[2], parts[1] || (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $faac1ddbb9638c5e$export$179460296da408e8 = [
    $faac1ddbb9638c5e$var$WINJS_PRIORITY,
    $faac1ddbb9638c5e$var$winjs
];
const $faac1ddbb9638c5e$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $faac1ddbb9638c5e$var$opera10 = (line)=>{
    const parts = $faac1ddbb9638c5e$var$opera10Regex.exec(line);
    return parts ? $faac1ddbb9638c5e$var$createFrame(parts[2], parts[3] || (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $faac1ddbb9638c5e$export$f892b52c880ffc7a = [
    $faac1ddbb9638c5e$var$OPERA10_PRIORITY,
    $faac1ddbb9638c5e$var$opera10
];
const $faac1ddbb9638c5e$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $faac1ddbb9638c5e$var$opera11 = (line)=>{
    const parts = $faac1ddbb9638c5e$var$opera11Regex.exec(line);
    return parts ? $faac1ddbb9638c5e$var$createFrame(parts[5], parts[3] || parts[4] || (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $faac1ddbb9638c5e$export$af11af13f09fb0dc = [
    $faac1ddbb9638c5e$var$OPERA11_PRIORITY,
    $faac1ddbb9638c5e$var$opera11
];
const $faac1ddbb9638c5e$export$7197c0fe6554c079 = [
    $faac1ddbb9638c5e$export$263a749fff749872,
    $faac1ddbb9638c5e$export$cdba47a5dd2804d
];
const $faac1ddbb9638c5e$export$2b2b997d81bf3907 = (0, $479c90d590bd4fd3$exports.createStackParser)(...$faac1ddbb9638c5e$export$7197c0fe6554c079);
const $faac1ddbb9638c5e$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $479c90d590bd4fd3$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




const $a0072c24ef9c7c8c$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $df1cedd591d67e7a$var$cachedImplementations = {};
function $df1cedd591d67e7a$export$e464f4a514ac28a8(name) {
    const cached = $df1cedd591d67e7a$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $7399e18e995d85aa$export$56d8a8a25bd48b81)[name];
    if ((0, $0d3379006a83d70a$export$d5f608b368e73f38)(impl)) return $df1cedd591d67e7a$var$cachedImplementations[name] = impl.bind((0, $7399e18e995d85aa$export$56d8a8a25bd48b81));
    const document = (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $df1cedd591d67e7a$var$cachedImplementations[name] = impl.bind((0, $7399e18e995d85aa$export$56d8a8a25bd48b81));
}
function $df1cedd591d67e7a$export$8aa36702e8c8978(name) {
    $df1cedd591d67e7a$var$cachedImplementations[name] = void 0;
}
function $df1cedd591d67e7a$export$e7aa7bc5c1b3cfb3(...rest) {
    return $df1cedd591d67e7a$export$e464f4a514ac28a8("fetch")(...rest);
}
function $df1cedd591d67e7a$export$831dc9f2ab0a617b(...rest) {
    return $df1cedd591d67e7a$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $a82d2bd634848c00$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $a82d2bd634848c00$export$b2311068c46d7cc8(options, nativeFetch = (0, $df1cedd591d67e7a$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $df1cedd591d67e7a$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $479c90d590bd4fd3$exports.createTransport)(options, makeRequest, (0, $479c90d590bd4fd3$exports.makePromiseBuffer)(options.bufferSize || $a82d2bd634848c00$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $00705a4aaa1e163c$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $b4179f8b67e3f518$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $b4179f8b67e3f518$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $00705a4aaa1e163c$export$45a5e7f76e0caa8d)(value)) {
        const objName = $b4179f8b67e3f518$var$getConstructorName(value);
        if ($b4179f8b67e3f518$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $65ba4186be3cc942$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $b4179f8b67e3f518$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $2c8b45c6fe94b3b6$export$dc236a86065879fc() {
    if ($2c8b45c6fe94b3b6$var$_isEmbeddedBrowserExtension()) {
        if (0, $1576abfee53a7006$export$16a28057038b10ef) (0, $479c90d590bd4fd3$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $2c8b45c6fe94b3b6$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $479c90d590bd4fd3$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81) === (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $23bb6d3494585a16$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $479c90d590bd4fd3$exports.inboundFiltersIntegration)(),
        (0, $479c90d590bd4fd3$exports.functionToStringIntegration)(),
        (0, $479c90d590bd4fd3$exports.conversationIdIntegration)(),
        (0, $bafeae5ba623f03a$export$59bfe9f1c76150e)(),
        (0, $47011ff9d2853925$export$c079d904b326663a)(),
        (0, $4e6fe6c25ec62793$export$66acc70e8cf2b71a)(),
        (0, $e3110857a059768f$export$ebabb00eb7f3a395)(),
        (0, $479c90d590bd4fd3$exports.dedupeIntegration)(),
        (0, $c2b5dd12f9c7b1d1$export$1378794447170364)(),
        (0, $f0431a1184bb695c$export$ec5976aacdc85985)(),
        (0, $66e3fb12e9cd78be$export$1baa7880e357371c)()
    ];
}
function $23bb6d3494585a16$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $2c8b45c6fe94b3b6$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $23bb6d3494585a16$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $479c90d590bd4fd3$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $faac1ddbb9638c5e$export$2b2b997d81bf3907)),
        integrations: (0, $479c90d590bd4fd3$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $a82d2bd634848c00$export$b2311068c46d7cc8)
    };
    (0, $479c90d590bd4fd3$exports.setNormalizeStringifier)((0, $b4179f8b67e3f518$export$4c88c355e6072df5));
    return (0, $479c90d590bd4fd3$exports.initAndBind)((0, $02fb4cb80835a224$export$1df9218a526d318d), clientOptions);
}
function $23bb6d3494585a16$export$a3f323d81eede727() {}
function $23bb6d3494585a16$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $itHdT = parcelRequire("itHdT");

function $4042a7435feefbca$export$bc2894c7158efbac(wat) {
    return (0, $6967c74e7baedc72$export$53b83ca8eaab0383)(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}


function $4adcd9775c7264be$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $479c90d590bd4fd3$exports.applySdkMetadata)(opts, "react");
    (0, $479c90d590bd4fd3$exports.setContext)("react", {
        version: $itHdT.version
    });
    const client = (0, $23bb6d3494585a16$export$2cd8252107eb640b)(opts);
    (0, $479c90d590bd4fd3$exports.setNormalizeStringifier)($4adcd9775c7264be$var$normalizeStringifyValue);
    return client;
}
function $4adcd9775c7264be$var$normalizeStringifyValue(value) {
    if ((0, $4042a7435feefbca$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
    return (0, $b4179f8b67e3f518$export$4c88c355e6072df5)(value);
}







function $ea97098a3117d65a$export$14a186326edbb264(context) {
    const startingTime = (0, $093eae9201b28ce4$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $990c0df00f1d901d$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ea97098a3117d65a$var$sessionToJSON(session)
    };
    if (context) $ea97098a3117d65a$export$531818e825e774db(session, context);
    return session;
}
function $ea97098a3117d65a$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $093eae9201b28ce4$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $990c0df00f1d901d$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $ea97098a3117d65a$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ea97098a3117d65a$export$531818e825e774db(session, context);
}
function $ea97098a3117d65a$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




function $2c493095358b3ec6$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $2c493095358b3ec6$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




function $9325d4385801d3cd$export$dc6d7ea554bcce10() {
    return (0, $990c0df00f1d901d$export$19f53698e68b2496)();
}
function $9325d4385801d3cd$export$295213bc4d0c54ad() {
    return (0, $990c0df00f1d901d$export$19f53698e68b2496)().substring(16);
}





function $bc1c288b3a6c7224$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $bc1c288b3a6c7224$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}


const $dc550567d0a83b87$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $dc550567d0a83b87$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $e632e89186c3a412$export$e73679ffaf56810e)(scope, $dc550567d0a83b87$var$SCOPE_SPAN_FIELD, (0, $bc1c288b3a6c7224$export$f0b98edec95fcb33)(span));
    else delete scope[$dc550567d0a83b87$var$SCOPE_SPAN_FIELD];
}
function $dc550567d0a83b87$export$91f063ebb8eff307(scope) {
    return (0, $bc1c288b3a6c7224$export$a0592ad8c3586cf)(scope[$dc550567d0a83b87$var$SCOPE_SPAN_FIELD]);
}




const $fd9eb9aee14dbf3b$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $fd9eb9aee14dbf3b$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $9325d4385801d3cd$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c95243b7bfad6ddc$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $fd9eb9aee14dbf3b$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $dc550567d0a83b87$export$3f25fa50c18e20ca)(newScope, (0, $dc550567d0a83b87$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $ea97098a3117d65a$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $fd9eb9aee14dbf3b$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $6967c74e7baedc72$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $dc550567d0a83b87$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $9325d4385801d3cd$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c95243b7bfad6ddc$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $fd9eb9aee14dbf3b$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $093eae9201b28ce4$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $c29d6ad4887306ad$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $dc550567d0a83b87$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $2c493095358b3ec6$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $990c0df00f1d901d$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $990c0df00f1d901d$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $990c0df00f1d901d$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


function $737f80d741cd4d01$export$6f1b9191db9c4d5() {
    return (0, $ae40082355c0ca7d$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $fd9eb9aee14dbf3b$export$775b6bb06e53a214)());
}
function $737f80d741cd4d01$export$de9862929b76bf57() {
    return (0, $ae40082355c0ca7d$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $fd9eb9aee14dbf3b$export$775b6bb06e53a214)());
}



const $d03aa350cae2668a$var$isActualPromise = (p)=>p instanceof Promise && !p[$d03aa350cae2668a$var$kChainedCopy];
const $d03aa350cae2668a$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $d03aa350cae2668a$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $d03aa350cae2668a$var$isActualPromise(chained) && $d03aa350cae2668a$var$isActualPromise(original) ? chained : $d03aa350cae2668a$var$copyProps(original, chained);
};
const $d03aa350cae2668a$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$d03aa350cae2668a$var$kChainedCopy]: true
    });
    return chained;
};




class $a0b644ede46dac5e$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $fd9eb9aee14dbf3b$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $fd9eb9aee14dbf3b$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $6967c74e7baedc72$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $d03aa350cae2668a$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $a0b644ede46dac5e$var$getAsyncContextStack() {
    const registry = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    const sentry = (0, $ae40082355c0ca7d$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $a0b644ede46dac5e$export$d36ec451f120cfba((0, $737f80d741cd4d01$export$6f1b9191db9c4d5)(), (0, $737f80d741cd4d01$export$de9862929b76bf57)());
}
function $a0b644ede46dac5e$var$withScope(callback) {
    return $a0b644ede46dac5e$var$getAsyncContextStack().withScope(callback);
}
function $a0b644ede46dac5e$var$withSetScope(scope, callback) {
    const stack = $a0b644ede46dac5e$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $a0b644ede46dac5e$var$withIsolationScope(callback) {
    return $a0b644ede46dac5e$var$getAsyncContextStack().withScope(()=>{
        return callback($a0b644ede46dac5e$var$getAsyncContextStack().getIsolationScope());
    });
}
function $a0b644ede46dac5e$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $a0b644ede46dac5e$var$withIsolationScope,
        withScope: $a0b644ede46dac5e$var$withScope,
        withSetScope: $a0b644ede46dac5e$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $a0b644ede46dac5e$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$a0b644ede46dac5e$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$a0b644ede46dac5e$var$getAsyncContextStack().getIsolationScope()
    };
}


function $a40db583fbfcfb8f$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    const sentry = (0, $ae40082355c0ca7d$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $a40db583fbfcfb8f$export$f639b0c2752203be(carrier) {
    const sentry = (0, $ae40082355c0ca7d$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $a0b644ede46dac5e$export$329d4d4d54e42710)();
}



function $3e4318a5556fb6b2$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $3e4318a5556fb6b2$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $3e4318a5556fb6b2$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $3e4318a5556fb6b2$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $3e4318a5556fb6b2$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $3e4318a5556fb6b2$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $3e4318a5556fb6b2$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $3e4318a5556fb6b2$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $6967c74e7baedc72$export$c3825b437cbdea5c)(val)) weight += $3e4318a5556fb6b2$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $3e4318a5556fb6b2$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $3e4318a5556fb6b2$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}







let $89fdb8ff58631b88$var$_externalPropagationContextProvider;
function $89fdb8ff58631b88$export$b5defb3466e9689b(fn) {
    $89fdb8ff58631b88$var$_externalPropagationContextProvider = fn;
}
function $89fdb8ff58631b88$export$92547f779c920a71() {
    return $89fdb8ff58631b88$var$_externalPropagationContextProvider?.();
}
function $89fdb8ff58631b88$export$53f0ae651a1c4298() {
    return $89fdb8ff58631b88$var$_externalPropagationContextProvider !== void 0;
}
function $89fdb8ff58631b88$export$c7be4b0125a10cba() {
    const carrier = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    const acs = (0, $a40db583fbfcfb8f$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $89fdb8ff58631b88$export$68f3af03034c9e90() {
    const carrier = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    const acs = (0, $a40db583fbfcfb8f$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $89fdb8ff58631b88$export$aa55d5ab8e05984f() {
    return (0, $ae40082355c0ca7d$export$7e223ec222791509)("globalScope", ()=>new (0, $fd9eb9aee14dbf3b$export$775b6bb06e53a214)());
}
function $89fdb8ff58631b88$export$ec58d9285c204497(...rest) {
    const carrier = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    const acs = (0, $a40db583fbfcfb8f$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $89fdb8ff58631b88$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    const acs = (0, $a40db583fbfcfb8f$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $89fdb8ff58631b88$export$6bb76d6eba7e258c() {
    return $89fdb8ff58631b88$export$c7be4b0125a10cba().getClient();
}
function $89fdb8ff58631b88$export$1e83db7ee4876dc4(scope) {
    const externalContext = $89fdb8ff58631b88$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $9325d4385801d3cd$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


const $4f85903ad30c6e77$export$d7a7d984b0791405 = "sentry.source";
const $4f85903ad30c6e77$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $4f85903ad30c6e77$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $4f85903ad30c6e77$export$1a413bd9a88fdb09 = "sentry.op";
const $4f85903ad30c6e77$export$cca8dd30f57f805e = "sentry.origin";
const $4f85903ad30c6e77$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $4f85903ad30c6e77$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $4f85903ad30c6e77$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $4f85903ad30c6e77$export$f5cefb258679b29e = "sentry.release";
const $4f85903ad30c6e77$export$d1b1dbb47f5ba57c = "sentry.environment";
const $4f85903ad30c6e77$export$4626f2be16112c1c = "sentry.segment.name";
const $4f85903ad30c6e77$export$25fa4a1832d3736a = "sentry.segment.id";
const $4f85903ad30c6e77$export$87a4807042e1f1bb = "sentry.sdk.name";
const $4f85903ad30c6e77$export$301ebe936458e291 = "sentry.sdk.version";
const $4f85903ad30c6e77$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $4f85903ad30c6e77$export$1f9cc1d34ea098a0 = "user.id";
const $4f85903ad30c6e77$export$b7466609ef46c07e = "user.email";
const $4f85903ad30c6e77$export$8d592bdaea63b930 = "user.ip_address";
const $4f85903ad30c6e77$export$c05ee933d3f74b2b = "user.name";
const $4f85903ad30c6e77$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $4f85903ad30c6e77$export$1efec95406bbe327 = "sentry.profile_id";
const $4f85903ad30c6e77$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $4f85903ad30c6e77$export$b016f89ac1066ec = "cache.hit";
const $4f85903ad30c6e77$export$3110e4c3f4386399 = "cache.key";
const $4f85903ad30c6e77$export$86be76deee227ff2 = "cache.item_size";
const $4f85903ad30c6e77$export$be7a251980e7e946 = "http.request.method";
const $4f85903ad30c6e77$export$25dfd73e0e32c6e1 = "url.full";
const $4f85903ad30c6e77$export$ff77b5fd5b2d627b = "sentry.link.type";
const $4f85903ad30c6e77$export$71a4a707257f2774 = "gen_ai.conversation.id";


const $5a487d463608a018$export$136e25984ba4a383 = 0;
const $5a487d463608a018$export$58f7963109c806fc = 1;
const $5a487d463608a018$export$f966a0446ece71e = 2;
function $5a487d463608a018$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $5a487d463608a018$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $5a487d463608a018$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $5a487d463608a018$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $5a487d463608a018$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $5a487d463608a018$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




const $da05531b2faa2b9e$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $da05531b2faa2b9e$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $da05531b2faa2b9e$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $e632e89186c3a412$export$e73679ffaf56810e)(span, $da05531b2faa2b9e$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $bc1c288b3a6c7224$export$f0b98edec95fcb33)(isolationScope));
        (0, $e632e89186c3a412$export$e73679ffaf56810e)(span, $da05531b2faa2b9e$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $da05531b2faa2b9e$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$da05531b2faa2b9e$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $bc1c288b3a6c7224$export$a0592ad8c3586cf)(spanWithScopes[$da05531b2faa2b9e$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}









const $9f26a8da2adcdb3c$export$6e69537d67fa20f = "sentry-";
const $9f26a8da2adcdb3c$export$eb0401070c617ea5 = /^sentry-/;
const $9f26a8da2adcdb3c$export$bdd844ddb2def819 = 8192;
function $9f26a8da2adcdb3c$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $9f26a8da2adcdb3c$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($9f26a8da2adcdb3c$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($9f26a8da2adcdb3c$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $9f26a8da2adcdb3c$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$9f26a8da2adcdb3c$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $9f26a8da2adcdb3c$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $9f26a8da2adcdb3c$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $6967c74e7baedc72$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $9f26a8da2adcdb3c$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $9f26a8da2adcdb3c$var$baggageHeaderToObject(baggageHeader);
}
function $9f26a8da2adcdb3c$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $9f26a8da2adcdb3c$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $9f26a8da2adcdb3c$export$bdd844ddb2def819) {
            (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $9f26a8da2adcdb3c$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $9f26a8da2adcdb3c$export$397de414d189db00(existing);
    const incomingEntries = $9f26a8da2adcdb3c$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($9f26a8da2adcdb3c$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($9f26a8da2adcdb3c$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $9f26a8da2adcdb3c$export$12a7349a29a6e3c2(merged);
}




const $afc8bc964220c0ab$var$ORG_ID_REGEX = /^o(\d+)\./;
const $afc8bc964220c0ab$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $afc8bc964220c0ab$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $afc8bc964220c0ab$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $afc8bc964220c0ab$export$b892860177f70a30(str) {
    const match = $afc8bc964220c0ab$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $35da606f4e6c3c2f$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $afc8bc964220c0ab$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $afc8bc964220c0ab$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $afc8bc964220c0ab$var$validateDsn(dsn) {
    if (!(0, $fc6c683469493657$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $35da606f4e6c3c2f$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $35da606f4e6c3c2f$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$afc8bc964220c0ab$var$isValidProtocol(protocol)) {
        (0, $35da606f4e6c3c2f$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $35da606f4e6c3c2f$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $afc8bc964220c0ab$export$5914f4e7748c29c9(host) {
    const match = host.match($afc8bc964220c0ab$var$ORG_ID_REGEX);
    return match?.[1];
}
function $afc8bc964220c0ab$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $afc8bc964220c0ab$export$5914f4e7748c29c9(host);
    return org_id;
}
function $afc8bc964220c0ab$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $afc8bc964220c0ab$export$b892860177f70a30(from) : $afc8bc964220c0ab$var$dsnFromComponents(from);
    if (!components || !$afc8bc964220c0ab$var$validateDsn(components)) return void 0;
    return components;
}


function $be51ae5ea672b965$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




const $4c7975f49d7b70e6$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $4c7975f49d7b70e6$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($4c7975f49d7b70e6$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $4c7975f49d7b70e6$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $4c7975f49d7b70e6$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9f26a8da2adcdb3c$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $9325d4385801d3cd$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $c95243b7bfad6ddc$export$9869d72de32a3917)()
    };
    const sampleRand = $4c7975f49d7b70e6$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $4c7975f49d7b70e6$export$f35d907436da45cf(traceId = (0, $9325d4385801d3cd$export$dc6d7ea554bcce10)(), spanId = (0, $9325d4385801d3cd$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $4c7975f49d7b70e6$export$1aff3752542747dd(traceId = (0, $9325d4385801d3cd$export$dc6d7ea554bcce10)(), spanId = (0, $9325d4385801d3cd$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $4c7975f49d7b70e6$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $be51ae5ea672b965$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $be51ae5ea672b965$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $c95243b7bfad6ddc$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $c95243b7bfad6ddc$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $c95243b7bfad6ddc$export$9869d72de32a3917)();
}
function $4c7975f49d7b70e6$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $afc8bc964220c0ab$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




const $da6e7e382c71fa3f$export$208d5b368507fb8b = 0;
const $da6e7e382c71fa3f$export$eb571cd9b5d98de8 = 1;
let $da6e7e382c71fa3f$var$hasShownSpanDropWarning = false;
function $da6e7e382c71fa3f$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $da6e7e382c71fa3f$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $da6e7e382c71fa3f$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $da6e7e382c71fa3f$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $da05531b2faa2b9e$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $9325d4385801d3cd$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $da6e7e382c71fa3f$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $da6e7e382c71fa3f$export$5caecac1caaf3a71(span);
    return (0, $4c7975f49d7b70e6$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $da6e7e382c71fa3f$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $da6e7e382c71fa3f$export$5caecac1caaf3a71(span);
    return (0, $4c7975f49d7b70e6$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $da6e7e382c71fa3f$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $da6e7e382c71fa3f$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $da6e7e382c71fa3f$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $da6e7e382c71fa3f$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $da6e7e382c71fa3f$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $da6e7e382c71fa3f$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $da6e7e382c71fa3f$var$ensureTimestampInSeconds(input.getTime());
    return (0, $093eae9201b28ce4$export$ee52dced521e3e18)();
}
function $da6e7e382c71fa3f$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $da6e7e382c71fa3f$export$92d8c23565496537(span) {
    if ($da6e7e382c71fa3f$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($da6e7e382c71fa3f$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $da6e7e382c71fa3f$var$getOtelParentSpanId(span),
            start_timestamp: $da6e7e382c71fa3f$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $da6e7e382c71fa3f$export$3f7581298f56c6d7(endTime) || void 0,
            status: $da6e7e382c71fa3f$export$e238a77ea3a8cd66(status),
            op: attributes[0, $4f85903ad30c6e77$export$1a413bd9a88fdb09],
            origin: attributes[0, $4f85903ad30c6e77$export$cca8dd30f57f805e],
            links: $da6e7e382c71fa3f$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $da6e7e382c71fa3f$export$db0cad9e44f67af8(span) {
    if ($da6e7e382c71fa3f$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($da6e7e382c71fa3f$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $da6e7e382c71fa3f$var$getOtelParentSpanId(span),
            start_timestamp: $da6e7e382c71fa3f$export$3f7581298f56c6d7(startTime),
            end_timestamp: $da6e7e382c71fa3f$export$3f7581298f56c6d7(endTime),
            is_segment: span === $da6e7e382c71fa3f$export$7a3106f345d83bb6(span),
            status: $da6e7e382c71fa3f$export$457dcd3df4e9f5c6(status),
            attributes: attributes,
            links: $da6e7e382c71fa3f$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $da6e7e382c71fa3f$export$7a3106f345d83bb6(span)
    };
}
function $da6e7e382c71fa3f$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $da6e7e382c71fa3f$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $3e4318a5556fb6b2$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $3e4318a5556fb6b2$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $da6e7e382c71fa3f$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $da6e7e382c71fa3f$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $da6e7e382c71fa3f$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $da6e7e382c71fa3f$export$eb571cd9b5d98de8;
}
function $da6e7e382c71fa3f$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $5a487d463608a018$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $5a487d463608a018$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $da6e7e382c71fa3f$export$457dcd3df4e9f5c6(status) {
    return !status || status.code === (0, $5a487d463608a018$export$58f7963109c806fc) || status.code === (0, $5a487d463608a018$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
const $da6e7e382c71fa3f$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $da6e7e382c71fa3f$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $da6e7e382c71fa3f$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$da6e7e382c71fa3f$var$ROOT_SPAN_FIELD] || span;
    (0, $e632e89186c3a412$export$e73679ffaf56810e)(childSpan, $da6e7e382c71fa3f$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$da6e7e382c71fa3f$var$CHILD_SPANS_FIELD]) span[$da6e7e382c71fa3f$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $e632e89186c3a412$export$e73679ffaf56810e)(span, $da6e7e382c71fa3f$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $da6e7e382c71fa3f$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$da6e7e382c71fa3f$var$CHILD_SPANS_FIELD]) span[$da6e7e382c71fa3f$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $da6e7e382c71fa3f$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($da6e7e382c71fa3f$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$da6e7e382c71fa3f$var$CHILD_SPANS_FIELD] ? Array.from(span2[$da6e7e382c71fa3f$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $da6e7e382c71fa3f$export$c4c6a79b1260ca1b = $da6e7e382c71fa3f$export$7a3106f345d83bb6;
function $da6e7e382c71fa3f$export$7a3106f345d83bb6(span) {
    return span[$da6e7e382c71fa3f$var$ROOT_SPAN_FIELD] || span;
}
function $da6e7e382c71fa3f$export$1be426a8e585c83e() {
    const carrier = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    const acs = (0, $a40db583fbfcfb8f$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $dc550567d0a83b87$export$91f063ebb8eff307)((0, $89fdb8ff58631b88$export$c7be4b0125a10cba)());
}
function $da6e7e382c71fa3f$export$d11691ff45a3e535() {
    if (!$da6e7e382c71fa3f$var$hasShownSpanDropWarning) {
        (0, $35da606f4e6c3c2f$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $da6e7e382c71fa3f$var$hasShownSpanDropWarning = true;
    }
}
function $da6e7e382c71fa3f$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $4f85903ad30c6e77$export$d7a7d984b0791405)]: "custom",
        [(0, $4f85903ad30c6e77$export$165ce9a229f6f050)]: name
    });
}



const $daa55f1f0d1b69e5$var$WINDOW = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1);
const $daa55f1f0d1b69e5$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $daa55f1f0d1b69e5$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $daa55f1f0d1b69e5$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $daa55f1f0d1b69e5$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $daa55f1f0d1b69e5$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($daa55f1f0d1b69e5$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $6967c74e7baedc72$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $daa55f1f0d1b69e5$export$1cfafeee2987818b() {
    try {
        return $daa55f1f0d1b69e5$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $daa55f1f0d1b69e5$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$daa55f1f0d1b69e5$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


const $16cbdb46106b353e$var$DEFAULT_BASE_URL = "thismessage:/";
function $16cbdb46106b353e$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $16cbdb46106b353e$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $16cbdb46106b353e$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $16cbdb46106b353e$export$5339fcdc8e2a427c(url) {
    if ($16cbdb46106b353e$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $16cbdb46106b353e$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $16cbdb46106b353e$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $16cbdb46106b353e$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $4f85903ad30c6e77$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $4f85903ad30c6e77$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $4f85903ad30c6e77$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $4f85903ad30c6e77$export$d7a7d984b0791405] = "route";
        }
        if (!$16cbdb46106b353e$export$e258e13805402ba7(urlObject)) {
            attributes[0, $4f85903ad30c6e77$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $16cbdb46106b353e$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $16cbdb46106b353e$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $16cbdb46106b353e$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $16cbdb46106b353e$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $16cbdb46106b353e$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}





function $61e4acb496cca31f$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $da6e7e382c71fa3f$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $4f85903ad30c6e77$export$69cd5c610c7bb96a)]: value,
            [(0, $4f85903ad30c6e77$export$f5f95cff026507b5)]: unit
        });
    }
}
function $61e4acb496cca31f$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $4f85903ad30c6e77$export$f5f95cff026507b5];
        const value = attributes[0, $4f85903ad30c6e77$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}










const $cdac079b6d8f65e6$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $cdac079b6d8f65e6$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $cdac079b6d8f65e6$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




const $33ba91c08a4af5c9$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $abf3868e98b14473$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $33ba91c08a4af5c9$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



function $62c7328b3260b418$export$26d3d892edc56833(type, listener, options) {
    if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document) (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $62c7328b3260b418$export$324d7b4b46528191(type, listener, options) {
    if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document) (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


let $65993a596175c10a$var$firstHiddenTime = -1;
const $65993a596175c10a$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $65993a596175c10a$var$initHiddenTime = ()=>{
    return (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $65993a596175c10a$var$onVisibilityUpdate = (event)=>{
    if ($65993a596175c10a$var$isPageHidden(event) && $65993a596175c10a$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $65993a596175c10a$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($65993a596175c10a$var$firstHiddenTime)) {
            $65993a596175c10a$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $62c7328b3260b418$export$324d7b4b46528191)("prerenderingchange", $65993a596175c10a$var$onVisibilityUpdate, true);
        }
    }
};
const $65993a596175c10a$export$443f86b2c77012c4 = ()=>{
    if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document && $65993a596175c10a$var$firstHiddenTime < 0) {
        const activationStart = (0, $abf3868e98b14473$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $65993a596175c10a$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $65993a596175c10a$var$initHiddenTime();
        (0, $62c7328b3260b418$export$26d3d892edc56833)("visibilitychange", $65993a596175c10a$var$onVisibilityUpdate, true);
        (0, $62c7328b3260b418$export$26d3d892edc56833)("pagehide", $65993a596175c10a$var$onVisibilityUpdate, true);
        (0, $62c7328b3260b418$export$26d3d892edc56833)("prerenderingchange", $65993a596175c10a$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $65993a596175c10a$var$firstHiddenTime;
        },
        onHidden (cb) {
            $65993a596175c10a$var$onHiddenFunctions.add(cb);
        }
    };
};
function $65993a596175c10a$var$isPageHidden(event) {
    return event.type === "pagehide" || (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.visibilityState === "hidden";
}



const $30e85b7650151d34$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $3c626a340e54aaab$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $33ba91c08a4af5c9$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.prerendering || (0, $abf3868e98b14473$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $30e85b7650151d34$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $87334103abcacf23$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $87334103abcacf23$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$87334103abcacf23$var$instanceMap.get(identityObj)) $87334103abcacf23$var$instanceMap.set(identityObj, new ClassObj());
        return $87334103abcacf23$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $48ee5fc64765d4be$export$4050f7f955e19aa0 {
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


const $31d6fabab901ed23$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {}
    return;
};


const $01b591f63ed1e293$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};








const $9a4e36bdde5cef77$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $3d4be121cb159ec4$export$e610c735b5510cec = [
    1800,
    3e3
];
const $3d4be121cb159ec4$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $9a4e36bdde5cef77$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $65993a596175c10a$export$443f86b2c77012c4)();
        const metric = (0, $3c626a340e54aaab$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $abf3868e98b14473$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $31d6fabab901ed23$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $cdac079b6d8f65e6$export$17679dccdd551979)(onReport, metric, $3d4be121cb159ec4$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $379691878c6b7f36$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $379691878c6b7f36$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $3d4be121cb159ec4$export$fe3c86b74e15d5de)((0, $01b591f63ed1e293$export$b841d51e31c12bab)(()=>{
        const metric = (0, $3c626a340e54aaab$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $65993a596175c10a$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $87334103abcacf23$export$7c74c9b2462ddb3c)(opts, (0, $48ee5fc64765d4be$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $31d6fabab901ed23$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $cdac079b6d8f65e6$export$17679dccdd551979)(onReport, metric, $379691878c6b7f36$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $7399e18e995d85aa$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







let $0a6038c1ed89095f$var$interactionCountEstimate = 0;
let $0a6038c1ed89095f$var$minKnownInteractionId = Infinity;
let $0a6038c1ed89095f$var$maxKnownInteractionId = 0;
const $0a6038c1ed89095f$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $0a6038c1ed89095f$var$minKnownInteractionId = Math.min($0a6038c1ed89095f$var$minKnownInteractionId, e.interactionId);
            $0a6038c1ed89095f$var$maxKnownInteractionId = Math.max($0a6038c1ed89095f$var$maxKnownInteractionId, e.interactionId);
            $0a6038c1ed89095f$var$interactionCountEstimate = $0a6038c1ed89095f$var$maxKnownInteractionId ? ($0a6038c1ed89095f$var$maxKnownInteractionId - $0a6038c1ed89095f$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $0a6038c1ed89095f$var$po;
const $0a6038c1ed89095f$export$8a962f2683a476d1 = ()=>{
    return $0a6038c1ed89095f$var$po ? $0a6038c1ed89095f$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $0a6038c1ed89095f$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $0a6038c1ed89095f$var$po) return;
    $0a6038c1ed89095f$var$po = (0, $31d6fabab901ed23$export$d1203567a167490e)("event", $0a6038c1ed89095f$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $47f11c7d07657ee1$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $47f11c7d07657ee1$var$prevInteractionCount = 0;
const $47f11c7d07657ee1$var$getInteractionCountForNavigation = ()=>{
    return (0, $0a6038c1ed89095f$export$8a962f2683a476d1)() - $47f11c7d07657ee1$var$prevInteractionCount;
};
class $47f11c7d07657ee1$export$aaa80641d584351c {
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $47f11c7d07657ee1$var$prevInteractionCount = (0, $0a6038c1ed89095f$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($47f11c7d07657ee1$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $47f11c7d07657ee1$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $47f11c7d07657ee1$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($47f11c7d07657ee1$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}








const $487a2cba2a5d5748$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).requestIdleCallback || (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $01b591f63ed1e293$export$b841d51e31c12bab)(cb);
        (0, $62c7328b3260b418$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $62c7328b3260b418$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $62c7328b3260b418$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $62c7328b3260b418$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};


const $0119c6c23f834180$export$7f4cb060ded9173c = [
    200,
    500
];
const $0119c6c23f834180$var$DEFAULT_DURATION_THRESHOLD = 40;
const $0119c6c23f834180$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $65993a596175c10a$export$443f86b2c77012c4)();
    (0, $9a4e36bdde5cef77$export$8bdb38a5671b594e)(()=>{
        (0, $0a6038c1ed89095f$export$67d90cda6b78a2eb)();
        const metric = (0, $3c626a340e54aaab$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $87334103abcacf23$export$7c74c9b2462ddb3c)(opts, (0, $47f11c7d07657ee1$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $487a2cba2a5d5748$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $31d6fabab901ed23$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $0119c6c23f834180$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $cdac079b6d8f65e6$export$17679dccdd551979)(onReport, metric, $0119c6c23f834180$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








class $b91a09dbd0f119cd$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






const $12dcff8ce3bb5553$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $12dcff8ce3bb5553$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $9a4e36bdde5cef77$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $65993a596175c10a$export$443f86b2c77012c4)();
        const metric = (0, $3c626a340e54aaab$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $87334103abcacf23$export$7c74c9b2462ddb3c)(opts, (0, $b91a09dbd0f119cd$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $abf3868e98b14473$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $31d6fabab901ed23$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $cdac079b6d8f65e6$export$17679dccdd551979)(onReport, metric, $12dcff8ce3bb5553$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $01b591f63ed1e293$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $487a2cba2a5d5748$export$d3314d5863fc1fef)(stopListening);
                    (0, $62c7328b3260b418$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $62c7328b3260b418$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









const $19dc6eeafc7e9380$export$65c59ea8064668fc = [
    800,
    1800
];
const $19dc6eeafc7e9380$var$whenReady = (callback)=>{
    if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.prerendering) (0, $9a4e36bdde5cef77$export$8bdb38a5671b594e)(()=>$19dc6eeafc7e9380$var$whenReady(callback));
    else if ((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$19dc6eeafc7e9380$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $19dc6eeafc7e9380$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $3c626a340e54aaab$export$3c29b44508a0612b)("TTFB");
    const report = (0, $cdac079b6d8f65e6$export$17679dccdd551979)(onReport, metric, $19dc6eeafc7e9380$export$65c59ea8064668fc, opts.reportAllChanges);
    $19dc6eeafc7e9380$var$whenReady(()=>{
        const navigationEntry = (0, $33ba91c08a4af5c9$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $abf3868e98b14473$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $43f5d9c7ac2ec95d$var$handlers = {};
const $43f5d9c7ac2ec95d$var$instrumented = {};
let $43f5d9c7ac2ec95d$var$_previousCls;
let $43f5d9c7ac2ec95d$var$_previousLcp;
let $43f5d9c7ac2ec95d$var$_previousTtfb;
let $43f5d9c7ac2ec95d$var$_previousInp;
function $43f5d9c7ac2ec95d$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $43f5d9c7ac2ec95d$var$addMetricObserver("cls", callback, $43f5d9c7ac2ec95d$var$instrumentCls, $43f5d9c7ac2ec95d$var$_previousCls, stopOnCallback);
}
function $43f5d9c7ac2ec95d$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $43f5d9c7ac2ec95d$var$addMetricObserver("lcp", callback, $43f5d9c7ac2ec95d$var$instrumentLcp, $43f5d9c7ac2ec95d$var$_previousLcp, stopOnCallback);
}
function $43f5d9c7ac2ec95d$export$699d9529c099a797(callback) {
    return $43f5d9c7ac2ec95d$var$addMetricObserver("ttfb", callback, $43f5d9c7ac2ec95d$var$instrumentTtfb, $43f5d9c7ac2ec95d$var$_previousTtfb);
}
function $43f5d9c7ac2ec95d$export$da3b76aa2022cbd7(callback) {
    return $43f5d9c7ac2ec95d$var$addMetricObserver("inp", callback, $43f5d9c7ac2ec95d$var$instrumentInp, $43f5d9c7ac2ec95d$var$_previousInp);
}
function $43f5d9c7ac2ec95d$export$69816c1a049f8db6(type, callback) {
    $43f5d9c7ac2ec95d$var$addHandler(type, callback);
    if (!$43f5d9c7ac2ec95d$var$instrumented[type]) {
        $43f5d9c7ac2ec95d$var$instrumentPerformanceObserver(type);
        $43f5d9c7ac2ec95d$var$instrumented[type] = true;
    }
    return $43f5d9c7ac2ec95d$var$getCleanupCallback(type, callback);
}
function $43f5d9c7ac2ec95d$var$triggerHandlers(type, data) {
    const typeHandlers = $43f5d9c7ac2ec95d$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $40a6d78e295685ac$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}
function $43f5d9c7ac2ec95d$var$instrumentCls() {
    return (0, $379691878c6b7f36$export$a7873055838e5ad8)((metric)=>{
        $43f5d9c7ac2ec95d$var$triggerHandlers("cls", {
            metric: metric
        });
        $43f5d9c7ac2ec95d$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $43f5d9c7ac2ec95d$var$instrumentLcp() {
    return (0, $12dcff8ce3bb5553$export$947b1626ab8d5632)((metric)=>{
        $43f5d9c7ac2ec95d$var$triggerHandlers("lcp", {
            metric: metric
        });
        $43f5d9c7ac2ec95d$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $43f5d9c7ac2ec95d$var$instrumentTtfb() {
    return (0, $19dc6eeafc7e9380$export$33a01e6c5f2c7e33)((metric)=>{
        $43f5d9c7ac2ec95d$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $43f5d9c7ac2ec95d$var$_previousTtfb = metric;
    });
}
function $43f5d9c7ac2ec95d$var$instrumentInp() {
    return (0, $0119c6c23f834180$export$7df4b36ecaed99e1)((metric)=>{
        $43f5d9c7ac2ec95d$var$triggerHandlers("inp", {
            metric: metric
        });
        $43f5d9c7ac2ec95d$var$_previousInp = metric;
    });
}
function $43f5d9c7ac2ec95d$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $43f5d9c7ac2ec95d$var$addHandler(type, callback);
    let stopListening;
    if (!$43f5d9c7ac2ec95d$var$instrumented[type]) {
        stopListening = instrumentFn();
        $43f5d9c7ac2ec95d$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $43f5d9c7ac2ec95d$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $43f5d9c7ac2ec95d$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $31d6fabab901ed23$export$d1203567a167490e)(type, (entries)=>{
        $43f5d9c7ac2ec95d$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $43f5d9c7ac2ec95d$var$addHandler(type, handler) {
    $43f5d9c7ac2ec95d$var$handlers[type] = $43f5d9c7ac2ec95d$var$handlers[type] || [];
    $43f5d9c7ac2ec95d$var$handlers[type].push(handler);
}
function $43f5d9c7ac2ec95d$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $43f5d9c7ac2ec95d$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $43f5d9c7ac2ec95d$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}











function $722bd0753abb2ab8$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $722bd0753abb2ab8$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $722bd0753abb2ab8$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $6967c74e7baedc72$export$f5b060c2914b97c8)(value)) return (0, $d03aa350cae2668a$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}



function $c69346a2d23996e5$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $69ce7f61acfb23d2$var$logIgnoredSpan(droppedSpan) {
    (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $69ce7f61acfb23d2$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($69ce7f61acfb23d2$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $c29d6ad4887306ad$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $fc6c683469493657$export$16a28057038b10ef) && $69ce7f61acfb23d2$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $c29d6ad4887306ad$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $c29d6ad4887306ad$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$69ce7f61acfb23d2$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $fc6c683469493657$export$16a28057038b10ef) && $69ce7f61acfb23d2$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $69ce7f61acfb23d2$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $c29d6ad4887306ad$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $69ce7f61acfb23d2$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $69ce7f61acfb23d2$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


function $2981c501e34e3f89$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}








const $7684020d7aa79e0a$export$849dbeeeda01ae98 = "production";
const $7684020d7aa79e0a$export$6829f580e78306fa = "development";










const $d83cd13c6c283d37$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $d83cd13c6c283d37$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $e632e89186c3a412$export$e73679ffaf56810e)(spanWithMaybeDsc, $d83cd13c6c283d37$var$FROZEN_DSC_FIELD, dsc);
}
function $d83cd13c6c283d37$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $7684020d7aa79e0a$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $afc8bc964220c0ab$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $d83cd13c6c283d37$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $d83cd13c6c283d37$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $d83cd13c6c283d37$export$a117f995597e25df(span) {
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $4f85903ad30c6e77$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $4f85903ad30c6e77$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$d83cd13c6c283d37$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $9f26a8da2adcdb3c$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $d83cd13c6c283d37$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $4f85903ad30c6e77$export$d7a7d984b0791405] ?? rootSpanAttributes["sentry.span.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $c69346a2d23996e5$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $da6e7e382c71fa3f$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $da05531b2faa2b9e$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $d83cd13c6c283d37$export$95cf936fdacaff7b(span) {
    const dsc = $d83cd13c6c283d37$export$a117f995597e25df(span);
    return (0, $9f26a8da2adcdb3c$export$56766feef403f365)(dsc);
}





function $96ffb72e33c179f2$export$2f3d84e767c9592b(span) {
    if (!(0, $fc6c683469493657$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $da6e7e382c71fa3f$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $96ffb72e33c179f2$export$b77c830667a4d630(span) {
    if (!(0, $fc6c683469493657$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(msg);
}






function $240ddf69b1e4ca67$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $c69346a2d23996e5$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $be51ae5ea672b965$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




class $8dfa46a2f1bff133$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $9325d4385801d3cd$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $9325d4385801d3cd$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $da6e7e382c71fa3f$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}






function $4dcc05c65ccfe3c5$export$d3f49b33a1f44720(callback) {
    (0, $e632e89186c3a412$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $4dcc05c65ccfe3c5$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}








function $19d9696247d655d7$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $19d9696247d655d7$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $19d9696247d655d7$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $19d9696247d655d7$export$604a45d95a155e2b(envelope, types) {
    return $19d9696247d655d7$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $19d9696247d655d7$var$encodeUTF8(input) {
    const carrier = (0, $ae40082355c0ca7d$export$c8bfa33e4e8ae492)((0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $19d9696247d655d7$var$decodeUTF8(input) {
    const carrier = (0, $ae40082355c0ca7d$export$c8bfa33e4e8ae492)((0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $19d9696247d655d7$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $19d9696247d655d7$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $19d9696247d655d7$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $85448db1d36b6561$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $19d9696247d655d7$var$concatBuffers(parts);
}
function $19d9696247d655d7$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $19d9696247d655d7$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $19d9696247d655d7$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($19d9696247d655d7$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $19d9696247d655d7$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $19d9696247d655d7$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $19d9696247d655d7$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $19d9696247d655d7$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $19d9696247d655d7$var$_isOverriddenType(type) {
    return type in $19d9696247d655d7$var$DATA_CATEGORY_OVERRIDES;
}
function $19d9696247d655d7$export$b11169581eeaf237(type) {
    return $19d9696247d655d7$var$_isOverriddenType(type) ? $19d9696247d655d7$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $19d9696247d655d7$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $19d9696247d655d7$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date((0, $c95243b7bfad6ddc$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $afc8bc964220c0ab$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





function $1b1ef97493a1ef2c$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $1b1ef97493a1ef2c$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $19d9696247d655d7$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date((0, $c95243b7bfad6ddc$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $afc8bc964220c0ab$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $19d9696247d655d7$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $1b1ef97493a1ef2c$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $19d9696247d655d7$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $1b1ef97493a1ef2c$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $19d9696247d655d7$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $19d9696247d655d7$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $1b1ef97493a1ef2c$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $d83cd13c6c283d37$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date((0, $c95243b7bfad6ddc$export$65b1bada40c91b34)()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $afc8bc964220c0ab$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(span);
        return !(0, $69ce7f61acfb23d2$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(span);
        const processedSpan = !(0, $4dcc05c65ccfe3c5$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $da6e7e382c71fa3f$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $da6e7e382c71fa3f$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $19d9696247d655d7$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $19d9696247d655d7$export$f93f7f385160c44e)(headers, items);
}












const $b87eeb42e9fc195e$var$MAX_SPAN_COUNT = 1e3;
class $b87eeb42e9fc195e$export$a92149b045260d9f {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $9325d4385801d3cd$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $9325d4385801d3cd$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $093eae9201b28ce4$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "manual",
            [(0, $4f85903ad30c6e77$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $da6e7e382c71fa3f$export$eb571cd9b5d98de8) : (0, $da6e7e382c71fa3f$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $da6e7e382c71fa3f$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $4f85903ad30c6e77$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) return;
        this._endTime = (0, $da6e7e382c71fa3f$export$3f7581298f56c6d7)(endTimestamp);
        (0, $96ffb72e33c179f2$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $4f85903ad30c6e77$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $da6e7e382c71fa3f$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $4f85903ad30c6e77$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $4f85903ad30c6e77$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $4f85903ad30c6e77$export$fea48ba9f4550879],
            measurements: (0, $61e4acb496cca31f$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $da6e7e382c71fa3f$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(this),
            status: (0, $da6e7e382c71fa3f$export$457dcd3df4e9f5c6)(this._status),
            attributes: this._attributes,
            links: (0, $da6e7e382c71fa3f$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $b87eeb42e9fc195e$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $093eae9201b28ce4$export$ee52dced521e3e18)();
        const attributes = $b87eeb42e9fc195e$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $da6e7e382c71fa3f$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        if (this._isStandaloneSpan) {
            if (this._sampled) $b87eeb42e9fc195e$var$sendSpanEnvelope((0, $1b1ef97493a1ef2c$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && (0, $2981c501e34e3f89$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $da05531b2faa2b9e$export$c08fbc656a245d03)(this).scope || (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        if (!$b87eeb42e9fc195e$var$isFullFinishedSpan((0, $da6e7e382c71fa3f$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $da05531b2faa2b9e$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        const finishedSpans = (0, $da6e7e382c71fa3f$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$b87eeb42e9fc195e$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $da6e7e382c71fa3f$export$92d8c23565496537)(span)).filter($b87eeb42e9fc195e$var$isFullFinishedSpan);
        const source = this._attributes[0, $4f85903ad30c6e77$export$d7a7d984b0791405];
        delete this._attributes[0, $4f85903ad30c6e77$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[0, $4f85903ad30c6e77$export$165ce9a229f6f050];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: (0, $da6e7e382c71fa3f$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $b87eeb42e9fc195e$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $b87eeb42e9fc195e$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $d83cd13c6c283d37$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $61e4acb496cca31f$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $b87eeb42e9fc195e$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $b87eeb42e9fc195e$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $b87eeb42e9fc195e$var$isStandaloneSpan(span) {
    return span instanceof $b87eeb42e9fc195e$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $b87eeb42e9fc195e$var$sendSpanEnvelope(envelope) {
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




const $274e9bcb6eb7453f$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $274e9bcb6eb7453f$export$a1bd95187356f372(options, callback) {
    const acs = $274e9bcb6eb7453f$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $274e9bcb6eb7453f$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $89fdb8ff58631b88$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $274e9bcb6eb7453f$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)();
            const parentSpan = $274e9bcb6eb7453f$var$getParentSpan(scope, customParentSpan);
            const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $8dfa46a2f1bff133$export$d6636b700b76c516)() : $274e9bcb6eb7453f$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent("no_parent_span", "span");
            if (!$274e9bcb6eb7453f$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $dc550567d0a83b87$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $722bd0753abb2ab8$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $5a487d463608a018$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $274e9bcb6eb7453f$export$c10292ad04b92aea(options, callback) {
    const acs = $274e9bcb6eb7453f$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $274e9bcb6eb7453f$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $89fdb8ff58631b88$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $274e9bcb6eb7453f$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)();
            const parentSpan = $274e9bcb6eb7453f$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $8dfa46a2f1bff133$export$d6636b700b76c516)() : $274e9bcb6eb7453f$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)()?.recordDroppedEvent("no_parent_span", "span");
            if (!$274e9bcb6eb7453f$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $dc550567d0a83b87$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $722bd0753abb2ab8$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $5a487d463608a018$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $274e9bcb6eb7453f$export$63dbba021a6b4047(options) {
    const acs = $274e9bcb6eb7453f$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $274e9bcb6eb7453f$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $89fdb8ff58631b88$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$274e9bcb6eb7453f$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)();
        const parentSpan = $274e9bcb6eb7453f$var$getParentSpan(scope, customParentSpan);
        const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent("no_parent_span", "span");
            return new (0, $8dfa46a2f1bff133$export$d6636b700b76c516)();
        }
        return $274e9bcb6eb7453f$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $274e9bcb6eb7453f$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    const acs = (0, $a40db583fbfcfb8f$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $9f26a8da2adcdb3c$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $4c7975f49d7b70e6$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $274e9bcb6eb7453f$export$f90b03291402f553(callback);
    return (0, $89fdb8ff58631b88$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $4c7975f49d7b70e6$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $dc550567d0a83b87$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $274e9bcb6eb7453f$export$e57ac09b143d92a2(span, callback) {
    const acs = $274e9bcb6eb7453f$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $89fdb8ff58631b88$export$ec58d9285c204497)((scope)=>{
        (0, $dc550567d0a83b87$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $274e9bcb6eb7453f$export$869298f9835abc68(callback) {
    const acs = $274e9bcb6eb7453f$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $89fdb8ff58631b88$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$274e9bcb6eb7453f$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$274e9bcb6eb7453f$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $274e9bcb6eb7453f$export$f90b03291402f553(callback) {
    const acs = $274e9bcb6eb7453f$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $89fdb8ff58631b88$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $9325d4385801d3cd$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c95243b7bfad6ddc$export$9869d72de32a3917)()
        });
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $274e9bcb6eb7453f$export$e57ac09b143d92a2(null, callback);
    });
}
function $274e9bcb6eb7453f$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $c69346a2d23996e5$export$1f70765132c3c225)()) {
        const span2 = new (0, $8dfa46a2f1bff133$export$d6636b700b76c516)();
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...(0, $d83cd13c6c283d37$export$a117f995597e25df)(span2)
            };
            (0, $d83cd13c6c283d37$export$7398c93e763ca9fd)(span2, dsc);
        }
        return span2;
    }
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    if ($274e9bcb6eb7453f$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$274e9bcb6eb7453f$var$_isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        return new (0, $8dfa46a2f1bff133$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = (0, $89fdb8ff58631b88$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $274e9bcb6eb7453f$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $da6e7e382c71fa3f$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $d83cd13c6c283d37$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $da6e7e382c71fa3f$export$5caecac1caaf3a71)(parentSpan);
        span = $274e9bcb6eb7453f$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $d83cd13c6c283d37$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $274e9bcb6eb7453f$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $d83cd13c6c283d37$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $96ffb72e33c179f2$export$2f3d84e767c9592b)(span);
    (0, $da05531b2faa2b9e$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
function $274e9bcb6eb7453f$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $da6e7e382c71fa3f$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $274e9bcb6eb7453f$var$getAcs() {
    const carrier = (0, $ae40082355c0ca7d$export$19eade501500c6c1)();
    return (0, $a40db583fbfcfb8f$export$f639b0c2752203be)(carrier);
}
function $274e9bcb6eb7453f$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $274e9bcb6eb7453f$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : (0, $240ddf69b1e4ca67$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $be51ae5ea672b965$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $b87eeb42e9fc195e$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $4f85903ad30c6e77$export$d7a7d984b0791405)]: "custom",
            [(0, $4f85903ad30c6e77$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $2981c501e34e3f89$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $274e9bcb6eb7453f$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $274e9bcb6eb7453f$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : (0, $da6e7e382c71fa3f$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $b87eeb42e9fc195e$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $8dfa46a2f1bff133$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $da6e7e382c71fa3f$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $2981c501e34e3f89$export$6ea47215d699c04a)(client) && childSpan instanceof (0, $8dfa46a2f1bff133$export$d6636b700b76c516)) {
        if (parentSpan instanceof (0, $8dfa46a2f1bff133$export$d6636b700b76c516) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $274e9bcb6eb7453f$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $dc550567d0a83b87$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $274e9bcb6eb7453f$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $274e9bcb6eb7453f$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $274e9bcb6eb7453f$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $2981c501e34e3f89$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $69ce7f61acfb23d2$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, $4f85903ad30c6e77$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $274e9bcb6eb7453f$var$_isIgnoredSpan(span) {
    return span instanceof (0, $8dfa46a2f1bff133$export$d6636b700b76c516) && span.dropReason === "ignored";
}
function $274e9bcb6eb7453f$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$274e9bcb6eb7453f$export$61ab4e30f2201736] === true;
}





const $6da5f8a1cc31388d$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb(event);
    };
    (0, $62c7328b3260b418$export$26d3d892edc56833)("visibilitychange", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    (0, $62c7328b3260b418$export$26d3d892edc56833)("pagehide", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


function $f3bf6b7560144a6f$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
function $f3bf6b7560144a6f$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    return (0, $274e9bcb6eb7453f$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $274e9bcb6eb7453f$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
function $f3bf6b7560144a6f$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    const { userInfo: userInfo } = client.getDataCollectionOptions();
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId();
    const scope = (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
    let profileId;
    try {
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {}
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || void 0,
        profile_id: profileId || void 0,
        replay_id: replayId || void 0,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": userInfo ? "{{auto}}" : void 0,
        ...passedAttributes
    };
    return (0, $274e9bcb6eb7453f$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
function $f3bf6b7560144a6f$export$f72a13c439a30cab() {
    return (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).addEventListener && (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).performance;
}
function $f3bf6b7560144a6f$export$b4785dbd4a81b33f(time) {
    return time / 1e3;
}
function $f3bf6b7560144a6f$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) name = _name;
    return {
        name: name,
        version: version
    };
}
function $f3bf6b7560144a6f$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
function $f3bf6b7560144a6f$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpan;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    (0, $6da5f8a1cc31388d$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce("pagehide");
    });
    const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options)=>{
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce("navigation");
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span)=>{
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $455e6c0370c13dc1$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $f3bf6b7560144a6f$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $43f5d9c7ac2ec95d$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $f3bf6b7560144a6f$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $455e6c0370c13dc1$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $455e6c0370c13dc1$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $093eae9201b28ce4$export$ee52dced521e3e18)();
    const routeName = (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {
        [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $4f85903ad30c6e77$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $4f85903ad30c6e77$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $65ba4186be3cc942$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $f3bf6b7560144a6f$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $4f85903ad30c6e77$export$f5f95cff026507b5)]: "",
            [(0, $4f85903ad30c6e77$export$69cd5c610c7bb96a)]: clsValue
        });
        span.end(startTime);
    }
}








const $172cf9be6475b238$export$ccce4d286bdc973b = 6e4;
function $172cf9be6475b238$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $172cf9be6475b238$export$ccce4d286bdc973b;
}
function $172cf9be6475b238$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $f3bf6b7560144a6f$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $43f5d9c7ac2ec95d$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$172cf9be6475b238$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $f3bf6b7560144a6f$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $172cf9be6475b238$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
function $172cf9be6475b238$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$172cf9be6475b238$export$e59775b7d17699ba(lcpValue)) return;
    (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {
        [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.http.browser.lcp",
        [(0, $4f85903ad30c6e77$export$1a413bd9a88fdb09)]: "ui.webvital.lcp",
        [(0, $4f85903ad30c6e77$export$fea48ba9f4550879)]: 0,
        // LCP is a point-in-time metric
        // attach the pageload span id to the LCP span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry) {
        entry.element && (attributes["lcp.element"] = (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes["lcp.id"] = entry.id);
        entry.url && (attributes["lcp.url"] = entry.url);
        entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
        entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
        entry.size != null && (attributes["lcp.size"] = entry.size);
    }
    const span = (0, $f3bf6b7560144a6f$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("lcp", {
            [(0, $4f85903ad30c6e77$export$f5f95cff026507b5)]: "millisecond",
            [(0, $4f85903ad30c6e77$export$69cd5c610c7bb96a)]: lcpValue
        });
        span.end(startTime);
    }
}




function $08f8a3bb3dd5392e$var$getAbsoluteTime(time) {
    return time ? (((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1e3 : time;
}
function $08f8a3bb3dd5392e$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    if (resourceTiming.nextHopProtocol != void 0) {
        const { name: name, version: version } = (0, $f3bf6b7560144a6f$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData["network.protocol.version"] = version;
        timingSpanData["network.protocol.name"] = name;
    }
    if (!((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() || (0, $f3bf6b7560144a6f$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $08f8a3bb3dd5392e$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        "http.request.redirect_start": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.redirectStart),
        "http.request.redirect_end": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.redirectEnd),
        "http.request.worker_start": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.workerStart),
        "http.request.fetch_start": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.fetchStart),
        "http.request.domain_lookup_start": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        "http.request.domain_lookup_end": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        "http.request.connect_start": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.connectStart),
        "http.request.secure_connection_start": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        "http.request.connection_end": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.connectEnd),
        "http.request.request_start": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.requestStart),
        "http.request.response_start": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.responseStart),
        "http.request.response_end": $08f8a3bb3dd5392e$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
    });
}
function $08f8a3bb3dd5392e$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}







const $3a117087bc36f0b7$var$MAX_INT_AS_BYTES = 2147483647;
let $3a117087bc36f0b7$var$_performanceCursor = 0;
let $3a117087bc36f0b7$var$_measurements = {};
let $3a117087bc36f0b7$var$_lcpEntry;
let $3a117087bc36f0b7$var$_clsEntry;
function $3a117087bc36f0b7$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $f3bf6b7560144a6f$export$f72a13c439a30cab)();
    if (performance && (0, $093eae9201b28ce4$export$baf075a948ffc0bf)()) {
        if (performance.mark) (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $172cf9be6475b238$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $3a117087bc36f0b7$var$_trackLCP() : void 0;
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $455e6c0370c13dc1$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $3a117087bc36f0b7$var$_trackCLS() : void 0;
        const ttfbCleanupCallback = $3a117087bc36f0b7$var$_trackTtfb();
        const fpFcpCleanupCallback = $3a117087bc36f0b7$var$_trackFpFcp();
        return ()=>{
            ttfbCleanupCallback();
            fpFcpCleanupCallback();
            lcpCleanupCallback?.();
            clsCleanupCallback?.();
        };
    }
    return ()=>void 0;
}
function $3a117087bc36f0b7$export$f396d19077034ad2() {
    (0, $43f5d9c7ac2ec95d$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $da6e7e382c71fa3f$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $f3bf6b7560144a6f$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
function $3a117087bc36f0b7$export$5b823ab2ccbc801d() {
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $da6e7e382c71fa3f$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $f3bf6b7560144a6f$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
function $3a117087bc36f0b7$export$e27543e0976315e4() {
    (0, $43f5d9c7ac2ec95d$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $da6e7e382c71fa3f$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $daa55f1f0d1b69e5$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $f3bf6b7560144a6f$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
function $3a117087bc36f0b7$var$_trackCLS() {
    return (0, $43f5d9c7ac2ec95d$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $3a117087bc36f0b7$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $3a117087bc36f0b7$var$_clsEntry = entry;
    }, true);
}
function $3a117087bc36f0b7$var$_trackLCP() {
    return (0, $43f5d9c7ac2ec95d$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $172cf9be6475b238$export$e59775b7d17699ba)(metric.value)) return;
        $3a117087bc36f0b7$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $3a117087bc36f0b7$var$_lcpEntry = entry;
    }, true);
}
function $3a117087bc36f0b7$var$_trackTtfb() {
    return (0, $43f5d9c7ac2ec95d$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $3a117087bc36f0b7$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
function $3a117087bc36f0b7$var$_trackFpFcp() {
    return (0, $43f5d9c7ac2ec95d$export$69816c1a049f8db6)("paint", ({ entries: entries })=>{
        const firstHidden = (0, $65993a596175c10a$export$443f86b2c77012c4)();
        for (const entry of entries){
            const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
            if (entry.name === "first-paint" && shouldRecord) $3a117087bc36f0b7$var$_measurements["fp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
            if (entry.name === "first-contentful-paint" && shouldRecord) $3a117087bc36f0b7$var$_measurements["fcp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
        }
    });
}
function $3a117087bc36f0b7$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $f3bf6b7560144a6f$export$f72a13c439a30cab)();
    const origin = (0, $093eae9201b28ce4$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) return;
    const { spanStreamingEnabled: spanStreamingEnabled, ignorePerformanceApiSpans: ignorePerformanceApiSpans, ignoreResourceSpans: ignoreResourceSpans } = options;
    const timeOrigin = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(span);
    performanceEntries.slice($3a117087bc36f0b7$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $3a117087bc36f0b7$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                $3a117087bc36f0b7$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                break;
            case "resource":
                $3a117087bc36f0b7$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $3a117087bc36f0b7$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $3a117087bc36f0b7$var$_trackNavigator(span, spanStreamingEnabled);
}
function $3a117087bc36f0b7$export$d14e394b690acc17(span, options) {
    const origin = (0, $093eae9201b28ce4$export$baf075a948ffc0bf)();
    if (!(0, $f3bf6b7560144a6f$export$f72a13c439a30cab)()?.getEntries || !origin) {
        $3a117087bc36f0b7$var$resetWebVitalState();
        return;
    }
    const { spanStreamingEnabled: spanStreamingEnabled, recordClsOnPageloadSpan: recordClsOnPageloadSpan, recordLcpOnPageloadSpan: recordLcpOnPageloadSpan } = options;
    const timeOrigin = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(origin);
    if ((0, $da6e7e382c71fa3f$export$92d8c23565496537)(span).op === "pageload") {
        $3a117087bc36f0b7$var$_addTtfbRequestTimeToMeasurements($3a117087bc36f0b7$var$_measurements);
        if (spanStreamingEnabled) {
            const setAttr = (shortWebVitalName, value, customAttrName)=>{
                const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
                span.setAttribute(attrKey, value);
                (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log("Setting web vital attribute", {
                    [attrKey]: value
                }, "on pageload span");
            };
            [
                "ttfb",
                "fp",
                "fcp"
            ].forEach((measurementName)=>{
                if ($3a117087bc36f0b7$var$_measurements[measurementName]) setAttr(measurementName, $3a117087bc36f0b7$var$_measurements[measurementName].value);
            });
            if ($3a117087bc36f0b7$var$_measurements["ttfb.requestTime"]) setAttr("ttfb.requestTime", $3a117087bc36f0b7$var$_measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
        } else {
            if (!recordClsOnPageloadSpan) delete $3a117087bc36f0b7$var$_measurements.cls;
            if (!recordLcpOnPageloadSpan) delete $3a117087bc36f0b7$var$_measurements.lcp;
            Object.entries($3a117087bc36f0b7$var$_measurements).forEach(([measurementName, measurement])=>{
                (0, $61e4acb496cca31f$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit, span);
            });
            $3a117087bc36f0b7$var$_setWebVitalAttributes(span, options);
        }
        span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
        span.setAttribute(spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart", (0, $abf3868e98b14473$export$d3e828b3c7b5b845)());
    }
    $3a117087bc36f0b7$var$resetWebVitalState();
}
function $3a117087bc36f0b7$var$resetWebVitalState() {
    $3a117087bc36f0b7$var$_lcpEntry = void 0;
    $3a117087bc36f0b7$var$_clsEntry = void 0;
    $3a117087bc36f0b7$var$_measurements = {};
}
function $3a117087bc36f0b7$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== "measure") return;
    try {
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
function $3a117087bc36f0b7$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($3a117087bc36f0b7$var$isReact19MeasureEntry(entry)) return;
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $c29d6ad4887306ad$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $33ba91c08a4af5c9$export$6431553786c94949)(false);
    const requestTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $3a117087bc36f0b7$var$_addDetailToSpanAttributes(attributes, entry);
    if (measureStartTimestamp <= measureEndTimestamp) (0, $f3bf6b7560144a6f$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $3a117087bc36f0b7$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        const detail = performanceMeasure.detail;
        if (!detail) return;
        if (typeof detail === "object") {
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $6967c74e7baedc72$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== void 0) try {
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {}
            }
            return;
        }
        if ((0, $6967c74e7baedc72$export$c3825b437cbdea5c)(detail)) {
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch  {}
    } catch  {}
}
function $3a117087bc36f0b7$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $3a117087bc36f0b7$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $3a117087bc36f0b7$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $3a117087bc36f0b7$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $3a117087bc36f0b7$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $3a117087bc36f0b7$var$_addRequest(span, entry, timeOrigin);
}
function $3a117087bc36f0b7$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $3a117087bc36f0b7$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $f3bf6b7560144a6f$export$7567a67bdb69a23d)(span, timeOrigin + (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics",
            ...event === "redirect" && entry.redirectCount != null ? {
                "http.redirect_count": entry.redirectCount
            } : {}
        }
    });
}
function $3a117087bc36f0b7$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
function $3a117087bc36f0b7$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        (0, $f3bf6b7560144a6f$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $f3bf6b7560144a6f$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
function $3a117087bc36f0b7$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    const parsedUrl = (0, $16cbdb46106b353e$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).location.origin);
    $3a117087bc36f0b7$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            "responseStatus",
            "http.response.status_code"
        ],
        [
            "transferSize",
            "http.response_transfer_size"
        ],
        [
            "encodedBodySize",
            "http.response_content_length"
        ],
        [
            "decodedBodySize",
            "http.decoded_response_content_length"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            "renderBlockingStatus",
            "resource.render_blocking_status"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            "deliveryType",
            "http.response_delivery_type"
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $08f8a3bb3dd5392e$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $f3bf6b7560144a6f$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $7399e18e995d85aa$export$56d8a8a25bd48b81).location.origin, ""),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
function $3a117087bc36f0b7$var$_trackNavigator(span, spanStreamingEnabled) {
    const navigator = (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
        if ((0, $f3bf6b7560144a6f$export$27169ccae1b439e3)(connection.rtt)) {
            if (spanStreamingEnabled) span.setAttribute("network.connection.rtt", connection.rtt);
            else if ((0, $da6e7e382c71fa3f$export$92d8c23565496537)(span).op === "pageload") (0, $61e4acb496cca31f$export$7cc31b475d33a706)("connection.rtt", connection.rtt, "millisecond");
        }
    }
    if ((0, $f3bf6b7560144a6f$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
        else span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    }
    if ((0, $f3bf6b7560144a6f$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
        else span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
function $3a117087bc36f0b7$var$_setWebVitalAttributes(span, options) {
    if ($3a117087bc36f0b7$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        if ($3a117087bc36f0b7$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $65ba4186be3cc942$export$5647df6b7814ac86)($3a117087bc36f0b7$var$_lcpEntry.element));
        if ($3a117087bc36f0b7$var$_lcpEntry.id) span.setAttribute("lcp.id", $3a117087bc36f0b7$var$_lcpEntry.id);
        if ($3a117087bc36f0b7$var$_lcpEntry.url) span.setAttribute("lcp.url", $3a117087bc36f0b7$var$_lcpEntry.url.trim().slice(0, 200));
        if ($3a117087bc36f0b7$var$_lcpEntry.loadTime != null) span.setAttribute("lcp.loadTime", $3a117087bc36f0b7$var$_lcpEntry.loadTime);
        if ($3a117087bc36f0b7$var$_lcpEntry.renderTime != null) span.setAttribute("lcp.renderTime", $3a117087bc36f0b7$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $3a117087bc36f0b7$var$_lcpEntry.size);
    }
    if ($3a117087bc36f0b7$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $3a117087bc36f0b7$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $65ba4186be3cc942$export$5647df6b7814ac86)(source.node)));
}
function $3a117087bc36f0b7$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === "number" && entryVal < $3a117087bc36f0b7$var$MAX_INT_AS_BYTES || typeof entryVal === "string")) attributes[attributeKey] = entryVal;
    });
}
function $3a117087bc36f0b7$var$_addTtfbRequestTimeToMeasurements(_measurements2) {
    const navEntry = (0, $33ba91c08a4af5c9$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements2["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}











function $12668e9127796b68$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $eba7c8bf7b81317f$export$a4e09611e30da72e)(type, handler);
    (0, $eba7c8bf7b81317f$export$e18d6c5462c01368)(type, ()=>$12668e9127796b68$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $12668e9127796b68$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $eba7c8bf7b81317f$export$a4e09611e30da72e)(type, handler);
    (0, $eba7c8bf7b81317f$export$e18d6c5462c01368)(type, ()=>$12668e9127796b68$var$instrumentFetch($12668e9127796b68$var$streamHandler));
    return removeHandler;
}
function $12668e9127796b68$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $0d3379006a83d70a$export$c82d238e23c40b21)()) return;
    (0, $e632e89186c3a412$export$9563e054e6f787fb)((0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $12668e9127796b68$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $093eae9201b28ce4$export$ee52dced521e3e18)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $12668e9127796b68$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $eba7c8bf7b81317f$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            return originalFetch.apply((0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $eba7c8bf7b81317f$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $093eae9201b28ce4$export$ee52dced521e3e18)() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $eba7c8bf7b81317f$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $093eae9201b28ce4$export$ee52dced521e3e18)() * 1e3,
                    error: error
                });
                if ((0, $6967c74e7baedc72$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $e632e89186c3a412$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $e632e89186c3a412$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $12668e9127796b68$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $12668e9127796b68$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $12668e9127796b68$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $eba7c8bf7b81317f$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $093eae9201b28ce4$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $12668e9127796b68$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $12668e9127796b68$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($12668e9127796b68$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $12668e9127796b68$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $12668e9127796b68$var$getUrlFromResource(resource),
            method: $12668e9127796b68$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $6967c74e7baedc72$export$6d3d1f317d7cda57)(resource) && $12668e9127796b68$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $12668e9127796b68$var$getUrlFromResource(arg),
        method: $12668e9127796b68$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $12668e9127796b68$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $6967c74e7baedc72$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}




const $687b4f8be478ce5b$export$b14a8888f80a0b3e = [];
function $687b4f8be478ce5b$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $687b4f8be478ce5b$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $687b4f8be478ce5b$var$filterDuplicates(integrations);
}
function $687b4f8be478ce5b$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $687b4f8be478ce5b$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $687b4f8be478ce5b$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $687b4f8be478ce5b$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$687b4f8be478ce5b$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $687b4f8be478ce5b$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
function $687b4f8be478ce5b$export$2d8f5188773bcddd(integration) {
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $fc6c683469493657$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $687b4f8be478ce5b$export$2323046b9414659f(fn) {
    return fn;
}


const $03d677d6894976df$var$responseToStreamSpan = /* @__PURE__ */ new WeakMap();
const $03d677d6894976df$var$responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
const $03d677d6894976df$var$STREAM_RESOLVE_FALLBACK_MS = 9e4;
const $03d677d6894976df$var$STREAMING_CONTENT_TYPES = [
    "text/event-stream",
    "application/x-ndjson",
    "application/stream+json"
];
const $03d677d6894976df$export$b49e0d1a48dc8754 = (0, $687b4f8be478ce5b$export$2323046b9414659f)(()=>{
    return {
        name: "FetchStreamPerformance",
        setup () {
            (0, $12668e9127796b68$export$1a79663eb318fe6a)((handlerData)=>{
                if (handlerData.response) {
                    const streamSpan = $03d677d6894976df$var$responseToStreamSpan.get(handlerData.response);
                    if (streamSpan && handlerData.endTimestamp) {
                        streamSpan.end(handlerData.endTimestamp);
                        const fallbackTimeout = $03d677d6894976df$var$responseToFallbackTimeout.get(handlerData.response);
                        if (fallbackTimeout) clearTimeout(fallbackTimeout);
                    }
                }
            });
            (0, $12668e9127796b68$export$f75d3c772c923df0)((handlerData)=>{
                if (handlerData.endTimestamp && handlerData.response) {
                    const contentType = handlerData.response.headers?.get("content-type") || "";
                    if (handlerData.response.headers?.get("content-length") || !$03d677d6894976df$var$STREAMING_CONTENT_TYPES.some((t)=>contentType.startsWith(t))) return;
                    const url = handlerData.fetchData?.url || "";
                    const method = handlerData.fetchData?.method || "GET";
                    const parsedUrl = (0, $16cbdb46106b353e$export$2004d912a9ead694)(url);
                    const sanitizedUrl = url.startsWith("data:") ? (0, $16cbdb46106b353e$export$8abd806fcaf234fa)(url) : parsedUrl ? (0, $16cbdb46106b353e$export$5339fcdc8e2a427c)(parsedUrl) : url;
                    const streamSpan = (0, $274e9bcb6eb7453f$export$63dbba021a6b4047)({
                        name: `${method} ${sanitizedUrl}`,
                        startTime: handlerData.endTimestamp,
                        attributes: {
                            url: (0, $16cbdb46106b353e$export$8abd806fcaf234fa)(url),
                            "http.method": method,
                            type: "fetch",
                            [(0, $4f85903ad30c6e77$export$1a413bd9a88fdb09)]: "http.client.stream",
                            [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.http.browser.stream"
                        }
                    });
                    $03d677d6894976df$var$responseToStreamSpan.set(handlerData.response, streamSpan);
                    const fallbackTimeout = setTimeout(()=>{
                        if (streamSpan.isRecording()) streamSpan.end();
                    }, $03d677d6894976df$var$STREAM_RESOLVE_FALLBACK_MS);
                    $03d677d6894976df$var$responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
                }
            });
        }
    };
});




var $11Ba2 = parcelRequire("11Ba2");

function $b6291c46628efa0d$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $11Ba2.isNodeEnv)() || $b6291c46628efa0d$var$isElectronNodeRenderer());
}
function $b6291c46628efa0d$var$isElectronNodeRenderer() {
    const process = (0, $19eb101f55ba68c8$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}






const $0dab17f18ed7534b$var$LAST_INTERACTIONS = [];
const $0dab17f18ed7534b$var$INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
const $0dab17f18ed7534b$var$ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
const $0dab17f18ed7534b$export$619786413bcce1e1 = 60;
function $0dab17f18ed7534b$export$f17d06681a4744a3() {
    const performance = (0, $f3bf6b7560144a6f$export$f72a13c439a30cab)();
    if (performance && (0, $093eae9201b28ce4$export$baf075a948ffc0bf)()) {
        const inpCallback = $0dab17f18ed7534b$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>void 0;
}
const $0dab17f18ed7534b$export$7cd941f925ded42f = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
function $0dab17f18ed7534b$export$eeab203db0ed99a9() {
    return (0, $43f5d9c7ac2ec95d$export$da3b76aa2022cbd7)($0dab17f18ed7534b$export$7bcb98fe01441521);
}
const $0dab17f18ed7534b$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == void 0) return;
    const duration = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(metric.value);
    if (duration > $0dab17f18ed7534b$export$619786413bcce1e1) return;
    const entry = metric.entries.find((entry2)=>entry2.duration === metric.value && $0dab17f18ed7534b$export$7cd941f925ded42f[entry2.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $0dab17f18ed7534b$export$7cd941f925ded42f[entry.name];
    const startTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $da6e7e382c71fa3f$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const cachedInteractionContext = interactionId != null ? $0dab17f18ed7534b$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
    const spanToUse = cachedInteractionContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $da6e7e382c71fa3f$export$92d8c23565496537)(spanToUse).description : (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedInteractionContext?.elementName || (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
        [(0, $4f85903ad30c6e77$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $4f85903ad30c6e77$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $f3bf6b7560144a6f$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("inp", {
            [(0, $4f85903ad30c6e77$export$f5f95cff026507b5)]: "millisecond",
            [(0, $4f85903ad30c6e77$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
function $0dab17f18ed7534b$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $0dab17f18ed7534b$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function $0dab17f18ed7534b$export$e4e04d43e223cce2() {
    const interactionEvents = Object.keys($0dab17f18ed7534b$export$7cd941f925ded42f);
    if ((0, $b6291c46628efa0d$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $65ba4186be3cc942$export$5647df6b7814ac86)(target);
        const timestamp = Math.round(event.timeStamp);
        $0dab17f18ed7534b$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        if ($0dab17f18ed7534b$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $0dab17f18ed7534b$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== void 0) $0dab17f18ed7534b$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $0dab17f18ed7534b$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $0dab17f18ed7534b$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || "<unknown>";
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $da6e7e382c71fa3f$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $43f5d9c7ac2ec95d$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            if ($0dab17f18ed7534b$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            if ($0dab17f18ed7534b$var$LAST_INTERACTIONS.length > 10) {
                const last = $0dab17f18ed7534b$var$LAST_INTERACTIONS.shift();
                $0dab17f18ed7534b$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            $0dab17f18ed7534b$var$LAST_INTERACTIONS.push(interactionId);
            $0dab17f18ed7534b$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $43f5d9c7ac2ec95d$export$69816c1a049f8db6)("event", handleEntries);
    (0, $43f5d9c7ac2ec95d$export$69816c1a049f8db6)("first-input", handleEntries);
}









function $fb52e8056942c35d$export$f4adb23e57c1dac6(options) {
    const { name: name, op: op, origin: origin, metricName: metricName, value: value, attributes: passedAttributes, parentSpan: parentSpan, reportEvent: reportEvent, startTime: startTime, endTime: endTime } = options;
    const routeName = (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const attributes = {
        [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: origin,
        [(0, $4f85903ad30c6e77$export$1a413bd9a88fdb09)]: op,
        [(0, $4f85903ad30c6e77$export$fea48ba9f4550879)]: 0,
        [`browser.web_vital.${metricName}.value`]: value,
        "sentry.transaction": routeName,
        // Web vital score calculation relies on the user agent
        "user_agent.original": (0, $7399e18e995d85aa$export$56d8a8a25bd48b81).navigator?.userAgent,
        ...passedAttributes
    };
    if (parentSpan && (0, $da6e7e382c71fa3f$export$db0cad9e44f67af8)(parentSpan).attributes?.[0, $4f85903ad30c6e77$export$1a413bd9a88fdb09] === "pageload") attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
    const span = (0, $274e9bcb6eb7453f$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        parentSpan: // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan
    });
    if (span) span.end(endTime ?? startTime);
}
function $fb52e8056942c35d$export$73747c030e2325c0(client) {
    let lcpValue = 0;
    let lcpEntry;
    if (!(0, $f3bf6b7560144a6f$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $43f5d9c7ac2ec95d$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $172cf9be6475b238$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $f3bf6b7560144a6f$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $fb52e8056942c35d$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
function $fb52e8056942c35d$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $172cf9be6475b238$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const performanceTimeOrigin = (0, $093eae9201b28ce4$export$baf075a948ffc0bf)() || 0;
    const timeOrigin = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    const endTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(performanceTimeOrigin + (entry?.startTime || 0));
    const name = entry ? (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {};
    entry?.element && (attributes["browser.web_vital.lcp.element"] = (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.element));
    entry?.id && (attributes["browser.web_vital.lcp.id"] = entry.id);
    entry?.url && (attributes["browser.web_vital.lcp.url"] = entry.url);
    entry?.loadTime != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
    entry?.renderTime != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
    entry?.size != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
    $fb52e8056942c35d$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.lcp",
        origin: "auto.http.browser.lcp",
        metricName: "lcp",
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
function $fb52e8056942c35d$export$f2ca9ed704743eb2(client) {
    let clsValue = 0;
    let clsEntry;
    if (!(0, $f3bf6b7560144a6f$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $43f5d9c7ac2ec95d$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $f3bf6b7560144a6f$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $fb52e8056942c35d$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
function $fb52e8056942c35d$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $093eae9201b28ce4$export$ee52dced521e3e18)();
    const name = entry ? (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {};
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`browser.web_vital.cls.source.${index + 1}`] = (0, $65ba4186be3cc942$export$5647df6b7814ac86)(source.node);
    });
    $fb52e8056942c35d$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.cls",
        origin: "auto.http.browser.cls",
        metricName: "cls",
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
function $fb52e8056942c35d$export$4a8cbc644515d57b() {
    const performance = (0, $f3bf6b7560144a6f$export$f72a13c439a30cab)();
    if (!performance || !(0, $093eae9201b28ce4$export$baf075a948ffc0bf)()) return;
    const onInp = ({ metric: metric })=>{
        if (metric.value == null) return;
        const duration = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $0dab17f18ed7534b$export$619786413bcce1e1)) return;
        const entry = metric.entries.find((e)=>e.duration === metric.value && (0, $0dab17f18ed7534b$export$7cd941f925ded42f)[e.name]);
        if (!entry) return;
        $fb52e8056942c35d$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $43f5d9c7ac2ec95d$export$da3b76aa2022cbd7)(onInp);
}
function $fb52e8056942c35d$export$bd315e549441b68a(inpValue, entry) {
    (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`Sending INP span (${inpValue})`);
    const startTime = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)((0, $093eae9201b28ce4$export$baf075a948ffc0bf)() + entry.startTime);
    const duration = (0, $f3bf6b7560144a6f$export$b4785dbd4a81b33f)(inpValue);
    const interactionType = (0, $0dab17f18ed7534b$export$7cd941f925ded42f)[entry.name];
    const cachedContext = (0, $0dab17f18ed7534b$export$e4a670d077ebcfef)(entry.interactionId);
    const activeSpan = (0, $da6e7e382c71fa3f$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $da6e7e382c71fa3f$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const spanToUse = cachedContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $da6e7e382c71fa3f$export$db0cad9e44f67af8)(spanToUse).name : (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedContext?.elementName || (0, $65ba4186be3cc942$export$5647df6b7814ac86)(entry.target);
    $fb52e8056942c35d$export$f4adb23e57c1dac6({
        name: name,
        op: `ui.interaction.${interactionType}`,
        origin: "auto.http.browser.inp",
        metricName: "inp",
        value: inpValue,
        attributes: {
            [(0, $4f85903ad30c6e77$export$fea48ba9f4550879)]: entry.duration,
            "sentry.transaction": routeName
        },
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


const $1e2d51284e3edf1d$export$8748555bacc7091c = "WebVitals";
const $1e2d51284e3edf1d$export$1ab4995602e8adaa = (0, $479c90d590bd4fd3$exports.defineIntegration)((options = {})=>{
    const ignored = new Set(options.ignore ?? []);
    return {
        name: $1e2d51284e3edf1d$export$8748555bacc7091c,
        setup (client) {
            const spanStreamingEnabled = (0, $479c90d590bd4fd3$exports.hasSpanStreamingEnabled)(client);
            const { enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans } = options._experiments ?? {};
            const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
            const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
            const finalizeWebVitals = (0, $3a117087bc36f0b7$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: recordClsStandaloneSpans,
                recordLcpStandaloneSpans: recordLcpStandaloneSpans,
                client: client
            });
            const pageloadSpans = /* @__PURE__ */ new WeakSet();
            client.on("afterStartPageLoadSpan", (span)=>{
                pageloadSpans.add(span);
            });
            client.on("spanEnd", (span)=>{
                if (!pageloadSpans.delete(span)) return;
                finalizeWebVitals();
                (0, $3a117087bc36f0b7$export$d14e394b690acc17)(span, {
                    // CLS/LCP are recorded as pageload span measurements only when they're neither
                    // tracked as standalone spans nor handled by span streaming (and not ignored).
                    recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
                    recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
                    spanStreamingEnabled: spanStreamingEnabled
                });
            });
            if (spanStreamingEnabled) {
                if (!ignored.has("lcp")) (0, $fb52e8056942c35d$export$73747c030e2325c0)(client);
                if (!ignored.has("cls")) (0, $fb52e8056942c35d$export$f2ca9ed704743eb2)(client);
                if (!ignored.has("inp")) (0, $fb52e8056942c35d$export$4a8cbc644515d57b)();
            } else if (!ignored.has("inp")) (0, $0dab17f18ed7534b$export$f17d06681a4744a3)();
        },
        afterAllSetup () {
            if (!ignored.has("inp")) (0, $0dab17f18ed7534b$export$e4e04d43e223cce2)();
        }
    };
});





function $80918957be5c938c$export$6f18f55521af71a1() {
    if ((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document) (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $479c90d590bd4fd3$exports.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $479c90d590bd4fd3$exports.getRootSpan)(activeSpan);
        if ((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $479c90d590bd4fd3$exports.spanToJSON)(rootSpan);
            if (0, $1576abfee53a7006$export$16a28057038b10ef) (0, $479c90d590bd4fd3$exports.debug).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            if (!status) rootSpan.setStatus({
                code: (0, $479c90d590bd4fd3$exports.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}














const $e8f3945b014ff581$export$c8d616af96ac729f = 3600;
const $e8f3945b014ff581$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $e8f3945b014ff581$export$237518aee8726f02 = "sentry.previous_trace";
function $e8f3945b014ff581$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === "session-storage";
    let inMemoryPreviousTraceInfo = useSessionStorage ? $e8f3945b014ff581$export$ef546bba8a402d99() : void 0;
    client.on("spanStart", (span)=>{
        if ((0, $479c90d590bd4fd3$exports.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $479c90d590bd4fd3$exports.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $e8f3945b014ff581$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $e8f3945b014ff581$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) client.on("beforeSampling", (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $479c90d590bd4fd3$exports.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($e8f3945b014ff581$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $e8f3945b014ff581$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
function $e8f3945b014ff581$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $479c90d590bd4fd3$exports.spanToJSON)(span);
    function getSampleRate() {
        try {
            const oldSampleRate = Number(spanJson.data?.[0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? oldPropagationContext.dsc?.sample_rate);
            return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) return previousTraceInfo;
    if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= $e8f3945b014ff581$export$c8d616af96ac729f) {
        if (0, $1576abfee53a7006$export$16a28057038b10ef) (0, $479c90d590bd4fd3$exports.debug).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
            op: spanJson.op,
            ...span.spanContext()
        })}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $479c90d590bd4fd3$exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: "previous_trace"
            }
        });
        span.setAttribute($e8f3945b014ff581$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$e8f3945b014ff581$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
function $e8f3945b014ff581$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).sessionStorage.setItem($e8f3945b014ff581$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn("Could not store previous trace in sessionStorage", e);
    }
}
function $e8f3945b014ff581$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).sessionStorage?.getItem($e8f3945b014ff581$export$16b6aa13b3c0f075);
        return JSON.parse(previousTraceInfo);
    } catch  {
        return void 0;
    }
}
function $e8f3945b014ff581$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 1;
}





const $b1fa3f7b226c6778$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $b1fa3f7b226c6778$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $b1fa3f7b226c6778$export$945a2d5364608d5(body, _debug = (0, $35da606f4e6c3c2f$export$1c9f709888824e05)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $b1fa3f7b226c6778$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $b1fa3f7b226c6778$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$b1fa3f7b226c6778$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $b1fa3f7b226c6778$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $a0072c24ef9c7c8c$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



function $07367fe5ae5533a2$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(",").some((value)=>value.trim().startsWith("sentry-"));
}
function $07367fe5ae5533a2$export$f2a087db7564c909(url) {
    try {
        const parsed = new URL(url, (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return void 0;
    }
}
function $07367fe5ae5533a2$export$5803eedf1027ce61(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function $07367fe5ae5533a2$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        return void 0;
    }
}


const $11754e34c22d0c9d$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
function $11754e34c22d0c9d$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$11754e34c22d0c9d$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$11754e34c22d0c9d$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) (0, $479c90d590bd4fd3$exports.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $479c90d590bd4fd3$exports.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
            propagateTraceparent: propagateTraceparent,
            onRequestSpanEnd: onRequestSpanEnd
        });
        if (createdSpan) {
            const fullUrl = (0, $07367fe5ae5533a2$export$f2a087db7564c909)(handlerData.fetchData.url);
            const host = fullUrl ? (0, $479c90d590bd4fd3$exports.parseUrl)(fullUrl).host : void 0;
            createdSpan.setAttributes({
                "http.url": fullUrl ? (0, $479c90d590bd4fd3$exports.stripDataUrlContent)(fullUrl) : void 0,
                "server.address": host
            });
            if (enableHTTPTimings) $11754e34c22d0c9d$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: handlerData.headers
            });
        }
    });
    if (traceXHR) (0, $c5fb575b1e4cb8c4$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $11754e34c22d0c9d$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $11754e34c22d0c9d$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $07367fe5ae5533a2$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
const $11754e34c22d0c9d$var$HTTP_TIMING_WAIT_MS = 300;
function $11754e34c22d0c9d$var$addHTTPTimings(span, client) {
    const { url: url } = (0, $479c90d590bd4fd3$exports.spanToJSON)(span).data;
    if (!url || typeof url !== "string") return;
    let onEntryFound = ()=>void setTimeout(unsubscribePerformanceObsever);
    if ((0, $479c90d590bd4fd3$exports.hasSpanStreamingEnabled)(client)) {
        const originalEnd = span.end.bind(span);
        span.end = (endTimestamp)=>{
            const capturedEndTimestamp = endTimestamp ?? (0, $479c90d590bd4fd3$exports.timestampInSeconds)();
            let isEnded = false;
            const endSpanAndCleanup = ()=>{
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            const fallbackTimeout = setTimeout(endSpanAndCleanup, $11754e34c22d0c9d$var$HTTP_TIMING_WAIT_MS);
        };
    }
    const unsubscribePerformanceObsever = (0, $43f5d9c7ac2ec95d$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $07367fe5ae5533a2$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $08f8a3bb3dd5392e$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
function $11754e34c22d0c9d$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    const href = (0, $479c90d590bd4fd3$exports.getLocationHref)();
    if (!href) {
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $479c90d590bd4fd3$exports.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $479c90d590bd4fd3$exports.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $479c90d590bd4fd3$exports.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
function $11754e34c22d0c9d$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $c5fb575b1e4cb8c4$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return void 0;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $479c90d590bd4fd3$exports.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
                (0, $479c90d590bd4fd3$exports.setHttpStatus)(span2, sentryXhrData.status_code);
                span2.end();
                onRequestSpanEnd?.(span2, {
                    headers: (0, $07367fe5ae5533a2$export$9dc5b8b2fb320da0)((0, $b1fa3f7b226c6778$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const fullUrl = (0, $07367fe5ae5533a2$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $479c90d590bd4fd3$exports.parseUrl)(fullUrl) : (0, $479c90d590bd4fd3$exports.parseUrl)(url);
    const urlForSpanName = (0, $479c90d590bd4fd3$exports.stripDataUrlContent)((0, $479c90d590bd4fd3$exports.stripUrlQueryAndFragment)(url));
    const client = (0, $479c90d590bd4fd3$exports.getClient)();
    const hasParent = !!(0, $479c90d590bd4fd3$exports.getActiveSpan)();
    const shouldEmitSpan = hasParent || !!client && (0, $479c90d590bd4fd3$exports.hasSpanStreamingEnabled)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $479c90d590bd4fd3$exports.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: (0, $479c90d590bd4fd3$exports.stripDataUrlContent)(url),
            type: "xhr",
            "http.method": method,
            "http.url": fullUrl ? (0, $479c90d590bd4fd3$exports.stripDataUrlContent)(fullUrl) : void 0,
            "server.address": parsedUrl?.host,
            [(0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser",
            [(0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client",
            ...parsedUrl?.search && {
                "http.query": parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                "http.fragment": parsedUrl?.hash
            }
        }
    }) : new (0, $479c90d590bd4fd3$exports.SentryNonRecordingSpan)();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders2(url)) $11754e34c22d0c9d$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $479c90d590bd4fd3$exports.hasSpansEnabled)() && shouldEmitSpan ? span : void 0, propagateTraceparent);
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $11754e34c22d0c9d$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { "sentry-trace": sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $479c90d590bd4fd3$exports.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $11754e34c22d0c9d$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $11754e34c22d0c9d$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.["sentry-trace"] || !xhr.setRequestHeader) return;
    try {
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.["traceparent"]) xhr.setRequestHeader("traceparent", traceparentHeader);
        if (sentryBaggageHeader) {
            const originalBaggageHeader = originalHeaders?.["baggage"];
            if (!originalBaggageHeader || !(0, $07367fe5ae5533a2$export$8193ac587e359dc0)(originalBaggageHeader)) xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch  {}
}


const $72f7c10954dbe37c$export$bbd2089f30bd3708 = "BrowserTracing";
const $72f7c10954dbe37c$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $72f7c10954dbe37c$export$e189d11d152c4191() {
    const nav = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).navigator;
    if (!nav?.userAgent) return false;
    return $72f7c10954dbe37c$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $72f7c10954dbe37c$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $479c90d590bd4fd3$exports.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $11754e34c22d0c9d$export$cc17fb3c0bc95cd7)
};
const $72f7c10954dbe37c$export$b4109253475213e9 = (options = {})=>{
    if ("enableElementTiming" in options) (0, $479c90d590bd4fd3$exports.consoleSandbox)(()=>{
        console.warn("[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.");
    });
    const latestRoute = {
        name: void 0,
        source: void 0
    };
    const optionalWindowDocument = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$72f7c10954dbe37c$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    const _isBot = $72f7c10954dbe37c$export$e189d11d152c4191();
    let lastInteractionTimestamp;
    let _pageloadSpan;
    function _createRouteSpan(client, startSpanOptions, makeActive = true) {
        const isPageloadSpan = startSpanOptions.op === "pageload";
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        if (initialSpanName !== finalStartSpanOptions.name) {
            attributes[0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        if (!makeActive) {
            const now = (0, $479c90d590bd4fd3$exports.dateTimestampInSeconds)();
            (0, $479c90d590bd4fd3$exports.startInactiveSpan)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $479c90d590bd4fd3$exports.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                (0, $3a117087bc36f0b7$export$5f8fa6b3467a7443)(span, {
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: (0, $479c90d590bd4fd3$exports.hasSpanStreamingEnabled)(client)
                });
                $72f7c10954dbe37c$var$setActiveIdleSpan(client, void 0);
                const scope = (0, $479c90d590bd4fd3$exports.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $479c90d590bd4fd3$exports.spanIsSampled)(idleSpan),
                    dsc: (0, $479c90d590bd4fd3$exports.getDynamicSamplingContextFromSpan)(span)
                });
                if (isPageloadSpan) _pageloadSpan = void 0;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $72f7c10954dbe37c$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) client.emit("idleSpanEnableAutoFinish", idleSpan);
        }
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $72f7c10954dbe37c$export$bbd2089f30bd3708,
        setup (client) {
            if (_isBot) {
                (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
                return;
            }
            (0, $479c90d590bd4fd3$exports.registerSpanErrorInstrumentation)();
            if (enableLongAnimationFrame && (0, $479c90d590bd4fd3$exports.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")) (0, $3a117087bc36f0b7$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $3a117087bc36f0b7$export$f396d19077034ad2)();
            if (enableInteractions) (0, $3a117087bc36f0b7$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $479c90d590bd4fd3$exports.timestampInSeconds)();
                };
                addEventListener("click", interactionHandler, {
                    capture: true
                });
                addEventListener("keydown", interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $72f7c10954dbe37c$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $479c90d590bd4fd3$exports.spanToJSON)(activeSpan).timestamp) {
                    (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).log(`[Tracing] Finishing current active span with op: ${(0, $479c90d590bd4fd3$exports.spanToJSON)(activeSpan).op}`);
                    activeSpan.setAttribute((0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions, navigationOptions)=>{
                if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
                    _createRouteSpan(client, {
                        op: "navigation.redirect",
                        ...startSpanOptions
                    }, false);
                    return;
                }
                lastInteractionTimestamp = void 0;
                maybeEndActiveSpan();
                (0, $479c90d590bd4fd3$exports.getIsolationScope)().setPropagationContext({
                    traceId: (0, $479c90d590bd4fd3$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $479c90d590bd4fd3$exports.hasSpansEnabled)() ? void 0 : (0, $479c90d590bd4fd3$exports.generateSpanId)()
                });
                const scope = (0, $479c90d590bd4fd3$exports.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $479c90d590bd4fd3$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $479c90d590bd4fd3$exports.hasSpansEnabled)() ? void 0 : (0, $479c90d590bd4fd3$exports.generateSpanId)()
                });
                scope.setSDKProcessingMetadata({
                    normalizedRequest: void 0
                });
                _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                });
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $479c90d590bd4fd3$exports.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $72f7c10954dbe37c$export$f147b32b03c9cf11("sentry-trace") || $72f7c10954dbe37c$export$5bb9693b37f7c2ae("sentry-trace");
                const baggage = traceOptions.baggage || $72f7c10954dbe37c$export$f147b32b03c9cf11("baggage") || $72f7c10954dbe37c$export$5bb9693b37f7c2ae("baggage");
                const propagationContext = (0, $479c90d590bd4fd3$exports.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $479c90d590bd4fd3$exports.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $479c90d590bd4fd3$exports.hasSpansEnabled)()) scope.getPropagationContext().propagationSpanId = (0, $479c90d590bd4fd3$exports.generateSpanId)();
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $26e2765b4d6baedf$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            client.on("endPageloadSpan", ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "reportPageLoaded");
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            if (_isBot) return;
            if (client.addIntegration && !client.getIntegrationByName?.((0, $1e2d51284e3edf1d$export$8748555bacc7091c))) client.addIntegration((0, $1e2d51284e3edf1d$export$1ab4995602e8adaa)({
                ignore: enableInp ? [] : [
                    "inp"
                ],
                _experiments: {
                    enableStandaloneClsSpans: enableStandaloneClsSpans,
                    enableStandaloneLcpSpans: enableStandaloneLcpSpans
                }
            }));
            let startingUrl = (0, $479c90d590bd4fd3$exports.getLocationHref)();
            if (linkPreviousTrace !== "off") (0, $e8f3945b014ff581$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $479c90d590bd4fd3$exports.browserPerformanceTimeOrigin)();
                    $72f7c10954dbe37c$export$aa44a07f82af519f(client, {
                        name: (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1e3 : void 0,
                        attributes: {
                            [(0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $0127b3f07f74acee$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    if (from === void 0 && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = void 0;
                        return;
                    }
                    startingUrl = void 0;
                    const parsed = (0, $479c90d590bd4fd3$exports.parseStringToURLObject)(to);
                    const activeSpan = $72f7c10954dbe37c$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $72f7c10954dbe37c$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $72f7c10954dbe37c$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.browser"
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $80918957be5c938c$export$6f18f55521af71a1)();
            if (enableInteractions) $72f7c10954dbe37c$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $11754e34c22d0c9d$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (trackFetchStreamPerformance) client.addIntegration((0, $03d677d6894976df$export$b49e0d1a48dc8754)());
        }
    };
};
function $72f7c10954dbe37c$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $479c90d590bd4fd3$exports.getCurrentScope)().setTransactionName(spanOptions.name);
    const pageloadSpan = $72f7c10954dbe37c$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit("afterStartPageLoadSpan", pageloadSpan);
    return pageloadSpan;
}
function $72f7c10954dbe37c$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect2 } = options || {};
    client.emit("beforeStartNavigationSpan", spanOptions, {
        isRedirect: isRedirect2
    });
    client.emit("startNavigationSpan", spanOptions, {
        isRedirect: isRedirect2
    });
    const scope = (0, $479c90d590bd4fd3$exports.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    if (url && !isRedirect2) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $26e2765b4d6baedf$export$a3c4a8453e8936f0)(),
            url: url
        }
    });
    return $72f7c10954dbe37c$var$getActiveIdleSpan(client);
}
function $72f7c10954dbe37c$export$f147b32b03c9cf11(metaName) {
    const optionalWindowDocument = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute("content") || void 0;
}
function $72f7c10954dbe37c$export$5bb9693b37f7c2ae(name) {
    const navigation = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    const entry = navigation?.serverTiming?.find((entry2)=>entry2.name === name);
    return entry?.description;
}
function $72f7c10954dbe37c$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    const optionalWindowDocument = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $72f7c10954dbe37c$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $479c90d590bd4fd3$exports.spanToJSON)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return void 0;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = void 0;
        }
        if (!latestRoute.name) {
            (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return void 0;
        }
        inflightInteractionSpan = (0, $479c90d590bd4fd3$exports.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $479c90d590bd4fd3$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        capture: true
    });
}
const $72f7c10954dbe37c$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $72f7c10954dbe37c$var$getActiveIdleSpan(client) {
    return client[$72f7c10954dbe37c$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $72f7c10954dbe37c$var$setActiveIdleSpan(client, span) {
    (0, $479c90d590bd4fd3$exports.addNonEnumerableProperty)(client, $72f7c10954dbe37c$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
const $72f7c10954dbe37c$var$REDIRECT_THRESHOLD = 1.5;
function $72f7c10954dbe37c$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $479c90d590bd4fd3$exports.spanToJSON)(activeSpan);
    const now = (0, $479c90d590bd4fd3$exports.dateTimestampInSeconds)();
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $72f7c10954dbe37c$var$REDIRECT_THRESHOLD) return false;
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $72f7c10954dbe37c$var$REDIRECT_THRESHOLD) return false;
    return true;
}




var $itHdT = parcelRequire("itHdT");
const $d28f1fbce9273c94$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $6ad9d39434910094$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
const $6ad9d39434910094$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
const $6ad9d39434910094$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
const $6ad9d39434910094$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
const $6ad9d39434910094$var$ForwardRefType = /* @__PURE__ */ Symbol.for("react.forward_ref");
const $6ad9d39434910094$var$MemoType = /* @__PURE__ */ Symbol.for("react.memo");
function $6ad9d39434910094$var$isMemo(component) {
    return typeof component === "object" && component !== null && component.$$typeof === $6ad9d39434910094$var$MemoType;
}
const $6ad9d39434910094$var$TYPE_STATICS = {};
$6ad9d39434910094$var$TYPE_STATICS[$6ad9d39434910094$var$ForwardRefType] = $6ad9d39434910094$var$FORWARD_REF_STATICS;
$6ad9d39434910094$var$TYPE_STATICS[$6ad9d39434910094$var$MemoType] = $6ad9d39434910094$var$MEMO_STATICS;
function $6ad9d39434910094$var$getStatics(component) {
    if ($6ad9d39434910094$var$isMemo(component)) return $6ad9d39434910094$var$MEMO_STATICS;
    const componentType = component.$$typeof;
    return componentType && $6ad9d39434910094$var$TYPE_STATICS[componentType] || $6ad9d39434910094$var$REACT_STATICS;
}
const $6ad9d39434910094$var$defineProperty = Object.defineProperty.bind(Object);
const $6ad9d39434910094$var$getOwnPropertyNames = Object.getOwnPropertyNames.bind(Object);
const $6ad9d39434910094$var$getOwnPropertySymbols = Object.getOwnPropertySymbols?.bind(Object);
const $6ad9d39434910094$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor.bind(Object);
const $6ad9d39434910094$var$getPrototypeOf = Object.getPrototypeOf.bind(Object);
const $6ad9d39434910094$var$objectPrototype = Object.prototype;
function $6ad9d39434910094$export$6c1f0397687d8b2(targetComponent, sourceComponent, excludelist) {
    if (typeof sourceComponent !== "string") {
        if ($6ad9d39434910094$var$objectPrototype) {
            const inheritedComponent = $6ad9d39434910094$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $6ad9d39434910094$var$objectPrototype) $6ad9d39434910094$export$6c1f0397687d8b2(targetComponent, inheritedComponent);
        }
        let keys = $6ad9d39434910094$var$getOwnPropertyNames(sourceComponent);
        if ($6ad9d39434910094$var$getOwnPropertySymbols) keys = keys.concat($6ad9d39434910094$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $6ad9d39434910094$var$getStatics(targetComponent);
        const sourceStatics = $6ad9d39434910094$var$getStatics(sourceComponent);
        for (const key of keys)if (!$6ad9d39434910094$var$KNOWN_STATICS[key] && true && !sourceStatics?.[key] && !targetStatics?.[key] && !$6ad9d39434910094$var$getOwnPropertyDescriptor(targetComponent, key)) {
            const descriptor = $6ad9d39434910094$var$getOwnPropertyDescriptor(sourceComponent, key);
            if (descriptor) try {
                $6ad9d39434910094$var$defineProperty(targetComponent, key, descriptor);
            } catch (_e) {}
        }
    }
    return targetComponent;
}









function $be9766618a9a03ae$export$7d73ab767c2c99ca(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return pathname;
    return pathname.slice(startIndex) || "/";
}
const $be9766618a9a03ae$var$SORTED_MANIFEST_CACHE = /* @__PURE__ */ new WeakMap();
function $be9766618a9a03ae$export$b350ee9894336a9c(pathname, manifest, basename) {
    if (!pathname || !manifest?.length) return null;
    const normalizedPathname = basename ? $be9766618a9a03ae$export$7d73ab767c2c99ca(pathname, basename) : pathname;
    let sorted = $be9766618a9a03ae$var$SORTED_MANIFEST_CACHE.get(manifest);
    if (!sorted) {
        sorted = $be9766618a9a03ae$var$sortBySpecificity(manifest);
        $be9766618a9a03ae$var$SORTED_MANIFEST_CACHE.set(manifest, sorted);
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).log("[React Router] Sorted route manifest by specificity:", sorted.length, "patterns");
    }
    for (const pattern of sorted)if ($be9766618a9a03ae$var$matchesPattern(normalizedPathname, pattern)) {
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).log("[React Router] Matched pathname", normalizedPathname, "to pattern", pattern);
        return pattern;
    }
    (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).log("[React Router] No manifest match found for pathname:", normalizedPathname);
    return null;
}
function $be9766618a9a03ae$var$matchesPattern(pathname, pattern) {
    if (pattern === "/") return pathname === "/" || pathname === "";
    const pathSegments = $be9766618a9a03ae$var$splitPath(pathname);
    const patternSegments = $be9766618a9a03ae$var$splitPath(pattern);
    const hasWildcard = patternSegments.length > 0 && patternSegments[patternSegments.length - 1] === "*";
    if (hasWildcard) {
        const patternSegmentsWithoutWildcard = patternSegments.slice(0, -1);
        if (pathSegments.length < patternSegmentsWithoutWildcard.length) return false;
        for (const [i, patternSegment] of patternSegmentsWithoutWildcard.entries()){
            if (!$be9766618a9a03ae$var$segmentMatches(pathSegments[i], patternSegment)) return false;
        }
        return true;
    }
    if (pathSegments.length !== patternSegments.length) return false;
    for (const [i, patternSegment] of patternSegments.entries()){
        if (!$be9766618a9a03ae$var$segmentMatches(pathSegments[i], patternSegment)) return false;
    }
    return true;
}
function $be9766618a9a03ae$var$segmentMatches(pathSegment, patternSegment) {
    if (pathSegment === void 0 || patternSegment === void 0) return false;
    if ($be9766618a9a03ae$var$PARAM_RE.test(patternSegment)) return true;
    return pathSegment === patternSegment;
}
function $be9766618a9a03ae$var$splitPath(path) {
    return path.split("/").filter(Boolean);
}
const $be9766618a9a03ae$var$PARAM_RE = /^:[\w-]+$/;
const $be9766618a9a03ae$var$STATIC_SEGMENT_SCORE = 10;
const $be9766618a9a03ae$var$DYNAMIC_SEGMENT_SCORE = 3;
const $be9766618a9a03ae$var$EMPTY_SEGMENT_SCORE = 1;
const $be9766618a9a03ae$var$SPLAT_PENALTY = -2;
function $be9766618a9a03ae$var$computeScore(pattern) {
    const segments = pattern.split("/");
    let score = segments.length;
    if (segments.includes("*")) score += $be9766618a9a03ae$var$SPLAT_PENALTY;
    for (const segment of segments){
        if (segment === "*") continue;
        else if ($be9766618a9a03ae$var$PARAM_RE.test(segment)) score += $be9766618a9a03ae$var$DYNAMIC_SEGMENT_SCORE;
        else if (segment === "") score += $be9766618a9a03ae$var$EMPTY_SEGMENT_SCORE;
        else score += $be9766618a9a03ae$var$STATIC_SEGMENT_SCORE;
    }
    return score;
}
function $be9766618a9a03ae$var$sortBySpecificity(manifest) {
    return [
        ...manifest
    ].sort((a, b)=>{
        const aScore = $be9766618a9a03ae$var$computeScore(a);
        const bScore = $be9766618a9a03ae$var$computeScore(b);
        return bScore - aScore;
    });
}


let $36e2a44d523353a7$var$_matchRoutes;
let $36e2a44d523353a7$var$_stripBasename = false;
const $36e2a44d523353a7$var$_navigationContextStack = [];
const $36e2a44d523353a7$var$MAX_CONTEXT_STACK_SIZE = 10;
function $36e2a44d523353a7$export$49f239a397357a7c(targetPath, span) {
    const token = {};
    if ($36e2a44d523353a7$var$_navigationContextStack.length >= $36e2a44d523353a7$var$MAX_CONTEXT_STACK_SIZE) {
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).warn("[React Router] Navigation context stack overflow - removing oldest context");
        $36e2a44d523353a7$var$_navigationContextStack.shift();
    }
    $36e2a44d523353a7$var$_navigationContextStack.push({
        token: token,
        targetPath: targetPath,
        span: span
    });
    return token;
}
function $36e2a44d523353a7$export$44ec4f5e487fad8c(token) {
    const top = $36e2a44d523353a7$var$_navigationContextStack[$36e2a44d523353a7$var$_navigationContextStack.length - 1];
    if (top?.token === token) $36e2a44d523353a7$var$_navigationContextStack.pop();
}
function $36e2a44d523353a7$export$c51ee4fdd2c5321d() {
    const length = $36e2a44d523353a7$var$_navigationContextStack.length;
    return length > 0 ? $36e2a44d523353a7$var$_navigationContextStack[length - 1] ?? null : null;
}
function $36e2a44d523353a7$export$d5deab901a3788fa(matchRoutes, stripBasename = false) {
    $36e2a44d523353a7$var$_matchRoutes = matchRoutes;
    $36e2a44d523353a7$var$_stripBasename = stripBasename;
}
function $36e2a44d523353a7$var$pickPath(match) {
    return $36e2a44d523353a7$var$trimWildcard(match.route.path || "");
}
function $36e2a44d523353a7$var$pickSplat(match) {
    return match.params["*"] || "";
}
function $36e2a44d523353a7$var$trimWildcard(path) {
    return path[path.length - 1] === "*" ? path.slice(0, -1) : path;
}
function $36e2a44d523353a7$var$trimSlash(path) {
    return path[path.length - 1] === "/" ? path.slice(0, -1) : path;
}
function $36e2a44d523353a7$export$3112bc7a3fd7a30f(path) {
    return path.endsWith("*");
}
function $36e2a44d523353a7$export$73bbd8f1d410fc7c(name) {
    return name.includes("/*") || name.endsWith("*");
}
function $36e2a44d523353a7$export$e45475f5937f105e(path, branch) {
    return $36e2a44d523353a7$export$3112bc7a3fd7a30f(path) && !!branch.route.children?.length || false;
}
function $36e2a44d523353a7$export$2d13d7df6cdaeba4(route) {
    return !!(!route.children && route.element && route.path?.endsWith("/*"));
}
function $36e2a44d523353a7$var$sendIndexPath(pathBuilder, pathname, basename) {
    const reconstructedPath = pathBuilder && pathBuilder.length > 0 ? pathBuilder : $36e2a44d523353a7$var$_stripBasename ? (0, $be9766618a9a03ae$export$7d73ab767c2c99ca)(pathname, basename) : pathname;
    let formattedPath = // If the path ends with a wildcard suffix, remove both the slash and the asterisk
    reconstructedPath.slice(-2) === "/*" ? reconstructedPath.slice(0, -2) : reconstructedPath;
    if (formattedPath.length > 1 && formattedPath[formattedPath.length - 1] === "/") formattedPath = formattedPath.slice(0, -1);
    return [
        formattedPath,
        "route"
    ];
}
function $36e2a44d523353a7$export$69dd85280a8d374c(url) {
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
function $36e2a44d523353a7$export$dbbc39b1314b6a40(path) {
    return path[0] === "/" ? path : `/${path}`;
}
function $36e2a44d523353a7$export$c1f7ff5899bfbd37(allRoutes, location) {
    const matchedRoutes = $36e2a44d523353a7$var$_matchRoutes(allRoutes, location);
    if (!matchedRoutes || matchedRoutes.length === 0) return "";
    for (const match of matchedRoutes)if (match.route.path && match.route.path !== "*") {
        const path = $36e2a44d523353a7$var$pickPath(match);
        const strippedPath = (0, $be9766618a9a03ae$export$7d73ab767c2c99ca)(location.pathname, $36e2a44d523353a7$export$dbbc39b1314b6a40(match.pathnameBase));
        if (location.pathname === strippedPath) return $36e2a44d523353a7$var$trimSlash(strippedPath);
        return $36e2a44d523353a7$var$trimSlash($36e2a44d523353a7$var$trimSlash(path || "") + $36e2a44d523353a7$export$dbbc39b1314b6a40($36e2a44d523353a7$export$c1f7ff5899bfbd37(allRoutes.filter((route)=>route !== match.route), {
            pathname: strippedPath
        })));
    }
    return "";
}
function $36e2a44d523353a7$export$35be733d25e64e5a(location, routes) {
    const matchedRoutes = $36e2a44d523353a7$var$_matchRoutes(routes, location);
    if (matchedRoutes) for (const match of matchedRoutes){
        if ($36e2a44d523353a7$export$2d13d7df6cdaeba4(match.route) && $36e2a44d523353a7$var$pickSplat(match)) return true;
    }
    return false;
}
function $36e2a44d523353a7$var$getFallbackTransactionName(location, basename) {
    return $36e2a44d523353a7$var$_stripBasename ? (0, $be9766618a9a03ae$export$7d73ab767c2c99ca)(location.pathname, basename) : location.pathname || "";
}
function $36e2a44d523353a7$export$b75af9192fcde169(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $36e2a44d523353a7$var$_stripBasename ? (0, $be9766618a9a03ae$export$7d73ab767c2c99ca)(location.pathname, basename) : location.pathname,
        "url"
    ];
    if (!branches) return [
        $36e2a44d523353a7$var$getFallbackTransactionName(location, basename),
        "url"
    ];
    let pathBuilder = "";
    for (const branch of branches){
        const route = branch.route;
        if (!route) continue;
        if (route.index) return $36e2a44d523353a7$var$sendIndexPath(pathBuilder, branch.pathname, basename);
        const path = route.path;
        if (!path || $36e2a44d523353a7$export$e45475f5937f105e(path, branch)) continue;
        const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
        pathBuilder = $36e2a44d523353a7$var$trimSlash(pathBuilder) + $36e2a44d523353a7$export$dbbc39b1314b6a40(newPath);
        if ($36e2a44d523353a7$var$trimSlash(location.pathname) !== $36e2a44d523353a7$var$trimSlash(basename + branch.pathname)) continue;
        if ($36e2a44d523353a7$export$69dd85280a8d374c(pathBuilder) !== $36e2a44d523353a7$export$69dd85280a8d374c(branch.pathname) && !$36e2a44d523353a7$export$3112bc7a3fd7a30f(pathBuilder)) return [
            ($36e2a44d523353a7$var$_stripBasename ? "" : basename) + newPath,
            "route"
        ];
        if ($36e2a44d523353a7$export$e45475f5937f105e(pathBuilder, branch)) pathBuilder = pathBuilder.slice(0, -1);
        return [
            ($36e2a44d523353a7$var$_stripBasename ? "" : basename) + pathBuilder,
            "route"
        ];
    }
    return [
        $36e2a44d523353a7$var$getFallbackTransactionName(location, basename),
        "url"
    ];
}
function $36e2a44d523353a7$export$d0d5aab0e629ad63(location, routes, allRoutes, branches, basename = "", lazyRouteManifest, enableAsyncRouteHandlers) {
    if (enableAsyncRouteHandlers && lazyRouteManifest && lazyRouteManifest.length > 0) {
        const manifestMatch = (0, $be9766618a9a03ae$export$b350ee9894336a9c)(location.pathname, lazyRouteManifest, basename);
        if (manifestMatch) return [
            ($36e2a44d523353a7$var$_stripBasename ? "" : basename) + manifestMatch,
            "route"
        ];
    }
    let name;
    let source = "url";
    const isInDescendantRoute = $36e2a44d523353a7$export$35be733d25e64e5a(location, allRoutes);
    if (isInDescendantRoute) {
        name = $36e2a44d523353a7$export$dbbc39b1314b6a40($36e2a44d523353a7$export$c1f7ff5899bfbd37(allRoutes, location));
        source = "route";
    }
    if (!isInDescendantRoute || !name) [name, source] = $36e2a44d523353a7$export$b75af9192fcde169(routes, location, branches, basename);
    return [
        name || location.pathname,
        source
    ];
}
function $36e2a44d523353a7$export$6d46479e35ff5f30() {
    const span = (0, $479c90d590bd4fd3$exports.getActiveSpan)();
    const rootSpan = span ? (0, $479c90d590bd4fd3$exports.getRootSpan)(span) : void 0;
    if (!rootSpan) return void 0;
    const op = (0, $479c90d590bd4fd3$exports.spanToJSON)(rootSpan).op;
    return op === "navigation" || op === "pageload" ? rootSpan : void 0;
}


function $4ab949ddaba4f6dd$var$captureCurrentLocation() {
    const navContext = (0, $36e2a44d523353a7$export$c51ee4fdd2c5321d)();
    if (navContext) {
        if (navContext.targetPath) return {
            pathname: navContext.targetPath,
            search: "",
            hash: "",
            state: null,
            key: "default"
        };
        return null;
    }
    if (typeof (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81) !== "undefined") try {
        const windowLocation = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location;
        if (windowLocation) return {
            pathname: windowLocation.pathname,
            search: windowLocation.search || "",
            hash: windowLocation.hash || "",
            state: null,
            key: "default"
        };
    } catch  {
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("[React Router] Could not access window.location");
    }
    return null;
}
function $4ab949ddaba4f6dd$var$captureActiveSpan() {
    const navContext = (0, $36e2a44d523353a7$export$c51ee4fdd2c5321d)();
    if (navContext) return navContext.span;
    return (0, $36e2a44d523353a7$export$6d46479e35ff5f30)();
}
function $4ab949ddaba4f6dd$export$ae31fcaba1cddbd8(originalFunction, route, handlerKey, processResolvedRoutes) {
    const proxy = new Proxy(originalFunction, {
        apply (target, thisArg, argArray) {
            const locationAtInvocation = $4ab949ddaba4f6dd$var$captureCurrentLocation();
            const spanAtInvocation = $4ab949ddaba4f6dd$var$captureActiveSpan();
            const result = target.apply(thisArg, argArray);
            $4ab949ddaba4f6dd$export$182dc63b40030b75(result, route, handlerKey, processResolvedRoutes, locationAtInvocation, spanAtInvocation);
            return result;
        }
    });
    (0, $e632e89186c3a412$export$e73679ffaf56810e)(proxy, "__sentry_proxied__", true);
    return proxy;
}
function $4ab949ddaba4f6dd$export$182dc63b40030b75(result, route, handlerKey, processResolvedRoutes, currentLocation, capturedSpan) {
    if ((0, $6967c74e7baedc72$export$f5b060c2914b97c8)(result)) result.then((resolvedRoutes)=>{
        if (Array.isArray(resolvedRoutes)) processResolvedRoutes(resolvedRoutes, route, currentLocation ?? void 0, capturedSpan);
    }).catch((e)=>{
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`Error resolving async handler '${handlerKey}' for route`, route, e);
    });
    else if (Array.isArray(result)) processResolvedRoutes(result, route, currentLocation ?? void 0, capturedSpan);
}
function $4ab949ddaba4f6dd$export$e9262e29e117b830(route, processResolvedRoutes) {
    if (route.handle && typeof route.handle === "object") for (const key of Object.keys(route.handle)){
        const maybeFn = route.handle[key];
        if (typeof maybeFn === "function" && !maybeFn.__sentry_proxied__) route.handle[key] = $4ab949ddaba4f6dd$export$ae31fcaba1cddbd8(maybeFn, route, key, processResolvedRoutes);
    }
    if (Array.isArray(route.children)) for (const child of route.children)$4ab949ddaba4f6dd$export$e9262e29e117b830(child, processResolvedRoutes);
}



let $fad849df2a5834bb$var$_useEffect;
let $fad849df2a5834bb$var$_useLocation;
let $fad849df2a5834bb$var$_useNavigationType;
let $fad849df2a5834bb$var$_createRoutesFromChildren;
let $fad849df2a5834bb$var$_matchRoutes;
let $fad849df2a5834bb$var$_enableAsyncRouteHandlers = false;
let $fad849df2a5834bb$var$_lazyRouteTimeout = 3e3;
let $fad849df2a5834bb$var$_lazyRouteManifest;
let $fad849df2a5834bb$var$_basename = "";
const $fad849df2a5834bb$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION = /* @__PURE__ */ new WeakSet();
const $fad849df2a5834bb$var$useIsomorphicLayoutEffect = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81)?.document ? $itHdT.useLayoutEffect : $itHdT.useEffect;
const $fad849df2a5834bb$var$activeNavigationSpans = /* @__PURE__ */ new WeakMap();
const $fad849df2a5834bb$export$3ef6d4da8160fa32 = /* @__PURE__ */ new Set();
const $fad849df2a5834bb$var$pendingLazyRouteLoads = /* @__PURE__ */ new WeakMap();
const $fad849df2a5834bb$var$deferredLazyRouteResolvers = /* @__PURE__ */ new WeakMap();
function $fad849df2a5834bb$var$scheduleCallback(callback) {
    if ((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81)?.requestAnimationFrame) return (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $fad849df2a5834bb$var$cancelScheduledCallback(id) {
    if ((0, $26e2765b4d6baedf$export$56d8a8a25bd48b81)?.cancelAnimationFrame) (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).cancelAnimationFrame(id);
    else clearTimeout(id);
}
function $fad849df2a5834bb$export$6da138630728824c(location) {
    return `${location.pathname}${location.search || ""}${location.hash || ""}`;
}
function $fad849df2a5834bb$var$isParameterizedRoute(routeName) {
    return routeName.includes(":") || routeName.includes("*");
}
function $fad849df2a5834bb$export$74ccc56dfa81ef20(trackedNav, locationKey, proposedName, spanHasEnded) {
    if (!trackedNav) return {
        skip: false,
        shouldUpdate: false
    };
    const isDuplicate = trackedNav.locationKey === locationKey && (trackedNav.isPlaceholder || !spanHasEnded);
    if (isDuplicate) {
        const currentHasWildcard = !!trackedNav.routeName && (0, $36e2a44d523353a7$export$73bbd8f1d410fc7c)(trackedNav.routeName);
        const proposedHasWildcard = (0, $36e2a44d523353a7$export$73bbd8f1d410fc7c)(proposedName);
        const currentIsParameterized = !!trackedNav.routeName && $fad849df2a5834bb$var$isParameterizedRoute(trackedNav.routeName);
        const proposedIsParameterized = $fad849df2a5834bb$var$isParameterizedRoute(proposedName);
        const isWildcardUpgrade = currentHasWildcard && !proposedHasWildcard;
        const isRawToParameterized = !currentIsParameterized && proposedIsParameterized;
        const isMoreSpecific = proposedName !== trackedNav.routeName && proposedName.length > (trackedNav.routeName?.length || 0) && !proposedHasWildcard;
        const shouldUpdate = !!(trackedNav.routeName && (isWildcardUpgrade || isRawToParameterized || isMoreSpecific));
        return {
            skip: true,
            shouldUpdate: shouldUpdate
        };
    }
    return {
        skip: false,
        shouldUpdate: false
    };
}
function $fad849df2a5834bb$export$d443af17fae6e7aa(resolvedRoutes, parentRoute) {
    const existingChildren = parentRoute.children || [];
    const newRoutes = resolvedRoutes.filter((newRoute)=>!existingChildren.some((existing)=>existing === newRoute || newRoute.path && existing.path === newRoute.path || newRoute.id && existing.id === newRoute.id));
    if (newRoutes.length > 0) parentRoute.children = [
        ...existingChildren,
        ...newRoutes
    ];
}
function $fad849df2a5834bb$var$trackLazyRouteLoad(span, promise) {
    let promises = $fad849df2a5834bb$var$pendingLazyRouteLoads.get(span);
    if (!promises) {
        promises = /* @__PURE__ */ new Set();
        $fad849df2a5834bb$var$pendingLazyRouteLoads.set(span, promises);
    }
    promises.add(promise);
    promise.finally(()=>{
        const currentPromises = $fad849df2a5834bb$var$pendingLazyRouteLoads.get(span);
        if (currentPromises) currentPromises.delete(promise);
    });
}
function $fad849df2a5834bb$var$createDeferredLazyRoutePromise(span) {
    const deferredPromise = new Promise((resolve)=>{
        $fad849df2a5834bb$var$deferredLazyRouteResolvers.set(span, resolve);
    });
    $fad849df2a5834bb$var$trackLazyRouteLoad(span, deferredPromise);
}
function $fad849df2a5834bb$var$resolveDeferredLazyRoutePromise(span) {
    const resolver = $fad849df2a5834bb$var$deferredLazyRouteResolvers.get(span);
    if (resolver) {
        resolver();
        $fad849df2a5834bb$var$deferredLazyRouteResolvers.delete(span);
        if (span.__sentry_may_have_lazy_routes__) span.__sentry_may_have_lazy_routes__ = false;
    }
}
function $fad849df2a5834bb$export$b18942cbaf6837a6(resolvedRoutes, parentRoute, currentLocation = null, capturedSpan) {
    resolvedRoutes.forEach((child)=>{
        $fad849df2a5834bb$export$3ef6d4da8160fa32.add(child);
        if ($fad849df2a5834bb$var$_enableAsyncRouteHandlers) (0, $4ab949ddaba4f6dd$export$e9262e29e117b830)(child, $fad849df2a5834bb$export$b18942cbaf6837a6);
    });
    if (parentRoute) $fad849df2a5834bb$export$d443af17fae6e7aa(resolvedRoutes, parentRoute);
    const targetSpan = capturedSpan ?? (0, $36e2a44d523353a7$export$6d46479e35ff5f30)();
    if (targetSpan) {
        const spanJson = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(targetSpan);
        if (spanJson.timestamp) {
            (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("[React Router] Lazy handler resolved after span ended - skipping update");
            return;
        }
        const spanOp = spanJson.op;
        let location = currentLocation;
        if (!location && !capturedSpan) {
            if (typeof (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81) !== "undefined") {
                const globalLocation = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location;
                if (globalLocation?.pathname) location = {
                    pathname: globalLocation.pathname
                };
            }
        }
        if (location) {
            if (spanOp === "pageload") $fad849df2a5834bb$var$updatePageloadTransaction({
                activeRootSpan: targetSpan,
                location: {
                    pathname: location.pathname
                },
                routes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32),
                allRoutes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32)
            });
            else if (spanOp === "navigation") $fad849df2a5834bb$export$8e00428fd5aa3427(targetSpan, location, Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32), false, $fad849df2a5834bb$var$_matchRoutes);
        }
    }
}
function $fad849df2a5834bb$export$8e00428fd5aa3427(activeRootSpan, location, allRoutes2, forceUpdate = false, matchRoutes) {
    const spanJson = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(activeRootSpan);
    const currentName = spanJson.description;
    const hasBeenNamed = activeRootSpan?.__sentry_navigation_name_set__;
    const currentNameHasWildcard = currentName && (0, $36e2a44d523353a7$export$73bbd8f1d410fc7c)(currentName);
    const shouldUpdate = !hasBeenNamed || forceUpdate || currentNameHasWildcard;
    if (shouldUpdate && !spanJson.timestamp) {
        const currentBranches = matchRoutes(allRoutes2, location);
        const [name, source] = (0, $36e2a44d523353a7$export$d0d5aab0e629ad63)(location, allRoutes2, allRoutes2, currentBranches || [], $fad849df2a5834bb$var$_basename, $fad849df2a5834bb$var$_lazyRouteManifest, $fad849df2a5834bb$var$_enableAsyncRouteHandlers);
        const currentSource = spanJson.data?.[0, $4f85903ad30c6e77$export$d7a7d984b0791405];
        const isImprovement = name && (!currentName || // No current name - always set
        !hasBeenNamed && (currentSource !== "route" || source === "route") || // Not finalized - allow unless downgrading route→url
        currentSource !== "route" && source === "route" || // URL → route upgrade
        currentSource === "route" && source === "route" && currentNameHasWildcard);
        if (isImprovement) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, $4f85903ad30c6e77$export$d7a7d984b0791405), source);
            if (!(0, $36e2a44d523353a7$export$73bbd8f1d410fc7c)(name) && source === "route") (0, $e632e89186c3a412$export$e73679ffaf56810e)(activeRootSpan, "__sentry_navigation_name_set__", true);
        }
    }
}
function $fad849df2a5834bb$var$setupRouterSubscription(router, routes, version, basename, activeRootSpan) {
    let isInitialPageloadComplete = false;
    let hasSeenPageloadSpan = !!activeRootSpan && (0, $da6e7e382c71fa3f$export$92d8c23565496537)(activeRootSpan).op === "pageload";
    let hasSeenPopAfterPageload = false;
    let scheduledNavigationHandler = null;
    let lastHandledPathname = null;
    router.subscribe((state)=>{
        if (!isInitialPageloadComplete) {
            const currentRootSpan = (0, $36e2a44d523353a7$export$6d46479e35ff5f30)();
            const isCurrentlyInPageload = currentRootSpan && (0, $da6e7e382c71fa3f$export$92d8c23565496537)(currentRootSpan).op === "pageload";
            if (isCurrentlyInPageload) hasSeenPageloadSpan = true;
            else if (hasSeenPageloadSpan) {
                if (state.historyAction === "POP" && !hasSeenPopAfterPageload) hasSeenPopAfterPageload = true;
                else isInitialPageloadComplete = true;
            }
        }
        const shouldHandleNavigation = state.historyAction === "PUSH" || state.historyAction === "POP" && isInitialPageloadComplete;
        if (shouldHandleNavigation) {
            const currentLocationKey = $fad849df2a5834bb$export$6da138630728824c(state.location);
            const navigationHandler = ()=>{
                if (lastHandledPathname === currentLocationKey) return;
                lastHandledPathname = currentLocationKey;
                scheduledNavigationHandler = null;
                $fad849df2a5834bb$export$706ad1af8096e280({
                    location: state.location,
                    routes: routes,
                    navigationType: state.historyAction,
                    version: version,
                    basename: basename,
                    allRoutes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32)
                });
            };
            if (state.navigation.state !== "idle") {
                if (lastHandledPathname !== currentLocationKey) lastHandledPathname = null;
                if (scheduledNavigationHandler !== null) $fad849df2a5834bb$var$cancelScheduledCallback(scheduledNavigationHandler);
                scheduledNavigationHandler = $fad849df2a5834bb$var$scheduleCallback(navigationHandler);
            } else {
                if (scheduledNavigationHandler !== null) {
                    $fad849df2a5834bb$var$cancelScheduledCallback(scheduledNavigationHandler);
                    scheduledNavigationHandler = null;
                }
                navigationHandler();
            }
        }
    });
}
function $fad849df2a5834bb$export$6f08ca2914060d3f(createRouterFunction, version) {
    if (!$fad849df2a5834bb$var$_useEffect || !$fad849df2a5834bb$var$_useLocation || !$fad849df2a5834bb$var$_useNavigationType || !$fad849df2a5834bb$var$_matchRoutes) {
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`reactRouterV${version}Instrumentation was unable to wrap the \`createRouter\` function because of one or more missing parameters.`);
        return createRouterFunction;
    }
    return function(routes, opts) {
        $fad849df2a5834bb$export$e8ecdda469a42a59(routes);
        if ($fad849df2a5834bb$var$_enableAsyncRouteHandlers) for (const route of routes)(0, $4ab949ddaba4f6dd$export$e9262e29e117b830)(route, $fad849df2a5834bb$export$b18942cbaf6837a6);
        const activeRootSpan = (0, $36e2a44d523353a7$export$6d46479e35ff5f30)();
        const hasPatchRoutesOnNavigation = opts && "patchRoutesOnNavigation" in opts && typeof opts.patchRoutesOnNavigation === "function";
        if (hasPatchRoutesOnNavigation && activeRootSpan) {
            (0, $e632e89186c3a412$export$e73679ffaf56810e)(activeRootSpan, "__sentry_may_have_lazy_routes__", true);
            $fad849df2a5834bb$var$createDeferredLazyRoutePromise(activeRootSpan);
        }
        const wrappedOpts = $fad849df2a5834bb$var$wrapPatchRoutesOnNavigation(opts, false, activeRootSpan);
        const router = createRouterFunction(routes, wrappedOpts);
        const basename = opts?.basename;
        if (router.state.historyAction === "POP" && activeRootSpan) $fad849df2a5834bb$var$updatePageloadTransaction({
            activeRootSpan: activeRootSpan,
            location: router.state.location,
            routes: routes,
            basename: basename,
            allRoutes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32)
        });
        $fad849df2a5834bb$var$_basename = basename || "";
        $fad849df2a5834bb$var$setupRouterSubscription(router, routes, version, basename, activeRootSpan);
        return router;
    };
}
function $fad849df2a5834bb$export$ce6d63af7f6f9771(createRouterFunction, version) {
    if (!$fad849df2a5834bb$var$_useEffect || !$fad849df2a5834bb$var$_useLocation || !$fad849df2a5834bb$var$_useNavigationType || !$fad849df2a5834bb$var$_matchRoutes) {
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`reactRouterV${version}Instrumentation was unable to wrap the \`createMemoryRouter\` function because of one or more missing parameters.`);
        return createRouterFunction;
    }
    return function(routes, opts) {
        $fad849df2a5834bb$export$e8ecdda469a42a59(routes);
        if ($fad849df2a5834bb$var$_enableAsyncRouteHandlers) for (const route of routes)(0, $4ab949ddaba4f6dd$export$e9262e29e117b830)(route, $fad849df2a5834bb$export$b18942cbaf6837a6);
        const memoryActiveRootSpanEarly = (0, $36e2a44d523353a7$export$6d46479e35ff5f30)();
        const hasPatchRoutesOnNavigation = opts && "patchRoutesOnNavigation" in opts && typeof opts.patchRoutesOnNavigation === "function";
        if (hasPatchRoutesOnNavigation && memoryActiveRootSpanEarly) {
            (0, $e632e89186c3a412$export$e73679ffaf56810e)(memoryActiveRootSpanEarly, "__sentry_may_have_lazy_routes__", true);
            $fad849df2a5834bb$var$createDeferredLazyRoutePromise(memoryActiveRootSpanEarly);
        }
        const wrappedOpts = $fad849df2a5834bb$var$wrapPatchRoutesOnNavigation(opts, true, memoryActiveRootSpanEarly);
        const router = createRouterFunction(routes, wrappedOpts);
        const basename = opts?.basename;
        let initialEntry = void 0;
        const initialEntries = opts?.initialEntries;
        const initialIndex = opts?.initialIndex;
        const hasOnlyOneInitialEntry = initialEntries?.length === 1;
        const hasIndexedEntry = initialIndex !== void 0 && initialEntries?.[initialIndex];
        initialEntry = hasOnlyOneInitialEntry ? initialEntries[0] : hasIndexedEntry ? initialEntries[initialIndex] : void 0;
        const location = initialEntry ? typeof initialEntry === "string" ? {
            pathname: initialEntry
        } : initialEntry : router.state.location;
        const memoryActiveRootSpan = (0, $36e2a44d523353a7$export$6d46479e35ff5f30)();
        if (router.state.historyAction === "POP" && memoryActiveRootSpan) $fad849df2a5834bb$var$updatePageloadTransaction({
            activeRootSpan: memoryActiveRootSpan,
            location: location,
            routes: routes,
            basename: basename,
            allRoutes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32)
        });
        $fad849df2a5834bb$var$_basename = basename || "";
        $fad849df2a5834bb$var$setupRouterSubscription(router, routes, version, basename, memoryActiveRootSpan);
        return router;
    };
}
function $fad849df2a5834bb$export$7e5bbc7e32f3c098(options, version) {
    const integration = (0, $72f7c10954dbe37c$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, enableAsyncRouteHandlers: enableAsyncRouteHandlers = false, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true, lazyRouteTimeout: lazyRouteTimeout, lazyRouteManifest: lazyRouteManifest } = options;
    return {
        ...integration,
        setup (client) {
            integration.setup(client);
            const finalTimeout = options.finalTimeout ?? 3e4;
            const defaultMaxWait = (options.idleTimeout ?? 1e3) * 3;
            const configuredMaxWait = lazyRouteTimeout ?? defaultMaxWait;
            if (configuredMaxWait === Infinity) {
                $fad849df2a5834bb$var$_lazyRouteTimeout = finalTimeout;
                (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log("[React Router] lazyRouteTimeout set to Infinity, capping at finalTimeout:", finalTimeout, "ms to prevent indefinite hangs");
            } else if (Number.isNaN(configuredMaxWait)) {
                (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("[React Router] lazyRouteTimeout must be a number, falling back to default:", defaultMaxWait);
                $fad849df2a5834bb$var$_lazyRouteTimeout = defaultMaxWait;
            } else if (configuredMaxWait < 0) {
                (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("[React Router] lazyRouteTimeout must be non-negative or Infinity, got:", configuredMaxWait, "falling back to:", defaultMaxWait);
                $fad849df2a5834bb$var$_lazyRouteTimeout = defaultMaxWait;
            } else $fad849df2a5834bb$var$_lazyRouteTimeout = configuredMaxWait;
            $fad849df2a5834bb$var$_useEffect = useEffect;
            $fad849df2a5834bb$var$_useLocation = useLocation;
            $fad849df2a5834bb$var$_useNavigationType = useNavigationType;
            $fad849df2a5834bb$var$_matchRoutes = matchRoutes;
            $fad849df2a5834bb$var$_createRoutesFromChildren = createRoutesFromChildren;
            $fad849df2a5834bb$var$_enableAsyncRouteHandlers = enableAsyncRouteHandlers;
            $fad849df2a5834bb$var$_lazyRouteManifest = lazyRouteManifest;
            (0, $36e2a44d523353a7$export$d5deab901a3788fa)(matchRoutes, stripBasename || false);
        },
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const initPathName = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).location?.pathname;
            if (instrumentPageLoad && initPathName) (0, $72f7c10954dbe37c$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $4f85903ad30c6e77$export$d7a7d984b0791405)]: "url",
                    [(0, $4f85903ad30c6e77$export$1a413bd9a88fdb09)]: "pageload",
                    [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: `auto.pageload.react.reactrouter_v${version}`
                }
            });
            if (instrumentNavigation) $fad849df2a5834bb$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION.add(client);
        }
    };
}
function $fad849df2a5834bb$export$3881404ad6870e59(origUseRoutes, version) {
    if (!$fad849df2a5834bb$var$_useEffect || !$fad849df2a5834bb$var$_useLocation || !$fad849df2a5834bb$var$_useNavigationType || !$fad849df2a5834bb$var$_matchRoutes) {
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    const SentryRoutes = (props)=>{
        const isMountRenderPass = $itHdT.useRef(true);
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $fad849df2a5834bb$var$_useLocation();
        const navigationType = $fad849df2a5834bb$var$_useNavigationType();
        const stableLocationParam = typeof locationArg === "string" || locationArg?.pathname ? locationArg : location;
        $fad849df2a5834bb$var$useIsomorphicLayoutEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass.current) {
                $fad849df2a5834bb$export$e8ecdda469a42a59(routes);
                $fad849df2a5834bb$var$updatePageloadTransaction({
                    activeRootSpan: (0, $36e2a44d523353a7$export$6d46479e35ff5f30)(),
                    location: normalizedLocation,
                    routes: routes,
                    allRoutes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32)
                });
                isMountRenderPass.current = false;
            } else $fad849df2a5834bb$export$706ad1af8096e280({
                location: normalizedLocation,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32)
            });
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    return (routes, locationArg)=>{
        return /* @__PURE__ */ $itHdT.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg
        });
    };
}
function $fad849df2a5834bb$var$wrapPatchRoutesOnNavigation(opts, isMemoryRouter = false, capturedSpan) {
    if (!opts || !("patchRoutesOnNavigation" in opts) || typeof opts.patchRoutesOnNavigation !== "function") return opts || {};
    const originalPatchRoutes = opts.patchRoutesOnNavigation;
    return {
        ...opts,
        patchRoutesOnNavigation: async (args)=>{
            const targetPath = args?.path;
            const activeRootSpan = (0, $36e2a44d523353a7$export$6d46479e35ff5f30)() ?? capturedSpan;
            if (!isMemoryRouter) {
                const originalPatch = args?.patch;
                const matches = args?.matches;
                if (originalPatch) args.patch = (routeId, children)=>{
                    $fad849df2a5834bb$export$e8ecdda469a42a59(children);
                    if (matches && matches.length > 0) {
                        const leafMatch = matches[matches.length - 1];
                        const leafRoute = leafMatch?.route;
                        if (leafRoute) {
                            const matchingRoute = Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32).find((route)=>{
                                const idMatches = route.id !== void 0 && route.id === routeId;
                                const referenceMatches = route === leafRoute;
                                const pathMatches = route.path !== void 0 && leafRoute.path !== void 0 && route.path === leafRoute.path;
                                return idMatches || referenceMatches || pathMatches;
                            });
                            if (matchingRoute) $fad849df2a5834bb$export$d443af17fae6e7aa(children, matchingRoute);
                        }
                    }
                    const spanJson = activeRootSpan ? (0, $da6e7e382c71fa3f$export$92d8c23565496537)(activeRootSpan) : void 0;
                    if (targetPath && activeRootSpan && spanJson && !spanJson.timestamp && // Span hasn't ended yet
                    spanJson.op === "navigation") $fad849df2a5834bb$export$8e00428fd5aa3427(activeRootSpan, {
                        pathname: targetPath,
                        search: "",
                        hash: "",
                        state: null,
                        key: "default"
                    }, Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32), true, $fad849df2a5834bb$var$_matchRoutes);
                    return originalPatch(routeId, children);
                };
            }
            const lazyLoadPromise = (async ()=>{
                const contextToken = (0, $36e2a44d523353a7$export$49f239a397357a7c)(targetPath, activeRootSpan);
                let result;
                try {
                    result = await originalPatchRoutes(args);
                } finally{
                    (0, $36e2a44d523353a7$export$44ec4f5e487fad8c)(contextToken);
                    if (activeRootSpan) $fad849df2a5834bb$var$resolveDeferredLazyRoutePromise(activeRootSpan);
                }
                const spanJson = activeRootSpan ? (0, $da6e7e382c71fa3f$export$92d8c23565496537)(activeRootSpan) : void 0;
                if (activeRootSpan && spanJson && !spanJson.timestamp && // Span hasn't ended yet
                spanJson.op === "navigation") {
                    const pathname = targetPath;
                    if (pathname) $fad849df2a5834bb$export$8e00428fd5aa3427(activeRootSpan, {
                        pathname: pathname,
                        search: "",
                        hash: "",
                        state: null,
                        key: "default"
                    }, Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32), false, $fad849df2a5834bb$var$_matchRoutes);
                }
                return result;
            })();
            if (activeRootSpan) $fad849df2a5834bb$var$trackLazyRouteLoad(activeRootSpan, lazyLoadPromise);
            return lazyLoadPromise;
        }
    };
}
function $fad849df2a5834bb$export$706ad1af8096e280(opts) {
    const { location: location, routes: routes, navigationType: navigationType, version: version, matches: matches, basename: basename, allRoutes: allRoutes2 } = opts;
    const branches = Array.isArray(matches) ? matches : $fad849df2a5834bb$var$_matchRoutes(allRoutes2 || routes, location, basename);
    const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
    if (!client || !$fad849df2a5834bb$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION.has(client)) return;
    const activeRootSpan = (0, $36e2a44d523353a7$export$6d46479e35ff5f30)();
    if (activeRootSpan && (0, $da6e7e382c71fa3f$export$92d8c23565496537)(activeRootSpan).op === "pageload" && navigationType === "POP") return;
    if ((navigationType === "PUSH" || navigationType === "POP") && branches) {
        const [name, source] = (0, $36e2a44d523353a7$export$d0d5aab0e629ad63)(location, allRoutes2 || routes, allRoutes2 || routes, branches, basename, $fad849df2a5834bb$var$_lazyRouteManifest, $fad849df2a5834bb$var$_enableAsyncRouteHandlers);
        const locationKey = $fad849df2a5834bb$export$6da138630728824c(location);
        const trackedNav = $fad849df2a5834bb$var$activeNavigationSpans.get(client);
        const trackedSpanHasEnded = trackedNav && !trackedNav.isPlaceholder ? !!(0, $da6e7e382c71fa3f$export$92d8c23565496537)(trackedNav.span).timestamp : false;
        const { skip: skip, shouldUpdate: shouldUpdate } = $fad849df2a5834bb$export$74ccc56dfa81ef20(trackedNav, locationKey, name, trackedSpanHasEnded);
        if (skip) {
            if (shouldUpdate && trackedNav) {
                const oldName = trackedNav.routeName;
                if (trackedNav.isPlaceholder) {
                    trackedNav.routeName = name;
                    (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`[Tracing] Updated placeholder navigation name from "${oldName}" to "${name}" (will apply to real span)`);
                } else {
                    trackedNav.span.updateName(name);
                    trackedNav.span.setAttribute((0, $4f85903ad30c6e77$export$d7a7d984b0791405), source);
                    (0, $e632e89186c3a412$export$e73679ffaf56810e)(trackedNav.span, "__sentry_navigation_name_set__", true);
                    trackedNav.routeName = name;
                    (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`[Tracing] Updated navigation span name from "${oldName}" to "${name}"`);
                }
            } else (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).log(`[Tracing] Skipping duplicate navigation for location: ${locationKey}`);
            return;
        }
        const placeholderSpan = {
            end: ()=>{}
        };
        const placeholderEntry = {
            span: placeholderSpan,
            routeName: name,
            pathname: location.pathname,
            locationKey: locationKey,
            isPlaceholder: true
        };
        $fad849df2a5834bb$var$activeNavigationSpans.set(client, placeholderEntry);
        let navigationSpan;
        try {
            navigationSpan = (0, $72f7c10954dbe37c$export$7d159749bd9969ad)(client, {
                name: placeholderEntry.routeName,
                // Use placeholder's routeName in case it was updated
                attributes: {
                    [(0, $4f85903ad30c6e77$export$d7a7d984b0791405)]: source,
                    [(0, $4f85903ad30c6e77$export$1a413bd9a88fdb09)]: "navigation",
                    [(0, $4f85903ad30c6e77$export$cca8dd30f57f805e)]: `auto.navigation.react.reactrouter_v${version}`
                }
            });
        } catch (e) {
            $fad849df2a5834bb$var$activeNavigationSpans.delete(client);
            throw e;
        }
        if (navigationSpan) {
            $fad849df2a5834bb$var$activeNavigationSpans.set(client, {
                span: navigationSpan,
                routeName: placeholderEntry.routeName,
                // Use the (potentially updated) placeholder routeName
                pathname: location.pathname,
                locationKey: locationKey
            });
            $fad849df2a5834bb$var$patchSpanEnd(navigationSpan, location, routes, basename, "navigation");
        } else $fad849df2a5834bb$var$activeNavigationSpans.delete(client);
    }
}
function $fad849df2a5834bb$export$e8ecdda469a42a59(routes) {
    routes.forEach((route)=>{
        const extractedChildRoutes = $fad849df2a5834bb$var$getChildRoutesRecursively(route);
        extractedChildRoutes.forEach((r)=>{
            $fad849df2a5834bb$export$3ef6d4da8160fa32.add(r);
        });
    });
}
function $fad849df2a5834bb$var$getChildRoutesRecursively(route, allRoutes2 = /* @__PURE__ */ new Set()) {
    if (!allRoutes2.has(route)) {
        allRoutes2.add(route);
        if (route.children && !route.index) route.children.forEach((child)=>{
            const childRoutes = $fad849df2a5834bb$var$getChildRoutesRecursively(child, allRoutes2);
            childRoutes.forEach((r)=>{
                allRoutes2.add(r);
            });
        });
    }
    return allRoutes2;
}
function $fad849df2a5834bb$var$updatePageloadTransaction({ activeRootSpan: activeRootSpan, location: location, routes: routes, matches: matches, basename: basename, allRoutes: allRoutes2 }) {
    const branches = Array.isArray(matches) ? matches : $fad849df2a5834bb$var$_matchRoutes(allRoutes2 || routes, location, basename);
    if (branches) {
        const [name, source] = (0, $36e2a44d523353a7$export$d0d5aab0e629ad63)(location, allRoutes2 || routes, allRoutes2 || routes, branches, basename, $fad849df2a5834bb$var$_lazyRouteManifest, $fad849df2a5834bb$var$_enableAsyncRouteHandlers);
        (0, $89fdb8ff58631b88$export$c7be4b0125a10cba)().setTransactionName(name || "/");
        if (activeRootSpan) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, $4f85903ad30c6e77$export$d7a7d984b0791405), source);
            $fad849df2a5834bb$var$patchSpanEnd(activeRootSpan, location, routes, basename, "pageload");
        }
    } else if (activeRootSpan) $fad849df2a5834bb$var$patchSpanEnd(activeRootSpan, location, routes, basename, "pageload");
}
function $fad849df2a5834bb$var$shouldUpdateWildcardSpanName(currentName, currentSource, newName, newSource, allowNoCurrentName = false) {
    if (!newName) return false;
    if (!currentName && allowNoCurrentName) return true;
    const hasWildcard = currentName && (0, $36e2a44d523353a7$export$73bbd8f1d410fc7c)(currentName);
    if (hasWildcard && newSource === "route" && !(0, $36e2a44d523353a7$export$73bbd8f1d410fc7c)(newName)) return true;
    if (currentSource !== "route" && newSource === "route") return true;
    return false;
}
function $fad849df2a5834bb$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, allRoutes2) {
    try {
        const currentSource = spanJson.data?.[0, $4f85903ad30c6e77$export$d7a7d984b0791405];
        if (currentSource === "route" && currentName && !(0, $36e2a44d523353a7$export$73bbd8f1d410fc7c)(currentName)) return;
        const currentAllRoutes = Array.from(allRoutes2);
        const routesToUse = currentAllRoutes.length > 0 ? currentAllRoutes : routes;
        const branches = $fad849df2a5834bb$var$_matchRoutes(routesToUse, location, basename);
        if (!branches) return;
        const [name, source] = (0, $36e2a44d523353a7$export$d0d5aab0e629ad63)(location, routesToUse, routesToUse, branches, basename, $fad849df2a5834bb$var$_lazyRouteManifest, $fad849df2a5834bb$var$_enableAsyncRouteHandlers);
        const isImprovement = $fad849df2a5834bb$var$shouldUpdateWildcardSpanName(currentName, currentSource, name, source, true);
        const spanNotEnded = spanType === "pageload" || !spanJson.timestamp;
        if (isImprovement && spanNotEnded) {
            span.updateName(name);
            span.setAttribute((0, $4f85903ad30c6e77$export$d7a7d984b0791405), source);
        }
    } catch (error) {
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`Error updating span details before ending: ${error}`);
    }
}
function $fad849df2a5834bb$var$patchSpanEnd(span, location, routes, basename, spanType) {
    const patchedPropertyName = `__sentry_${spanType}_end_patched__`;
    const hasEndBeenPatched = span?.[patchedPropertyName];
    if (hasEndBeenPatched || !span.end) return;
    const originalEnd = span.end.bind(span);
    let endCalled = false;
    span.end = function patchedEnd(...args) {
        if (endCalled) return;
        endCalled = true;
        const endTimestamp = args.length > 0 ? args[0] : Date.now() / 1e3;
        const spanJson = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(span);
        const currentName = spanJson.description;
        const currentSource = spanJson.data?.[0, $4f85903ad30c6e77$export$d7a7d984b0791405];
        const cleanupNavigationSpan = ()=>{
            const client = (0, $89fdb8ff58631b88$export$6bb76d6eba7e258c)();
            if (client && spanType === "navigation") {
                const trackedNav = $fad849df2a5834bb$var$activeNavigationSpans.get(client);
                if (trackedNav && trackedNav.span === span) $fad849df2a5834bb$var$activeNavigationSpans.delete(client);
            }
        };
        const pendingPromises = $fad849df2a5834bb$var$pendingLazyRouteLoads.get(span);
        const mayHaveLazyRoutes = span.__sentry_may_have_lazy_routes__;
        const hasPendingOrMayHaveLazyRoutes = pendingPromises && pendingPromises.size > 0 || mayHaveLazyRoutes;
        const shouldWaitForLazyRoutes = hasPendingOrMayHaveLazyRoutes && currentName && ((0, $36e2a44d523353a7$export$73bbd8f1d410fc7c)(currentName) || currentSource !== "route");
        if (shouldWaitForLazyRoutes) {
            if ($fad849df2a5834bb$var$_lazyRouteTimeout === 0) {
                $fad849df2a5834bb$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, $fad849df2a5834bb$export$3ef6d4da8160fa32);
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
                return;
            }
            const timeoutPromise = new Promise((r)=>setTimeout(r, $fad849df2a5834bb$var$_lazyRouteTimeout));
            let waitPromise;
            if (pendingPromises && pendingPromises.size > 0) {
                const allSettled = Promise.allSettled(pendingPromises).then(()=>{});
                waitPromise = $fad849df2a5834bb$var$_lazyRouteTimeout === Infinity ? allSettled : Promise.race([
                    allSettled,
                    timeoutPromise
                ]);
            } else waitPromise = timeoutPromise;
            waitPromise.then(()=>{
                const updatedSpanJson = (0, $da6e7e382c71fa3f$export$92d8c23565496537)(span);
                $fad849df2a5834bb$var$tryUpdateSpanNameBeforeEnd(span, updatedSpanJson, updatedSpanJson.description, location, routes, basename, spanType, $fad849df2a5834bb$export$3ef6d4da8160fa32);
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
            }).catch(()=>{
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
            });
            return;
        }
        $fad849df2a5834bb$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, $fad849df2a5834bb$export$3ef6d4da8160fa32);
        cleanupNavigationSpan();
        originalEnd(endTimestamp);
    };
    (0, $e632e89186c3a412$export$e73679ffaf56810e)(span, patchedPropertyName, true);
}
function $fad849df2a5834bb$export$b90e0c8f3b3b5df0(Routes, version) {
    if (!$fad849df2a5834bb$var$_useEffect || !$fad849df2a5834bb$var$_useLocation || !$fad849df2a5834bb$var$_useNavigationType || !$fad849df2a5834bb$var$_createRoutesFromChildren || !$fad849df2a5834bb$var$_matchRoutes) {
        (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$fad849df2a5834bb$var$_useEffect}. useLocation: ${$fad849df2a5834bb$var$_useLocation}. useNavigationType: ${$fad849df2a5834bb$var$_useNavigationType}.
      createRoutesFromChildren: ${$fad849df2a5834bb$var$_createRoutesFromChildren}. matchRoutes: ${$fad849df2a5834bb$var$_matchRoutes}.`);
        return Routes;
    }
    const SentryRoutes = (props)=>{
        const isMountRenderPass = $itHdT.useRef(true);
        const location = $fad849df2a5834bb$var$_useLocation();
        const navigationType = $fad849df2a5834bb$var$_useNavigationType();
        $fad849df2a5834bb$var$useIsomorphicLayoutEffect(()=>{
            const routes = $fad849df2a5834bb$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass.current) {
                $fad849df2a5834bb$export$e8ecdda469a42a59(routes);
                $fad849df2a5834bb$var$updatePageloadTransaction({
                    activeRootSpan: (0, $36e2a44d523353a7$export$6d46479e35ff5f30)(),
                    location: location,
                    routes: routes,
                    allRoutes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32)
                });
                isMountRenderPass.current = false;
            } else $fad849df2a5834bb$export$706ad1af8096e280({
                location: location,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from($fad849df2a5834bb$export$3ef6d4da8160fa32)
            });
        }, // Re-run only on location/navigation changes, not children changes
        [
            location,
            navigationType
        ]);
        return /* @__PURE__ */ $itHdT.createElement(Routes, {
            ...props
        });
    };
    (0, $6ad9d39434910094$export$6c1f0397687d8b2)(SentryRoutes, Routes);
    return SentryRoutes;
}





function $d99727d27dbc013b$export$8c58a21c71b0a1de(options) {
    return (0, $fad849df2a5834bb$export$7e5bbc7e32f3c098)(options, "7");
}
function $d99727d27dbc013b$export$1d21f1c69f33ffe5(routes) {
    return (0, $fad849df2a5834bb$export$b90e0c8f3b3b5df0)(routes, "7");
}
function $d99727d27dbc013b$export$b070baa27381b3d3(createRouterFunction) {
    return (0, $fad849df2a5834bb$export$6f08ca2914060d3f)(createRouterFunction, "7");
}
function $d99727d27dbc013b$export$6d8f60accec7deae(createMemoryRouterFunction) {
    return (0, $fad849df2a5834bb$export$ce6d63af7f6f9771)(createMemoryRouterFunction, "7");
}
function $d99727d27dbc013b$export$54f60524efa5c3b2(origUseRoutes) {
    return (0, $fad849df2a5834bb$export$3881404ad6870e59)(origUseRoutes, "7");
}



var $itHdT = parcelRequire("itHdT");
var $3d1bc10025e74699$export$882461b6382ed46c;
var $3d1bc10025e74699$export$757ceba2d55c277e;
'use strict';
var $f53291ba5372fee6$exports = {};
'use strict';
function $f53291ba5372fee6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f53291ba5372fee6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f53291ba5372fee6$var$checkDCE();

$f53291ba5372fee6$exports = (parcelRequire("8nPCK"));


var $3d1bc10025e74699$var$i;
$3d1bc10025e74699$export$882461b6382ed46c = $f53291ba5372fee6$exports.createRoot;
$3d1bc10025e74699$export$757ceba2d55c277e = $f53291ba5372fee6$exports.hydrateRoot;


/**
 * react-router v7.18.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $itHdT = parcelRequire("itHdT");
var $b634fe06a3f61222$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.18.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-router/dist/development/chunk-6KYCQHYJ.mjs"
});
var $b634fe06a3f61222$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $b634fe06a3f61222$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $b634fe06a3f61222$var$__typeError("Cannot " + msg);
var $b634fe06a3f61222$var$__privateGet = (obj, member, getter)=>($b634fe06a3f61222$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $b634fe06a3f61222$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $b634fe06a3f61222$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $b634fe06a3f61222$var$__privateSet = (obj, member, value, setter)=>($b634fe06a3f61222$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $b634fe06a3f61222$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $b634fe06a3f61222$export$825a82322d91916e = /^[\\/]{2}/;
function $b634fe06a3f61222$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $b634fe06a3f61222$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($b634fe06a3f61222$export$e19cd5f9376f8cee || {});
var $b634fe06a3f61222$var$PopStateEventType = "popstate";
function $b634fe06a3f61222$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $b634fe06a3f61222$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $b634fe06a3f61222$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $b634fe06a3f61222$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $b634fe06a3f61222$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $b634fe06a3f61222$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $b634fe06a3f61222$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $b634fe06a3f61222$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to);
    }
    return $b634fe06a3f61222$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $b634fe06a3f61222$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b634fe06a3f61222$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b634fe06a3f61222$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b634fe06a3f61222$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $b634fe06a3f61222$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b634fe06a3f61222$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b634fe06a3f61222$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $b634fe06a3f61222$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $b634fe06a3f61222$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $b634fe06a3f61222$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b634fe06a3f61222$var$createKey(),
        mask: mask
    };
    return location;
}
function $b634fe06a3f61222$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $b634fe06a3f61222$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b634fe06a3f61222$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $b634fe06a3f61222$var$isLocation(to) ? to : $b634fe06a3f61222$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b634fe06a3f61222$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $b634fe06a3f61222$var$isLocation(to) ? to : $b634fe06a3f61222$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b634fe06a3f61222$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $b634fe06a3f61222$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($b634fe06a3f61222$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($b634fe06a3f61222$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $b634fe06a3f61222$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $b634fe06a3f61222$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $b634fe06a3f61222$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $b634fe06a3f61222$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $b634fe06a3f61222$var$_map;
var $b634fe06a3f61222$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $b634fe06a3f61222$var$__privateAdd(this, $b634fe06a3f61222$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_map).has(context)) return $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_map).set(context, value);
    }
};
$b634fe06a3f61222$var$_map = new WeakMap();
var $b634fe06a3f61222$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b634fe06a3f61222$var$isUnsupportedLazyRouteObjectKey(key) {
    return $b634fe06a3f61222$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $b634fe06a3f61222$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $b634fe06a3f61222$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $b634fe06a3f61222$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $b634fe06a3f61222$var$isIndexRoute(route) {
    return route.index === true;
}
function $b634fe06a3f61222$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b634fe06a3f61222$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $b634fe06a3f61222$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($b634fe06a3f61222$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $b634fe06a3f61222$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $b634fe06a3f61222$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $b634fe06a3f61222$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $b634fe06a3f61222$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $b634fe06a3f61222$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $b634fe06a3f61222$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $b634fe06a3f61222$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b634fe06a3f61222$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $b634fe06a3f61222$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $b634fe06a3f61222$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $b634fe06a3f61222$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $b634fe06a3f61222$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $b634fe06a3f61222$var$flattenAndRankRoutes(routes) {
    let branches = $b634fe06a3f61222$var$flattenRoutes(routes);
    $b634fe06a3f61222$var$rankRouteBranches(branches);
    return branches;
}
function $b634fe06a3f61222$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $b634fe06a3f61222$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b634fe06a3f61222$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $b634fe06a3f61222$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $b634fe06a3f61222$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b634fe06a3f61222$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $b634fe06a3f61222$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $b634fe06a3f61222$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $b634fe06a3f61222$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b634fe06a3f61222$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b634fe06a3f61222$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $b634fe06a3f61222$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $b634fe06a3f61222$var$paramRe = /^:[\w-]+$/;
var $b634fe06a3f61222$var$dynamicSegmentValue = 3;
var $b634fe06a3f61222$var$indexRouteValue = 2;
var $b634fe06a3f61222$var$emptySegmentValue = 1;
var $b634fe06a3f61222$var$staticSegmentValue = 10;
var $b634fe06a3f61222$var$splatPenalty = -2;
var $b634fe06a3f61222$var$isSplat = (s)=>s === "*";
function $b634fe06a3f61222$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b634fe06a3f61222$var$isSplat)) initialScore += $b634fe06a3f61222$var$splatPenalty;
    if (index) initialScore += $b634fe06a3f61222$var$indexRouteValue;
    return segments.filter((s)=>!$b634fe06a3f61222$var$isSplat(s)).reduce((score, segment)=>score + ($b634fe06a3f61222$var$paramRe.test(segment) ? $b634fe06a3f61222$var$dynamicSegmentValue : segment === "" ? $b634fe06a3f61222$var$emptySegmentValue : $b634fe06a3f61222$var$staticSegmentValue), initialScore);
}
function $b634fe06a3f61222$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b634fe06a3f61222$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $b634fe06a3f61222$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $b634fe06a3f61222$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $b634fe06a3f61222$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b634fe06a3f61222$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b634fe06a3f61222$var$normalizePathname($b634fe06a3f61222$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b634fe06a3f61222$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $b634fe06a3f61222$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b634fe06a3f61222$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $b634fe06a3f61222$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $b634fe06a3f61222$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b634fe06a3f61222$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $b634fe06a3f61222$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $b634fe06a3f61222$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $b634fe06a3f61222$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $b634fe06a3f61222$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b634fe06a3f61222$var$compilePath(path, caseSensitive = false, end = true) {
    $b634fe06a3f61222$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $b634fe06a3f61222$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $b634fe06a3f61222$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $b634fe06a3f61222$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $b634fe06a3f61222$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $b634fe06a3f61222$var$joinPaths([
        basename,
        pathname
    ]);
}
var $b634fe06a3f61222$var$isAbsoluteUrl = (url)=>$b634fe06a3f61222$var$ABSOLUTE_URL_REGEX.test(url);
function $b634fe06a3f61222$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $b634fe06a3f61222$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $b634fe06a3f61222$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $b634fe06a3f61222$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $b634fe06a3f61222$var$normalizeSearch(search),
        hash: $b634fe06a3f61222$var$normalizeHash(hash)
    };
}
function $b634fe06a3f61222$var$resolvePathname(relativePath, fromPathname) {
    let segments = $b634fe06a3f61222$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b634fe06a3f61222$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $b634fe06a3f61222$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $b634fe06a3f61222$var$getResolveToMatches(matches) {
    let pathMatches = $b634fe06a3f61222$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $b634fe06a3f61222$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $b634fe06a3f61222$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $b634fe06a3f61222$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $b634fe06a3f61222$var$getInvalidPathError("?", "pathname", "search", to));
        $b634fe06a3f61222$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $b634fe06a3f61222$var$getInvalidPathError("#", "pathname", "hash", to));
        $b634fe06a3f61222$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $b634fe06a3f61222$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b634fe06a3f61222$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $b634fe06a3f61222$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $b634fe06a3f61222$var$joinPaths = (paths)=>$b634fe06a3f61222$var$removeDoubleSlashes(paths.join("/"));
function $b634fe06a3f61222$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $b634fe06a3f61222$var$normalizePathname = (pathname)=>$b634fe06a3f61222$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $b634fe06a3f61222$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $b634fe06a3f61222$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $b634fe06a3f61222$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $b634fe06a3f61222$export$4051a07651545597(data2, init) {
    return new $b634fe06a3f61222$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $b634fe06a3f61222$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $b634fe06a3f61222$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b634fe06a3f61222$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $b634fe06a3f61222$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $b634fe06a3f61222$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $b634fe06a3f61222$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $b634fe06a3f61222$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $b634fe06a3f61222$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $b634fe06a3f61222$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $b634fe06a3f61222$var$joinPaths(parts) || "/";
}
var $b634fe06a3f61222$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $b634fe06a3f61222$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$b634fe06a3f61222$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($b634fe06a3f61222$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $b634fe06a3f61222$export$825a82322d91916e.test(to) ? new URL($b634fe06a3f61222$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $b634fe06a3f61222$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $b634fe06a3f61222$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $b634fe06a3f61222$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $b634fe06a3f61222$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $b634fe06a3f61222$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $b634fe06a3f61222$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$b634fe06a3f61222$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $b634fe06a3f61222$var$wrapImpl(aggregated[key], original, (...args)=>$b634fe06a3f61222$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$b634fe06a3f61222$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$b634fe06a3f61222$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $b634fe06a3f61222$var$wrapImpl(aggregated.middleware, original, (...args)=>$b634fe06a3f61222$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$b634fe06a3f61222$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $b634fe06a3f61222$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$b634fe06a3f61222$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $b634fe06a3f61222$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $b634fe06a3f61222$export$fe53371bee54353d(to) : ".",
                ...$b634fe06a3f61222$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$b634fe06a3f61222$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$b634fe06a3f61222$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $b634fe06a3f61222$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$b634fe06a3f61222$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$b634fe06a3f61222$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $b634fe06a3f61222$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $b634fe06a3f61222$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $b634fe06a3f61222$var$getReadonlyRequest(request),
            context: context != null ? $b634fe06a3f61222$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $b634fe06a3f61222$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $b634fe06a3f61222$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $b634fe06a3f61222$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $b634fe06a3f61222$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $b634fe06a3f61222$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $b634fe06a3f61222$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $b634fe06a3f61222$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $b634fe06a3f61222$var$getReadonlyContext(context)
    };
}
function $b634fe06a3f61222$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $b634fe06a3f61222$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $b634fe06a3f61222$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $b634fe06a3f61222$var$getReadonlyContext(context) {
    if ($b634fe06a3f61222$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $b634fe06a3f61222$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $b634fe06a3f61222$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $b634fe06a3f61222$var$objectProtoNames;
}
// lib/router/navigation.ts
var $b634fe06a3f61222$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $b634fe06a3f61222$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $b634fe06a3f61222$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $b634fe06a3f61222$var$DEFAULT_NAVIGATION_URL;
    }
}
function $b634fe06a3f61222$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $b634fe06a3f61222$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $b634fe06a3f61222$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$b634fe06a3f61222$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$b634fe06a3f61222$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$b634fe06a3f61222$var$isExplicitUrl(original, originalUrl) || !$b634fe06a3f61222$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $b634fe06a3f61222$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $b634fe06a3f61222$var$validMutationMethods = new Set($b634fe06a3f61222$var$validMutationMethodsArr);
var $b634fe06a3f61222$var$validRequestMethodsArr = [
    "GET",
    ...$b634fe06a3f61222$var$validMutationMethodsArr
];
var $b634fe06a3f61222$var$validRequestMethods = new Set($b634fe06a3f61222$var$validRequestMethodsArr);
var $b634fe06a3f61222$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $b634fe06a3f61222$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $b634fe06a3f61222$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $b634fe06a3f61222$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $b634fe06a3f61222$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $b634fe06a3f61222$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $b634fe06a3f61222$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $b634fe06a3f61222$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $b634fe06a3f61222$var$_routes, $b634fe06a3f61222$var$_branches, $b634fe06a3f61222$var$_hmrRoutes, $b634fe06a3f61222$var$_hmrBranches;
var $b634fe06a3f61222$var$DataRoutes = class {
    constructor(routes){
        $b634fe06a3f61222$var$__privateAdd(this, $b634fe06a3f61222$var$_routes);
        $b634fe06a3f61222$var$__privateAdd(this, $b634fe06a3f61222$var$_branches);
        $b634fe06a3f61222$var$__privateAdd(this, $b634fe06a3f61222$var$_hmrRoutes);
        $b634fe06a3f61222$var$__privateAdd(this, $b634fe06a3f61222$var$_hmrBranches);
        $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_routes, routes);
        $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_branches, $b634fe06a3f61222$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_hmrRoutes) ?? $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_hmrBranches) ?? $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_branches);
    }
    get hasHMRRoutes() {
        return $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_routes, routes);
        $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_branches, $b634fe06a3f61222$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_hmrRoutes, routes);
        $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_hmrBranches, $b634fe06a3f61222$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_hmrRoutes)) {
            $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_routes, $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_hmrRoutes));
            $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_branches, $b634fe06a3f61222$var$__privateGet(this, $b634fe06a3f61222$var$_hmrBranches));
            $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_hmrRoutes, void 0);
            $b634fe06a3f61222$var$__privateSet(this, $b634fe06a3f61222$var$_hmrBranches, void 0);
        }
    }
};
$b634fe06a3f61222$var$_routes = new WeakMap();
$b634fe06a3f61222$var$_branches = new WeakMap();
$b634fe06a3f61222$var$_hmrRoutes = new WeakMap();
$b634fe06a3f61222$var$_hmrBranches = new WeakMap();
function $b634fe06a3f61222$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $b634fe06a3f61222$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $b634fe06a3f61222$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$b634fe06a3f61222$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $b634fe06a3f61222$var$DataRoutes($b634fe06a3f61222$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $b634fe06a3f61222$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b634fe06a3f61222$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $b634fe06a3f61222$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b634fe06a3f61222$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$b634fe06a3f61222$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $b634fe06a3f61222$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $b634fe06a3f61222$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $b634fe06a3f61222$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b634fe06a3f61222$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $b634fe06a3f61222$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b634fe06a3f61222$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b634fe06a3f61222$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $b634fe06a3f61222$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b634fe06a3f61222$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b634fe06a3f61222$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $b634fe06a3f61222$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $b634fe06a3f61222$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $b634fe06a3f61222$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $b634fe06a3f61222$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($b634fe06a3f61222$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $b634fe06a3f61222$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $b634fe06a3f61222$export$fe53371bee54353d(opts.mask), $b634fe06a3f61222$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $b634fe06a3f61222$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $b634fe06a3f61222$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $b634fe06a3f61222$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b634fe06a3f61222$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $b634fe06a3f61222$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $b634fe06a3f61222$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $b634fe06a3f61222$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b634fe06a3f61222$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $b634fe06a3f61222$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $b634fe06a3f61222$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $b634fe06a3f61222$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $b634fe06a3f61222$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($b634fe06a3f61222$var$isErrorResult(result) && $b634fe06a3f61222$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $b634fe06a3f61222$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $b634fe06a3f61222$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$b634fe06a3f61222$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $b634fe06a3f61222$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $b634fe06a3f61222$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $b634fe06a3f61222$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $b634fe06a3f61222$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $b634fe06a3f61222$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b634fe06a3f61222$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $b634fe06a3f61222$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($b634fe06a3f61222$var$isErrorResult(result)) {
            let boundaryMatch = $b634fe06a3f61222$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $b634fe06a3f61222$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $b634fe06a3f61222$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $b634fe06a3f61222$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $b634fe06a3f61222$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $b634fe06a3f61222$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $b634fe06a3f61222$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$b634fe06a3f61222$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $b634fe06a3f61222$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $b634fe06a3f61222$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $b634fe06a3f61222$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$b634fe06a3f61222$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $b634fe06a3f61222$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $b634fe06a3f61222$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $b634fe06a3f61222$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $b634fe06a3f61222$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b634fe06a3f61222$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $b634fe06a3f61222$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b634fe06a3f61222$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b634fe06a3f61222$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b634fe06a3f61222$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b634fe06a3f61222$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $b634fe06a3f61222$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $b634fe06a3f61222$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($b634fe06a3f61222$var$isRedirectResult(actionResult) || $b634fe06a3f61222$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b634fe06a3f61222$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($b634fe06a3f61222$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $b634fe06a3f61222$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b634fe06a3f61222$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($b634fe06a3f61222$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b634fe06a3f61222$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $b634fe06a3f61222$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $b634fe06a3f61222$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $b634fe06a3f61222$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $b634fe06a3f61222$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $b634fe06a3f61222$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $b634fe06a3f61222$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $b634fe06a3f61222$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $b634fe06a3f61222$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $b634fe06a3f61222$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $b634fe06a3f61222$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b634fe06a3f61222$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $b634fe06a3f61222$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b634fe06a3f61222$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b634fe06a3f61222$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b634fe06a3f61222$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $b634fe06a3f61222$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $b634fe06a3f61222$var$getDoneFetcher(void 0));
            return;
        }
        if ($b634fe06a3f61222$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $b634fe06a3f61222$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($b634fe06a3f61222$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $b634fe06a3f61222$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $b634fe06a3f61222$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $b634fe06a3f61222$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $b634fe06a3f61222$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $b634fe06a3f61222$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($b634fe06a3f61222$var$isAbsoluteUrl(location)) {
                const url = $b634fe06a3f61222$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b634fe06a3f61222$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b634fe06a3f61222$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($b634fe06a3f61222$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $b634fe06a3f61222$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $b634fe06a3f61222$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $b634fe06a3f61222$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$b634fe06a3f61222$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($b634fe06a3f61222$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $b634fe06a3f61222$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $b634fe06a3f61222$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $b634fe06a3f61222$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $b634fe06a3f61222$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $b634fe06a3f61222$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $b634fe06a3f61222$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $b634fe06a3f61222$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $b634fe06a3f61222$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $b634fe06a3f61222$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $b634fe06a3f61222$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b634fe06a3f61222$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b634fe06a3f61222$export$386d57f03f0b2883;
        $b634fe06a3f61222$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $b634fe06a3f61222$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $b634fe06a3f61222$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $b634fe06a3f61222$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $b634fe06a3f61222$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$b634fe06a3f61222$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $b634fe06a3f61222$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $b634fe06a3f61222$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $b634fe06a3f61222$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $b634fe06a3f61222$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $b634fe06a3f61222$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $b634fe06a3f61222$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($b634fe06a3f61222$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $b634fe06a3f61222$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $b634fe06a3f61222$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $b634fe06a3f61222$export$3336b097a6fbc59a(routes, opts) {
    $b634fe06a3f61222$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $b634fe06a3f61222$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$b634fe06a3f61222$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $b634fe06a3f61222$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $b634fe06a3f61222$var$flattenAndRankRoutes(dataRoutes);
    let matchCost = routeBranches.reduce((total, branch)=>total + branch.routesMeta.length, 0);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $b634fe06a3f61222$var$defaultNormalizePath;
        let method = request.method;
        let location = $b634fe06a3f61222$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $b634fe06a3f61222$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $b634fe06a3f61222$export$b8d3e69d4b3eff04();
        if (!$b634fe06a3f61222$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b634fe06a3f61222$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b634fe06a3f61222$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $b634fe06a3f61222$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b634fe06a3f61222$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $b634fe06a3f61222$export$f5708dca728d7177(requestContext instanceof $b634fe06a3f61222$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $b634fe06a3f61222$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $b634fe06a3f61222$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $b634fe06a3f61222$var$createDataFunctionUrl(request, location),
                    pattern: $b634fe06a3f61222$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($b634fe06a3f61222$export$6e80290866a84dd4(error)) return error;
                    if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $b634fe06a3f61222$export$f2680fa305b734ca(error.status, error.statusText, await $b634fe06a3f61222$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($b634fe06a3f61222$export$e0163cfdf7bc9cfa(error)) error = $b634fe06a3f61222$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $b634fe06a3f61222$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $b634fe06a3f61222$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $b634fe06a3f61222$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $b634fe06a3f61222$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $b634fe06a3f61222$export$f5708dca728d7177($b634fe06a3f61222$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $b634fe06a3f61222$var$defaultNormalizePath;
        let method = request.method;
        let location = $b634fe06a3f61222$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $b634fe06a3f61222$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $b634fe06a3f61222$export$b8d3e69d4b3eff04();
        if (!$b634fe06a3f61222$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b634fe06a3f61222$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b634fe06a3f61222$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b634fe06a3f61222$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b634fe06a3f61222$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $b634fe06a3f61222$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $b634fe06a3f61222$export$f5708dca728d7177(requestContext instanceof $b634fe06a3f61222$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $b634fe06a3f61222$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $b634fe06a3f61222$var$runServerMiddlewarePipeline({
                request: request,
                url: $b634fe06a3f61222$var$createDataFunctionUrl(request, location),
                pattern: $b634fe06a3f61222$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $b634fe06a3f61222$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($b634fe06a3f61222$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($b634fe06a3f61222$var$dataWithResponseInitToResponse(error));
                if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $b634fe06a3f61222$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b634fe06a3f61222$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $b634fe06a3f61222$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $b634fe06a3f61222$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($b634fe06a3f61222$var$isDataStrategyResult(e) && $b634fe06a3f61222$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($b634fe06a3f61222$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b634fe06a3f61222$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $b634fe06a3f61222$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($b634fe06a3f61222$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($b634fe06a3f61222$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($b634fe06a3f61222$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b634fe06a3f61222$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $b634fe06a3f61222$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($b634fe06a3f61222$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b634fe06a3f61222$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $b634fe06a3f61222$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $b634fe06a3f61222$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $b634fe06a3f61222$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $b634fe06a3f61222$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $b634fe06a3f61222$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $b634fe06a3f61222$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $b634fe06a3f61222$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $b634fe06a3f61222$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $b634fe06a3f61222$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $b634fe06a3f61222$var$callDataStrategyImpl(dataStrategy || $b634fe06a3f61222$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($b634fe06a3f61222$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $b634fe06a3f61222$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($b634fe06a3f61222$export$e0163cfdf7bc9cfa(result.result)) throw $b634fe06a3f61222$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $b634fe06a3f61222$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _matchCost: matchCost,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $b634fe06a3f61222$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $b634fe06a3f61222$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $b634fe06a3f61222$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $b634fe06a3f61222$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $b634fe06a3f61222$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $b634fe06a3f61222$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $b634fe06a3f61222$var$resolveTo(to ? to : ".", $b634fe06a3f61222$var$getResolveToMatches(contextualMatches), $b634fe06a3f61222$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $b634fe06a3f61222$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $b634fe06a3f61222$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $b634fe06a3f61222$export$fe53371bee54353d(path);
}
function $b634fe06a3f61222$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$b634fe06a3f61222$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b634fe06a3f61222$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b634fe06a3f61222$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b634fe06a3f61222$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $b634fe06a3f61222$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$b634fe06a3f61222$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$b634fe06a3f61222$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b634fe06a3f61222$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b634fe06a3f61222$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b634fe06a3f61222$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b634fe06a3f61222$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b634fe06a3f61222$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($b634fe06a3f61222$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $b634fe06a3f61222$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $b634fe06a3f61222$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $b634fe06a3f61222$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $b634fe06a3f61222$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $b634fe06a3f61222$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $b634fe06a3f61222$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $b634fe06a3f61222$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$b634fe06a3f61222$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $b634fe06a3f61222$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($b634fe06a3f61222$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $b634fe06a3f61222$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($b634fe06a3f61222$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $b634fe06a3f61222$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $b634fe06a3f61222$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $b634fe06a3f61222$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $b634fe06a3f61222$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $b634fe06a3f61222$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($b634fe06a3f61222$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $b634fe06a3f61222$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $b634fe06a3f61222$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$b634fe06a3f61222$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $b634fe06a3f61222$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $b634fe06a3f61222$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b634fe06a3f61222$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $b634fe06a3f61222$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $b634fe06a3f61222$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$b634fe06a3f61222$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $b634fe06a3f61222$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $b634fe06a3f61222$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $b634fe06a3f61222$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$b634fe06a3f61222$var$isSameRoute(aChild, bChild))) ?? false;
}
var $b634fe06a3f61222$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $b634fe06a3f61222$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $b634fe06a3f61222$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $b634fe06a3f61222$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $b634fe06a3f61222$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $b634fe06a3f61222$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $b634fe06a3f61222$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $b634fe06a3f61222$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $b634fe06a3f61222$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $b634fe06a3f61222$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $b634fe06a3f61222$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $b634fe06a3f61222$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $b634fe06a3f61222$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $b634fe06a3f61222$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $b634fe06a3f61222$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $b634fe06a3f61222$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $b634fe06a3f61222$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $b634fe06a3f61222$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $b634fe06a3f61222$var$isNonNullable(value) {
    return value !== void 0;
}
function $b634fe06a3f61222$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $b634fe06a3f61222$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($b634fe06a3f61222$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $b634fe06a3f61222$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $b634fe06a3f61222$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $b634fe06a3f61222$var$defaultDataStrategy(args);
    return $b634fe06a3f61222$var$runClientMiddlewarePipeline(args, ()=>$b634fe06a3f61222$var$defaultDataStrategy(args));
}
function $b634fe06a3f61222$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $b634fe06a3f61222$var$runMiddlewarePipeline(args, handler, processResult, $b634fe06a3f61222$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $b634fe06a3f61222$export$e0163cfdf7bc9cfa(result) ? $b634fe06a3f61222$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $b634fe06a3f61222$var$runClientMiddlewarePipeline(args, handler) {
    return $b634fe06a3f61222$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($b634fe06a3f61222$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $b634fe06a3f61222$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $b634fe06a3f61222$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $b634fe06a3f61222$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $b634fe06a3f61222$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $b634fe06a3f61222$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $b634fe06a3f61222$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $b634fe06a3f61222$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $b634fe06a3f61222$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $b634fe06a3f61222$var$loadLazyRoute(match.route, $b634fe06a3f61222$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $b634fe06a3f61222$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $b634fe06a3f61222$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $b634fe06a3f61222$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $b634fe06a3f61222$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $b634fe06a3f61222$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$b634fe06a3f61222$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($b634fe06a3f61222$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $b634fe06a3f61222$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $b634fe06a3f61222$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $b634fe06a3f61222$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $b634fe06a3f61222$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $b634fe06a3f61222$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $b634fe06a3f61222$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $b634fe06a3f61222$var$createDataFunctionUrl(request, path),
        pattern: $b634fe06a3f61222$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $b634fe06a3f61222$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $b634fe06a3f61222$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $b634fe06a3f61222$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $b634fe06a3f61222$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b634fe06a3f61222$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b634fe06a3f61222$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $b634fe06a3f61222$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $b634fe06a3f61222$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $b634fe06a3f61222$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $b634fe06a3f61222$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($b634fe06a3f61222$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $b634fe06a3f61222$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $b634fe06a3f61222$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $b634fe06a3f61222$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($b634fe06a3f61222$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $b634fe06a3f61222$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $b634fe06a3f61222$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$b634fe06a3f61222$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $b634fe06a3f61222$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $b634fe06a3f61222$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $b634fe06a3f61222$export$961a3ef7a4da3a39(location) {
    try {
        return $b634fe06a3f61222$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $b634fe06a3f61222$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($b634fe06a3f61222$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $b634fe06a3f61222$export$825a82322d91916e.test(normalizedLocation) ? new URL($b634fe06a3f61222$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($b634fe06a3f61222$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $b634fe06a3f61222$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $b634fe06a3f61222$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($b634fe06a3f61222$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $b634fe06a3f61222$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b634fe06a3f61222$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b634fe06a3f61222$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $b634fe06a3f61222$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b634fe06a3f61222$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $b634fe06a3f61222$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b634fe06a3f61222$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b634fe06a3f61222$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $b634fe06a3f61222$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $b634fe06a3f61222$export$f5708dca728d7177(!$b634fe06a3f61222$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b634fe06a3f61222$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $b634fe06a3f61222$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $b634fe06a3f61222$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $b634fe06a3f61222$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b634fe06a3f61222$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $b634fe06a3f61222$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $b634fe06a3f61222$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($b634fe06a3f61222$var$isErrorResult(result)) {
            let boundaryMatch = $b634fe06a3f61222$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($b634fe06a3f61222$var$isRedirectResult(result)) $b634fe06a3f61222$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $b634fe06a3f61222$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b634fe06a3f61222$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $b634fe06a3f61222$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $b634fe06a3f61222$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $b634fe06a3f61222$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $b634fe06a3f61222$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b634fe06a3f61222$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b634fe06a3f61222$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $b634fe06a3f61222$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $b634fe06a3f61222$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($b634fe06a3f61222$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $b634fe06a3f61222$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(path) : path;
    return $b634fe06a3f61222$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $b634fe06a3f61222$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $b634fe06a3f61222$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $b634fe06a3f61222$var$dataWithResponseInitToErrorResponse(data2) {
    return new $b634fe06a3f61222$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $b634fe06a3f61222$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $b634fe06a3f61222$var$isDataStrategyResult(value));
}
function $b634fe06a3f61222$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $b634fe06a3f61222$var$isRedirectDataStrategyResult(result) {
    return $b634fe06a3f61222$export$3f1eb41d9a6a6a27(result.result) && $b634fe06a3f61222$var$redirectStatusCodes.has(result.result.status);
}
function $b634fe06a3f61222$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $b634fe06a3f61222$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $b634fe06a3f61222$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $b634fe06a3f61222$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b634fe06a3f61222$export$794b2760043cf8cd(statusCode) {
    return $b634fe06a3f61222$var$redirectStatusCodes.has(statusCode);
}
function $b634fe06a3f61222$export$6e80290866a84dd4(result) {
    return $b634fe06a3f61222$export$3f1eb41d9a6a6a27(result) && $b634fe06a3f61222$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $b634fe06a3f61222$var$isValidMethod(method) {
    return $b634fe06a3f61222$var$validRequestMethods.has(method.toUpperCase());
}
function $b634fe06a3f61222$export$cbae47800eb95bc3(method) {
    return $b634fe06a3f61222$var$validMutationMethods.has(method.toUpperCase());
}
function $b634fe06a3f61222$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b634fe06a3f61222$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b634fe06a3f61222$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $b634fe06a3f61222$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b634fe06a3f61222$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $b634fe06a3f61222$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $b634fe06a3f61222$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b634fe06a3f61222$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $b634fe06a3f61222$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $b634fe06a3f61222$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $b634fe06a3f61222$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b634fe06a3f61222$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $b634fe06a3f61222$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b634fe06a3f61222$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b634fe06a3f61222$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $b634fe06a3f61222$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $b634fe06a3f61222$export$2eeee58951ff3c1c = $itHdT.createContext(null);
$b634fe06a3f61222$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $b634fe06a3f61222$export$315e3ffb01f217 = $itHdT.createContext(null);
$b634fe06a3f61222$export$315e3ffb01f217.displayName = "DataRouterState";
var $b634fe06a3f61222$export$717f757c655223f1 = $itHdT.createContext(false);
function $b634fe06a3f61222$var$useIsRSCRouterContext() {
    return $itHdT.useContext($b634fe06a3f61222$export$717f757c655223f1);
}
var $b634fe06a3f61222$export$3681f408decb40d1 = $itHdT.createContext({
    isTransitioning: false
});
$b634fe06a3f61222$export$3681f408decb40d1.displayName = "ViewTransition";
var $b634fe06a3f61222$export$cb3f1df1bef00a39 = $itHdT.createContext(/* @__PURE__ */ new Map());
$b634fe06a3f61222$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $b634fe06a3f61222$var$AwaitContext = $itHdT.createContext(null);
$b634fe06a3f61222$var$AwaitContext.displayName = "Await";
var $b634fe06a3f61222$export$2666c20e15407622 = (props)=>$itHdT.createElement($b634fe06a3f61222$var$AwaitContext.Provider, props);
var $b634fe06a3f61222$export$3044ab7fdabeaee6 = $itHdT.createContext(null);
$b634fe06a3f61222$export$3044ab7fdabeaee6.displayName = "Navigation";
var $b634fe06a3f61222$export$e6a44b110a0c44d3 = $itHdT.createContext(null);
$b634fe06a3f61222$export$e6a44b110a0c44d3.displayName = "Location";
var $b634fe06a3f61222$export$aac280ed165a4397 = $itHdT.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$b634fe06a3f61222$export$aac280ed165a4397.displayName = "Route";
var $b634fe06a3f61222$var$RouteErrorContext = $itHdT.createContext(null);
$b634fe06a3f61222$var$RouteErrorContext.displayName = "RouteError";
var $b634fe06a3f61222$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $b634fe06a3f61222$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $b634fe06a3f61222$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $b634fe06a3f61222$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $b634fe06a3f61222$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$b634fe06a3f61222$var$ERROR_DIGEST_BASE}:${$b634fe06a3f61222$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $b634fe06a3f61222$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$b634fe06a3f61222$var$ERROR_DIGEST_BASE}:${$b634fe06a3f61222$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $b634fe06a3f61222$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $b634fe06a3f61222$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $b634fe06a3f61222$export$f5708dca728d7177($b634fe06a3f61222$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $b634fe06a3f61222$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $b634fe06a3f61222$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $b634fe06a3f61222$export$9c954a9d03d32f4a() {
    return $itHdT.useContext($b634fe06a3f61222$export$e6a44b110a0c44d3) != null;
}
function $b634fe06a3f61222$export$45d76561a5302f2b() {
    $b634fe06a3f61222$export$f5708dca728d7177($b634fe06a3f61222$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $itHdT.useContext($b634fe06a3f61222$export$e6a44b110a0c44d3).location;
}
function $b634fe06a3f61222$export$1b3f31771c5d07c() {
    return $itHdT.useContext($b634fe06a3f61222$export$e6a44b110a0c44d3).navigationType;
}
function $b634fe06a3f61222$export$6c330e8992e8a295(pattern) {
    $b634fe06a3f61222$export$f5708dca728d7177($b634fe06a3f61222$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $b634fe06a3f61222$export$45d76561a5302f2b();
    return $itHdT.useMemo(()=>$b634fe06a3f61222$export$81336c211d5ff295(pattern, $b634fe06a3f61222$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $b634fe06a3f61222$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $b634fe06a3f61222$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6).static;
    if (!isStatic) $itHdT.useLayoutEffect(cb);
}
function $b634fe06a3f61222$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    return isDataRoute ? $b634fe06a3f61222$var$useNavigateStable() : $b634fe06a3f61222$var$useNavigateUnstable();
}
function $b634fe06a3f61222$var$useNavigateUnstable() {
    $b634fe06a3f61222$export$f5708dca728d7177($b634fe06a3f61222$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $itHdT.useContext($b634fe06a3f61222$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let { matches: matches } = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    let { pathname: locationPathname } = $b634fe06a3f61222$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($b634fe06a3f61222$var$getResolveToMatches(matches));
    let activeRef = $itHdT.useRef(false);
    $b634fe06a3f61222$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $itHdT.useCallback((to, options = {})=>{
        $b634fe06a3f61222$var$warning(activeRef.current, $b634fe06a3f61222$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $b634fe06a3f61222$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b634fe06a3f61222$var$joinPaths([
            basename,
            path.pathname
        ]);
        $b634fe06a3f61222$export$6c8e41f66e7aa990(typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to), navigator.createHref(path), $b634fe06a3f61222$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $b634fe06a3f61222$var$OutletContext = $itHdT.createContext(null);
function $b634fe06a3f61222$export$4138103a3ae699cc() {
    return $itHdT.useContext($b634fe06a3f61222$var$OutletContext);
}
function $b634fe06a3f61222$export$a3be3530d8e40d0b(context) {
    let outlet = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397).outlet;
    return $itHdT.useMemo(()=>outlet && /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $b634fe06a3f61222$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $b634fe06a3f61222$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    let { pathname: locationPathname } = $b634fe06a3f61222$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($b634fe06a3f61222$var$getResolveToMatches(matches));
    return $itHdT.useMemo(()=>$b634fe06a3f61222$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $b634fe06a3f61222$export$5d3fca4a98652595(routes, locationArg) {
    return $b634fe06a3f61222$var$useRoutesImpl(routes, locationArg);
}
function $b634fe06a3f61222$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $b634fe06a3f61222$export$f5708dca728d7177($b634fe06a3f61222$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($b634fe06a3f61222$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $b634fe06a3f61222$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $b634fe06a3f61222$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $b634fe06a3f61222$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $b634fe06a3f61222$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $b634fe06a3f61222$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($b634fe06a3f61222$export$945fecf35a8ef089) {
        $b634fe06a3f61222$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $b634fe06a3f61222$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $b634fe06a3f61222$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $b634fe06a3f61222$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $b634fe06a3f61222$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b634fe06a3f61222$var$DefaultErrorComponent() {
    let error = $b634fe06a3f61222$export$ed527bf60f6e05f2();
    let message = $b634fe06a3f61222$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($b634fe06a3f61222$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, /* @__PURE__ */ $itHdT.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $itHdT.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $itHdT.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $itHdT.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, /* @__PURE__ */ $itHdT.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $itHdT.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $itHdT.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $b634fe06a3f61222$var$defaultErrorElement = /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$DefaultErrorComponent, null);
var $b634fe06a3f61222$var$RenderErrorBoundary = class extends $itHdT.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $b634fe06a3f61222$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$b634fe06a3f61222$var$RenderErrorBoundary.contextType = $b634fe06a3f61222$export$717f757c655223f1;
var $b634fe06a3f61222$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $b634fe06a3f61222$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $b634fe06a3f61222$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $b634fe06a3f61222$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $b634fe06a3f61222$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $b634fe06a3f61222$export$6c8e41f66e7aa990(redirect2.location, target, $b634fe06a3f61222$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($b634fe06a3f61222$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($b634fe06a3f61222$var$isBrowser && !$b634fe06a3f61222$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $b634fe06a3f61222$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $itHdT.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $b634fe06a3f61222$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $itHdT.useContext($b634fe06a3f61222$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $b634fe06a3f61222$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $b634fe06a3f61222$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $b634fe06a3f61222$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $b634fe06a3f61222$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $b634fe06a3f61222$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $itHdT.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $b634fe06a3f61222$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $b634fe06a3f61222$var$useDataRouterContext(hookName) {
    let ctx = $itHdT.useContext($b634fe06a3f61222$export$2eeee58951ff3c1c);
    $b634fe06a3f61222$export$f5708dca728d7177(ctx, $b634fe06a3f61222$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $b634fe06a3f61222$var$useDataRouterState(hookName) {
    let state = $itHdT.useContext($b634fe06a3f61222$export$315e3ffb01f217);
    $b634fe06a3f61222$export$f5708dca728d7177(state, $b634fe06a3f61222$var$getDataRouterConsoleError(hookName));
    return state;
}
function $b634fe06a3f61222$var$useRouteContext(hookName) {
    let route = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    $b634fe06a3f61222$export$f5708dca728d7177(route, $b634fe06a3f61222$var$getDataRouterConsoleError(hookName));
    return route;
}
function $b634fe06a3f61222$var$useCurrentRouteId(hookName) {
    let route = $b634fe06a3f61222$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $b634fe06a3f61222$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $b634fe06a3f61222$var$useRouteId() {
    return $b634fe06a3f61222$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $b634fe06a3f61222$export$d0fd4b7106de2769() {
    let state = $b634fe06a3f61222$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $itHdT.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $b634fe06a3f61222$export$600dc272ed516c15() {
    let dataRouterContext = $b634fe06a3f61222$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $b634fe06a3f61222$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $itHdT.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $itHdT.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $b634fe06a3f61222$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b634fe06a3f61222$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $itHdT.useMemo(()=>matches.map((m)=>$b634fe06a3f61222$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $b634fe06a3f61222$export$1448a5050d252c4d() {
    let state = $b634fe06a3f61222$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $b634fe06a3f61222$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $b634fe06a3f61222$export$fd5d37484eab868d(routeId) {
    let state = $b634fe06a3f61222$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $b634fe06a3f61222$export$fdc00f3f26066d5e() {
    let state = $b634fe06a3f61222$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $b634fe06a3f61222$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $b634fe06a3f61222$export$ed527bf60f6e05f2() {
    let error = $itHdT.useContext($b634fe06a3f61222$var$RouteErrorContext);
    let state = $b634fe06a3f61222$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $b634fe06a3f61222$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $b634fe06a3f61222$export$78a72ddb39bdd145() {
    let value = $itHdT.useContext($b634fe06a3f61222$var$AwaitContext);
    return value?._data;
}
function $b634fe06a3f61222$export$17f53340677d5831() {
    let value = $itHdT.useContext($b634fe06a3f61222$var$AwaitContext);
    return value?._error;
}
var $b634fe06a3f61222$var$blockerId = 0;
function $b634fe06a3f61222$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $b634fe06a3f61222$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $b634fe06a3f61222$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $itHdT.useState("");
    let blockerFunction = $itHdT.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $b634fe06a3f61222$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $b634fe06a3f61222$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $itHdT.useEffect(()=>{
        let key = String(++$b634fe06a3f61222$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $itHdT.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $b634fe06a3f61222$export$386d57f03f0b2883;
}
function $b634fe06a3f61222$var$useNavigateStable() {
    let { router: router } = $b634fe06a3f61222$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $b634fe06a3f61222$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $itHdT.useRef(false);
    $b634fe06a3f61222$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $itHdT.useCallback(async (to, options = {})=>{
        $b634fe06a3f61222$var$warning(activeRef.current, $b634fe06a3f61222$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $b634fe06a3f61222$var$alreadyWarned = {};
function $b634fe06a3f61222$var$warningOnce(key, cond, message) {
    if (!cond && !$b634fe06a3f61222$var$alreadyWarned[key]) {
        $b634fe06a3f61222$var$alreadyWarned[key] = true;
        $b634fe06a3f61222$var$warning(false, message);
    }
}
function $b634fe06a3f61222$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $b634fe06a3f61222$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $b634fe06a3f61222$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $b634fe06a3f61222$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $b634fe06a3f61222$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $b634fe06a3f61222$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $itHdT.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$b634fe06a3f61222$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $itHdT.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$b634fe06a3f61222$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $itHdT.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $b634fe06a3f61222$var$alreadyWarned2 = {};
function $b634fe06a3f61222$export$5b28268982f175ba(condition, message) {
    if (!condition && !$b634fe06a3f61222$var$alreadyWarned2[message]) {
        $b634fe06a3f61222$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $b634fe06a3f61222$var$USE_OPTIMISTIC = "useOptimistic";
var $b634fe06a3f61222$var$useOptimisticImpl = $itHdT[$b634fe06a3f61222$var$USE_OPTIMISTIC];
var $b634fe06a3f61222$var$stableUseOptimisticSetter = ()=>void 0;
function $b634fe06a3f61222$var$useOptimisticSafe(val) {
    if ($b634fe06a3f61222$var$useOptimisticImpl) return $b634fe06a3f61222$var$useOptimisticImpl(val);
    else return [
        val,
        $b634fe06a3f61222$var$stableUseOptimisticSetter
    ];
}
function $b634fe06a3f61222$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($b634fe06a3f61222$export$945fecf35a8ef089) {
            if (route.element) $b634fe06a3f61222$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $itHdT.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($b634fe06a3f61222$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $b634fe06a3f61222$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $itHdT.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($b634fe06a3f61222$export$945fecf35a8ef089) {
            if (route.errorElement) $b634fe06a3f61222$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $itHdT.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $b634fe06a3f61222$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $b634fe06a3f61222$export$f30f7e456d254e83(routes, opts) {
    return $b634fe06a3f61222$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $b634fe06a3f61222$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $b634fe06a3f61222$export$e2fd2c03906469db,
        mapRouteProperties: $b634fe06a3f61222$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $b634fe06a3f61222$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $b634fe06a3f61222$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $b634fe06a3f61222$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $itHdT.useState(router.state);
    let [state, setOptimisticState] = $b634fe06a3f61222$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $itHdT.useState();
    let [vtContext, setVtContext] = $itHdT.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $itHdT.useState();
    let [transition, setTransition] = $itHdT.useState();
    let [interruption, setInterruption] = $itHdT.useState();
    let fetcherData = $itHdT.useRef(/* @__PURE__ */ new Map());
    let setState = $itHdT.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $b634fe06a3f61222$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $b634fe06a3f61222$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $b634fe06a3f61222$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $itHdT.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$b634fe06a3f61222$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $itHdT.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $itHdT.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $b634fe06a3f61222$var$Deferred());
    }, [
        vtContext
    ]);
    $itHdT.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $itHdT.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$b634fe06a3f61222$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $itHdT.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $itHdT.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $itHdT.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $itHdT.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $b634fe06a3f61222$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $b634fe06a3f61222$var$MemoizedDataRoutes = $itHdT.memo($b634fe06a3f61222$var$DataRoutes2);
function $b634fe06a3f61222$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $b634fe06a3f61222$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $b634fe06a3f61222$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $itHdT.useRef();
    if (historyRef.current == null) historyRef.current = $b634fe06a3f61222$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $itHdT.useState({
        action: history.action,
        location: history.location
    });
    let setState = $itHdT.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $itHdT.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $itHdT.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $b634fe06a3f61222$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $b634fe06a3f61222$export$f5708dca728d7177($b634fe06a3f61222$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    $b634fe06a3f61222$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    let { pathname: locationPathname } = $b634fe06a3f61222$export$45d76561a5302f2b();
    let navigate = $b634fe06a3f61222$export$9770f232ac06a008();
    let path = $b634fe06a3f61222$var$resolveTo(to, $b634fe06a3f61222$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $b634fe06a3f61222$export$6c8e41f66e7aa990(typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to), navigator.createHref(path), $b634fe06a3f61222$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $itHdT.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $b634fe06a3f61222$export$910ae8079b2c2852(props) {
    return $b634fe06a3f61222$export$a3be3530d8e40d0b(props.context);
}
function $b634fe06a3f61222$export$e7b0ac011bb776c6(props) {
    $b634fe06a3f61222$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $b634fe06a3f61222$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $b634fe06a3f61222$export$f5708dca728d7177(!$b634fe06a3f61222$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $itHdT.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $b634fe06a3f61222$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $itHdT.useMemo(()=>{
        let trailingPathname = $b634fe06a3f61222$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $b634fe06a3f61222$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $b634fe06a3f61222$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $b634fe06a3f61222$export$5d3fca4a98652595($b634fe06a3f61222$export$16da398f5434bdec(children), location);
}
function $b634fe06a3f61222$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $itHdT.useContext($b634fe06a3f61222$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $itHdT.useContext($b634fe06a3f61222$export$315e3ffb01f217);
    let onError = $itHdT.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $b634fe06a3f61222$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$ResolveAwait, null, children));
}
var $b634fe06a3f61222$var$AwaitErrorBoundary = class extends $itHdT.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $b634fe06a3f61222$var$ResolveAwait({ children: children }) {
    let data2 = $b634fe06a3f61222$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, toRender);
}
function $b634fe06a3f61222$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $itHdT.Children.forEach(children, (element, index)=>{
        if (!$itHdT.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $itHdT.Fragment) {
            routes.push.apply(routes, $b634fe06a3f61222$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $b634fe06a3f61222$export$f5708dca728d7177(element.type === $b634fe06a3f61222$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $b634fe06a3f61222$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b634fe06a3f61222$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $b634fe06a3f61222$export$9b5b6d122dea0c88 = $b634fe06a3f61222$export$16da398f5434bdec;
function $b634fe06a3f61222$export$daf73786167a7f72(matches) {
    return $b634fe06a3f61222$var$_renderMatches(matches);
}
function $b634fe06a3f61222$var$useRouteComponentProps() {
    return {
        params: $b634fe06a3f61222$export$99eaa27ddbbb95ef(),
        loaderData: $b634fe06a3f61222$export$1448a5050d252c4d(),
        actionData: $b634fe06a3f61222$export$fdc00f3f26066d5e(),
        matches: $b634fe06a3f61222$export$2378eb7f5ff86053()
    };
}
function $b634fe06a3f61222$export$6c4f3826290c37af({ children: children }) {
    const props = $b634fe06a3f61222$var$useRouteComponentProps();
    return $itHdT.cloneElement(children, props);
}
function $b634fe06a3f61222$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $b634fe06a3f61222$var$useRouteComponentProps();
        return $itHdT.createElement(Component4, props);
    };
}
function $b634fe06a3f61222$var$useHydrateFallbackProps() {
    return {
        params: $b634fe06a3f61222$export$99eaa27ddbbb95ef(),
        loaderData: $b634fe06a3f61222$export$1448a5050d252c4d(),
        actionData: $b634fe06a3f61222$export$fdc00f3f26066d5e()
    };
}
function $b634fe06a3f61222$export$f8cff34f39c1932a({ children: children }) {
    const props = $b634fe06a3f61222$var$useHydrateFallbackProps();
    return $itHdT.cloneElement(children, props);
}
function $b634fe06a3f61222$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $b634fe06a3f61222$var$useHydrateFallbackProps();
        return $itHdT.createElement(HydrateFallback, props);
    };
}
function $b634fe06a3f61222$var$useErrorBoundaryProps() {
    return {
        params: $b634fe06a3f61222$export$99eaa27ddbbb95ef(),
        loaderData: $b634fe06a3f61222$export$1448a5050d252c4d(),
        actionData: $b634fe06a3f61222$export$fdc00f3f26066d5e(),
        error: $b634fe06a3f61222$export$ed527bf60f6e05f2()
    };
}
function $b634fe06a3f61222$export$e5afde5c4b6d747b({ children: children }) {
    const props = $b634fe06a3f61222$var$useErrorBoundaryProps();
    return $itHdT.cloneElement(children, props);
}
function $b634fe06a3f61222$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $b634fe06a3f61222$var$useErrorBoundaryProps();
        return $itHdT.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $b634fe06a3f61222$var$defaultMethod = "get";
var $b634fe06a3f61222$var$defaultEncType = "application/x-www-form-urlencoded";
function $b634fe06a3f61222$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $b634fe06a3f61222$var$isButtonElement(object) {
    return $b634fe06a3f61222$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b634fe06a3f61222$var$isFormElement(object) {
    return $b634fe06a3f61222$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b634fe06a3f61222$var$isInputElement(object) {
    return $b634fe06a3f61222$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b634fe06a3f61222$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b634fe06a3f61222$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b634fe06a3f61222$var$isModifiedEvent(event);
}
function $b634fe06a3f61222$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b634fe06a3f61222$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b634fe06a3f61222$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $b634fe06a3f61222$var$_formDataSupportsSubmitter = null;
function $b634fe06a3f61222$var$isFormDataSubmitterSupported() {
    if ($b634fe06a3f61222$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b634fe06a3f61222$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b634fe06a3f61222$var$_formDataSupportsSubmitter = true;
    }
    return $b634fe06a3f61222$var$_formDataSupportsSubmitter;
}
var $b634fe06a3f61222$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b634fe06a3f61222$var$getFormEncType(encType) {
    if (encType != null && !$b634fe06a3f61222$var$supportedFormEncTypes.has(encType)) {
        $b634fe06a3f61222$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$b634fe06a3f61222$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $b634fe06a3f61222$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b634fe06a3f61222$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $b634fe06a3f61222$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $b634fe06a3f61222$var$defaultMethod;
        encType = $b634fe06a3f61222$var$getFormEncType(target.getAttribute("enctype")) || $b634fe06a3f61222$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b634fe06a3f61222$var$isButtonElement(target) || $b634fe06a3f61222$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $b634fe06a3f61222$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b634fe06a3f61222$var$defaultMethod;
        encType = $b634fe06a3f61222$var$getFormEncType(target.getAttribute("formenctype")) || $b634fe06a3f61222$var$getFormEncType(form.getAttribute("enctype")) || $b634fe06a3f61222$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$b634fe06a3f61222$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b634fe06a3f61222$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $b634fe06a3f61222$var$defaultMethod;
        action = null;
        encType = $b634fe06a3f61222$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $b634fe06a3f61222$var$HOLE = -1;
var $b634fe06a3f61222$var$NAN = -2;
var $b634fe06a3f61222$var$NEGATIVE_INFINITY = -3;
var $b634fe06a3f61222$var$NEGATIVE_ZERO = -4;
var $b634fe06a3f61222$var$NULL = -5;
var $b634fe06a3f61222$var$POSITIVE_INFINITY = -6;
var $b634fe06a3f61222$var$UNDEFINED = -7;
var $b634fe06a3f61222$var$TYPE_BIGINT = "B";
var $b634fe06a3f61222$var$TYPE_DATE = "D";
var $b634fe06a3f61222$var$TYPE_ERROR = "E";
var $b634fe06a3f61222$var$TYPE_MAP = "M";
var $b634fe06a3f61222$var$TYPE_NULL_OBJECT = "N";
var $b634fe06a3f61222$var$TYPE_PROMISE = "P";
var $b634fe06a3f61222$var$TYPE_REGEXP = "R";
var $b634fe06a3f61222$var$TYPE_SET = "S";
var $b634fe06a3f61222$var$TYPE_SYMBOL = "Y";
var $b634fe06a3f61222$var$TYPE_URL = "U";
var $b634fe06a3f61222$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $b634fe06a3f61222$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $b634fe06a3f61222$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $b634fe06a3f61222$var$TIME_LIMIT_MS = 1;
var $b634fe06a3f61222$var$getNow = ()=>Date.now();
var $b634fe06a3f61222$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $b634fe06a3f61222$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $b634fe06a3f61222$var$UNDEFINED;
    if (input === null) return $b634fe06a3f61222$var$NULL;
    if (Number.isNaN(input)) return $b634fe06a3f61222$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $b634fe06a3f61222$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $b634fe06a3f61222$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $b634fe06a3f61222$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $b634fe06a3f61222$var$stringify.call(this, stack);
    return index;
}
async function $b634fe06a3f61222$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $b634fe06a3f61222$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $b634fe06a3f61222$var$UNDEFINED;
        if (value === null) return $b634fe06a3f61222$var$NULL;
        if (Number.isNaN(value)) return $b634fe06a3f61222$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $b634fe06a3f61222$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $b634fe06a3f61222$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $b634fe06a3f61222$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $b634fe06a3f61222$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $b634fe06a3f61222$var$TIME_LIMIT_MS) {
            await $b634fe06a3f61222$var$yieldToMain();
            lastYieldTime = $b634fe06a3f61222$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$b634fe06a3f61222$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$b634fe06a3f61222$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$b634fe06a3f61222$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $b634fe06a3f61222$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$b634fe06a3f61222$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$b634fe06a3f61222$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$b634fe06a3f61222$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$b634fe06a3f61222$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$b634fe06a3f61222$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$b634fe06a3f61222$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$b634fe06a3f61222$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$b634fe06a3f61222$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$b634fe06a3f61222$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$b634fe06a3f61222$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($b634fe06a3f61222$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $b634fe06a3f61222$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $b634fe06a3f61222$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $b634fe06a3f61222$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $b634fe06a3f61222$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $b634fe06a3f61222$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $b634fe06a3f61222$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $b634fe06a3f61222$var$hydrate.call(this, startIndex);
}
function $b634fe06a3f61222$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $b634fe06a3f61222$var$UNDEFINED:
                set(void 0);
                continue;
            case $b634fe06a3f61222$var$NULL:
                set(null);
                continue;
            case $b634fe06a3f61222$var$NAN:
                set(NaN);
                continue;
            case $b634fe06a3f61222$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $b634fe06a3f61222$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $b634fe06a3f61222$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        $b634fe06a3f61222$var$validateIndex(index2, values.length);
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $b634fe06a3f61222$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $b634fe06a3f61222$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $b634fe06a3f61222$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $b634fe06a3f61222$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $b634fe06a3f61222$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $b634fe06a3f61222$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $b634fe06a3f61222$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $b634fe06a3f61222$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $b634fe06a3f61222$var$TYPE_PROMISE:
                        $b634fe06a3f61222$var$validateIndex(b, values.length);
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $b634fe06a3f61222$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $b634fe06a3f61222$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $b634fe06a3f61222$var$globalObj && $b634fe06a3f61222$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $b634fe06a3f61222$var$globalObj && typeof $b634fe06a3f61222$var$globalObj[errorType] === "function" ? new $b634fe06a3f61222$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $b634fe06a3f61222$var$TYPE_PREVIOUS_RESOLVED:
                        $b634fe06a3f61222$var$validateIndex(b, values.length);
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $b634fe06a3f61222$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    Object.defineProperty(object, r[0], {
                        value: r[1],
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
function $b634fe06a3f61222$var$validateIndex(index, length) {
    if (!Number.isSafeInteger(index) || index < 0 || index >= length) throw new SyntaxError();
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $b634fe06a3f61222$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $b634fe06a3f61222$var$Deferred2();
    const reader = readable.pipeThrough($b634fe06a3f61222$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $b634fe06a3f61222$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $b634fe06a3f61222$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $b634fe06a3f61222$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $b634fe06a3f61222$var$unflatten.call(this, line)
    };
}
async function $b634fe06a3f61222$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $b634fe06a3f61222$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $b634fe06a3f61222$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $b634fe06a3f61222$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $b634fe06a3f61222$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $b634fe06a3f61222$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $b634fe06a3f61222$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $b634fe06a3f61222$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$b634fe06a3f61222$var$TYPE_PROMISE}${deferredId}:[["${$b634fe06a3f61222$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$b634fe06a3f61222$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$b634fe06a3f61222$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $b634fe06a3f61222$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$b634fe06a3f61222$var$TYPE_ERROR}${deferredId}:[["${$b634fe06a3f61222$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$b634fe06a3f61222$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$b634fe06a3f61222$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $b634fe06a3f61222$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $b634fe06a3f61222$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $b634fe06a3f61222$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $b634fe06a3f61222$export$4cf11838cdc2a8a8(html) {
    return html.replace($b634fe06a3f61222$var$ESCAPE_REGEX, (match)=>$b634fe06a3f61222$var$ESCAPE_LOOKUP[match]);
}
function $b634fe06a3f61222$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $b634fe06a3f61222$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $b634fe06a3f61222$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $b634fe06a3f61222$var$SingleFetchNoResultError = class extends Error {
};
var $b634fe06a3f61222$export$ae9272e641ead836 = 202;
var $b634fe06a3f61222$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $b634fe06a3f61222$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $itHdT.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$b634fe06a3f61222$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, scriptTag, /* @__PURE__ */ $itHdT.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, scriptTag, /* @__PURE__ */ $itHdT.createElement($itHdT.Suspense, null, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $b634fe06a3f61222$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $b634fe06a3f61222$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $b634fe06a3f61222$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $b634fe06a3f61222$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $b634fe06a3f61222$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $b634fe06a3f61222$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $b634fe06a3f61222$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $b634fe06a3f61222$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $b634fe06a3f61222$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $b634fe06a3f61222$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $b634fe06a3f61222$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $b634fe06a3f61222$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($b634fe06a3f61222$export$3f1eb41d9a6a6a27(result.result) || $b634fe06a3f61222$export$972111febbeef05b(result.result) || $b634fe06a3f61222$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $b634fe06a3f61222$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $b634fe06a3f61222$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $b634fe06a3f61222$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $b634fe06a3f61222$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$b634fe06a3f61222$var$createDeferred2());
    let singleFetchDfd = $b634fe06a3f61222$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $b634fe06a3f61222$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $b634fe06a3f61222$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $b634fe06a3f61222$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $b634fe06a3f61222$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $b634fe06a3f61222$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $b634fe06a3f61222$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $b634fe06a3f61222$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $b634fe06a3f61222$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $b634fe06a3f61222$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $b634fe06a3f61222$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $b634fe06a3f61222$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$b634fe06a3f61222$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$b634fe06a3f61222$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $b634fe06a3f61222$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $b634fe06a3f61222$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $b634fe06a3f61222$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $b634fe06a3f61222$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $b634fe06a3f61222$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $b634fe06a3f61222$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($b634fe06a3f61222$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $b634fe06a3f61222$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $b634fe06a3f61222$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($b634fe06a3f61222$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$b634fe06a3f61222$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $b634fe06a3f61222$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $b634fe06a3f61222$export$4023ad4ecd4126a2(body, global) {
    return $b634fe06a3f61222$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $b634fe06a3f61222$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $b634fe06a3f61222$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$b634fe06a3f61222$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $b634fe06a3f61222$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $b634fe06a3f61222$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $b634fe06a3f61222$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $b634fe06a3f61222$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $b634fe06a3f61222$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $b634fe06a3f61222$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $b634fe06a3f61222$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $b634fe06a3f61222$var$getModuleLinkHrefs(matches, manifest);
    return $b634fe06a3f61222$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $b634fe06a3f61222$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $b634fe06a3f61222$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $b634fe06a3f61222$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($b634fe06a3f61222$var$prefetchStyleLink));
}
async function $b634fe06a3f61222$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$b634fe06a3f61222$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$b634fe06a3f61222$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$b634fe06a3f61222$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($b634fe06a3f61222$var$prefetchStyleLink));
}
async function $b634fe06a3f61222$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $b634fe06a3f61222$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $b634fe06a3f61222$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $b634fe06a3f61222$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $b634fe06a3f61222$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $b634fe06a3f61222$var$dedupeLinkDescriptors(links.flat(1).filter($b634fe06a3f61222$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $b634fe06a3f61222$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $b634fe06a3f61222$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $b634fe06a3f61222$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $b634fe06a3f61222$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $b634fe06a3f61222$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $b634fe06a3f61222$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$b634fe06a3f61222$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($b634fe06a3f61222$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $b634fe06a3f61222$var$_isPreloadSupported;
function $b634fe06a3f61222$var$isPreloadSupported() {
    if ($b634fe06a3f61222$var$_isPreloadSupported !== void 0) return $b634fe06a3f61222$var$_isPreloadSupported;
    let el = document.createElement("link");
    $b634fe06a3f61222$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $b634fe06a3f61222$var$_isPreloadSupported;
}
function $b634fe06a3f61222$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $b634fe06a3f61222$var$useFrameworkContext();
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $b634fe06a3f61222$export$945fecf35a8ef089 ? /* @__PURE__ */ $itHdT.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $b634fe06a3f61222$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $b634fe06a3f61222$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $b634fe06a3f61222$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $b634fe06a3f61222$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$RemixRootDefaultErrorBoundary, {
            error: $b634fe06a3f61222$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $itHdT.createElement(routeModule.Layout, null, /* @__PURE__ */ $itHdT.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $itHdT.createElement(routeModule.Layout, null, /* @__PURE__ */ $itHdT.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $itHdT.createElement(routeModule.Layout, null, /* @__PURE__ */ $itHdT.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $b634fe06a3f61222$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $b634fe06a3f61222$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $b634fe06a3f61222$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$b634fe06a3f61222$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $b634fe06a3f61222$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $b634fe06a3f61222$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $b634fe06a3f61222$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $b634fe06a3f61222$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $b634fe06a3f61222$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $b634fe06a3f61222$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $b634fe06a3f61222$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $b634fe06a3f61222$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $b634fe06a3f61222$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $b634fe06a3f61222$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $b634fe06a3f61222$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $b634fe06a3f61222$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $b634fe06a3f61222$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$b634fe06a3f61222$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $b634fe06a3f61222$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $b634fe06a3f61222$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $b634fe06a3f61222$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $b634fe06a3f61222$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $b634fe06a3f61222$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $b634fe06a3f61222$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $b634fe06a3f61222$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $b634fe06a3f61222$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $b634fe06a3f61222$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $b634fe06a3f61222$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $b634fe06a3f61222$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $b634fe06a3f61222$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $b634fe06a3f61222$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $b634fe06a3f61222$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $b634fe06a3f61222$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $b634fe06a3f61222$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $b634fe06a3f61222$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $b634fe06a3f61222$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $b634fe06a3f61222$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $b634fe06a3f61222$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $b634fe06a3f61222$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $b634fe06a3f61222$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $b634fe06a3f61222$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $b634fe06a3f61222$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $b634fe06a3f61222$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $b634fe06a3f61222$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $b634fe06a3f61222$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $b634fe06a3f61222$var$nextPaths = /* @__PURE__ */ new Set();
var $b634fe06a3f61222$var$discoveredPathsMaxSize = 1e3;
var $b634fe06a3f61222$var$discoveredPaths = /* @__PURE__ */ new Set();
var $b634fe06a3f61222$export$b5915cf27fa06b9f = 7680;
function $b634fe06a3f61222$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $b634fe06a3f61222$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
var $b634fe06a3f61222$var$MANIFEST_MATCH_COST_LIMIT = 5e4;
var $b634fe06a3f61222$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD = 10;
function $b634fe06a3f61222$export$6b125d9215e726d(pathname, matchCost = 0) {
    let segmentCount = pathname.split("/").length - 1;
    let ancestorCount = Math.max(segmentCount - 1, 0);
    return ancestorCount * pathname.length + 1 > $b634fe06a3f61222$export$b5915cf27fa06b9f || segmentCount > $b634fe06a3f61222$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD && segmentCount * matchCost > $b634fe06a3f61222$var$MANIFEST_MATCH_COST_LIMIT;
}
function $b634fe06a3f61222$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $b634fe06a3f61222$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $b634fe06a3f61222$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$b634fe06a3f61222$export$741d98b28dbfd(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($b634fe06a3f61222$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $b634fe06a3f61222$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $b634fe06a3f61222$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $b634fe06a3f61222$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $itHdT.useEffect(()=>{
        if (!$b634fe06a3f61222$export$741d98b28dbfd(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$b634fe06a3f61222$var$discoveredPaths.has(pathname)) $b634fe06a3f61222$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($b634fe06a3f61222$var$nextPaths.keys()).filter((path)=>{
                if ($b634fe06a3f61222$var$discoveredPaths.has(path)) {
                    $b634fe06a3f61222$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $b634fe06a3f61222$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $b634fe06a3f61222$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $b634fe06a3f61222$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $b634fe06a3f61222$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $b634fe06a3f61222$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $b634fe06a3f61222$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $b634fe06a3f61222$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($b634fe06a3f61222$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $b634fe06a3f61222$export$b5915cf27fa06b9f) {
        $b634fe06a3f61222$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($b634fe06a3f61222$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($b634fe06a3f61222$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($b634fe06a3f61222$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$b634fe06a3f61222$var$addToFifoQueue(p, $b634fe06a3f61222$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $b634fe06a3f61222$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $b634fe06a3f61222$var$addToFifoQueue(path, queue) {
    if (queue.size >= $b634fe06a3f61222$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $b634fe06a3f61222$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $b634fe06a3f61222$var$useDataRouterContext2() {
    let context = $itHdT.useContext($b634fe06a3f61222$export$2eeee58951ff3c1c);
    $b634fe06a3f61222$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $b634fe06a3f61222$var$useDataRouterStateContext() {
    let context = $itHdT.useContext($b634fe06a3f61222$export$315e3ffb01f217);
    $b634fe06a3f61222$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $b634fe06a3f61222$export$208d6a3bc3aa62bd = $itHdT.createContext(void 0);
$b634fe06a3f61222$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $b634fe06a3f61222$var$useFrameworkContext() {
    let context = $itHdT.useContext($b634fe06a3f61222$export$208d6a3bc3aa62bd);
    $b634fe06a3f61222$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $b634fe06a3f61222$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $itHdT.useContext($b634fe06a3f61222$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $itHdT.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $itHdT.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $itHdT.useRef(null);
    $itHdT.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $itHdT.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $b634fe06a3f61222$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $b634fe06a3f61222$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $b634fe06a3f61222$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $b634fe06a3f61222$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $b634fe06a3f61222$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $b634fe06a3f61222$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $b634fe06a3f61222$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$b634fe06a3f61222$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $b634fe06a3f61222$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $b634fe06a3f61222$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $b634fe06a3f61222$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $b634fe06a3f61222$var$useDataRouterStateContext();
    let matches = $b634fe06a3f61222$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $itHdT.useMemo(()=>$b634fe06a3f61222$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $itHdT.createElement("style", {
        [$b634fe06a3f61222$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $itHdT.createElement("link", {
        [$b634fe06a3f61222$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$b634fe06a3f61222$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $itHdT.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $b634fe06a3f61222$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $b634fe06a3f61222$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $b634fe06a3f61222$var$useFrameworkContext();
    let { router: router } = $b634fe06a3f61222$var$useDataRouterContext2();
    let matches = $itHdT.useMemo(()=>$b634fe06a3f61222$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $b634fe06a3f61222$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $b634fe06a3f61222$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $itHdT.useState([]);
    $itHdT.useEffect(()=>{
        let interrupted = false;
        $b634fe06a3f61222$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $b634fe06a3f61222$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let { future: future } = $b634fe06a3f61222$var$useFrameworkContext();
    let { basename: basename } = $b634fe06a3f61222$var$useDataRouterContext2();
    let dataHrefs = $itHdT.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $b634fe06a3f61222$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $itHdT.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $b634fe06a3f61222$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $b634fe06a3f61222$var$useFrameworkContext();
    let { basename: basename } = $b634fe06a3f61222$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $b634fe06a3f61222$var$useDataRouterStateContext();
    let newMatchesForData = $itHdT.useMemo(()=>$b634fe06a3f61222$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $itHdT.useMemo(()=>$b634fe06a3f61222$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $itHdT.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $b634fe06a3f61222$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $itHdT.useMemo(()=>$b634fe06a3f61222$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $b634fe06a3f61222$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $itHdT.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $itHdT.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $itHdT.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $b634fe06a3f61222$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $b634fe06a3f61222$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $b634fe06a3f61222$var$useDataRouterStateContext();
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let _matches = $b634fe06a3f61222$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$b634fe06a3f61222$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $itHdT.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $itHdT.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $itHdT.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $itHdT.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $b634fe06a3f61222$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $itHdT.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $b634fe06a3f61222$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $b634fe06a3f61222$var$isHydrated = false;
function $b634fe06a3f61222$export$3be068dde909e563() {
    $b634fe06a3f61222$var$isHydrated = true;
}
function $b634fe06a3f61222$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $b634fe06a3f61222$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $b634fe06a3f61222$var$useDataRouterContext2();
    let { matches: routerMatches } = $b634fe06a3f61222$var$useDataRouterStateContext();
    let isRSCRouterContext = $b634fe06a3f61222$var$useIsRSCRouterContext();
    let enableFogOfWar = $b634fe06a3f61222$export$741d98b28dbfd(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $b634fe06a3f61222$var$getActiveMatches(routerMatches, null, isSpaMode);
    $itHdT.useEffect(()=>{
        $b634fe06a3f61222$export$3be068dde909e563();
    }, []);
    let initialScripts = $itHdT.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $b634fe06a3f61222$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($b634fe06a3f61222$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, /* @__PURE__ */ $itHdT.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $itHdT.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $b634fe06a3f61222$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($b634fe06a3f61222$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $b634fe06a3f61222$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $b634fe06a3f61222$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $itHdT.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $itHdT.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $itHdT.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $itHdT.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $b634fe06a3f61222$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $b634fe06a3f61222$export$32e57f52df4b6e34 = class extends $itHdT.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $b634fe06a3f61222$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $b634fe06a3f61222$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $itHdT.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($b634fe06a3f61222$export$972111febbeef05b(error)) return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $itHdT.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $b634fe06a3f61222$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $itHdT.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $itHdT.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $b634fe06a3f61222$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $b634fe06a3f61222$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $itHdT.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $itHdT.createElement("head", null, /* @__PURE__ */ $itHdT.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $itHdT.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $itHdT.createElement("title", null, title)), /* @__PURE__ */ $itHdT.createElement("body", null, /* @__PURE__ */ $itHdT.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$ff0bf87698939488, null) : null)));
}
var $b634fe06a3f61222$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($b634fe06a3f61222$var$isBrowser2) window.__reactRouterVersion = "7.18.5";
} catch (e) {}
function $b634fe06a3f61222$export$1f3f55432a00e06d(routes, opts) {
    return $b634fe06a3f61222$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $b634fe06a3f61222$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $b634fe06a3f61222$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $b634fe06a3f61222$export$9269a41d8c4635e,
        hydrationRouteProperties: $b634fe06a3f61222$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $b634fe06a3f61222$export$1ba7ed8a3a7b3765(routes, opts) {
    return $b634fe06a3f61222$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $b634fe06a3f61222$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $b634fe06a3f61222$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $b634fe06a3f61222$export$9269a41d8c4635e,
        hydrationRouteProperties: $b634fe06a3f61222$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $b634fe06a3f61222$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $b634fe06a3f61222$var$deserializeErrors(state.errors)
    };
    return state;
}
function $b634fe06a3f61222$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $b634fe06a3f61222$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $b634fe06a3f61222$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $b634fe06a3f61222$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $itHdT.useRef();
    if (historyRef.current == null) historyRef.current = $b634fe06a3f61222$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $itHdT.useState({
        action: history.action,
        location: history.location
    });
    let setState = $itHdT.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $itHdT.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $itHdT.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $b634fe06a3f61222$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $itHdT.useRef();
    if (historyRef.current == null) historyRef.current = $b634fe06a3f61222$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $itHdT.useState({
        action: history.action,
        location: history.location
    });
    let setState = $itHdT.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $itHdT.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $itHdT.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $b634fe06a3f61222$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $itHdT.useState({
        action: history.action,
        location: history.location
    });
    let setState = $itHdT.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $itHdT.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $itHdT.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$b634fe06a3f61222$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $b634fe06a3f61222$export$a6c7ac8248d6e38a = $itHdT.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $b634fe06a3f61222$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $b634fe06a3f61222$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $b634fe06a3f61222$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $b634fe06a3f61222$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $b634fe06a3f61222$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $b634fe06a3f61222$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $b634fe06a3f61222$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $itHdT.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $b634fe06a3f61222$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, link, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$b634fe06a3f61222$export$a6c7ac8248d6e38a.displayName = "Link";
var $b634fe06a3f61222$export$b0d92dbee9b5b60d = $itHdT.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $b634fe06a3f61222$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let routerState = $itHdT.useContext($b634fe06a3f61222$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $b634fe06a3f61222$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $b634fe06a3f61222$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$b634fe06a3f61222$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $b634fe06a3f61222$export$a7fed597f4b8afd8 = $itHdT.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $b634fe06a3f61222$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let submit = $b634fe06a3f61222$export$47c85c6e3a081d3();
    let formAction = $b634fe06a3f61222$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $b634fe06a3f61222$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $itHdT.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $itHdT.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$b634fe06a3f61222$export$a7fed597f4b8afd8.displayName = "Form";
function $b634fe06a3f61222$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $itHdT.useContext($b634fe06a3f61222$export$208d6a3bc3aa62bd);
    let { basename: basename } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let matches = $b634fe06a3f61222$export$2378eb7f5ff86053();
    $b634fe06a3f61222$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $itHdT.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $b634fe06a3f61222$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $itHdT.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$b634fe06a3f61222$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $b634fe06a3f61222$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$b634fe06a3f61222$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$b634fe06a3f61222$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $b634fe06a3f61222$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $b634fe06a3f61222$var$useDataRouterContext3(hookName) {
    let ctx = $itHdT.useContext($b634fe06a3f61222$export$2eeee58951ff3c1c);
    $b634fe06a3f61222$export$f5708dca728d7177(ctx, $b634fe06a3f61222$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $b634fe06a3f61222$var$useDataRouterState2(hookName) {
    let state = $itHdT.useContext($b634fe06a3f61222$export$315e3ffb01f217);
    $b634fe06a3f61222$export$f5708dca728d7177(state, $b634fe06a3f61222$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $b634fe06a3f61222$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $b634fe06a3f61222$export$9770f232ac06a008();
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let path = $b634fe06a3f61222$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $itHdT.useCallback((event)=>{
        if ($b634fe06a3f61222$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $b634fe06a3f61222$export$fe53371bee54353d(location) === $b634fe06a3f61222$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $itHdT.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $b634fe06a3f61222$export$f1a78c17382fe22a(defaultInit) {
    $b634fe06a3f61222$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $itHdT.useRef($b634fe06a3f61222$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $itHdT.useRef(false);
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let searchParams = $itHdT.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b634fe06a3f61222$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $b634fe06a3f61222$export$9770f232ac06a008();
    let setSearchParams = $itHdT.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b634fe06a3f61222$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $b634fe06a3f61222$var$fetcherId = 0;
var $b634fe06a3f61222$var$getUniqueFetcherId = ()=>`__${String(++$b634fe06a3f61222$var$fetcherId)}__`;
function $b634fe06a3f61222$export$47c85c6e3a081d3() {
    let { router: router } = $b634fe06a3f61222$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let currentRouteId = $b634fe06a3f61222$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $itHdT.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b634fe06a3f61222$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $b634fe06a3f61222$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $b634fe06a3f61222$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let routeContext = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    $b634fe06a3f61222$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$b634fe06a3f61222$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $b634fe06a3f61222$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $b634fe06a3f61222$export$fe53371bee54353d(path);
}
function $b634fe06a3f61222$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $b634fe06a3f61222$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $b634fe06a3f61222$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $itHdT.useContext($b634fe06a3f61222$export$cb3f1df1bef00a39);
    let route = $itHdT.useContext($b634fe06a3f61222$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $b634fe06a3f61222$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $b634fe06a3f61222$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $b634fe06a3f61222$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $itHdT.useId();
    let [fetcherKey, setFetcherKey] = $itHdT.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $itHdT.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $itHdT.useCallback(async (href, opts)=>{
        $b634fe06a3f61222$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $b634fe06a3f61222$export$47c85c6e3a081d3();
    let submit = $itHdT.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $itHdT.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $itHdT.useMemo(()=>{
        let FetcherForm2 = $itHdT.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $b634fe06a3f61222$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $itHdT.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $b634fe06a3f61222$export$fa996778a3a31087() {
    let state = $b634fe06a3f61222$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $itHdT.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $b634fe06a3f61222$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $b634fe06a3f61222$var$savedScrollPositions = {};
function $b634fe06a3f61222$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $b634fe06a3f61222$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $b634fe06a3f61222$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $b634fe06a3f61222$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b634fe06a3f61222$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $itHdT.useContext($b634fe06a3f61222$export$3044ab7fdabeaee6);
    let location = $b634fe06a3f61222$export$45d76561a5302f2b();
    let matches = $b634fe06a3f61222$export$2378eb7f5ff86053();
    let navigation = $b634fe06a3f61222$export$d0fd4b7106de2769();
    $itHdT.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $b634fe06a3f61222$var$usePageHide($itHdT.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $b634fe06a3f61222$var$getScrollRestorationKey(location, matches, basename, getKey);
            $b634fe06a3f61222$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $b634fe06a3f61222$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b634fe06a3f61222$var$savedScrollPositions));
        } catch (error) {
            $b634fe06a3f61222$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $itHdT.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b634fe06a3f61222$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b634fe06a3f61222$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $itHdT.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($b634fe06a3f61222$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$b634fe06a3f61222$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $itHdT.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $b634fe06a3f61222$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $b634fe06a3f61222$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $itHdT.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $b634fe06a3f61222$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $itHdT.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $b634fe06a3f61222$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $b634fe06a3f61222$export$b273b3273281a049(when);
    $itHdT.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $itHdT.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $b634fe06a3f61222$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $itHdT.useContext($b634fe06a3f61222$export$3681f408decb40d1);
    $b634fe06a3f61222$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $b634fe06a3f61222$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $b634fe06a3f61222$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $b634fe06a3f61222$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $b634fe06a3f61222$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $b634fe06a3f61222$export$81336c211d5ff295(path.pathname, nextPath) != null || $b634fe06a3f61222$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $b634fe06a3f61222$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $b634fe06a3f61222$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $b634fe06a3f61222$var$getStatelessNavigator();
    return /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $b634fe06a3f61222$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $b634fe06a3f61222$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $b634fe06a3f61222$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $b634fe06a3f61222$var$serializeErrors(context.errors)
        };
        let json = $b634fe06a3f61222$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $itHdT.createElement($itHdT.Fragment, null, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $itHdT.createElement($b634fe06a3f61222$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $itHdT.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $b634fe06a3f61222$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($b634fe06a3f61222$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $b634fe06a3f61222$var$getStatelessNavigator() {
    return {
        createHref: $b634fe06a3f61222$var$createHref,
        encodeLocation: $b634fe06a3f61222$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $b634fe06a3f61222$export$69163f0b72ec60d9(routes, opts) {
    return $b634fe06a3f61222$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $b634fe06a3f61222$export$9269a41d8c4635e
    });
}
function $b634fe06a3f61222$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $b634fe06a3f61222$export$87cb1a9238dc3fba(routes, $b634fe06a3f61222$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $b634fe06a3f61222$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $b634fe06a3f61222$var$createHref,
        encodeLocation: $b634fe06a3f61222$var$encodeLocation,
        getFetcher () {
            return $b634fe06a3f61222$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $b634fe06a3f61222$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $b634fe06a3f61222$var$createHref(to) {
    return typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to);
}
function $b634fe06a3f61222$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $b634fe06a3f61222$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $b634fe06a3f61222$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}



// \0@oxc-project+runtime@0.155.0/helpers/esm/checkPrivateRedeclaration.js
function $8abf3f80f32bda0d$export$407448d2b89b1813(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/classPrivateFieldInitSpec.js
function $8abf3f80f32bda0d$export$23f2a1d2818174ef(e, t, a) {
    $8abf3f80f32bda0d$export$407448d2b89b1813(e, t), t.set(e, a);
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/assertClassBrand.js
function $8abf3f80f32bda0d$export$43caf9889c228507(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/classPrivateFieldGet2.js
function $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5(s, a) {
    return s.get($8abf3f80f32bda0d$export$43caf9889c228507(s, a));
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/classPrivateFieldSet2.js
function $8abf3f80f32bda0d$export$625550452a3fa3ec(s, a, r) {
    return s.set($8abf3f80f32bda0d$export$43caf9889c228507(s, a), r), r;
}



// src/timeoutManager.ts
const $769570b3c4fef1fb$export$d235812f9125bf47 = {
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $769570b3c4fef1fb$var$_provider = /* @__PURE__ */ new WeakMap();
var $769570b3c4fef1fb$var$_providerCalled = /* @__PURE__ */ new WeakMap();
/**
* Allows customization of how timeouts are created.
*
* `@tanstack/query-core` makes liberal use of timeouts to implement `staleTime`
* and `gcTime`. The default TimeoutManager provider uses the platform's global
* `setTimeout` implementation, which is known to have scalability issues with
* thousands of timeouts on the event loop.
*
* If you hit this limitation, consider providing a custom TimeoutProvider that
* coalesces timeouts.
*/ var $769570b3c4fef1fb$export$6336d90323f0ab52 = class {
    constructor(){
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $769570b3c4fef1fb$var$_provider, $769570b3c4fef1fb$export$d235812f9125bf47);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $769570b3c4fef1fb$var$_providerCalled, false);
    }
    /**
	* `setTimeoutProvider` can be used to set a custom implementation of the
	* `setTimeout`, `clearTimeout`, `setInterval`, `clearInterval` functions,
	* called a `TimeoutProvider`.
	*
	* This may be useful if you notice event loop performance issues with
	* thousands of queries. A custom TimeoutProvider could also support timer
	* delays longer than the global `setTimeout` maximum delay value of about
	* 24 days.
	*
	* It is important to call `setTimeoutProvider` before creating a
	* QueryClient or queries, so that the same provider is used consistently
	* for all timers in the application, since different TimeoutProviders
	* cannot cancel each others' timers.
	* @param provider - The `TimeoutProvider` to use for all timers from now on.
	* @example
	* ```ts
	* import { timeoutManager, QueryClient } from '@tanstack/query-core'
	* import { CustomTimeoutProvider } from './CustomTimeoutProvider'
	*
	* timeoutManager.setTimeoutProvider(new CustomTimeoutProvider())
	*
	* export const queryClient = new QueryClient()
	* ```
	*/ setTimeoutProvider(provider) {
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($769570b3c4fef1fb$var$_provider, this, provider);
    }
    /**
	* `setTimeout` schedules a callback to run after approximately `delay`
	* milliseconds, like the global `setTimeout` function. The callback can be
	* canceled with `clearTimeout`.
	*
	* It returns a timer ID, which may be a number or an object that can be
	* coerced to a number via `Symbol.toPrimitive`.
	* @param callback - The function to call when the timeout elapses.
	* @param delay - The time to wait before calling `callback`, in milliseconds.
	* @returns The timer ID, to pass to {@link TimeoutManager#clearTimeout}.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const timeoutId = timeoutManager.setTimeout(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* const timeoutIdNumber: number = Number(timeoutId)
	* ```
	*/ setTimeout(callback, delay) {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($769570b3c4fef1fb$var$_provider, this).setTimeout(callback, delay);
    }
    /**
	* `clearTimeout` cancels a timeout callback scheduled with `setTimeout`,
	* like the global `clearTimeout` function. It should be called with a
	* timer ID returned by `setTimeout`.
	* @param timeoutId - The timer ID returned by `setTimeout`, or `undefined`.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const timeoutId = timeoutManager.setTimeout(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* timeoutManager.clearTimeout(timeoutId)
	* ```
	*/ clearTimeout(timeoutId) {
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($769570b3c4fef1fb$var$_provider, this).clearTimeout(timeoutId);
    }
    /**
	* `setInterval` schedules a callback to be called approximately every
	* `delay` milliseconds, like the global `setInterval` function.
	*
	* Like `setTimeout`, it returns a timer ID, which may be a number or an
	* object that can be coerced to a number via `Symbol.toPrimitive`.
	* @param callback - The function to call on every interval.
	* @param delay - The time between calls, in milliseconds.
	* @returns The timer ID, to pass to {@link TimeoutManager#clearInterval}.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const intervalId = timeoutManager.setInterval(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	* ```
	*/ setInterval(callback, delay) {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($769570b3c4fef1fb$var$_provider, this).setInterval(callback, delay);
    }
    /**
	* `clearInterval` can be used to cancel an interval, like the global
	* `clearInterval` function. It should be called with an interval ID
	* returned by `setInterval`.
	* @param intervalId - The timer ID returned by `setInterval`, or `undefined`.
	* @example
	* ```ts
	* import { timeoutManager } from '@tanstack/query-core'
	*
	* const intervalId = timeoutManager.setInterval(
	*   () => console.log('ran at:', new Date()),
	*   1000,
	* )
	*
	* timeoutManager.clearInterval(intervalId)
	* ```
	*/ clearInterval(intervalId) {
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($769570b3c4fef1fb$var$_provider, this).clearInterval(intervalId);
    }
};
/**
* Singleton instance of {@link TimeoutManager}, used throughout TanStack Query to schedule and cancel timers.
*/ const $769570b3c4fef1fb$export$94a2700736e69372 = new $769570b3c4fef1fb$export$6336d90323f0ab52();
/**
* In many cases code wants to delay to the next event loop tick; this is not
* mediated by {@link timeoutManager}.
*
* This function is provided to make auditing the `tanstack/query-core` for
* incorrect use of system `setTimeout` easier.
* @param callback - The function to call on the next event loop tick.
*/ function $769570b3c4fef1fb$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


// src/utils.ts
/**
* @deprecated use `environmentManager.isServer()` instead.
*/ const $ee0a7c55ac205e24$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $ee0a7c55ac205e24$export$8793edee2d425525() {}
/**
* Resolves an {@link Updater}: calls it with `input` if it is a function, otherwise returns it as
* is.
* @param updater - The new value, or a function that receives `input` and returns the new value.
* @param input - The current value, passed to `updater` if it is a function.
* @returns The new value.
*/ function $ee0a7c55ac205e24$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
/**
* Checks whether a value can be used as a timeout: a non-negative, finite number.
* @param value - The value to check.
* @returns `true` if `value` is a number that is `>= 0` and not `Infinity`.
*/ function $ee0a7c55ac205e24$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
/**
* Calculates how long until data updated at `updatedAt` becomes stale.
* @param updatedAt - The timestamp, in milliseconds, at which the data was last updated.
* @param staleTime - The time, in milliseconds, after which data is considered stale. Defaults to
* `0`.
* @returns The remaining time in milliseconds, or `0` if the data is already stale.
*/ function $ee0a7c55ac205e24$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
/**
* Resolves an option that can be given either as a value or as a function of the query, such as
* `staleTime`.
* @param value - The option value, or a function that receives `query` and returns the value.
* @param query - The query passed to `value` if it is a function.
* @returns The resolved value, or `undefined` if `value` is `undefined`.
*/ function $ee0a7c55ac205e24$export$e36731f6aa6a4362(value, query) {
    return typeof value === "function" ? value(query) : value;
}
/**
* Checks whether a query matches the given {@link QueryFilters}.
* Every filter that is specified must match; filters that are left unspecified are ignored.
* @param filters - The filters to check the query against.
* @param query - The query to check.
* @returns `true` if the query matches every specified filter.
* @example
* ```ts
* const queryCache = queryClient.getQueryCache()
*
* const matchingQueries = queryCache
*   .getAll()
*   .filter((query) => matchQuery({ queryKey: ['posts'] }, query))
* ```
*/ function $ee0a7c55ac205e24$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $ee0a7c55ac205e24$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$ee0a7c55ac205e24$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
/**
* Checks whether a mutation matches the given {@link MutationFilters}.
* Every filter that is specified must match; filters that are left unspecified are ignored.
* If a `mutationKey` filter is provided but the mutation has no `mutationKey` of its own, it does not match.
* @param filters - The filters to check the mutation against.
* @param mutation - The mutation to check.
* @returns `true` if the mutation matches every specified filter.
* @example
* ```ts
* const mutationCache = queryClient.getMutationCache()
*
* const matchingMutations = mutationCache
*   .getAll()
*   .filter((mutation) => matchMutation({ mutationKey: ['addPost'] }, mutation))
* ```
*/ function $ee0a7c55ac205e24$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($ee0a7c55ac205e24$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $ee0a7c55ac205e24$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$ee0a7c55ac205e24$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
/**
* Hashes a query key with the query's `queryKeyHashFn` option, falling back to {@link hashKey}.
* @param queryKey - The query key to hash.
* @param options - The query options that may provide a custom `queryKeyHashFn`.
* @returns The query hash, a string that identifies the query in the cache.
*/ function $ee0a7c55ac205e24$export$cc90ca97bc0d73fd(queryKey, options) {
    return ((options === null || options === void 0 ? void 0 : options.queryKeyHashFn) || $ee0a7c55ac205e24$export$1e87d19d4aab5805)(queryKey);
}
/**
* Default query & mutation keys hash function.
* Hashes the value into a stable hash.
* @param queryKey - The query or mutation key to hash.
* @returns The stable hash of the key, as a JSON string.
* @example
* ```ts
* // Object keys are sorted, so key order doesn't affect the hash:
* hashKey(['todos', { page: 1, filter: 'done' }]) // === '["todos",{"filter":"done","page":1}]'
* ```
*/ function $ee0a7c55ac205e24$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$ee0a7c55ac205e24$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $ee0a7c55ac205e24$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (Array.isArray(a) && Array.isArray(b)) {
            if (b.length > a.length) return false;
            for(let i = 0; i < b.length; i++)if (!$ee0a7c55ac205e24$export$2f07189bb9fa26a7(a[i], b[i])) return false;
            return true;
        }
        const bKeys = Object.keys(b);
        for (const key of bKeys)if (!$ee0a7c55ac205e24$export$2f07189bb9fa26a7(a[key], b[key])) return false;
        return true;
    }
    return false;
}
const $ee0a7c55ac205e24$var$hasOwn = Object.prototype.hasOwnProperty;
function $ee0a7c55ac205e24$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $ee0a7c55ac205e24$export$7a8558113332b71e(a) && $ee0a7c55ac205e24$export$7a8558113332b71e(b);
    if (!array && !($ee0a7c55ac205e24$export$53b83ca8eaab0383(a) && $ee0a7c55ac205e24$export$53b83ca8eaab0383(b))) return b;
    const aSize = (array ? a : Object.keys(a)).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $ee0a7c55ac205e24$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $ee0a7c55ac205e24$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
/**
* Shallow compare objects.
* @param a - The first object.
* @param b - The second object, or `undefined`.
* @returns `true` if both objects have the same keys, with strictly equal values for each key.
*/ function $ee0a7c55ac205e24$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a)if (a[key] !== b[key]) return false;
    return true;
}
/**
* Checks whether a value is an array with no holes and no extra properties.
* @param value - The value to check.
* @returns `true` if `value` is an array whose number of own keys equals its `length`.
*/ function $ee0a7c55ac205e24$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
/**
* Checks whether a value is a plain object, e.g. created with an object literal or
* `Object.create(null)`.
* @param o - The value to check.
* @returns `true` if `o` is a plain object.
*/ function $ee0a7c55ac205e24$export$53b83ca8eaab0383(o) {
    if (!$ee0a7c55ac205e24$var$hasObjectPrototype(o)) return false;
    const objectPrototype = Object.getPrototypeOf(o);
    const ctor = objectPrototype === null || objectPrototype === void 0 ? void 0 : objectPrototype.constructor;
    if (ctor === void 0) return true;
    if (typeof ctor !== "function") return false;
    const prot = ctor.prototype;
    if (!$ee0a7c55ac205e24$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (objectPrototype !== Object.prototype) return false;
    return true;
}
/**
* Checks whether a value's `Object.prototype.toString` tag is `[object Object]`.
* @param o - The value to check.
* @returns `true` if the tag is `[object Object]`.
*/ function $ee0a7c55ac205e24$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
/**
* Waits for the given time, using the configured {@link timeoutManager}.
* @param timeout - The time to wait, in milliseconds.
* @returns A promise that resolves after `timeout` milliseconds.
*/ function $ee0a7c55ac205e24$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $769570b3c4fef1fb$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
/**
* Applies a query's `structuralSharing` option when writing new data.
* @param prevData - The previously cached data.
* @param data - The new data.
* @param options - The query options, whose `structuralSharing` decides how the data is merged.
* @returns The result of a custom `structuralSharing` function, `data` with its unchanged parts
* replaced by those of `prevData` by default, or `data` as is if `structuralSharing` is `false`.
* @throws {Error} The error from the default structural sharing, e.g. when the data is not JSON serializable.
* Outside production, it is also logged to the console.
*/ function $ee0a7c55ac205e24$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $ee0a7c55ac205e24$export$77a71fc411098696(prevData, data);
    }
    return data;
}
/**
* Intended to be passed as a query's `placeholderData` option, for example
* `placeholderData: keepPreviousData`. Instead of resetting the query's data to `undefined` while a new
* query key is fetching, it keeps displaying the previously fetched data until the new data arrives.
* @param previousData - The data of the previous query key, passed by the observer.
* @returns The previous data, unchanged.
* @example
* ```ts
* new QueryObserver(queryClient, {
*   queryKey: ['posts', page],
*   queryFn: () => fetchPosts(page),
*   placeholderData: keepPreviousData,
* })
* ```
*/ function $ee0a7c55ac205e24$export$f537417e7e421eac(previousData) {
    return previousData;
}
/**
* Returns a new array with `item` added at the end. If that makes the array longer than `max`,
* the first item is dropped. Only one item is dropped, so the result can still exceed `max` if
* `items` already did.
* @param items - The current items.
* @param item - The value to append.
* @param max - The length above which an item is dropped. `0` (the default) means no limit.
* @returns A new array with `item` added.
*/ function $ee0a7c55ac205e24$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
/**
* Returns a new array with `item` added at the start. If that makes the array longer than `max`,
* the last item is dropped. Only one item is dropped, so the result can still exceed `max` if
* `items` already did.
* @param items - The current items.
* @param item - The value to prepend.
* @param max - The length above which an item is dropped. `0` (the default) means no limit.
* @returns A new array with `item` added.
*/ function $ee0a7c55ac205e24$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
/**
* Sentinel value that can be passed as a query's `queryFn` to conditionally disable the query (equivalent
* to `enabled: false`) while preserving full type inference for the query's data. Unlike `enabled: false`,
* a query disabled via `skipToken` cannot be triggered with `refetch`.
* @example
* ```ts
* new QueryObserver(queryClient, {
*   queryKey: ['post', postId],
*   queryFn: postId != null ? () => fetchPost(postId) : skipToken,
* })
* ```
*/ const $ee0a7c55ac205e24$export$1aa5a89531b7670d = Symbol();
/**
* Returns the function to call for a fetch. If there is no `queryFn` but the fetch was started from
* an `initialPromise`, that promise is returned instead. If there is no usable `queryFn` (missing or
* {@link skipToken}), the returned function rejects with a `Missing queryFn` error.
* @param options - The query options with the `queryFn`, and the `queryHash` used in error messages.
* @param fetchOptions - The fetch options, which may carry an `initialPromise`.
* @returns The function to call for the fetch.
*/ function $ee0a7c55ac205e24$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $ee0a7c55ac205e24$export$1aa5a89531b7670d) return ()=>Promise.reject(/* @__PURE__ */ new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
/**
* Resolves a `throwOnError` option to a boolean.
* If `throwOnError` is a function, it is called with `params` (e.g. the error and, depending on the caller,
* additional context such as the query or mutation) and its result is returned, allowing the throwing
* behavior to be decided per error. Otherwise, `throwOnError` itself is coerced to a boolean (`undefined`
* resolves to `false`).
* @param throwOnError - The `throwOnError` option: a boolean, a function that decides per error, or
* `undefined`.
* @param params - The arguments passed to `throwOnError` if it is a function.
* @returns Whether the error should be thrown.
* @example
* ```ts
* const throwOnError =
*   query.state.error && typeof options.throwOnError === 'function'
*     ? shouldThrowError(options.throwOnError, [query.state.error, query])
*     : options.throwOnError
* ```
*/ function $ee0a7c55ac205e24$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
/**
* Adds a lazy `signal` getter to an object, such as a query function context. The first time
* `signal` is read, `onCancelled` is registered for the signal's `abort` event (or called right
* away if it is already aborted), so cancellation is only tracked when the signal is actually used.
* @param object - The object to add the `signal` property to.
* @param getSignal - Returns the `AbortSignal`. Called once, when `signal` is first read.
* @param onCancelled - Called when the signal is aborted, if `signal` was read.
* @returns The same object, with the `signal` property added.
*/ function $ee0a7c55ac205e24$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ?? (signal = getSignal());
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}



// src/subscribable.ts
/**
* The base class behind everything in Query that you can subscribe to: `QueryCache`, `MutationCache`,
* the observers, and the `FocusManager`/`OnlineManager` behind `focusManager` and `onlineManager`.
* Subclasses decide what a listener receives and when it is called.
*/ var $5cb24f678e609491$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    /**
	* Registers a listener to be called on every update this object notifies about. Returns a function
	* that removes the listener again — call it to stop listening. The base class never drops a listener
	* on its own, though some subclasses clear all of theirs in `destroy()`.
	* @param listener - Called on each update, with whatever the subclass passes to its subscribers.
	* @returns A function that removes the listener.
	* @example
	* ```ts
	* const unsubscribe = subscribable.subscribe(() => {
	*   // react to the update
	* })
	*
	* unsubscribe()
	* ```
	*/ subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    /**
	* Returns `true` while at least one listener is registered, `false` once they have all unsubscribed.
	* @returns `true` if at least one listener is registered.
	*/ hasListeners() {
        return this.listeners.size > 0;
    }
    /**
	* Called after a listener is added. Does nothing here; subclasses override it, e.g. to start
	* tracking what they observe once the first listener subscribes.
	*/ onSubscribe() {}
    /**
	* Called after a listener is removed. Does nothing here; subclasses override it, e.g. to clean up
	* once the last listener unsubscribes.
	*/ onUnsubscribe() {}
};


// src/focusManager.ts
var $fddc2922147f8f96$var$_focused = /* @__PURE__ */ new WeakMap();
var $fddc2922147f8f96$var$_cleanup = /* @__PURE__ */ new WeakMap();
var $fddc2922147f8f96$var$_setup = /* @__PURE__ */ new WeakMap();
/**
* The `FocusManager` manages the focus state within TanStack Query.
*
* It can be used to change the default event listeners or to manually change the focus state.
*/ var $fddc2922147f8f96$export$86f1af424b2ca4de = class extends (0, $5cb24f678e609491$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $fddc2922147f8f96$var$_focused, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $fddc2922147f8f96$var$_cleanup, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $fddc2922147f8f96$var$_setup, void 0);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($fddc2922147f8f96$var$_setup, this, (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
        });
    }
    onSubscribe() {
        if (!(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($fddc2922147f8f96$var$_cleanup, this)) this.setEventListener((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($fddc2922147f8f96$var$_setup, this));
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _classPrivateFieldGet2$1;
            (_classPrivateFieldGet2$1 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($fddc2922147f8f96$var$_cleanup, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($fddc2922147f8f96$var$_cleanup, this, void 0);
        }
    }
    /**
	* `setEventListener` can be used to set a custom event listener that will
	* be used to determine the focus state. The provided `setup` function
	* receives a `setFocused` callback: call it with a `boolean` to manually
	* set the focus state, or with no arguments to re-evaluate the current
	* focus state and notify subscribers.
	* @param setup - Receives the `setFocused` callback, registers the event listener, and may return
	* a cleanup function that is called when the listener is replaced or no longer needed.
	* @example
	* ```ts
	* import { focusManager } from '@tanstack/query-core'
	*
	* focusManager.setEventListener((handleFocus) => {
	*   const listener = () => handleFocus()
	*   // Listen to visibilitychange
	*   if (typeof window !== 'undefined' && window.addEventListener) {
	*     window.addEventListener('visibilitychange', listener, false)
	*   }
	*
	*   return () => {
	*     // Be sure to unsubscribe if a new handler is set
	*     window.removeEventListener('visibilitychange', listener)
	*   }
	* })
	* ```
	*/ setEventListener(setup) {
        var _classPrivateFieldGet3;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($fddc2922147f8f96$var$_setup, this, setup);
        (_classPrivateFieldGet3 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($fddc2922147f8f96$var$_cleanup, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($fddc2922147f8f96$var$_cleanup, this, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    /**
	* `setFocused` can be used to manually set the focus state. Set `undefined`
	* to fall back to the default focus check.
	* @param focused - The focus state, or `undefined` to use the default focus check.
	* @example
	* ```ts
	* import { focusManager } from '@tanstack/query-core'
	*
	* // Set focused
	* focusManager.setFocused(true)
	*
	* // Set unfocused
	* focusManager.setFocused(false)
	*
	* // Fallback to the default focus check
	* focusManager.setFocused(undefined)
	* ```
	*/ setFocused(focused) {
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($fddc2922147f8f96$var$_focused, this) !== focused) {
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($fddc2922147f8f96$var$_focused, this, focused);
            this.onFocus();
        }
    }
    /**
	* `onFocus` notifies all subscribed listeners with the current focus state.
	*/ onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    /**
	* `isFocused` can be used to get the current focus state.
	* @returns The focus state set with `setFocused`, or otherwise whether the document is visible.
	*/ isFocused() {
        var _globalThis$document;
        if (typeof (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($fddc2922147f8f96$var$_focused, this) === "boolean") return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($fddc2922147f8f96$var$_focused, this);
        return ((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== "hidden";
    }
};
/**
* Singleton instance of {@link FocusManager}, used to manage and observe the focus state within TanStack Query.
*/ const $fddc2922147f8f96$export$6bf54661be5b02cf = new $fddc2922147f8f96$export$86f1af424b2ca4de();



// src/notifyManager.ts
/**
* Default scheduling function used by the notify manager.
* Schedules the callback with the system's `setTimeout(callback, 0)`.
*/ const $e62a61312d2d5e98$export$7c76da44185e6090 = (0, $769570b3c4fef1fb$export$5086591e51e32a18);
/**
* Creates a notify manager, which schedules and batches notifications to subscribers. Query uses a
* single instance of it, exported as {@link notifyManager}.
* @returns A new notify manager.
*/ function $e62a61312d2d5e98$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $e62a61312d2d5e98$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        /**
		* Batches all updates scheduled inside the passed callback.
		* This is mainly used internally to optimize query client updating.
		* Batches can be nested; the queue is only flushed once the outermost `batch` call finishes.
		* The return value of `callback` is passed through.
		* @param callback - The function to run in the batch.
		* @returns The return value of `callback`.
		*/ batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
		* All calls to the wrapped function will be batched.
		* @param callback - The function to wrap.
		* @returns A function that schedules a call to `callback` with the given arguments.
		*/ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: /**
		* Schedules a function to be run on the next batch.
		* By default, the batch is run with a `setTimeout`, but this can be configured via `setScheduler`.
		*/ schedule,
        /**
		* Use this method to set a custom notify function.
		* This can be used to for example wrap notifications with `React.act` while running tests.
		* @param fn - Receives each notification callback and must call it.
		*/ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
		* Use this method to set a custom function to batch notifications together into a single tick.
		* Framework adapters use this to plug in their own batching primitive, so that a single query
		* update only triggers one re-render instead of one per subscriber.
		* @param fn - Receives a function that runs a batch of notifications and must call it.
		* @example
		* ```ts
		* import { notifyManager } from '@tanstack/query-core'
		* import { batch } from 'solid-js'
		*
		* notifyManager.setBatchNotifyFunction(batch)
		* ```
		*/ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        /**
		* Configures a custom callback that schedules when the next batch runs.
		* The default behavior is `setTimeout(callback, 0)`.
		* @param fn - Receives a callback that runs the next batch, and schedules it.
		* @example
		* ```ts
		* import { notifyManager } from '@tanstack/query-core'
		*
		* // Schedule batches in the next microtask
		* notifyManager.setScheduler(queueMicrotask)
		*
		* // Schedule batches before the next frame is rendered
		* notifyManager.setScheduler(requestAnimationFrame)
		*
		* // Schedule batches some time in the future
		* notifyManager.setScheduler((cb) => setTimeout(cb, 10))
		* ```
		*/ setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
/**
* Handles scheduling and batching callbacks in TanStack Query.
*/ const $e62a61312d2d5e98$export$520687f44db6e1ab = $e62a61312d2d5e98$export$316a8efd03cd1458();




// src/onlineManager.ts
var $322e88328cdac36c$var$_online = /* @__PURE__ */ new WeakMap();
var $322e88328cdac36c$var$_cleanup = /* @__PURE__ */ new WeakMap();
var $322e88328cdac36c$var$_setup = /* @__PURE__ */ new WeakMap();
/**
* The `OnlineManager` manages the online state within TanStack Query. It can
* be used to change the default event listeners or to manually change the
* online state.
*
* By default, the `onlineManager` assumes an active network connection, and
* listens to the `online` and `offline` events on the `window` object to
* detect changes.
*/ var $322e88328cdac36c$export$58774fb55d5ff7fc = class extends (0, $5cb24f678e609491$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $322e88328cdac36c$var$_online, true);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $322e88328cdac36c$var$_cleanup, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $322e88328cdac36c$var$_setup, void 0);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($322e88328cdac36c$var$_setup, this, (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
        });
    }
    onSubscribe() {
        if (!(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($322e88328cdac36c$var$_cleanup, this)) this.setEventListener((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($322e88328cdac36c$var$_setup, this));
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _classPrivateFieldGet2$1;
            (_classPrivateFieldGet2$1 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($322e88328cdac36c$var$_cleanup, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($322e88328cdac36c$var$_cleanup, this, void 0);
        }
    }
    /**
	* `setEventListener` can be used to set a custom event listener that will
	* be used to determine the online state. The provided `setup` function
	* receives a `setOnline` callback that should be called with a `boolean`
	* whenever the online state changes.
	* @param setup - Receives the `setOnline` callback, registers the event listener, and may return
	* a cleanup function that is called when the listener is replaced or no longer needed.
	* @example
	* ```ts
	* import NetInfo from '@react-native-community/netinfo'
	* import { onlineManager } from '@tanstack/query-core'
	*
	* onlineManager.setEventListener((setOnline) => {
	*   return NetInfo.addEventListener((state) => {
	*     setOnline(!!state.isConnected)
	*   })
	* })
	* ```
	*/ setEventListener(setup) {
        var _classPrivateFieldGet3;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($322e88328cdac36c$var$_setup, this, setup);
        (_classPrivateFieldGet3 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($322e88328cdac36c$var$_cleanup, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($322e88328cdac36c$var$_cleanup, this, setup(this.setOnline.bind(this)));
    }
    /**
	* `setOnline` can be used to manually set the online state.
	* @param online - The online state.
	* @example
	* ```ts
	* import { onlineManager } from '@tanstack/query-core'
	*
	* // Set to online
	* onlineManager.setOnline(true)
	*
	* // Set to offline
	* onlineManager.setOnline(false)
	* ```
	*/ setOnline(online) {
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($322e88328cdac36c$var$_online, this) !== online) {
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($322e88328cdac36c$var$_online, this, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    /**
	* `isOnline` can be used to get the current online state.
	* @returns `true` if online.
	*/ isOnline() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($322e88328cdac36c$var$_online, this);
    }
};
/**
* Singleton instance of {@link OnlineManager}, used to manage and observe the online state within TanStack Query.
*/ const $322e88328cdac36c$export$b113e788b2dd3fdc = new $322e88328cdac36c$export$58774fb55d5ff7fc();










// src/environmentManager.ts
let $c0c290c4c8652ba5$var$isServerFn = ()=>(0, $ee0a7c55ac205e24$export$6acf61af03e62db);
/**
* Returns whether the current runtime should be treated as a server environment.
* @returns `true` if the runtime is treated as a server.
*/ const $c0c290c4c8652ba5$export$6acf61af03e62db = ()=>$c0c290c4c8652ba5$var$isServerFn();
/**
* Manages how TanStack Query detects whether the current runtime should be treated as
* server-side, which disables scheduling refetch timers and changes the default `retry` count
* and `gcTime`. By default, the detection treats a missing `window` (or the presence of a
* `Deno` global) as server.
*
* Override this for runtimes where that default detection would give the wrong answer — for
* example, a Service Worker, where `window` is undefined even though the environment should
* behave like a client.
* @example
* ```ts
* import { environmentManager } from '@tanstack/query-core'
*
* environmentManager.setIsServer(() => false)
* ```
*/ const $c0c290c4c8652ba5$export$2d935f1a9c9d3f3e = {
    isServer: $c0c290c4c8652ba5$export$6acf61af03e62db,
    /**
	* Overrides the server check globally.
	* @param isServerValue - A function that returns whether the runtime should be treated as a
	* server.
	*/ setIsServer (isServerValue) {
        $c0c290c4c8652ba5$var$isServerFn = isServerValue;
    }
};




// src/retryer.ts
/**
* The default `retryDelay`: doubles with every failure, starting at 1 second, up to 30 seconds.
* @param failureCount - The number of failures so far.
* @returns The delay before the next retry, in milliseconds.
*/ function $897430696a6e5e77$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
/**
* Checks whether a fetch can run for the given network mode.
* @param networkMode - The `networkMode` option. Defaults to `'online'`.
* @returns `true` if the network mode is not `'online'`, or if it is and the client is online.
*/ function $897430696a6e5e77$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $322e88328cdac36c$export$b113e788b2dd3fdc).isOnline() : true;
}
/**
* The error thrown by a `Retryer` (and surfaced to `query.promise`/`mutation`) when a fetch is cancelled, e.g. via
* `query.cancel()`. `revert`, if `true`, tells the caller to restore the state the query was in before the fetch
* started instead of surfacing the error. `silent`, if `true`, tells the caller to suppress this error and instead
* resolve with the promise of the fetch that triggered the cancellation.
* @example
* ```ts
* query.cancel()
*
* try {
*   await query.promise
* } catch (error) {
*   if (error instanceof CancelledError) {
*     // the fetch was cancelled, e.g. via `query.cancel()`
*   }
* }
* ```
*/ var $897430696a6e5e77$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options === null || options === void 0 ? void 0 : options.revert;
        this.silent = options === null || options === void 0 ? void 0 : options.silent;
    }
};
/**
* Checks whether a value is a `CancelledError`.
* @param value - The value to check.
* @returns `true` if `value` is a `CancelledError`.
* @deprecated Use instanceof `CancelledError` instead.
*/ function $897430696a6e5e77$export$986cc6445c1d323(value) {
    return value instanceof $897430696a6e5e77$export$a8430ed4188f35a9;
}
/**
* Creates a retryer, which runs a function and retries it on failure according to the `retry` and
* `retryDelay` options. It pauses while the network mode doesn't allow fetching or `canRun` returns
* `false`, and can be cancelled. Queries and mutations use it to run their `queryFn` and
* `mutationFn`.
* @param config - The function to run, the retry options, and the callbacks for failures, pausing,
* continuing, and cancellation.
* @returns The retryer, whose `promise` settles with the result of the function.
*/ function $897430696a6e5e77$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    let status = "pending";
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((resolve, reject)=>{
        promiseResolve = resolve;
        promiseReject = reject;
    });
    promise.catch((0, $ee0a7c55ac205e24$export$8793edee2d425525));
    const isResolved = ()=>status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            var _config$onCancel;
            const error = new $897430696a6e5e77$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_config$onCancel = config.onCancel) === null || _config$onCancel === void 0 || _config$onCancel.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $fddc2922147f8f96$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $322e88328cdac36c$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$897430696a6e5e77$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 || continueFn();
            status = "resolved";
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 || continueFn();
            status = "rejected";
            promiseReject(value);
        }
    };
    const pause = (canResume)=>{
        return new Promise((continueResolve)=>{
            var _config$onPause;
            continueFn = (value)=>{
                if (isResolved() || canResume()) continueResolve(value);
            };
            (_config$onPause = config.onPause) === null || _config$onPause === void 0 || _config$onPause.call(config);
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) {
                var _config$onContinue;
                (_config$onContinue = config.onContinue) === null || _config$onContinue === void 0 || _config$onContinue.call(config);
            }
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$onFail;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $c0c290c4c8652ba5$export$6acf61af03e62db)() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $897430696a6e5e77$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_config$onFail = config.onFail) === null || _config$onFail === void 0 || _config$onFail.call(config, failureCount, error);
            (0, $ee0a7c55ac205e24$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause(canContinue);
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        status: ()=>status,
        cancel: cancel,
        continue: ()=>{
            continueFn === null || continueFn === void 0 || continueFn();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause(canStart).then(run);
            return promise;
        }
    };
}






// src/removable.ts
var $9dd0afac91a4d706$var$_gcTimeout = /* @__PURE__ */ new WeakMap();
/**
* The base class for cache entries that are garbage collected once nothing is using them —
* `Query` and `Mutation` both extend it. `gcTime` controls how long an unused entry is kept.
*/ var $9dd0afac91a4d706$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $9dd0afac91a4d706$var$_gcTimeout, void 0);
    }
    /**
	* Clears the pending garbage collection timeout, so the entry is no longer scheduled for removal.
	* A subclass may override this to release what it holds on to as well — `Query` also cancels any
	* in-flight fetch.
	*/ destroy() {
        this.clearGcTimeout();
    }
    /**
	* Schedules the entry to be removed from its cache after `gcTime`, replacing any timeout scheduled
	* before. Nothing is scheduled if `gcTime` is `Infinity`.
	*/ scheduleGc() {
        this.clearGcTimeout();
        if ((0, $ee0a7c55ac205e24$export$e539f754e934e270)(this.gcTime)) (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($9dd0afac91a4d706$var$_gcTimeout, this, (0, $769570b3c4fef1fb$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    /**
	* Updates `gcTime`, keeping the longest one seen so far. Without a value, it defaults to 5 minutes
	* on the client and `Infinity` on the server.
	* @param newGcTime - The `gcTime` from the latest options, if any.
	*/ updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $c0c290c4c8652ba5$export$6acf61af03e62db)() ? Infinity : 3e5));
    }
    /**
	* Cancels the scheduled removal, if there is one.
	*/ clearGcTimeout() {
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($9dd0afac91a4d706$var$_gcTimeout, this) !== void 0) {
            (0, $769570b3c4fef1fb$export$94a2700736e69372).clearTimeout((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($9dd0afac91a4d706$var$_gcTimeout, this));
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($9dd0afac91a4d706$var$_gcTimeout, this, void 0);
        }
    }
};



// \0@oxc-project+runtime@0.155.0/helpers/esm/classPrivateMethodInitSpec.js
function $2f8b5ecae537244d$export$625550452a3fa3ec(e, a) {
    (0, $8abf3f80f32bda0d$export$407448d2b89b1813)(e, a), a.add(e);
}


// src/mutation.ts
var $00ec7d3e9aeca4ee$var$_client = /* @__PURE__ */ new WeakMap();
var $00ec7d3e9aeca4ee$var$_observers = /* @__PURE__ */ new WeakMap();
var $00ec7d3e9aeca4ee$var$_mutationCache = /* @__PURE__ */ new WeakMap();
var $00ec7d3e9aeca4ee$var$_retryer = /* @__PURE__ */ new WeakMap();
var $00ec7d3e9aeca4ee$var$_Mutation_brand = /* @__PURE__ */ new WeakSet();
/**
* Represents a single mutation attempt. A `Mutation` holds the mutation's
* options, state (data/error/status), and the `MutationObserver`s currently
* subscribed to it.
*
* Instances are created and managed internally by `MutationCache`; application
* code typically interacts with mutations indirectly through `QueryClient` or
* a framework hook like `useMutation`. Direct access to a `Mutation` instance
* is possible via `mutationCache.find()`/`getAll()` for inspecting cache state.
* @example
* ```ts
* const mutationCache = queryClient.getMutationCache()
*
* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
* ```
*/ var $00ec7d3e9aeca4ee$export$17b8b19c814bcf56 = class extends (0, $9dd0afac91a4d706$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $2f8b5ecae537244d$export$625550452a3fa3ec)(this, $00ec7d3e9aeca4ee$var$_Mutation_brand);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $00ec7d3e9aeca4ee$var$_client, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $00ec7d3e9aeca4ee$var$_observers, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $00ec7d3e9aeca4ee$var$_mutationCache, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $00ec7d3e9aeca4ee$var$_retryer, void 0);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($00ec7d3e9aeca4ee$var$_client, this, config.client);
        this.mutationId = config.mutationId;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($00ec7d3e9aeca4ee$var$_mutationCache, this, config.mutationCache);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($00ec7d3e9aeca4ee$var$_observers, this, []);
        this.state = config.state || $00ec7d3e9aeca4ee$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    /**
	* Replaces the mutation's options and applies their `gcTime`.
	* @internal
	* @param options - The new mutation options.
	*/ setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    /**
	* The `meta` object passed in the mutation's options, if any.
	* @returns The mutation's `meta`, or `undefined` if none was set.
	*/ get meta() {
        return this.options.meta;
    }
    /**
	* Subscribes an observer to the mutation and stops its garbage collection.
	* @internal
	* @param observer - The observer to add. Adding an observer that is already subscribed does
	* nothing.
	*/ addObserver(observer) {
        if (!(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_observers, this).includes(observer)) {
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_observers, this).push(observer);
            this.clearGcTimeout();
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    /**
	* Unsubscribes an observer from the mutation.
	* @internal
	* @param observer - The observer to remove. Garbage collection is scheduled afterwards.
	*/ removeObserver(observer) {
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($00ec7d3e9aeca4ee$var$_observers, this, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_observers, this).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_observers, this).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).remove(this);
        }
    }
    /**
	* Resumes a mutation that is currently paused or was restored from a
	* dehydrated, still-`pending` state.
	*
	* - If this mutation has an active retryer (it paused mid-attempt, e.g. due
	*   to the network mode or scope-based queuing), its retryer is resumed.
	* - Otherwise, if the mutation's status is still `pending` (e.g. it was
	*   dehydrated while an attempt was in flight and never got a retryer in
	*   this instance), `execute` is called again with the last known variables.
	* - Otherwise the mutation has already settled and this resolves immediately
	*   without running anything again.
	* @returns A promise that settles with the resumed mutation: it rejects if the mutation fails.
	* It resolves immediately if the mutation has already settled.
	* @see {@link Mutation#execute}
	* @example
	* ```ts
	* // typically driven by reconnect handling, e.g. queryClient.resumePausedMutations()
	* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
	* await mutation?.continue()
	* ```
	*/ continue() {
        var _classPrivateFieldGet2$1;
        return ((_classPrivateFieldGet2$1 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_retryer, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.continue()) ?? (this.state.status === "pending" ? this.execute(this.state.variables) : Promise.resolve());
    }
    /**
	* Runs the mutation function for the given variables through a retryer, and
	* drives the mutation's state and lifecycle callbacks through to settlement.
	*
	* If this mutation's state is already `pending` when `execute` is called
	* (i.e. it was restored, still in-flight, from a dehydrated state), the
	* `onMutate` step is skipped and a `continue` action is dispatched to
	* unpause it; otherwise a `pending` action is dispatched first, then the
	* mutation cache's `onMutate` and the mutation's own `onMutate` option are
	* awaited in that order, and the resulting context is stored.
	*
	* The mutation function is then run (subject to `retry`/`retryDelay`/
	* `networkMode`, and to the mutation cache's scope-based serialization).
	* On success, the cache's `onSuccess`/`onSettled` callbacks run before the
	* mutation's own `onSuccess`/`onSettled` options, a `success` action is
	* dispatched, and the resolved data is returned. On failure, the same
	* cache-then-option ordering is used for `onError`/`onSettled`, but each of
	* those four callbacks is individually caught so that a throwing callback
	* cannot mask the original error; an `error` action is then dispatched and
	* the original error is re-thrown.
	* @param variables - The variables passed to the `mutationFn`.
	* @returns A promise that resolves with the mutation's data, or rejects with its error.
	* @see {@link Mutation#continue}
	* @example
	* ```ts
	* // Called internally by `MutationObserver.mutate` and `Mutation.continue` —
	* // applications normally trigger mutations through those, not this method.
	* const data = await mutation.execute(variables)
	* ```
	*/ async execute(variables) {
        const onContinue = ()=>{
            (0, $8abf3f80f32bda0d$export$43caf9889c228507)($00ec7d3e9aeca4ee$var$_Mutation_brand, this, $00ec7d3e9aeca4ee$var$_dispatch).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_client, this),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        const retryer = (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($00ec7d3e9aeca4ee$var$_retryer, this, (0, $897430696a6e5e77$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(/* @__PURE__ */ new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $8abf3f80f32bda0d$export$43caf9889c228507)($00ec7d3e9aeca4ee$var$_Mutation_brand, this, $00ec7d3e9aeca4ee$var$_dispatch).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $8abf3f80f32bda0d$export$43caf9889c228507)($00ec7d3e9aeca4ee$var$_Mutation_brand, this, $00ec7d3e9aeca4ee$var$_dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !retryer.canStart();
        try {
            var _classPrivateFieldGet3, _classPrivateFieldGet4, _this$options$onSucce, _this$options2, _classPrivateFieldGet5, _classPrivateFieldGet6, _this$options$onSettl, _this$options3;
            if (restored) onContinue();
            else {
                var _this$options$onMutat, _this$options;
                (0, $8abf3f80f32bda0d$export$43caf9889c228507)($00ec7d3e9aeca4ee$var$_Mutation_brand, this, $00ec7d3e9aeca4ee$var$_dispatch).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).config.onMutate) await (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).config.onMutate(variables, this, mutationFnContext);
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) === null || _this$options$onMutat === void 0 ? void 0 : _this$options$onMutat.call(_this$options, variables, mutationFnContext));
                if (context !== this.state.context) (0, $8abf3f80f32bda0d$export$43caf9889c228507)($00ec7d3e9aeca4ee$var$_Mutation_brand, this, $00ec7d3e9aeca4ee$var$_dispatch).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await retryer.start();
            await ((_classPrivateFieldGet3 = (_classPrivateFieldGet4 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).config).onSuccess) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.call(_classPrivateFieldGet4, data, variables, this.state.context, this, mutationFnContext));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) === null || _this$options$onSucce === void 0 ? void 0 : _this$options$onSucce.call(_this$options2, data, variables, this.state.context, mutationFnContext));
            await ((_classPrivateFieldGet5 = (_classPrivateFieldGet6 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).config).onSettled) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.call(_classPrivateFieldGet6, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) === null || _this$options$onSettl === void 0 ? void 0 : _this$options$onSettl.call(_this$options3, data, null, variables, this.state.context, mutationFnContext));
            (0, $8abf3f80f32bda0d$export$43caf9889c228507)($00ec7d3e9aeca4ee$var$_Mutation_brand, this, $00ec7d3e9aeca4ee$var$_dispatch).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _classPrivateFieldGet7, _classPrivateFieldGet8;
                await ((_classPrivateFieldGet7 = (_classPrivateFieldGet8 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).config).onError) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.call(_classPrivateFieldGet8, error, variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this$options$onError, _this$options4;
                await ((_this$options$onError = (_this$options4 = this.options).onError) === null || _this$options$onError === void 0 ? void 0 : _this$options$onError.call(_this$options4, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _classPrivateFieldGet9, _classPrivateFieldGet10;
                await ((_classPrivateFieldGet9 = (_classPrivateFieldGet10 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).config).onSettled) === null || _classPrivateFieldGet9 === void 0 ? void 0 : _classPrivateFieldGet9.call(_classPrivateFieldGet10, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this$options$onSettl2, _this$options5;
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) === null || _this$options$onSettl2 === void 0 ? void 0 : _this$options$onSettl2.call(_this$options5, void 0, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            (0, $8abf3f80f32bda0d$export$43caf9889c228507)($00ec7d3e9aeca4ee$var$_Mutation_brand, this, $00ec7d3e9aeca4ee$var$_dispatch).call(this, {
                type: "error",
                error: error
            });
            throw error;
        } finally{
            if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_retryer, this) === retryer) (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($00ec7d3e9aeca4ee$var$_retryer, this, void 0);
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).runNext(this);
        }
    }
};
function $00ec7d3e9aeca4ee$var$_dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_observers, this).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($00ec7d3e9aeca4ee$var$_mutationCache, this).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
}
/**
* Returns the initial state of a mutation: `'idle'`, with no data, error, or variables.
* @returns The initial mutation state.
*/ function $00ec7d3e9aeca4ee$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}


// src/mutationCache.ts
var $e7d7abf8511e6c6c$var$_mutations = /* @__PURE__ */ new WeakMap();
var $e7d7abf8511e6c6c$var$_scopes = /* @__PURE__ */ new WeakMap();
var $e7d7abf8511e6c6c$var$_mutationId = /* @__PURE__ */ new WeakMap();
/**
* The `MutationCache` is the storage for mutations.
*
* Normally, you will not interact with the `MutationCache` directly and instead use a
* `QueryClient`. You can subscribe to it (inherited from `Subscribable`) to be informed of
* safe/known updates to the cache, such as mutations being added, removed, or updated.
* @example
* ```ts
* const unsubscribe = mutationCache.subscribe((event) => {
*   console.log(event.type, event.mutation)
* })
* ```
*/ var $e7d7abf8511e6c6c$export$1fcfd9a244434844 = class extends (0, $5cb24f678e609491$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $e7d7abf8511e6c6c$var$_mutations, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $e7d7abf8511e6c6c$var$_scopes, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $e7d7abf8511e6c6c$var$_mutationId, void 0);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($e7d7abf8511e6c6c$var$_mutations, this, /* @__PURE__ */ new Set());
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($e7d7abf8511e6c6c$var$_scopes, this, /* @__PURE__ */ new Map());
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($e7d7abf8511e6c6c$var$_mutationId, this, 0);
    }
    /**
	* Creates a mutation and adds it to the cache.
	* @internal
	* @param client - The client the mutation belongs to, used to default its options.
	* @param options - The mutation options. They are defaulted with {@link
	* QueryClient#defaultMutationOptions}.
	* @param state - The initial state of the mutation, e.g. when restoring a dehydrated mutation.
	* @returns The new mutation, already added to the cache.
	*/ build(client, options, state) {
        var _this$mutationId;
        const mutation = new (0, $00ec7d3e9aeca4ee$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($e7d7abf8511e6c6c$var$_mutationId, this, (_this$mutationId = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_mutationId, this), ++_this$mutationId)),
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    /**
	* Adds a mutation to the cache.
	* @internal
	* @param mutation - The mutation to add. If it has a `scope`, it is queued in that scope.
	*/ add(mutation) {
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_mutations, this).add(mutation);
        const scope = $e7d7abf8511e6c6c$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_scopes, this).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_scopes, this).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    /**
	* Removes a mutation from the cache.
	* @internal
	* @param mutation - The mutation to remove, also from its scope's queue.
	*/ remove(mutation) {
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_mutations, this).delete(mutation)) {
            const scope = $e7d7abf8511e6c6c$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_scopes, this).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_scopes, this).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    /**
	* Checks whether a mutation can run now, given the other mutations in its `scope`.
	* @internal
	* @param mutation - The mutation to check.
	* @returns `true` if the mutation has no `scope`, or no other mutation in its scope is pending
	* ahead of it.
	*/ canRun(mutation) {
        const scope = $e7d7abf8511e6c6c$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_scopes, this).get(scope);
            const firstPendingMutation = mutationsWithSameScope === null || mutationsWithSameScope === void 0 ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    /**
	* Continues the next paused mutation in the same `scope` after a mutation finishes.
	* @internal
	* @param mutation - The mutation that finished.
	* @returns A promise that resolves once the next paused mutation in the same scope has continued,
	* or immediately if there is none.
	*/ runNext(mutation) {
        const scope = $e7d7abf8511e6c6c$var$scopeFor(mutation);
        if (typeof scope === "string") {
            var _classPrivateFieldGet2$1;
            const foundMutation = (_classPrivateFieldGet2$1 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_scopes, this).get(scope)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    /**
	* Removes all mutations from the cache.
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* mutationCache.clear()
	* ```
	*/ clear() {
        (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            const mutations = this.getAll();
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_mutations, this).clear();
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_scopes, this).clear();
            mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
        });
    }
    /**
	* Returns all mutations within the cache.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a mutation in rare scenarios.
	* @returns Every mutation in the cache.
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutations = mutationCache.getAll()
	* ```
	*/ getAll() {
        return Array.from((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($e7d7abf8511e6c6c$var$_mutations, this));
    }
    /**
	* A slightly more advanced method that can be used to get an existing mutation instance from
	* the cache. If the mutation does not exist, `undefined` is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a mutation in rare scenarios.
	* @param filters - The filters to match. `exact` defaults to `true`.
	* @returns The first matching mutation, or `undefined`.
	* @see {@link MutationCache#findAll}
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutation = mutationCache.find({ mutationKey: ['addPost'] })
	* ```
	*/ find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $ee0a7c55ac205e24$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    /**
	* An even more advanced method that can be used to get existing mutation instances from the
	* cache that match the given filters. If no mutations match, an empty array is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about mutations in rare scenarios.
	* @param filters - The filters to match. Without filters, every mutation is returned.
	* @returns The matching mutations.
	* @see {@link MutationCache#find}
	* @example
	* ```ts
	* const mutationCache = queryClient.getMutationCache()
	*
	* const mutations = mutationCache.findAll({ mutationKey: ['addPost'] })
	* ```
	*/ findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $ee0a7c55ac205e24$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    /**
	* Notifies every cache listener of an event, in one batch.
	* @internal
	* @param event - The event passed to every listener.
	*/ notify(event) {
        (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    /**
	* Continues every paused mutation, e.g. when the app comes back online.
	* @internal
	* @returns A promise that resolves once every paused mutation has continued and settled.
	*/ resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $ee0a7c55ac205e24$export$8793edee2d425525)))));
    }
};
/**
* Returns the scope id of a mutation, used to run mutations with the same scope one after another.
* @param mutation - The mutation to read the scope of.
* @returns The mutation's `scope.id`, or `undefined` if it has no scope.
*/ function $e7d7abf8511e6c6c$var$scopeFor(mutation) {
    var _mutation$options$sco;
    return (_mutation$options$sco = mutation.options.scope) === null || _mutation$options$sco === void 0 ? void 0 : _mutation$options$sco.id;
}












// src/infiniteQueryBehavior.ts
/**
* Creates the behavior that fetches the pages of an infinite query: the next or previous page for
* `fetchNextPage`/`fetchPreviousPage`, or all pages again from the start on a refetch.
* @param pages - The number of pages to fetch from the start when all pages are fetched again,
* e.g. from the `pages` option of `queryClient.infiniteQuery`. Defaults to the number of cached
* pages.
* @returns The query behavior to set on an infinite query.
*/ function $600b6110105f656d$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _context$fetchOptions, _context$state$data, _context$state$data2;
            const options = context.options;
            const direction = (_context$fetchOptions = context.fetchOptions) === null || _context$fetchOptions === void 0 || (_context$fetchOptions = _context$fetchOptions.meta) === null || _context$fetchOptions === void 0 || (_context$fetchOptions = _context$fetchOptions.fetchMore) === null || _context$fetchOptions === void 0 ? void 0 : _context$fetchOptions.direction;
            const oldPages = ((_context$state$data = context.state.data) === null || _context$state$data === void 0 ? void 0 : _context$state$data.pages) || [];
            const oldPageParams = ((_context$state$data2 = context.state.data) === null || _context$state$data2 === void 0 ? void 0 : _context$state$data2.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $ee0a7c55ac205e24$export$83f813cd1f8a4973)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $ee0a7c55ac205e24$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext);
                        return queryFnContext;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $ee0a7c55ac205e24$export$8c6246b73dd61f4a) : (0, $ee0a7c55ac205e24$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $600b6110105f656d$var$getPreviousPageParam : $600b6110105f656d$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    result = await fetchPage(oldData, pageParamFn(options, oldData), previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] === void 0 ? options.initialPageParam : oldPageParams[0] : $600b6110105f656d$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _context$options$pers, _context$options;
                return (_context$options$pers = (_context$options = context.options).persister) === null || _context$options$pers === void 0 ? void 0 : _context$options$pers.call(_context$options, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
/**
* Computes the page param of the page after the last one, with the `getNextPageParam` option.
* @param options - The infinite query options.
* @param data - The current pages and page params.
* @returns The next page param, or `undefined` if there are no pages yet.
*/ function $600b6110105f656d$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
/**
* Computes the page param of the page before the first one, with the `getPreviousPageParam`
* option.
* @param options - The infinite query options.
* @param data - The current pages and page params.
* @returns The previous page param, or `undefined` if there are no pages yet or no
* `getPreviousPageParam` option.
*/ function $600b6110105f656d$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _options$getPreviousP;
    return pages.length > 0 ? (_options$getPreviousP = options.getPreviousPageParam) === null || _options$getPreviousP === void 0 ? void 0 : _options$getPreviousP.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
/**
* Checks if there is a next page.
* @param options - The infinite query options with `getNextPageParam`.
* @param data - The current pages and page params.
* @returns `true` if `getNextPageParam` returns a value other than `null` or `undefined`.
*/ function $600b6110105f656d$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $600b6110105f656d$var$getNextPageParam(options, data) != null;
}
/**
* Checks if there is a previous page.
* @param options - The infinite query options with `getPreviousPageParam`.
* @param data - The current pages and page params.
* @returns `true` if `getPreviousPageParam` is set and returns a value other than `null` or
* `undefined`.
*/ function $600b6110105f656d$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $600b6110105f656d$var$getPreviousPageParam(options, data) != null;
}



// src/query.ts
var $54b7cad5678267da$var$_queryType = /* @__PURE__ */ new WeakMap();
var $54b7cad5678267da$var$_initialState = /* @__PURE__ */ new WeakMap();
var $54b7cad5678267da$var$_revertState = /* @__PURE__ */ new WeakMap();
var $54b7cad5678267da$var$_cache = /* @__PURE__ */ new WeakMap();
var $54b7cad5678267da$var$_client = /* @__PURE__ */ new WeakMap();
var $54b7cad5678267da$var$_retryer = /* @__PURE__ */ new WeakMap();
var $54b7cad5678267da$var$_defaultOptions = /* @__PURE__ */ new WeakMap();
var $54b7cad5678267da$var$_abortSignalConsumed = /* @__PURE__ */ new WeakMap();
var $54b7cad5678267da$var$_Query_brand = /* @__PURE__ */ new WeakSet();
/**
* Represents a single cached query. A `Query` holds the query's key, options,
* state (data/error/status), and the observers currently subscribed to it.
*
* Instances are created and managed internally by `QueryCache`; application
* code typically interacts with queries indirectly through `QueryClient` or
* a framework hook like `useQuery`. Direct access to a `Query` instance is
* possible via `queryCache.find()`/`findAll()` for inspecting cache state.
* @example
* ```ts
* const queryCache = queryClient.getQueryCache()
* const query = queryCache.find({ queryKey: ['posts'] })
*
* if (query) {
*   console.log(query.state.dataUpdatedAt)
* }
* ```
*/ var $54b7cad5678267da$export$62297b13309008b2 = class extends (0, $9dd0afac91a4d706$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $2f8b5ecae537244d$export$625550452a3fa3ec)(this, $54b7cad5678267da$var$_Query_brand);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $54b7cad5678267da$var$_queryType, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $54b7cad5678267da$var$_initialState, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $54b7cad5678267da$var$_revertState, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $54b7cad5678267da$var$_cache, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $54b7cad5678267da$var$_client, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $54b7cad5678267da$var$_retryer, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $54b7cad5678267da$var$_defaultOptions, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $54b7cad5678267da$var$_abortSignalConsumed, void 0);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_abortSignalConsumed, this, false);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_defaultOptions, this, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_client, this, config.client);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_cache, this, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_client, this).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_initialState, this, $54b7cad5678267da$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_initialState, this);
        this.scheduleGc();
    }
    /**
	* The `meta` object passed in the query's options, if any.
	* @returns The query's `meta`, or `undefined` if none was set.
	*/ get meta() {
        return this.options.meta;
    }
    /**
	* `'infinite'` for an infinite query, otherwise `undefined`.
	* @internal
	* @returns The type of the query, set from the `_type` option (e.g. `'infinite'`).
	*/ get queryType() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_queryType, this);
    }
    /**
	* The promise for the currently in-flight fetch, if the query is fetching.
	* `undefined` when the query is not fetching.
	* @returns The promise of the in-flight fetch, or `undefined`.
	*/ get promise() {
        var _classPrivateFieldGet2$1;
        return (_classPrivateFieldGet2$1 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.promise;
    }
    /**
	* Replaces the query's options and applies their `gcTime`. If the query has no data yet, it gets
	* the `initialData` from the new options, if any.
	* @internal
	* @param options - The new query options, merged on top of the query's default options.
	*/ setOptions(options) {
        this.options = {
            ...(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_defaultOptions, this),
            ...options
        };
        if (options === null || options === void 0 ? void 0 : options._type) (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_queryType, this, options._type);
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $54b7cad5678267da$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($54b7cad5678267da$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_initialState, this, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_cache, this).remove(this);
    }
    /**
	* Writes new data to the query and marks it as successfully fetched.
	* @internal
	* @param newData - The data to write. Structural sharing with the current data is applied.
	* @param options - Set `updatedAt` to override the timestamp, and `manual` to mark the write as
	* manual (e.g. from `queryClient.setQueryData`).
	* @returns The data that was written.
	*/ setData(newData, options) {
        const data = (0, $ee0a7c55ac205e24$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($54b7cad5678267da$var$_Query_brand, this, $54b7cad5678267da$var$_dispatch).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options === null || options === void 0 ? void 0 : options.updatedAt,
            manual: options === null || options === void 0 ? void 0 : options.manual
        });
        return data;
    }
    /**
	* Merges the given partial state directly into this query's state, notifying observers. Used
	* by persistence and broadcast plugins to restore a state snapshot, and by devtools to let a
	* user manually trigger a loading/error state or edit the cached data.
	* @param state - The partial state to merge into the query's state.
	*/ setState(state) {
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($54b7cad5678267da$var$_Query_brand, this, $54b7cad5678267da$var$_dispatch).call(this, {
            type: "setState",
            state: state
        });
    }
    /**
	* Cancels the query's currently in-flight fetch, if any.
	* - Returns a promise that resolves once the cancellation has settled.
	* - If no fetch is in progress, resolves immediately.
	* @param options - Set `revert` to restore the state from before the fetch started, and `silent`
	* to suppress the cancellation error when a new fetch replaces the cancelled one.
	* @returns A promise that resolves once the cancellation has settled.
	* @example
	* ```ts
	* await query.cancel()
	* ```
	*/ cancel(options) {
        var _classPrivateFieldGet3, _classPrivateFieldGet4;
        const promise = (_classPrivateFieldGet3 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.promise;
        (_classPrivateFieldGet4 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.cancel(options);
        return promise ? promise.then((0, $ee0a7c55ac205e24$export$8793edee2d425525)).catch((0, $ee0a7c55ac205e24$export$8793edee2d425525)) : Promise.resolve();
    }
    /**
	* Clears the query's garbage collection timeout and silently cancels any
	* in-flight fetch. Called by `QueryCache` when the query is removed from
	* the cache.
	* @see {@link Query#cancel}
	*/ destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    /**
	* The state the query was created with.
	* @internal
	* @returns The state the query had when it was first created, used by {@link Query#reset}.
	*/ get resetState() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_initialState, this);
    }
    /**
	* Resets the query back to its initial state (the state it had when it was
	* first created, e.g. any `initialData`), destroying it first to cancel any
	* in-flight fetch.
	*/ reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    /**
	* Returns `true` if the query has at least one observer for which `enabled`
	* does not resolve to `false`.
	* @returns `true` if the query has an enabled observer.
	*/ isActive() {
        return this.observers.some((observer)=>(0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(observer.options.enabled, this) !== false);
    }
    /**
	* Returns `true` if the query is disabled, meaning it will not fetch
	* automatically.
	* - If the query has observers, it is disabled when none of them are active
	*   (see `isActive`).
	* - If the query has no observers, it is disabled when its `queryFn` is
	*   `skipToken` or it has never been fetched.
	* @returns `true` if the query is disabled.
	*/ isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $ee0a7c55ac205e24$export$1aa5a89531b7670d) || !this.isFetched();
    }
    /**
	* Returns `true` if the query has been fetched, i.e. it has resolved with
	* either data or an error at least once.
	* @returns `true` if the query has been fetched.
	*/ isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    /**
	* Returns `true` if the query has at least one observer configured with
	* `staleTime: 'static'`, meaning it is treated as never stale.
	* @returns `true` if the query is static.
	*/ isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(observer.options.staleTime, this) === "static");
        return false;
    }
    /**
	* Returns `true` if the query is stale.
	* - If the query has observers, defers to whether any observer's current
	*   result reports `isStale` (which accounts for each observer's own
	*   `staleTime` and `enabled` state).
	* - If the query has no observers, it is considered stale when it has no
	*   data or has been invalidated.
	* @returns `true` if the query is stale.
	* @see {@link Query#isStaleByTime}
	* @example
	* ```ts
	* if (query.isStale()) {
	*   // refetch or otherwise treat the cached data as outdated
	* }
	* ```
	*/ isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    /**
	* Returns `true` if the query's data is stale relative to the given
	* `staleTime` (defaults to `0`).
	* - A query with no data is always stale.
	* - `staleTime: 'static'` is never stale.
	* - An invalidated query is always stale.
	* - Otherwise, staleness is based on elapsed time since `dataUpdatedAt`.
	* @param staleTime - The time, in milliseconds, after which data is considered stale, or
	* `'static'` to never treat existing data as stale. A query without data is stale either way.
	* @returns `true` if the query's data is stale.
	* @see {@link Query#isStale}
	* @example
	* ```ts
	* const isStale = query.isStaleByTime(60 * 1000)
	* ```
	*/ isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $ee0a7c55ac205e24$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    /**
	* Refetches the query when the window regains focus, if an observer wants that, and continues a
	* paused fetch.
	* @internal
	*/ onFocus() {
        var _classPrivateFieldGet5;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer === null || observer === void 0 || observer.refetch({
            cancelRefetch: false
        });
        (_classPrivateFieldGet5 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.continue();
    }
    /**
	* Refetches the query when the app reconnects, if an observer wants that, and continues a paused
	* fetch.
	* @internal
	*/ onOnline() {
        var _classPrivateFieldGet6;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer === null || observer === void 0 || observer.refetch({
            cancelRefetch: false
        });
        (_classPrivateFieldGet6 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.continue();
    }
    /**
	* Subscribes an observer to the query and stops its garbage collection.
	* @internal
	* @param observer - The observer to add. Adding an observer that is already subscribed does
	* nothing.
	*/ addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_cache, this).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    /**
	* Unsubscribes an observer from the query.
	* @internal
	* @param observer - The observer to remove. When the last observer is removed, the in-flight
	* fetch is cancelled if its abort signal was consumed (otherwise only its retries are stopped),
	* and garbage collection is scheduled.
	*/ removeObserver(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
            if (!this.observers.length) {
                if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this)) {
                    if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_abortSignalConsumed, this) || this.state.fetchStatus === "paused" && this.state.status === "pending") (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this).cancel({
                        revert: true
                    });
                    else (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_cache, this).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    /**
	* Returns the number of observers currently subscribed to this query.
	* @returns The number of observers.
	* @example
	* ```ts
	* if (query.getObserversCount() === 0) {
	*   // no component is currently watching this query
	* }
	* ```
	*/ getObserversCount() {
        return this.observers.length;
    }
    /**
	* Marks the query as invalidated, unless it is already invalidated. This
	* updates `state.isInvalidated` and notifies observers, but does not by
	* itself trigger a refetch.
	* @example
	* ```ts
	* query.invalidate()
	* ```
	*/ invalidate() {
        if (!this.state.isInvalidated) (0, $8abf3f80f32bda0d$export$43caf9889c228507)($54b7cad5678267da$var$_Query_brand, this, $54b7cad5678267da$var$_dispatch).call(this, {
            type: "invalidate"
        });
    }
    /**
	* Fetches the query, i.e. runs its `queryFn` (through any configured
	* retryer/behavior) and updates the query's state with the result.
	* - If a fetch is already in flight, returns its promise instead of
	*   starting a new one, unless `fetchOptions.cancelRefetch` is set and the
	*   query already has data, in which case the current fetch is silently
	*   cancelled first.
	* - If `options` is passed, it replaces the query's current options
	*   before fetching.
	* @param options - Query options that replace the query's current options before fetching. They
	* are not applied when an in-flight fetch is reused.
	* @param fetchOptions - Set `cancelRefetch` to cancel an in-flight fetch first (only if the query
	* already has data), and `meta` to pass extra information to the query's behavior.
	* @returns A promise that resolves with the fetched data, or rejects with the fetch error. If the
	* fetch is cancelled with `revert` while the query has data, it resolves with the restored data
	* instead.
	*/ async fetch(options, fetchOptions) {
        var _classPrivateFieldGet7, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle" && ((_classPrivateFieldGet7 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this)) {
                (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this).continueRetry();
                return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_abortSignalConsumed, this, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $ee0a7c55ac205e24$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext = {
                    client: (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_client, this),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext);
                return queryFnContext;
            };
            const queryFnContext = createQueryFnContext();
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_abortSignalConsumed, this, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_client, this),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context);
            return context;
        };
        const context = createFetchContext();
        const behavior = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_queryType, this) === "infinite" ? (0, $600b6110105f656d$export$84470d1367601e8d)(this.options.pages) : this.options.behavior;
        behavior === null || behavior === void 0 || behavior.onFetch(context, this);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_revertState, this, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) === null || _context$fetchOptions === void 0 ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            (0, $8abf3f80f32bda0d$export$43caf9889c228507)($54b7cad5678267da$var$_Query_brand, this, $54b7cad5678267da$var$_dispatch).call(this, {
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) === null || _context$fetchOptions2 === void 0 ? void 0 : _context$fetchOptions2.meta
            });
        }
        const retryer = (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_retryer, this, (0, $897430696a6e5e77$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $897430696a6e5e77$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_revertState, this),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $8abf3f80f32bda0d$export$43caf9889c228507)($54b7cad5678267da$var$_Query_brand, this, $54b7cad5678267da$var$_dispatch).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $8abf3f80f32bda0d$export$43caf9889c228507)($54b7cad5678267da$var$_Query_brand, this, $54b7cad5678267da$var$_dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $8abf3f80f32bda0d$export$43caf9889c228507)($54b7cad5678267da$var$_Query_brand, this, $54b7cad5678267da$var$_dispatch).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            var _classPrivateFieldGet8, _classPrivateFieldGet9, _classPrivateFieldGet10, _classPrivateFieldGet11;
            const data = await retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_classPrivateFieldGet8 = (_classPrivateFieldGet9 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_cache, this).config).onSuccess) === null || _classPrivateFieldGet8 === void 0 || _classPrivateFieldGet8.call(_classPrivateFieldGet9, data, this);
            (_classPrivateFieldGet10 = (_classPrivateFieldGet11 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_cache, this).config).onSettled) === null || _classPrivateFieldGet10 === void 0 || _classPrivateFieldGet10.call(_classPrivateFieldGet11, data, this.state.error, this);
            return data;
        } catch (error) {
            var _classPrivateFieldGet12, _classPrivateFieldGet13, _classPrivateFieldGet14, _classPrivateFieldGet15;
            if (error instanceof (0, $897430696a6e5e77$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $8abf3f80f32bda0d$export$43caf9889c228507)($54b7cad5678267da$var$_Query_brand, this, $54b7cad5678267da$var$_dispatch).call(this, {
                type: "error",
                error: error
            });
            (_classPrivateFieldGet12 = (_classPrivateFieldGet13 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_cache, this).config).onError) === null || _classPrivateFieldGet12 === void 0 || _classPrivateFieldGet12.call(_classPrivateFieldGet13, error, this);
            (_classPrivateFieldGet14 = (_classPrivateFieldGet15 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_cache, this).config).onSettled) === null || _classPrivateFieldGet14 === void 0 || _classPrivateFieldGet14.call(_classPrivateFieldGet15, this.state.data, error, this);
            throw error;
        } finally{
            if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_retryer, this) === retryer) (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_retryer, this, void 0);
            this.scheduleGc();
        }
    }
};
function $54b7cad5678267da$var$_dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$54b7cad5678267da$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    ...$54b7cad5678267da$var$successState(action.data, action.dataUpdatedAt),
                    dataUpdateCount: state.dataUpdateCount + 1,
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($54b7cad5678267da$var$_revertState, this, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error",
                    isInvalidated: true
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
        this.observers.slice().forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($54b7cad5678267da$var$_cache, this).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
}
/**
* Returns the state changes applied when a query starts fetching.
* @param data - The query's current data. If it is `undefined`, the query is also reset to
* `'pending'` with no error.
* @param options - The query options, whose `networkMode` decides whether the query is `'fetching'`
* or `'paused'`.
* @returns The partial query state for a starting fetch.
*/ function $54b7cad5678267da$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $897430696a6e5e77$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
/**
* Returns the state changes applied when a query receives data.
* @param data - The new data.
* @param dataUpdatedAt - The timestamp the data is recorded with. Defaults to the current time.
* @returns The partial query state for a successful update.
*/ function $54b7cad5678267da$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
/**
* Returns the initial state of a query, based on its `initialData` and `initialDataUpdatedAt`
* options.
* @param options - The query options.
* @returns The initial query state: `'success'` if `initialData` is set, otherwise `'pending'`.
*/ function $54b7cad5678267da$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}


// src/queryCache.ts
var $ce990c829ca9b703$var$_queries = /* @__PURE__ */ new WeakMap();
/**
* The `QueryCache` is the storage mechanism for TanStack Query. It stores all the data, meta
* information, and state of the queries it contains.
*
* Normally, you will not interact with the `QueryCache` directly and instead use a `QueryClient`
* for a specific cache. You can subscribe to it (inherited from `Subscribable`) to be informed of
* safe/known updates to the cache, such as queries being added, removed, or updated — updates made
* outside of the cache's own tracked mechanisms (e.g. mutating a query's state object directly) do
* not notify subscribers.
* @example
* ```ts
* const unsubscribe = queryCache.subscribe((event) => {
*   console.log(event.type, event.query)
* })
* ```
*/ var $ce990c829ca9b703$export$5dde0cd941da8468 = class extends (0, $5cb24f678e609491$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $ce990c829ca9b703$var$_queries, void 0);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($ce990c829ca9b703$var$_queries, this, /* @__PURE__ */ new Map());
    }
    /**
	* Returns the existing `Query` instance for the given options' `queryKey`/`queryHash`, or
	* builds and adds a new one to the cache if none exists yet. Used by framework adapters and
	* plugins (e.g. broadcast/persistence) that need to get-or-create a `Query` directly, bypassing
	* the reactive `QueryObserver` machinery.
	* @param client - The client the query belongs to, used to default its options.
	* @param options - The query options, including the `queryKey`. A new query is created with the
	* options defaulted by {@link QueryClient#defaultQueryOptions}.
	* @param state - The initial state of a newly created query, e.g. when hydrating. Ignored if the
	* query already exists.
	* @returns The existing or newly created query.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const query = queryCache.build(queryClient, {
	*   queryKey: ['posts'],
	*   queryFn: fetchPosts,
	* })
	* ```
	*/ build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $ee0a7c55ac205e24$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $54b7cad5678267da$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    /**
	* Adds a query to the cache.
	* @internal
	* @param query - The query to add. If a query with the same hash is already cached, nothing
	* happens.
	*/ add(query) {
        if (!(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($ce990c829ca9b703$var$_queries, this).has(query.queryHash)) {
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($ce990c829ca9b703$var$_queries, this).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    /**
	* Destroys the given `Query` and removes it from the cache, notifying subscribers with a
	* `'removed'` event. A no-op if the query is no longer the one currently stored under its hash
	* (e.g. it was already replaced). Used by plugins (e.g. the broadcast client) that mirror
	* removals across `QueryCache` instances.
	* @param query - The query to remove.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	* const query = queryCache.find({ queryKey: ['posts'] })
	*
	* if (query) {
	*   queryCache.remove(query)
	* }
	* ```
	*/ remove(query) {
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($ce990c829ca9b703$var$_queries, this).get(query.queryHash) === query) {
            query.destroy();
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($ce990c829ca9b703$var$_queries, this).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    /**
	* Removes all queries from the cache.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* queryCache.clear()
	* ```
	*/ clear() {
        (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    /**
	* Returns the `Query` instance stored under the given `queryHash`, or `undefined` if none
	* exists. Unlike {@link QueryCache#find}, this looks up by the already-computed hash rather
	* than by `QueryFilters`. Used by plugins (e.g. broadcast/hydration) that already have a hash
	* to look up directly.
	* @param queryHash - The hash of the query to look up.
	* @returns The query stored under the hash, or `undefined`.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	* const queryHash = hashKey(['posts'])
	*
	* const query = queryCache.get(queryHash)
	* ```
	*/ get(queryHash) {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($ce990c829ca9b703$var$_queries, this).get(queryHash);
    }
    /**
	* Returns all queries within the cache.
	* @returns Every query in the cache.
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const queries = queryCache.getAll()
	* ```
	*/ getAll() {
        return [
            ...(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($ce990c829ca9b703$var$_queries, this).values()
        ];
    }
    /**
	* A slightly more advanced method that can be used to get an existing query instance from the
	* cache. This instance not only contains all the state for the query, but all of the instances,
	* and underlying guts of the query as well. If the query does not exist, `undefined` is
	* returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about a query in rare scenarios (e.g. looking at `query.state.dataUpdatedAt` to
	* decide whether a query is fresh enough to be used as an initial value).
	* @param filters - The filters to match, including the required `queryKey`. `exact` defaults to
	* `true`.
	* @returns The first matching query, or `undefined`.
	* @see {@link QueryCache#findAll}
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const query = queryCache.find({ queryKey: ['posts'] })
	* ```
	*/ find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $ee0a7c55ac205e24$export$c5d1efe363797780)(defaultedFilters, query));
    }
    /**
	* An even more advanced method that can be used to get existing query instances from the cache
	* that partially match a query key. If no queries match, an empty array is returned.
	*
	* This is not typically needed for most applications, but can come in handy when needing more
	* information about queries in rare scenarios.
	* @param filters - The filters to match. Without filters, every query is returned.
	* @returns The matching queries.
	* @see {@link QueryCache#find}
	* @example
	* ```ts
	* const queryCache = queryClient.getQueryCache()
	*
	* const queries = queryCache.findAll({ queryKey: ['posts'] })
	* ```
	*/ findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $ee0a7c55ac205e24$export$c5d1efe363797780)(filters, query)) : queries;
    }
    /**
	* Notifies every cache listener of an event, in one batch.
	* @internal
	* @param event - The event passed to every listener.
	*/ notify(event) {
        (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    /**
	* Calls {@link Query#onFocus} on every cached query, in one batch.
	* @internal
	*/ onFocus() {
        (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    /**
	* Calls {@link Query#onOnline} on every cached query, in one batch.
	* @internal
	*/ onOnline() {
        (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};


// src/queryClient.ts
var $c35f27cd41559d1f$var$_queryCache = /* @__PURE__ */ new WeakMap();
var $c35f27cd41559d1f$var$_mutationCache = /* @__PURE__ */ new WeakMap();
var $c35f27cd41559d1f$var$_defaultOptions = /* @__PURE__ */ new WeakMap();
var $c35f27cd41559d1f$var$_queryDefaults = /* @__PURE__ */ new WeakMap();
var $c35f27cd41559d1f$var$_mutationDefaults = /* @__PURE__ */ new WeakMap();
var $c35f27cd41559d1f$var$_mountCount = /* @__PURE__ */ new WeakMap();
var $c35f27cd41559d1f$var$_unsubscribeFocus = /* @__PURE__ */ new WeakMap();
var $c35f27cd41559d1f$var$_unsubscribeOnline = /* @__PURE__ */ new WeakMap();
/**
* `QueryClient` is used to interact with a cache of queries and mutations. It owns a
* `QueryCache` and a `MutationCache` (creating default ones if none are passed in) and holds
* the default options that are applied to queries and mutations created through it.
* @example
* ```ts
* const queryClient = new QueryClient({
*   defaultOptions: {
*     queries: {
*       staleTime: Infinity,
*     },
*   },
* })
*
* await queryClient.query({ queryKey: ['posts'], queryFn: fetchPosts })
* ```
*/ var $c35f27cd41559d1f$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $c35f27cd41559d1f$var$_queryCache, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $c35f27cd41559d1f$var$_mutationCache, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $c35f27cd41559d1f$var$_defaultOptions, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $c35f27cd41559d1f$var$_queryDefaults, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $c35f27cd41559d1f$var$_mutationDefaults, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $c35f27cd41559d1f$var$_mountCount, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $c35f27cd41559d1f$var$_unsubscribeFocus, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $c35f27cd41559d1f$var$_unsubscribeOnline, void 0);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_queryCache, this, config.queryCache || new (0, $ce990c829ca9b703$export$5dde0cd941da8468)());
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_mutationCache, this, config.mutationCache || new (0, $e7d7abf8511e6c6c$export$1fcfd9a244434844)());
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_defaultOptions, this, config.defaultOptions || {});
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_queryDefaults, this, /* @__PURE__ */ new Map());
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_mutationDefaults, this, /* @__PURE__ */ new Map());
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_mountCount, this, 0);
    }
    /**
	* Called by a framework adapter's `QueryClientProvider`-equivalent when it mounts, to start
	* listening for focus/online events and resume paused mutations. Ref-counted via an internal
	* mount count, so nested or multiple providers sharing the same `QueryClient` don't tear down
	* the shared listeners until the last one unmounts.
	*/ mount() {
        var _this$mountCount;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_mountCount, this, (_this$mountCount = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mountCount, this), _this$mountCount++, _this$mountCount));
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mountCount, this) !== 1) return;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_unsubscribeFocus, this, (0, $fddc2922147f8f96$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).onFocus();
            }
        }));
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_unsubscribeOnline, this, (0, $322e88328cdac36c$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).onOnline();
            }
        }));
    }
    /**
	* The inverse of {@link QueryClient#mount} — called by a framework adapter's
	* `QueryClientProvider`-equivalent when it unmounts. Only tears down the focus/online
	* listeners once the mount count returns to `0`.
	*/ unmount() {
        var _this$mountCount3, _classPrivateFieldGet2$1, _classPrivateFieldGet3;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_mountCount, this, (_this$mountCount3 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mountCount, this), _this$mountCount3--, _this$mountCount3));
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mountCount, this) !== 0) return;
        (_classPrivateFieldGet2$1 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_unsubscribeFocus, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_unsubscribeFocus, this, void 0);
        (_classPrivateFieldGet3 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_unsubscribeOnline, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_unsubscribeOnline, this, void 0);
    }
    /**
	* Returns the number of queries in the cache that are currently fetching, optionally
	* matching a set of filters. This includes background-fetching, loading new pages, and
	* loading more infinite query results.
	* @param filters - Narrows down which fetching queries are counted. Without filters, every
	* fetching query is counted.
	* @returns The number of matching queries whose `fetchStatus` is `'fetching'`.
	* @example
	* ```ts
	* if (queryClient.isFetching()) {
	*   console.log('At least one query is fetching!')
	* }
	* ```
	*/ isFetching(filters) {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    /**
	* Returns the number of mutations in the cache that are currently pending, optionally
	* matching a set of filters.
	* @param filters - Narrows down which pending mutations are counted. Without filters, every
	* pending mutation is counted.
	* @returns The number of matching mutations whose `status` is `'pending'`.
	* @example
	* ```ts
	* if (queryClient.isMutating()) {
	*   console.log('At least one mutation is pending!')
	* }
	* ```
	*/ isMutating(filters) {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mutationCache, this).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
	* Imperative (non-reactive) way to retrieve data for a QueryKey.
	* Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
	*
	* Hint: Do not use this function inside a component, because it won't receive updates.
	* Use `useQuery` to create a `QueryObserver` that subscribes to changes.
	* @param queryKey - The query key of the query to read.
	* @returns The cached data for the query, or `undefined` if no query with this key has been observed yet.
	* @see {@link QueryClient#getQueriesData}
	*/ getQueryData(queryKey) {
        var _classPrivateFieldGet4;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_classPrivateFieldGet4 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).get(options.queryHash)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.state.data;
    }
    /**
	* Returns the cached data of a query, or fetches it if there is none. With `revalidateIfStale`,
	* stale cached data is also refetched in the background.
	* @param options - The query options. If the query has no cached data yet, it is fetched with
	* these options.
	* @returns A promise that resolves to the cached data, or to the fetched data if nothing was
	* cached yet.
	* @deprecated Use queryClient.query({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    /**
	* Imperative (non-reactive) way to retrieve the cached data of multiple queries at once.
	* Only queries matching the given filters are returned; if none match, an empty array is
	* returned.
	*
	* Because the matched queries can hold data of different shapes (e.g. a broad filter can match
	* queries with unrelated data types), the `TQueryFnData` generic defaults to `unknown` rather
	* than being inferred. Passing a more specific type is a convenience for call sites that know
	* every matched query holds the same shape — it is not checked against the actual cache
	* contents.
	* @param filters - The filters that select which queries to read.
	* @returns An array of query key and data pairs. The data is `undefined` for a query with no cached data.
	* @see {@link QueryClient#getQueryData}
	* @example
	* ```ts
	* const data = queryClient.getQueriesData({ queryKey: ['posts'] })
	* ```
	*/ getQueriesData(filters) {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            return [
                queryKey,
                state.data
            ];
        });
    }
    /**
	* Synchronous way to immediately update a query's cached data. If the updater (or the value
	* passed) resolves to `undefined`, the cache is left untouched and no query is created;
	* otherwise, if the query does not exist yet, it will be created. To update multiple queries
	* at once by partially matching query keys, use {@link QueryClient#setQueriesData} instead.
	*
	* Updates must be performed immutably: do not mutate `oldData`, or data previously retrieved
	* via {@link QueryClient#getQueryData}, in place.
	* @param queryKey - The query key to set data for.
	* @param updater - Either the new data, or a function that receives the current data (which
	* may be `undefined`) and returns the new data.
	* @param options - Set `updatedAt` to override the timestamp the written data is recorded with.
	* @returns The data that was written, or `undefined` if the updater returned `undefined` — in that case
	* the write is skipped and the cache is left unchanged.
	* @example
	* ```ts
	* queryClient.setQueryData(['posts'], newPosts)
	*
	* // Or, using an updater function that receives the current data:
	* queryClient.setQueryData(['posts'], (oldPosts) => [...oldPosts, newPost])
	* ```
	*/ setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).get(defaultedOptions.queryHash);
        const prevData = query === null || query === void 0 ? void 0 : query.state.data;
        const data = (0, $ee0a7c55ac205e24$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return;
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    /**
	* Synchronous way to immediately update the cached data of multiple queries at once, using
	* filters or partial query key matching. Only queries that already exist and match the given
	* filters are updated; no new cache entries are created. Internally this calls
	* {@link QueryClient#setQueryData} for each matching query.
	* @param filters - The filters that select which existing queries to update.
	* @param updater - Either the new data, or a function that receives each matched query's current
	* data (which may be `undefined`) and returns the new data.
	* @param options - Set `updatedAt` to override the timestamp the written data is recorded with.
	* @returns One `[queryKey, data]` tuple per matched query, in the same shape and with the same
	* `undefined` case as {@link QueryClient#setQueryData}.
	* @example
	* ```ts
	* queryClient.setQueriesData({ queryKey: ['posts'] }, (oldPosts) =>
	*   oldPosts ? oldPosts.filter((post) => post.id !== deletedId) : oldPosts,
	* )
	* ```
	*/ setQueriesData(filters, updater, options) {
        return (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    /**
	* Imperative (non-reactive) way to retrieve an existing query's state. If the query does not
	* exist, `undefined` is returned.
	* @param queryKey - The query key of the query to read.
	* @returns The query's state, or `undefined` if no query with this key exists.
	* @example
	* ```ts
	* const state = queryClient.getQueryState(['posts'])
	* console.log(state?.dataUpdatedAt)
	* ```
	*/ getQueryState(queryKey) {
        var _classPrivateFieldGet5;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_classPrivateFieldGet5 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).get(options.queryHash)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.state;
    }
    /**
	* Removes queries from the cache that match the given filters. Unlike
	* {@link QueryClient#invalidateQueries} or {@link QueryClient#refetchQueries}, this removes
	* matching queries from the cache instead of refetching them. Without filters, every query in
	* the cache is removed.
	* @param filters - The filters that select which queries to remove. Without filters, every query
	* is removed.
	* @example
	* ```ts
	* queryClient.removeQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ removeQueries(filters) {
        const queryCache = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this);
        (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
	* Resets queries matching the given filters back to their initial state (e.g. any
	* `initialData`), notifying subscribers rather than removing them. Active queries among the
	* matched set are then refetched, and the returned promise resolves once that refetch settles.
	* @param filters - The filters that select which queries to reset. Without filters, every query
	* is reset.
	* @param options - Passed to the refetch of the active matched queries, e.g. `cancelRefetch` and
	* `throwOnError`.
	* @returns A promise that resolves once the refetch of the active matched queries settles.
	* @example
	* ```ts
	* await queryClient.resetQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ resetQueries(filters, options) {
        const queryCache = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this);
        return (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            const matched = queryCache.findAll(filters);
            const queriesToRefetch = new Set(matched);
            matched.forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                predicate: (query)=>queriesToRefetch.has(query)
            }, options);
        });
    }
    /**
	* Cancels outgoing fetches for queries matching the given filters. Most useful when performing
	* optimistic updates, since any outgoing refetch that resolves afterwards would otherwise
	* overwrite the optimistic update. By default (`revert: true`), a cancelled query's data is
	* reverted to its state before the outgoing fetch started.
	*
	* The returned promise never rejects, even if individual cancellations fail.
	* @param filters - The filters that select which queries to cancel. Without filters, every query
	* is cancelled.
	* @param cancelOptions - Passed to each matched query's cancellation. `revert` defaults to
	* `true`.
	* @returns A promise that resolves once every cancellation has settled.
	* @example
	* ```ts
	* await queryClient.cancelQueries({ queryKey: ['posts'], exact: true })
	* ```
	*/ cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $ee0a7c55ac205e24$export$8793edee2d425525)).catch((0, $ee0a7c55ac205e24$export$8793edee2d425525));
    }
    /**
	* Marks queries matching the given filters as invalidated. Unlike
	* {@link QueryClient#removeQueries}, invalidated queries stay in the cache.
	*
	* Unless `filters.refetchType` is `'none'`, matching queries are then refetched via
	* {@link QueryClient#refetchQueries}, using `filters.refetchType` if set, otherwise
	* `filters.type`, otherwise `'active'`.
	* @param filters - The filters that select which queries to invalidate, plus `refetchType` to
	* control which of them to refetch afterwards. Without filters, every query is invalidated.
	* @param options - Passed to {@link QueryClient#refetchQueries}, e.g. `cancelRefetch` and
	* `throwOnError`.
	* @returns A promise that resolves once the refetch settles, or immediately if `refetchType` is
	* `'none'`.
	* @example
	* ```ts
	* await queryClient.invalidateQueries({ queryKey: ['posts'], refetchType: 'active' })
	* ```
	*/ invalidateQueries(filters, options = {}) {
        return (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters === null || filters === void 0 ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters === null || filters === void 0 ? void 0 : filters.refetchType) ?? (filters === null || filters === void 0 ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    /**
	* Refetches queries matching the given filters, regardless of whether they are stale. Without
	* filters, every query in the cache is refetched. Queries that are disabled, or static (only
	* have observers with a static `staleTime`), are never refetched.
	*
	* By default (`cancelRefetch: true`), a currently running fetch is cancelled before the new
	* one starts. The returned promise resolves once all matching queries have settled; it does
	* not reject on individual query failures unless `throwOnError` is set.
	* @param filters - The filters that select which queries to refetch. Without filters, every query
	* in the cache is included.
	* @param options - Set `cancelRefetch` to `false` to keep a running fetch instead of cancelling
	* it, and `throwOnError` to `true` to reject when a refetch fails.
	* @returns A promise that resolves once every matched query has settled.
	* @example
	* ```ts
	* // refetch all active queries partially matching a query key:
	* await queryClient.refetchQueries({ queryKey: ['posts'], type: 'active' })
	* ```
	*/ refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $ee0a7c55ac205e24$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $ee0a7c55ac205e24$export$8793edee2d425525));
    }
    /**
	* Asynchronous method to fetch and cache a query, resolving with the data or throwing with
	* the error.
	*
	* If the query already exists in the cache and its data is not stale (per the given
	* `staleTime`), the cached data is returned without fetching. Otherwise, the query is fetched
	* and the promise resolves once the fetch settles. If a `select` function is provided, it is
	* applied to the data in both cases (cached or freshly fetched) before it is returned.
	*
	* Unlike a reactive observer, retries are disabled by default here (`retry: false`) unless
	* explicitly configured, since there is no component to catch a thrown error and retry through
	* re-render.
	*
	* The accepted options are `QueryObserverOptions` minus the fields that only make sense for a
	* reactive observer — `enabled`, `refetchInterval`, `refetchIntervalInBackground`,
	* `refetchOnWindowFocus`, `refetchOnReconnect`, `refetchOnMount`, `retryOnMount`,
	* `notifyOnChangeProps`, `throwOnError`, `suspense`, and `placeholderData` are not part of this
	* method's options.
	*
	* This method replaces the deprecated `fetchQuery`, and — combined with
	* `{ staleTime: 'static' }` — the deprecated `ensureQueryData`.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves to the data, or to the result of `select` if provided. It
	* rejects with the error from the fetch or from `select`.
	* @example
	* ```ts
	* try {
	*   const data = await queryClient.query({ queryKey, queryFn, staleTime: 10000 })
	* } catch (error) {
	*   console.log(error)
	* }
	* ```
	*/ async query(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).build(this, defaultedOptions);
        const queryData = query.isStaleByTime((0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query)) ? await query.fetch(defaultedOptions) : query.state.data;
        const select = defaultedOptions.select;
        if (select) return select(queryData);
        return queryData;
    }
    /**
	* Fetches and caches a query, or returns its cached data if it isn't stale. Unlike in observers,
	* the fetch isn't retried unless `retry` is set.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves to the cached or fetched data, or rejects with the fetch
	* error.
	* @deprecated Use queryClient.query(options) instead. This method will be removed in the next major version.
	*/ fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).build(this, defaultedOptions);
        return query.isStaleByTime((0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
	* Fetches and caches a query like {@link QueryClient#fetchQuery}, but ignores the result and any
	* error.
	* @param options - The query options, including the `queryKey` and the `queryFn` used if the
	* query needs to fetch.
	* @returns A promise that resolves once the fetch settles. It never rejects.
	* @deprecated Use queryClient.query(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $ee0a7c55ac205e24$export$8793edee2d425525)).catch((0, $ee0a7c55ac205e24$export$8793edee2d425525));
    }
    /**
	* Asynchronous method to fetch and cache an infinite query, resolving with an
	* {@link InfiniteData} object or throwing with the error.
	*
	* Behaves like {@link QueryClient#query}, accepting the same options (minus
	* `initialPageParam`), plus the required `initialPageParam`, and an optional `pages` /
	* `getNextPageParam` pair used to refetch a fixed number of pages from the start.
	*
	* This method replaces the deprecated `fetchInfiniteQuery`, and — combined with
	* `{ staleTime: 'static' }` — the deprecated `ensureInfiniteQueryData`.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves to the {@link InfiniteData}, or to the result of `select` if
	* provided. It rejects with the error from the fetch or from `select`.
	* @example
	* ```ts
	* try {
	*   const data = await queryClient.infiniteQuery({ queryKey, queryFn, initialPageParam: 0 })
	*   console.log(data.pages)
	* } catch (error) {
	*   console.log(error)
	* }
	* ```
	*/ infiniteQuery(options) {
        options._type = "infinite";
        return this.query(options);
    }
    /**
	* Fetches and caches an infinite query, or returns its cached data if it isn't stale.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves to the cached or fetched {@link InfiniteData}, or rejects with
	* the fetch error.
	* @deprecated Use queryClient.infiniteQuery(options) instead. This method will be removed in the next major version.
	*/ fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    /**
	* Fetches and caches an infinite query like {@link QueryClient#fetchInfiniteQuery}, but ignores
	* the result and any error.
	* @param options - The infinite query options, including the `queryKey`, the `queryFn`, and the
	* `initialPageParam`.
	* @returns A promise that resolves once the fetch settles. It never rejects.
	* @deprecated Use queryClient.infiniteQuery(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $ee0a7c55ac205e24$export$8793edee2d425525)).catch((0, $ee0a7c55ac205e24$export$8793edee2d425525));
    }
    /**
	* Returns the cached data of an infinite query, or fetches it if there is none. With
	* `revalidateIfStale`, stale cached data is also refetched in the background.
	* @param options - The infinite query options. If the query has no cached data yet, it is fetched
	* with these options.
	* @returns A promise that resolves to the cached {@link InfiniteData}, or to the fetched data if
	* nothing was cached yet.
	* @deprecated Use queryClient.infiniteQuery({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    /**
	* Resumes mutations that were paused because there was no network connection. Does nothing
	* (resolving immediately) if the client is currently offline.
	* @returns A promise that resolves once the resumed mutations have settled.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* await queryClient.resumePausedMutations()
	* ```
	*/ resumePausedMutations() {
        if ((0, $322e88328cdac36c$export$b113e788b2dd3fdc).isOnline()) return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mutationCache, this).resumePausedMutations();
        return Promise.resolve();
    }
    /**
	* Returns the query cache this client is connected to.
	* @returns The {@link QueryCache} instance.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const queryCache = queryClient.getQueryCache()
	* const queries = queryCache.findAll({ queryKey: ['posts'] })
	* ```
	*/ getQueryCache() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this);
    }
    /**
	* Returns the mutation cache this client is connected to.
	* @returns The {@link MutationCache} instance.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const mutationCache = queryClient.getMutationCache()
	* const mutations = mutationCache.findAll({ status: 'pending' })
	* ```
	*/ getMutationCache() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mutationCache, this);
    }
    /**
	* Returns the default options that were set when creating the client, or via
	* {@link QueryClient#setDefaultOptions}.
	* @returns The client's current default options.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* const defaultOptions = queryClient.getDefaultOptions()
	* ```
	*/ getDefaultOptions() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_defaultOptions, this);
    }
    /**
	* Dynamically sets the default options for this client, overwriting any previously defined
	* default options.
	* @param options - The new default options for queries and mutations.
	* @see {@link QueryClient#getDefaultOptions}
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* queryClient.setDefaultOptions({
	*   queries: {
	*     staleTime: Infinity,
	*   },
	* })
	* ```
	*/ setDefaultOptions(options) {
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($c35f27cd41559d1f$var$_defaultOptions, this, options);
    }
    /**
	* Sets default options for queries whose query key partially matches the given `queryKey`.
	*
	* If several registered query defaults match a given query key, they are merged together in
	* registration order by {@link QueryClient#getQueryDefaults}, so register defaults from the
	* most generic key to the least generic one — more specific defaults should be registered
	* after more generic ones so they take precedence.
	* @param queryKey - The query key that query keys are partially matched against.
	* @param options - The default options applied to matching queries.
	* @example
	* ```ts
	* queryClient.setQueryDefaults(['posts'], { queryFn: fetchPosts })
	*
	* await queryClient.query({ queryKey: ['posts'] })
	* ```
	*/ setQueryDefaults(queryKey, options) {
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryDefaults, this).set((0, $ee0a7c55ac205e24$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    /**
	* Returns the default options registered for queries whose query key partially matches the
	* given `queryKey`, via {@link QueryClient#setQueryDefaults}. If multiple registered defaults
	* match, they are merged together in registration order.
	* @param queryKey - The query key to look up registered defaults for.
	* @returns The merged default options of every registration that matches, or an empty object if
	* none match.
	* @example
	* ```ts
	* const defaultOptions = queryClient.getQueryDefaults(['posts'])
	* ```
	*/ getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryDefaults, this).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $ee0a7c55ac205e24$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    /**
	* Sets default options for mutations whose mutation key partially matches the given
	* `mutationKey`. As with {@link QueryClient#setQueryDefaults}, the order of registration
	* matters when several registered defaults match the same mutation key.
	* @param mutationKey - The mutation key that mutation keys are partially matched against.
	* @param options - The default options applied to matching mutations.
	* @see {@link QueryClient#getMutationDefaults}
	* @example
	* ```ts
	* queryClient.setMutationDefaults(['addPost'], { mutationFn: addPost })
	* ```
	*/ setMutationDefaults(mutationKey, options) {
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mutationDefaults, this).set((0, $ee0a7c55ac205e24$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    /**
	* Returns the default options registered for mutations whose mutation key partially matches
	* the given `mutationKey`, via {@link QueryClient#setMutationDefaults}. If multiple registered
	* defaults match, they are merged together in registration order.
	* @param mutationKey - The mutation key to look up registered defaults for.
	* @returns The merged default options of every registration that matches, or an empty object if
	* none match.
	* @example
	* ```ts
	* const defaultOptions = queryClient.getMutationDefaults(['addPost'])
	* ```
	*/ getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mutationDefaults, this).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $ee0a7c55ac205e24$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    /**
	* Called by framework adapters (e.g. inside `useQuery`) to resolve the options passed by the
	* caller into their final, defaulted form: merging the client's own `defaultOptions.queries`,
	* then `queryClient.setQueryDefaults` for the given `queryKey`, then the caller's options on
	* top. A no-op if the options are already defaulted (`_defaulted: true`).
	* @param options - The query options passed by the caller.
	* @returns The defaulted options, with `queryHash` and dependent defaults (e.g.
	* `refetchOnReconnect`) filled in.
	*/ defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_defaultOptions, this).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $ee0a7c55ac205e24$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $ee0a7c55ac205e24$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    /**
	* The mutation counterpart of {@link QueryClient#defaultQueryOptions}. Called by framework
	* adapters (e.g. inside `useMutation`) to merge the client's `defaultOptions.mutations`, then
	* `queryClient.setMutationDefaults` for the given `mutationKey`, then the caller's options on
	* top. A no-op if the options are already defaulted (`_defaulted: true`).
	* @param options - The mutation options passed by the caller.
	* @returns The defaulted options.
	*/ defaultMutationOptions(options) {
        if (options === null || options === void 0 ? void 0 : options._defaulted) return options;
        return {
            ...(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_defaultOptions, this).mutations,
            ...(options === null || options === void 0 ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    /**
	* Clears both the query cache and the mutation cache this client is connected to.
	* @example
	* ```ts
	* import { QueryClient } from '@tanstack/query-core'
	*
	* const queryClient = new QueryClient()
	* queryClient.clear()
	* ```
	*/ clear() {
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_queryCache, this).clear();
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($c35f27cd41559d1f$var$_mutationCache, this).clear();
    }
};


var $itHdT = parcelRequire("itHdT");

"use client";
// src/QueryClientProvider.tsx
/**
* The context that `useQueryClient` reads from. `QueryClientProvider` is the normal way to set it.
*/ const $e49ef136abe795ca$export$da112d31b0149f31 = $itHdT.createContext(void 0);
/**
* The `useQueryClient` hook returns the current `QueryClient` instance.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns The current `QueryClient` instance.
* @throws {Error} If no `queryClient` argument is passed and no `QueryClientProvider` is found in the
* component tree.
*/ const $e49ef136abe795ca$export$22e77b9572c4fded = (queryClient)=>{
    const client = $itHdT.useContext($e49ef136abe795ca$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
/**
* Use the `QueryClientProvider` component to connect and provide a `QueryClient` to your application. Also
* calls `client.mount()`/`client.unmount()` as this component mounts/unmounts, which subscribes the client to
* focus/online events (resuming any paused mutations and refetching as needed when the app regains focus or
* comes back online).
* @param props - The `client` to provide, and the `children` that get access to it.
* @returns The provided `children`, wrapped so they can read the `QueryClient` via `useQueryClient`.
* @example
* ```tsx
* import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
*
* const queryClient = new QueryClient()
*
* function App() {
*   return <QueryClientProvider client={queryClient}>...</QueryClientProvider>
* }
* ```
*/ const $e49ef136abe795ca$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $itHdT.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $3d04577e83656c0d$exports.jsx)($e49ef136abe795ca$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};




"use client";
// src/index.ts
const $09a74071c03a4c1b$export$fd1469cb3147d866 = function() {
    return null;
};
const $09a74071c03a4c1b$export$6d64409a8b475869 = function() {
    return null;
};








var $74c1486349c77b6a$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($74c1486349c77b6a$exports) {
        classNames.default = classNames;
        $74c1486349c77b6a$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");

"use client";
const $064b812fd356008a$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $064b812fd356008a$export$ff817e17bad2e091 = 'xs';
const $064b812fd356008a$var$ThemeContext = /*#__PURE__*/ $itHdT.createContext({
    prefixes: {},
    breakpoints: $064b812fd356008a$export$666ad80b5007f835,
    minBreakpoint: $064b812fd356008a$export$ff817e17bad2e091
});
const { Consumer: $064b812fd356008a$export$b631efc24e9d5e2f, Provider: $064b812fd356008a$var$Provider } = $064b812fd356008a$var$ThemeContext;
function $064b812fd356008a$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $064b812fd356008a$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $064b812fd356008a$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $itHdT.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($064b812fd356008a$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $064b812fd356008a$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $itHdT.useContext)($064b812fd356008a$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $064b812fd356008a$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $itHdT.useContext)($064b812fd356008a$var$ThemeContext);
    return breakpoints;
}
function $064b812fd356008a$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $itHdT.useContext)($064b812fd356008a$var$ThemeContext);
    return minBreakpoint;
}
function $064b812fd356008a$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $itHdT.useContext)($064b812fd356008a$var$ThemeContext);
    return dir === 'rtl';
}
function $064b812fd356008a$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $itHdT.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $064b812fd356008a$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $064b812fd356008a$export$2e2bcd8739ae039 = $064b812fd356008a$var$ThemeProvider;



"use client";
const $dfa4e6f1fce6f772$var$Container = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$dfa4e6f1fce6f772$var$Container.displayName = 'Container';
var $dfa4e6f1fce6f772$export$2e2bcd8739ae039 = $dfa4e6f1fce6f772$var$Container;



var $itHdT = parcelRequire("itHdT");
var $48dfaa521cc7b972$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $48dfaa521cc7b972$export$2e2bcd8739ae039(element, selector) {
    return $48dfaa521cc7b972$var$toArray(element.querySelectorAll(selector));
}


/* eslint-disable no-return-assign */ var $484c65261e05df0c$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $c490d8c1595974ec$export$63fefd044b2bc624 = false;
var $c490d8c1595974ec$export$a614c6b395900f69 = false;
try {
    var $c490d8c1595974ec$var$options = {
        get passive () {
            return $c490d8c1595974ec$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $c490d8c1595974ec$export$a614c6b395900f69 = $c490d8c1595974ec$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $484c65261e05df0c$export$2e2bcd8739ae039) {
        window.addEventListener('test', $c490d8c1595974ec$var$options, $c490d8c1595974ec$var$options);
        window.removeEventListener('test', $c490d8c1595974ec$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $c490d8c1595974ec$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$c490d8c1595974ec$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$c490d8c1595974ec$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $c490d8c1595974ec$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $c490d8c1595974ec$export$2e2bcd8739ae039 = $c490d8c1595974ec$var$addEventListener;



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
function $23a3828420e7d42a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $23a3828420e7d42a$var$_toPropertyKey(arg) {
    var key = $23a3828420e7d42a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $23a3828420e7d42a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $23a3828420e7d42a$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $23a3828420e7d42a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $itHdT.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $itHdT.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $itHdT.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $23a3828420e7d42a$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $23a3828420e7d42a$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $23a3828420e7d42a$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($23a3828420e7d42a$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $23a3828420e7d42a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}



var $itHdT = parcelRequire("itHdT");
function $7578cedb2667400d$export$2e2bcd8739ae039(value) {
    const ref = (0, $itHdT.useRef)(null);
    (0, $itHdT.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $itHdT = parcelRequire("itHdT");
function $5df4f1c464338b98$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $itHdT.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $b38b24a09b454a91$var$useCommittedRef(value) {
    const ref = (0, $itHdT.useRef)(value);
    (0, $itHdT.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $b38b24a09b454a91$export$2e2bcd8739ae039 = $b38b24a09b454a91$var$useCommittedRef;


function $fc9c376d766ce5b6$export$2e2bcd8739ae039(fn) {
    const ref = (0, $b38b24a09b454a91$export$2e2bcd8739ae039)(fn);
    return (0, $itHdT.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


function $8b241aa73cfc3524$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)(listener);
    (0, $itHdT.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $itHdT = parcelRequire("itHdT");
const $f073576c2559e8b7$var$DropdownContext = /*#__PURE__*/ $itHdT.createContext(null);
var $f073576c2559e8b7$export$2e2bcd8739ae039 = $f073576c2559e8b7$var$DropdownContext;



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
function $8c2e3326720988d4$export$2e2bcd8739ae039() {
    return (0, $itHdT.useState)(null);
}




var $itHdT = parcelRequire("itHdT");
var $c2589763a4317c42$var$has = Object.prototype.hasOwnProperty;
function $c2589763a4317c42$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($c2589763a4317c42$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $c2589763a4317c42$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $c2589763a4317c42$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $c2589763a4317c42$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $c2589763a4317c42$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$c2589763a4317c42$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($c2589763a4317c42$var$has.call(foo, ctor) && ++len && !$c2589763a4317c42$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$c2589763a4317c42$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
function $2ceb9f66fc633217$export$2e2bcd8739ae039() {
    const mounted = (0, $itHdT.useRef)(true);
    const isMounted = (0, $itHdT.useRef)(()=>mounted.current);
    (0, $itHdT.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $c77740af4e597116$var$useSafeState(state) {
    const isMounted = (0, $2ceb9f66fc633217$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $itHdT.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $c77740af4e597116$export$2e2bcd8739ae039 = $c77740af4e597116$var$useSafeState;



function $674c4bf3d0bdfec7$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $6f1abf4a67bd9c81$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $5de6a688f89d4385$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $5de6a688f89d4385$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $5de6a688f89d4385$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $2165bd7202ab90ef$export$8960430cfd85939f = Math.max;
var $2165bd7202ab90ef$export$96ec731ed4dcb222 = Math.min;
var $2165bd7202ab90ef$export$2077e0241d6afd3c = Math.round;



function $0733095c4e9f9f93$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $f61969c96a884d5b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $0733095c4e9f9f93$export$2e2bcd8739ae039)());
}


function $006c18abb4a6f995$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $2165bd7202ab90ef$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $2165bd7202ab90ef$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $5de6a688f89d4385$export$45a5e7f76e0caa8d)(element) ? (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $f61969c96a884d5b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $efc0cb256f5c0c6c$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $006c18abb4a6f995$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $c6acba609bc7ba23$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $5de6a688f89d4385$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $fd01d7246249e4fd$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $52e6da104a10dc5c$export$2e2bcd8739ae039(element) {
    return (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $411167f0cd2b97d3$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $fd01d7246249e4fd$export$2e2bcd8739ae039)(element)) >= 0;
}




function $9e15fa33c0961711$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $5de6a688f89d4385$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $5445d2a2d2b3438c$export$2e2bcd8739ae039(element) {
    if ((0, $fd01d7246249e4fd$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $5de6a688f89d4385$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9e15fa33c0961711$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42b94cc71658d05d$var$getTrueOffsetParent(element) {
    if (!(0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42b94cc71658d05d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $0733095c4e9f9f93$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $0733095c4e9f9f93$export$2e2bcd8739ae039)());
    if (isIE && (0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5445d2a2d2b3438c$export$2e2bcd8739ae039)(element);
    if ((0, $5de6a688f89d4385$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $fd01d7246249e4fd$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42b94cc71658d05d$export$2e2bcd8739ae039(element) {
    var window = (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(element);
    var offsetParent = $42b94cc71658d05d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $411167f0cd2b97d3$export$2e2bcd8739ae039)(offsetParent) && (0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42b94cc71658d05d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $fd01d7246249e4fd$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $fd01d7246249e4fd$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42b94cc71658d05d$var$getContainingBlock(element) || window;
}


function $1837962de5d069f3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $55b99197859a6fe4$export$f28d906d67a997f3(min, value, max) {
    return (0, $2165bd7202ab90ef$export$8960430cfd85939f)(min, (0, $2165bd7202ab90ef$export$96ec731ed4dcb222)(value, max));
}
function $55b99197859a6fe4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $55b99197859a6fe4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $29ed1a1673b20142$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $e03cd2c7414bcb35$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $29ed1a1673b20142$export$2e2bcd8739ae039)(), paddingObject);
}


function $e9f47836a741d163$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $925435d4cca9d04a$export$1e95b668f3b82d = 'top';
var $925435d4cca9d04a$export$40e543e69a8b3fbb = 'bottom';
var $925435d4cca9d04a$export$79ffe56a765070d2 = 'right';
var $925435d4cca9d04a$export$eabcd2c8791e7bf4 = 'left';
var $925435d4cca9d04a$export$dfb5619354ba860 = 'auto';
var $925435d4cca9d04a$export$aec2ce47c367b8c3 = [
    $925435d4cca9d04a$export$1e95b668f3b82d,
    $925435d4cca9d04a$export$40e543e69a8b3fbb,
    $925435d4cca9d04a$export$79ffe56a765070d2,
    $925435d4cca9d04a$export$eabcd2c8791e7bf4
];
var $925435d4cca9d04a$export$b3571188c770cc5a = 'start';
var $925435d4cca9d04a$export$bd5df0f255a350f8 = 'end';
var $925435d4cca9d04a$export$390fd549c5303b4d = 'clippingParents';
var $925435d4cca9d04a$export$d7b7311ec04a3e8f = 'viewport';
var $925435d4cca9d04a$export$ae5ab1c730825774 = 'popper';
var $925435d4cca9d04a$export$ca50aac9f3ba507f = 'reference';
var $925435d4cca9d04a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $925435d4cca9d04a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $925435d4cca9d04a$export$b3571188c770cc5a,
        placement + "-" + $925435d4cca9d04a$export$bd5df0f255a350f8
    ]);
}, []);
var $925435d4cca9d04a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($925435d4cca9d04a$export$aec2ce47c367b8c3, [
    $925435d4cca9d04a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $925435d4cca9d04a$export$b3571188c770cc5a,
        placement + "-" + $925435d4cca9d04a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $925435d4cca9d04a$export$421679a7c3d56e = 'beforeRead';
var $925435d4cca9d04a$export$aafa59e2e03f2942 = 'read';
var $925435d4cca9d04a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $925435d4cca9d04a$export$c65e99957a05207c = 'beforeMain';
var $925435d4cca9d04a$export$f22da7240b7add18 = 'main';
var $925435d4cca9d04a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $925435d4cca9d04a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $925435d4cca9d04a$export$68d8715fc104d294 = 'write';
var $925435d4cca9d04a$export$70a6e5159acce2e6 = 'afterWrite';
var $925435d4cca9d04a$export$d087d3878fdf71d5 = [
    $925435d4cca9d04a$export$421679a7c3d56e,
    $925435d4cca9d04a$export$aafa59e2e03f2942,
    $925435d4cca9d04a$export$6964f6c886723980,
    $925435d4cca9d04a$export$c65e99957a05207c,
    $925435d4cca9d04a$export$f22da7240b7add18,
    $925435d4cca9d04a$export$bab79516f2d662fe,
    $925435d4cca9d04a$export$8d4d2d70e7d46032,
    $925435d4cca9d04a$export$68d8715fc104d294,
    $925435d4cca9d04a$export$70a6e5159acce2e6
];


var $948452b64ea7c49d$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $e03cd2c7414bcb35$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e9f47836a741d163$export$2e2bcd8739ae039)(padding, (0, $925435d4cca9d04a$export$aec2ce47c367b8c3)));
};
function $948452b64ea7c49d$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $1837962de5d069f3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4),
        (0, $925435d4cca9d04a$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $948452b64ea7c49d$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $efc0cb256f5c0c6c$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $925435d4cca9d04a$export$1e95b668f3b82d) : (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $925435d4cca9d04a$export$40e543e69a8b3fbb) : (0, $925435d4cca9d04a$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42b94cc71658d05d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $55b99197859a6fe4$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $948452b64ea7c49d$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $c6acba609bc7ba23$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $948452b64ea7c49d$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $948452b64ea7c49d$var$arrow,
    effect: $948452b64ea7c49d$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $9daa0e663c838235$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $8d00fdfd62a48b21$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8d00fdfd62a48b21$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $2165bd7202ab90ef$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $2165bd7202ab90ef$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $8d00fdfd62a48b21$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4);
    var sideY = (0, $925435d4cca9d04a$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42b94cc71658d05d$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $9e15fa33c0961711$export$2e2bcd8739ae039)(popper);
            if ((0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $925435d4cca9d04a$export$1e95b668f3b82d) || (placement === (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4) || placement === (0, $925435d4cca9d04a$export$79ffe56a765070d2)) && variation === (0, $925435d4cca9d04a$export$bd5df0f255a350f8)) {
            sideY = (0, $925435d4cca9d04a$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4) || (placement === (0, $925435d4cca9d04a$export$1e95b668f3b82d) || placement === (0, $925435d4cca9d04a$export$40e543e69a8b3fbb)) && variation === (0, $925435d4cca9d04a$export$bd5df0f255a350f8)) {
            sideX = (0, $925435d4cca9d04a$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8d00fdfd62a48b21$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8d00fdfd62a48b21$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $8d00fdfd62a48b21$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $9daa0e663c838235$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8d00fdfd62a48b21$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8d00fdfd62a48b21$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8d00fdfd62a48b21$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $8d00fdfd62a48b21$var$computeStyles,
    data: {}
};



var $767871d9d96f42b4$var$passive = {
    passive: true
};
function $767871d9d96f42b4$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $767871d9d96f42b4$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $767871d9d96f42b4$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $767871d9d96f42b4$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $767871d9d96f42b4$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $767871d9d96f42b4$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $767871d9d96f42b4$var$effect,
    data: {}
};


var $7501e6b0cfcf150b$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $7501e6b0cfcf150b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $7501e6b0cfcf150b$var$hash[matched];
    });
}



var $0e3561c2fe5dc917$var$hash = {
    start: 'end',
    end: 'start'
};
function $0e3561c2fe5dc917$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $0e3561c2fe5dc917$var$hash[matched];
    });
}








function $6f2e5982aab4fedb$export$2e2bcd8739ae039(node) {
    var win = (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $387390cae5217c89$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $006c18abb4a6f995$export$2e2bcd8739ae039)((0, $9e15fa33c0961711$export$2e2bcd8739ae039)(element)).left + (0, $6f2e5982aab4fedb$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $975f9e6948e076a0$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(element);
    var html = (0, $9e15fa33c0961711$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $f61969c96a884d5b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $387390cae5217c89$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $7fec242297c24dca$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9e15fa33c0961711$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $6f2e5982aab4fedb$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $2165bd7202ab90ef$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $2165bd7202ab90ef$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $387390cae5217c89$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $2165bd7202ab90ef$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $78f16f57405ad155$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $0cff54f7c4ccf2d2$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $fd01d7246249e4fd$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(node) && (0, $78f16f57405ad155$export$2e2bcd8739ae039)(node)) return node;
    return $0cff54f7c4ccf2d2$export$2e2bcd8739ae039((0, $5445d2a2d2b3438c$export$2e2bcd8739ae039)(node));
}





function $ae3db4cdbc09991c$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $0cff54f7c4ccf2d2$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $78f16f57405ad155$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($ae3db4cdbc09991c$export$2e2bcd8739ae039((0, $5445d2a2d2b3438c$export$2e2bcd8739ae039)(target)));
}










function $781413a0ad76237f$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $f2f043e914833629$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $006c18abb4a6f995$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $f2f043e914833629$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $925435d4cca9d04a$export$d7b7311ec04a3e8f) ? (0, $781413a0ad76237f$export$2e2bcd8739ae039)((0, $975f9e6948e076a0$export$2e2bcd8739ae039)(element, strategy)) : (0, $5de6a688f89d4385$export$45a5e7f76e0caa8d)(clippingParent) ? $f2f043e914833629$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $781413a0ad76237f$export$2e2bcd8739ae039)((0, $7fec242297c24dca$export$2e2bcd8739ae039)((0, $9e15fa33c0961711$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $f2f043e914833629$var$getClippingParents(element) {
    var clippingParents = (0, $ae3db4cdbc09991c$export$2e2bcd8739ae039)((0, $5445d2a2d2b3438c$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $52e6da104a10dc5c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(element) ? (0, $42b94cc71658d05d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $5de6a688f89d4385$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $5de6a688f89d4385$export$45a5e7f76e0caa8d)(clippingParent) && (0, $c6acba609bc7ba23$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $fd01d7246249e4fd$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $f2f043e914833629$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $f2f043e914833629$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $f2f043e914833629$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $2165bd7202ab90ef$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $2165bd7202ab90ef$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $2165bd7202ab90ef$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $2165bd7202ab90ef$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $f2f043e914833629$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $93afa4d695202201$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $9daa0e663c838235$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $925435d4cca9d04a$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $925435d4cca9d04a$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $925435d4cca9d04a$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $925435d4cca9d04a$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $1837962de5d069f3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $925435d4cca9d04a$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $925435d4cca9d04a$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c5ca12f4817149ee$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $925435d4cca9d04a$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $925435d4cca9d04a$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $925435d4cca9d04a$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $e03cd2c7414bcb35$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e9f47836a741d163$export$2e2bcd8739ae039)(padding, (0, $925435d4cca9d04a$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $925435d4cca9d04a$export$ae5ab1c730825774) ? (0, $925435d4cca9d04a$export$ca50aac9f3ba507f) : (0, $925435d4cca9d04a$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $f2f043e914833629$export$2e2bcd8739ae039)((0, $5de6a688f89d4385$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $9e15fa33c0961711$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $006c18abb4a6f995$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $93afa4d695202201$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $781413a0ad76237f$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $925435d4cca9d04a$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $925435d4cca9d04a$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $925435d4cca9d04a$export$79ffe56a765070d2),
                (0, $925435d4cca9d04a$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $925435d4cca9d04a$export$1e95b668f3b82d),
                (0, $925435d4cca9d04a$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $b1f975f93f3751ad$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $925435d4cca9d04a$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $9daa0e663c838235$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $925435d4cca9d04a$export$368f9a87e87fa4e1) : (0, $925435d4cca9d04a$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $9daa0e663c838235$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $925435d4cca9d04a$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c5ca12f4817149ee$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $0decfc419fb8acc1$var$getExpandedFallbackPlacements(placement) {
    if ((0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(placement) === (0, $925435d4cca9d04a$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $7501e6b0cfcf150b$export$2e2bcd8739ae039)(placement);
    return [
        (0, $0e3561c2fe5dc917$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $0e3561c2fe5dc917$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $0decfc419fb8acc1$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $7501e6b0cfcf150b$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $0decfc419fb8acc1$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(placement) === (0, $925435d4cca9d04a$export$dfb5619354ba860) ? (0, $b1f975f93f3751ad$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $9daa0e663c838235$export$2e2bcd8739ae039)(placement) === (0, $925435d4cca9d04a$export$b3571188c770cc5a);
        var isVertical = [
            (0, $925435d4cca9d04a$export$1e95b668f3b82d),
            (0, $925435d4cca9d04a$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c5ca12f4817149ee$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $925435d4cca9d04a$export$79ffe56a765070d2) : (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $925435d4cca9d04a$export$40e543e69a8b3fbb) : (0, $925435d4cca9d04a$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $7501e6b0cfcf150b$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $7501e6b0cfcf150b$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $0decfc419fb8acc1$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $0decfc419fb8acc1$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $0f2a4068dc424561$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $0f2a4068dc424561$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $925435d4cca9d04a$export$1e95b668f3b82d),
        (0, $925435d4cca9d04a$export$79ffe56a765070d2),
        (0, $925435d4cca9d04a$export$40e543e69a8b3fbb),
        (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $0f2a4068dc424561$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c5ca12f4817149ee$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c5ca12f4817149ee$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $0f2a4068dc424561$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $0f2a4068dc424561$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $0f2a4068dc424561$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $0f2a4068dc424561$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $0f2a4068dc424561$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $0f2a4068dc424561$var$hide
};




function $edf9af6135498c81$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4),
        (0, $925435d4cca9d04a$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4),
        (0, $925435d4cca9d04a$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $edf9af6135498c81$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $925435d4cca9d04a$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $edf9af6135498c81$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $edf9af6135498c81$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $edf9af6135498c81$var$offset
};



function $812214f1d8c46e2b$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $93afa4d695202201$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $812214f1d8c46e2b$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $812214f1d8c46e2b$var$popperOffsets,
    data: {}
};





function $bf4d7206c6c1e217$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $f38a3ad74738dac2$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c5ca12f4817149ee$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $674c4bf3d0bdfec7$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $9daa0e663c838235$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $1837962de5d069f3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $bf4d7206c6c1e217$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $925435d4cca9d04a$export$1e95b668f3b82d) : (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $925435d4cca9d04a$export$40e543e69a8b3fbb) : (0, $925435d4cca9d04a$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $925435d4cca9d04a$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $925435d4cca9d04a$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $efc0cb256f5c0c6c$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $29ed1a1673b20142$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $55b99197859a6fe4$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42b94cc71658d05d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $55b99197859a6fe4$export$f28d906d67a997f3)(tether ? (0, $2165bd7202ab90ef$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $2165bd7202ab90ef$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $925435d4cca9d04a$export$1e95b668f3b82d) : (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $925435d4cca9d04a$export$40e543e69a8b3fbb) : (0, $925435d4cca9d04a$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $925435d4cca9d04a$export$1e95b668f3b82d),
            (0, $925435d4cca9d04a$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $55b99197859a6fe4$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $55b99197859a6fe4$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f38a3ad74738dac2$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $f38a3ad74738dac2$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $4961d7496635437f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $d958c90f6c033721$export$2e2bcd8739ae039(node) {
    if (node === (0, $6f1abf4a67bd9c81$export$2e2bcd8739ae039)(node) || !(0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(node)) return (0, $6f2e5982aab4fedb$export$2e2bcd8739ae039)(node);
    else return (0, $4961d7496635437f$export$2e2bcd8739ae039)(node);
}








function $2fb71f5d669b32cf$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $2165bd7202ab90ef$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $2165bd7202ab90ef$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $2fb71f5d669b32cf$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(offsetParent) && $2fb71f5d669b32cf$var$isElementScaled(offsetParent);
    var documentElement = (0, $9e15fa33c0961711$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $006c18abb4a6f995$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fd01d7246249e4fd$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $78f16f57405ad155$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $d958c90f6c033721$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $5de6a688f89d4385$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $006c18abb4a6f995$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $387390cae5217c89$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $2932a2874a6f2320$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2932a2874a6f2320$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2932a2874a6f2320$var$order(modifiers); // order based on phase
    return (0, $925435d4cca9d04a$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $f9ade1c5c3a9bbd6$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $7fd06ef15ab523dd$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $21d2cf029ae8fa97$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $21d2cf029ae8fa97$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $21d2cf029ae8fa97$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $21d2cf029ae8fa97$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $21d2cf029ae8fa97$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $5de6a688f89d4385$export$45a5e7f76e0caa8d)(reference) ? (0, $ae3db4cdbc09991c$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $ae3db4cdbc09991c$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $ae3db4cdbc09991c$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $2932a2874a6f2320$export$2e2bcd8739ae039)((0, $7fd06ef15ab523dd$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$21d2cf029ae8fa97$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $2fb71f5d669b32cf$export$2e2bcd8739ae039)(reference, (0, $42b94cc71658d05d$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $efc0cb256f5c0c6c$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $f9ade1c5c3a9bbd6$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$21d2cf029ae8fa97$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $21d2cf029ae8fa97$export$8f7491d57c8f97a9 = /*#__PURE__*/ $21d2cf029ae8fa97$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $fbe434253f594365$export$8f7491d57c8f97a9 = (0, $21d2cf029ae8fa97$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $0f2a4068dc424561$export$2e2bcd8739ae039),
        (0, $812214f1d8c46e2b$export$2e2bcd8739ae039),
        (0, $8d00fdfd62a48b21$export$2e2bcd8739ae039),
        (0, $767871d9d96f42b4$export$2e2bcd8739ae039),
        (0, $edf9af6135498c81$export$2e2bcd8739ae039),
        (0, $0decfc419fb8acc1$export$2e2bcd8739ae039),
        (0, $f38a3ad74738dac2$export$2e2bcd8739ae039),
        (0, $948452b64ea7c49d$export$2e2bcd8739ae039)
    ]
});


const $c773b670d4c3ff48$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $c773b670d4c3ff48$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $c773b670d4c3ff48$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $c773b670d4c3ff48$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $c773b670d4c3ff48$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $c773b670d4c3ff48$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $c773b670d4c3ff48$var$EMPTY_MODIFIERS } = _ref, config = $c773b670d4c3ff48$var$_objectWithoutPropertiesLoose(_ref, $c773b670d4c3ff48$var$_excluded);
    const prevModifiers = (0, $itHdT.useRef)(modifiers);
    const popperInstanceRef = (0, $itHdT.useRef)();
    const update = (0, $itHdT.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $itHdT.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $c77740af4e597116$export$2e2bcd8739ae039)((0, $itHdT.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $itHdT.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $itHdT.useMemo)(()=>{
        if (!(0, $c2589763a4317c42$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $itHdT.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $c773b670d4c3ff48$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $itHdT.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $fbe434253f594365$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $c773b670d4c3ff48$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $c773b670d4c3ff48$export$2e2bcd8739ae039 = $c773b670d4c3ff48$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $f292680e7c6407e3$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $d4018e14e4aa8bd7$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $d4018e14e4aa8bd7$export$2e2bcd8739ae039 = $d4018e14e4aa8bd7$var$removeEventListener;


function $697341c5b17243d6$var$listen(node, eventName, handler, options) {
    (0, $c490d8c1595974ec$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $d4018e14e4aa8bd7$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $697341c5b17243d6$export$2e2bcd8739ae039 = $697341c5b17243d6$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $c5bd197adfafb87d$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $itHdT = parcelRequire("itHdT");

var $313780d67514515b$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $313780d67514515b$var$__DEV__ = false;
var $313780d67514515b$var$warning = function() {};
if ($313780d67514515b$var$__DEV__) {
    var $313780d67514515b$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $313780d67514515b$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $313780d67514515b$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$313780d67514515b$exports = $313780d67514515b$var$warning;


const $7cd476a6b03997a6$var$noop = ()=>{};
function $7cd476a6b03997a6$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $7cd476a6b03997a6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $7cd476a6b03997a6$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $7cd476a6b03997a6$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $7cd476a6b03997a6$var$useClickOutside(ref, onClickOutside = $7cd476a6b03997a6$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $itHdT.useRef)(false);
    const waitingForTrigger = (0, $itHdT.useRef)(false);
    const handleMouseCapture = (0, $itHdT.useCallback)((e)=>{
        const currentTarget = $7cd476a6b03997a6$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($313780d67514515b$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $7cd476a6b03997a6$var$isModifiedEvent(e) || !$7cd476a6b03997a6$var$isLeftClickEvent(e) || !!(0, $f292680e7c6407e3$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $7cd476a6b03997a6$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $f292680e7c6407e3$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $itHdT.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $c5bd197adfafb87d$export$2e2bcd8739ae039)($7cd476a6b03997a6$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($7cd476a6b03997a6$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $697341c5b17243d6$export$2e2bcd8739ae039)(doc, $7cd476a6b03997a6$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $697341c5b17243d6$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $697341c5b17243d6$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $697341c5b17243d6$export$2e2bcd8739ae039)(el, 'mousemove', $7cd476a6b03997a6$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $7cd476a6b03997a6$export$2e2bcd8739ae039 = $7cd476a6b03997a6$var$useClickOutside;


function $c3aee055b011a6e8$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $c3aee055b011a6e8$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $c3aee055b011a6e8$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $c3aee055b011a6e8$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $c3aee055b011a6e8$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



const $37d9345383490cf3$var$_excluded = [
    "children",
    "usePopper"
];
function $37d9345383490cf3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $37d9345383490cf3$var$noop = ()=>{};
function $37d9345383490cf3$export$133c4d08f3775d64(options = {}) {
    const context = (0, $itHdT.useContext)((0, $f073576c2559e8b7$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $8c2e3326720988d4$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $itHdT.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $c773b670d4c3ff48$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $c3aee055b011a6e8$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $37d9345383490cf3$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $7cd476a6b03997a6$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $37d9345383490cf3$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $37d9345383490cf3$var$_objectWithoutPropertiesLoose(_ref, $37d9345383490cf3$var$_excluded);
    const [props, meta] = $37d9345383490cf3$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
        children: children(props, meta)
    });
}
$37d9345383490cf3$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $37d9345383490cf3$export$2e2bcd8739ae039 = $37d9345383490cf3$var$DropdownMenu;



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createContext($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$defaultContext);
const $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createContext(false);
// This is only used in React < 18.
function $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $itHdT.useContext)($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$useCounter(cur === $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $itHdT.useState)(true);
    let value = (0, $itHdT.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $itHdT.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createElement($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createElement($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $269ab05b3ceb5e90$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($itHdT)))['useId'] === 'function') {
        if (!$269ab05b3ceb5e90$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createElement($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $itHdT.useContext)($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $itHdT.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $itHdT.useContext)($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$defaultContext && !$269ab05b3ceb5e90$var$$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useId();
    let [didSSR] = (0, $itHdT.useState)($269ab05b3ceb5e90$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$269ab05b3ceb5e90$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $269ab05b3ceb5e90$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($itHdT)))['useId'] === 'function' ? $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$useModernSSRSafeId : $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $269ab05b3ceb5e90$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($itHdT)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($itHdT)))['useSyncExternalStore']($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$subscribe, $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$getSnapshot, $269ab05b3ceb5e90$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $itHdT.useContext)($269ab05b3ceb5e90$var$$b5e257d569688ac6$var$IsSSRContext);
}




const $bcffba1602b9e3c5$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $bcffba1602b9e3c5$var$noop = ()=>{};
function $bcffba1602b9e3c5$export$96df6c7c5036b9a2() {
    const id = (0, $269ab05b3ceb5e90$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $bcffba1602b9e3c5$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $itHdT.useContext)((0, $f073576c2559e8b7$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $itHdT.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $bcffba1602b9e3c5$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $bcffba1602b9e3c5$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $bcffba1602b9e3c5$var$DropdownToggle({ children: children }) {
    const [props, meta] = $bcffba1602b9e3c5$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
        children: children(props, meta)
    });
}
$bcffba1602b9e3c5$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $bcffba1602b9e3c5$export$2e2bcd8739ae039 = $bcffba1602b9e3c5$var$DropdownToggle;



var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");
const $f2cddde8eb83ce78$var$SelectableContext = /*#__PURE__*/ $itHdT.createContext(null);
const $f2cddde8eb83ce78$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $f2cddde8eb83ce78$export$2e2bcd8739ae039 = $f2cddde8eb83ce78$var$SelectableContext;



var $itHdT = parcelRequire("itHdT");
const $30a0406f4f546380$var$NavContext = /*#__PURE__*/ $itHdT.createContext(null);
$30a0406f4f546380$var$NavContext.displayName = 'NavContext';
var $30a0406f4f546380$export$2e2bcd8739ae039 = $30a0406f4f546380$var$NavContext;



var $itHdT = parcelRequire("itHdT");

const $8f0666e83f781007$var$_excluded = [
    "as",
    "disabled"
];
function $8f0666e83f781007$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $8f0666e83f781007$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $8f0666e83f781007$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $8f0666e83f781007$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $8f0666e83f781007$var$Button = /*#__PURE__*/ $itHdT.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $8f0666e83f781007$var$_objectWithoutPropertiesLoose(_ref, $8f0666e83f781007$var$_excluded);
    const [buttonProps, { tagName: Component }] = $8f0666e83f781007$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$8f0666e83f781007$var$Button.displayName = 'Button';
var $8f0666e83f781007$export$2e2bcd8739ae039 = $8f0666e83f781007$var$Button;


const $a5ace9316f73275d$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $a5ace9316f73275d$export$635202801f9383a0 = `rrUi`;
function $a5ace9316f73275d$export$5cc3b7b83e34ade7(property) {
    return `${$a5ace9316f73275d$export$fd7bcb7e9bef4e8a}${property}`;
}
function $a5ace9316f73275d$export$7776c0a7cd2eb3e0(property) {
    return `${$a5ace9316f73275d$export$635202801f9383a0}${property}`;
}



const $3eb9e785326eacd6$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $3eb9e785326eacd6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $3eb9e785326eacd6$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $itHdT.useContext)((0, $f2cddde8eb83ce78$export$2e2bcd8739ae039));
    const navContext = (0, $itHdT.useContext)((0, $30a0406f4f546380$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $f2cddde8eb83ce78$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $f2cddde8eb83ce78$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $a5ace9316f73275d$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $3eb9e785326eacd6$var$DropdownItem = /*#__PURE__*/ $itHdT.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $8f0666e83f781007$export$2e2bcd8739ae039) } = _ref, props = $3eb9e785326eacd6$var$_objectWithoutPropertiesLoose(_ref, $3eb9e785326eacd6$var$_excluded);
    const [dropdownItemProps] = $3eb9e785326eacd6$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$3eb9e785326eacd6$var$DropdownItem.displayName = 'DropdownItem';
var $3eb9e785326eacd6$export$2e2bcd8739ae039 = $3eb9e785326eacd6$var$DropdownItem;





var $itHdT = parcelRequire("itHdT");

const $ef31c49d95c8eee5$var$Context = /*#__PURE__*/ (0, $itHdT.createContext)((0, $484c65261e05df0c$export$2e2bcd8739ae039) ? window : undefined);
const $ef31c49d95c8eee5$export$f7d306aeb1cf5fbc = $ef31c49d95c8eee5$var$Context.Provider;
function $ef31c49d95c8eee5$export$2e2bcd8739ae039() {
    return (0, $itHdT.useContext)($ef31c49d95c8eee5$var$Context);
}



function $9a8cbd092366657f$var$useRefWithUpdate() {
    const forceUpdate = (0, $5df4f1c464338b98$export$2e2bcd8739ae039)();
    const ref = (0, $itHdT.useRef)(null);
    const attachRef = (0, $itHdT.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $9a8cbd092366657f$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $a5ace9316f73275d$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $ef31c49d95c8eee5$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $23a3828420e7d42a$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $9a8cbd092366657f$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $9a8cbd092366657f$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $7578cedb2667400d$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $itHdT.useRef)(null);
    const focusInDropdown = (0, $itHdT.useRef)(false);
    const onSelectCtx = (0, $itHdT.useContext)((0, $f2cddde8eb83ce78$export$2e2bcd8739ae039));
    const toggle = (0, $itHdT.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $itHdT.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $bcffba1602b9e3c5$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $itHdT.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $itHdT.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $8b241aa73cfc3524$export$2e2bcd8739ae039)((0, $itHdT.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $c490d8c1595974ec$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f2cddde8eb83ce78$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f073576c2559e8b7$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$9a8cbd092366657f$var$Dropdown.displayName = 'Dropdown';
$9a8cbd092366657f$var$Dropdown.Menu = (0, $37d9345383490cf3$export$2e2bcd8739ae039);
$9a8cbd092366657f$var$Dropdown.Toggle = (0, $bcffba1602b9e3c5$export$2e2bcd8739ae039);
$9a8cbd092366657f$var$Dropdown.Item = (0, $3eb9e785326eacd6$export$2e2bcd8739ae039);
var $9a8cbd092366657f$export$2e2bcd8739ae039 = $9a8cbd092366657f$var$Dropdown;


function $ccac32dca08e8391$export$2e2bcd8739ae039() {
    return $ccac32dca08e8391$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ccac32dca08e8391$export$2e2bcd8739ae039.apply(null, arguments);
}


function $3171e3955cd84084$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $itHdT = parcelRequire("itHdT");
var $e6ad8d761948274d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $e6ad8d761948274d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$e6ad8d761948274d$exports = $e6ad8d761948274d$var$invariant;


var $871855252742a482$var$noop = function noop() {};
function $871855252742a482$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $871855252742a482$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $871855252742a482$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$871855252742a482$export$26cbf8c37e721e67(prop)] = $871855252742a482$var$noop;
        var handler;
    });
    return propTypes;
}
function $871855252742a482$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $871855252742a482$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $871855252742a482$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $ebcd10849b756af0$var$_toPropertyKey(arg) {
    var key = $ebcd10849b756af0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ebcd10849b756af0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ebcd10849b756af0$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $itHdT.useRef)(propValue !== undefined);
    var _useState = (0, $itHdT.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $itHdT.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $ebcd10849b756af0$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$871855252742a482$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $3171e3955cd84084$export$2e2bcd8739ae039)(_ref, [
            $871855252742a482$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($ebcd10849b756af0$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $ebcd10849b756af0$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $ccac32dca08e8391$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $aa2791a3f8b017d5$export$2e2bcd8739ae039(t, e) {
    return $aa2791a3f8b017d5$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $aa2791a3f8b017d5$export$2e2bcd8739ae039(t, e);
}


function $38a8ebb77716eab9$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $aa2791a3f8b017d5$export$2e2bcd8739ae039)(t, o);
}



var $itHdT = parcelRequire("itHdT");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $9989f876e27238c4$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $9989f876e27238c4$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $9989f876e27238c4$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$9989f876e27238c4$var$componentWillMount.__suppressDeprecationWarning = true;
$9989f876e27238c4$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$9989f876e27238c4$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $9989f876e27238c4$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $9989f876e27238c4$var$componentWillMount;
        prototype.componentWillReceiveProps = $9989f876e27238c4$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $9989f876e27238c4$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $6cf4914becf8a66d$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $6cf4914becf8a66d$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $871855252742a482$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($871855252742a482$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($e6ad8d761948274d$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $38a8ebb77716eab9$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $ccac32dca08e8391$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$871855252742a482$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $ccac32dca08e8391$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$871855252742a482$export$12ae2baa35bd9b8b(props, key) && $871855252742a482$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$871855252742a482$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $3171e3955cd84084$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createElement(Component, (0, $ccac32dca08e8391$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).Component);
    (0, $9989f876e27238c4$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $ccac32dca08e8391$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $871855252742a482$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createElement(UncontrolledComponent, (0, $ccac32dca08e8391$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $6cf4914becf8a66d$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $6cf4914becf8a66d$export$2e2bcd8739ae039(newComponent, (0, $ccac32dca08e8391$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $d2c53b6d5c6c5887$var$useCommittedRef(value) {
    const ref = (0, $itHdT.useRef)(value);
    (0, $itHdT.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $d2c53b6d5c6c5887$export$2e2bcd8739ae039 = $d2c53b6d5c6c5887$var$useCommittedRef;


function $153be9953ec91ab7$export$2e2bcd8739ae039(fn) {
    const ref = (0, $d2c53b6d5c6c5887$export$2e2bcd8739ae039)(fn);
    return (0, $itHdT.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $itHdT = parcelRequire("itHdT");
"use client";
const $eb5034e9f2dba757$var$DropdownContext = /*#__PURE__*/ $itHdT.createContext({});
$eb5034e9f2dba757$var$DropdownContext.displayName = 'DropdownContext';
var $eb5034e9f2dba757$export$2e2bcd8739ae039 = $eb5034e9f2dba757$var$DropdownContext;



var $itHdT = parcelRequire("itHdT");



"use client";
const $7ceec57114135207$var$DropdownDivider = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$7ceec57114135207$var$DropdownDivider.displayName = 'DropdownDivider';
var $7ceec57114135207$export$2e2bcd8739ae039 = $7ceec57114135207$var$DropdownDivider;



var $itHdT = parcelRequire("itHdT");



"use client";
const $fd83abd85238f294$var$DropdownHeader = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$fd83abd85238f294$var$DropdownHeader.displayName = 'DropdownHeader';
var $fd83abd85238f294$export$2e2bcd8739ae039 = $fd83abd85238f294$var$DropdownHeader;




var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");






var $itHdT = parcelRequire("itHdT");
function $9fec08d98bdc43cc$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $itHdT.useCallback)(()=>document, []);
    return (0, $8b241aa73cfc3524$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $itHdT = parcelRequire("itHdT");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $04b3b3c934a076dd$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $b38b24a09b454a91$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $b38b24a09b454a91$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $itHdT.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $04b3b3c934a076dd$export$2e2bcd8739ae039 = $04b3b3c934a076dd$var$useInterval;



var $itHdT = parcelRequire("itHdT");

function $a037bd885bad68fd$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $b38b24a09b454a91$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $b38b24a09b454a91$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $itHdT.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $a037bd885bad68fd$export$2e2bcd8739ae039 = $a037bd885bad68fd$var$useRafInterval;



var $itHdT = parcelRequire("itHdT");
function $16a56967ced965bc$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $itHdT.useState)(initialState);
    const updater = (0, $itHdT.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $9825c70a9d14be61$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $16a56967ced965bc$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $itHdT = parcelRequire("itHdT");
function $ac4d2414972d02a0$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $itHdT.useState)({
        image: null,
        error: null
    });
    (0, $itHdT.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
const $a7a261fa0ba9f022$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $a7a261fa0ba9f022$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $a7a261fa0ba9f022$export$2e2bcd8739ae039 = $a7a261fa0ba9f022$var$isDOM || $a7a261fa0ba9f022$var$isReactNative ? (0, $itHdT.useLayoutEffect) : (0, $itHdT.useEffect);


const $a773b5e63bef283a$var$targetMap = new WeakMap();
let $a773b5e63bef283a$var$resizeObserver;
function $a773b5e63bef283a$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $a773b5e63bef283a$var$resizeObserver = $a773b5e63bef283a$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $a773b5e63bef283a$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $a773b5e63bef283a$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $itHdT.useState)(null);
    (0, $a7a261fa0ba9f022$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $a773b5e63bef283a$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $a773b5e63bef283a$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $a773b5e63bef283a$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $7b1c46c0196abba4$var$_excluded = [
    "onKeyDown"
];
function $7b1c46c0196abba4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $7b1c46c0196abba4$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $7b1c46c0196abba4$var$Anchor = /*#__PURE__*/ $itHdT.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $7b1c46c0196abba4$var$_objectWithoutPropertiesLoose(_ref, $7b1c46c0196abba4$var$_excluded);
    const [buttonProps] = (0, $8f0666e83f781007$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($7b1c46c0196abba4$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$7b1c46c0196abba4$var$Anchor.displayName = 'Anchor';
var $7b1c46c0196abba4$export$2e2bcd8739ae039 = $7b1c46c0196abba4$var$Anchor;




"use client";
const $276655b24d9f629b$var$DropdownItem = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $7b1c46c0196abba4$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $3eb9e785326eacd6$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$276655b24d9f629b$var$DropdownItem.displayName = 'DropdownItem';
var $276655b24d9f629b$export$2e2bcd8739ae039 = $276655b24d9f629b$var$DropdownItem;



var $itHdT = parcelRequire("itHdT");



"use client";
const $9f913a6c8fa852c0$var$DropdownItemText = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$9f913a6c8fa852c0$var$DropdownItemText.displayName = 'DropdownItemText';
var $9f913a6c8fa852c0$export$2e2bcd8739ae039 = $9f913a6c8fa852c0$var$DropdownItemText;




var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");
const $844e75cced394cc3$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $844e75cced394cc3$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $844e75cced394cc3$export$2e2bcd8739ae039 = $844e75cced394cc3$var$isDOM || $844e75cced394cc3$var$isReactNative ? (0, $itHdT.useLayoutEffect) : (0, $itHdT.useEffect);



var $itHdT = parcelRequire("itHdT");
const $2dff25418658288a$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $2dff25418658288a$export$c9058316764c140e(refA, refB) {
    const a = $2dff25418658288a$var$toFnRef(refA);
    const b = $2dff25418658288a$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $2dff25418658288a$var$useMergedRefs(refA, refB) {
    return (0, $itHdT.useMemo)(()=>$2dff25418658288a$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $2dff25418658288a$export$2e2bcd8739ae039 = $2dff25418658288a$var$useMergedRefs;





var $itHdT = parcelRequire("itHdT");
"use client";
const $d468ea62b97419e0$var$context = /*#__PURE__*/ $itHdT.createContext(null);
$d468ea62b97419e0$var$context.displayName = 'InputGroupContext';
var $d468ea62b97419e0$export$2e2bcd8739ae039 = $d468ea62b97419e0$var$context;



var $itHdT = parcelRequire("itHdT");
"use client";
// TODO: check
const $0dd46598caee6987$var$context = /*#__PURE__*/ $itHdT.createContext(null);
$0dd46598caee6987$var$context.displayName = 'NavbarContext';
var $0dd46598caee6987$export$2e2bcd8739ae039 = $0dd46598caee6987$var$context;




parcelRequire("itHdT");

function $e97e681b9dd59f7d$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $44b1865634da8610$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $44b1865634da8610$var$DropdownMenu = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $itHdT.useContext)((0, $0dd46598caee6987$export$2e2bcd8739ae039));
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $itHdT.useContext)((0, $eb5034e9f2dba757$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $itHdT.useContext)((0, $d468ea62b97419e0$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $44b1865634da8610$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $37d9345383490cf3$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $2dff25418658288a$export$2e2bcd8739ae039)((0, $e97e681b9dd59f7d$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $844e75cced394cc3$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$44b1865634da8610$var$DropdownMenu.displayName = 'DropdownMenu';
var $44b1865634da8610$export$2e2bcd8739ae039 = $44b1865634da8610$var$DropdownMenu;







var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");



"use client";
const $0dc71333bb7bcb46$var$Button = /*#__PURE__*/ $itHdT.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $8f0666e83f781007$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$0dc71333bb7bcb46$var$Button.displayName = 'Button';
var $0dc71333bb7bcb46$export$2e2bcd8739ae039 = $0dc71333bb7bcb46$var$Button;





"use client";
const $adf24b2212e08f75$var$DropdownToggle = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $itHdT.useContext)((0, $f073576c2559e8b7$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $bcffba1602b9e3c5$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $2dff25418658288a$export$2e2bcd8739ae039)(toggleProps.ref, (0, $e97e681b9dd59f7d$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$adf24b2212e08f75$var$DropdownToggle.displayName = 'DropdownToggle';
var $adf24b2212e08f75$export$2e2bcd8739ae039 = $adf24b2212e08f75$var$DropdownToggle;






"use client";
const $c3d2300ee9df0bec$var$Dropdown = /*#__PURE__*/ $itHdT.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $ebcd10849b756af0$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $itHdT.useContext)((0, $d468ea62b97419e0$export$2e2bcd8739ae039));
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $064b812fd356008a$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $153be9953ec91ab7$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $44b1865634da8610$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $itHdT.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $eb5034e9f2dba757$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a8cbd092366657f$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$c3d2300ee9df0bec$var$Dropdown.displayName = 'Dropdown';
var $c3d2300ee9df0bec$export$2e2bcd8739ae039 = Object.assign($c3d2300ee9df0bec$var$Dropdown, {
    Toggle: (0, $adf24b2212e08f75$export$2e2bcd8739ae039),
    Menu: (0, $44b1865634da8610$export$2e2bcd8739ae039),
    Item: (0, $276655b24d9f629b$export$2e2bcd8739ae039),
    ItemText: (0, $9f913a6c8fa852c0$export$2e2bcd8739ae039),
    Divider: (0, $7ceec57114135207$export$2e2bcd8739ae039),
    Header: (0, $fd83abd85238f294$export$2e2bcd8739ae039)
});



var $itHdT = parcelRequire("itHdT");



var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");
const $eed73de565f16b81$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $eed73de565f16b81$export$c9058316764c140e(refA, refB) {
    const a = $eed73de565f16b81$var$toFnRef(refA);
    const b = $eed73de565f16b81$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $eed73de565f16b81$var$useMergedRefs(refA, refB) {
    return (0, $itHdT.useMemo)(()=>$eed73de565f16b81$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $eed73de565f16b81$export$2e2bcd8739ae039 = $eed73de565f16b81$var$useMergedRefs;





var $itHdT = parcelRequire("itHdT");
const $a1a99f7663a65bbd$var$TabContext = /*#__PURE__*/ $itHdT.createContext(null);
var $a1a99f7663a65bbd$export$2e2bcd8739ae039 = $a1a99f7663a65bbd$var$TabContext;




var $itHdT = parcelRequire("itHdT");







const $53cc4500654059a3$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $53cc4500654059a3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $53cc4500654059a3$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $itHdT.useContext)((0, $f2cddde8eb83ce78$export$2e2bcd8739ae039));
    const navContext = (0, $itHdT.useContext)((0, $30a0406f4f546380$export$2e2bcd8739ae039));
    const tabContext = (0, $itHdT.useContext)((0, $a1a99f7663a65bbd$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $a5ace9316f73275d$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $53cc4500654059a3$var$NavItem = /*#__PURE__*/ $itHdT.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $8f0666e83f781007$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $53cc4500654059a3$var$_objectWithoutPropertiesLoose(_ref, $53cc4500654059a3$var$_excluded);
    const [props, meta] = $53cc4500654059a3$export$d7a68693710982a(Object.assign({
        key: (0, $f2cddde8eb83ce78$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $a5ace9316f73275d$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$53cc4500654059a3$var$NavItem.displayName = 'NavItem';
var $53cc4500654059a3$export$2e2bcd8739ae039 = $53cc4500654059a3$var$NavItem;



const $4fe4adb6465dd41d$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $4fe4adb6465dd41d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $4fe4adb6465dd41d$var$noop = ()=>{};
const $4fe4adb6465dd41d$var$EVENT_KEY_ATTR = (0, $a5ace9316f73275d$export$5cc3b7b83e34ade7)('event-key');
const $4fe4adb6465dd41d$var$Nav = /*#__PURE__*/ $itHdT.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $4fe4adb6465dd41d$var$_objectWithoutPropertiesLoose(_ref, $4fe4adb6465dd41d$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $5df4f1c464338b98$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $itHdT.useRef)(false);
    const parentOnSelect = (0, $itHdT.useContext)((0, $f2cddde8eb83ce78$export$2e2bcd8739ae039));
    const tabContext = (0, $itHdT.useContext)((0, $a1a99f7663a65bbd$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $itHdT.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(currentListNode, `[${$4fe4adb6465dd41d$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $a5ace9316f73275d$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $itHdT.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$4fe4adb6465dd41d$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $eed73de565f16b81$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f2cddde8eb83ce78$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $30a0406f4f546380$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $f2cddde8eb83ce78$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $4fe4adb6465dd41d$var$noop,
                getControllerId: getControllerId || $4fe4adb6465dd41d$var$noop
            },
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$4fe4adb6465dd41d$var$Nav.displayName = 'Nav';
var $4fe4adb6465dd41d$export$2e2bcd8739ae039 = Object.assign($4fe4adb6465dd41d$var$Nav, {
    Item: (0, $53cc4500654059a3$export$2e2bcd8739ae039)
});





var $itHdT = parcelRequire("itHdT");
"use client";
const $ac8a75a6a1b836ec$var$context = /*#__PURE__*/ $itHdT.createContext(null);
$ac8a75a6a1b836ec$var$context.displayName = 'CardHeaderContext';
var $ac8a75a6a1b836ec$export$2e2bcd8739ae039 = $ac8a75a6a1b836ec$var$context;



var $itHdT = parcelRequire("itHdT");



"use client";
const $eb20cefbd4e527f6$var$NavItem = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$eb20cefbd4e527f6$var$NavItem.displayName = 'NavItem';
var $eb20cefbd4e527f6$export$2e2bcd8739ae039 = $eb20cefbd4e527f6$var$NavItem;




var $itHdT = parcelRequire("itHdT");





"use client";
const $a36253890ccc54be$var$NavLink = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $7b1c46c0196abba4$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $53cc4500654059a3$export$d7a68693710982a)({
        key: (0, $f2cddde8eb83ce78$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$a36253890ccc54be$var$NavLink.displayName = 'NavLink';
var $a36253890ccc54be$export$2e2bcd8739ae039 = $a36253890ccc54be$var$NavLink;



"use client";
const $dd5ea25fd6bb92a1$var$Nav = /*#__PURE__*/ $itHdT.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $ebcd10849b756af0$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $itHdT.useContext)((0, $0dd46598caee6987$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $itHdT.useContext)((0, $ac8a75a6a1b836ec$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4fe4adb6465dd41d$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$dd5ea25fd6bb92a1$var$Nav.displayName = 'Nav';
var $dd5ea25fd6bb92a1$export$2e2bcd8739ae039 = Object.assign($dd5ea25fd6bb92a1$var$Nav, {
    Item: (0, $eb20cefbd4e527f6$export$2e2bcd8739ae039),
    Link: (0, $a36253890ccc54be$export$2e2bcd8739ae039)
});



var $itHdT = parcelRequire("itHdT");




var $itHdT = parcelRequire("itHdT");


"use client";
const $fe192e15278c2aba$var$NavbarBrand = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix)
    });
});
$fe192e15278c2aba$var$NavbarBrand.displayName = 'NavbarBrand';
var $fe192e15278c2aba$export$2e2bcd8739ae039 = $fe192e15278c2aba$var$NavbarBrand;



var $itHdT = parcelRequire("itHdT");


function $ecff9b10f838d9fb$export$2e2bcd8739ae039(node) {
    var doc = (0, $c5bd197adfafb87d$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $06a37476ffdc376c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $ecff9b10f838d9fb$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $74fd11ed1fa89319$var$rUpper = /([A-Z])/g;
function $74fd11ed1fa89319$export$2e2bcd8739ae039(string) {
    return string.replace($74fd11ed1fa89319$var$rUpper, '-$1').toLowerCase();
}


var $c12bc4d7eb3eaef4$var$msPattern = /^ms-/;
function $c12bc4d7eb3eaef4$export$2e2bcd8739ae039(string) {
    return (0, $74fd11ed1fa89319$export$2e2bcd8739ae039)(string).replace($c12bc4d7eb3eaef4$var$msPattern, '-ms-');
}


var $f76a8ad3da369f3c$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $f76a8ad3da369f3c$export$2e2bcd8739ae039(value) {
    return !!(value && $f76a8ad3da369f3c$var$supportedTransforms.test(value));
}


function $1d295ea8cafefc74$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $c12bc4d7eb3eaef4$export$2e2bcd8739ae039)(property)) || (0, $06a37476ffdc376c$export$2e2bcd8739ae039)(node).getPropertyValue((0, $c12bc4d7eb3eaef4$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $c12bc4d7eb3eaef4$export$2e2bcd8739ae039)(key));
        else if ((0, $f76a8ad3da369f3c$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $c12bc4d7eb3eaef4$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d295ea8cafefc74$export$2e2bcd8739ae039 = $1d295ea8cafefc74$var$style;



var $itHdT = parcelRequire("itHdT");




var $itHdT = parcelRequire("itHdT");

var $2cbbe3bd158b59e3$export$2e2bcd8739ae039 = {
    disabled: false
};




var $itHdT = parcelRequire("itHdT");
var $4e8ba6b1f44f75c0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createContext(null);


var $8bba05046e87d3a2$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $9d02f641a2547a3b$export$bb38bb9a1161268 = 'unmounted';
var $9d02f641a2547a3b$export$84cbff306f539230 = 'exited';
var $9d02f641a2547a3b$export$df38205c966be359 = 'entering';
var $9d02f641a2547a3b$export$78e9e6e3e014d60a = 'entered';
var $9d02f641a2547a3b$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9d02f641a2547a3b$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $38a8ebb77716eab9$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9d02f641a2547a3b$export$84cbff306f539230;
                _this.appearStatus = $9d02f641a2547a3b$export$df38205c966be359;
            } else initialStatus = $9d02f641a2547a3b$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9d02f641a2547a3b$export$bb38bb9a1161268;
        else initialStatus = $9d02f641a2547a3b$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9d02f641a2547a3b$export$bb38bb9a1161268) return {
            status: $9d02f641a2547a3b$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9d02f641a2547a3b$export$df38205c966be359 && status !== $9d02f641a2547a3b$export$78e9e6e3e014d60a) nextStatus = $9d02f641a2547a3b$export$df38205c966be359;
            } else if (status === $9d02f641a2547a3b$export$df38205c966be359 || status === $9d02f641a2547a3b$export$78e9e6e3e014d60a) nextStatus = $9d02f641a2547a3b$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9d02f641a2547a3b$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($f53291ba5372fee6$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $8bba05046e87d3a2$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9d02f641a2547a3b$export$84cbff306f539230) this.setState({
            status: $9d02f641a2547a3b$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($f53291ba5372fee6$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2cbbe3bd158b59e3$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $9d02f641a2547a3b$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9d02f641a2547a3b$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9d02f641a2547a3b$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($f53291ba5372fee6$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2cbbe3bd158b59e3$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $9d02f641a2547a3b$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9d02f641a2547a3b$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9d02f641a2547a3b$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($f53291ba5372fee6$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9d02f641a2547a3b$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $3171e3955cd84084$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createElement((0, $4e8ba6b1f44f75c0$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).Component);
$9d02f641a2547a3b$var$Transition.contextType = (0, $4e8ba6b1f44f75c0$export$2e2bcd8739ae039);
$9d02f641a2547a3b$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $9d02f641a2547a3b$var$noop() {}
$9d02f641a2547a3b$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9d02f641a2547a3b$var$noop,
    onEntering: $9d02f641a2547a3b$var$noop,
    onEntered: $9d02f641a2547a3b$var$noop,
    onExit: $9d02f641a2547a3b$var$noop,
    onExiting: $9d02f641a2547a3b$var$noop,
    onExited: $9d02f641a2547a3b$var$noop
};
$9d02f641a2547a3b$var$Transition.UNMOUNTED = $9d02f641a2547a3b$export$bb38bb9a1161268;
$9d02f641a2547a3b$var$Transition.EXITED = $9d02f641a2547a3b$export$84cbff306f539230;
$9d02f641a2547a3b$var$Transition.ENTERING = $9d02f641a2547a3b$export$df38205c966be359;
$9d02f641a2547a3b$var$Transition.ENTERED = $9d02f641a2547a3b$export$78e9e6e3e014d60a;
$9d02f641a2547a3b$var$Transition.EXITING = $9d02f641a2547a3b$export$4aacc83d4d59139f;
var $9d02f641a2547a3b$export$2e2bcd8739ae039 = $9d02f641a2547a3b$var$Transition;



var $itHdT = parcelRequire("itHdT");
function $d6f37bf74aea038f$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $d6f37bf74aea038f$export$13e065f3a74cfe36() {
    const parts = $itHdT.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $d6f37bf74aea038f$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $d6f37bf74aea038f$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}





/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $1702c7f05017806b$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $716909ebabe0c73a$var$parseDuration(node) {
    var str = (0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $716909ebabe0c73a$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $1702c7f05017806b$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $697341c5b17243d6$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $716909ebabe0c73a$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $716909ebabe0c73a$var$parseDuration(element) || 0;
    var removeEmulate = $716909ebabe0c73a$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $697341c5b17243d6$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $7e4390c263ced950$var$parseDuration(node, property) {
    const str = (0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $7e4390c263ced950$export$2e2bcd8739ae039(element, handler) {
    const duration = $7e4390c263ced950$var$parseDuration(element, 'transitionDuration');
    const delay = $7e4390c263ced950$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $716909ebabe0c73a$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $5725dbb80636a569$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $5725dbb80636a569$export$2e2bcd8739ae039 = $5725dbb80636a569$var$createChainedFunction;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $33dcd3dcc9914c74$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $itHdT = parcelRequire("itHdT");



function $a34b5afcf5d3f643$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($f53291ba5372fee6$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $9c94770c0413854b$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $itHdT.useRef)(null);
    const mergedRef = (0, $2dff25418658288a$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $a34b5afcf5d3f643$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $itHdT.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $itHdT.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $itHdT.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $itHdT.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $itHdT.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $itHdT.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $itHdT.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9d02f641a2547a3b$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$9c94770c0413854b$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $9c94770c0413854b$export$2e2bcd8739ae039 = $9c94770c0413854b$var$TransitionWrapper;



const $38744d8eba8ad168$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $38744d8eba8ad168$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $38744d8eba8ad168$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $38744d8eba8ad168$var$collapseStyles = {
    [(0, $9d02f641a2547a3b$export$84cbff306f539230)]: 'collapse',
    [(0, $9d02f641a2547a3b$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $9d02f641a2547a3b$export$df38205c966be359)]: 'collapsing',
    [(0, $9d02f641a2547a3b$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $38744d8eba8ad168$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $38744d8eba8ad168$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $itHdT.useMemo)(()=>(0, $5725dbb80636a569$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $itHdT.useMemo)(()=>(0, $5725dbb80636a569$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $itHdT.useMemo)(()=>(0, $5725dbb80636a569$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $itHdT.useMemo)(()=>(0, $5725dbb80636a569$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $33dcd3dcc9914c74$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $itHdT.useMemo)(()=>(0, $5725dbb80636a569$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9c94770c0413854b$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $7e4390c263ced950$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $d6f37bf74aea038f$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, children.props.className, $38744d8eba8ad168$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$38744d8eba8ad168$var$Collapse.displayName = 'Collapse';
var $38744d8eba8ad168$export$2e2bcd8739ae039 = $38744d8eba8ad168$var$Collapse;





"use client";
const $eb5ada18e0e6fe42$var$NavbarCollapse = /*#__PURE__*/ $itHdT.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $itHdT.useContext)((0, $0dd46598caee6987$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $38744d8eba8ad168$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$eb5ada18e0e6fe42$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $eb5ada18e0e6fe42$export$2e2bcd8739ae039 = $eb5ada18e0e6fe42$var$NavbarCollapse;




var $itHdT = parcelRequire("itHdT");




"use client";
const $47b56e5996a20d4f$var$NavbarToggle = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $itHdT.useContext)((0, $0dd46598caee6987$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $153be9953ec91ab7$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$47b56e5996a20d4f$var$NavbarToggle.displayName = 'NavbarToggle';
var $47b56e5996a20d4f$export$2e2bcd8739ae039 = $47b56e5996a20d4f$var$NavbarToggle;



var $itHdT = parcelRequire("itHdT");




var $itHdT = parcelRequire("itHdT");
const $9a1b1889873e8932$var$matchersByWindow = new WeakMap();
const $9a1b1889873e8932$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $9a1b1889873e8932$var$matchersByWindow.get(targetWindow) || new Map();
    $9a1b1889873e8932$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $9a1b1889873e8932$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $9a1b1889873e8932$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $itHdT.useState)(()=>mql ? mql.matches : false);
    (0, $844e75cced394cc3$export$2e2bcd8739ae039)(()=>{
        let mql = $9a1b1889873e8932$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $9a1b1889873e8932$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $itHdT = parcelRequire("itHdT");
function $f7440b6d866a60f2$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $itHdT.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $9a1b1889873e8932$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $f7440b6d866a60f2$var$useBreakpoint = $f7440b6d866a60f2$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $f7440b6d866a60f2$export$2e2bcd8739ae039 = $f7440b6d866a60f2$var$useBreakpoint;




var $itHdT = parcelRequire("itHdT");

function $19a67699c77c5f40$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $c5bd197adfafb87d$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $itHdT = parcelRequire("itHdT");



var $itHdT = parcelRequire("itHdT");
function $9cecd11c345602f0$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $itHdT.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $itHdT = parcelRequire("itHdT");
function $e5e0e4ede39d8f30$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $9cecd11c345602f0$export$2e2bcd8739ae039)(fn);
    (0, $itHdT.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $d195800084238d72$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $0af041b3e26520d8$export$1a88c12b8b979fa0 = (0, $a5ace9316f73275d$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $0af041b3e26520d8$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $d195800084238d72$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($0af041b3e26520d8$export$1a88c12b8b979fa0, '');
        (0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($0af041b3e26520d8$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $0af041b3e26520d8$export$2e2bcd8739ae039 = $0af041b3e26520d8$var$ModalManager;





var $itHdT = parcelRequire("itHdT");

const $98ea167609896df6$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $484c65261e05df0c$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $c5bd197adfafb87d$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $98ea167609896df6$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $ef31c49d95c8eee5$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $itHdT.useState)(()=>$98ea167609896df6$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $98ea167609896df6$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $itHdT.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $itHdT.useEffect)(()=>{
        const nextRef = $98ea167609896df6$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $itHdT = parcelRequire("itHdT");



var $itHdT = parcelRequire("itHdT");

function $2440e9e276d1be52$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $itHdT.useRef)(null);
    const hasEnteredRef = (0, $itHdT.useRef)(inProp);
    const handleExited = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)(onExited);
    (0, $itHdT.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $eed73de565f16b81$export$2e2bcd8739ae039)(ref, (0, $d6f37bf74aea038f$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $itHdT.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $2440e9e276d1be52$export$2e2bcd8739ae039 = $2440e9e276d1be52$var$NoopTransition;



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");


const $11e30aae920577aa$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $11e30aae920577aa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $11e30aae920577aa$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $11e30aae920577aa$var$_objectWithoutPropertiesLoose(_ref, $11e30aae920577aa$var$_excluded);
    const nodeRef = (0, $itHdT.useRef)(null);
    const mergedRef = (0, $eed73de565f16b81$export$2e2bcd8739ae039)(nodeRef, (0, $d6f37bf74aea038f$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $itHdT.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $itHdT.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $itHdT.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $itHdT.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $itHdT.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $itHdT.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $itHdT.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $itHdT.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $4bc6015c9d4857d7$var$_excluded = [
    "component"
];
function $4bc6015c9d4857d7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $4bc6015c9d4857d7$var$RTGTransition = /*#__PURE__*/ $itHdT.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $4bc6015c9d4857d7$var$_objectWithoutPropertiesLoose(_ref, $4bc6015c9d4857d7$var$_excluded);
    const transitionProps = (0, $11e30aae920577aa$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $4bc6015c9d4857d7$export$2e2bcd8739ae039 = $4bc6015c9d4857d7$var$RTGTransition;




function $b12373dc327fb5b2$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $itHdT.useRef)(null);
    const isInitialRef = (0, $itHdT.useRef)(true);
    const handleTransition = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)(onTransition);
    (0, $a7a261fa0ba9f022$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $a7a261fa0ba9f022$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $b12373dc327fb5b2$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $itHdT.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $b12373dc327fb5b2$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $eed73de565f16b81$export$2e2bcd8739ae039)(ref, (0, $d6f37bf74aea038f$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $itHdT.cloneElement)(children, {
        ref: combinedRef
    });
}
function $b12373dc327fb5b2$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4bc6015c9d4857d7$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($b12373dc327fb5b2$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2440e9e276d1be52$export$2e2bcd8739ae039), Object.assign({}, props));
}




const $f04cf1efcbaf36dd$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $f04cf1efcbaf36dd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $f04cf1efcbaf36dd$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $f04cf1efcbaf36dd$var$getManager(window) {
    if (!$f04cf1efcbaf36dd$var$manager) $f04cf1efcbaf36dd$var$manager = new (0, $0af041b3e26520d8$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $f04cf1efcbaf36dd$var$manager;
}
function $f04cf1efcbaf36dd$var$useModalManager(provided) {
    const window = (0, $ef31c49d95c8eee5$export$2e2bcd8739ae039)();
    const modalManager = provided || $f04cf1efcbaf36dd$var$getManager(window);
    const modal = (0, $itHdT.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $itHdT.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $itHdT.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $f04cf1efcbaf36dd$var$Modal = /*#__PURE__*/ (0, $itHdT.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $f04cf1efcbaf36dd$var$_objectWithoutPropertiesLoose(_ref, $f04cf1efcbaf36dd$var$_excluded);
    const ownerWindow = (0, $ef31c49d95c8eee5$export$2e2bcd8739ae039)();
    const container = (0, $98ea167609896df6$export$2e2bcd8739ae039)(containerRef);
    const modal = $f04cf1efcbaf36dd$var$useModalManager(providedManager);
    const isMounted = (0, $2ceb9f66fc633217$export$2e2bcd8739ae039)();
    const prevShow = (0, $7578cedb2667400d$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $itHdT.useState)(!show);
    const lastFocusRef = (0, $itHdT.useRef)(null);
    (0, $itHdT.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $484c65261e05df0c$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $19a67699c77c5f40$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $697341c5b17243d6$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $697341c5b17243d6$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $19a67699c77c5f40$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $f292680e7c6407e3$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $itHdT.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $itHdT.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $e5e0e4ede39d8f30$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $19a67699c77c5f40$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $f292680e7c6407e3$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $d6f37bf74aea038f$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $itHdT.useRef)();
    const removeKeydownListenerRef = (0, $itHdT.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $itHdT.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $b12373dc327fb5b2$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $b12373dc327fb5b2$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f53291ba5372fee6$exports))).createPortal(/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$f04cf1efcbaf36dd$var$Modal.displayName = 'Modal';
var $f04cf1efcbaf36dd$export$2e2bcd8739ae039 = Object.assign($f04cf1efcbaf36dd$var$Modal, {
    Manager: (0, $0af041b3e26520d8$export$2e2bcd8739ae039)
});




var $itHdT = parcelRequire("itHdT");






const $eb31cd918b0fa60f$var$fadeStyles = {
    [(0, $9d02f641a2547a3b$export$df38205c966be359)]: 'show',
    [(0, $9d02f641a2547a3b$export$78e9e6e3e014d60a)]: 'show'
};
const $eb31cd918b0fa60f$var$Fade = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $itHdT.useCallback)((node, isAppearing)=>{
        (0, $33dcd3dcc9914c74$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9c94770c0413854b$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $7e4390c263ced950$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $d6f37bf74aea038f$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $itHdT.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))('fade', className, children.props.className, $eb31cd918b0fa60f$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$eb31cd918b0fa60f$var$Fade.displayName = 'Fade';
var $eb31cd918b0fa60f$export$2e2bcd8739ae039 = $eb31cd918b0fa60f$var$Fade;



var $itHdT = parcelRequire("itHdT");



"use client";
const $e4ac2dfe2d81234b$var$OffcanvasBody = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$e4ac2dfe2d81234b$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $e4ac2dfe2d81234b$export$2e2bcd8739ae039 = $e4ac2dfe2d81234b$var$OffcanvasBody;




var $itHdT = parcelRequire("itHdT");






"use client";
const $b6b0afc60fd89a0b$var$transitionStyles = {
    [(0, $9d02f641a2547a3b$export$df38205c966be359)]: 'show',
    [(0, $9d02f641a2547a3b$export$78e9e6e3e014d60a)]: 'show'
};
const $b6b0afc60fd89a0b$var$OffcanvasToggling = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9c94770c0413854b$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $7e4390c263ced950$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $d6f37bf74aea038f$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $itHdT.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, children.props.className, (status === (0, $9d02f641a2547a3b$export$df38205c966be359) || status === (0, $9d02f641a2547a3b$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $b6b0afc60fd89a0b$var$transitionStyles[status])
            })
    });
});
$b6b0afc60fd89a0b$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $b6b0afc60fd89a0b$export$2e2bcd8739ae039 = $b6b0afc60fd89a0b$var$OffcanvasToggling;



var $itHdT = parcelRequire("itHdT");
"use client";
const $4e1f959e29ca9ad1$var$ModalContext = /*#__PURE__*/ $itHdT.createContext({
    onHide () {}
});
var $4e1f959e29ca9ad1$export$2e2bcd8739ae039 = $4e1f959e29ca9ad1$var$ModalContext;




var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");

var $6df474e6792427b0$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6df474e6792427b0$var$ReactIs, $6df474e6792427b0$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$6df474e6792427b0$exports = (parcelRequire("i8WYF"))();



var $itHdT = parcelRequire("itHdT");


const $8e67b2a05f9aad1c$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).oneOf([
        'white'
    ])
};
const $8e67b2a05f9aad1c$var$CloseButton = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$8e67b2a05f9aad1c$var$CloseButton.displayName = 'CloseButton';
$8e67b2a05f9aad1c$var$CloseButton.propTypes = $8e67b2a05f9aad1c$var$propTypes;
var $8e67b2a05f9aad1c$export$2e2bcd8739ae039 = $8e67b2a05f9aad1c$var$CloseButton;




"use client";
const $78a469f7262e35aa$var$AbstractModalHeader = /*#__PURE__*/ $itHdT.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $itHdT.useContext)((0, $4e1f959e29ca9ad1$export$2e2bcd8739ae039));
    const handleClick = (0, $153be9953ec91ab7$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8e67b2a05f9aad1c$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$78a469f7262e35aa$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $78a469f7262e35aa$export$2e2bcd8739ae039 = $78a469f7262e35aa$var$AbstractModalHeader;



"use client";
const $17d3c398b5610a0a$var$OffcanvasHeader = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $78a469f7262e35aa$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$17d3c398b5610a0a$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $17d3c398b5610a0a$export$2e2bcd8739ae039 = $17d3c398b5610a0a$var$OffcanvasHeader;



var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");


var $62e41ab67f5e63a5$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $itHdT.forwardRef((p, ref)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(p.className, className)
        }));




"use client";
const $6aa4483a53f1d01c$var$DivStyledAsH5 = (0, $62e41ab67f5e63a5$export$2e2bcd8739ae039)('h5');
const $6aa4483a53f1d01c$var$OffcanvasTitle = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $6aa4483a53f1d01c$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$6aa4483a53f1d01c$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $6aa4483a53f1d01c$export$2e2bcd8739ae039 = $6aa4483a53f1d01c$var$OffcanvasTitle;



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $d24c125de4c96666$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $5eaae7990610d62e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $d24c125de4c96666$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $38bc0c7c12f0cdec$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $38bc0c7c12f0cdec$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $38bc0c7c12f0cdec$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $38bc0c7c12f0cdec$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $a66cc7cc3c743241$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $a66cc7cc3c743241$var$BootstrapModalManager extends (0, $0af041b3e26520d8$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $1d295ea8cafefc74$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $5eaae7990610d62e$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(container, $a66cc7cc3c743241$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(container, $a66cc7cc3c743241$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(container, $a66cc7cc3c743241$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $38bc0c7c12f0cdec$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(container, $a66cc7cc3c743241$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(container, $a66cc7cc3c743241$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $48dfaa521cc7b972$export$2e2bcd8739ae039)(container, $a66cc7cc3c743241$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $a66cc7cc3c743241$var$sharedManager;
function $a66cc7cc3c743241$export$a03641438014b436(options) {
    if (!$a66cc7cc3c743241$var$sharedManager) $a66cc7cc3c743241$var$sharedManager = new $a66cc7cc3c743241$var$BootstrapModalManager(options);
    return $a66cc7cc3c743241$var$sharedManager;
}
var $a66cc7cc3c743241$export$2e2bcd8739ae039 = $a66cc7cc3c743241$var$BootstrapModalManager;



"use client";
function $e33248f28a43b8c2$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b6b0afc60fd89a0b$export$2e2bcd8739ae039), {
        ...props
    });
}
function $e33248f28a43b8c2$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $eb31cd918b0fa60f$export$2e2bcd8739ae039), {
        ...props
    });
}
const $e33248f28a43b8c2$var$Offcanvas = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $itHdT.useRef)();
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $itHdT.useState)(false);
    const handleHide = (0, $153be9953ec91ab7$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $f7440b6d866a60f2$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $itHdT.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $itHdT.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $a66cc7cc3c743241$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $a66cc7cc3c743241$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $itHdT.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4e1f959e29ca9ad1$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f04cf1efcbaf36dd$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $e33248f28a43b8c2$var$DialogTransition,
                    backdropTransition: $e33248f28a43b8c2$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$e33248f28a43b8c2$var$Offcanvas.displayName = 'Offcanvas';
var $e33248f28a43b8c2$export$2e2bcd8739ae039 = Object.assign($e33248f28a43b8c2$var$Offcanvas, {
    Body: (0, $e4ac2dfe2d81234b$export$2e2bcd8739ae039),
    Header: (0, $17d3c398b5610a0a$export$2e2bcd8739ae039),
    Title: (0, $6aa4483a53f1d01c$export$2e2bcd8739ae039)
});




"use client";
const $f6b69411dd2e8fed$var$NavbarOffcanvas = /*#__PURE__*/ $itHdT.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $itHdT.useContext)((0, $0dd46598caee6987$export$2e2bcd8739ae039));
    const handleHide = (0, $153be9953ec91ab7$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $e33248f28a43b8c2$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$f6b69411dd2e8fed$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $f6b69411dd2e8fed$export$2e2bcd8739ae039 = $f6b69411dd2e8fed$var$NavbarOffcanvas;





var $itHdT = parcelRequire("itHdT");



"use client";
const $30ef02bb18a026df$var$NavbarText = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$30ef02bb18a026df$var$NavbarText.displayName = 'NavbarText';
var $30ef02bb18a026df$export$2e2bcd8739ae039 = $30ef02bb18a026df$var$NavbarText;



"use client";
const $c5c707e1c7e013d3$var$Navbar = /*#__PURE__*/ $itHdT.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $ebcd10849b756af0$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $itHdT.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $itHdT.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dd46598caee6987$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f2cddde8eb83ce78$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$c5c707e1c7e013d3$var$Navbar.displayName = 'Navbar';
var $c5c707e1c7e013d3$export$2e2bcd8739ae039 = Object.assign($c5c707e1c7e013d3$var$Navbar, {
    Brand: (0, $fe192e15278c2aba$export$2e2bcd8739ae039),
    Collapse: (0, $eb5ada18e0e6fe42$export$2e2bcd8739ae039),
    Offcanvas: (0, $f6b69411dd2e8fed$export$2e2bcd8739ae039),
    Text: (0, $30ef02bb18a026df$export$2e2bcd8739ae039),
    Toggle: (0, $47b56e5996a20d4f$export$2e2bcd8739ae039)
});





var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");

const $028265c72ab38339$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("aLtt3"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $59d8dd94fc2bfa1e$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $59d8dd94fc2bfa1e$export$14f2b6540d498ce extends $59d8dd94fc2bfa1e$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $59d8dd94fc2bfa1e$export$d08a45df86040161 extends $59d8dd94fc2bfa1e$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $59d8dd94fc2bfa1e$export$761f8c0e0fa4624f extends $59d8dd94fc2bfa1e$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $59d8dd94fc2bfa1e$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($59d8dd94fc2bfa1e$export$9b19f1a5abf91e06 || ($59d8dd94fc2bfa1e$export$9b19f1a5abf91e06 = {}));


var $def1f42960a27951$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $def1f42960a27951$export$1d0b400bf8a0fa55 {
    constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $59d8dd94fc2bfa1e$export$9b19f1a5abf91e06).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $028265c72ab38339$export$98d92b1aa79f8cc7)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $def1f42960a27951$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                // Add region as query parameter using URL API
                const url = new URL(`${this.url}/${functionName}`);
                if (region && region !== 'any') {
                    _headers['x-region'] = region;
                    url.searchParams.set('forceFunctionRegion', region);
                }
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(url.toString(), {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $59d8dd94fc2bfa1e$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $59d8dd94fc2bfa1e$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $59d8dd94fc2bfa1e$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null,
                    response: response
                };
            } catch (error) {
                return {
                    data: null,
                    error: error,
                    response: error instanceof (0, $59d8dd94fc2bfa1e$export$761f8c0e0fa4624f) || error instanceof (0, $59d8dd94fc2bfa1e$export$d08a45df86040161) ? error.context : undefined
                };
            }
        });
    }
}


var $05edb9785841efd4$exports = {};
"use strict";
var $05edb9785841efd4$var$__importDefault = $05edb9785841efd4$exports && $05edb9785841efd4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($05edb9785841efd4$exports, "__esModule", {
    value: true
});
$05edb9785841efd4$exports.PostgrestError = $05edb9785841efd4$exports.PostgrestBuilder = $05edb9785841efd4$exports.PostgrestTransformBuilder = $05edb9785841efd4$exports.PostgrestFilterBuilder = $05edb9785841efd4$exports.PostgrestQueryBuilder = $05edb9785841efd4$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
const $05edb9785841efd4$var$PostgrestClient_1 = $05edb9785841efd4$var$__importDefault((parcelRequire("kuAZy")));
$05edb9785841efd4$exports.PostgrestClient = $05edb9785841efd4$var$PostgrestClient_1.default;

const $05edb9785841efd4$var$PostgrestQueryBuilder_1 = $05edb9785841efd4$var$__importDefault((parcelRequire("3XBkd")));
$05edb9785841efd4$exports.PostgrestQueryBuilder = $05edb9785841efd4$var$PostgrestQueryBuilder_1.default;

const $05edb9785841efd4$var$PostgrestFilterBuilder_1 = $05edb9785841efd4$var$__importDefault((parcelRequire("kcIcf")));
$05edb9785841efd4$exports.PostgrestFilterBuilder = $05edb9785841efd4$var$PostgrestFilterBuilder_1.default;

const $05edb9785841efd4$var$PostgrestTransformBuilder_1 = $05edb9785841efd4$var$__importDefault((parcelRequire("k5Niq")));
$05edb9785841efd4$exports.PostgrestTransformBuilder = $05edb9785841efd4$var$PostgrestTransformBuilder_1.default;

const $05edb9785841efd4$var$PostgrestBuilder_1 = $05edb9785841efd4$var$__importDefault((parcelRequire("96pgx")));
$05edb9785841efd4$exports.PostgrestBuilder = $05edb9785841efd4$var$PostgrestBuilder_1.default;

const $05edb9785841efd4$var$PostgrestError_1 = $05edb9785841efd4$var$__importDefault((parcelRequire("bXeOl")));
$05edb9785841efd4$exports.PostgrestError = $05edb9785841efd4$var$PostgrestError_1.default;
$05edb9785841efd4$exports.default = {
    PostgrestClient: $05edb9785841efd4$var$PostgrestClient_1.default,
    PostgrestQueryBuilder: $05edb9785841efd4$var$PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: $05edb9785841efd4$var$PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: $05edb9785841efd4$var$PostgrestTransformBuilder_1.default,
    PostgrestBuilder: $05edb9785841efd4$var$PostgrestBuilder_1.default,
    PostgrestError: $05edb9785841efd4$var$PostgrestError_1.default
};


const { PostgrestClient: $c6cffb92fd18d72c$export$796f32e2ee984aaa, PostgrestQueryBuilder: $c6cffb92fd18d72c$export$a81993b50ca081ad, PostgrestFilterBuilder: $c6cffb92fd18d72c$export$3158317c13bdc93a, PostgrestTransformBuilder: $c6cffb92fd18d72c$export$7b4361bb87e3030c, PostgrestBuilder: $c6cffb92fd18d72c$export$3106e21688a06353, PostgrestError: $c6cffb92fd18d72c$export$445b7e3a323f992f } = (0, (/*@__PURE__*/$parcel$interopDefault($05edb9785841efd4$exports)));
var // compatibility with CJS output
$c6cffb92fd18d72c$export$2e2bcd8739ae039 = {
    PostgrestClient: $c6cffb92fd18d72c$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $c6cffb92fd18d72c$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $c6cffb92fd18d72c$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $c6cffb92fd18d72c$export$7b4361bb87e3030c,
    PostgrestBuilder: $c6cffb92fd18d72c$export$3106e21688a06353,
    PostgrestError: $c6cffb92fd18d72c$export$445b7e3a323f992f
};


class $d3bac3df73bee295$export$67be75336dea7fb5 {
    static detectEnvironment() {
        var _a;
        if (typeof WebSocket !== 'undefined') return {
            type: 'native',
            constructor: WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocket !== 'undefined') return {
            type: 'native',
            constructor: globalThis.WebSocket
        };
        if (typeof $parcel$global !== 'undefined' && typeof $parcel$global.WebSocket !== 'undefined') return {
            type: 'native',
            constructor: $parcel$global.WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof globalThis.WebSocketPair !== 'undefined' && typeof globalThis.WebSocket === 'undefined') return {
            type: 'cloudflare',
            error: 'Cloudflare Workers detected. WebSocket clients are not supported in Cloudflare Workers.',
            workaround: 'Use Cloudflare Workers WebSocket API for server-side WebSocket handling, or deploy to a different runtime.'
        };
        if (typeof globalThis !== 'undefined' && globalThis.EdgeRuntime || typeof navigator !== 'undefined' && ((_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('Vercel-Edge'))) return {
            type: 'unsupported',
            error: 'Edge runtime detected (Vercel Edge/Netlify Edge). WebSockets are not supported in edge functions.',
            workaround: 'Use serverless functions or a different deployment target for WebSocket functionality.'
        };
        return {
            type: 'unsupported',
            error: 'Unknown JavaScript runtime without WebSocket support.',
            workaround: "Ensure you're running in a supported environment (browser, Node.js, Deno) or provide a custom WebSocket implementation."
        };
    }
    static getWebSocketConstructor() {
        const env = this.detectEnvironment();
        if (env.constructor) return env.constructor;
        let errorMessage = env.error || 'WebSocket not supported in this environment.';
        if (env.workaround) errorMessage += `\n\nSuggested solution: ${env.workaround}`;
        throw new Error(errorMessage);
    }
    static createWebSocket(url, protocols) {
        const WS = this.getWebSocketConstructor();
        return new WS(url, protocols);
    }
    static isWebSocketSupported() {
        try {
            const env = this.detectEnvironment();
            return env.type === 'native' || env.type === 'ws';
        } catch (_a) {
            return false;
        }
    }
}
var $d3bac3df73bee295$export$2e2bcd8739ae039 = $d3bac3df73bee295$export$67be75336dea7fb5;


const $42709b4e42b695a4$export$83d89fbfd8236492 = '2.15.1';


const $2e0562ab56175960$export$363ebe89e6e7aeef = `realtime-js/${(0, $42709b4e42b695a4$export$83d89fbfd8236492)}`;
const $2e0562ab56175960$export$df3f558bb9a9c991 = '1.0.0';
const $2e0562ab56175960$export$a4ad2735b021c132 = (0, $42709b4e42b695a4$export$83d89fbfd8236492);
const $2e0562ab56175960$export$7bd623b29ec8e1eb = 10000;
const $2e0562ab56175960$export$5e80cf62e56a877b = 1000;
const $2e0562ab56175960$export$f227fe8351a81f4a = 100;
var $2e0562ab56175960$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($2e0562ab56175960$export$a6d0320a1563d49e || ($2e0562ab56175960$export$a6d0320a1563d49e = {}));
var $2e0562ab56175960$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($2e0562ab56175960$export$b83816118db74fe7 || ($2e0562ab56175960$export$b83816118db74fe7 = {}));
var $2e0562ab56175960$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($2e0562ab56175960$export$8db7548e65d6ea55 || ($2e0562ab56175960$export$8db7548e65d6ea55 = {}));
var $2e0562ab56175960$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($2e0562ab56175960$export$b2688bfb999f5751 || ($2e0562ab56175960$export$b2688bfb999f5751 = {}));
var $2e0562ab56175960$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($2e0562ab56175960$export$deda39003d27273 || ($2e0562ab56175960$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $d214dfb16cadc3ee$export$2e2bcd8739ae039 {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $daad528c49fc1075$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
        this.timer = undefined;
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $7a4722133ee6347b$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($7a4722133ee6347b$export$4d213a7d364021dc || ($7a4722133ee6347b$export$4d213a7d364021dc = {}));
const $7a4722133ee6347b$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $7a4722133ee6347b$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $7a4722133ee6347b$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $7a4722133ee6347b$export$3df02a362b86a91(colType, value);
    return $7a4722133ee6347b$var$noop(value);
};
const $7a4722133ee6347b$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $7a4722133ee6347b$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $7a4722133ee6347b$export$4d213a7d364021dc.bool:
            return $7a4722133ee6347b$export$3c2e6d1b7583eee6(value);
        case $7a4722133ee6347b$export$4d213a7d364021dc.float4:
        case $7a4722133ee6347b$export$4d213a7d364021dc.float8:
        case $7a4722133ee6347b$export$4d213a7d364021dc.int2:
        case $7a4722133ee6347b$export$4d213a7d364021dc.int4:
        case $7a4722133ee6347b$export$4d213a7d364021dc.int8:
        case $7a4722133ee6347b$export$4d213a7d364021dc.numeric:
        case $7a4722133ee6347b$export$4d213a7d364021dc.oid:
            return $7a4722133ee6347b$export$a0a81dc3380ce7d3(value);
        case $7a4722133ee6347b$export$4d213a7d364021dc.json:
        case $7a4722133ee6347b$export$4d213a7d364021dc.jsonb:
            return $7a4722133ee6347b$export$d5b7a8bf56ee1fe2(value);
        case $7a4722133ee6347b$export$4d213a7d364021dc.timestamp:
            return $7a4722133ee6347b$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $7a4722133ee6347b$export$4d213a7d364021dc.abstime:
        case $7a4722133ee6347b$export$4d213a7d364021dc.date:
        case $7a4722133ee6347b$export$4d213a7d364021dc.daterange:
        case $7a4722133ee6347b$export$4d213a7d364021dc.int4range:
        case $7a4722133ee6347b$export$4d213a7d364021dc.int8range:
        case $7a4722133ee6347b$export$4d213a7d364021dc.money:
        case $7a4722133ee6347b$export$4d213a7d364021dc.reltime:
        case $7a4722133ee6347b$export$4d213a7d364021dc.text:
        case $7a4722133ee6347b$export$4d213a7d364021dc.time:
        case $7a4722133ee6347b$export$4d213a7d364021dc.timestamptz:
        case $7a4722133ee6347b$export$4d213a7d364021dc.timetz:
        case $7a4722133ee6347b$export$4d213a7d364021dc.tsrange:
        case $7a4722133ee6347b$export$4d213a7d364021dc.tstzrange:
            return $7a4722133ee6347b$var$noop(value);
        default:
            // Return the value for remaining types
            return $7a4722133ee6347b$var$noop(value);
    }
};
const $7a4722133ee6347b$var$noop = (value)=>{
    return value;
};
const $7a4722133ee6347b$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $7a4722133ee6347b$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $7a4722133ee6347b$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $7a4722133ee6347b$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$7a4722133ee6347b$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $7a4722133ee6347b$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $7a4722133ee6347b$export$976fda7151b30cae = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '') + '/api/broadcast';
};




class $c2a0650e59c2a634$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $2e0562ab56175960$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $376928138cf4da52$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($376928138cf4da52$export$f1ce049df2794fb4 || ($376928138cf4da52$export$f1ce049df2794fb4 = {}));
class $376928138cf4da52$export$2e2bcd8739ae039 {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.enabled = false;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $376928138cf4da52$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $376928138cf4da52$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $376928138cf4da52$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}



var $7ece6d3d4f0fb361$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($7ece6d3d4f0fb361$export$bc171c571098b6c4 || ($7ece6d3d4f0fb361$export$bc171c571098b6c4 = {}));
var $7ece6d3d4f0fb361$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($7ece6d3d4f0fb361$export$9e3fe8e487ef792e || ($7ece6d3d4f0fb361$export$9e3fe8e487ef792e = {}));
var $7ece6d3d4f0fb361$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($7ece6d3d4f0fb361$export$a6885b926af646a2 || ($7ece6d3d4f0fb361$export$a6885b926af646a2 = {}));
const $7ece6d3d4f0fb361$export$154db638d9c0559e = (0, $2e0562ab56175960$export$b83816118db74fe7);
class $7ece6d3d4f0fb361$export$2e2bcd8739ae039 {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $c2a0650e59c2a634$export$2e2bcd8739ae039)(this, (0, $2e0562ab56175960$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $daad528c49fc1075$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('error', (reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $2e0562ab56175960$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $376928138cf4da52$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $7a4722133ee6347b$export$976fda7151b30cae)(this.socket.endPoint);
        this.private = this.params.config.private || false;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.state == (0, $2e0562ab56175960$export$b83816118db74fe7).closed) {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            const postgres_changes = (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [];
            const presence_enabled = !!this.bindings[$7ece6d3d4f0fb361$export$9e3fe8e487ef792e.PRESENCE] && this.bindings[$7ece6d3d4f0fb361$export$9e3fe8e487ef792e.PRESENCE].length > 0;
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: Object.assign(Object.assign({}, presence), {
                    enabled: presence_enabled
                }),
                postgres_changes: postgres_changes,
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback($7ece6d3d4f0fb361$export$a6885b926af646a2.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($7ece6d3d4f0fb361$export$a6885b926af646a2.CLOSED));
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes: postgres_changes })=>{
                var _a;
                this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($7ece6d3d4f0fb361$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).errored;
                            callback === null || callback === void 0 || callback($7ece6d3d4f0fb361$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback($7ece6d3d4f0fb361$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).errored;
                callback === null || callback === void 0 || callback($7ece6d3d4f0fb361$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($7ece6d3d4f0fb361$export$a6885b926af646a2.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        if (this.state === (0, $2e0562ab56175960$export$b83816118db74fe7).joined && type === $7ece6d3d4f0fb361$export$9e3fe8e487ef792e.PRESENCE) {
            this.socket.log('channel', `resubscribe to ${this.topic} due to change in presence callbacks on joined channel`);
            this.unsubscribe().then(()=>this.subscribe());
        }
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event: event, payload: endpoint_payload } = args;
            const authorization = this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : '';
            const options = {
                method: 'POST',
                headers: {
                    Authorization: authorization,
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $2e0562ab56175960$export$8db7548e65d6ea55).close, 'leave', this._joinRef());
        };
        this.joinPush.destroy();
        let leavePush = null;
        return new Promise((resolve)=>{
            leavePush = new (0, $c2a0650e59c2a634$export$2e2bcd8739ae039)(this, (0, $2e0562ab56175960$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        }).finally(()=>{
            leavePush === null || leavePush === void 0 || leavePush.destroy();
        });
    }
    /**
     * Teardown the channel.
     *
     * Destroys and stops related timers.
     */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.pushBuffer = [];
        this.rejoinTimer.reset();
        this.joinPush.destroy();
        this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).closed;
        this.bindings = {};
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $c2a0650e59c2a634$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else this._addToPushBuffer(pushEvent);
        return pushEvent;
    }
    /** @internal */ _addToPushBuffer(pushEvent) {
        pushEvent.startTimeout();
        this.pushBuffer.push(pushEvent);
        // Enforce buffer size limit
        if (this.pushBuffer.length > (0, $2e0562ab56175960$export$f227fe8351a81f4a)) {
            const removedPush = this.pushBuffer.shift();
            if (removedPush) {
                removedPush.destroy();
                this.socket.log('channel', `discarded push due to buffer overflow: ${removedPush.event}`, removedPush.payload);
            }
        }
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $2e0562ab56175960$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $2e0562ab56175960$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $2e0562ab56175960$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $2e0562ab56175960$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $2e0562ab56175960$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        if (this.bindings[typeLower]) this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $7ece6d3d4f0fb361$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $2e0562ab56175960$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $2e0562ab56175960$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $2e0562ab56175960$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $7a4722133ee6347b$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $7a4722133ee6347b$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
}


const $d080f38a352a2a89$var$noop = ()=>{};
// Connection-related constants
const $d080f38a352a2a89$var$CONNECTION_TIMEOUTS = {
    HEARTBEAT_INTERVAL: 25000,
    RECONNECT_DELAY: 10,
    HEARTBEAT_TIMEOUT_FALLBACK: 100
};
const $d080f38a352a2a89$var$RECONNECT_INTERVALS = [
    1000,
    2000,
    5000,
    10000
];
const $d080f38a352a2a89$var$DEFAULT_RECONNECT_FALLBACK = 10000;
const $d080f38a352a2a89$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;

class $d080f38a352a2a89$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers Deprecated: headers cannot be set on websocket connections and this option will be removed in the future.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.logLevel Sets the log level for Realtime
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = new Array();
        this.endPoint = '';
        this.httpEndpoint = '';
        /** @deprecated headers cannot be set on websocket connections */ this.headers = {};
        this.params = {};
        this.timeout = (0, $2e0562ab56175960$export$7bd623b29ec8e1eb);
        this.transport = null;
        this.heartbeatIntervalMs = $d080f38a352a2a89$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.heartbeatCallback = $d080f38a352a2a89$var$noop;
        this.ref = 0;
        this.reconnectTimer = null;
        this.logger = $d080f38a352a2a89$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $d214dfb16cadc3ee$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        this._connectionState = 'disconnected';
        this._wasManualDisconnect = false;
        this._authPromise = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') // Node.js environment without native fetch
            _fetch = (...args)=>Promise.resolve((parcelRequire("aLtt3"))).then(({ default: fetch1 })=>fetch1(...args)).catch((error)=>{
                    throw new Error(`Failed to load @supabase/node-fetch: ${error.message}. ` + `This is required for HTTP requests in Node.js environments without native fetch.`);
                });
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        // Validate required parameters
        if (!((_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey)) throw new Error('API key is required to connect to Realtime');
        this.apiKey = options.params.apikey;
        // Initialize endpoint URLs
        this.endPoint = `${endPoint}/${(0, $2e0562ab56175960$export$b2688bfb999f5751).websocket}`;
        this.httpEndpoint = (0, $7a4722133ee6347b$export$976fda7151b30cae)(endPoint);
        this._initializeOptions(options);
        this._setupReconnectionTimer();
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        // Skip if already connecting, disconnecting, or connected
        if (this.isConnecting() || this.isDisconnecting() || this.conn !== null && this.isConnected()) return;
        this._setConnectionState('connecting');
        this._setAuthSafely('connect');
        // Establish WebSocket connection
        if (this.transport) // Use custom transport if provided
        this.conn = new this.transport(this.endpointURL());
        else // Try to use native WebSocket
        try {
            this.conn = (0, $d3bac3df73bee295$export$2e2bcd8739ae039).createWebSocket(this.endpointURL());
        } catch (error) {
            this._setConnectionState('disconnected');
            const errorMessage = error.message;
            // Provide helpful error message based on environment
            if (errorMessage.includes('Node.js')) throw new Error(`${errorMessage}\n\n` + 'To use Realtime in Node.js, you need to provide a WebSocket implementation:\n\n' + 'Option 1: Use Node.js 22+ which has native WebSocket support\n' + 'Option 2: Install and provide the "ws" package:\n\n' + '  npm install ws\n\n' + '  import ws from "ws"\n' + '  const client = new RealtimeClient(url, {\n' + '    ...options,\n' + '    transport: ws\n' + '  })');
            throw new Error(`WebSocket not available: ${errorMessage}`);
        }
        this._setupConnectionHandlers();
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $2e0562ab56175960$export$df3f558bb9a9c991)
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.isDisconnecting()) return;
        this._setConnectionState('disconnecting', true);
        if (this.conn) {
            // Setup fallback timer to prevent hanging in disconnecting state
            const fallbackTimer = setTimeout(()=>{
                this._setConnectionState('disconnected');
            }, 100);
            this.conn.onclose = ()=>{
                clearTimeout(fallbackTimer);
                this._setConnectionState('disconnected');
            };
            // Close the WebSocket connection
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this._teardownConnection();
        } else this._setConnectionState('disconnected');
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.channels = [];
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $2e0562ab56175960$export$a6d0320a1563d49e).connecting:
                return (0, $2e0562ab56175960$export$deda39003d27273).Connecting;
            case (0, $2e0562ab56175960$export$a6d0320a1563d49e).open:
                return (0, $2e0562ab56175960$export$deda39003d27273).Open;
            case (0, $2e0562ab56175960$export$a6d0320a1563d49e).closing:
                return (0, $2e0562ab56175960$export$deda39003d27273).Closing;
            default:
                return (0, $2e0562ab56175960$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $2e0562ab56175960$export$deda39003d27273).Open;
    }
    /**
     * Returns `true` if the connection is currently connecting.
     */ isConnecting() {
        return this._connectionState === 'connecting';
    }
    /**
     * Returns `true` if the connection is currently disconnecting.
     */ isDisconnecting() {
        return this._connectionState === 'disconnecting';
    }
    channel(topic, params = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c)=>c.topic === realtimeTopic);
        if (!exists) {
            const chan = new (0, $7ece6d3d4f0fb361$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ async setAuth(token = null) {
        this._authPromise = this._performAuth(token);
        try {
            await this._authPromise;
        } finally{
            this._authPromise = null;
        }
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) {
            this.heartbeatCallback('disconnected');
            return;
        }
        // Handle heartbeat timeout and force reconnection if needed
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            this.heartbeatCallback('timeout');
            // Force reconnection after heartbeat timeout
            this._wasManualDisconnect = false;
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $2e0562ab56175960$export$5e80cf62e56a877b), 'heartbeat timeout');
            setTimeout(()=>{
                var _a;
                if (!this.isConnected()) (_a = this.reconnectTimer) === null || _a === void 0 || _a.scheduleTimeout();
            }, $d080f38a352a2a89$var$CONNECTION_TIMEOUTS.HEARTBEAT_TIMEOUT_FALLBACK);
            return;
        }
        // Send heartbeat message to server
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.heartbeatCallback('sent');
        this._setAuthSafely('heartbeat');
    }
    onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c.topic !== channel.topic);
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            // Handle heartbeat responses
            if (msg.topic === 'phoenix' && msg.event === 'phx_reply') this.heartbeatCallback(msg.payload.status === 'ok' ? 'ok' : 'error');
            // Handle pending heartbeat reference cleanup
            if (msg.ref && msg.ref === this.pendingHeartbeatRef) this.pendingHeartbeatRef = null;
            // Log incoming message
            const { topic: topic, event: event, payload: payload, ref: ref } = msg;
            const refString = ref ? `(${ref})` : '';
            const status = payload.status || '';
            this.log('receive', `${status} ${topic} ${event} ${refString}`.trim(), payload);
            // Route message to appropriate channels
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this._triggerStateCallbacks('message', msg);
        });
    }
    /**
     * Clear specific timer
     * @internal
     */ _clearTimer(timer) {
        var _a;
        if (timer === 'heartbeat' && this.heartbeatTimer) {
            clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = undefined;
        } else if (timer === 'reconnect') (_a = this.reconnectTimer) === null || _a === void 0 || _a.reset();
    }
    /**
     * Clear all timers
     * @internal
     */ _clearAllTimers() {
        this._clearTimer('heartbeat');
        this._clearTimer('reconnect');
    }
    /**
     * Setup connection handlers for WebSocket events
     * @internal
     */ _setupConnectionHandlers() {
        if (!this.conn) return;
        // Set binary type if supported (browsers and most WebSocket implementations)
        if ('binaryType' in this.conn) this.conn.binaryType = 'arraybuffer';
        this.conn.onopen = ()=>this._onConnOpen();
        this.conn.onerror = (error)=>this._onConnError(error);
        this.conn.onmessage = (event)=>this._onConnMessage(event);
        this.conn.onclose = (event)=>this._onConnClose(event);
    }
    /**
     * Teardown connection and cleanup resources
     * @internal
     */ _teardownConnection() {
        if (this.conn) {
            this.conn.onopen = null;
            this.conn.onerror = null;
            this.conn.onmessage = null;
            this.conn.onclose = null;
            this.conn = null;
        }
        this._clearAllTimers();
        this.channels.forEach((channel)=>channel.teardown());
    }
    /** @internal */ _onConnOpen() {
        this._setConnectionState('connected');
        this.log('transport', `connected to ${this.endpointURL()}`);
        this.flushSendBuffer();
        this._clearTimer('reconnect');
        if (!this.worker) this._startHeartbeat();
        else if (!this.workerRef) this._startWorkerHeartbeat();
        this._triggerStateCallbacks('open');
    }
    /** @internal */ _startHeartbeat() {
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    /** @internal */ _startWorkerHeartbeat() {
        if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
        else this.log('worker', `starting default worker`);
        const objectUrl = this._workerObjectUrl(this.workerUrl);
        this.workerRef = new Worker(objectUrl);
        this.workerRef.onerror = (error)=>{
            this.log('worker', 'worker error', error.message);
            this.workerRef.terminate();
        };
        this.workerRef.onmessage = (event)=>{
            if (event.data.event === 'keepAlive') this.sendHeartbeat();
        };
        this.workerRef.postMessage({
            event: 'start',
            interval: this.heartbeatIntervalMs
        });
    }
    /** @internal */ _onConnClose(event) {
        var _a;
        this._setConnectionState('disconnected');
        this.log('transport', 'close', event);
        this._triggerChanError();
        this._clearTimer('heartbeat');
        // Only schedule reconnection if it wasn't a manual disconnect
        if (!this._wasManualDisconnect) (_a = this.reconnectTimer) === null || _a === void 0 || _a.scheduleTimeout();
        this._triggerStateCallbacks('close', event);
    }
    /** @internal */ _onConnError(error) {
        this._setConnectionState('disconnected');
        this.log('transport', `${error}`);
        this._triggerChanError();
        this._triggerStateCallbacks('error', error);
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $2e0562ab56175960$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $d080f38a352a2a89$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
    /**
     * Set connection state with proper state management
     * @internal
     */ _setConnectionState(state, manual = false) {
        this._connectionState = state;
        if (state === 'connecting') this._wasManualDisconnect = false;
        else if (state === 'disconnecting') this._wasManualDisconnect = manual;
    }
    /**
     * Perform the actual auth operation
     * @internal
     */ async _performAuth(token = null) {
        let tokenToSend;
        if (token) tokenToSend = token;
        else if (this.accessToken) // Always call the accessToken callback to get fresh token
        tokenToSend = await this.accessToken();
        else tokenToSend = this.accessTokenValue;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                const payload = {
                    access_token: tokenToSend,
                    version: (0, $2e0562ab56175960$export$363ebe89e6e7aeef)
                };
                tokenToSend && channel.updateJoinPayload(payload);
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, $2e0562ab56175960$export$8db7548e65d6ea55).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Wait for any in-flight auth operations to complete
     * @internal
     */ async _waitForAuthIfNeeded() {
        if (this._authPromise) await this._authPromise;
    }
    /**
     * Safely call setAuth with standardized error handling
     * @internal
     */ _setAuthSafely(context = 'general') {
        this.setAuth().catch((e)=>{
            this.log('error', `error setting auth in ${context}`, e);
        });
    }
    /**
     * Trigger state change callbacks with proper error handling
     * @internal
     */ _triggerStateCallbacks(event, data) {
        try {
            this.stateChangeCallbacks[event].forEach((callback)=>{
                try {
                    callback(data);
                } catch (e) {
                    this.log('error', `error in ${event} callback`, e);
                }
            });
        } catch (e) {
            this.log('error', `error triggering ${event} callbacks`, e);
        }
    }
    /**
     * Setup reconnection timer with proper configuration
     * @internal
     */ _setupReconnectionTimer() {
        this.reconnectTimer = new (0, $daad528c49fc1075$export$2e2bcd8739ae039)(async ()=>{
            setTimeout(async ()=>{
                await this._waitForAuthIfNeeded();
                if (!this.isConnected()) this.connect();
            }, $d080f38a352a2a89$var$CONNECTION_TIMEOUTS.RECONNECT_DELAY);
        }, this.reconnectAfterMs);
    }
    /**
     * Initialize client options with defaults
     * @internal
     */ _initializeOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // Set defaults
        this.transport = (_a = options === null || options === void 0 ? void 0 : options.transport) !== null && _a !== void 0 ? _a : null;
        this.timeout = (_b = options === null || options === void 0 ? void 0 : options.timeout) !== null && _b !== void 0 ? _b : (0, $2e0562ab56175960$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = (_c = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _c !== void 0 ? _c : $d080f38a352a2a89$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        this.worker = (_d = options === null || options === void 0 ? void 0 : options.worker) !== null && _d !== void 0 ? _d : false;
        this.accessToken = (_e = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _e !== void 0 ? _e : null;
        // Handle special cases
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            this.params = Object.assign(Object.assign({}, this.params), {
                log_level: this.logLevel
            });
        }
        // Set up functions with defaults
        this.reconnectAfterMs = (_f = options === null || options === void 0 ? void 0 : options.reconnectAfterMs) !== null && _f !== void 0 ? _f : (tries)=>{
            return $d080f38a352a2a89$var$RECONNECT_INTERVALS[tries - 1] || $d080f38a352a2a89$var$DEFAULT_RECONNECT_FALLBACK;
        };
        this.encode = (_g = options === null || options === void 0 ? void 0 : options.encode) !== null && _g !== void 0 ? _g : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (_h = options === null || options === void 0 ? void 0 : options.decode) !== null && _h !== void 0 ? _h : this.serializer.decode.bind(this.serializer);
        // Handle worker setup
        if (this.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
    }
}







class $0ff43d2fd44c7837$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function $0ff43d2fd44c7837$export$5a322e77e5eb0561(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class $0ff43d2fd44c7837$export$ca9ecfd959b3871c extends $0ff43d2fd44c7837$export$697502632950e9d3 {
    constructor(message, status, statusCode){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            statusCode: this.statusCode
        };
    }
}
class $0ff43d2fd44c7837$export$29127ca2e1a271d extends $0ff43d2fd44c7837$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}



var $e9472ce4f65779b5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $e9472ce4f65779b5$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("aLtt3"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $e9472ce4f65779b5$export$ace1d6afc438cf26 = ()=>$e9472ce4f65779b5$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield Promise.resolve((parcelRequire("aLtt3")))).Response;
        return Response;
    });
const $e9472ce4f65779b5$export$69d519e35e6fc3d4 = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$e9472ce4f65779b5$export$69d519e35e6fc3d4(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = $e9472ce4f65779b5$export$69d519e35e6fc3d4(value);
    });
    return result;
};
const $e9472ce4f65779b5$export$53b83ca8eaab0383 = (value)=>{
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};


var $ea0f10987155fb83$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $ea0f10987155fb83$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $ea0f10987155fb83$var$handleError = (error, reject, options)=>$ea0f10987155fb83$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $e9472ce4f65779b5$export$ace1d6afc438cf26)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            const status = error.status || 500;
            const statusCode = (err === null || err === void 0 ? void 0 : err.statusCode) || status + '';
            reject(new (0, $0ff43d2fd44c7837$export$ca9ecfd959b3871c)($ea0f10987155fb83$var$_getErrorMessage(err), status, statusCode));
        }).catch((err)=>{
            reject(new (0, $0ff43d2fd44c7837$export$29127ca2e1a271d)($ea0f10987155fb83$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $0ff43d2fd44c7837$export$29127ca2e1a271d)($ea0f10987155fb83$var$_getErrorMessage(error), error));
    });
const $ea0f10987155fb83$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET' || !body) return params;
    if ((0, $e9472ce4f65779b5$export$53b83ca8eaab0383)(body)) {
        params.headers = Object.assign({
            'Content-Type': 'application/json'
        }, options === null || options === void 0 ? void 0 : options.headers);
        params.body = JSON.stringify(body);
    } else params.body = body;
    return Object.assign(Object.assign({}, params), parameters);
};
function $ea0f10987155fb83$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $ea0f10987155fb83$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $ea0f10987155fb83$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$ea0f10987155fb83$var$handleError(error, reject, options));
        });
    });
}
function $ea0f10987155fb83$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $ea0f10987155fb83$var$__awaiter(this, void 0, void 0, function*() {
        return $ea0f10987155fb83$var$_handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function $ea0f10987155fb83$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $ea0f10987155fb83$var$__awaiter(this, void 0, void 0, function*() {
        return $ea0f10987155fb83$var$_handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function $ea0f10987155fb83$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $ea0f10987155fb83$var$__awaiter(this, void 0, void 0, function*() {
        return $ea0f10987155fb83$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function $ea0f10987155fb83$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $ea0f10987155fb83$var$__awaiter(this, void 0, void 0, function*() {
        return $ea0f10987155fb83$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function $ea0f10987155fb83$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $ea0f10987155fb83$var$__awaiter(this, void 0, void 0, function*() {
        return $ea0f10987155fb83$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ffba0539ef071dee$export$a143d493d941bafc;
var $ffba0539ef071dee$export$e4cf37d7f6fb9e0a;
var $ffba0539ef071dee$export$f99ded8fe4b79145;
var $ffba0539ef071dee$export$599f31c3813fae4d;
'use strict';
var $0e018d12e20a6018$export$a48f0734ac7c2329;
var $0e018d12e20a6018$export$d622b2ad8d90c771;
var $0e018d12e20a6018$export$6100ba28696e12de;
'use strict';
$0e018d12e20a6018$export$a48f0734ac7c2329 = $0e018d12e20a6018$var$byteLength;
$0e018d12e20a6018$export$d622b2ad8d90c771 = $0e018d12e20a6018$var$toByteArray;
$0e018d12e20a6018$export$6100ba28696e12de = $0e018d12e20a6018$var$fromByteArray;
var $0e018d12e20a6018$var$lookup = [];
var $0e018d12e20a6018$var$revLookup = [];
var $0e018d12e20a6018$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $0e018d12e20a6018$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $0e018d12e20a6018$var$i = 0, $0e018d12e20a6018$var$len = $0e018d12e20a6018$var$code.length; $0e018d12e20a6018$var$i < $0e018d12e20a6018$var$len; ++$0e018d12e20a6018$var$i){
    $0e018d12e20a6018$var$lookup[$0e018d12e20a6018$var$i] = $0e018d12e20a6018$var$code[$0e018d12e20a6018$var$i];
    $0e018d12e20a6018$var$revLookup[$0e018d12e20a6018$var$code.charCodeAt($0e018d12e20a6018$var$i)] = $0e018d12e20a6018$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0e018d12e20a6018$var$revLookup['-'.charCodeAt(0)] = 62;
$0e018d12e20a6018$var$revLookup['_'.charCodeAt(0)] = 63;
function $0e018d12e20a6018$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0e018d12e20a6018$var$byteLength(b64) {
    var lens = $0e018d12e20a6018$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0e018d12e20a6018$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0e018d12e20a6018$var$toByteArray(b64) {
    var tmp;
    var lens = $0e018d12e20a6018$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0e018d12e20a6018$var$Arr($0e018d12e20a6018$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i)] << 18 | $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i)] << 2 | $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i)] << 10 | $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0e018d12e20a6018$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0e018d12e20a6018$var$tripletToBase64(num) {
    return $0e018d12e20a6018$var$lookup[num >> 18 & 0x3F] + $0e018d12e20a6018$var$lookup[num >> 12 & 0x3F] + $0e018d12e20a6018$var$lookup[num >> 6 & 0x3F] + $0e018d12e20a6018$var$lookup[num & 0x3F];
}
function $0e018d12e20a6018$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0e018d12e20a6018$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $0e018d12e20a6018$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0e018d12e20a6018$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0e018d12e20a6018$var$lookup[tmp >> 2] + $0e018d12e20a6018$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0e018d12e20a6018$var$lookup[tmp >> 10] + $0e018d12e20a6018$var$lookup[tmp >> 4 & 0x3F] + $0e018d12e20a6018$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a6179745659a60fb$export$aafa59e2e03f2942;
var $a6179745659a60fb$export$68d8715fc104d294;
$a6179745659a60fb$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a6179745659a60fb$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $ffba0539ef071dee$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$ffba0539ef071dee$export$a143d493d941bafc = $ffba0539ef071dee$var$Buffer;
$ffba0539ef071dee$export$e4cf37d7f6fb9e0a = $ffba0539ef071dee$var$SlowBuffer;
$ffba0539ef071dee$export$f99ded8fe4b79145 = 50;
const $ffba0539ef071dee$var$K_MAX_LENGTH = 0x7fffffff;
$ffba0539ef071dee$export$599f31c3813fae4d = $ffba0539ef071dee$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ffba0539ef071dee$var$Buffer.TYPED_ARRAY_SUPPORT = $ffba0539ef071dee$var$typedArraySupport();
if (!$ffba0539ef071dee$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ffba0539ef071dee$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ffba0539ef071dee$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$ffba0539ef071dee$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ffba0539ef071dee$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$ffba0539ef071dee$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ffba0539ef071dee$var$createBuffer(length) {
    if (length > $ffba0539ef071dee$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ffba0539ef071dee$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ffba0539ef071dee$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ffba0539ef071dee$var$allocUnsafe(arg);
    }
    return $ffba0539ef071dee$var$from(arg, encodingOrOffset, length);
}
$ffba0539ef071dee$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ffba0539ef071dee$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $ffba0539ef071dee$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ffba0539ef071dee$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($ffba0539ef071dee$var$isInstance(value, ArrayBuffer) || value && $ffba0539ef071dee$var$isInstance(value.buffer, ArrayBuffer)) return $ffba0539ef071dee$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($ffba0539ef071dee$var$isInstance(value, SharedArrayBuffer) || value && $ffba0539ef071dee$var$isInstance(value.buffer, SharedArrayBuffer))) return $ffba0539ef071dee$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ffba0539ef071dee$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $ffba0539ef071dee$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $ffba0539ef071dee$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ffba0539ef071dee$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ffba0539ef071dee$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ffba0539ef071dee$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ffba0539ef071dee$var$Buffer, Uint8Array);
function $ffba0539ef071dee$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ffba0539ef071dee$var$alloc(size, fill, encoding) {
    $ffba0539ef071dee$var$assertSize(size);
    if (size <= 0) return $ffba0539ef071dee$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $ffba0539ef071dee$var$createBuffer(size).fill(fill, encoding) : $ffba0539ef071dee$var$createBuffer(size).fill(fill);
    return $ffba0539ef071dee$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ffba0539ef071dee$var$Buffer.alloc = function(size, fill, encoding) {
    return $ffba0539ef071dee$var$alloc(size, fill, encoding);
};
function $ffba0539ef071dee$var$allocUnsafe(size) {
    $ffba0539ef071dee$var$assertSize(size);
    return $ffba0539ef071dee$var$createBuffer(size < 0 ? 0 : $ffba0539ef071dee$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ffba0539ef071dee$var$Buffer.allocUnsafe = function(size) {
    return $ffba0539ef071dee$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ffba0539ef071dee$var$Buffer.allocUnsafeSlow = function(size) {
    return $ffba0539ef071dee$var$allocUnsafe(size);
};
function $ffba0539ef071dee$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$ffba0539ef071dee$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $ffba0539ef071dee$var$byteLength(string, encoding) | 0;
    let buf = $ffba0539ef071dee$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ffba0539ef071dee$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $ffba0539ef071dee$var$checked(array.length) | 0;
    const buf = $ffba0539ef071dee$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ffba0539ef071dee$var$fromArrayView(arrayView) {
    if ($ffba0539ef071dee$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $ffba0539ef071dee$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ffba0539ef071dee$var$fromArrayLike(arrayView);
}
function $ffba0539ef071dee$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ffba0539ef071dee$var$Buffer.prototype);
    return buf;
}
function $ffba0539ef071dee$var$fromObject(obj) {
    if ($ffba0539ef071dee$var$Buffer.isBuffer(obj)) {
        const len = $ffba0539ef071dee$var$checked(obj.length) | 0;
        const buf = $ffba0539ef071dee$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $ffba0539ef071dee$var$numberIsNaN(obj.length)) return $ffba0539ef071dee$var$createBuffer(0);
        return $ffba0539ef071dee$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $ffba0539ef071dee$var$fromArrayLike(obj.data);
}
function $ffba0539ef071dee$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ffba0539ef071dee$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ffba0539ef071dee$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $ffba0539ef071dee$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ffba0539ef071dee$var$Buffer.alloc(+length);
}
$ffba0539ef071dee$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ffba0539ef071dee$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ffba0539ef071dee$var$Buffer.compare = function compare(a, b) {
    if ($ffba0539ef071dee$var$isInstance(a, Uint8Array)) a = $ffba0539ef071dee$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ffba0539ef071dee$var$isInstance(b, Uint8Array)) b = $ffba0539ef071dee$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ffba0539ef071dee$var$Buffer.isBuffer(a) || !$ffba0539ef071dee$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ffba0539ef071dee$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$ffba0539ef071dee$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ffba0539ef071dee$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $ffba0539ef071dee$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($ffba0539ef071dee$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$ffba0539ef071dee$var$Buffer.isBuffer(buf)) buf = $ffba0539ef071dee$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ffba0539ef071dee$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ffba0539ef071dee$var$byteLength(string, encoding) {
    if ($ffba0539ef071dee$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ffba0539ef071dee$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $ffba0539ef071dee$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $ffba0539ef071dee$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ffba0539ef071dee$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ffba0539ef071dee$var$Buffer.byteLength = $ffba0539ef071dee$var$byteLength;
function $ffba0539ef071dee$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $ffba0539ef071dee$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $ffba0539ef071dee$var$utf8Slice(this, start, end);
        case 'ascii':
            return $ffba0539ef071dee$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $ffba0539ef071dee$var$latin1Slice(this, start, end);
        case 'base64':
            return $ffba0539ef071dee$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ffba0539ef071dee$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ffba0539ef071dee$var$Buffer.prototype._isBuffer = true;
function $ffba0539ef071dee$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ffba0539ef071dee$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$ffba0539ef071dee$var$swap(this, i, i + 1);
    return this;
};
$ffba0539ef071dee$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $ffba0539ef071dee$var$swap(this, i, i + 3);
        $ffba0539ef071dee$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ffba0539ef071dee$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $ffba0539ef071dee$var$swap(this, i, i + 7);
        $ffba0539ef071dee$var$swap(this, i + 1, i + 6);
        $ffba0539ef071dee$var$swap(this, i + 2, i + 5);
        $ffba0539ef071dee$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ffba0539ef071dee$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $ffba0539ef071dee$var$utf8Slice(this, 0, length);
    return $ffba0539ef071dee$var$slowToString.apply(this, arguments);
};
$ffba0539ef071dee$var$Buffer.prototype.toLocaleString = $ffba0539ef071dee$var$Buffer.prototype.toString;
$ffba0539ef071dee$var$Buffer.prototype.equals = function equals(b) {
    if (!$ffba0539ef071dee$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $ffba0539ef071dee$var$Buffer.compare(this, b) === 0;
};
$ffba0539ef071dee$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $ffba0539ef071dee$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($ffba0539ef071dee$var$customInspectSymbol) $ffba0539ef071dee$var$Buffer.prototype[$ffba0539ef071dee$var$customInspectSymbol] = $ffba0539ef071dee$var$Buffer.prototype.inspect;
$ffba0539ef071dee$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ffba0539ef071dee$var$isInstance(target, Uint8Array)) target = $ffba0539ef071dee$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ffba0539ef071dee$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ffba0539ef071dee$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ffba0539ef071dee$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $ffba0539ef071dee$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ffba0539ef071dee$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ffba0539ef071dee$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ffba0539ef071dee$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $ffba0539ef071dee$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ffba0539ef071dee$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ffba0539ef071dee$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ffba0539ef071dee$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ffba0539ef071dee$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ffba0539ef071dee$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ffba0539ef071dee$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ffba0539ef071dee$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ffba0539ef071dee$var$utf8Write(buf, string, offset, length) {
    return $ffba0539ef071dee$var$blitBuffer($ffba0539ef071dee$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ffba0539ef071dee$var$asciiWrite(buf, string, offset, length) {
    return $ffba0539ef071dee$var$blitBuffer($ffba0539ef071dee$var$asciiToBytes(string), buf, offset, length);
}
function $ffba0539ef071dee$var$base64Write(buf, string, offset, length) {
    return $ffba0539ef071dee$var$blitBuffer($ffba0539ef071dee$var$base64ToBytes(string), buf, offset, length);
}
function $ffba0539ef071dee$var$ucs2Write(buf, string, offset, length) {
    return $ffba0539ef071dee$var$blitBuffer($ffba0539ef071dee$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ffba0539ef071dee$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $ffba0539ef071dee$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $ffba0539ef071dee$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $ffba0539ef071dee$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $ffba0539ef071dee$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ffba0539ef071dee$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ffba0539ef071dee$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ffba0539ef071dee$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $0e018d12e20a6018$export$6100ba28696e12de(buf);
    else return $0e018d12e20a6018$export$6100ba28696e12de(buf.slice(start, end));
}
function $ffba0539ef071dee$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ffba0539ef071dee$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $ffba0539ef071dee$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ffba0539ef071dee$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $ffba0539ef071dee$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ffba0539ef071dee$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ffba0539ef071dee$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ffba0539ef071dee$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ffba0539ef071dee$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $ffba0539ef071dee$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ffba0539ef071dee$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ffba0539ef071dee$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ffba0539ef071dee$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ffba0539ef071dee$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$ffba0539ef071dee$var$Buffer.prototype.readUintLE = $ffba0539ef071dee$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ffba0539ef071dee$var$Buffer.prototype.readUintBE = $ffba0539ef071dee$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ffba0539ef071dee$var$Buffer.prototype.readUint8 = $ffba0539ef071dee$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ffba0539ef071dee$var$Buffer.prototype.readUint16LE = $ffba0539ef071dee$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ffba0539ef071dee$var$Buffer.prototype.readUint16BE = $ffba0539ef071dee$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ffba0539ef071dee$var$Buffer.prototype.readUint32LE = $ffba0539ef071dee$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ffba0539ef071dee$var$Buffer.prototype.readUint32BE = $ffba0539ef071dee$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ffba0539ef071dee$var$Buffer.prototype.readBigUInt64LE = $ffba0539ef071dee$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $ffba0539ef071dee$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ffba0539ef071dee$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$ffba0539ef071dee$var$Buffer.prototype.readBigUInt64BE = $ffba0539ef071dee$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $ffba0539ef071dee$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ffba0539ef071dee$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$ffba0539ef071dee$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ffba0539ef071dee$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ffba0539ef071dee$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ffba0539ef071dee$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ffba0539ef071dee$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ffba0539ef071dee$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ffba0539ef071dee$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ffba0539ef071dee$var$Buffer.prototype.readBigInt64LE = $ffba0539ef071dee$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $ffba0539ef071dee$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ffba0539ef071dee$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$ffba0539ef071dee$var$Buffer.prototype.readBigInt64BE = $ffba0539ef071dee$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $ffba0539ef071dee$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ffba0539ef071dee$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$ffba0539ef071dee$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 4, this.length);
    return $a6179745659a60fb$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$ffba0539ef071dee$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 4, this.length);
    return $a6179745659a60fb$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$ffba0539ef071dee$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 8, this.length);
    return $a6179745659a60fb$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$ffba0539ef071dee$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkOffset(offset, 8, this.length);
    return $a6179745659a60fb$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $ffba0539ef071dee$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ffba0539ef071dee$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$ffba0539ef071dee$var$Buffer.prototype.writeUintLE = $ffba0539ef071dee$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ffba0539ef071dee$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ffba0539ef071dee$var$Buffer.prototype.writeUintBE = $ffba0539ef071dee$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ffba0539ef071dee$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ffba0539ef071dee$var$Buffer.prototype.writeUint8 = $ffba0539ef071dee$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ffba0539ef071dee$var$Buffer.prototype.writeUint16LE = $ffba0539ef071dee$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ffba0539ef071dee$var$Buffer.prototype.writeUint16BE = $ffba0539ef071dee$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ffba0539ef071dee$var$Buffer.prototype.writeUint32LE = $ffba0539ef071dee$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ffba0539ef071dee$var$Buffer.prototype.writeUint32BE = $ffba0539ef071dee$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ffba0539ef071dee$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $ffba0539ef071dee$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $ffba0539ef071dee$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $ffba0539ef071dee$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$ffba0539ef071dee$var$Buffer.prototype.writeBigUInt64LE = $ffba0539ef071dee$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $ffba0539ef071dee$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ffba0539ef071dee$var$Buffer.prototype.writeBigUInt64BE = $ffba0539ef071dee$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $ffba0539ef071dee$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ffba0539ef071dee$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ffba0539ef071dee$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ffba0539ef071dee$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ffba0539ef071dee$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ffba0539ef071dee$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ffba0539ef071dee$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ffba0539ef071dee$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ffba0539ef071dee$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ffba0539ef071dee$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ffba0539ef071dee$var$Buffer.prototype.writeBigInt64LE = $ffba0539ef071dee$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $ffba0539ef071dee$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$ffba0539ef071dee$var$Buffer.prototype.writeBigInt64BE = $ffba0539ef071dee$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $ffba0539ef071dee$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $ffba0539ef071dee$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $ffba0539ef071dee$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $a6179745659a60fb$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ffba0539ef071dee$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ffba0539ef071dee$var$writeFloat(this, value, offset, true, noAssert);
};
$ffba0539ef071dee$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ffba0539ef071dee$var$writeFloat(this, value, offset, false, noAssert);
};
function $ffba0539ef071dee$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ffba0539ef071dee$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $a6179745659a60fb$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ffba0539ef071dee$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ffba0539ef071dee$var$writeDouble(this, value, offset, true, noAssert);
};
$ffba0539ef071dee$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ffba0539ef071dee$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ffba0539ef071dee$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ffba0539ef071dee$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ffba0539ef071dee$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$ffba0539ef071dee$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $ffba0539ef071dee$var$Buffer.isBuffer(val) ? val : $ffba0539ef071dee$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $ffba0539ef071dee$var$errors = {};
function $ffba0539ef071dee$var$E(sym, getMessage, Base) {
    $ffba0539ef071dee$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$ffba0539ef071dee$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$ffba0539ef071dee$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$ffba0539ef071dee$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $ffba0539ef071dee$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $ffba0539ef071dee$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $ffba0539ef071dee$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $ffba0539ef071dee$var$checkBounds(buf, offset, byteLength) {
    $ffba0539ef071dee$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $ffba0539ef071dee$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $ffba0539ef071dee$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $ffba0539ef071dee$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $ffba0539ef071dee$var$checkBounds(buf, offset, byteLength);
}
function $ffba0539ef071dee$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $ffba0539ef071dee$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $ffba0539ef071dee$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $ffba0539ef071dee$var$validateNumber(value, type);
        throw new $ffba0539ef071dee$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $ffba0539ef071dee$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $ffba0539ef071dee$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $ffba0539ef071dee$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ffba0539ef071dee$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ffba0539ef071dee$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $ffba0539ef071dee$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $ffba0539ef071dee$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ffba0539ef071dee$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ffba0539ef071dee$var$base64ToBytes(str) {
    return $0e018d12e20a6018$export$d622b2ad8d90c771($ffba0539ef071dee$var$base64clean(str));
}
function $ffba0539ef071dee$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ffba0539ef071dee$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ffba0539ef071dee$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $ffba0539ef071dee$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $ffba0539ef071dee$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $ffba0539ef071dee$var$BufferBigIntNotDefined : fn;
}
function $ffba0539ef071dee$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $73e49f2d4f5c389e$require$Buffer = $ffba0539ef071dee$export$a143d493d941bafc;
var $73e49f2d4f5c389e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $73e49f2d4f5c389e$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const $73e49f2d4f5c389e$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class $73e49f2d4f5c389e$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $e9472ce4f65779b5$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $73e49f2d4f5c389e$var$DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const data = yield (method == 'PUT' ? (0, $ea0f10987155fb83$export$327f7b26ebf455db) : (0, $ea0f10987155fb83$export$299ba2dee77727e9))(this.fetch, `${this.url}/object/${_path}`, body, Object.assign({
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $73e49f2d4f5c389e$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const data = yield (0, $ea0f10987155fb83$export$327f7b26ebf455db)(this.fetch, url.toString(), body, {
                    headers: headers
                });
                return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, $ea0f10987155fb83$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, $0ff43d2fd44c7837$export$697502632950e9d3)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $ea0f10987155fb83$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $ea0f10987155fb83$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, $ea0f10987155fb83$export$3988ae62b71be9a3)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, $e9472ce4f65779b5$export$69d519e35e6fc3d4)(data),
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, $ea0f10987155fb83$export$5fd5031fecdacec3)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error) && error instanceof (0, $0ff43d2fd44c7837$export$29127ca2e1a271d)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error: error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     * @param options Search options including limit (defaults to 100), offset, sortBy, and search
     */ list(path, options, parameters) {
        return $73e49f2d4f5c389e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $73e49f2d4f5c389e$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, $ea0f10987155fb83$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $73e49f2d4f5c389e$require$Buffer !== 'undefined') return $73e49f2d4f5c389e$require$Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path.replace(/^\/+/, '')}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
}


// generated by genversion
const $77e94bd13e777e27$export$83d89fbfd8236492 = '2.10.4';


const $0c7fdd81d1ef1de9$export$88a84136db6a4b64 = {
    'X-Client-Info': `storage-js/${(0, $77e94bd13e777e27$export$83d89fbfd8236492)}`
};





var $0bbe16f35285a455$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $0bbe16f35285a455$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, fetch, opts){
        const baseUrl = new URL(url);
        // if legacy uri is used, replace with new storage host (disables request buffering to allow > 50GB uploads)
        // "project-ref.supabase.co" becomes "project-ref.storage.supabase.co"
        if (opts === null || opts === void 0 ? void 0 : opts.useNewHostname) {
            const isSupabaseHost = /supabase\.(co|in|red)$/.test(baseUrl.hostname);
            if (isSupabaseHost && !baseUrl.hostname.includes('storage.supabase.')) baseUrl.hostname = baseUrl.hostname.replace('supabase.', 'storage.supabase.');
        }
        this.url = baseUrl.href;
        this.headers = Object.assign(Object.assign({}, (0, $0c7fdd81d1ef1de9$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $e9472ce4f65779b5$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $0bbe16f35285a455$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $0bbe16f35285a455$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     * @param options.type (private-beta) specifies the bucket type. see `BucketType` for more details.
     *   - default bucket type is `STANDARD`
     */ createBucket(id, options = {
        public: false
    }) {
        return $0bbe16f35285a455$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    type: options.type,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $0bbe16f35285a455$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $0bbe16f35285a455$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $0bbe16f35285a455$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $ea0f10987155fb83$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $0ff43d2fd44c7837$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
}


class $39cf89884fa138aa$export$6c85f5032e75eff9 extends (0, $0bbe16f35285a455$export$2e2bcd8739ae039) {
    constructor(url, headers = {}, fetch, opts){
        super(url, headers, fetch, opts);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $73e49f2d4f5c389e$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
}


const $30c2fb1a3704e929$export$83d89fbfd8236492 = '2.55.0';


let $b5a1c771bd0a8d3d$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $b5a1c771bd0a8d3d$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $b5a1c771bd0a8d3d$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $b5a1c771bd0a8d3d$var$JS_ENV = 'react-native';
else $b5a1c771bd0a8d3d$var$JS_ENV = 'node';
const $b5a1c771bd0a8d3d$export$88a84136db6a4b64 = {
    'X-Client-Info': `supabase-js-${$b5a1c771bd0a8d3d$var$JS_ENV}/${(0, $30c2fb1a3704e929$export$83d89fbfd8236492)}`
};
const $b5a1c771bd0a8d3d$export$b63a5c3a2e5becd2 = {
    headers: $b5a1c771bd0a8d3d$export$88a84136db6a4b64
};
const $b5a1c771bd0a8d3d$export$b31378ae815bea6b = {
    schema: 'public'
};
const $b5a1c771bd0a8d3d$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const $b5a1c771bd0a8d3d$export$59685507ca0a3912 = {};



var $aLtt3 = parcelRequire("aLtt3");
var $d96687504915e762$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d96687504915e762$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $aLtt3.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $d96687504915e762$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === 'undefined') return 0, $aLtt3.Headers;
    return Headers;
};
const $d96687504915e762$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $d96687504915e762$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $d96687504915e762$export$3d2cf54f85b7fc8a();
    return (input, init)=>$d96687504915e762$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


var $85cee330a7fd2718$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $85cee330a7fd2718$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $85cee330a7fd2718$export$a896b865588a414b(url) {
    return url.endsWith('/') ? url : url + '/';
}
const $85cee330a7fd2718$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined';
function $85cee330a7fd2718$export$da186dc3f8eace71(options, defaults) {
    var _a, _b;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        storage: {},
        global: Object.assign(Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions), {
            headers: Object.assign(Object.assign({}, (_a = DEFAULT_GLOBAL_OPTIONS === null || DEFAULT_GLOBAL_OPTIONS === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS.headers) !== null && _a !== void 0 ? _a : {}), (_b = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _b !== void 0 ? _b : {})
        }),
        accessToken: ()=>$85cee330a7fd2718$var$__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}


const $3d7a7b4b2261e6f1$export$83d89fbfd8236492 = '2.71.1';


const $ae7ad79a31ca1376$export$a4558fee79d6c8ae = 30000;
const $ae7ad79a31ca1376$export$f20a97df8f5fe223 = 3;
const $ae7ad79a31ca1376$export$a36ad0026e55ac00 = $ae7ad79a31ca1376$export$f20a97df8f5fe223 * $ae7ad79a31ca1376$export$a4558fee79d6c8ae;
const $ae7ad79a31ca1376$export$7fedf552187f0c3d = 'http://localhost:9999';
const $ae7ad79a31ca1376$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $ae7ad79a31ca1376$export$2f9161bad044dacb = '';
const $ae7ad79a31ca1376$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $3d7a7b4b2261e6f1$export$83d89fbfd8236492)}`
};
const $ae7ad79a31ca1376$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $ae7ad79a31ca1376$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $ae7ad79a31ca1376$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $ae7ad79a31ca1376$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $ae7ad79a31ca1376$export$5bd768495200f133 = 600000; // 10 minutes



class $938c0a51861f0c00$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $938c0a51861f0c00$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $938c0a51861f0c00$export$45fde0b55b14f37b extends $938c0a51861f0c00$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $938c0a51861f0c00$export$4fe744aeb810d543(error) {
    return $938c0a51861f0c00$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $938c0a51861f0c00$export$f7559805d4a50078 extends $938c0a51861f0c00$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $938c0a51861f0c00$export$823c745ae0673c5e extends $938c0a51861f0c00$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $938c0a51861f0c00$export$403b3fc0d3ad5f0c extends $938c0a51861f0c00$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $938c0a51861f0c00$export$3e849aa4db565c1d(error) {
    return $938c0a51861f0c00$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $938c0a51861f0c00$export$7e277b620449c1b4 extends $938c0a51861f0c00$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $938c0a51861f0c00$export$9ef583f0381b4cc extends $938c0a51861f0c00$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $938c0a51861f0c00$export$bf5df8e043856ef5 extends $938c0a51861f0c00$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $938c0a51861f0c00$export$45edea3999507afd(error) {
    return $938c0a51861f0c00$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $938c0a51861f0c00$export$39583657eb2a7027 extends $938c0a51861f0c00$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $938c0a51861f0c00$export$2423b763f68be1b4 extends $938c0a51861f0c00$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $938c0a51861f0c00$export$a77af358da5fb874(error) {
    return $938c0a51861f0c00$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $938c0a51861f0c00$export$b034076aa04913a6 extends $938c0a51861f0c00$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $938c0a51861f0c00$export$dac36143fd8a46ef(error) {
    return $938c0a51861f0c00$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $938c0a51861f0c00$export$d04cb18528f2043e extends $938c0a51861f0c00$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}


/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $9650d5e5977458d3$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $9650d5e5977458d3$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $9650d5e5977458d3$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $9650d5e5977458d3$var$IGNORE_BASE64URL.length; i += 1)charMap[$9650d5e5977458d3$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $9650d5e5977458d3$var$TO_BASE64URL.length; i += 1)charMap[$9650d5e5977458d3$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $9650d5e5977458d3$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($9650d5e5977458d3$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($9650d5e5977458d3$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $9650d5e5977458d3$export$403e86c86002a137(charCode, state, emit) {
    const bits = $9650d5e5977458d3$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $9650d5e5977458d3$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $9650d5e5977458d3$export$caccae6095ceb6da(str, (byte)=>{
        $9650d5e5977458d3$export$744f452403189a3e(byte, state, emitter);
    });
    $9650d5e5977458d3$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $9650d5e5977458d3$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $9650d5e5977458d3$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$9650d5e5977458d3$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $9650d5e5977458d3$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $9650d5e5977458d3$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $9650d5e5977458d3$export$d203cd9136753332(codepoint, emit);
    }
}
function $9650d5e5977458d3$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $9650d5e5977458d3$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$9650d5e5977458d3$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $9650d5e5977458d3$export$a098e7b533f96db3(str) {
    const result = [];
    $9650d5e5977458d3$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}
function $9650d5e5977458d3$export$3f156efe462a835e(bytes) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onChar = (char)=>{
        result.push(char);
    };
    bytes.forEach((byte)=>$9650d5e5977458d3$export$744f452403189a3e(byte, state, onChar));
    // always call with `null` after processing all bytes
    $9650d5e5977458d3$export$744f452403189a3e(null, state, onChar);
    return result.join('');
}


function $f5d545cb9f5d2d02$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $f5d545cb9f5d2d02$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $f5d545cb9f5d2d02$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $f5d545cb9f5d2d02$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $f5d545cb9f5d2d02$export$9ec034ee80211814 = ()=>{
    if (!$f5d545cb9f5d2d02$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($f5d545cb9f5d2d02$var$localStorageWriteTests.tested) return $f5d545cb9f5d2d02$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $f5d545cb9f5d2d02$var$localStorageWriteTests.tested = true;
        $f5d545cb9f5d2d02$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $f5d545cb9f5d2d02$var$localStorageWriteTests.tested = true;
        $f5d545cb9f5d2d02$var$localStorageWriteTests.writable = false;
    }
    return $f5d545cb9f5d2d02$var$localStorageWriteTests.writable;
};
function $f5d545cb9f5d2d02$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $f5d545cb9f5d2d02$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("aLtt3"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $f5d545cb9f5d2d02$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $f5d545cb9f5d2d02$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $f5d545cb9f5d2d02$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $f5d545cb9f5d2d02$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $f5d545cb9f5d2d02$export$85f6557964517f1a {
    constructor(){
        this.promise = new $f5d545cb9f5d2d02$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$f5d545cb9f5d2d02$export$85f6557964517f1a.promiseConstructor = Promise;
function $f5d545cb9f5d2d02$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $938c0a51861f0c00$export$d04cb18528f2043e)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $ae7ad79a31ca1376$export$7a68c9e70b9d3911).test(parts[i])) throw new (0, $938c0a51861f0c00$export$d04cb18528f2043e)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $9650d5e5977458d3$export$bd5d476f823ea024)(parts[0])),
        payload: JSON.parse((0, $9650d5e5977458d3$export$bd5d476f823ea024)(parts[1])),
        signature: (0, $9650d5e5977458d3$export$9cae2cd6076b8fb6)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $f5d545cb9f5d2d02$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $f5d545cb9f5d2d02$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $f5d545cb9f5d2d02$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $f5d545cb9f5d2d02$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $f5d545cb9f5d2d02$var$dec2hex).join('');
}
async function $f5d545cb9f5d2d02$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $f5d545cb9f5d2d02$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $f5d545cb9f5d2d02$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $f5d545cb9f5d2d02$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $f5d545cb9f5d2d02$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $f5d545cb9f5d2d02$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $f5d545cb9f5d2d02$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $f5d545cb9f5d2d02$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $f5d545cb9f5d2d02$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $ae7ad79a31ca1376$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($f5d545cb9f5d2d02$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}
function $f5d545cb9f5d2d02$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $f5d545cb9f5d2d02$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}
const $f5d545cb9f5d2d02$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function $f5d545cb9f5d2d02$export$a4c72ae47296db0c(str) {
    if (!$f5d545cb9f5d2d02$var$UUID_REGEX.test(str)) throw new Error('@supabase/auth-js: Expected parameter to be UUID but is not');
}
function $f5d545cb9f5d2d02$export$52c7f0d8a78626b() {
    const proxyTarget = {};
    return new Proxy(proxyTarget, {
        get: (target, prop)=>{
            if (prop === '__isUserNotAvailableProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms.
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)') // Node.js util.inspect
                return undefined;
            }
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${prop}" property of the session object is not supported. Please use getUser() instead.`);
        },
        set: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        },
        deleteProperty: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        }
    });
}
function $f5d545cb9f5d2d02$export$b7d58db314e0ac27(obj) {
    return JSON.parse(JSON.stringify(obj));
}



var $aee05e5aed150952$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $aee05e5aed150952$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $aee05e5aed150952$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $aee05e5aed150952$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $f5d545cb9f5d2d02$export$e8ad6599be1036a7)(error)) throw new (0, $938c0a51861f0c00$export$2423b763f68be1b4)($aee05e5aed150952$var$_getErrorMessage(error), 0);
    if ($aee05e5aed150952$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $938c0a51861f0c00$export$2423b763f68be1b4)($aee05e5aed150952$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $938c0a51861f0c00$export$f7559805d4a50078)($aee05e5aed150952$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $f5d545cb9f5d2d02$export$5f69ecf1c14d56fd)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $ae7ad79a31ca1376$export$1f9a66038489bdeb)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $938c0a51861f0c00$export$b034076aa04913a6)($aee05e5aed150952$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $938c0a51861f0c00$export$b034076aa04913a6)($aee05e5aed150952$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $938c0a51861f0c00$export$403b3fc0d3ad5f0c)();
    throw new (0, $938c0a51861f0c00$export$45fde0b55b14f37b)($aee05e5aed150952$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $aee05e5aed150952$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $aee05e5aed150952$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $ae7ad79a31ca1376$export$e4f5507f88977535]) headers[0, $ae7ad79a31ca1376$export$e4f5507f88977535] = (0, $ae7ad79a31ca1376$export$1f9a66038489bdeb)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $aee05e5aed150952$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $aee05e5aed150952$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $aee05e5aed150952$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $938c0a51861f0c00$export$2423b763f68be1b4)($aee05e5aed150952$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $aee05e5aed150952$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $aee05e5aed150952$export$d3da1ecaf1206c58(e);
    }
}
function $aee05e5aed150952$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($aee05e5aed150952$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $f5d545cb9f5d2d02$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $aee05e5aed150952$export$db83aade1c2922c7(data) {
    const response = $aee05e5aed150952$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $aee05e5aed150952$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $aee05e5aed150952$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $aee05e5aed150952$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $aee05e5aed150952$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $aee05e5aed150952$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $aee05e5aed150952$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}



const $ff73a8f279292424$export$9a0f1d0c97ce73ca = [
    'global',
    'local',
    'others'
];



var $ce1aa5deb2a25675$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $ce1aa5deb2a25675$export$2e2bcd8739ae039 {
    constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $f5d545cb9f5d2d02$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = (0, $ff73a8f279292424$export$9a0f1d0c97ce73ca)[0]) {
        if ((0, $ff73a8f279292424$export$9a0f1d0c97ce73ca).indexOf(scope) < 0) throw new Error(`@supabase/auth-js: Parameter scope must be one of ${(0, $ff73a8f279292424$export$9a0f1d0c97ce73ca).join(', ')}`);
        try {
            await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $aee05e5aed150952$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $ce1aa5deb2a25675$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $aee05e5aed150952$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $aee05e5aed150952$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $aee05e5aed150952$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        (0, $f5d545cb9f5d2d02$export$a4c72ae47296db0c)(uid);
        try {
            return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $aee05e5aed150952$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        (0, $f5d545cb9f5d2d02$export$a4c72ae47296db0c)(uid);
        try {
            return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $aee05e5aed150952$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        (0, $f5d545cb9f5d2d02$export$a4c72ae47296db0c)(id);
        try {
            return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $aee05e5aed150952$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        (0, $f5d545cb9f5d2d02$export$a4c72ae47296db0c)(params.userId);
        try {
            const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        (0, $f5d545cb9f5d2d02$export$a4c72ae47296db0c)(params.userId);
        (0, $f5d545cb9f5d2d02$export$a4c72ae47296db0c)(params.id);
        try {
            const data = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}







/**
 * Returns a localStorage-like object that stores the key-value pairs in
 * memory.
 */ function $51176fe486f3402f$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $183dcac10f4187b3$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $191d92d99e493f9f$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $f5d545cb9f5d2d02$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $191d92d99e493f9f$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $191d92d99e493f9f$export$4aa56776043a4631 extends $191d92d99e493f9f$export$23e9464cc010dff9 {
}
class $191d92d99e493f9f$export$4b982ee840d3d915 extends $191d92d99e493f9f$export$23e9464cc010dff9 {
}
async function $191d92d99e493f9f$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($191d92d99e493f9f$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($191d92d99e493f9f$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                if ($191d92d99e493f9f$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($191d92d99e493f9f$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($191d92d99e493f9f$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $191d92d99e493f9f$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($191d92d99e493f9f$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                return await fn();
            }
        }));
}
const $191d92d99e493f9f$var$PROCESS_LOCKS = {};
async function $191d92d99e493f9f$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $191d92d99e493f9f$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new $191d92d99e493f9f$export$4b982ee840d3d915(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    $191d92d99e493f9f$var$PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}



(0, $183dcac10f4187b3$export$ad067ce270531206)(); // Make "globalThis" available
const $5c61e7683d8461e6$var$DEFAULT_OPTIONS = {
    url: (0, $ae7ad79a31ca1376$export$7fedf552187f0c3d),
    storageKey: (0, $ae7ad79a31ca1376$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $ae7ad79a31ca1376$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
async function $5c61e7683d8461e6$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
/**
 * Caches JWKS values for all clients created in the same environment. This is
 * especially useful for shared-memory execution environments such as Vercel's
 * Fluid Compute, AWS Lambda or Supabase's Edge Functions. Regardless of how
 * many clients are created, if they share the same storage key they will use
 * the same JWKS cache, significantly speeding up getClaims() with asymmetric
 * JWTs.
 */ const $5c61e7683d8461e6$var$GLOBAL_JWKS = {};
class $5c61e7683d8461e6$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        /**
         * @experimental
         */ this.userStorage = null;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $5c61e7683d8461e6$export$2e2bcd8739ae039.nextInstanceID;
        $5c61e7683d8461e6$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, $5c61e7683d8461e6$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $ce1aa5deb2a25675$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $f5d545cb9f5d2d02$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $5c61e7683d8461e6$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $191d92d99e493f9f$export$f4ff21938fb7af3c);
        else this.lock = $5c61e7683d8461e6$var$lockNoOp;
        if (!this.jwks) {
            this.jwks = {
                keys: []
            };
            this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        }
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $f5d545cb9f5d2d02$export$9ec034ee80211814)()) this.storage = globalThis.localStorage;
            else {
                this.memoryStorage = {};
                this.storage = (0, $51176fe486f3402f$export$d791f66d7e5710cf)(this.memoryStorage);
            }
            if (settings.userStorage) this.userStorage = settings.userStorage;
        } else {
            this.memoryStorage = {};
            this.storage = (0, $51176fe486f3402f$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    /**
     * The JWKS used for verifying asymmetric JWTs
     */ get jwks() {
        var _a, _b;
        return (_b = (_a = $5c61e7683d8461e6$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.jwks) !== null && _b !== void 0 ? _b : {
            keys: []
        };
    }
    set jwks(value) {
        $5c61e7683d8461e6$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $5c61e7683d8461e6$var$GLOBAL_JWKS[this.storageKey]), {
            jwks: value
        });
    }
    get jwks_cached_at() {
        var _a, _b;
        return (_b = (_a = $5c61e7683d8461e6$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.cachedAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER;
    }
    set jwks_cached_at(value) {
        $5c61e7683d8461e6$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $5c61e7683d8461e6$var$GLOBAL_JWKS[this.storageKey]), {
            cachedAt: value
        });
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $3d7a7b4b2261e6f1$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const params = (0, $f5d545cb9f5d2d02$export$7a29392fb778224c)(window.location.href);
            let callbackUrlType = 'none';
            if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
            else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $938c0a51861f0c00$export$45edea3999507afd)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $938c0a51861f0c00$export$f7559805d4a50078)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $aee05e5aed150952$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $f5d545cb9f5d2d02$export$81b177cadfcf873c)(this.storage, this.storageKey);
                res = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $aee05e5aed150952$export$273fe4673a018c2e)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $aee05e5aed150952$export$273fe4673a018c2e)
                });
            } else throw new (0, $938c0a51861f0c00$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $aee05e5aed150952$export$db83aade1c2922c7)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $aee05e5aed150952$export$db83aade1c2922c7)
                });
            } else throw new (0, $938c0a51861f0c00$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $938c0a51861f0c00$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    /**
     * Signs in a user by verifying a message signed by the user's private key.
     * Only Solana supported at this time, using the Sign in with Solana standard.
     */ async signInWithWeb3(credentials) {
        const { chain: chain } = credentials;
        if (chain === 'solana') return await this.signInWithSolana(credentials);
        throw new Error(`@supabase/auth-js: Unsupported chain "${chain}"`);
    }
    async signInWithSolana(credentials) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('solana' in windowAny && typeof windowAny.solana === 'object' && ('signIn' in windowAny.solana && typeof windowAny.solana.signIn === 'function' || 'signMessage' in windowAny.solana && typeof windowAny.solana.signMessage === 'function')) resolvedWallet = windowAny.solana;
                else throw new Error(`@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            if ('signIn' in resolvedWallet && resolvedWallet.signIn) {
                const output = await resolvedWallet.signIn(Object.assign(Object.assign(Object.assign({
                    issuedAt: new Date().toISOString()
                }, options === null || options === void 0 ? void 0 : options.signInWithSolana), {
                    // non-overridable properties
                    version: '1',
                    domain: url.host,
                    uri: url.href
                }), statement ? {
                    statement: statement
                } : null));
                let outputToProcess;
                if (Array.isArray(output) && output[0] && typeof output[0] === 'object') outputToProcess = output[0];
                else if (output && typeof output === 'object' && 'signedMessage' in output && 'signature' in output) outputToProcess = output;
                else throw new Error('@supabase/auth-js: Wallet method signIn() returned unrecognized value');
                if ('signedMessage' in outputToProcess && 'signature' in outputToProcess && (typeof outputToProcess.signedMessage === 'string' || outputToProcess.signedMessage instanceof Uint8Array) && outputToProcess.signature instanceof Uint8Array) {
                    message = typeof outputToProcess.signedMessage === 'string' ? outputToProcess.signedMessage : new TextDecoder().decode(outputToProcess.signedMessage);
                    signature = outputToProcess.signature;
                } else throw new Error('@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields');
            } else {
                if (!('signMessage' in resolvedWallet) || typeof resolvedWallet.signMessage !== 'function' || !('publicKey' in resolvedWallet) || typeof resolvedWallet !== 'object' || !resolvedWallet.publicKey || !('toBase58' in resolvedWallet.publicKey) || typeof resolvedWallet.publicKey.toBase58 !== 'function') throw new Error('@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API');
                message = [
                    `${url.host} wants you to sign in with your Solana account:`,
                    resolvedWallet.publicKey.toBase58(),
                    ...statement ? [
                        '',
                        statement,
                        ''
                    ] : [
                        ''
                    ],
                    'Version: 1',
                    `URI: ${url.href}`,
                    `Issued At: ${(_c = (_b = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _b === void 0 ? void 0 : _b.issuedAt) !== null && _c !== void 0 ? _c : new Date().toISOString()}`,
                    ...((_d = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _d === void 0 ? void 0 : _d.notBefore) ? [
                        `Not Before: ${options.signInWithSolana.notBefore}`
                    ] : [],
                    ...((_e = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _e === void 0 ? void 0 : _e.expirationTime) ? [
                        `Expiration Time: ${options.signInWithSolana.expirationTime}`
                    ] : [],
                    ...((_f = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _f === void 0 ? void 0 : _f.chainId) ? [
                        `Chain ID: ${options.signInWithSolana.chainId}`
                    ] : [],
                    ...((_g = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _g === void 0 ? void 0 : _g.nonce) ? [
                        `Nonce: ${options.signInWithSolana.nonce}`
                    ] : [],
                    ...((_h = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _h === void 0 ? void 0 : _h.requestId) ? [
                        `Request ID: ${options.signInWithSolana.requestId}`
                    ] : [],
                    ...((_k = (_j = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _j === void 0 ? void 0 : _j.resources) === null || _k === void 0 ? void 0 : _k.length) ? [
                        'Resources',
                        ...options.signInWithSolana.resources.map((resource)=>`- ${resource}`)
                    ] : []
                ].join('\n');
                const maybeSignature = await resolvedWallet.signMessage(new TextEncoder().encode(message), 'utf8');
                if (!maybeSignature || !(maybeSignature instanceof Uint8Array)) throw new Error('@supabase/auth-js: Wallet signMessage() API returned an recognized value');
                signature = maybeSignature;
            }
        }
        try {
            const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'solana',
                    message: message,
                    signature: (0, $9650d5e5977458d3$export$3f156efe462a835e)(signature)
                }, ((_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken
                    }
                } : null),
                xform: (0, $aee05e5aed150952$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $938c0a51861f0c00$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({}, data),
                error: error
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $f5d545cb9f5d2d02$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $aee05e5aed150952$export$273fe4673a018c2e)
            });
            await (0, $f5d545cb9f5d2d02$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, $938c0a51861f0c00$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $aee05e5aed150952$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $938c0a51861f0c00$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $f5d545cb9f5d2d02$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $938c0a51861f0c00$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $aee05e5aed150952$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $f5d545cb9f5d2d02$export$81b177cadfcf873c)(this.storage, this.storageKey);
            return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $aee05e5aed150952$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $938c0a51861f0c00$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $938c0a51861f0c00$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $f5d545cb9f5d2d02$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $ae7ad79a31ca1376$export$a36ad0026e55ac00) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.userStorage) {
                    const maybeUser = await (0, $f5d545cb9f5d2d02$export$ba6fcb7c333d32c0)(this.userStorage, this.storageKey + '-user');
                    if (maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) currentSession.user = maybeUser.user;
                    else currentSession.user = (0, $f5d545cb9f5d2d02$export$52c7f0d8a78626b)();
                }
                if (this.storage.isServer && currentSession.user) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $aee05e5aed150952$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $938c0a51861f0c00$export$403b3fc0d3ad5f0c)()
                };
                return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $aee05e5aed150952$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) {
                if ((0, $938c0a51861f0c00$export$3e849aa4db565c1d)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $f5d545cb9f5d2d02$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error: error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $938c0a51861f0c00$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $f5d545cb9f5d2d02$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $aee05e5aed150952$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $938c0a51861f0c00$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $f5d545cb9f5d2d02$export$9a62e6c0a30e00bc)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $938c0a51861f0c00$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)()) throw new (0, $938c0a51861f0c00$export$bf5df8e043856ef5)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $938c0a51861f0c00$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $938c0a51861f0c00$export$39583657eb2a7027)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $938c0a51861f0c00$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $938c0a51861f0c00$export$39583657eb2a7027)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $938c0a51861f0c00$export$bf5df8e043856ef5)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $ae7ad79a31ca1376$export$a4558fee79d6c8ae)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantCallback(params) {
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $f5d545cb9f5d2d02$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $938c0a51861f0c00$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error: error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $f5d545cb9f5d2d02$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $f5d545cb9f5d2d02$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $f5d545cb9f5d2d02$export$81b177cadfcf873c)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $f5d545cb9f5d2d02$export$9e1b8e833f44ff21)(async (attempt)=>{
                if (attempt > 0) await (0, $f5d545cb9f5d2d02$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $aee05e5aed150952$export$273fe4673a018c2e)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $938c0a51861f0c00$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $ae7ad79a31ca1376$export$a4558fee79d6c8ae);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a, _b;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $f5d545cb9f5d2d02$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            if (currentSession && this.userStorage) {
                let maybeUser = await (0, $f5d545cb9f5d2d02$export$ba6fcb7c333d32c0)(this.userStorage, this.storageKey + '-user');
                if (!this.storage.isServer && Object.is(this.storage, this.userStorage) && !maybeUser) {
                    // storage and userStorage are the same storage medium, for example
                    // window.localStorage if userStorage does not have the user from
                    // storage stored, store it first thereby migrating the user object
                    // from storage -> userStorage
                    maybeUser = {
                        user: currentSession.user
                    };
                    await (0, $f5d545cb9f5d2d02$export$e82c36d29078a87f)(this.userStorage, this.storageKey + '-user', maybeUser);
                }
                currentSession.user = (_a = maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) !== null && _a !== void 0 ? _a : (0, $f5d545cb9f5d2d02$export$52c7f0d8a78626b)();
            } else if (currentSession && !currentSession.user) // user storage is not set, let's check if it was previously enabled so
            // we bring back the storage as it should be
            {
                if (!currentSession.user) {
                    // test if userStorage was previously enabled and the storage medium was the same, to move the user back under the same key
                    const separateUser = await (0, $f5d545cb9f5d2d02$export$ba6fcb7c333d32c0)(this.storage, this.storageKey + '-user');
                    if (separateUser && (separateUser === null || separateUser === void 0 ? void 0 : separateUser.user)) {
                        currentSession.user = separateUser.user;
                        await (0, $f5d545cb9f5d2d02$export$d35c645d585317ec)(this.storage, this.storageKey + '-user');
                        await (0, $f5d545cb9f5d2d02$export$e82c36d29078a87f)(this.storage, this.storageKey, currentSession);
                    } else currentSession.user = (0, $f5d545cb9f5d2d02$export$52c7f0d8a78626b)();
                }
            }
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_b = currentSession.expires_at) !== null && _b !== void 0 ? _b : Infinity) * 1000 - Date.now() < (0, $ae7ad79a31ca1376$export$a36ad0026e55ac00);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $ae7ad79a31ca1376$export$a36ad0026e55ac00)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $938c0a51861f0c00$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else if (currentSession.user && currentSession.user.__isUserNotAvailableProxy === true) // If we have a proxy user, try to get the real user data
            try {
                const { data: data, error: userError } = await this._getUser(currentSession.access_token);
                if (!userError && (data === null || data === void 0 ? void 0 : data.user)) {
                    currentSession.user = data.user;
                    await this._saveSession(currentSession);
                    await this._notifyAllSubscribers('SIGNED_IN', currentSession);
                } else this._debug(debugName, 'could not get user data, skipping SIGNED_IN notification');
            } catch (getUserError) {
                console.error('Error getting user data:', getUserError);
                this._debug(debugName, 'error getting user data, skipping SIGNED_IN notification', getUserError);
            }
            else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $938c0a51861f0c00$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $f5d545cb9f5d2d02$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $938c0a51861f0c00$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $938c0a51861f0c00$export$a77af358da5fb874)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        // Create a shallow copy to work with, to avoid mutating the original session object if it's used elsewhere
        const sessionToProcess = Object.assign({}, session);
        const userIsProxy = sessionToProcess.user && sessionToProcess.user.__isUserNotAvailableProxy === true;
        if (this.userStorage) {
            if (!userIsProxy && sessionToProcess.user) // If it's a real user object, save it to userStorage.
            await (0, $f5d545cb9f5d2d02$export$e82c36d29078a87f)(this.userStorage, this.storageKey + '-user', {
                user: sessionToProcess.user
            });
            else userIsProxy;
            // Prepare the main session data for primary storage: remove the user property before cloning
            // This is important because the original session.user might be the proxy
            const mainSessionData = Object.assign({}, sessionToProcess);
            delete mainSessionData.user; // Remove user (real or proxy) before cloning for main storage
            const clonedMainSessionData = (0, $f5d545cb9f5d2d02$export$b7d58db314e0ac27)(mainSessionData);
            await (0, $f5d545cb9f5d2d02$export$e82c36d29078a87f)(this.storage, this.storageKey, clonedMainSessionData);
        } else {
            // No userStorage is configured.
            // In this case, session.user should ideally not be a proxy.
            // If it were, structuredClone would fail. This implies an issue elsewhere if user is a proxy here
            const clonedSession = (0, $f5d545cb9f5d2d02$export$b7d58db314e0ac27)(sessionToProcess); // sessionToProcess still has its original user property
            await (0, $f5d545cb9f5d2d02$export$e82c36d29078a87f)(this.storage, this.storageKey, clonedSession);
        }
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, $f5d545cb9f5d2d02$export$d35c645d585317ec)(this.storage, this.storageKey);
        await (0, $f5d545cb9f5d2d02$export$d35c645d585317ec)(this.storage, this.storageKey + '-code-verifier');
        await (0, $f5d545cb9f5d2d02$export$d35c645d585317ec)(this.storage, this.storageKey + '-user');
        if (this.userStorage) await (0, $f5d545cb9f5d2d02$export$d35c645d585317ec)(this.userStorage, this.storageKey + '-user');
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $ae7ad79a31ca1376$export$a4558fee79d6c8ae));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $ae7ad79a31ca1376$export$a4558fee79d6c8ae));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $ae7ad79a31ca1376$export$a4558fee79d6c8ae)}ms, refresh threshold is ${(0, $ae7ad79a31ca1376$export$f20a97df8f5fe223)} ticks`);
                            if (expiresInTicks <= (0, $ae7ad79a31ca1376$export$f20a97df8f5fe223)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $191d92d99e493f9f$export$23e9464cc010dff9)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $f5d545cb9f5d2d02$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $f5d545cb9f5d2d02$export$81b177cadfcf873c)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp: totp,
                phone: phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const { payload: payload } = (0, $f5d545cb9f5d2d02$export$9a62e6c0a30e00bc)(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        const now = Date.now();
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $ae7ad79a31ca1376$export$5bd768495200f133) > now) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $aee05e5aed150952$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) return null;
        this.jwks = data;
        this.jwks_cached_at = now;
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) return null;
        return jwk;
    }
    /**
     * Extracts the JWT claims present in the access token by first verifying the
     * JWT against the server's JSON Web Key Set endpoint
     * `/.well-known/jwks.json` which is often cached, resulting in significantly
     * faster responses. Prefer this method over {@link #getUser} which always
     * sends a request to the Auth server for each JWT.
     *
     * If the project is not using an asymmetric JWT signing key (like ECC or
     * RSA) it always sends a request to the Auth server (similar to {@link
     * #getUser}) to verify the JWT.
     *
     * @param jwt An optional specific JWT you wish to verify, not the one you
     *            can obtain from {@link #getSession}.
     * @param options Various additional options that allow you to customize the
     *                behavior of this method.
     */ async getClaims(jwt, options = {}) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return {
                    data: null,
                    error: error
                };
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $f5d545cb9f5d2d02$export$9a62e6c0a30e00bc)(token);
            if (!(options === null || options === void 0 ? void 0 : options.allowExpired)) // Reject expired JWTs should only happen if jwt argument was passed
            (0, $f5d545cb9f5d2d02$export$a5850868adeb9253)(payload.exp);
            const signingKey = !header.alg || header.alg.startsWith('HS') || !header.kid || !('crypto' in globalThis && 'subtle' in globalThis.crypto) ? null : await this.fetchJwk(header.kid, (options === null || options === void 0 ? void 0 : options.keys) ? {
                keys: options.keys
            } : options === null || options === void 0 ? void 0 : options.jwks);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!signingKey) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $f5d545cb9f5d2d02$export$fa59f625ab60cb91)(header.alg);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $9650d5e5977458d3$export$a098e7b533f96db3)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $938c0a51861f0c00$export$d04cb18528f2043e)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $938c0a51861f0c00$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}
$5c61e7683d8461e6$export$2e2bcd8739ae039.nextInstanceID = 0;



const $89e5e3f3fd649581$var$AuthAdminApi = (0, $ce1aa5deb2a25675$export$2e2bcd8739ae039);
var $89e5e3f3fd649581$export$2e2bcd8739ae039 = $89e5e3f3fd649581$var$AuthAdminApi;



const $bbe6f4b473ed992d$var$AuthClient = (0, $5c61e7683d8461e6$export$2e2bcd8739ae039);
var $bbe6f4b473ed992d$export$2e2bcd8739ae039 = $bbe6f4b473ed992d$var$AuthClient;







class $20d621b3b2df27d5$export$8199a418bb09bd56 extends (0, $bbe6f4b473ed992d$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $ea5e6167a94ede8d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $ea5e6167a94ede8d$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.storage Options passed along to the storage-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, $85cee330a7fd2718$export$a896b865588a414b)(supabaseUrl);
        const baseUrl = new URL(_supabaseUrl);
        this.realtimeUrl = new URL('realtime/v1', baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace('http', 'ws');
        this.authUrl = new URL('auth/v1', baseUrl);
        this.storageUrl = new URL('storage/v1', baseUrl);
        this.functionsUrl = new URL('functions/v1', baseUrl);
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${baseUrl.hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $b5a1c771bd0a8d3d$export$b31378ae815bea6b),
            realtime: (0, $b5a1c771bd0a8d3d$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $b5a1c771bd0a8d3d$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $b5a1c771bd0a8d3d$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $85cee330a7fd2718$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, $d96687504915e762$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, $c6cffb92fd18d72c$export$796f32e2ee984aaa)(new URL('rest/v1', baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        this.storage = new (0, $39cf89884fa138aa$export$6c85f5032e75eff9)(this.storageUrl.href, this.headers, this.fetch, options === null || options === void 0 ? void 0 : options.storage);
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $def1f42960a27951$export$1d0b400bf8a0fa55)(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $ea5e6167a94ede8d$var$__awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : this.supabaseKey;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug }, headers, fetch) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $20d621b3b2df27d5$export$8199a418bb09bd56)({
            url: this.authUrl.href,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            fetch: fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: 'Authorization' in this.headers
        });
    }
    _initRealtimeClient(options) {
        return new (0, $d080f38a352a2a89$export$2e2bcd8739ae039)(this.realtimeUrl.href, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
        else if (event === 'SIGNED_OUT') {
            this.realtime.setAuth();
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}






const $9b5b9c646af79288$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $ea5e6167a94ede8d$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};
// Check for Node.js <= 18 deprecation
function $9b5b9c646af79288$var$shouldShowDeprecationWarning() {
    // Skip in browser environments
    if (typeof window !== 'undefined') return false;
    return false;
}
if ($9b5b9c646af79288$var$shouldShowDeprecationWarning()) console.warn(`\u{26A0}\u{FE0F}  Node.js 18 and below are deprecated and will no longer be supported in future versions of @supabase/supabase-js. ` + `Please upgrade to Node.js 20 or later. ` + `For more information, visit: https://github.com/orgs/supabase/discussions/37217`);


const $5471293cded6d6a9$export$a0b632a28672d3c0 = (0, $9b5b9c646af79288$export$5d730b7aed1a3eb0)("https://senti-tools.supabase.co", "sb_publishable_rhPJGbIOFGEedjBh9iVCiw_c5FbA8hn");


const $a2ead8eb3468501d$export$3285420c698bc605 = /*#__PURE__*/ (0, $itHdT.createContext)(null);
const $a2ead8eb3468501d$export$d053b53cdff1ea07 = ({ children: children })=>{
    const [loading, setLoading] = (0, $itHdT.useState)(true);
    const [session, setSession] = (0, $itHdT.useState)(null);
    // Manage the session state
    (0, $itHdT.useEffect)(()=>{
        // Load the initial session state
        (0, $5471293cded6d6a9$export$a0b632a28672d3c0).auth.getSession().then(({ data: { session: session } })=>{
            setSession(session);
            setLoading(false);
        });
        // Listen for changes to the session state
        const stateChangeEventHandler = (0, $5471293cded6d6a9$export$a0b632a28672d3c0).auth.onAuthStateChange((_event, session)=>{
            setSession(session);
        });
        // Unsubscribe from the event when the component is unmounted
        return stateChangeEventHandler.data.subscription.unsubscribe;
    }, []);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($a2ead8eb3468501d$export$3285420c698bc605.Provider, {
        value: {
            loading: loading,
            session: session,
            setSession: setSession
        },
        children: children
    });
};


const $36b82dca41f80dd8$export$4269543a09b27cac = ({ children: children, fallback: fallback = null })=>{
    const { session: session } = (0, $itHdT.useContext)((0, $a2ead8eb3468501d$export$3285420c698bc605));
    return session ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
        children: children
    }) : fallback;
};




var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");




"use client";
const $52eefa69bdceddac$var$NavDropdown = /*#__PURE__*/ $itHdT.forwardRef(({ id: id, title: title, children: children, bsPrefix: bsPrefix, className: className, rootCloseEvent: rootCloseEvent, menuRole: menuRole, disabled: disabled, active: active, renderMenuOnMount: renderMenuOnMount, menuVariant: menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, $a36253890ccc54be$export$2e2bcd8739ae039),
                children: title
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
$52eefa69bdceddac$var$NavDropdown.displayName = 'NavDropdown';
var $52eefa69bdceddac$export$2e2bcd8739ae039 = Object.assign($52eefa69bdceddac$var$NavDropdown, {
    Item: (0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Item,
    ItemText: (0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).ItemText,
    Divider: (0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Divider,
    Header: (0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Header
});




var $itHdT = parcelRequire("itHdT");


const $fa089317a4c6f1f1$export$d6d7a890cfecc7d5 = "popup";


// Generate a nonce for Google authentication
// Copied from here: https://supabase.com/docs/guides/auth/social-login/auth-google#google-pre-built
const $eef635b6e2747028$var$nonce = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32))));
(async ()=>{
    // Skip this initialization if we are not using the popup-based auth flow
    if ((0, $fa089317a4c6f1f1$export$d6d7a890cfecc7d5) !== "popup") {
        console.info("Skipping Google Sign-In initialization since APP_AUTH_UX_MODE is not set to 'popup'");
        return;
    }
    // Hash the nonce using SHA-256 before providing it to Google, since that is the format that Supabase expects to receive
    // See: https://supabase.com/docs/guides/auth/social-login/auth-google#google-pre-built
    const encoder = new TextEncoder();
    const encodedNonce = encoder.encode($eef635b6e2747028$var$nonce);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encodedNonce);
    const hashedNonce = Array.from(new Uint8Array(hashBuffer)).map((b)=>b.toString(16).padStart(2, "0")).join("");
    // Initialize the "Sign In With Google JavaScript API". This just needs to happen once on page load
    // See: https://developers.google.com/identity/gsi/web/reference/js-reference
    google.accounts.id.initialize({
        client_id: "394344920652-bpumsd57c1858u49crjs11domjpfdo2h.apps.googleusercontent.com",
        context: "signin",
        ux_mode: "popup",
        callback: (response)=>void $eef635b6e2747028$var$handleSignInWithGoogle(response),
        auto_select: true,
        itp_support: true,
        hd: "sentisolutions.ca",
        nonce: hashedNonce,
        use_fedcm_for_prompt: true
    });
})();
const $eef635b6e2747028$export$33f3f0a205996c11 = ()=>{
    const { loading: loading, session: session } = (0, $itHdT.useContext)((0, $a2ead8eb3468501d$export$3285420c698bc605));
    // Render the Google Sign-In button
    (0, $itHdT.useEffect)(()=>{
        const parent = document.getElementById("google-sign-in-container");
        if (!parent) throw new Error("Google Sign-In container not found");
        google.accounts.id.renderButton(parent, {
            type: "standard",
            shape: "rectangular",
            theme: "outline",
            text: "signin",
            size: "medium",
            logo_alignment: "left"
        });
    }, []);
    // If the user is not already signed in, initialize the one-tap sign in process
    (0, $itHdT.useEffect)(()=>{
        // Do nothing if the session is already loading, or if the user is already signed in
        if (loading || session) return;
        // Initialize the one-tap sign in process
        google.accounts.id.prompt();
        // Attempt to cancel the Google Sign-In process when the component is unmounted
        return google.accounts.id.cancel;
    }, [
        loading,
        session
    ]);
    // This component just renders the container that will hold the Google Sign-In button
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
        id: "google-sign-in-container"
    });
};
// Callback method to handle Google Sign-In responses
async function $eef635b6e2747028$var$handleSignInWithGoogle(googleAuthResponse) {
    // Use the token returned from Google to authenticate with Supabase
    // NOTE: This will raise the `supabase.auth.onAuthStateChange` event to any listeners (i.e. the AuthNavStatus component)
    const supabaseAuthResponse = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).auth.signInWithIdToken({
        provider: "google",
        token: googleAuthResponse.credential,
        nonce: $eef635b6e2747028$var$nonce
    });
    // Throw an error if the authentication request failed
    if (supabaseAuthResponse.error) throw supabaseAuthResponse.error;
    // Configure supabase edge functions to use the access token
    (0, $5471293cded6d6a9$export$a0b632a28672d3c0).functions.setAuth(supabaseAuthResponse.data.session.access_token);
}





var $itHdT = parcelRequire("itHdT");
var $3c01c4575390ddc2$exports = {};
$3c01c4575390ddc2$exports = $parcel$resolve("cMf9G");


const $306ab2a8108aa131$var$spriteSheetUrl = new URL($3c01c4575390ddc2$exports);
const $306ab2a8108aa131$export$f04a61298a47a40f = /*#__PURE__*/ (0, $itHdT.forwardRef)(function Icon({ icon: icon, className: className, ...props }, ref) {
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("svg", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("bi ", className),
        fill: "currentColor",
        ...props,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("use", {
            href: $306ab2a8108aa131$var$spriteSheetUrl.href + "#" + icon
        })
    });
});









var $itHdT = parcelRequire("itHdT");
const $ea035bf89b3d8923$export$6a7f87fd6631b6fd = ()=>{
    const [searchParams] = (0, $b634fe06a3f61222$export$f1a78c17382fe22a)();
    const handleRedirectSignIn = (0, $itHdT.useCallback)(()=>{
        // Redirect back to the /unathenticated page, including any returnUrl parameter from the current URL
        // The /unathenticated page handles the redirect and will send the user back to the returnUrl after successful sign-in
        const returnUrl = searchParams.get("returnUrl") || "/";
        const redirectTo = window.location.origin + "/unauthenticated?returnUrl=" + encodeURIComponent(returnUrl);
        (0, $5471293cded6d6a9$export$a0b632a28672d3c0).auth.signInWithOAuth({
            provider: "google",
            options: {
                redirectTo: redirectTo
            }
        }).then(({ error: error })=>{
            if (error) throw error;
        }).catch((error)=>{
            console.error("Google OAuth redirect sign-in failed", error);
        });
    }, [
        searchParams
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("button", {
        type: "button",
        className: "btn btn-outline-secondary",
        onClick: handleRedirectSignIn,
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: "google",
                className: "text-body me-2",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                children: "Sign in"
            })
        ]
    });
};



const $c2333257bae92541$export$71cc1408abbe49b8 = ()=>{
    const { session: session, setSession: setSession } = (0, $itHdT.useContext)((0, $a2ead8eb3468501d$export$3285420c698bc605));
    // Callback to sign out the user
    const signOut = (0, $itHdT.useCallback)(()=>{
        (0, $5471293cded6d6a9$export$a0b632a28672d3c0).auth.signOut().then(()=>{
            setSession(null);
        });
    }, [
        setSession
    ]);
    // Show a sign in button if the user is not signed in
    if (!session) return (0, $fa089317a4c6f1f1$export$d6d7a890cfecc7d5) === "popup" ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $eef635b6e2747028$export$33f3f0a205996c11), {}) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $ea035bf89b3d8923$export$6a7f87fd6631b6fd), {});
    // Otherwise show the auth dropdown
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $52eefa69bdceddac$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
            icon: "person-circle"
        }),
        align: "end",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $52eefa69bdceddac$export$2e2bcd8739ae039).ItemText, {
                className: "d-flex align-items-center",
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                        icon: "google",
                        className: "me-2"
                    }),
                    session.user.email
                ]
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $52eefa69bdceddac$export$2e2bcd8739ae039).Item, {
                className: "d-flex align-items-center",
                onClick: signOut,
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                        icon: "box-arrow-left",
                        className: "me-2"
                    }),
                    "Sign Out"
                ]
            })
        ]
    });
};




var $itHdT = parcelRequire("itHdT");

const $4c8de7547756ff0d$export$d6500e7dfb333414 = ({ className: className, ...props })=>{
    // Define a function to get the class name based on the isActive prop, while respecting any additional class names passed in
    const getClassName = (0, $itHdT.useCallback)((renderProps)=>{
        const classes = [
            "dropdown-item",
            typeof className === "function" ? className(renderProps) : className,
            renderProps.isActive ? "active" : ""
        ];
        return classes.filter(Boolean).join(" ").trim();
    }, [
        className
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$b0d92dbee9b5b60d), {
        ...props,
        className: getClassName
    });
};




var $itHdT = parcelRequire("itHdT");

const $4ffce360de2f2a65$export$d556a17c56488edc = ({ className: className, ...props })=>{
    // Define a function to get the class name based on the isActive prop, while respecting any additional class names passed in
    const getClassName = (0, $itHdT.useCallback)((renderProps)=>{
        const classes = [
            "nav-link",
            typeof className === "function" ? className(renderProps) : className,
            renderProps.isActive ? "active" : ""
        ];
        return classes.filter(Boolean).join(" ").trim();
    }, [
        className
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$b0d92dbee9b5b60d), {
        ...props,
        className: getClassName
    });
};



// NOTE: Style for this SVG are applied via an external stylesheet because we do not have `unsafe-inline` CSP enabled
//       The SVG must be inlined in the DOM so that we can apply conditional styles to it based on the current theme.

const $1832dba737c37411$export$e6ff31bff12b7ff4 = ()=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("svg", {
        id: "senti-logo",
        width: "28.772",
        height: "20.552",
        version: "1.1",
        viewBox: "0 0 345.26 179.88",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("path", {
                className: "st2",
                d: "m127.98 103.47c-0.33 1.61-0.88 3.78-3.01 7.13-3.91 6.14-12.09 13.09-29.07 13.09-30.41 0-30.27-22.3-63.89-22.3-25.34 0-28.61 12.67-28.68 18.91"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("path", {
                className: "st1",
                d: "m171.17-11.3c28.28 22.28 46.79 59.33 46.79 101.27 0 42.01-18.57 79.12-46.93 101.38m34.23-41.1h126.97m-114.75-35.62h127.3m-131.16-69.85h127.3m-146.59-28.8h127.3"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("ellipse", {
                className: "st1",
                cx: "147.56",
                cy: "89.97",
                rx: "108.98",
                ry: "123.31"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("ellipse", {
                className: "st1",
                cx: "193.85",
                cy: "89.97",
                rx: "108.98",
                ry: "123.31"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("path", {
                className: "st1",
                d: "m127.98 103.83c-0.45-4.55-0.68-9.18-0.68-13.86 0-68.1 48.79-123.31 108.98-123.31s108.98 55.21 108.98 123.31-48.79 123.31-108.98 123.31c-56.04 0-102.21-47.87-108.3-109.45m12.52 46.42h-127.31m150.45 30.47h-127.3m90.96-101.71h-127.3m131.16-34.23h-127.3m146.59-28.8h-127.31m162.03 164.74h127.3m-96.44-101.71h127.31m-340.02 41.29c-2.17-9.7-3.32-19.87-3.32-30.34 0-68.09 48.79-123.3 108.98-123.3 13.58 0 26.59 2.81 38.58 7.95m2.31 229.69c-12.63 5.79-26.43 8.98-40.89 8.98-50.94 0-93.71-39.54-105.66-92.97m39.05-127.67h260.46"
            })
        ]
    });





var $itHdT = parcelRequire("itHdT");




var $itHdT = parcelRequire("itHdT");
const $f3ead4447ee0b856$var$ThemeContext = /*#__PURE__*/ (0, $itHdT.createContext)(undefined);
function $f3ead4447ee0b856$export$93d4e7f90805808f() {
    const ctx = (0, $itHdT.useContext)($f3ead4447ee0b856$var$ThemeContext);
    if (!ctx) throw new Error("useTheme must be used within a ThemeProvider");
    return ctx;
}
const $f3ead4447ee0b856$var$prefersColorSchemeDarkMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
const $f3ead4447ee0b856$export$d8964aec282183a3 = ({ children: children })=>{
    const [themeOption, setThemeOption] = (0, $itHdT.useState)($f3ead4447ee0b856$var$getStoredThemeOption() || "auto");
    const [preferredColorScheme, setPreferredColorScheme] = (0, $itHdT.useState)($f3ead4447ee0b856$var$getPreferredColorScheme());
    // Use an effect to keep the user's preferred color scheme in sync
    (0, $itHdT.useEffect)(()=>{
        const onPrefersColorSchemeChange = ()=>{
            setPreferredColorScheme($f3ead4447ee0b856$var$getPreferredColorScheme());
        };
        $f3ead4447ee0b856$var$prefersColorSchemeDarkMediaQuery.addEventListener("change", onPrefersColorSchemeChange);
        return ()=>{
            $f3ead4447ee0b856$var$prefersColorSchemeDarkMediaQuery.removeEventListener("change", onPrefersColorSchemeChange);
        };
    });
    // Calculate the applied theme based on the selected theme option
    const appliedTheme = themeOption === "auto" ? preferredColorScheme : themeOption;
    // Apply the theme to the document when it changes
    (0, $itHdT.useEffect)(()=>{
        document.documentElement.setAttribute("data-bs-theme", appliedTheme);
    }, [
        appliedTheme
    ]);
    // Define a callback to update the selected theme option and save it to local storage
    const updateThemeOption = (0, $itHdT.useCallback)((themeOption)=>{
        setThemeOption(themeOption);
        $f3ead4447ee0b856$var$setStoredThemeOption(themeOption);
    }, []);
    // Compute the remaining context values
    const isDarkMode = appliedTheme === "dark";
    const isLightMode = appliedTheme === "light";
    const oppositeTheme = appliedTheme === "dark" ? "light" : "dark";
    const contextValue = {
        themeOption: themeOption,
        appliedTheme: appliedTheme,
        isDarkMode: isDarkMode,
        isLightMode: isLightMode,
        oppositeTheme: oppositeTheme,
        updateThemeOption: updateThemeOption
    };
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($f3ead4447ee0b856$var$ThemeContext.Provider, {
        value: contextValue,
        children: children
    });
};
function $f3ead4447ee0b856$var$getStoredThemeOption() {
    return localStorage.getItem("theme");
}
function $f3ead4447ee0b856$var$setStoredThemeOption(theme) {
    localStorage.setItem("theme", theme);
}
function $f3ead4447ee0b856$var$getPreferredColorScheme() {
    return $f3ead4447ee0b856$var$prefersColorSchemeDarkMediaQuery.matches ? "dark" : "light";
}


const $0314e4bc0f0b7f31$var$themeIconMap = {
    light: "sun-fill",
    dark: "moon-stars-fill",
    auto: "circle-half"
};
const $0314e4bc0f0b7f31$export$9d63163ee2173b37 = ({ className: className })=>{
    const { themeOption: currentThemeOption, updateThemeOption: setCurrentThemeOption } = (0, $f3ead4447ee0b856$export$93d4e7f90805808f)();
    // Event handler to update the theme when the user clicks on a theme toggle
    const onThemeButtonClicked = (0, $itHdT.useCallback)((e)=>{
        const newTheme = e.currentTarget.dataset["theme"];
        setCurrentThemeOption(newTheme);
    }, [
        setCurrentThemeOption
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $52eefa69bdceddac$export$2e2bcd8739ae039), {
        className: className,
        title: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($0314e4bc0f0b7f31$var$ThemeDropdownTitle, {
            theme: currentThemeOption
        }),
        align: "end",
        children: Object.entries($0314e4bc0f0b7f31$var$themeIconMap).map(([themeOption, icon])=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $52eefa69bdceddac$export$2e2bcd8739ae039).Item, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("d-flex align-items-center", {
                    active: themeOption === currentThemeOption
                }),
                onClick: onThemeButtonClicked,
                "data-theme": themeOption,
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                        icon: icon,
                        className: "me-2 opacity-50"
                    }),
                    themeOption,
                    themeOption === currentThemeOption && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                        icon: "check2",
                        className: "ms-auto"
                    })
                ]
            }, themeOption))
    });
};
const $0314e4bc0f0b7f31$var$ThemeDropdownTitle = ({ theme: theme })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: $0314e4bc0f0b7f31$var$themeIconMap[theme]
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                className: "d-lg-none ms-2",
                children: "Toggle theme"
            })
        ]
    });
};





var $itHdT = parcelRequire("itHdT");
"use client";
// src/IsRestoringProvider.ts
const $f443645ce973e7da$var$IsRestoringContext = $itHdT.createContext(false);
/**
* If you are using `PersistQueryClientProvider`, you can also use the `useIsRestoring` hook alongside it to
* check if a restore is currently in progress. `useQuery` and friends also check this internally to avoid
* race conditions between the restore and mounting queries.
* @returns `true` while a persisted client is being restored, `false` otherwise.
*/ const $f443645ce973e7da$export$4da0178d6b5f553 = ()=>$itHdT.useContext($f443645ce973e7da$var$IsRestoringContext);
/**
* The Provider that `PersistQueryClientProvider` uses to signal whether a persisted client is currently
* being restored, read by `useIsRestoring`.
*/ const $f443645ce973e7da$export$593807d4e94f9621 = $f443645ce973e7da$var$IsRestoringContext.Provider;



var $itHdT = parcelRequire("itHdT");

"use client";
// src/QueryErrorResetBoundary.tsx
/**
* Creates the value shared through the boundary's context, which tracks whether a reset was
* requested.
* @returns The `clearReset`, `isReset`, and `reset` functions of the boundary.
*/ function $fa46fdbb53964745$var$createValue() {
    let isReset = false;
    return {
        /**
		* Clears the reset state, so queries know not to try again until the boundary is reset again.
		*/ clearReset: ()=>{
            isReset = false;
        },
        /**
		* Resets any query errors within the boundary, so queries know they can try again.
		*/ reset: ()=>{
            isReset = true;
        },
        /**
		* Returns whether the boundary has been reset and not yet cleared.
		* @returns `true` if the boundary has been reset and not yet cleared.
		*/ isReset: ()=>{
            return isReset;
        }
    };
}
const $fa46fdbb53964745$var$QueryErrorResetBoundaryContext = $itHdT.createContext($fa46fdbb53964745$var$createValue());
/**
* This hook will reset any query errors within the closest `QueryErrorResetBoundary`. If there is no boundary
* defined it will reset them globally.
* @returns The boundary's {@link QueryErrorResetBoundaryValue}.
* @example
* ```tsx
* import { ErrorBoundary } from 'react-error-boundary'
* import { useQueryErrorResetBoundary } from '@tanstack/react-query'
*
* function App({ children }: { children: React.ReactNode }) {
*   const { reset } = useQueryErrorResetBoundary()
*
*   return (
*     <ErrorBoundary
*       onReset={reset}
*       fallbackRender={({ resetErrorBoundary }) => (
*         <div>
*           There was an error!
*           <button onClick={() => resetErrorBoundary()}>Try again</button>
*         </div>
*       )}
*     >
*       {children}
*     </ErrorBoundary>
*   )
* }
* ```
*/ const $fa46fdbb53964745$export$50dfac555130cafd = ()=>$itHdT.useContext($fa46fdbb53964745$var$QueryErrorResetBoundaryContext);
/**
* When using `suspense` or `throwOnError` in your queries, you need a way to let queries know that you want to
* try again when re-rendering after some error occurred. With the `QueryErrorResetBoundary` component you can
* reset any query errors within the boundaries of the component.
* @param props - The `children` to render.
* @returns The `children`, rendered as-is, or called with the boundary's {@link QueryErrorResetBoundaryValue}
* if `children` is a function.
* @example
* ```tsx
* import { ErrorBoundary } from 'react-error-boundary'
* import { QueryErrorResetBoundary } from '@tanstack/react-query'
*
* function App() {
*   return (
*     <QueryErrorResetBoundary>
*       {({ reset }) => (
*         <ErrorBoundary
*           onReset={reset}
*           fallbackRender={({ resetErrorBoundary }) => (
*             <div>
*               There was an error!
*               <button onClick={() => resetErrorBoundary()}>Try again</button>
*             </div>
*           )}
*         >
*           <Page />
*         </ErrorBoundary>
*       )}
*     </QueryErrorResetBoundary>
*   )
* }
* ```
*/ const $fa46fdbb53964745$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $itHdT.useState(()=>$fa46fdbb53964745$var$createValue());
    return /* @__PURE__ */ (0, $3d04577e83656c0d$exports.jsx)($fa46fdbb53964745$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $itHdT = parcelRequire("itHdT");

"use client";
// src/errorBoundaryUtils.ts
/**
* Turns off `retryOnMount` for a query that throws its errors (with `suspense` or `throwOnError`),
* unless the error boundary has been reset, so a remount doesn't retry the failed query before the
* user resets the boundary. Mutates the options.
* @param options - The defaulted query options to adjust.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
* @param query - The query, used to evaluate a `throwOnError` function against its error.
*/ const $0d7e69120253f81f$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = (query === null || query === void 0 ? void 0 : query.state.status) === "error" && typeof options.throwOnError === "function" ? (0, $ee0a7c55ac205e24$export$2072f68e6c3507cf)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
/**
* Clears the reset state of the error boundary after the component mounts, so later errors are
* thrown to the boundary again.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
*/ const $0d7e69120253f81f$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $itHdT.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
/**
* Checks whether the query error should be thrown to the nearest error boundary: the query errored
* and isn't fetching, the boundary hasn't been reset, and either `suspense` is enabled with no data
* or `throwOnError` says so.
* @param params - The observer `result`, the `errorResetBoundary`, the `throwOnError` option, the
* `query`, and the `suspense` option.
* @returns `true` if the error should be thrown.
*/ const $0d7e69120253f81f$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $ee0a7c55ac205e24$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};


// src/suspense.ts
/**
* The default `throwOnError` of the suspense hooks: throws the error to the nearest error boundary
* only if the query has no data to show.
* @param _error - The error of the query. Unused.
* @param query - The query that errored.
* @returns `true` if the query has no data.
*/ const $2b76ef155efaf667$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
/**
* Raises `staleTime` and a numeric `gcTime` to at least 1000ms when `suspense` is enabled, so a
* component that remounts after suspending doesn't refetch right away or find the query garbage
* collected. A `'static'` `staleTime` is kept as is. Mutates the options.
* @param defaultedOptions - The defaulted query options to adjust.
*/ const $2b76ef155efaf667$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
/**
* Checks whether a query should suspend: `suspense` is enabled and the result is still `pending`.
* @param defaultedOptions - The defaulted query options, if any.
* @param result - The current result of the observer.
* @returns `true` if the component should suspend.
*/ const $2b76ef155efaf667$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions === null || defaultedOptions === void 0 ? void 0 : defaultedOptions.suspense) && result.isPending;
/**
* Fetches the query for a suspending component, without affecting the observer's own result. If
* the fetch fails, the reset state of the error boundary is cleared, so the error is thrown to it.
* @param defaultedOptions - The defaulted query options to fetch with.
* @param observer - The observer of the query.
* @param errorResetBoundary - The value of the nearest `QueryErrorResetBoundary`.
* @returns A promise that resolves once the fetch settles. It never rejects.
*/ const $2b76ef155efaf667$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });



var $itHdT = parcelRequire("itHdT");

"use client";
// src/useBaseQuery.ts
/**
* Base implementation shared by `useQuery`, `useInfiniteQuery`, `useSuspenseQuery`, and
* `useSuspenseInfiniteQuery`.
* @param options - The options passed to the calling hook.
* @param Observer - The observer class from query-core (`QueryObserver` or
* `InfiniteQueryObserver`).
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest
* context will be used.
* @returns The query result, tracking which properties are read unless `notifyOnChangeProps` is
* set.
* @throws {Error} If `options` is not an object (outside production), or the query error when it should be
* thrown to the nearest error boundary (see `throwOnError`). While suspending, it throws a promise instead.
*/ function $3e43c78d2427eb00$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $f443645ce973e7da$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $fa46fdbb53964745$export$50dfac555130cafd)();
    const client = (0, $e49ef136abe795ca$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $2b76ef155efaf667$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $0d7e69120253f81f$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary, query);
    (0, $0d7e69120253f81f$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $itHdT.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $itHdT.useSyncExternalStore($itHdT.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $e62a61312d2d5e98$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $ee0a7c55ac205e24$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $itHdT.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $2b76ef155efaf667$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $2b76ef155efaf667$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $0d7e69120253f81f$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}











// src/queryObserver.ts
var $828f6af858e18068$var$_client = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_currentQuery = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_currentQueryInitialState = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_currentResult = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_currentResultState = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_currentResultOptions = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_selectError = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_selectFn = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_selectResult = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_lastQueryWithDefinedData = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_staleTimeoutId = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_refetchIntervalId = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_currentRefetchInterval = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_trackedProps = /* @__PURE__ */ new WeakMap();
var $828f6af858e18068$var$_QueryObserver_brand = /* @__PURE__ */ new WeakSet();
/**
* A `QueryObserver` watches a single query in the `QueryCache` and computes a
* `QueryObserverResult` from its state, recomputing and notifying subscribers
* whenever the underlying query (or the observer's options) changes. It is
* the primitive that framework adapters (e.g. `useQuery`) build their hooks
* on top of, but it can also be used directly to observe and switch between
* queries outside of any framework.
* @example
* ```ts
* const observer = new QueryObserver(queryClient, {
*   queryKey: ['posts'],
*   queryFn: fetchPosts,
* })
*
* const unsubscribe = observer.subscribe((result) => {
*   console.log(result.data)
* })
* ```
*/ var $828f6af858e18068$export$a06cf8c0066f0d4c = class extends (0, $5cb24f678e609491$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $2f8b5ecae537244d$export$625550452a3fa3ec)(this, $828f6af858e18068$var$_QueryObserver_brand);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_client, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_currentQuery, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_currentQueryInitialState, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_currentResult, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_currentResultState, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_currentResultOptions, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_selectError, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_selectFn, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_selectResult, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_lastQueryWithDefinedData, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_staleTimeoutId, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_refetchIntervalId, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_currentRefetchInterval, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $828f6af858e18068$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_client, this, client);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_selectError, this, null);
        this.bindMethods();
        this.setOptions(options);
    }
    /**
	* Binds the methods of the result (`refetch`) to the observer, so they keep working when destructured
	* from it. Subclasses override it to bind their own result methods as well.
	*/ bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this).addObserver(this);
            if ($828f6af858e18068$var$shouldFetchOnMount((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this), this.options)) (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_executeFetch).call(this);
            else this.updateResult();
            (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_updateTimers).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    /**
	* Returns whether the observed query is currently stale and configured
	* (via the `refetchOnReconnect` option) to refetch when the network
	* reconnects.
	* @returns `true` if the observer should refetch the query on reconnect.
	*/ shouldFetchOnReconnect() {
        return $828f6af858e18068$var$shouldFetchOn((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this), this.options, this.options.refetchOnReconnect);
    }
    /**
	* Returns whether the observed query is currently stale and configured
	* (via the `refetchOnWindowFocus` option) to refetch when the window
	* regains focus.
	* @returns `true` if the observer should refetch the query on window focus.
	*/ shouldFetchOnWindowFocus() {
        return $828f6af858e18068$var$shouldFetchOn((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this), this.options, this.options.refetchOnWindowFocus);
    }
    /**
	* Stops observing the current query: clears all listeners, cancels the
	* stale and refetch-interval timers, and removes this observer from the
	* query it was observing.
	*/ destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_clearStaleTimeout).call(this);
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_clearRefetchInterval).call(this);
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this).removeObserver(this);
    }
    /**
	* Updates the observer's options. This will re-resolve the query being
	* observed (switching to a different query if the `queryKey` changed),
	* trigger a fetch if the new options require one and the observer has
	* subscribers, recompute the current result, and reschedule the stale and
	* refetch-interval timers as needed.
	* @param options - The new observer options. They are defaulted with {@link
	* QueryClient#defaultQueryOptions} before being applied.
	* @throws {Error} If `enabled` is neither a boolean nor a function.
	* @example
	* ```ts
	* observer.setOptions({ queryKey: ['posts', 1], queryFn: () => fetchPost(1) })
	* // later: switch to a different query, reusing the same observer
	* observer.setOptions({ queryKey: ['posts', 2], queryFn: () => fetchPost(2) })
	* ```
	*/ setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this);
        this.options = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(this.options.enabled, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_updateQuery).call(this);
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $ee0a7c55ac205e24$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $828f6af858e18068$var$shouldFetchOptionally((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this), prevQuery, this.options, prevOptions)) (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_executeFetch).call(this);
        this.updateResult();
        if (mounted && ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this) !== prevQuery || (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(this.options.enabled, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) !== (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(prevOptions.enabled, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) || (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(this.options.staleTime, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) !== (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(prevOptions.staleTime, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)))) (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_updateStaleTimeout).call(this);
        const nextRefetchInterval = (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_computeRefetchInterval).call(this);
        if (mounted && ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this) !== prevQuery || (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(this.options.enabled, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) !== (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(prevOptions.enabled, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) || nextRefetchInterval !== (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentRefetchInterval, this))) (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_updateRefetchInterval).call(this, nextRefetchInterval);
    }
    /**
	* Computes the result the observer would produce for the given (already-defaulted) options
	* right now, building the underlying `Query` if it doesn't exist yet, without waiting for a
	* subscription callback. Called by framework adapters on every render (e.g. `useQuery`) so the
	* returned value is available synchronously, ahead of `setOptions` triggering an actual fetch.
	* @param options - The defaulted observer options to compute the result for.
	* @returns The result for the given options.
	*/ getOptimisticResult(options) {
        const query = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this).getQueryCache().build((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this), options);
        const result = this.createResult(query, options);
        if (!(0, $ee0a7c55ac205e24$export$3e67810a3f0e9f1c)(this.getCurrentResult(), result)) {
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentResult, this, result);
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentResultOptions, this, this.options);
            (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentResultState, this, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this).state);
        }
        return result;
    }
    /**
	* Returns the most recently computed `QueryObserverResult` for the
	* observed query. This is a point-in-time read; to be notified of updates
	* as they happen, subscribe to the observer instead (its inherited
	* `subscribe` method).
	* @returns The observer's latest result.
	* @example
	* ```ts
	* const result = observer.getCurrentResult()
	* console.log(result.status, result.data)
	* ```
	*/ getCurrentResult() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this);
    }
    /**
	* Wraps a `QueryObserverResult` in a `Proxy` that records which properties are read, via
	* {@link QueryObserver#trackProp} (and an optional `onPropTracked` callback). Used by framework
	* adapters when `notifyOnChangeProps` is not set, to implement its default "only re-render on
	* properties you actually read" behavior.
	* @param result - The result to wrap.
	* @param onPropTracked - Called with the name of each property that is read.
	* @returns A proxy of `result` that tracks property reads.
	*/ trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked === null || onPropTracked === void 0 || onPropTracked(key);
                return Reflect.get(target, key);
            }
        });
    }
    /**
	* Records that the given `QueryObserverResult` property was read, so a subsequent update only
	* notifies this observer if a tracked property actually changed. Normally called indirectly via
	* {@link QueryObserver#trackResult}'s proxy; exposed directly for adapters that track property
	* access themselves (e.g. through their own reactivity system) instead of via the proxy.
	* @param key - The name of the property that was read.
	*/ trackProp(key) {
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_trackedProps, this).add(key);
    }
    /**
	* Returns the `Query` instance this observer is currently observing.
	* @returns The observed query.
	*/ getCurrentQuery() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this);
    }
    /**
	* Refetches the observed query and returns a promise that resolves with
	* the resulting `QueryObserverResult`.
	* @param options - Set `cancelRefetch` to `false` to keep a running fetch instead of cancelling
	* it, and `throwOnError` to `true` to reject when the refetch fails.
	* @returns A promise that resolves with the result after the refetch.
	* @example
	* ```ts
	* const result = await observer.refetch({ cancelRefetch: false })
	* console.log(result.data)
	* ```
	*/ refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    /**
	* Fetches a query defined by the given options without affecting this
	* observer's own tracked query or result, and returns a promise that
	* resolves with the `QueryObserverResult` for that fetch. This is useful
	* for prefetching data that another observer (e.g. a query about to be
	* navigated to) will need, ahead of time.
	* @param options - The observer options of the query to fetch.
	* @returns A promise that resolves with the result for the fetched query.
	* @example
	* ```ts
	* const result = await observer.fetchOptimistic({
	*   queryKey: ['posts', 2],
	*   queryFn: () => fetchPost(2),
	* })
	* console.log(result.data)
	* ```
	*/ fetchOptimistic(options) {
        const defaultedOptions = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this).defaultQueryOptions(options);
        const query = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this).getQueryCache().build((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this), defaultedOptions);
        let unsubscribe = ()=>{};
        let resolveEarly;
        const cachePromise = new Promise((resolve)=>{
            resolveEarly = resolve;
            unsubscribe = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this).getQueryCache().subscribe((event)=>{
                if (event.type === "updated" && event.query.queryHash === query.queryHash && query.state.data !== void 0) {
                    unsubscribe();
                    resolve(this.createResult(query, defaultedOptions));
                }
            });
        });
        return Promise.race([
            query.fetch(defaultedOptions).then(()=>{
                const result = this.createResult(query, defaultedOptions);
                resolveEarly === null || resolveEarly === void 0 || resolveEarly(result);
                return result;
            }).finally(()=>{
                unsubscribe();
            }),
            cachePromise
        ]);
    }
    /**
	* Fetches the observed query and updates the result once the fetch settles. Used by `refetch` and,
	* in `InfiniteQueryObserver`, to fetch more pages.
	* @param fetchOptions - Options for this fetch. `cancelRefetch` defaults to `true`.
	* @returns A promise that resolves with the updated result.
	*/ fetch(fetchOptions) {
        return (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_executeFetch).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this);
        });
    }
    /**
	* Computes the result for a query and options from the query's state, applying `select`,
	* `placeholderData`, and the derived flags. Subclasses override it to add their own fields.
	* @param query - The query to compute the result for.
	* @param options - The observer options to compute the result with.
	* @returns The computed result.
	*/ createResult(query, options) {
        const prevQuery = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this);
        const prevOptions = this.options;
        const prevResult = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this);
        const prevResultState = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResultState, this);
        const prevResultOptions = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResultOptions, this);
        const queryInitialState = query !== prevQuery ? query.state : (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQueryInitialState, this);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $828f6af858e18068$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $828f6af858e18068$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $54b7cad5678267da$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult === null || prevResult === void 0 ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions === null || prevResultOptions === void 0 ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else {
                var _classPrivateFieldGet2$1;
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_classPrivateFieldGet2$1 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_lastQueryWithDefinedData, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.state.data, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_lastQueryWithDefinedData, this)) : options.placeholderData;
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $ee0a7c55ac205e24$export$17619bac5b909b23)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState === null || prevResultState === void 0 ? void 0 : prevResultState.data) && options.select === (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_selectFn, this)) data = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_selectResult, this);
            else try {
                (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_selectFn, this, options.select);
                data = options.select(data);
                data = (0, $ee0a7c55ac205e24$export$17619bac5b909b23)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, data, options);
                (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_selectResult, this, data);
                (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_selectError, this, null);
            } catch (selectError) {
                (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_selectError, this, selectError);
            }
        } else if (data === void 0) (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_selectError, this, null);
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_selectError, this)) {
            error = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_selectError, this);
            data = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_selectResult, this);
            errorUpdatedAt = Date.now();
            status = "error";
            isPlaceholderData = false;
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        return {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $828f6af858e18068$var$isStale(query, options),
            refetch: this.refetch,
            isEnabled: (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(options.enabled, query) !== false
        };
    }
    /**
	* Recomputes and stores the current result from the current query/options, notifying listeners
	* if it changed. Framework adapters call this right after subscribing to make sure no query
	* update was missed in the gap between creating the observer and subscribing to it.
	*/ updateResult() {
        const prevResult = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this);
        const nextResult = this.createResult((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this), this.options);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentResultState, this, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this).state);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentResultOptions, this, this.options);
        if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResultState, this).data !== void 0) (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_lastQueryWithDefinedData, this, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this));
        if ((0, $ee0a7c55ac205e24$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentResult, this, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_trackedProps, this).size) return true;
            if (this.options.throwOnError && (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this).error !== prevResult.error) return true;
            for (const key of notifyOnChangePropsValue ?? (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_trackedProps, this))if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this)[key] !== prevResult[key]) return true;
            return false;
        };
        const notifyListeners = shouldNotifyListeners();
        (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
            if (notifyListeners) this.listeners.forEach((listener)=>{
                listener((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this));
            });
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this).getQueryCache().notify({
                query: (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this),
                type: "observerResultsUpdated"
            });
        });
    }
    /**
	* Updates the observer's result when the observed query changes, and reschedules its timers if it
	* has listeners.
	* @internal
	*/ onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_updateTimers).call(this);
    }
};
function $828f6af858e18068$var$_executeFetch(fetchOptions) {
    (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_updateQuery).call(this);
    let promise = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this).fetch(this.options, fetchOptions);
    if (!(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $ee0a7c55ac205e24$export$8793edee2d425525));
    return promise;
}
function $828f6af858e18068$var$_shouldScheduleTimer(timeout) {
    return !(0, $c0c290c4c8652ba5$export$6acf61af03e62db)() && (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(this.options.enabled, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) !== false && (0, $ee0a7c55ac205e24$export$e539f754e934e270)(timeout);
}
function $828f6af858e18068$var$_updateStaleTimeout() {
    (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_clearStaleTimeout).call(this);
    const staleTime = (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(this.options.staleTime, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this));
    if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this).isStale || !(0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_shouldScheduleTimer).call(this, staleTime)) return;
    const timeout = (0, $ee0a7c55ac205e24$export$811b83d62bcf47f0)((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this).dataUpdatedAt, staleTime) + 1;
    (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_staleTimeoutId, this, (0, $769570b3c4fef1fb$export$94a2700736e69372).setTimeout(()=>{
        if (!(0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentResult, this).isStale) this.updateResult();
    }, timeout));
}
function $828f6af858e18068$var$_computeRefetchInterval() {
    return (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(this.options.refetchInterval, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) ?? false;
}
function $828f6af858e18068$var$_updateRefetchInterval(nextInterval) {
    (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_clearRefetchInterval).call(this);
    (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentRefetchInterval, this, nextInterval);
    if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentRefetchInterval, this) === 0 || !(0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_shouldScheduleTimer).call(this, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentRefetchInterval, this))) return;
    (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_refetchIntervalId, this, (0, $769570b3c4fef1fb$export$94a2700736e69372).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $fddc2922147f8f96$export$6bf54661be5b02cf).isFocused()) (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_executeFetch).call(this);
    }, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentRefetchInterval, this)));
}
function $828f6af858e18068$var$_updateTimers() {
    (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_updateStaleTimeout).call(this);
    (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_updateRefetchInterval).call(this, (0, $8abf3f80f32bda0d$export$43caf9889c228507)($828f6af858e18068$var$_QueryObserver_brand, this, $828f6af858e18068$var$_computeRefetchInterval).call(this));
}
function $828f6af858e18068$var$_clearStaleTimeout() {
    if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_staleTimeoutId, this) !== void 0) {
        (0, $769570b3c4fef1fb$export$94a2700736e69372).clearTimeout((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_staleTimeoutId, this));
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_staleTimeoutId, this, void 0);
    }
}
function $828f6af858e18068$var$_clearRefetchInterval() {
    if ((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_refetchIntervalId, this) !== void 0) {
        (0, $769570b3c4fef1fb$export$94a2700736e69372).clearInterval((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_refetchIntervalId, this));
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_refetchIntervalId, this, void 0);
    }
}
function $828f6af858e18068$var$_updateQuery() {
    const query = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this).getQueryCache().build((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_client, this), this.options);
    if (query === (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this)) return;
    const prevQuery = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($828f6af858e18068$var$_currentQuery, this);
    (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentQuery, this, query);
    (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($828f6af858e18068$var$_currentQueryInitialState, this, query.state);
    if (this.hasListeners()) {
        prevQuery === null || prevQuery === void 0 || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
}
/**
* Checks whether a query has no data yet and should do its initial load when an observer mounts.
* @param query - The query to check.
* @param options - The observer options.
* @returns `true` if the query is enabled, has no data, and isn't in an error state with
* `retryOnMount: false`.
*/ function $828f6af858e18068$var$shouldLoadOnMount(query, options) {
    return (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(options.retryOnMount, query) === false);
}
/**
* Checks whether a query should fetch when an observer mounts: either for its initial load, or
* because it has data and `refetchOnMount` asks for a refetch.
* @param query - The query to check.
* @param options - The observer options.
* @returns `true` if the query should fetch on mount.
*/ function $828f6af858e18068$var$shouldFetchOnMount(query, options) {
    return $828f6af858e18068$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $828f6af858e18068$var$shouldFetchOn(query, options, options.refetchOnMount);
}
/**
* Checks whether a query should fetch for a `refetchOnMount`, `refetchOnWindowFocus`, or
* `refetchOnReconnect` option.
* @param query - The query to check.
* @param options - The observer options.
* @param field - The value of the option to check.
* @returns `true` if the query is enabled, not static, and the option is `'always'`, or is not
* `false` and the query is stale.
*/ function $828f6af858e18068$var$shouldFetchOn(query, options, field) {
    if ((0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(options.enabled, query) !== false && (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(options.staleTime, query) !== "static") {
        const value = (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(field, query);
        return value === "always" || value !== false && $828f6af858e18068$var$isStale(query, options);
    }
    return false;
}
/**
* Checks whether a query should fetch after the observer's options change.
* @param query - The query observed with the new options.
* @param prevQuery - The query observed with the previous options.
* @param options - The new observer options.
* @param prevOptions - The previous observer options.
* @returns `true` if the query changed or was disabled before, it isn't a suspense query in an
* error state, and it is stale.
*/ function $828f6af858e18068$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $828f6af858e18068$var$isStale(query, options);
}
/**
* Checks whether a query is stale for the given observer options.
* @param query - The query to check.
* @param options - The observer options, whose `enabled` and `staleTime` are used.
* @returns `true` if the query is enabled and its data is stale for `staleTime`.
*/ function $828f6af858e18068$var$isStale(query, options) {
    return (0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(options.enabled, query) !== false && query.isStaleByTime((0, $ee0a7c55ac205e24$export$e36731f6aa6a4362)(options.staleTime, query));
}


"use client";
// src/useQuery.ts
function $6ea0b2638e0c092a$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $3e43c78d2427eb00$export$fff0865807e996c5)(options, (0, $828f6af858e18068$export$a06cf8c0066f0d4c), queryClient);
}




var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");


"use client";
const $67974e86dbd6e1f4$var$Spinner = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$67974e86dbd6e1f4$var$Spinner.displayName = 'Spinner';
var $67974e86dbd6e1f4$export$2e2bcd8739ae039 = $67974e86dbd6e1f4$var$Spinner;



var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");
var $658434408754ac61$exports = {};
var $c2bfe06b6383bbdf$exports = {};
var $98d3e9752cee3072$exports = {};
var $68aa251488aa1603$exports = {};
var $9e076c4f099a76a7$exports = {};
var $42322044bbbf4898$exports = {};
var $f54b3c3cffee7f44$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f54b3c3cffee7f44$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$f54b3c3cffee7f44$exports = $f54b3c3cffee7f44$var$listCacheClear;


var $da554e8ddea4c113$exports = {};
var $247f57f78b81e630$exports = {};
var $4ccffa0477315322$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4ccffa0477315322$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$4ccffa0477315322$exports = $4ccffa0477315322$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $247f57f78b81e630$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4ccffa0477315322$exports(array[length][0], key)) return length;
    }
    return -1;
}
$247f57f78b81e630$exports = $247f57f78b81e630$var$assocIndexOf;


/** Used for built-in method references. */ var $da554e8ddea4c113$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $da554e8ddea4c113$var$splice = $da554e8ddea4c113$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $da554e8ddea4c113$var$listCacheDelete(key) {
    var data = this.__data__, index = $247f57f78b81e630$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $da554e8ddea4c113$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$da554e8ddea4c113$exports = $da554e8ddea4c113$var$listCacheDelete;


var $6d4f4022f7c4abd6$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6d4f4022f7c4abd6$var$listCacheGet(key) {
    var data = this.__data__, index = $247f57f78b81e630$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$6d4f4022f7c4abd6$exports = $6d4f4022f7c4abd6$var$listCacheGet;


var $1504a42a614a7dfc$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1504a42a614a7dfc$var$listCacheHas(key) {
    return $247f57f78b81e630$exports(this.__data__, key) > -1;
}
$1504a42a614a7dfc$exports = $1504a42a614a7dfc$var$listCacheHas;


var $236551c090455bc5$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $236551c090455bc5$var$listCacheSet(key, value) {
    var data = this.__data__, index = $247f57f78b81e630$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$236551c090455bc5$exports = $236551c090455bc5$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $42322044bbbf4898$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$42322044bbbf4898$var$ListCache.prototype.clear = $f54b3c3cffee7f44$exports;
$42322044bbbf4898$var$ListCache.prototype['delete'] = $da554e8ddea4c113$exports;
$42322044bbbf4898$var$ListCache.prototype.get = $6d4f4022f7c4abd6$exports;
$42322044bbbf4898$var$ListCache.prototype.has = $1504a42a614a7dfc$exports;
$42322044bbbf4898$var$ListCache.prototype.set = $236551c090455bc5$exports;
$42322044bbbf4898$exports = $42322044bbbf4898$var$ListCache;


var $467155a9857a8057$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $467155a9857a8057$var$stackClear() {
    this.__data__ = new $42322044bbbf4898$exports;
    this.size = 0;
}
$467155a9857a8057$exports = $467155a9857a8057$var$stackClear;


var $87103be02892d694$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $87103be02892d694$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$87103be02892d694$exports = $87103be02892d694$var$stackDelete;


var $1e13032d54f66cff$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1e13032d54f66cff$var$stackGet(key) {
    return this.__data__.get(key);
}
$1e13032d54f66cff$exports = $1e13032d54f66cff$var$stackGet;


var $dd46f498759d4de8$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dd46f498759d4de8$var$stackHas(key) {
    return this.__data__.has(key);
}
$dd46f498759d4de8$exports = $dd46f498759d4de8$var$stackHas;


var $d295afe762a4af6b$exports = {};

var $b22b059dc602d9e8$exports = {};
var $050b290091bba370$exports = {};
var $6e0822fd2208b847$exports = {};
var $ed2327a9dc7966cd$exports = {};
var $6f100228b69eda33$exports = {};
var $a5e751c5a48e6fb1$exports = {};

var $5wFbo = parcelRequire("5wFbo");
/** Built-in value references. */ var $a5e751c5a48e6fb1$var$Symbol = $5wFbo.Symbol;
$a5e751c5a48e6fb1$exports = $a5e751c5a48e6fb1$var$Symbol;


var $f4657bc7ed622fd1$exports = {};

/** Used for built-in method references. */ var $f4657bc7ed622fd1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f4657bc7ed622fd1$var$hasOwnProperty = $f4657bc7ed622fd1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f4657bc7ed622fd1$var$nativeObjectToString = $f4657bc7ed622fd1$var$objectProto.toString;
/** Built-in value references. */ var $f4657bc7ed622fd1$var$symToStringTag = $a5e751c5a48e6fb1$exports ? $a5e751c5a48e6fb1$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f4657bc7ed622fd1$var$getRawTag(value) {
    var isOwn = $f4657bc7ed622fd1$var$hasOwnProperty.call(value, $f4657bc7ed622fd1$var$symToStringTag), tag = value[$f4657bc7ed622fd1$var$symToStringTag];
    try {
        value[$f4657bc7ed622fd1$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f4657bc7ed622fd1$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f4657bc7ed622fd1$var$symToStringTag] = tag;
        else delete value[$f4657bc7ed622fd1$var$symToStringTag];
    }
    return result;
}
$f4657bc7ed622fd1$exports = $f4657bc7ed622fd1$var$getRawTag;


var $deb6be184ea0ae81$exports = {};
/** Used for built-in method references. */ var $deb6be184ea0ae81$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $deb6be184ea0ae81$var$nativeObjectToString = $deb6be184ea0ae81$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $deb6be184ea0ae81$var$objectToString(value) {
    return $deb6be184ea0ae81$var$nativeObjectToString.call(value);
}
$deb6be184ea0ae81$exports = $deb6be184ea0ae81$var$objectToString;


/** `Object#toString` result references. */ var $6f100228b69eda33$var$nullTag = '[object Null]', $6f100228b69eda33$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $6f100228b69eda33$var$symToStringTag = $a5e751c5a48e6fb1$exports ? $a5e751c5a48e6fb1$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $6f100228b69eda33$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $6f100228b69eda33$var$undefinedTag : $6f100228b69eda33$var$nullTag;
    return $6f100228b69eda33$var$symToStringTag && $6f100228b69eda33$var$symToStringTag in Object(value) ? $f4657bc7ed622fd1$exports(value) : $deb6be184ea0ae81$exports(value);
}
$6f100228b69eda33$exports = $6f100228b69eda33$var$baseGetTag;


var $bf7b23ae406572e5$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bf7b23ae406572e5$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$bf7b23ae406572e5$exports = $bf7b23ae406572e5$var$isObject;


/** `Object#toString` result references. */ var $ed2327a9dc7966cd$var$asyncTag = '[object AsyncFunction]', $ed2327a9dc7966cd$var$funcTag = '[object Function]', $ed2327a9dc7966cd$var$genTag = '[object GeneratorFunction]', $ed2327a9dc7966cd$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $ed2327a9dc7966cd$var$isFunction(value) {
    if (!$bf7b23ae406572e5$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $6f100228b69eda33$exports(value);
    return tag == $ed2327a9dc7966cd$var$funcTag || tag == $ed2327a9dc7966cd$var$genTag || tag == $ed2327a9dc7966cd$var$asyncTag || tag == $ed2327a9dc7966cd$var$proxyTag;
}
$ed2327a9dc7966cd$exports = $ed2327a9dc7966cd$var$isFunction;


var $b9232594bfaabeeb$exports = {};
var $1e0ddacfa25df36c$exports = {};

var $5wFbo = parcelRequire("5wFbo");
/** Used to detect overreaching core-js shims. */ var $1e0ddacfa25df36c$var$coreJsData = $5wFbo["__core-js_shared__"];
$1e0ddacfa25df36c$exports = $1e0ddacfa25df36c$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $b9232594bfaabeeb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1e0ddacfa25df36c$exports && $1e0ddacfa25df36c$exports.keys && $1e0ddacfa25df36c$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b9232594bfaabeeb$var$isMasked(func) {
    return !!$b9232594bfaabeeb$var$maskSrcKey && $b9232594bfaabeeb$var$maskSrcKey in func;
}
$b9232594bfaabeeb$exports = $b9232594bfaabeeb$var$isMasked;



var $347c66bb2b0035c7$exports = {};
/** Used for built-in method references. */ var $347c66bb2b0035c7$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $347c66bb2b0035c7$var$funcToString = $347c66bb2b0035c7$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $347c66bb2b0035c7$var$toSource(func) {
    if (func != null) {
        try {
            return $347c66bb2b0035c7$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$347c66bb2b0035c7$exports = $347c66bb2b0035c7$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6e0822fd2208b847$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $6e0822fd2208b847$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $6e0822fd2208b847$var$funcProto = Function.prototype, $6e0822fd2208b847$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $6e0822fd2208b847$var$funcToString = $6e0822fd2208b847$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6e0822fd2208b847$var$hasOwnProperty = $6e0822fd2208b847$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $6e0822fd2208b847$var$reIsNative = RegExp('^' + $6e0822fd2208b847$var$funcToString.call($6e0822fd2208b847$var$hasOwnProperty).replace($6e0822fd2208b847$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $6e0822fd2208b847$var$baseIsNative(value) {
    if (!$bf7b23ae406572e5$exports(value) || $b9232594bfaabeeb$exports(value)) return false;
    var pattern = $ed2327a9dc7966cd$exports(value) ? $6e0822fd2208b847$var$reIsNative : $6e0822fd2208b847$var$reIsHostCtor;
    return pattern.test($347c66bb2b0035c7$exports(value));
}
$6e0822fd2208b847$exports = $6e0822fd2208b847$var$baseIsNative;


var $768cd676b912af67$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $768cd676b912af67$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$768cd676b912af67$exports = $768cd676b912af67$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $050b290091bba370$var$getNative(object, key) {
    var value = $768cd676b912af67$exports(object, key);
    return $6e0822fd2208b847$exports(value) ? value : undefined;
}
$050b290091bba370$exports = $050b290091bba370$var$getNative;



var $5wFbo = parcelRequire("5wFbo");
/* Built-in method references that are verified to be native. */ var $b22b059dc602d9e8$var$Map = $050b290091bba370$exports($5wFbo, 'Map');
$b22b059dc602d9e8$exports = $b22b059dc602d9e8$var$Map;


var $a9db9cf5cc49ec33$exports = {};
var $a054b98124566184$exports = {};
var $bb19a27d7123bc4e$exports = {};
var $3e95ae6809ae0ebf$exports = {};
var $a68674c20b2c13c8$exports = {};

/* Built-in method references that are verified to be native. */ var $a68674c20b2c13c8$var$nativeCreate = $050b290091bba370$exports(Object, 'create');
$a68674c20b2c13c8$exports = $a68674c20b2c13c8$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3e95ae6809ae0ebf$var$hashClear() {
    this.__data__ = $a68674c20b2c13c8$exports ? $a68674c20b2c13c8$exports(null) : {};
    this.size = 0;
}
$3e95ae6809ae0ebf$exports = $3e95ae6809ae0ebf$var$hashClear;


var $817192c883b25407$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $817192c883b25407$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$817192c883b25407$exports = $817192c883b25407$var$hashDelete;


var $877d5cbef1525bc3$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $877d5cbef1525bc3$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $877d5cbef1525bc3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $877d5cbef1525bc3$var$hasOwnProperty = $877d5cbef1525bc3$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $877d5cbef1525bc3$var$hashGet(key) {
    var data = this.__data__;
    if ($a68674c20b2c13c8$exports) {
        var result = data[key];
        return result === $877d5cbef1525bc3$var$HASH_UNDEFINED ? undefined : result;
    }
    return $877d5cbef1525bc3$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$877d5cbef1525bc3$exports = $877d5cbef1525bc3$var$hashGet;


var $209a2b29cd491c78$exports = {};

/** Used for built-in method references. */ var $209a2b29cd491c78$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $209a2b29cd491c78$var$hasOwnProperty = $209a2b29cd491c78$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $209a2b29cd491c78$var$hashHas(key) {
    var data = this.__data__;
    return $a68674c20b2c13c8$exports ? data[key] !== undefined : $209a2b29cd491c78$var$hasOwnProperty.call(data, key);
}
$209a2b29cd491c78$exports = $209a2b29cd491c78$var$hashHas;


var $c8584b35e4e02d66$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $c8584b35e4e02d66$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c8584b35e4e02d66$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $a68674c20b2c13c8$exports && value === undefined ? $c8584b35e4e02d66$var$HASH_UNDEFINED : value;
    return this;
}
$c8584b35e4e02d66$exports = $c8584b35e4e02d66$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bb19a27d7123bc4e$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$bb19a27d7123bc4e$var$Hash.prototype.clear = $3e95ae6809ae0ebf$exports;
$bb19a27d7123bc4e$var$Hash.prototype['delete'] = $817192c883b25407$exports;
$bb19a27d7123bc4e$var$Hash.prototype.get = $877d5cbef1525bc3$exports;
$bb19a27d7123bc4e$var$Hash.prototype.has = $209a2b29cd491c78$exports;
$bb19a27d7123bc4e$var$Hash.prototype.set = $c8584b35e4e02d66$exports;
$bb19a27d7123bc4e$exports = $bb19a27d7123bc4e$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $a054b98124566184$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $bb19a27d7123bc4e$exports,
        'map': new ($b22b059dc602d9e8$exports || $42322044bbbf4898$exports),
        'string': new $bb19a27d7123bc4e$exports
    };
}
$a054b98124566184$exports = $a054b98124566184$var$mapCacheClear;


var $40169d53c4d4f4df$exports = {};
var $c552b370355e6352$exports = {};
var $1f151da2f14e8c49$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $1f151da2f14e8c49$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$1f151da2f14e8c49$exports = $1f151da2f14e8c49$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c552b370355e6352$var$getMapData(map, key) {
    var data = map.__data__;
    return $1f151da2f14e8c49$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c552b370355e6352$exports = $c552b370355e6352$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $40169d53c4d4f4df$var$mapCacheDelete(key) {
    var result = $c552b370355e6352$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$40169d53c4d4f4df$exports = $40169d53c4d4f4df$var$mapCacheDelete;


var $6a959e866f7b3ab4$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6a959e866f7b3ab4$var$mapCacheGet(key) {
    return $c552b370355e6352$exports(this, key).get(key);
}
$6a959e866f7b3ab4$exports = $6a959e866f7b3ab4$var$mapCacheGet;


var $1103a6e5988c4f81$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1103a6e5988c4f81$var$mapCacheHas(key) {
    return $c552b370355e6352$exports(this, key).has(key);
}
$1103a6e5988c4f81$exports = $1103a6e5988c4f81$var$mapCacheHas;


var $94898196f77dcb56$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $94898196f77dcb56$var$mapCacheSet(key, value) {
    var data = $c552b370355e6352$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$94898196f77dcb56$exports = $94898196f77dcb56$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a9db9cf5cc49ec33$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a9db9cf5cc49ec33$var$MapCache.prototype.clear = $a054b98124566184$exports;
$a9db9cf5cc49ec33$var$MapCache.prototype['delete'] = $40169d53c4d4f4df$exports;
$a9db9cf5cc49ec33$var$MapCache.prototype.get = $6a959e866f7b3ab4$exports;
$a9db9cf5cc49ec33$var$MapCache.prototype.has = $1103a6e5988c4f81$exports;
$a9db9cf5cc49ec33$var$MapCache.prototype.set = $94898196f77dcb56$exports;
$a9db9cf5cc49ec33$exports = $a9db9cf5cc49ec33$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $d295afe762a4af6b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d295afe762a4af6b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $42322044bbbf4898$exports) {
        var pairs = data.__data__;
        if (!$b22b059dc602d9e8$exports || pairs.length < $d295afe762a4af6b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $a9db9cf5cc49ec33$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$d295afe762a4af6b$exports = $d295afe762a4af6b$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9e076c4f099a76a7$var$Stack(entries) {
    var data = this.__data__ = new $42322044bbbf4898$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$9e076c4f099a76a7$var$Stack.prototype.clear = $467155a9857a8057$exports;
$9e076c4f099a76a7$var$Stack.prototype['delete'] = $87103be02892d694$exports;
$9e076c4f099a76a7$var$Stack.prototype.get = $1e13032d54f66cff$exports;
$9e076c4f099a76a7$var$Stack.prototype.has = $dd46f498759d4de8$exports;
$9e076c4f099a76a7$var$Stack.prototype.set = $d295afe762a4af6b$exports;
$9e076c4f099a76a7$exports = $9e076c4f099a76a7$var$Stack;


var $2c06d558d1290ecd$exports = {};
var $2430113ad1f13a05$exports = {};

var $306e27363fa515fa$exports = {};
var $0d76dbfd081f3fae$exports = {};

var $220e56d94202797c$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $220e56d94202797c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $220e56d94202797c$var$setCacheAdd(value) {
    this.__data__.set(value, $220e56d94202797c$var$HASH_UNDEFINED);
    return this;
}
$220e56d94202797c$exports = $220e56d94202797c$var$setCacheAdd;


var $011e6bff76f30281$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $011e6bff76f30281$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$011e6bff76f30281$exports = $011e6bff76f30281$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $0d76dbfd081f3fae$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $a9db9cf5cc49ec33$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$0d76dbfd081f3fae$var$SetCache.prototype.add = $0d76dbfd081f3fae$var$SetCache.prototype.push = $220e56d94202797c$exports;
$0d76dbfd081f3fae$var$SetCache.prototype.has = $011e6bff76f30281$exports;
$0d76dbfd081f3fae$exports = $0d76dbfd081f3fae$var$SetCache;


var $e1b165463ee76697$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $e1b165463ee76697$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$e1b165463ee76697$exports = $e1b165463ee76697$var$arraySome;


var $97b21191650bf4c3$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $97b21191650bf4c3$var$cacheHas(cache, key) {
    return cache.has(key);
}
$97b21191650bf4c3$exports = $97b21191650bf4c3$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $306e27363fa515fa$var$COMPARE_PARTIAL_FLAG = 1, $306e27363fa515fa$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $306e27363fa515fa$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $306e27363fa515fa$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $306e27363fa515fa$var$COMPARE_UNORDERED_FLAG ? new $0d76dbfd081f3fae$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$e1b165463ee76697$exports(other, function(othValue, othIndex) {
                if (!$97b21191650bf4c3$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$306e27363fa515fa$exports = $306e27363fa515fa$var$equalArrays;


var $b685e92e07591e0c$exports = {};

var $d42530eef3f0bd0c$exports = {};

var $5wFbo = parcelRequire("5wFbo");
/** Built-in value references. */ var $d42530eef3f0bd0c$var$Uint8Array = $5wFbo.Uint8Array;
$d42530eef3f0bd0c$exports = $d42530eef3f0bd0c$var$Uint8Array;




var $34e2688d3debcb2a$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $34e2688d3debcb2a$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$34e2688d3debcb2a$exports = $34e2688d3debcb2a$var$mapToArray;


var $933f3d0047d7d014$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $933f3d0047d7d014$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$933f3d0047d7d014$exports = $933f3d0047d7d014$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $b685e92e07591e0c$var$COMPARE_PARTIAL_FLAG = 1, $b685e92e07591e0c$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $b685e92e07591e0c$var$boolTag = '[object Boolean]', $b685e92e07591e0c$var$dateTag = '[object Date]', $b685e92e07591e0c$var$errorTag = '[object Error]', $b685e92e07591e0c$var$mapTag = '[object Map]', $b685e92e07591e0c$var$numberTag = '[object Number]', $b685e92e07591e0c$var$regexpTag = '[object RegExp]', $b685e92e07591e0c$var$setTag = '[object Set]', $b685e92e07591e0c$var$stringTag = '[object String]', $b685e92e07591e0c$var$symbolTag = '[object Symbol]';
var $b685e92e07591e0c$var$arrayBufferTag = '[object ArrayBuffer]', $b685e92e07591e0c$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $b685e92e07591e0c$var$symbolProto = $a5e751c5a48e6fb1$exports ? $a5e751c5a48e6fb1$exports.prototype : undefined, $b685e92e07591e0c$var$symbolValueOf = $b685e92e07591e0c$var$symbolProto ? $b685e92e07591e0c$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b685e92e07591e0c$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $b685e92e07591e0c$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $b685e92e07591e0c$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $d42530eef3f0bd0c$exports(object), new $d42530eef3f0bd0c$exports(other))) return false;
            return true;
        case $b685e92e07591e0c$var$boolTag:
        case $b685e92e07591e0c$var$dateTag:
        case $b685e92e07591e0c$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $4ccffa0477315322$exports(+object, +other);
        case $b685e92e07591e0c$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $b685e92e07591e0c$var$regexpTag:
        case $b685e92e07591e0c$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $b685e92e07591e0c$var$mapTag:
            var convert = $34e2688d3debcb2a$exports;
        case $b685e92e07591e0c$var$setTag:
            var isPartial = bitmask & $b685e92e07591e0c$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $933f3d0047d7d014$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $b685e92e07591e0c$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $306e27363fa515fa$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $b685e92e07591e0c$var$symbolTag:
            if ($b685e92e07591e0c$var$symbolValueOf) return $b685e92e07591e0c$var$symbolValueOf.call(object) == $b685e92e07591e0c$var$symbolValueOf.call(other);
    }
    return false;
}
$b685e92e07591e0c$exports = $b685e92e07591e0c$var$equalByTag;


var $a8fcab3fb9d05d35$exports = {};
var $cc20c3c529f33407$exports = {};
var $ebc91822bd2b73c8$exports = {};
var $a78674d0cd13d401$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $a78674d0cd13d401$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$a78674d0cd13d401$exports = $a78674d0cd13d401$var$arrayPush;


var $f7463dbc77cf4722$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $f7463dbc77cf4722$var$isArray = Array.isArray;
$f7463dbc77cf4722$exports = $f7463dbc77cf4722$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ebc91822bd2b73c8$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $f7463dbc77cf4722$exports(object) ? result : $a78674d0cd13d401$exports(result, symbolsFunc(object));
}
$ebc91822bd2b73c8$exports = $ebc91822bd2b73c8$var$baseGetAllKeys;


var $5a3fc5e9a94f6274$exports = {};
var $f335b5fe19b2e7ec$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $f335b5fe19b2e7ec$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$f335b5fe19b2e7ec$exports = $f335b5fe19b2e7ec$var$arrayFilter;


var $9e1e457464873c58$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $9e1e457464873c58$var$stubArray() {
    return [];
}
$9e1e457464873c58$exports = $9e1e457464873c58$var$stubArray;


/** Used for built-in method references. */ var $5a3fc5e9a94f6274$var$objectProto = Object.prototype;
/** Built-in value references. */ var $5a3fc5e9a94f6274$var$propertyIsEnumerable = $5a3fc5e9a94f6274$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5a3fc5e9a94f6274$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5a3fc5e9a94f6274$var$getSymbols = !$5a3fc5e9a94f6274$var$nativeGetSymbols ? $9e1e457464873c58$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $f335b5fe19b2e7ec$exports($5a3fc5e9a94f6274$var$nativeGetSymbols(object), function(symbol) {
        return $5a3fc5e9a94f6274$var$propertyIsEnumerable.call(object, symbol);
    });
};
$5a3fc5e9a94f6274$exports = $5a3fc5e9a94f6274$var$getSymbols;


var $c13f350ecddacb0c$exports = {};
var $845e771b578e3f50$exports = {};
var $23fd7b379947ea79$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $23fd7b379947ea79$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$23fd7b379947ea79$exports = $23fd7b379947ea79$var$baseTimes;


var $39469abbd59941a5$exports = {};
var $f7b6001edfe85ab6$exports = {};

var $4a4f0e8dbee85a7e$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4a4f0e8dbee85a7e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$4a4f0e8dbee85a7e$exports = $4a4f0e8dbee85a7e$var$isObjectLike;


/** `Object#toString` result references. */ var $f7b6001edfe85ab6$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $f7b6001edfe85ab6$var$baseIsArguments(value) {
    return $4a4f0e8dbee85a7e$exports(value) && $6f100228b69eda33$exports(value) == $f7b6001edfe85ab6$var$argsTag;
}
$f7b6001edfe85ab6$exports = $f7b6001edfe85ab6$var$baseIsArguments;



/** Used for built-in method references. */ var $39469abbd59941a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $39469abbd59941a5$var$hasOwnProperty = $39469abbd59941a5$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $39469abbd59941a5$var$propertyIsEnumerable = $39469abbd59941a5$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $39469abbd59941a5$var$isArguments = $f7b6001edfe85ab6$exports(function() {
    return arguments;
}()) ? $f7b6001edfe85ab6$exports : function(value) {
    return $4a4f0e8dbee85a7e$exports(value) && $39469abbd59941a5$var$hasOwnProperty.call(value, 'callee') && !$39469abbd59941a5$var$propertyIsEnumerable.call(value, 'callee');
};
$39469abbd59941a5$exports = $39469abbd59941a5$var$isArguments;




var $laUMG = parcelRequire("laUMG");
var $964fc6ece1fce4f0$exports = {};
/** Used as references for various `Number` constants. */ var $964fc6ece1fce4f0$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $964fc6ece1fce4f0$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $964fc6ece1fce4f0$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $964fc6ece1fce4f0$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $964fc6ece1fce4f0$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$964fc6ece1fce4f0$exports = $964fc6ece1fce4f0$var$isIndex;


var $eafd2a27f6e262d6$exports = {};
var $e6000a3a4acd2830$exports = {};

var $65e4a3d137ed5813$exports = {};
/** Used as references for various `Number` constants. */ var $65e4a3d137ed5813$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $65e4a3d137ed5813$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $65e4a3d137ed5813$var$MAX_SAFE_INTEGER;
}
$65e4a3d137ed5813$exports = $65e4a3d137ed5813$var$isLength;



/** `Object#toString` result references. */ var $e6000a3a4acd2830$var$argsTag = '[object Arguments]', $e6000a3a4acd2830$var$arrayTag = '[object Array]', $e6000a3a4acd2830$var$boolTag = '[object Boolean]', $e6000a3a4acd2830$var$dateTag = '[object Date]', $e6000a3a4acd2830$var$errorTag = '[object Error]', $e6000a3a4acd2830$var$funcTag = '[object Function]', $e6000a3a4acd2830$var$mapTag = '[object Map]', $e6000a3a4acd2830$var$numberTag = '[object Number]', $e6000a3a4acd2830$var$objectTag = '[object Object]', $e6000a3a4acd2830$var$regexpTag = '[object RegExp]', $e6000a3a4acd2830$var$setTag = '[object Set]', $e6000a3a4acd2830$var$stringTag = '[object String]', $e6000a3a4acd2830$var$weakMapTag = '[object WeakMap]';
var $e6000a3a4acd2830$var$arrayBufferTag = '[object ArrayBuffer]', $e6000a3a4acd2830$var$dataViewTag = '[object DataView]', $e6000a3a4acd2830$var$float32Tag = '[object Float32Array]', $e6000a3a4acd2830$var$float64Tag = '[object Float64Array]', $e6000a3a4acd2830$var$int8Tag = '[object Int8Array]', $e6000a3a4acd2830$var$int16Tag = '[object Int16Array]', $e6000a3a4acd2830$var$int32Tag = '[object Int32Array]', $e6000a3a4acd2830$var$uint8Tag = '[object Uint8Array]', $e6000a3a4acd2830$var$uint8ClampedTag = '[object Uint8ClampedArray]', $e6000a3a4acd2830$var$uint16Tag = '[object Uint16Array]', $e6000a3a4acd2830$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $e6000a3a4acd2830$var$typedArrayTags = {};
$e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$float32Tag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$float64Tag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$int8Tag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$int16Tag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$int32Tag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$uint8Tag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$uint8ClampedTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$uint16Tag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$uint32Tag] = true;
$e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$argsTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$arrayTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$arrayBufferTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$boolTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$dataViewTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$dateTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$errorTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$funcTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$mapTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$numberTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$objectTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$regexpTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$setTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$stringTag] = $e6000a3a4acd2830$var$typedArrayTags[$e6000a3a4acd2830$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $e6000a3a4acd2830$var$baseIsTypedArray(value) {
    return $4a4f0e8dbee85a7e$exports(value) && $65e4a3d137ed5813$exports(value.length) && !!$e6000a3a4acd2830$var$typedArrayTags[$6f100228b69eda33$exports(value)];
}
$e6000a3a4acd2830$exports = $e6000a3a4acd2830$var$baseIsTypedArray;


var $75dd5453b04fc9f3$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $75dd5453b04fc9f3$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$75dd5453b04fc9f3$exports = $75dd5453b04fc9f3$var$baseUnary;



var $7XhJT = parcelRequire("7XhJT");
/* Node.js helper references. */ var $eafd2a27f6e262d6$var$nodeIsTypedArray = $7XhJT && $7XhJT.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $eafd2a27f6e262d6$var$isTypedArray = $eafd2a27f6e262d6$var$nodeIsTypedArray ? $75dd5453b04fc9f3$exports($eafd2a27f6e262d6$var$nodeIsTypedArray) : $e6000a3a4acd2830$exports;
$eafd2a27f6e262d6$exports = $eafd2a27f6e262d6$var$isTypedArray;


/** Used for built-in method references. */ var $845e771b578e3f50$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $845e771b578e3f50$var$hasOwnProperty = $845e771b578e3f50$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $845e771b578e3f50$var$arrayLikeKeys(value, inherited) {
    var isArr = $f7463dbc77cf4722$exports(value), isArg = !isArr && $39469abbd59941a5$exports(value), isBuff = !isArr && !isArg && $laUMG(value), isType = !isArr && !isArg && !isBuff && $eafd2a27f6e262d6$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $23fd7b379947ea79$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $845e771b578e3f50$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $964fc6ece1fce4f0$exports(key, length)))) result.push(key);
    return result;
}
$845e771b578e3f50$exports = $845e771b578e3f50$var$arrayLikeKeys;


var $0e5a0ebcfd3817b4$exports = {};
var $274b0496c7bbc672$exports = {};
/** Used for built-in method references. */ var $274b0496c7bbc672$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $274b0496c7bbc672$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $274b0496c7bbc672$var$objectProto;
    return value === proto;
}
$274b0496c7bbc672$exports = $274b0496c7bbc672$var$isPrototype;


var $36b08e1f658e71da$exports = {};
var $d7d5b8d976a0cabb$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $d7d5b8d976a0cabb$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$d7d5b8d976a0cabb$exports = $d7d5b8d976a0cabb$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $36b08e1f658e71da$var$nativeKeys = $d7d5b8d976a0cabb$exports(Object.keys, Object);
$36b08e1f658e71da$exports = $36b08e1f658e71da$var$nativeKeys;


/** Used for built-in method references. */ var $0e5a0ebcfd3817b4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0e5a0ebcfd3817b4$var$hasOwnProperty = $0e5a0ebcfd3817b4$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0e5a0ebcfd3817b4$var$baseKeys(object) {
    if (!$274b0496c7bbc672$exports(object)) return $36b08e1f658e71da$exports(object);
    var result = [];
    for(var key in Object(object))if ($0e5a0ebcfd3817b4$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$0e5a0ebcfd3817b4$exports = $0e5a0ebcfd3817b4$var$baseKeys;


var $e1ea3190b025ca72$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e1ea3190b025ca72$var$isArrayLike(value) {
    return value != null && $65e4a3d137ed5813$exports(value.length) && !$ed2327a9dc7966cd$exports(value);
}
$e1ea3190b025ca72$exports = $e1ea3190b025ca72$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $c13f350ecddacb0c$var$keys(object) {
    return $e1ea3190b025ca72$exports(object) ? $845e771b578e3f50$exports(object) : $0e5a0ebcfd3817b4$exports(object);
}
$c13f350ecddacb0c$exports = $c13f350ecddacb0c$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cc20c3c529f33407$var$getAllKeys(object) {
    return $ebc91822bd2b73c8$exports(object, $c13f350ecddacb0c$exports, $5a3fc5e9a94f6274$exports);
}
$cc20c3c529f33407$exports = $cc20c3c529f33407$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $a8fcab3fb9d05d35$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $a8fcab3fb9d05d35$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a8fcab3fb9d05d35$var$hasOwnProperty = $a8fcab3fb9d05d35$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a8fcab3fb9d05d35$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a8fcab3fb9d05d35$var$COMPARE_PARTIAL_FLAG, objProps = $cc20c3c529f33407$exports(object), objLength = objProps.length, othProps = $cc20c3c529f33407$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $a8fcab3fb9d05d35$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$a8fcab3fb9d05d35$exports = $a8fcab3fb9d05d35$var$equalObjects;


var $f3d678c1a6308874$exports = {};
var $08b8e1f0b6d08966$exports = {};


var $5wFbo = parcelRequire("5wFbo");
/* Built-in method references that are verified to be native. */ var $08b8e1f0b6d08966$var$DataView = $050b290091bba370$exports($5wFbo, 'DataView');
$08b8e1f0b6d08966$exports = $08b8e1f0b6d08966$var$DataView;



var $f7a9433c7b160cb6$exports = {};


var $5wFbo = parcelRequire("5wFbo");
/* Built-in method references that are verified to be native. */ var $f7a9433c7b160cb6$var$Promise = $050b290091bba370$exports($5wFbo, 'Promise');
$f7a9433c7b160cb6$exports = $f7a9433c7b160cb6$var$Promise;


var $7c3fbd7ff3e7f0b9$exports = {};


var $5wFbo = parcelRequire("5wFbo");
/* Built-in method references that are verified to be native. */ var $7c3fbd7ff3e7f0b9$var$Set = $050b290091bba370$exports($5wFbo, 'Set');
$7c3fbd7ff3e7f0b9$exports = $7c3fbd7ff3e7f0b9$var$Set;


var $fec1818b33939d0f$exports = {};


var $5wFbo = parcelRequire("5wFbo");
/* Built-in method references that are verified to be native. */ var $fec1818b33939d0f$var$WeakMap = $050b290091bba370$exports($5wFbo, 'WeakMap');
$fec1818b33939d0f$exports = $fec1818b33939d0f$var$WeakMap;




/** `Object#toString` result references. */ var $f3d678c1a6308874$var$mapTag = '[object Map]', $f3d678c1a6308874$var$objectTag = '[object Object]', $f3d678c1a6308874$var$promiseTag = '[object Promise]', $f3d678c1a6308874$var$setTag = '[object Set]', $f3d678c1a6308874$var$weakMapTag = '[object WeakMap]';
var $f3d678c1a6308874$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $f3d678c1a6308874$var$dataViewCtorString = $347c66bb2b0035c7$exports($08b8e1f0b6d08966$exports), $f3d678c1a6308874$var$mapCtorString = $347c66bb2b0035c7$exports($b22b059dc602d9e8$exports), $f3d678c1a6308874$var$promiseCtorString = $347c66bb2b0035c7$exports($f7a9433c7b160cb6$exports), $f3d678c1a6308874$var$setCtorString = $347c66bb2b0035c7$exports($7c3fbd7ff3e7f0b9$exports), $f3d678c1a6308874$var$weakMapCtorString = $347c66bb2b0035c7$exports($fec1818b33939d0f$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $f3d678c1a6308874$var$getTag = $6f100228b69eda33$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($08b8e1f0b6d08966$exports && $f3d678c1a6308874$var$getTag(new $08b8e1f0b6d08966$exports(new ArrayBuffer(1))) != $f3d678c1a6308874$var$dataViewTag || $b22b059dc602d9e8$exports && $f3d678c1a6308874$var$getTag(new $b22b059dc602d9e8$exports) != $f3d678c1a6308874$var$mapTag || $f7a9433c7b160cb6$exports && $f3d678c1a6308874$var$getTag($f7a9433c7b160cb6$exports.resolve()) != $f3d678c1a6308874$var$promiseTag || $7c3fbd7ff3e7f0b9$exports && $f3d678c1a6308874$var$getTag(new $7c3fbd7ff3e7f0b9$exports) != $f3d678c1a6308874$var$setTag || $fec1818b33939d0f$exports && $f3d678c1a6308874$var$getTag(new $fec1818b33939d0f$exports) != $f3d678c1a6308874$var$weakMapTag) $f3d678c1a6308874$var$getTag = function(value) {
    var result = $6f100228b69eda33$exports(value), Ctor = result == $f3d678c1a6308874$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $347c66bb2b0035c7$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $f3d678c1a6308874$var$dataViewCtorString:
            return $f3d678c1a6308874$var$dataViewTag;
        case $f3d678c1a6308874$var$mapCtorString:
            return $f3d678c1a6308874$var$mapTag;
        case $f3d678c1a6308874$var$promiseCtorString:
            return $f3d678c1a6308874$var$promiseTag;
        case $f3d678c1a6308874$var$setCtorString:
            return $f3d678c1a6308874$var$setTag;
        case $f3d678c1a6308874$var$weakMapCtorString:
            return $f3d678c1a6308874$var$weakMapTag;
    }
    return result;
};
$f3d678c1a6308874$exports = $f3d678c1a6308874$var$getTag;




var $laUMG = parcelRequire("laUMG");

/** Used to compose bitmasks for value comparisons. */ var $2430113ad1f13a05$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2430113ad1f13a05$var$argsTag = '[object Arguments]', $2430113ad1f13a05$var$arrayTag = '[object Array]', $2430113ad1f13a05$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $2430113ad1f13a05$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2430113ad1f13a05$var$hasOwnProperty = $2430113ad1f13a05$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2430113ad1f13a05$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $f7463dbc77cf4722$exports(object), othIsArr = $f7463dbc77cf4722$exports(other), objTag = objIsArr ? $2430113ad1f13a05$var$arrayTag : $f3d678c1a6308874$exports(object), othTag = othIsArr ? $2430113ad1f13a05$var$arrayTag : $f3d678c1a6308874$exports(other);
    objTag = objTag == $2430113ad1f13a05$var$argsTag ? $2430113ad1f13a05$var$objectTag : objTag;
    othTag = othTag == $2430113ad1f13a05$var$argsTag ? $2430113ad1f13a05$var$objectTag : othTag;
    var objIsObj = objTag == $2430113ad1f13a05$var$objectTag, othIsObj = othTag == $2430113ad1f13a05$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $laUMG(object)) {
        if (!$laUMG(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $9e076c4f099a76a7$exports);
        return objIsArr || $eafd2a27f6e262d6$exports(object) ? $306e27363fa515fa$exports(object, other, bitmask, customizer, equalFunc, stack) : $b685e92e07591e0c$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2430113ad1f13a05$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2430113ad1f13a05$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $2430113ad1f13a05$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $9e076c4f099a76a7$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $9e076c4f099a76a7$exports);
    return $a8fcab3fb9d05d35$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$2430113ad1f13a05$exports = $2430113ad1f13a05$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $2c06d558d1290ecd$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$4a4f0e8dbee85a7e$exports(value) && !$4a4f0e8dbee85a7e$exports(other)) return value !== value && other !== other;
    return $2430113ad1f13a05$exports(value, other, bitmask, customizer, $2c06d558d1290ecd$var$baseIsEqual, stack);
}
$2c06d558d1290ecd$exports = $2c06d558d1290ecd$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $68aa251488aa1603$var$COMPARE_PARTIAL_FLAG = 1, $68aa251488aa1603$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $68aa251488aa1603$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $9e076c4f099a76a7$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $2c06d558d1290ecd$exports(srcValue, objValue, $68aa251488aa1603$var$COMPARE_PARTIAL_FLAG | $68aa251488aa1603$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$68aa251488aa1603$exports = $68aa251488aa1603$var$baseIsMatch;


var $419b816fda2058e2$exports = {};
var $e3721afb30d1953a$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $e3721afb30d1953a$var$isStrictComparable(value) {
    return value === value && !$bf7b23ae406572e5$exports(value);
}
$e3721afb30d1953a$exports = $e3721afb30d1953a$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $419b816fda2058e2$var$getMatchData(object) {
    var result = $c13f350ecddacb0c$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $e3721afb30d1953a$exports(value)
        ];
    }
    return result;
}
$419b816fda2058e2$exports = $419b816fda2058e2$var$getMatchData;


var $1432e185ddbb00e1$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1432e185ddbb00e1$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1432e185ddbb00e1$exports = $1432e185ddbb00e1$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $98d3e9752cee3072$var$baseMatches(source) {
    var matchData = $419b816fda2058e2$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1432e185ddbb00e1$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $68aa251488aa1603$exports(object, source, matchData);
    };
}
$98d3e9752cee3072$exports = $98d3e9752cee3072$var$baseMatches;


var $ec36592106951175$exports = {};

var $7e9cadee8ce81f52$exports = {};
var $f8a171ab8c37ee14$exports = {};
var $1c46753beea0ed15$exports = {};

var $bece6a92790ac22a$exports = {};

var $2190937dc50df275$exports = {};


/** `Object#toString` result references. */ var $2190937dc50df275$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2190937dc50df275$var$isSymbol(value) {
    return typeof value == 'symbol' || $4a4f0e8dbee85a7e$exports(value) && $6f100228b69eda33$exports(value) == $2190937dc50df275$var$symbolTag;
}
$2190937dc50df275$exports = $2190937dc50df275$var$isSymbol;


/** Used to match property names within property paths. */ var $bece6a92790ac22a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $bece6a92790ac22a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $bece6a92790ac22a$var$isKey(value, object) {
    if ($f7463dbc77cf4722$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $2190937dc50df275$exports(value)) return true;
    return $bece6a92790ac22a$var$reIsPlainProp.test(value) || !$bece6a92790ac22a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$bece6a92790ac22a$exports = $bece6a92790ac22a$var$isKey;


var $75e91eee60c00cf2$exports = {};
var $f5053c5a61c16b83$exports = {};
var $a19f72450a9e03a9$exports = {};

/** Error message constants. */ var $a19f72450a9e03a9$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a19f72450a9e03a9$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($a19f72450a9e03a9$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a19f72450a9e03a9$var$memoize.Cache || $a9db9cf5cc49ec33$exports);
    return memoized;
}
// Expose `MapCache`.
$a19f72450a9e03a9$var$memoize.Cache = $a9db9cf5cc49ec33$exports;
$a19f72450a9e03a9$exports = $a19f72450a9e03a9$var$memoize;


/** Used as the maximum memoize cache size. */ var $f5053c5a61c16b83$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $f5053c5a61c16b83$var$memoizeCapped(func) {
    var result = $a19f72450a9e03a9$exports(func, function(key) {
        if (cache.size === $f5053c5a61c16b83$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$f5053c5a61c16b83$exports = $f5053c5a61c16b83$var$memoizeCapped;


/** Used to match property names within property paths. */ var $75e91eee60c00cf2$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $75e91eee60c00cf2$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $75e91eee60c00cf2$var$stringToPath = $f5053c5a61c16b83$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($75e91eee60c00cf2$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($75e91eee60c00cf2$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$75e91eee60c00cf2$exports = $75e91eee60c00cf2$var$stringToPath;


var $9483e1bbc9cde17c$exports = {};
var $dd0a7e921eff46ca$exports = {};

var $7da3b9b0e02d149e$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7da3b9b0e02d149e$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$7da3b9b0e02d149e$exports = $7da3b9b0e02d149e$var$arrayMap;




/** Used as references for various `Number` constants. */ var $dd0a7e921eff46ca$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $dd0a7e921eff46ca$var$symbolProto = $a5e751c5a48e6fb1$exports ? $a5e751c5a48e6fb1$exports.prototype : undefined, $dd0a7e921eff46ca$var$symbolToString = $dd0a7e921eff46ca$var$symbolProto ? $dd0a7e921eff46ca$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $dd0a7e921eff46ca$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($f7463dbc77cf4722$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $7da3b9b0e02d149e$exports(value, $dd0a7e921eff46ca$var$baseToString) + '';
    if ($2190937dc50df275$exports(value)) return $dd0a7e921eff46ca$var$symbolToString ? $dd0a7e921eff46ca$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$dd0a7e921eff46ca$var$INFINITY ? '-0' : result;
}
$dd0a7e921eff46ca$exports = $dd0a7e921eff46ca$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $9483e1bbc9cde17c$var$toString(value) {
    return value == null ? '' : $dd0a7e921eff46ca$exports(value);
}
$9483e1bbc9cde17c$exports = $9483e1bbc9cde17c$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $1c46753beea0ed15$var$castPath(value, object) {
    if ($f7463dbc77cf4722$exports(value)) return value;
    return $bece6a92790ac22a$exports(value, object) ? [
        value
    ] : $75e91eee60c00cf2$exports($9483e1bbc9cde17c$exports(value));
}
$1c46753beea0ed15$exports = $1c46753beea0ed15$var$castPath;


var $f0fb60160d7b268f$exports = {};

/** Used as references for various `Number` constants. */ var $f0fb60160d7b268f$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $f0fb60160d7b268f$var$toKey(value) {
    if (typeof value == 'string' || $2190937dc50df275$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$f0fb60160d7b268f$var$INFINITY ? '-0' : result;
}
$f0fb60160d7b268f$exports = $f0fb60160d7b268f$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $f8a171ab8c37ee14$var$baseGet(object, path) {
    path = $1c46753beea0ed15$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$f0fb60160d7b268f$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$f8a171ab8c37ee14$exports = $f8a171ab8c37ee14$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $7e9cadee8ce81f52$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $f8a171ab8c37ee14$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$7e9cadee8ce81f52$exports = $7e9cadee8ce81f52$var$get;


var $8f200ffb5fa530cf$exports = {};
var $cd8249235f787459$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $cd8249235f787459$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$cd8249235f787459$exports = $cd8249235f787459$var$baseHasIn;


var $bd290d67af99202a$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $bd290d67af99202a$var$hasPath(object, path, hasFunc) {
    path = $1c46753beea0ed15$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $f0fb60160d7b268f$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $65e4a3d137ed5813$exports(length) && $964fc6ece1fce4f0$exports(key, length) && ($f7463dbc77cf4722$exports(object) || $39469abbd59941a5$exports(object));
}
$bd290d67af99202a$exports = $bd290d67af99202a$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $8f200ffb5fa530cf$var$hasIn(object, path) {
    return object != null && $bd290d67af99202a$exports(object, path, $cd8249235f787459$exports);
}
$8f200ffb5fa530cf$exports = $8f200ffb5fa530cf$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $ec36592106951175$var$COMPARE_PARTIAL_FLAG = 1, $ec36592106951175$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ec36592106951175$var$baseMatchesProperty(path, srcValue) {
    if ($bece6a92790ac22a$exports(path) && $e3721afb30d1953a$exports(srcValue)) return $1432e185ddbb00e1$exports($f0fb60160d7b268f$exports(path), srcValue);
    return function(object) {
        var objValue = $7e9cadee8ce81f52$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $8f200ffb5fa530cf$exports(object, path) : $2c06d558d1290ecd$exports(srcValue, objValue, $ec36592106951175$var$COMPARE_PARTIAL_FLAG | $ec36592106951175$var$COMPARE_UNORDERED_FLAG);
    };
}
$ec36592106951175$exports = $ec36592106951175$var$baseMatchesProperty;


var $1f65ff87e6363a01$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $1f65ff87e6363a01$var$identity(value) {
    return value;
}
$1f65ff87e6363a01$exports = $1f65ff87e6363a01$var$identity;



var $a126f409d35044aa$exports = {};
var $dc9c32bf545c579a$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $dc9c32bf545c579a$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$dc9c32bf545c579a$exports = $dc9c32bf545c579a$var$baseProperty;


var $553c407500dda938$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $553c407500dda938$var$basePropertyDeep(path) {
    return function(object) {
        return $f8a171ab8c37ee14$exports(object, path);
    };
}
$553c407500dda938$exports = $553c407500dda938$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $a126f409d35044aa$var$property(path) {
    return $bece6a92790ac22a$exports(path) ? $dc9c32bf545c579a$exports($f0fb60160d7b268f$exports(path)) : $553c407500dda938$exports(path);
}
$a126f409d35044aa$exports = $a126f409d35044aa$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $c2bfe06b6383bbdf$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $1f65ff87e6363a01$exports;
    if (typeof value == 'object') return $f7463dbc77cf4722$exports(value) ? $ec36592106951175$exports(value[0], value[1]) : $98d3e9752cee3072$exports(value);
    return $a126f409d35044aa$exports(value);
}
$c2bfe06b6383bbdf$exports = $c2bfe06b6383bbdf$var$baseIteratee;


var $3c914656529445a1$exports = {};

/** Used as references for the maximum length and index of an array. */ var $3c914656529445a1$var$MAX_ARRAY_LENGTH = 4294967295, $3c914656529445a1$var$MAX_ARRAY_INDEX = $3c914656529445a1$var$MAX_ARRAY_LENGTH - 1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3c914656529445a1$var$nativeFloor = Math.floor, $3c914656529445a1$var$nativeMin = Math.min;
/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function $3c914656529445a1$var$baseSortedIndexBy(array, value, iteratee, retHighest) {
    var low = 0, high = array == null ? 0 : array.length;
    if (high === 0) return 0;
    value = iteratee(value);
    var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = $2190937dc50df275$exports(value), valIsUndefined = value === undefined;
    while(low < high){
        var mid = $3c914656529445a1$var$nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = $2190937dc50df275$exports(computed);
        if (valIsNaN) var setLow = retHighest || othIsReflexive;
        else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
        else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        else if (othIsNull || othIsSymbol) setLow = false;
        else setLow = retHighest ? computed <= value : computed < value;
        if (setLow) low = mid + 1;
        else high = mid;
    }
    return $3c914656529445a1$var$nativeMin(high, $3c914656529445a1$var$MAX_ARRAY_INDEX);
}
$3c914656529445a1$exports = $3c914656529445a1$var$baseSortedIndexBy;


/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */ function $658434408754ac61$var$sortedIndexBy(array, value, iteratee) {
    return $3c914656529445a1$exports(array, value, $c2bfe06b6383bbdf$exports(iteratee, 2));
}
$658434408754ac61$exports = $658434408754ac61$var$sortedIndexBy;


function $be8f6f33925d422b$export$a2d8f355a4dba7ae(errorMessage) {
    throw new Error(errorMessage);
}
function $be8f6f33925d422b$export$f06b772ecb3051c2(haystack, needle, iteratee) {
    // Use a binary search to determine the lowest index at which the needle should be inserted into the haystack in order to maintain its sort order.
    const insertionIndex = (0, (/*@__PURE__*/$parcel$interopDefault($658434408754ac61$exports)))(haystack, needle, iteratee);
    // There is no match found if the needle is greater than all haystack items
    // If the needle is equal to the last item, the index returned would have inserted it BEFORE the last item, not after it
    if (insertionIndex === haystack.length) return undefined;
    // If there is a match then the value at the insertion index will match the needle
    const potentialMatch = haystack[insertionIndex];
    return iteratee(potentialMatch) === iteratee(needle) ? potentialMatch : undefined;
}
function $be8f6f33925d422b$export$8894120faf2e049d(url) {
    // Parse the URL if a plain string was provided
    if (typeof url === "string") try {
        url = new URL(url);
    } catch  {
        return null;
    }
    // Only support http and https protocols
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    // Now that the protocol is validated, we just use the host and path for matching
    const hostAndPath = url.host + url.pathname;
    // 1. /file/d/<id>
    let match = /^drive\.google\.com\/file\/d\/([a-z0-9_-]+)/i.exec(hostAndPath);
    if (match) return match[1];
    // 2. /open?id=<id> (with possible extra params)
    if (hostAndPath.startsWith("drive.google.com/open")) {
        const id = url.searchParams.get("id");
        if (id && /^[a-z0-9_-]+$/i.test(id)) return id;
    }
    // 3. /uc?id=<id> (with possible extra params)
    if (hostAndPath.startsWith("drive.google.com/uc")) {
        const id = url.searchParams.get("id");
        if (id && /^[A-Za-z0-9_-]+$/.test(id)) return id;
    }
    // 4. docs.google.com/(document|spreadsheets|presentation|drawings)/d/<id>
    match = /^docs\.google\.com\/(document|spreadsheets|presentation|drawings)(\/u\/\d)?\/d\/([a-z0-9_-]+)/i.exec(hostAndPath);
    if (match) return match[3];
    return null;
}


const $bbe62af273f211ec$export$d6aa9e298ea80f68 = /*#__PURE__*/ (0, $itHdT.createContext)(undefined);
const $bbe62af273f211ec$export$16086139eda1cc92 = ({ children: children })=>{
    // Use state to track the set of query results registered with the context
    const [queryResults, setQueryResults] = (0, $itHdT.useState)({});
    // Keep internal count state in a ref so that it doesn't trigger any re-rendering
    // We only update React state when a query is actually added or removed (transition 0->1 or 1->0).
    const queryCountsRef = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useRef({});
    const registerQuery = (0, $itHdT.useCallback)((hashedQueryKey, queryResult)=>{
        // Increment the count
        const newCount = queryCountsRef.current[hashedQueryKey] = (queryCountsRef.current[hashedQueryKey] ?? 0) + 1;
        // Only add to queryResults when the first registration occurs.
        if (newCount === 1) setQueryResults((prev)=>({
                ...prev,
                [hashedQueryKey]: queryResult
            }));
    }, []);
    const unregisterQuery = (0, $itHdT.useCallback)((hashedQueryKey)=>{
        // Get the previous count
        const prevCount = queryCountsRef.current[hashedQueryKey];
        if (!prevCount) (0, $be8f6f33925d422b$export$a2d8f355a4dba7ae)("`unregisterQuery` was called with a key that was not registered: " + hashedQueryKey);
        // Decrement the count
        const newCount = queryCountsRef.current[hashedQueryKey] = prevCount - 1;
        // Last unregister — remove from results state
        if (!newCount) setQueryResults((prev)=>{
            if (!(hashedQueryKey in prev)) return prev;
            const next = {
                ...prev
            };
            delete next[hashedQueryKey]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
            return next;
        });
    }, []);
    const getQueries = (0, $itHdT.useCallback)(()=>Object.values(queryResults), [
        queryResults
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useMemo(()=>({
            registerQuery: registerQuery,
            unregisterQuery: unregisterQuery,
            getQueries: getQueries
        }), [
        registerQuery,
        unregisterQuery,
        getQueries
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($bbe62af273f211ec$export$d6aa9e298ea80f68.Provider, {
        value: contextValue,
        children: children
    });
};



function $615d4ef8039d571e$export$53a0372a68eb74f7() {
    const context = (0, $itHdT.useContext)((0, $bbe62af273f211ec$export$d6aa9e298ea80f68)) ?? (0, $be8f6f33925d422b$export$a2d8f355a4dba7ae)("useTrackedQueries must be used within a QueryTrackingProvider");
    return context.getQueries();
}






/**
 * This class exposes the `requestAccessToken` method that can be used to initiate the authorization flow with Google.
 *
 * A new access token is requested from Google by triggering a UX flow from the "Google 3P Authorization" library
 * with the 'code model'. See the following references for more information:
 *
 * - https://developers.google.com/identity/oauth2/web/reference/js-reference
 * - https://developers.google.com/identity/oauth2/web/guides/use-code-model
 *
 * Once the user has authorized the application, a code is returned to the callback function, which is then sent to the
 * Supabase Edge Function `api/auth/code-exchange` to exchange it for an access token and refresh token with the requested
 * scopes.
 *
 * The access token is stored on the server and never returned to the client. As such, all calls to Google APIs are
 * performed on the server using Supabase Edge Functions.
 *
 * NOTE: The token retrieved by this class is an 'authorization' token, which is different than the 'authentication' JWT
 * returned by the Google sign in button and one-tap sign in flow. The authentication JWT retrieved by the Google sign
 * in button is used to authenticate and log in with Supabase, but cannot be used to call any Google APIs due to the lack
 * of any scopes attached to it. The Google authorization token requested here can be requested on-demand after sign in,
 * and can be used to call Google APIs by the back-end according to the scopes specified in the constructor.
 */ class $2b6f63e7a3bd75b9$var$GoogleAuthorizationService {
    requiredScopes;
    codeClient;
    accessTokenPromise;
    resolve;
    reject;
    constructor(requiredScopes){
        this.requiredScopes = requiredScopes;
        this.codeClient = null;
        this.accessTokenPromise = null;
        this.resolve = null;
        this.reject = null;
    }
    /**
   * Initiates the process authorize the current user. No tokens are returned directly from this method; A successful
   * return of this method indicates that the user has authorized the application and the access/refresh tokens are now
   * stored on the server.
   */ async authorizeCurrentUser() {
        // Wait for the result of an existing token request to complete, if any, to prevent concurrent requests
        if (this.accessTokenPromise) await this.accessTokenPromise;
        // Create the code client if it does not exist yet
        if (!this.codeClient) {
            // Get the current user's email address from the Supabase session that was created during authentication
            // This will allow the user to skip the user selection screen for this authorization step
            const session = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).auth.getSession();
            const login_hint = session.data.session?.user.email;
            this.codeClient = google.accounts.oauth2.initCodeClient({
                client_id: "394344920652-bpumsd57c1858u49crjs11domjpfdo2h.apps.googleusercontent.com",
                scope: [
                    ...this.requiredScopes
                ].join(" "),
                ux_mode: "popup",
                login_hint: login_hint,
                callback: this.tokenCallback.bind(this),
                error_callback: this.tokenCallback.bind(this)
            });
        }
        // Create a new promise that will be resolved when the token request completes
        this.accessTokenPromise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        try {
            // Start a new token request and wait for the result
            this.codeClient.requestCode();
            await this.accessTokenPromise;
        } finally{
            // Reset state before exiting returning the result
            this.accessTokenPromise = null;
            this.resolve = null;
            this.reject = null;
        }
    }
    async tokenCallback(tokenResponse) {
        // Throw an error if our state is somehow corrupted and we have no promise to resolve
        // This should never happen because the promise is set when the token request flow is started
        if (!this.resolve || !this.reject) throw new Error("Access token callback was called but there is no promise awaiting it");
        try {
            // Attempt to parse the token response and resolve the promise
            await this.processTokenResponse(tokenResponse);
            this.resolve();
        } catch (cause) {
            // On error, reject the promise
            const error = new Error("An error occurred during Google authorization: " + cause.message, {
                cause: cause
            });
            this.reject(error);
        }
    }
    async processTokenResponse(codeResponse) {
        // Fail if a client-side error occurred during the token request (i.e. error_callback was invoked)
        if (codeResponse instanceof Error) throw codeResponse;
        // Fail if the token request failed
        if (codeResponse.error) {
            console.error("Google authorization failed: ", codeResponse);
            throw new Error(codeResponse.error_description);
        }
        // Fail if the user did not authorize all the requested scopes
        const grantedScopes = new Set(codeResponse.scope.split(" "));
        const missingScopes = [
            ...this.requiredScopes
        ].filter((scope)=>!grantedScopes.has(scope)).join(", ");
        if (missingScopes.length) throw new Error("User did not authorize all requested permissions. Missing scopes: " + missingScopes);
        // Send the code to the server to exchange it for an access token
        // NOTE: For some reason we can't send this request using `supabase.functions.invoke` because it refuses to send a request body
        const tokenResponse = await fetch("https://senti-tools.supabase.co/functions/v1/api/auth/code-exchange", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${(await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).auth.getSession()).data.session.access_token}`,
                "Content-Type": "application/json",
                // Add a custom header to trigger CORS and protect against CSRF (see: https://stackoverflow.com/a/22533680/1988326)
                "X-Requested-With": "XmlHttpRequest"
            },
            body: JSON.stringify({
                code: codeResponse.code
            })
        });
        // Throw an error if the function invocation failed
        if (!tokenResponse.ok) {
            const responseText = await tokenResponse.text();
            throw new Error(`Google token exchange failed with code ${tokenResponse.status.toFixed()} (${tokenResponse.statusText}): ${responseText}`);
        }
    }
}
var // Export a singleton instance of the GoogleAuthorizationTokenFetcher class with all the scopes required for this application
$2b6f63e7a3bd75b9$export$2e2bcd8739ae039 = new $2b6f63e7a3bd75b9$var$GoogleAuthorizationService(new Set([
    "https://www.googleapis.com/auth/drive.readonly"
]));



async function $c9c26cf183c0c8b8$export$31a67b5db8076ca7(url, options) {
    // Execute the Supabase function
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { error: error, data: data } = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).functions.invoke(url, {
        method: "GET",
        ...options
    });
    // If function executed without error, return the data
    if (!error) return data;
    // We only handle http response code errors here; any other errors can be thrown directly
    if (!(error instanceof (0, $59d8dd94fc2bfa1e$export$761f8c0e0fa4624f))) throw error;
    // Try to extract and log the request id from the 'x-request-id' header
    const response = error.context;
    const requestId = response.headers.get("x-request-id");
    if (requestId) console.warn(`An error occurred in Supabase edge function with request id ${requestId}`);
    // Only handle JSON error responses
    const contentType = response.headers.get("content-type");
    if (!contentType?.includes("application/json")) throw error;
    const errorData = await response.json();
    // For Google auth errors, trigger the UX flow to fetch a new auth token, then retry the request
    if (response.status === 401 && errorData && typeof errorData === "object" && "error" in errorData && errorData.error === "google_auth_required") {
        console.info("Google authorization required. Starting new token request");
        await (0, $2b6f63e7a3bd75b9$export$2e2bcd8739ae039).authorizeCurrentUser();
        console.info("Google authorization completed successfully. Retrying Supabase edge function request");
        return await $c9c26cf183c0c8b8$export$31a67b5db8076ca7(url, options);
    }
    // Otherwise, we don't know how to handle this error, so re-throw it
    throw error;
}


async function $ccc5551a7c4a0296$export$30882f31a5ec29c0(gasApiMethod, queryParams, body) {
    const response = await (0, $c9c26cf183c0c8b8$export$31a67b5db8076ca7)(`api/gas/long-running/${gasApiMethod}?${new URLSearchParams(queryParams)}`, {
        method: "POST",
        body: body
    });
    return response.requestId;
}
async function $ccc5551a7c4a0296$export$885b55e49ac7cd3a(requestId) {
    const response = await (0, $c9c26cf183c0c8b8$export$31a67b5db8076ca7)(`api/gas/long-running/status/${requestId}`);
    return response.data;
}



class $46b44c46d1c90e99$export$a1f57880b288db0e {
    channelName;
    onError;
    channel;
    constructor(supabase, channelName, /**
     * Callback to execute when an error occurs in a `system` message, or in any of the subscribed event callbacks.
     * By default, errors are logged to the console and reported to Sentry.
     */ onError = (error)=>{
        console.error(`An error occurred in the ${channelName} realtime channel:`, error);
        $479c90d590bd4fd3$exports.captureException(error);
    }){
        this.channelName = channelName;
        this.onError = onError;
        this.channel = supabase.channel(channelName);
        // Add an even listener to log status updates and errors
        this.channel.on("system", {}, (payload)=>{
            if (payload.status === "error") onError(new Error(`Supabase realtime system message error: ${payload.message}`));
            else console.debug(payload);
        });
    }
    getInternalChannel() {
        return this.channel;
    }
    /**
   * Wraps {@link typeof RealtimeChannel.on} with error handling using the `onError` callback provided in this class constructor
   *
   * @param filter - The filter to apply to the Postgres changes event
   * @param callback - The callback to execute when a matched change event occurs. Note that the payload passed to this
   *                   callback will never contain the `errors` property, as this is handled internally by this class.
   */ onPostgresChange(filter, callback) {
        // Add the event listener to the channel, wrapping the callback to handle errors
        this.channel.on(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
        "postgres_changes", filter, (payload)=>{
            try {
                console.debug(`Received realtime update:`, payload);
                // Fail if the payload contains errors
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Type definition from library is wrong
                if (payload.errors?.length) {
                    this.onError(new Error(`Received errors from realtime update: ${JSON.stringify(payload.errors)}`));
                    return;
                } else // Otherwise, execute the provided callback with the payload
                callback(payload);
            } catch (err) {
                this.onError(new Error(`Error processing realtime update: ${err instanceof Error ? err.message : String(err)}`, {
                    cause: err
                }));
            }
        });
        // Return the current instance to allow method chaining
        return this;
    }
    async subscribeAsync() {
        return await new Promise((resolve, reject)=>{
            this.channel.subscribe((status, err)=>{
                if (err) reject(err);
                else {
                    console.debug(`Subscription update for realtime channel '${this.channelName}': ${status}`);
                    resolve(status);
                }
            });
        });
    }
    async [Symbol.asyncDispose]() {
        const result = await this.channel.unsubscribe();
        if (result !== "ok") console.warn(`Failed to unsubscribe from Supabase realtime channel: ${result}`);
    }
}


class $5783fce124489726$export$6d1782eb7b99d11f {
    serverFilter;
    channel;
    eventQueue;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    signalNewEvents;
    constructor(supabase, channelName, serverFilter){
        this.serverFilter = serverFilter;
        this.eventQueue = [];
        this.signalNewEvents = ()=>{};
        console.debug(`Creating Supabase realtime channel for event '${serverFilter.event}':`, serverFilter);
        this.channel = new (0, $46b44c46d1c90e99$export$a1f57880b288db0e)(supabase, channelName, this.enqueueEvent.bind(this));
        // Add an event listener for the specific event type we're interested in and add them to the queue
        this.channel.onPostgresChange(serverFilter, this.enqueueEvent.bind(this));
    }
    enqueueEvent(event) {
        this.eventQueue.push(event);
        this.signalNewEvents();
    }
    async *[Symbol.asyncIterator]() {
        // Attempt to start listening for events
        // NOTE: This will throw an error if the subscription fails, which can be caught by the caller
        await this.channel.subscribeAsync();
        console.debug(`Supabase realtime channel subscribed for event '${this.serverFilter.event}':`, this.serverFilter);
        while(true)if (this.eventQueue.length > 0) {
            // If an error is found in the queue, throw it
            const event = this.eventQueue.shift();
            if (event instanceof Error) throw event;
            // Otherwise, yield the event
            yield event;
        } else // Otherwise, wait until new data arrives.
        await new Promise((resolve)=>{
            this.signalNewEvents = resolve;
        });
    }
    async [Symbol.asyncDispose]() {
        await this.channel[Symbol.asyncDispose]();
    }
}


async function $30e6f8dc1563064d$export$8c83cf1afb7f2c41(reportProgress) {
    await $30e6f8dc1563064d$var$executeLongRunningRequest(reportProgress, "syncAllEntities");
}
async function $30e6f8dc1563064d$export$f4c87bf59542a348(reportProgress, csvText) {
    await $30e6f8dc1563064d$var$executeLongRunningRequest(reportProgress, "uploadBOMSyncData", {}, csvText);
}
async function $30e6f8dc1563064d$export$e965bc5376352402(reportProgress, csvText) {
    await $30e6f8dc1563064d$var$executeLongRunningRequest(reportProgress, "uploadVendorItemCatalogSyncData", {}, csvText);
}
async function $30e6f8dc1563064d$var$executeLongRunningRequest(reportProgress, gasApiMethod, queryParams, body) {
    // Call an edge function to start execution of the long-running request
    console.info(`Starting execution of long-running GAS API method: ${gasApiMethod}`);
    const requestId = await (0, $ccc5551a7c4a0296$export$30882f31a5ec29c0)(gasApiMethod, queryParams, body);
    console.info(`Long-running GAS API method '${gasApiMethod}' started with request ID: ${requestId}`);
    // Get a stream of status updates for the long-running request
    // NOTE: Use a unique channel name based on the request ID so that we don't collide with other request channels
    const eventStream = new (0, $5783fce124489726$export$6d1782eb7b99d11f)((0, $5471293cded6d6a9$export$a0b632a28672d3c0), `LongRunningGasRequest-${requestId}`, {
        event: (0, $7ece6d3d4f0fb361$export$bc171c571098b6c4).UPDATE,
        schema: "public",
        table: "LongRunningGasRequest",
        filter: `id=eq.${requestId}`
    });
    // TODO: Remove this try-catch block once we can switch to the `await using` syntax. This will be available in the
    // Firefox 141 release, on July 22, 2025 (see: https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Releases/141)
    try {
        // Get the initial status of the long-running request
        const { data: initialStatus } = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("LongRunningGasRequest").select("*").eq("id", requestId).single().throwOnError();
        console.info(`Fetched initial status of long-running GAS API method '${gasApiMethod}' (${requestId}):`, initialStatus);
        // Prepend the initial status to the event stream
        const eventStreamWithInitialStatus = async function*() {
            yield initialStatus;
            for await (const payload of eventStream)yield payload.new;
        }();
        // Send a progress update for each event, and break when the request is complete
        for await (const payload of eventStreamWithInitialStatus){
            if (payload.progress) reportProgress(payload.progress);
            if (payload.status === "completed") break;
        }
    } finally{
        await eventStream[Symbol.asyncDispose]();
    }
    // Call an edge function to get the result of the long-running request
    // NOTE: This is necessary rather than just getting the result from the realtime subscription because the API call
    // to fetch the result also makes sure to delete the request information in the database
    const result = await (0, $ccc5551a7c4a0296$export$885b55e49ac7cd3a)(requestId);
    // Throw an error if the request failed
    if (result.status !== "success") {
        const errorDetails = result.data;
        throw new Error(`'${gasApiMethod}' request failed: ${errorDetails.message} -> ${errorDetails.cause}`);
    }
    // Return the result of the long-running request
    return result.data;
}


// src/queryOptions.ts
function $e7c296f6690d0391$export$9a8e3100474fe331(options) {
    return options;
}





const $db95884f00cbfd06$var$syncMetadataQuery = (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("SyncMetadata").select("*").order("lastUpdated", {
    ascending: true
}).throwOnError();
const $db95884f00cbfd06$export$bf1bd58dc6eb2c9b = (0, $e7c296f6690d0391$export$9a8e3100474fe331)({
    queryKey: [
        "SyncMetadata",
        "all"
    ],
    queryFn: async ()=>(await $db95884f00cbfd06$var$syncMetadataQuery).data,
    select: (data)=>data.map(({ lastUpdated: lastUpdated, ...record })=>({
                ...record,
                lastUpdated: new Date(lastUpdated)
            }))
});
const $db95884f00cbfd06$export$dc01ba770c018601 = (queryClient)=>{
    // Create a new realtime channel for listening to changes in the SyncMetadata table
    // NOTE: Any errors that occur in the channel will be logged to the console, but will not throw an error
    const channel = new (0, $46b44c46d1c90e99$export$a1f57880b288db0e)((0, $5471293cded6d6a9$export$a0b632a28672d3c0), "SyncMetadataChanges", (error)=>{
        console.warn("An error occured in the SyncMetadataChanges realtime channel:", error);
    }).onPostgresChange({
        event: (0, $7ece6d3d4f0fb361$export$bc171c571098b6c4).UPDATE,
        schema: "public",
        table: "SyncMetadata"
    }, (newRecord)=>{
        queryClient.setQueryData([
            "SyncMetadata",
            "all"
        ], (oldData)=>{
            const newData = structuredClone(oldData);
            const oldRecordIndex = newData.findIndex((x)=>x.entityType === newRecord.new.entityType);
            if (oldRecordIndex !== -1) newData[oldRecordIndex] = newRecord.new;
            else newData.push(newRecord.new);
            return newData.sort((a, b)=>a.lastUpdated.localeCompare(b.lastUpdated));
        });
    });
    // Initialize the channel subscription, do not wait for success
    channel.subscribeAsync();
    // Return a function that can be used to dispose (unsubscribe) the channel
    return async ()=>{
        await channel[Symbol.asyncDispose]();
    };
};




const $2b18f0c4ecc45e43$var$bomExportUrl = "https://legacy.sosinventory.com/ReportV2/GetReportCSV?reportType=ExportBOMs&settings=exportformat=csv|showdeleted=1|showarchived=1|&fields=Assembly,Component,Quantity,Notes,LineNumber,";
async function $2b18f0c4ecc45e43$export$e7f9f2a9c93c7d25(reportProgress) {
    // Get CSV contents of the BOM export from SOS
    reportProgress("Fetching BOM data from SOS...");
    let response;
    try {
        response = await fetch($2b18f0c4ecc45e43$var$bomExportUrl, {
            redirect: "manual"
        });
    } catch (error) {
        // If the user does not have the SOS Fixer extension installed, the fetch request will fail due to CORS limitations
        // The browser extension forges the 'Referer' request header and the 'access-control-allow-origin' response header to make the CORS request succeed
        throw new Error("An error occurred when fetching the Vendor-Item Catalog from SOS. Please ensure you have the 'SOS Fixer' browser extension installed and then try again.", {
            cause: error
        });
    }
    // Throw an error if the user is not logged in to SOS. In this case, the request will return a 302 redirect to the login page
    // NOTE: It is not possible to check the 'Location' header when blocking redirects using `redirect: "manual"`, so we
    // just have to assume that every 302 response is a redirect to the SOS login page
    // See: https://github.com/whatwg/fetch/issues/763
    if (response.type === "opaqueredirect") throw new Error("Please open SOS in a new tab, log in to your account, and then try again.");
    if (!response.ok) throw new Error(`Failed to fetch BOM export: ${response.statusText}`);
    const csvText = await response.text();
    // Submit the BOM data to the supabase database
    reportProgress("Uploading BOM data to database...");
    await (0, $30e6f8dc1563064d$export$f4c87bf59542a348)(reportProgress, csvText);
}




var $itHdT = parcelRequire("itHdT");




var $itHdT = parcelRequire("itHdT");
function $38a75dce9b009288$export$2e2bcd8739ae039(date) {
    const parsed = new Date(date);
    if (!Number.isNaN(parsed.valueOf())) return parsed;
    const parts = String(date).match(/\d+/g);
    if (parts == null || parts.length <= 2) return parsed;
    else {
        const [firstP, secondP, ...restPs] = parts.map((x)=>parseInt(x));
        const correctedParts = [
            firstP,
            secondP - 1,
            ...restPs
        ];
        const isoDate = new Date(Date.UTC(...correctedParts));
        return isoDate;
    }
}


const $35b413b7e6ff7c02$var$defaultFormatter = (value, _unit, suffix)=>{
    const unit = value !== 1 ? _unit + 's' : _unit;
    return value + ' ' + unit + ' ' + suffix;
};
var $35b413b7e6ff7c02$export$2e2bcd8739ae039 = $35b413b7e6ff7c02$var$defaultFormatter;
const $35b413b7e6ff7c02$export$1dce50aaf031581d = ({ locale: locale, ...options })=>(value, unit, suffix)=>{
        const RelativeTimeFormat = Intl.RelativeTimeFormat;
        if (!RelativeTimeFormat) throw new Error('Intl.RelativeTimeFormat is not supported');
        const rtf = new RelativeTimeFormat(locale ?? undefined, {
            style: 'long',
            numeric: 'auto',
            ...options
        });
        return rtf.format(suffix === 'ago' ? -value : value, unit);
    };


function $132900893c14632d$var$_extends() {
    return $132900893c14632d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $132900893c14632d$var$_extends.apply(null, arguments);
}
const $132900893c14632d$var$MINUTE = 60;
const $132900893c14632d$var$HOUR = $132900893c14632d$var$MINUTE * 60;
const $132900893c14632d$var$DAY = $132900893c14632d$var$HOUR * 24;
const $132900893c14632d$var$WEEK = $132900893c14632d$var$DAY * 7;
const $132900893c14632d$var$MONTH = $132900893c14632d$var$DAY * 30;
const $132900893c14632d$var$YEAR = $132900893c14632d$var$DAY * 365;
const $132900893c14632d$var$defaultNow = ()=>Date.now();
function $132900893c14632d$export$2e2bcd8739ae039({ date: date, formatter: formatter, component: component = 'time', live: live = true, minPeriod: minPeriod = 0, maxPeriod: maxPeriod = $132900893c14632d$var$WEEK, title: title, now: now = $132900893c14632d$var$defaultNow, ...passDownProps }) {
    const [timeNow, setTimeNow] = (0, $itHdT.useState)(now());
    (0, $itHdT.useEffect)(()=>{
        if (!live) return;
        const tick = ()=>{
            const then = (0, $38a75dce9b009288$export$2e2bcd8739ae039)(date).valueOf();
            if (!then) {
                console.warn('[react-timeago] Invalid Date provided');
                return 0;
            }
            const seconds = Math.round(Math.abs(timeNow - then) / 1000);
            const unboundPeriod = seconds < $132900893c14632d$var$MINUTE ? 1000 : seconds < $132900893c14632d$var$HOUR ? 1000 * $132900893c14632d$var$MINUTE : seconds < $132900893c14632d$var$DAY ? 1000 * $132900893c14632d$var$HOUR : 1000 * $132900893c14632d$var$WEEK;
            const period = Math.min(Math.max(unboundPeriod, minPeriod * 1000), maxPeriod * 1000);
            if (period) return setTimeout(()=>{
                setTimeNow(now());
            }, period);
            return 0;
        };
        const timeoutId = tick();
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        date,
        live,
        maxPeriod,
        minPeriod,
        now,
        timeNow
    ]);
    (0, $itHdT.useEffect)(()=>{
        setTimeNow(now());
    }, [
        date
    ]);
    const Komponent = component;
    const then = (0, $38a75dce9b009288$export$2e2bcd8739ae039)(date).valueOf();
    if (!then) return null;
    const seconds = Math.round(Math.abs(timeNow - then) / 1000);
    const suffix = then < timeNow ? 'ago' : 'from now';
    const [value, unit] = seconds < $132900893c14632d$var$MINUTE ? [
        Math.round(seconds),
        'second'
    ] : seconds < $132900893c14632d$var$HOUR ? [
        Math.round(seconds / $132900893c14632d$var$MINUTE),
        'minute'
    ] : seconds < $132900893c14632d$var$DAY ? [
        Math.round(seconds / $132900893c14632d$var$HOUR),
        'hour'
    ] : seconds < $132900893c14632d$var$WEEK ? [
        Math.round(seconds / $132900893c14632d$var$DAY),
        'day'
    ] : seconds < $132900893c14632d$var$MONTH ? [
        Math.round(seconds / $132900893c14632d$var$WEEK),
        'week'
    ] : seconds < $132900893c14632d$var$YEAR ? [
        Math.round(seconds / $132900893c14632d$var$MONTH),
        'month'
    ] : [
        Math.round(seconds / $132900893c14632d$var$YEAR),
        'year'
    ];
    const passDownTitle = typeof title === 'undefined' ? typeof date === 'string' ? date : (0, $38a75dce9b009288$export$2e2bcd8739ae039)(date).toISOString().substring(0, 16).replace('T', ' ') : title;
    const spreadProps = Komponent === 'time' ? {
        ...passDownProps,
        dateTime: (0, $38a75dce9b009288$export$2e2bcd8739ae039)(date).toISOString()
    } : passDownProps;
    const nextFormatter = (value = value, unit = unit, suffix = suffix, epochMilliseconds = then, nextFormatter = (0, $35b413b7e6ff7c02$export$2e2bcd8739ae039), now = now)=>(0, $35b413b7e6ff7c02$export$2e2bcd8739ae039)(value, unit, suffix, epochMilliseconds, nextFormatter, now);
    const effectiveFormatter = formatter || (0, $35b413b7e6ff7c02$export$2e2bcd8739ae039);
    let content;
    try {
        content = effectiveFormatter(value, unit, suffix, then, nextFormatter, now);
        if (!content) content = (0, $35b413b7e6ff7c02$export$2e2bcd8739ae039)(value, unit, suffix, then, nextFormatter, now);
    } catch (error) {
        console.error('[react-timeago] Formatter threw an error:', error);
        content = (0, $35b413b7e6ff7c02$export$2e2bcd8739ae039)(value, unit, suffix, then, nextFormatter, now);
    }
    return /*#__PURE__*/ $itHdT.createElement(Komponent, $132900893c14632d$var$_extends({}, spreadProps, {
        title: passDownTitle
    }), content);
}



const $a6af8ae3492f338c$export$13ed6273c6e40d43 = ({ lastUpdated: lastUpdated })=>{
    const showAlert = !lastUpdated || lastUpdated.getTime() < Date.now() - 86400000; // 24 hours
    return showAlert ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
        className: "align-text-bottom text-warning",
        children: "\u26A0"
    }) : null;
};


const $25f2d14c4284ef3f$export$66ebf4e43a1b8deb = ({ lastUpdated: lastUpdated })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a6af8ae3492f338c$export$13ed6273c6e40d43), {
                lastUpdated: lastUpdated
            }),
            " ",
            lastUpdated ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $132900893c14632d$export$2e2bcd8739ae039), {
                date: lastUpdated
            }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
                children: "never synced"
            })
        ]
    });
};


const $85e13f311e4e73ec$var$successStatus = "Sync Complete - Refresh page to see changes";
const $85e13f311e4e73ec$var$errorStatusPrefix = "Error: ";
const $85e13f311e4e73ec$export$448d10f887a7e19 = ({ label: label, lastSynced: lastSynced, runSync: runSync, syncRunning: syncRunning, setSyncRunning: setSyncRunning })=>{
    const [syncStatus, setSyncStatusInternal] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState("");
    const setSyncStatus = (0, $itHdT.useCallback)((status)=>{
        setSyncStatusInternal(status);
        console.info(`Status update for ${label} sync: ${status}`);
    }, [
        label
    ]);
    const syncSuccess = syncStatus === $85e13f311e4e73ec$var$successStatus;
    const syncError = syncStatus.startsWith($85e13f311e4e73ec$var$errorStatusPrefix);
    const onClick = (0, $itHdT.useCallback)(()=>{
        if (syncRunning) return;
        setSyncRunning(true);
        setSyncStatus("Starting Sync...");
        runSync(setSyncStatus).then(()=>{
            setSyncStatus($85e13f311e4e73ec$var$successStatus);
            setTimeout(()=>{
                if (syncStatus === $85e13f311e4e73ec$var$successStatus) setSyncStatus("");
            }, 5000);
        }).catch((err)=>{
            console.error(err);
            setSyncStatus($85e13f311e4e73ec$var$errorStatusPrefix + err.message);
        }).finally(()=>{
            setSyncRunning(false);
        });
    }, [
        syncRunning,
        setSyncRunning,
        runSync,
        syncStatus,
        setSyncStatus
    ]);
    const icon = syncRunning ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $67974e86dbd6e1f4$export$2e2bcd8739ae039), {
        className: "me-2",
        size: "sm"
    }) : syncError ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
        icon: "exclamation-circle-fill",
        className: "col-auto mt-1 me-2 text-danger"
    }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
        icon: "arrow-repeat",
        className: "col-auto mt-1 me-2"
    });
    const syncStatusClass = syncError ? "text-wrap text-danger-emphasis" : syncSuccess ? "text-success-emphasis" : "text-secondary";
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Item, {
        onClick: onClick,
        className: "text-wrap text-md-nowrap",
        disabled: syncRunning,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
            className: "d-flex align-items-center",
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                    children: icon
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
                    children: [
                        label,
                        !syncStatus && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
                            className: "text-secondary",
                            children: [
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                                "Last Synced: ",
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $25f2d14c4284ef3f$export$66ebf4e43a1b8deb), {
                                    lastUpdated: lastSynced
                                })
                            ]
                        }),
                        syncStatus && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
                            className: syncStatusClass,
                            children: [
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                                syncStatus
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





const $0210c5f6067e8d03$var$vendorItemCatalogExportUrl = "https://legacy.sosinventory.com/ReportV2/GetReportCSV?reportType=ExportVendorItemCatalog&settings=exportformat=csv|showdeleted=1|showarchived=1|&fields=Vendor,Item,Price,VendorPartNumber,";
async function $0210c5f6067e8d03$export$1960d5cac3cf1a3(reportProgress) {
    // Get CSV contents of the Vendor-Item catalog export from SOS
    reportProgress("Fetching Vendor-Item Catalog data from SOS...");
    let response;
    try {
        response = await fetch($0210c5f6067e8d03$var$vendorItemCatalogExportUrl, {
            redirect: "manual"
        });
    } catch (error) {
        // If the user does not have the SOS Fixer extension installed, the fetch request will fail due to CORS limitations
        // The browser extension forges the 'Referer' request header and the 'access-control-allow-origin' response header to make the CORS request succeed
        throw new Error("An error occurred when fetching the Vendor-Item Catalog from SOS. Please ensure you have the 'SOS Fixer' browser extension installed and then try again.", {
            cause: error
        });
    }
    // Throw an error if the user is not logged in to SOS. In this case, the request will return a 302 redirect to the login page
    // NOTE: It is not possible to check the 'Location' header when blocking redirects using `redirect: "manual"`, so we
    // just have to assume that every 302 response is a redirect to the SOS login page
    // See: https://github.com/whatwg/fetch/issues/763
    if (response.type === "opaqueredirect") throw new Error("Please open SOS in a new tab, log in to your account, and then try again.");
    if (!response.ok) throw new Error(`Failed to fetch Vendor-Item Catalog export: ${response.statusText}`);
    const csvText = await response.text();
    // Submit the BOM data to the supabase database
    reportProgress("Uploading Vendor-Item Catalog data to database...");
    await (0, $30e6f8dc1563064d$export$e965bc5376352402)(reportProgress, csvText);
}


const $878bf1ab511527ff$export$e9aaf2082659c577 = ({ className: className })=>{
    const { session: session } = (0, $itHdT.useContext)((0, $a2ead8eb3468501d$export$3285420c698bc605));
    const [syncBOMRunning, setSyncBOMRunning] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState(false);
    const [syncVendorItemCatalogRunning, setSyncVendorItemCatalogRunning] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState(false);
    const [syncOthersRunning, setSyncOthersRunning] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState(false);
    // Get all the queries that are currently being used for rendering, and determine the date of the oldest data
    const renderedQueries = (0, $615d4ef8039d571e$export$53a0372a68eb74f7)();
    const dataUpdatedAts = renderedQueries.map((q)=>q.dataUpdatedAt).filter((v)=>typeof v === "number" && v > 0);
    const pageOldestDataLoadedAt = dataUpdatedAts.length ? new Date(Math.min(...dataUpdatedAts)) : new Date();
    // Fetch sync metadata and subscribe to changes (if user is logged in)
    const { isPending: isPending, isError: isError, data: allSyncMetadata, error: error } = (0, $6ea0b2638e0c092a$export$dd0a697e1782aedd)({
        ...(0, $db95884f00cbfd06$export$bf1bd58dc6eb2c9b),
        enabled: !!session
    }); // eslint-disable-line no-restricted-syntax -- This query is not relevant to page data staleness
    const queryClient = (0, $e49ef136abe795ca$export$22e77b9572c4fded)();
    (0, $itHdT.useEffect)(()=>{
        if (!session) return;
        const unsubscribe = (0, $db95884f00cbfd06$export$dc01ba770c018601)(queryClient);
        return ()=>void unsubscribe();
    }, [
        queryClient,
        session
    ]);
    if (isError) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)($878bf1ab511527ff$var$LoadingNavItem, {
        children: [
            "Error loading sync data: ",
            error.message
        ]
    });
    if (isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($878bf1ab511527ff$var$LoadingNavItem, {
        children: "Loading sync data..."
    });
    // Extract the BOM and Vendor-Item Catalog sync metadata from the list
    const otherSyncMetadata = [
        ...allSyncMetadata
    ];
    const bomSyncMetadataIndex = otherSyncMetadata.findIndex((sync)=>sync.entityType === "bom");
    const bomSyncMetadata = bomSyncMetadataIndex === -1 ? null : otherSyncMetadata.splice(bomSyncMetadataIndex, 1)[0];
    const vendorItemCatalogSyncMetadataIndex = otherSyncMetadata.findIndex((sync)=>sync.entityType === "vendoritemcatalog");
    const vendorItemCatalogSyncMetadata = vendorItemCatalogSyncMetadataIndex === -1 ? null : otherSyncMetadata.splice(vendorItemCatalogSyncMetadataIndex, 1)[0];
    const anySyncLastUpdated = allSyncMetadata[0]?.lastUpdated;
    const anySyncLastUpdatedMin = anySyncLastUpdated && anySyncLastUpdated < pageOldestDataLoadedAt ? anySyncLastUpdated : pageOldestDataLoadedAt;
    const anySyncRunning = syncBOMRunning || syncVendorItemCatalogRunning || syncOthersRunning;
    const title = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            anySyncRunning ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $67974e86dbd6e1f4$export$2e2bcd8739ae039), {
                size: "sm"
            }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a6af8ae3492f338c$export$13ed6273c6e40d43), {
                lastUpdated: anySyncLastUpdatedMin
            }),
            " ",
            "Sync"
        ]
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("nav-item fixed-height", className),
        autoClose: "outside",
        align: "end",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Toggle, {
                className: "nav-link",
                variant: "link",
                children: title
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Menu, {
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Header, {
                        className: "text-decoration-underline pt-0 pb-1",
                        children: "Current Page"
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).ItemText, {
                        children: [
                            "Data Loaded: ",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $25f2d14c4284ef3f$export$66ebf4e43a1b8deb), {
                                lastUpdated: pageOldestDataLoadedAt
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Divider, {}),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Header, {
                        className: "text-decoration-underline pt-0 pb-1",
                        children: "Database Sync"
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $85e13f311e4e73ec$export$448d10f887a7e19), {
                        label: "Sync BOMs",
                        lastSynced: bomSyncMetadata?.lastUpdated ?? null,
                        runSync: (0, $2b18f0c4ecc45e43$export$e7f9f2a9c93c7d25),
                        syncRunning: syncBOMRunning,
                        setSyncRunning: setSyncBOMRunning
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $85e13f311e4e73ec$export$448d10f887a7e19), {
                        label: "Sync Vendor-Item Catalog",
                        lastSynced: vendorItemCatalogSyncMetadata?.lastUpdated ?? null,
                        runSync: (0, $0210c5f6067e8d03$export$1960d5cac3cf1a3),
                        syncRunning: syncVendorItemCatalogRunning,
                        setSyncRunning: setSyncVendorItemCatalogRunning
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $85e13f311e4e73ec$export$448d10f887a7e19), {
                        label: "Sync Others",
                        lastSynced: otherSyncMetadata[0]?.lastUpdated,
                        runSync: (0, $30e6f8dc1563064d$export$8c83cf1afb7f2c41),
                        syncRunning: syncOthersRunning,
                        setSyncRunning: setSyncOthersRunning
                    })
                ]
            })
        ]
    });
};
const $878bf1ab511527ff$var$LoadingNavItem = ({ children: children })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039), {
        className: "nav-item",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Toggle, {
            className: "nav-link",
            variant: "link",
            disabled: true,
            children: children
        })
    });


const $a409f52924384ef4$export$41d0d88a6b0e456f = ()=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c5c707e1c7e013d3$export$2e2bcd8739ae039), {
        expand: "lg",
        className: "bg-body-tertiary",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
            fluid: true,
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $b634fe06a3f61222$export$a6c7ac8248d6e38a), {
                    to: "/",
                    className: "navbar-brand",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1832dba737c37411$export$e6ff31bff12b7ff4), {}),
                        " ",
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                            className: "d-none d-lg-inline text-uppercase front-monospace",
                            children: "Senti Internal Tools"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c5c707e1c7e013d3$export$2e2bcd8739ae039).Toggle, {
                    "aria-controls": "basic-navbar-nav"
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c5c707e1c7e013d3$export$2e2bcd8739ae039).Collapse, {
                    id: "basic-navbar-nav",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039), {
                            className: "me-auto",
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $36b82dca41f80dd8$export$4269543a09b27cac), {
                                children: [
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                                            to: "/estimates",
                                            children: [
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                    icon: "receipt"
                                                }),
                                                " Estimates"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                                            to: "/orders",
                                            children: [
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                    icon: "clipboard2-check"
                                                }),
                                                " Orders"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                                            to: "/ncrs",
                                            children: [
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                    icon: "clipboard2-x"
                                                }),
                                                " NCRs"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039), {
                                        className: "nav-item",
                                        children: [
                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Toggle, {
                                                className: "nav-link",
                                                variant: "link",
                                                children: [
                                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                        icon: "patch-check",
                                                        className: "me-1"
                                                    }),
                                                    "QMS"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Menu, {
                                                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4c8de7547756ff0d$export$d6500e7dfb333414), {
                                                    to: "/qms/vendor-assessments/",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                            icon: "card-checklist"
                                                        }),
                                                        " Vendor Assessments"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039), {
                                        className: "nav-item",
                                        children: [
                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Toggle, {
                                                className: "nav-link",
                                                variant: "link",
                                                children: [
                                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                        icon: "box-arrow-up-right",
                                                        className: "me-1"
                                                    }),
                                                    "External Tools"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Menu, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Item, {
                                                        href: "https://senti-solutions.gitlab.io/quoting-machine/",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                                icon: "calculator"
                                                            }),
                                                            " Quoting Tool ",
                                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                                icon: "box-arrow-up-right"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Item, {
                                                        href: "https://docs.google.com/spreadsheets/d/1JuiFie1VHb-s57R-pOeAg0XOlc64RWk6cYBoZEf4atI",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                                icon: "pencil"
                                                            }),
                                                            " Drawing Package Generator ",
                                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                                icon: "box-arrow-up-right"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Item, {
                                                        href: "mailto:mark+qbo-receipt-upload@sentisolutions.ca?subject=QBO%20Receipt%20Upload&body=Please%20follow%20these%20instructions%20to%20upload%20your%20receipt%20to%20QBO%3A%0A%0A1.%20Take%20a%20picture%20of%20your%20bill%20or%20receipt%20on%20your%20mobile%20device.%0A%20%20%20%20Note%3A%20The%20photo%27s%20file%20type%20must%20be%20a%20pdf%2C%20jpeg%2C%20jpg%2C%20gif%2C%20or%20png.%0A2.%20Make%20sure%20each%20image%20or%20file%20contains%20only%20one%20receipt.%0A3.%20Attach%20the%20image%28s%29%20to%20this%20email%20and%20sent%20it%20%28the%20recipient%20must%20be%20%22mark%2Bqbo-receipt-upload%40sentisolutions.ca%22%29%0A%20%20%20%20Note%3A%20You%20can%20send%20multiple%20receipt%20images%20in%20one%20email.%20The%20email%20attachment%27s%20file%20size%20must%20be%20between%2046KB%20to%2020%20MB.",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                                icon: "receipt"
                                                            }),
                                                            " Email Receipt to QBO ",
                                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                                icon: "box-arrow-up-right"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Link, {
                                        href: "https://sites.google.com/sentisolutions.ca/help-center",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                icon: "question-circle"
                                            }),
                                            " Senti Help Center ",
                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                                icon: "box-arrow-up-right"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("hr", {
                            className: "d-lg-none m-0 mt-1"
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039), {
                            className: "ms-md-auto",
                            children: [
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $36b82dca41f80dd8$export$4269543a09b27cac), {
                                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $878bf1ab511527ff$export$e9aaf2082659c577), {
                                        className: "me-1"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0314e4bc0f0b7f31$export$9d63163ee2173b37), {
                                    className: "me-1"
                                }),
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c2333257bae92541$export$71cc1408abbe49b8), {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


const $73afe6efd67cc935$export$e034111dc0cfe9e7 = ()=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        className: "vh-100 d-flex flex-column",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a409f52924384ef4$export$41d0d88a6b0e456f), {}),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "flex-grow-1 minh-0",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$910ae8079b2c2852), {})
            })
        ]
    });
};




var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");




var $itHdT = parcelRequire("itHdT");




"use client";
const $86f55ad23c232907$var$DivStyledAsH4 = (0, $62e41ab67f5e63a5$export$2e2bcd8739ae039)('h4');
$86f55ad23c232907$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $86f55ad23c232907$var$AlertHeading = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $86f55ad23c232907$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$86f55ad23c232907$var$AlertHeading.displayName = 'AlertHeading';
var $86f55ad23c232907$export$2e2bcd8739ae039 = $86f55ad23c232907$var$AlertHeading;



var $itHdT = parcelRequire("itHdT");




"use client";
const $0b30abe2cf1bdece$var$AlertLink = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $7b1c46c0196abba4$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$0b30abe2cf1bdece$var$AlertLink.displayName = 'AlertLink';
var $0b30abe2cf1bdece$export$2e2bcd8739ae039 = $0b30abe2cf1bdece$var$AlertLink;





"use client";
const $ed503698bce8761d$var$Alert = /*#__PURE__*/ $itHdT.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $eb31cd918b0fa60f$export$2e2bcd8739ae039), ...props } = (0, $ebcd10849b756af0$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $153be9953ec91ab7$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $eb31cd918b0fa60f$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8e67b2a05f9aad1c$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$ed503698bce8761d$var$Alert.displayName = 'Alert';
var $ed503698bce8761d$export$2e2bcd8739ae039 = Object.assign($ed503698bce8761d$var$Alert, {
    Link: (0, $0b30abe2cf1bdece$export$2e2bcd8739ae039),
    Heading: (0, $86f55ad23c232907$export$2e2bcd8739ae039)
});




const $01b3ada793939000$export$daddb13553a29f22 = ()=>{
    const { session: session } = (0, $itHdT.useContext)((0, $a2ead8eb3468501d$export$3285420c698bc605));
    const [searchParams] = (0, $b634fe06a3f61222$export$f1a78c17382fe22a)();
    const authError = $01b3ada793939000$var$parseAuthError(searchParams);
    // Navigate back to the previous page automatically when the user signs in
    if (session) {
        const returnUrl = $01b3ada793939000$var$parseAndValidatedReturnUrl(searchParams.get("returnUrl"));
        console.info("User is now authenticated, redirecting to the return URL", returnUrl);
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$444b3ab0cb9aec40), {
            to: returnUrl,
            replace: true
        });
    }
    // Show the unauthenticated message
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
        className: "mt-5",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("h1", {
                children: "You are not authenticated"
            }),
            authError && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $ed503698bce8761d$export$2e2bcd8739ae039), {
                variant: "danger",
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("strong", {
                        children: "Sign-in failed."
                    }),
                    " ",
                    authError
                ]
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("p", {
                children: "Please log in using the Google Sign In button at the top right to continue."
            })
        ]
    });
};
function $01b3ada793939000$var$parseAuthError(searchParams) {
    const errorDescription = searchParams.get("error_description");
    if (!errorDescription) return null;
    const errorCode = searchParams.get("error_code");
    return errorCode ? `${errorDescription} (code: ${errorCode})` : errorDescription;
}
/**
 * Allows only same-app relative return URLs from the query string and falls back to `/` for invalid input.
 */ function $01b3ada793939000$var$parseAndValidatedReturnUrl(returnUrl) {
    // Only support relative URLs
    if (!returnUrl?.startsWith("/")) {
        console.warn("Ignoring invalid return URL and falling back to /", returnUrl);
        return "/";
    }
    try {
        const parsedUrl = new URL(returnUrl, window.location.origin);
        if (parsedUrl.origin !== window.location.origin) {
            console.warn("Ignoring cross-origin return URL and falling back to /", returnUrl);
            return "/";
        }
        return returnUrl;
    } catch  {
        console.warn("Ignoring malformed return URL and falling back to /", returnUrl);
        return "/";
    }
}




var $itHdT = parcelRequire("itHdT");


const $25450085f9e379bd$export$f01b3d7c7bbe3997 = ({ children: children })=>{
    const { loading: loading, session: session } = (0, $itHdT.useContext)((0, $a2ead8eb3468501d$export$3285420c698bc605));
    const location = (0, $b634fe06a3f61222$export$45d76561a5302f2b)();
    // Render nothing while the existing session state is loading
    // This is necessary to prevent doing an unnecessary redirect
    if (loading) return null;
    if (!session) {
        const returnUrl = encodeURIComponent(location.pathname + location.search + location.hash);
        console.info("Redirecting to 'unauthenticated' page with return URL", returnUrl);
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$444b3ab0cb9aec40), {
            to: "/unauthenticated?returnUrl=" + returnUrl,
            replace: true
        });
    }
    return children ? children : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$910ae8079b2c2852), {});
};






var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");

var $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($c4553a5d3ce9fa3e$export$7debb50ef11d5e0b || ($c4553a5d3ce9fa3e$export$7debb50ef11d5e0b = {}));
var $c4553a5d3ce9fa3e$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($c4553a5d3ce9fa3e$export$4aa2142c225fd5c7 || ($c4553a5d3ce9fa3e$export$4aa2142c225fd5c7 = {}));
const $c4553a5d3ce9fa3e$export$5716da67bfaa244d = $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.undefined;
        case "string":
            return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $c4553a5d3ce9fa3e$export$5716da67bfaa244d.nan : $c4553a5d3ce9fa3e$export$5716da67bfaa244d.number;
        case "boolean":
            return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.boolean;
        case "function":
            return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.function;
        case "bigint":
            return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.array;
            if (data === null) return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.date;
            return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.object;
        default:
            return $c4553a5d3ce9fa3e$export$5716da67bfaa244d.unknown;
    }
};


const $8f906c871d115551$export$5ba560653e4a1035 = (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $8f906c871d115551$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $8f906c871d115551$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $8f906c871d115551$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$8f906c871d115551$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $8f906c871d115551$export$f98dac4b251ab333(issues);
    return error;
};




const $2241a5ea00ed5d3e$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type:
            if (issue.received === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).jsonStringifyReplacer)}`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).joinValues(issue.options)}`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).custom:
            message = `Invalid input`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $8f906c871d115551$export$5ba560653e4a1035).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).assertNever(issue);
    }
    return {
        message: message
    };
};
var $2241a5ea00ed5d3e$export$2e2bcd8739ae039 = $2241a5ea00ed5d3e$var$errorMap;


let $8cee540214202600$var$overrideErrorMap = (0, $2241a5ea00ed5d3e$export$2e2bcd8739ae039);
function $8cee540214202600$export$1097a8289cfd22d7(map) {
    $8cee540214202600$var$overrideErrorMap = map;
}
function $8cee540214202600$export$32f27c719778d4c4() {
    return $8cee540214202600$var$overrideErrorMap;
}


var $8725ea93ab6e4588$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($8725ea93ab6e4588$export$b9faa7f0c32cb80d || ($8725ea93ab6e4588$export$b9faa7f0c32cb80d = {}));




const $a74aa2f75401a059$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $a74aa2f75401a059$export$1526d2e05f74572 = [];
function $a74aa2f75401a059$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $8cee540214202600$export$32f27c719778d4c4)();
    const issue = $a74aa2f75401a059$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $2241a5ea00ed5d3e$export$2e2bcd8739ae039) ? undefined : (0, $2241a5ea00ed5d3e$export$2e2bcd8739ae039)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $a74aa2f75401a059$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $a74aa2f75401a059$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $a74aa2f75401a059$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $a74aa2f75401a059$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $a74aa2f75401a059$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $a74aa2f75401a059$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $a74aa2f75401a059$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $a74aa2f75401a059$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $a74aa2f75401a059$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $a74aa2f75401a059$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $a74aa2f75401a059$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $a74aa2f75401a059$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;



class $0ecef21ea2da6305$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $0ecef21ea2da6305$var$handleResult = (ctx, result)=>{
    if ((0, $a74aa2f75401a059$export$1ea939691cdc45b8)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $8f906c871d115551$export$f98dac4b251ab333)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $0ecef21ea2da6305$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $a74aa2f75401a059$export$aefee5ebe1dcfd9e)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $0ecef21ea2da6305$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $a74aa2f75401a059$export$1ea939691cdc45b8)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $a74aa2f75401a059$export$1ea939691cdc45b8)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $a74aa2f75401a059$export$aefee5ebe1dcfd9e)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $0ecef21ea2da6305$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $0ecef21ea2da6305$export$a60af00cc0ce2582({
            schema: this,
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $0ecef21ea2da6305$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $0ecef21ea2da6305$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $0ecef21ea2da6305$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $0ecef21ea2da6305$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $0ecef21ea2da6305$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $0ecef21ea2da6305$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $0ecef21ea2da6305$export$a60af00cc0ce2582({
            ...$0ecef21ea2da6305$var$processCreateParams(this._def),
            schema: this,
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $0ecef21ea2da6305$export$bb19b37874861e7e({
            ...$0ecef21ea2da6305$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $0ecef21ea2da6305$export$66b0c798a395271f({
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$0ecef21ea2da6305$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $0ecef21ea2da6305$export$75a44ec6249ac76b({
            ...$0ecef21ea2da6305$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $0ecef21ea2da6305$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $0ecef21ea2da6305$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $0ecef21ea2da6305$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $0ecef21ea2da6305$var$cuid2Regex = /^[0-9a-z]+$/;
const $0ecef21ea2da6305$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $0ecef21ea2da6305$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $0ecef21ea2da6305$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $0ecef21ea2da6305$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $0ecef21ea2da6305$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $0ecef21ea2da6305$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $0ecef21ea2da6305$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $0ecef21ea2da6305$var$emojiRegex;
// faster, simpler, safer
const $0ecef21ea2da6305$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $0ecef21ea2da6305$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $0ecef21ea2da6305$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $0ecef21ea2da6305$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $0ecef21ea2da6305$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $0ecef21ea2da6305$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $0ecef21ea2da6305$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $0ecef21ea2da6305$var$dateRegex = new RegExp(`^${$0ecef21ea2da6305$var$dateRegexSource}$`);
function $0ecef21ea2da6305$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $0ecef21ea2da6305$var$timeRegex(args) {
    return new RegExp(`^${$0ecef21ea2da6305$var$timeRegexSource(args)}$`);
}
function $0ecef21ea2da6305$export$a4b563879add27a(args) {
    let regex = `${$0ecef21ea2da6305$var$dateRegexSource}T${$0ecef21ea2da6305$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $0ecef21ea2da6305$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $0ecef21ea2da6305$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $0ecef21ea2da6305$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $0ecef21ea2da6305$var$isValidJWT(jwt, alg) {
    if (!$0ecef21ea2da6305$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $0ecef21ea2da6305$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $0ecef21ea2da6305$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $0ecef21ea2da6305$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $0ecef21ea2da6305$export$1230eb29b8d3b502 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).string,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const status = new (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$0ecef21ea2da6305$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "email",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$0ecef21ea2da6305$var$emojiRegex) $0ecef21ea2da6305$var$emojiRegex = new RegExp($0ecef21ea2da6305$var$_emojiRegex, "u");
                if (!$0ecef21ea2da6305$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "emoji",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$0ecef21ea2da6305$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "uuid",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$0ecef21ea2da6305$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "nanoid",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$0ecef21ea2da6305$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "cuid",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$0ecef21ea2da6305$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "cuid2",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$0ecef21ea2da6305$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "ulid",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                    validation: "url",
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "regex",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $0ecef21ea2da6305$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $0ecef21ea2da6305$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $0ecef21ea2da6305$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$0ecef21ea2da6305$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "duration",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$0ecef21ea2da6305$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "ip",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$0ecef21ea2da6305$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "jwt",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$0ecef21ea2da6305$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "cidr",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$0ecef21ea2da6305$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "base64",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$0ecef21ea2da6305$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        validation: "base64url",
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_string,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $0ecef21ea2da6305$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message));
    }
    trim() {
        return new $0ecef21ea2da6305$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $0ecef21ea2da6305$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $0ecef21ea2da6305$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$0ecef21ea2da6305$export$1230eb29b8d3b502.create = (params)=>{
    return new $0ecef21ea2da6305$export$1230eb29b8d3b502({
        checks: [],
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $0ecef21ea2da6305$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $0ecef21ea2da6305$export$5b070a55c0c43e09 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).number,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($0ecef21ea2da6305$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $0ecef21ea2da6305$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $0ecef21ea2da6305$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$0ecef21ea2da6305$export$5b070a55c0c43e09.create = (params)=>{
    return new $0ecef21ea2da6305$export$5b070a55c0c43e09({
        checks: [],
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$67d741fd70ff98f4 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
            code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
            expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).bigint,
            received: ctx.parsedType
        });
        return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $0ecef21ea2da6305$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $0ecef21ea2da6305$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$0ecef21ea2da6305$export$67d741fd70ff98f4.create = (params)=>{
    return new $0ecef21ea2da6305$export$67d741fd70ff98f4({
        checks: [],
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$723d146f80596191 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).boolean,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
}
$0ecef21ea2da6305$export$723d146f80596191.create = (params)=>{
    return new $0ecef21ea2da6305$export$723d146f80596191({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$e974be33bdc55521 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).date,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_date
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const status = new (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $0ecef21ea2da6305$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$0ecef21ea2da6305$export$e974be33bdc55521.create = (params)=>{
    return new $0ecef21ea2da6305$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodDate,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$bcc3b40f6b638044 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).symbol,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
}
$0ecef21ea2da6305$export$bcc3b40f6b638044.create = (params)=>{
    return new $0ecef21ea2da6305$export$bcc3b40f6b638044({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodSymbol,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$4e780e961c30340d extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).undefined,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
}
$0ecef21ea2da6305$export$4e780e961c30340d.create = (params)=>{
    return new $0ecef21ea2da6305$export$4e780e961c30340d({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodUndefined,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$a96281f914484f2d extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).null,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
}
$0ecef21ea2da6305$export$a96281f914484f2d.create = (params)=>{
    return new $0ecef21ea2da6305$export$a96281f914484f2d({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodNull,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$b9d1edb536b4e4eb extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
}
$0ecef21ea2da6305$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $0ecef21ea2da6305$export$b9d1edb536b4e4eb({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodAny,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$ef3b1bb1630977ae extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
}
$0ecef21ea2da6305$export$ef3b1bb1630977ae.create = (params)=>{
    return new $0ecef21ea2da6305$export$ef3b1bb1630977ae({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodUnknown,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$1e576a20c3ce9fb5 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
            code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
            expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).never,
            received: ctx.parsedType
        });
        return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
    }
}
$0ecef21ea2da6305$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $0ecef21ea2da6305$export$1e576a20c3ce9fb5({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodNever,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$7d39f5df85f21031 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).void,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
}
$0ecef21ea2da6305$export$7d39f5df85f21031.create = (params)=>{
    return new $0ecef21ea2da6305$export$7d39f5df85f21031({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodVoid,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$7acfc3e64785411 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).array) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).array,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                    code: tooBig ? (0, $8f906c871d115551$export$5ba560653e4a1035).too_big : (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $0ecef21ea2da6305$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $0ecef21ea2da6305$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    length(len, message) {
        return new $0ecef21ea2da6305$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$0ecef21ea2da6305$export$7acfc3e64785411.create = (schema, params)=>{
    return new $0ecef21ea2da6305$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodArray,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
function $0ecef21ea2da6305$var$deepPartialify(schema) {
    if (schema instanceof $0ecef21ea2da6305$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $0ecef21ea2da6305$export$aa56fec1e9d629b8.create($0ecef21ea2da6305$var$deepPartialify(fieldSchema));
        }
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $0ecef21ea2da6305$export$7acfc3e64785411) return new $0ecef21ea2da6305$export$7acfc3e64785411({
        ...schema._def,
        type: $0ecef21ea2da6305$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $0ecef21ea2da6305$export$aa56fec1e9d629b8) return $0ecef21ea2da6305$export$aa56fec1e9d629b8.create($0ecef21ea2da6305$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $0ecef21ea2da6305$export$aaac0b8b429cef5) return $0ecef21ea2da6305$export$aaac0b8b429cef5.create($0ecef21ea2da6305$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $0ecef21ea2da6305$export$e2a18bb771d8e6a3) return $0ecef21ea2da6305$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$0ecef21ea2da6305$var$deepPartialify(item)));
    else return schema;
}
class $0ecef21ea2da6305$export$736315c5b55efbad extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $0ecef21ea2da6305$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $0ecef21ea2da6305$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                        code: (0, $8f906c871d115551$export$5ba560653e4a1035).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f).mergeObjectSync(status, syncPairs);
        });
        else return (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj;
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $0ecef21ea2da6305$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $0ecef21ea2da6305$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $0ecef21ea2da6305$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $0ecef21ea2da6305$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $0ecef21ea2da6305$var$createZodEnum((0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectKeys(this.shape));
    }
}
$0ecef21ea2da6305$export$736315c5b55efbad.create = (shape, params)=>{
    return new $0ecef21ea2da6305$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $0ecef21ea2da6305$export$1e576a20c3ce9fb5.create(),
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodObject,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
$0ecef21ea2da6305$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $0ecef21ea2da6305$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $0ecef21ea2da6305$export$1e576a20c3ce9fb5.create(),
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodObject,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
$0ecef21ea2da6305$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $0ecef21ea2da6305$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $0ecef21ea2da6305$export$1e576a20c3ce9fb5.create(),
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodObject,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$a8b236cb5070a311 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $8f906c871d115551$export$f98dac4b251ab333)(result.ctx.common.issues));
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $8f906c871d115551$export$f98dac4b251ab333)(issues));
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$0ecef21ea2da6305$export$a8b236cb5070a311.create = (types, params)=>{
    return new $0ecef21ea2da6305$export$a8b236cb5070a311({
        options: types,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodUnion,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $0ecef21ea2da6305$var$getDiscriminator = (type)=>{
    if (type instanceof $0ecef21ea2da6305$export$378d0cfce37406e6) return $0ecef21ea2da6305$var$getDiscriminator(type.schema);
    else if (type instanceof $0ecef21ea2da6305$export$a60af00cc0ce2582) return $0ecef21ea2da6305$var$getDiscriminator(type.innerType());
    else if (type instanceof $0ecef21ea2da6305$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $0ecef21ea2da6305$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $0ecef21ea2da6305$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectValues(type.enum);
    else if (type instanceof $0ecef21ea2da6305$export$bb19b37874861e7e) return $0ecef21ea2da6305$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $0ecef21ea2da6305$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $0ecef21ea2da6305$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $0ecef21ea2da6305$export$aa56fec1e9d629b8) return [
        undefined,
        ...$0ecef21ea2da6305$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $0ecef21ea2da6305$export$aaac0b8b429cef5) return [
        null,
        ...$0ecef21ea2da6305$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $0ecef21ea2da6305$export$66b0c798a395271f) return $0ecef21ea2da6305$var$getDiscriminator(type.unwrap());
    else if (type instanceof $0ecef21ea2da6305$export$5d1f7ef05c4e493a) return $0ecef21ea2da6305$var$getDiscriminator(type.unwrap());
    else if (type instanceof $0ecef21ea2da6305$export$75a44ec6249ac76b) return $0ecef21ea2da6305$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $0ecef21ea2da6305$export$5ef2424805ac76a3 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).object) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $0ecef21ea2da6305$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $0ecef21ea2da6305$export$5ef2424805ac76a3({
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$0ecef21ea2da6305$var$processCreateParams(params)
        });
    }
}
function $0ecef21ea2da6305$var$mergeValues(a, b) {
    const aType = (0, $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a)(a);
    const bType = (0, $c4553a5d3ce9fa3e$export$3e9057828ebd5c7a)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).object && bType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).object) {
        const bKeys = (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectKeys(b);
        const sharedKeys = (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $0ecef21ea2da6305$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).array && bType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $0ecef21ea2da6305$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).date && bType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $0ecef21ea2da6305$export$c02deaf0bb5203d4 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $a74aa2f75401a059$export$afa861e3c5730743)(parsedLeft) || (0, $a74aa2f75401a059$export$afa861e3c5730743)(parsedRight)) return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
            const merged = $0ecef21ea2da6305$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_intersection_types
                });
                return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
            }
            if ((0, $a74aa2f75401a059$export$910b6cdd390341b3)(parsedLeft) || (0, $a74aa2f75401a059$export$910b6cdd390341b3)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$0ecef21ea2da6305$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $0ecef21ea2da6305$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodIntersection,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$e2a18bb771d8e6a3 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).array) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).array,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f).mergeArray(status, results);
        });
        else return (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $0ecef21ea2da6305$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$0ecef21ea2da6305$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $0ecef21ea2da6305$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$a2acc09968cb4b7f extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).object) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).object,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f).mergeObjectAsync(status, pairs);
        else return (0, $a74aa2f75401a059$export$5b20a5c3d05c1f6f).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $0ecef21ea2da6305$export$2afb8ab49d4b92c0) return new $0ecef21ea2da6305$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodRecord,
            ...$0ecef21ea2da6305$var$processCreateParams(third)
        });
        return new $0ecef21ea2da6305$export$a2acc09968cb4b7f({
            keyType: $0ecef21ea2da6305$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodRecord,
            ...$0ecef21ea2da6305$var$processCreateParams(second)
        });
    }
}
class $0ecef21ea2da6305$export$163b6a2b712d9542 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).map) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).map,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$0ecef21ea2da6305$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $0ecef21ea2da6305$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodMap,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$977057706f816712 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).set) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).set,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $0ecef21ea2da6305$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $0ecef21ea2da6305$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $0ecef21ea2da6305$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $8725ea93ab6e4588$export$b9faa7f0c32cb80d).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$0ecef21ea2da6305$export$977057706f816712.create = (valueType, params)=>{
    return new $0ecef21ea2da6305$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodSet,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$d4602ba55673f53c extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).function) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).function,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return (0, $a74aa2f75401a059$export$244a85fde9c419ed)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $8cee540214202600$export$32f27c719778d4c4)(),
                    (0, $2241a5ea00ed5d3e$export$2e2bcd8739ae039)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $a74aa2f75401a059$export$244a85fde9c419ed)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $8cee540214202600$export$32f27c719778d4c4)(),
                    (0, $2241a5ea00ed5d3e$export$2e2bcd8739ae039)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $0ecef21ea2da6305$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(async function(...args) {
                const error = new (0, $8f906c871d115551$export$f98dac4b251ab333)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $8f906c871d115551$export$f98dac4b251ab333)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $8f906c871d115551$export$f98dac4b251ab333)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $0ecef21ea2da6305$export$d4602ba55673f53c({
            ...this._def,
            args: $0ecef21ea2da6305$export$e2a18bb771d8e6a3.create(items).rest($0ecef21ea2da6305$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $0ecef21ea2da6305$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $0ecef21ea2da6305$export$d4602ba55673f53c({
            args: args ? args : $0ecef21ea2da6305$export$e2a18bb771d8e6a3.create([]).rest($0ecef21ea2da6305$export$ef3b1bb1630977ae.create()),
            returns: returns || $0ecef21ea2da6305$export$ef3b1bb1630977ae.create(),
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodFunction,
            ...$0ecef21ea2da6305$var$processCreateParams(params)
        });
    }
}
class $0ecef21ea2da6305$export$378d0cfce37406e6 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$0ecef21ea2da6305$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $0ecef21ea2da6305$export$378d0cfce37406e6({
        getter: getter,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodLazy,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$7e44096782a165d3 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_literal,
                expected: this._def.value
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$0ecef21ea2da6305$export$7e44096782a165d3.create = (value, params)=>{
    return new $0ecef21ea2da6305$export$7e44096782a165d3({
        value: value,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodLiteral,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
function $0ecef21ea2da6305$var$createZodEnum(values, params) {
    return new $0ecef21ea2da6305$export$d325d1f0e1c20179({
        values: values,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodEnum,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
}
class $0ecef21ea2da6305$export$d325d1f0e1c20179 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                expected: (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_enum_value,
                options: expectedValues
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $0ecef21ea2da6305$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $0ecef21ea2da6305$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$0ecef21ea2da6305$export$d325d1f0e1c20179.create = $0ecef21ea2da6305$var$createZodEnum;
class $0ecef21ea2da6305$export$370b2e8d6d6f5c56 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).string && ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).number) {
            const expectedValues = (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectValues(nativeEnumValues);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                expected: (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        if (!this._cache) this._cache = new Set((0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).objectValues(nativeEnumValues);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                received: ctx.data,
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_enum_value,
                options: expectedValues
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$0ecef21ea2da6305$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $0ecef21ea2da6305$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodNativeEnum,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$3f196b0127d6e50a extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).promise && ctx.common.async === false) {
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).promise,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$0ecef21ea2da6305$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $0ecef21ea2da6305$export$3f196b0127d6e50a({
        type: schema,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodPromise,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$a60af00cc0ce2582 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $0ecef21ea2da6305$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                if (result.status === "dirty") return (0, $a74aa2f75401a059$export$325a211da9693fcf)(result.value);
                if (status.value === "dirty") return (0, $a74aa2f75401a059$export$325a211da9693fcf)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                if (result.status === "dirty") return (0, $a74aa2f75401a059$export$325a211da9693fcf)(result.value);
                if (status.value === "dirty") return (0, $a74aa2f75401a059$export$325a211da9693fcf)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $a74aa2f75401a059$export$1ea939691cdc45b8)(base)) return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $a74aa2f75401a059$export$1ea939691cdc45b8)(base)) return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $c4553a5d3ce9fa3e$export$7debb50ef11d5e0b).assertNever(effect);
    }
}
$0ecef21ea2da6305$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $0ecef21ea2da6305$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
$0ecef21ea2da6305$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $0ecef21ea2da6305$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodEffects,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$aa56fec1e9d629b8 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).undefined) return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$0ecef21ea2da6305$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $0ecef21ea2da6305$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodOptional,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$aaac0b8b429cef5 extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).null) return (0, $a74aa2f75401a059$export$c6813a8d51f77eaf)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$0ecef21ea2da6305$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $0ecef21ea2da6305$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodNullable,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$bb19b37874861e7e extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$0ecef21ea2da6305$export$bb19b37874861e7e.create = (type, params)=>{
    return new $0ecef21ea2da6305$export$bb19b37874861e7e({
        innerType: type,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$75a44ec6249ac76b extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $a74aa2f75401a059$export$aefee5ebe1dcfd9e)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $8f906c871d115551$export$f98dac4b251ab333)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $8f906c871d115551$export$f98dac4b251ab333)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$0ecef21ea2da6305$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $0ecef21ea2da6305$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
class $0ecef21ea2da6305$export$26ccfa0145e8511f extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $a74aa2f75401a059$export$db7caee60e5d514d)(ctx, {
                code: (0, $8f906c871d115551$export$5ba560653e4a1035).invalid_type,
                expected: (0, $c4553a5d3ce9fa3e$export$5716da67bfaa244d).nan,
                received: ctx.parsedType
            });
            return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$0ecef21ea2da6305$export$26ccfa0145e8511f.create = (params)=>{
    return new $0ecef21ea2da6305$export$26ccfa0145e8511f({
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodNaN,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
const $0ecef21ea2da6305$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $0ecef21ea2da6305$export$66b0c798a395271f extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $0ecef21ea2da6305$export$a3c3ef8a0e95c6da extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $a74aa2f75401a059$export$325a211da9693fcf)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $a74aa2f75401a059$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $0ecef21ea2da6305$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $0ecef21ea2da6305$export$5d1f7ef05c4e493a extends $0ecef21ea2da6305$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $a74aa2f75401a059$export$1ea939691cdc45b8)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $a74aa2f75401a059$export$aefee5ebe1dcfd9e)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$0ecef21ea2da6305$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $0ecef21ea2da6305$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $0ecef21ea2da6305$export$558106ce543bd011.ZodReadonly,
        ...$0ecef21ea2da6305$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $0ecef21ea2da6305$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $0ecef21ea2da6305$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $0ecef21ea2da6305$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $0ecef21ea2da6305$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $0ecef21ea2da6305$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $0ecef21ea2da6305$export$b9d1edb536b4e4eb.create();
}
const $0ecef21ea2da6305$export$1ee8ee30835eab8b = {
    object: $0ecef21ea2da6305$export$736315c5b55efbad.lazycreate
};
var $0ecef21ea2da6305$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($0ecef21ea2da6305$export$558106ce543bd011 || ($0ecef21ea2da6305$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $0ecef21ea2da6305$var$Class {
    constructor(..._){}
}
const $0ecef21ea2da6305$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$0ecef21ea2da6305$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $0ecef21ea2da6305$export$22b082955e083ec3 = $0ecef21ea2da6305$export$1230eb29b8d3b502.create;
const $0ecef21ea2da6305$export$98e628dec113755e = $0ecef21ea2da6305$export$5b070a55c0c43e09.create;
const $0ecef21ea2da6305$export$9e06de0973666692 = $0ecef21ea2da6305$export$26ccfa0145e8511f.create;
const $0ecef21ea2da6305$export$a0f65b52274bcc00 = $0ecef21ea2da6305$export$67d741fd70ff98f4.create;
const $0ecef21ea2da6305$export$4a21f16c33752377 = $0ecef21ea2da6305$export$723d146f80596191.create;
const $0ecef21ea2da6305$export$324d90190a8b822a = $0ecef21ea2da6305$export$e974be33bdc55521.create;
const $0ecef21ea2da6305$export$8f701197936bc2a6 = $0ecef21ea2da6305$export$bcc3b40f6b638044.create;
const $0ecef21ea2da6305$export$1db45310990710a5 = $0ecef21ea2da6305$export$4e780e961c30340d.create;
const $0ecef21ea2da6305$export$7b1b591b262c240 = $0ecef21ea2da6305$export$a96281f914484f2d.create;
const $0ecef21ea2da6305$export$4154a199d7d90455 = $0ecef21ea2da6305$export$b9d1edb536b4e4eb.create;
const $0ecef21ea2da6305$export$19282c40b967aec6 = $0ecef21ea2da6305$export$ef3b1bb1630977ae.create;
const $0ecef21ea2da6305$export$b3e22bcfd64c1022 = $0ecef21ea2da6305$export$1e576a20c3ce9fb5.create;
const $0ecef21ea2da6305$export$490e536ee7389aeb = $0ecef21ea2da6305$export$7d39f5df85f21031.create;
const $0ecef21ea2da6305$export$2f23118c22fb2630 = $0ecef21ea2da6305$export$7acfc3e64785411.create;
const $0ecef21ea2da6305$export$be5493f9613cbbe = $0ecef21ea2da6305$export$736315c5b55efbad.create;
const $0ecef21ea2da6305$export$8fb0df5f40d0b477 = $0ecef21ea2da6305$export$736315c5b55efbad.strictCreate;
const $0ecef21ea2da6305$export$971dd5b0dfd021b6 = $0ecef21ea2da6305$export$a8b236cb5070a311.create;
const $0ecef21ea2da6305$export$4b888e40c4ee26dd = $0ecef21ea2da6305$export$5ef2424805ac76a3.create;
const $0ecef21ea2da6305$export$bc86dfbf7795668c = $0ecef21ea2da6305$export$c02deaf0bb5203d4.create;
const $0ecef21ea2da6305$export$65e3907585753458 = $0ecef21ea2da6305$export$e2a18bb771d8e6a3.create;
const $0ecef21ea2da6305$export$e5185e241753e543 = $0ecef21ea2da6305$export$a2acc09968cb4b7f.create;
const $0ecef21ea2da6305$export$871de8747c9eaa88 = $0ecef21ea2da6305$export$163b6a2b712d9542.create;
const $0ecef21ea2da6305$export$adaa4cf7ef1b65be = $0ecef21ea2da6305$export$977057706f816712.create;
const $0ecef21ea2da6305$export$44e51c8aac7c2deb = $0ecef21ea2da6305$export$d4602ba55673f53c.create;
const $0ecef21ea2da6305$export$488013bae63b21da = $0ecef21ea2da6305$export$378d0cfce37406e6.create;
const $0ecef21ea2da6305$export$c8ec6e1ec9fefcb0 = $0ecef21ea2da6305$export$7e44096782a165d3.create;
const $0ecef21ea2da6305$export$78a99c8d44d72635 = $0ecef21ea2da6305$export$d325d1f0e1c20179.create;
const $0ecef21ea2da6305$export$6fe7eca19ebe5199 = $0ecef21ea2da6305$export$370b2e8d6d6f5c56.create;
const $0ecef21ea2da6305$export$c957ef27a0ebfd4 = $0ecef21ea2da6305$export$3f196b0127d6e50a.create;
const $0ecef21ea2da6305$export$dc573d8a6576cdb3 = $0ecef21ea2da6305$export$a60af00cc0ce2582.create;
const $0ecef21ea2da6305$export$516e28dec6a4b6d4 = $0ecef21ea2da6305$export$aa56fec1e9d629b8.create;
const $0ecef21ea2da6305$export$133fc36489ac9add = $0ecef21ea2da6305$export$aaac0b8b429cef5.create;
const $0ecef21ea2da6305$export$fc37fe19dfda43ee = $0ecef21ea2da6305$export$a60af00cc0ce2582.createWithPreprocess;
const $0ecef21ea2da6305$export$43f28b24e1eb8181 = $0ecef21ea2da6305$export$a3c3ef8a0e95c6da.create;
const $0ecef21ea2da6305$export$3b3d07727c5b702c = ()=>$0ecef21ea2da6305$export$22b082955e083ec3().optional();
const $0ecef21ea2da6305$export$eb150471a61fced6 = ()=>$0ecef21ea2da6305$export$98e628dec113755e().optional();
const $0ecef21ea2da6305$export$269251733cdcbbf1 = ()=>$0ecef21ea2da6305$export$4a21f16c33752377().optional();
const $0ecef21ea2da6305$export$8c14e57e778d3873 = {
    string: (arg)=>$0ecef21ea2da6305$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$0ecef21ea2da6305$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$0ecef21ea2da6305$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$0ecef21ea2da6305$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$0ecef21ea2da6305$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $0ecef21ea2da6305$export$96c94437c95d7862 = (0, $a74aa2f75401a059$export$9a105a556e65c2c0);




var $itHdT = parcelRequire("itHdT");



var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");


const $9ab7c99fd1b792dc$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).elementType
};
const $9ab7c99fd1b792dc$var$Feedback = /*#__PURE__*/ $itHdT.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$9ab7c99fd1b792dc$var$Feedback.displayName = 'Feedback';
$9ab7c99fd1b792dc$var$Feedback.propTypes = $9ab7c99fd1b792dc$var$propTypes;
var $9ab7c99fd1b792dc$export$2e2bcd8739ae039 = $9ab7c99fd1b792dc$var$Feedback;




var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
"use client";
// TODO
const $394d79ec0764dcd8$var$FormContext = /*#__PURE__*/ $itHdT.createContext({});
var $394d79ec0764dcd8$export$2e2bcd8739ae039 = $394d79ec0764dcd8$var$FormContext;




"use client";
const $c98421f7b1cc2c8b$var$FormCheckInput = /*#__PURE__*/ $itHdT.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $itHdT.useContext)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039));
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$c98421f7b1cc2c8b$var$FormCheckInput.displayName = 'FormCheckInput';
var $c98421f7b1cc2c8b$export$2e2bcd8739ae039 = $c98421f7b1cc2c8b$var$FormCheckInput;




var $itHdT = parcelRequire("itHdT");



"use client";
const $1a875d56d87629ee$var$FormCheckLabel = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $itHdT.useContext)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039));
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix)
    });
});
$1a875d56d87629ee$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $1a875d56d87629ee$export$2e2bcd8739ae039 = $1a875d56d87629ee$var$FormCheckLabel;





var $itHdT = parcelRequire("itHdT");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $df3ba9d3de1728c5$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $itHdT.Children.map(children, (child)=>/*#__PURE__*/ $itHdT.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $df3ba9d3de1728c5$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $itHdT.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $itHdT.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $df3ba9d3de1728c5$export$500fd6099226ffae(children, type) {
    return $itHdT.Children.toArray(children).some((child)=>/*#__PURE__*/ $itHdT.isValidElement(child) && child.type === type);
}



"use client";
const $99e1a808fc2109d9$var$FormCheck = /*#__PURE__*/ $itHdT.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $itHdT.useContext)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039));
    const innerFormContext = (0, $itHdT.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $df3ba9d3de1728c5$export$500fd6099226ffae)(children, (0, $1a875d56d87629ee$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c98421f7b1cc2c8b$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1a875d56d87629ee$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9ab7c99fd1b792dc$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$99e1a808fc2109d9$var$FormCheck.displayName = 'FormCheck';
var $99e1a808fc2109d9$export$2e2bcd8739ae039 = Object.assign($99e1a808fc2109d9$var$FormCheck, {
    Input: (0, $c98421f7b1cc2c8b$export$2e2bcd8739ae039),
    Label: (0, $1a875d56d87629ee$export$2e2bcd8739ae039)
});




var $itHdT = parcelRequire("itHdT");





"use client";
const $26a6f755a0a770ee$var$FormControl = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $itHdT.useContext)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039));
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$26a6f755a0a770ee$var$FormControl.displayName = 'FormControl';
var $26a6f755a0a770ee$export$2e2bcd8739ae039 = Object.assign($26a6f755a0a770ee$var$FormControl, {
    Feedback: $9ab7c99fd1b792dc$export$2e2bcd8739ae039
});



var $itHdT = parcelRequire("itHdT");



"use client";
const $38fc1044913bc4ee$var$FormFloating = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$38fc1044913bc4ee$var$FormFloating.displayName = 'FormFloating';
var $38fc1044913bc4ee$export$2e2bcd8739ae039 = $38fc1044913bc4ee$var$FormFloating;



var $itHdT = parcelRequire("itHdT");


const $0af9230807a3996c$var$FormGroup = /*#__PURE__*/ $itHdT.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $itHdT.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$0af9230807a3996c$var$FormGroup.displayName = 'FormGroup';
var $0af9230807a3996c$export$2e2bcd8739ae039 = $0af9230807a3996c$var$FormGroup;




var $itHdT = parcelRequire("itHdT");



var $itHdT = parcelRequire("itHdT");


"use client";
function $331b7ee3bbcced71$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $064b812fd356008a$export$8970c8db816a5863)();
    const minBreakpoint = (0, $064b812fd356008a$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $331b7ee3bbcced71$var$Col = /*#__PURE__*/ $itHdT.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $331b7ee3bbcced71$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, !spans.length && bsPrefix)
    });
});
$331b7ee3bbcced71$var$Col.displayName = 'Col';
var $331b7ee3bbcced71$export$2e2bcd8739ae039 = $331b7ee3bbcced71$var$Col;





"use client";
const $d29a204a56177e52$var$FormLabel = /*#__PURE__*/ $itHdT.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $itHdT.useContext)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039));
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $331b7ee3bbcced71$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$d29a204a56177e52$var$FormLabel.displayName = 'FormLabel';
var $d29a204a56177e52$export$2e2bcd8739ae039 = $d29a204a56177e52$var$FormLabel;




var $itHdT = parcelRequire("itHdT");



"use client";
const $b1c55c2507a9cf89$var$FormRange = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $itHdT.useContext)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039));
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$b1c55c2507a9cf89$var$FormRange.displayName = 'FormRange';
var $b1c55c2507a9cf89$export$2e2bcd8739ae039 = $b1c55c2507a9cf89$var$FormRange;




var $itHdT = parcelRequire("itHdT");



"use client";
const $37407817d0db383d$var$FormSelect = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $itHdT.useContext)((0, $394d79ec0764dcd8$export$2e2bcd8739ae039));
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$37407817d0db383d$var$FormSelect.displayName = 'FormSelect';
var $37407817d0db383d$export$2e2bcd8739ae039 = $37407817d0db383d$var$FormSelect;




var $itHdT = parcelRequire("itHdT");


"use client";
const $761f0927bd857463$var$FormText = /*#__PURE__*/ $itHdT.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$761f0927bd857463$var$FormText.displayName = 'FormText';
var $761f0927bd857463$export$2e2bcd8739ae039 = $761f0927bd857463$var$FormText;



var $itHdT = parcelRequire("itHdT");


const $c17f47e17db5ca7d$var$Switch = /*#__PURE__*/ $itHdT.forwardRef((props, ref)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $99e1a808fc2109d9$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$c17f47e17db5ca7d$var$Switch.displayName = 'Switch';
var $c17f47e17db5ca7d$export$2e2bcd8739ae039 = Object.assign($c17f47e17db5ca7d$var$Switch, {
    Input: (0, $99e1a808fc2109d9$export$2e2bcd8739ae039).Input,
    Label: (0, $99e1a808fc2109d9$export$2e2bcd8739ae039).Label
});




var $itHdT = parcelRequire("itHdT");



"use client";
const $d8af6b5132674c9f$var$FloatingLabel = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0af9230807a3996c$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$d8af6b5132674c9f$var$FloatingLabel.displayName = 'FloatingLabel';
var $d8af6b5132674c9f$export$2e2bcd8739ae039 = $d8af6b5132674c9f$var$FloatingLabel;



const $6cb539fda66d64c0$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).elementType
};
const $6cb539fda66d64c0$var$Form = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, validated && 'was-validated')
    }));
$6cb539fda66d64c0$var$Form.displayName = 'Form';
$6cb539fda66d64c0$var$Form.propTypes = $6cb539fda66d64c0$var$propTypes;
var $6cb539fda66d64c0$export$2e2bcd8739ae039 = Object.assign($6cb539fda66d64c0$var$Form, {
    Group: (0, $0af9230807a3996c$export$2e2bcd8739ae039),
    Control: (0, $26a6f755a0a770ee$export$2e2bcd8739ae039),
    Floating: (0, $38fc1044913bc4ee$export$2e2bcd8739ae039),
    Check: (0, $99e1a808fc2109d9$export$2e2bcd8739ae039),
    Switch: $c17f47e17db5ca7d$export$2e2bcd8739ae039,
    Label: (0, $d29a204a56177e52$export$2e2bcd8739ae039),
    Text: (0, $761f0927bd857463$export$2e2bcd8739ae039),
    Range: (0, $b1c55c2507a9cf89$export$2e2bcd8739ae039),
    Select: (0, $37407817d0db383d$export$2e2bcd8739ae039),
    FloatingLabel: $d8af6b5132674c9f$export$2e2bcd8739ae039
});


const $4c5bf82a8769709c$export$a67d8389fb37ab06 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).forwardRef(({ checked: checked, ...props }, ref)=>{
    const innerRef = (0, $itHdT.useRef)(null);
    // Prefer the forwarded ref if provided, otherwise use our own
    const resolvedRef = ref ?? innerRef;
    (0, $itHdT.useEffect)(()=>{
        if (resolvedRef.current) resolvedRef.current.indeterminate = checked === undefined;
    }, [
        checked,
        resolvedRef
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Check, {
        ...props,
        ref: resolvedRef,
        checked: !!checked,
        type: "checkbox"
    });
});
$4c5bf82a8769709c$export$a67d8389fb37ab06.displayName = "IndeterminateCheckbox";


const $fdc1026103b282ad$export$1655277b7107d364 = $0ecef21ea2da6305$export$e5185e241753e543($0ecef21ea2da6305$export$22b082955e083ec3(), $0ecef21ea2da6305$export$c8ec6e1ec9fefcb0(false));
const $fdc1026103b282ad$export$2afc421433b63e08 = {
    serialize: (state)=>Object.keys(state).join(","),
    deserialize: (encoded)=>Object.fromEntries(encoded.split(",").filter(Boolean).map((key)=>[
                key,
                false
            ]))
};
function $fdc1026103b282ad$export$861d8392a5ba9dfb({ columns: columns, columnVisibility: columnVisibility, onColumnVisibilityChange: onColumnVisibilityChange }) {
    // Convert the column definitions into a simplified tree structure for rendering
    const { tree: tree, numLeaves: numLeaves } = $fdc1026103b282ad$var$buildColumnTree(columns, columnVisibility);
    // Count the number of hidden vs visible columns
    const numHiddenColumns = Object.values(columnVisibility).length;
    const numVisibleColumns = numLeaves - numHiddenColumns;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039), {
        autoClose: "outside",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Toggle, {
                variant: "secondary",
                size: "sm",
                children: [
                    "Columns ",
                    numHiddenColumns > 0 ? `(${numVisibleColumns.toFixed()} / ${numLeaves.toFixed()} selected)` : ""
                ]
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Menu, {
                style: {
                    maxHeight: 300,
                    overflowY: "auto",
                    padding: "0.5rem"
                },
                children: tree.map((node)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).ItemText, {
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($fdc1026103b282ad$var$ColumnVisibilityNode, {
                            node: node,
                            columnVisibility: columnVisibility,
                            onColumnVisibilityChange: onColumnVisibilityChange
                        })
                    }, node.id))
            })
        ]
    });
}
/**
 * Recursively renders a node in the column visibility tree.
 */ const $fdc1026103b282ad$var$ColumnVisibilityNode = ({ node: node, columnVisibility: columnVisibility, onColumnVisibilityChange: onColumnVisibilityChange })=>{
    // Define a callback for the checkbox change event
    const onChange = (0, $itHdT.useCallback)(()=>{
        const newColumnVisibility = $fdc1026103b282ad$var$toggleColumnVisibility(node, columnVisibility);
        onColumnVisibilityChange(newColumnVisibility);
    }, [
        node,
        columnVisibility,
        onColumnVisibilityChange
    ]);
    // Do not render parent nodes that have no children
    if (node.type === "parent" && !node.children.length) return null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4c5bf82a8769709c$export$a67d8389fb37ab06), {
                id: `filter-col-visibility-${node.id}`,
                checked: node.checked,
                onChange: onChange,
                label: node.label
            }),
            node.children.length > 0 && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "ms-3",
                children: node.children.map((child)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($fdc1026103b282ad$var$ColumnVisibilityNode, {
                        node: child,
                        columnVisibility: columnVisibility,
                        onColumnVisibilityChange: onColumnVisibilityChange
                    }, child.id))
            })
        ]
    });
};
/**
 * Recursively build a tree structure from the column definitions for hierarchical visibility toggling.
 */ function $fdc1026103b282ad$var$buildColumnTree(columns, visibility) {
    let numLeaves = 0;
    const tree = columns.filter((col)=>col.enableHiding !== false).map((col)=>{
        // Determine the unique ID for the column
        // See: https://tanstack.com/table/latest/docs/guide/column-defs#unique-column-ids
        const id = "id" in col && col.id ? col.id : "accessorKey" in col ? col.accessorKey.toString().replaceAll(".", "_") : "header" in col && typeof col.header === "string" ? col.header : undefined;
        // Determine the column type
        const isParent = "columns" in col && col.columns;
        const type = isParent ? "parent" : "leaf";
        if (!isParent) numLeaves++;
        // Recursively build the tree for child columns
        const recursiveResult = $fdc1026103b282ad$var$buildColumnTree("columns" in col ? col.columns ?? [] : [], visibility);
        const children = recursiveResult.tree;
        numLeaves += recursiveResult.numLeaves;
        return {
            type: type,
            id: id,
            label: typeof col.header === "string" ? col.header : col.id ?? "",
            children: children
        };
    }).map((node)=>({
            ...node,
            checked: $fdc1026103b282ad$var$getNodeCheckedState(node, visibility)
        }));
    return {
        tree: tree,
        numLeaves: numLeaves
    };
}
/**
 * Determine the checked state for a node based on it's visibility or the visibility of its children.
 */ function $fdc1026103b282ad$var$getNodeCheckedState(node, columnVisibility) {
    // If this is a leaf node, return its visibility state directly
    // NOTE: If a visibility state for the column is not explicitly set, it defaults to true
    if (node.type === "leaf") return columnVisibility[node.id] !== false;
    // Parent node visibilities are determined by their children
    // If all children have the same visibility value, return that value
    // If children have mixed visibility, return undefined (indeterminate)
    const uniqueChildVisibilities = new Set(node.children.map((child)=>$fdc1026103b282ad$var$getNodeCheckedState(child, columnVisibility)));
    return uniqueChildVisibilities.size === 1 ? uniqueChildVisibilities.values().next().value : undefined;
}
/**
 * Toggle the visibility for a column and its children in the column tree.
 * @param node - The column node to toggle.
 * @param columnVisibility - The current visibility state of the columns. This object is not modified.
 * @returns A new visibility state object with the updated visibility.
 */ function $fdc1026103b282ad$var$toggleColumnVisibility(node, columnVisibility) {
    const newVisibility = {
        ...columnVisibility
    };
    $fdc1026103b282ad$var$toggleColumnVisibilityInternal(node, newVisibility);
    console.log("newVisibility", newVisibility);
    return newVisibility;
}
/**
 * Toggle the visibility for a column and its children in the column tree, modifying the visibility state in-place.
 */ function $fdc1026103b282ad$var$toggleColumnVisibilityInternal(node, columnVisibility, forceValue) {
    if (node.type === "leaf") {
        // For leaf nodes, update the node's visibility directly
        // NOTE: If visibility is true, set the value to undefined to indicate that the column is visible
        const newVisibility = forceValue !== undefined ? forceValue : !node.checked;
        if (newVisibility) delete columnVisibility[node.id]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
        else columnVisibility[node.id] = false;
    } else {
        // Determine the new visibility state for the parent node based on the current state
        // NOTE: Parent nodes can also be indeterminate (undefined) if their children have mixed visibility, in which case,
        //       we set the parent node to be visible (true) when toggling.
        const newVisibility = forceValue !== undefined ? forceValue : node.checked === undefined ? true : !node.checked;
        // Recursively update visibility for all children to the same value
        node.children.forEach((child)=>{
            $fdc1026103b282ad$var$toggleColumnVisibilityInternal(child, columnVisibility, newVisibility);
        });
    }
}



/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ 
var $itHdT = parcelRequire("itHdT");
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === 'function' ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $a7e41fd3cc0a83c1$export$8793edee2d425525() {
//
}
function $a7e41fd3cc0a83c1$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $a7e41fd3cc0a83c1$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $a7e41fd3cc0a83c1$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === 'number');
}
function $a7e41fd3cc0a83c1$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $a7e41fd3cc0a83c1$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = ' ' + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $a7e41fd3cc0a83c1$export$b1f82222dc43996c(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function $a7e41fd3cc0a83c1$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugCells', 'cell.getContext'))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
function $a7e41fd3cc0a83c1$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === 'function' ? accessorKey.replaceAll('.', '_') : accessorKey.replace(/\./g, '_') : undefined) != null ? _ref : typeof resolvedColumnDef.header === 'string' ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes('.')) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split('.')){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getFlatColumns')),
        getLeafColumns: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getLeafColumns'))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to unknown, because we know more than the compiler here.
    return column;
}
const $a7e41fd3cc0a83c1$var$debug = 'debugHeaders';
//
function $a7e41fd3cc0a83c1$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const $a7e41fd3cc0a83c1$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = $a7e41fd3cc0a83c1$export$d8c3a8af36458fc3(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getHeaderGroups'));
        table.getCenterHeaderGroups = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return $a7e41fd3cc0a83c1$export$d8c3a8af36458fc3(allColumns, leafColumns, table, 'center');
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getCenterHeaderGroups'));
        table.getLeftHeaderGroups = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return $a7e41fd3cc0a83c1$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'left');
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getLeftHeaderGroups'));
        table.getRightHeaderGroups = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return $a7e41fd3cc0a83c1$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'right');
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getRightHeaderGroups'));
        // Footer Groups
        table.getFooterGroups = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getFooterGroups'));
        table.getLeftFooterGroups = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getLeftFooterGroups'));
        table.getCenterFooterGroups = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getCenterFooterGroups'));
        table.getRightFooterGroups = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getRightFooterGroups'));
        // Flat Headers
        table.getFlatHeaders = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getFlatHeaders'));
        table.getLeftFlatHeaders = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getLeftFlatHeaders'));
        table.getCenterFlatHeaders = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getCenterFlatHeaders'));
        table.getRightFlatHeaders = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getRightFlatHeaders'));
        // Leaf Headers
        table.getCenterLeafHeaders = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getCenterLeafHeaders'));
        table.getLeftLeafHeaders = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getLeftLeafHeaders'));
        table.getRightLeafHeaders = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getRightLeafHeaders'));
        table.getLeafHeaders = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, $a7e41fd3cc0a83c1$var$debug, 'getLeafHeaders'));
    }
};
function $a7e41fd3cc0a83c1$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join('_'),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $a7e41fd3cc0a83c1$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join('_'),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$a7e41fd3cc0a83c1$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
const $a7e41fd3cc0a83c1$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$a7e41fd3cc0a83c1$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $a7e41fd3cc0a83c1$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCells')),
        _getAllCellsByColumnId: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCellsByColumnId'))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
//
const $a7e41fd3cc0a83c1$export$1f746e6a9cd841b1 = {
    createColumn: (column, table)=>{
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    }
};
const $a7e41fd3cc0a83c1$var$includesString = (row, columnId, filterValue)=>{
    var _filterValue$toString, _row$getValue;
    const search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
$a7e41fd3cc0a83c1$var$includesString.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val);
const $a7e41fd3cc0a83c1$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
$a7e41fd3cc0a83c1$var$includesStringSensitive.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val);
const $a7e41fd3cc0a83c1$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$a7e41fd3cc0a83c1$var$equalsString.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val);
const $a7e41fd3cc0a83c1$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$a7e41fd3cc0a83c1$var$arrIncludes.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val);
const $a7e41fd3cc0a83c1$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$a7e41fd3cc0a83c1$var$arrIncludesAll.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val) || !(val != null && val.length);
const $a7e41fd3cc0a83c1$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$a7e41fd3cc0a83c1$var$arrIncludesSome.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val) || !(val != null && val.length);
const $a7e41fd3cc0a83c1$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$a7e41fd3cc0a83c1$var$equals.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val);
const $a7e41fd3cc0a83c1$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$a7e41fd3cc0a83c1$var$weakEquals.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val);
const $a7e41fd3cc0a83c1$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$a7e41fd3cc0a83c1$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$a7e41fd3cc0a83c1$var$inNumberRange.autoRemove = (val)=>$a7e41fd3cc0a83c1$var$testFalsey(val) || $a7e41fd3cc0a83c1$var$testFalsey(val[0]) && $a7e41fd3cc0a83c1$var$testFalsey(val[1]);
// Export
const $a7e41fd3cc0a83c1$export$6ad8312e296ec316 = {
    includesString: $a7e41fd3cc0a83c1$var$includesString,
    includesStringSensitive: $a7e41fd3cc0a83c1$var$includesStringSensitive,
    equalsString: $a7e41fd3cc0a83c1$var$equalsString,
    arrIncludes: $a7e41fd3cc0a83c1$var$arrIncludes,
    arrIncludesAll: $a7e41fd3cc0a83c1$var$arrIncludesAll,
    arrIncludesSome: $a7e41fd3cc0a83c1$var$arrIncludesSome,
    equals: $a7e41fd3cc0a83c1$var$equals,
    weakEquals: $a7e41fd3cc0a83c1$var$weakEquals,
    inNumberRange: $a7e41fd3cc0a83c1$var$inNumberRange
};
// Utils
function $a7e41fd3cc0a83c1$var$testFalsey(val) {
    return val === undefined || val === null || val === '';
}
//
const $a7e41fd3cc0a83c1$export$f1d67534a0c5e9d3 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('columnFilters', table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return $a7e41fd3cc0a83c1$export$6ad8312e296ec316.includesString;
            if (typeof value === 'number') return $a7e41fd3cc0a83c1$export$6ad8312e296ec316.inNumberRange;
            if (typeof value === 'boolean') return $a7e41fd3cc0a83c1$export$6ad8312e296ec316.equals;
            if (value !== null && typeof value === 'object') return $a7e41fd3cc0a83c1$export$6ad8312e296ec316.equals;
            if (Array.isArray(value)) return $a7e41fd3cc0a83c1$export$6ad8312e296ec316.arrIncludes;
            return $a7e41fd3cc0a83c1$export$6ad8312e296ec316.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return $a7e41fd3cc0a83c1$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === 'auto' ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $a7e41fd3cc0a83c1$export$6ad8312e296ec316[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousFilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(value, previousFilter ? previousFilter.value : undefined);
                //
                if ($a7e41fd3cc0a83c1$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousFilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
    },
    createRow: (row, _table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if ($a7e41fd3cc0a83c1$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
    }
};
function $a7e41fd3cc0a83c1$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === 'undefined' || typeof value === 'string' && !value;
}
const $a7e41fd3cc0a83c1$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === 'number' ? nextValue : 0);
    }, 0);
};
const $a7e41fd3cc0a83c1$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $a7e41fd3cc0a83c1$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $a7e41fd3cc0a83c1$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $a7e41fd3cc0a83c1$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $a7e41fd3cc0a83c1$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$a7e41fd3cc0a83c1$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $a7e41fd3cc0a83c1$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $a7e41fd3cc0a83c1$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $a7e41fd3cc0a83c1$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $a7e41fd3cc0a83c1$export$3aa4339120b8b25b = {
    sum: $a7e41fd3cc0a83c1$var$sum,
    min: $a7e41fd3cc0a83c1$var$min,
    max: $a7e41fd3cc0a83c1$var$max,
    extent: $a7e41fd3cc0a83c1$var$extent,
    mean: $a7e41fd3cc0a83c1$var$mean,
    median: $a7e41fd3cc0a83c1$var$median,
    unique: $a7e41fd3cc0a83c1$var$unique,
    uniqueCount: $a7e41fd3cc0a83c1$var$uniqueCount,
    count: $a7e41fd3cc0a83c1$var$count
};
//
const $a7e41fd3cc0a83c1$export$9c9247c655f92e74 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('grouping', table),
            groupedColumnMode: 'reorder'
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'number') return $a7e41fd3cc0a83c1$export$3aa4339120b8b25b.sum;
            if (Object.prototype.toString.call(value) === '[object Date]') return $a7e41fd3cc0a83c1$export$3aa4339120b8b25b.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return $a7e41fd3cc0a83c1$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === 'auto' ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $a7e41fd3cc0a83c1$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function $a7e41fd3cc0a83c1$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === 'remove') return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $a7e41fd3cc0a83c1$export$fec9c66cd0275c2c = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('columnOrder', table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = $a7e41fd3cc0a83c1$export$7c73462e0d25e514((position)=>[
                $a7e41fd3cc0a83c1$export$1d7c103713892a11(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', 'getIndex'));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = $a7e41fd3cc0a83c1$export$1d7c103713892a11(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = $a7e41fd3cc0a83c1$export$1d7c103713892a11(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return $a7e41fd3cc0a83c1$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
            }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', '_getOrderColumnsFn'));
    }
};
//
const $a7e41fd3cc0a83c1$var$getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const $a7e41fd3cc0a83c1$export$3563275ce70c4813 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $a7e41fd3cc0a83c1$var$getDefaultColumnPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('columnPinning', table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === 'right') {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === 'left') {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left: left, right: right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? 'left' : isRight ? 'right' : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.getCenterVisibleCells = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterVisibleCells'));
        row.getLeftVisibleCells = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'left'
                }));
            return cells;
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getLeftVisibleCells'));
        row.getRightVisibleCells = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'right'
                }));
            return cells;
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getRightVisibleCells'));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? $a7e41fd3cc0a83c1$var$getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $a7e41fd3cc0a83c1$var$getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', 'getLeftLeafColumns'));
        table.getRightLeafColumns = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', 'getRightLeafColumns'));
        table.getCenterLeafColumns = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', 'getCenterLeafColumns'));
    }
};
function $a7e41fd3cc0a83c1$var$safelyAccessDocument(_document) {
    return _document || (typeof document !== 'undefined' ? document : null);
}
//
//
const $a7e41fd3cc0a83c1$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $a7e41fd3cc0a83c1$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $a7e41fd3cc0a83c1$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $a7e41fd3cc0a83c1$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $a7e41fd3cc0a83c1$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: 'onEnd',
            columnResizeDirection: 'ltr',
            onColumnSizingChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('columnSizing', table),
            onColumnSizingInfoChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('columnSizingInfo', table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $a7e41fd3cc0a83c1$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $a7e41fd3cc0a83c1$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $a7e41fd3cc0a83c1$export$2f660993f4eb1f29.maxSize);
        };
        column.getStart = $a7e41fd3cc0a83c1$export$7c73462e0d25e514((position)=>[
                position,
                $a7e41fd3cc0a83c1$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', 'getStart'));
        column.getAfter = $a7e41fd3cc0a83c1$export$7c73462e0d25e514((position)=>[
                position,
                $a7e41fd3cc0a83c1$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', 'getAfter'));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if ($a7e41fd3cc0a83c1$var$isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = $a7e41fd3cc0a83c1$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== 'number') return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === 'rtl' ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset: deltaOffset,
                            deltaPercentage: deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === 'onChange' || eventType === 'end') table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset('move', clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset('end', clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = $a7e41fd3cc0a83c1$var$safelyAccessDocument(_contextDocument);
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener('mousemove', mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('mouseup', mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener('touchmove', touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('touchend', touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = $a7e41fd3cc0a83c1$export$4927b5943c7c0b4() ? {
                    passive: false
                } : false;
                if ($a7e41fd3cc0a83c1$var$isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener('touchmove', touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('touchend', touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener('mousemove', mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize: startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart: columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? $a7e41fd3cc0a83c1$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $a7e41fd3cc0a83c1$var$getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let $a7e41fd3cc0a83c1$var$passiveSupported = null;
function $a7e41fd3cc0a83c1$export$4927b5943c7c0b4() {
    if (typeof $a7e41fd3cc0a83c1$var$passiveSupported === 'boolean') return $a7e41fd3cc0a83c1$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop);
    } catch (err) {
        supported = false;
    }
    $a7e41fd3cc0a83c1$var$passiveSupported = supported;
    return $a7e41fd3cc0a83c1$var$passiveSupported;
}
function $a7e41fd3cc0a83c1$var$isTouchStartEvent(e) {
    return e.type === 'touchstart';
}
//
const $a7e41fd3cc0a83c1$export$be5545a32e20d889 = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('columnVisibility', table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _ref, _table$getState$colum;
            const childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some((c)=>c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', '_getAllVisibleCells'));
        row.getVisibleCells = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getVisibleCells'));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join('_')
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugColumns', key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod('getVisibleFlatColumns', ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod('getVisibleLeafColumns', ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod('getLeftVisibleLeafColumns', ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod('getRightVisibleLeafColumns', ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod('getCenterVisibleLeafColumns', ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function $a7e41fd3cc0a83c1$export$1d7c103713892a11(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === 'center' ? table.getCenterVisibleLeafColumns() : position === 'left' ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
//
const $a7e41fd3cc0a83c1$export$4b37edcdc7ad2fe1 = {
    createTable: (table)=>{
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__');
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, '__global__');
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, '__global__');
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
//
const $a7e41fd3cc0a83c1$export$61e9e0661ff79b1c = {
    getInitialState: (state)=>{
        return {
            globalFilter: undefined,
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGlobalFilterChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('globalFilter', table),
            globalFilterFn: 'auto',
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === 'string' || typeof value === 'number';
            }
        };
    },
    createColumn: (column, table)=>{
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
            return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return $a7e41fd3cc0a83c1$export$6ad8312e296ec316.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            const { globalFilterFn: globalFilterFn } = table.options;
            return $a7e41fd3cc0a83c1$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === 'auto' ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : $a7e41fd3cc0a83c1$export$6ad8312e296ec316[globalFilterFn];
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
    }
};
//
const $a7e41fd3cc0a83c1$export$fed54e0d64c17fb2 = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('expanded', table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === 'boolean') return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split('.');
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
//
const $a7e41fd3cc0a83c1$var$defaultPageIndex = 0;
const $a7e41fd3cc0a83c1$var$defaultPageSize = 10;
const $a7e41fd3cc0a83c1$var$getDefaultPaginationState = ()=>({
        pageIndex: $a7e41fd3cc0a83c1$var$defaultPageIndex,
        pageSize: $a7e41fd3cc0a83c1$var$defaultPageSize
    });
const $a7e41fd3cc0a83c1$export$bce540641752d22b = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$a7e41fd3cc0a83c1$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('pagination', table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? $a7e41fd3cc0a83c1$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $a7e41fd3cc0a83c1$var$getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex: pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? $a7e41fd3cc0a83c1$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : $a7e41fd3cc0a83c1$var$defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? $a7e41fd3cc0a83c1$var$defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : $a7e41fd3cc0a83c1$var$defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex: pageIndex,
                    pageSize: pageSize
                };
            });
        };
        //deprecated
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === 'number') newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getPageOptions'));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex: pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.firstPage = ()=>{
            return table.setPageIndex(0);
        };
        table.lastPage = ()=>{
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = ()=>{
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
const $a7e41fd3cc0a83c1$var$getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const $a7e41fd3cc0a83c1$export$213d72cb2ac7d440 = {
    getInitialState: (state)=>{
        return {
            rowPinning: $a7e41fd3cc0a83c1$var$getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowPinningChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('rowPinning', table)
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref)=>{
                let { id: id } = _ref;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2)=>{
                let { id: id } = _ref2;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === 'bottom') {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === 'top') {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref3;
            const { enableRowPinning: enableRowPinning, enablePinning: enablePinning } = table.options;
            if (typeof enableRowPinning === 'function') return enableRowPinning(row);
            return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top: top, bottom: bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? 'top' : isBottom ? 'bottom' : false;
        };
        row.getPinnedIndex = ()=>{
            var _ref4, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_ref4 = position === 'top' ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map((_ref5)=>{
                let { id: id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
    },
    createTable: (table)=>{
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState;
            return table.setRowPinning(defaultState ? $a7e41fd3cc0a83c1$var$getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : $a7e41fd3cc0a83c1$var$getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table._getPinnedRows = (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position: position
                }));
        };
        table.getTopRows = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top
            ], (allRows, topPinnedRowIds)=>table._getPinnedRows(allRows, topPinnedRowIds, 'top'), $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getTopRows'));
        table.getBottomRows = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.bottom
            ], (allRows, bottomPinnedRowIds)=>table._getPinnedRows(allRows, bottomPinnedRowIds, 'bottom'), $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getBottomRows'));
        table.getCenterRows = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterRows'));
    }
};
//
const $a7e41fd3cc0a83c1$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('rowSelection', table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    $a7e41fd3cc0a83c1$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a7e41fd3cc0a83c1$export$f150e72530556b0b(table, rowModel);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getSelectedRowModel'));
        table.getFilteredSelectedRowModel = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a7e41fd3cc0a83c1$export$f150e72530556b0b(table, rowModel);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredSelectedRowModel'));
        table.getGroupedSelectedRowModel = $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a7e41fd3cc0a83c1$export$f150e72530556b0b(table, rowModel);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedSelectedRowModel'));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection: rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection: rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== 'undefined' ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                $a7e41fd3cc0a83c1$var$mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a7e41fd3cc0a83c1$export$710e11cf672b86c(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a7e41fd3cc0a83c1$export$8f4c46e5d7907334(row, rowSelection) === 'some';
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a7e41fd3cc0a83c1$export$8f4c46e5d7907334(row, rowSelection) === 'all';
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === 'function') return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === 'function') return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === 'function') return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const $a7e41fd3cc0a83c1$var$mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$a7e41fd3cc0a83c1$var$mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function $a7e41fd3cc0a83c1$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $a7e41fd3cc0a83c1$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $a7e41fd3cc0a83c1$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $a7e41fd3cc0a83c1$export$8f4c46e5d7907334(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if ($a7e41fd3cc0a83c1$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = $a7e41fd3cc0a83c1$export$8f4c46e5d7907334(subRow, selection);
            if (subRowChildrenSelected === 'all') someSelected = true;
            else if (subRowChildrenSelected === 'some') {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
}
const $a7e41fd3cc0a83c1$export$8758689f50bddb9f = /([0-9]+)/gm;
const $a7e41fd3cc0a83c1$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $a7e41fd3cc0a83c1$var$compareAlphanumeric($a7e41fd3cc0a83c1$var$toString(rowA.getValue(columnId)).toLowerCase(), $a7e41fd3cc0a83c1$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $a7e41fd3cc0a83c1$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $a7e41fd3cc0a83c1$var$compareAlphanumeric($a7e41fd3cc0a83c1$var$toString(rowA.getValue(columnId)), $a7e41fd3cc0a83c1$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $a7e41fd3cc0a83c1$var$text = (rowA, rowB, columnId)=>{
    return $a7e41fd3cc0a83c1$var$compareBasic($a7e41fd3cc0a83c1$var$toString(rowA.getValue(columnId)).toLowerCase(), $a7e41fd3cc0a83c1$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $a7e41fd3cc0a83c1$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $a7e41fd3cc0a83c1$var$compareBasic($a7e41fd3cc0a83c1$var$toString(rowA.getValue(columnId)), $a7e41fd3cc0a83c1$var$toString(rowB.getValue(columnId)));
};
const $a7e41fd3cc0a83c1$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $a7e41fd3cc0a83c1$var$basic = (rowA, rowB, columnId)=>{
    return $a7e41fd3cc0a83c1$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $a7e41fd3cc0a83c1$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $a7e41fd3cc0a83c1$var$toString(a) {
    if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) return '';
        return String(a);
    }
    if (typeof a === 'string') return a;
    return '';
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $a7e41fd3cc0a83c1$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($a7e41fd3cc0a83c1$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($a7e41fd3cc0a83c1$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $a7e41fd3cc0a83c1$export$47423a4cd813a815 = {
    alphanumeric: $a7e41fd3cc0a83c1$var$alphanumeric,
    alphanumericCaseSensitive: $a7e41fd3cc0a83c1$var$alphanumericCaseSensitive,
    text: $a7e41fd3cc0a83c1$var$text,
    textCaseSensitive: $a7e41fd3cc0a83c1$var$textCaseSensitive,
    datetime: $a7e41fd3cc0a83c1$var$datetime,
    basic: $a7e41fd3cc0a83c1$var$basic
};
//
const $a7e41fd3cc0a83c1$export$c7de5ec16c5efba8 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: 'auto',
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $a7e41fd3cc0a83c1$export$2b5605d8069324bd('sorting', table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === '[object Date]') return $a7e41fd3cc0a83c1$export$47423a4cd813a815.datetime;
                if (typeof value === 'string') {
                    isString = true;
                    if (value.split($a7e41fd3cc0a83c1$export$8758689f50bddb9f).length > 1) return $a7e41fd3cc0a83c1$export$47423a4cd813a815.alphanumeric;
                }
            }
            if (isString) return $a7e41fd3cc0a83c1$export$47423a4cd813a815.text;
            return $a7e41fd3cc0a83c1$export$47423a4cd813a815.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return 'asc';
            return 'desc';
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return $a7e41fd3cc0a83c1$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === 'auto' ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $a7e41fd3cc0a83c1$export$47423a4cd813a815[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== 'undefined' && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc';
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'add';
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = 'replace';
                    else if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'replace';
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === 'toggle') {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = 'remove';
                    }
                }
                if (sortAction === 'add') {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === 'toggle') // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === 'remove') newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === 'desc';
            return sortDescFirst ? 'desc' : 'asc';
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === 'desc' ? 'asc' : 'desc';
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
const $a7e41fd3cc0a83c1$var$builtInFeatures = [
    $a7e41fd3cc0a83c1$export$79b704688b15c0f4,
    $a7e41fd3cc0a83c1$export$be5545a32e20d889,
    $a7e41fd3cc0a83c1$export$fec9c66cd0275c2c,
    $a7e41fd3cc0a83c1$export$3563275ce70c4813,
    $a7e41fd3cc0a83c1$export$1f746e6a9cd841b1,
    $a7e41fd3cc0a83c1$export$f1d67534a0c5e9d3,
    $a7e41fd3cc0a83c1$export$4b37edcdc7ad2fe1,
    //depends on ColumnFaceting
    $a7e41fd3cc0a83c1$export$61e9e0661ff79b1c,
    //depends on ColumnFiltering
    $a7e41fd3cc0a83c1$export$c7de5ec16c5efba8,
    $a7e41fd3cc0a83c1$export$9c9247c655f92e74,
    //depends on RowSorting
    $a7e41fd3cc0a83c1$export$fed54e0d64c17fb2,
    $a7e41fd3cc0a83c1$export$bce540641752d22b,
    $a7e41fd3cc0a83c1$export$213d72cb2ac7d440,
    $a7e41fd3cc0a83c1$export$e8905133e7bf3121,
    $a7e41fd3cc0a83c1$export$9916c85814812d4a
];
//
function $a7e41fd3cc0a83c1$export$33bbb3ec7652e187(options) {
    var _options$_features, _options$initialState;
    const _features = [
        ...$a7e41fd3cc0a83c1$var$builtInFeatures,
        ...(_options$_features = options._features) != null ? _options$_features : []
    ];
    let table = {
        _features: _features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: _features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $a7e41fd3cc0a83c1$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join('.') : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(options, 'debugColumns', '_getDefaultColumnDef')),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $a7e41fd3cc0a83c1$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(options, 'debugColumns', 'getAllColumns')),
        getAllFlatColumns: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumns')),
        _getAllFlatColumnsById: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumnsById')),
        getAllLeafColumns: $a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(options, 'debugColumns', 'getAllLeafColumns')),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function $a7e41fd3cc0a83c1$export$32d0bc001e828250() {
    return (table)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $a7e41fd3cc0a83c1$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getRowModel', ()=>table._autoResetPageIndex()));
}
function $a7e41fd3cc0a83c1$export$53cfec7b1b8d1fcd() {
    return (table)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $a7e41fd3cc0a83c1$export$1293f966cdb38633(rowModel);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getExpandedRowModel'));
}
function $a7e41fd3cc0a83c1$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $a7e41fd3cc0a83c1$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return undefined;
            const uniqueValues = facetedRowModel.flatRows.flatMap((flatRow)=>{
                var _flatRow$getUniqueVal;
                return (_flatRow$getUniqueVal = flatRow.getUniqueValues(columnId)) != null ? _flatRow$getUniqueVal : [];
            }).map(Number).filter((value)=>!Number.isNaN(value));
            if (!uniqueValues.length) return;
            let facetedMinValue = uniqueValues[0];
            let facetedMaxValue = uniqueValues[uniqueValues.length - 1];
            for (const value of uniqueValues){
                if (value < facetedMinValue) facetedMinValue = value;
                else if (value > facetedMaxValue) facetedMaxValue = value;
            }
            return [
                facetedMinValue,
                facetedMaxValue
            ];
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedMinMaxValues'));
}
function $a7e41fd3cc0a83c1$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $a7e41fd3cc0a83c1$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $a7e41fd3cc0a83c1$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $a7e41fd3cc0a83c1$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $a7e41fd3cc0a83c1$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $a7e41fd3cc0a83c1$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $a7e41fd3cc0a83c1$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $a7e41fd3cc0a83c1$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? '__global__' : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $a7e41fd3cc0a83c1$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedRowModel'));
}
function $a7e41fd3cc0a83c1$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', `getFacetedUniqueValues_${columnId}`));
}
function $a7e41fd3cc0a83c1$export$26f255a2756e1638() {
    return (table)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = (columnFilters != null ? columnFilters : []).map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push('__global__');
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $a7e41fd3cc0a83c1$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredRowModel', ()=>table._autoResetPageIndex()));
}
function $a7e41fd3cc0a83c1$export$2b7f4b57ce71b81() {
    return (table)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) {
                rowModel.rows.forEach((row)=>{
                    row.depth = 0;
                    row.parentId = undefined;
                });
                return rowModel;
            }
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $a7e41fd3cc0a83c1$var$groupBy(rows, columnId);
                // Perform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    subRows.forEach((subRow)=>{
                        subRow.parentId = id;
                    });
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $a7e41fd3cc0a83c1$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $a7e41fd3cc0a83c1$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedRowModel', ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function $a7e41fd3cc0a83c1$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $a7e41fd3cc0a83c1$export$ddfd3662e196c265(opts) {
    return (table)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $a7e41fd3cc0a83c1$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getPaginationRowModel'));
}
function $a7e41fd3cc0a83c1$export$4ca93ca80835d8c1() {
    return (table)=>$a7e41fd3cc0a83c1$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const sortUndefined = columnInfo.sortUndefined;
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) {
                                if (sortUndefined === 'first') return aUndefined ? -1 : 1;
                                if (sortUndefined === 'last') return aUndefined ? 1 : -1;
                                sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                            }
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, $a7e41fd3cc0a83c1$export$b1f82222dc43996c(table.options, 'debugTable', 'getSortedRowModel', ()=>table._autoResetPageIndex()));
}


//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function $846ffc19ca7303a9$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $846ffc19ca7303a9$var$isReactComponent(Comp) ? /*#__PURE__*/ $itHdT.createElement(Comp, props) : Comp;
}
function $846ffc19ca7303a9$var$isReactComponent(component) {
    return $846ffc19ca7303a9$var$isClassComponent(component) || typeof component === 'function' || $846ffc19ca7303a9$var$isExoticComponent(component);
}
function $846ffc19ca7303a9$var$isClassComponent(component) {
    return typeof component === 'function' && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $846ffc19ca7303a9$var$isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && [
        'react.memo',
        'react.forward_ref'
    ].includes(component.$$typeof.description);
}
function $846ffc19ca7303a9$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $itHdT.useState(()=>({
            current: (0, $a7e41fd3cc0a83c1$export$33bbb3ec7652e187)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $itHdT.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}




var $itHdT = parcelRequire("itHdT");



var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");

var $itHdT = parcelRequire("itHdT");
function $c5c4346a3f4fad52$export$2e2bcd8739ae039() {
    const mounted = (0, $itHdT.useRef)(true);
    const isMounted = (0, $itHdT.useRef)(()=>mounted.current);
    (0, $itHdT.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $itHdT = parcelRequire("itHdT");
function $2e5f4f8a19092d4f$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $itHdT.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $itHdT = parcelRequire("itHdT");
function $740c8f7c59afb438$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $2e5f4f8a19092d4f$export$2e2bcd8739ae039)(fn);
    (0, $itHdT.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $8d5875d2dd7d5a3e$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $8d5875d2dd7d5a3e$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $8d5875d2dd7d5a3e$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$8d5875d2dd7d5a3e$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $8d5875d2dd7d5a3e$var$MAX_DELAY_MS);
}
function $8d5875d2dd7d5a3e$export$2e2bcd8739ae039() {
    const isMounted = (0, $c5c4346a3f4fad52$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $itHdT.useRef)();
    (0, $740c8f7c59afb438$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $itHdT.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $8d5875d2dd7d5a3e$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $8d5875d2dd7d5a3e$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}







var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");







var $itHdT = parcelRequire("itHdT");



const $29acba1f8f83f25c$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $29acba1f8f83f25c$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $29acba1f8f83f25c$var$noop;
    (0, $7cd476a6b03997a6$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $fc9c376d766ce5b6$export$2e2bcd8739ae039)((e)=>{
        if ((0, $d6f37bf74aea038f$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $itHdT.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $c5bd197adfafb87d$export$2e2bcd8739ae039)((0, $7cd476a6b03997a6$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $697341c5b17243d6$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $29acba1f8f83f25c$export$2e2bcd8739ae039 = $29acba1f8f83f25c$var$useRootClose;





/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $c3267357ef9733e0$var$Overlay = /*#__PURE__*/ $itHdT.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $8c2e3326720988d4$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $8c2e3326720988d4$export$2e2bcd8739ae039)();
    const mergedRef = (0, $eed73de565f16b81$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $98ea167609896df6$export$2e2bcd8739ae039)(props.container);
    const target = (0, $98ea167609896df6$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $itHdT.useState)(!props.show);
    const popper = (0, $c773b670d4c3ff48$export$2e2bcd8739ae039)(target, rootElement, (0, $c3aee055b011a6e8$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $29acba1f8f83f25c$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $b12373dc327fb5b2$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f53291ba5372fee6$exports))).createPortal(child, container) : null;
});
$c3267357ef9733e0$var$Overlay.displayName = 'Overlay';
var $c3267357ef9733e0$export$2e2bcd8739ae039 = $c3267357ef9733e0$var$Overlay;






var $itHdT = parcelRequire("itHdT");




var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");



"use client";
const $2a100cc5f713652b$var$PopoverHeader = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$2a100cc5f713652b$var$PopoverHeader.displayName = 'PopoverHeader';
var $2a100cc5f713652b$export$2e2bcd8739ae039 = $2a100cc5f713652b$var$PopoverHeader;



var $itHdT = parcelRequire("itHdT");



"use client";
const $58c343b19381a4c0$var$PopoverBody = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$58c343b19381a4c0$var$PopoverBody.displayName = 'PopoverBody';
var $58c343b19381a4c0$export$2e2bcd8739ae039 = $58c343b19381a4c0$var$PopoverBody;



var $itHdT = parcelRequire("itHdT");
class $fca1c68920ede057$export$34582a676b91ff07 extends $itHdT.Component {
}
function $fca1c68920ede057$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $4f68f7b8d4d65690$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $53905517a09a4f32$var$Popover = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $064b812fd356008a$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $fca1c68920ede057$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $4f68f7b8d4d65690$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $58c343b19381a4c0$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$53905517a09a4f32$var$Popover.displayName = 'Popover';
var $53905517a09a4f32$export$2e2bcd8739ae039 = Object.assign($53905517a09a4f32$var$Popover, {
    Header: (0, $2a100cc5f713652b$export$2e2bcd8739ae039),
    Body: (0, $58c343b19381a4c0$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $itHdT = parcelRequire("itHdT");




"use client";
const $0cc7cb3366938b69$var$Tooltip = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $064b812fd356008a$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $fca1c68920ede057$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $4f68f7b8d4d65690$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$0cc7cb3366938b69$var$Tooltip.displayName = 'Tooltip';
var $0cc7cb3366938b69$export$2e2bcd8739ae039 = Object.assign($0cc7cb3366938b69$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $dc48cd877e62fd26$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $itHdT.useRef)(null);
    const popoverClass = (0, $064b812fd356008a$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $064b812fd356008a$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $itHdT.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $d24c125de4c96666$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $53905517a09a4f32$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $d24c125de4c96666$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $0cc7cb3366938b69$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}





"use client";
function $f88a1b87109a953a$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $a34b5afcf5d3f643$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $a34b5afcf5d3f643$export$2e2bcd8739ae039)(r)));
}
const $f88a1b87109a953a$var$Overlay = /*#__PURE__*/ $itHdT.forwardRef(({ children: overlay, transition: transition = (0, $eb31cd918b0fa60f$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $itHdT.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $itHdT.useState)(null);
    const [ref, modifiers] = (0, $dc48cd877e62fd26$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $2dff25418658288a$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $eb31cd918b0fa60f$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $153be9953ec91ab7$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $844e75cced394cc3$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $itHdT.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3267357ef9733e0$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $f88a1b87109a953a$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $itHdT.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$f88a1b87109a953a$var$Overlay.displayName = 'Overlay';
var $f88a1b87109a953a$export$2e2bcd8739ae039 = $f88a1b87109a953a$var$Overlay;




"use client";
function $c6324eb2ca8e9e2c$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $c6324eb2ca8e9e2c$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $f292680e7c6407e3$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $c6324eb2ca8e9e2c$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $c6324eb2ca8e9e2c$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $itHdT.useRef)(null);
    const mergedRef = (0, $2dff25418658288a$export$2e2bcd8739ae039)(triggerNodeRef, (0, $d6f37bf74aea038f$export$87943f2672146d57)(children));
    const timeout = (0, $8d5875d2dd7d5a3e$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $itHdT.useRef)('');
    const [show, setShow] = (0, $ebcd10849b756af0$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $c6324eb2ca8e9e2c$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $itHdT.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $a34b5afcf5d3f643$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $itHdT.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $itHdT.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $itHdT.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $itHdT.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $itHdT.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $itHdT.useCallback)((...args)=>{
        $c6324eb2ca8e9e2c$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $itHdT.useCallback)((...args)=>{
        $c6324eb2ca8e9e2c$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $itHdT.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f88a1b87109a953a$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $c6324eb2ca8e9e2c$export$2e2bcd8739ae039 = $c6324eb2ca8e9e2c$var$OverlayTrigger;



var $itHdT = parcelRequire("itHdT");


"use client";
const $8454c76e6b2ece98$var$Table = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$8454c76e6b2ece98$var$Table.displayName = 'Table';
var $8454c76e6b2ece98$export$2e2bcd8739ae039 = $8454c76e6b2ece98$var$Table;



var $itHdT = parcelRequire("itHdT");

const $e14cbc1cb5a764fe$export$fb8a00c97d9b99dd = (props)=>{
    const { as: NavTarget = "div", children: children, id: id, ...remainingProps } = props;
    const location = (0, $b634fe06a3f61222$export$45d76561a5302f2b)();
    const navTargetRef = (0, $itHdT.useRef)(null);
    (0, $itHdT.useEffect)(()=>{
        // Remove the '#' from the hash
        const hash = location.hash.slice(1);
        // Do nothing if the hash does not match the elementId or if the navTargetRef is not set
        if (hash !== id || !navTargetRef.current) return;
        const targetElem = navTargetRef.current;
        // Scroll to the target element. Wait a moment to ensure any layout changes are complete before scrolling.
        // Specifically, when scrolling to a table row, this gives time to allow the sticky header hight to be calculated
        const startScrollTimeout = setTimeout(()=>{
            targetElem.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }, 1);
        // Add a class to highlight the target element for a short duration
        // Wait a short time before adding the class to allow the scroll to complete
        const addClass = ()=>{
            targetElem.classList.add("hash-nav-scroll-target-highlight");
        };
        const removeClass = ()=>{
            targetElem.classList.remove("hash-nav-scroll-target-highlight");
        };
        const addClassTimeout = setTimeout(addClass, 300);
        const removeClassTimeout = setTimeout(removeClass, 5300);
        // Cleanup function to clear timeouts and remove the highlight class when the component unmounts or the hash changes
        return ()=>{
            clearTimeout(startScrollTimeout);
            clearTimeout(addClassTimeout);
            clearTimeout(removeClassTimeout);
            removeClass();
        };
    }, [
        location.hash,
        id
    ]);
    // Render the NavTarget (e.g., 'div', 'section', or a custom component type)
    // Apply the internally managed ref and the 'id' props; spread all other props
    const navTargetProps = {
        ref: navTargetRef,
        id: id,
        ...remainingProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).createElement(NavTarget, navTargetProps, children);
};



const $282cd4d039b346d2$export$df30df7ec97b32b5 = ({ data: data, columns: columns, getRowId: getRowId, state: state, initialState: initialState, meta: meta, showFooter: showFooter, getSubRows: getSubRows, onExpandedChange: onExpandedChange, ...tableProps })=>{
    const [showSkeleton, setShowSkeleton] = (0, $itHdT.useState)(true);
    // Use an effect to hide the skeleton rendered rows after the first render
    // The skeleton rows will continue to be displayed until React is able to process all the table data and render it
    (0, $itHdT.useEffect)(()=>{
        if (!showSkeleton) return;
        const timeout = setTimeout(()=>{
            setShowSkeleton(false);
        }, 0);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        showSkeleton
    ]);
    // Determine if sorting is enabled for the table
    const enableSorting = !!initialState?.sorting;
    const table = (0, $846ffc19ca7303a9$export$25eaeb3743e6b31f)({
        data: showSkeleton ? [] : data,
        columns: columns,
        getRowId: getRowId,
        state: state,
        initialState: initialState,
        meta: meta,
        getSubRows: getSubRows,
        getCoreRowModel: (0, $a7e41fd3cc0a83c1$export$32d0bc001e828250)(),
        getSortedRowModel: enableSorting ? (0, $a7e41fd3cc0a83c1$export$4ca93ca80835d8c1)() : undefined,
        getExpandedRowModel: getSubRows ? (0, $a7e41fd3cc0a83c1$export$53cfec7b1b8d1fcd)() : undefined,
        enableSortingRemoval: false,
        onExpandedChange: onExpandedChange
    });
    const rows = table.getRowModel().rows;
    const headerGroups = table.getHeaderGroups();
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $8454c76e6b2ece98$export$2e2bcd8739ae039), {
        size: "sm",
        ...tableProps,
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("thead", {
                children: headerGroups.map((headerGroup)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("tr", {
                        "data-header-group-id": headerGroup.id,
                        children: headerGroup.headers.map((header)=>{
                            // Get the sorting state and icon for the header
                            const canSort = enableSorting && header.column.getCanSort();
                            const isSorted = enableSorting && header.column.getIsSorted();
                            const sortIcon = !canSort ? null : isSorted === "asc" ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                icon: "caret-up-fill"
                            }) : isSorted === "desc" ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                icon: "caret-down-fill"
                            }) : null;
                            const sortIndex = header.column.getSortIndex();
                            const numSortedColumns = table.getState().sorting.length;
                            const sortIndexIndicator = isSorted && numSortedColumns > 1 ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("sup", {
                                children: sortIndex + 1
                            }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("sup", {
                                className: "invisible",
                                children: "0"
                            });
                            const sortSuffix = canSort ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                                children: [
                                    "\xa0",
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("pre", {
                                        className: "d-inline",
                                        children: [
                                            sortIcon,
                                            sortIndexIndicator
                                        ]
                                    })
                                ]
                            }) : null;
                            // Get custom header cell props, if defined
                            const headerCellPropsOpt = header.column.columnDef.meta?.headerCellProps;
                            const { className: className, ...headerCellProps } = typeof headerCellPropsOpt === "function" ? headerCellPropsOpt(header) : headerCellPropsOpt ?? {};
                            // Optionally render an icon with tooltip if helpText is provided in column meta
                            const helpText = header.column.columnDef.meta?.helpText;
                            const helpIcon = helpText && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                                trigger: [
                                    "hover",
                                    "focus"
                                ],
                                placement: "top",
                                overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                                        ...props,
                                        children: helpText
                                    }),
                                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                    icon: "info-circle",
                                    className: "ms-1"
                                })
                            });
                            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("th", {
                                "data-header-id": header.id,
                                colSpan: header.colSpan,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("text-center align-middle", className, {
                                    "cursor-pointer": canSort
                                }),
                                onClick: canSort ? header.column.getToggleSortingHandler() : undefined,
                                ...headerCellProps,
                                children: !header.isPlaceholder && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                                    children: [
                                        (0, $846ffc19ca7303a9$export$f2385bb6e3ac4b4f)(header.column.columnDef.header, header.getContext()),
                                        helpIcon,
                                        sortSuffix
                                    ]
                                })
                            }, header.id);
                        })
                    }, headerGroup.id))
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("tbody", {
                className: "table-group-divider",
                children: showSkeleton ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($282cd4d039b346d2$var$SkeletonRows, {
                    numCols: headerGroups.slice(-1)[0].headers.length
                }) : rows.length === 0 ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($282cd4d039b346d2$var$NoDataRow, {
                    numCols: headerGroups.slice(-1)[0].headers.length
                }) : rows.map((row)=>{
                    const rowPropsOpt = meta?.dataRowProps;
                    const rowProps = typeof rowPropsOpt === "function" ? rowPropsOpt(row) : rowPropsOpt ?? {};
                    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $e14cbc1cb5a764fe$export$fb8a00c97d9b99dd), {
                        as: "tr",
                        id: row.id,
                        ...rowProps,
                        children: row.getVisibleCells().map((cell)=>{
                            const cellPropsOpt = cell.column.columnDef.meta?.cellProps;
                            const cellProps = typeof cellPropsOpt === "function" ? cellPropsOpt(cell) : cellPropsOpt ?? {};
                            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("td", {
                                ...cellProps,
                                children: (0, $846ffc19ca7303a9$export$f2385bb6e3ac4b4f)(cell.column.columnDef.cell, cell.getContext())
                            }, cell.id);
                        })
                    }, row.id);
                })
            }),
            showFooter && !showSkeleton && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("tfoot", {
                className: "table-group-divider",
                children: table.getFooterGroups().map((footerGroup)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("tr", {
                        children: footerGroup.headers.map((header)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("th", {
                                colSpan: header.colSpan,
                                children: !header.isPlaceholder && (0, $846ffc19ca7303a9$export$f2385bb6e3ac4b4f)(header.column.columnDef.footer, header.getContext())
                            }, header.id))
                    }, footerGroup.id))
            })
        ]
    });
};
/**
 * Renders 20 skeleton rows matching the number of columns, for use as a loading placeholder.
 */ const $282cd4d039b346d2$var$SkeletonRows = ({ numCols: numCols })=>{
    return Array.from({
        length: 20
    }).map((_, rowIdx)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("tr", {
            children: Array.from({
                length: numCols
            }).map((_, colIdx)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("td", {
                    className: "skeleton-loading-table-cell"
                }, colIdx))
        }, rowIdx));
};
const $282cd4d039b346d2$var$NoDataRow = ({ numCols: numCols })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("tr", {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("td", {
            colSpan: numCols,
            className: "text-center p-3",
            children: "Table Has No Data"
        })
    });







var $itHdT = parcelRequire("itHdT");

const $58d207e48650f974$export$11e0a2e3e94855e6 = /*#__PURE__*/ (0, $itHdT.forwardRef)(({ fromHash: fromHash, onClick: onClick, ...props }, ref)=>{
    const handleClick = (0, $itHdT.useCallback)((e)=>{
        if (onClick) onClick(e);
        if (e.defaultPrevented) return;
        if (fromHash && window.location.hash !== `#${fromHash}`) window.history.replaceState(null, "", `#${fromHash}`);
    }, [
        fromHash,
        onClick
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$a6c7ac8248d6e38a), {
        ...props,
        onClick: handleClick,
        ref: ref
    });
});
$58d207e48650f974$export$11e0a2e3e94855e6.displayName = "HashPreservingLink";




const $2b3a7af3658dfb79$var$starColorMapping = {
    0: null,
    1: "\uD83D\uDD34",
    2: "\uD83D\uDFE1",
    3: "\uD83D\uDFE2"
};
function $2b3a7af3658dfb79$export$4c873d4168351350(starred, unstarredEmoji) {
    return $2b3a7af3658dfb79$var$starColorMapping[starred] ?? unstarredEmoji ?? "\u2753";
}
function $2b3a7af3658dfb79$export$3b6db6d9ae78dca4(itemType) {
    return itemType === "Inventory Item" || itemType === "Assembly" || itemType === "Non-inventory Item";
}
function $2b3a7af3658dfb79$export$35a6203b467a7166(itemType) {
    return itemType === "Inventory Item" || itemType === "Assembly";
}
const $2b3a7af3658dfb79$export$453e593af56ab20 = $2b3a7af3658dfb79$export$35a6203b467a7166;
function $2b3a7af3658dfb79$export$e6ae7ae9cddc1cf4(itemType) {
    return itemType === "Assembly" || itemType === "Item Group";
}
// TODO: Add paths for remaining entity types
const $2b3a7af3658dfb79$var$entityApiPathToUrlPath = {
    customer: "Customer",
    vendor: "Vendor",
    item: "Item",
    salesorder: "SalesOrder",
    purchaseorder: "PurchaseOrder",
    itemreceipt: "ItemReceipt",
    build: "BuildAssembly",
    workorder: "WorkOrder",
    shipment: "Shipment",
    adjustment: "InventoryAdjustment",
    transfer: "InventoryTransfer",
    job: "Job",
    estimate: "Estimate"
};
function $2b3a7af3658dfb79$export$53301272fb439fcd(entityType, id) {
    return `https://legacy.sosinventory.com/${$2b3a7af3658dfb79$var$entityApiPathToUrlPath[entityType]}/IndexView/${id.toFixed()}`;
}
const $2b3a7af3658dfb79$var$linkedTransactionTypeToEntityPathMapping = {
    IR: "itemreceipt",
    PO: "purchaseorder",
    SO: "salesorder",
    WO: "workorder",
    SR: "salesreceipt",
    Invoice: "invoice"
};
function $2b3a7af3658dfb79$export$c8c9d71bd3ec8d8b(linkedTransactionType) {
    return $2b3a7af3658dfb79$var$linkedTransactionTypeToEntityPathMapping[linkedTransactionType];
}
const $2b3a7af3658dfb79$export$aa7c5af0d6404c01 = {
    itemreceipt: "number",
    purchaseorder: "number",
    salesorder: "number",
    workorder: "number",
    salesreceipt: "number",
    invoice: "number"
};



const $aa4833b2f2131489$export$c66dc3d652f86954 = ({ type: type, id: id, label: label, ...anchorProps })=>{
    const href = (0, $2b3a7af3658dfb79$export$53301272fb439fcd)(type, id);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
        className: "text-nowrap",
        children: [
            label,
            " ",
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                    children: "View In SOS"
                }),
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("a", {
                    href: href,
                    target: "_blank",
                    rel: "noreferrer",
                    ...anchorProps,
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                        icon: "box-arrow-up-right"
                    })
                })
            })
        ]
    });
};


const $a23decb4ddcbc17a$export$8a6bf4e459a8d696 = ({ urlPath: urlPath, tooltipContent: tooltipContent, type: type, id: id, idSuffix: idSuffix, label: label, ...linkProps })=>{
    const href = `${urlPath ?? ""}#${$a23decb4ddcbc17a$export$3e63b58f3f3486b6(type, id, idSuffix)}`;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                    children: tooltipContent
                }),
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $58d207e48650f974$export$11e0a2e3e94855e6), {
                    to: href,
                    ...linkProps,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("me-1", linkProps.className),
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: type,
                id: id,
                label: ""
            })
        ]
    });
};
function $a23decb4ddcbc17a$export$3e63b58f3f3486b6(type, id, suffix) {
    return `${type}-${id.toFixed()}${suffix ? `-${suffix}` : ""}`;
}




var $itHdT = parcelRequire("itHdT");
function $712f3339b3650c2f$export$4267411171632d35({ responsive: responsive = true, stickyHeader: stickyHeader = true, className: className = "", children: children }) {
    const containerRef = (0, $itHdT.useRef)(null);
    // Optionally monitor the height of the table header and save it in the `--table-header-height` CSS variable
    (0, $itHdT.useEffect)(()=>{
        // Do nothing if this table does not have a sticky header
        if (!stickyHeader) return;
        // Do nothing if the table is not rendered yet
        const wrapper = containerRef.current;
        if (!wrapper) return;
        const header = wrapper.querySelector("table > thead");
        if (!header) return;
        // Define a callback to update the header height property
        const setHeaderHeight = ()=>{
            const height = header.getBoundingClientRect().height;
            wrapper.style.setProperty("--table-header-height", height.toFixed(3) + "px");
        };
        // Set up a ResizeObserver to update the header height any time the header is resized
        const resizeObserver = new ResizeObserver(setHeaderHeight);
        resizeObserver.observe(header);
        // Set the initial header height when the component mounts
        setHeaderHeight();
        // Clean up the ResizeObserver when the component unmounts
        return resizeObserver.disconnect.bind(resizeObserver);
    }, [
        stickyHeader,
        children
    ]);
    // Dynamically build the className for the container
    if (responsive) className += " table-responsive";
    if (stickyHeader) className += " sticky-table-container";
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
        ref: containerRef,
        className: className,
        children: children
    });
}




var $itHdT = parcelRequire("itHdT");

var $335fff2cb036660c$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $335fff2cb036660c$var$isEqual(value, other) {
    return $2c06d558d1290ecd$exports(value, other);
}
$335fff2cb036660c$exports = $335fff2cb036660c$var$isEqual;


function $5711052b6217fc5b$export$ba7dd4b1a46684c1({ componentId: componentId, urlKey: urlKey, stateSchema: stateSchema, version: version, defaultState: defaultState, urlSerializer: urlSerializer }) {
    // Use urlKey if provided, otherwise fall back to componentId
    const urlParamKey = urlKey || componentId;
    // Construct the persisted state schema dynamically
    const persistedSchema = $0ecef21ea2da6305$export$be5493f9613cbbe({
        version: $0ecef21ea2da6305$export$c8ec6e1ec9fefcb0(version),
        state: stateSchema
    });
    const [state, setState] = (0, $itHdT.useState)(()=>$5711052b6217fc5b$var$loadState(componentId, urlParamKey, stateSchema, persistedSchema, version, defaultState, urlSerializer));
    // Track the saved state from localStorage as a separate state object
    const [savedState, setSavedState] = (0, $itHdT.useState)(()=>$5711052b6217fc5b$var$getLocalStorageState(componentId, persistedSchema, version));
    // Check for equality between the current state, the saved state, and the default state
    const stateMatchesDefault = (0, (/*@__PURE__*/$parcel$interopDefault($335fff2cb036660c$exports)))(state, defaultState);
    const stateMatchesSaved = stateMatchesDefault && !savedState || (0, (/*@__PURE__*/$parcel$interopDefault($335fff2cb036660c$exports)))(state, savedState);
    // Sync state to URL on state changes; if the state is equal to the default state, remove the URL param
    (0, $itHdT.useEffect)(()=>{
        if (stateMatchesDefault) $5711052b6217fc5b$var$resetUrlState(urlParamKey);
        else $5711052b6217fc5b$var$saveUrlState(urlParamKey, state, urlSerializer);
    }, [
        stateMatchesDefault,
        urlParamKey,
        state,
        urlSerializer
    ]);
    // Define 'save state' callback (save state to localStorage)
    const saveState = (0, $itHdT.useCallback)(()=>{
        if (stateMatchesDefault) {
            $5711052b6217fc5b$var$resetLocalStorageState(componentId);
            setSavedState(undefined);
        } else {
            $5711052b6217fc5b$var$saveLocalStorageState(componentId, state, version);
            setSavedState(state);
        }
    }, [
        stateMatchesDefault,
        componentId,
        state,
        version
    ]);
    // Define 'reset to saved' callback (reset state to what is stored in localStorage)
    const resetToSaved = (0, $itHdT.useCallback)(()=>{
        if (!savedState) throw new Error("Cannot reset to saved state, no saved state found");
        setState(savedState);
        $5711052b6217fc5b$var$saveUrlState(urlParamKey, savedState, urlSerializer);
    }, [
        urlParamKey,
        savedState,
        urlSerializer
    ]);
    // Define 'reset to defaults' callback
    const resetToDefaults = (0, $itHdT.useCallback)(()=>{
        setState(defaultState);
        $5711052b6217fc5b$var$saveUrlState(urlParamKey, defaultState, urlSerializer);
    }, [
        urlParamKey,
        defaultState,
        urlSerializer
    ]);
    return [
        state,
        setState,
        {
            saveState: saveState,
            resetToSaved: resetToSaved,
            resetToDefaults: resetToDefaults,
            stateMatchesSaved: stateMatchesSaved,
            stateMatchesDefault: stateMatchesDefault,
            hasSavedState: savedState !== undefined
        }
    ];
}
const $5711052b6217fc5b$export$ba853dbbfb85b659 = ({ saveState: saveState, resetToSaved: resetToSaved, resetToDefaults: resetToDefaults, stateMatchesSaved: stateMatchesSaved, stateMatchesDefault: stateMatchesDefault, hasSavedState: hasSavedState })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("button", {
                className: "btn btn-primary btn-sm ms-2",
                onClick: saveState,
                type: "button",
                disabled: stateMatchesSaved,
                children: "Save Filter"
            }),
            hasSavedState && !stateMatchesSaved && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("button", {
                className: "btn btn-secondary btn-sm ms-2",
                onClick: resetToSaved,
                type: "button",
                children: "Reset to Saved"
            }),
            !stateMatchesDefault && (!hasSavedState || stateMatchesSaved) && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("button", {
                className: "btn btn-secondary btn-sm ms-2",
                onClick: resetToDefaults,
                type: "button",
                children: "Reset to Defaults"
            })
        ]
    });
/**
 * Load state from URL or localStorage, with Zod validation and versioning.
 */ function $5711052b6217fc5b$var$loadState(componentId, urlParamKey, stateSchema, persistedSchema, version, defaultState, urlSerializer) {
    // Try URL first
    const urlState = $5711052b6217fc5b$var$getUrlState(urlParamKey, stateSchema, urlSerializer);
    if (urlState !== undefined) return urlState;
    // Try localStorage
    const localStorageState = $5711052b6217fc5b$var$getLocalStorageState(componentId, persistedSchema, version);
    if (localStorageState !== undefined) return localStorageState;
    // Fallback to default state
    return defaultState;
}
function $5711052b6217fc5b$var$getLocalStorageState(componentId, schema, version) {
    const raw = localStorage.getItem(componentId);
    if (raw) try {
        const parsed = JSON.parse(raw);
        const result = schema.safeParse(parsed);
        if (result.success && result.data.version === version) return result.data.state;
    } catch (e) {
        // Ignore parse errors and return undefined
        console.warn(`Failed to parse persistent state from local storage for '${componentId}':`, e);
    }
    return undefined;
}
/**
 * Save state to localStorage with version.
 */ function $5711052b6217fc5b$var$saveLocalStorageState(componentId, state, version) {
    const toSave = {
        version: version,
        state: state
    };
    localStorage.setItem(componentId, JSON.stringify(toSave));
    console.info(`Saved state to localStorage for '${componentId}':`, toSave);
}
/**
 * Remove state from localStorage.
 */ function $5711052b6217fc5b$var$resetLocalStorageState(componentId) {
    localStorage.removeItem(componentId);
    console.info(`Removed state from localStorage for '${componentId}'`);
}
/**
 * Extract and validate state from URL.
 *
 * URL state is stored without the version wrapper — only the raw state is serialized. The Zod schema alone handles
 * validation/invalidation of stale URL state (rejecting payloads whose shape no longer matches). This keeps URLs
 * short and readable. The tradeoff is that bumping `version` alone (without a schema shape change) won't invalidate
 * URL state the way it does for localStorage.
 */ function $5711052b6217fc5b$var$getUrlState(paramKey, schema, urlSerializer) {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get(paramKey);
    if (!encoded) return undefined;
    try {
        // Deserialize using custom serializer or default JSON parsing
        const parsed = urlSerializer ? urlSerializer.deserialize(encoded) : JSON.parse(encoded);
        const result = schema.safeParse(parsed);
        if (result.success) return result.data;
    } catch (e) {
        // Ignore parse errors and return undefined
        console.warn(`Failed to parse persistent state from URL for '${paramKey}':`, e);
    }
    return undefined;
}
/**
 * Save state to URL.
 *
 * Only the raw state is saved (no version wrapper) to keep URLs short and readable. Zod schema validation is
 * sufficient to reject stale URL state when the shape changes. See {@link getUrlState} for the full rationale.
 *
 * Uses the custom {@link UrlSerializer} if provided, otherwise falls back to JSON stringification.
 */ function $5711052b6217fc5b$var$saveUrlState(paramKey, state, urlSerializer) {
    const params = new URLSearchParams(window.location.search);
    // Serialize using custom serializer or default JSON stringification
    params.set(paramKey, urlSerializer ? urlSerializer.serialize(state) : JSON.stringify(state));
    // URLSearchParams uses application/x-www-form-urlencoded encoding, which percent-encodes many characters that are
    // actually valid in query strings per RFC 3986. We unescape commas and colons because:
    //   - Both are explicitly allowed in the RFC 3986 query grammar (`,` as a sub-delim, `:` as part of pchar)
    //   - URLSearchParams.get() returns them correctly on the read path (it only splits on `&` and `=`)
    //   - They're common in our serialized data (commas in CSV-style custom serializers, colons in JSON key-value pairs)
    // Other characters like ~ ! $ ' ( ) @ / ? are also RFC 3986 query-safe and could be unescaped here if needed, but
    // they rarely appear in our serialized state so the readability benefit is negligible.
    const queryString = params.toString().replaceAll("%2C", ",").replaceAll("%3A", ":");
    const newUrl = params.size ? `${window.location.pathname}?${queryString}` : window.location.pathname;
    window.history.replaceState({}, "", newUrl);
    console.info(`Saved state to URL for '${paramKey}':`, state);
}
/** Remove state from URL. */ function $5711052b6217fc5b$var$resetUrlState(paramKey) {
    // Do nothing if the paramKey is not present in the URL query parameter
    const url = new URL(window.location.href);
    if (!url.searchParams.has(paramKey)) return;
    // Otherwise, remove the parameter and update the URL without affecting the browser history
    url.searchParams.delete(paramKey);
    window.history.replaceState({}, "", url);
    console.info(`Removed state from URL for '${paramKey}'`);
}







var $0dc92cf253a5de95$exports = {};
var $f4a179b2e5954de2$exports = {};

var $c455ab13f13eefd7$exports = {};
var $b89309ed7fadc624$exports = {};
var $3db63ba36804fe28$exports = {};

var $3db63ba36804fe28$var$defineProperty = function() {
    try {
        var func = $050b290091bba370$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$3db63ba36804fe28$exports = $3db63ba36804fe28$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b89309ed7fadc624$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $3db63ba36804fe28$exports) $3db63ba36804fe28$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$b89309ed7fadc624$exports = $b89309ed7fadc624$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $c455ab13f13eefd7$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$4ccffa0477315322$exports(object[key], value) || value === undefined && !(key in object)) $b89309ed7fadc624$exports(object, key, value);
}
$c455ab13f13eefd7$exports = $c455ab13f13eefd7$var$assignMergeValue;


var $362b8f2f8a5f669f$exports = {};
var $9922b324352ec979$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $9922b324352ec979$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$9922b324352ec979$exports = $9922b324352ec979$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $362b8f2f8a5f669f$var$baseFor = $9922b324352ec979$exports();
$362b8f2f8a5f669f$exports = $362b8f2f8a5f669f$var$baseFor;


var $ed85ab211a2f317a$exports = {};


var $5C2YQ = parcelRequire("5C2YQ");
var $5654876beb111e05$exports = {};
var $0900bc382bf336f6$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $0900bc382bf336f6$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $d42530eef3f0bd0c$exports(result).set(new $d42530eef3f0bd0c$exports(arrayBuffer));
    return result;
}
$0900bc382bf336f6$exports = $0900bc382bf336f6$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $5654876beb111e05$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $0900bc382bf336f6$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$5654876beb111e05$exports = $5654876beb111e05$var$cloneTypedArray;


var $47b6321836ef18d4$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $47b6321836ef18d4$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$47b6321836ef18d4$exports = $47b6321836ef18d4$var$copyArray;


var $f19653cc288910e5$exports = {};
var $a26edb5182ec3c58$exports = {};

/** Built-in value references. */ var $a26edb5182ec3c58$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a26edb5182ec3c58$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$bf7b23ae406572e5$exports(proto)) return {};
        if ($a26edb5182ec3c58$var$objectCreate) return $a26edb5182ec3c58$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$a26edb5182ec3c58$exports = $a26edb5182ec3c58$var$baseCreate;


var $0d38f824451b02b3$exports = {};

/** Built-in value references. */ var $0d38f824451b02b3$var$getPrototype = $d7d5b8d976a0cabb$exports(Object.getPrototypeOf, Object);
$0d38f824451b02b3$exports = $0d38f824451b02b3$var$getPrototype;



/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $f19653cc288910e5$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$274b0496c7bbc672$exports(object) ? $a26edb5182ec3c58$exports($0d38f824451b02b3$exports(object)) : {};
}
$f19653cc288910e5$exports = $f19653cc288910e5$var$initCloneObject;




var $7e6c1283c8aa7f2e$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $7e6c1283c8aa7f2e$var$isArrayLikeObject(value) {
    return $4a4f0e8dbee85a7e$exports(value) && $e1ea3190b025ca72$exports(value);
}
$7e6c1283c8aa7f2e$exports = $7e6c1283c8aa7f2e$var$isArrayLikeObject;



var $laUMG = parcelRequire("laUMG");


var $e8013503d303cb1e$exports = {};



/** `Object#toString` result references. */ var $e8013503d303cb1e$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e8013503d303cb1e$var$funcProto = Function.prototype, $e8013503d303cb1e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e8013503d303cb1e$var$funcToString = $e8013503d303cb1e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e8013503d303cb1e$var$hasOwnProperty = $e8013503d303cb1e$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $e8013503d303cb1e$var$objectCtorString = $e8013503d303cb1e$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $e8013503d303cb1e$var$isPlainObject(value) {
    if (!$4a4f0e8dbee85a7e$exports(value) || $6f100228b69eda33$exports(value) != $e8013503d303cb1e$var$objectTag) return false;
    var proto = $0d38f824451b02b3$exports(value);
    if (proto === null) return true;
    var Ctor = $e8013503d303cb1e$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $e8013503d303cb1e$var$funcToString.call(Ctor) == $e8013503d303cb1e$var$objectCtorString;
}
$e8013503d303cb1e$exports = $e8013503d303cb1e$var$isPlainObject;



var $077ca1d620c9d1fd$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $077ca1d620c9d1fd$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
$077ca1d620c9d1fd$exports = $077ca1d620c9d1fd$var$safeGet;


var $6a7f82270496d848$exports = {};
var $06db3368d789f91a$exports = {};
var $ed317c9bb9642c31$exports = {};


/** Used for built-in method references. */ var $ed317c9bb9642c31$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ed317c9bb9642c31$var$hasOwnProperty = $ed317c9bb9642c31$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $ed317c9bb9642c31$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($ed317c9bb9642c31$var$hasOwnProperty.call(object, key) && $4ccffa0477315322$exports(objValue, value)) || value === undefined && !(key in object)) $b89309ed7fadc624$exports(object, key, value);
}
$ed317c9bb9642c31$exports = $ed317c9bb9642c31$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $06db3368d789f91a$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $b89309ed7fadc624$exports(object, key, newValue);
        else $ed317c9bb9642c31$exports(object, key, newValue);
    }
    return object;
}
$06db3368d789f91a$exports = $06db3368d789f91a$var$copyObject;


var $00a3fe29612b1465$exports = {};

var $fbda15f2b18c9c1b$exports = {};


var $96aaeadbd91cd924$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $96aaeadbd91cd924$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$96aaeadbd91cd924$exports = $96aaeadbd91cd924$var$nativeKeysIn;


/** Used for built-in method references. */ var $fbda15f2b18c9c1b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fbda15f2b18c9c1b$var$hasOwnProperty = $fbda15f2b18c9c1b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $fbda15f2b18c9c1b$var$baseKeysIn(object) {
    if (!$bf7b23ae406572e5$exports(object)) return $96aaeadbd91cd924$exports(object);
    var isProto = $274b0496c7bbc672$exports(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$fbda15f2b18c9c1b$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$fbda15f2b18c9c1b$exports = $fbda15f2b18c9c1b$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $00a3fe29612b1465$var$keysIn(object) {
    return $e1ea3190b025ca72$exports(object) ? $845e771b578e3f50$exports(object, true) : $fbda15f2b18c9c1b$exports(object);
}
$00a3fe29612b1465$exports = $00a3fe29612b1465$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $6a7f82270496d848$var$toPlainObject(value) {
    return $06db3368d789f91a$exports(value, $00a3fe29612b1465$exports(value));
}
$6a7f82270496d848$exports = $6a7f82270496d848$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $ed85ab211a2f317a$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $077ca1d620c9d1fd$exports(object, key), srcValue = $077ca1d620c9d1fd$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $c455ab13f13eefd7$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $f7463dbc77cf4722$exports(srcValue), isBuff = !isArr && $laUMG(srcValue), isTyped = !isArr && !isBuff && $eafd2a27f6e262d6$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($f7463dbc77cf4722$exports(objValue)) newValue = objValue;
            else if ($7e6c1283c8aa7f2e$exports(objValue)) newValue = $47b6321836ef18d4$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $5C2YQ(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $5654876beb111e05$exports(srcValue, true);
            } else newValue = [];
        } else if ($e8013503d303cb1e$exports(srcValue) || $39469abbd59941a5$exports(srcValue)) {
            newValue = objValue;
            if ($39469abbd59941a5$exports(objValue)) newValue = $6a7f82270496d848$exports(objValue);
            else if (!$bf7b23ae406572e5$exports(objValue) || $ed2327a9dc7966cd$exports(objValue)) newValue = $f19653cc288910e5$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $c455ab13f13eefd7$exports(object, key, newValue);
}
$ed85ab211a2f317a$exports = $ed85ab211a2f317a$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $f4a179b2e5954de2$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $362b8f2f8a5f669f$exports(source, function(srcValue, key) {
        stack || (stack = new $9e076c4f099a76a7$exports);
        if ($bf7b23ae406572e5$exports(srcValue)) $ed85ab211a2f317a$exports(object, source, key, srcIndex, $f4a179b2e5954de2$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($077ca1d620c9d1fd$exports(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $c455ab13f13eefd7$exports(object, key, newValue);
        }
    }, $00a3fe29612b1465$exports);
}
$f4a179b2e5954de2$exports = $f4a179b2e5954de2$var$baseMerge;


var $a1f19f9406ba72e4$exports = {};
var $af0bfff8b42a9ac6$exports = {};

var $5e594fed17cdad4e$exports = {};
var $a2fb584cd61a8ccb$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $a2fb584cd61a8ccb$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$a2fb584cd61a8ccb$exports = $a2fb584cd61a8ccb$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $5e594fed17cdad4e$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $5e594fed17cdad4e$var$overRest(func, start, transform) {
    start = $5e594fed17cdad4e$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $5e594fed17cdad4e$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $a2fb584cd61a8ccb$exports(func, this, otherArgs);
    };
}
$5e594fed17cdad4e$exports = $5e594fed17cdad4e$var$overRest;


var $effe151b51513b14$exports = {};
var $9dce1bca606972d8$exports = {};
var $bd861aa0b554be4a$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $bd861aa0b554be4a$var$constant(value) {
    return function() {
        return value;
    };
}
$bd861aa0b554be4a$exports = $bd861aa0b554be4a$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $9dce1bca606972d8$var$baseSetToString = !$3db63ba36804fe28$exports ? $1f65ff87e6363a01$exports : function(func, string) {
    return $3db63ba36804fe28$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $bd861aa0b554be4a$exports(string),
        'writable': true
    });
};
$9dce1bca606972d8$exports = $9dce1bca606972d8$var$baseSetToString;


var $02b7e7509dfe2d7d$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $02b7e7509dfe2d7d$var$HOT_COUNT = 800, $02b7e7509dfe2d7d$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02b7e7509dfe2d7d$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $02b7e7509dfe2d7d$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $02b7e7509dfe2d7d$var$nativeNow(), remaining = $02b7e7509dfe2d7d$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $02b7e7509dfe2d7d$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$02b7e7509dfe2d7d$exports = $02b7e7509dfe2d7d$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $effe151b51513b14$var$setToString = $02b7e7509dfe2d7d$exports($9dce1bca606972d8$exports);
$effe151b51513b14$exports = $effe151b51513b14$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $af0bfff8b42a9ac6$var$baseRest(func, start) {
    return $effe151b51513b14$exports($5e594fed17cdad4e$exports(func, start, $1f65ff87e6363a01$exports), func + '');
}
$af0bfff8b42a9ac6$exports = $af0bfff8b42a9ac6$var$baseRest;


var $51500238064a120b$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $51500238064a120b$var$isIterateeCall(value, index, object) {
    if (!$bf7b23ae406572e5$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $e1ea3190b025ca72$exports(object) && $964fc6ece1fce4f0$exports(index, object.length) : type == 'string' && index in object) return $4ccffa0477315322$exports(object[index], value);
    return false;
}
$51500238064a120b$exports = $51500238064a120b$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $a1f19f9406ba72e4$var$createAssigner(assigner) {
    return $af0bfff8b42a9ac6$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $51500238064a120b$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$a1f19f9406ba72e4$exports = $a1f19f9406ba72e4$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $0dc92cf253a5de95$var$merge = $a1f19f9406ba72e4$exports(function(object, source, srcIndex) {
    $f4a179b2e5954de2$exports(object, source, srcIndex);
});
$0dc92cf253a5de95$exports = $0dc92cf253a5de95$var$merge;


var $18fd3ca1b111910e$exports = {};
var $75b0a270dc56fd3a$exports = {};
var $2b47cb7b3fe3332d$exports = {};

$parcel$export($2b47cb7b3fe3332d$exports, "AED", function () { return $2b47cb7b3fe3332d$export$977aafad42cf69c5; });
/**
 * United Arab Emirates dirham.
 */ var $2b47cb7b3fe3332d$export$977aafad42cf69c5 = {
    code: 'AED',
    base: 10,
    exponent: 2
};


var $f964822479586124$exports = {};

$parcel$export($f964822479586124$exports, "AFN", function () { return $f964822479586124$export$518640f5ed5ea7ab; });
/**
 * Afghan afghani.
 */ var $f964822479586124$export$518640f5ed5ea7ab = {
    code: 'AFN',
    base: 10,
    exponent: 2
};


var $daa31b0a6adc1c54$exports = {};

$parcel$export($daa31b0a6adc1c54$exports, "ALL", function () { return $daa31b0a6adc1c54$export$61b49a5ae59d663; });
/**
 * Albanian lek.
 */ var $daa31b0a6adc1c54$export$61b49a5ae59d663 = {
    code: 'ALL',
    base: 10,
    exponent: 2
};


var $fadf14ddbd2c81c2$exports = {};

$parcel$export($fadf14ddbd2c81c2$exports, "AMD", function () { return $fadf14ddbd2c81c2$export$dfc484d68dea6d2; });
/**
 * Armenian dram.
 */ var $fadf14ddbd2c81c2$export$dfc484d68dea6d2 = {
    code: 'AMD',
    base: 10,
    exponent: 2
};


var $e728c0e49ee8acdc$exports = {};

$parcel$export($e728c0e49ee8acdc$exports, "ANG", function () { return $e728c0e49ee8acdc$export$80708660a23a79b9; });
/**
 * Netherlands Antillean guilder.
 */ var $e728c0e49ee8acdc$export$80708660a23a79b9 = {
    code: 'ANG',
    base: 10,
    exponent: 2
};


var $8f06a82fbf4a085e$exports = {};

$parcel$export($8f06a82fbf4a085e$exports, "AOA", function () { return $8f06a82fbf4a085e$export$267f8845040e0269; });
/**
 * Angolan kwanza.
 */ var $8f06a82fbf4a085e$export$267f8845040e0269 = {
    code: 'AOA',
    base: 10,
    exponent: 2
};


var $8df36c2b362431f7$exports = {};

$parcel$export($8df36c2b362431f7$exports, "ARS", function () { return $8df36c2b362431f7$export$9b6129d5caf77fb9; });
/**
 * Argentine peso.
 */ var $8df36c2b362431f7$export$9b6129d5caf77fb9 = {
    code: 'ARS',
    base: 10,
    exponent: 2
};


var $850f2ef0359c12cc$exports = {};

$parcel$export($850f2ef0359c12cc$exports, "AUD", function () { return $850f2ef0359c12cc$export$5f54274ae16af775; });
/**
 * Australian dollar.
 */ var $850f2ef0359c12cc$export$5f54274ae16af775 = {
    code: 'AUD',
    base: 10,
    exponent: 2
};


var $965b78b915a1a68a$exports = {};

$parcel$export($965b78b915a1a68a$exports, "AWG", function () { return $965b78b915a1a68a$export$14311d5b0536aac4; });
/**
 * Aruban florin.
 */ var $965b78b915a1a68a$export$14311d5b0536aac4 = {
    code: 'AWG',
    base: 10,
    exponent: 2
};


var $d977739fe2a1ad8d$exports = {};

$parcel$export($d977739fe2a1ad8d$exports, "AZN", function () { return $d977739fe2a1ad8d$export$f61f45a31cdd3db5; });
/**
 * Azerbaijani manat.
 */ var $d977739fe2a1ad8d$export$f61f45a31cdd3db5 = {
    code: 'AZN',
    base: 10,
    exponent: 2
};


var $b6a2d3712341df9c$exports = {};

$parcel$export($b6a2d3712341df9c$exports, "BAM", function () { return $b6a2d3712341df9c$export$9e410dd86e1ea86c; });
/**
 * Bosnia and Herzegovina convertible mark.
 */ var $b6a2d3712341df9c$export$9e410dd86e1ea86c = {
    code: 'BAM',
    base: 10,
    exponent: 2
};


var $bd03e19f1e58a353$exports = {};

$parcel$export($bd03e19f1e58a353$exports, "BBD", function () { return $bd03e19f1e58a353$export$b6d8632648fed702; });
/**
 * Barbados dollar.
 */ var $bd03e19f1e58a353$export$b6d8632648fed702 = {
    code: 'BBD',
    base: 10,
    exponent: 2
};


var $9cb8e893e4f336e4$exports = {};

$parcel$export($9cb8e893e4f336e4$exports, "BDT", function () { return $9cb8e893e4f336e4$export$7350e86d9493dbd2; });
/**
 * Bangladeshi taka.
 */ var $9cb8e893e4f336e4$export$7350e86d9493dbd2 = {
    code: 'BDT',
    base: 10,
    exponent: 2
};


var $2c45afefc0688b0f$exports = {};

$parcel$export($2c45afefc0688b0f$exports, "BGN", function () { return $2c45afefc0688b0f$export$b9be44ac2825bd1d; });
/**
 * Bulgarian lev.
 */ var $2c45afefc0688b0f$export$b9be44ac2825bd1d = {
    code: 'BGN',
    base: 10,
    exponent: 2
};


var $a8d577a403e3c27b$exports = {};

$parcel$export($a8d577a403e3c27b$exports, "BHD", function () { return $a8d577a403e3c27b$export$2b751cddc498b3ae; });
/**
 * Bahraini dinar.
 */ var $a8d577a403e3c27b$export$2b751cddc498b3ae = {
    code: 'BHD',
    base: 10,
    exponent: 3
};


var $4f4487f95ac2b427$exports = {};

$parcel$export($4f4487f95ac2b427$exports, "BIF", function () { return $4f4487f95ac2b427$export$e9a75a10475450b7; });
/**
 * Burundian franc.
 */ var $4f4487f95ac2b427$export$e9a75a10475450b7 = {
    code: 'BIF',
    base: 10,
    exponent: 0
};


var $fb1e96c968e67277$exports = {};

$parcel$export($fb1e96c968e67277$exports, "BMD", function () { return $fb1e96c968e67277$export$c152d74210d2e169; });
/**
 * Bermudian dollar.
 */ var $fb1e96c968e67277$export$c152d74210d2e169 = {
    code: 'BMD',
    base: 10,
    exponent: 2
};


var $546ffc8df1f85046$exports = {};

$parcel$export($546ffc8df1f85046$exports, "BND", function () { return $546ffc8df1f85046$export$423a1774583d93f7; });
/**
 * Brunei dollar.
 */ var $546ffc8df1f85046$export$423a1774583d93f7 = {
    code: 'BND',
    base: 10,
    exponent: 2
};


var $ef234d7657f7ac97$exports = {};

$parcel$export($ef234d7657f7ac97$exports, "BOB", function () { return $ef234d7657f7ac97$export$c53032d6e0b0e07d; });
/**
 * Bolivian boliviano.
 */ var $ef234d7657f7ac97$export$c53032d6e0b0e07d = {
    code: 'BOB',
    base: 10,
    exponent: 2
};


var $8a194f72e0114463$exports = {};

$parcel$export($8a194f72e0114463$exports, "BOV", function () { return $8a194f72e0114463$export$e50860972fda200b; });
/**
 * Bolivian Mvdol.
 */ var $8a194f72e0114463$export$e50860972fda200b = {
    code: 'BOV',
    base: 10,
    exponent: 2
};


var $036db5f3a18e5aef$exports = {};

$parcel$export($036db5f3a18e5aef$exports, "BRL", function () { return $036db5f3a18e5aef$export$e4084e57734f87a8; });
/**
 * Brazilian real.
 */ var $036db5f3a18e5aef$export$e4084e57734f87a8 = {
    code: 'BRL',
    base: 10,
    exponent: 2
};


var $9a12ad1e029ead8c$exports = {};

$parcel$export($9a12ad1e029ead8c$exports, "BSD", function () { return $9a12ad1e029ead8c$export$e907bd5ce2c5c7d3; });
/**
 * Bahamian dollar.
 */ var $9a12ad1e029ead8c$export$e907bd5ce2c5c7d3 = {
    code: 'BSD',
    base: 10,
    exponent: 2
};


var $c9e64a42cf7f8404$exports = {};

$parcel$export($c9e64a42cf7f8404$exports, "BTN", function () { return $c9e64a42cf7f8404$export$d8c6aef026908aab; });
/**
 * Bhutanese ngultrum.
 */ var $c9e64a42cf7f8404$export$d8c6aef026908aab = {
    code: 'BTN',
    base: 10,
    exponent: 2
};


var $05e78743ca81a775$exports = {};

$parcel$export($05e78743ca81a775$exports, "BWP", function () { return $05e78743ca81a775$export$2b3355eb3569816e; });
/**
 * Botswana pula.
 */ var $05e78743ca81a775$export$2b3355eb3569816e = {
    code: 'BWP',
    base: 10,
    exponent: 2
};


var $5be7c2ab0dd41ea1$exports = {};

$parcel$export($5be7c2ab0dd41ea1$exports, "BYN", function () { return $5be7c2ab0dd41ea1$export$c0a304052498baa6; });
/**
 * Belarusian ruble.
 */ var $5be7c2ab0dd41ea1$export$c0a304052498baa6 = {
    code: 'BYN',
    base: 10,
    exponent: 2
};


var $4e3ff54668829b0a$exports = {};

$parcel$export($4e3ff54668829b0a$exports, "BZD", function () { return $4e3ff54668829b0a$export$c164ff8c2f8e222c; });
/**
 * Belize dollar.
 */ var $4e3ff54668829b0a$export$c164ff8c2f8e222c = {
    code: 'BZD',
    base: 10,
    exponent: 2
};


var $12cbf1ecc1f0ac35$exports = {};

$parcel$export($12cbf1ecc1f0ac35$exports, "CAD", function () { return $12cbf1ecc1f0ac35$export$6f6cabe4ede87f37; });
/**
 * Canadian dollar.
 */ var $12cbf1ecc1f0ac35$export$6f6cabe4ede87f37 = {
    code: 'CAD',
    base: 10,
    exponent: 2
};


var $d2b4760855949ba4$exports = {};

$parcel$export($d2b4760855949ba4$exports, "CDF", function () { return $d2b4760855949ba4$export$e4a86c11c25e0160; });
/**
 * Congolese franc.
 */ var $d2b4760855949ba4$export$e4a86c11c25e0160 = {
    code: 'CDF',
    base: 10,
    exponent: 2
};


var $aea2c41d5a53517b$exports = {};

$parcel$export($aea2c41d5a53517b$exports, "CHE", function () { return $aea2c41d5a53517b$export$a49e637f8d993b0c; });
/**
 * WIR Euro.
 */ var $aea2c41d5a53517b$export$a49e637f8d993b0c = {
    code: 'CHE',
    base: 10,
    exponent: 2
};


var $caebf02998ed4d27$exports = {};

$parcel$export($caebf02998ed4d27$exports, "CHF", function () { return $caebf02998ed4d27$export$8b6bd893931bf160; });
/**
 * Swiss franc.
 */ var $caebf02998ed4d27$export$8b6bd893931bf160 = {
    code: 'CHF',
    base: 10,
    exponent: 2
};


var $4afd7cf5dec93b3f$exports = {};

$parcel$export($4afd7cf5dec93b3f$exports, "CHW", function () { return $4afd7cf5dec93b3f$export$15fcc66c77320613; });
/**
 * WIR Franc.
 */ var $4afd7cf5dec93b3f$export$15fcc66c77320613 = {
    code: 'CHW',
    base: 10,
    exponent: 2
};


var $07ea3d5914161ebd$exports = {};

$parcel$export($07ea3d5914161ebd$exports, "CLF", function () { return $07ea3d5914161ebd$export$cf6418260f8a6143; });
/**
 * Unidad de Fomento.
 */ var $07ea3d5914161ebd$export$cf6418260f8a6143 = {
    code: 'CLF',
    base: 10,
    exponent: 4
};


var $87fa7735c8457010$exports = {};

$parcel$export($87fa7735c8457010$exports, "CLP", function () { return $87fa7735c8457010$export$77341ee80c686439; });
/**
 * Chilean peso.
 */ var $87fa7735c8457010$export$77341ee80c686439 = {
    code: 'CLP',
    base: 10,
    exponent: 0
};


var $6c91a1b465a45bc8$exports = {};

$parcel$export($6c91a1b465a45bc8$exports, "CNY", function () { return $6c91a1b465a45bc8$export$325ea4323bda0f6a; });
/**
 * Renminbi (Chinese) yuan.
 */ var $6c91a1b465a45bc8$export$325ea4323bda0f6a = {
    code: 'CNY',
    base: 10,
    exponent: 2
};


var $7e42e92287e68573$exports = {};

$parcel$export($7e42e92287e68573$exports, "COP", function () { return $7e42e92287e68573$export$a2caae726dd811ed; });
/**
 * Colombian peso.
 */ var $7e42e92287e68573$export$a2caae726dd811ed = {
    code: 'COP',
    base: 10,
    exponent: 2
};


var $2ef2836589aa3f60$exports = {};

$parcel$export($2ef2836589aa3f60$exports, "COU", function () { return $2ef2836589aa3f60$export$2da79ce2a9b0abb; });
/**
 * Unidad de Valor Real.
 */ var $2ef2836589aa3f60$export$2da79ce2a9b0abb = {
    code: 'COU',
    base: 10,
    exponent: 2
};


var $36f835e060581a93$exports = {};

$parcel$export($36f835e060581a93$exports, "CRC", function () { return $36f835e060581a93$export$5be0c4d7d8d17551; });
/**
 * Costa Rican colón.
 */ var $36f835e060581a93$export$5be0c4d7d8d17551 = {
    code: 'CRC',
    base: 10,
    exponent: 2
};


var $fd105f3e0201d6ed$exports = {};

$parcel$export($fd105f3e0201d6ed$exports, "CUC", function () { return $fd105f3e0201d6ed$export$7fe5b40168547351; });
/**
 * Cuban convertible peso.
 */ var $fd105f3e0201d6ed$export$7fe5b40168547351 = {
    code: 'CUC',
    base: 10,
    exponent: 2
};


var $95e3082d4ca4d328$exports = {};

$parcel$export($95e3082d4ca4d328$exports, "CUP", function () { return $95e3082d4ca4d328$export$e9936a41b345be; });
/**
 * Cuban peso.
 */ var $95e3082d4ca4d328$export$e9936a41b345be = {
    code: 'CUP',
    base: 10,
    exponent: 2
};


var $3784e4d74a78951f$exports = {};

$parcel$export($3784e4d74a78951f$exports, "CVE", function () { return $3784e4d74a78951f$export$32cfd326097b8f08; });
/**
 * Cape Verdean escudo.
 */ var $3784e4d74a78951f$export$32cfd326097b8f08 = {
    code: 'CVE',
    base: 10,
    exponent: 2
};


var $83236117d7ae9170$exports = {};

$parcel$export($83236117d7ae9170$exports, "CZK", function () { return $83236117d7ae9170$export$aca176d79e58ea9f; });
/**
 * Czech koruna.
 */ var $83236117d7ae9170$export$aca176d79e58ea9f = {
    code: 'CZK',
    base: 10,
    exponent: 2
};


var $e18cf9733fdf1ae7$exports = {};

$parcel$export($e18cf9733fdf1ae7$exports, "DJF", function () { return $e18cf9733fdf1ae7$export$548c3ca5717ea76f; });
/**
 * Djiboutian franc.
 */ var $e18cf9733fdf1ae7$export$548c3ca5717ea76f = {
    code: 'DJF',
    base: 10,
    exponent: 0
};


var $e40df4ead4bf7248$exports = {};

$parcel$export($e40df4ead4bf7248$exports, "DKK", function () { return $e40df4ead4bf7248$export$d90ceb4d720ed8c5; });
/**
 * Danish krone.
 */ var $e40df4ead4bf7248$export$d90ceb4d720ed8c5 = {
    code: 'DKK',
    base: 10,
    exponent: 2
};


var $9c5b3298c0cc74e9$exports = {};

$parcel$export($9c5b3298c0cc74e9$exports, "DOP", function () { return $9c5b3298c0cc74e9$export$94fa695d2f8f9862; });
/**
 * Dominican peso.
 */ var $9c5b3298c0cc74e9$export$94fa695d2f8f9862 = {
    code: 'DOP',
    base: 10,
    exponent: 2
};


var $707147239bb593a1$exports = {};

$parcel$export($707147239bb593a1$exports, "DZD", function () { return $707147239bb593a1$export$4e7ee3eddfbba36c; });
/**
 * Algerian dinar.
 */ var $707147239bb593a1$export$4e7ee3eddfbba36c = {
    code: 'DZD',
    base: 10,
    exponent: 2
};


var $9b3654fb2ff93756$exports = {};

$parcel$export($9b3654fb2ff93756$exports, "EGP", function () { return $9b3654fb2ff93756$export$72cfeee20048f06f; });
/**
 * Egyptian pound.
 */ var $9b3654fb2ff93756$export$72cfeee20048f06f = {
    code: 'EGP',
    base: 10,
    exponent: 2
};


var $49e9cd1220dd2687$exports = {};

$parcel$export($49e9cd1220dd2687$exports, "ERN", function () { return $49e9cd1220dd2687$export$f5a50feb63922574; });
/**
 * Eritrean nakfa.
 */ var $49e9cd1220dd2687$export$f5a50feb63922574 = {
    code: 'ERN',
    base: 10,
    exponent: 2
};


var $e68375e689e370da$exports = {};

$parcel$export($e68375e689e370da$exports, "ETB", function () { return $e68375e689e370da$export$6eeecc5f4b7e3d5c; });
/**
 * Ethiopian birr.
 */ var $e68375e689e370da$export$6eeecc5f4b7e3d5c = {
    code: 'ETB',
    base: 10,
    exponent: 2
};


var $2d0c80cfa8af1bee$exports = {};

$parcel$export($2d0c80cfa8af1bee$exports, "EUR", function () { return $2d0c80cfa8af1bee$export$56b85b07b2af7a09; });
/**
 * Euro.
 */ var $2d0c80cfa8af1bee$export$56b85b07b2af7a09 = {
    code: 'EUR',
    base: 10,
    exponent: 2
};


var $c6e4cd18b8d4dd7e$exports = {};

$parcel$export($c6e4cd18b8d4dd7e$exports, "FJD", function () { return $c6e4cd18b8d4dd7e$export$6167b03b69946c68; });
/**
 * Fiji dollar.
 */ var $c6e4cd18b8d4dd7e$export$6167b03b69946c68 = {
    code: 'FJD',
    base: 10,
    exponent: 2
};


var $41d60081a822c2b3$exports = {};

$parcel$export($41d60081a822c2b3$exports, "FKP", function () { return $41d60081a822c2b3$export$76d79e9ec1dc1b14; });
/**
 * Falkland Islands pound.
 */ var $41d60081a822c2b3$export$76d79e9ec1dc1b14 = {
    code: 'FKP',
    base: 10,
    exponent: 2
};


var $d7737c6502fce4f5$exports = {};

$parcel$export($d7737c6502fce4f5$exports, "GBP", function () { return $d7737c6502fce4f5$export$934d96ab768fd888; });
/**
 * Pound sterling.
 */ var $d7737c6502fce4f5$export$934d96ab768fd888 = {
    code: 'GBP',
    base: 10,
    exponent: 2
};


var $6ad48aa643fbd25c$exports = {};

$parcel$export($6ad48aa643fbd25c$exports, "GEL", function () { return $6ad48aa643fbd25c$export$544ec57318f70bf8; });
/**
 * Georgian lari.
 */ var $6ad48aa643fbd25c$export$544ec57318f70bf8 = {
    code: 'GEL',
    base: 10,
    exponent: 2
};


var $7a70cc5d676ef645$exports = {};

$parcel$export($7a70cc5d676ef645$exports, "GHS", function () { return $7a70cc5d676ef645$export$c56f65a89a801e16; });
/**
 * Ghanaian cedi.
 */ var $7a70cc5d676ef645$export$c56f65a89a801e16 = {
    code: 'GHS',
    base: 10,
    exponent: 2
};


var $eeae45c91eb53483$exports = {};

$parcel$export($eeae45c91eb53483$exports, "GIP", function () { return $eeae45c91eb53483$export$e5f311a6abf8800b; });
/**
 * Gibraltar pound.
 */ var $eeae45c91eb53483$export$e5f311a6abf8800b = {
    code: 'GIP',
    base: 10,
    exponent: 2
};


var $7e04efc16c000050$exports = {};

$parcel$export($7e04efc16c000050$exports, "GMD", function () { return $7e04efc16c000050$export$9441872470d61f13; });
/**
 * Gambian dalasi.
 */ var $7e04efc16c000050$export$9441872470d61f13 = {
    code: 'GMD',
    base: 10,
    exponent: 2
};


var $25644e8ec0038984$exports = {};

$parcel$export($25644e8ec0038984$exports, "GNF", function () { return $25644e8ec0038984$export$73be1a9385a9e390; });
/**
 * Guinean franc.
 */ var $25644e8ec0038984$export$73be1a9385a9e390 = {
    code: 'GNF',
    base: 10,
    exponent: 0
};


var $0c34eeebb2b04960$exports = {};

$parcel$export($0c34eeebb2b04960$exports, "GTQ", function () { return $0c34eeebb2b04960$export$5e1fda4d3ba89258; });
/**
 * Guatemalan quetzal.
 */ var $0c34eeebb2b04960$export$5e1fda4d3ba89258 = {
    code: 'GTQ',
    base: 10,
    exponent: 2
};


var $5d847daa9a2526fb$exports = {};

$parcel$export($5d847daa9a2526fb$exports, "GYD", function () { return $5d847daa9a2526fb$export$11b17368230c9243; });
/**
 * Guyanese dollar.
 */ var $5d847daa9a2526fb$export$11b17368230c9243 = {
    code: 'GYD',
    base: 10,
    exponent: 2
};


var $77aa3e7d413a840d$exports = {};

$parcel$export($77aa3e7d413a840d$exports, "HKD", function () { return $77aa3e7d413a840d$export$be396ebdc990abac; });
/**
 * Hong Kong dollar.
 */ var $77aa3e7d413a840d$export$be396ebdc990abac = {
    code: 'HKD',
    base: 10,
    exponent: 2
};


var $3986d8c5e3b5667d$exports = {};

$parcel$export($3986d8c5e3b5667d$exports, "HNL", function () { return $3986d8c5e3b5667d$export$97c7bb505846d531; });
/**
 * Honduran lempira.
 */ var $3986d8c5e3b5667d$export$97c7bb505846d531 = {
    code: 'HNL',
    base: 10,
    exponent: 2
};


var $dbda48f0b8934ccd$exports = {};

$parcel$export($dbda48f0b8934ccd$exports, "HRK", function () { return $dbda48f0b8934ccd$export$ee22eecce6e7bd1; });
/**
 * Croatian kuna.
 */ var $dbda48f0b8934ccd$export$ee22eecce6e7bd1 = {
    code: 'HRK',
    base: 10,
    exponent: 2
};


var $d63f9fa480859a9d$exports = {};

$parcel$export($d63f9fa480859a9d$exports, "HTG", function () { return $d63f9fa480859a9d$export$176e4e43573b7e6; });
/**
 * Haitian gourde.
 */ var $d63f9fa480859a9d$export$176e4e43573b7e6 = {
    code: 'HTG',
    base: 10,
    exponent: 2
};


var $55142afb063cc96f$exports = {};

$parcel$export($55142afb063cc96f$exports, "HUF", function () { return $55142afb063cc96f$export$fce9e0d189d06245; });
/**
 * Hungarian forint.
 */ var $55142afb063cc96f$export$fce9e0d189d06245 = {
    code: 'HUF',
    base: 10,
    exponent: 2
};


var $70981b98d4929aaa$exports = {};

$parcel$export($70981b98d4929aaa$exports, "IDR", function () { return $70981b98d4929aaa$export$f8e8d0a7bc06722f; });
/**
 * Indonesian rupiah.
 */ var $70981b98d4929aaa$export$f8e8d0a7bc06722f = {
    code: 'IDR',
    base: 10,
    exponent: 2
};


var $f1c876ee8f195b2b$exports = {};

$parcel$export($f1c876ee8f195b2b$exports, "ILS", function () { return $f1c876ee8f195b2b$export$e3ee6abb20f3a6fd; });
/**
 * Israeli new shekel.
 */ var $f1c876ee8f195b2b$export$e3ee6abb20f3a6fd = {
    code: 'ILS',
    base: 10,
    exponent: 2
};


var $2f7772f6d7770577$exports = {};

$parcel$export($2f7772f6d7770577$exports, "INR", function () { return $2f7772f6d7770577$export$b58d7930a68cce5c; });
/**
 * Indian rupee.
 */ var $2f7772f6d7770577$export$b58d7930a68cce5c = {
    code: 'INR',
    base: 10,
    exponent: 2
};


var $f0a1ff318fc5b480$exports = {};

$parcel$export($f0a1ff318fc5b480$exports, "IQD", function () { return $f0a1ff318fc5b480$export$1f857362d42fe853; });
/**
 * Iraqi dinar.
 */ var $f0a1ff318fc5b480$export$1f857362d42fe853 = {
    code: 'IQD',
    base: 10,
    exponent: 3
};


var $d33992590d14d280$exports = {};

$parcel$export($d33992590d14d280$exports, "IRR", function () { return $d33992590d14d280$export$687b78831fd2914a; });
/**
 * Iranian rial.
 */ var $d33992590d14d280$export$687b78831fd2914a = {
    code: 'IRR',
    base: 10,
    exponent: 2
};


var $5a791dda799bd6f7$exports = {};

$parcel$export($5a791dda799bd6f7$exports, "ISK", function () { return $5a791dda799bd6f7$export$fdee7f5c81f1fd4f; });
/**
 * Icelandic króna.
 */ var $5a791dda799bd6f7$export$fdee7f5c81f1fd4f = {
    code: 'ISK',
    base: 10,
    exponent: 0
};


var $234db6fec6ea9b07$exports = {};

$parcel$export($234db6fec6ea9b07$exports, "JMD", function () { return $234db6fec6ea9b07$export$be27fd961b892d4f; });
/**
 * Jamaican dollar.
 */ var $234db6fec6ea9b07$export$be27fd961b892d4f = {
    code: 'JMD',
    base: 10,
    exponent: 2
};


var $a02a2b363c9c6acd$exports = {};

$parcel$export($a02a2b363c9c6acd$exports, "JOD", function () { return $a02a2b363c9c6acd$export$25002cff7f68b554; });
/**
 * Jordanian dinar.
 */ var $a02a2b363c9c6acd$export$25002cff7f68b554 = {
    code: 'JOD',
    base: 10,
    exponent: 3
};


var $c0cc6e5a72a2422b$exports = {};

$parcel$export($c0cc6e5a72a2422b$exports, "JPY", function () { return $c0cc6e5a72a2422b$export$7caf1906cda6c0a0; });
/**
 * Japanese yen.
 */ var $c0cc6e5a72a2422b$export$7caf1906cda6c0a0 = {
    code: 'JPY',
    base: 10,
    exponent: 0
};


var $8ff59fb871d0661a$exports = {};

$parcel$export($8ff59fb871d0661a$exports, "KES", function () { return $8ff59fb871d0661a$export$da35634becca9a74; });
/**
 * Kenyan shilling.
 */ var $8ff59fb871d0661a$export$da35634becca9a74 = {
    code: 'KES',
    base: 10,
    exponent: 2
};


var $6981d037ec1e5d24$exports = {};

$parcel$export($6981d037ec1e5d24$exports, "KGS", function () { return $6981d037ec1e5d24$export$e73d11d222fd60f8; });
/**
 * Kyrgyzstani som.
 */ var $6981d037ec1e5d24$export$e73d11d222fd60f8 = {
    code: 'KGS',
    base: 10,
    exponent: 2
};


var $87641413cad49405$exports = {};

$parcel$export($87641413cad49405$exports, "KHR", function () { return $87641413cad49405$export$f70cd670146893bd; });
/**
 * Cambodian riel.
 */ var $87641413cad49405$export$f70cd670146893bd = {
    code: 'KHR',
    base: 10,
    exponent: 2
};


var $1b3665e1491b9865$exports = {};

$parcel$export($1b3665e1491b9865$exports, "KMF", function () { return $1b3665e1491b9865$export$1072e025d4462d1b; });
/**
 * Comoro franc.
 */ var $1b3665e1491b9865$export$1072e025d4462d1b = {
    code: 'KMF',
    base: 10,
    exponent: 0
};


var $40937b0518bdb082$exports = {};

$parcel$export($40937b0518bdb082$exports, "KPW", function () { return $40937b0518bdb082$export$5c756429b819aa38; });
/**
 * North Korean won.
 */ var $40937b0518bdb082$export$5c756429b819aa38 = {
    code: 'KPW',
    base: 10,
    exponent: 2
};


var $6a51e26280985ca2$exports = {};

$parcel$export($6a51e26280985ca2$exports, "KRW", function () { return $6a51e26280985ca2$export$58ca5a2f61ada07b; });
/**
 * South Korean won.
 */ var $6a51e26280985ca2$export$58ca5a2f61ada07b = {
    code: 'KRW',
    base: 10,
    exponent: 0
};


var $d32ac6c869fdc4e0$exports = {};

$parcel$export($d32ac6c869fdc4e0$exports, "KWD", function () { return $d32ac6c869fdc4e0$export$5c3f122d27557d98; });
/**
 * Kuwaiti dinar.
 */ var $d32ac6c869fdc4e0$export$5c3f122d27557d98 = {
    code: 'KWD',
    base: 10,
    exponent: 3
};


var $2b399ae10f8743d8$exports = {};

$parcel$export($2b399ae10f8743d8$exports, "KYD", function () { return $2b399ae10f8743d8$export$7649504485c7f25b; });
/**
 * Cayman Islands dollar.
 */ var $2b399ae10f8743d8$export$7649504485c7f25b = {
    code: 'KYD',
    base: 10,
    exponent: 2
};


var $eb4968176786222b$exports = {};

$parcel$export($eb4968176786222b$exports, "KZT", function () { return $eb4968176786222b$export$c4b3c6a25e293cde; });
/**
 * Kazakhstani tenge.
 */ var $eb4968176786222b$export$c4b3c6a25e293cde = {
    code: 'KZT',
    base: 10,
    exponent: 2
};


var $cbec82fb1e408df0$exports = {};

$parcel$export($cbec82fb1e408df0$exports, "LAK", function () { return $cbec82fb1e408df0$export$657bd556216625d8; });
/**
 * Lao kip.
 */ var $cbec82fb1e408df0$export$657bd556216625d8 = {
    code: 'LAK',
    base: 10,
    exponent: 2
};


var $fa0feec9a5693036$exports = {};

$parcel$export($fa0feec9a5693036$exports, "LBP", function () { return $fa0feec9a5693036$export$2a0af9feaf4d436c; });
/**
 * Lebanese pound.
 */ var $fa0feec9a5693036$export$2a0af9feaf4d436c = {
    code: 'LBP',
    base: 10,
    exponent: 2
};


var $27358b34a663ff8b$exports = {};

$parcel$export($27358b34a663ff8b$exports, "LKR", function () { return $27358b34a663ff8b$export$dd99e632ff56e663; });
/**
 * Sri Lankan rupee.
 */ var $27358b34a663ff8b$export$dd99e632ff56e663 = {
    code: 'LKR',
    base: 10,
    exponent: 2
};


var $42853197e29f5104$exports = {};

$parcel$export($42853197e29f5104$exports, "LRD", function () { return $42853197e29f5104$export$ed7c954349be181d; });
/**
 * Liberian dollar.
 */ var $42853197e29f5104$export$ed7c954349be181d = {
    code: 'LRD',
    base: 10,
    exponent: 2
};


var $4dd7848181c0c024$exports = {};

$parcel$export($4dd7848181c0c024$exports, "LSL", function () { return $4dd7848181c0c024$export$9a2605e913d3a892; });
/**
 * Lesotho loti.
 */ var $4dd7848181c0c024$export$9a2605e913d3a892 = {
    code: 'LSL',
    base: 10,
    exponent: 2
};


var $987f02034ea1ba05$exports = {};

$parcel$export($987f02034ea1ba05$exports, "LYD", function () { return $987f02034ea1ba05$export$323301eec69f1190; });
/**
 * Libyan dinar.
 */ var $987f02034ea1ba05$export$323301eec69f1190 = {
    code: 'LYD',
    base: 10,
    exponent: 3
};


var $ab077577423bea19$exports = {};

$parcel$export($ab077577423bea19$exports, "MAD", function () { return $ab077577423bea19$export$5f1384b794ae49f1; });
/**
 * Moroccan dirham.
 */ var $ab077577423bea19$export$5f1384b794ae49f1 = {
    code: 'MAD',
    base: 10,
    exponent: 2
};


var $92bb9d7448eafa84$exports = {};

$parcel$export($92bb9d7448eafa84$exports, "MDL", function () { return $92bb9d7448eafa84$export$c55fb11b658367ed; });
/**
 * Moldovan leu.
 */ var $92bb9d7448eafa84$export$c55fb11b658367ed = {
    code: 'MDL',
    base: 10,
    exponent: 2
};


var $e7403573cd6a2474$exports = {};

$parcel$export($e7403573cd6a2474$exports, "MGA", function () { return $e7403573cd6a2474$export$8b8edc4d3cdda59; });
/**
 * Malagasy ariary.
 */ var $e7403573cd6a2474$export$8b8edc4d3cdda59 = {
    code: 'MGA',
    base: 5,
    exponent: 1
};


var $62e1a650a00c2f90$exports = {};

$parcel$export($62e1a650a00c2f90$exports, "MKD", function () { return $62e1a650a00c2f90$export$f566ca5422e9e2ec; });
/**
 * Macedonian denar.
 */ var $62e1a650a00c2f90$export$f566ca5422e9e2ec = {
    code: 'MKD',
    base: 10,
    exponent: 2
};


var $b51da6c02df5e758$exports = {};

$parcel$export($b51da6c02df5e758$exports, "MMK", function () { return $b51da6c02df5e758$export$566d5c50b4c2aa85; });
/**
 * Myanmar kyat.
 */ var $b51da6c02df5e758$export$566d5c50b4c2aa85 = {
    code: 'MMK',
    base: 10,
    exponent: 2
};


var $2bf330a54cf2f83c$exports = {};

$parcel$export($2bf330a54cf2f83c$exports, "MNT", function () { return $2bf330a54cf2f83c$export$ec1b2260d57c09d2; });
/**
 * Mongolian tögrög.
 */ var $2bf330a54cf2f83c$export$ec1b2260d57c09d2 = {
    code: 'MNT',
    base: 10,
    exponent: 2
};


var $6233fddc32f1ccb4$exports = {};

$parcel$export($6233fddc32f1ccb4$exports, "MOP", function () { return $6233fddc32f1ccb4$export$884bdd024177836b; });
/**
 * Macanese pataca.
 */ var $6233fddc32f1ccb4$export$884bdd024177836b = {
    code: 'MOP',
    base: 10,
    exponent: 2
};


var $2b537e88297243cd$exports = {};

$parcel$export($2b537e88297243cd$exports, "MRU", function () { return $2b537e88297243cd$export$68a7195d53dd72e3; });
/**
 * Mauritanian ouguiya.
 */ var $2b537e88297243cd$export$68a7195d53dd72e3 = {
    code: 'MRU',
    base: 5,
    exponent: 1
};


var $31dab33d6605b22c$exports = {};

$parcel$export($31dab33d6605b22c$exports, "MUR", function () { return $31dab33d6605b22c$export$2142ac2229f99f3b; });
/**
 * Mauritian rupee.
 */ var $31dab33d6605b22c$export$2142ac2229f99f3b = {
    code: 'MUR',
    base: 10,
    exponent: 2
};


var $2d58866272930040$exports = {};

$parcel$export($2d58866272930040$exports, "MVR", function () { return $2d58866272930040$export$6a11c395a4c945bb; });
/**
 * Maldivian rufiyaa.
 */ var $2d58866272930040$export$6a11c395a4c945bb = {
    code: 'MVR',
    base: 10,
    exponent: 2
};


var $cfb9897df024f970$exports = {};

$parcel$export($cfb9897df024f970$exports, "MWK", function () { return $cfb9897df024f970$export$6462512701447579; });
/**
 * Malawian kwacha.
 */ var $cfb9897df024f970$export$6462512701447579 = {
    code: 'MWK',
    base: 10,
    exponent: 2
};


var $57ce641b60ad1f09$exports = {};

$parcel$export($57ce641b60ad1f09$exports, "MXN", function () { return $57ce641b60ad1f09$export$d61769f099cad2b; });
/**
 * Mexican peso.
 */ var $57ce641b60ad1f09$export$d61769f099cad2b = {
    code: 'MXN',
    base: 10,
    exponent: 2
};


var $328e066866044f75$exports = {};

$parcel$export($328e066866044f75$exports, "MXV", function () { return $328e066866044f75$export$a566b9886bb9c6c3; });
/**
 * Mexican Unidad de Inversion.
 */ var $328e066866044f75$export$a566b9886bb9c6c3 = {
    code: 'MXV',
    base: 10,
    exponent: 2
};


var $77acb42fd731a974$exports = {};

$parcel$export($77acb42fd731a974$exports, "MYR", function () { return $77acb42fd731a974$export$c42367d1d910b54; });
/**
 * Malaysian ringgit.
 */ var $77acb42fd731a974$export$c42367d1d910b54 = {
    code: 'MYR',
    base: 10,
    exponent: 2
};


var $bf2b8edecb485bc0$exports = {};

$parcel$export($bf2b8edecb485bc0$exports, "MZN", function () { return $bf2b8edecb485bc0$export$5771eab37e30c961; });
/**
 * Mozambican metical.
 */ var $bf2b8edecb485bc0$export$5771eab37e30c961 = {
    code: 'MZN',
    base: 10,
    exponent: 2
};


var $2837317e530c5450$exports = {};

$parcel$export($2837317e530c5450$exports, "NAD", function () { return $2837317e530c5450$export$c84433d0c3bf98ce; });
/**
 * Namibian dollar.
 */ var $2837317e530c5450$export$c84433d0c3bf98ce = {
    code: 'NAD',
    base: 10,
    exponent: 2
};


var $52257294db3896cd$exports = {};

$parcel$export($52257294db3896cd$exports, "NGN", function () { return $52257294db3896cd$export$fec9c06778f525b5; });
/**
 * Nigerian naira.
 */ var $52257294db3896cd$export$fec9c06778f525b5 = {
    code: 'NGN',
    base: 10,
    exponent: 2
};


var $ba036a26559a5c17$exports = {};

$parcel$export($ba036a26559a5c17$exports, "NIO", function () { return $ba036a26559a5c17$export$f7f7d9f75f713b0a; });
/**
 * Nicaraguan córdoba.
 */ var $ba036a26559a5c17$export$f7f7d9f75f713b0a = {
    code: 'NIO',
    base: 10,
    exponent: 2
};


var $e1696568bc95feb0$exports = {};

$parcel$export($e1696568bc95feb0$exports, "NOK", function () { return $e1696568bc95feb0$export$3b63806dd8f8f73e; });
/**
 * Norwegian krone.
 */ var $e1696568bc95feb0$export$3b63806dd8f8f73e = {
    code: 'NOK',
    base: 10,
    exponent: 2
};


var $740f22ae5497ef51$exports = {};

$parcel$export($740f22ae5497ef51$exports, "NPR", function () { return $740f22ae5497ef51$export$1a741b0947a57df4; });
/**
 * Nepalese rupee.
 */ var $740f22ae5497ef51$export$1a741b0947a57df4 = {
    code: 'NPR',
    base: 10,
    exponent: 2
};


var $a494b73b82d4f4a8$exports = {};

$parcel$export($a494b73b82d4f4a8$exports, "NZD", function () { return $a494b73b82d4f4a8$export$3b0ed7964ddcad73; });
/**
 * New Zealand dollar.
 */ var $a494b73b82d4f4a8$export$3b0ed7964ddcad73 = {
    code: 'NZD',
    base: 10,
    exponent: 2
};


var $22b4b029844a308f$exports = {};

$parcel$export($22b4b029844a308f$exports, "OMR", function () { return $22b4b029844a308f$export$20a97b75d898a4ca; });
/**
 * Omani rial.
 */ var $22b4b029844a308f$export$20a97b75d898a4ca = {
    code: 'OMR',
    base: 10,
    exponent: 3
};


var $bd60c8df71042981$exports = {};

$parcel$export($bd60c8df71042981$exports, "PAB", function () { return $bd60c8df71042981$export$f5af66254c5a4ab4; });
/**
 * Panamanian balboa.
 */ var $bd60c8df71042981$export$f5af66254c5a4ab4 = {
    code: 'PAB',
    base: 10,
    exponent: 2
};


var $c67be5fd22890b66$exports = {};

$parcel$export($c67be5fd22890b66$exports, "PEN", function () { return $c67be5fd22890b66$export$ca04b20a4bb1ded7; });
/**
 * Peruvian sol.
 */ var $c67be5fd22890b66$export$ca04b20a4bb1ded7 = {
    code: 'PEN',
    base: 10,
    exponent: 2
};


var $f6839deca4f0faed$exports = {};

$parcel$export($f6839deca4f0faed$exports, "PGK", function () { return $f6839deca4f0faed$export$1406569ed2374d9f; });
/**
 * Papua New Guinean kina.
 */ var $f6839deca4f0faed$export$1406569ed2374d9f = {
    code: 'PGK',
    base: 10,
    exponent: 2
};


var $65f2c3ed38fcc1b6$exports = {};

$parcel$export($65f2c3ed38fcc1b6$exports, "PHP", function () { return $65f2c3ed38fcc1b6$export$75e463e960baeac; });
/**
 * Philippine peso.
 */ var $65f2c3ed38fcc1b6$export$75e463e960baeac = {
    code: 'PHP',
    base: 10,
    exponent: 2
};


var $a58b87f0cb185e17$exports = {};

$parcel$export($a58b87f0cb185e17$exports, "PKR", function () { return $a58b87f0cb185e17$export$45ff23536335e66d; });
/**
 * Pakistani rupee.
 */ var $a58b87f0cb185e17$export$45ff23536335e66d = {
    code: 'PKR',
    base: 10,
    exponent: 2
};


var $d92b430cab86c221$exports = {};

$parcel$export($d92b430cab86c221$exports, "PLN", function () { return $d92b430cab86c221$export$374bf6cbdd4e0a9b; });
/**
 * Polish złoty.
 */ var $d92b430cab86c221$export$374bf6cbdd4e0a9b = {
    code: 'PLN',
    base: 10,
    exponent: 2
};


var $9105215748b7e48e$exports = {};

$parcel$export($9105215748b7e48e$exports, "PYG", function () { return $9105215748b7e48e$export$315d544764e8861a; });
/**
 * Paraguayan guaraní.
 */ var $9105215748b7e48e$export$315d544764e8861a = {
    code: 'PYG',
    base: 10,
    exponent: 0
};


var $61dbf81b1edc9e76$exports = {};

$parcel$export($61dbf81b1edc9e76$exports, "QAR", function () { return $61dbf81b1edc9e76$export$a202b8041dc2628c; });
/**
 * Qatari riyal.
 */ var $61dbf81b1edc9e76$export$a202b8041dc2628c = {
    code: 'QAR',
    base: 10,
    exponent: 2
};


var $f457aa70f4a77035$exports = {};

$parcel$export($f457aa70f4a77035$exports, "RON", function () { return $f457aa70f4a77035$export$2839d627b6f3bcfe; });
/**
 * Romanian leu.
 */ var $f457aa70f4a77035$export$2839d627b6f3bcfe = {
    code: 'RON',
    base: 10,
    exponent: 2
};


var $cd64af8ab8c6f9db$exports = {};

$parcel$export($cd64af8ab8c6f9db$exports, "RSD", function () { return $cd64af8ab8c6f9db$export$4d089f9d5db564c8; });
/**
 * Serbian dinar.
 */ var $cd64af8ab8c6f9db$export$4d089f9d5db564c8 = {
    code: 'RSD',
    base: 10,
    exponent: 2
};


var $bb19e99512e26554$exports = {};

$parcel$export($bb19e99512e26554$exports, "RUB", function () { return $bb19e99512e26554$export$bbaaf8b71d37054f; });
/**
 * Russian ruble.
 */ var $bb19e99512e26554$export$bbaaf8b71d37054f = {
    code: 'RUB',
    base: 10,
    exponent: 2
};


var $b04a1eb010f8b82a$exports = {};

$parcel$export($b04a1eb010f8b82a$exports, "RWF", function () { return $b04a1eb010f8b82a$export$3093f9475438b2ed; });
/**
 * Rwandan franc.
 */ var $b04a1eb010f8b82a$export$3093f9475438b2ed = {
    code: 'RWF',
    base: 10,
    exponent: 0
};


var $dc1f51c962b644da$exports = {};

$parcel$export($dc1f51c962b644da$exports, "SAR", function () { return $dc1f51c962b644da$export$f9c879fd08a1126b; });
/**
 * Saudi riyal.
 */ var $dc1f51c962b644da$export$f9c879fd08a1126b = {
    code: 'SAR',
    base: 10,
    exponent: 2
};


var $4497b2180ea2cb3a$exports = {};

$parcel$export($4497b2180ea2cb3a$exports, "SBD", function () { return $4497b2180ea2cb3a$export$3dd140a2fd6202e0; });
/**
 * Solomon Islands dollar.
 */ var $4497b2180ea2cb3a$export$3dd140a2fd6202e0 = {
    code: 'SBD',
    base: 10,
    exponent: 2
};


var $aad67d2db0252d83$exports = {};

$parcel$export($aad67d2db0252d83$exports, "SCR", function () { return $aad67d2db0252d83$export$781aa9089a01e5e1; });
/**
 * Seychelles rupee.
 */ var $aad67d2db0252d83$export$781aa9089a01e5e1 = {
    code: 'SCR',
    base: 10,
    exponent: 2
};


var $813be430397a954d$exports = {};

$parcel$export($813be430397a954d$exports, "SDG", function () { return $813be430397a954d$export$65ed97b9023cb1de; });
/**
 * Sudanese pound.
 */ var $813be430397a954d$export$65ed97b9023cb1de = {
    code: 'SDG',
    base: 10,
    exponent: 2
};


var $5228f3becf7c5e68$exports = {};

$parcel$export($5228f3becf7c5e68$exports, "SEK", function () { return $5228f3becf7c5e68$export$e9d4596f22e5cdbf; });
/**
 * Swedish krona.
 */ var $5228f3becf7c5e68$export$e9d4596f22e5cdbf = {
    code: 'SEK',
    base: 10,
    exponent: 2
};


var $892275b705e92cac$exports = {};

$parcel$export($892275b705e92cac$exports, "SGD", function () { return $892275b705e92cac$export$e33e8c14b6cdfdd6; });
/**
 * Singapore dollar.
 */ var $892275b705e92cac$export$e33e8c14b6cdfdd6 = {
    code: 'SGD',
    base: 10,
    exponent: 2
};


var $2f985fb863f63949$exports = {};

$parcel$export($2f985fb863f63949$exports, "SHP", function () { return $2f985fb863f63949$export$c14263469285bbc; });
/**
 * Saint Helena pound.
 */ var $2f985fb863f63949$export$c14263469285bbc = {
    code: 'SHP',
    base: 10,
    exponent: 2
};


var $5aef5d8316f933e3$exports = {};

$parcel$export($5aef5d8316f933e3$exports, "SLL", function () { return $5aef5d8316f933e3$export$7531c1012352dd09; });
/**
 * Sierra Leonean leone.
 */ var $5aef5d8316f933e3$export$7531c1012352dd09 = {
    code: 'SLL',
    base: 10,
    exponent: 2
};


var $d3eb3f638a4da489$exports = {};

$parcel$export($d3eb3f638a4da489$exports, "SOS", function () { return $d3eb3f638a4da489$export$abfaf66b49b724de; });
/**
 * Somali shilling.
 */ var $d3eb3f638a4da489$export$abfaf66b49b724de = {
    code: 'SOS',
    base: 10,
    exponent: 2
};


var $5417e159c0e251c2$exports = {};

$parcel$export($5417e159c0e251c2$exports, "SRD", function () { return $5417e159c0e251c2$export$6522f6980d903b70; });
/**
 * Surinamese dollar.
 */ var $5417e159c0e251c2$export$6522f6980d903b70 = {
    code: 'SRD',
    base: 10,
    exponent: 2
};


var $2690310ccd6d9b50$exports = {};

$parcel$export($2690310ccd6d9b50$exports, "SSP", function () { return $2690310ccd6d9b50$export$cc443f0cb3cb3c72; });
/**
 * South Sudanese pound.
 */ var $2690310ccd6d9b50$export$cc443f0cb3cb3c72 = {
    code: 'SSP',
    base: 10,
    exponent: 2
};


var $dc14fa403d5f95e6$exports = {};

$parcel$export($dc14fa403d5f95e6$exports, "STN", function () { return $dc14fa403d5f95e6$export$8b4ea4de0b678631; });
/**
 * São Tomé and Príncipe dobra.
 */ var $dc14fa403d5f95e6$export$8b4ea4de0b678631 = {
    code: 'STN',
    base: 10,
    exponent: 2
};


var $8bd67308d145f912$exports = {};

$parcel$export($8bd67308d145f912$exports, "SVC", function () { return $8bd67308d145f912$export$eda5eb6fa1a6fe77; });
/**
 * Salvadoran colón.
 */ var $8bd67308d145f912$export$eda5eb6fa1a6fe77 = {
    code: 'SVC',
    base: 10,
    exponent: 2
};


var $32baddab6588662c$exports = {};

$parcel$export($32baddab6588662c$exports, "SYP", function () { return $32baddab6588662c$export$16bded9b9ef0eac6; });
/**
 * Syrian pound.
 */ var $32baddab6588662c$export$16bded9b9ef0eac6 = {
    code: 'SYP',
    base: 10,
    exponent: 2
};


var $adf0a42e99fe8590$exports = {};

$parcel$export($adf0a42e99fe8590$exports, "SZL", function () { return $adf0a42e99fe8590$export$c2a291fe530a6676; });
/**
 * Swazi lilangeni.
 */ var $adf0a42e99fe8590$export$c2a291fe530a6676 = {
    code: 'SZL',
    base: 10,
    exponent: 2
};


var $0d2f1c1e44da8faa$exports = {};

$parcel$export($0d2f1c1e44da8faa$exports, "THB", function () { return $0d2f1c1e44da8faa$export$1f5d90316d5a5e9; });
/**
 * Thai baht.
 */ var $0d2f1c1e44da8faa$export$1f5d90316d5a5e9 = {
    code: 'THB',
    base: 10,
    exponent: 2
};


var $ea59de721198407d$exports = {};

$parcel$export($ea59de721198407d$exports, "TJS", function () { return $ea59de721198407d$export$e8bf52a2032ec3f5; });
/**
 * Tajikistani somoni.
 */ var $ea59de721198407d$export$e8bf52a2032ec3f5 = {
    code: 'TJS',
    base: 10,
    exponent: 2
};


var $48f5f27e3556ff68$exports = {};

$parcel$export($48f5f27e3556ff68$exports, "TMT", function () { return $48f5f27e3556ff68$export$6829d66e1ee4d77f; });
/**
 * Turkmenistan manat.
 */ var $48f5f27e3556ff68$export$6829d66e1ee4d77f = {
    code: 'TMT',
    base: 10,
    exponent: 2
};


var $dfcc249873e82dc8$exports = {};

$parcel$export($dfcc249873e82dc8$exports, "TND", function () { return $dfcc249873e82dc8$export$7bf4fb576181caa3; });
/**
 * Tunisian dinar.
 */ var $dfcc249873e82dc8$export$7bf4fb576181caa3 = {
    code: 'TND',
    base: 10,
    exponent: 3
};


var $825b7f34dd1cb6f2$exports = {};

$parcel$export($825b7f34dd1cb6f2$exports, "TOP", function () { return $825b7f34dd1cb6f2$export$793ed84f5e13fedc; });
/**
 * Tongan paʻanga.
 */ var $825b7f34dd1cb6f2$export$793ed84f5e13fedc = {
    code: 'TOP',
    base: 10,
    exponent: 2
};


var $1dd934247c82c748$exports = {};

$parcel$export($1dd934247c82c748$exports, "TRY", function () { return $1dd934247c82c748$export$d5ffd01a575cba8e; });
/**
 * Turkish lira.
 */ var $1dd934247c82c748$export$d5ffd01a575cba8e = {
    code: 'TRY',
    base: 10,
    exponent: 2
};


var $599a7f1705406622$exports = {};

$parcel$export($599a7f1705406622$exports, "TTD", function () { return $599a7f1705406622$export$381a3f455fff859b; });
/**
 * Trinidad and Tobago dollar.
 */ var $599a7f1705406622$export$381a3f455fff859b = {
    code: 'TTD',
    base: 10,
    exponent: 2
};


var $15e188d4b78f5972$exports = {};

$parcel$export($15e188d4b78f5972$exports, "TWD", function () { return $15e188d4b78f5972$export$e91d874a1116245f; });
/**
 * New Taiwan dollar.
 */ var $15e188d4b78f5972$export$e91d874a1116245f = {
    code: 'TWD',
    base: 10,
    exponent: 2
};


var $afb5e4549ba0a557$exports = {};

$parcel$export($afb5e4549ba0a557$exports, "TZS", function () { return $afb5e4549ba0a557$export$c29267c2430495b9; });
/**
 * Tanzanian shilling.
 */ var $afb5e4549ba0a557$export$c29267c2430495b9 = {
    code: 'TZS',
    base: 10,
    exponent: 2
};


var $b7ff0866a0cfcb19$exports = {};

$parcel$export($b7ff0866a0cfcb19$exports, "UAH", function () { return $b7ff0866a0cfcb19$export$d1cb182b5ade2793; });
/**
 * Ukrainian hryvnia.
 */ var $b7ff0866a0cfcb19$export$d1cb182b5ade2793 = {
    code: 'UAH',
    base: 10,
    exponent: 2
};


var $53e0c1541e70ba90$exports = {};

$parcel$export($53e0c1541e70ba90$exports, "UGX", function () { return $53e0c1541e70ba90$export$dd6bf1c422a82464; });
/**
 * Ugandan shilling.
 */ var $53e0c1541e70ba90$export$dd6bf1c422a82464 = {
    code: 'UGX',
    base: 10,
    exponent: 0
};


var $72d5601414c40032$exports = {};

$parcel$export($72d5601414c40032$exports, "USD", function () { return $72d5601414c40032$export$21abe75bbf5aa63c; });
/**
 * United States dollar.
 */ var $72d5601414c40032$export$21abe75bbf5aa63c = {
    code: 'USD',
    base: 10,
    exponent: 2
};


var $1bb42103a1ae40e3$exports = {};

$parcel$export($1bb42103a1ae40e3$exports, "USN", function () { return $1bb42103a1ae40e3$export$79215014ef451883; });
/**
 * United States dollar (next day).
 */ var $1bb42103a1ae40e3$export$79215014ef451883 = {
    code: 'USN',
    base: 10,
    exponent: 2
};


var $6dadaee8977d0b8c$exports = {};

$parcel$export($6dadaee8977d0b8c$exports, "UYI", function () { return $6dadaee8977d0b8c$export$e8eb52296cca9232; });
/**
 * Uruguay Peso en Unidades Indexadas.
 */ var $6dadaee8977d0b8c$export$e8eb52296cca9232 = {
    code: 'UYI',
    base: 10,
    exponent: 0
};


var $1d986aa2fc5a2042$exports = {};

$parcel$export($1d986aa2fc5a2042$exports, "UYU", function () { return $1d986aa2fc5a2042$export$16790656c68d6873; });
/**
 * Uruguayan peso.
 */ var $1d986aa2fc5a2042$export$16790656c68d6873 = {
    code: 'UYU',
    base: 10,
    exponent: 2
};


var $0fe3d4cdc95005aa$exports = {};

$parcel$export($0fe3d4cdc95005aa$exports, "UYW", function () { return $0fe3d4cdc95005aa$export$7b60d547ad20c3ef; });
/**
 * Unidad previsional.
 */ var $0fe3d4cdc95005aa$export$7b60d547ad20c3ef = {
    code: 'UYW',
    base: 10,
    exponent: 4
};


var $09cd3d5ccc05004a$exports = {};

$parcel$export($09cd3d5ccc05004a$exports, "UZS", function () { return $09cd3d5ccc05004a$export$a4012b66618e1b4a; });
/**
 * Uzbekistani soʻm.
 */ var $09cd3d5ccc05004a$export$a4012b66618e1b4a = {
    code: 'UZS',
    base: 10,
    exponent: 2
};


var $4b43cd23628ca369$exports = {};

$parcel$export($4b43cd23628ca369$exports, "VES", function () { return $4b43cd23628ca369$export$8033bc8283664ea9; });
/**
 * Venezuelan bolívar.
 */ var $4b43cd23628ca369$export$8033bc8283664ea9 = {
    code: 'VES',
    base: 10,
    exponent: 2
};


var $2ca38ba22cd2f300$exports = {};

$parcel$export($2ca38ba22cd2f300$exports, "VND", function () { return $2ca38ba22cd2f300$export$392409f229620c6d; });
/**
 * Vietnamese đồng.
 */ var $2ca38ba22cd2f300$export$392409f229620c6d = {
    code: 'VND',
    base: 10,
    exponent: 0
};


var $4495b1c997b70580$exports = {};

$parcel$export($4495b1c997b70580$exports, "VUV", function () { return $4495b1c997b70580$export$4ca1d7a3b2b140e1; });
/**
 * Vanuatu vatu.
 */ var $4495b1c997b70580$export$4ca1d7a3b2b140e1 = {
    code: 'VUV',
    base: 10,
    exponent: 0
};


var $f6740f806551d358$exports = {};

$parcel$export($f6740f806551d358$exports, "WST", function () { return $f6740f806551d358$export$fa048c6deb79e2a8; });
/**
 * Samoan tālā.
 */ var $f6740f806551d358$export$fa048c6deb79e2a8 = {
    code: 'WST',
    base: 10,
    exponent: 2
};


var $87bafbe07a5bf1af$exports = {};

$parcel$export($87bafbe07a5bf1af$exports, "XAF", function () { return $87bafbe07a5bf1af$export$a6ea4b1cbbcc1e5d; });
/**
 * Central African CFA franc.
 */ var $87bafbe07a5bf1af$export$a6ea4b1cbbcc1e5d = {
    code: 'XAF',
    base: 10,
    exponent: 0
};


var $5a643ddce70fd979$exports = {};

$parcel$export($5a643ddce70fd979$exports, "XCD", function () { return $5a643ddce70fd979$export$b23517abde8e9bff; });
/**
 * East Caribbean dollar.
 */ var $5a643ddce70fd979$export$b23517abde8e9bff = {
    code: 'XCD',
    base: 10,
    exponent: 2
};


var $b35766029a724a8a$exports = {};

$parcel$export($b35766029a724a8a$exports, "XOF", function () { return $b35766029a724a8a$export$340640fe64d21a28; });
/**
 * West African CFA franc.
 */ var $b35766029a724a8a$export$340640fe64d21a28 = {
    code: 'XOF',
    base: 10,
    exponent: 0
};


var $7f922c12ede6cc55$exports = {};

$parcel$export($7f922c12ede6cc55$exports, "XPF", function () { return $7f922c12ede6cc55$export$6cc2f916f5da5ece; });
/**
 * CFP franc.
 */ var $7f922c12ede6cc55$export$6cc2f916f5da5ece = {
    code: 'XPF',
    base: 10,
    exponent: 0
};


var $84780d4b456edd4e$exports = {};

$parcel$export($84780d4b456edd4e$exports, "YER", function () { return $84780d4b456edd4e$export$ff2e2033f932dfb7; });
/**
 * Yemeni rial.
 */ var $84780d4b456edd4e$export$ff2e2033f932dfb7 = {
    code: 'YER',
    base: 10,
    exponent: 2
};


var $fa5d0ce3ee0cb7aa$exports = {};

$parcel$export($fa5d0ce3ee0cb7aa$exports, "ZAR", function () { return $fa5d0ce3ee0cb7aa$export$6907838e42fd4fe0; });
/**
 * South African rand.
 */ var $fa5d0ce3ee0cb7aa$export$6907838e42fd4fe0 = {
    code: 'ZAR',
    base: 10,
    exponent: 2
};


var $fe5e344b015a0dfd$exports = {};

$parcel$export($fe5e344b015a0dfd$exports, "ZMW", function () { return $fe5e344b015a0dfd$export$9cb70409bc26a537; });
/**
 * Zambian kwacha.
 */ var $fe5e344b015a0dfd$export$9cb70409bc26a537 = {
    code: 'ZMW',
    base: 10,
    exponent: 2
};


var $2a62d631ec219dba$exports = {};

$parcel$export($2a62d631ec219dba$exports, "ZWL", function () { return $2a62d631ec219dba$export$60784d2879a6b146; });
/**
 * Zimbabwean dollar.
 */ var $2a62d631ec219dba$export$60784d2879a6b146 = {
    code: 'ZWL',
    base: 10,
    exponent: 2
};


$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2b47cb7b3fe3332d$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $f964822479586124$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $daa31b0a6adc1c54$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $fadf14ddbd2c81c2$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $e728c0e49ee8acdc$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $8f06a82fbf4a085e$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $8df36c2b362431f7$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $850f2ef0359c12cc$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $965b78b915a1a68a$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $d977739fe2a1ad8d$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $b6a2d3712341df9c$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $bd03e19f1e58a353$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $9cb8e893e4f336e4$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2c45afefc0688b0f$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $a8d577a403e3c27b$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $4f4487f95ac2b427$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $fb1e96c968e67277$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $546ffc8df1f85046$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $ef234d7657f7ac97$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $8a194f72e0114463$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $036db5f3a18e5aef$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $9a12ad1e029ead8c$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $c9e64a42cf7f8404$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $05e78743ca81a775$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $5be7c2ab0dd41ea1$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $4e3ff54668829b0a$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $12cbf1ecc1f0ac35$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $d2b4760855949ba4$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $aea2c41d5a53517b$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $caebf02998ed4d27$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $4afd7cf5dec93b3f$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $07ea3d5914161ebd$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $87fa7735c8457010$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $6c91a1b465a45bc8$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $7e42e92287e68573$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2ef2836589aa3f60$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $36f835e060581a93$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $fd105f3e0201d6ed$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $95e3082d4ca4d328$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $3784e4d74a78951f$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $83236117d7ae9170$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $e18cf9733fdf1ae7$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $e40df4ead4bf7248$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $9c5b3298c0cc74e9$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $707147239bb593a1$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $9b3654fb2ff93756$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $49e9cd1220dd2687$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $e68375e689e370da$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2d0c80cfa8af1bee$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $c6e4cd18b8d4dd7e$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $41d60081a822c2b3$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $d7737c6502fce4f5$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $6ad48aa643fbd25c$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $7a70cc5d676ef645$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $eeae45c91eb53483$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $7e04efc16c000050$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $25644e8ec0038984$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $0c34eeebb2b04960$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $5d847daa9a2526fb$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $77aa3e7d413a840d$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $3986d8c5e3b5667d$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $dbda48f0b8934ccd$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $d63f9fa480859a9d$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $55142afb063cc96f$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $70981b98d4929aaa$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $f1c876ee8f195b2b$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2f7772f6d7770577$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $f0a1ff318fc5b480$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $d33992590d14d280$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $5a791dda799bd6f7$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $234db6fec6ea9b07$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $a02a2b363c9c6acd$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $c0cc6e5a72a2422b$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $8ff59fb871d0661a$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $6981d037ec1e5d24$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $87641413cad49405$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $1b3665e1491b9865$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $40937b0518bdb082$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $6a51e26280985ca2$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $d32ac6c869fdc4e0$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2b399ae10f8743d8$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $eb4968176786222b$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $cbec82fb1e408df0$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $fa0feec9a5693036$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $27358b34a663ff8b$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $42853197e29f5104$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $4dd7848181c0c024$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $987f02034ea1ba05$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $ab077577423bea19$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $92bb9d7448eafa84$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $e7403573cd6a2474$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $62e1a650a00c2f90$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $b51da6c02df5e758$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2bf330a54cf2f83c$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $6233fddc32f1ccb4$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2b537e88297243cd$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $31dab33d6605b22c$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2d58866272930040$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $cfb9897df024f970$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $57ce641b60ad1f09$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $328e066866044f75$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $77acb42fd731a974$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $bf2b8edecb485bc0$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2837317e530c5450$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $52257294db3896cd$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $ba036a26559a5c17$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $e1696568bc95feb0$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $740f22ae5497ef51$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $a494b73b82d4f4a8$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $22b4b029844a308f$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $bd60c8df71042981$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $c67be5fd22890b66$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $f6839deca4f0faed$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $65f2c3ed38fcc1b6$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $a58b87f0cb185e17$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $d92b430cab86c221$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $9105215748b7e48e$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $61dbf81b1edc9e76$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $f457aa70f4a77035$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $cd64af8ab8c6f9db$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $bb19e99512e26554$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $b04a1eb010f8b82a$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $dc1f51c962b644da$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $4497b2180ea2cb3a$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $aad67d2db0252d83$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $813be430397a954d$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $5228f3becf7c5e68$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $892275b705e92cac$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2f985fb863f63949$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $5aef5d8316f933e3$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $d3eb3f638a4da489$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $5417e159c0e251c2$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2690310ccd6d9b50$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $dc14fa403d5f95e6$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $8bd67308d145f912$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $32baddab6588662c$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $adf0a42e99fe8590$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $0d2f1c1e44da8faa$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $ea59de721198407d$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $48f5f27e3556ff68$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $dfcc249873e82dc8$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $825b7f34dd1cb6f2$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $1dd934247c82c748$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $599a7f1705406622$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $15e188d4b78f5972$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $afb5e4549ba0a557$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $b7ff0866a0cfcb19$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $53e0c1541e70ba90$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $72d5601414c40032$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $1bb42103a1ae40e3$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $6dadaee8977d0b8c$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $1d986aa2fc5a2042$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $0fe3d4cdc95005aa$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $09cd3d5ccc05004a$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $4b43cd23628ca369$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2ca38ba22cd2f300$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $4495b1c997b70580$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $f6740f806551d358$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $87bafbe07a5bf1af$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $5a643ddce70fd979$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $b35766029a724a8a$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $7f922c12ede6cc55$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $84780d4b456edd4e$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $fa5d0ce3ee0cb7aa$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $fe5e344b015a0dfd$exports);
$parcel$exportWildcard($75b0a270dc56fd3a$exports, $2a62d631ec219dba$exports);


var $ff59e3c78fdcd508$exports = {};
var $8da8523113345982$exports = {};


$parcel$exportWildcard($ff59e3c78fdcd508$exports, $8da8523113345982$exports);


$parcel$exportWildcard($18fd3ca1b111910e$exports, $75b0a270dc56fd3a$exports);
$parcel$exportWildcard($18fd3ca1b111910e$exports, $ff59e3c78fdcd508$exports);


function $d85e86c2d2965756$export$7f825c2ffa1f2c9a(amount) {
    return amount === null || amount === void 0 ? void 0 : amount.hasOwnProperty('amount');
}


function $c631104d96f9c819$export$e360235ce2c77844(value, zero) {
    if ((0, $d85e86c2d2965756$export$7f825c2ffa1f2c9a)(value)) {
        var _value$scale;
        return {
            amount: value.amount,
            scale: (_value$scale = value === null || value === void 0 ? void 0 : value.scale) !== null && _value$scale !== void 0 ? _value$scale : zero
        };
    }
    return {
        amount: value,
        scale: zero
    };
}

/* eslint-disable functional/no-mixed-type */ var $d203a89a64aa5515$export$e99d6c94ff657bc9;
(function(ComparisonOperator) {
    ComparisonOperator[ComparisonOperator["LT"] = -1] = "LT";
    ComparisonOperator[ComparisonOperator["EQ"] = 0] = "EQ";
    ComparisonOperator[ComparisonOperator["GT"] = 1] = "GT";
})($d203a89a64aa5515$export$e99d6c94ff657bc9 || ($d203a89a64aa5515$export$e99d6c94ff657bc9 = {}));


function $ada021349f332249$export$9b050841a3a1b328(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $d203a89a64aa5515$export$e99d6c94ff657bc9).LT;
    };
}


function $d88054b6190a12d8$export$b25e0be55f42c9a(calculator) {
    var lessThanFn = (0, $ada021349f332249$export$9b050841a3a1b328)(calculator);
    return function(values) {
        return values.reduce(function(acc, curr) {
            return lessThanFn(acc, curr) ? curr : acc;
        });
    };
}



function $cbc8c1361a7ab847$export$411ce8e5a71e3069(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $d203a89a64aa5515$export$e99d6c94ff657bc9).EQ;
    };
}


function $304f50b03efae5a0$export$f517ea36c68d4644(calculator) {
    return function(subject, comparator) {
        return calculator.compare(subject, comparator) === (0, $d203a89a64aa5515$export$e99d6c94ff657bc9).GT;
    };
}


var $2090acfe0076c66d$export$5df884bdba3ad6a1 = function down(amount, factor, calculator) {
    var greaterThanFn = (0, $304f50b03efae5a0$export$f517ea36c68d4644)(calculator);
    var equalFn = (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(calculator);
    var zero = calculator.zero();
    var isPositive = greaterThanFn(amount, zero);
    var quotient = calculator.integerDivide(amount, factor);
    var remainder = calculator.modulo(amount, factor);
    var isInteger = equalFn(remainder, zero);
    if (isPositive || isInteger) return quotient;
    return calculator.decrement(quotient);
};


function $31c7965c5a33be10$export$43bee75e5e14138e(maybeArray) {
    return Array.isArray(maybeArray);
}


function $35dbf503d4b6bc95$export$34f5795259ce9fbe(calculator) {
    return function(base) {
        if ((0, $31c7965c5a33be10$export$43bee75e5e14138e)(base)) return base.reduce(function(acc, curr) {
            return calculator.multiply(acc, curr);
        });
        return base;
    };
}


function $ccf30d0ba609f014$var$_slicedToArray(arr, i) {
    return $ccf30d0ba609f014$var$_arrayWithHoles(arr) || $ccf30d0ba609f014$var$_iterableToArrayLimit(arr, i) || $ccf30d0ba609f014$var$_unsupportedIterableToArray(arr, i) || $ccf30d0ba609f014$var$_nonIterableRest();
}
function $ccf30d0ba609f014$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ccf30d0ba609f014$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ccf30d0ba609f014$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ccf30d0ba609f014$var$_arrayLikeToArray(o, minLen);
}
function $ccf30d0ba609f014$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ccf30d0ba609f014$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ccf30d0ba609f014$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ccf30d0ba609f014$export$5a26e3b3d26ddeb7(calculator) {
    var greaterThanFn = (0, $304f50b03efae5a0$export$f517ea36c68d4644)(calculator);
    var computeBaseFn = (0, $35dbf503d4b6bc95$export$34f5795259ce9fbe)(calculator);
    return function transformScaleFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], newScale = _ref[1], _ref$ = _ref[2], divide = _ref$ === void 0 ? (0, $2090acfe0076c66d$export$5df884bdba3ad6a1) : _ref$;
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var isLarger = greaterThanFn(newScale, scale);
        var operation = isLarger ? calculator.multiply : divide;
        var _ref2 = isLarger ? [
            newScale,
            scale
        ] : [
            scale,
            newScale
        ], _ref3 = $ccf30d0ba609f014$var$_slicedToArray(_ref2, 2), a = _ref3[0], b = _ref3[1];
        var base = computeBaseFn(currency.base);
        var factor = calculator.power(base, calculator.subtract(a, b));
        return dineroObject.create({
            amount: operation(amount, factor, calculator),
            currency: currency,
            scale: newScale
        });
    };
}


function $6eba9829431e0e55$export$9c68d69a4c5bbcf9(calculator) {
    var convertScaleFn = (0, $ccf30d0ba609f014$export$5a26e3b3d26ddeb7)(calculator);
    var maximumFn = (0, $d88054b6190a12d8$export$b25e0be55f42c9a)(calculator);
    var zero = calculator.zero();
    return function convertFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], newCurrency = _ref[1], rates = _ref[2];
        var rate = rates[newCurrency.code];
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, scale = _dineroObject$toJSON.scale;
        var _getAmountAndScale = (0, $c631104d96f9c819$export$e360235ce2c77844)(rate, zero), rateAmount = _getAmountAndScale.amount, rateScale = _getAmountAndScale.scale;
        var newScale = calculator.add(scale, rateScale);
        return convertScaleFn(dineroObject.create({
            amount: calculator.multiply(amount, rateAmount),
            currency: newCurrency,
            scale: newScale
        }), maximumFn([
            newScale,
            newCurrency.exponent
        ]));
    };
}


function $424c155a06311772$export$9c68d69a4c5bbcf9() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var dineroObject = _ref[0], newCurrency = _ref[1], rates = _ref[2];
    var calculator = dineroObject.calculator;
    var converter = (0, $6eba9829431e0e55$export$9c68d69a4c5bbcf9)(calculator);
    return converter(dineroObject, newCurrency, rates);
}

/* eslint-disable functional/no-expression-statement */ /**
 * Returns the sum of two numbers.
 *
 * @param augend - The number to add to.
 * @param addend - The number to add.
 *
 * @returns The sum of the two numbers.
 */ var $ad6800563487849d$export$e16d8520af44a096 = function add(augend, addend) {
    return augend + addend;
};


var $9c3bec4fa7c90ce5$export$398604a469f7de9a = function compare(a, b) {
    if (a < b) return (0, $d203a89a64aa5515$export$e99d6c94ff657bc9).LT;
    if (a > b) return (0, $d203a89a64aa5515$export$e99d6c94ff657bc9).GT;
    return (0, $d203a89a64aa5515$export$e99d6c94ff657bc9).EQ;
};

/**
 * Returns an decremented number.
 *
 * @param value - The number to decrement.
 *
 * @returns The decremented number.
 */ var $d2feda366f088194$export$8f85cc9753f280aa = function decrement(value) {
    return value - 1;
};

/**
 * Returns an incremented number.
 *
 * @param value - The number to increment.
 *
 * @returns The incremented number.
 */ var $3b51a6321d6bd965$export$a2647aa13413c947 = function increment(value) {
    return value + 1;
};

/**
 * Returns the quotient of two numbers with no fractional part.
 *
 * @param dividend - The number to divide.
 * @param divisor - The number to divide with.
 *
 * @returns The quotient of the two numbers.
 */ var $dab753c42bbb52b4$export$e466e21ee5950aaf = function integerDivide(dividend, divisor) {
    return Math.trunc(dividend / divisor);
};

/**
 * Returns the remainder of two numbers.
 *
 * @param dividend - The number to divide.
 * @param divisor - The number to divide with.
 *
 * @returns The remainder of the two numbers.
 */ var $42903fbec89fc36a$export$ba467bec01d66def = function modulo(dividend, divisor) {
    return dividend % divisor;
};

/**
 * Returns the product of two numbers.
 *
 * @param multiplicand - The number to multiply.
 * @param multiplier - The number to multiply with.
 *
 * @returns The product of the two numbers.
 */ var $8f06bf7736d13fc4$export$2060d2db72cce88f = function multiply(multiplicand, multiplier) {
    return multiplicand * multiplier;
};

/**
 * Returns an number to the power of an exponent.
 *
 * @param base - The base number.
 * @param exponent - The exponent to raise the base to.
 *
 * @returns The base to the power of the exponent.
 */ var $c187c143c6937857$export$836601bcef5ff40 = function power(base, exponent) {
    return Math.pow(base, exponent);
};

/**
 * Returns the difference between two numbers.
 *
 * @param minuend - The number to subtract from.
 * @param subtrahend - The number to subtract.
 *
 * @returns The difference of the two numbers.
 */ var $d8da359c72f57b84$export$4e2d2ead65e5f7e3 = function subtract(minuend, subtrahend) {
    return minuend - subtrahend;
};

/**
 * Return zero as a number.
 *
 * @returns Zero as a number.
 */ function $2cb9434d8ce15449$export$7f9972325ebfd559() {
    return 0;
}


var $3c6a2e961a6e4394$export$25f84be31b76e92 = {
    add: (0, $ad6800563487849d$export$e16d8520af44a096),
    compare: (0, $9c3bec4fa7c90ce5$export$398604a469f7de9a),
    decrement: (0, $d2feda366f088194$export$8f85cc9753f280aa),
    increment: (0, $3b51a6321d6bd965$export$a2647aa13413c947),
    integerDivide: (0, $dab753c42bbb52b4$export$e466e21ee5950aaf),
    modulo: (0, $42903fbec89fc36a$export$ba467bec01d66def),
    multiply: (0, $8f06bf7736d13fc4$export$2060d2db72cce88f),
    power: (0, $c187c143c6937857$export$836601bcef5ff40),
    subtract: (0, $d8da359c72f57b84$export$4e2d2ead65e5f7e3),
    zero: (0, $2cb9434d8ce15449$export$7f9972325ebfd559)
};


/* eslint-disable functional/no-throw-statement, valid-jsdoc */ /**
 * Assert a condition.
 *
 * @param condition - The condition to verify.
 * @param message - The error message to throw.
 *
 * @throws If the condition isn't met.
 */ function $a9338308e6cef3f8$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error("[Dinero.js] ".concat(message));
}

/* eslint-disable functional/no-mixed-type, functional/no-return-void, functional/no-expression-statement */ function $213252135cbc6081$export$7d8b30ba682ca797(_ref) {
    var calculator = _ref.calculator, onCreate = _ref.onCreate, _ref$formatter = _ref.formatter, formatter = _ref$formatter === void 0 ? {
        toNumber: Number,
        toString: String
    } : _ref$formatter;
    return function dinero(_ref2) {
        var amount = _ref2.amount, _ref2$currency = _ref2.currency, code = _ref2$currency.code, base = _ref2$currency.base, exponent = _ref2$currency.exponent, _ref2$scale = _ref2.scale, scale = _ref2$scale === void 0 ? exponent : _ref2$scale;
        var currency = {
            code: code,
            base: base,
            exponent: exponent
        };
        onCreate === null || onCreate === void 0 || onCreate({
            amount: amount,
            currency: currency,
            scale: scale
        });
        return {
            calculator: calculator,
            formatter: formatter,
            create: dinero,
            toJSON: function toJSON() {
                return {
                    amount: amount,
                    currency: currency,
                    scale: scale
                };
            }
        };
    };
}

var $f680e8b316896db8$export$e27f261d364932eb = 'Amount is invalid.';
var $f680e8b316896db8$export$6ea6c533eb222651 = 'Scale is invalid.';
var $f680e8b316896db8$export$f38d191a1e558a4d = 'Ratios are invalid.';
var $f680e8b316896db8$export$13345bd9e924e673 = 'Objects must have the same scale.';
var $f680e8b316896db8$export$b89a7c181fdad771 = 'Objects must have the same currency.';
var $f680e8b316896db8$export$8e529f3fe7bbf42 = 'Currency is not decimal.';


var $4adb2449403c5e83$export$d19701748df0f687 = (0, $213252135cbc6081$export$7d8b30ba682ca797)({
    calculator: (0, $3c6a2e961a6e4394$export$25f84be31b76e92),
    onCreate: function onCreate(_ref) {
        var amount = _ref.amount, scale = _ref.scale;
        (0, $a9338308e6cef3f8$export$a7a9523472993e97)(Number.isInteger(amount), (0, $f680e8b316896db8$export$e27f261d364932eb));
        (0, $a9338308e6cef3f8$export$a7a9523472993e97)(Number.isInteger(scale), (0, $f680e8b316896db8$export$6ea6c533eb222651));
    }
});



function $c1a3f7f38ae327fa$export$2060d2db72cce88f(calculator) {
    var convertScaleFn = (0, $ccf30d0ba609f014$export$5a26e3b3d26ddeb7)(calculator);
    var zero = calculator.zero();
    return function multiplyFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var multiplicand = _ref[0], multiplier = _ref[1];
        var _multiplicand$toJSON = multiplicand.toJSON(), amount = _multiplicand$toJSON.amount, currency = _multiplicand$toJSON.currency, scale = _multiplicand$toJSON.scale;
        var _getAmountAndScale = (0, $c631104d96f9c819$export$e360235ce2c77844)(multiplier, zero), multiplierAmount = _getAmountAndScale.amount, multiplierScale = _getAmountAndScale.scale;
        var newScale = calculator.add(scale, multiplierScale);
        return convertScaleFn(multiplicand.create({
            amount: calculator.multiply(amount, multiplierAmount),
            currency: currency,
            scale: newScale
        }), newScale);
    };
}


function $cceca44035b2af6e$export$2060d2db72cce88f() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var multiplicand = _ref[0], multiplier = _ref[1];
    var calculator = multiplicand.calculator;
    var multiplyFn = (0, $c1a3f7f38ae327fa$export$2060d2db72cce88f)(calculator);
    return multiplyFn(multiplicand, multiplier);
}





function $7bf7725bf4f6d29d$export$d31af2dc8039efd3(calculator) {
    var equalFn = (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(calculator);
    var lessThanFn = (0, $ada021349f332249$export$9b050841a3a1b328)(calculator);
    var zero = calculator.zero();
    return function(input) {
        if (equalFn(input, zero)) return zero;
        if (lessThanFn(input, zero)) {
            var minusOne = calculator.decrement(zero);
            return calculator.multiply(minusOne, input);
        }
        return input;
    };
}


function $e987431ea8109eee$var$_toConsumableArray(arr) {
    return $e987431ea8109eee$var$_arrayWithoutHoles(arr) || $e987431ea8109eee$var$_iterableToArray(arr) || $e987431ea8109eee$var$_unsupportedIterableToArray(arr) || $e987431ea8109eee$var$_nonIterableSpread();
}
function $e987431ea8109eee$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e987431ea8109eee$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e987431ea8109eee$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e987431ea8109eee$var$_arrayLikeToArray(o, minLen);
}
function $e987431ea8109eee$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e987431ea8109eee$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e987431ea8109eee$var$_arrayLikeToArray(arr);
}
function $e987431ea8109eee$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e987431ea8109eee$export$e7d37819eb69f4b9(calculator) {
    var multiply = calculator.multiply;
    return function(bases) {
        return bases.reduce(function(divisors, _, i) {
            var divisor = bases.slice(i).reduce(function(acc, curr) {
                return multiply(acc, curr);
            });
            return [].concat($e987431ea8109eee$var$_toConsumableArray(divisors), [
                divisor
            ]);
        }, []);
    };
}


function $fae03d7549c93d24$var$_toConsumableArray(arr) {
    return $fae03d7549c93d24$var$_arrayWithoutHoles(arr) || $fae03d7549c93d24$var$_iterableToArray(arr) || $fae03d7549c93d24$var$_unsupportedIterableToArray(arr) || $fae03d7549c93d24$var$_nonIterableSpread();
}
function $fae03d7549c93d24$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fae03d7549c93d24$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fae03d7549c93d24$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fae03d7549c93d24$var$_arrayLikeToArray(o, minLen);
}
function $fae03d7549c93d24$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $fae03d7549c93d24$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $fae03d7549c93d24$var$_arrayLikeToArray(arr);
}
function $fae03d7549c93d24$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fae03d7549c93d24$export$4059381979a3a85c(calculator) {
    var getDivisorsFn = (0, $e987431ea8109eee$export$e7d37819eb69f4b9)(calculator);
    return function toUnitsFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], transformer = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var power = calculator.power, integerDivide = calculator.integerDivide, modulo = calculator.modulo;
        var bases = (0, $31c7965c5a33be10$export$43bee75e5e14138e)(currency.base) ? currency.base : [
            currency.base
        ];
        var divisors = getDivisorsFn(bases.map(function(base) {
            return power(base, scale);
        }));
        var value = divisors.reduce(function(amounts, divisor, index) {
            var amountLeft = amounts[index];
            var quotient = integerDivide(amountLeft, divisor);
            var remainder = modulo(amountLeft, divisor);
            return [].concat($fae03d7549c93d24$var$_toConsumableArray(amounts.filter(function(_, i) {
                return i !== index;
            })), [
                quotient,
                remainder
            ]);
        }, [
            amount
        ]);
        if (!transformer) return value;
        return transformer({
            value: value,
            currency: currency
        });
    };
}


function $fbfcf5f524d02fd3$export$63ad841d70774900(calculator) {
    var toUnitsFn = (0, $fae03d7549c93d24$export$4059381979a3a85c)(calculator);
    var computeBaseFn = (0, $35dbf503d4b6bc95$export$34f5795259ce9fbe)(calculator);
    var equalFn = (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(calculator);
    return function toDecimalFn() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], transformer = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var base = computeBaseFn(currency.base);
        var zero = calculator.zero();
        var ten = new Array(10).fill(null).reduce(calculator.increment, zero);
        var isMultiBase = (0, $31c7965c5a33be10$export$43bee75e5e14138e)(currency.base);
        var isBaseTen = equalFn(calculator.modulo(base, ten), zero);
        var isDecimal = !isMultiBase && isBaseTen;
        // eslint-disable-next-line functional/no-expression-statement
        (0, $a9338308e6cef3f8$export$a7a9523472993e97)(isDecimal, (0, $f680e8b316896db8$export$8e529f3fe7bbf42));
        var units = toUnitsFn(dineroObject);
        var getDecimalFn = $fbfcf5f524d02fd3$var$getDecimal(calculator, dineroObject.formatter);
        var value = getDecimalFn(units, scale);
        if (!transformer) return value;
        return transformer({
            value: value,
            currency: currency
        });
    };
}
function $fbfcf5f524d02fd3$var$getDecimal(calculator, formatter) {
    var absoluteFn = (0, $7bf7725bf4f6d29d$export$d31af2dc8039efd3)(calculator);
    var equalFn = (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(calculator);
    var lessThanFn = (0, $ada021349f332249$export$9b050841a3a1b328)(calculator);
    var zero = calculator.zero();
    return function(units, scale) {
        var whole = formatter.toString(units[0]);
        var fractional = formatter.toString(absoluteFn(units[1]));
        var scaleNumber = formatter.toNumber(scale);
        var decimal = "".concat(whole, ".").concat(fractional.padStart(scaleNumber, '0'));
        var leadsWithZero = equalFn(units[0], zero);
        var isNegative = lessThanFn(units[1], zero);
        // A leading negative zero is a special case because the `toString`
        // formatter won't preserve its negative sign (since 0 === -0).
        return leadsWithZero && isNegative ? "-".concat(decimal) : decimal;
    };
}


function $e5aea94665190d71$export$63ad841d70774900() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var dineroObject = _ref[0], transformer = _ref[1];
    var calculator = dineroObject.calculator;
    var toDecimalFn = (0, $fbfcf5f524d02fd3$export$63ad841d70774900)(calculator);
    return toDecimalFn(dineroObject, transformer);
}


const $bb09d99f2c0a98ec$export$41a3cbea1d0bb6f8 = $bb09d99f2c0a98ec$export$828c89097764172d(0);
function $bb09d99f2c0a98ec$export$e5d48fa21b54da3e(floatingPointAmount, currencyCode, exchangeRate) {
    // If the currency is CAD, convert directly to a CAD dinero object
    if (currencyCode === "CAD") {
        if (exchangeRate !== 1) throw new Error(`Expected exchange rate to be 1 for CAD currency, but got ${exchangeRate.toString()}`);
        return $bb09d99f2c0a98ec$export$828c89097764172d(floatingPointAmount);
    }
    // Create a dinero object in the specified currency
    const costAmountLocal = $bb09d99f2c0a98ec$export$956a16bd79899df1(floatingPointAmount, currencyCode);
    // Invert the exchange rate and scale it to avoid floating point errors
    const inverseScaledExchangeRate = $bb09d99f2c0a98ec$var$invertAndRoundFloatingPointExchangeRate(exchangeRate);
    // Convert the amount to CAD
    return (0, $424c155a06311772$export$9c68d69a4c5bbcf9)(costAmountLocal, $18fd3ca1b111910e$exports.CAD, {
        CAD: inverseScaledExchangeRate
    });
}
function $bb09d99f2c0a98ec$export$828c89097764172d(floatingPointAmount) {
    return $bb09d99f2c0a98ec$export$956a16bd79899df1(floatingPointAmount, "CAD");
}
function $bb09d99f2c0a98ec$export$956a16bd79899df1(floatingPointAmount, currency) {
    const amount = Math.round(floatingPointAmount * Math.pow(10, $18fd3ca1b111910e$exports[currency].exponent));
    return (0, $4adb2449403c5e83$export$d19701748df0f687)({
        amount: amount,
        currency: $18fd3ca1b111910e$exports[currency]
    });
}
function $bb09d99f2c0a98ec$export$6ade6d89a215534c(code) {
    if (!(code in $18fd3ca1b111910e$exports)) throw new Error(`Invalid currency code: ${code}`);
    return code;
}
function $bb09d99f2c0a98ec$export$5c87e5997adedfc8(multiplicand, multiplier) {
    const scaledAmount = $bb09d99f2c0a98ec$var$roundFloatToScale(multiplier.amount, multiplier.scale);
    return (0, $cceca44035b2af6e$export$2060d2db72cce88f)(multiplicand, scaledAmount);
}
function $bb09d99f2c0a98ec$export$afdfcbdba94169b7(rates) {
    // Create a new map of rates, inverting them, and scaling the rates to avoid floating point errors
    const invertedAndScaledRates = Object.fromEntries(Object.entries(rates).map(([code, rate])=>[
            code,
            $bb09d99f2c0a98ec$var$invertAndRoundFloatingPointExchangeRate(rate)
        ]));
    // Return a function that can convert from any supported currency to CAD
    return (dineroObject)=>{
        const sourceCurrencyCode = dineroObject.toJSON().currency.code;
        if (sourceCurrencyCode === "CAD") return dineroObject;
        const rate = invertedAndScaledRates[sourceCurrencyCode];
        return (0, $424c155a06311772$export$9c68d69a4c5bbcf9)(dineroObject, $18fd3ca1b111910e$exports.CAD, {
            CAD: rate
        });
    };
}
/**
 * Invert the provided exchange rate and scale it to avoid floating point errors when converting between
 * currencies. The exchange rate is scaled with a precision of 8 decimal places, since that is what is used in SOS and is
 * more than enough precision for our purposes.
 */ function $bb09d99f2c0a98ec$var$invertAndRoundFloatingPointExchangeRate(exchangeRate) {
    return $bb09d99f2c0a98ec$var$roundFloatToScale(1 / exchangeRate, 8);
}
/**
 * Convert a floating point number to a scaled amount that can be used safely by dinero.js, which only deals in integers.
 * Any precision beyond the scale will be rounded off and lost.
 */ function $bb09d99f2c0a98ec$var$roundFloatToScale(floatAmount, scale) {
    return {
        amount: Math.round(floatAmount * Math.pow(10, scale)),
        scale: scale
    };
}
function $bb09d99f2c0a98ec$export$e3370200ec4b4375(dineroObject, options = {}) {
    return $bb09d99f2c0a98ec$export$fac1d89c5c56401(dineroObject, "en-CA", options);
}
function $bb09d99f2c0a98ec$export$fac1d89c5c56401(dineroObject, locale, options = {}) {
    const transformer = ({ value: value, currency: currency })=>{
        return parseFloat(value).toLocaleString(locale, {
            ...options,
            style: "currency",
            currency: currency.code
        });
    };
    return (0, $e5aea94665190d71$export$63ad841d70774900)(dineroObject, transformer);
}
function $bb09d99f2c0a98ec$export$a0a81dc3380ce7d3(dineroObject) {
    return (0, $e5aea94665190d71$export$63ad841d70774900)(dineroObject, ({ value: value })=>parseFloat(value));
}







const $f6bce4f618ea63d9$export$3f0f2d69bf4fa3c7 = "bg-warning-subtle text-warning-emphasis";
const $f6bce4f618ea63d9$export$ee48491cfb0c8625 = ({ children: children, error: error = true })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))({
            [$f6bce4f618ea63d9$export$3f0f2d69bf4fa3c7]: error
        }),
        children: children
    });



const $41caf841eb1d8d0c$export$1e050932b91ba5cd = ({ cost: cost, title: title, children: children })=>{
    if (cost.errors.length === 0) return null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        placement: "bottom",
        overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $53905517a09a4f32$export$2e2bcd8739ae039), {
                ...props,
                style: {
                    ...props.style,
                    "--bs-popover-bg": "var(--bs-warning-bg-subtle)"
                },
                children: [
                    title && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $53905517a09a4f32$export$2e2bcd8739ae039).Header, {
                        as: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $53905517a09a4f32$export$2e2bcd8739ae039).Body, {
                        children: [
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("p", {
                                className: "mb-1",
                                children: "The following error(s) are associated with this cost:"
                            }),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($41caf841eb1d8d0c$export$b67e1a46ae508045, {
                                errors: cost.errors,
                                className: "mb-0"
                            })
                        ]
                    })
                ]
            }),
        children: children ?? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
            className: (0, $f6bce4f618ea63d9$export$3f0f2d69bf4fa3c7),
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                    icon: "exclamation-triangle-fill"
                }),
                " ",
                cost.errors.length,
                " error",
                cost.errors.length > 1 && "s"
            ]
        })
    });
};
const $41caf841eb1d8d0c$export$b67e1a46ae508045 = ({ errors: errors, className: className })=>{
    if (errors.length > 1) // Display errors as a bulleted list
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))((0, $f6bce4f618ea63d9$export$3f0f2d69bf4fa3c7), className),
        children: errors.map((error, i)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("li", {
                children: [
                    "\u26A0 ",
                    error
                ]
            }, i))
    });
    else if (errors.length) // Display a single error
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))((0, $f6bce4f618ea63d9$export$3f0f2d69bf4fa3c7), className),
        children: [
            "\u26A0 ",
            errors[0]
        ]
    });
    else throw new Error("Cannot render TaxBreakdownErrors component without errors");
};


function $6169a59e3e4ce096$export$f3bedecf6f49c44b(costAccessor, idPrefix, additionalColumnDef = {}) {
    // Create a new cellProps function, wrapping the provided one, that also sets some default values:
    // If there are errors, only the first visible column among the three will display the error and span all visible
    // columns. All other columns will be hidden.
    const cellProps = (cell)=>{
        // Get the cell props provided by the caller, if any
        const originalCellPropsOption = additionalColumnDef.meta?.cellProps;
        const originalCellProps = typeof originalCellPropsOption === "function" ? originalCellPropsOption(cell) : originalCellPropsOption ?? {};
        // Return the default cellProps if there are no errors
        const cost = costAccessor(cell.row.original);
        if (!cost.errors.length) return originalCellProps;
        // Find the first visible column among the three (subtotal, tax, total)
        const colIds = [
            idPrefix + "_subtotal",
            idPrefix + "_tax",
            idPrefix + "_total"
        ];
        const visibleColIds = cell.row.getVisibleCells().map((c)=>c.column.id);
        const firstVisible = visibleColIds.find((id)=>colIds.includes(id));
        if (firstVisible === cell.column.id) {
            // If this is the first visible column, set `colSpan` to span all the visible columns
            const numVisibleCols = colIds.filter((x)=>visibleColIds.includes(x)).length;
            return {
                colSpan: numVisibleCols,
                ...originalCellProps
            };
        } else // Otherwise, set `hidden` to hide the cell
        return {
            hidden: true,
            ...originalCellProps
        };
    };
    // Merge the new cellProps callback into the provided column definition then use it to create the three column definitions
    const newColumnDef = (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({}, additionalColumnDef, {
        meta: {
            cellProps: cellProps
        }
    });
    return [
        $6169a59e3e4ce096$export$5d654c3b511cb463(costAccessor, idPrefix, newColumnDef),
        $6169a59e3e4ce096$export$70d497afa7207f3d(costAccessor, idPrefix, newColumnDef),
        $6169a59e3e4ce096$export$5d7e248686ecb0b9(costAccessor, idPrefix, newColumnDef)
    ];
}
function $6169a59e3e4ce096$export$5d654c3b511cb463(costAccessor, idPrefix, { useErrorPopover: useErrorPopover, ...additionalColumnDef } = {}) {
    return (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)().accessor((row)=>costAccessor(row).subtotal, {
        id: idPrefix + "_subtotal",
        header: "Subtotal",
        cell: $6169a59e3e4ce096$var$getCostTaxBreakdownCellComponent(costAccessor, useErrorPopover),
        ...additionalColumnDef
    });
}
function $6169a59e3e4ce096$export$70d497afa7207f3d(costAccessor, idPrefix, { useErrorPopover: useErrorPopover, ...additionalColumnDef } = {}) {
    return (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)().accessor((row)=>costAccessor(row).tax, {
        id: idPrefix + "_tax",
        header: "Tax",
        cell: $6169a59e3e4ce096$var$getCostTaxBreakdownCellComponent(costAccessor, useErrorPopover),
        ...additionalColumnDef
    });
}
function $6169a59e3e4ce096$export$5d7e248686ecb0b9(costAccessor, idPrefix, { useErrorPopover: useErrorPopover, ...additionalColumnDef } = {}) {
    return (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)().accessor((row)=>costAccessor(row).total, {
        id: idPrefix + "_total",
        header: "Total",
        cell: $6169a59e3e4ce096$var$getCostTaxBreakdownCellComponent(costAccessor, useErrorPopover),
        ...additionalColumnDef
    });
}
/**
 * Gets a new component that renders the cell content for a cost/tax/total column. If there are errors, this renders the
 * error component in the cell. Otherwise, it renders the formatted value.
 */ function $6169a59e3e4ce096$var$getCostTaxBreakdownCellComponent(costAccessor, useErrorPopover = false) {
    const CostTaxBreakDownCell = ({ row: row, getValue: getValue })=>{
        const cost = costAccessor(row.original);
        if (!cost.errors.length) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
            children: (0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
        });
        return useErrorPopover ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $41caf841eb1d8d0c$export$1e050932b91ba5cd), {
            cost: cost
        }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $41caf841eb1d8d0c$export$b67e1a46ae508045), {
            errors: cost.errors
        });
    };
    return CostTaxBreakDownCell;
}



parcelRequire("itHdT");




const $0eb2778588255d1b$export$ee3a8ac17e8ddb11 = ({ quantity: quantity, uom: uom })=>uom ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            $0eb2778588255d1b$var$formatQuantity(quantity),
            " ",
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("abbr", {
                title: uom.name,
                children: uom.abbreviation
            })
        ]
    }) : $0eb2778588255d1b$var$formatQuantity(quantity);
/**
 * Format an inventory quantity for display. This is a simple wrapper around `toLocaleString` that formats the number
 * with a maximum of 5 decimal places (matching the database precision).
 */ function $0eb2778588255d1b$var$formatQuantity(quantity) {
    return quantity.toLocaleString(undefined, {
        maximumFractionDigits: 5
    });
}








parcelRequire("itHdT");






function $ff5d31cd277282bd$export$3a8fd680da42627b(options = {}) {
    const optionalDocument = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document;
    const injectionPoint = optionalDocument?.head || optionalDocument?.body;
    if (!injectionPoint) {
        (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).error("[showReportDialog] Global document not defined");
        return;
    }
    const scope = (0, $479c90d590bd4fd3$exports.getCurrentScope)();
    const client = (0, $479c90d590bd4fd3$exports.getClient)();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $1576abfee53a7006$export$16a28057038b10ef) && (0, $479c90d590bd4fd3$exports.debug).error("[showReportDialog] DSN not configured");
        return;
    }
    const mergedOptions = {
        ...options,
        user: {
            ...scope.getUser(),
            ...options.user
        },
        eventId: options.eventId || (0, $479c90d590bd4fd3$exports.lastEventId)()
    };
    const script = (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $479c90d590bd4fd3$exports.getReportDialogEndpoint)(dsn, mergedOptions);
    const { onLoad: onLoad, onClose: onClose } = mergedOptions;
    if (onLoad) script.onload = onLoad;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $26e2765b4d6baedf$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    injectionPoint.appendChild(script);
}




var $itHdT = parcelRequire("itHdT");




var $itHdT = parcelRequire("itHdT");
function $4c6e8e238c0f4133$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
function $4c6e8e238c0f4133$export$bc95048bc211a673(error, cause) {
    const seenErrors = /* @__PURE__ */ new WeakSet();
    function recurse(error2, cause2) {
        if (seenErrors.has(error2)) return;
        if (error2.cause) {
            seenErrors.add(error2);
            return recurse(error2.cause, cause2);
        }
        error2.cause = cause2;
    }
    recurse(error, cause);
}
function $4c6e8e238c0f4133$export$270be4195468cda9(error, { componentStack: componentStack }, hint) {
    if ($4c6e8e238c0f4133$export$a87138b73900f5b((0, $itHdT.version)) && (0, $479c90d590bd4fd3$exports.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        $4c6e8e238c0f4133$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $479c90d590bd4fd3$exports.captureException)(error, hint);
}
function $4c6e8e238c0f4133$export$1e6f045b27b3cfb1(callback) {
    return (error, errorInfo)=>{
        const hasCallback = !!callback;
        const eventId = $4c6e8e238c0f4133$export$270be4195468cda9(error, errorInfo, {
            mechanism: {
                handled: hasCallback,
                type: "auto.function.react.error_handler"
            }
        });
        if (hasCallback) callback(error, errorInfo, eventId);
    };
}



const $7aec0b7104658b7c$export$6ef4c0367e27f2d5 = "unknown";
const $7aec0b7104658b7c$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
class $7aec0b7104658b7c$export$e926676385687eaf extends $itHdT.Component {
    constructor(props){
        super(props);
        this.state = $7aec0b7104658b7c$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $479c90d590bd4fd3$exports.getClient)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on("afterSendEvent", (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $ff5d31cd277282bd$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $479c90d590bd4fd3$exports.withScope)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $4c6e8e238c0f4133$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled,
                    type: "auto.function.react.error_boundary"
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $ff5d31cd277282bd$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $7aec0b7104658b7c$var$INITIAL_STATE) onUnmount(null, null, null);
            else onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = void 0;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) onReset(error, componentStack, eventId);
        this.setState($7aec0b7104658b7c$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.componentStack === null) return typeof children === "function" ? children() : children;
        const element = typeof fallback === "function" ? $itHdT.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($itHdT.isValidElement(element)) return element;
        if (fallback) (0, $d28f1fbce9273c94$export$16a28057038b10ef) && (0, $35da606f4e6c3c2f$export$1c9f709888824e05).warn("fallback did not produce a valid ReactElement");
        return null;
    }
}
function $7aec0b7104658b7c$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $7aec0b7104658b7c$export$6ef4c0367e27f2d5;
    const Wrapped = $itHdT.memo((props)=>/* @__PURE__ */ $itHdT.createElement($7aec0b7104658b7c$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, /* @__PURE__ */ $itHdT.createElement(WrappedComponent, {
            ...props
        })));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    (0, $6ad9d39434910094$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}



var $itHdT = parcelRequire("itHdT");


const $efb8a5333b785146$var$ErrorFallback = ({ error: error, componentStack: componentStack })=>{
    const [showComponentStack, setShowComponentStack] = (0, $itHdT.useState)(false);
    const toggleShowComponentStack = (0, $itHdT.useCallback)(()=>{
        setShowComponentStack(!showComponentStack);
    }, [
        showComponentStack
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
        className: "w-100 h-100 position-relative",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $ed503698bce8761d$export$2e2bcd8739ae039), {
            variant: "danger",
            className: "position-absolute mh-100 top-50 start-50 translate-middle d-flex flex-column",
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $ed503698bce8761d$export$2e2bcd8739ae039).Heading, {
                    children: "An unexpected error has occurred"
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("blockquote", {
                    className: "blockquote",
                    children: error instanceof Error ? error.message : "Unknown Error"
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("p", {
                    children: "You may refresh the page to reload the application."
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
                    variant: "secondary",
                    onClick: toggleShowComponentStack,
                    children: [
                        showComponentStack ? "Hide" : "Show",
                        " Component Stack"
                    ]
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $38744d8eba8ad168$export$2e2bcd8739ae039), {
                    in: showComponentStack,
                    className: "flex-fill overflow-y-auto mt-3",
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                        className: "border border-danger p-2",
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("pre", {
                            className: "m-0",
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("code", {
                                children: componentStack.trim()
                            })
                        })
                    })
                })
            ]
        })
    });
};
const $efb8a5333b785146$export$e926676385687eaf = (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($7aec0b7104658b7c$export$e926676385687eaf, {
        showDialog: true,
        fallback: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($efb8a5333b785146$var$ErrorFallback, {
                ...props
            }),
        children: props.children
    });





var $itHdT = parcelRequire("itHdT");



const $43cf7c9ae2e5a746$export$c6d957f49cf4d9e2 = ({ job: job })=>{
    const [detailsOpen, setDetailsOpen] = (0, $itHdT.useState)(false);
    const toggleDetails = ()=>{
        setDetailsOpen((open)=>!open);
    };
    const evolvedOpportunityNumbers = [
        job.customFieldValues.find((x)=>x.customFieldDefinitionId === 28)?.value,
        job.customFieldValues.find((x)=>x.customFieldDefinitionId === 31)?.value
    ].filter((x)=>!!x).map((x)=>`GNM#${x}`).join(", ");
    const orderDetails = [
        [
            "Evolved #",
            evolvedOpportunityNumbers
        ],
        [
            "Customer",
            job.customer?.name
        ],
        [
            "Model",
            job.customFieldValues.find((x)=>x.customFieldDefinitionId === 18)?.value
        ],
        [
            "Date",
            job.customFieldValues.find((x)=>x.customFieldDefinitionId === 22)?.value
        ]
    ];
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039), {
        activeKey: window.location.href,
        className: "flex-column nav-pills",
        style: {
            "--bs-nav-pills-border-radius": 0
        },
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                className: "text-wrap px-3",
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
                        variant: "link",
                        size: "sm",
                        onClick: toggleDetails,
                        className: "px-0 text-reset text-decoration-none",
                        children: [
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("h1", {
                                className: "h3 d-inline m-0",
                                children: job.number
                            }),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                icon: detailsOpen ? "caret-down-square" : "caret-right-square",
                                className: "ms-2 mb-1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $38744d8eba8ad168$export$2e2bcd8739ae039), {
                        in: detailsOpen,
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dl", {
                            className: "m-0",
                            children: orderDetails.filter(([, value])=>value).map(([label, value], index, array)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dt", {
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dd", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))({
                                                "m-0": index === array.length - 1
                                            }),
                                            children: value
                                        })
                                    ]
                                }, label))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/details`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "file-text",
                            className: "me-2"
                        }),
                        "Order Details"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/erns`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "gear-wide-connected",
                            className: "me-2"
                        }),
                        "ERNs"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/bom-hierarchy`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "list-nested",
                            className: "me-2"
                        }),
                        "BOM Hierarchy"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/bom-by-component`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "list",
                            className: "me-2"
                        }),
                        "BOM By Component"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/existing-inventory`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "boxes",
                            className: "me-2"
                        }),
                        "Existing Inventory"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/purchase-orders`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "cart",
                            className: "me-2"
                        }),
                        "Purchase Orders"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/purchasing-progress`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "file-text",
                            className: "me-2"
                        }),
                        "Purchasing Progress"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/landed-costs`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "receipt",
                            className: "me-2"
                        }),
                        "Landed Costs"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/work-orders`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "wrench-adjustable",
                            className: "me-2"
                        }),
                        "Work Orders"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/builds`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "hammer",
                            className: "me-2"
                        }),
                        "Builds"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/job/${job.number}/shipments`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "truck",
                            className: "me-2"
                        }),
                        "Shipments"
                    ]
                })
            })
        ]
    });
};



parcelRequire("itHdT");



const $d8ed0f693b57ae21$export$1afe2b5a93b67b3 = ({ text: text })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
        className: "flex-grow-1 d-flex flex-column justify-content-center text-center mt-5",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                    className: "spinner-border me-3",
                    role: "status"
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("h1", {
                    className: "d-inline",
                    children: [
                        text,
                        "..."
                    ]
                })
            ]
        })
    });




function $e0cb42a7611434bd$var$getJobByNameQuery(name) {
    return (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Job").select("*, customer:Customer(id,name), customFieldValues:JobCustomFieldValue(*)").eq("number", name).eq("deleted", false).limit(1).single().throwOnError();
}
function $e0cb42a7611434bd$export$fc9c0949df050a6b(name) {
    return (0, $e7c296f6690d0391$export$9a8e3100474fe331)({
        queryKey: [
            "Job",
            "by-name",
            name
        ],
        queryFn: async ()=>(await $e0cb42a7611434bd$var$getJobByNameQuery(name)).data
    });
}




var $itHdT = parcelRequire("itHdT");


function $b262411d05d5989d$export$ad4afeb3151d80fa(options) {
    // Hash the query key to a string
    const hashedQueryKey = (0, $ee0a7c55ac205e24$export$1e87d19d4aab5805)(options.queryKey);
    // Get the context where we registered the query
    const { registerQuery: registerQuery, unregisterQuery: unregisterQuery } = (0, $itHdT.useContext)((0, $bbe62af273f211ec$export$d6aa9e298ea80f68)) ?? (0, $be8f6f33925d422b$export$a2d8f355a4dba7ae)("useTrackedQuery must be used within a QueryTrackingProvider");
    // Initiate the query using react-query
    const result = (0, $6ea0b2638e0c092a$export$dd0a697e1782aedd)(options);
    // Register the query with the context and register a callback to unregister the query when the component unmounts
    // NOTE: `result` is not included in the dependency array for this `useEffect` call, because We don't want to re-run
    // the effect when the query result changes. Checking the hashed query key is sufficient for checking equality of the
    // query. Re-running for changes to the query result object would result in an infinite loop
    (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useEffect(()=>{
        registerQuery(hashedQueryKey, result);
        return ()=>{
            unregisterQuery(hashedQueryKey);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- see note above
    }, [
        registerQuery,
        unregisterQuery,
        hashedQueryKey
    ]);
    // Return the query result
    return result;
}


const $8080646ce18e3d87$export$839c859e3b3cdbd5 = (WrappedComponent)=>{
    return function WithJob(props) {
        const jobNumber = (0, $b634fe06a3f61222$export$99eaa27ddbbb95ef)().jobNumber;
        const jobQuery = (0, $b262411d05d5989d$export$ad4afeb3151d80fa)((0, $e0cb42a7611434bd$export$fc9c0949df050a6b)(jobNumber));
        if (jobQuery.isError) return `Error loading job: ${jobQuery.error.message}`;
        if (jobQuery.isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d8ed0f693b57ae21$export$1afe2b5a93b67b3), {
            text: "Loading job"
        });
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(WrappedComponent, {
            job: jobQuery.data,
            ...props
        });
    };
};





const $d26a81661766878d$export$c05cb0c134c424f1 = ({ children: children })=>{
    // Extract the tracker path from the current URL path
    const location = (0, $b634fe06a3f61222$export$45d76561a5302f2b)();
    const trackerPath = /job\/[^/]+\/([^/]+)/.exec(location.pathname)?.[1];
    // Get the page title based on the tracker path
    const pageTitle = trackerPath ? (0, $eaeeb144eed6ac3b$export$19d2ef56a3b9ec8a)[trackerPath] : null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
            className: "d-flex flex-column h-100",
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("h2", {
                        className: "mb-3",
                        children: pageTitle
                    })
                }),
                children
            ]
        })
    });
};


const $6a077366af2550f6$var$JobTrackerLayout = ({ job: job })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        className: "d-flex h-100",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "flex-grow-0 flex-shrink-0 bg-secondary-subtle py-3 me-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $43cf7c9ae2e5a746$export$c6d957f49cf4d9e2), {
                    job: job
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
                fluid: true,
                className: "flex-grow-1 overflow-y-auto py-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $efb8a5333b785146$export$e926676385687eaf), {
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d26a81661766878d$export$c05cb0c134c424f1), {
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$910ae8079b2c2852), {})
                    })
                })
            })
        ]
    });
};
var $6a077366af2550f6$export$2e2bcd8739ae039 = (0, $8080646ce18e3d87$export$839c859e3b3cdbd5)($6a077366af2550f6$var$JobTrackerLayout);






const $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36 = ({ date: dateOrString, nullishValue: nullishValue })=>{
    const date = typeof dateOrString === "string" ? new Date(dateOrString) : dateOrString;
    return date ? new Date(date).toISOString().split("T")[0] : nullishValue ?? "";
};




(function(SosCustomFields) {
    /**
   * This object holds the metadata for each custom field. It is used by utility methods to perform reading/writing of
   * custom field values with static typing.
   *
   * TODO: This is basically a copy of the associated type definition. It would be more DRY to instead automatically
   * derive the `CustomFieldDefinitionMap` type definition by declaring this object as `const` and using the `typeof`
   * operator. The current implementation is a holdover from before we switched to ParcelJS bundling.
   */ const definitions = {
        manufacturer: {
            id: 2,
            dataType: "Text",
            name: "Manufacturer",
            showOn: [
                "Items"
            ]
        },
        receivingInspectionFlag: {
            id: 3,
            dataType: "Boolean",
            name: "Receiving Inspection Flag",
            showOn: [
                "Item Receipts",
                "Items",
                "Purchase Orders"
            ]
        },
        kanban: {
            id: 4,
            dataType: "Boolean",
            name: "Kanban",
            showOn: [
                "Items"
            ]
        },
        vendorReceiptNum: {
            id: 5,
            dataType: "Text",
            name: "Vendor Receipt Num",
            showOn: [
                "Item Receipts"
            ]
        },
        pressureSystem: {
            id: 7,
            dataType: "Boolean",
            name: "Pressure System",
            showOn: [
                "Jobs",
                "Purchase Orders"
            ]
        },
        createdBy: {
            id: 9,
            dataType: "Text",
            name: "Created By",
            showOn: [
                "Builds",
                "Item Receipts",
                "Purchase Orders",
                "Shipments",
                "Work Orders"
            ]
        },
        approvedBy: {
            id: 10,
            dataType: "Text",
            name: "Approved By",
            showOn: [
                "Purchase Orders"
            ]
        },
        approvedOn: {
            id: 11,
            dataType: "Date",
            name: "Approved On",
            showOn: [
                "Purchase Orders"
            ]
        },
        inspectionInstructions: {
            id: 13,
            dataType: "Text",
            name: "Inspection Instructions",
            showOn: [
                "Items"
            ]
        },
        electricalDesigner: {
            id: 15,
            dataType: "Text",
            name: "Electrical Designer",
            showOn: [
                "Jobs"
            ]
        },
        mechanicalDesigner: {
            id: 16,
            dataType: "Text",
            name: "Mechanical Designer",
            showOn: [
                "Jobs"
            ]
        },
        model: {
            id: 18,
            dataType: "Text",
            name: "Model",
            showOn: [
                "Jobs"
            ]
        },
        saleType: {
            id: 19,
            dataType: "List",
            name: "Sale Type",
            showOn: [
                "Jobs"
            ],
            listValues: [
                "Equipment",
                "Technical Services",
                "Other",
                "N/A"
            ]
        },
        brand: {
            id: 20,
            dataType: "List",
            name: "Brand",
            showOn: [
                "Estimates",
                "Jobs"
            ],
            listValues: [
                "SNTI",
                "GNM",
                "YS"
            ]
        },
        pressureCertification: {
            id: 21,
            dataType: "List",
            name: "Pressure Certification",
            showOn: [
                "Jobs"
            ],
            listValues: [
                "ASME",
                "CRN"
            ]
        },
        dateOpened: {
            id: 22,
            dataType: "Date",
            name: "Date Opened",
            showOn: [
                "Jobs"
            ]
        },
        dateClosed: {
            id: 23,
            dataType: "Date",
            name: "Date Closed",
            showOn: [
                "Jobs"
            ]
        },
        orderName: {
            id: 24,
            dataType: "Text",
            name: "Order Name",
            showOn: [
                "Jobs"
            ]
        },
        solidWorksFileName: {
            id: 25,
            dataType: "Text",
            name: "SolidWorks File Name",
            showOn: [
                "Items"
            ]
        },
        manufacturerPartNumber: {
            id: 26,
            dataType: "Text",
            name: "Manufacturer Part Number",
            showOn: [
                "Items"
            ]
        },
        hasCrn: {
            id: 27,
            dataType: "Boolean",
            name: "Has CRN",
            showOn: [
                "Items"
            ]
        },
        evolvedOpportunityNumber: {
            id: 28,
            dataType: "Number",
            name: "Evolved Opportunity Number",
            showOn: [
                "Estimates",
                "Jobs"
            ]
        },
        dateIssued: {
            id: 29,
            dataType: "Date",
            name: "Date Issued",
            showOn: [
                "Purchase Orders"
            ]
        },
        dateConfirmed: {
            id: 30,
            dataType: "Date",
            name: "Date Confirmed By Vendor",
            showOn: [
                "Purchase Orders"
            ]
        },
        serviceEstimateOpportunityNumber: {
            id: 31,
            dataType: "Number",
            name: "Service Estimate Opportunity Number",
            showOn: [
                "Jobs"
            ]
        },
        assessmentLink: {
            id: 33,
            dataType: "Text",
            name: "Assessment Document Link",
            showOn: [
                "Vendors"
            ]
        },
        assessmentStatus: {
            id: 34,
            dataType: "List",
            name: "Assessment Status",
            showOn: [
                "Vendors"
            ],
            listValues: [
                "Not Needed",
                "In-Progress",
                "Complete - Approved",
                "Complete - Rejected"
            ]
        }
    };
    function getStringValue(entity, fieldKey) {
        return getRawValue(entity, fieldKey);
    }
    SosCustomFields.getStringValue = getStringValue;
    function getBoolValue(entity, fieldKey) {
        const rawValue = getRawValue(entity, fieldKey);
        if (!rawValue) return null;
        return rawValue === "true";
    }
    SosCustomFields.getBoolValue = getBoolValue;
    function getNumberValue(entity, fieldKey) {
        const rawValue = getRawValue(entity, fieldKey);
        if (!rawValue) return null;
        return parseFloat(rawValue);
    }
    SosCustomFields.getNumberValue = getNumberValue;
    function getListValue(entity, fieldKey) {
        return getRawValue(entity, fieldKey);
    }
    SosCustomFields.getListValue = getListValue;
    /** Regex for a date in the format dd/mm/yyyy */ const customFieldDateFormatRegex = /[0-3]?[0-9]\/[01]?[0-9]\/20[0-9]{2}/;
    function getDateValue(entity, fieldKey) {
        // Get the custom field value and validate its format
        const rawValue = getRawValue(entity, fieldKey);
        if (!rawValue) return null;
        if (!customFieldDateFormatRegex.exec(rawValue)) {
            const fieldDefinition = definitions[fieldKey];
            throw new Error(`Expected a date in format dd/mm/yyyy for custom field value '${fieldDefinition.name}', but got '${rawValue}'`);
        }
        // Validate each segment of the date
        const [day, month, year] = rawValue.split("/").map((x)=>parseInt(x));
        if (month < 1 || month > 12) throw new Error(`Invalid month value '${month.toFixed()}' for custom field date value (dd/mm/yyyy): '${rawValue}'`);
        if (day < 1 || day > 31) throw new Error(`Invalid date value '${day.toFixed()}' for custom field date value (dd/mm/yyyy): '${rawValue}'`);
        // Get the timezone offset for the parsed date without relying on the timezone of the local computer
        // See for details: https://stackoverflow.com/a/77693985/1988326
        const tzname = "America/Toronto";
        const isoString = `${year.toFixed()}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}T12:00:00.000`;
        const longOffsetFormatter = new Intl.DateTimeFormat("en-US", {
            timeZone: tzname,
            timeZoneName: "longOffset"
        });
        const longOffsetString = longOffsetFormatter.format(new Date(isoString)); // This will give something like '2/28/2013, GMT-05:00'
        const gmtOffset = longOffsetString.split("GMT")[1]; // This will give something like '-05:00'
        // Return a new date object with the timezone offset
        return new Date(isoString + gmtOffset);
    }
    /**
   * NOTE: SOS stores the date custom field values according to the date format selected in the user and company
   * settings. We have decided as a company to make sure everyone has their settings set to the format dd/mm/yyyy,
   * which is the format expected here.
   *
   * NOTE: This function parses the value so that the date object returned has the time set to noon on the specified day
   * in Senti's local timezone (ET). By setting the time to noon, we can avoid some errors that may occur due to shifting
   * time zones, DST, etc. We don't actually care about the time portion of this date, so setting it to noon, gives the
   * highest chance of the date portion not being inadvertently changed.
   */ SosCustomFields.getDateValue = getDateValue;
    const getRawValue = (entity, fieldKey)=>{
        // Find the existing value entry
        const fieldDefinition = definitions[fieldKey];
        const customFieldValues = "customFields" in entity ? entity.customFields : entity.customFieldValues;
        const entry = customFieldValues?.find((customFieldValue)=>{
            const definitionId = "id" in customFieldValue ? customFieldValue.id : customFieldValue.customFieldDefinitionId;
            return definitionId === fieldDefinition.id;
        });
        // Return null if the value doesn't exist, otherwise return the value
        if (!entry) return null;
        return entry.value;
    };
    function setStringValue(entity, fieldKey, value) {
        setRawValue(entity, fieldKey, value);
    }
    SosCustomFields.setStringValue = setStringValue;
    function setBoolValue(entity, fieldKey, value) {
        const rawValue = formatBoolValue(value);
        setRawValue(entity, fieldKey, rawValue);
    }
    SosCustomFields.setBoolValue = setBoolValue;
    function setNumberValue(entity, fieldKey, value) {
        const rawValue = formatNumberValue(value);
        setRawValue(entity, fieldKey, rawValue);
    }
    SosCustomFields.setNumberValue = setNumberValue;
    function setDateValue(entity, fieldKey, value) {
        const rawValue = formatDateCustomFieldValue(value);
        setRawValue(entity, fieldKey, rawValue);
    }
    SosCustomFields.setDateValue = setDateValue;
    function setListValue(entity, fieldKey, value) {
        setRawValue(entity, fieldKey, value);
    }
    SosCustomFields.setListValue = setListValue;
    const setRawValue = (entity, fieldKey, rawValue)=>{
        // Set the custom field value
        const fieldDefinition = definitions[fieldKey];
        const { id: id, name: name, dataType: dataType } = fieldDefinition;
        const customFieldEntries = entity.customFields ||= [];
        const existingEntry = customFieldEntries.find((customFieldValue)=>customFieldValue.id === id);
        if (existingEntry) existingEntry.value = rawValue;
        else customFieldEntries.push({
            id: id,
            name: name,
            dataType: dataType,
            value: rawValue
        });
    };
    function buildStringValue(fieldKey, value) {
        return buildRawValue(fieldKey, value);
    }
    SosCustomFields.buildStringValue = buildStringValue;
    function buildBoolValue(fieldKey, value) {
        const rawValue = formatBoolValue(value);
        return buildRawValue(fieldKey, rawValue);
    }
    SosCustomFields.buildBoolValue = buildBoolValue;
    function buildNumberValue(fieldKey, value) {
        const rawValue = formatNumberValue(value);
        return buildRawValue(fieldKey, rawValue);
    }
    SosCustomFields.buildNumberValue = buildNumberValue;
    function buildDateValue(fieldKey, value) {
        const rawValue = formatDateCustomFieldValue(value);
        return buildRawValue(fieldKey, rawValue);
    }
    SosCustomFields.buildDateValue = buildDateValue;
    function buildListValue(fieldKey, value) {
        return buildRawValue(fieldKey, value);
    }
    SosCustomFields.buildListValue = buildListValue;
    const buildRawValue = (fieldKey, value)=>{
        const fieldDefinition = definitions[fieldKey];
        return {
            id: fieldDefinition.id,
            name: fieldDefinition.name,
            dataType: fieldDefinition.dataType,
            value: value
        };
    };
    /** Format the provided number value in the format used for number custom field values by the SOS API. */ const formatNumberValue = (value)=>{
        return value === null ? null : value.toString();
    };
    /** Format the provided boolean value in the format used for boolean custom field values by the SOS API. */ const formatBoolValue = (value)=>{
        return value === null ? null : value ? "true" : "false";
    };
    /**
   * Format the provided date in the format used for date custom field values is the SOS web UI (dd/mm/yyyy).
   *
   * NOTE: This format is determined by the date format selected in the user and company settings on the SOS website. We
   * have decided as a company to make sure everyone has this format selected.
   */ const formatDateCustomFieldValue = (date)=>{
        if (date === null) return null;
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${day.toFixed()}/${month.toFixed()}/${year.toFixed()}`;
    };
})($2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4 || ($2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4 = {}));
var $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4;



const $32df95eb0ee5e5ca$export$d7888f4f62c79646 = ({ line: line })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
        className: "text-pre-wrap",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($32df95eb0ee5e5ca$var$LineItemDescriptionInternal, {
            line: line
        })
    });
const $32df95eb0ee5e5ca$var$LineItemDescriptionInternal = ({ line: line })=>{
    // Decide if a warning icon should be shown for lines with 700001 items that do not have a custom description
    const showDescriptionWarning = line.item.name === "700001" && (!line.description || line.description === line.item.description);
    const descriptionWarning = showDescriptionWarning ? "\u26A0\uFE0F" : "";
    // Fall back to just the item description if there is no description on the line item
    if (!line.description) return descriptionWarning + (line.item.description ?? "");
    // Show the line description on its own if it is the same as the item description, or there is no item description
    if (!line.item.description || line.description === line.item.description) return descriptionWarning + line.description;
    // Otherwise, show the line description followed by the item description on a new line in parentheses
    // The item description for item 700001 is re-written to be more user-friendly
    const itemDescription = line.item.name === "700001" ? "GENERAL ONE TIME PURCHASE" : line.item.description;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            line.description,
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
            "(",
            itemDescription,
            ")"
        ]
    });
};




parcelRequire("itHdT");


class $9d013be4fbfc710e$export$538aafe006ec6bcf {
    /**
   * Internal registry of steps and their dependencies.
   */ steps = {};
    /**
   * Tracks in-progress promises for each step to avoid duplicate execution.
   */ promises = {};
    /**
   * Define a step in the graph.
   * @param name - The unique name of the step.
   * @param deps - An array of step names this step depends on.
   * @param fn - An async function that receives a map of dependency results and returns the result for this step.
   */ define(name, deps, fn) {
        // Do not allow registering a step with the same name twice
        if (this.steps[name]) throw new Error(`Step '${String(name)}' is already defined`);
        // Scan the previously registered steps to determine the dependents of this step.
        const existingEntries = Object.entries(this.steps);
        const dependents = new Set(existingEntries.filter(([_, otherDef])=>otherDef.deps.includes(name)).map(([otherName])=>otherName));
        // Register this step in the steps map
        this.steps[name] = {
            deps: deps,
            fn: fn,
            dependents: dependents
        };
        // Link this step as a dependent of any previously-defined dependencies
        for (const dep of deps)this.steps[dep]?.dependents.add(name);
    }
    /**
   * Executes all steps in the graph, resolving dependencies as needed.
   * Each step is only executed once, and dependencies are resolved recursively.
   * Steps with no dependencies are started in parallel.
   *
   * @returns A promise resolving to an object containing all step results.
   */ async runAll() {
        // Reset the internal promises map to ensure a clean state
        this.resetPromises();
        // Start all steps in parallel (dependencies will be resolved recursively)
        const stepNames = Object.keys(this.steps);
        const results = await Promise.all(stepNames.map((name)=>this.runStep(name, new Set())));
        // Return all promise results as a single object
        return Object.fromEntries(stepNames.map((name, index)=>[
                name,
                results[index]
            ]));
    }
    /**
   * Re-run a portion of the graph given one or more invalidated steps.
   *
   *  - We assume an "invalidated" step means its previously produced result (in existingResults) is no longer valid.
   *  - All steps that (transitively) depend on any invalidated step must also be recomputed so their results remain
   *    consistent.
   *  - Upstream dependency steps of an invalidated step are ONLY recomputed if they themselves are listed as
   *    invalidated; otherwise their existing results (or provided precomputed results) are treated as still valid.
   *  - You may provide `precomputedResults` to short‑circuit recomputation for any step (invalidated or downstream). This
   *    is useful when data has already been updated in-place elsewhere and want the graph updated for any dependencies.
   *  - `existingResults` is not mutated; a new object is returned containing the merged, updated results for all defined
   *    steps.
   *
   * @param existingResults Previously computed results (e.g. from runAll or a prior incremental run).
   * @param invalidatedStepNames Steps whose prior results are invalid. Must be keys of defined steps.
   * @param precomputedResults Optional map of step results to use instead of (re)computing.
   * @returns A new complete results object for the graph (same shape as TResultMap).
   */ async runIncremental(existingResults, invalidatedStepNames, precomputedResults) {
        // Compute full set of steps needing recompute: invalidated + all downstream dependents
        const allInvalidatedSteps = [
            ...invalidatedStepNames,
            ...Object.keys(precomputedResults ?? {})
        ];
        const toRecompute = this.getDependentsForSteps(allInvalidatedSteps);
        // Initialize the internal `promises` map with all existing results that do not need to be recomputed, and all the
        // precomputed results that should be used instead of recomputing
        const existingEntries = Object.entries(existingResults);
        const precomputedEntries = Object.entries(precomputedResults ?? {});
        const unchangedResults = Object.fromEntries([
            ...existingEntries.filter(([stepName])=>!toRecompute.has(stepName)),
            ...precomputedEntries
        ]);
        this.resetPromises(unchangedResults);
        // Start all remaining steps to recompute in parallel (dependencies will be resolved recursively)
        const resultsArray = await Promise.all([
            ...toRecompute
        ].map((name)=>this.runStep(name, new Set())));
        const resultsMap = Object.fromEntries([
            ...toRecompute
        ].map((name, index)=>[
                name,
                resultsArray[index]
            ]));
        // Combine the recomputed results with the existing unchanged results
        return {
            ...unchangedResults,
            ...resultsMap
        };
    }
    resetPromises(results = {}) {
        this.promises = Object.fromEntries(Object.entries(results).map(([stepName, result])=>[
                stepName,
                Promise.resolve(result)
            ]));
    }
    async runStep(name, visitedSteps) {
        // Fail if this step has already been visited in this execution path
        if (visitedSteps.has(name)) throw new Error(`Cyclical dependency detected at step: ${String(name)}`);
        // Add this step to the list of visited nodes
        const newVisitedSteps = new Set(visitedSteps);
        newVisitedSteps.add(name);
        // Return existing promise if this step is already running
        if (this.promises[name]) return await this.promises[name];
        // Otherwise, register a new promise for this step and return the result
        return await (this.promises[name] = this.runStepInternal(name, newVisitedSteps));
    }
    async runStepInternal(name, visitedSteps) {
        // Get the step definition
        const { deps: deps, fn: fn } = this.steps[name] ?? (0, $be8f6f33925d422b$export$a2d8f355a4dba7ae)(`Step '${name.toString()}' is not defined`);
        // Resolve all dependencies first, passing along the already visited steps
        const depResults = await Promise.all(deps.map((dep)=>this.runStep(dep, visitedSteps)));
        const depResultsMap = Object.fromEntries(deps.map((dep, index)=>[
                dep,
                depResults[index]
            ]));
        // Execute the step function with resolved dependencies
        const consoleLabel = `Graph step '${name.toString()}'`;
        console.time(consoleLabel);
        try {
            return await Promise.resolve(fn(depResultsMap));
        } finally{
            console.timeEnd(consoleLabel);
        }
    }
    /**
   * Get all dependents (recursive) for the provided step names. The returned set also includes the provided step names.
   */ getDependentsForSteps(names) {
        const visited = new Set();
        names.forEach((name)=>this.getDependentsForStep(name, visited));
        return visited;
    }
    /**
   * Get all dependents (recursive) for the provided step name. The returned set also includes the provided step name
   */ getDependentsForStep(name, visited = new Set()) {
        visited.add(name);
        this.steps[name].dependents.forEach((name)=>this.getDependentsForStep(name, visited));
        return visited;
    }
}



const $6ce3d2cdf1f3fab7$export$b2d27939239ce27c = `
  conversion,
  isBase,
  purchaseCost,
  uom:UOM!inner(id, name, abbreviation)
`;
function $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295(uomQuantity, itemUOM) {
    // If itemUOM is null, assume the base UOM and return the original quantity
    if (!itemUOM) return uomQuantity;
    // Otherwise, calculate the base quantity using the conversion factor in the ItemUOM
    const { isBase: isBase, conversion: conversion } = itemUOM;
    return isBase ? uomQuantity : uomQuantity * conversion;
}
function $6ce3d2cdf1f3fab7$export$e4a8ee74edd711fe(quantity, sourceUOM, targetUOM) {
    // Convert the source quantity to the base UOM
    const baseQuantity = $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295(quantity, sourceUOM);
    // If the target UOM is null, assume the target is the base UOM
    if (!targetUOM) return baseQuantity;
    // Otherwise, convert the base quantity to the target UOM
    return baseQuantity / targetUOM.conversion;
}



var $b56b586d52151131$exports = {};
var $dd76581ca64cfaee$exports = {};

var $01fa11f0633ade7b$exports = {};
var $e01fd5d820913f59$exports = {};
var $c8c2a25c7e74f008$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c8c2a25c7e74f008$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$c8c2a25c7e74f008$exports = $c8c2a25c7e74f008$var$baseFindIndex;


var $521c2a07495ee44d$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $521c2a07495ee44d$var$baseIsNaN(value) {
    return value !== value;
}
$521c2a07495ee44d$exports = $521c2a07495ee44d$var$baseIsNaN;


var $59d07f00c53539e2$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $59d07f00c53539e2$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$59d07f00c53539e2$exports = $59d07f00c53539e2$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e01fd5d820913f59$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $59d07f00c53539e2$exports(array, value, fromIndex) : $c8c2a25c7e74f008$exports(array, $521c2a07495ee44d$exports, fromIndex);
}
$e01fd5d820913f59$exports = $e01fd5d820913f59$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $01fa11f0633ade7b$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $e01fd5d820913f59$exports(array, value, 0) > -1;
}
$01fa11f0633ade7b$exports = $01fa11f0633ade7b$var$arrayIncludes;


var $749f055b7de57457$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $749f055b7de57457$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$749f055b7de57457$exports = $749f055b7de57457$var$arrayIncludesWith;



var $13571056e054bcec$exports = {};

var $9d0b85edc8524b79$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $9d0b85edc8524b79$var$noop() {
// No operation performed.
}
$9d0b85edc8524b79$exports = $9d0b85edc8524b79$var$noop;



/** Used as references for various `Number` constants. */ var $13571056e054bcec$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $13571056e054bcec$var$createSet = !($7c3fbd7ff3e7f0b9$exports && 1 / $933f3d0047d7d014$exports(new $7c3fbd7ff3e7f0b9$exports([
    ,
    -0
]))[1] == $13571056e054bcec$var$INFINITY) ? $9d0b85edc8524b79$exports : function(values) {
    return new $7c3fbd7ff3e7f0b9$exports(values);
};
$13571056e054bcec$exports = $13571056e054bcec$var$createSet;



/** Used as the size to enable large array optimizations. */ var $dd76581ca64cfaee$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $dd76581ca64cfaee$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $01fa11f0633ade7b$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $749f055b7de57457$exports;
    } else if (length >= $dd76581ca64cfaee$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $13571056e054bcec$exports(array);
        if (set) return $933f3d0047d7d014$exports(set);
        isCommon = false;
        includes = $97b21191650bf4c3$exports;
        seen = new $0d76dbfd081f3fae$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$dd76581ca64cfaee$exports = $dd76581ca64cfaee$var$baseUniq;


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $b56b586d52151131$var$uniq(array) {
    return array && array.length ? $dd76581ca64cfaee$exports(array) : [];
}
$b56b586d52151131$exports = $b56b586d52151131$var$uniq;






function $cdc36ca3ee423cc0$var$_toArray(arr) {
    return $cdc36ca3ee423cc0$var$_arrayWithHoles(arr) || $cdc36ca3ee423cc0$var$_iterableToArray(arr) || $cdc36ca3ee423cc0$var$_unsupportedIterableToArray(arr) || $cdc36ca3ee423cc0$var$_nonIterableRest();
}
function $cdc36ca3ee423cc0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cdc36ca3ee423cc0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cdc36ca3ee423cc0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cdc36ca3ee423cc0$var$_arrayLikeToArray(o, minLen);
}
function $cdc36ca3ee423cc0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cdc36ca3ee423cc0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cdc36ca3ee423cc0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cdc36ca3ee423cc0$export$e4d810766679866(dineroObjects) {
    var _dineroObjects = $cdc36ca3ee423cc0$var$_toArray(dineroObjects), firstDinero = _dineroObjects[0], otherDineros = _dineroObjects.slice(1);
    var computeBaseFn = (0, $35dbf503d4b6bc95$export$34f5795259ce9fbe)(firstDinero.calculator);
    var _firstDinero$toJSON = firstDinero.toJSON(), comparator = _firstDinero$toJSON.currency;
    var equalFn = (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(firstDinero.calculator);
    var comparatorBase = computeBaseFn(comparator.base);
    return otherDineros.every(function(d) {
        var _d$toJSON = d.toJSON(), subject = _d$toJSON.currency;
        var subjectBase = computeBaseFn(subject.base);
        return subject.code === comparator.code && equalFn(subjectBase, comparatorBase) && equalFn(subject.exponent, comparator.exponent);
    });
}




function $f06f282122e1638e$export$a566bffc16069997(calculator) {
    var maximumFn = (0, $d88054b6190a12d8$export$b25e0be55f42c9a)(calculator);
    var convertScaleFn = (0, $ccf30d0ba609f014$export$5a26e3b3d26ddeb7)(calculator);
    var equalFn = (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(calculator);
    return function _normalizeScale() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObjects = _ref[0];
        var highestScale = dineroObjects.reduce(function(highest, current) {
            var _current$toJSON = current.toJSON(), scale = _current$toJSON.scale;
            return maximumFn([
                highest,
                scale
            ]);
        }, calculator.zero());
        return dineroObjects.map(function(d) {
            var _d$toJSON = d.toJSON(), scale = _d$toJSON.scale;
            return !equalFn(scale, highestScale) ? convertScaleFn(d, highestScale) : d;
        });
    };
}


function $623f1779c7e49fd4$var$_slicedToArray(arr, i) {
    return $623f1779c7e49fd4$var$_arrayWithHoles(arr) || $623f1779c7e49fd4$var$_iterableToArrayLimit(arr, i) || $623f1779c7e49fd4$var$_unsupportedIterableToArray(arr, i) || $623f1779c7e49fd4$var$_nonIterableRest();
}
function $623f1779c7e49fd4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $623f1779c7e49fd4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $623f1779c7e49fd4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $623f1779c7e49fd4$var$_arrayLikeToArray(o, minLen);
}
function $623f1779c7e49fd4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $623f1779c7e49fd4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $623f1779c7e49fd4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $623f1779c7e49fd4$var$unsafeAdd(calculator) {
    return function add() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var augend = _ref[0], addend = _ref[1];
        var _augend$toJSON = augend.toJSON(), augendAmount = _augend$toJSON.amount, currency = _augend$toJSON.currency, scale = _augend$toJSON.scale;
        var _addend$toJSON = addend.toJSON(), addendAmount = _addend$toJSON.amount;
        var amount = calculator.add(augendAmount, addendAmount);
        return augend.create({
            amount: amount,
            currency: currency,
            scale: scale
        });
    };
}
function $623f1779c7e49fd4$export$76e7653eb27840a7(calculator) {
    var normalizeFn = (0, $f06f282122e1638e$export$a566bffc16069997)(calculator);
    var addFn = $623f1779c7e49fd4$var$unsafeAdd(calculator);
    return function add() {
        for(var _len2 = arguments.length, _ref2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)_ref2[_key2] = arguments[_key2];
        var augend = _ref2[0], addend = _ref2[1];
        var condition = (0, $cdc36ca3ee423cc0$export$e4d810766679866)([
            augend,
            addend
        ]);
        (0, $a9338308e6cef3f8$export$a7a9523472993e97)(condition, (0, $f680e8b316896db8$export$b89a7c181fdad771));
        var _normalizeFn = normalizeFn([
            augend,
            addend
        ]), _normalizeFn2 = $623f1779c7e49fd4$var$_slicedToArray(_normalizeFn, 2), newAugend = _normalizeFn2[0], newAddend = _normalizeFn2[1];
        return addFn(newAugend, newAddend);
    };
}


function $0701175184650a14$export$e16d8520af44a096() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var augend = _ref[0], addend = _ref[1];
    var calculator = augend.calculator;
    var addFn = (0, $623f1779c7e49fd4$export$76e7653eb27840a7)(calculator);
    return addFn(augend, addend);
}

/* eslint-disable functional/no-expression-statement */ 

/* eslint-disable functional/no-let, functional/no-loop-statement, functional/immutable-data, functional/no-expression-statement */ 



function $60039877b9ff7a68$export$1d972cf4acc123bd(calculator) {
    return function(subject, comparator) {
        return (0, $304f50b03efae5a0$export$f517ea36c68d4644)(calculator)(subject, comparator) || (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(calculator)(subject, comparator);
    };
}



function $f762578a1bde2d50$export$f02a9ddbe4480f19(calculator) {
    return function(value, ratios) {
        var equalFn = (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(calculator);
        var greaterThanFn = (0, $304f50b03efae5a0$export$f517ea36c68d4644)(calculator);
        var lessThanFn = (0, $ada021349f332249$export$9b050841a3a1b328)(calculator);
        var greaterThanOrEqualFn = (0, $60039877b9ff7a68$export$1d972cf4acc123bd)(calculator);
        var zero = calculator.zero();
        var one = calculator.increment(zero);
        var total = ratios.reduce(function(a, b) {
            return calculator.add(a, b);
        }, zero);
        if (equalFn(total, zero)) return ratios;
        var remainder = value;
        var shares = ratios.map(function(ratio) {
            var share = calculator.integerDivide(calculator.multiply(value, ratio), total) || zero;
            remainder = calculator.subtract(remainder, share);
            return share;
        });
        var isPositive = greaterThanOrEqualFn(value, zero);
        var compare = isPositive ? greaterThanFn : lessThanFn;
        var amount = isPositive ? one : calculator.decrement(zero);
        var i = 0;
        while(compare(remainder, zero)){
            if (!equalFn(ratios[i], zero)) {
                shares[i] = calculator.add(shares[i], amount);
                remainder = calculator.subtract(remainder, amount);
            }
            i++;
        }
        return shares;
    };
}



function $c5f66e4870d39239$var$unsafeAllocate(calculator) {
    return function allocate() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var dineroObject = _ref[0], ratios = _ref[1];
        var _dineroObject$toJSON = dineroObject.toJSON(), amount = _dineroObject$toJSON.amount, currency = _dineroObject$toJSON.currency, scale = _dineroObject$toJSON.scale;
        var distributeFn = (0, $f762578a1bde2d50$export$f02a9ddbe4480f19)(calculator);
        var shares = distributeFn(amount, ratios.map(function(ratio) {
            return ratio.amount;
        }));
        return shares.map(function(share) {
            return dineroObject.create({
                amount: share,
                currency: currency,
                scale: scale
            });
        });
    };
}
function $c5f66e4870d39239$export$2104e4e9e1547c02(calculator) {
    var allocateFn = $c5f66e4870d39239$var$unsafeAllocate(calculator);
    var greaterThanOrEqualFn = (0, $60039877b9ff7a68$export$1d972cf4acc123bd)(calculator);
    var greaterThanFn = (0, $304f50b03efae5a0$export$f517ea36c68d4644)(calculator);
    var convertScaleFn = (0, $ccf30d0ba609f014$export$5a26e3b3d26ddeb7)(calculator);
    var maximumFn = (0, $d88054b6190a12d8$export$b25e0be55f42c9a)(calculator);
    var equalFn = (0, $cbc8c1361a7ab847$export$411ce8e5a71e3069)(calculator);
    var zero = calculator.zero();
    var ten = new Array(10).fill(null).reduce(calculator.increment, zero);
    return function allocate() {
        for(var _len2 = arguments.length, _ref2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)_ref2[_key2] = arguments[_key2];
        var dineroObject = _ref2[0], ratios = _ref2[1];
        var hasRatios = ratios.length > 0;
        var scaledRatios = ratios.map(function(ratio) {
            return (0, $c631104d96f9c819$export$e360235ce2c77844)(ratio, zero);
        });
        var highestRatioScale = hasRatios ? maximumFn(scaledRatios.map(function(_ref3) {
            var scale = _ref3.scale;
            return scale;
        })) : zero;
        var normalizedRatios = scaledRatios.map(function(_ref4) {
            var amount = _ref4.amount, scale = _ref4.scale;
            var factor = equalFn(scale, highestRatioScale) ? zero : calculator.subtract(highestRatioScale, scale);
            return {
                amount: calculator.multiply(amount, calculator.power(ten, factor)),
                scale: scale
            };
        });
        var hasOnlyPositiveRatios = normalizedRatios.every(function(_ref5) {
            var amount = _ref5.amount;
            return greaterThanOrEqualFn(amount, zero);
        });
        var hasOneNonZeroRatio = normalizedRatios.some(function(_ref6) {
            var amount = _ref6.amount;
            return greaterThanFn(amount, zero);
        });
        var condition = hasRatios && hasOnlyPositiveRatios && hasOneNonZeroRatio;
        (0, $a9338308e6cef3f8$export$a7a9523472993e97)(condition, (0, $f680e8b316896db8$export$f38d191a1e558a4d));
        var _dineroObject$toJSON2 = dineroObject.toJSON(), scale = _dineroObject$toJSON2.scale;
        var newScale = calculator.add(scale, highestRatioScale);
        return allocateFn(convertScaleFn(dineroObject, newScale), normalizedRatios);
    };
}


function $19832eb33091c6d8$export$19118764a8a1dde4() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var dineroObject = _ref[0], ratios = _ref[1];
    var calculator = dineroObject.calculator;
    var allocateFn = (0, $c5f66e4870d39239$export$2104e4e9e1547c02)(calculator);
    return allocateFn(dineroObject, ratios);
}





function $bf39f621749139b2$var$_slicedToArray(arr, i) {
    return $bf39f621749139b2$var$_arrayWithHoles(arr) || $bf39f621749139b2$var$_iterableToArrayLimit(arr, i) || $bf39f621749139b2$var$_unsupportedIterableToArray(arr, i) || $bf39f621749139b2$var$_nonIterableRest();
}
function $bf39f621749139b2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bf39f621749139b2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bf39f621749139b2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bf39f621749139b2$var$_arrayLikeToArray(o, minLen);
}
function $bf39f621749139b2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bf39f621749139b2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bf39f621749139b2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bf39f621749139b2$var$unsafeSubtract(calculator) {
    return function subtract() {
        for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
        var minuend = _ref[0], subtrahend = _ref[1];
        var _minuend$toJSON = minuend.toJSON(), minuendAmount = _minuend$toJSON.amount, currency = _minuend$toJSON.currency, scale = _minuend$toJSON.scale;
        var _subtrahend$toJSON = subtrahend.toJSON(), subtrahendAmount = _subtrahend$toJSON.amount;
        var amount = calculator.subtract(minuendAmount, subtrahendAmount);
        return minuend.create({
            amount: amount,
            currency: currency,
            scale: scale
        });
    };
}
function $bf39f621749139b2$export$57d9ea8e234e2dc2(calculator) {
    var normalizeFn = (0, $f06f282122e1638e$export$a566bffc16069997)(calculator);
    var subtractFn = $bf39f621749139b2$var$unsafeSubtract(calculator);
    return function subtract() {
        for(var _len2 = arguments.length, _ref2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)_ref2[_key2] = arguments[_key2];
        var minuend = _ref2[0], subtrahend = _ref2[1];
        var condition = (0, $cdc36ca3ee423cc0$export$e4d810766679866)([
            minuend,
            subtrahend
        ]);
        (0, $a9338308e6cef3f8$export$a7a9523472993e97)(condition, (0, $f680e8b316896db8$export$b89a7c181fdad771));
        var _normalizeFn = normalizeFn([
            minuend,
            subtrahend
        ]), _normalizeFn2 = $bf39f621749139b2$var$_slicedToArray(_normalizeFn, 2), newMinuend = _normalizeFn2[0], newSubtrahend = _normalizeFn2[1];
        return subtractFn(newMinuend, newSubtrahend);
    };
}


function $53d517b6a8043872$export$4e2d2ead65e5f7e3() {
    for(var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++)_ref[_key] = arguments[_key];
    var minuend = _ref[0], subtrahend = _ref[1];
    var calculator = minuend.calculator;
    var subtractFn = (0, $bf39f621749139b2$export$57d9ea8e234e2dc2)(calculator);
    return subtractFn(minuend, subtrahend);
}



const $76af25cbdec97018$export$8c5c5153a2e56f3b = 4;
class $76af25cbdec97018$export$effcfb42d1cb2ea1 {
    taxes;
    /** Static instance for a cost with no tax codes applied */ static EMPTY = new $76af25cbdec97018$export$effcfb42d1cb2ea1(new Map());
    /** The sum of all the taxes in the `taxes` map */ total;
    /**
   * Create a new instance of TaxBreakdown
   * @param taxes All the tax codes applied to the cost, and the amount of tax applied for each tax code.
   */ constructor(taxes){
        this.taxes = taxes;
        this.total = Array.from(taxes.values()).reduce((acc, tax)=>(0, $0701175184650a14$export$e16d8520af44a096)(acc, tax), (0, $bb09d99f2c0a98ec$export$41a3cbea1d0bb6f8));
    }
    add(other) {
        const newTaxes = new Map(this.taxes);
        for (const [taxCode, tax] of other.taxes){
            const existingTax = newTaxes.get(taxCode);
            newTaxes.set(taxCode, (0, $0701175184650a14$export$e16d8520af44a096)(existingTax ?? (0, $bb09d99f2c0a98ec$export$41a3cbea1d0bb6f8), tax));
        }
        return new $76af25cbdec97018$export$effcfb42d1cb2ea1(newTaxes);
    }
    subtract(other) {
        const newTaxes = new Map(this.taxes);
        for (const [taxCode, tax] of other.taxes){
            const existingTax = newTaxes.get(taxCode);
            newTaxes.set(taxCode, (0, $53d517b6a8043872$export$4e2d2ead65e5f7e3)(existingTax ?? (0, $bb09d99f2c0a98ec$export$41a3cbea1d0bb6f8), tax));
        }
        return new $76af25cbdec97018$export$effcfb42d1cb2ea1(newTaxes);
    }
    multiply(amount) {
        const newTaxes = new Map([
            ...this.taxes
        ].map(([taxCode, tax])=>[
                taxCode,
                (0, $bb09d99f2c0a98ec$export$5c87e5997adedfc8)(tax, {
                    amount: amount,
                    scale: $76af25cbdec97018$export$8c5c5153a2e56f3b
                })
            ]));
        return new $76af25cbdec97018$export$effcfb42d1cb2ea1(newTaxes);
    }
    allocate(ratios) {
        // Allocate each of the taxes based on the ratios provided
        const allocatedTaxes = [
            ...this.taxes.entries()
        ].map(([taxCode, amount])=>[
                taxCode,
                (0, $19832eb33091c6d8$export$19118764a8a1dde4)(amount, ratios)
            ]);
        // Create a new TaxBreakdown for each of the ratios
        return ratios.map((_, i)=>new $76af25cbdec97018$export$effcfb42d1cb2ea1(new Map(allocatedTaxes.map(([taxCode, amounts])=>[
                    taxCode,
                    amounts[i]
                ]))));
    }
    getLabel() {
        if (this.taxes.size === 0) return "";
        if (this.taxes.size === 1) return Array.from(this.taxes.keys())[0].name;
        return "taxes";
    }
}



class $f2faaafdab540e00$export$72b98bde8fc72fd9 {
    /** Static instance for a cost of $0.00 with no taxed applied */ static ZERO = new $f2faaafdab540e00$export$72b98bde8fc72fd9({
        subtotal: (0, $bb09d99f2c0a98ec$export$41a3cbea1d0bb6f8),
        taxes: (0, $76af25cbdec97018$export$effcfb42d1cb2ea1).EMPTY
    });
    /** Create a new cost breakdown with the specified error. */ static withError(error) {
        return new $f2faaafdab540e00$export$72b98bde8fc72fd9({
            errors: [
                error
            ]
        });
    }
    /**
   * Create a cost breakdown for the specified item and vendor. The tax code from the item is used if it exists, otherwise
   * the tax code from the vendor is used. If neither has a tax code, an error is returned.
   *
   * In general, the item's tax code should match the vendor's tax code, but there are cases where they may differ (e.g. a
   * vendor that sells both taxable and non-taxable items, or the labour items (exempt) that are under the Senti vendor (HST)).
   */ static forItemAndVendor({ item: item, vendor: vendor, ...options }) {
        const taxCode = item.purchaseTaxCode || vendor.taxCode;
        if (!taxCode) return $f2faaafdab540e00$export$72b98bde8fc72fd9.withError(`Item ${item.name} has no purchase tax code selected, and neither does it's preferred vendor '${vendor.name}'`);
        return new $f2faaafdab540e00$export$72b98bde8fc72fd9({
            ...options,
            taxCode: taxCode
        });
    }
    subtotal;
    taxes;
    tax;
    total;
    /**
   * Any errors that occurred while creating the cost breakdown. If this array is empty, the cost breakdown is valid.
   * If this array has one or more elements, the cost breakdown is invalid and the cost values should not be used.
   */ errors;
    constructor(options){
        if ("errors" in options) {
            this.errors = options.errors;
            this.subtotal = (0, $bb09d99f2c0a98ec$export$41a3cbea1d0bb6f8);
            this.taxes = (0, $76af25cbdec97018$export$effcfb42d1cb2ea1).EMPTY;
            this.total = (0, $bb09d99f2c0a98ec$export$41a3cbea1d0bb6f8);
            this.tax = (0, $bb09d99f2c0a98ec$export$41a3cbea1d0bb6f8);
            return;
        } else this.errors = [];
        if ("taxes" in options) {
            this.subtotal = options.subtotal;
            this.taxes = options.taxes;
            this.total = (0, $0701175184650a14$export$e16d8520af44a096)(options.subtotal, options.taxes.total);
        } else {
            const taxCode = options.taxCode;
            const taxRate = taxCode.purchaseTaxRate / 100;
            if ("total" in options) {
                this.total = options.total;
                this.subtotal = (0, $bb09d99f2c0a98ec$export$5c87e5997adedfc8)(this.total, {
                    amount: 1 / (1 + taxRate),
                    scale: (0, $76af25cbdec97018$export$8c5c5153a2e56f3b)
                });
                const tax = (0, $53d517b6a8043872$export$4e2d2ead65e5f7e3)(this.total, this.subtotal);
                this.taxes = new (0, $76af25cbdec97018$export$effcfb42d1cb2ea1)(new Map([
                    [
                        taxCode,
                        tax
                    ]
                ]));
            } else {
                this.subtotal = options.subtotal;
                const tax = (0, $bb09d99f2c0a98ec$export$5c87e5997adedfc8)(options.subtotal, {
                    amount: taxRate,
                    scale: (0, $76af25cbdec97018$export$8c5c5153a2e56f3b)
                });
                this.total = (0, $0701175184650a14$export$e16d8520af44a096)(this.subtotal, tax);
                this.taxes = new (0, $76af25cbdec97018$export$effcfb42d1cb2ea1)(new Map([
                    [
                        taxCode,
                        tax
                    ]
                ]));
            }
        }
        this.tax = this.taxes.total;
    }
    add(other) {
        const errors = (0, (/*@__PURE__*/$parcel$interopDefault($b56b586d52151131$exports)))(this.errors.concat(other.errors));
        if (errors.length) return new $f2faaafdab540e00$export$72b98bde8fc72fd9({
            errors: errors
        });
        return new $f2faaafdab540e00$export$72b98bde8fc72fd9({
            subtotal: (0, $0701175184650a14$export$e16d8520af44a096)(this.subtotal, other.subtotal),
            taxes: this.taxes.add(other.taxes)
        });
    }
    subtract(other) {
        const errors = (0, (/*@__PURE__*/$parcel$interopDefault($b56b586d52151131$exports)))(this.errors.concat(other.errors));
        if (errors.length) return new $f2faaafdab540e00$export$72b98bde8fc72fd9({
            errors: errors
        });
        return new $f2faaafdab540e00$export$72b98bde8fc72fd9({
            subtotal: (0, $53d517b6a8043872$export$4e2d2ead65e5f7e3)(this.subtotal, other.subtotal),
            taxes: this.taxes.subtract(other.taxes)
        });
    }
    /**
   * See: https://v2.dinerojs.com/docs/api/mutations/multiply
   */ multiply(amount, scale = 2) {
        if (this.errors.length) return this;
        return new $f2faaafdab540e00$export$72b98bde8fc72fd9({
            subtotal: (0, $bb09d99f2c0a98ec$export$5c87e5997adedfc8)(this.subtotal, {
                amount: amount,
                scale: scale
            }),
            taxes: this.taxes.multiply(amount)
        });
    }
    /**
   * See: https://v2.dinerojs.com/docs/api/mutations/allocate
   */ allocate(ratios) {
        if (this.errors.length) return ratios.map(()=>this);
        const allocatedSubtotals = (0, $19832eb33091c6d8$export$19118764a8a1dde4)(this.subtotal, ratios);
        const allocatedTaxes = this.taxes.allocate(ratios);
        return allocatedSubtotals.map((subtotal, i)=>new $f2faaafdab540e00$export$72b98bde8fc72fd9({
                subtotal: subtotal,
                taxes: allocatedTaxes[i]
            }));
    }
}




const $2b48e978c222bd17$export$87cca2e53773fd2a = `
  id,
  name,
  currency:Currency!currencyId(id,code),
  taxCode:TaxCode!taxCodeId(id,name,purchaseTaxRate)
`;
function $2b48e978c222bd17$export$700aee188bfc9(vendor) {
    const currency = vendor.currency;
    if (!currency) throw new Error(`Vendor '${vendor.name}' has no currency`);
    return (0, $bb09d99f2c0a98ec$export$6ade6d89a215534c)(currency.code);
}


const $6d50882dcfab2b28$export$6bcff91a197a7380 = `
  id,
  name,
  type,
  description,
  purchaseCost,
  leadTimeDays:leadTime,
  preferredVendor:Vendor!vendorId(${(0, $2b48e978c222bd17$export$87cca2e53773fd2a)}),
  purchaseTaxCode:TaxCode!purchaseTaxCodeId(*),
  catalogEntries:VendorItemCatalog(
    price,
    vendorPartNumber,
    vendor:Vendor!vendorId(${(0, $2b48e978c222bd17$export$87cca2e53773fd2a)})
  ),
  uoms:ItemUOM(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)})
`;
function $6d50882dcfab2b28$export$62232a46d0543a40(item, CADCurrencyConverter) {
    return {
        ...item,
        preferredPurchaseCost: $6d50882dcfab2b28$var$getPurchaseCostForItemAndVendor(item, CADCurrencyConverter),
        baseItemUOM: item.uoms.find((x)=>x.isBase),
        leadTimeMs: item.leadTimeDays ? item.leadTimeDays * 86400000 : null
    };
}
/**
 * Get the purchase cost for a specific vendor and item combination.
 *
 * See {@link getPreferredPurchaseSubtotalCad} for details on how the cost is calculated.
 *
 * The tax code from the vendor is used. If there is no tax code on the vendor, it is an error and we don't fall back
 * to the tax code on the item.
 */ function $6d50882dcfab2b28$var$getPurchaseCostForItemAndVendor(item, CADCurrencyConverter) {
    // Get the subtotal for the item, return an error on failure
    const subtotalResult = $6d50882dcfab2b28$var$getPreferredPurchaseSubtotalCad(item, CADCurrencyConverter);
    if ("error" in subtotalResult) return (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).withError(subtotalResult.error);
    // Compute the full cost breakdown - use the tax code from the item, falling back to the vendor's tax code
    return (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).forItemAndVendor({
        item: item,
        ...subtotalResult
    });
}
/**
 * Get the purchase cost subtotal for the specified item, and the vendor associated with the purchase subtotal.
 *
 * If the item has a preferred vendor, the cost comes from the associated vendor-item catalog entry, if any, falling
 * back to the item purchase cost.
 *
 * If the item has no preferred vendor, but a single vendor-item catalog entry exists, the cost comes from that entry.
 *
 * Otherwise, an error message is returned.
 */ function $6d50882dcfab2b28$var$getPreferredPurchaseSubtotalCad(item, CADCurrencyConverter) {
    const vendor = item.preferredVendor;
    if (vendor) {
        // If the item has a preferred vendor, use the catalog entry for that vendor if it exists, fall back to the item's purchase cost
        const catalogEntry = item.catalogEntries.find((x)=>x.vendor.id === vendor.id);
        const vendorCurrencyCode = (0, $2b48e978c222bd17$export$700aee188bfc9)(vendor);
        const purchaseCost = (0, $bb09d99f2c0a98ec$export$956a16bd79899df1)(catalogEntry ? catalogEntry.price : item.purchaseCost, vendorCurrencyCode);
        return {
            subtotal: CADCurrencyConverter(purchaseCost),
            vendor: vendor
        };
    } else if (item.catalogEntries.length > 1) // Return an error if there were multiple catalog entries to choose from
    return {
        error: `Item '${item.name}' has multiple vendor-item catalog entries and no preferred vendor`
    };
    else if (item.catalogEntries.length) {
        // If the item has no preferred vendor, but a single catalog entry, use that entry
        const { price: price, vendor: vendor } = item.catalogEntries[0];
        const vendorCurrencyCode = (0, $2b48e978c222bd17$export$700aee188bfc9)(vendor);
        const purchaseCost = (0, $bb09d99f2c0a98ec$export$956a16bd79899df1)(price, vendorCurrencyCode);
        return {
            subtotal: CADCurrencyConverter(purchaseCost),
            vendor: vendor
        };
    } else // Otherwise there are no catalog entries or preferred vendor, return an error
    return {
        error: `Item '${item.name}' has no preferred vendor or vendor-item catalog entries`
    };
}


const $83b619531aea1976$var$adjustmentSelect = `
id,
number,
date,
comment,
lines:AdjustmentLineItem!inner(
  id,
  lineNumber:linenumber,
  item:Item(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
  job:Job(id, name),
  description,
  uomQuantityDiff:quantityDiff,
  uomNewQuantity:newQuantity,
  itemUOM:ItemUOM(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
  bin:Bin(id, number)
)
`;
async function $83b619531aea1976$export$c09013399ecf8503(binId, CADCurrencyConverter) {
    // Get all adjustment ids with any non-deleted line item to or from the sales order rack bin
    const adjustmentIds = new Set((await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("AdjustmentLineItem").select("adjustmentId").eq("binId", binId).eq("deleted", false).throwOnError()).data.map((x)=>x.adjustmentId));
    // Get all non-deleted adjustments with the matched adjustment ids
    const queryResult = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Adjustment").select($83b619531aea1976$var$adjustmentSelect).in("id", [
        ...adjustmentIds
    ]).eq("deleted", false).eq("lines.deleted", false).order("date", {
        ascending: false
    }).order("linenumber", {
        referencedTable: "lines",
        ascending: true
    }).throwOnError()).data;
    // Do some additional client-side processing on the results before returning
    return queryResult.map((po)=>$83b619531aea1976$var$processAdjustment(po, binId, CADCurrencyConverter));
}
function $83b619531aea1976$var$processAdjustment({ lines: rawLines, ...adjustment }, binId, CADCurrencyConverter) {
    const allLines = rawLines.map((line)=>$83b619531aea1976$var$processAdjustmentLineItem(line, CADCurrencyConverter));
    const salesOrderRackLines = allLines.filter((x)=>x.bin?.id === binId);
    return {
        ...adjustment,
        allLines: allLines,
        salesOrderRackLines: salesOrderRackLines
    };
}
function $83b619531aea1976$var$processAdjustmentLineItem(line, CADCurrencyConverter) {
    return {
        ...line,
        baseQuantityDiff: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomQuantityDiff, line.itemUOM),
        baseNewQuantity: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomNewQuantity, line.itemUOM),
        item: (0, $6d50882dcfab2b28$export$62232a46d0543a40)(line.item, CADCurrencyConverter)
    };
}


var $4ff36ccfbdb107da$exports = {};

var $982da38d3ecbe5d0$exports = {};
var $aced355301eb3904$exports = {};
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $aced355301eb3904$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
$aced355301eb3904$exports = $aced355301eb3904$var$arrayAggregator;


var $4e00347094fa96be$exports = {};
var $61c558abc78dc56d$exports = {};
var $6178923aa99f9551$exports = {};


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $6178923aa99f9551$var$baseForOwn(object, iteratee) {
    return object && $362b8f2f8a5f669f$exports(object, iteratee, $c13f350ecddacb0c$exports);
}
$6178923aa99f9551$exports = $6178923aa99f9551$var$baseForOwn;


var $228ccc43151d4690$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $228ccc43151d4690$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$e1ea3190b025ca72$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$228ccc43151d4690$exports = $228ccc43151d4690$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $61c558abc78dc56d$var$baseEach = $228ccc43151d4690$exports($6178923aa99f9551$exports);
$61c558abc78dc56d$exports = $61c558abc78dc56d$var$baseEach;


/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $4e00347094fa96be$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $61c558abc78dc56d$exports(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
$4e00347094fa96be$exports = $4e00347094fa96be$var$baseAggregator;




/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $982da38d3ecbe5d0$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $f7463dbc77cf4722$exports(collection) ? $aced355301eb3904$exports : $4e00347094fa96be$exports, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $c2bfe06b6383bbdf$exports(iteratee, 2), accumulator);
    };
}
$982da38d3ecbe5d0$exports = $982da38d3ecbe5d0$var$createAggregator;


/** Used for built-in method references. */ var $4ff36ccfbdb107da$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4ff36ccfbdb107da$var$hasOwnProperty = $4ff36ccfbdb107da$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $4ff36ccfbdb107da$var$groupBy = $982da38d3ecbe5d0$exports(function(result, value, key) {
    if ($4ff36ccfbdb107da$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $b89309ed7fadc624$exports(result, key, [
        value
    ]);
});
$4ff36ccfbdb107da$exports = $4ff36ccfbdb107da$var$groupBy;


const $ccba93d7976774da$export$426717e7f687ece8 = [
    1,
    2,
    3,
    4
];
const $ccba93d7976774da$export$f5105a1a3a9ecd40 = 1;
const $ccba93d7976774da$export$cc3cd71de886be2d = 4;
const $ccba93d7976774da$export$39e251832c3f0c85 = {
    1: "#A3A380",
    2: "#E2C290",
    3: "#B4B4B4",
    4: "#A18FC6"
};
const $ccba93d7976774da$export$9cad03fca08bc80e = {
    priority: 1,
    nodeTemplateRecord: null,
    nodeJobRecord: null,
    appliedRecord: null,
    appliedRecordSource: "default",
    inherited: false
};
function $ccba93d7976774da$export$c95f37487a209b12(parentEffectivePriority, nodeTemplateRecord, nodeJobRecord) {
    // The applied record always prefers the job-specific record over the template record
    const appliedRecord = nodeJobRecord ?? nodeTemplateRecord;
    // If this node does not have it's own explicit priority, inherit from the parent node
    if (!appliedRecord) return {
        ...parentEffectivePriority,
        nodeTemplateRecord: nodeTemplateRecord,
        nodeJobRecord: nodeJobRecord,
        inherited: true
    };
    // If this node has a template priority, but the parent priority is job-specific, inherit it (job-specific priorities always override template priorities)
    const sourceType = appliedRecord.jobId ? "job" : "template";
    if (parentEffectivePriority.appliedRecordSource === "job" && sourceType === "template") return {
        ...parentEffectivePriority,
        nodeTemplateRecord: nodeTemplateRecord,
        nodeJobRecord: nodeJobRecord,
        inherited: true
    };
    // Compute and return the overridden priority for the current node
    return {
        appliedRecord: appliedRecord,
        nodeTemplateRecord: nodeTemplateRecord,
        nodeJobRecord: nodeJobRecord,
        appliedRecordSource: sourceType,
        priority: appliedRecord.priority,
        inherited: false
    };
}
function $ccba93d7976774da$export$c3696b1b07bd1317(children) {
    return children.reduce((overrides, child)=>{
        // Include this child if it is an override
        if (!child.purchasingPriority.inherited && child.purchasingPriority.appliedRecordSource !== "default") overrides[child.purchasingPriority.appliedRecordSource].push(child);
        // Include all the overridden children of this child
        overrides.job.push(...child.purchasingPriority.childOverrides.job);
        overrides.template.push(...child.purchasingPriority.childOverrides.template);
        return overrides;
    }, {
        job: [],
        template: []
    });
}







const $a96d640c2c5a19c8$var$costCategories = [
    "material",
    "nonMaterial",
    "existingInventory",
    "labour",
    "shipping"
];
class $a96d640c2c5a19c8$export$16b8238881e79cc9 {
    costs;
    material = (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO;
    nonMaterial = (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO;
    existingInventory = (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO;
    labour = (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO;
    shipping = (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO;
    static ZERO = new $a96d640c2c5a19c8$export$16b8238881e79cc9(Object.fromEntries($a96d640c2c5a19c8$var$costCategories.map((category)=>[
            category,
            (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO
        ])));
    constructor(costs){
        this.costs = Object.fromEntries($a96d640c2c5a19c8$var$costCategories.map((category)=>[
                category,
                costs[category] ?? (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO
            ]));
        for (const category of $a96d640c2c5a19c8$var$costCategories)this[category] = this.costs[category];
    }
    add(other) {
        return new $a96d640c2c5a19c8$export$16b8238881e79cc9(Object.fromEntries($a96d640c2c5a19c8$var$costCategories.map((category)=>[
                category,
                this.costs[category].add(other.costs[category])
            ])));
    }
    multiply(multiplier) {
        return new $a96d640c2c5a19c8$export$16b8238881e79cc9(Object.fromEntries($a96d640c2c5a19c8$var$costCategories.map((category)=>[
                category,
                this.costs[category].multiply(multiplier)
            ])));
    }
    getTotalCost() {
        return Object.values(this.costs).reduce((total, cost)=>total.add(cost), (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO);
    }
    static getItemCostCategory(item) {
        if (item.id === 775) return "shipping";
        if (item.type === "Labor") return "labour";
        return (0, $2b3a7af3658dfb79$export$3b6db6d9ae78dca4)(item.type) ? "material" : "nonMaterial";
    }
}


const $522415699e9e4669$var$ASCII_TREE_STRINGS = {
    CHILD: "\u251C\u2500 ",
    LAST_CHILD: "\u2514\u2500 ",
    DIRECTORY: "\u2502  ",
    EMPTY: "   "
};
class $522415699e9e4669$export$8331bd18d884bb15 {
    purchasingPriorities;
    constructor(purchasingPriorities){
        this.purchasingPriorities = purchasingPriorities;
    }
    generate({ parents: parents, bomRecordsByParentPath: bomRecordsByParentPath }) {
        // Do nothing if no parents were specified
        if (!parents.length) return [];
        // Create dummy BOM records for the provided parents, then recursively generate the BOM hierarchy
        return parents.map((parent, index)=>({
                assemblyId: NaN,
                lineNumber: index + 1,
                componentId: parent.item.id,
                item: parent.item,
                quantity: parent.quantity,
                notes: "",
                path: [],
                depth: -1
            })).map((x)=>this.supabaseBomRecordToHierarchicalBomNode(x, [], 1, (0, $ccba93d7976774da$export$9cad03fca08bc80e), bomRecordsByParentPath));
    }
    supabaseBomRecordToHierarchicalBomNode(currentRecord, asciiTreeComponents, parentTotalQuantity, parentPurchasingPriority, bomRecordsByParentPath) {
        // Determine the effective purchasing priority for this node
        const pathString = [
            ...currentRecord.path,
            currentRecord.componentId
        ].join(",");
        const nodeTemplatePriorityRecord = (0, $be8f6f33925d422b$export$f06b772ecb3051c2)(this.purchasingPriorities.templatePriorities, {
            path: pathString
        }, (x)=>x.path);
        const nodeJobPriorityRecord = (0, $be8f6f33925d422b$export$f06b772ecb3051c2)(this.purchasingPriorities.salesOrderPriorities, {
            path: pathString
        }, (x)=>x.path);
        const purchasingPriority = (0, $ccba93d7976774da$export$c95f37487a209b12)(parentPurchasingPriority, nodeTemplatePriorityRecord, nodeJobPriorityRecord);
        // Get the BOM records for this item (will be an empty array for non-assemblies)
        // NOTE: We need to check the item type here because non-assemblies may still have BOM records (i.e. if they used to
        // be an assembly but the item type was later changed)
        const bomRecords = (0, $2b3a7af3658dfb79$export$e6ae7ae9cddc1cf4)(currentRecord.item.type) ? bomRecordsByParentPath[pathString] : [];
        // Recursively generate the BOM for each child
        const totalQuantity = currentRecord.quantity * parentTotalQuantity;
        const children = (bomRecords ?? []).map((x, index, arr)=>{
            // Determine the components of the ASCII tree for this child
            const childAsciiTreeComponents = $522415699e9e4669$export$8331bd18d884bb15.getAsciiTreeComponents(asciiTreeComponents, index === arr.length - 1);
            return this.supabaseBomRecordToHierarchicalBomNode(x, childAsciiTreeComponents, totalQuantity, purchasingPriority, bomRecordsByParentPath);
        });
        // Calculate costs for the current item
        const item = currentRecord.item;
        const isAssembly = (0, $2b3a7af3658dfb79$export$e6ae7ae9cddc1cf4)(item.type);
        const categorizedUnitCosts = this.calculateCategorizedUnitCosts(item, children);
        const categorizedLineItemCosts = categorizedUnitCosts.multiply(currentRecord.quantity);
        const unitCost = categorizedUnitCosts.getTotalCost();
        const lineItemCost = categorizedLineItemCosts.getTotalCost();
        // Collect all child nodes with overridden priorities
        const childOverrides = (0, $ccba93d7976774da$export$c3696b1b07bd1317)(children);
        // Create a BOM node for the current item
        return {
            lineNumber: currentRecord.lineNumber,
            item: item,
            path: pathString,
            missingLabourEstimate: this.isMissingLabourEstimate(item, children),
            purchasingPriority: {
                ...purchasingPriority,
                childOverrides: childOverrides
            },
            quantity: currentRecord.quantity,
            totalQuantity: totalQuantity,
            notes: currentRecord.notes,
            isAssembly: isAssembly,
            recursiveDepth: currentRecord.depth + 1,
            categorizedUnitCosts: categorizedUnitCosts,
            categorizedLineItemCosts: categorizedLineItemCosts,
            unitCost: unitCost,
            lineItemCost: lineItemCost,
            children: children,
            asciiTreePrefix: asciiTreeComponents.join("")
        };
    }
    isMissingLabourEstimate(item, children) {
        return (0, $2b3a7af3658dfb79$export$e6ae7ae9cddc1cf4)(item.type) && !children.some((x)=>x.item.type === "Labor" || x.item.name.endsWith("-CM"));
    }
    calculateCategorizedUnitCosts(item, children) {
        if (!(0, $2b3a7af3658dfb79$export$e6ae7ae9cddc1cf4)(item.type)) {
            // Non-assemblies use the purchase cost for the preferred vendor
            // The category is assigned based on the item type (all other categories are zero)
            const category = (0, $a96d640c2c5a19c8$export$16b8238881e79cc9).getItemCostCategory(item);
            return new (0, $a96d640c2c5a19c8$export$16b8238881e79cc9)({
                [category]: item.preferredPurchaseCost
            });
        } else // Calculate assembly costs as the sum of its line items
        return children.map((x)=>x.categorizedUnitCosts.multiply(x.quantity)).reduce((sum, x)=>sum.add(x), (0, $a96d640c2c5a19c8$export$16b8238881e79cc9).ZERO);
    }
    /**
   * Get the ASCII tree components for a node based on the ASCII tree components of its parent and whether it is the
   * last child.
   */ static getAsciiTreeComponents(parentComponents, isLastChild) {
        // Swap out the parent's last leaf component for the appropriate tree component
        const childComponents = [
            ...parentComponents
        ];
        if (childComponents.length) childComponents.push(childComponents.pop() === $522415699e9e4669$var$ASCII_TREE_STRINGS.LAST_CHILD ? $522415699e9e4669$var$ASCII_TREE_STRINGS.EMPTY : $522415699e9e4669$var$ASCII_TREE_STRINGS.DIRECTORY);
        // Add a leaf segment for the child
        childComponents.push(isLastChild ? $522415699e9e4669$var$ASCII_TREE_STRINGS.LAST_CHILD : $522415699e9e4669$var$ASCII_TREE_STRINGS.CHILD);
        return childComponents;
    }
}



class $e7668e32bbad6126$export$615c8bd31334196d {
    static ZERO = new $e7668e32bbad6126$export$615c8bd31334196d({
        balance: 0
    });
    fromInventory;
    toInventory;
    balance;
    constructor(args){
        if ("balance" in args) {
            this.balance = args.balance;
            if (this.balance > 0) {
                this.fromInventory = this.balance;
                this.toInventory = 0;
            } else {
                this.fromInventory = 0;
                this.toInventory = -this.balance;
            }
        } else {
            this.fromInventory = args.fromInventory;
            this.toInventory = args.toInventory;
            this.balance = this.fromInventory - this.toInventory;
        }
    }
    isZero() {
        return this.fromInventory === 0 && this.toInventory === 0;
    }
    add(other) {
        return new $e7668e32bbad6126$export$615c8bd31334196d({
            fromInventory: this.fromInventory + other.fromInventory,
            toInventory: this.toInventory + other.toInventory
        });
    }
}


function $5358e52d581e377f$export$dfc163bfbf6fa863(jobId, salesOrderRack, transfers, adjustments, builds, shipments, itemReceipts) {
    // Collect all the relevant record line items into a single generic collection
    // prettier-ignore
    const sourceLines = [
        ...transfers.flatMap((transfer)=>transfer.salesOrderRackLines.map((sourceLine)=>({
                    type: "Transfer",
                    sourceRecordType: 'transfer',
                    sourceRecord: transfer,
                    sourceLine: sourceLine
                }))),
        ...adjustments.flatMap((adjustment)=>adjustment.salesOrderRackLines.map((sourceLine)=>({
                    type: "Adjustment",
                    sourceRecordType: 'adjustment',
                    sourceRecord: adjustment,
                    sourceLine: sourceLine
                }))),
        ...builds.flatMap((build)=>build.inputs.map((sourceLine)=>({
                    type: "Build Input",
                    sourceRecordType: 'build',
                    sourceRecord: build,
                    sourceLine: sourceLine
                }))),
        ...builds.flatMap((build)=>build.outputs.map((sourceLine)=>({
                    type: "Build Output",
                    sourceRecordType: 'build',
                    sourceRecord: build,
                    sourceLine: sourceLine
                }))),
        ...shipments.flatMap((shipment)=>shipment.allLines.map((sourceLine)=>({
                    type: "Shipment",
                    sourceRecordType: 'shipment',
                    sourceRecord: shipment,
                    sourceLine: sourceLine
                })))
    ];
    // For non-inventory items, create a map of item id, to the number of that item received for this job
    // We will first pull from job-specific item receipts, and then any remaining required quantity will be assumed to be
    // pulled from existing inventory
    const nonInventoryLines = itemReceipts.flatMap((receipt)=>receipt.jobLines).filter((line)=>line.item.type === "Non-inventory Item").map((line)=>line).filter((line)=>line.baseQuantity);
    const nonInventoryPurchaseQuantities = new Map(Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($4ff36ccfbdb107da$exports)))(nonInventoryLines, (line)=>line.item.id)).map(([itemId, lines])=>[
            Number(itemId),
            lines.reduce((sum, line)=>sum + line.baseQuantity, 0)
        ]));
    // Get the quantity of existing inventory used for each collected line item
    const rackId = salesOrderRack.id;
    const sourceRecords = sourceLines.map((line)=>{
        const balance = $5358e52d581e377f$var$getExistingInventoryBalanceForSourceLine(jobId, rackId, line, nonInventoryPurchaseQuantities);
        return {
            ...line,
            balance: balance
        };
    }).filter((x)=>x.balance !== 0);
    // Group the line items by item then collapse them so we end up with a single record per item
    // Sort by quantity so that positive and negative values are separated
    const recordsByItem = Map.groupBy(sourceRecords, (record)=>record.sourceLine.item.id);
    return Array.from(recordsByItem.values()).map((records)=>{
        const item = records[0].sourceLine.item;
        const description = records.map((x)=>x.sourceLine.description || "").reduce((a, b)=>a.length > b.length ? a : b, "");
        const quantity = records.reduce((sum, { balance: balance })=>sum.add(new (0, $e7668e32bbad6126$export$615c8bd31334196d)({
                balance: balance
            })), (0, $e7668e32bbad6126$export$615c8bd31334196d).ZERO);
        return {
            item: item,
            description: description,
            quantity: quantity,
            sources: records
        };
    }).sort((a, b)=>a.item.type.localeCompare(b.item.type) || a.item.name.localeCompare(b.item.name));
}
const $5358e52d581e377f$var$getExistingInventoryBalanceForSourceLine = (jobId, rackId, { type: type, sourceLine: line }, nonInventoryPurchaseQuantities)=>{
    // For transfers, the quantity of existing inventory used for a given line item is:
    // - 0 if the source and destination bin are both the sales order rack
    // - the positive transfer quantity if the sales order rack is the destination bin
    // - The negative transfer quantity if the sales order rack is the source bin
    if (type === "Transfer") {
        const sameBin = line.fromBin.id === line.toBin.id;
        return sameBin ? 0 : line.fromBin.id === rackId ? -line.baseQuantity : line.baseQuantity;
    }
    // For adjustments, the quantity difference on the line item can be used to see how much existing inventory was used
    if (type === "Adjustment") return line.baseQuantityDiff;
    // If this is a non-inventory item, try to allocate some of the quantity from purchases first
    // Note that we also need to check no bin is assigned because the build record could have been created before the item
    // was changed to non-inventory, in which case we treat it as a regular inventory item
    const toInventory = type === "Build Output";
    if (!line.bin && line.item.type === "Non-inventory Item") {
        // Allocate purchased quantity first
        const availablePurchasedQuantity = nonInventoryPurchaseQuantities.get(line.item.id) ?? 0;
        const purchasedQuantityUsedForLine = Math.min(availablePurchasedQuantity, line.baseQuantity);
        nonInventoryPurchaseQuantities.set(line.item.id, availablePurchasedQuantity - purchasedQuantityUsedForLine);
        // The remaining quantity is taken from existing inventory
        const inventoryQuantity = line.baseQuantity - purchasedQuantityUsedForLine;
        return toInventory ? -inventoryQuantity : inventoryQuantity;
    }
    // For shipments, the quantity of existing inventory used for a given line is:
    // - 0 if there is no source bin (i.e. non-inventory items)
    // - 0 if job id and source bin both DO match this order (i.e. normal shipment for this SO)
    // - 0 if job id and source bin both DO NOT match this order (i.e. normal shipment for a different SO)
    // - The positive quantity on the line item if job matches, but the source bin does not (i.e. we took something from stock and shipped it for this job)
    // - The negative quantity on the line item if the bin matches, but the job does not (i.e. we took something from this SO rack and shipped it for a different job)
    if (type === "Shipment") {
        if (!line.bin) return 0;
        const binMatches = line.bin.id === rackId;
        const jobMatches = line.job?.id === jobId;
        if (binMatches && jobMatches) return 0;
        if (!binMatches && !jobMatches) return 0;
        return jobMatches ? line.baseQuantity : -line.baseQuantity;
    }
    // For build inputs/outputs, the quantity of existing inventory used for a given line is:
    //
    // - 0 if there is no source/destination bin (i.e. non-inventory items)
    // - 0 if the source/destination bin is the sales order rack
    // - the positive quantity for builds inputs
    // - the negative quantity for build outputs
    //
    // NOTE: This does not handle the case where a build input is taken from this SO rack and used as a build input for a
    // different job. This does not generally happen because we ensure items are available on the SO rack before work
    // orders are created.
    return !line.bin ? 0 : line.bin.id === rackId ? 0 : type === "Build Input" ? line.baseQuantity : -line.baseQuantity;
};
class $5358e52d581e377f$export$52586f11829e4479 {
    unallocatedStockByItemId;
    constructor(existingInventory){
        this.unallocatedStockByItemId = new Map(existingInventory.map((x)=>[
                x.item.id,
                x.quantity.balance
            ]));
    }
    /**
   * Attempts to use existing inventory for a given item ID and up to the specified quantity. The map of existing
   * inventory quantities is updated to reflect the amount used. The value returned is the amount used from existing
   * inventory.
   */ tryAllocate(itemId, quantity) {
        if (!this.unallocatedStockByItemId.has(itemId)) return 0;
        const existingInventory = this.unallocatedStockByItemId.get(itemId);
        const usedInventory = Math.min(existingInventory, quantity);
        this.unallocatedStockByItemId.set(itemId, existingInventory - usedInventory);
        return usedInventory;
    }
}


const $62e16125ac3b96f9$var$zeroQuantities = {
    bomTotalQuantity: 0,
    existingInventoryQuantity: 0,
    nonInventoryQuantity: 0,
    quantityRequiredForJob: 0
};
const $62e16125ac3b96f9$var$zeroQuantitiesByPriority = new Map((0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>[
        priority,
        $62e16125ac3b96f9$var$zeroQuantities
    ]));
function $62e16125ac3b96f9$export$2952bc636db38024(salesOrderBomHierarchy, existingInventory) {
    // Simulate the parent quantities as 1 unit, not pulled from existing inventory, since this is the top-level of the BOM
    const parentQuantities = {
        bomTotalQuantity: 1,
        existingInventoryQuantity: 0,
        nonInventoryQuantity: 1,
        quantityRequiredForJob: 1
    };
    // Create a map of existing inventory allocators, one for each priority option
    const existingInventoryAllocators = new Map((0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>[
            priority,
            new (0, $5358e52d581e377f$export$52586f11829e4479)(existingInventory)
        ]));
    return $62e16125ac3b96f9$var$groupBomByComponent(salesOrderBomHierarchy, existingInventoryAllocators, parentQuantities, true);
}
function $62e16125ac3b96f9$export$259c7696b7a7491e(salesOrderComponents, itemsNotOnSalesOrderBomRecords, purchasingPriorities) {
    // Create a map of dummy existing inventory allocators that never allocate anything. We don't need to allocate existing
    // inventory to items not on the sales order
    const dummyAllocator = new (0, $5358e52d581e377f$export$52586f11829e4479)([]);
    const dummyAllocators = new Map((0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>[
            priority,
            dummyAllocator
        ]));
    // Create a second list of components based on items not found on the sales order; these are items found on various
    // records assigned to the job, but are not part of the BOM derived from the sales order line items
    // NOTE: Only the top-level nodes are included in this part of the BOM; children are only used to calculate costs
    // NOTE: This step is performed because the total quantity for all these components is zero, but we don't want to
    // filter them out; they are useful to include because they represent the 'actual' BOM
    const supplementaryHierarchy = new (0, $522415699e9e4669$export$8331bd18d884bb15)(purchasingPriorities).generate(itemsNotOnSalesOrderBomRecords).map((node)=>({
            ...node,
            children: []
        }));
    const supplementaryComponents = $62e16125ac3b96f9$var$groupBomByComponent(supplementaryHierarchy, dummyAllocators, $62e16125ac3b96f9$var$zeroQuantities, false);
    // Combine both lists of components, items not on the sales order are sorted to the end of the list
    return [
        ...salesOrderComponents,
        ...supplementaryComponents
    ];
}
function $62e16125ac3b96f9$var$groupBomByComponent(bomHierarchy, existingInventoryAllocators, parentMaxQuantities, onSalesOrder) {
    // Flatten the BOM hierarchy into a list of BOM components, one component per node
    // This list will contain duplicates of items that appear in multiple places in the BOM hierarchy
    const flattenedNodes = bomHierarchy.flatMap((node)=>{
        const { item: item, isAssembly: isAssembly, unitCost: unitCost, children: children } = node;
        // Calculate the quantities for this node at each priority level
        const quantitiesByPriority = new Map((0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>[
                priority,
                $62e16125ac3b96f9$var$calculateQuantitiesForPriority(node, priority, parentMaxQuantities, existingInventoryAllocators.get(priority))
            ]));
        const parentRecord = {
            item: item,
            isAssembly: isAssembly,
            unitCost: unitCost,
            onSalesOrder: onSalesOrder,
            quantitiesByPriority: quantitiesByPriority,
            ...$62e16125ac3b96f9$var$zeroQuantities
        };
        const childRecords = $62e16125ac3b96f9$var$groupBomByComponent(children, existingInventoryAllocators, quantitiesByPriority.get((0, $ccba93d7976774da$export$cc3cd71de886be2d)), onSalesOrder);
        return [
            parentRecord,
            ...childRecords
        ];
    });
    // Group the flattened nodes by item ID, then reduce the groups into a single entry for each item
    // Sort the entries before returning by item type (descending) and item name (ascending)
    return Object.values((0, (/*@__PURE__*/$parcel$interopDefault($4ff36ccfbdb107da$exports)))(flattenedNodes, (x)=>x.item.id)).map((groupNodes)=>{
        const quantitiesByPriority = groupNodes.reduce((acc, x)=>$62e16125ac3b96f9$var$addQuantitiesByPriority(acc, x.quantitiesByPriority), $62e16125ac3b96f9$var$zeroQuantitiesByPriority);
        return {
            ...groupNodes[0],
            quantitiesByPriority: quantitiesByPriority,
            ...quantitiesByPriority.get((0, $ccba93d7976774da$export$cc3cd71de886be2d))
        };
    }).sort((a, b)=>b.item.type.localeCompare(a.item.type) || a.item.name.localeCompare(b.item.name));
}
function $62e16125ac3b96f9$var$calculateQuantitiesForPriority(node, priority, parentMaxQuantities, existingInventoryAllocator) {
    // Return a zero result if the node's priority is higher (numerically) than the current priority
    if (node.purchasingPriority.priority > priority) return $62e16125ac3b96f9$var$zeroQuantities;
    // Calculate the total quantity as found on the BOM
    const bomLineQuantity = node.quantity;
    const bomTotalQuantity = parentMaxQuantities.bomTotalQuantity * bomLineQuantity;
    // Calculate the total quantity required for the job by multiplying the current node's quantity by the parent's non-inventory quantity
    // By using the parent's non-inventory quantity instead of the total quantity, we ensure that if a parent assembly
    // is pulled from existing inventory, the child components will also have their required quantity reduced accordingly
    const quantityRequiredForJob = parentMaxQuantities.nonInventoryQuantity * bomLineQuantity;
    // Calculate the amount to use from existing inventory; Make sure to subtract any allocated inventory from the existing inventory map
    const existingInventoryQuantity = existingInventoryAllocator.tryAllocate(node.item.id, quantityRequiredForJob);
    // The non-inventory quantity is the total quantity minus the existing inventory quantity
    const nonInventoryQuantity = quantityRequiredForJob - existingInventoryQuantity;
    return {
        bomTotalQuantity: bomTotalQuantity,
        quantityRequiredForJob: quantityRequiredForJob,
        existingInventoryQuantity: existingInventoryQuantity,
        nonInventoryQuantity: nonInventoryQuantity
    };
}
function $62e16125ac3b96f9$var$addQuantitiesByPriority(a, b) {
    return new Map((0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>[
            priority,
            $62e16125ac3b96f9$var$addQuantitiesForPriority(a.get(priority), b.get(priority))
        ]));
}
function $62e16125ac3b96f9$var$addQuantitiesForPriority(a, b) {
    return {
        bomTotalQuantity: a.bomTotalQuantity + b.bomTotalQuantity,
        existingInventoryQuantity: a.existingInventoryQuantity + b.existingInventoryQuantity,
        nonInventoryQuantity: a.nonInventoryQuantity + b.nonInventoryQuantity,
        quantityRequiredForJob: a.quantityRequiredForJob + b.quantityRequiredForJob
    };
}


var $4c19424296e35099$exports = {};


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $4c19424296e35099$var$uniqBy(array, iteratee) {
    return array && array.length ? $dd76581ca64cfaee$exports(array, $c2bfe06b6383bbdf$exports(iteratee, 2)) : [];
}
$4c19424296e35099$exports = $4c19424296e35099$var$uniqBy;





const $8d6862cbf2c18fc2$var$builtLineItemSelect = `
  id,
  lineNumber,
  description,
  item:Item!inner(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
  uomQuantity:quantity,
  itemUOM:ItemUOM(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
  bin:Bin(id, number),
  job:Job(id, name)
`;
const $8d6862cbf2c18fc2$var$buildSelect = `
id,
number,
date,
job:Job(id, name),
workCenter:Workcenter(id, name),
comment,
archived,
inputs:BuildInputLineItem(
  ${$8d6862cbf2c18fc2$var$builtLineItemSelect},
  notes
),
outputs:BuildOutputLineItem!inner(
  ${$8d6862cbf2c18fc2$var$builtLineItemSelect},
  linkedWorkOrderLineItem:WorkOrderLineItem(
    quantity,
    workOrder:WorkOrder(id, number)
  )
)
`;
async function $8d6862cbf2c18fc2$export$d6895b88e7d9798e({ id: jobId, name: jobName }, CADCurrencyConverter) {
    // Fetch non-deleted builds from SOS that have the job assigned on the build itself or the output line item
    const getBaseQuery = ()=>(0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Build").select($8d6862cbf2c18fc2$var$buildSelect).eq("deleted", false).eq("inputs.deleted", false).eq("outputs.deleted", false).order("date", {
            ascending: false
        }).order("lineNumber", {
            referencedTable: "inputs",
            ascending: true
        }).order("lineNumber", {
            referencedTable: "outputs",
            ascending: true
        }).throwOnError();
    const [buildsByJobId, buildsByOutputJobId] = await Promise.all([
        getBaseQuery().eq("jobId", jobId).then((x)=>x.data ?? []),
        getBaseQuery().eq("outputs.jobId", jobId).then((x)=>x.data ?? [])
    ]);
    const queryResult = (0, (/*@__PURE__*/$parcel$interopDefault($4c19424296e35099$exports)))([
        ...buildsByJobId,
        ...buildsByOutputJobId
    ], (build)=>build.id).sort((a, b)=>b.date.localeCompare(a.date));
    // For each build, validate that all job assignments are either null, or match the job ID
    queryResult.forEach((build)=>{
        // Validate output
        const output = build.outputs[0];
        if (!output) throw new Error(`Build ${build.number} has no output line item`);
        // Validate build job
        const buildJob = build.job;
        if (buildJob?.id && buildJob.id !== jobId) throw new Error(`Build ${build.number} is assigned to job ${buildJob.name}, but the output is assigned to ${jobName}`);
        // Validate output job
        const outputJob = output.job;
        if (outputJob?.id && outputJob.id !== jobId) throw new Error(`Build ${build.number} is assigned to job ${jobName}, but the output is assigned to job ${outputJob.name}`);
        // Validate input jobs
        build.inputs.forEach((input)=>{
            const inputJob = input.job;
            if (inputJob?.id && inputJob.id !== jobId) throw new Error(`Build ${build.number} input #${input.lineNumber.toFixed()} assigned to job ${inputJob.name}, but the build is assigned to job ${jobName}`);
        });
    });
    // Fail-fast if any of the builds have created using the 'Produce All' button in SOS. This feature in SOS is broken
    // and should not be used. We have gone through the painful process of fixing these once already and do not want to
    // facilitate them in any way.
    const brokenBuilds = queryResult.filter((build)=>build.inputs.every((x)=>x.lineNumber === 0)).map((x)=>x.number).join(", ");
    if (brokenBuilds.length) throw new Error(`The following builds have been created using the broken 'Produce All' button in SOS need to be fixed or re-created: ${brokenBuilds}`);
    // Do some additional client-side processing on the results before returning
    return queryResult.map((build)=>$8d6862cbf2c18fc2$var$processBuild(build, CADCurrencyConverter));
}
function $8d6862cbf2c18fc2$var$processBuild({ inputs: inputs, outputs: outputs, ...build }, CADCurrencyConverter) {
    return {
        ...build,
        inputs: inputs.map((line)=>$8d6862cbf2c18fc2$var$processBuildLineItem(line, CADCurrencyConverter)),
        outputs: outputs.map((line)=>$8d6862cbf2c18fc2$var$processBuildLineItem(line, CADCurrencyConverter)),
        linkedWOs: (0, (/*@__PURE__*/$parcel$interopDefault($4c19424296e35099$exports)))(outputs.map((line)=>line.linkedWorkOrderLineItem?.workOrder).filter((x)=>!!x), (x)=>x.id)
    };
}
function $8d6862cbf2c18fc2$var$processBuildLineItem(line, CADCurrencyConverter) {
    return {
        ...line,
        item: (0, $6d50882dcfab2b28$export$62232a46d0543a40)(line.item, CADCurrencyConverter),
        baseQuantity: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomQuantity, line.itemUOM),
        linkedWO: line.linkedWorkOrderLineItem?.workOrder
    };
}



// NOTE: This is set to the default value in Supabase, but can be changed
const $28e64e211b363b26$var$PAGINATION_SIZE = 1000;
async function $28e64e211b363b26$export$2b5d1eb7d1255b79(table, select, queryBuilderCallback) {
    // Get the first page; count the total number of records
    queryBuilderCallback ??= (x)=>x;
    const firstPageBaseQuery = (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from(table).select(select, {
        count: "exact"
    }).range(0, $28e64e211b363b26$var$PAGINATION_SIZE - 1);
    const firstPageQuery = queryBuilderCallback(firstPageBaseQuery);
    const firstPageResponse = await firstPageQuery.throwOnError();
    const allData = firstPageResponse.data;
    // Get the total count
    const count = firstPageResponse.count;
    if (count === null) throw new Error("Count was not returned in the first page of data. Ensure the 'count' option is set correctly in the select() options");
    // Return early if there are no more pages
    if (count <= $28e64e211b363b26$var$PAGINATION_SIZE) return allData;
    // Fetch the remaining pages
    const numPages = Math.ceil(count / $28e64e211b363b26$var$PAGINATION_SIZE);
    for(let pageIndex = 1; pageIndex < numPages; pageIndex++){
        const rangeStart = pageIndex * $28e64e211b363b26$var$PAGINATION_SIZE;
        const rangeEnd = rangeStart + $28e64e211b363b26$var$PAGINATION_SIZE - 1;
        const pageBaseQuery = (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from(table).select(select).range(rangeStart, rangeEnd);
        const pageQuery = queryBuilderCallback(pageBaseQuery);
        const pageData = (await pageQuery.throwOnError()).data;
        allData.push(...pageData);
    }
    return allData;
}



async function $bc8b83dd69accca9$export$8b1b5d5ff9e1cff2() {
    // Fetch the latest exchange rate using the Bank of Canada's API
    const response = await fetch("https://www.bankofcanada.ca/valet/observations/group/FX_RATES_DAILY/json?recent=1&order_dir=desc");
    // Validate response code
    if (!response.ok) {
        const responseCode = response.status.toFixed();
        const responseText = await response.text();
        throw new Error(`Request for exchange rates failed with status code ${responseCode}: ${responseText}`);
    }
    // Get a list of exchange rate keys in the returned data
    const exchangeRateResponse = await response.json();
    const fxObservation = exchangeRateResponse.observations[0];
    if (!fxObservation) throw new Error("No exchange rate data found in response");
    const rateKeys = Object.keys(fxObservation).filter((x)=>typeof x === "string" && x !== "d" && x.startsWith("FX") && x.endsWith("CAD"));
    // Get a list of exchange rates
    // NOTE: Use the inverse of the exchange rate provided by the BoC API in order to match how exchange rates are represented in SOS (i.e. on purchase orders)
    const rates = rateKeys.map((key)=>{
        const countryCode = key.substring(2, key.length - 3);
        const exchangeRate = 1 / fxObservation[key].v;
        return {
            countryCode: countryCode,
            exchangeRate: exchangeRate
        };
    });
    // Return a mapping of the country code to the associated exchange rate
    return new Map(rates.map((x)=>[
            x.countryCode,
            x.exchangeRate
        ]));
}
async function $bc8b83dd69accca9$export$8ca924d13649910f(exchangeRates) {
    // Fetch all currencies from supabase
    const supabaseCurrencies = await (0, $28e64e211b363b26$export$2b5d1eb7d1255b79)("Currency");
    // Merge the exchange rates with the currencies to create currency objects that match SOS
    const currencies = supabaseCurrencies.map((currency)=>{
        const exchangeRate = currency.code === "CAD" ? 1 : exchangeRates.get(currency.code);
        return {
            ...currency,
            exchangeRate: exchangeRate
        };
    });
    return new Map(currencies.map((x)=>[
            x.id,
            x
        ]));
}
function $bc8b83dd69accca9$export$fd948ec30cc2749e(currencies) {
    const rates = Object.fromEntries(Array.from(currencies.values()).map((currency)=>[
            currency.code,
            currency.exchangeRate
        ]));
    return (0, $bb09d99f2c0a98ec$export$afdfcbdba94169b7)(rates);
}
















function $24d8d0166a2f98e7$export$57d06620b9c2690f(lines, currencyCode, exchangeRate, jobId, CADCurrencyConverter) {
    // Get all the lines for the specified job
    const linesForJob = lines.filter((x)=>x.job?.id === jobId);
    // Process each line
    const jobLines = linesForJob.map((line)=>$24d8d0166a2f98e7$export$bc860c44d361e8de(line, currencyCode, exchangeRate, CADCurrencyConverter));
    // Perform summary calculations on the lines
    const jobLinesSummary = $24d8d0166a2f98e7$export$fd28b8820508e2fd(jobLines);
    return {
        jobLines: jobLines,
        jobLinesSummary: jobLinesSummary
    };
}
function $24d8d0166a2f98e7$export$bc860c44d361e8de({ item: item, unitprice: unitprice, amount: amount, ...line }, currencyCode, exchangeRate, CADCurrencyConverter) {
    const costCategory = $24d8d0166a2f98e7$export$6c8b37d35fca77ca(item);
    const taxCode = line.taxCode;
    const unitPriceCad = (0, $bb09d99f2c0a98ec$export$e5d48fa21b54da3e)(unitprice, currencyCode, exchangeRate);
    const unitCost = new (0, $f2faaafdab540e00$export$72b98bde8fc72fd9)({
        subtotal: unitPriceCad,
        taxCode: taxCode
    });
    const amountCad = (0, $bb09d99f2c0a98ec$export$e5d48fa21b54da3e)(amount, currencyCode, exchangeRate);
    const totalCost = new (0, $f2faaafdab540e00$export$72b98bde8fc72fd9)({
        subtotal: amountCad,
        taxCode: taxCode
    });
    return {
        ...line,
        item: (0, $6d50882dcfab2b28$export$62232a46d0543a40)(item, CADCurrencyConverter),
        costCategory: costCategory,
        unitCost: unitCost,
        totalCost: totalCost
    };
}
function $24d8d0166a2f98e7$export$fd28b8820508e2fd(lines) {
    // Iterate through the line items to create sums for each cost category
    const categorizedCosts = lines.reduce((sums, line)=>{
        const lineCategory = line.costCategory;
        sums[lineCategory] = sums[lineCategory].add("jobAmountCad" in line ? line.jobAmountCad : line.totalCost);
        return sums;
    }, {
        material: (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO,
        nonMaterial: (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO,
        shipping: (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO
    });
    // Perform some additional summary calculations
    const cost = Object.values(categorizedCosts).reduce((sum, x)=>sum.add(x), (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO);
    return {
        categorizedCosts: categorizedCosts,
        cost: cost
    };
}
function $24d8d0166a2f98e7$export$6c8b37d35fca77ca(item) {
    if (item.id === 775) return "shipping";
    return (0, $2b3a7af3658dfb79$export$3b6db6d9ae78dca4)(item.type) ? "material" : "nonMaterial";
}



const $3438a94627ad1b7c$var$itemReceiptSelect = `
  *,
  vendor:Vendor!inner(${(0, $2b48e978c222bd17$export$87cca2e53773fd2a)}),
  currency:Currency!inner(code),
  customFieldValues:ItemReceiptCustomFieldValue(*),
  lines:ItemReceiptLineItem!inner(
    id,
    lineNumber,
    description,
    unitprice,
    amount,
    uomQuantity:quantity,
    itemUOM:ItemUOM!ItemReceiptLineItem_itemId_uomId_fkey(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
    item:Item!inner(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
    taxCode:TaxCode!taxCodeId(id,name,purchaseTaxRate),
    bin:Bin(id,number),
    job:Job(id, name),
    linkedPurchaseOrderLineItem:PurchaseOrderLineItem(
      purchaseOrder:PurchaseOrder!inner(id, number)
    )
  ),
  receivingCosts:ReceivingCost(
    *,
    item:Item!inner(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
    vendor:Vendor(${(0, $2b48e978c222bd17$export$87cca2e53773fd2a)})
  )
`;
async function $3438a94627ad1b7c$export$b983d579e2ae38e1(jobId, CADCurrencyConverter, todayExchangeRates) {
    // Fine all non-deleted item receipts that have a line item linked to the job
    const jobMatchingReceiptIdsResponse = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("ItemReceiptLineItem").select("itemReceiptId").eq("jobId", jobId).eq("deleted", false).throwOnError();
    const jobMatchingReceiptIds = (0, (/*@__PURE__*/$parcel$interopDefault($b56b586d52151131$exports)))(jobMatchingReceiptIdsResponse.data.map((x)=>x.itemReceiptId));
    // Fetch all non-deleted item receipts matching the ids
    const queryResult = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("ItemReceipt").select($3438a94627ad1b7c$var$itemReceiptSelect).in("id", jobMatchingReceiptIds).eq("deleted", false).eq("lines.deleted", false).eq("receivingCosts.deleted", false).order("date", {
        ascending: false
    }).order("lineNumber", {
        referencedTable: "lines",
        ascending: true
    }).order("lineNumber", {
        referencedTable: "receivingCosts",
        ascending: true
    }).throwOnError();
    // Process all the receipts before returning
    return queryResult.data.map((receipt)=>$3438a94627ad1b7c$var$processItemReceipt(receipt, jobId, CADCurrencyConverter, todayExchangeRates));
}
function $3438a94627ad1b7c$var$processItemReceipt({ lines: allLines, receivingCosts: receivingCosts, ...receipt }, jobId, cadCurrencyConverter, todayExchangeRates) {
    const vendorReceiptNum = (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(receipt, "vendorReceiptNum");
    // Process the line items; Do some common processing first, then continue doing some additional processing specific to item receipts
    const currencyCode = (0, $bb09d99f2c0a98ec$export$6ade6d89a215534c)(receipt.currency.code);
    const { jobLines: preProcessedJobLines, jobLinesSummary: jobLinesSummary } = (0, $24d8d0166a2f98e7$export$57d06620b9c2690f)(allLines, currencyCode, receipt.exchangeRate, jobId, cadCurrencyConverter);
    const jobLines = preProcessedJobLines.map((x)=>$3438a94627ad1b7c$var$processItemReceiptLineItem(x));
    // Get a list of all linked POs from the processed line items
    const linkedPos = (0, (/*@__PURE__*/$parcel$interopDefault($4c19424296e35099$exports)))(jobLines.map((line)=>line.linkedPo).filter((x)=>!!x), (x)=>x.id);
    // Process the receiving costs
    const numJobs = (0, (/*@__PURE__*/$parcel$interopDefault($b56b586d52151131$exports)))(allLines.filter((x)=>!!x.job?.id).map((x)=>x.job.id)).length;
    const receivingCostsJobPercent = 1 / numJobs;
    const jobReceivingCosts = receivingCosts.map((x)=>$3438a94627ad1b7c$var$processReceivingCost(x, receipt, numJobs, todayExchangeRates));
    return {
        ...receipt,
        vendorReceiptNum: vendorReceiptNum,
        allLines: allLines,
        jobLines: jobLines,
        jobLinesSummary: jobLinesSummary,
        linkedPos: linkedPos,
        receivingCostsJobPercent: receivingCostsJobPercent,
        jobReceivingCosts: jobReceivingCosts
    };
}
function $3438a94627ad1b7c$var$processItemReceiptLineItem(line) {
    return {
        ...line,
        baseQuantity: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomQuantity, line.itemUOM),
        linkedPo: line.linkedPurchaseOrderLineItem?.purchaseOrder
    };
}
function $3438a94627ad1b7c$var$processReceivingCost(cost, receipt, numJobs, todayExchangeRates) {
    const costCategory = (0, $24d8d0166a2f98e7$export$6c8b37d35fca77ca)(cost.item);
    // Calculate the receiving cost in CAD with tax
    const amountCad = $3438a94627ad1b7c$var$getReceivingCostAmount(cost, receipt, todayExchangeRates);
    // Calculate the portion of the cost allocated to the current job
    const jobAmountCad = amountCad.allocate([
        1,
        numJobs - 1
    ])[0];
    return {
        ...cost,
        costCategory: costCategory,
        jobAmountCad: jobAmountCad
    };
}
/**
 * Calculate the receiving cost in CAD with tax. This assumes that the cost entered into SOS is after-tax amount in the
 * vendor's local currency.
 */ function $3438a94627ad1b7c$var$getReceivingCostAmount(cost, receipt, todayExchangeRates) {
    // Return an error amount if no vendor is specified on the cost
    if (!cost.vendor) return (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).withError("No vendor specified");
    // Return an error if the vendor has no currency
    if (!cost.vendor.currency) return (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).withError(`Vendor '${cost.vendor.name}' has no currency`);
    // Decide on the exchange rate to use. If the cost vendor's currency matches the item receipt vendor's currency, use
    // the exchange rate saved on the item receipt. Otherwise, use the exchange rate for the vendor on the current date.
    // TODO: We should fall back to the vendor's exchange rate on the day the item receipt was created, not the current date.
    const costCurrencyCode = (0, $bb09d99f2c0a98ec$export$6ade6d89a215534c)(cost.vendor.currency.code);
    const receiptCurrencyCode = receipt.vendor.currency?.code;
    const exchangeRate = costCurrencyCode === receiptCurrencyCode ? receipt.exchangeRate : todayExchangeRates.get(costCurrencyCode) ?? (0, $be8f6f33925d422b$export$a2d8f355a4dba7ae)(`No exchange rate found for '${cost.vendor.name}' vendor currency '${costCurrencyCode}'`);
    // Create a CAD dinero object from the cost amount, converting from the vendor's currency
    const costAmountCad = (0, $bb09d99f2c0a98ec$export$e5d48fa21b54da3e)(cost.amount, costCurrencyCode, exchangeRate);
    // Create the full tax breakdown. The tax code from the item is used, falling back to the vendor's tax code if necessary
    // TODO: We may need to revisit this, it's not clear whether the amount entered on item receipts includes tax or not. It may not actually be consistent at all
    return (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).forItemAndVendor({
        item: cost.item,
        vendor: cost.vendor,
        total: costAmountCad
    });
}



function $4c9c51f5113cbed2$export$356bfe123864f1b9(salesOrderBomRecords, purchaseOrders, jobItemReceipts, workOrders, builds, shipments, transfers, adjustments) {
    // Get a list of all items assigned to the job that are not part of the sales order BOM
    const salesOrderItemsById = salesOrderBomRecords.itemsById;
    const itemsNotOnSalesOrder = [
        ...purchaseOrders.flatMap((po)=>$4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord("purchaseorder", po, po.jobLines, salesOrderItemsById)),
        ...jobItemReceipts.flatMap((receipt)=>[
                ...$4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord("itemreceipt", receipt, receipt.jobLines, salesOrderItemsById),
                ...$4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord("itemreceipt", receipt, receipt.jobReceivingCosts, salesOrderItemsById)
            ]),
        ...workOrders.flatMap((wo)=>$4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord("workorder", wo, wo.jobLines, salesOrderItemsById)),
        ...builds.flatMap((build)=>{
            const lines = [
                ...build.inputs,
                ...build.outputs
            ];
            return $4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord("build", build, lines, salesOrderItemsById);
        }),
        ...shipments.flatMap((shipment)=>$4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord("shipment", shipment, shipment.jobLines, salesOrderItemsById)),
        ...transfers.flatMap((transfer)=>$4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord("transfer", transfer, transfer.salesOrderRackLines, salesOrderItemsById)),
        ...adjustments.flatMap((adjustment)=>$4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord("adjustment", adjustment, adjustment.salesOrderRackLines, salesOrderItemsById))
    ];
    // Group the list by unique item id before returning; Also make sure to remove any duplicates from the sources (i.e.
    // if the same item appears on multiple lines in the same record)
    return Array.from(Map.groupBy(itemsNotOnSalesOrder, (x)=>x.item.id).values()).map((group)=>({
            item: group[0].item,
            sources: (0, (/*@__PURE__*/$parcel$interopDefault($4c19424296e35099$exports)))(group.map((x)=>x.source), (x)=>x.type + x.id.toFixed())
        }));
}
/**
 * Get all items for the provided record and line items that are assigned to the current job, but cannot be found on the
 * expanded BOM derived from the sales order line items.
 *
 * @param recordType - The type of the record (e.g. "purchaseorder", "itemreceipt", etc.)
 * @param record - The record object
 * @param jobLines - The line items from the record that are associated with the current job (i.e. relevant for the current sales order tracker context).
 * @param salesOrderItemsById - A map of items by ID that are part of the sales order BOM, used to filter out items that are already included in the sales order.
 */ const $4c9c51f5113cbed2$var$getItemsNotOnSalesOrderForRecord = (recordType, record, jobLines, salesOrderItemsById)=>{
    return jobLines.map((x)=>x.item).filter((itemRef)=>!salesOrderItemsById.has(itemRef.id)).map((itemRef)=>({
            source: {
                type: recordType,
                id: record.id,
                name: record.number
            },
            item: itemRef
        }));
};











const $49073331c0a11d1b$var$purchaseOrderSelect = `
*,
vendor:Vendor!inner(${(0, $2b48e978c222bd17$export$87cca2e53773fd2a)}),
currency:Currency!inner(code),
lines:PurchaseOrderLineItem!inner(
  id,
  lineNumber,
  description,
  unitprice,
  amount,
  uomQuantity:quantity,
  itemUOM:ItemUOM!PurchaseOrderLineItem_itemId_uomId_fkey(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
  item:Item!inner(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
  taxCode:TaxCode!taxCodeId(id,name,purchaseTaxRate),
  job:Job(id, name),
  linkedItemReceiptLineItems:ItemReceiptLineItem(
    uomQuantity:quantity,
    itemUOM:ItemUOM!ItemReceiptLineItem_itemId_uomId_fkey(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
    itemReceipt:ItemReceipt!inner(id, number)
  )
)
`;
async function $49073331c0a11d1b$export$bdac7b25323009f9(jobId, itemReceipts, CADCurrencyConverter) {
    // Get all PO ids based on non-deleted PO line items assigned to the job
    const jobMatchingPOIdsResponse = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("PurchaseOrderLineItem").select("purchaseOrderId").eq("deleted", false).eq("jobId", jobId).throwOnError();
    const jobMatchingPOIds = jobMatchingPOIdsResponse.data.map((x)=>x.purchaseOrderId);
    // Get all PO ids based on linked item receipt line items assigned to the job
    const jobMatchingReceiptLines = itemReceipts.flatMap((x)=>x.jobLines);
    const receiptMatchingPoIds = jobMatchingReceiptLines.filter((x)=>x.linkedPurchaseOrderLineItem).map((x)=>x.linkedPurchaseOrderLineItem.purchaseOrder.id);
    // Get the POs from Supabase
    const allMatchingPOIds = (0, (/*@__PURE__*/$parcel$interopDefault($b56b586d52151131$exports)))([
        ...jobMatchingPOIds,
        ...receiptMatchingPoIds
    ]);
    const queryResult = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("PurchaseOrder").select($49073331c0a11d1b$var$purchaseOrderSelect).in("id", allMatchingPOIds).eq("deleted", false).eq("lines.deleted", false).order("date", {
        ascending: false
    }).order("lineNumber", {
        referencedTable: "lines",
        ascending: true
    }).throwOnError()).data;
    // Do some additional client-side processing on the results before returning
    return queryResult.map((po)=>$49073331c0a11d1b$var$processPo(po, jobId, CADCurrencyConverter));
}
function $49073331c0a11d1b$var$processPo({ lines: allLines, ...po }, jobId, CADCurrencyConverter) {
    // Process the line items; Do some common processing first, then continue doing some additional processing specific to POs
    const currencyCode = (0, $bb09d99f2c0a98ec$export$6ade6d89a215534c)(po.currency.code);
    const { jobLines: preProcessedJobLines, jobLinesSummary: jobLinesSummary } = (0, $24d8d0166a2f98e7$export$57d06620b9c2690f)(allLines, currencyCode, po.exchangeRate, jobId, CADCurrencyConverter);
    const jobLines = preProcessedJobLines.map((line)=>$49073331c0a11d1b$var$processPoLineItem(line));
    // Get all linked receipts for the PO (for the current job only)
    const linkedReceipts = (0, (/*@__PURE__*/$parcel$interopDefault($4c19424296e35099$exports)))(jobLines.flatMap((line)=>line.linkedLineReceipts), (x)=>x.id);
    // Count the number of job line items that have been fully received
    const receivedJobLines = jobLines.filter((x)=>x.uomReceived === x.uomQuantity).length;
    return {
        ...po,
        starEmoji: (0, $2b3a7af3658dfb79$export$4c873d4168351350)(po.starred),
        linkedReceipts: linkedReceipts,
        allLines: allLines,
        jobLines: jobLines,
        jobLinesSummary: jobLinesSummary,
        receivedJobLines: receivedJobLines
    };
}
function $49073331c0a11d1b$var$processPoLineItem(poLine) {
    // Calculate the total received quantity for the line item (convert to the UOM units selected in PO)
    // NOTE: This value is also available directly from the SOS API, but we cannot use it because our sync process to supabase
    // is not able to keep it up to date so it is not included in Supabase
    const uomReceived = poLine.linkedItemReceiptLineItems.reduce((sum, receiptLine)=>sum + (0, $6ce3d2cdf1f3fab7$export$e4a8ee74edd711fe)(receiptLine.uomQuantity, receiptLine.itemUOM, poLine.itemUOM), 0);
    // Calculate the base quantity based on the UOM
    const baseQuantity = (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(poLine.uomQuantity, poLine.itemUOM);
    // Get all linked receipts for the current line item
    const linkedLineReceipts = (0, (/*@__PURE__*/$parcel$interopDefault($4c19424296e35099$exports)))(poLine.linkedItemReceiptLineItems.filter((x)=>x.uomQuantity).map((x)=>x.itemReceipt), (x)=>x.id);
    return {
        ...poLine,
        baseQuantity: baseQuantity,
        uomReceived: uomReceived,
        linkedLineReceipts: linkedLineReceipts
    };
}


var $8d8dec79ea041689$exports = {};

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $8d8dec79ea041689$var$partition = $982da38d3ecbe5d0$exports(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
$8d8dec79ea041689$exports = $8d8dec79ea041689$var$partition;



async function $df9fe021f00c5dd5$export$15335a870ecd6a5b() {
    return $df9fe021f00c5dd5$var$getPurchasingPriorities(null);
}
async function $df9fe021f00c5dd5$export$9835181312a5cec2(jobId) {
    return $df9fe021f00c5dd5$var$getPurchasingPriorities(jobId);
}
async function $df9fe021f00c5dd5$var$getPurchasingPriorities(jobId) {
    // Fetch all purchasing priorities for the sales order (if a job id was specified), and the template priorities (jobId=null)
    const allPriorities = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("BomPathPurchasingPriority").select("*").or(`${jobId ? `jobId.eq.${jobId.toFixed(0)},` : ""}jobId.is.null`).order("path", {
        ascending: true
    }).throwOnError()).data.map($df9fe021f00c5dd5$export$2d807f90eef064d3);
    // Partition the priorities into sales order-specific and template priorities before returning
    const [templatePriorities, salesOrderPriorities] = (0, (/*@__PURE__*/$parcel$interopDefault($8d8dec79ea041689$exports)))(allPriorities, (x)=>x.jobId === null);
    return {
        templatePriorities: templatePriorities,
        salesOrderPriorities: salesOrderPriorities
    };
}
function $df9fe021f00c5dd5$export$2d807f90eef064d3(record) {
    const pathSegments = record.path.split(",").map((segmentString)=>parseInt(segmentString, 10));
    return {
        ...record,
        pathSegments: pathSegments,
        targetItemId: pathSegments[pathSegments.length - 1],
        priority: record.priority
    };
}



function $6fa1653f0f32fe1f$export$857664281ca25fd8(bomRecordsForSalesOrder, purchasingPriorities) {
    return new (0, $522415699e9e4669$export$8331bd18d884bb15)(purchasingPriorities).generate(bomRecordsForSalesOrder);
}



async function $a6aaccd8ec28e334$export$1834384e3717436a(job) {
    const sentiLocationId = 3;
    const expectedBinName = `Order Rack (${job.number})`;
    const salesOrderRack = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Bin").select("id,number,description").eq("locationId", sentiLocationId).like("number", expectedBinName + "%") // NOTE: Use a wildcard to match the bin name because it could have a ` (deleted)` suffix
    .maybeSingle().throwOnError()).data;
    if (!salesOrderRack) throw new Error(`Failed to find a bin with name '${expectedBinName}' at the 'Senti Solutions Inc.' location. This bin will need to be created manually in SOS before this page can be loaded.`);
    return salesOrderRack;
}





const $5fca9cfd508c0b83$var$salesOrderSelect = `
  id,
  number,
  customer:Customer!inner(id,name),
  lines:SalesOrderLineItem!inner(
    id,
    lineNumber,
    item:Item!inner(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
    description,
    uomQuantity:quantity,
    itemUOM:ItemUOM(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
    job:Job(id, name)
  )
`;
async function $5fca9cfd508c0b83$export$60afb83cda9cbf7a(job, CADCurrencyConverter) {
    const salesOrderNumber = job.number;
    const salesOrder = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("SalesOrder").select($5fca9cfd508c0b83$var$salesOrderSelect).eq("number", salesOrderNumber).eq("deleted", false).eq("lines.deleted", false).throwOnError().limit(1).maybeSingle()).data;
    if (!salesOrder) throw new Error(`Failed to find a sales order with number ${salesOrderNumber}`);
    return $5fca9cfd508c0b83$var$processSalesOrder(salesOrder, job.id, CADCurrencyConverter);
}
function $5fca9cfd508c0b83$var$processSalesOrder({ lines: rawLines, ...salesOrder }, jobId, CADCurrencyConverter) {
    const allLines = rawLines.map((x)=>$5fca9cfd508c0b83$var$processSalesOrderLineItem(x, CADCurrencyConverter)).sort((a, b)=>a.lineNumber - b.lineNumber);
    const jobLines = allLines.filter((x)=>x.job?.id === jobId);
    return {
        ...salesOrder,
        allLines: allLines,
        jobLines: jobLines
    };
}
function $5fca9cfd508c0b83$var$processSalesOrderLineItem(line, CADCurrencyConverter) {
    return {
        ...line,
        baseQuantity: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomQuantity, line.itemUOM),
        item: (0, $6d50882dcfab2b28$export$62232a46d0543a40)(line.item, CADCurrencyConverter)
    };
}





const $a0b63b8c74972f85$var$shipmentSelect = `
id,
number,
date,
shippingMethod:ShipMethod(id, name),
trackingNumber,
trackingLink,
comment,
lines:ShipmentLineItem!inner(
  id,
  lineNumber,
  item:Item(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
  job:Job(id, name),
  description,
  uomQuantity:quantity,
  itemUOM:ItemUOM(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
  bin:Bin(id, number)
)
`;
async function $a0b63b8c74972f85$export$79ad783d83778419(jobId, binId, CADCurrencyConverter) {
    // Get all shipment ids with any non-deleted line item either assigned to the job, or the sales order rack bin
    const shipmentIds = new Set((await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("ShipmentLineItem").select("shipmentId").eq("deleted", false).or(`binId.eq.${binId.toFixed()},jobId.eq.${jobId.toFixed()}`).throwOnError()).data.map((x)=>x.shipmentId));
    // Get all non-deleted shipments with the matched shipment ids
    const queryResult = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Shipment").select($a0b63b8c74972f85$var$shipmentSelect).in("id", [
        ...shipmentIds
    ]).eq("deleted", false).eq("lines.deleted", false).order("date", {
        ascending: false
    }).order("lineNumber", {
        referencedTable: "lines",
        ascending: true
    }).throwOnError()).data;
    // Do some additional client-side processing on the results before returning
    return queryResult.map((po)=>$a0b63b8c74972f85$var$processShipment(po, jobId, CADCurrencyConverter));
}
function $a0b63b8c74972f85$var$processShipment({ lines: rawLines, ...shipment }, jobId, CADCurrencyConverter) {
    const allLines = rawLines.map((line)=>$a0b63b8c74972f85$var$processShipmentLineItem(line, CADCurrencyConverter));
    const jobLines = allLines.filter((x)=>x.job?.id === jobId);
    return {
        ...shipment,
        allLines: allLines,
        jobLines: jobLines
    };
}
function $a0b63b8c74972f85$var$processShipmentLineItem(line, CADCurrencyConverter) {
    return {
        ...line,
        baseQuantity: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomQuantity, line.itemUOM),
        item: (0, $6d50882dcfab2b28$export$62232a46d0543a40)(line.item, CADCurrencyConverter)
    };
}





const $58cd30f5e9c2e7ad$var$transferSelect = `
id,
number,
date,
comment,
lines:TransferLineItem!inner(
  id,
  lineNumber,
  item:Item(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
  job:Job(id, name),
  description,
  uomQuantity:quantity,
  itemUOM:ItemUOM(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
  fromBin:Bin!TransferLineItem_fromBinId_fkey(id, number),
  toBin:Bin!TransferLineItem_toBinId_fkey(id, number)
)
`;
async function $58cd30f5e9c2e7ad$export$5cbdbc3239a7c906(binId, CADCurrencyConverter) {
    // Get all transfer ids with any non-deleted line item to or from the sales order rack bin
    const transferIds = new Set((await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("TransferLineItem").select("transferId").eq("deleted", false).or(`fromBinId.eq.${binId.toFixed()},toBinId.eq.${binId.toFixed()}`).throwOnError()).data.map((x)=>x.transferId));
    // Get all non-deleted transfers with the matched transfer ids
    const queryResult = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Transfer").select($58cd30f5e9c2e7ad$var$transferSelect).in("id", [
        ...transferIds
    ]).eq("deleted", false).eq("lines.deleted", false).order("date", {
        ascending: false
    }).order("lineNumber", {
        referencedTable: "lines",
        ascending: true
    }).throwOnError()).data;
    // Do some additional client-side processing on the results before returning
    return queryResult.map((po)=>$58cd30f5e9c2e7ad$var$processTransfer(po, binId, CADCurrencyConverter));
}
function $58cd30f5e9c2e7ad$var$processTransfer({ lines: rawLines, ...transfer }, binId, CADCurrencyConverter) {
    const allLines = rawLines.map((line)=>$58cd30f5e9c2e7ad$var$processTransferLineItem(line, CADCurrencyConverter));
    const salesOrderRackLines = allLines.filter((x)=>x.fromBin?.id === binId || x.toBin?.id === binId);
    return {
        ...transfer,
        allLines: allLines,
        salesOrderRackLines: salesOrderRackLines
    };
}
function $58cd30f5e9c2e7ad$var$processTransferLineItem(line, CADCurrencyConverter) {
    return {
        ...line,
        baseQuantity: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomQuantity, line.itemUOM),
        item: (0, $6d50882dcfab2b28$export$62232a46d0543a40)(line.item, CADCurrencyConverter)
    };
}






const $8716b92390f4a284$var$workOrderSelect = `
id,
number,
date,
comment,
closed,
archived,
lines:WorkOrderLineItem!inner(
  id,
  lineNumber,
  item:Item!inner(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
  description,
  uomQuantity:quantity,
  itemUOM:ItemUOM!WorkOrderLineItem_itemId_uomId_fkey(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
  produced,
  duedate,
  job:Job(id, name),
  linkedBuildOutputLineItems:BuildOutputLineItem(
    quantity,
    build:Build!inner(id, number)
  )
)
`;
async function $8716b92390f4a284$export$32e670a3d234d234(jobId, CADCurrencyConverter) {
    // Get all WO ids based on non-deleted WO line items assigned to the job
    const jobMatchingWOIdsResponse = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("WorkOrderLineItem").select("workOrderId").eq("jobId", jobId).eq("deleted", false).throwOnError();
    const jobMatchingWOIds = jobMatchingWOIdsResponse.data.map((x)=>x.workOrderId);
    // Get the non-deleted WOs matching the returned ids
    const queryResult = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("WorkOrder").select($8716b92390f4a284$var$workOrderSelect).in("id", jobMatchingWOIds).eq("deleted", false).eq("lines.deleted", false).order("date", {
        ascending: false
    }).order("lineNumber", {
        referencedTable: "lines",
        ascending: true
    }).throwOnError()).data;
    // Do some additional client-side processing on the results before returning
    return queryResult.map((wo)=>$8716b92390f4a284$var$processWo(wo, jobId, CADCurrencyConverter));
}
function $8716b92390f4a284$var$processWo({ lines: allLines, ...wo }, jobId, CADCurrencyConverter) {
    // Get the job lines and process them
    const jobLines = allLines.filter((x)=>x.job?.id === jobId).map((line)=>$8716b92390f4a284$var$processWoLineItem(line, CADCurrencyConverter));
    // Get all linked builds for the WO (for the current job only)
    const linkedBuilds = (0, (/*@__PURE__*/$parcel$interopDefault($4c19424296e35099$exports)))(jobLines.flatMap((line)=>line.linkedBuilds), (x)=>x.id);
    // Count the number of job line items that have been fully produced
    const receivedJobLines = jobLines.filter((x)=>x.produced === x.uomQuantity).length;
    // Return the processed work order
    return {
        ...wo,
        receivedJobLines: receivedJobLines,
        jobLines: jobLines,
        allLines: allLines,
        linkedBuilds: linkedBuilds
    };
}
function $8716b92390f4a284$var$processWoLineItem(line, CADCurrencyConverter) {
    return {
        ...line,
        item: (0, $6d50882dcfab2b28$export$62232a46d0543a40)(line.item, CADCurrencyConverter),
        baseQuantity: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomQuantity, line.itemUOM),
        linkedBuilds: line.linkedBuildOutputLineItems.map((x)=>x.build)
    };
}








async function $7a0f43b91323161f$export$7e6c2cf210afcbef(rpcName, params) {
    const allData = [];
    let pageOffset = 0;
    const pageLimit = params.pageLimit ?? 1000;
    while(true){
        // Fetch the current page
        const rpcParams = {
            ...params,
            pageLimit: pageLimit,
            pageOffset: pageOffset
        };
        const response = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).rpc(rpcName, rpcParams).throwOnError()).data;
        // Add the data to the results
        const responseData = response.data;
        allData.push(...responseData);
        // Exit if this is the last page
        if (responseData.length < pageLimit) break;
        if (allData.length >= response.count) break;
        // Increment the offset for the next page
        pageOffset += pageLimit;
    }
    return allData;
}


async function $9683b24540f03969$export$fdab0f9c6843bab1(parents, cadCurrencyConverter) {
    // Do nothing if no parents were specified
    if (!parents.length) return {
        parents: parents,
        bomRecordsByParentPath: {},
        itemsById: new Map()
    };
    // Fetch BOM records for all assemblies
    const assemblyIds = (0, (/*@__PURE__*/$parcel$interopDefault($b56b586d52151131$exports)))(parents.filter((x)=>x.item.type === "Assembly").map((x)=>x.item.id));
    const supabaseBomRecords = await (0, $7a0f43b91323161f$export$7e6c2cf210afcbef)("getExpandedBOMHierarchy", {
        assemblyIds: assemblyIds
    });
    console.info(`Fetched ${supabaseBomRecords.length.toFixed()} expanded BOM records for ${assemblyIds.length.toFixed()} assemblies from ${parents.length.toFixed()} parent line items`);
    // Fetch item records for all items in the BOM
    const parentIds = new Set(parents.map((x)=>x.item.id));
    const componentIds = (0, (/*@__PURE__*/$parcel$interopDefault($b56b586d52151131$exports)))(supabaseBomRecords.map((x)=>x.componentId)).filter((id)=>!parentIds.has(id));
    console.info(`Fetching ${componentIds.length.toFixed()} BOM component item records`);
    const rawComponents = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Item").select((0, $6d50882dcfab2b28$export$6bcff91a197a7380)).in("id", componentIds).throwOnError()).data;
    const components = rawComponents.map((x)=>(0, $6d50882dcfab2b28$export$62232a46d0543a40)(x, cadCurrencyConverter));
    const allItems = parents.map((x)=>x.item).concat(components);
    const itemsById = new Map(allItems.map((x)=>[
            x.id,
            x
        ]));
    // Add item details to each BOM record
    const bomRecords = supabaseBomRecords.map((record)=>({
            ...record,
            item: itemsById.get(record.componentId) ?? (0, $be8f6f33925d422b$export$a2d8f355a4dba7ae)(`Component with ID ${record.componentId.toFixed()} not found while expanding BOM`)
        }));
    // Group the BOM records by path
    const bomRecordsByParentPath = (0, (/*@__PURE__*/$parcel$interopDefault($4ff36ccfbdb107da$exports)))(bomRecords, (x)=>x.path.join(","));
    return {
        parents: parents,
        bomRecordsByParentPath: bomRecordsByParentPath,
        itemsById: itemsById
    };
}


async function $ab9b65019b74910a$export$63f9889eb1e95585(job) {
    const graph = $ab9b65019b74910a$var$getJobTrackingGraph(job);
    return {
        job: job,
        ...await graph.runAll()
    };
}
async function $ab9b65019b74910a$export$f81979825eb6953d({ job: job, ...old }, invalidatedStepNames, precomputedResults) {
    const graph = $ab9b65019b74910a$var$getJobTrackingGraph(job);
    return {
        job: job,
        ...await graph.runIncremental(old, invalidatedStepNames, precomputedResults)
    };
}
function $ab9b65019b74910a$var$getJobTrackingGraph(job) {
    const graph = new (0, $9d013be4fbfc710e$export$538aafe006ec6bcf)();
    graph.define("salesOrderRackBin", [], ()=>(0, $a6aaccd8ec28e334$export$1834384e3717436a)(job));
    graph.define("exchangeRates", [], ()=>(0, $bc8b83dd69accca9$export$8b1b5d5ff9e1cff2)());
    graph.define("purchasingPriorities", [], ()=>(0, $df9fe021f00c5dd5$export$9835181312a5cec2)(job.id));
    graph.define("currencies", [
        "exchangeRates"
    ], ({ exchangeRates: exchangeRates })=>(0, $bc8b83dd69accca9$export$8ca924d13649910f)(exchangeRates));
    graph.define("CADCurrencyConverter", [
        "currencies"
    ], ({ currencies: currencies })=>(0, $bc8b83dd69accca9$export$fd948ec30cc2749e)(currencies));
    graph.define("salesOrder", [
        "CADCurrencyConverter"
    ], ({ CADCurrencyConverter: CADCurrencyConverter })=>(0, $5fca9cfd508c0b83$export$60afb83cda9cbf7a)(job, CADCurrencyConverter));
    graph.define("salesOrderBomRecords", [
        "salesOrder",
        "CADCurrencyConverter"
    ], ({ salesOrder: salesOrder, CADCurrencyConverter: CADCurrencyConverter })=>(0, $9683b24540f03969$export$fdab0f9c6843bab1)(salesOrder.jobLines.map(({ item: item, baseQuantity: quantity })=>({
                item: item,
                quantity: quantity
            })), CADCurrencyConverter));
    graph.define("transfers", [
        "salesOrderRackBin",
        "CADCurrencyConverter"
    ], ({ salesOrderRackBin: salesOrderRackBin, CADCurrencyConverter: CADCurrencyConverter })=>(0, $58cd30f5e9c2e7ad$export$5cbdbc3239a7c906)(salesOrderRackBin.id, CADCurrencyConverter));
    graph.define("adjustments", [
        "salesOrderRackBin",
        "CADCurrencyConverter"
    ], ({ salesOrderRackBin: salesOrderRackBin, CADCurrencyConverter: CADCurrencyConverter })=>(0, $83b619531aea1976$export$c09013399ecf8503)(salesOrderRackBin.id, CADCurrencyConverter));
    graph.define("itemReceipts", [
        "CADCurrencyConverter",
        "exchangeRates"
    ], ({ CADCurrencyConverter: CADCurrencyConverter, exchangeRates: exchangeRates })=>(0, $3438a94627ad1b7c$export$b983d579e2ae38e1)(job.id, CADCurrencyConverter, exchangeRates));
    graph.define("builds", [
        "CADCurrencyConverter"
    ], ({ CADCurrencyConverter: CADCurrencyConverter })=>(0, $8d6862cbf2c18fc2$export$d6895b88e7d9798e)(job, CADCurrencyConverter));
    graph.define("shipments", [
        "salesOrderRackBin",
        "CADCurrencyConverter"
    ], ({ salesOrderRackBin: salesOrderRackBin, CADCurrencyConverter: CADCurrencyConverter })=>(0, $a0b63b8c74972f85$export$79ad783d83778419)(job.id, salesOrderRackBin.id, CADCurrencyConverter));
    graph.define("existingInventory", [
        "salesOrderRackBin",
        "transfers",
        "adjustments",
        "builds",
        "shipments",
        "itemReceipts"
    ], ({ salesOrderRackBin: salesOrderRackBin, transfers: transfers, adjustments: adjustments, builds: builds, shipments: shipments, itemReceipts: itemReceipts })=>(0, $5358e52d581e377f$export$dfc163bfbf6fa863)(job.id, salesOrderRackBin, transfers, adjustments, builds, shipments, itemReceipts));
    graph.define("existingInventoryByItemId", [
        "existingInventory"
    ], ({ existingInventory: existingInventory })=>new Map(existingInventory.map((x)=>[
                x.item.id,
                x
            ])));
    graph.define("purchaseOrders", [
        "itemReceipts",
        "CADCurrencyConverter"
    ], ({ itemReceipts: itemReceipts, CADCurrencyConverter: CADCurrencyConverter })=>(0, $49073331c0a11d1b$export$bdac7b25323009f9)(job.id, itemReceipts, CADCurrencyConverter));
    graph.define("workOrders", [
        "CADCurrencyConverter"
    ], ({ CADCurrencyConverter: CADCurrencyConverter })=>(0, $8716b92390f4a284$export$32e670a3d234d234)(job.id, CADCurrencyConverter));
    graph.define("itemsNotOnSalesOrder", [
        "salesOrderBomRecords",
        "purchaseOrders",
        "itemReceipts",
        "workOrders",
        "builds",
        "shipments",
        "transfers",
        "adjustments"
    ], (deps)=>(0, $4c9c51f5113cbed2$export$356bfe123864f1b9)(deps.salesOrderBomRecords, deps.purchaseOrders, deps.itemReceipts, deps.workOrders, deps.builds, deps.shipments, deps.transfers, deps.adjustments));
    graph.define("itemsNotOnSalesOrderBomRecords", [
        "itemsNotOnSalesOrder",
        "CADCurrencyConverter"
    ], async ({ itemsNotOnSalesOrder: itemsNotOnSalesOrder, CADCurrencyConverter: CADCurrencyConverter })=>(0, $9683b24540f03969$export$fdab0f9c6843bab1)(itemsNotOnSalesOrder.map(({ item: item })=>({
                item: item,
                quantity: 0
            })), CADCurrencyConverter));
    graph.define("salesOrderBomHierarchy", [
        "salesOrderBomRecords",
        "purchasingPriorities"
    ], ({ salesOrderBomRecords: salesOrderBomRecords, purchasingPriorities: purchasingPriorities })=>(0, $6fa1653f0f32fe1f$export$857664281ca25fd8)(salesOrderBomRecords, purchasingPriorities));
    graph.define("salesOrderBomComponents", [
        "salesOrderBomHierarchy",
        "existingInventory"
    ], ({ salesOrderBomHierarchy: salesOrderBomHierarchy, existingInventory: existingInventory })=>(0, $62e16125ac3b96f9$export$2952bc636db38024)(salesOrderBomHierarchy, existingInventory));
    graph.define("bomComponents", [
        "salesOrderBomComponents",
        "itemsNotOnSalesOrderBomRecords",
        "purchasingPriorities"
    ], (deps)=>(0, $62e16125ac3b96f9$export$259c7696b7a7491e)(deps.salesOrderBomComponents, deps.itemsNotOnSalesOrderBomRecords, deps.purchasingPriorities));
    graph.define("bomComponentsByItemId", [
        "bomComponents"
    ], ({ bomComponents: bomComponents })=>new Map(bomComponents.map((x)=>[
                x.item.id,
                x
            ])));
    return graph;
}




function $4f97e0b25d4f91a2$export$3f39a7b61f1136ac(jobNumber) {
    return [
        "JobTracking",
        jobNumber
    ];
}
const $4f97e0b25d4f91a2$export$f1c5549db2901e40 = (WrappedComponent)=>{
    // Inner component that receives job and P, injects trackingDataQuery
    const WithTrackingData = (props)=>{
        const { job: job, ...rest } = props;
        const trackingDataQuery = (0, $b262411d05d5989d$export$ad4afeb3151d80fa)({
            queryKey: $4f97e0b25d4f91a2$export$3f39a7b61f1136ac(job.number),
            queryFn: async ()=>await (0, $ab9b65019b74910a$export$63f9889eb1e95585)(job),
            retry: false
        });
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(WrappedComponent, {
            trackingDataQuery: trackingDataQuery,
            job: job,
            ...rest
        });
    };
    // Compose withJob, return a component that only accepts P
    const WithJobHOC = (0, $8080646ce18e3d87$export$839c859e3b3cdbd5)(WithTrackingData);
    const Result = (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(WithJobHOC, {
            ...props
        });
    Result.displayName = `withJobTrackingDataQuery(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
    return Result;
};
const $4f97e0b25d4f91a2$export$53cc986057983387 = (WrappedComponent)=>{
    // Inner component that receives trackingDataQuery and P, injects loaded data
    const WithLoadedTrackingData = (props)=>{
        const { trackingDataQuery: trackingDataQuery, ...rest } = props;
        if (trackingDataQuery.isError) throw trackingDataQuery.error;
        if (trackingDataQuery.isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d8ed0f693b57ae21$export$1afe2b5a93b67b3), {
            text: "Loading Job Data"
        });
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(WrappedComponent, {
            ...trackingDataQuery.data,
            ...rest
        });
    };
    // Compose withJobTrackingDataQuery, return a component that only accepts P
    const WithTrackingDataQueryHOC = $4f97e0b25d4f91a2$export$f1c5549db2901e40(WithLoadedTrackingData);
    const Result = (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(WithTrackingDataQueryHOC, {
            ...props
        });
    Result.displayName = `withJobTrackingData(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
    return Result;
};




const $5e4e43af2ec40d42$export$a33f39dd24777af9 = ({ line: { item: item, uomQuantity: uomQuantity, baseQuantity: baseQuantity, itemUOM: itemUOM } })=>{
    // If the line item does not have a UOM specified, show it without units
    if (!itemUOM) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
        quantity: uomQuantity
    });
    // If the line item has a UOM specified, but it is the base UOM, show it with units
    if (itemUOM.isBase) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
        quantity: uomQuantity,
        uom: itemUOM.uom
    });
    // Otherwise, show the quantity with the selected UOM units, and also using the base units in parentheses
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                quantity: uomQuantity,
                uom: itemUOM.uom
            }),
            " (",
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                quantity: baseQuantity,
                uom: item.baseItemUOM?.uom
            }),
            ")"
        ]
    });
};


const $a606775df21c1f96$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $a606775df21c1f96$var$columns = [
    $a606775df21c1f96$var$columnHelper.accessor("lineNumber", {
        header: "#",
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    row.original.wrongJob ? "\u26A0\uFE0F" : "",
                    getValue()
                ]
            })
    }),
    $a606775df21c1f96$var$columnHelper.accessor("item.name", {
        header: "Item",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: row.original.item.id,
                        label: row.original.item.name
                    })
            })
    }),
    $a606775df21c1f96$var$columnHelper.accessor("description", {
        header: "Description",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $32df95eb0ee5e5ca$export$d7888f4f62c79646), {
                line: row.original
            })
    }),
    $a606775df21c1f96$var$columnHelper.accessor("uomQuantity", {
        header: "Quantity",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5e4e43af2ec40d42$export$a33f39dd24777af9), {
                line: row.original
            })
    }),
    $a606775df21c1f96$var$columnHelper.accessor("job.name", {
        header: "Job",
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    row.original.wrongJob ? "\u26A0\uFE0F" : "",
                    getValue()
                ]
            })
    })
];
const $a606775df21c1f96$export$c8675b494fc9b301 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ job: job, salesOrder: salesOrder })=>{
    const evolvedOpportunityNumbers = [
        (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getNumberValue(job, "evolvedOpportunityNumber"),
        (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getNumberValue(job, "serviceEstimateOpportunityNumber")
    ].filter((x)=>!!x).map((x)=>`GNM#${x.toFixed()}`).join(", ");
    const orderDetails = [
        {
            label: "Job #",
            value: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "job",
                id: job.id,
                label: job.number
            })
        },
        {
            label: "Sales Order #",
            value: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "salesorder",
                id: salesOrder.id,
                label: salesOrder.number
            })
        },
        {
            label: "Evolved Opportunity #s",
            value: evolvedOpportunityNumbers
        },
        {
            label: "Date Opened",
            value: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getDateValue(job, "dateOpened")
            })
        },
        {
            label: "Date Closed",
            value: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getDateValue(job, "dateClosed"),
                nullishValue: "N/A"
            })
        },
        {
            label: "Customer",
            value: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "customer",
                id: salesOrder.customer.id,
                label: salesOrder.customer.name
            })
        },
        {
            label: "Model",
            value: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(job, "model")
        },
        {
            label: "Pressure System",
            value: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getBoolValue(job, "pressureSystem") ? "\u2705" : "\u274C"
        },
        {
            label: "Electrical Designer",
            value: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(job, "electricalDesigner") || "N/A"
        },
        {
            label: "Mechanical Designer",
            value: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(job, "mechanicalDesigner") || "N/A"
        }
    ];
    const lines = salesOrder.allLines.map((line)=>({
            ...line,
            wrongJob: line.job?.id !== job.id
        }));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dl", {
                className: "row",
                children: orderDetails.map(({ label: label, value: value }, index, array)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                        className: "col-12 col-md-6 col-lg-4 col-xl-3",
                        children: [
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dt", {
                                children: label
                            }),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dd", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))({
                                    "m-0": index === array.length - 1
                                }),
                                children: value
                            })
                        ]
                    }, label))
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("h3", {
                children: "Line Items"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                bordered: true,
                hover: true,
                columns: $a606775df21c1f96$var$columns,
                data: lines,
                initialState: {
                    sorting: [
                        {
                            id: "lineNumber",
                            desc: false
                        }
                    ]
                }
            })
        ]
    });
});





var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");



function $084d4bdf6569a5e3$export$3d03cefad97f5c33(propType) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).oneOfType([
        propType,
        (0, (/*@__PURE__*/$parcel$interopDefault($6df474e6792427b0$exports))).shape({
            xs: propType,
            sm: propType,
            md: propType,
            lg: propType,
            xl: propType,
            xxl: propType
        })
    ]);
}
function $084d4bdf6569a5e3$export$2e2bcd8739ae039(utilityValues, breakpoints = (0, $064b812fd356008a$export$666ad80b5007f835), minBreakpoint = (0, $064b812fd356008a$export$ff817e17bad2e091)) {
    const classes = [];
    Object.entries(utilityValues).forEach(([utilName, utilValue])=>{
        if (utilValue != null) {
            if (typeof utilValue === 'object') breakpoints.forEach((brkPoint)=>{
                const bpValue = utilValue[brkPoint];
                if (bpValue != null) {
                    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
                    classes.push(`${utilName}${infix}-${bpValue}`);
                }
            });
            else classes.push(`${utilName}-${utilValue}`);
        }
    });
    return classes;
}



"use client";
const $18d39a5a2e476fcb$var$Stack = /*#__PURE__*/ $itHdT.forwardRef(({ as: Component = 'div', bsPrefix: bsPrefix, className: className, direction: direction, gap: gap, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, direction === 'horizontal' ? 'hstack' : 'vstack');
    const breakpoints = (0, $064b812fd356008a$export$8970c8db816a5863)();
    const minBreakpoint = (0, $064b812fd356008a$export$d926d6ef38f3fd32)();
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix, ...(0, $084d4bdf6569a5e3$export$2e2bcd8739ae039)({
            gap: gap
        }, breakpoints, minBreakpoint))
    });
});
$18d39a5a2e476fcb$var$Stack.displayName = 'Stack';
var $18d39a5a2e476fcb$export$2e2bcd8739ae039 = $18d39a5a2e476fcb$var$Stack;






var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");



"use client";
const $36343242d7ebcdbb$var$CardBody = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$36343242d7ebcdbb$var$CardBody.displayName = 'CardBody';
var $36343242d7ebcdbb$export$2e2bcd8739ae039 = $36343242d7ebcdbb$var$CardBody;



var $itHdT = parcelRequire("itHdT");



"use client";
const $17123530030738f7$var$CardFooter = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$17123530030738f7$var$CardFooter.displayName = 'CardFooter';
var $17123530030738f7$export$2e2bcd8739ae039 = $17123530030738f7$var$CardFooter;




var $itHdT = parcelRequire("itHdT");



"use client";
const $f560df2117ee0767$var$CardHeader = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $itHdT.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $ac8a75a6a1b836ec$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, prefix)
        })
    });
});
$f560df2117ee0767$var$CardHeader.displayName = 'CardHeader';
var $f560df2117ee0767$export$2e2bcd8739ae039 = $f560df2117ee0767$var$CardHeader;




var $itHdT = parcelRequire("itHdT");


"use client";
const $77761db5ee671891$var$CardImg = /*#__PURE__*/ $itHdT.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$77761db5ee671891$var$CardImg.displayName = 'CardImg';
var $77761db5ee671891$export$2e2bcd8739ae039 = $77761db5ee671891$var$CardImg;



var $itHdT = parcelRequire("itHdT");



"use client";
const $74586bcdc1779cb7$var$CardImgOverlay = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$74586bcdc1779cb7$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $74586bcdc1779cb7$export$2e2bcd8739ae039 = $74586bcdc1779cb7$var$CardImgOverlay;



var $itHdT = parcelRequire("itHdT");



"use client";
const $3d4494e3119575b1$var$CardLink = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$3d4494e3119575b1$var$CardLink.displayName = 'CardLink';
var $3d4494e3119575b1$export$2e2bcd8739ae039 = $3d4494e3119575b1$var$CardLink;



var $itHdT = parcelRequire("itHdT");




"use client";
const $14399746c3a75f9d$var$DivStyledAsH6 = (0, $62e41ab67f5e63a5$export$2e2bcd8739ae039)('h6');
const $14399746c3a75f9d$var$CardSubtitle = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $14399746c3a75f9d$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$14399746c3a75f9d$var$CardSubtitle.displayName = 'CardSubtitle';
var $14399746c3a75f9d$export$2e2bcd8739ae039 = $14399746c3a75f9d$var$CardSubtitle;



var $itHdT = parcelRequire("itHdT");



"use client";
const $ec2baca8f642b44e$var$CardText = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$ec2baca8f642b44e$var$CardText.displayName = 'CardText';
var $ec2baca8f642b44e$export$2e2bcd8739ae039 = $ec2baca8f642b44e$var$CardText;



var $itHdT = parcelRequire("itHdT");




"use client";
const $9200ecae33d52884$var$DivStyledAsH5 = (0, $62e41ab67f5e63a5$export$2e2bcd8739ae039)('h5');
const $9200ecae33d52884$var$CardTitle = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $9200ecae33d52884$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$9200ecae33d52884$var$CardTitle.displayName = 'CardTitle';
var $9200ecae33d52884$export$2e2bcd8739ae039 = $9200ecae33d52884$var$CardTitle;



"use client";
const $6e86d1791657e77a$var$Card = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $36343242d7ebcdbb$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$6e86d1791657e77a$var$Card.displayName = 'Card';
var $6e86d1791657e77a$export$2e2bcd8739ae039 = Object.assign($6e86d1791657e77a$var$Card, {
    Img: (0, $77761db5ee671891$export$2e2bcd8739ae039),
    Title: (0, $9200ecae33d52884$export$2e2bcd8739ae039),
    Subtitle: (0, $14399746c3a75f9d$export$2e2bcd8739ae039),
    Body: (0, $36343242d7ebcdbb$export$2e2bcd8739ae039),
    Link: (0, $3d4494e3119575b1$export$2e2bcd8739ae039),
    Text: (0, $ec2baca8f642b44e$export$2e2bcd8739ae039),
    Header: (0, $f560df2117ee0767$export$2e2bcd8739ae039),
    Footer: (0, $17123530030738f7$export$2e2bcd8739ae039),
    ImgOverlay: (0, $74586bcdc1779cb7$export$2e2bcd8739ae039)
});


var $itHdT = parcelRequire("itHdT");



"use client";
const $e619582357491d22$var$CardGroup = /*#__PURE__*/ $itHdT.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'card-group');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        ...props
    });
});
$e619582357491d22$var$CardGroup.displayName = 'CardGroup';
var $e619582357491d22$export$2e2bcd8739ae039 = $e619582357491d22$var$CardGroup;




var $62d016101caeb43a$exports = {};
var $631df4c6f1731424$exports = {};

var $d90c8cca5762b02a$exports = {};



/** Built-in value references. */ var $d90c8cca5762b02a$var$spreadableSymbol = $a5e751c5a48e6fb1$exports ? $a5e751c5a48e6fb1$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d90c8cca5762b02a$var$isFlattenable(value) {
    return $f7463dbc77cf4722$exports(value) || $39469abbd59941a5$exports(value) || !!($d90c8cca5762b02a$var$spreadableSymbol && value && value[$d90c8cca5762b02a$var$spreadableSymbol]);
}
$d90c8cca5762b02a$exports = $d90c8cca5762b02a$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $631df4c6f1731424$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $d90c8cca5762b02a$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $631df4c6f1731424$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $a78674d0cd13d401$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$631df4c6f1731424$exports = $631df4c6f1731424$var$baseFlatten;


var $5fc3c90f9832e9dd$exports = {};



var $d57d451ecd1a20b1$exports = {};


/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d57d451ecd1a20b1$var$baseMap(collection, iteratee) {
    var index = -1, result = $e1ea3190b025ca72$exports(collection) ? Array(collection.length) : [];
    $61c558abc78dc56d$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$d57d451ecd1a20b1$exports = $d57d451ecd1a20b1$var$baseMap;


var $3d0ee5a3f0e161ca$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $3d0ee5a3f0e161ca$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$3d0ee5a3f0e161ca$exports = $3d0ee5a3f0e161ca$var$baseSortBy;



var $10e0c3779367f6a5$exports = {};
var $df8774cfb4d1e92d$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $df8774cfb4d1e92d$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $2190937dc50df275$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $2190937dc50df275$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$df8774cfb4d1e92d$exports = $df8774cfb4d1e92d$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $10e0c3779367f6a5$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $df8774cfb4d1e92d$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$10e0c3779367f6a5$exports = $10e0c3779367f6a5$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $5fc3c90f9832e9dd$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $7da3b9b0e02d149e$exports(iteratees, function(iteratee) {
        if ($f7463dbc77cf4722$exports(iteratee)) return function(value) {
            return $f8a171ab8c37ee14$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $1f65ff87e6363a01$exports
    ];
    var index = -1;
    iteratees = $7da3b9b0e02d149e$exports(iteratees, $75dd5453b04fc9f3$exports($c2bfe06b6383bbdf$exports));
    var result = $d57d451ecd1a20b1$exports(collection, function(value, key, collection) {
        var criteria = $7da3b9b0e02d149e$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $3d0ee5a3f0e161ca$exports(result, function(object, other) {
        return $10e0c3779367f6a5$exports(object, other, orders);
    });
}
$5fc3c90f9832e9dd$exports = $5fc3c90f9832e9dd$var$baseOrderBy;




/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $62d016101caeb43a$var$sortBy = $af0bfff8b42a9ac6$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $51500238064a120b$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $51500238064a120b$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $5fc3c90f9832e9dd$exports(collection, $631df4c6f1731424$exports(iteratees, 1), []);
});
$62d016101caeb43a$exports = $62d016101caeb43a$var$sortBy;


/** Determines the sort order for item types */ const $b0109774a8e2d22e$var$sortIndexForType = {
    "Inventory Item": 0,
    Assembly: 1,
    Other: 2,
    Overhead: 3,
    Service: 4,
    Expense: 5,
    "Non-inventory Item": 6,
    Labor: NaN,
    Category: NaN,
    "Item Group": NaN
};
function $b0109774a8e2d22e$export$4ba9c7a995823fdf(bomComponents, itemReceipts, purchaseOrders, salesOrderRack) {
    // Group the line items by item ID for faster lookup
    const poLinesByItemId = Map.groupBy(purchaseOrders.flatMap((po)=>po.jobLines.filter((line)=>!!line.uomQuantity).map((line)=>({
                ...line,
                po: po
            }))), (line)=>line.item.id);
    const receiptLinesByItemid = Map.groupBy(itemReceipts.flatMap((receipt)=>receipt.jobLines.filter((line)=>!!line.uomQuantity).map((line)=>({
                ...line,
                receipt: receipt
            }))), (line)=>line.item.id);
    // Filter the BOM components to only those that need to be purchased, or are not on the BOM but have been purchased or
    // received for this current job anyway
    const relevantComponents = bomComponents.filter((x)=>$b0109774a8e2d22e$export$9f0bcf09d33e913a(x, poLinesByItemId, receiptLinesByItemid));
    // For each relevant component, create a PurchasingProgress record
    const purchasingProgressRecords = relevantComponents.map((component)=>{
        const item = component.item;
        const preferredVendorName = item.preferredVendor?.name;
        // Get a map of POs containing this item, and the quantity of that item on the PO
        const poLines = poLinesByItemId.get(item.id) || [];
        const linesByPo = Map.groupBy(poLines, (line)=>line.po);
        const quantitiesByPo = new Map([
            ...linesByPo.entries()
        ].map(([po, lines])=>[
                po,
                lines.reduce((sum, line)=>sum + line.uomQuantity, 0)
            ]));
        // Get a map of item receipts containing this item, and the quantity of that item on the receipt
        const receiptLines = receiptLinesByItemid.get(item.id) || [];
        const linesByReceipt = Map.groupBy(receiptLines, (line)=>line.receipt);
        const quantitiesByReceipt = new Map([
            ...linesByReceipt.entries()
        ].map(([receipt, lines])=>[
                receipt,
                lines.reduce((sum, line)=>sum + line.uomQuantity, 0)
            ]));
        const numOrdered = poLines.filter((x)=>x.po.starEmoji === "\uD83D\uDFE2").reduce((sum, line)=>sum + line.baseQuantity, 0);
        const numReceived = receiptLines.reduce((sum, line)=>sum + line.baseQuantity, 0);
        const numReceivedToSoRack = receiptLines.filter((x)=>x.bin?.id === salesOrderRack.id).reduce((sum, line)=>sum + line.baseQuantity, 0);
        return {
            component: component,
            sortIndexForType: $b0109774a8e2d22e$var$sortIndexForType[item.type],
            preferredVendorName: preferredVendorName,
            purchaseOrderLines: poLines,
            quantitiesByPo: quantitiesByPo,
            quantitiesByReceipt: quantitiesByReceipt,
            numOrdered: numOrdered,
            numReceived: numReceived,
            numReceivedToSoRack: numReceivedToSoRack
        };
    });
    // Sort first by type, then by preferred vendor, then by item name
    return (0, (/*@__PURE__*/$parcel$interopDefault($62d016101caeb43a$exports)))(purchasingProgressRecords, (x)=>x.sortIndexForType, (x)=>x.component.item.preferredVendor?.name, (x)=>x.component.item.name);
}
function $b0109774a8e2d22e$export$9f0bcf09d33e913a(bomItem, poLinesByItemId, receiptLinesByItemId) {
    // Labour is not purchased, it is used as part of in-house builds
    if (bomItem.item.type === "Labor") return false;
    // If the item is not on the sales order BOM, or is an assembly, it is only included if it can be found on a purchase order or item receipt
    // NOTE: Assemblies are not normally purchased. If we outsource their manufacturing, then the associated -CM item goes on the PO, not the assembly itself
    if (!bomItem.onSalesOrder || bomItem.isAssembly) return poLinesByItemId?.has(bomItem.item.id) || receiptLinesByItemId?.has(bomItem.item.id);
    // No need to purchase items that have zero quantity on the BOM
    // NOTE: Items that are fully being pulled from existing inventory will still show up, but this is helpful to the
    // purchaser to indicate why they don't need to purchase that part
    // NOTE: Items with zero quantity on the BOM appear in an error report to indicate that something is likely wrong
    if (bomItem.quantityRequiredForJob <= 0) return false;
    // TODO: -CM items are required to be purchased, but in some cases we may decide to build the associated assembly
    // in-house rather than outsourcing it. To support this use case, we need to check if the full quantity for the
    // associated assembly has already been issued on work orders or build. If yes, then we don't need to purchase the
    // -CM item. See: https://gitlab.com/senti-solutions/google-apps-scripts/-/issues/134
    // All tests passed, return true
    return true;
}







const $1630003de9d6d19f$export$92a44ac9c59126cf = ({ priority: priority })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
        className: "badge",
        style: {
            backgroundColor: (0, $ccba93d7976774da$export$39e251832c3f0c85)[priority],
            color: "var(--bs-dark)"
        },
        children: priority
    });
};


const $b5b1081e6a2f874a$export$822779f0626b1ee4 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ bomComponents: bomComponents })=>{
    const costsByPriority = (0, $itHdT.useMemo)(()=>$b5b1081e6a2f874a$var$calculateCostsByPriority(bomComponents), [
        bomComponents
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $e619582357491d22$export$2e2bcd8739ae039), {
        className: "text-nowrap",
        children: (0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($b5b1081e6a2f874a$var$PurchasingPriorityCostCard, {
                priority: priority,
                cost: costsByPriority[priority].cost,
                numComponents: costsByPriority[priority].numComponents
            }, priority))
    });
});
const $b5b1081e6a2f874a$var$PurchasingPriorityCostCard = ({ priority: priority, cost: cost, numComponents: numComponents })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6e86d1791657e77a$export$2e2bcd8739ae039), {
        className: "col-auto text-dark",
        style: {
            backgroundColor: (0, $ccba93d7976774da$export$39e251832c3f0c85)[priority],
            flexBasis: "auto"
        },
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6e86d1791657e77a$export$2e2bcd8739ae039).Body, {
            className: "py-0 px-2",
            children: cost.errors.length ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $41caf841eb1d8d0c$export$1e050932b91ba5cd), {
                cost: cost,
                title: "Failed To Calculate Priority Costs"
            }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                        ...props,
                        style: {
                            ...props.style,
                            "--bs-tooltip-max-width": "400px"
                        },
                        children: [
                            "Total purchasing cost for ",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("b", {
                                children: numComponents
                            }),
                            " items at priority",
                            " ",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1630003de9d6d19f$export$92a44ac9c59126cf), {
                                priority: priority
                            }),
                            ":",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                            (0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(cost.subtotal),
                            " + ",
                            (0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(cost.tax),
                            " tax = ",
                            (0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(cost.total),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("b", {
                                children: "NOTE:"
                            }),
                            " This estimate does not include any shipping costs"
                        ]
                    }),
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6e86d1791657e77a$export$2e2bcd8739ae039).Title, {
                    className: "d-inline",
                    children: (0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(cost.total)
                })
            })
        })
    }, priority);
};
function $b5b1081e6a2f874a$var$calculateCostsByPriority(bomComponents) {
    // Filter the BOM components to only those that need to be purchased
    const componentsToPurchase = bomComponents.filter((component)=>(0, $b0109774a8e2d22e$export$9f0bcf09d33e913a)(component));
    // Get a list of all components that will be purchased at each priority level
    const componentsByPriority = (0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>componentsToPurchase.filter((component)=>component.quantitiesByPriority.get(priority).nonInventoryQuantity));
    // Calculate the total costs for each priority option
    // This is a cumulative sum (i.e. stage 2 includes all the costs for stage 1)
    const totalCostsByPriority = (0, $ccba93d7976774da$export$426717e7f687ece8).map((priority, index)=>componentsByPriority[index].reduce((total, component)=>{
            const componentQuantity = component.quantitiesByPriority.get(priority).nonInventoryQuantity;
            const componentCost = component.unitCost.multiply(componentQuantity);
            return total.add(componentCost);
        }, (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO));
    // Calculate the total, non-cumulative, number of components and cost for each priority
    return Object.fromEntries((0, $ccba93d7976774da$export$426717e7f687ece8).map((priority, index)=>{
        const numComponents = index === 0 ? componentsByPriority[index].length : componentsByPriority[index].length - componentsByPriority[index - 1].length;
        const totalCost = totalCostsByPriority[index];
        const cost = index === 0 ? totalCost : totalCost.subtract(totalCostsByPriority[index - 1]);
        return [
            priority,
            {
                numComponents: numComponents,
                cost: cost
            }
        ];
    }));
}




var $itHdT = parcelRequire("itHdT");




const $51c8a12f6a1f52c0$export$ac7507aabb6c6a70 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ bomComponents: bomComponents })=>{
    const labourHoursByPriority = (0, $itHdT.useMemo)(()=>$51c8a12f6a1f52c0$var$calculateLabourByPriority(bomComponents), [
        bomComponents
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $e619582357491d22$export$2e2bcd8739ae039), {
        className: "text-nowrap",
        children: (0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($51c8a12f6a1f52c0$var$PurchasingPriorityLabourCard, {
                priority: priority,
                labourHours: labourHoursByPriority[priority].labourHours,
                numAssemblies: labourHoursByPriority[priority].numAssemblies
            }, priority))
    });
});
const $51c8a12f6a1f52c0$var$PurchasingPriorityLabourCard = ({ priority: priority, labourHours: labourHours, numAssemblies: numAssemblies })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6e86d1791657e77a$export$2e2bcd8739ae039), {
        className: "col-auto text-dark",
        style: {
            backgroundColor: (0, $ccba93d7976774da$export$39e251832c3f0c85)[priority],
            flexBasis: "auto"
        },
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6e86d1791657e77a$export$2e2bcd8739ae039).Body, {
            className: "py-0 px-2",
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                        ...props,
                        style: {
                            ...props.style,
                            "--bs-tooltip-max-width": "400px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("b", {
                                children: labourHours.toLocaleString(undefined, {
                                    maximumFractionDigits: 1
                                })
                            }),
                            " build hours for",
                            " ",
                            numAssemblies,
                            " assemblies at priority ",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1630003de9d6d19f$export$92a44ac9c59126cf), {
                                priority: priority
                            })
                        ]
                    }),
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $6e86d1791657e77a$export$2e2bcd8739ae039).Title, {
                    className: "d-inline",
                    children: [
                        labourHours.toLocaleString(undefined, {
                            maximumFractionDigits: 2
                        }),
                        " hours"
                    ]
                })
            })
        })
    }, priority);
};
function $51c8a12f6a1f52c0$var$calculateLabourByPriority(bomComponents) {
    // Filter the BOM components to only those that need to be purchased
    const labourComponents = bomComponents.filter((component)=>component.item.type === "Labor");
    // Get a list of all assemblies that will be built at each priority level
    const componentsToBuild = bomComponents.filter((component)=>component.item.type === "Assembly");
    const numAssembliesByPriority = (0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>componentsToBuild.filter((component)=>component.quantitiesByPriority.get(priority).nonInventoryQuantity).length);
    // Calculate the total labour hours for each priority option
    // This is a cumulative sum (i.e. stage 2 includes all the costs for stage 1)
    const totalLabourHoursByPriority = (0, $ccba93d7976774da$export$426717e7f687ece8).map((priority)=>labourComponents.reduce((total, component)=>total + component.quantitiesByPriority.get(priority).nonInventoryQuantity, 0));
    // Calculate the total, non-cumulative, number of hours and assemblies for each priority
    return Object.fromEntries((0, $ccba93d7976774da$export$426717e7f687ece8).map((priority, index)=>{
        const totalHours = totalLabourHoursByPriority[index];
        const labourHours = index === 0 ? totalHours : totalHours - totalLabourHoursByPriority[index - 1];
        const numAssemblies = index === 0 ? numAssembliesByPriority[index] : numAssembliesByPriority[index] - numAssembliesByPriority[index - 1];
        return [
            priority,
            {
                labourHours: labourHours,
                numAssemblies: numAssemblies
            }
        ];
    }));
}






var $itHdT = parcelRequire("itHdT");



const $cdf93fc3684ad5cf$export$5e8cf9fecce8187 = ({ children: children, showChildren: showChildren, toggleShowChildren: toggleShowChildren })=>{
    // Render nothing for items that do not support children
    if (!children) return null;
    // Render an un-clickable button for items that support children but do not have one
    if (!children.length) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            children: "No children found"
        }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
            variant: "link",
            className: "p-0",
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: "x-square",
                className: "text-muted"
            })
        })
    });
    // Otherwise, render a toggle button
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            children: showChildren ? "Hide Children" : "Show Children"
        }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
            variant: "link",
            className: "p-0 lh-1",
            onClick: children.length ? toggleShowChildren : undefined,
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: showChildren ? "dash-square" : "plus-square-fill"
            })
        })
    });
};






var $itHdT = parcelRequire("itHdT");

const $4220604e14789aa3$export$1d3fbcd96e8a5a25 = (props)=>{
    const textRef = (0, $itHdT.useRef)(null);
    const [isOverflowing, setIsOverflowing] = (0, $itHdT.useState)(false);
    // Callback function to update the overflowing state
    const checkOverflow = (0, $itHdT.useCallback)(()=>{
        if (!textRef.current) return;
        setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
    }, []);
    // Effect callback to check overflow on initial render and resize
    (0, $itHdT.useLayoutEffect)(()=>{
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return ()=>{
            window.removeEventListener("resize", checkOverflow);
        };
    }, [
        checkOverflow,
        props.children
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: isOverflowing ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            id: "text-tooltip",
            children: props.children
        }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {}),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
            ref: textRef,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("text-truncate", props.className)
        })
    });
};





var $itHdT = parcelRequire("itHdT");



var $itHdT = parcelRequire("itHdT");


const $f1efb1e28adccc66$export$bbb4a13c6e738029 = ({ mutation: mutation, className: className })=>{
    // Define a click handler to reset the mutation state (i.e. clear the current error)
    const handleClick = (0, $itHdT.useCallback)(()=>{
        mutation.reset();
    }, [
        mutation
    ]);
    // Display nothing if the mutation has no error
    if (!mutation.isError) return null;
    const tooltip = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
        style: {
            "--bs-tooltip-max-width": "300px"
        },
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
            className: "text-danger",
            children: [
                "ERROR: ",
                mutation.error.message
            ]
        })
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        placement: "top",
        overlay: tooltip,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
            variant: "link",
            onClick: handleClick,
            disabled: mutation.isPending,
            className: className,
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: "exclamation-triangle",
                className: "text-danger"
            })
        })
    });
};




var $itHdT = parcelRequire("itHdT");






// src/mutationObserver.ts
var $2697bf98b2792c98$var$_client = /* @__PURE__ */ new WeakMap();
var $2697bf98b2792c98$var$_currentResult = /* @__PURE__ */ new WeakMap();
var $2697bf98b2792c98$var$_currentMutation = /* @__PURE__ */ new WeakMap();
var $2697bf98b2792c98$var$_mutateOptions = /* @__PURE__ */ new WeakMap();
var $2697bf98b2792c98$var$_MutationObserver_brand = /* @__PURE__ */ new WeakSet();
/**
* Observes a single mutation and derives a `MutationObserverResult` from it.
* A framework hook like `useMutation` creates one `MutationObserver` per hook
* call, keeps it stable across re-renders, calls `setOptions` when the options
* passed to the hook change, subscribes to it to re-render on updates, and
* reads `getCurrentResult()` for the value to return. Calling `mutate()`
* builds a new underlying `Mutation` in the `MutationCache` and executes it.
* @example
* ```ts
* const observer = new MutationObserver(queryClient, {
*   mutationFn: (variables: { title: string }) => addPost(variables),
* })
* ```
*/ var $2697bf98b2792c98$export$d3c1860ee66f291a = class extends (0, $5cb24f678e609491$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $2f8b5ecae537244d$export$625550452a3fa3ec)(this, $2697bf98b2792c98$var$_MutationObserver_brand);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $2697bf98b2792c98$var$_client, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $2697bf98b2792c98$var$_currentResult, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $2697bf98b2792c98$var$_currentMutation, void 0);
        (0, $8abf3f80f32bda0d$export$23f2a1d2818174ef)(this, $2697bf98b2792c98$var$_mutateOptions, void 0);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($2697bf98b2792c98$var$_client, this, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($2697bf98b2792c98$var$_MutationObserver_brand, this, $2697bf98b2792c98$var$_updateResult).call(this);
    }
    /**
	* Binds the methods of the result (`mutate` and `reset`) to the observer, so they keep working when
	* destructured from it.
	*/ bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    /**
	* Updates the observer's options.
	*
	* If the new `mutationKey` differs from the previous one (and both were
	* defined), the observer is reset, detaching it from the mutation it was
	* observing. Otherwise, if the currently observed mutation is still
	* `pending`, its options are updated in place as well.
	* @param options - The new mutation observer options. They are defaulted with {@link
	* QueryClient#defaultMutationOptions} before being applied.
	* @example
	* ```ts
	* observer.setOptions({
	*   mutationFn: (variables: { title: string }) => addPost(variables),
	*   onSuccess: (data) => console.log(data),
	* })
	* ```
	*/ setOptions(options) {
        var _classPrivateFieldGet2$1;
        const prevOptions = this.options;
        this.options = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_client, this).defaultMutationOptions(options);
        if (!(0, $ee0a7c55ac205e24$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_client, this).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this),
            observer: this
        });
        if ((prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $ee0a7c55ac205e24$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $ee0a7c55ac205e24$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_classPrivateFieldGet2$1 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.state.status) === "pending") (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this).setOptions(this.options);
    }
    onSubscribe() {
        if (this.listeners.size === 1 && (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this)) {
            (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this).addObserver(this);
            (0, $8abf3f80f32bda0d$export$43caf9889c228507)($2697bf98b2792c98$var$_MutationObserver_brand, this, $2697bf98b2792c98$var$_updateResult).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _classPrivateFieldGet3;
            (_classPrivateFieldGet3 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.removeObserver(this);
        }
    }
    /**
	* Updates the observer's result when the observed mutation changes, and notifies its listeners.
	* @internal
	* @param action - The action that updated the observed mutation, passed on to the observer's
	* callbacks.
	*/ onMutationUpdate(action) {
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($2697bf98b2792c98$var$_MutationObserver_brand, this, $2697bf98b2792c98$var$_updateResult).call(this);
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($2697bf98b2792c98$var$_MutationObserver_brand, this, $2697bf98b2792c98$var$_notify).call(this, action);
    }
    /**
	* Returns the observer's current result, derived from the observed
	* mutation's state (or the default, `idle` state if no mutation has been
	* built yet, e.g. before the first `mutate()` call or after `reset()`).
	* @returns The observer's latest result.
	*/ getCurrentResult() {
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentResult, this);
    }
    /**
	* Detaches the observer from the mutation it is currently observing (if
	* any) and resets the observed result back to its default, `idle` state.
	*
	* This does not cancel an in-flight mutation; the mutation itself keeps
	* running to completion and its own callbacks still fire, but this
	* observer stops reflecting its state and a subsequent `mutate()` call
	* will build a brand new mutation.
	* @see {@link MutationObserver#mutate}
	* @example
	* ```ts
	* observer.reset()
	* ```
	*/ reset() {
        var _classPrivateFieldGet4;
        (_classPrivateFieldGet4 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.removeObserver(this);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($2697bf98b2792c98$var$_currentMutation, this, void 0);
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($2697bf98b2792c98$var$_MutationObserver_brand, this, $2697bf98b2792c98$var$_updateResult).call(this);
        (0, $8abf3f80f32bda0d$export$43caf9889c228507)($2697bf98b2792c98$var$_MutationObserver_brand, this, $2697bf98b2792c98$var$_notify).call(this);
    }
    /**
	* Builds a new `Mutation` in the `MutationCache` using the observer's
	* current options, detaches this observer from any previously observed
	* mutation, attaches it to the new one, and executes it with the given
	* variables.
	*
	* The optional per-call `options` (`onSuccess`/`onError`/`onSettled`) are
	* invoked once the mutation settles, in addition to any callbacks defined
	* on the observer's own options.
	* @param variables - The variables passed to the `mutationFn`.
	* @param options - Per-call `onSuccess`, `onError`, and `onSettled` callbacks.
	* @returns A promise that resolves with the mutation's data, or rejects with its error.
	* @example
	* ```ts
	* await observer.mutate(
	*   { title: 'New post' },
	*   { onSuccess: (data) => console.log(data) },
	* )
	* ```
	*/ mutate(variables, options) {
        var _classPrivateFieldGet5;
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($2697bf98b2792c98$var$_mutateOptions, this, options);
        (_classPrivateFieldGet5 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.removeObserver(this);
        (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($2697bf98b2792c98$var$_currentMutation, this, (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_client, this).getMutationCache().build((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_client, this), this.options));
        (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this).addObserver(this);
        return (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this).execute(variables);
    }
};
function $2697bf98b2792c98$var$_updateResult() {
    var _classPrivateFieldGet6;
    const state = ((_classPrivateFieldGet6 = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentMutation, this)) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.state) ?? (0, $00ec7d3e9aeca4ee$export$a1659b54bac3252a)();
    (0, $8abf3f80f32bda0d$export$625550452a3fa3ec)($2697bf98b2792c98$var$_currentResult, this, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
}
function $2697bf98b2792c98$var$_notify(action) {
    (0, $e62a61312d2d5e98$export$520687f44db6e1ab).batch(()=>{
        const mutateOptions = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_mutateOptions, this);
        if (mutateOptions && this.hasListeners()) {
            const variables = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentResult, this).variables;
            const onMutateResult = (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentResult, this).context;
            const context = {
                client: (0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_client, this),
                meta: this.options.meta,
                mutationKey: this.options.mutationKey
            };
            if ((action === null || action === void 0 ? void 0 : action.type) === "success") {
                try {
                    var _mutateOptions$onSucc;
                    (_mutateOptions$onSucc = mutateOptions.onSuccess) === null || _mutateOptions$onSucc === void 0 || _mutateOptions$onSucc.call(mutateOptions, action.data, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    var _mutateOptions$onSett;
                    (_mutateOptions$onSett = mutateOptions.onSettled) === null || _mutateOptions$onSett === void 0 || _mutateOptions$onSett.call(mutateOptions, action.data, null, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            } else if ((action === null || action === void 0 ? void 0 : action.type) === "error") {
                try {
                    var _mutateOptions$onErro;
                    (_mutateOptions$onErro = mutateOptions.onError) === null || _mutateOptions$onErro === void 0 || _mutateOptions$onErro.call(mutateOptions, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    var _mutateOptions$onSett2;
                    (_mutateOptions$onSett2 = mutateOptions.onSettled) === null || _mutateOptions$onSett2 === void 0 || _mutateOptions$onSett2.call(mutateOptions, void 0, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $8abf3f80f32bda0d$export$7ccc53e8f1e7dfc5)($2697bf98b2792c98$var$_currentResult, this));
        });
    });
}


"use client";
// src/useMutation.ts
/**
* Unlike queries, mutations are typically used to create/update/delete data or perform server side-effects.
* `useMutation` is the hook for that.
* @param options - The {@link UseMutationOptions} to use — everything you can pass to `useMutation`.
* @param queryClient - Use this to use a custom `QueryClient`. Otherwise, the one from the nearest context will
* be used.
* @returns `mutate`/`mutateAsync` also accept per-call `onSuccess`/`onError`/`onSettled` callbacks as a second
* argument, useful for triggering call-site side effects (e.g. navigation) without coupling them to the shared
* mutation definition. Hook-level callbacks (passed to `options`) fire for every mutation; per-call callbacks
* fire only for the latest call you've made, and only while the component is still mounted — unmounting before
* the mutation settles removes the subscription and prevents them from firing.
* @throws {Error} The mutation error, when `throwOnError` is `true` or returns `true` for it, so that it is
* thrown to the nearest error boundary.
* @see {@link mutationOptions} to share these options across multiple `useMutation` call sites, or to look
* the mutation up elsewhere via its `mutationKey` (e.g. with `useMutationState`).
* @example
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   return (
*     <button
*       onClick={() =>
*         addMutation.mutate('Item', {
*           onError: (error) => console.error('Failed to add item:', error),
*         })
*       }
*     >
*       Add
*     </button>
*   )
* }
* ```
* @example
* Rendering the mutation's own state, rather than just firing it off:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   return (
*     <div>
*       {addMutation.isPending ? (
*         'Adding todo...'
*       ) : (
*         <>
*           {addMutation.isError ? (
*             <div>An error occurred: {addMutation.error.message}</div>
*           ) : null}
*           <button onClick={() => addMutation.mutate('Item')}>Add</button>
*         </>
*       )}
*     </div>
*   )
* }
* ```
* @example
* Optimistic update via `onMutate`, rolling back on `onError`:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodo() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onMutate: async (newTodo) => {
*       await queryClient.cancelQueries({ queryKey: ['todos'] })
*       const previousTodos = queryClient.getQueryData<Array<string>>(['todos'])
*
*       queryClient.setQueryData<Array<string>>(['todos'], (old) => [
*         ...(old ?? []),
*         newTodo,
*       ])
*
*       // Passed to `onError` as `onMutateResult` if the mutation fails.
*       return { previousTodos }
*     },
*     onError: (_err, _newTodo, onMutateResult) => {
*       queryClient.setQueryData(['todos'], onMutateResult?.previousTodos)
*     },
*     onSettled: () => {
*       queryClient.invalidateQueries({ queryKey: ['todos'] })
*     },
*   })
*
*   return (
*     <button onClick={() => addMutation.mutate('Item')}>Add</button>
*   )
* }
* ```
* @example
* Callbacks passed per call to `mutate` only fire for the last call — `mutateAsync` gives you a
* promise per call instead, so you can wait for all of them when they succeed:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodos() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   async function handleAddAll(todos: Array<string>) {
*     try {
*       await Promise.all(todos.map((todo) => addMutation.mutateAsync(todo)))
*     } catch (error) {
*       console.error('Failed to add todos:', error)
*     }
*   }
*
*   return (
*     <button onClick={() => handleAddAll(['Todo 1', 'Todo 2', 'Todo 3'])}>
*       Add all
*     </button>
*   )
* }
* ```
* @example
* If some of the mutations above can fail independently of the others, and you want to know which ones
* did — rather than losing that information the moment the first one rejects — swap `Promise.all` for
* `Promise.allSettled`:
* ```tsx
* import { useMutation, useQueryClient } from '@tanstack/react-query'
*
* function AddTodos() {
*   const queryClient = useQueryClient()
*
*   const addMutation = useMutation({
*     mutationFn: addTodo,
*     onSuccess: () => queryClient.invalidateQueries({ queryKey: ['todos'] }),
*   })
*
*   async function handleAddAll(todos: Array<string>) {
*     const addResults = await Promise.allSettled(
*       todos.map((todo) => addMutation.mutateAsync(todo)),
*     )
*
*     addResults.forEach((addResult, index) => {
*       if (addResult.status === 'rejected') {
*         console.error(`Failed to add "${todos[index]}":`, addResult.reason)
*       }
*     })
*   }
*
*   return (
*     <button onClick={() => handleAddAll(['Todo 1', 'Todo 2', 'Todo 3'])}>
*       Add all
*     </button>
*   )
* }
* ```
*/ function $5803826dbe122ce6$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $e49ef136abe795ca$export$22e77b9572c4fded)(queryClient);
    const [observer] = $itHdT.useState(()=>new (0, $2697bf98b2792c98$export$d3c1860ee66f291a)(client, options));
    $itHdT.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $itHdT.useSyncExternalStore($itHdT.useCallback((onStoreChange)=>observer.subscribe((0, $e62a61312d2d5e98$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $itHdT.useCallback((...args)=>{
        observer.mutate(args[0], args[1]).catch((0, $ee0a7c55ac205e24$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $ee0a7c55ac205e24$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}







function $b1191ddd10c88efd$export$319954fba48a90ab(job) {
    const queryClient = (0, $e49ef136abe795ca$export$22e77b9572c4fded)();
    return (0, $5803826dbe122ce6$export$609860bf8b0084c)({
        mutationFn: async (variables)=>{
            const action = variables.action;
            if (action === "upsert") {
                // Create a set of database records to upsert based of the provided upsert details
                const priorityRecords = variables.upsertDetails.map(({ path: path, jobSpecific: jobSpecific, priority: priority, recordToUpdate: recordToUpdate })=>({
                        ...recordToUpdate && {
                            id: recordToUpdate.id,
                            version: recordToUpdate.version
                        },
                        jobId: jobSpecific ? job.id : null,
                        path: path,
                        priority: priority
                    }));
                // Upsert the priority records in the database
                const alteredRecords = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("BomPathPurchasingPriority").upsert(priorityRecords, {
                    onConflict: "jobId,path"
                }).select().throwOnError()).data.map((0, $df9fe021f00c5dd5$export$2d807f90eef064d3));
                return {
                    action: action,
                    alteredRecords: alteredRecords
                };
            } else {
                // Delete the purchasing priority record for the specified path
                const idsToDelete = variables.recordsToDelete.map((x)=>x.id);
                await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("BomPathPurchasingPriority").delete().in("id", idsToDelete).throwOnError();
                return {
                    action: action,
                    alteredRecords: variables.recordsToDelete
                };
            }
        },
        onSuccess: ({ action: action, alteredRecords: alteredRecords })=>{
            // Update the job tracking data in the query cache
            queryClient.setQueryData((0, $4f97e0b25d4f91a2$export$3f39a7b61f1136ac)(job.number), (old)=>{
                // If the job tracking data is not loaded, return early
                if (!old) return old;
                // Update the purchasing priorities
                const purchasingPriorities = $b1191ddd10c88efd$var$applyMutationsToPurchasingPriorities(old.purchasingPriorities, action, alteredRecords);
                // Recompute the purchasing priority details for each node in the bom hierarchy by applying each altered priority
                // record one-by-one. In theory we could do this in a single iteration, but this approach is simpler and should
                // provide good enough performance for the use case
                // NOTE: We could just get the dependency graph to re-compute this, which is very quick, but by doing a targeted
                // update we can reduce the number of objects updates and re-renders in the UI
                const salesOrderBomHierarchy = $b1191ddd10c88efd$var$applyMutationsToBomHierarchy(action, old.salesOrderBomHierarchy, alteredRecords);
                // Asynchronously recompute the job tracking data graph, then update the query cache with the new data
                (0, $ab9b65019b74910a$export$f81979825eb6953d)(old, [], {
                    purchasingPriorities: purchasingPriorities,
                    salesOrderBomHierarchy: salesOrderBomHierarchy
                }).then((updatedData)=>{
                    queryClient.setQueryData((0, $4f97e0b25d4f91a2$export$3f39a7b61f1136ac)(job.number), updatedData);
                });
                // Return undefined to skip the updating the query synchronously (will be updated async)
                return undefined;
            });
        }
    });
}
function $b1191ddd10c88efd$var$applyMutationsToPurchasingPriorities(old, action, alteredRecords) {
    const alteredRecordsById = new Map(alteredRecords.map((x)=>[
            x.id,
            x
        ]));
    return {
        salesOrderPriorities: $b1191ddd10c88efd$var$applyMutationsToPurchasingPrioritiesInternal(old.salesOrderPriorities, action, alteredRecordsById),
        templatePriorities: $b1191ddd10c88efd$var$applyMutationsToPurchasingPrioritiesInternal(old.templatePriorities, action, alteredRecordsById)
    };
}
function $b1191ddd10c88efd$var$applyMutationsToPurchasingPrioritiesInternal(old, action, alteredRecordsById) {
    return old.map((oldRecord)=>{
        // Get the matching altered record for this ID, if any
        const alteredRecord = alteredRecordsById.get(oldRecord.id);
        // If this was not one of the altered records, return the it as-is
        if (!alteredRecord) return oldRecord;
        // If the action is to delete, return null to filter this record out
        if (action === "delete") return null;
        // Otherwise, return the altered record
        return alteredRecord;
    }).filter((x)=>!!x);
}
/**
 * Recursively apply each of the altered priority records to the provided BOM hierarchy and return a new hierarchy.
 *
 * This method can either handle a set of upserted priority records, or a set of deleted priority records, depending
 * on the value provided to the `type` argument.
 *
 * All nodes in the hierarchy are treated as immutable, that is, any unmodified nodes are copied as-is, while modified
 * nodes are returned as new objects with updated properties.
 */ function $b1191ddd10c88efd$var$applyMutationsToBomHierarchy(mutationType, bomHierarchy, alteredPriorityRecords) {
    return bomHierarchy.map((oldNode)=>alteredPriorityRecords.reduce((newNode, alteredRecord)=>$b1191ddd10c88efd$var$addOrUpdateBomNodePriorityInternal((0, $ccba93d7976774da$export$9cad03fca08bc80e), newNode, alteredRecord.pathSegments, mutationType, alteredRecord), oldNode));
}
function $b1191ddd10c88efd$var$addOrUpdateBomNodePriorityInternal(/** The parent node's computed priority record. For top level nodes, this will be the default priority. */ parentEffectivePriority, /** The current BOM node in the hierarchy to update */ node, /** The remaining path segments to the target node that was affected by the mutation */ pathSegments, mutationType, alteredRecord) {
    // If there are path segments remaining and the first one does not match the current node, then it is not on the update
    // path and we can return it unmodified
    const [currentPathSegment, ...remainingPathSegments] = pathSegments;
    if (currentPathSegment && currentPathSegment !== node.item.id) return node;
    // Recompute the effective priority for the current node if it is the target node that was updated by the mutation,
    // or one of its descendants. Otherwise, keep the effective priority unmodified
    const isTargetNode = currentPathSegment === node.item.id && !remainingPathSegments.length;
    const isTargetNodeDescendant = !currentPathSegment;
    const purchasingPriority = isTargetNode || isTargetNodeDescendant ? $b1191ddd10c88efd$var$getEffectivePurchasingPriorityForUpdatedNodeOrDescendant(parentEffectivePriority, node, isTargetNode, mutationType, alteredRecord) : node.purchasingPriority;
    // Recurse to update all children
    const children = node.children.map((child)=>$b1191ddd10c88efd$var$addOrUpdateBomNodePriorityInternal(purchasingPriority, child, remainingPathSegments, mutationType, alteredRecord));
    // Recompute the list of child overrides (note: this needs to be done for all nodes, even those above the target
    // node in the hierarchy)
    const childOverrides = (0, $ccba93d7976774da$export$c3696b1b07bd1317)(children);
    // Return the updated node
    return {
        ...node,
        children: children,
        purchasingPriority: {
            ...purchasingPriority,
            childOverrides: childOverrides
        }
    };
}
function $b1191ddd10c88efd$var$getEffectivePurchasingPriorityForUpdatedNodeOrDescendant(parentEffectivePriority, node, isTargetNode, mutationType, alteredRecord) {
    if (!isTargetNode) // This is not the target node, we don't need to update either the template or job priority records for this node
    return (0, $ccba93d7976774da$export$c95f37487a209b12)(parentEffectivePriority, node.purchasingPriority.nodeTemplateRecord, node.purchasingPriority.nodeJobRecord);
    else if (mutationType === "upsert") {
        // Either the template or job-specific priority record for this node was updated
        const isJobUpdate = !!alteredRecord.jobId;
        const nodeTemplateRecord = !isJobUpdate ? alteredRecord : node.purchasingPriority.nodeTemplateRecord;
        const nodeJobRecord = isJobUpdate ? alteredRecord : node.purchasingPriority.nodeJobRecord;
        return (0, $ccba93d7976774da$export$c95f37487a209b12)(parentEffectivePriority, nodeTemplateRecord, nodeJobRecord);
    } else {
        // Either the template or job-specific priority record for this node was deleted
        const isJobUpdate = !!alteredRecord.jobId;
        const nodeTemplateRecord = !isJobUpdate ? null : node.purchasingPriority.nodeTemplateRecord;
        const nodeJobRecord = isJobUpdate ? null : node.purchasingPriority.nodeJobRecord;
        return (0, $ccba93d7976774da$export$c95f37487a209b12)(parentEffectivePriority, nodeTemplateRecord, nodeJobRecord);
    }
}







const $de5e9bef0a4848aa$export$86594a5ce2e273f2 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ bomComponentsByItemId: bomComponentsByItemId, purchasingPriority: purchasingPriority, recursiveDepth: recursiveDepth })=>{
    // Determine icon and style based on priority sourceType/inherited
    const { appliedRecord: appliedRecord, appliedRecordSource: appliedRecordSource, inherited: inherited } = purchasingPriority;
    const icon = appliedRecordSource === "default" ? "slash-circle" : inherited ? "link" : appliedRecordSource === "job" ? "star-fill" : "file-earmark-text"; // template override
    const iconColorClass = appliedRecordSource === "job" || !!appliedRecord?.jobId ? "text-primary" : null;
    const fontStyleClass = appliedRecordSource === "default" ? "fst-italic" : !inherited ? "fw-bold" : null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($de5e9bef0a4848aa$var$TooltipText, {
                purchasingPriority: purchasingPriority,
                recursiveDepth: recursiveDepth,
                bomComponentsByItemId: bomComponentsByItemId
            })
        }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(iconColorClass, fontStyleClass),
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: icon,
                width: 18,
                height: 18
            })
        })
    });
});
const $de5e9bef0a4848aa$var$TooltipText = ({ purchasingPriority: { appliedRecord: appliedRecord, appliedRecordSource: appliedRecordSource, inherited: inherited }, recursiveDepth: recursiveDepth, bomComponentsByItemId: bomComponentsByItemId })=>{
    if (appliedRecordSource === "default") return "Default Priority";
    if (!inherited) {
        const setText = recursiveDepth === 0 ? "Set" : "Overridden";
        return appliedRecordSource === "job" ? `${setText} for this job` : `${setText} in Template`;
    }
    const inheritedFromItem = bomComponentsByItemId.get(appliedRecord.targetItemId).item;
    const distanceFromInherited = recursiveDepth - appliedRecord.pathSegments.length + 1;
    const levels = distanceFromInherited === 1 ? "level" : "levels";
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            "Inherited from ",
            inheritedFromItem.name,
            " (",
            distanceFromInherited.toFixed(),
            " ",
            levels,
            " up)"
        ]
    });
};




var $itHdT = parcelRequire("itHdT");


const $62bce9010911d430$export$f04cf3a415018bcc = ({ bomNode: bomNode, updatePurchasingPriorityMutation: updatePurchasingPriorityMutation, className: className })=>{
    // Define the click handler for the button that creates job-specific overrides
    const handleClick = (0, $itHdT.useCallback)(()=>{
        // Define the upsert mutation details for the current node
        const currentNodeMutation = {
            path: bomNode.path,
            jobSpecific: true,
            priority: bomNode.purchasingPriority.priority,
            recordToUpdate: bomNode.purchasingPriority.nodeJobRecord
        };
        // Get a list of all child nodes that have template priority records
        const templatePriorityRecords = $62bce9010911d430$var$getTemplatePriorityNodes(bomNode.children);
        // Create upsert mutation details for each child node to create a new job-specific record to match the template priority
        const childNodeMutations = templatePriorityRecords.map((node)=>({
                path: node.path,
                jobSpecific: true,
                priority: node.purchasingPriority.priority,
                recordToUpdate: node.purchasingPriority.nodeJobRecord
            }));
        // Upsert all the mutation records
        updatePurchasingPriorityMutation.mutate({
            action: "upsert",
            upsertDetails: [
                currentNodeMutation,
                ...childNodeMutations
            ]
        });
    }, [
        bomNode,
        updatePurchasingPriorityMutation
    ]);
    // Do not render anything if this is not a top-level node, or if this node already has a job-specific priority
    if (bomNode.recursiveDepth !== 0) return null;
    if (bomNode.purchasingPriority.appliedRecordSource === "job") return null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            children: "Override For This Job"
        }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
            variant: "link",
            size: "sm",
            disabled: updatePurchasingPriorityMutation.isPending,
            onClick: handleClick,
            className: className,
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: "pencil-square",
                className: "text-primary"
            })
        })
    });
};
/** Recursively finds all child nodes that have a template purchasing priority record */ function $62bce9010911d430$var$getTemplatePriorityNodes(bomNodes) {
    return bomNodes.filter((node)=>node.purchasingPriority.nodeTemplateRecord).concat(bomNodes.flatMap((node)=>$62bce9010911d430$var$getTemplatePriorityNodes(node.children)));
}




var $itHdT = parcelRequire("itHdT");


const $e8e4551f7feea07e$export$b93d500d084be207 = ({ purchasingPriority: purchasingPriority, updatePurchasingPriorityMutation: updatePurchasingPriorityMutation, className: className })=>{
    // Define a click handler for the delete button
    const handleDelete = (0, $itHdT.useCallback)(()=>{
        // Do nothing if this node doesn't have a record to delete
        const recordToDelete = purchasingPriority.nodeJobRecord ?? purchasingPriority.nodeTemplateRecord;
        if (!recordToDelete) return;
        // Apply the mutation to delete the record
        updatePurchasingPriorityMutation.mutate({
            action: "delete",
            recordsToDelete: [
                recordToDelete
            ]
        });
    }, [
        purchasingPriority,
        updatePurchasingPriorityMutation
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            children: "Reset priority"
        }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
            variant: "link",
            size: "sm",
            disabled: updatePurchasingPriorityMutation.isPending,
            onClick: handleDelete,
            className: className,
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: "arrow-counterclockwise",
                className: "text-secondary"
            })
        })
    });
};





var $itHdT = parcelRequire("itHdT");


var $itHdT = parcelRequire("itHdT");


"use client";
const $adbbc7357073ab7c$var$ButtonGroup = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$adbbc7357073ab7c$var$ButtonGroup.displayName = 'ButtonGroup';
var $adbbc7357073ab7c$export$2e2bcd8739ae039 = $adbbc7357073ab7c$var$ButtonGroup;




const $5ab74c789090709c$export$f7917013fe399617 = ({ bomNode: bomNode, updatePurchasingPriorityMutation: updatePurchasingPriorityMutation })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $adbbc7357073ab7c$export$2e2bcd8739ae039), {
            size: "sm",
            className: "ms-2",
            children: (0, $ccba93d7976774da$export$426717e7f687ece8).map((buttonPriority)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($5ab74c789090709c$var$PurchasingPriorityButton, {
                    bomNode: bomNode,
                    buttonPriority: buttonPriority,
                    updatePurchasingPriorityMutation: updatePurchasingPriorityMutation
                }, buttonPriority))
        })
    });
};
const $5ab74c789090709c$var$PurchasingPriorityButton = ({ bomNode: bomNode, buttonPriority: buttonPriority, updatePurchasingPriorityMutation: updatePurchasingPriorityMutation })=>{
    const { oppositeTheme: oppositeTheme } = (0, $f3ead4447ee0b856$export$93d4e7f90805808f)();
    // Define the click callback for the button that adds or updates a job-specific purchasing priority for the current node
    const handleClick = (0, $itHdT.useCallback)(()=>{
        updatePurchasingPriorityMutation.mutate({
            action: "upsert",
            upsertDetails: [
                {
                    jobSpecific: true,
                    path: bomNode.path,
                    priority: buttonPriority,
                    recordToUpdate: bomNode.purchasingPriority.nodeJobRecord
                }
            ]
        });
    }, [
        updatePurchasingPriorityMutation,
        bomNode.path,
        bomNode.purchasingPriority,
        buttonPriority
    ]);
    // Compute the style to apply based on the active state and priority
    const active = buttonPriority === bomNode.purchasingPriority.priority;
    const nodePriority = bomNode.purchasingPriority.priority;
    const style = active ? {
        borderColor: (0, $ccba93d7976774da$export$39e251832c3f0c85)[nodePriority],
        backgroundColor: (0, $ccba93d7976774da$export$39e251832c3f0c85)[nodePriority],
        color: "rgba(var(--bs-dark-rgb), var(--bs-text-opacity))",
        opacity: "var(--bs-text-opacity)"
    } : undefined;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("py-0 btn-inherit-opacity", {
            "fw-bold": active
        }),
        variant: active ? oppositeTheme : `outline-${oppositeTheme}`,
        active: active,
        disabled: bomNode.purchasingPriority.appliedRecordSource !== "job" || // Editing is disabled unless node is job-specific
        active || // Active button cannot be clicked again
        updatePurchasingPriorityMutation.isPending // Disable while mutation is in-progress
        ,
        onClick: handleClick,
        children: buttonPriority
    }, buttonPriority);
};






const $73a7f0c1203ef9d9$export$c7ffa1d6933da8b7 = ({ sourceType: sourceType, overriddenChildren: overriddenChildren })=>{
    // Render nothing if this node has no overridden children
    const numOverrides = overriddenChildren.length;
    if (!numOverrides) return null;
    // Use a highlighted icon color if any of the overridden children are job-specific
    const colorClass = {
        "text-primary": sourceType === "job"
    };
    // Define the tooltip that will be displayed on hover
    const toolTip = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
            className: "text-start",
            children: [
                "Overridden by ",
                numOverrides.toFixed(0),
                " ",
                numOverrides === 1 ? "child" : "children",
                " ",
                sourceType === "job" ? "for" : "in",
                " ",
                sourceType,
                ":",
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("ul", {
                    className: "ps-3 m-0",
                    children: overriddenChildren.map((child)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("li", {
                            children: [
                                child.item.name,
                                " (priority: ",
                                child.purchasingPriority.priority,
                                ")"
                            ]
                        }, child.item.id))
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: toolTip,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
            icon: "flag-fill",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("ms-2", colorClass)
        })
    });
};






var $itHdT = parcelRequire("itHdT");
const $e095ba675ec1dd37$export$c2fa480ca071a9cb = ({ bomNode: bomNode, updatePurchasingPriorityMutation: updatePurchasingPriorityMutation, className: className })=>{
    // Define a click handler for the delete button
    const handleDelete = (0, $itHdT.useCallback)(()=>{
        // Do nothing if this node doesn't have a job-specific record to delete
        if (!bomNode.purchasingPriority.nodeJobRecord) return;
        // Confirm with the user before deleting anything
        const confirmResult = confirm("This will delete the job-specific priorities for this item and all it's children. They will be reverted to the template or default priorities.\n\nThis action cannot be undone. Are you sure you want to continue?");
        if (!confirmResult) return;
        // Apply the mutation to delete the record
        const recordsToDelete = [
            bomNode,
            ...$e095ba675ec1dd37$var$getAllJobSpecificNodes(bomNode.children)
        ].map((node)=>node.purchasingPriority.nodeJobRecord);
        updatePurchasingPriorityMutation.mutate({
            action: "delete",
            recordsToDelete: recordsToDelete
        });
    }, [
        bomNode,
        updatePurchasingPriorityMutation
    ]);
    // Render nothing unless this is a top-level node with a job-specific record associated
    if (bomNode.recursiveDepth !== 0 || !bomNode.purchasingPriority.nodeJobRecord) return null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            children: [
                "Revert to template",
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                "(discard all job-specific priorities)"
            ]
        }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
            variant: "link",
            size: "sm",
            disabled: updatePurchasingPriorityMutation.isPending,
            onClick: handleDelete,
            className: className,
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: "trash3",
                className: "text-secondary"
            })
        })
    });
};
/** Recursively get all bom nodes that have a job-specific priority record associated with them. */ function $e095ba675ec1dd37$var$getAllJobSpecificNodes(bomNodes) {
    return bomNodes.filter((node)=>!!node.purchasingPriority.nodeJobRecord).concat(bomNodes.flatMap((node)=>$e095ba675ec1dd37$var$getAllJobSpecificNodes(node.children)));
}




var $itHdT = parcelRequire("itHdT");


const $cfaabd6387312ae2$export$d70e877098832f39 = ({ bomNode: bomNode, updatePurchasingPriorityMutation: updatePurchasingPriorityMutation, className: className })=>{
    // Define the button click handler
    const handleDeleteCallBack = (0, $itHdT.useCallback)(()=>void $cfaabd6387312ae2$var$handleDelete(bomNode, updatePurchasingPriorityMutation), [
        bomNode,
        updatePurchasingPriorityMutation
    ]);
    // Render nothing unless this is a top-level node with a job-specific record
    if (bomNode.recursiveDepth !== 0 || !bomNode.purchasingPriority.nodeJobRecord) return null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            children: "Save As Template"
        }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
            variant: "link",
            size: "sm",
            disabled: updatePurchasingPriorityMutation.isPending,
            onClick: handleDeleteCallBack,
            className: className,
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: "floppy-fill",
                className: "text-secondary"
            })
        })
    });
};
async function $cfaabd6387312ae2$var$handleDelete(bomNode, updatePurchasingPriorityMutation) {
    // Do nothing if this node doesn't have a job-specific purchasing priority record
    if (!bomNode.purchasingPriority.nodeJobRecord) return;
    // Confirm with the user before proceeding
    const confirmResult = confirm("This will save the the current priorities for this assembly and all its children as the new priority template for this assembly.\n\nThis will replace (i.e. delete) the existing template for this assembly, and the new template will immediately apply to any other sales orders with this assembly\n\nThis action cannot be undone, are you sure you want to continue?");
    if (!confirmResult) return;
    // Get all template purchasing priority records for this node's children
    const templateRecords = $cfaabd6387312ae2$var$getAllTemplatePriorityRecords(bomNode.children);
    // Get all job-specific purchasing priority records for this node and its children
    const jobSpecificRecords = [
        bomNode.purchasingPriority.nodeJobRecord,
        ...$cfaabd6387312ae2$var$getAllJobSpecificPriorityRecords(bomNode.children)
    ];
    // Apply a mutation to delete any existing template records
    await updatePurchasingPriorityMutation.mutateAsync({
        action: "delete",
        recordsToDelete: templateRecords
    });
    // Apply a mutation to create new template records based on the job-specific records
    await updatePurchasingPriorityMutation.mutateAsync({
        action: "upsert",
        upsertDetails: jobSpecificRecords.map((jobRecord)=>({
                jobSpecific: false,
                path: jobRecord.path,
                priority: jobRecord.priority,
                recordToUpdate: null
            }))
    });
    // Apply a mutation to delete the job-specific records
    await updatePurchasingPriorityMutation.mutateAsync({
        action: "delete",
        recordsToDelete: jobSpecificRecords
    });
}
function $cfaabd6387312ae2$var$getAllJobSpecificPriorityRecords(bomNodes) {
    return bomNodes.filter((node)=>node.purchasingPriority.nodeJobRecord).map((node)=>node.purchasingPriority.nodeJobRecord).concat(bomNodes.flatMap((node)=>$cfaabd6387312ae2$var$getAllJobSpecificPriorityRecords(node.children)));
}
function $cfaabd6387312ae2$var$getAllTemplatePriorityRecords(bomNodes) {
    return bomNodes.filter((node)=>node.purchasingPriority.nodeTemplateRecord).map((node)=>node.purchasingPriority.nodeTemplateRecord).concat(bomNodes.flatMap((node)=>$cfaabd6387312ae2$var$getAllTemplatePriorityRecords(node.children)));
}


/**
 * Renders a cell for viewing and updating the purchasing priority of a BOM node.
 */ const $b519a103102cdac0$var$PurchasingPriorityCellInternal = ({ job: job, bomNode: bomNode })=>{
    const updatePurchasingPriorityMutation = (0, $b1191ddd10c88efd$export$319954fba48a90ab)(job);
    const { appliedRecordSource: appliedRecordSource, childOverrides: childOverrides } = bomNode.purchasingPriority;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("d-flex align-items-center text-body", {
            "text-opacity-25": appliedRecordSource === "default",
            "text-opacity-50": appliedRecordSource === "template"
        }),
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("pre", {
                className: "m-0 lh-1",
                style: {
                    fontSize: "calc(var(--bs-body-line-height) * 1em)"
                },
                children: bomNode.asciiTreePrefix
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $de5e9bef0a4848aa$export$86594a5ce2e273f2), {
                ...bomNode
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5ab74c789090709c$export$f7917013fe399617), {
                bomNode: bomNode,
                updatePurchasingPriorityMutation: updatePurchasingPriorityMutation
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $73a7f0c1203ef9d9$export$c7ffa1d6933da8b7), {
                overriddenChildren: childOverrides.job,
                sourceType: "job"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $73a7f0c1203ef9d9$export$c7ffa1d6933da8b7), {
                overriddenChildren: childOverrides.template,
                sourceType: "template"
            }),
            bomNode.recursiveDepth === 0 && bomNode.purchasingPriority.appliedRecordSource !== "job" && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $62bce9010911d430$export$f04cf3a415018bcc), {
                bomNode: bomNode,
                updatePurchasingPriorityMutation: updatePurchasingPriorityMutation,
                className: "p-0 ms-2"
            }),
            bomNode.recursiveDepth === 0 && bomNode.purchasingPriority.nodeJobRecord && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $cfaabd6387312ae2$export$d70e877098832f39), {
                        bomNode: bomNode,
                        updatePurchasingPriorityMutation: updatePurchasingPriorityMutation,
                        className: "p-0 ms-2"
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $e095ba675ec1dd37$export$c2fa480ca071a9cb), {
                        bomNode: bomNode,
                        updatePurchasingPriorityMutation: updatePurchasingPriorityMutation,
                        className: "p-0 ms-1"
                    })
                ]
            }),
            bomNode.recursiveDepth !== 0 && bomNode.purchasingPriority.nodeJobRecord && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $e8e4551f7feea07e$export$b93d500d084be207), {
                purchasingPriority: bomNode.purchasingPriority,
                updatePurchasingPriorityMutation: updatePurchasingPriorityMutation,
                className: "p-0 ms-1"
            }),
            updatePurchasingPriorityMutation.isPending && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $67974e86dbd6e1f4$export$2e2bcd8739ae039), {
                size: "sm",
                className: "ms-1"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f1efb1e28adccc66$export$bbb4a13c6e738029), {
                mutation: updatePurchasingPriorityMutation,
                className: "ms-1 lh-1 p-0"
            })
        ]
    });
};
const $b519a103102cdac0$export$1a1488fa5c200a74 = /*#__PURE__*/ (0, $itHdT.memo)($b519a103102cdac0$var$PurchasingPriorityCellInternal);








var $itHdT = parcelRequire("itHdT");



const $802e99ab74c8072c$export$29df35c2681e40c8 = ({ duration: duration })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $132900893c14632d$export$2e2bcd8739ae039), {
        live: false,
        date: duration,
        now: ()=>0,
        formatter: $802e99ab74c8072c$var$durationFormatter
    });
};
/**
 * A timeago formatter for durations, that returns the default string without the ' from now' suffix.
 *
 * For example: "2 years from now" -> "2 years"
 */ function $802e99ab74c8072c$var$durationFormatter(value, unit, suffix, epochMilliseconds, nextFormatter, now) {
    const defaultFormat = nextFormatter(value, unit, suffix, epochMilliseconds, ()=>"", now);
    return defaultFormat.slice(0, -9);
}


const $1210798d2c8b7bfb$var$LeadTimeCellInternal = ({ item: item, fuzzyDurationThreshold: fuzzyDurationThreshold })=>{
    // Render nothing if the lead time is not set
    const leadTimeMs = item.leadTimeMs;
    if (!leadTimeMs) return null;
    // Conditionally render an alert icon if the lead time is greater than 3 weeks (21 days)
    const leadTimeDays = Math.ceil(item.leadTimeDays);
    const showAlert = !!leadTimeDays && leadTimeDays >= 21;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $f6bce4f618ea63d9$export$ee48491cfb0c8625), {
        error: showAlert,
        children: [
            leadTimeDays.toFixed(0),
            " days",
            " ",
            fuzzyDurationThreshold && leadTimeDays > fuzzyDurationThreshold && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    "(~",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $802e99ab74c8072c$export$29df35c2681e40c8), {
                        duration: leadTimeMs
                    }),
                    ")"
                ]
            }),
            showAlert && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                className: "align-text-bottom text-warning",
                children: "\u26A0"
            })
        ]
    });
};
const $1210798d2c8b7bfb$export$87a3dfbb64954554 = /*#__PURE__*/ (0, $itHdT.memo)($1210798d2c8b7bfb$var$LeadTimeCellInternal);







const $4e5d3a028600f3a0$export$95f03250ea71320b = ({ item: item })=>{
    const taxCodeMissing = !item.purchaseTaxCode;
    const taxCodeMismatch = item.preferredVendor?.taxCode && item.purchaseTaxCode?.id !== item.preferredVendor.taxCode.id;
    const error = taxCodeMissing ? "tax code is missing" : taxCodeMismatch ? "tax code does not match vendor" : null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            item.purchaseTaxCode ? $4e5d3a028600f3a0$export$c6f48bf3215925ea(item.purchaseTaxCode) : "",
            " ",
            error && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $f6bce4f618ea63d9$export$ee48491cfb0c8625), {
                children: [
                    "\u26A0 ",
                    error
                ]
            })
        ]
    });
};
function $4e5d3a028600f3a0$export$c6f48bf3215925ea(taxCode) {
    return `${taxCode.name} - ${taxCode.purchaseTaxRate.toLocaleString(undefined, {
        maximumFractionDigits: 5
    })}%`;
}


const $8c7ae95559385c88$export$a8430f3acfbfd10 = ({ item: item, showTax: showTax = true })=>{
    const vendor = item.preferredVendor;
    const missingVendor = !(0, $2b3a7af3658dfb79$export$e6ae7ae9cddc1cf4)(item.type) && !vendor;
    const missingTaxCode = showTax && vendor && !vendor.taxCode;
    const error = missingVendor ? "no preferred vendor selected" : missingTaxCode ? "tax code is missing" : null;
    const taxCodeSuffix = showTax && vendor?.taxCode ? ` (${(0, $4e5d3a028600f3a0$export$c6f48bf3215925ea)(vendor.taxCode)})` : "";
    const vendorText = vendor ? `${vendor.name}${taxCodeSuffix}` : null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            vendorText,
            " ",
            error && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $f6bce4f618ea63d9$export$ee48491cfb0c8625), {
                children: [
                    "\u26A0 ",
                    error
                ]
            })
        ]
    });
};


const $6c5a730c11ff7490$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $6c5a730c11ff7490$export$273a9cf586439a1a = [
    $6c5a730c11ff7490$var$columnHelper.accessor("item.name", {
        header: "Item",
        meta: {
            cellProps: {
                className: "tree-shaded"
            }
        },
        cell: ({ getValue: getValue, row: { original: node, getIsExpanded: getIsExpanded, getToggleExpandedHandler: getToggleExpandedHandler } })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("pre", {
                className: "m-0",
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                        className: "lh-1",
                        style: {
                            fontSize: "calc(var(--bs-body-line-height) * 1em)"
                        },
                        children: node.asciiTreePrefix
                    }),
                    getValue(),
                    " ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $cdf93fc3684ad5cf$export$5e8cf9fecce8187), {
                        showChildren: getIsExpanded(),
                        toggleShowChildren: getToggleExpandedHandler(),
                        children: (0, $2b3a7af3658dfb79$export$e6ae7ae9cddc1cf4)(node.item.type) ? node.children : null
                    })
                ]
            })
    }),
    // This column will take up all remaining horizontal space in the table. The contents are positioned absolutely
    // so that the text can be truncated without affecting the layout of the table.
    $6c5a730c11ff7490$var$columnHelper.accessor("item.description", {
        header: "Description",
        meta: {
            cellProps: {
                className: "tree-shaded position-relative w-100",
                style: {
                    minWidth: 300
                }
            }
        },
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($6c5a730c11ff7490$var$MemoizedDescriptionCell, {
                text: getValue()
            })
    }),
    // The text in this column is allowed to wrap. This isn't ideal but notes are quite rare so it's not a big deal
    $6c5a730c11ff7490$var$columnHelper.accessor("notes", {
        header: "Notes",
        meta: {
            cellProps: {
                className: "tree-shaded text-wrap",
                style: {
                    minWidth: 150
                }
            }
        }
    }),
    // This column has a max width and will be truncated if the vendor name is too long
    $6c5a730c11ff7490$var$columnHelper.accessor("item.preferredVendor.name", {
        header: "Preferred Vendor",
        meta: {
            cellProps: {
                className: "tree-shaded",
                style: {
                    maxWidth: 150
                }
            }
        },
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($6c5a730c11ff7490$var$MemoizedTruncatedPreferredVendorCell, {
                item: row.original.item
            })
    }),
    $6c5a730c11ff7490$var$columnHelper.accessor("quantity", {
        header: "Qty.",
        meta: {
            cellProps: {
                className: "tree-shaded"
            }
        },
        cell: ({ getValue: getValue })=>getValue().toLocaleString(undefined, {
                maximumFractionDigits: 5
            })
    }),
    $6c5a730c11ff7490$var$columnHelper.accessor("item.leadTimeMs", {
        header: "Lead Time",
        meta: {
            cellProps: {
                className: "tree-shaded"
            }
        },
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1210798d2c8b7bfb$export$87a3dfbb64954554), {
                item: row.original.item
            })
    }),
    $6c5a730c11ff7490$var$columnHelper.accessor("totalPurchaseCost.total", {
        header: "Estimated Purchase Costs",
        meta: {
            helpText: "NOTE: Does NOT include labour",
            cellProps: {
                className: "tree-shaded"
            }
        },
        cell: ({ row: { original: original } })=>{
            // Don't show purchase costs for labor items
            if (original.item.type === "Labor") return null;
            // Show a list of errors if the cost calculation failed
            const totalPurchaseCost = original.totalPurchaseCost;
            if (totalPurchaseCost.errors.length) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $41caf841eb1d8d0c$export$1e050932b91ba5cd), {
                cost: totalPurchaseCost
            });
            // Show a tooltip with the breakdown of the cost
            const formattedTotal = (0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(totalPurchaseCost.total);
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                trigger: [
                    "hover",
                    "focus"
                ],
                overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                        ...props,
                        children: [
                            (0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(original.unitPurchaseCost.total),
                            " x",
                            " ",
                            original.totalQuantity.toLocaleString(undefined, {
                                maximumFractionDigits: 5
                            }),
                            " = ",
                            formattedTotal
                        ]
                    }),
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                    children: formattedTotal
                })
            });
        }
    }),
    $6c5a730c11ff7490$var$columnHelper.accessor("totalLabourCost.total", {
        header: "Estimated Labour",
        meta: {
            cellProps: {
                className: "tree-shaded"
            }
        },
        cell: ({ row: { original: original } })=>{
            // Don't show labour cost for leaf nodes (always zero)
            if (!original.children.length) return null;
            // Calculate the total number of hours based on the labour cost
            // NOTE: Assumes a rate of $100/hr for all labour
            const totalLabourCost = original.totalLabourCost;
            const totalHours = (0, $bb09d99f2c0a98ec$export$a0a81dc3380ce7d3)(totalLabourCost.subtotal) / 100;
            // Don't show labour cost for assemblies built via contract manufacturing
            if (!totalHours && original.children.some((x)=>x.item.name.endsWith("-CM"))) return null;
            // Show a list of errors if the cost calculation failed
            if (totalLabourCost.errors.length) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $41caf841eb1d8d0c$export$1e050932b91ba5cd), {
                cost: totalLabourCost
            });
            // Show a tooltip with the breakdown of the cost
            const formattedTotal = totalHours.toLocaleString(undefined, {
                maximumFractionDigits: 2
            }) + " hrs";
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                trigger: [
                    "hover",
                    "focus"
                ],
                overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                        ...props,
                        children: [
                            ((0, $bb09d99f2c0a98ec$export$a0a81dc3380ce7d3)(original.unitLabourCost.subtotal) / 100).toLocaleString(undefined, {
                                maximumFractionDigits: 2
                            }),
                            " ",
                            "hrs x ",
                            original.totalQuantity.toLocaleString(undefined, {
                                maximumFractionDigits: 5
                            }),
                            " = ",
                            formattedTotal
                        ]
                    }),
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))({
                        [(0, $f6bce4f618ea63d9$export$3f0f2d69bf4fa3c7)]: original.missingLabourEstimate
                    }),
                    children: [
                        original.missingLabourEstimate && "\u26A0 ",
                        formattedTotal
                    ]
                })
            });
        }
    }),
    $6c5a730c11ff7490$var$columnHelper.accessor("purchasingPriority.priority", {
        header: "Purchasing Priority",
        cell: ({ row: row, table: table })=>{
            const job = table.options.meta["job"];
            if (!job) return null;
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b519a103102cdac0$export$1a1488fa5c200a74), {
                bomNode: row.original,
                job: job
            });
        }
    })
];
const $6c5a730c11ff7490$var$MemoizedDescriptionCell = /*#__PURE__*/ (0, $itHdT.memo)(function DescriptionCell({ text: text }) {
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4220604e14789aa3$export$1d3fbcd96e8a5a25), {
        className: "position-absolute w-100 h-100",
        children: text
    });
});
const $6c5a730c11ff7490$var$MemoizedTruncatedPreferredVendorCell = /*#__PURE__*/ (0, $itHdT.memo)(function TruncatedPreferredVendorCell({ item: item }) {
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4220604e14789aa3$export$1d3fbcd96e8a5a25), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8c7ae95559385c88$export$a8430f3acfbfd10), {
            item: item,
            showTax: false
        })
    });
});


const $d31443acc6b5459c$export$9144070b323d068b = ({ bomHierarchy: bomHierarchy, job: job })=>{
    const [expanded, setExpanded] = (0, $itHdT.useState)({});
    const handleExpandAll = (0, $itHdT.useCallback)(()=>{
        setExpanded(true);
    }, []);
    const handleCollapseAll = (0, $itHdT.useCallback)(()=>{
        setExpanded({});
    }, []);
    const tableRows = (0, $itHdT.useMemo)(()=>$d31443acc6b5459c$var$createTableRows(bomHierarchy), [
        bomHierarchy
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "col-auto mb-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                    className: "row row-cols-auto gx-3 align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "secondary",
                                onClick: handleExpandAll,
                                children: "Expand All"
                            })
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "secondary",
                                onClick: handleCollapseAll,
                                children: "Collapse All"
                            })
                        }),
                        job && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $18d39a5a2e476fcb$export$2e2bcd8739ae039), {
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $18d39a5a2e476fcb$export$2e2bcd8739ae039), {
                                    direction: "horizontal",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                                            className: "text-end",
                                            style: {
                                                minWidth: "8em"
                                            },
                                            children: "Estimated Costs:"
                                        }),
                                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b5b1081e6a2f874a$export$822779f0626b1ee4), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $18d39a5a2e476fcb$export$2e2bcd8739ae039), {
                                    direction: "horizontal",
                                    gap: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                                            className: "text-end",
                                            style: {
                                                minWidth: "8em"
                                            },
                                            children: "Estimated Labour:"
                                        }),
                                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $51c8a12f6a1f52c0$export$ac7507aabb6c6a70), {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                className: "col",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                    bordered: true,
                    hover: true,
                    className: "bom-hierarchy-table",
                    data: tableRows,
                    columns: (0, $6c5a730c11ff7490$export$273a9cf586439a1a),
                    getSubRows: (x)=>x.children,
                    state: {
                        expanded: expanded,
                        columnVisibility: {
                            ["purchasingPriority_priority"]: !!job
                        }
                    },
                    onExpandedChange: setExpanded,
                    meta: {
                        job: job,
                        dataRowProps: (row)=>({
                                className: `tree-depth-${row.depth.toFixed(0)} text-nowrap`
                            })
                    }
                })
            })
        ]
    });
};
function $d31443acc6b5459c$var$createTableRows(bomNodes) {
    return bomNodes.map((node)=>{
        const unitLabourCost = node.categorizedUnitCosts.labour;
        const totalLabourCost = node.categorizedLineItemCosts.labour;
        return {
            ...node,
            unitLabourCost: unitLabourCost,
            totalLabourCost: totalLabourCost,
            unitPurchaseCost: node.unitCost.subtract(unitLabourCost),
            totalPurchaseCost: node.lineItemCost.subtract(totalLabourCost),
            children: $d31443acc6b5459c$var$createTableRows(node.children)
        };
    });
}







const $9064d462c95211b8$export$195eb2a2e4ef02fe = ({ lineNumber: lineNumber, ...props })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
        ...props,
        idSuffix: $9064d462c95211b8$var$getLineItemSuffix(lineNumber, props.idSuffix)
    });
};
function $9064d462c95211b8$export$f3f8186491bf53ab(type, id, lineNumber, suffix) {
    return (0, $a23decb4ddcbc17a$export$3e63b58f3f3486b6)(type, id, $9064d462c95211b8$var$getLineItemSuffix(lineNumber, suffix));
}
function $9064d462c95211b8$var$getLineItemSuffix(lineNumber, suffix) {
    return `line-${lineNumber.toFixed()}${suffix ? `-${suffix}` : ""}`;
}







var $itHdT = parcelRequire("itHdT");







const $3d643190fccb9d64$export$3a4836b3bd8a8af6 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ bin: bin, salesOrderRackBin: salesOrderRackBin, warnForNonSORack: warnForNonSORack })=>{
    if (!bin) return null;
    const isSORack = bin.id === salesOrderRackBin.id;
    const warnIcon = !isSORack && warnForNonSORack ? "\u26A0 " : "";
    const className = isSORack ? "text-secondary" : warnForNonSORack ? "text-warning" : undefined;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
        className: className,
        children: [
            warnIcon,
            bin.number
        ]
    });
});




// For build/output columns, set the rowspan of each cell on the on the first line to the total number of lines. Hide all subsequent rows for the same receipt
const $6baf9d6a5c4b1f3c$var$buildColCellProps = (cell, additionalProps)=>{
    const { numLines: numLines, isFirstLine: isFirstLine } = cell.row.original;
    return isFirstLine ? {
        ...additionalProps,
        rowSpan: numLines
    } : {
        ...additionalProps,
        className: "d-none " + (additionalProps?.className ?? "")
    };
};
// Create helpers for defining columns
const $6baf9d6a5c4b1f3c$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $6baf9d6a5c4b1f3c$var$buildAccessorCol = (accessor, column)=>$6baf9d6a5c4b1f3c$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $6baf9d6a5c4b1f3c$var$buildColCellProps
        }
    }, column));
const $6baf9d6a5c4b1f3c$var$outputAccessorCol = (accessor, column)=>$6baf9d6a5c4b1f3c$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $6baf9d6a5c4b1f3c$var$buildColCellProps
        },
        enableSorting: false
    }, column));
const $6baf9d6a5c4b1f3c$var$inputAccessorCol = (accessor, column)=>$6baf9d6a5c4b1f3c$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        enableSorting: false
    }, column));
const $6baf9d6a5c4b1f3c$var$buildColumns = [
    $6baf9d6a5c4b1f3c$var$buildAccessorCol("build.number", {
        header: "Build #",
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "build",
                id: row.original.build.id,
                label: getValue()
            })
    }),
    $6baf9d6a5c4b1f3c$var$buildAccessorCol("build.date", {
        header: "Date",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: getValue()
            })
    }),
    $6baf9d6a5c4b1f3c$var$buildAccessorCol("build.linkedWOs", {
        header: "Linked WO",
        cell: ({ row: row, getValue: getValue })=>getValue().map((wo, index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $itHdT.Fragment), {
                    children: [
                        index > 0 && ", ",
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                            trackerPath: "work-orders",
                            children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                                    fromHash: row.id,
                                    urlPath: targetPath,
                                    tooltipContent: `View on '${targetPageTitle}' page`,
                                    type: "workorder",
                                    id: wo.id,
                                    lineNumber: 0,
                                    label: wo.number
                                })
                        })
                    ]
                }, wo.id))
    }),
    $6baf9d6a5c4b1f3c$var$buildAccessorCol("build.workCenter.name", {
        header: "Work Center",
        cell: ({ getValue: getValue })=>{
            const workCenter = getValue();
            const variant = workCenter === "Finished Goods" ? "success" : "warning";
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                className: `text-${variant}`,
                children: workCenter
            });
        }
    })
];
const $6baf9d6a5c4b1f3c$var$outputColumns = [
    $6baf9d6a5c4b1f3c$var$outputAccessorCol("output.item.name", {
        header: "Assembly",
        cell: ({ row: row })=>{
            const output = row.original.output;
            return output && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: output.item.id,
                        label: output.item.name
                    })
            });
        },
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: (cell)=>$6baf9d6a5c4b1f3c$var$buildColCellProps(cell, {
                    className: "border-start-double"
                })
        }
    }),
    $6baf9d6a5c4b1f3c$var$outputAccessorCol("output.item.description", {
        header: "Description",
        cell: ({ row: row })=>row.original.output && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $32df95eb0ee5e5ca$export$d7888f4f62c79646), {
                line: row.original.output
            })
    }),
    $6baf9d6a5c4b1f3c$var$outputAccessorCol("output.uomQuantity", {
        header: "Quantity",
        cell: ({ row: row })=>row.original.output && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5e4e43af2ec40d42$export$a33f39dd24777af9), {
                line: row.original.output
            })
    }),
    $6baf9d6a5c4b1f3c$var$outputAccessorCol("output.bin.number", {
        header: "To Bin",
        cell: ({ row: row })=>row.original.output && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d643190fccb9d64$export$3a4836b3bd8a8af6), {
                bin: row.original.output.bin
            })
    })
];
const $6baf9d6a5c4b1f3c$var$inputColumns = [
    $6baf9d6a5c4b1f3c$var$inputAccessorCol("input.lineNumber", {
        header: "Line #",
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: {
                className: "border-start-double"
            }
        }
    }),
    $6baf9d6a5c4b1f3c$var$inputAccessorCol("input.item.name", {
        header: "Item",
        cell: ({ row: row })=>{
            const input = row.original.input;
            return input && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: input.item.id,
                        label: input.item.name
                    })
            });
        }
    }),
    $6baf9d6a5c4b1f3c$var$inputAccessorCol("input.item.type", {
        header: "Type"
    }),
    $6baf9d6a5c4b1f3c$var$inputAccessorCol("input.item.description", {
        header: "Description",
        cell: ({ row: row })=>row.original.input && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $32df95eb0ee5e5ca$export$d7888f4f62c79646), {
                line: row.original.input
            })
    }),
    $6baf9d6a5c4b1f3c$var$inputAccessorCol("input.uomQuantity", {
        header: "Quantity",
        cell: ({ row: row })=>row.original.input && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5e4e43af2ec40d42$export$a33f39dd24777af9), {
                line: row.original.input
            })
    }),
    $6baf9d6a5c4b1f3c$var$inputAccessorCol("input.bin.number", {
        header: "From Bin",
        cell: ({ row: row })=>row.original.input && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d643190fccb9d64$export$3a4836b3bd8a8af6), {
                bin: row.original.input.bin
            })
    })
];
const $6baf9d6a5c4b1f3c$export$fc2e5c8f581d0fe5 = [
    $6baf9d6a5c4b1f3c$var$columnHelper.group({
        header: "Builds",
        columns: $6baf9d6a5c4b1f3c$var$buildColumns
    }),
    $6baf9d6a5c4b1f3c$var$columnHelper.group({
        header: "Output",
        columns: $6baf9d6a5c4b1f3c$var$outputColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    }),
    $6baf9d6a5c4b1f3c$var$columnHelper.group({
        header: "Inputs",
        columns: $6baf9d6a5c4b1f3c$var$inputColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    })
];


const $19417bece9bd7197$export$5026e6aa86fecb8d = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ builds: builds })=>{
    // Flatten the list of builds into a list of table rows (one row for each input/output line item)
    const data = builds.flatMap((build)=>{
        const numLines = Math.max(build.inputs.length, build.outputs.length);
        return Array.from({
            length: numLines
        }, (_, index)=>{
            const input = build.inputs[index];
            const output = build.outputs[index];
            return {
                rowId: (0, $9064d462c95211b8$export$f3f8186491bf53ab)("build", build.id, index),
                build: build,
                input: input,
                output: output,
                numLines: numLines,
                isFirstLine: index === 0
            };
        });
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
        className: "col",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
            bordered: true,
            hover: true,
            data: data,
            columns: (0, $6baf9d6a5c4b1f3c$export$fc2e5c8f581d0fe5),
            getRowId: ({ rowId: rowId })=>rowId,
            initialState: {
                sorting: [
                    {
                        id: "build_date",
                        desc: true
                    }
                ]
            }
        })
    });
});








async function $9cc5dac14613d503$export$5b0f659051bba6e(jobNumber) {
    return await (0, $c9c26cf183c0c8b8$export$31a67b5db8076ca7)(`api/erns/${jobNumber}`, {
        method: "GET"
    });
}









// For ERN columns, set the rowspan of each cell on the on the first line to the total number of lines. Hide all subsequent rows for the same ERN
const $995c3fed61e132de$var$ernColCellProps = (cell, additionalProps)=>{
    const { ern: ern, line: line } = cell.row.original;
    return line.lineNumber === 0 ? {
        ...additionalProps,
        rowSpan: ern.bomData.length
    } : {
        ...additionalProps,
        className: "d-none " + (additionalProps?.className ?? "")
    };
};
// For BOM columns, apply a class to the table cell indicating the recursive depth of the row
const $995c3fed61e132de$var$bomColCellProps = (cell, additionalProps)=>{
    const depth = cell.row.original.line.hierarchyLevel ?? 0;
    return {
        ...additionalProps,
        className: `tree-depth-${depth.toString()} ${additionalProps?.className ?? ""}`
    };
};
// Create helpers for defining columns
const $995c3fed61e132de$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $995c3fed61e132de$var$ernAccessorCol = (accessor, column)=>$995c3fed61e132de$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $995c3fed61e132de$var$ernColCellProps
        }
    }, column));
const $995c3fed61e132de$var$bomAccessorCol = (accessor, column)=>$995c3fed61e132de$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $995c3fed61e132de$var$bomColCellProps
        }
    }, column));
const $995c3fed61e132de$var$ernColumns = [
    $995c3fed61e132de$var$ernAccessorCol("ern.number", {
        header: "ERN #"
    }),
    $995c3fed61e132de$var$ernAccessorCol("ern.description", {
        header: "Description"
    }),
    $995c3fed61e132de$var$ernAccessorCol("ern.createdBy", {
        header: "Created By"
    })
];
const $995c3fed61e132de$var$bomColumns = [
    $995c3fed61e132de$var$bomAccessorCol("line.itemName", {
        header: "Item",
        cell: ({ row: row })=>{
            const itemId = row.original.line.itemId;
            const indent = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("pre", {
                className: "d-inline",
                children: "   ".repeat(row.original.line.hierarchyLevel ?? 0)
            });
            const label = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    indent,
                    row.original.line.itemName
                ]
            });
            return itemId ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: itemId,
                        className: "text-decoration-none text-nowrap",
                        label: label
                    })
            }) : label;
        },
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: (cell)=>$995c3fed61e132de$var$bomColCellProps(cell, {
                    className: "border-start-double"
                })
        }
    }),
    $995c3fed61e132de$var$bomAccessorCol("line.description", {
        header: "Description"
    }),
    $995c3fed61e132de$var$bomAccessorCol("line.quantity", {
        header: "Quantity"
    }),
    $995c3fed61e132de$var$bomAccessorCol("line.unitOfMeasure", {
        header: "UOM"
    }),
    $995c3fed61e132de$var$bomAccessorCol("line.actionRequired", {
        header: "Action Required",
        cell: ({ getValue: getValue })=>{
            const action = getValue();
            const colorClasses = action === "Add" ? "bg-success text-success-subtle" : action === "Remove" ? "bg-danger text-danger-subtle" : action === "See Comment" ? "bg-info text-info-subtle" : null;
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("badge", colorClasses),
                children: action
            });
        },
        meta: {
            cellProps: (cell)=>$995c3fed61e132de$var$bomColCellProps(cell, {
                    className: "text-center align-middle"
                })
        }
    }),
    $995c3fed61e132de$var$bomAccessorCol("line.comments", {
        header: "Comments"
    })
];
const $995c3fed61e132de$export$4cc0949c8e014ab6 = [
    $995c3fed61e132de$var$columnHelper.group({
        header: "ERNs",
        columns: $995c3fed61e132de$var$ernColumns
    }),
    $995c3fed61e132de$var$columnHelper.group({
        header: "BOM Data",
        columns: $995c3fed61e132de$var$bomColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    })
];


const $466c8efe06d70928$export$2dd503f827ed679b = (0, $8080646ce18e3d87$export$839c859e3b3cdbd5)(({ job: job })=>{
    const ernQuery = (0, $b262411d05d5989d$export$ad4afeb3151d80fa)({
        queryKey: [
            "salesOrderTrackingData",
            job.number,
            "erns"
        ],
        queryFn: ()=>(0, $9cc5dac14613d503$export$5b0f659051bba6e)(job.number)
    });
    // Handle loading and error states
    if (ernQuery.isError) return `Error loading ERNs: ${ernQuery.error.message}`;
    if (ernQuery.isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d8ed0f693b57ae21$export$1afe2b5a93b67b3), {
        text: "Loading ERNs"
    });
    // Flatten the list of ERNs into a list of table rows (one row for each BOM line item)
    const data = ernQuery.data.flatMap((ern)=>ern.bomData.map((line, index)=>({
                rowId: `ern-${ern.number}-line-${index.toFixed()}`,
                ern: ern,
                line: line
            })));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
        className: "col",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
            bordered: true,
            data: data,
            columns: (0, $995c3fed61e132de$export$4cc0949c8e014ab6),
            getRowId: ({ rowId: rowId })=>rowId
        })
    });
});




var $itHdT = parcelRequire("itHdT");







/**
 * Creates the query key for purchasing notes by job ID.
 *
 * @param jobId - The job ID to create the query key for (null if no job context)
 * @returns The query key array that can be used with TanStack Query
 */ function $c15fb01840b13614$export$64f32ce369deee00(jobId) {
    return [
        "PurchasingNote",
        jobId
    ];
}


function $79a9b33d45be89f5$export$8195762461c0e40a(jobId) {
    return (0, $b262411d05d5989d$export$ad4afeb3151d80fa)({
        queryKey: (0, $c15fb01840b13614$export$64f32ce369deee00)(jobId),
        queryFn: async ()=>{
            const { data: data } = await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("PurchasingNote").select("*").eq("jobId", jobId).throwOnError();
            return new Map(data.map((note)=>[
                    note.itemId,
                    note
                ]));
        },
        enabled: jobId !== null,
        staleTime: 1800000,
        gcTime: 2100000
    });
}











var $itHdT = parcelRequire("itHdT");





/**
 * Update the purchasing note for a specific item/job combination with the provided value.
 *
 * @param params - The parameters for updating the note
 * @returns The updated note if the value has changed, null if the note was deleted, or false if no changes were made.
 */ async function $f50c221da49d7a6a$var$updatePurchasingNote({ note: note, newValue: newValue, itemId: itemId, jobId: jobId }) {
    if (!newValue) {
        // If the input is empty and there is no existing note, do nothing
        if (!note) return {
            updated: false,
            newNote: note
        };
        // If the input is empty and there is an existing note, delete it
        await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("PurchasingNote").delete().eq("itemId", note.itemId).eq("jobId", note.jobId).throwOnError();
        return {
            updated: true,
            newNote: null
        };
    }
    // If there is no existing note, create a new one
    if (!note) {
        const newNote = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("PurchasingNote").insert({
            itemId: itemId,
            jobId: jobId,
            value: newValue
        }).select().single().throwOnError()).data;
        return {
            updated: true,
            newNote: newNote
        };
    }
    // If the text has changed, update the existing note
    if (note.value !== newValue) {
        const newNote = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("PurchasingNote").update({
            value: newValue
        }).eq("itemId", itemId).eq("jobId", jobId).select().single().throwOnError()).data;
        return {
            updated: true,
            newNote: newNote
        };
    }
    // Otherwise, the note is unchanged, return the existing note
    return {
        updated: false,
        newNote: note
    };
}
function $f50c221da49d7a6a$export$c8ce4e285b370faf() {
    const queryClient = (0, $e49ef136abe795ca$export$22e77b9572c4fded)();
    return (0, $5803826dbe122ce6$export$609860bf8b0084c)({
        mutationFn: $f50c221da49d7a6a$var$updatePurchasingNote,
        onSuccess: (result, variables)=>{
            // Only update cache if something actually changed
            if (!result.updated) return;
            const { jobId: jobId, itemId: itemId } = variables;
            const queryKey = (0, $c15fb01840b13614$export$64f32ce369deee00)(jobId);
            // Update the cached data immediately
            queryClient.setQueryData(queryKey, (oldData)=>{
                if (!oldData) return oldData;
                const newData = new Map(oldData);
                if (result.newNote === null) // Note was deleted
                newData.delete(itemId);
                else // Note was created or updated
                newData.set(itemId, result.newNote);
                return newData;
            });
        }
    });
}


const $f6853181fc3efadc$export$d7869cf7b7128ff6 = ({ initialNote: initialNote, jobId: jobId, itemId: itemId })=>{
    const [note, setNote] = (0, $itHdT.useState)(initialNote);
    const [input, setInput] = (0, $itHdT.useState)(initialNote?.value ?? "");
    const [saved, setSaved] = (0, $itHdT.useState)(false);
    const [savedTimeout, setSavedTimeout] = (0, $itHdT.useState)(null);
    const textareaRef = (0, $itHdT.useRef)(null);
    const updateNoteMutation = (0, $f50c221da49d7a6a$export$c8ce4e285b370faf)();
    const saving = updateNoteMutation.isPending;
    const error = updateNoteMutation.error;
    // Update the input state value as the user types
    const onChange = (0, $itHdT.useCallback)((e)=>{
        setInput(e.target.value);
    }, []);
    // Define callback to save note on blur
    const onBlurAsync = (0, $itHdT.useCallback)(async (e)=>{
        // Avoid saving again if a save is already in progress
        if (saving) return;
        // Reset some state at the start of a save operation
        setSaved(false);
        if (savedTimeout) {
            clearTimeout(savedTimeout);
            setSavedTimeout(null);
        }
        const newValue = e.target.value.trim();
        const result = await updateNoteMutation.mutateAsync({
            note: note,
            newValue: newValue,
            itemId: itemId,
            jobId: jobId
        });
        setNote(result.newNote);
        setSaved(result.updated);
        if (result.updated) setSavedTimeout(setTimeout(()=>{
            setSaved(false);
        }, 1200));
    }, [
        itemId,
        jobId,
        note,
        saving,
        savedTimeout,
        updateNoteMutation
    ]);
    const onBlur = (0, $itHdT.useCallback)((e)=>{
        onBlurAsync(e);
    }, [
        onBlurAsync
    ]);
    // This effect runs when the component mounts and whenever the input value changes
    (0, $itHdT.useEffect)(()=>{
        // Do nothing if the textarea is not yet mounted
        const textarea = textareaRef.current;
        if (!textarea) return;
        // Resize the textarea to fit its content, with a minimum height of the parent container
        // NOTE: We need to change the height to auto first so that it can shrink when content is removed
        const parent = textarea.parentElement;
        const resize = ()=>{
            textarea.style.height = "auto";
            const height = Math.max(textarea.scrollHeight, parent.clientHeight);
            textarea.style.height = height.toString() + "px";
        };
        resize();
        // Listen for container resize
        const observer = new ResizeObserver(resize);
        observer.observe(textarea.parentElement);
        return observer.disconnect.bind(observer);
    }, [
        input
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("textarea", {
                ref: textareaRef,
                className: "form-control form-control-sm overflow-hidden",
                style: {
                    minWidth: 200,
                    resize: "none"
                },
                value: input,
                rows: 2,
                onChange: onChange,
                onBlur: onBlur,
                disabled: saving,
                placeholder: "Add note..."
            }),
            saving && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $67974e86dbd6e1f4$export$2e2bcd8739ae039), {
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("small", {
                        className: "text-secondary",
                        children: "Saving..."
                    })
                ]
            }),
            saved && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
                className: "text-success ms-1 align-middle",
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                        icon: "check",
                        className: "text-success"
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("small", {
                        children: "Saved"
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("small", {
                className: "text-danger",
                children: [
                    "ERROR: ",
                    error.message
                ]
            })
        ]
    });
};


function $6f5dd23132a624ec$export$26ff4a032eb2212({ getItemId: getItemId }) {
    return {
        id: "notes",
        header: "Notes",
        cell: (cell)=>{
            const row = cell.row.original;
            if (row.initialNote === undefined) return null;
            if (row.initialNote instanceof Error) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
                className: "text-danger",
                children: [
                    "Failed to load notes: ",
                    row.initialNote.message
                ]
            });
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f6853181fc3efadc$export$d7869cf7b7128ff6), {
                initialNote: row.initialNote,
                jobId: row.jobId,
                itemId: getItemId(row)
            });
        },
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: (cell)=>{
                const noteLoading = cell.row.original.initialNote === undefined;
                return {
                    className: `border-start-double ${noteLoading ? " skeleton-loading-table-cell" : "p-0"}`
                };
            }
        }
    };
}





var $itHdT = parcelRequire("itHdT");







const $d10bed940359e2e7$export$8d9f20122e3554b1 = /*#__PURE__*/ (0, $itHdT.memo)((0, $4f97e0b25d4f91a2$export$53cc986057983387)(function QuantityRequiredForJobCellInternal({ salesOrderBomHierarchy: salesOrderBomHierarchy, bomComponentsByItemId: bomComponentsByItemId, item: item, priority: priority }) {
    const [showPopover, setShowPopover] = (0, $itHdT.useState)(false);
    const closePopover = (0, $itHdT.useCallback)(()=>{
        setShowPopover(false);
    }, []);
    const bomComponent = bomComponentsByItemId.get(item.id);
    const quantityRequiredForJobAtPriority = bomComponent?.quantitiesByPriority.get(priority ?? (0, $ccba93d7976774da$export$cc3cd71de886be2d)).quantityRequiredForJob ?? 0;
    const filteredBomHierarchy = $d10bed940359e2e7$var$filterBomHierarchyForItem(salesOrderBomHierarchy, item.id);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        trigger: "click",
        show: showPopover,
        onToggle: setShowPopover,
        rootClose: true,
        overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $53905517a09a4f32$export$2e2bcd8739ae039), {
                ...props,
                className: "d-flex flex-column",
                style: {
                    ...props.style,
                    "--bs-popover-max-width": "500px",
                    maxHeight: 300
                },
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $53905517a09a4f32$export$2e2bcd8739ae039).Header, {
                        as: "h3",
                        children: [
                            "Total Quantity Breakdown For ",
                            item.name,
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8e67b2a05f9aad1c$export$2e2bcd8739ae039), {
                                className: "float-end",
                                onClick: closePopover
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $53905517a09a4f32$export$2e2bcd8739ae039).Body, {
                        className: "flex-fill overflow-y-auto",
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($d10bed940359e2e7$var$TotalQuantityBreakdown, {
                            filteredBomHierarchy: filteredBomHierarchy,
                            item: item,
                            bomComponent: bomComponent,
                            priority: priority
                        })
                    })
                ]
            }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))("btn btn-link p-0", {
                [(0, $f6bce4f618ea63d9$export$3f0f2d69bf4fa3c7)]: !bomComponent?.onSalesOrder
            }),
            title: "Click to see breakdown",
            children: [
                !bomComponent?.onSalesOrder && "\u26A0",
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                    quantity: quantityRequiredForJobAtPriority,
                    uom: item.baseItemUOM?.uom
                })
            ]
        })
    });
}));
const $d10bed940359e2e7$var$TotalQuantityBreakdown = ({ filteredBomHierarchy: filteredBomHierarchy, bomComponent: bomComponent, item: item, priority: priority })=>{
    // Return an error message if the item does not exist in the BOM hierarchy
    if (!filteredBomHierarchy.length) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            "Item ",
            item.name,
            " is not found anywhere in the BOM hierarchy."
        ]
    });
    // If the item exists in the hierarchy it should always have a corresponding BOM component
    if (!bomComponent) throw new Error(`No BOM component found for item ${item.name} that occurs in the BOM hierarchy.`);
    // Count the number of leaf nodes in the filtered BOM hierarchy (i.e. nodes where the item is found)
    const leafNodes = $d10bed940359e2e7$var$getLeafNodes(filteredBomHierarchy);
    const quantitiesForPriority = bomComponent.quantitiesByPriority.get(priority ?? (0, $ccba93d7976774da$export$cc3cd71de886be2d));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("p", {
                children: [
                    "The total quantity of ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("b", {
                        children: item.name
                    }),
                    " on the sales order BOM",
                    " ",
                    priority && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                        children: [
                            "for priority ",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1630003de9d6d19f$export$92a44ac9c59126cf), {
                                priority: priority
                            }),
                            " "
                        ]
                    }),
                    "is",
                    " ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("b", {
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                            quantity: quantitiesForPriority.bomTotalQuantity,
                            uom: item.baseItemUOM?.uom
                        })
                    }),
                    "."
                ]
            }),
            quantitiesForPriority.bomTotalQuantity !== quantitiesForPriority.quantityRequiredForJob && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("p", {
                children: [
                    "\u26A0\uFE0F The quantity required for this order has",
                    " ",
                    quantitiesForPriority.quantityRequiredForJob > quantitiesForPriority.bomTotalQuantity ? "increased" : "decreased",
                    " ",
                    "to",
                    " ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("b", {
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                            quantity: quantitiesForPriority.quantityRequiredForJob,
                            uom: item.baseItemUOM?.uom
                        })
                    }),
                    " ",
                    "due to movement of parent assemblies to/from stock or other jobs."
                ]
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("p", {
                children: [
                    "Item ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("b", {
                        children: item.name
                    }),
                    " is found in ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("b", {
                        children: leafNodes.length
                    }),
                    " locations in the BOM hierarchy. Hover over any of the quantities below to see the breakdown of how that quantity is calculated."
                ]
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "lh-1",
                children: filteredBomHierarchy.map((node)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($d10bed940359e2e7$var$BomNodeComponent, {
                        parentTotalQuantity: null,
                        node: node,
                        priority: priority
                    }, node.path))
            })
        ]
    });
};
const $d10bed940359e2e7$var$BomNodeComponent = ({ parentTotalQuantity: parentTotalQuantity, node: node, priority: priority })=>{
    const isLeaf = node.children.length === 0;
    const prioritized = !priority || !isLeaf || node.purchasingPriority.priority <= priority;
    const nodeTotalQuantityForPriority = prioritized ? node.totalQuantity : 0;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("pre", {
                className: "m-0 overflow-y-hidden",
                children: [
                    node.asciiTreePrefix,
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
                        className: isLeaf ? "fw-bold text-primary" : "",
                        children: [
                            node.item.name,
                            ":",
                            " ",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                                trigger: [
                                    "hover",
                                    "focus"
                                ],
                                overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                                        ...props,
                                        style: {
                                            ...props.style,
                                            "--bs-tooltip-max-width": "300px"
                                        },
                                        children: !prioritized ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                                            children: [
                                                "This component is filtered out because it has purchasing priority",
                                                " ",
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1630003de9d6d19f$export$92a44ac9c59126cf), {
                                                    priority: node.purchasingPriority.priority
                                                })
                                            ]
                                        }) : parentTotalQuantity ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                                                    quantity: node.quantity,
                                                    uom: node.item.baseItemUOM?.uom
                                                }),
                                                " per build x",
                                                " ",
                                                parentTotalQuantity,
                                                " builds =",
                                                " ",
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                                                    quantity: nodeTotalQuantityForPriority,
                                                    uom: node.item.baseItemUOM?.uom
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                                            children: [
                                                nodeTotalQuantityForPriority,
                                                " on sales order"
                                            ]
                                        })
                                    }),
                                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                                    className: "text-decoration-underline-dotted",
                                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                                        quantity: nodeTotalQuantityForPriority,
                                        uom: node.item.baseItemUOM?.uom
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            node.children.map((child)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($d10bed940359e2e7$var$BomNodeComponent, {
                    parentTotalQuantity: node.totalQuantity,
                    node: child,
                    priority: priority
                }, child.path))
        ]
    });
};
function $d10bed940359e2e7$var$filterBomHierarchyForItem(bomHierarchy, itemId) {
    // Filter the BOM hierarchy to only include nodes that contain the specified item (or it's ancestors)
    const filteredBomHierarchy = bomHierarchy.map((node)=>$d10bed940359e2e7$var$filterBomHierarchyForItemInternal(node, itemId)).filter((node)=>node !== null);
    // Update each node in the tree to recalculate the ascii tree components
    return filteredBomHierarchy.map((node, index)=>$d10bed940359e2e7$var$updateFilteredBomHierarchy(node, null, index === filteredBomHierarchy.length - 1));
}
function $d10bed940359e2e7$var$filterBomHierarchyForItemInternal(node, itemId) {
    // If this item matches the item, return it with no children
    if (node.item.id === itemId) return {
        ...node,
        children: []
    };
    // Recursively filter children for the item
    const children = node.children.map((child)=>$d10bed940359e2e7$var$filterBomHierarchyForItemInternal(child, itemId)).filter((child)=>child !== null);
    // Filter out this node if all its children have been filtered out
    if (children.length === 0) return null;
    // Otherwise, return this node with its filtered children
    return {
        ...node,
        children: children
    };
}
function $d10bed940359e2e7$var$updateFilteredBomHierarchy(node, parentComponents, isLastChild) {
    // Recalculate the ascii tree components for each node after filtering
    const asciiTreeComponents = parentComponents ? (0, $522415699e9e4669$export$8331bd18d884bb15).getAsciiTreeComponents(parentComponents, isLastChild) : [];
    return {
        ...node,
        asciiTreePrefix: asciiTreeComponents.join(""),
        children: node.children.map((child, index)=>$d10bed940359e2e7$var$updateFilteredBomHierarchy(child, asciiTreeComponents, index === node.children.length - 1))
    };
}
function $d10bed940359e2e7$var$getLeafNodes(nodes) {
    return nodes.flatMap((node)=>{
        if (node.children.length === 0) return [
            node
        ];
        return $d10bed940359e2e7$var$getLeafNodes(node.children);
    });
}



parcelRequire("itHdT");





const $8e83be46f8eaf7af$export$602bee8c97934705 = ({ item: item, sources: sources, fromRowId: fromRowId })=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("ul", {
        className: "mb-0 list-unstyled",
        children: sources.map((source, index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($8e83be46f8eaf7af$var$ExistingInventorySourceLine, {
                    fromRowId: fromRowId,
                    item: item,
                    source: source
                })
            }, index))
    });
};
const $8e83be46f8eaf7af$var$ExistingInventorySourceLine = ({ fromRowId: fromRowId, item: item, source: source })=>{
    const { type: type, balance: balance, sourceRecord: sourceRecord, sourceLine: sourceLine } = source;
    const bin = "bin" in sourceLine ? sourceLine.bin : balance > 0 ? sourceLine.fromBin : sourceLine.toBin;
    const binLabel = type === "Shipment" && balance < 0 ? `${sourceLine.job?.name ?? "unknown"} shipment` : bin?.number ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            "'",
            bin.number,
            "' on"
        ]
    }) : item.type === "Non-inventory Item" ? "non-inventory stock on" : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
        children: "'unknown bin' on"
    });
    const buildInputOutputLabel = type === "Build Input" ? "input " : type === "Build Output" ? "output " : null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        className: "d-flex",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "me-1",
                children: balance > 0 ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                    icon: "plus-lg",
                    className: "text-success"
                }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                    icon: "dash-lg",
                    className: "text-danger"
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                        quantity: Math.abs(balance),
                        uom: item.baseItemUOM?.uom
                    }),
                    " ",
                    balance > 0 ? "from" : "to",
                    " ",
                    binLabel,
                    " ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($8e83be46f8eaf7af$var$ExistingInventorySourceLink, {
                        fromRowId: fromRowId,
                        source: source
                    }),
                    " ",
                    buildInputOutputLabel,
                    "line #",
                    sourceLine.lineNumber.toFixed(),
                    sourceRecord.comment && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                                className: "text-secondary",
                                children: sourceRecord.comment
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $8e83be46f8eaf7af$var$ExistingInventorySourceLink = ({ fromRowId: fromRowId, source: { type: type, balance: balance, sourceRecordType: sourceRecordType, sourceRecord: sourceRecord, sourceLine: sourceLine } })=>{
    // Do not link anywhere for adjustments or transfers, we don't have a dedicated page for them
    if (type === "Adjustment" || type === "Transfer") return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
        type: sourceRecordType,
        id: sourceRecord.id,
        label: sourceRecord.number
    });
    // Do not link anywhere if the record is not part of this sales order (i.e. a shipment from a different sales order)
    // In this scenario, the source record is not included in any tracking tables for this sales order
    if ((type === "Shipment" || type === "Build Input") && balance < 0) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
        type: sourceRecordType,
        id: sourceRecord.id,
        label: sourceRecord.number
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
        className: "me-1",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
            trackerPath: type === "Shipment" ? "shipments" : "builds",
            children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                    fromHash: fromRowId,
                    urlPath: targetPath,
                    tooltipContent: `View on '${targetPageTitle}' page`,
                    type: sourceRecordType,
                    id: sourceRecord.id,
                    lineNumber: sourceLine.lineNumber,
                    label: sourceRecord.number
                })
        })
    });
};


// Create helpers for defining columns
const $a3043f0ad7dfb54f$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $a3043f0ad7dfb54f$var$itemDetailColumns = [
    $a3043f0ad7dfb54f$var$columnHelper.accessor("item.name", {
        header: "Item",
        enableHiding: false,
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: row.original.item.id,
                        label: row.original.item.name
                    })
            })
    }),
    $a3043f0ad7dfb54f$var$columnHelper.accessor("item.type", {
        header: "Type"
    }),
    $a3043f0ad7dfb54f$var$columnHelper.accessor("item.description", {
        header: "Description"
    })
];
const $a3043f0ad7dfb54f$var$quantityColumns = [
    $a3043f0ad7dfb54f$var$columnHelper.accessor("quantityRequiredForJob", {
        header: "Total Required",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d10bed940359e2e7$export$8d9f20122e3554b1), {
                item: row.original.item
            }),
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: {
                className: "border-start-double"
            }
        }
    }),
    $a3043f0ad7dfb54f$var$columnHelper.accessor("quantity.fromInventory", {
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                quantity: getValue(),
                uom: row.original.item.baseItemUOM?.uom
            }),
        header: "# From Inventory"
    }),
    $a3043f0ad7dfb54f$var$columnHelper.accessor("quantity.toInventory", {
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                quantity: getValue(),
                uom: row.original.item.baseItemUOM?.uom
            }),
        header: "# To Inventory"
    })
];
const $a3043f0ad7dfb54f$var$valueColumns = [
    $a3043f0ad7dfb54f$var$columnHelper.accessor("fromInventoryCosts.subtotal", {
        header: "From Inventory",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue()),
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: {
                className: "border-start-double"
            }
        }
    }),
    $a3043f0ad7dfb54f$var$columnHelper.accessor("toInventoryCosts.subtotal", {
        header: "To Inventory",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
    })
];
const $a3043f0ad7dfb54f$export$3b6f9012098a3d29 = [
    $a3043f0ad7dfb54f$var$columnHelper.group({
        header: "Item Details",
        columns: $a3043f0ad7dfb54f$var$itemDetailColumns
    }),
    $a3043f0ad7dfb54f$var$columnHelper.group({
        header: "Quantities",
        columns: $a3043f0ad7dfb54f$var$quantityColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    }),
    $a3043f0ad7dfb54f$var$columnHelper.group({
        header: "Values (Before Tax)",
        columns: $a3043f0ad7dfb54f$var$valueColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    }),
    $a3043f0ad7dfb54f$var$columnHelper.accessor("sources", {
        header: "Sources",
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8e83be46f8eaf7af$export$602bee8c97934705), {
                fromRowId: row.id,
                item: row.original.item,
                sources: getValue()
            }),
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: {
                className: "border-start-double"
            }
        }
    }),
    (0, $6f5dd23132a624ec$export$26ff4a032eb2212)({
        getItemId: (row)=>row.item.id
    })
];


const $8668497794e9bea6$export$261918a79b7582b6 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ existingInventory: existingInventory, bomComponentsByItemId: bomComponentsByItemId, job: job })=>{
    // Fetch all purchasing notes for the current job
    const notesByItemIdQuery = (0, $79a9b33d45be89f5$export$8195762461c0e40a)(job.id);
    // Flatten the list of shipments into a list of table rows (one row for each line item)
    const data = (0, $itHdT.useMemo)(()=>existingInventory.map((x)=>{
            const bomComponent = bomComponentsByItemId.get(x.item.id);
            return {
                ...x,
                rowId: (0, $a23decb4ddcbc17a$export$3e63b58f3f3486b6)("item", x.item.id),
                jobId: job.id,
                quantityRequiredForJob: bomComponent?.quantityRequiredForJob ?? 0,
                fromInventoryCosts: bomComponent?.unitCost.multiply(x.quantity.fromInventory, 2) ?? (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO,
                toInventoryCosts: bomComponent?.unitCost.multiply(x.quantity.toInventory, 2) ?? (0, $f2faaafdab540e00$export$72b98bde8fc72fd9).ZERO,
                initialNote: notesByItemIdQuery.isLoading ? undefined : notesByItemIdQuery.error ? notesByItemIdQuery.error : notesByItemIdQuery.data?.get(x.item.id) ?? null
            };
        }), [
        existingInventory,
        bomComponentsByItemId,
        job.id,
        notesByItemIdQuery
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
        className: "col",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
            bordered: true,
            hover: true,
            data: data,
            columns: (0, $a3043f0ad7dfb54f$export$3b6f9012098a3d29),
            getRowId: ({ rowId: rowId })=>rowId,
            initialState: {
                sorting: [
                    {
                        id: "item_type",
                        desc: false
                    },
                    {
                        id: "item_name",
                        desc: false
                    }
                ]
            }
        })
    });
});









var $itHdT = parcelRequire("itHdT");
function $a4fe301f9339adde$export$aeab823c9f913be(columnSetIds, columnVisibility, setColumnVisibility) {
    const isVisible = $a4fe301f9339adde$var$getVisibilityStateForColumnSet(columnSetIds, columnVisibility);
    const toggleVisibility = (0, $itHdT.useCallback)(()=>{
        setColumnVisibility((prev)=>$a4fe301f9339adde$var$updateColumnSetVisibility(columnSetIds, !isVisible, prev));
    }, [
        isVisible,
        setColumnVisibility,
        columnSetIds
    ]);
    return [
        isVisible,
        toggleVisibility
    ];
}
/**
 * Helper function to update the visibility of a set of columns.
 *
 * @param columnIds The set of column IDs to update.
 * @param newVisibility The new visibility state for the columns.
 * @param visibilityState The current visibility state of the columns.
 * @returns A new visibility state object with the updated visibility.
 */ function $a4fe301f9339adde$var$updateColumnSetVisibility(columnIds, newVisibility, visibilityState) {
    return newVisibility ? // Return a new object with the specified columns all removed from the visibility state
    Object.fromEntries(Object.entries(visibilityState).filter(([colId])=>!columnIds.has(colId))) : {
        ...visibilityState,
        ...Object.fromEntries([
            ...columnIds
        ].map((colId)=>[
                colId,
                false
            ]))
    };
}
/**
 * Get the visibility state for a set of columns. If all columns have the same visibility value, return that value. If
 * columns have mixed visibility, return undefined (indeterminate).
 */ function $a4fe301f9339adde$var$getVisibilityStateForColumnSet(columnIds, visibilityState) {
    const uniqueColumnVisibilities = new Set([
        ...columnIds
    ].map((colId)=>visibilityState[colId] !== false ? true : false));
    return uniqueColumnVisibilities.size === 1 ? uniqueColumnVisibilities.values().next().value : undefined;
}





parcelRequire("itHdT");







function $42f48b0cccb30e55$export$1bb41df59c3d84c(lineItem) {
    const { id: id, lineNumber: lineNumber, item: item, unitCost: unitCostDinero, totalCost: totalCost, bin: bin, linkedPo: linkedPo } = lineItem;
    const unitCost = (0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(unitCostDinero.subtotal);
    return {
        id: id,
        lineNumber: lineNumber,
        item: item,
        description: lineItem.description,
        descriptionElement: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $32df95eb0ee5e5ca$export$d7888f4f62c79646), {
            line: lineItem
        }),
        uomQuantity: lineItem.uomQuantity,
        uomQuantityElement: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5e4e43af2ec40d42$export$a33f39dd24777af9), {
            line: lineItem
        }),
        unitCost: unitCost,
        unitCostElement: unitCost,
        totalCost: totalCost,
        bin: bin,
        BinComponent: $42f48b0cccb30e55$var$BinCellComponent,
        linkedPo: linkedPo,
        linkedPoComponent: $42f48b0cccb30e55$var$LinkedPoCellComponent
    };
}
const $42f48b0cccb30e55$var$BinCellComponent = ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d643190fccb9d64$export$3a4836b3bd8a8af6), {
        bin: row.original.normalizedLine.bin,
        warnForNonSORack: true
    });
const $42f48b0cccb30e55$var$LinkedPoCellComponent = ({ row: row })=>{
    const linkedPo = row.original.normalizedLine.linkedPo;
    if (!linkedPo) return null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
        trackerPath: "purchase-orders",
        children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                fromHash: row.id,
                urlPath: targetPath,
                tooltipContent: `View on '${targetPageTitle}' page`,
                type: "purchaseorder",
                id: linkedPo.id,
                lineNumber: 0,
                label: linkedPo.number
            })
    });
};
function $42f48b0cccb30e55$export$96fcdf0ed343e686(receivingCost, receipt) {
    const { id: id, lineNumber: lineNumber, item: item, vendor: vendor, jobAmountCad: jobAmountCad } = receivingCost;
    const jobPercent = receipt.receivingCostsJobPercent;
    const vendorLabel = vendor ? `(${vendor.name})` : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f6bce4f618ea63d9$export$ee48491cfb0c8625), {
        children: "\u26A0 Vendor Missing"
    });
    const descriptionElement = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            "Other Costs (",
            (jobPercent * 100).toLocaleString(undefined, {
                maximumFractionDigits: 2
            }),
            "% allocated to this job):",
            " ",
            item.description,
            " ",
            vendorLabel
        ]
    });
    return {
        id: id,
        lineNumber: receipt.allLines.length + lineNumber,
        item: item,
        description: item.description,
        descriptionElement: descriptionElement,
        uomQuantity: NaN,
        uomQuantityElement: $42f48b0cccb30e55$var$naElement,
        unitCost: "N/A",
        unitCostElement: $42f48b0cccb30e55$var$naElement,
        totalCost: jobAmountCad,
        bin: {
            id: -1,
            number: "N/A"
        },
        BinComponent: $42f48b0cccb30e55$var$NAComponent,
        linkedPo: undefined,
        linkedPoComponent: $42f48b0cccb30e55$var$NAComponent
    };
}
const $42f48b0cccb30e55$var$naElement = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
    className: "text-secondary",
    children: "N/A"
});
const $42f48b0cccb30e55$var$NAComponent = ()=>$42f48b0cccb30e55$var$naElement;











function $9e9c18720a00945b$export$538b1c0a15ffa4a9(getCellElement) {
    // eslint-disable-next-line react/display-name
    return (cell)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
            children: getCellElement(cell.row.original)
        });
}
function $9e9c18720a00945b$export$c7833dffea95eae0(getCellComponent) {
    // eslint-disable-next-line react/display-name
    return (cell)=>{
        const CellComponent = getCellComponent(cell.row.original);
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(CellComponent, {
            ...cell
        });
    };
}
function $9e9c18720a00945b$export$6bf526352c1a7ddc(getNow, getMax) {
    return (a, b)=>{
        const nowA = getNow(a.original);
        const maxA = getMax(a.original);
        const nowB = getNow(b.original);
        const maxB = getMax(b.original);
        // Calculate the percentage of 'now' to 'max' for both rows
        // If max is 0 and now is also 0, we treat it as the minimum value
        // If max is 0 and now is non-zero, we treat it as the maximum value
        const percentA = maxA ? nowA / maxA : nowA ? 2 : -2;
        const percentB = maxB ? nowB / maxB : nowB ? 2 : -2;
        // Sort by percentage first, then by 'now' value, then by 'max' value
        // NOTE: The last tie-breaker is only used for rows where 'max' is 0 (i.e. sorting 0/1 vs 0/2)
        const sort = percentA - percentB || nowA - nowB || maxA - maxB;
        // With react-table, it is not good enough to return a value > 0 or < 0, we need to return exactly -1, 0, or 1
        // See: https://tanstack.com/table/latest/docs/guide/sorting#custom-sorting-functions
        return sort > 0 ? 1 : sort < 0 ? -1 : 0;
    };
}





// For receipt columns, set the rowspan of each cell on the on the first line to the total number of lines. Hide all subsequent rows for the same receipt
const $bd0cfca70be1cd1f$var$receiptColCellProps = ({ row: row })=>{
    const { receipt: receipt } = row.original;
    const lineItem = "lineItem" in row.original ? row.original.lineItem : undefined;
    const firstLineId = receipt.jobLines[0].id;
    const isFirstLine = lineItem?.id === firstLineId;
    return isFirstLine ? {
        rowSpan: receipt.jobLines.length + receipt.jobReceivingCosts.length
    } : {
        className: "d-none"
    };
};
// Create helpers for defining columns
const $bd0cfca70be1cd1f$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $bd0cfca70be1cd1f$var$itemReceiptAccessorCol = (accessor, column)=>$bd0cfca70be1cd1f$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $bd0cfca70be1cd1f$var$receiptColCellProps
        }
    }, column));
const $bd0cfca70be1cd1f$var$lineItemAccessorCol = (accessor, column)=>$bd0cfca70be1cd1f$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        enableSorting: false
    }, column));
const $bd0cfca70be1cd1f$var$itemReceiptColumns = [
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.number", {
        header: "Item Receipt #",
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "itemreceipt",
                id: row.original.receipt.id,
                label: getValue()
            })
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.date", {
        header: "Date",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: getValue()
            })
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.vendor.name", {
        header: "Vendor",
        meta: {
            cellProps: $bd0cfca70be1cd1f$var$receiptColCellProps
        }
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.vendorReceiptNum", {
        header: "Vendor #"
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.linkedPos", {
        header: "Linked POs",
        cell: ({ row: row, getValue: getValue })=>getValue().map((po, index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                    children: [
                        index > 0 && ", ",
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                            trackerPath: "purchase-orders",
                            children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                                    fromHash: row.id,
                                    urlPath: targetPath,
                                    tooltipContent: `View on '${targetPageTitle}' page`,
                                    type: "purchaseorder",
                                    id: po.id,
                                    lineNumber: 0,
                                    label: po.number
                                })
                        })
                    ]
                }, po.id))
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.currency.code", {
        header: "Currency",
        cell: ({ row: { original: { receipt: receipt } } })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    receipt.currency.code,
                    receipt.vendor.currency && receipt.currency.code !== receipt.vendor.currency.code && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f6bce4f618ea63d9$export$ee48491cfb0c8625), {
                        children: "\u26A0 Mismatch With Vendor"
                    })
                ]
            })
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.exchangeRate", {
        header: "Exchange Rate"
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.jobLinesSummary.categorizedCosts.material.subtotal", {
        header: "Material Costs",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.jobLinesSummary.categorizedCosts.nonMaterial.subtotal", {
        header: "Non-Material Costs",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
    }),
    $bd0cfca70be1cd1f$var$itemReceiptAccessorCol("receipt.jobLinesSummary.categorizedCosts.shipping.subtotal", {
        header: "Shipping Costs",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
    }),
    ...(0, $6169a59e3e4ce096$export$f3bedecf6f49c44b)((row)=>row.receipt.jobLinesSummary.cost, "receipt_jobLinesSummary_cost", {
        meta: {
            cellProps: $bd0cfca70be1cd1f$var$receiptColCellProps
        }
    })
];
const $bd0cfca70be1cd1f$var$lineItemColumns = [
    $bd0cfca70be1cd1f$var$lineItemAccessorCol("normalizedLine.lineNumber", {
        header: "Line #",
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: {
                className: "border-start-double"
            }
        }
    }),
    $bd0cfca70be1cd1f$var$lineItemAccessorCol("normalizedLine.item.name", {
        header: "Item",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: row.original.normalizedLine.item.id,
                        label: row.original.normalizedLine.item.name
                    })
            })
    }),
    $bd0cfca70be1cd1f$var$lineItemAccessorCol("normalizedLine.item.type", {
        header: "Type"
    }),
    $bd0cfca70be1cd1f$var$lineItemAccessorCol("normalizedLine.description", {
        header: "Description",
        cell: (0, $9e9c18720a00945b$export$538b1c0a15ffa4a9)((row)=>row.normalizedLine.descriptionElement)
    }),
    $bd0cfca70be1cd1f$var$lineItemAccessorCol("normalizedLine.uomQuantity", {
        header: "Quantity",
        cell: (0, $9e9c18720a00945b$export$538b1c0a15ffa4a9)((row)=>row.normalizedLine.uomQuantityElement)
    }),
    $bd0cfca70be1cd1f$var$lineItemAccessorCol("normalizedLine.unitCost", {
        header: "Unit Cost",
        cell: (0, $9e9c18720a00945b$export$538b1c0a15ffa4a9)((row)=>row.normalizedLine.unitCostElement)
    }),
    ...(0, $6169a59e3e4ce096$export$f3bedecf6f49c44b)((row)=>row.normalizedLine.totalCost, "normalizedLine_totalCost"),
    $bd0cfca70be1cd1f$var$lineItemAccessorCol("normalizedLine.bin.number", {
        header: "To Bin",
        cell: (0, $9e9c18720a00945b$export$c7833dffea95eae0)((row)=>row.normalizedLine.BinComponent)
    }),
    $bd0cfca70be1cd1f$var$lineItemAccessorCol((row)=>row.normalizedLine.linkedPo?.number, {
        id: "normalizedLine_linkedPo_number",
        header: "Linked PO",
        cell: (0, $9e9c18720a00945b$export$c7833dffea95eae0)((row)=>row.normalizedLine.linkedPoComponent)
    })
];
const $bd0cfca70be1cd1f$export$cd85eaa6b0c19ae1 = [
    $bd0cfca70be1cd1f$var$columnHelper.group({
        header: "Item Receipts",
        columns: $bd0cfca70be1cd1f$var$itemReceiptColumns
    }),
    $bd0cfca70be1cd1f$var$columnHelper.group({
        header: "Line Items",
        columns: $bd0cfca70be1cd1f$var$lineItemColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    })
];


const $52c5ac23337d69f3$var$pricingDetailColumnIds = new Set([
    "receipt_currency_code",
    "receipt_exchangeRate",
    "receipt_jobLinesSummary_categorizedCosts_material_subtotal",
    "receipt_jobLinesSummary_categorizedCosts_nonMaterial_subtotal",
    "receipt_jobLinesSummary_categorizedCosts_shipping_subtotal",
    "normalizedLine_totalCost_tax",
    "normalizedLine_totalCost_total"
]);
const $52c5ac23337d69f3$export$a635edefc4ba2efc = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ itemReceipts: itemReceipts })=>{
    // Persisted column visibility state
    const [columnVisibility, setColumnVisibility, persistedStateActions] = (0, $5711052b6217fc5b$export$ba7dd4b1a46684c1)({
        componentId: "landed-costs-hidden-cols",
        urlKey: "hidden-cols",
        stateSchema: (0, $fdc1026103b282ad$export$1655277b7107d364),
        version: 1,
        defaultState: Object.fromEntries([
            ...$52c5ac23337d69f3$var$pricingDetailColumnIds
        ].map((id)=>[
                id,
                false
            ])),
        urlSerializer: (0, $fdc1026103b282ad$export$2afc421433b63e08)
    });
    // Use hook for toggling visibility on pricing detail columns
    const [showPricingDetails, toggleShowPricingDetails] = (0, $a4fe301f9339adde$export$aeab823c9f913be)($52c5ac23337d69f3$var$pricingDetailColumnIds, columnVisibility, setColumnVisibility);
    // Flatten the list of item receipts into a list of table rows (one row for each line item and receiving cost)
    const data = itemReceipts.flatMap((receipt)=>[
            ...receipt.jobLines.map((lineItem, index)=>({
                    rowId: (0, $9064d462c95211b8$export$f3f8186491bf53ab)("itemreceipt", receipt.id, index),
                    receipt: receipt,
                    lineItem: lineItem,
                    normalizedLine: (0, $42f48b0cccb30e55$export$1bb41df59c3d84c)(lineItem)
                })),
            ...receipt.jobReceivingCosts.map((receivingCost, index)=>({
                    rowId: (0, $9064d462c95211b8$export$f3f8186491bf53ab)("itemreceipt", receipt.id, receipt.jobLines.length + index),
                    receipt: receipt,
                    receivingCost: receivingCost,
                    normalizedLine: (0, $42f48b0cccb30e55$export$96fcdf0ed343e686)(receivingCost, receipt)
                }))
        ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "col-auto mb-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                    className: "row row-cols-auto gx-3 align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4c5bf82a8769709c$export$a67d8389fb37ab06), {
                                id: "filter-pricing-details",
                                label: "Show Detailed Pricing",
                                checked: showPricingDetails,
                                onChange: toggleShowPricingDetails
                            })
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $fdc1026103b282ad$export$861d8392a5ba9dfb), {
                            columns: (0, $bd0cfca70be1cd1f$export$cd85eaa6b0c19ae1),
                            columnVisibility: columnVisibility,
                            onColumnVisibilityChange: setColumnVisibility
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5711052b6217fc5b$export$ba853dbbfb85b659), {
                            ...persistedStateActions
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                className: "col",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                    bordered: true,
                    hover: true,
                    data: data,
                    columns: (0, $bd0cfca70be1cd1f$export$cd85eaa6b0c19ae1),
                    getRowId: ({ rowId: rowId })=>rowId,
                    state: {
                        columnVisibility: columnVisibility
                    },
                    initialState: {
                        sorting: [
                            {
                                id: "receipt_date",
                                desc: true
                            }
                        ]
                    }
                })
            })
        ]
    });
});

















var $itHdT = parcelRequire("itHdT");



"use client";
const $d4d26a2ae6eeb540$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $d4d26a2ae6eeb540$var$onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    $itHdT.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ const element = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($d4d26a2ae6eeb540$var$ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ $itHdT.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function $d4d26a2ae6eeb540$var$getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $d4d26a2ae6eeb540$var$ROUND_PRECISION) / $d4d26a2ae6eeb540$var$ROUND_PRECISION;
}
function $d4d26a2ae6eeb540$var$renderProgressBar({ min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, className: className, style: style, variant: variant, bsPrefix: bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${$d4d26a2ae6eeb540$var$getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const $d4d26a2ae6eeb540$var$ProgressBar = /*#__PURE__*/ $itHdT.forwardRef(({ isChild: isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(props.bsPrefix, 'progress');
    if (isChild) return $d4d26a2ae6eeb540$var$renderProgressBar(props, ref);
    const { min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, bsPrefix: bsPrefix, variant: variant, className: className, children: children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, bsPrefix),
        children: children ? (0, $df3ba9d3de1728c5$export$871de8747c9eaa88)(children, (child)=>/*#__PURE__*/ (0, $itHdT.cloneElement)(child, {
                isChild: true
            })) : $d4d26a2ae6eeb540$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    });
});
$d4d26a2ae6eeb540$var$ProgressBar.displayName = 'ProgressBar';
var $d4d26a2ae6eeb540$export$2e2bcd8739ae039 = $d4d26a2ae6eeb540$var$ProgressBar;




const $2a958b1a6443d7e0$export$a968da95ab584b6f = ({ now: now, max: max, selectedItemUOM: selectedItemUOM, baseUOM: baseUOM })=>{
    // Select a color variant based on the current value (`now`) compared to the maximum value (`max`).
    const variant = now === max ? "success" : now > max ? "danger" : "warning";
    // Calculate what percentage of the bar should be filled; customize logic so that x/0 is always 100%
    const barPercentage = max ? now / max : 1;
    // In some cases, we may need to show the variant as a warning icon because the fill color of the progress bar is not
    // visible enough (i.e. if the now value is 0 there is no colored bar)
    const variantIcon = variant === "success" || barPercentage > 0.1 ? null : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
        className: `ms-1 text-${variant}`,
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
            icon: "exclamation-triangle-fill"
        })
    });
    // Define the default label, which displays the quantity with the selected UOM
    const label = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                quantity: now
            }),
            " / ",
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                quantity: max,
                uom: selectedItemUOM?.uom
            }),
            variantIcon
        ]
    });
    // Optionally wrap the label with a tooltip that shows the base UOM quantity. This is only added if the selected UOM is not the base UOM.
    const labelWithBaseUOMTooltip = !selectedItemUOM || selectedItemUOM.isBase || !baseUOM ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
        className: "progress-bar-label-centered",
        children: label
    }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                    quantity: now
                }),
                " /",
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                    quantity: max,
                    uom: baseUOM
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("a", {
            className: "progress-bar-label-centered",
            children: label
        })
    });
    // If progress is x/0, we need to modify the values passed to the ProgressBar component
    // so that it appears full instead of empty
    const barNow = !max && !now ? 1 : now;
    const barMax = !max ? barNow : max;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d4d26a2ae6eeb540$export$2e2bcd8739ae039), {
        "data-bs-theme": "light",
        now: barNow,
        max: barMax,
        label: labelWithBaseUOMTooltip,
        variant: variant
    });
};












// For po columns, set the rowspan of each cell on the on the first line to the total number of lines. Hide all subsequent rows for the same receipt
const $49da06ff89f52682$var$poColCellProps = (cell, additionalProps)=>{
    const { po: po, line: line } = cell.row.original;
    const firstLineId = po.jobLines[0].id;
    const isFirstLine = line.id === firstLineId;
    return isFirstLine ? {
        ...additionalProps,
        rowSpan: po.jobLines.length
    } : {
        ...additionalProps,
        className: "d-none " + (additionalProps?.className ?? "")
    };
};
// Create helpers for defining columns
const $49da06ff89f52682$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $49da06ff89f52682$var$poAccessorCol = (accessor, column)=>$49da06ff89f52682$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $49da06ff89f52682$var$poColCellProps
        }
    }, column));
const $49da06ff89f52682$var$lineItemAccessorCol = (accessor, column)=>$49da06ff89f52682$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        enableSorting: false
    }, column));
const $49da06ff89f52682$var$poColumns = [
    $49da06ff89f52682$var$poAccessorCol("po.number", {
        header: "PO #",
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "purchaseorder",
                id: row.original.po.id,
                label: getValue()
            })
    }),
    $49da06ff89f52682$var$poAccessorCol("po.date", {
        header: "Date",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: getValue()
            })
    }),
    $49da06ff89f52682$var$poAccessorCol("po.starEmoji", {
        header: "Star",
        meta: {
            cellProps: (cell)=>$49da06ff89f52682$var$poColCellProps(cell, {
                    className: "text-center"
                })
        }
    }),
    $49da06ff89f52682$var$poAccessorCol("po.closed", {
        header: "Closed",
        cell: ({ getValue: getValue })=>getValue() ? "\u2705" : "\u2B1C",
        meta: {
            cellProps: (cell)=>$49da06ff89f52682$var$poColCellProps(cell, {
                    className: "text-center"
                })
        }
    }),
    $49da06ff89f52682$var$poAccessorCol("po.vendor.name", {
        header: "Vendor",
        cell: ({ getValue: getValue, row: { original: original } })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    getValue(),
                    " (",
                    original.po.vendor.currency?.code ?? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f6bce4f618ea63d9$export$ee48491cfb0c8625), {
                        children: "\u26A0 No currency set"
                    }),
                    ")"
                ]
            })
    }),
    $49da06ff89f52682$var$poAccessorCol("po.receivedJobLines", {
        header: "Received Lines",
        sortingFn: (0, $9e9c18720a00945b$export$6bf526352c1a7ddc)(({ po: po })=>po.receivedJobLines, ({ po: po })=>po.jobLines.length),
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2a958b1a6443d7e0$export$a968da95ab584b6f), {
                now: getValue(),
                max: row.original.po.jobLines.length
            })
    }),
    $49da06ff89f52682$var$poAccessorCol("po.linkedReceipts", {
        header: "Linked Item Receipts",
        enableSorting: false,
        cell: ({ row: row, getValue: getValue })=>getValue().map((receipt, index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                    children: [
                        index > 0 && ", ",
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                            trackerPath: "landed-costs",
                            children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                                    fromHash: row.id,
                                    urlPath: targetPath,
                                    tooltipContent: `View on '${targetPageTitle}' page`,
                                    type: "itemreceipt",
                                    id: receipt.id,
                                    lineNumber: 0,
                                    label: receipt.number
                                })
                        })
                    ]
                }, receipt.id))
    }),
    $49da06ff89f52682$var$poAccessorCol("po.currency.code", {
        header: "Currency",
        cell: ({ getValue: getValue, row: { original: original } })=>{
            const poCurrencyCode = getValue();
            const vendorCurrency = original.po.vendor.currency;
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    poCurrencyCode,
                    vendorCurrency && poCurrencyCode !== vendorCurrency.code && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f6bce4f618ea63d9$export$ee48491cfb0c8625), {
                        children: "\u26A0 Mismatch With Vendor"
                    })
                ]
            });
        }
    }),
    $49da06ff89f52682$var$poAccessorCol("po.exchangeRate", {
        header: "Exchange Rate"
    }),
    $49da06ff89f52682$var$poAccessorCol("po.jobLinesSummary.categorizedCosts.material.subtotal", {
        header: "Material Costs",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
    }),
    $49da06ff89f52682$var$poAccessorCol("po.jobLinesSummary.categorizedCosts.nonMaterial.subtotal", {
        header: "Non-Material Costs",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
    }),
    $49da06ff89f52682$var$poAccessorCol("po.jobLinesSummary.categorizedCosts.shipping.subtotal", {
        header: "Shipping Costs",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
    }),
    ...(0, $6169a59e3e4ce096$export$f3bedecf6f49c44b)((row)=>row.po.jobLinesSummary.cost, "po_jobLinesSummary_cost", {
        meta: {
            cellProps: $49da06ff89f52682$var$poColCellProps
        }
    })
];
const $49da06ff89f52682$var$lineItemColumns = [
    $49da06ff89f52682$var$lineItemAccessorCol("line.lineNumber", {
        header: "Line #",
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: {
                className: "border-start-double"
            }
        }
    }),
    $49da06ff89f52682$var$lineItemAccessorCol("line.item.name", {
        header: "Item",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: row.original.line.item.id,
                        label: row.original.line.item.name
                    })
            })
    }),
    $49da06ff89f52682$var$lineItemAccessorCol("line.item.type", {
        header: "Type",
        enableSorting: false
    }),
    $49da06ff89f52682$var$lineItemAccessorCol("line.item.description", {
        header: "Description",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $32df95eb0ee5e5ca$export$d7888f4f62c79646), {
                line: row.original.line
            })
    }),
    $49da06ff89f52682$var$lineItemAccessorCol("line.uomReceived", {
        header: "Received/Quantity",
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2a958b1a6443d7e0$export$a968da95ab584b6f), {
                now: getValue(),
                max: row.original.line.uomQuantity,
                selectedItemUOM: row.original.line.itemUOM,
                baseUOM: row.original.line.item.baseItemUOM?.uom
            })
    }),
    $49da06ff89f52682$var$lineItemAccessorCol("line.linkedLineReceipts", {
        header: "Linked Item Receipts",
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
                children: getValue().map((receipt, index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                        children: [
                            index > 0 && ", ",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                                trackerPath: "landed-costs",
                                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                                        fromHash: row.id,
                                        urlPath: targetPath,
                                        tooltipContent: `View on '${targetPageTitle}' page`,
                                        type: "itemreceipt",
                                        id: receipt.id,
                                        lineNumber: 0,
                                        label: receipt.number
                                    })
                            })
                        ]
                    }, receipt.id))
            })
    }),
    $49da06ff89f52682$var$lineItemAccessorCol("line.unitCost.subtotal", {
        header: "Unit Cost",
        cell: ({ getValue: getValue })=>(0, $bb09d99f2c0a98ec$export$e3370200ec4b4375)(getValue())
    }),
    ...(0, $6169a59e3e4ce096$export$f3bedecf6f49c44b)((row)=>row.line.totalCost, "line_totalCost", {
        enableSorting: false
    })
];
const $49da06ff89f52682$export$9926ec667f750e40 = [
    $49da06ff89f52682$var$columnHelper.group({
        header: "Purchase Orders",
        columns: $49da06ff89f52682$var$poColumns
    }),
    $49da06ff89f52682$var$columnHelper.group({
        header: "Line Items",
        columns: $49da06ff89f52682$var$lineItemColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    })
];


const $c2b10b797f20ebad$var$pricingDetailColumnIds = new Set([
    "po_currency_code",
    "po_exchangeRate",
    "po_jobLinesSummary_categorizedCosts_material_subtotal",
    "po_jobLinesSummary_categorizedCosts_nonMaterial_subtotal",
    "po_jobLinesSummary_categorizedCosts_shipping_subtotal",
    "line_totalCost_tax",
    "line_totalCost_total"
]);
const $c2b10b797f20ebad$export$950cda14659bad14 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ purchaseOrders: purchaseOrders })=>{
    // Persisted column visibility state
    const [columnVisibility, setColumnVisibility, persistedStateActions] = (0, $5711052b6217fc5b$export$ba7dd4b1a46684c1)({
        componentId: "purchase-orders-hidden-cols",
        urlKey: "hidden-cols",
        stateSchema: (0, $fdc1026103b282ad$export$1655277b7107d364),
        version: 1,
        defaultState: Object.fromEntries([
            ...$c2b10b797f20ebad$var$pricingDetailColumnIds
        ].map((id)=>[
                id,
                false
            ])),
        urlSerializer: (0, $fdc1026103b282ad$export$2afc421433b63e08)
    });
    // Use hook for toggling visibility on sets of columns
    const [showPricingDetails, toggleShowPricingDetails] = (0, $a4fe301f9339adde$export$aeab823c9f913be)($c2b10b797f20ebad$var$pricingDetailColumnIds, columnVisibility, setColumnVisibility);
    // Flatten the list of item receipts into a list of table rows (one row for each line item and receiving cost)
    const data = purchaseOrders.flatMap((po)=>po.jobLines.map((line, index)=>({
                rowId: (0, $9064d462c95211b8$export$f3f8186491bf53ab)("purchaseorder", po.id, index),
                po: po,
                line: line
            })));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "col-auto mb-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                    className: "row row-cols-auto gx-3 align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4c5bf82a8769709c$export$a67d8389fb37ab06), {
                                id: "filter-pricing-details",
                                label: "Show Detailed Pricing",
                                checked: showPricingDetails,
                                onChange: toggleShowPricingDetails
                            })
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $fdc1026103b282ad$export$861d8392a5ba9dfb), {
                            columns: (0, $49da06ff89f52682$export$9926ec667f750e40),
                            columnVisibility: columnVisibility,
                            onColumnVisibilityChange: setColumnVisibility
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5711052b6217fc5b$export$ba853dbbfb85b659), {
                            ...persistedStateActions
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                className: "col",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                    bordered: true,
                    hover: true,
                    data: data,
                    columns: (0, $49da06ff89f52682$export$9926ec667f750e40),
                    getRowId: ({ rowId: rowId })=>rowId,
                    state: {
                        columnVisibility: columnVisibility
                    },
                    initialState: {
                        sorting: [
                            {
                                id: "po_date",
                                desc: true
                            }
                        ]
                    }
                })
            })
        ]
    });
});




var $itHdT = parcelRequire("itHdT");






var $itHdT = parcelRequire("itHdT");

function $b761f23ab1616388$export$edccd8c2ceb63567({ filterDefs: filterDefs, data: data, selectedFilterValues: selectedFilterValues }) {
    return (0, $itHdT.useMemo)(()=>{
        // Get the reduced set of data with all filters applied
        const filteredData = $b761f23ab1616388$var$applyFiltersToData(data, filterDefs, selectedFilterValues);
        // Get the facet count for each filter option
        const selectedFilterKeys = Object.keys(selectedFilterValues);
        const facetCounts = Object.fromEntries(selectedFilterKeys.map((key)=>{
            const def = filterDefs[key] ?? (0, $be8f6f33925d422b$export$a2d8f355a4dba7ae)(`Filter definition for key "${String(key)}" not found`);
            const counts = new Map(def.options.map((option)=>{
                // To get the facet count for a specific option, we apply all filters except the current one
                // and then count how many rows match the current option
                // This ensures we get the count of rows that match the current option after applying all other filters
                const subset = $b761f23ab1616388$var$applyFiltersToData(data, filterDefs, selectedFilterValues, key);
                const subsetFilteredByOptionValue = $b761f23ab1616388$var$applySingleFilter(subset, def, option, true);
                return [
                    option,
                    subsetFilteredByOptionValue.length
                ];
            }));
            return [
                key,
                counts
            ];
        }));
        return {
            filteredData: filteredData,
            facetCounts: facetCounts
        };
    }, [
        filterDefs,
        data,
        selectedFilterValues
    ]);
}
/**
 * Applies all the selected filters to the data set using the provided filter definitions.
 */ function $b761f23ab1616388$var$applyFiltersToData(data, filterDefs, selectedFilterValues, /** An optional filter to exclude from the filtering process. */ excludeKey) {
    const selectedFilterKeys = Object.keys(selectedFilterValues);
    const filtersToApply = selectedFilterKeys.filter((key)=>key !== excludeKey);
    return filtersToApply.reduce((filteredData, key)=>{
        const def = filterDefs[key] ?? (0, $be8f6f33925d422b$export$a2d8f355a4dba7ae)(`Filter definition for key "${String(key)}" not found`);
        return $b761f23ab1616388$var$applySingleFilter(filteredData, def, selectedFilterValues[key], false);
    }, data);
}
/** Apply a single filter to a set of data for a given selected filter value. */ function $b761f23ab1616388$var$applySingleFilter(data, filterDef, selectedFilterValue, /** True if this filter is being applied to calculate facet counts, otherwise false. */ facet) {
    // Use the facet predicate if available, otherwise use the regular predicate
    const predicate = facet && filterDef.facetPredicate ? filterDef.facetPredicate : filterDef.predicate;
    return data.filter((row)=>{
        // Apply filter to an array of filter values (any match)
        if (Array.isArray(selectedFilterValue)) return selectedFilterValue.length === 0 || selectedFilterValue.some((v)=>predicate(row, v));
        // Apply filter to a single filter value
        return predicate(row, selectedFilterValue);
    });
}








var $itHdT = parcelRequire("itHdT");











// Define a callback that fades out all cells for non-inventory items
const $7d9c476ac9e7db6d$var$purchasingProgressCellProps = (cell, { ...additionalProps } = {})=>{
    const isNonInventory = cell.row.original.component.item.type === "Non-inventory Item";
    return {
        ...additionalProps,
        className: `${isNonInventory ? "text-body-tertiary" : ""}${additionalProps.className ?? ""}`
    };
};
// Create helpers for defining columns
const $7d9c476ac9e7db6d$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $7d9c476ac9e7db6d$var$accessorCol = (accessor, column)=>$7d9c476ac9e7db6d$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $7d9c476ac9e7db6d$var$purchasingProgressCellProps
        }
    }, column));
const $7d9c476ac9e7db6d$var$itemDetailColumns = [
    $7d9c476ac9e7db6d$var$accessorCol("component.item.name", {
        header: "Item",
        enableHiding: false,
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: row.original.component.item.id,
                        label: row.original.component.item.name
                    })
            })
    }),
    $7d9c476ac9e7db6d$var$accessorCol("component.item.type", {
        header: "Type",
        enableHiding: false,
        sortingFn: (a, b)=>a.original.sortIndexForType - b.original.sortIndexForType
    }),
    $7d9c476ac9e7db6d$var$accessorCol("component.item.description", {
        header: "Description"
    }),
    $7d9c476ac9e7db6d$var$accessorCol((x)=>x.component.item.preferredVendor?.name, {
        id: "component_item_preferredVendor_name",
        header: "Preferred Vendor",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8c7ae95559385c88$export$a8430f3acfbfd10), {
                item: row.original.component.item
            })
    }),
    $7d9c476ac9e7db6d$var$columnHelper.accessor("component.item.leadTimeMs", {
        header: "Lead Time",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1210798d2c8b7bfb$export$87a3dfbb64954554), {
                item: row.original.component.item
            })
    })
];
const $7d9c476ac9e7db6d$var$purchasingProgressColumns = [
    $7d9c476ac9e7db6d$var$accessorCol("quantitiesForSelectedPriority.quantityRequiredForJob", {
        header: "Total Required",
        cell: ({ table: table, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d10bed940359e2e7$export$8d9f20122e3554b1), {
                item: row.original.component.item,
                priority: table.options.meta["priority"]
            }),
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: (cell)=>$7d9c476ac9e7db6d$var$purchasingProgressCellProps(cell, {
                    className: "border-start-double text-end"
                })
        }
    }),
    $7d9c476ac9e7db6d$var$accessorCol("quantitiesForSelectedPriority.existingInventoryQuantity", {
        header: "# From Inventory",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9fabe43876c65327$export$2d62a9888c47eb62), {
                item: row.original.component.item,
                fromRowId: row.id
            }),
        meta: {
            cellProps: (cell)=>$7d9c476ac9e7db6d$var$purchasingProgressCellProps(cell, {
                    className: "text-end"
                })
        }
    }),
    $7d9c476ac9e7db6d$var$accessorCol("quantitiesForSelectedPriority.nonInventoryQuantity", {
        header: "# Required To Purchase",
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                quantity: getValue(),
                uom: row.original.component.item.baseItemUOM?.uom
            }),
        meta: {
            cellProps: (cell)=>$7d9c476ac9e7db6d$var$purchasingProgressCellProps(cell, {
                    className: "text-end"
                })
        }
    }),
    $7d9c476ac9e7db6d$var$accessorCol("numOrdered", {
        header: "# Ordered",
        sortingFn: (0, $9e9c18720a00945b$export$6bf526352c1a7ddc)((row)=>row.numOrdered, (row)=>row.quantitiesForSelectedPriority.nonInventoryQuantity),
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2a958b1a6443d7e0$export$a968da95ab584b6f), {
                now: getValue(),
                max: row.original.quantitiesForSelectedPriority.nonInventoryQuantity,
                selectedItemUOM: row.original.component.item.baseItemUOM,
                baseUOM: row.original.component.item.baseItemUOM?.uom
            })
    }),
    $7d9c476ac9e7db6d$var$accessorCol("numReceived", {
        header: "# Received",
        cell: ({ getValue: getValue, row: row })=>row.original.numOrdered ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2a958b1a6443d7e0$export$a968da95ab584b6f), {
                now: getValue(),
                max: row.original.numOrdered,
                selectedItemUOM: row.original.component.item.baseItemUOM,
                baseUOM: row.original.component.item.baseItemUOM?.uom
            }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                className: "text-body-tertiary",
                children: "N/A"
            })
    }),
    $7d9c476ac9e7db6d$var$accessorCol("numReceivedToSoRack", {
        header: "# Received To SO Rack",
        cell: ({ getValue: getValue, row: row })=>row.original.numReceived ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2a958b1a6443d7e0$export$a968da95ab584b6f), {
                now: getValue(),
                max: row.original.numReceived,
                selectedItemUOM: row.original.component.item.baseItemUOM,
                baseUOM: row.original.component.item.baseItemUOM?.uom
            }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                className: "text-body-tertiary",
                children: "N/A"
            })
    }),
    $7d9c476ac9e7db6d$var$accessorCol("quantitiesByPo", {
        header: "Purchase Orders",
        enableSorting: false,
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($7d9c476ac9e7db6d$var$QuantitiesByPoTableCell, {
                rowId: row.id,
                quantitiesByPo: getValue()
            })
    }),
    $7d9c476ac9e7db6d$var$accessorCol("quantitiesByReceipt", {
        header: "Item Receipts",
        enableSorting: false,
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($7d9c476ac9e7db6d$var$QuantitiesByReceiptTableCell, {
                rowId: row.id,
                quantitiesByReceipt: getValue()
            })
    })
];
const $7d9c476ac9e7db6d$export$15a779abb31d6c5a = [
    $7d9c476ac9e7db6d$var$columnHelper.group({
        header: "Item Details",
        columns: $7d9c476ac9e7db6d$var$itemDetailColumns
    }),
    $7d9c476ac9e7db6d$var$columnHelper.group({
        header: "Purchasing Progress",
        columns: $7d9c476ac9e7db6d$var$purchasingProgressColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    }),
    (0, $6f5dd23132a624ec$export$26ff4a032eb2212)({
        getItemId: (row)=>row.component.item.id
    })
];
const $7d9c476ac9e7db6d$var$QuantitiesByPoTableCell = ({ rowId: rowId, quantitiesByPo: quantitiesByPo })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("pre", {
        children: [
            ...quantitiesByPo.entries()
        ].map(([po, quantity], index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $itHdT.Fragment), {
                children: [
                    index > 0 && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                    quantity.toLocaleString(undefined, {
                        maximumFractionDigits: 5
                    }),
                    " x ",
                    po.starEmoji,
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                        trackerPath: "purchase-orders",
                        children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                                fromHash: rowId,
                                urlPath: targetPath,
                                tooltipContent: `View on '${targetPageTitle}' page`,
                                type: "purchaseorder",
                                id: po.id,
                                lineNumber: 0,
                                label: po.number
                            })
                    })
                ]
            }, index))
    });
const $7d9c476ac9e7db6d$var$QuantitiesByReceiptTableCell = ({ rowId: rowId, quantitiesByReceipt: quantitiesByReceipt })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("pre", {
        children: [
            ...quantitiesByReceipt.entries()
        ].map(([receipt, quantity], index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $itHdT.Fragment), {
                children: [
                    index > 0 && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                    quantity.toLocaleString(undefined, {
                        maximumFractionDigits: 5
                    }),
                    " x",
                    " ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                        trackerPath: "landed-costs",
                        children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                                fromHash: rowId,
                                urlPath: targetPath,
                                tooltipContent: `View on '${targetPageTitle}' page`,
                                type: "itemreceipt",
                                id: receipt.id,
                                label: receipt.number
                            })
                    })
                ]
            }, index))
    });



const $09ce19a454ad7fb9$var$filterDefs = {
    priority: {
        options: (0, $ccba93d7976774da$export$426717e7f687ece8),
        predicate: (row, filterValue)=>filterValue === (0, $ccba93d7976774da$export$cc3cd71de886be2d) || // Show everything when the max priority is selected
            !row.component.onSalesOrder || // Items not on the sales order are always shows regardless of priority
            row.component.quantitiesByPriority.get(filterValue).quantityRequiredForJob > 0
    }
};
const $09ce19a454ad7fb9$export$e2535cb730abfb5d = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ job: job, bomComponents: bomComponents, itemReceipts: itemReceipts, purchaseOrders: purchaseOrders, salesOrderRackBin: salesOrderRackBin })=>{
    // Define state and callback for priority selection
    const [priority, setPriority] = (0, $itHdT.useState)((0, $ccba93d7976774da$export$cc3cd71de886be2d));
    const onPriorityChange = (event)=>{
        setPriority(parseInt(event.target.value, 10));
    };
    // Fetch all purchasing notes for the current job
    const notesByItemIdQuery = (0, $79a9b33d45be89f5$export$8195762461c0e40a)(job.id);
    // Calculate the purchasing progress data
    const purchasingProgress = (0, $itHdT.useMemo)(()=>(0, $b0109774a8e2d22e$export$4ba9c7a995823fdf)(bomComponents, itemReceipts, purchaseOrders, salesOrderRackBin), [
        bomComponents,
        itemReceipts,
        purchaseOrders,
        salesOrderRackBin
    ]);
    // Combine the purchasing progress data, selected priority, and purchasing notes into table rows
    const data = (0, $itHdT.useMemo)(()=>purchasingProgress.map((x)=>({
                ...x,
                rowId: (0, $a23decb4ddcbc17a$export$3e63b58f3f3486b6)("item", x.component.item.id),
                jobId: job.id,
                quantitiesForSelectedPriority: x.component.quantitiesByPriority.get(priority),
                initialNote: notesByItemIdQuery.isLoading ? undefined : notesByItemIdQuery.error ? notesByItemIdQuery.error : notesByItemIdQuery.data.get(x.component.item.id) ?? null
            })), [
        purchasingProgress,
        job.id,
        notesByItemIdQuery,
        priority
    ]);
    // Apply filter and get all filter facet quantities
    const { filteredData: filteredData, facetCounts: facetCounts } = (0, $b761f23ab1616388$export$edccd8c2ceb63567)({
        filterDefs: $09ce19a454ad7fb9$var$filterDefs,
        data: data,
        selectedFilterValues: {
            priority: priority
        }
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "col-auto mb-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                    className: "row row-cols-auto gx-3 align-items-center",
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Group, {
                            className: "form-floating",
                            style: {
                                "--bs-body-color": "var(--bs-dark)",
                                "--bs-body-color-rgb": "var(--bs-dark-rgb)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Select, {
                                    value: priority,
                                    onChange: onPriorityChange,
                                    size: "sm",
                                    style: {
                                        backgroundColor: (0, $ccba93d7976774da$export$39e251832c3f0c85)[priority]
                                    },
                                    children: (0, $ccba93d7976774da$export$426717e7f687ece8).map((option)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("option", {
                                            value: option,
                                            style: {
                                                backgroundColor: (0, $ccba93d7976774da$export$39e251832c3f0c85)[option]
                                            },
                                            children: [
                                                option,
                                                " (",
                                                facetCounts.priority.get(option) ?? 0,
                                                " items)",
                                                option === (0, $ccba93d7976774da$export$cc3cd71de886be2d) ? " (All)" : ""
                                            ]
                                        }, option))
                                }),
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Label, {
                                    children: "Priority"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                className: "col",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                    bordered: true,
                    hover: true,
                    data: filteredData,
                    columns: (0, $7d9c476ac9e7db6d$export$15a779abb31d6c5a),
                    getRowId: ({ rowId: rowId })=>rowId,
                    initialState: {
                        sorting: [
                            {
                                id: "component_item_type",
                                desc: false
                            },
                            {
                                id: "component_item_preferredVendor_name",
                                desc: false
                            },
                            {
                                id: "component_item_name",
                                desc: false
                            }
                        ]
                    },
                    meta: {
                        priority: priority
                    }
                })
            })
        ]
    });
});

















// For shipment/output columns, set the rowspan of each cell on the on the first line to the total number of lines. Hide all subsequent rows for the same receipt
const $b610dafded09c1c5$var$shipmentColCellProps = (cell, additionalProps)=>{
    const { shipment: shipment, line: line } = cell.row.original;
    const firstLineId = shipment.jobLines[0].id;
    const isFirstLine = line.id === firstLineId;
    return isFirstLine ? {
        ...additionalProps,
        rowSpan: shipment.jobLines.length
    } : {
        ...additionalProps,
        className: "d-none " + (additionalProps?.className ?? "")
    };
};
// Create helpers for defining columns
const $b610dafded09c1c5$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $b610dafded09c1c5$var$shipmentAccessorCol = (accessor, column)=>$b610dafded09c1c5$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $b610dafded09c1c5$var$shipmentColCellProps
        }
    }, column));
const $b610dafded09c1c5$var$lineItemAccessorCol = (accessor, column)=>$b610dafded09c1c5$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        enableSorting: false
    }, column));
const $b610dafded09c1c5$var$shipmentColumns = [
    $b610dafded09c1c5$var$shipmentAccessorCol("shipment.number", {
        header: "Shipment #",
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "shipment",
                id: row.original.shipment.id,
                label: getValue()
            })
    }),
    $b610dafded09c1c5$var$shipmentAccessorCol("shipment.date", {
        header: "Date",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: getValue()
            })
    }),
    $b610dafded09c1c5$var$shipmentAccessorCol((x)=>x.shipment.shippingMethod?.name ?? null, {
        id: "shipment.shippingMethod.name",
        header: "Shipping Method"
    }),
    $b610dafded09c1c5$var$shipmentAccessorCol("shipment.trackingNumber", {
        header: "Tracking #",
        cell: ({ row: row, getValue: getValue })=>{
            const trackingNumber = getValue();
            const trackingLink = row.original.shipment.trackingLink;
            if (!trackingLink) return trackingNumber;
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("a", {
                href: trackingLink,
                target: "_blank",
                rel: "noreferrer",
                children: trackingNumber
            });
        }
    })
];
const $b610dafded09c1c5$var$lineItemColumns = [
    $b610dafded09c1c5$var$lineItemAccessorCol("line.lineNumber", {
        header: "Line #",
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: {
                className: "border-start-double"
            }
        }
    }),
    $b610dafded09c1c5$var$lineItemAccessorCol("line.item.name", {
        header: "Item",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: row.original.line.item.id,
                        label: row.original.line.item.name
                    })
            })
    }),
    $b610dafded09c1c5$var$lineItemAccessorCol("line.item.type", {
        header: "Type"
    }),
    $b610dafded09c1c5$var$lineItemAccessorCol("line.item.description", {
        header: "Description",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $32df95eb0ee5e5ca$export$d7888f4f62c79646), {
                line: row.original.line
            })
    }),
    $b610dafded09c1c5$var$lineItemAccessorCol("line.uomQuantity", {
        header: "Quantity",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5e4e43af2ec40d42$export$a33f39dd24777af9), {
                line: row.original.line
            })
    }),
    $b610dafded09c1c5$var$lineItemAccessorCol("line.bin.number", {
        header: "From Bin",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d643190fccb9d64$export$3a4836b3bd8a8af6), {
                bin: row.original.line.bin
            })
    })
];
const $b610dafded09c1c5$export$8034303ddc17bbf9 = [
    $b610dafded09c1c5$var$columnHelper.group({
        header: "Shipments",
        columns: $b610dafded09c1c5$var$shipmentColumns
    }),
    $b610dafded09c1c5$var$columnHelper.group({
        header: "Line Items",
        columns: $b610dafded09c1c5$var$lineItemColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    })
];


const $0dfc6896b7fd4587$export$ba57dca01d4934c7 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ shipments: shipments })=>{
    // Flatten the list of shipments into a list of table rows (one row for each line item)
    const data = shipments.flatMap((shipment)=>shipment.jobLines.map((line, index)=>({
                rowId: (0, $9064d462c95211b8$export$f3f8186491bf53ab)("shipment", shipment.id, index),
                shipment: shipment,
                line: line
            })));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
        className: "col",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
            bordered: true,
            hover: true,
            data: data,
            columns: (0, $b610dafded09c1c5$export$8034303ddc17bbf9),
            getRowId: ({ rowId: rowId })=>rowId,
            initialState: {
                sorting: [
                    {
                        id: "shipment_date",
                        desc: true
                    }
                ]
            }
        })
    });
});












var $itHdT = parcelRequire("itHdT");








// For WO columns, set the rowspan of each cell on the on the first line to the total number of lines. Hide all subsequent rows for the same receipt
const $a90b2d6e910c9822$var$woColCellProps = (cell, additionalProps)=>{
    const { wo: wo, line: line } = cell.row.original;
    const firstLineId = wo.jobLines[0].id;
    const isFirstLine = line.id === firstLineId;
    return isFirstLine ? {
        ...additionalProps,
        rowSpan: wo.jobLines.length
    } : {
        ...additionalProps,
        className: "d-none " + (additionalProps?.className ?? "")
    };
};
// Create helpers for defining columns
const $a90b2d6e910c9822$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $a90b2d6e910c9822$var$woAccessorCol = (accessor, column)=>$a90b2d6e910c9822$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        meta: {
            cellProps: $a90b2d6e910c9822$var$woColCellProps
        }
    }, column));
const $a90b2d6e910c9822$var$lineItemAccessorCol = (accessor, column)=>$a90b2d6e910c9822$var$columnHelper.accessor(accessor, (0, (/*@__PURE__*/$parcel$interopDefault($0dc92cf253a5de95$exports)))({
        enableSorting: false
    }, column));
const $a90b2d6e910c9822$var$woColumns = [
    $a90b2d6e910c9822$var$woAccessorCol("wo.number", {
        header: "WO #",
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "workorder",
                id: row.original.wo.id,
                label: getValue()
            })
    }),
    $a90b2d6e910c9822$var$woAccessorCol("wo.date", {
        header: "Date",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: getValue()
            })
    }),
    $a90b2d6e910c9822$var$woAccessorCol("wo.linkedBuilds", {
        header: "Linked Builds",
        enableSorting: false,
        cell: ({ row: row, getValue: getValue })=>getValue().map((build, index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $itHdT.Fragment), {
                    children: [
                        index > 0 && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                            trackerPath: "builds",
                            children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                                    fromHash: row.id,
                                    urlPath: targetPath,
                                    tooltipContent: `View on '${targetPageTitle}' page`,
                                    type: "build",
                                    id: build.id,
                                    lineNumber: 0,
                                    label: build.number
                                })
                        })
                    ]
                }, build.id))
    }),
    $a90b2d6e910c9822$var$woAccessorCol("wo.receivedJobLines", {
        header: "Line Items Produced",
        sortingFn: (0, $9e9c18720a00945b$export$6bf526352c1a7ddc)(({ wo: wo })=>wo.receivedJobLines, ({ wo: wo })=>wo.jobLines.length),
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2a958b1a6443d7e0$export$a968da95ab584b6f), {
                now: getValue(),
                max: row.original.wo.jobLines.length
            })
    }),
    $a90b2d6e910c9822$var$woAccessorCol("wo.closed", {
        header: "Closed",
        cell: ({ getValue: getValue })=>getValue() ? "\u2705" : "\u2B1C",
        meta: {
            cellProps: (cell)=>$a90b2d6e910c9822$var$woColCellProps(cell, {
                    className: "text-center"
                })
        }
    }),
    $a90b2d6e910c9822$var$woAccessorCol("wo.archived", {
        header: "Archived",
        cell: ({ getValue: getValue })=>getValue() ? "\u2705" : "\u2B1C",
        meta: {
            cellProps: (cell)=>$a90b2d6e910c9822$var$woColCellProps(cell, {
                    className: "text-center"
                })
        }
    })
];
const $a90b2d6e910c9822$var$lineItemColumns = [
    $a90b2d6e910c9822$var$lineItemAccessorCol("line.lineNumber", {
        header: "Line #",
        meta: {
            headerCellProps: {
                className: "border-start-double"
            },
            cellProps: {
                className: "border-start-double"
            }
        }
    }),
    $a90b2d6e910c9822$var$lineItemAccessorCol("line.item.name", {
        header: "Item",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: row.original.line.item.id,
                        label: row.original.line.item.name
                    })
            })
    }),
    $a90b2d6e910c9822$var$lineItemAccessorCol("line.item.description", {
        header: "Description",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $32df95eb0ee5e5ca$export$d7888f4f62c79646), {
                line: row.original.line
            })
    }),
    $a90b2d6e910c9822$var$lineItemAccessorCol("line.produced", {
        header: "Produced/Quantity",
        cell: ({ getValue: getValue, row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2a958b1a6443d7e0$export$a968da95ab584b6f), {
                now: getValue(),
                max: row.original.line.uomQuantity,
                selectedItemUOM: row.original.line.itemUOM,
                baseUOM: row.original.line.item.baseItemUOM?.uom
            })
    }),
    $a90b2d6e910c9822$var$lineItemAccessorCol("line.linkedBuilds", {
        header: "Linked Builds",
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
                children: getValue().map((build, index)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $itHdT.Fragment), {
                        children: [
                            index > 0 && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                                trackerPath: "builds",
                                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9064d462c95211b8$export$195eb2a2e4ef02fe), {
                                        fromHash: row.id,
                                        urlPath: targetPath,
                                        tooltipContent: `View on '${targetPageTitle}' page`,
                                        type: "build",
                                        id: build.id,
                                        lineNumber: 0,
                                        label: build.number
                                    })
                            })
                        ]
                    }, build.id))
            })
    })
];
const $a90b2d6e910c9822$export$d6e11359a8bae4d1 = [
    $a90b2d6e910c9822$var$columnHelper.group({
        header: "Work Orders",
        columns: $a90b2d6e910c9822$var$woColumns
    }),
    $a90b2d6e910c9822$var$columnHelper.group({
        header: "Line Items",
        columns: $a90b2d6e910c9822$var$lineItemColumns,
        meta: {
            headerCellProps: {
                className: "border-start-double"
            }
        }
    })
];


const $2a953047d4b3d104$export$2ebe11bf466082a5 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ workOrders: workOrders })=>{
    // Flatten the list of work orders into a list of table rows (one row for each line item)
    const data = workOrders.flatMap((wo)=>wo.jobLines.map((line, index)=>({
                rowId: (0, $9064d462c95211b8$export$f3f8186491bf53ab)("workorder", wo.id, index),
                wo: wo,
                line: line
            })));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
        className: "col",
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
            bordered: true,
            hover: true,
            data: data,
            columns: (0, $a90b2d6e910c9822$export$d6e11359a8bae4d1),
            getRowId: ({ rowId: rowId })=>rowId,
            initialState: {
                sorting: [
                    {
                        id: "wo_date",
                        desc: true
                    }
                ]
            }
        })
    });
});


/** A copy of `<Route/>` from `react-router`, with the props restricted to only accept paths in the `JobTrackerPath` type */ const $eaeeb144eed6ac3b$var$JobTrackerRoute = (0, $b634fe06a3f61222$export$e7b0ac011bb776c6);
const $eaeeb144eed6ac3b$export$d6a7ea8220714eaa = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
    path: "job/:jobNumber",
    element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6a077366af2550f6$export$2e2bcd8739ae039), {}),
    children: [
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
            index: true,
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$444b3ab0cb9aec40), {
                to: "./details"
            })
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "details",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a606775df21c1f96$export$c8675b494fc9b301), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "financial-summary",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                children: "TODO: Financial Summary"
            })
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "erns",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $466c8efe06d70928$export$2dd503f827ed679b), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "bom-hierarchy",
            Component: (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ salesOrderBomHierarchy: salesOrderBomHierarchy, job: job })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d31443acc6b5459c$export$9144070b323d068b), {
                    bomHierarchy: salesOrderBomHierarchy,
                    job: job
                }))
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "bom-by-component",
            Component: (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ bomComponents: bomComponents, job: job })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $cea6c79945c7dfb7$export$4dbd5fb83a72ab65), {
                    bomComponents: bomComponents,
                    jobId: job.id
                }))
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "existing-inventory",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8668497794e9bea6$export$261918a79b7582b6), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "purchase-orders",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c2b10b797f20ebad$export$950cda14659bad14), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "purchasing-progress",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $09ce19a454ad7fb9$export$e2535cb730abfb5d), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "landed-costs",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $52c5ac23337d69f3$export$a635edefc4ba2efc), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "work-orders",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $2a953047d4b3d104$export$2ebe11bf466082a5), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "work-order-creation",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                children: "TODO: Work Order Creation"
            })
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "builds",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $19417bece9bd7197$export$5026e6aa86fecb8d), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "fabrication-progress",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                children: "TODO: Fabrication Progress"
            })
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($eaeeb144eed6ac3b$var$JobTrackerRoute, {
            path: "shipments",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dfc6896b7fd4587$export$ba57dca01d4934c7), {})
        })
    ]
});
const $eaeeb144eed6ac3b$export$19d2ef56a3b9ec8a = {
    details: "Sales Order Details",
    "financial-summary": "Financial Summary",
    erns: "ERNs",
    "bom-hierarchy": "BOM Hierarchy",
    "bom-by-component": "BOM By Component",
    "existing-inventory": "Existing Inventory",
    "purchase-orders": "Purchase Orders",
    "purchasing-progress": "Purchasing Progress",
    "landed-costs": "Landed Costs",
    "work-orders": "Work Orders",
    "work-order-creation": "Work Order Creation",
    builds: "Builds",
    "fabrication-progress": "Fabrication Progress",
    shipments: "Shipments"
};


const $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0 = ({ trackerPath: trackerPath, children: ChildComponent })=>{
    const routeParams = (0, $b634fe06a3f61222$export$99eaa27ddbbb95ef)();
    const jobNumber = routeParams["jobNumber"];
    if (!jobNumber) throw new Error("No job number found in URL route params");
    const targetPath = `/job/${jobNumber}/${trackerPath}`;
    const targetPageTitle = (0, $eaeeb144eed6ac3b$export$19d2ef56a3b9ec8a)[trackerPath];
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(ChildComponent, {
        targetPath: targetPath,
        targetPageTitle: targetPageTitle
    });
};




const $9fabe43876c65327$export$2d62a9888c47eb62 = (0, $4f97e0b25d4f91a2$export$53cc986057983387)(({ item: item, fromRowId: fromRowId, existingInventoryByItemId: existingInventoryByItemId })=>{
    const existingInventory = existingInventoryByItemId.get(item.id);
    if (!existingInventory) return 0;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
        trigger: "focus",
        overlay: (props)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $53905517a09a4f32$export$2e2bcd8739ae039), {
                ...props,
                style: {
                    ...props.style,
                    "--bs-popover-max-width": "500px"
                },
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $53905517a09a4f32$export$2e2bcd8739ae039).Header, {
                        as: "h3",
                        children: [
                            "Existing Inventory for ",
                            item.name,
                            " ",
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9a0c7d17653de1ec$export$50ccffd7c9e4d6b0), {
                                trackerPath: "existing-inventory",
                                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $58d207e48650f974$export$11e0a2e3e94855e6), {
                                        fromHash: fromRowId,
                                        to: targetPath + "#" + (0, $a23decb4ddcbc17a$export$3e63b58f3f3486b6)("item", item.id),
                                        title: `View on '${targetPageTitle}' page`,
                                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                            icon: "link-45deg"
                                        })
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $53905517a09a4f32$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8e83be46f8eaf7af$export$602bee8c97934705), {
                            item: item,
                            sources: existingInventory.sources,
                            fromRowId: fromRowId
                        })
                    })
                ]
            }),
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("button", {
            className: "btn btn-link p-0",
            title: "Click to see breakdown",
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0eb2778588255d1b$export$ee3a8ac17e8ddb11), {
                quantity: existingInventory.quantity.balance,
                uom: item.baseItemUOM?.uom
            })
        })
    });
});







const $83d4efd9d340e465$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $83d4efd9d340e465$var$itemDetailColumns = [
    $83d4efd9d340e465$var$columnHelper.accessor("item.name", {
        header: "Item",
        enableHiding: false,
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "item",
                id: row.original.item.id,
                label: row.original.item.name
            })
    }),
    $83d4efd9d340e465$var$columnHelper.accessor("item.type", {
        header: "Type"
    }),
    $83d4efd9d340e465$var$columnHelper.accessor("item.description", {
        header: "Description"
    }),
    $83d4efd9d340e465$var$columnHelper.accessor("item.preferredVendor.id", {
        header: "Preferred Vendor",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8c7ae95559385c88$export$a8430f3acfbfd10), {
                item: row.original.item
            })
    }),
    $83d4efd9d340e465$var$columnHelper.accessor("item.purchaseTaxCode", {
        header: "Tax Rate",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4e5d3a028600f3a0$export$95f03250ea71320b), {
                item: row.original.item
            })
    }),
    $83d4efd9d340e465$var$columnHelper.accessor("item.leadTimeMs", {
        header: "Lead Time",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1210798d2c8b7bfb$export$87a3dfbb64954554), {
                item: row.original.item
            })
    }),
    $83d4efd9d340e465$var$columnHelper.accessor("onSalesOrder", {
        header: "On Sales Order",
        cell: ({ getValue: getValue })=>getValue() ? "\u2714" : "\u274C",
        meta: {
            cellProps: {
                className: "text-center align-middle"
            }
        }
    })
];
const $83d4efd9d340e465$var$estimatedUnitCostColumns = (0, $6169a59e3e4ce096$export$f3bedecf6f49c44b)((row)=>row.unitCost, "unitCost");
const $83d4efd9d340e465$var$getEstimatedQuantitiesColumns = (jobId)=>[
        jobId !== null && $83d4efd9d340e465$var$columnHelper.accessor("quantityRequiredForJob", {
            header: "Total Required",
            cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d10bed940359e2e7$export$8d9f20122e3554b1), {
                    item: row.original.item
                })
        }),
        jobId !== null && $83d4efd9d340e465$var$columnHelper.accessor("existingInventoryQuantity", {
            header: "# To/From Inventory",
            cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $9fabe43876c65327$export$2d62a9888c47eb62), {
                    item: row.original.item,
                    fromRowId: row.id
                })
        }),
        $83d4efd9d340e465$var$columnHelper.accessor("numToPurchase", {
            header: "# To Purchase",
            cell: ({ getValue: getValue })=>getValue()?.toLocaleString(undefined, {
                    maximumFractionDigits: 5
                }) ?? "N/A",
            meta: {
                cellProps: ({ getValue: getValue })=>getValue() === undefined ? {
                        className: "text-body-tertiary"
                    } : {}
            }
        }),
        $83d4efd9d340e465$var$columnHelper.accessor("numToBuild", {
            header: "# To Build",
            cell: ({ getValue: getValue })=>getValue()?.toLocaleString(undefined, {
                    maximumFractionDigits: 5
                }) ?? "N/A",
            meta: {
                cellProps: ({ getValue: getValue })=>getValue() === undefined ? {
                        className: "text-body-tertiary"
                    } : {}
            }
        })
    ].filter(Boolean);
const $83d4efd9d340e465$export$b94fb726344caf6b = (jobId)=>[
        $83d4efd9d340e465$var$columnHelper.group({
            header: "Item Details",
            columns: $83d4efd9d340e465$var$itemDetailColumns
        }),
        $83d4efd9d340e465$var$columnHelper.group({
            header: "Estimated Unit Cost",
            columns: $83d4efd9d340e465$var$estimatedUnitCostColumns
        }),
        $83d4efd9d340e465$var$columnHelper.group({
            header: "Estimated Quantities",
            columns: $83d4efd9d340e465$var$getEstimatedQuantitiesColumns(jobId)
        }),
        jobId !== null && (0, $6f5dd23132a624ec$export$26ff4a032eb2212)({
            getItemId: (row)=>row.item.id
        })
    ].filter(Boolean);



const $cea6c79945c7dfb7$export$4dbd5fb83a72ab65 = ({ bomComponents: bomComponents, jobId: jobId })=>{
    const [columnVisibility, setColumnVisibility, persistedStateActions] = (0, $5711052b6217fc5b$export$ba7dd4b1a46684c1)({
        componentId: "bom-by-component-hidden-cols",
        urlKey: "hidden-cols",
        stateSchema: (0, $fdc1026103b282ad$export$1655277b7107d364),
        version: 1,
        defaultState: {},
        urlSerializer: (0, $fdc1026103b282ad$export$2afc421433b63e08)
    });
    // Fetch all purchasing notes for the current job, if a jobId is provided
    const notesByItemIdQuery = (0, $79a9b33d45be89f5$export$8195762461c0e40a)(jobId);
    // Generate the table row data
    const data = (0, $itHdT.useMemo)(()=>bomComponents.map((component)=>{
            const baseRow = {
                rowId: (0, $a23decb4ddcbc17a$export$3e63b58f3f3486b6)("item", component.item.id),
                numToPurchase: component.isAssembly ? undefined : component.nonInventoryQuantity,
                numToBuild: component.isAssembly ? component.nonInventoryQuantity : undefined,
                ...component
            };
            if (jobId === null) return baseRow;
            return {
                ...baseRow,
                jobId: jobId,
                initialNote: notesByItemIdQuery.isLoading ? undefined : notesByItemIdQuery.error ? notesByItemIdQuery.error : notesByItemIdQuery.data?.get(component.item.id) ?? null
            };
        }), [
        bomComponents,
        jobId,
        notesByItemIdQuery
    ]);
    const bomByComponentTableColumns = (0, $83d4efd9d340e465$export$b94fb726344caf6b)(jobId);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "col-auto mb-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                    className: "row row-cols-auto gx-3 align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $fdc1026103b282ad$export$861d8392a5ba9dfb), {
                            columns: bomByComponentTableColumns,
                            columnVisibility: columnVisibility,
                            onColumnVisibilityChange: setColumnVisibility
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5711052b6217fc5b$export$ba853dbbfb85b659), {
                            ...persistedStateActions
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                className: "col",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                    bordered: true,
                    hover: true,
                    data: data,
                    columns: bomByComponentTableColumns,
                    getRowId: ({ rowId: rowId })=>rowId,
                    initialState: {
                        sorting: [
                            {
                                id: "onSalesOrder",
                                desc: true
                            },
                            {
                                id: "item_type",
                                desc: true
                            },
                            {
                                id: "item_name",
                                desc: false
                            }
                        ]
                    },
                    state: {
                        columnVisibility: columnVisibility
                    }
                })
            })
        ]
    });
};










parcelRequire("itHdT");














const $d219f28b3d51c16d$var$estimateSelect = `
  id,
  number,
  date,
  customerMessage,
  comment,
  customer:Customer!inner(id,name),
  lines:EstimateLineItem!inner(
    id,
    lineNumber,
    item:Item!inner(${(0, $6d50882dcfab2b28$export$6bcff91a197a7380)}),
    description,
    uomQuantity:quantity,
    itemUOM:ItemUOM(${(0, $6ce3d2cdf1f3fab7$export$b2d27939239ce27c)}),
    amount,
    taxCode:TaxCode!taxCodeId(id,name,purchaseTaxRate),
    job:Job(id, name)
  ),
  customFieldValues:EstimateCustomFieldValue(*)
`;
async function $d219f28b3d51c16d$export$62969456410a44ae(estimateNumber, CADCurrencyConverter) {
    const estimate = (await (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Estimate").select($d219f28b3d51c16d$var$estimateSelect).eq("number", estimateNumber).eq("deleted", false).eq("lines.deleted", false).throwOnError().limit(1).maybeSingle()).data;
    if (!estimate) throw new Error(`Failed to find an estimate with number ${estimateNumber}`);
    return $d219f28b3d51c16d$var$processEstimate(estimate, CADCurrencyConverter);
}
function $d219f28b3d51c16d$var$processEstimate({ lines: rawLines, ...estimate }, CADCurrencyConverter) {
    const lines = rawLines.map((x)=>$d219f28b3d51c16d$var$processEstimateLineItem(x, CADCurrencyConverter)).sort((a, b)=>a.lineNumber - b.lineNumber);
    return {
        ...estimate,
        lines: lines
    };
}
function $d219f28b3d51c16d$var$processEstimateLineItem(line, CADCurrencyConverter) {
    return {
        ...line,
        baseQuantity: (0, $6ce3d2cdf1f3fab7$export$6e9aa51bb6ca7295)(line.uomQuantity, line.itemUOM),
        item: (0, $6d50882dcfab2b28$export$62232a46d0543a40)(line.item, CADCurrencyConverter),
        quotedTotal: new (0, $f2faaafdab540e00$export$72b98bde8fc72fd9)({
            subtotal: (0, $bb09d99f2c0a98ec$export$828c89097764172d)(line.amount),
            taxCode: line.taxCode
        })
    };
}


async function $35c042223768a07b$export$30e565e0ca566cbb(estimateNumber) {
    const graph = $35c042223768a07b$var$getEstimateTrackingGraph(estimateNumber);
    return await graph.runAll();
}
function $35c042223768a07b$var$getEstimateTrackingGraph(estimateNumber) {
    const graph = new (0, $9d013be4fbfc710e$export$538aafe006ec6bcf)();
    graph.define("exchangeRates", [], ()=>(0, $bc8b83dd69accca9$export$8b1b5d5ff9e1cff2)());
    graph.define("purchasingPriorities", [], ()=>(0, $df9fe021f00c5dd5$export$15335a870ecd6a5b)());
    graph.define("currencies", [
        "exchangeRates"
    ], ({ exchangeRates: exchangeRates })=>(0, $bc8b83dd69accca9$export$8ca924d13649910f)(exchangeRates));
    graph.define("CADCurrencyConverter", [
        "currencies"
    ], ({ currencies: currencies })=>(0, $bc8b83dd69accca9$export$fd948ec30cc2749e)(currencies));
    graph.define("estimate", [
        "CADCurrencyConverter"
    ], ({ CADCurrencyConverter: CADCurrencyConverter })=>(0, $d219f28b3d51c16d$export$62969456410a44ae)(estimateNumber, CADCurrencyConverter));
    graph.define("estimateBomRecords", [
        "estimate",
        "CADCurrencyConverter"
    ], ({ estimate: estimate, CADCurrencyConverter: CADCurrencyConverter })=>(0, $9683b24540f03969$export$fdab0f9c6843bab1)(estimate.lines.map(({ item: item, baseQuantity: quantity })=>({
                item: item,
                quantity: quantity
            })), CADCurrencyConverter));
    graph.define("bomHierarchy", [
        "estimateBomRecords",
        "purchasingPriorities"
    ], ({ estimateBomRecords: estimateBomRecords, purchasingPriorities: purchasingPriorities })=>new (0, $522415699e9e4669$export$8331bd18d884bb15)(purchasingPriorities).generate(estimateBomRecords));
    graph.define("bomComponents", [
        "bomHierarchy"
    ], ({ bomHierarchy: bomHierarchy })=>(0, $62e16125ac3b96f9$export$2952bc636db38024)(bomHierarchy, []));
    graph.define("bomComponentsByItemId", [
        "bomComponents"
    ], ({ bomComponents: bomComponents })=>new Map(bomComponents.map((x)=>[
                x.item.id,
                x
            ])));
    return graph;
}


function $d6709b982d6f1c59$export$b56ad4ae025756e6(estimateNumber) {
    return [
        "EstimateTracking",
        estimateNumber
    ];
}
function $d6709b982d6f1c59$export$d542199f0d5ab885(WrappedComponent) {
    return function WithEstimateTrackingData(props) {
        const estimateNumber = (0, $b634fe06a3f61222$export$99eaa27ddbbb95ef)().estimateNumber;
        const estimateQuery = (0, $b262411d05d5989d$export$ad4afeb3151d80fa)({
            queryKey: $d6709b982d6f1c59$export$b56ad4ae025756e6(estimateNumber),
            queryFn: async ()=>await (0, $35c042223768a07b$export$30e565e0ca566cbb)(estimateNumber),
            retry: false
        });
        if (estimateQuery.isError) return `Error loading estimate: ${estimateQuery.error.message}`;
        if (estimateQuery.isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d8ed0f693b57ae21$export$1afe2b5a93b67b3), {
            text: "Loading estimate"
        });
        const combinedProps = {
            ...estimateQuery.data,
            ...props
        };
        return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(WrappedComponent, {
            ...combinedProps
        });
    };
}











const $62ac8f842305cf3e$export$a10a6291a58bb4d0 = ({ trackerPath: trackerPath, children: ChildComponent })=>{
    const routeParams = (0, $b634fe06a3f61222$export$99eaa27ddbbb95ef)();
    const estimateNumber = routeParams["estimateNumber"];
    if (!estimateNumber) throw new Error("No estimate number found in URL route params");
    const targetPath = `/estimate/${estimateNumber}/${trackerPath}`;
    const targetPageTitle = (0, $0876dd8dcb246aa0$export$a6547ae99e520edb)[trackerPath];
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(ChildComponent, {
        targetPath: targetPath,
        targetPageTitle: targetPageTitle
    });
};


const $fe7c340b6472f49b$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $fe7c340b6472f49b$var$lineDetailColumns = [
    $fe7c340b6472f49b$var$columnHelper.accessor("lineNumber", {
        header: "#"
    }),
    $fe7c340b6472f49b$var$columnHelper.accessor("item.name", {
        header: "Item",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $62ac8f842305cf3e$export$a10a6291a58bb4d0), {
                trackerPath: "bom-by-component",
                children: ({ targetPath: targetPath, targetPageTitle: targetPageTitle })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a23decb4ddcbc17a$export$8a6bf4e459a8d696), {
                        fromHash: row.id,
                        urlPath: targetPath,
                        tooltipContent: `View on '${targetPageTitle}' page`,
                        type: "item",
                        id: row.original.item.id,
                        label: row.original.item.name
                    })
            })
    }),
    $fe7c340b6472f49b$var$columnHelper.accessor("description", {
        header: "Description",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $32df95eb0ee5e5ca$export$d7888f4f62c79646), {
                line: row.original
            })
    }),
    $fe7c340b6472f49b$var$columnHelper.accessor("uomQuantity", {
        header: "Quantity",
        cell: ({ row: row })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $5e4e43af2ec40d42$export$a33f39dd24777af9), {
                line: row.original
            })
    })
];
const $fe7c340b6472f49b$var$estimatedCostColumns = [
    (0, $6169a59e3e4ce096$export$5d654c3b511cb463)((row)=>row.labour, "labour", {
        header: "Labour",
        useErrorPopover: true
    }),
    (0, $6169a59e3e4ce096$export$5d654c3b511cb463)((row)=>row.cogs, "cogs", {
        header: "COGS",
        useErrorPopover: true
    }),
    ...(0, $6169a59e3e4ce096$export$f3bedecf6f49c44b)((row)=>row.total, "total", {
        useErrorPopover: true
    })
];
const $fe7c340b6472f49b$var$quotedCostColumns = (0, $6169a59e3e4ce096$export$f3bedecf6f49c44b)((row)=>row.quotedTotal, "quotedTotal");
const $fe7c340b6472f49b$export$d9f5b07c28552429 = [
    $fe7c340b6472f49b$var$columnHelper.group({
        header: "Line Details",
        columns: $fe7c340b6472f49b$var$lineDetailColumns
    }),
    $fe7c340b6472f49b$var$columnHelper.group({
        header: "Estimated Costs",
        columns: $fe7c340b6472f49b$var$estimatedCostColumns
    }),
    $fe7c340b6472f49b$var$columnHelper.group({
        header: "Quoted Cost",
        columns: $fe7c340b6472f49b$var$quotedCostColumns
    })
];


function $036cab8e5125afe8$export$3f30ee9d3900ec59(line, index, bomHierarchy) {
    const bomHierarchyNode = bomHierarchy[index];
    const total = bomHierarchyNode.lineItemCost;
    const labour = bomHierarchyNode.categorizedLineItemCosts.labour;
    const cogs = total.subtract(labour);
    return {
        ...line,
        bomHierarchyNode: bomHierarchyNode,
        labour: labour,
        cogs: cogs,
        total: total
    };
}



const $4ef542b0f9cd0b1e$export$485fdd76693062c6 = (0, $d6709b982d6f1c59$export$d542199f0d5ab885)(({ estimate: estimate, bomHierarchy: bomHierarchy })=>{
    const orderDetails = [
        {
            label: "Estimate #",
            value: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "estimate",
                id: estimate.id,
                label: estimate.number
            })
        },
        {
            label: "Evolved Opportunity #",
            value: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getNumberValue(estimate, "evolvedOpportunityNumber") || "N/A"
        },
        {
            label: "Date",
            value: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: estimate.date
            })
        },
        {
            label: "Customer",
            value: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "customer",
                id: estimate.customer.id,
                label: estimate.customer.name
            })
        }
    ];
    const tableData = estimate.lines.map((line, index)=>(0, $036cab8e5125afe8$export$3f30ee9d3900ec59)(line, index, bomHierarchy));
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "col-auto",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("dl", {
                    className: "row",
                    children: [
                        orderDetails.map(({ label: label, value: value }, index, array)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                                className: "col-12 col-md-6 col-lg-4 col-xl-3",
                                children: [
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dt", {
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dd", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))({
                                            "m-0": index === array.length - 1
                                        }),
                                        children: value
                                    })
                                ]
                            }, label)),
                        estimate.customerMessage && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                            className: "col-12 col-lg-6",
                            children: [
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dt", {
                                    children: "Customer Message"
                                }),
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dd", {
                                    className: "text-pre-wrap",
                                    children: estimate.customerMessage
                                })
                            ]
                        }),
                        estimate.comment && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                            className: "col-12 col-lg-6",
                            children: [
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dt", {
                                    children: "Memo"
                                }),
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("dd", {
                                    className: "text-pre-wrap",
                                    children: estimate.comment
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                className: "col",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                    bordered: true,
                    hover: true,
                    columns: (0, $fe7c340b6472f49b$export$d9f5b07c28552429),
                    data: tableData,
                    initialState: {
                        sorting: [
                            {
                                id: "lineNumber",
                                desc: false
                            }
                        ]
                    }
                })
            })
        ]
    });
});



parcelRequire("itHdT");








const $29be6b98b36aee17$export$271f9f08425019c7 = ()=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
        className: "mt-5",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("h1", {
                children: "404 - Not Found"
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("p", {
                children: [
                    "The requested resource cannot be found. You can try to navigate back in your browser, or return",
                    " ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: "home"
                    }),
                    "."
                ]
            })
        ]
    });





const $c08532426efeaff6$export$4979ae88ec4a302b = ()=>{
    // Get the estimate number from the URL route parameters
    const params = (0, $b634fe06a3f61222$export$99eaa27ddbbb95ef)();
    if (!params["estimateNumber"]) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $29be6b98b36aee17$export$271f9f08425019c7), {});
    const estimateNumber = params["estimateNumber"];
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039), {
        activeKey: window.location.href,
        className: "flex-column nav-pills",
        style: {
            "--bs-nav-pills-border-radius": 0
        },
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                className: "text-wrap px-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("h2", {
                    children: estimateNumber
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/estimate/${estimateNumber}/details`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "file-text",
                            className: "me-2"
                        }),
                        "Estimate Details"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/estimate/${estimateNumber}/bom-hierarchy`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "list-nested",
                            className: "me-2"
                        }),
                        "BOM Hierarchy"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dd5ea25fd6bb92a1$export$2e2bcd8739ae039).Item, {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $4ffce360de2f2a65$export$d556a17c56488edc), {
                    to: `/estimate/${estimateNumber}/bom-by-component`,
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                            icon: "list",
                            className: "me-2"
                        }),
                        "BOM By Component"
                    ]
                })
            })
        ]
    });
};





const $6c07a5cc6a60d1a0$export$cb7d309eea4fa31b = ({ children: children })=>{
    // Extract the tracker path from the current URL path
    const location = (0, $b634fe06a3f61222$export$45d76561a5302f2b)();
    const trackerPath = /estimate\/[^/]+\/([^/]+)/.exec(location.pathname)?.[1];
    // Get the page title based on the tracker path
    const pageTitle = trackerPath ? (0, $0876dd8dcb246aa0$export$a6547ae99e520edb)[trackerPath] : null;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3d04577e83656c0d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
            className: "d-flex flex-column h-100",
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("h2", {
                        className: "mb-3",
                        children: pageTitle
                    })
                }),
                children
            ]
        })
    });
};


const $4113548ced4f19b5$export$1c353503d591342d = ()=>{
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        className: "d-flex h-100",
        children: [
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                className: "flex-grow-0 flex-shrink-0 bg-secondary-subtle py-3 me-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c08532426efeaff6$export$4979ae88ec4a302b), {})
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
                fluid: true,
                className: "flex-grow-1 overflow-y-auto py-3",
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $efb8a5333b785146$export$e926676385687eaf), {
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6c07a5cc6a60d1a0$export$cb7d309eea4fa31b), {
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$910ae8079b2c2852), {})
                    })
                })
            })
        ]
    });
};



/** A copy of `<Route/>` from `react-router`, with the props restricted to only accept paths in the `JobTrackerPath` type */ const $0876dd8dcb246aa0$var$EstimateTrackerRoute = (0, $b634fe06a3f61222$export$e7b0ac011bb776c6);
const $0876dd8dcb246aa0$export$15070f52b03544ce = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
    path: "estimate/:estimateNumber",
    element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4113548ced4f19b5$export$1c353503d591342d), {}),
    children: [
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
            index: true,
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$444b3ab0cb9aec40), {
                to: "./details"
            })
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($0876dd8dcb246aa0$var$EstimateTrackerRoute, {
            path: "details",
            element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $4ef542b0f9cd0b1e$export$485fdd76693062c6), {})
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($0876dd8dcb246aa0$var$EstimateTrackerRoute, {
            path: "bom-hierarchy",
            Component: (0, $d6709b982d6f1c59$export$d542199f0d5ab885)(({ bomHierarchy: bomHierarchy })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d31443acc6b5459c$export$9144070b323d068b), {
                    bomHierarchy: bomHierarchy
                }))
        }),
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($0876dd8dcb246aa0$var$EstimateTrackerRoute, {
            path: "bom-by-component",
            Component: (0, $d6709b982d6f1c59$export$d542199f0d5ab885)(({ bomComponents: bomComponents })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $cea6c79945c7dfb7$export$4dbd5fb83a72ab65), {
                    bomComponents: bomComponents,
                    jobId: null
                }))
        })
    ]
});
const $0876dd8dcb246aa0$export$a6547ae99e520edb = {
    details: "Estimate Details",
    "bom-hierarchy": "BOM Hierarchy",
    "bom-by-component": "BOM By Component"
};





var $itHdT = parcelRequire("itHdT");


// NOTE: This file is copied from the google-apps-script repository, in which it is generated automatically using the supabase CLI
const $82326dc839e10563$export$a002182e51710d39 = {
    graphql_public: {
        Enums: {}
    },
    public: {
        Enums: {
            CustomFieldDataType: [
                "Text",
                "Boolean",
                "List",
                "Number",
                "TextArea",
                "Date",
                "Money"
            ],
            EstimateStatus: [
                "Accepted",
                "Pending",
                "Closed",
                "Rejected"
            ],
            ItemType: [
                "Inventory Item",
                "Non-inventory Item",
                "Category",
                "Expense",
                "Assembly",
                "Item Group",
                "Service",
                "Labor",
                "Overhead",
                "Other"
            ],
            LongRunningGasRequestStatus: [
                "pending",
                "processing",
                "completed"
            ],
            ReceivedStatus: [
                "",
                "All",
                "Some"
            ]
        }
    }
};












const $7f58137812028252$var$estimateListQuery = (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Estimate").select("*, customer:Customer(id,name,billing), customFieldValues:EstimateCustomFieldValue(*)").eq("deleted", false).order("date", {
    ascending: false
}).throwOnError();
const $7f58137812028252$export$af4a43298f925143 = (0, $e7c296f6690d0391$export$9a8e3100474fe331)({
    queryKey: [
        "Estimate",
        "list"
    ],
    queryFn: async ()=>(await $7f58137812028252$var$estimateListQuery).data
});


const $1cd31cfc234b85db$var$estimateStatuses = [
    "All",
    ...(0, $82326dc839e10563$export$a002182e51710d39).public.Enums.EstimateStatus
];
const $1cd31cfc234b85db$var$filterDefs = {
    status: {
        options: $1cd31cfc234b85db$var$estimateStatuses,
        predicate: (job, status)=>status === "All" || job.status === status
    },
    archived: {
        options: [
            true,
            false
        ],
        predicate: (job, includeArchived)=>includeArchived || !job.archived,
        facetPredicate: (job, _includeArchived)=>job.archived
    }
};
const $1cd31cfc234b85db$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $1cd31cfc234b85db$var$columns = [
    $1cd31cfc234b85db$var$columnHelper.accessor("number", {
        header: "Estimate #",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$a6c7ac8248d6e38a), {
                to: `/estimate/${getValue()}/details`,
                className: "stretched-link",
                children: getValue()
            })
    }),
    $1cd31cfc234b85db$var$columnHelper.accessor("date", {
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: getValue()
            })
    }),
    $1cd31cfc234b85db$var$columnHelper.accessor("status", {
        header: "Status"
    }),
    $1cd31cfc234b85db$var$columnHelper.accessor("brand", {
        header: "Brand"
    }),
    $1cd31cfc234b85db$var$columnHelper.accessor("evolvedOpportunityNumber", {
        header: "Evolved #"
    }),
    $1cd31cfc234b85db$var$columnHelper.accessor((x)=>x.customer.name, {
        id: "customer.name",
        header: "Customer"
    }),
    $1cd31cfc234b85db$var$columnHelper.accessor("customerBillingAddress", {
        header: "Customer Location"
    }),
    $1cd31cfc234b85db$var$columnHelper.accessor("customerMessage", {
        header: "Customer Message",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                className: "text-pre-wrap",
                children: getValue()
            }),
        meta: {
            cellProps: {
                className: "w-100",
                style: {
                    minWidth: 300
                }
            }
        }
    }),
    $1cd31cfc234b85db$var$columnHelper.accessor("comment", {
        header: "Memo",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                className: "text-pre-wrap",
                children: getValue()
            }),
        meta: {
            cellProps: {
                className: "w-100",
                style: {
                    minWidth: 300
                }
            }
        }
    })
];
const $1cd31cfc234b85db$export$a58670a25a3489b = ()=>{
    // Define State
    const [showStatus, setShowStatus] = (0, $itHdT.useState)("All");
    const [showArchived, setShowArchived] = (0, $itHdT.useState)(false);
    // Define callbacks
    const onShowStatusChanged = (0, $itHdT.useCallback)((e)=>{
        setShowStatus(e.target.value);
    }, []);
    const toggleShowArchived = (0, $itHdT.useCallback)(()=>{
        setShowArchived(!showArchived);
    }, [
        showArchived
    ]);
    // Fetch data
    const estimateQuery = (0, $b262411d05d5989d$export$ad4afeb3151d80fa)({
        ...(0, $7f58137812028252$export$af4a43298f925143),
        select: (data)=>data.map((estimate)=>({
                    ...estimate,
                    customerBillingAddress: $1cd31cfc234b85db$var$formatCustomerLocation(estimate.customer),
                    brand: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getListValue(estimate, "brand") || "",
                    evolvedOpportunityNumber: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getNumberValue(estimate, "evolvedOpportunityNumber")
                }))
    });
    // Apply filter and get all filter facet quantities
    const { filteredData: filteredData, facetCounts: facetCounts } = (0, $b761f23ab1616388$export$edccd8c2ceb63567)({
        filterDefs: $1cd31cfc234b85db$var$filterDefs,
        data: estimateQuery.data ?? [],
        selectedFilterValues: {
            status: showStatus,
            archived: showArchived
        }
    });
    // Handle loading and error states
    if (estimateQuery.isError) return `Error loading orders: ${estimateQuery.error.message}`;
    if (estimateQuery.isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d8ed0f693b57ae21$export$1afe2b5a93b67b3), {
        text: "Loading Orders"
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $efb8a5333b785146$export$e926676385687eaf), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
            fluid: true,
            className: "py-3 h-100 d-flex flex-column",
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                    className: "col-auto",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("h2", {
                            children: [
                                "Estimates",
                                " ",
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("small", {
                                    className: "text-body-secondary",
                                    children: [
                                        "(Displaying ",
                                        filteredData.length,
                                        " of ",
                                        estimateQuery.data.length,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("p", {
                            className: "lead",
                            children: "Click on a row to load a detailed breakdown for that estimate."
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                            className: "overflow-hidden mb-3",
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                                className: "row row-cols-auto gx-4 align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                                        children: "Filters:"
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Group, {
                                            className: "form-floating",
                                            children: [
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Select, {
                                                    value: showStatus,
                                                    onChange: onShowStatusChanged,
                                                    className: "w-auto",
                                                    children: $1cd31cfc234b85db$var$estimateStatuses.map((status)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("option", {
                                                            value: status,
                                                            children: [
                                                                status,
                                                                " (",
                                                                facetCounts.status.get(status),
                                                                ")"
                                                            ]
                                                        }, status))
                                                }),
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Label, {
                                                    children: "Status"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Check, {
                                        type: "switch",
                                        label: `Show Archived (${facetCounts.archived.get(true).toFixed(0)})`,
                                        checked: showArchived,
                                        onChange: toggleShowArchived
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                    className: "col",
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                        bordered: true,
                        hover: true,
                        className: "table-constrain-column-widths",
                        columns: $1cd31cfc234b85db$var$columns,
                        data: filteredData,
                        initialState: {
                            sorting: [
                                {
                                    id: "date",
                                    desc: true
                                }
                            ]
                        },
                        // Add relative positioning to the data rows so that we can use the 'stretched-link' class
                        meta: {
                            dataRowProps: {
                                className: "position-relative"
                            }
                        }
                    })
                })
            ]
        })
    });
};
function $1cd31cfc234b85db$var$formatCustomerLocation(customer) {
    if (!customer) return "";
    const { city: city, stateProvince: stateProvince, country: country } = customer.billing;
    return [
        city,
        stateProvince,
        country
    ].filter((x)=>x).join(", ");
}






var $itHdT = parcelRequire("itHdT");









const $99afabb9f86b636a$var$ncrJobsQuery = (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Job").select("*, customer:Customer(id,name,billing), customFieldValues:JobCustomFieldValue(*)").eq("deleted", false).like("number", "NCR-____").order("number", {
    ascending: false
}).throwOnError();
const $99afabb9f86b636a$export$639b993458acff62 = (0, $e7c296f6690d0391$export$9a8e3100474fe331)({
    queryKey: [
        "Job",
        "ncr"
    ],
    queryFn: async ()=>(await $99afabb9f86b636a$var$ncrJobsQuery).data
});


const $700eb699397b8db1$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $700eb699397b8db1$var$columns = [
    $700eb699397b8db1$var$columnHelper.accessor("number", {
        header: "NCR #",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$a6c7ac8248d6e38a), {
                to: `/job/${getValue()}/details`,
                className: "stretched-link",
                children: getValue()
            })
    }),
    $700eb699397b8db1$var$columnHelper.accessor("description", {
        header: "Notes",
        meta: {
            cellProps: {
                className: "text-pre-line"
            }
        }
    }),
    $700eb699397b8db1$var$columnHelper.accessor("closed", {
        header: "Status",
        cell: ({ getValue: getValue })=>getValue() ? "Inactive" : "Active"
    })
];
const $700eb699397b8db1$export$bb608f429abc947f = ()=>{
    // Define State
    const [showClosed, setShowClosed] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState(false);
    const [showArchived, setShowArchived] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState(false);
    // Define callbacks
    const toggleShowClosed = (0, $itHdT.useCallback)(()=>{
        setShowClosed(!showClosed);
    }, [
        showClosed
    ]);
    const toggleShowArchived = (0, $itHdT.useCallback)(()=>{
        setShowArchived(!showArchived);
    }, [
        showArchived
    ]);
    // Fetch data
    const jobQuery = (0, $b262411d05d5989d$export$ad4afeb3151d80fa)((0, $99afabb9f86b636a$export$639b993458acff62));
    // Filter and map query data into table format
    // NOTE: We aren't using the 'select' option in the query because we want to show the user the number of unfiltered records
    // Note: Use the useMemo hook here so that we aren't recomputing the table data on every render
    const tableData = (0, $itHdT.useMemo)(()=>{
        return (jobQuery.data ?? []).filter((x)=>showClosed || !x.closed).filter((x)=>showArchived || !x.archived);
    }, [
        jobQuery.data,
        showClosed,
        showArchived
    ]);
    // Calculate some number for displaying on the filters
    const numClosed = jobQuery.data?.filter((x)=>x.closed).length ?? 0;
    const numArchived = jobQuery.data?.filter((x)=>x.archived).length ?? 0;
    // Handle loading and error states
    if (jobQuery.isError) return `Error loading NCRs: ${jobQuery.error.message}`;
    if (jobQuery.isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d8ed0f693b57ae21$export$1afe2b5a93b67b3), {
        text: "Loading NCRs"
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $efb8a5333b785146$export$e926676385687eaf), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
            fluid: true,
            className: "py-3 h-100 d-flex flex-column",
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                    className: "col-auto",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("h2", {
                            children: [
                                "NCRs",
                                " ",
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("small", {
                                    className: "text-body-secondary",
                                    children: [
                                        "(Displaying ",
                                        tableData.length,
                                        " of ",
                                        jobQuery.data.length,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("p", {
                            className: "lead",
                            children: "Click on a row to load the detailed tracker for that NCR."
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                            className: "overflow-hidden mb-3",
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                                className: "row row-cols-auto g-4 align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                                        children: "Filters:"
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Check, {
                                        type: "switch",
                                        label: `Show Closed (${numClosed.toFixed()})`,
                                        checked: showClosed,
                                        onChange: toggleShowClosed
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Check, {
                                        type: "switch",
                                        label: `Show Archived (${numArchived.toFixed()})`,
                                        checked: showArchived,
                                        onChange: toggleShowArchived
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                    className: "col",
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                        bordered: true,
                        hover: true,
                        columns: $700eb699397b8db1$var$columns,
                        data: tableData,
                        initialState: {
                            sorting: [
                                {
                                    id: "number",
                                    desc: true
                                }
                            ]
                        },
                        // Add relative positioning to the data rows so that we can use the 'stretched-link' class
                        meta: {
                            dataRowProps: {
                                className: "position-relative"
                            }
                        }
                    })
                })
            ]
        })
    });
};





var $itHdT = parcelRequire("itHdT");












const $d1851566cb2cf35f$var$orderJobsQuery = (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Job").select("*, customer:Customer(id,name,billing), customFieldValues:JobCustomFieldValue(*)").eq("deleted", false).or("number.like.SO-____,number.like.DO-____,number.like.RO-____").order("id", {
    ascending: false
}).throwOnError();
const $d1851566cb2cf35f$export$28b6fc3aeca6ff36 = (0, $e7c296f6690d0391$export$9a8e3100474fe331)({
    queryKey: [
        "Job",
        "order"
    ],
    queryFn: async ()=>(await $d1851566cb2cf35f$var$orderJobsQuery).data
});


const $7781990a95f064e2$var$orderTypes = [
    "All",
    "Sales Order",
    "Design Order",
    "Research Order"
];
const $7781990a95f064e2$var$filterDefs = {
    closed: {
        options: [
            true,
            false
        ],
        predicate: (job, includeClosed)=>includeClosed || !job.closed,
        facetPredicate: (job, _includeClosed)=>job.closed
    },
    archived: {
        options: [
            true,
            false
        ],
        predicate: (job, includeArchived)=>includeArchived || !job.archived,
        facetPredicate: (job, _includeArchived)=>job.archived
    },
    type: {
        options: $7781990a95f064e2$var$orderTypes,
        predicate: (job, filterValue)=>{
            if (filterValue === "All") return true;
            if (filterValue === "Sales Order") return job.name.startsWith("SO-");
            if (filterValue === "Design Order") return job.name.startsWith("DO-");
            return job.name.startsWith("RO-");
        }
    }
};
const $7781990a95f064e2$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $7781990a95f064e2$var$columns = [
    $7781990a95f064e2$var$columnHelper.accessor("number", {
        header: "Order #",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$a6c7ac8248d6e38a), {
                to: `/job/${getValue()}/details`,
                className: "stretched-link",
                children: getValue()
            })
    }),
    $7781990a95f064e2$var$columnHelper.accessor("brand", {
        header: "Brand"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("evolvedOpportunityNumber", {
        header: "Evolved #"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("serviceEstimateOpportunityNumber", {
        header: "Evolved # (Service Estimate)"
    }),
    $7781990a95f064e2$var$columnHelper.accessor((x)=>x.customer?.name, {
        id: "customer.name",
        header: "Customer"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("customerBillingAddress", {
        header: "Customer Location"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("saleType", {
        header: "Sale Type"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("model", {
        header: "Model"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("pressureSystem", {
        header: "Pressure System",
        cell: ({ getValue: getValue })=>getValue() ? "\u2705" : "\u2B1C",
        meta: {
            cellProps: {
                className: "text-center"
            }
        }
    }),
    $7781990a95f064e2$var$columnHelper.accessor("pressureCertification", {
        header: "Pressure Certification"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("electricalDesigner", {
        header: "Electrical Designer"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("mechanicalDesigner", {
        header: "Mechanical Designer"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("orderName", {
        header: "Order Name"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("notes", {
        header: "Notes"
    }),
    $7781990a95f064e2$var$columnHelper.accessor("dateOpened", {
        header: "Date Opened",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: getValue()
            })
    }),
    $7781990a95f064e2$var$columnHelper.accessor("dateClosed", {
        header: "Date Closed",
        cell: ({ getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bf8d0f8e8c0dd86a$export$68962dbd27cd2e36), {
                date: getValue()
            })
    }),
    $7781990a95f064e2$var$columnHelper.accessor("closed", {
        header: "Status",
        cell: ({ getValue: getValue })=>getValue() ? "Inactive" : "Active"
    })
];
const $7781990a95f064e2$export$87a9b7f4d9e281bd = ()=>{
    // Define State
    const [showClosed, setShowClosed] = (0, $itHdT.useState)(false);
    const [showArchived, setShowArchived] = (0, $itHdT.useState)(false);
    const [showTypes, setShowTypes] = (0, $itHdT.useState)("All");
    // Define callbacks
    const toggleShowClosed = (0, $itHdT.useCallback)(()=>{
        setShowClosed(!showClosed);
    }, [
        showClosed
    ]);
    const toggleShowArchived = (0, $itHdT.useCallback)(()=>{
        setShowArchived(!showArchived);
    }, [
        showArchived
    ]);
    const onShowTypeChanged = (0, $itHdT.useCallback)((e)=>{
        setShowTypes(e.target.value);
    }, []);
    // Fetch data
    const jobQuery = (0, $b262411d05d5989d$export$ad4afeb3151d80fa)({
        ...(0, $d1851566cb2cf35f$export$28b6fc3aeca6ff36),
        select: (data)=>{
            return data.map((job)=>{
                const orderName = (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(job, "orderName") || "";
                return {
                    ...job,
                    orderName: orderName,
                    notes: (job.description ?? "").replace(orderName, "").trim(),
                    customerBillingAddress: $7781990a95f064e2$var$formatCustomerLocation(job.customer),
                    brand: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getListValue(job, "brand") || "",
                    evolvedOpportunityNumber: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getNumberValue(job, "evolvedOpportunityNumber"),
                    serviceEstimateOpportunityNumber: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getNumberValue(job, "serviceEstimateOpportunityNumber"),
                    saleType: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getListValue(job, "saleType") || "",
                    model: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(job, "model") || "",
                    pressureSystem: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getBoolValue(job, "pressureSystem") || false,
                    pressureCertification: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getListValue(job, "pressureCertification") || "None",
                    electricalDesigner: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(job, "electricalDesigner") || "",
                    mechanicalDesigner: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(job, "mechanicalDesigner") || "",
                    dateOpened: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getDateValue(job, "dateOpened"),
                    dateClosed: (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getDateValue(job, "dateClosed")
                };
            });
        }
    });
    // Apply filter and get all filter facet quantities
    const { filteredData: filteredData, facetCounts: facetCounts } = (0, $b761f23ab1616388$export$edccd8c2ceb63567)({
        filterDefs: $7781990a95f064e2$var$filterDefs,
        data: jobQuery.data ?? [],
        selectedFilterValues: {
            closed: showClosed,
            archived: showArchived,
            type: showTypes
        }
    });
    // Handle loading and error states
    if (jobQuery.isError) return `Error loading orders: ${jobQuery.error.message}`;
    if (jobQuery.isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d8ed0f693b57ae21$export$1afe2b5a93b67b3), {
        text: "Loading Orders"
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $efb8a5333b785146$export$e926676385687eaf), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
            fluid: true,
            className: "py-3 h-100 d-flex flex-column",
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                    className: "col-auto",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("h2", {
                            children: [
                                "Orders",
                                " ",
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("small", {
                                    className: "text-body-secondary",
                                    children: [
                                        "(Displaying ",
                                        filteredData.length,
                                        " of ",
                                        jobQuery.data.length,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("p", {
                            className: "lead",
                            children: "Click on a row to load the detailed tracker for that order."
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                            className: "overflow-hidden mb-3",
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                                className: "row row-cols-auto gx-4 align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                                        children: "Filters:"
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Check, {
                                        type: "switch",
                                        label: `Show Closed (${facetCounts.closed.get(true).toFixed(0)})`,
                                        checked: showClosed,
                                        onChange: toggleShowClosed
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Check, {
                                        type: "switch",
                                        label: `Show Archived (${facetCounts.archived.get(true).toFixed(0)})`,
                                        checked: showArchived,
                                        onChange: toggleShowArchived
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Group, {
                                            className: "form-floating",
                                            children: [
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Select, {
                                                    value: showTypes,
                                                    onChange: onShowTypeChanged,
                                                    className: "w-auto",
                                                    children: $7781990a95f064e2$var$orderTypes.map((type)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("option", {
                                                            value: type,
                                                            children: [
                                                                type,
                                                                " (",
                                                                facetCounts.type.get(type),
                                                                ")"
                                                            ]
                                                        }, type))
                                                }),
                                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Label, {
                                                    children: "Order Type"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                    className: "col",
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                        bordered: true,
                        hover: true,
                        columns: $7781990a95f064e2$var$columns,
                        data: filteredData,
                        initialState: {
                            sorting: [
                                {
                                    id: "dateOpened",
                                    desc: true
                                }
                            ]
                        },
                        // Add relative positioning to the data rows so that we can use the 'stretched-link' class
                        meta: {
                            dataRowProps: {
                                className: "position-relative"
                            }
                        }
                    })
                })
            ]
        })
    });
};
function $7781990a95f064e2$var$formatCustomerLocation(customer) {
    if (!customer) return "";
    const { city: city, stateProvince: stateProvince, country: country } = customer.billing;
    return [
        city,
        stateProvince,
        country
    ].filter((x)=>x).join(", ");
}





var $itHdT = parcelRequire("itHdT");








const $73dc5731b56021be$var$vendorAssessmentLogQuery = (0, $5471293cded6d6a9$export$a0b632a28672d3c0).from("Vendor").select("id, name, currency:Currency(id, code), notes, archived, customFieldValues:VendorCustomFieldValue(*)").eq("deleted", false).order("name").throwOnError();
const $73dc5731b56021be$export$636d94d9a402fafd = (0, $e7c296f6690d0391$export$9a8e3100474fe331)({
    queryKey: [
        "Vendor",
        "assessment-log"
    ],
    queryFn: async ()=>(await $73dc5731b56021be$var$vendorAssessmentLogQuery).data
});






var $itHdT = parcelRequire("itHdT");


"use client";
const $90a8e7ecc8bf1d65$var$Badge = /*#__PURE__*/ $itHdT.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $064b812fd356008a$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($74c1486349c77b6a$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$90a8e7ecc8bf1d65$var$Badge.displayName = 'Badge';
var $90a8e7ecc8bf1d65$export$2e2bcd8739ae039 = $90a8e7ecc8bf1d65$var$Badge;




var $itHdT = parcelRequire("itHdT");





var $itHdT = parcelRequire("itHdT");

const $dca618291dc583d3$export$499481e68fc05254 = ({ loadingMessage: loadingMessage = /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("span", {
    children: [
        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $67974e86dbd6e1f4$export$2e2bcd8739ae039), {
            size: "sm"
        }),
        " Loading preview..."
    ]
}), style: style, width: width = 640, height: height = 480, onLoad: onLoadProp, ...iframeProps })=>{
    const [loading, setLoading] = (0, $itHdT.useState)(true);
    const onLoad = (0, $itHdT.useCallback)((e)=>{
        setLoading(false);
        if (onLoadProp) onLoadProp(e);
    }, [
        onLoadProp
    ]);
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
        style: {
            position: "relative",
            maxWidth: "100%",
            maxHeight: "100%",
            width: width,
            height: height
        },
        children: [
            loading && /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1
                },
                children: loadingMessage
            }),
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("iframe", {
                ...iframeProps,
                width: width,
                height: height,
                style: {
                    maxWidth: "100%",
                    maxHeight: "100%",
                    ...style,
                    display: loading ? "none" : undefined
                },
                onLoad: onLoad
            })
        ]
    });
};


const $ee1583c3557d5fcf$export$43e62cb725a06b = ({ url: url, ...iframeProps })=>{
    // Validate and parse the URL
    const parsedUrl = $ee1583c3557d5fcf$var$validateUrl(url);
    if (!parsedUrl) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            "Invalid URL: ",
            url
        ]
    });
    // Extract the Google Drive file ID from the URL
    const driveFileId = (0, $be8f6f33925d422b$export$8894120faf2e049d)(parsedUrl);
    if (!driveFileId) return "Not a valid Google Drive file URL: " + url;
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $dca618291dc583d3$export$499481e68fc05254), {
        src: `https://docs.google.com/document/d/${driveFileId}/preview`,
        style: {
            border: "none"
        },
        ...iframeProps
    });
};
function $ee1583c3557d5fcf$var$validateUrl(url) {
    try {
        const parsedUrl = new URL(url);
        if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") return false;
        return parsedUrl;
    } catch  {
        return false;
    }
}



const $8f6ddd833496e04b$export$8eef824fd77093e7 = ({ id: id, url: url, children: child, popoverPlacement: popoverPlacement })=>{
    const [showTooltip, setShowTooltip] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState(false);
    const [showPopover, setShowPopover] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState(false);
    const [popoverHiding, setPopoverHiding] = (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).useState(false);
    const targetRef = (0, $itHdT.useRef)(null);
    const childOnClick = child.props.onClick;
    const childOnMouseEnter = child.props.onMouseEnter;
    const childOnMouseLeave = child.props.onMouseLeave;
    // Toggle the preview visibility on click
    const onClick = (0, $itHdT.useCallback)((e)=>{
        setShowPopover((prev)=>!prev);
        setPopoverHiding(false);
        childOnClick?.(e);
    }, [
        childOnClick
    ]);
    // Show the tooltip on hover
    const onMouseEnter = (0, $itHdT.useCallback)((e)=>{
        setShowTooltip(true);
        childOnMouseLeave?.(e);
    }, [
        childOnMouseLeave
    ]);
    const onMouseLeave = (0, $itHdT.useCallback)((e)=>{
        setShowTooltip(false);
        childOnMouseEnter?.(e);
    }, [
        childOnMouseEnter
    ]);
    // Hide the overlay when the backdrop is clicked
    const onHide = (0, $itHdT.useCallback)(()=>{
        setPopoverHiding(showPopover);
        setShowPopover(false);
        setShowTooltip(false);
    }, [
        showPopover
    ]);
    const onExited = (0, $itHdT.useCallback)(()=>{
        setPopoverHiding(false);
    }, []);
    // Clone the child element with our overridden event handlers
    const childWithHandler = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($itHdT))).cloneElement(child, {
        ref: targetRef,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
        children: [
            childWithHandler,
            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $f88a1b87109a953a$export$2e2bcd8739ae039), {
                target: targetRef.current,
                show: showPopover || showTooltip,
                rootClose: true,
                onHide: onHide,
                onExited: onExited,
                placement: showPopover ? popoverPlacement : undefined,
                children: (props)=>showPopover || popoverHiding ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $53905517a09a4f32$export$2e2bcd8739ae039), {
                        id: `document-preview-popover_${id}`,
                        ...props,
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $53905517a09a4f32$export$2e2bcd8739ae039).Body, {
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $ee1583c3557d5fcf$export$43e62cb725a06b), {
                                url: url,
                                onLoad: ()=>{
                                    props.popper.scheduleUpdate?.();
                                }
                            })
                        })
                    }) : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                        id: `document-preview-tooltip_${id}`,
                        ...props,
                        children: "Preview"
                    })
            })
        ]
    });
};




const $042f5623e8da3ed0$var$columnHelper = (0, $a7e41fd3cc0a83c1$export$4b44a5cb9651fe5e)();
const $042f5623e8da3ed0$export$3f64044a3d3f1502 = [
    $042f5623e8da3ed0$var$columnHelper.accessor("name", {
        header: "Vendor Name",
        cell: ({ row: row, getValue: getValue })=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $aa4833b2f2131489$export$c66dc3d652f86954), {
                type: "vendor",
                id: row.original.id,
                label: getValue()
            })
    }),
    $042f5623e8da3ed0$var$columnHelper.accessor("currency.code", {
        header: "Currency",
        cell: ({ row: row, getValue: getValue })=>[
                getValue(),
                row.original.currencyFlag
            ].filter(Boolean).join(" ")
    }),
    $042f5623e8da3ed0$var$columnHelper.accessor("notes", {
        header: "Notes"
    }),
    $042f5623e8da3ed0$var$columnHelper.accessor("archived", {
        header: "Archived",
        cell: ({ getValue: getValue })=>getValue() ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                icon: "archive-fill"
            }) : null,
        meta: {
            cellProps: {
                className: "text-center"
            }
        }
    }),
    $042f5623e8da3ed0$var$columnHelper.accessor("assessmentLink", {
        header: "Assessment",
        cell: ({ row: row, getValue: getValue })=>{
            const assessmentUrl = getValue();
            return assessmentUrl ? /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $3d04577e83656c0d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $8f6ddd833496e04b$export$8eef824fd77093e7), {
                        id: `vendor-assessment-${row.original.id.toFixed(0)}`,
                        url: assessmentUrl,
                        popoverPlacement: "left",
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0dc71333bb7bcb46$export$2e2bcd8739ae039), {
                            variant: "link",
                            className: "p-0 ms-2",
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                icon: "eye"
                            })
                        })
                    }),
                    " ",
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                        overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                            children: "Open In New Tab"
                        }),
                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("a", {
                            href: assessmentUrl,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                icon: "box-arrow-up-right"
                            })
                        })
                    })
                ]
            }) : row.original.assessmentStatus === "Not Needed" ? "N/A" : /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c6324eb2ca8e9e2c$export$2e2bcd8739ae039), {
                overlay: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $0cc7cb3366938b69$export$2e2bcd8739ae039), {
                    children: "Assessment Missing"
                }),
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                        icon: "x-circle",
                        className: "text-danger"
                    })
                })
            });
        },
        meta: {
            cellProps: {
                className: "text-center"
            }
        }
    }),
    $042f5623e8da3ed0$var$columnHelper.accessor("assessmentStatus", {
        header: "Assessment Status",
        cell: ({ getValue: getValue })=>{
            const status = getValue();
            const bg = status === "Complete - Approved" ? "success" : status === "In-Progress" ? "warning" : status === "Not Needed" ? "secondary" : "danger";
            return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $90a8e7ecc8bf1d65$export$2e2bcd8739ae039), {
                bg: bg,
                children: status
            });
        },
        meta: {
            cellProps: {
                className: "text-center"
            }
        }
    })
];



const $ccad49ca5db3580b$var$allAssessmentStatuses = [
    "Not Needed",
    "Not Started",
    "In-Progress",
    "Complete - Approved",
    "Complete - Rejected",
    "Unknown"
];
const $ccad49ca5db3580b$export$330cce7ba9e25a02 = ()=>{
    // Define State
    const [showArchived, setShowArchived] = (0, $itHdT.useState)(false);
    const [showStatuses, setShowStatuses] = (0, $itHdT.useState)(new Set([
        "Not Started",
        "In-Progress",
        "Complete - Approved",
        "Complete - Rejected",
        "Unknown"
    ]));
    // Define callbacks
    const toggleShowArchived = (0, $itHdT.useCallback)(()=>{
        setShowArchived((x)=>!x);
    }, []);
    const toggleShowStatus = (0, $itHdT.useCallback)((e)=>{
        const status = e.target.value;
        setShowStatuses((prev)=>{
            const newStatuses = new Set(prev);
            if (newStatuses.has(status)) newStatuses.delete(status);
            else newStatuses.add(status);
            return newStatuses;
        });
    }, []);
    // Fetch data
    const vendorsQuery = (0, $b262411d05d5989d$export$ad4afeb3151d80fa)((0, $73dc5731b56021be$export$636d94d9a402fafd));
    // Determine the assessment status for all vendors before filtering
    const allVendors = (0, $itHdT.useMemo)(()=>{
        return (vendorsQuery.data ?? []).map((vendor)=>{
            const assessmentLink = (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getStringValue(vendor, "assessmentLink") || "";
            let assessmentStatus = (0, $2a2ef9e5465fcf19$export$8b3902b9c2cbc0d4).getListValue(vendor, "assessmentStatus");
            if (assessmentStatus !== "Not Needed" && !assessmentLink) assessmentStatus = "Not Started";
            assessmentStatus ||= "Unknown";
            return {
                ...vendor,
                assessmentLink: assessmentLink,
                assessmentStatus: assessmentStatus
            };
        });
    }, [
        vendorsQuery.data
    ]);
    // Filter and map query data into table format
    // NOTE: We aren't using the 'select' option in the query because we want to show the user the number of unfiltered records
    // Note: Use the useMemo hook here so that we aren't recomputing the table data on every render
    const tableData = (0, $itHdT.useMemo)(()=>{
        return allVendors.filter((x)=>showArchived || !x.archived).filter((x)=>showStatuses.has(x.assessmentStatus)).map((vendor)=>({
                ...vendor,
                currencyFlag: vendor.currency?.code === "CAD" ? "\uD83C\uDDE8\uD83C\uDDE6" : vendor.currency?.code === "USD" ? "\uD83C\uDDFA\uD83C\uDDF8" : undefined
            }));
    }, [
        allVendors,
        showArchived,
        showStatuses
    ]);
    // Calculate some numbers for displaying on the filters
    const numArchived = allVendors.filter((x)=>x.archived).length;
    // Handle loading and error states
    // NOTE: This must be done after all hooks have executed; hooks must be called in the same order on every render
    if (vendorsQuery.isError) return `Error loading sales orders: ${vendorsQuery.error.message}`;
    if (vendorsQuery.isPending) return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $d8ed0f693b57ae21$export$1afe2b5a93b67b3), {
        text: "Loading Vendor Assessments"
    });
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $7aec0b7104658b7c$export$e926676385687eaf), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $dfa4e6f1fce6f772$export$2e2bcd8739ae039), {
            fluid: true,
            className: "py-3 h-100 d-flex flex-column",
            children: [
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                    className: "col-auto",
                    children: [
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("h2", {
                            children: [
                                "Vendor Assessments",
                                " ",
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("small", {
                                    className: "text-body-secondary",
                                    children: [
                                        "(Displaying ",
                                        tableData.length,
                                        " of ",
                                        vendorsQuery.data.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("a", {
                                    href: "https://drive.google.com/drive/folders/1M2tqcE3y2_G1hIxS1FyCYPB6uNSybt6j",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "btn btn-outline-secondary btn-sm ms-3 align-middle d-inline-flex align-items-center",
                                    children: [
                                        "Google Drive Folder",
                                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $306ab2a8108aa131$export$f04a61298a47a40f), {
                                            icon: "box-arrow-up-right",
                                            className: "ms-1"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("div", {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)("div", {
                                className: "row row-cols-auto g-4 align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)("span", {
                                        children: "Filters:"
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Check, {
                                        type: "switch",
                                        label: `Show Archived (${numArchived.toFixed()})`,
                                        checked: showArchived,
                                        onChange: toggleShowArchived
                                    }),
                                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039), {
                                        autoClose: "outside",
                                        children: [
                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Toggle, {
                                                variant: "secondary",
                                                size: "sm",
                                                children: [
                                                    "Assessment Status (",
                                                    showStatuses.size,
                                                    "/",
                                                    $ccad49ca5db3580b$var$allAssessmentStatuses.length,
                                                    " selected)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).Menu, {
                                                children: $ccad49ca5db3580b$var$allAssessmentStatuses.map((status)=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $c3d2300ee9df0bec$export$2e2bcd8739ae039).ItemText, {
                                                        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $6cb539fda66d64c0$export$2e2bcd8739ae039).Check, {
                                                            type: "checkbox",
                                                            id: `assessment-status-${status}`,
                                                            label: status,
                                                            value: status,
                                                            checked: showStatuses.has(status),
                                                            onChange: toggleShowStatus
                                                        })
                                                    }, status))
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $712f3339b3650c2f$export$4267411171632d35), {
                    className: "col",
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $282cd4d039b346d2$export$df30df7ec97b32b5), {
                        bordered: true,
                        hover: true,
                        columns: (0, $042f5623e8da3ed0$export$3f64044a3d3f1502),
                        data: tableData,
                        initialState: {
                            sorting: [
                                {
                                    id: "name",
                                    desc: false
                                }
                            ]
                        },
                        state: {
                            columnVisibility: {
                                // Hide the 'archived' column when archived records are filtered out
                                archived: showArchived
                            }
                        }
                    })
                })
            ]
        })
    });
};



// See: https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/#usage-with-routes--component
const $3be12b3a0e0003e4$var$SentryRoutes = (0, $d99727d27dbc013b$export$1d21f1c69f33ffe5)((0, $b634fe06a3f61222$export$3565eb3d00ca5a74));
const $3be12b3a0e0003e4$export$8707b35fd1c03f46 = ()=>/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)($3be12b3a0e0003e4$var$SentryRoutes, {
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $73afe6efd67cc935$export$e034111dc0cfe9e7), {}),
                children: [
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $25450085f9e379bd$export$f01b3d7c7bbe3997), {}),
                        children: [
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                                index: true,
                                element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$444b3ab0cb9aec40), {
                                    to: "/orders"
                                })
                            }),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                                path: "estimates",
                                element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $1cd31cfc234b85db$export$a58670a25a3489b), {})
                            }),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                                path: "orders",
                                element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $7781990a95f064e2$export$87a9b7f4d9e281bd), {})
                            }),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                                path: "ncrs",
                                element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $700eb699397b8db1$export$bb608f429abc947f), {})
                            }),
                            (0, $eaeeb144eed6ac3b$export$d6a7ea8220714eaa),
                            (0, $0876dd8dcb246aa0$export$15070f52b03544ce),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                                path: "qms/vendor-assessments",
                                element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $ccad49ca5db3580b$export$330cce7ba9e25a02), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                        path: "unauthenticated",
                        element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $01b3ada793939000$export$daddb13553a29f22), {})
                    }),
                    /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $b634fe06a3f61222$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $29be6b98b36aee17$export$271f9f08425019c7), {})
                    })
                ]
            })
        })
    });






// Create a React Query client
const $77173b494b034856$var$queryClient = new (0, $c35f27cd41559d1f$export$405d0624ed55a03f)({
    // By setting the default staleTime to `infinity`, queries will never be considered stale, and will only re-fetch when
    // the page is reloaded
    defaultOptions: {
        queries: {
            staleTime: Infinity
        }
    }
});
function $77173b494b034856$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $efb8a5333b785146$export$e926676385687eaf), {
        children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $a2ead8eb3468501d$export$d053b53cdff1ea07), {
            children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $bbe62af273f211ec$export$16086139eda1cc92), {
                children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $e49ef136abe795ca$export$45604f0cc8ae667b), {
                    client: $77173b494b034856$var$queryClient,
                    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsxs)((0, $f3ead4447ee0b856$export$d8964aec282183a3), {
                        children: [
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $3be12b3a0e0003e4$export$8707b35fd1c03f46), {}),
                            /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $09a74071c03a4c1b$export$fd1469cb3147d866), {
                                initialIsOpen: false
                            })
                        ]
                    })
                })
            })
        })
    });
}



$4adcd9775c7264be$export$2cd8252107eb640b({
    dsn: "https://82acc39192f38bf46f85935148d01f02@o436832.ingest.us.sentry.io/4508359628554240",
    integrations: [
        // See: https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/
        $d99727d27dbc013b$export$8c58a21c71b0a1de({
            useEffect: $itHdT.useEffect,
            useLocation: $b634fe06a3f61222$export$45d76561a5302f2b,
            useNavigationType: $b634fe06a3f61222$export$1b3f31771c5d07c,
            createRoutesFromChildren: $b634fe06a3f61222$export$16da398f5434bdec,
            matchRoutes: $b634fe06a3f61222$export$2708184779ceb39d
        }),
        // See: https://docs.sentry.io/platforms/javascript/configuration/integrations/httpclient/
        $9e4edf64159831e9$export$8a3b7aeb379b3907(),
        // See: https://docs.sentry.io/platforms/javascript/logs/#console-logging-integration
        $479c90d590bd4fd3$exports.consoleLoggingIntegration(),
        // See: https://docs.sentry.io/platforms/javascript/guides/node/configuration/integrations/supabase/
        $479c90d590bd4fd3$exports.supabaseIntegration({
            supabaseClient: (0, $5471293cded6d6a9$export$a0b632a28672d3c0)
        })
    ],
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
});
// Render App
const $463aa7e1dc491445$var$container = document.getElementById("app");
if (!$463aa7e1dc491445$var$container) throw new Error('Container element with id "app" not found');
const $463aa7e1dc491445$var$root = (0, $3d1bc10025e74699$export$882461b6382ed46c)($463aa7e1dc491445$var$container);
$463aa7e1dc491445$var$root.render(/*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $itHdT.StrictMode), {
    children: /*#__PURE__*/ (0, $3d04577e83656c0d$exports.jsx)((0, $77173b494b034856$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=repo.e12de79a.js.map
